
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $a5056a6656605403$exports = {};
/*! For license information please see widget.module.js.LICENSE.txt */ (()=>{
    var t1 = {
        375: (t1, e, i)=>{
            var n = i(853), r = {
                ease: n(.25, .1, .25, 1),
                easeIn: n(.42, 0, 1, 1),
                easeOut: n(0, 0, .58, 1),
                easeInOut: n(.42, 0, .58, 1),
                linear: n(0, 0, 1, 1)
            };
            function a() {}
            function s() {
                var t1 = new Set, e = new Set, i = 0;
                return {
                    next: n,
                    cancel: n,
                    clearAll: function() {
                        t1.clear(), e.clear(), cancelAnimationFrame(i), i = 0;
                    }
                };
                function n(t1) {
                    e.add(t1), i || (i = requestAnimationFrame(r));
                }
                function r() {
                    i = 0;
                    var n = e;
                    e = t1, (t1 = n).forEach(function(t1) {
                        t1();
                    }), t1.clear();
                }
            }
            t1.exports = function(t1, e, i) {
                var n = Object.create(null), s = Object.create(null), o = "function" == typeof (i = i || {}).easing ? i.easing : r[i.easing];
                o || (i.easing && console.warn("Unknown easing function in amator: " + i.easing), o = r.ease);
                var l = "function" == typeof i.step ? i.step : a, c = "function" == typeof i.done ? i.done : a, u = function(t1) {
                    if (!t1) return "undefined" != typeof window && window.requestAnimationFrame ? {
                        next: window.requestAnimationFrame.bind(window),
                        cancel: window.cancelAnimationFrame.bind(window)
                    } : {
                        next: function(t1) {
                            return setTimeout(t1, 1e3 / 60);
                        },
                        cancel: function(t1) {
                            return clearTimeout(t1);
                        }
                    };
                    if ("function" != typeof t1.next) throw new Error("Scheduler is supposed to have next(cb) function");
                    if ("function" != typeof t1.cancel) throw new Error("Scheduler is supposed to have cancel(handle) function");
                    return t1;
                }(i.scheduler), h = Object.keys(e);
                h.forEach(function(i) {
                    n[i] = t1[i], s[i] = e[i] - t1[i];
                });
                var d, p = "number" == typeof i.duration ? i.duration : 400, A = Math.max(1, .06 * p), f = 0;
                return d = u.next(function e() {
                    var i = o(f / A);
                    f += 1, function(e) {
                        h.forEach(function(i) {
                            t1[i] = s[i] * e + n[i];
                        });
                    }(i), f <= A ? (d = u.next(e), l(t1)) : (d = 0, setTimeout(function() {
                        c(t1);
                    }, 0));
                }), {
                    cancel: function() {
                        u.cancel(d), d = 0;
                    }
                };
            }, t1.exports.makeAggregateRaf = s, t1.exports.sharedScheduler = s();
        },
        853: (t1)=>{
            var e = .1, i = "function" == typeof Float32Array;
            function n(t1, e) {
                return 1 - 3 * e + 3 * t1;
            }
            function r(t1, e) {
                return 3 * e - 6 * t1;
            }
            function a(t1) {
                return 3 * t1;
            }
            function s(t1, e, i) {
                return ((n(e, i) * t1 + r(e, i)) * t1 + a(e)) * t1;
            }
            function o(t1, e, i) {
                return 3 * n(e, i) * t1 * t1 + 2 * r(e, i) * t1 + a(e);
            }
            function l(t1) {
                return t1;
            }
            t1.exports = function(t1, n, r, a) {
                if (!(0 <= t1 && t1 <= 1 && 0 <= r && r <= 1)) throw new Error("bezier x values must be in [0, 1] range");
                if (t1 === n && r === a) return l;
                for(var c = i ? new Float32Array(11) : new Array(11), u = 0; u < 11; ++u)c[u] = s(u * e, t1, r);
                return function(i) {
                    return 0 === i ? 0 : 1 === i ? 1 : s(function(i) {
                        for(var n = 0, a = 1; 10 !== a && c[a] <= i; ++a)n += e;
                        --a;
                        var l = n + (i - c[a]) / (c[a + 1] - c[a]) * e, u = o(l, t1, r);
                        return u >= .001 ? function(t1, e, i, n) {
                            for(var r = 0; r < 4; ++r){
                                var a = o(e, i, n);
                                if (0 === a) return e;
                                e -= (s(e, i, n) - t1) / a;
                            }
                            return e;
                        }(i, l, t1, r) : 0 === u ? l : function(t1, e, i, n, r) {
                            var a, o, l = 0;
                            do (a = s(o = e + (i - e) / 2, n, r) - t1) > 0 ? i = o : e = o;
                            while (Math.abs(a) > 1e-7 && ++l < 10);
                            return o;
                        }(i, n, n + e, t1, r);
                    }(i), n, a);
                };
            };
        },
        809: (t1, e, i)=>{
            "use strict";
            i.d(e, {
                A: ()=>A
            });
            var n = i(601), r = i.n(n), a = i(314), s = i.n(a), o = i(417), l = i.n(o), c = new URL(i(877), i.b), u = new URL(i(709), i.b), h = s()(r()), d = l()(c), p = l()(u);
            h.push([
                t1.id,
                `@font-face{font-family:"Roboto Mono";font-style:normal;font-display:swap;font-weight:100;src:url(${d}) format("woff2"),url(${p}) format("woff")}`,
                ""
            ]);
            const A = h;
        },
        875: (t1, e, i)=>{
            "use strict";
            i.d(e, {
                A: ()=>A
            });
            var n = i(601), r = i.n(n), a = i(314), s = i.n(a), o = i(417), l = i.n(o), c = new URL(i(67), i.b), u = new URL(i(907), i.b), h = s()(r()), d = l()(c), p = l()(u);
            h.push([
                t1.id,
                `@font-face{font-family:"Roboto Mono";font-style:normal;font-display:swap;font-weight:700;src:url(${d}) format("woff2"),url(${p}) format("woff")}`,
                ""
            ]);
            const A = h;
        },
        482: (t1, e, i)=>{
            "use strict";
            i.d(e, {
                A: ()=>A
            });
            var n = i(601), r = i.n(n), a = i(314), s = i.n(a), o = i(417), l = i.n(o), c = new URL(i(702), i.b), u = new URL(i(356), i.b), h = s()(r()), d = l()(c), p = l()(u);
            h.push([
                t1.id,
                `@font-face{font-family:"Roboto Mono";font-style:normal;font-display:swap;font-weight:100;src:url(${d}) format("woff2"),url(${p}) format("woff")}`,
                ""
            ]);
            const A = h;
        },
        928: (t1, e, i)=>{
            "use strict";
            i.d(e, {
                A: ()=>A
            });
            var n = i(601), r = i.n(n), a = i(314), s = i.n(a), o = i(417), l = i.n(o), c = new URL(i(756), i.b), u = new URL(i(933), i.b), h = s()(r()), d = l()(c), p = l()(u);
            h.push([
                t1.id,
                `@font-face{font-family:"Roboto Mono";font-style:normal;font-display:swap;font-weight:700;src:url(${d}) format("woff2"),url(${p}) format("woff")}`,
                ""
            ]);
            const A = h;
        },
        761: (t1, e, i)=>{
            "use strict";
            i.d(e, {
                A: ()=>o
            });
            var n = i(601), r = i.n(n), a = i(314), s = i.n(a)()(r());
            s.push([
                t1.id,
                '.widget-application{--main-color: #FAC62D;--main-text: #413E3E;width:100%;height:100%;flex:none;overflow:hidden;position:relative;z-index:1;background-color:#fff;font-size:20px}.widget-application *,.widget-application *:before,.widget-application *:after{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-family:"Roboto Mono",monospace;text-decoration:none;font-weight:700;color:#413e3e;outline:none;padding:0;margin:0;box-sizing:border-box;-webkit-box-sizing:border-box}.widget-application .widget-logo{position:absolute;left:45px;top:30px;z-index:3}.widget-application--tablet.widget-application .widget-logo{left:36px;top:39px}.widget-application--mobile.widget-application .widget-logo{left:23px;top:24px}.widget-application--smallMobile.widget-application .widget-logo{left:23px;top:21px}.widget-application .widget-logo img{display:block;width:82px;height:82px;object-fit:contain;object-position:center}.widget-application--tablet.widget-application .widget-logo img{width:58px;height:58px}.widget-application--mobile.widget-application .widget-logo img{width:36px;height:36px}.widget-application--smallMobile.widget-application .widget-logo img{width:28px;height:28px}.widget-application .widget-tab__panorama-close-map{position:absolute;right:45px;top:36px;z-index:3;padding:10px;touch-action:none;ouline:none;border:none;box-shadow:none;background:rgba(0,0,0,0);cursor:pointer}.widget-application--tablet.widget-application .widget-tab__panorama-close-map{right:30px;top:35px}.widget-application--mobile.widget-application .widget-tab__panorama-close-map{padding:5px;right:22px;top:20px}.widget-application .widget-tab__panorama-close-map img{display:block;width:50px;height:50px;object-fit:contain;object-position:center}.widget-application--tablet.widget-application .widget-tab__panorama-close-map img{width:40px;height:40px}.widget-application--mobile.widget-application .widget-tab__panorama-close-map img{width:32px;height:32px}.widget-application--smallMobile.widget-application .widget-tab__panorama-close-map img{width:26px;height:26px}.widget-application .widget-enter-fullscreen{position:absolute;right:45px;top:36px;z-index:3;padding:10px;touch-action:none;ouline:none;border:none;box-shadow:none;background:rgba(0,0,0,0);cursor:pointer}.widget-application--tablet.widget-application .widget-enter-fullscreen{right:30px;top:35px}.widget-application--mobile.widget-application .widget-enter-fullscreen{padding:5px;right:22px;top:20px}.widget-application .widget-enter-fullscreen img{display:block;width:50px;height:50px;object-fit:contain;object-position:center}.widget-application--tablet.widget-application .widget-enter-fullscreen img{width:40px;height:40px}.widget-application--mobile.widget-application .widget-enter-fullscreen img{width:32px;height:32px}.widget-application--smallMobile.widget-application .widget-enter-fullscreen img{width:26px;height:26px}.widget-application .widget-exit-fullscreen{position:absolute;right:45px;top:36px;z-index:3;padding:10px;touch-action:none;ouline:none;border:none;box-shadow:none;background:rgba(0,0,0,0);cursor:pointer}.widget-application--tablet.widget-application .widget-exit-fullscreen{right:30px;top:35px}.widget-application--mobile.widget-application .widget-exit-fullscreen{padding:5px;right:22px;top:20px}.widget-application .widget-exit-fullscreen img{display:block;width:50px;height:50px;object-fit:contain;object-position:center}.widget-application--tablet.widget-application .widget-exit-fullscreen img{width:40px;height:40px}.widget-application--mobile.widget-application .widget-exit-fullscreen img{width:32px;height:32px}.widget-application--smallMobile.widget-application .widget-exit-fullscreen img{width:26px;height:26px}.widget-application .widget-tab-buttons{position:absolute;z-index:3;right:44px;bottom:35px;display:flex;align-items:center;justify-content:flex-end}.widget-application--tablet.widget-application .widget-tab-buttons{right:35px;bottom:35px}.widget-application--mobile.widget-application .widget-tab-buttons{right:22px;bottom:22px}.widget-application--smallMobile.widget-application .widget-tab-buttons{right:20px;bottom:30px}.widget-application .widget-tab-buttons-vertical{flex-direction:column;row-gap:28px;bottom:120px;right:30px}.widget-application--tablet.widget-application .widget-tab-buttons-vertical{bottom:120px;right:30px}.widget-application--mobile.widget-application .widget-tab-buttons-vertical{row-gap:10px;bottom:90px;right:21px}.widget-application .widget-tab-buttons-vertical .widget-tab-button{font-size:19px;font-weight:700;line-height:26px;width:50px;height:50px}.widget-application--tablet.widget-application .widget-tab-buttons-vertical .widget-tab-button{font-size:19px;font-weight:700;line-height:26px;width:50px;height:50px}.widget-application--mobile.widget-application .widget-tab-buttons-vertical .widget-tab-button{font-size:17px;line-height:23px;width:44px;height:44px}.widget-application .widget-tab-button{ouline:none;border:none;box-shadow:none;background:rgba(0,0,0,0);cursor:pointer;width:72px;height:72px;border-radius:50%;display:flex;align-items:center;justify-content:center;background-color:#eaeaea;color:#413e3e;font-size:28px;line-height:120%;font-weight:700;margin-left:40px}.widget-application--tablet.widget-application .widget-tab-button{margin-left:20px;width:60px;height:60px;font-size:22px}.widget-application--mobile.widget-application .widget-tab-button{margin-left:10px;font-size:17px;width:44px;height:44px}.widget-application--smallMobile.widget-application .widget-tab-button{width:36px;height:36px;font-size:14px}.widget-application .widget-tab-button--active{background-color:var(--main-color);color:var(--main-text)}.widget-application .widget-tab-button--active img{filter:invert(100%) sepia(99%) saturate(0%) hue-rotate(97deg) brightness(105%) contrast(100%)}.widget-application .widget-tab-button img{width:38px;height:28px}.widget-application--mobile.widget-application .widget-tab-button img{width:33px;height:25px}.widget-application .widget-tab{width:100%;height:100%;display:flex;align-items:center;justify-content:center;padding:60px 30px}.widget-application--smallMobile.widget-application .widget-tab{padding:60px 20px}.widget-application .widget-tab--rotation{padding:0 !important}.widget-application .widget-tab-menu{position:absolute;z-index:3;left:15px;top:15px;max-height:100%;overflow-y:auto;padding-bottom:30px}.widget-application .widget-tab-menu__wallpapers{display:flex;flex-wrap:wrap;align-items:flex-start;margin-top:10px;width:100%}.widget-application .widget-tab-menu__wallpapers img{width:30px;height:30px;display:block;object-fit:cover;cursor:pointer;margin-right:10px;margin-block-end:10px}.widget-application .widget-tab-menu ul{list-style-type:none}.widget-application .widget-tab-menu ul li{color:#413e3e;background-color:var(--main-color);padding:5px 15px;border-radius:10px;font-size:.7rem;border:none;cursor:pointer;margin-bottom:15px;width:200px;user-select:none;-webkit-user-select:none;user-drag:none;-webkit-user-drag:none}.widget-application .widget-tab-menu ul li label{display:flex;cursor:inherit;width:100%}.widget-application .widget-tab-menu ul li input[type=color]{cursor:pointer;margin-left:auto;width:50px;height:20px;border:0;border-radius:5px}.widget-application .widget-tab-menu ul li input[type=color]::-webkit-color-swatch-wrapper{display:none !important}.widget-application .widget-tab-menu ul li input[type=file]{display:none}.widget-application .widget-tab-menu ul li:nth-child(1){position:relative}.widget-application .widget-tab-menu ul li:nth-child(1)::after{--bar-width: 2px;content:"";width:20px;height:15px;display:block;background:repeating-linear-gradient(180deg, #000000, #000000 var(--bar-width), rgba(0, 0, 0, 0) var(--bar-width), rgba(0, 0, 0, 0) calc(var(--bar-width) * 3));position:absolute;right:10px;top:50%;transform:translateY(-50%)}.widget-application--mobile.widget-application .widget-tab--area~.widget-tab-buttons-vertical{bottom:23px;right:22px;flex-direction:row}.widget-application .widget-tab--area .widget-tab__isometry-arrows{bottom:119px;height:42px}.widget-application--tablet.widget-application .widget-tab--area .widget-tab__isometry-arrows{bottom:119px;height:42px}.widget-application--mobile.widget-application .widget-tab--area .widget-tab__isometry-arrows{bottom:180px}.widget-application .widget-tab--area .widget-tab__isometry-arrows span{font-size:14px;font-weight:700;line-height:18px;margin:0 2px}.widget-application--tablet.widget-application .widget-tab--area .widget-tab__isometry-arrows span{font-size:14px;font-weight:700;line-height:18px;margin:0 2px}.widget-application .widget-tab--area .widget-tab__isometry-arrow img{width:16px;height:16px}.widget-application--tablet.widget-application .widget-tab--area .widget-tab__isometry-arrow img{width:16px;height:16px}.widget-application .widget-instructions{position:absolute;z-index:2;left:0;top:0;width:100%;height:100%;display:flex;align-items:center;justify-content:center;background-position:center;background-repeat:no-repeat;background-size:cover}.widget-application .widget-instructions__content{display:flex;flex-direction:column;align-items:center;justify-content:flex-start;background-color:rgba(234,234,234,.85);border-radius:20px;overflow:hidden;width:400px;max-width:calc(100% - 60px);padding:36px 30px 30px 30px;backdrop-filter:blur(5px);-moz-backdrop-filter:blur(5px);-webkit-backdrop-filter:blur(5px)}.widget-application--mobile.widget-application .widget-instructions__content{width:280px;padding:26px 20px 20px 20px}.widget-application .widget-instructions__steps{display:flex;align-items:flex-start;justify-content:center}.widget-application .widget-instructions__step{display:flex;flex-direction:column;align-items:center;justify-content:flex-start;margin:0 15px}.widget-application--tablet.widget-application .widget-instructions__step{margin:0 10px}.widget-application .widget-instructions__step img{display:block;width:52px;height:80px;object-fit:contain;object-position:center}.widget-application--mobile.widget-application .widget-instructions__step img{width:40px;height:60px}.widget-application--smallMobile.widget-application .widget-instructions__step img{width:35px}.widget-application .widget-instructions__step p{color:#413e3e;font-size:20px;font-weight:700;text-align:center;margin-top:10px;max-width:130px}.widget-application--tablet.widget-application .widget-instructions__step p{font-size:18px;max-width:115px}.widget-application--mobile.widget-application .widget-instructions__step p{font-size:16px}.widget-application--smallMobile.widget-application .widget-instructions__step p{font-size:14px}.widget-application .widget-instructions__hint p{color:#413e3e;font-weight:700;text-align:center;margin-top:1.5em;font-size:14px}.widget-application--tablet.widget-application .widget-instructions__hint p{font-size:12px}.widget-application--mobile.widget-application .widget-instructions__hint p{font-size:10px}.widget-application--smallMobile.widget-application .widget-instructions__hint p{font-size:8px}.widget-application .widget-instructions button{ouline:none;border:none;box-shadow:none;background:rgba(0,0,0,0);cursor:pointer;display:flex;align-items:center;justify-content:center;height:44px;padding:0 33px;border-radius:52px;background-color:var(--main-color);color:var(--main-text);font-size:24px;font-weight:700;text-transform:uppercase;margin:25px auto 0 auto}.widget-application .widget-instructions button:disabled{opacity:.75;cursor:not-allowed}.widget-application--tablet.widget-application .widget-instructions button{font-size:18px;height:40px}.widget-application--mobile.widget-application .widget-instructions button{font-size:16px;height:35px}.widget-application--smallMobile.widget-application .widget-instructions button{font-size:14px;height:26px;padding:0 25px}.widget-application .widget-tab__panorama{width:100%;height:100%;position:absolute;left:0;top:0;z-index:2}.widget-application .widget-tab__panorama-overlay{width:100%;height:100%;overflow:hidden;background:#fff !important}.widget-application .widget-tab__panorama-overlay *{display:none !important}.widget-application .widget-tab__panorama-overlay canvas{display:block !important}.widget-application .widget-tab__panorama-enter-vr{position:absolute;left:50%;bottom:50px;transform:translateX(-50%);z-index:3;padding:10px 15px;border-radius:10px;border:2px solid #000;background-color:#fff;font-size:16px;font-weight:600;cursor:pointer}.widget-application .widget-tab__panorama-enter-vr:disabled{opacity:.5}.widget-application .widget-tab__panorama-controls{position:absolute;z-index:2;left:50%;bottom:35px;display:flex;align-items:center;justify-content:center;padding:8px;border-radius:38px;background-color:rgba(0,0,0,.2);transform:translateX(-50%);backdrop-filter:blur(5px);-moz-backdrop-filter:blur(5px);-webkit-backdrop-filter:blur(5px)}.widget-application--mobile.widget-application .widget-tab__panorama-controls{padding:5px;bottom:22px}.widget-application--smallMobile.widget-application .widget-tab__panorama-controls{bottom:30px}.widget-application .widget-tab__panorama-controls-container{position:absolute;left:50%;bottom:35px;display:flex;column-gap:5px;transform:translateX(-50%)}.widget-application--mobile.widget-application .widget-tab__panorama-controls-container{bottom:25px}.widget-application .widget-tab__panorama-controls-container>div{position:unset;left:unset;bottom:unset;padding:5px;transform:translateX(0)}.widget-application--mobile.widget-application .widget-tab__panorama-controls-container>div{padding:4px}.widget-application .widget-tab__panorama-controls-container .widget-tab__panorama-controls-button{width:40px;height:40px;margin-right:11px}.widget-application--mobile.widget-application .widget-tab__panorama-controls-container .widget-tab__panorama-controls-button{width:34px;height:34px;margin-right:9px}.widget-application .widget-tab__panorama-controls-container .widget-tab__panorama-controls-button img{width:22px}.widget-application--tablet.widget-application .widget-tab__panorama-controls-container .widget-tab__panorama-controls-button img{width:32px}.widget-application--mobile.widget-application .widget-tab__panorama-controls-container .widget-tab__panorama-controls-button img{width:37px}.widget-application .widget-tab__panorama-controls-button{ouline:none;border:none;box-shadow:none;background:rgba(0,0,0,0);cursor:pointer;width:55px;height:55px;border-radius:50%;background-color:#fff;display:flex;align-items:center;justify-content:center;margin-right:18px}.widget-application--tablet.widget-application .widget-tab__panorama-controls-button{width:44px;height:44px}.widget-application--mobile.widget-application .widget-tab__panorama-controls-button{margin-right:10px;width:33px;height:33px}.widget-application--smallMobile.widget-application .widget-tab__panorama-controls-button{width:26px;height:26px}.widget-application .widget-tab__panorama-controls-button:disabled{background-color:#e6e6e6;cursor:not-allowed}.widget-application .widget-tab__panorama-controls-button:disabled img{filter:invert(100%) saturate(0)}.widget-application .widget-tab__panorama-controls-button img{display:block}.widget-application--tablet.widget-application .widget-tab__panorama-controls-button img{transform:scale(0.7)}.widget-application--mobile.widget-application .widget-tab__panorama-controls-button img{transform:scale(0.52)}.widget-application--smallMobile.widget-application .widget-tab__panorama-controls-button img{transform:scale(0.45)}.widget-application .widget-tab__panorama-controls-button:nth-last-child(1){margin-right:0}.widget-application .widget-tab__panorama-controls-button--bareshell{display:flex;align-items:center;column-gap:10px;padding:11px 9px 9px 8px;background:none;border:none;cursor:pointer}.widget-application--mobile.widget-application .widget-tab__panorama-controls-button--bareshell{column-gap:7px;padding:8px 8px 8px 6px}.widget-application .widget-tab__panorama-controls-button--bareshell .checked{right:calc(100% - 2px);transform:translateX(-100%)}.widget-application .widget-tab__panorama-controls-button--bareshell-text{font-size:15px;font-weight:700;line-height:20px;color:#fff}.widget-application--mobile.widget-application .widget-tab__panorama-controls-button--bareshell-text{font-size:13px;line-height:17px}.widget-application .widget-tab__panorama-controls-button--bareshell-switch{position:relative;width:34px;height:19px}.widget-application--mobile.widget-application .widget-tab__panorama-controls-button--bareshell-switch{width:28px;height:16px}.widget-application .widget-tab__panorama-controls-button--bareshell-switch-checkbox{height:0;width:0;visibility:hidden}.widget-application .widget-tab__panorama-controls-button--bareshell-switch-checkbox:checked+.widget-tab__panorama-controls-button--bareshell-switch-label .widget-tab__panorama-controls-button--bareshell-switch-button{right:calc(100% - 2px);transform:translateX(100%)}.widget-application .widget-tab__panorama-controls-button--bareshell-switch-label{position:absolute;top:0;display:flex;align-items:center;justify-content:space-between;width:34px;height:19px;background-color:#fff;border-radius:20px;border:1px solid #fff;transition:background-color .2s}.widget-application--mobile.widget-application .widget-tab__panorama-controls-button--bareshell-switch-label{width:28px;height:16px}.widget-application .widget-tab__panorama-controls-button--bareshell-switch-label .widget-tab__panorama-controls-button--bareshell-switch-button{content:"";position:absolute;top:1px;right:1px;width:14px;height:14px;border-radius:45px;transition:.2s;background:#413e3e}.widget-application--mobile.widget-application .widget-tab__panorama-controls-button--bareshell-switch-label .widget-tab__panorama-controls-button--bareshell-switch-button{width:12px;height:12px}.widget-application .widget-tab__panorama-controls-button span{font-size:23px;font-weight:700;line-height:120%;letter-spacing:-0.12em}.widget-application .widget-tab__panorama-close-map{z-index:4}.widget-application .widget-tab__panorama-map{position:absolute;left:45px;bottom:35px;z-index:3;border-radius:10px;opacity:1;transition:opacity .5s;padding:8px;background-color:#fff;touch-action:none;-webkit-touch-action:none}.widget-application .widget-tab__panorama-map::before{content:"";position:absolute;z-index:-1;left:50%;top:50%;transform:translate(-50%, -50%);width:100%;height:100%;border-radius:inherit;background-color:#fff}.widget-application--tablet.widget-application .widget-tab__panorama-map{left:35px;transform:scale(0.6);transform-origin:0% 100%}.widget-application--mobile.widget-application .widget-tab__panorama-map{left:22px;bottom:22px;transform:scale(0.4)}.widget-application--smallMobile.widget-application .widget-tab__panorama-map{left:20px;bottom:30px;transform:scale(0.35)}.widget-application--mobile.widget-application .widget-tab__panorama-map--bottom{bottom:91px}.widget-application--tablet.widget-application .widget-tab__panorama-map--scaled{transform:scale(1.4) translate(-50%, 50%);left:50%;bottom:50%}.widget-application--tablet.widget-application .widget-tab__panorama-map--scaled::after{content:"";position:absolute;z-index:-2;left:50%;top:50%;transform:translate(-50%, -50%);width:100vw;height:100vh;background-color:rgba(196,196,196,.8)}.widget-application--tablet.widget-application .widget-tab__panorama-map--scaled svg path:active{opacity:.3 !important}.widget-application--mobile.widget-application .widget-tab__panorama-map--scaled{transform:scale(1) translate(-50%, 50%)}.widget-application .widget-tab__panorama-map--hidden{opacity:0;pointer-events:none}.widget-application .widget-tab__panorama-map canvas{width:200px;border-radius:unset;user-select:none;-webkit-user-select:none;user-drag:none;-webkit-user-drag:none;-webkit-backface-visibility:hidden;-ms-transform:translateZ(0);-webkit-transform:translateZ(0);transform:translateZ(0)}.widget-application .widget-tab__panorama-map-image{position:absolute;left:0;top:0;z-index:-1;display:none;user-select:none;-webkit-user-select:none;user-drag:none;-webkit-user-drag:none;-webkit-backface-visibility:hidden;-ms-transform:translateZ(0);-webkit-transform:translateZ(0);transform:translateZ(0)}.widget-application .widget-tab__panorama-map svg{position:absolute;left:50%;top:50%;transform:translate(-50%, -50%);width:200px;height:calc(100% - 16px);z-index:3;display:block;border-radius:inherit}.widget-application .widget-tab__panorama-map svg path{opacity:0;fill:var(--main-color);cursor:pointer}.widget-application .widget-tab__panorama-map svg path:hover{opacity:.3}.widget-application .widget-tab__panorama-map__fov{--x: 0;--y: 0;--rotate: 0;position:absolute;left:calc(var(--x) + 8px);top:calc(var(--y) + 8px);width:16px;height:16px;transform:translate(-50%, -50%) rotate(calc(var(--rotate) * 1rad));transform-origin:50% 50%;z-index:4;pointer-events:none}.widget-application .widget-tab__panorama-map__fov-direction{border-radius:50%;border-left:30px solid rgba(0,0,0,0);border-right:30px solid rgba(0,0,0,0);border-bottom:30px solid rgba(0,0,0,0);border-top:40px solid var(--main-color);opacity:.4;position:absolute;left:50%;top:50%;transform:translate(-50%, -50%);z-index:1}.widget-application .widget-tab__panorama-map__fov-dot{position:relative;z-index:5;width:100%;height:100%;background-color:var(--main-color);border-radius:50%;border:2px solid var(--main-color);box-shadow:inset 0 0 0 2px #fff}.widget-application .widget-tab__panorama-top-view-map{cursor:pointer;position:absolute;left:45px;bottom:35px;z-index:3;border-radius:10px;opacity:1;transition:opacity .5s;padding:8px;background-color:#fff;touch-action:none;-webkit-touch-action:none}.widget-application--tablet.widget-application .widget-tab__panorama-top-view-map{left:35px;transform:scale(0.6);transform-origin:0% 100%}.widget-application--mobile.widget-application .widget-tab__panorama-top-view-map{left:22px;bottom:22px;transform:scale(0.4)}.widget-application--smallMobile.widget-application .widget-tab__panorama-top-view-map{left:20px;bottom:30px;transform:scale(0.35)}.widget-application--tablet.widget-application .widget-tab__panorama-top-view-map--scaled{transform:scale(1.4) translate(-50%, 50%);left:50%;bottom:50%}.widget-application--mobile.widget-application .widget-tab__panorama-top-view-map--bottom{bottom:91px}.widget-application .widget-tab__panorama-top-view-map--hidden{opacity:0;pointer-events:none}.widget-application .widget-tab__panorama-top-view-map .display-wrapper{position:relative}.widget-application .widget-tab__panorama-top-view-map .display-wrapper canvas,.widget-application .widget-tab__panorama-top-view-map .display-wrapper img{position:relative}.widget-application .widget-tab__panorama-top-view-map .display-wrapper canvas.hidden,.widget-application .widget-tab__panorama-top-view-map .display-wrapper img.hidden{display:none}.widget-application .widget-tab__panorama-top-view-map .camera{opacity:.8;display:block;position:absolute;width:8px;height:8px;background:radial-gradient(orange 0%, orange 30%, transparent 45%, transparent 50%, orange 70%);border-radius:50%;transform:translate(-50%, -50%);pointer-events:none;transition:background 200ms,opacity 200ms,width 200ms,height 200ms}.widget-application .widget-tab__panorama-top-view-map .camera--current{--rotate: 0;width:16px;height:16px;opacity:1;transform:translate(-50%, -50%) rotate(calc(var(--rotate) * 1rad))}.widget-application .widget-tab__panorama-top-view-map .camera--current::before{content:"";border-radius:50%;border-left:30px solid rgba(0,0,0,0);border-right:30px solid rgba(0,0,0,0);border-bottom:30px solid rgba(0,0,0,0);border-top:40px solid var(--main-color);opacity:.4;position:absolute;left:50%;top:50%;transform:translate(-50%, -50%);z-index:1}.map-overlay{position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0);z-index:3;display:none}.map-overlay--visible{display:block}.widget-application .widget-tab__rotation{width:100%;height:100%}.widget-application .widget-tab__rotation-start{ouline:none;border:none;box-shadow:none;background:rgba(0,0,0,0);cursor:pointer;position:absolute;left:50%;bottom:35px;transform:translateX(-50%);display:flex;align-items:center;justify-content:center;padding:0 25px 0 10px;background-color:#eaeaea;border-radius:38px;height:72px;width:202px}.widget-application--tablet.widget-application .widget-tab__rotation-start{height:60px;width:166px;padding:0 20px 0 8px;bottom:35px}.widget-application--mobile.widget-application .widget-tab__rotation-start{height:44px;width:115px;padding:0 10px 0 6px}.widget-application--smallMobile.widget-application .widget-tab__rotation-start{height:36px;width:85px;padding:0 8px 0 6px;bottom:30px}.widget-application .widget-tab__rotation-start-icon{display:flex;align-items:center;justify-content:center;border-radius:50%;background-color:#fff;margin-right:18px;padding:10px}.widget-application--tablet.widget-application .widget-tab__rotation-start-icon{padding:7px;margin-right:15px}.widget-application--mobile.widget-application .widget-tab__rotation-start-icon{margin-right:7px}.widget-application--smallMobile.widget-application .widget-tab__rotation-start-icon{padding:6px;margin-right:5px}.widget-application .widget-tab__rotation-start-icon img{display:block;position:relative;top:2px;width:34px}.widget-application--tablet.widget-application .widget-tab__rotation-start-icon img{width:30px;top:1px}.widget-application--mobile.widget-application .widget-tab__rotation-start-icon img{width:19px;top:0}.widget-application--smallMobile.widget-application .widget-tab__rotation-start-icon img{width:15px}.widget-application .widget-tab__rotation-start span{font-size:24px;font-weight:700;color:#413e3e;text-transform:uppercase;width:100%;display:block;text-align:center;position:relative;top:1px}.widget-application--tablet.widget-application .widget-tab__rotation-start span{font-size:20px}.widget-application--mobile.widget-application .widget-tab__rotation-start span{font-size:14px}.widget-application--smallMobile.widget-application .widget-tab__rotation-start span{font-size:10px;top:0}.widget-application .widget-tab__threesixty,.widget-application .widget-tab__isometry{width:100%;height:100%;touch-action:none;-webkit-touch-action:none}.widget-application .widget-tab__threesixty-container,.widget-application .widget-tab__isometry-container{width:100% !important;height:100% !important;position:relative;background-image:none !important}.widget-application .widget-tab__threesixty-container img,.widget-application .widget-tab__isometry-container img{position:absolute;left:50%;top:50%;transform:translate(-50%, -50%);max-width:calc(100% - 60px);max-height:calc(100% - 120px);width:600px;height:600px;object-fit:contain;opacity:0;pointer-events:none;user-select:none;-webkit-user-select:none;user-drag:none;-webkit-user-drag:none}.widget-application .widget-tab__threesixty-container img.active,.widget-application .widget-tab__isometry-container img.active{opacity:1}.widget-application .widget-tab__threesixty--active{cursor:move}.widget-application--smallMobile.widget-application .widget-tab__threesixty-container img{max-width:calc(100% - 40px)}.widget-application--smallMobile.widget-application .widget-tab__isometry-container img{max-width:calc(100% - 40px)}.widget-application .widget-tab__isometry-shader{position:absolute;left:50%;width:470px !important;height:470px !important;margin:37px auto;transform:translateX(-50%);cursor:pointer}.widget-application--mobile.widget-application .widget-tab__isometry-shader{width:calc(100vw - 120px) !important;height:calc(100vw - 120px) !important;max-height:calc(100vh - 330px) !important;max-width:calc(100vh - 330px) !important}.widget-application .widget-tab__isometry-shader canvas{position:absolute;width:100% !important;height:100% !important}.widget-application .widget-tab__isometry .hidden{display:none}.widget-application .widget-tab__isometry-arrows{position:absolute;z-index:3;left:50%;bottom:35px;transform:translateX(-50%);height:72px;display:flex;align-items:center;justify-content:center}.widget-application--tablet.widget-application .widget-tab__isometry-arrows{bottom:35px;height:60px}.widget-application--mobile.widget-application .widget-tab__isometry-arrows{bottom:22px;height:44px}.widget-application--smallMobile.widget-application .widget-tab__isometry-arrows{bottom:100px;height:36px}.widget-application .widget-tab__isometry-arrows::before{content:"";position:absolute;left:50%;top:50%;width:calc(100% + 30px);height:100%;transform:translate(-50%, -50%);background-color:#eaeaea;z-index:-1;border-radius:60px}.widget-application--tablet.widget-application .widget-tab__isometry-arrows::before{border-radius:32px}.widget-application--mobile.widget-application .widget-tab__isometry-arrows::before{width:calc(100% + 15px);border-radius:30px}.widget-application .widget-tab__isometry-arrows span{font-size:28px;font-weight:700;display:block;margin:0 9px}.widget-application--tablet.widget-application .widget-tab__isometry-arrows span{font-size:22px}.widget-application--mobile.widget-application .widget-tab__isometry-arrows span{font-size:17px;margin:0 3px}.widget-application--smallMobile.widget-application .widget-tab__isometry-arrows span{font-size:14px;margin:0}.widget-application .widget-tab__isometry-arrow{ouline:none;border:none;box-shadow:none;background:rgba(0,0,0,0);cursor:pointer;display:flex;align-items:center;justify-content:center;padding:5px}.widget-application .widget-tab__isometry-arrow img{width:32px}.widget-application--tablet.widget-application .widget-tab__isometry-arrow img{width:24px}.widget-application--mobile.widget-application .widget-tab__isometry-arrow img{width:18px}.widget-application--smallMobile.widget-application .widget-tab__isometry-arrow img{width:14px}.widget-application .widget-tab__isometry-buttons{position:absolute;z-index:3;left:44px;bottom:35px;display:flex;align-items:center;justify-content:flex-end}.widget-application--tablet.widget-application .widget-tab__isometry-buttons{left:35px;bottom:35px}.widget-application--mobile.widget-application .widget-tab__isometry-buttons{left:22px;bottom:22px}.widget-application--smallMobile.widget-application .widget-tab__isometry-buttons{left:20px;bottom:30px}.widget-application .widget-tab__isometry-button{ouline:none;border:none;box-shadow:none;background:rgba(0,0,0,0);cursor:pointer;width:72px;height:72px;border-radius:50%;display:flex;align-items:center;justify-content:center;background-color:#eaeaea;margin-top:40px}.widget-application--tablet.widget-application .widget-tab__isometry-button{margin-top:20px;width:60px;height:60px}.widget-application--mobile.widget-application .widget-tab__isometry-button{margin-top:10px;width:44px;height:44px}.widget-application--smallMobile.widget-application .widget-tab__isometry-button{width:36px;height:36px}.widget-application .widget-tab__isometry-button img{display:block;width:50px}.widget-application--tablet.widget-application .widget-tab__isometry-button img{width:40px}.widget-application--mobile.widget-application .widget-tab__isometry-button img{width:30px}.widget-application--smallMobile.widget-application .widget-tab__isometry-button img{width:25px}.widget-application .widget-loader{display:block;position:relative;width:80px;height:80px}.widget-application .widget-loader--absolute{position:absolute;left:50%;top:50%;transform:translate(-50%, -50%)}.widget-application .widget-loader--sm{transform:translate(-50%, -50%) scale(0.75)}.widget-application .widget-loader div{position:absolute;top:33px;width:13px;height:13px;border-radius:50%;background:var(--main-color);animation-timing-function:cubic-bezier(0, 1, 1, 0)}.widget-application .widget-loader div:nth-child(1){left:8px;animation:widget-loader-1 .6s infinite}.widget-application .widget-loader div:nth-child(2){left:8px;animation:widget-loader-2 .6s infinite}.widget-application .widget-loader div:nth-child(3){left:32px;animation:widget-loader-2 .6s infinite}.widget-application .widget-loader div:nth-child(4){left:56px;animation:widget-loader-3 .6s infinite}@keyframes widget-loader-1{0%{transform:scale(0)}100%{transform:scale(1)}}@keyframes widget-loader-3{0%{transform:scale(1)}100%{transform:scale(0)}}@keyframes widget-loader-2{0%{transform:translate(0, 0)}100%{transform:translate(24px, 0)}}.widget-application .widget-watermark-button{position:absolute;right:4px;bottom:4px;z-index:1000}.widget-application--tablet.widget-application .widget-watermark-button{right:3px;bottom:2px}.widget-application--mobile.widget-application .widget-watermark-button{right:2px}.widget-application--smallMobile.widget-application .widget-watermark-button{right:13px;bottom:8px}.widget-application .widget-watermark-button a{font-size:18px;line-height:90%;color:#000;opacity:.5}.widget-application--tablet.widget-application .widget-watermark-button a{font-size:15px}.widget-application--mobile.widget-application .widget-watermark-button a{font-size:10px}.widget-application--smallMobile.widget-application .widget-watermark-button a{font-size:9px}.widget-application .widget-watermark-button a span{font-weight:100;font-size:inherit;line-height:90%;color:inherit}.widget-application .floors-select{position:absolute;top:47px;left:50%;background:none;height:37px;border:none;transform:translateX(-50%);cursor:pointer;white-space:nowrap;overflow-x:visible;z-index:3}.widget-application .floors-select--text{user-select:none;-webkit-user-select:none;user-drag:none;-webkit-user-drag:none;font-size:28px;line-height:36px;font-weight:700;word-spacing:-12px;border-bottom:1px #413e3e solid;padding:0 2px}.widget-application--tablet.widget-application .floors-select--text{font-size:24px;line-height:32px;word-spacing:-9px}.widget-application--mobile.widget-application .floors-select--text{font-size:20px;line-height:28px;word-spacing:-6px}.widget-application .floors-select--text:hover{border-bottom:1px #000 solid}.widget-application .floors-select--block{display:flex;flex-direction:column;background:#fff;margin-top:7px;border-radius:6px;-moz-box-shadow:0 0 2px 2px rgba(0,0,0,.2);-webkit-box-shadow:0 0 2px 2px rgba(0,0,0,.2);box-shadow:0 0 2px 2px rgba(0,0,0,.2);overflow:hidden}.widget-application .floors-select--block-item{font-size:20px;text-align:center;line-height:40px;word-spacing:-9px}.widget-application--tablet.widget-application .floors-select--block-item{font-size:18px;word-spacing:-5px}.widget-application--mobile.widget-application .floors-select--block-item{font-size:16px;word-spacing:-4px}.widget-application .floors-select--block-item:active{background:linear-gradient(180deg, rgba(0, 0, 0, 0.1) 0%, rgba(0, 0, 0, 0) 100%)}.widget-application .floors-select--block-item--active{background:var(--main-color)}.widget-application .widget-tab-rooms{user-select:none;-webkit-user-select:none;user-drag:none;-webkit-user-drag:none;position:absolute;bottom:20px;width:100%;max-width:100%;height:69px;overflow-x:scroll;-ms-overflow-style:none;overflow:-moz-scrollbars-none}.widget-application--mobile.widget-application .widget-tab-rooms{bottom:90px}.widget-application .widget-tab-rooms::-webkit-scrollbar{width:0;display:none}.widget-application .widget-tab-rooms-container{display:flex;column-gap:22px}.widget-application--mobile.widget-application .widget-tab-rooms-container{column-gap:10px}.widget-application .widget-tab-rooms-item{position:relative;flex-shrink:0;display:flex;flex-direction:column;align-items:center;background:#fff;width:93px;height:69px;padding:4px 3px;border:2px solid var(--main-color);border-radius:12px;cursor:pointer}.widget-application--mobile.widget-application .widget-tab-rooms-item{width:68px;height:50px;padding:2px 0;border-radius:9px}.widget-application .widget-tab-rooms-item:first-child{margin-left:30px}.widget-application--mobile.widget-application .widget-tab-rooms-item:first-child{margin-left:20px}.widget-application .widget-tab-rooms-item:last-child::after{content:"";position:absolute;right:-30px;top:0;width:30px;height:1px}.widget-application--mobile.widget-application .widget-tab-rooms-item:last-child::after{right:-20px;width:20px}.widget-application .widget-tab-rooms-item-img{user-select:none;-webkit-user-select:none;user-drag:none;-webkit-user-drag:none;height:26px !important;width:46px !important}.widget-application--mobile.widget-application .widget-tab-rooms-item-img{height:19px !important;width:34px !important}.widget-application .widget-tab-rooms-item-type{user-select:none;-webkit-user-select:none;user-drag:none;-webkit-user-drag:none;font-size:12px;font-weight:700;line-height:11px;letter-spacing:-0.03em;text-align:center;color:rgba(65,62,62,.5);margin-top:3px}.widget-application--mobile.widget-application .widget-tab-rooms-item-type{font-size:9px;line-height:8px;letter-spacing:-0.03em;margin-top:2px}.widget-application .widget-tab-rooms-item-area{user-select:none;-webkit-user-select:none;user-drag:none;-webkit-user-drag:none;font-size:10px;font-weight:700;line-height:12px;letter-spacing:-0.08em;word-spacing:-1px;text-align:center;color:#413e3e;margin-top:4px}.widget-application--mobile.widget-application .widget-tab-rooms-item-area{font-size:7px;line-height:8px;margin-top:2px}.widget-application .widget-tab-rooms-item-active{background:var(--main-color)}.widget-application .widget-tab-rooms-item-active .widget-tab-rooms-item-img{filter:invert(100%) sepia(99%) saturate(0%) hue-rotate(97deg) brightness(105%) contrast(100%)}.widget-application .widget-tab-rooms-item-active .widget-tab-rooms-item-type{color:#fff}.widget-application .widget-tab-rooms-item-active .widget-tab-rooms-item-area{color:#fff}.widget-application .widget-tab-rooms-switch{position:fixed;bottom:119px;left:30px;width:109px;height:29px}.widget-application--mobile.widget-application .widget-tab-rooms-switch{bottom:30px;left:26px}.widget-application .widget-tab-rooms-switch-checkbox{height:0;width:0;visibility:hidden}.widget-application .widget-tab-rooms-switch-checkbox:checked+.widget-tab-rooms-switch-label .widget-tab-rooms-switch-button{left:calc(100% - 1px);transform:translateX(-100%)}.widget-application .widget-tab-rooms-switch-label{position:absolute;top:0;display:flex;align-items:center;justify-content:space-between;cursor:pointer;width:109px;height:29px;border-radius:20px;border:1px solid var(--main-color);transition:background-color .2s}.widget-application .widget-tab-rooms-switch-label .widget-tab-rooms-switch-button{content:"";position:absolute;top:1px;left:1px;width:56px;height:25px;border-radius:45px;transition:.2s;background:var(--main-color)}.widget-application .widget-tab-rooms-switch-text{position:absolute;display:flex;align-items:center;justify-content:space-between;width:100%;padding:0 10px 0 15px}.widget-application .widget-tab-rooms-switch-text-item{font-size:12px;font-weight:700;line-height:11px;color:var(--main-color);letter-spacing:-0.03em}.widget-application .widget-tab-rooms-switch-text .active{color:#fff}',
                ""
            ]);
            const o = s;
        },
        314: (t1)=>{
            "use strict";
            t1.exports = function(t1) {
                var e = [];
                return e.toString = function() {
                    return this.map(function(e) {
                        var i = "", n = void 0 !== e[5];
                        return e[4] && (i += "@supports (".concat(e[4], ") {")), e[2] && (i += "@media ".concat(e[2], " {")), n && (i += "@layer".concat(e[5].length > 0 ? " ".concat(e[5]) : "", " {")), i += t1(e), n && (i += "}"), e[2] && (i += "}"), e[4] && (i += "}"), i;
                    }).join("");
                }, e.i = function(t1, i, n, r, a) {
                    "string" == typeof t1 && (t1 = [
                        [
                            null,
                            t1,
                            void 0
                        ]
                    ]);
                    var s = {};
                    if (n) for(var o = 0; o < this.length; o++){
                        var l = this[o][0];
                        null != l && (s[l] = !0);
                    }
                    for(var c = 0; c < t1.length; c++){
                        var u = [].concat(t1[c]);
                        n && s[u[0]] || (void 0 !== a && (void 0 === u[5] || (u[1] = "@layer".concat(u[5].length > 0 ? " ".concat(u[5]) : "", " {").concat(u[1], "}")), u[5] = a), i && (u[2] ? (u[1] = "@media ".concat(u[2], " {").concat(u[1], "}"), u[2] = i) : u[2] = i), r && (u[4] ? (u[1] = "@supports (".concat(u[4], ") {").concat(u[1], "}"), u[4] = r) : u[4] = "".concat(r)), e.push(u));
                    }
                }, e;
            };
        },
        417: (t1)=>{
            "use strict";
            t1.exports = function(t1, e) {
                return e || (e = {}), t1 ? (t1 = String(t1.__esModule ? t1.default : t1), /^['"].*['"]$/.test(t1) && (t1 = t1.slice(1, -1)), e.hash && (t1 += e.hash), /["'() \t\n]|(%20)/.test(t1) || e.needQuotes ? '"'.concat(t1.replace(/"/g, '\\"').replace(/\n/g, "\\n"), '"') : t1) : t1;
            };
        },
        601: (t1)=>{
            "use strict";
            t1.exports = function(t1) {
                return t1[1];
            };
        },
        790: (t1)=>{
            t1.exports = function(t1) {
                !function(t1) {
                    if (!t1) throw new Error("Eventify cannot use falsy object as events subject");
                    for(var e = [
                        "on",
                        "fire",
                        "off"
                    ], i = 0; i < e.length; ++i)if (t1.hasOwnProperty(e[i])) throw new Error("Subject cannot be eventified, since it already has property '" + e[i] + "'");
                }(t1);
                var e = function(t1) {
                    var e = Object.create(null);
                    return {
                        on: function(i, n, r) {
                            if ("function" != typeof n) throw new Error("callback is expected to be a function");
                            var a = e[i];
                            return a || (a = e[i] = []), a.push({
                                callback: n,
                                ctx: r
                            }), t1;
                        },
                        off: function(i, n) {
                            if (void 0 === i) return e = Object.create(null), t1;
                            if (e[i]) {
                                if ("function" != typeof n) delete e[i];
                                else for(var r = e[i], a = 0; a < r.length; ++a)r[a].callback === n && r.splice(a, 1);
                            }
                            return t1;
                        },
                        fire: function(i) {
                            var n, r = e[i];
                            if (!r) return t1;
                            arguments.length > 1 && (n = Array.prototype.splice.call(arguments, 1));
                            for(var a = 0; a < r.length; ++a){
                                var s = r[a];
                                s.callback.apply(s.ctx, n);
                            }
                            return t1;
                        }
                    };
                }(t1);
                return t1.on = e.on, t1.off = e.off, t1.fire = e.fire, t1;
            };
        },
        228: (t1)=>{
            "use strict";
            var e = Object.getOwnPropertySymbols, i = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
            t1.exports = function() {
                try {
                    if (!Object.assign) return !1;
                    var t1 = new String("abc");
                    if (t1[5] = "de", "5" === Object.getOwnPropertyNames(t1)[0]) return !1;
                    for(var e = {}, i = 0; i < 10; i++)e["_" + String.fromCharCode(i)] = i;
                    if ("0123456789" !== Object.getOwnPropertyNames(e).map(function(t1) {
                        return e[t1];
                    }).join("")) return !1;
                    var n = {};
                    return "abcdefghijklmnopqrst".split("").forEach(function(t1) {
                        n[t1] = t1;
                    }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, n)).join("");
                } catch (t1) {
                    return !1;
                }
            }() ? Object.assign : function(t1, r) {
                for(var a, s, o = function(t1) {
                    if (null == t1) throw new TypeError("Object.assign cannot be called with null or undefined");
                    return Object(t1);
                }(t1), l = 1; l < arguments.length; l++){
                    for(var c in a = Object(arguments[l]))i.call(a, c) && (o[c] = a[c]);
                    if (e) {
                        s = e(a);
                        for(var u = 0; u < s.length; u++)n.call(a, s[u]) && (o[s[u]] = a[s[u]]);
                    }
                }
                return o;
            };
        },
        611: (t1, e, i)=>{
            "use strict";
            var n = i(964), r = i(375), a = i(790), s = i(860), o = i(833), l = o(), c = o(!0), u = i(59), h = i(25), d = i(35);
            function p(t1, e) {
                var i = (e = e || {}).controller;
                if (i || (h.canAttach(t1) ? i = h(t1, e) : d.canAttach(t1) && (i = d(t1, e))), !i) throw new Error("Cannot create panzoom for the current type of dom element");
                var o = i.getOwner(), p = {
                    x: 0,
                    y: 0
                }, f = !1, v = new u;
                i.initTransform && i.initTransform(v);
                var y, x = "function" == typeof e.filterKey ? e.filterKey : m, w = "number" == typeof e.pinchSpeed ? e.pinchSpeed : 1, b = e.bounds, T = "number" == typeof e.maxZoom ? e.maxZoom : Number.POSITIVE_INFINITY, E = "number" == typeof e.minZoom ? e.minZoom : 0, _ = "number" == typeof e.boundsPadding ? e.boundsPadding : .05, I = "number" == typeof e.zoomDoubleClickSpeed ? e.zoomDoubleClickSpeed : 1.75, S = e.beforeWheel || m, N = e.beforeMouseDown || m, D = "number" == typeof e.zoomSpeed ? e.zoomSpeed : 1, C = A(e.transformOrigin), z = e.enableTextSelection ? c : l;
                !function(t1) {
                    var e = typeof t1;
                    if ("undefined" !== e && "boolean" !== e && !(g(t1.left) && g(t1.top) && g(t1.bottom) && g(t1.right))) throw new Error("Bounds object is not valid. It can be: undefined, boolean (true|false) or an object {left, top, right, bottom}");
                }(b), e.autocenter && function() {
                    var t1, e, n = 0, r = 0, a = at();
                    if (a) n = a.left, r = a.top, t1 = a.right - a.left, e = a.bottom - a.top;
                    else {
                        var s = o.getBoundingClientRect();
                        t1 = s.width, e = s.height;
                    }
                    var l = i.getBBox();
                    if (0 !== l.width && 0 !== l.height) {
                        var c = e / l.height, u = t1 / l.width, h = Math.min(u, c);
                        v.x = -(l.left + l.width / 2) * h + t1 / 2 + n, v.y = -(l.top + l.height / 2) * h + e / 2 + r, v.scale = h;
                    }
                }();
                var L, O, P, j, R, k, U, B, F, Q, H = 0, V = 0, G = 0, W = null, Y = new Date, X = !1, Z = !1;
                U = "smoothScroll" in e && !e.smoothScroll ? {
                    start: m,
                    stop: m,
                    cancel: m
                } : s(function() {
                    return {
                        x: v.x,
                        y: v.y
                    };
                }, function(t1, e) {
                    zt(), it(t1, e);
                }, e.smoothScroll);
                var q = !1;
                ut();
                var J = {
                    dispose: function() {
                        ht();
                    },
                    moveBy: ct,
                    moveTo: it,
                    smoothMoveTo: function(t1, e) {
                        ct(t1 - v.x, e - v.y, !0);
                    },
                    centerOn: function(t1) {
                        var e = t1.ownerSVGElement;
                        if (!e) throw new Error("ui element is required to be within the scene");
                        var i = t1.getBoundingClientRect(), n = i.left + i.width / 2, r = i.top + i.height / 2, a = e.getBoundingClientRect();
                        ct(a.width / 2 - n, a.height / 2 - r, !0);
                    },
                    zoomTo: Ct,
                    zoomAbs: lt,
                    smoothZoom: Nt,
                    smoothZoomAbs: function(t1, e, i) {
                        var n = {
                            scale: v.scale
                        }, a = {
                            scale: i
                        };
                        U.cancel(), zt(), F = r(n, a, {
                            step: function(i) {
                                lt(t1, e, i.scale);
                            }
                        });
                    },
                    showRectangle: function(t1) {
                        var e = o.getBoundingClientRect(), i = et(e.width, e.height), n = t1.right - t1.left, r = t1.bottom - t1.top;
                        if (!Number.isFinite(n) || !Number.isFinite(r)) throw new Error("Invalid rectangle");
                        var a = i.x / n, s = i.y / r, l = Math.min(a, s);
                        v.x = -(t1.left + n / 2) * l + i.x / 2, v.y = -(t1.top + r / 2) * l + i.y / 2, v.scale = l;
                    },
                    pause: function() {
                        ht(), q = !0;
                    },
                    resume: function() {
                        q && (ut(), q = !1);
                    },
                    isPaused: function() {
                        return q;
                    },
                    getTransform: function() {
                        return v;
                    },
                    getMinZoom: function() {
                        return E;
                    },
                    setMinZoom: function(t1) {
                        E = t1;
                    },
                    getMaxZoom: function() {
                        return T;
                    },
                    setMaxZoom: function(t1) {
                        T = t1;
                    },
                    getTransformOrigin: function() {
                        return C;
                    },
                    setTransformOrigin: function(t1) {
                        C = A(t1);
                    },
                    getZoomSpeed: function() {
                        return D;
                    },
                    setZoomSpeed: function(t1) {
                        if (!Number.isFinite(t1)) throw new Error("Zoom speed should be a number");
                        D = t1;
                    }
                };
                a(J);
                var K = "number" == typeof e.initialX ? e.initialX : v.x, $ = "number" == typeof e.initialY ? e.initialY : v.y, tt = "number" == typeof e.initialZoom ? e.initialZoom : v.scale;
                return K == v.x && $ == v.y && tt == v.scale || lt(K, $, tt), J;
                function et(t1, e) {
                    if (i.getScreenCTM) {
                        var n = i.getScreenCTM(), r = n.a, a = n.d, s = n.e, o = n.f;
                        p.x = t1 * r - s, p.y = e * a - o;
                    } else p.x = t1, p.y = e;
                    return p;
                }
                function it(t1, e) {
                    v.x = t1, v.y = e, rt(), Rt("pan"), st();
                }
                function nt(t1, e) {
                    it(v.x + t1, v.y + e);
                }
                function rt() {
                    var t1 = at();
                    if (t1) {
                        var e, n, r, a, s = !1, o = (r = (e = i.getBBox()).left, a = e.top, {
                            left: (n = {
                                x: r * v.scale + v.x,
                                y: a * v.scale + v.y
                            }).x,
                            top: n.y,
                            right: e.width * v.scale + n.x,
                            bottom: e.height * v.scale + n.y
                        }), l = t1.left - o.right;
                        return l > 0 && (v.x += l, s = !0), (l = t1.right - o.left) < 0 && (v.x += l, s = !0), (l = t1.top - o.bottom) > 0 && (v.y += l, s = !0), (l = t1.bottom - o.top) < 0 && (v.y += l, s = !0), s;
                    }
                }
                function at() {
                    if (b) {
                        if ("boolean" == typeof b) {
                            var t1 = o.getBoundingClientRect(), e = t1.width, i = t1.height;
                            return {
                                left: e * _,
                                top: i * _,
                                right: e * (1 - _),
                                bottom: i * (1 - _)
                            };
                        }
                        return b;
                    }
                }
                function st() {
                    f = !0, y = window.requestAnimationFrame(dt);
                }
                function ot(t1, e, i) {
                    if (M(t1) || M(e) || M(i)) throw new Error("zoom requires valid numbers");
                    var n = v.scale * i;
                    if (n < E) {
                        if (v.scale === E) return;
                        i = E / v.scale;
                    }
                    if (n > T) {
                        if (v.scale === T) return;
                        i = T / v.scale;
                    }
                    var r = et(t1, e);
                    v.x = r.x - i * (r.x - v.x), v.y = r.y - i * (r.y - v.y), b && 1 === _ && 1 === E ? (v.scale *= i, rt()) : rt() || (v.scale *= i), Rt("zoom"), st();
                }
                function lt(t1, e, i) {
                    ot(t1, e, i / v.scale);
                }
                function ct(t1, e, i) {
                    if (!i) return nt(t1, e);
                    B && B.cancel();
                    var n = 0, a = 0;
                    B = r({
                        x: 0,
                        y: 0
                    }, {
                        x: t1,
                        y: e
                    }, {
                        step: function(t1) {
                            nt(t1.x - n, t1.y - a), n = t1.x, a = t1.y;
                        }
                    });
                }
                function ut() {
                    o.addEventListener("mousedown", wt, {
                        passive: !1
                    }), o.addEventListener("dblclick", xt, {
                        passive: !1
                    }), o.addEventListener("touchstart", At, {
                        passive: !1
                    }), o.addEventListener("keydown", pt, {
                        passive: !1
                    }), n.addWheelListener(o, It, {
                        passive: !1
                    }), st();
                }
                function ht() {
                    n.removeWheelListener(o, It), o.removeEventListener("mousedown", wt), o.removeEventListener("keydown", pt), o.removeEventListener("dblclick", xt), o.removeEventListener("touchstart", At), y && (window.cancelAnimationFrame(y), y = 0), U.cancel(), Et(), _t(), z.release(), Pt();
                }
                function dt() {
                    f && (f = !1, i.applyTransform(v), Rt("transform"), y = 0);
                }
                function pt(t1) {
                    var e = 0, i = 0, n = 0;
                    if (38 === t1.keyCode ? i = 1 : 40 === t1.keyCode ? i = -1 : 37 === t1.keyCode ? e = 1 : 39 === t1.keyCode ? e = -1 : 189 === t1.keyCode || 109 === t1.keyCode ? n = 1 : 187 !== t1.keyCode && 107 !== t1.keyCode || (n = -1), !x(t1, e, i, n)) {
                        if (e || i) {
                            t1.preventDefault(), t1.stopPropagation();
                            var r = o.getBoundingClientRect();
                            ct(.05 * (a = Math.min(r.width, r.height)) * e, .05 * a * i);
                        }
                        if (n) {
                            var a, s = Lt(100 * n);
                            Ct((a = C ? Dt() : {
                                x: (l = o.getBoundingClientRect()).width / 2,
                                y: l.height / 2
                            }).x, a.y, s);
                        }
                        var l;
                    }
                }
                function At(t1) {
                    if (function(t1) {
                        e.onTouch && !e.onTouch(t1) || (t1.stopPropagation(), t1.preventDefault());
                    }(t1), gt(), 1 === t1.touches.length) return function(t1) {
                        V = new Date;
                        var e = St(t1.touches[0]);
                        L = e;
                        var i = et(e.x, e.y);
                        O = i.x, P = i.y, j = O, R = P, U.cancel(), ft();
                    }(t1, t1.touches[0]);
                    2 === t1.touches.length && (k = yt(t1.touches[0], t1.touches[1]), Q = !0, ft());
                }
                function ft() {
                    X || (X = !0, document.addEventListener("touchmove", mt), document.addEventListener("touchend", vt), document.addEventListener("touchcancel", vt));
                }
                function mt(t1) {
                    if (1 === t1.touches.length) {
                        t1.stopPropagation();
                        var e = et((u = St(t1.touches[0])).x, u.y), i = e.x - O, n = e.y - P;
                        0 !== i && 0 !== n && Ot(), O = e.x, P = e.y, ct(i, n);
                    } else if (2 === t1.touches.length) {
                        Q = !0;
                        var r = t1.touches[0], a = t1.touches[1], s = yt(r, a), o = 1 + (s / k - 1) * w, l = St(r), c = St(a);
                        if (O = (l.x + c.x) / 2, P = (l.y + c.y) / 2, C) {
                            var u = Dt();
                            O = u.x, P = u.y;
                        }
                        Ct(O, P, o), k = s, t1.stopPropagation(), t1.preventDefault();
                    }
                }
                function gt() {
                    G && (clearTimeout(G), G = 0);
                }
                function Mt(t1) {
                    if (e.onClick) {
                        gt();
                        var i = O - j, n = P - R;
                        Math.sqrt(i * i + n * n) > 5 || (G = setTimeout(function() {
                            G = 0, e.onClick(t1);
                        }, 300));
                    }
                }
                function vt(t1) {
                    if (gt(), t1.touches.length > 0) {
                        var e = et((i = St(t1.touches[0])).x, i.y);
                        O = e.x, P = e.y;
                    } else {
                        var i, n = new Date;
                        n - H < 300 ? C ? Nt((i = Dt()).x, i.y, I) : Nt(L.x, L.y, I) : n - V < 200 && Mt(t1), H = n, Pt(), _t();
                    }
                }
                function yt(t1, e) {
                    var i = t1.clientX - e.clientX, n = t1.clientY - e.clientY;
                    return Math.sqrt(i * i + n * n);
                }
                function xt(t1) {
                    !function(t1) {
                        gt(), e.onDoubleClick && !e.onDoubleClick(t1) || (t1.preventDefault(), t1.stopPropagation());
                    }(t1);
                    var i = St(t1);
                    C && (i = Dt()), Nt(i.x, i.y, I);
                }
                function wt(t1) {
                    if (gt(), !N(t1)) {
                        if (W = t1, Y = new Date, X) return t1.stopPropagation(), !1;
                        if (1 === t1.button && null !== window.event || 0 === t1.button) {
                            U.cancel();
                            var e = St(t1), i = et(e.x, e.y);
                            return j = O = i.x, R = P = i.y, document.addEventListener("mousemove", bt), document.addEventListener("mouseup", Tt), z.capture(t1.target || t1.srcElement), !1;
                        }
                    }
                }
                function bt(t1) {
                    if (!X) {
                        Ot();
                        var e = St(t1), i = et(e.x, e.y), n = i.x - O, r = i.y - P;
                        O = i.x, P = i.y, ct(n, r);
                    }
                }
                function Tt() {
                    new Date - Y < 200 && Mt(W), z.release(), Pt(), Et();
                }
                function Et() {
                    document.removeEventListener("mousemove", bt), document.removeEventListener("mouseup", Tt), Z = !1;
                }
                function _t() {
                    document.removeEventListener("touchmove", mt), document.removeEventListener("touchend", vt), document.removeEventListener("touchcancel", vt), Z = !1, Q = !1, X = !1;
                }
                function It(t1) {
                    if (!S(t1)) {
                        U.cancel();
                        var e = t1.deltaY;
                        t1.deltaMode > 0 && (e *= 100);
                        var i = Lt(e);
                        if (1 !== i) {
                            var n = C ? Dt() : St(t1);
                            Ct(n.x, n.y, i), t1.preventDefault();
                        }
                    }
                }
                function St(t1) {
                    var e = o.getBoundingClientRect();
                    return {
                        x: t1.clientX - e.left,
                        y: t1.clientY - e.top
                    };
                }
                function Nt(t1, e, i) {
                    var n = v.scale, a = {
                        scale: n
                    }, s = {
                        scale: i * n
                    };
                    U.cancel(), zt(), F = r(a, s, {
                        step: function(i) {
                            lt(t1, e, i.scale);
                        },
                        done: jt
                    });
                }
                function Dt() {
                    var t1 = o.getBoundingClientRect();
                    return {
                        x: t1.width * C.x,
                        y: t1.height * C.y
                    };
                }
                function Ct(t1, e, i) {
                    return U.cancel(), zt(), ot(t1, e, i);
                }
                function zt() {
                    F && (F.cancel(), F = null);
                }
                function Lt(t1) {
                    return 1 - Math.sign(t1) * Math.min(.25, Math.abs(D * t1 / 128));
                }
                function Ot() {
                    Z || (Rt("panstart"), Z = !0, U.start());
                }
                function Pt() {
                    Z && (Q || U.stop(), Rt("panend"));
                }
                function jt() {
                    Rt("zoomend");
                }
                function Rt(t1) {
                    J.fire(t1, J);
                }
            }
            function A(t1) {
                if (t1) return "object" == typeof t1 ? (g(t1.x) && g(t1.y) || f(t1), t1) : void f();
            }
            function f(t1) {
                throw console.error(t1), new Error([
                    "Cannot parse transform origin.",
                    "Some good examples:",
                    '  "center center" can be achieved with {x: 0.5, y: 0.5}',
                    '  "top center" can be achieved with {x: 0.5, y: 0}',
                    '  "bottom right" can be achieved with {x: 1, y: 1}'
                ].join("\n"));
            }
            function m() {}
            function g(t1) {
                return Number.isFinite(t1);
            }
            function M(t1) {
                return Number.isNaN ? Number.isNaN(t1) : t1 != t1;
            }
            t1.exports = p, function() {
                if ("undefined" != typeof document) {
                    var t1 = document.getElementsByTagName("script");
                    if (t1) {
                        for(var e, i = 0; i < t1.length; ++i){
                            var n = t1[i];
                            if (n.src && n.src.match(/\bpanzoom(\.min)?\.js/)) {
                                e = n;
                                break;
                            }
                        }
                        if (e) {
                            var r = e.getAttribute("query");
                            if (r) {
                                var a = e.getAttribute("name") || "pz", s = Date.now();
                                !function t1() {
                                    var i = document.querySelector(r);
                                    if (!i) return Date.now() - s < 2e3 ? void setTimeout(t1, 100) : void console.error("Cannot find the panzoom element", a);
                                    var n = function(t1) {
                                        for(var e = t1.attributes, i = {}, n = 0; n < e.length; ++n){
                                            var r = o(e[n]);
                                            r && (i[r.name] = r.value);
                                        }
                                        return i;
                                    }(e);
                                    console.log(n), window[a] = p(i, n);
                                }();
                            }
                        }
                    }
                }
                function o(t1) {
                    if (t1.name && "p" === t1.name[0] && "z" === t1.name[1] && "-" === t1.name[2]) return {
                        name: t1.name.substr(3),
                        value: JSON.parse(t1.value)
                    };
                }
            }();
        },
        833: (t1)=>{
            function e(t1) {
                return t1.stopPropagation(), !1;
            }
            function i() {}
            t1.exports = function(t1) {
                if (t1) return {
                    capture: i,
                    release: i
                };
                var n, r, a, s = !1;
                return {
                    capture: function(t1) {
                        s = !0, r = window.document.onselectstart, a = window.document.ondragstart, window.document.onselectstart = e, (n = t1).ondragstart = e;
                    },
                    release: function() {
                        s && (s = !1, window.document.onselectstart = r, n && (n.ondragstart = a));
                    }
                };
            };
        },
        35: (t1)=>{
            function e(t1) {
                return t1 && t1.parentElement && t1.style;
            }
            t1.exports = function(t1, i) {
                if (!e(t1)) throw new Error("panzoom requires DOM element to be attached to the DOM tree");
                var n = t1.parentElement;
                return t1.scrollTop = 0, i.disableKeyboardInteraction || n.setAttribute("tabindex", 0), {
                    getBBox: function() {
                        return {
                            left: 0,
                            top: 0,
                            width: t1.clientWidth,
                            height: t1.clientHeight
                        };
                    },
                    getOwner: function() {
                        return n;
                    },
                    applyTransform: function(e) {
                        t1.style.transformOrigin = "0 0 0", t1.style.transform = "matrix(" + e.scale + ", 0, 0, " + e.scale + ", " + e.x + ", " + e.y + ")";
                    }
                };
            }, t1.exports.canAttach = e;
        },
        860: (t1)=>{
            function e() {
                return "function" == typeof cancelAnimationFrame ? cancelAnimationFrame : clearTimeout;
            }
            function i() {
                return "function" == typeof requestAnimationFrame ? requestAnimationFrame : function(t1) {
                    return setTimeout(t1, 16);
                };
            }
            t1.exports = function(t1, n, r) {
                "object" != typeof r && (r = {});
                var a, s, o, l, c, u, h, d, p, A, f = "number" == typeof r.minVelocity ? r.minVelocity : 5, m = "number" == typeof r.amplitude ? r.amplitude : .25, g = "function" == typeof r.cancelAnimationFrame ? r.cancelAnimationFrame : e(), M = "function" == typeof r.requestAnimationFrame ? r.requestAnimationFrame : i();
                return {
                    start: function() {
                        a = t1(), u = p = l = h = 0, s = new Date, g(o), g(A), o = M(v);
                    },
                    stop: function() {
                        g(o), g(A);
                        var e = t1();
                        c = e.x, d = e.y, s = Date.now(), (l < -f || l > f) && (c += u = m * l), (h < -f || h > f) && (d += p = m * h), A = M(y);
                    },
                    cancel: function() {
                        g(o), g(A);
                    }
                };
                function v() {
                    var e = Date.now(), i = e - s;
                    s = e;
                    var n = t1(), r = n.x - a.x, c = n.y - a.y;
                    a = n;
                    var u = 1e3 / (1 + i);
                    l = .8 * r * u + .2 * l, h = .8 * c * u + .2 * h, o = M(v);
                }
                function y() {
                    var t1 = Date.now() - s, e = !1, i = 0, r = 0;
                    u && ((i = -u * Math.exp(-t1 / 342)) > .5 || i < -0.5 ? e = !0 : i = u = 0), p && ((r = -p * Math.exp(-t1 / 342)) > .5 || r < -0.5 ? e = !0 : r = p = 0), e && (n(c + i, d + r), A = M(y));
                }
            };
        },
        25: (t1)=>{
            function e(t1) {
                return t1 && t1.ownerSVGElement && t1.getCTM;
            }
            t1.exports = function(t1, i) {
                if (!e(t1)) throw new Error("svg element is required for svg.panzoom to work");
                var n = t1.ownerSVGElement;
                if (!n) throw new Error("Do not apply panzoom to the root <svg> element. Use its child instead (e.g. <g></g>). As of March 2016 only FireFox supported transform on the root element");
                return i.disableKeyboardInteraction || n.setAttribute("tabindex", 0), {
                    getBBox: function() {
                        var e = t1.getBBox();
                        return {
                            left: e.x,
                            top: e.y,
                            width: e.width,
                            height: e.height
                        };
                    },
                    getScreenCTM: function() {
                        var t1 = n.getCTM();
                        return t1 || n.getScreenCTM();
                    },
                    getOwner: function() {
                        return n;
                    },
                    applyTransform: function(e) {
                        t1.setAttribute("transform", "matrix(" + e.scale + " 0 0 " + e.scale + " " + e.x + " " + e.y + ")");
                    },
                    initTransform: function(e) {
                        var i = t1.getCTM();
                        null === i && (i = document.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGMatrix()), e.x = i.e, e.y = i.f, e.scale = i.a, n.removeAttributeNS(null, "viewBox");
                    }
                };
            }, t1.exports.canAttach = e;
        },
        59: (t1)=>{
            t1.exports = function() {
                this.x = 0, this.y = 0, this.scale = 1;
            };
        },
        551: (t1, e, i)=>{
            "use strict";
            var n = i(540), r = i(228), a = i(982);
            function s(t1) {
                for(var e = "https://reactjs.org/docs/error-decoder.html?invariant=" + t1, i = 1; i < arguments.length; i++)e += "&args[]=" + encodeURIComponent(arguments[i]);
                return "Minified React error #" + t1 + "; visit " + e + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
            }
            if (!n) throw Error(s(227));
            var o = new Set, l = {};
            function c(t1, e) {
                u(t1, e), u(t1 + "Capture", e);
            }
            function u(t1, e) {
                for(l[t1] = e, t1 = 0; t1 < e.length; t1++)o.add(e[t1]);
            }
            var h = !("undefined" == typeof window || void 0 === window.document || void 0 === window.document.createElement), d = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, p = Object.prototype.hasOwnProperty, A = {}, f = {};
            function m(t1, e, i, n, r, a, s) {
                this.acceptsBooleans = 2 === e || 3 === e || 4 === e, this.attributeName = n, this.attributeNamespace = r, this.mustUseProperty = i, this.propertyName = t1, this.type = e, this.sanitizeURL = a, this.removeEmptyString = s;
            }
            var g = {};
            "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(t1) {
                g[t1] = new m(t1, 0, !1, t1, null, !1, !1);
            }), [
                [
                    "acceptCharset",
                    "accept-charset"
                ],
                [
                    "className",
                    "class"
                ],
                [
                    "htmlFor",
                    "for"
                ],
                [
                    "httpEquiv",
                    "http-equiv"
                ]
            ].forEach(function(t1) {
                var e = t1[0];
                g[e] = new m(e, 1, !1, t1[1], null, !1, !1);
            }), [
                "contentEditable",
                "draggable",
                "spellCheck",
                "value"
            ].forEach(function(t1) {
                g[t1] = new m(t1, 2, !1, t1.toLowerCase(), null, !1, !1);
            }), [
                "autoReverse",
                "externalResourcesRequired",
                "focusable",
                "preserveAlpha"
            ].forEach(function(t1) {
                g[t1] = new m(t1, 2, !1, t1, null, !1, !1);
            }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(t1) {
                g[t1] = new m(t1, 3, !1, t1.toLowerCase(), null, !1, !1);
            }), [
                "checked",
                "multiple",
                "muted",
                "selected"
            ].forEach(function(t1) {
                g[t1] = new m(t1, 3, !0, t1, null, !1, !1);
            }), [
                "capture",
                "download"
            ].forEach(function(t1) {
                g[t1] = new m(t1, 4, !1, t1, null, !1, !1);
            }), [
                "cols",
                "rows",
                "size",
                "span"
            ].forEach(function(t1) {
                g[t1] = new m(t1, 6, !1, t1, null, !1, !1);
            }), [
                "rowSpan",
                "start"
            ].forEach(function(t1) {
                g[t1] = new m(t1, 5, !1, t1.toLowerCase(), null, !1, !1);
            });
            var M = /[\-:]([a-z])/g;
            function v(t1) {
                return t1[1].toUpperCase();
            }
            function y(t1, e, i, n) {
                var r = g.hasOwnProperty(e) ? g[e] : null;
                (null !== r ? 0 === r.type : !n && 2 < e.length && ("o" === e[0] || "O" === e[0]) && ("n" === e[1] || "N" === e[1])) || (function(t1, e, i, n) {
                    if (null == e || function(t1, e, i, n) {
                        if (null !== i && 0 === i.type) return !1;
                        switch(typeof e){
                            case "function":
                            case "symbol":
                                return !0;
                            case "boolean":
                                return !n && (null !== i ? !i.acceptsBooleans : "data-" !== (t1 = t1.toLowerCase().slice(0, 5)) && "aria-" !== t1);
                            default:
                                return !1;
                        }
                    }(t1, e, i, n)) return !0;
                    if (n) return !1;
                    if (null !== i) switch(i.type){
                        case 3:
                            return !e;
                        case 4:
                            return !1 === e;
                        case 5:
                            return isNaN(e);
                        case 6:
                            return isNaN(e) || 1 > e;
                    }
                    return !1;
                }(e, i, r, n) && (i = null), n || null === r ? function(t1) {
                    return !!p.call(f, t1) || !p.call(A, t1) && (d.test(t1) ? f[t1] = !0 : (A[t1] = !0, !1));
                }(e) && (null === i ? t1.removeAttribute(e) : t1.setAttribute(e, "" + i)) : r.mustUseProperty ? t1[r.propertyName] = null === i ? 3 !== r.type && "" : i : (e = r.attributeName, n = r.attributeNamespace, null === i ? t1.removeAttribute(e) : (i = 3 === (r = r.type) || 4 === r && !0 === i ? "" : "" + i, n ? t1.setAttributeNS(n, e, i) : t1.setAttribute(e, i))));
            }
            "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(t1) {
                var e = t1.replace(M, v);
                g[e] = new m(e, 1, !1, t1, null, !1, !1);
            }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(t1) {
                var e = t1.replace(M, v);
                g[e] = new m(e, 1, !1, t1, "http://www.w3.org/1999/xlink", !1, !1);
            }), [
                "xml:base",
                "xml:lang",
                "xml:space"
            ].forEach(function(t1) {
                var e = t1.replace(M, v);
                g[e] = new m(e, 1, !1, t1, "http://www.w3.org/XML/1998/namespace", !1, !1);
            }), [
                "tabIndex",
                "crossOrigin"
            ].forEach(function(t1) {
                g[t1] = new m(t1, 1, !1, t1.toLowerCase(), null, !1, !1);
            }), g.xlinkHref = new m("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), [
                "src",
                "href",
                "action",
                "formAction"
            ].forEach(function(t1) {
                g[t1] = new m(t1, 1, !1, t1.toLowerCase(), null, !0, !0);
            });
            var x = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, w = 60103, b = 60106, T = 60107, E = 60108, _ = 60114, I = 60109, S = 60110, N = 60112, D = 60113, C = 60120, z = 60115, L = 60116, O = 60121, P = 60128, j = 60129, R = 60130, k = 60131;
            if ("function" == typeof Symbol && Symbol.for) {
                var U = Symbol.for;
                w = U("react.element"), b = U("react.portal"), T = U("react.fragment"), E = U("react.strict_mode"), _ = U("react.profiler"), I = U("react.provider"), S = U("react.context"), N = U("react.forward_ref"), D = U("react.suspense"), C = U("react.suspense_list"), z = U("react.memo"), L = U("react.lazy"), O = U("react.block"), U("react.scope"), P = U("react.opaque.id"), j = U("react.debug_trace_mode"), R = U("react.offscreen"), k = U("react.legacy_hidden");
            }
            var B, F = "function" == typeof Symbol && Symbol.iterator;
            function Q(t1) {
                return null === t1 || "object" != typeof t1 ? null : "function" == typeof (t1 = F && t1[F] || t1["@@iterator"]) ? t1 : null;
            }
            function H(t1) {
                if (void 0 === B) try {
                    throw Error();
                } catch (t1) {
                    var e = t1.stack.trim().match(/\n( *(at )?)/);
                    B = e && e[1] || "";
                }
                return "\n" + B + t1;
            }
            var V = !1;
            function G(t1, e) {
                if (!t1 || V) return "";
                V = !0;
                var i = Error.prepareStackTrace;
                Error.prepareStackTrace = void 0;
                try {
                    if (e) {
                        if (e = function() {
                            throw Error();
                        }, Object.defineProperty(e.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        }), "object" == typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(e, []);
                            } catch (t1) {
                                var n = t1;
                            }
                            Reflect.construct(t1, [], e);
                        } else {
                            try {
                                e.call();
                            } catch (t1) {
                                n = t1;
                            }
                            t1.call(e.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (t1) {
                            n = t1;
                        }
                        t1();
                    }
                } catch (t1) {
                    if (t1 && n && "string" == typeof t1.stack) {
                        for(var r = t1.stack.split("\n"), a = n.stack.split("\n"), s = r.length - 1, o = a.length - 1; 1 <= s && 0 <= o && r[s] !== a[o];)o--;
                        for(; 1 <= s && 0 <= o; s--, o--)if (r[s] !== a[o]) {
                            if (1 !== s || 1 !== o) do {
                                if (s--, 0 > --o || r[s] !== a[o]) return "\n" + r[s].replace(" at new ", " at ");
                            }while (1 <= s && 0 <= o);
                            break;
                        }
                    }
                } finally{
                    V = !1, Error.prepareStackTrace = i;
                }
                return (t1 = t1 ? t1.displayName || t1.name : "") ? H(t1) : "";
            }
            function W(t1) {
                switch(t1.tag){
                    case 5:
                        return H(t1.type);
                    case 16:
                        return H("Lazy");
                    case 13:
                        return H("Suspense");
                    case 19:
                        return H("SuspenseList");
                    case 0:
                    case 2:
                    case 15:
                        return G(t1.type, !1);
                    case 11:
                        return G(t1.type.render, !1);
                    case 22:
                        return G(t1.type._render, !1);
                    case 1:
                        return G(t1.type, !0);
                    default:
                        return "";
                }
            }
            function Y(t1) {
                if (null == t1) return null;
                if ("function" == typeof t1) return t1.displayName || t1.name || null;
                if ("string" == typeof t1) return t1;
                switch(t1){
                    case T:
                        return "Fragment";
                    case b:
                        return "Portal";
                    case _:
                        return "Profiler";
                    case E:
                        return "StrictMode";
                    case D:
                        return "Suspense";
                    case C:
                        return "SuspenseList";
                }
                if ("object" == typeof t1) switch(t1.$$typeof){
                    case S:
                        return (t1.displayName || "Context") + ".Consumer";
                    case I:
                        return (t1._context.displayName || "Context") + ".Provider";
                    case N:
                        var e = t1.render;
                        return e = e.displayName || e.name || "", t1.displayName || ("" !== e ? "ForwardRef(" + e + ")" : "ForwardRef");
                    case z:
                        return Y(t1.type);
                    case O:
                        return Y(t1._render);
                    case L:
                        e = t1._payload, t1 = t1._init;
                        try {
                            return Y(t1(e));
                        } catch (t1) {}
                }
                return null;
            }
            function X(t1) {
                switch(typeof t1){
                    case "boolean":
                    case "number":
                    case "object":
                    case "string":
                    case "undefined":
                        return t1;
                    default:
                        return "";
                }
            }
            function Z(t1) {
                var e = t1.type;
                return (t1 = t1.nodeName) && "input" === t1.toLowerCase() && ("checkbox" === e || "radio" === e);
            }
            function q(t1) {
                t1._valueTracker || (t1._valueTracker = function(t1) {
                    var e = Z(t1) ? "checked" : "value", i = Object.getOwnPropertyDescriptor(t1.constructor.prototype, e), n = "" + t1[e];
                    if (!t1.hasOwnProperty(e) && void 0 !== i && "function" == typeof i.get && "function" == typeof i.set) {
                        var r = i.get, a = i.set;
                        return Object.defineProperty(t1, e, {
                            configurable: !0,
                            get: function() {
                                return r.call(this);
                            },
                            set: function(t1) {
                                n = "" + t1, a.call(this, t1);
                            }
                        }), Object.defineProperty(t1, e, {
                            enumerable: i.enumerable
                        }), {
                            getValue: function() {
                                return n;
                            },
                            setValue: function(t1) {
                                n = "" + t1;
                            },
                            stopTracking: function() {
                                t1._valueTracker = null, delete t1[e];
                            }
                        };
                    }
                }(t1));
            }
            function J(t1) {
                if (!t1) return !1;
                var e = t1._valueTracker;
                if (!e) return !0;
                var i = e.getValue(), n = "";
                return t1 && (n = Z(t1) ? t1.checked ? "true" : "false" : t1.value), (t1 = n) !== i && (e.setValue(t1), !0);
            }
            function K(t1) {
                if (void 0 === (t1 = t1 || ("undefined" != typeof document ? document : void 0))) return null;
                try {
                    return t1.activeElement || t1.body;
                } catch (e) {
                    return t1.body;
                }
            }
            function $(t1, e) {
                var i = e.checked;
                return r({}, e, {
                    defaultChecked: void 0,
                    defaultValue: void 0,
                    value: void 0,
                    checked: null != i ? i : t1._wrapperState.initialChecked
                });
            }
            function tt(t1, e) {
                var i = null == e.defaultValue ? "" : e.defaultValue, n = null != e.checked ? e.checked : e.defaultChecked;
                i = X(null != e.value ? e.value : i), t1._wrapperState = {
                    initialChecked: n,
                    initialValue: i,
                    controlled: "checkbox" === e.type || "radio" === e.type ? null != e.checked : null != e.value
                };
            }
            function et(t1, e) {
                null != (e = e.checked) && y(t1, "checked", e, !1);
            }
            function it(t1, e) {
                et(t1, e);
                var i = X(e.value), n = e.type;
                if (null != i) "number" === n ? (0 === i && "" === t1.value || t1.value != i) && (t1.value = "" + i) : t1.value !== "" + i && (t1.value = "" + i);
                else if ("submit" === n || "reset" === n) return void t1.removeAttribute("value");
                e.hasOwnProperty("value") ? rt(t1, e.type, i) : e.hasOwnProperty("defaultValue") && rt(t1, e.type, X(e.defaultValue)), null == e.checked && null != e.defaultChecked && (t1.defaultChecked = !!e.defaultChecked);
            }
            function nt(t1, e, i) {
                if (e.hasOwnProperty("value") || e.hasOwnProperty("defaultValue")) {
                    var n = e.type;
                    if (!("submit" !== n && "reset" !== n || void 0 !== e.value && null !== e.value)) return;
                    e = "" + t1._wrapperState.initialValue, i || e === t1.value || (t1.value = e), t1.defaultValue = e;
                }
                "" !== (i = t1.name) && (t1.name = ""), t1.defaultChecked = !!t1._wrapperState.initialChecked, "" !== i && (t1.name = i);
            }
            function rt(t1, e, i) {
                "number" === e && K(t1.ownerDocument) === t1 || (null == i ? t1.defaultValue = "" + t1._wrapperState.initialValue : t1.defaultValue !== "" + i && (t1.defaultValue = "" + i));
            }
            function at(t1, e) {
                return t1 = r({
                    children: void 0
                }, e), (e = function(t1) {
                    var e = "";
                    return n.Children.forEach(t1, function(t1) {
                        null != t1 && (e += t1);
                    }), e;
                }(e.children)) && (t1.children = e), t1;
            }
            function st(t1, e, i, n) {
                if (t1 = t1.options, e) {
                    e = {};
                    for(var r = 0; r < i.length; r++)e["$" + i[r]] = !0;
                    for(i = 0; i < t1.length; i++)r = e.hasOwnProperty("$" + t1[i].value), t1[i].selected !== r && (t1[i].selected = r), r && n && (t1[i].defaultSelected = !0);
                } else {
                    for(i = "" + X(i), e = null, r = 0; r < t1.length; r++){
                        if (t1[r].value === i) return t1[r].selected = !0, void (n && (t1[r].defaultSelected = !0));
                        null !== e || t1[r].disabled || (e = t1[r]);
                    }
                    null !== e && (e.selected = !0);
                }
            }
            function ot(t1, e) {
                if (null != e.dangerouslySetInnerHTML) throw Error(s(91));
                return r({}, e, {
                    value: void 0,
                    defaultValue: void 0,
                    children: "" + t1._wrapperState.initialValue
                });
            }
            function lt(t1, e) {
                var i = e.value;
                if (null == i) {
                    if (i = e.children, e = e.defaultValue, null != i) {
                        if (null != e) throw Error(s(92));
                        if (Array.isArray(i)) {
                            if (!(1 >= i.length)) throw Error(s(93));
                            i = i[0];
                        }
                        e = i;
                    }
                    null == e && (e = ""), i = e;
                }
                t1._wrapperState = {
                    initialValue: X(i)
                };
            }
            function ct(t1, e) {
                var i = X(e.value), n = X(e.defaultValue);
                null != i && ((i = "" + i) !== t1.value && (t1.value = i), null == e.defaultValue && t1.defaultValue !== i && (t1.defaultValue = i)), null != n && (t1.defaultValue = "" + n);
            }
            function ut(t1) {
                var e = t1.textContent;
                e === t1._wrapperState.initialValue && "" !== e && null !== e && (t1.value = e);
            }
            var ht = {
                html: "http://www.w3.org/1999/xhtml",
                mathml: "http://www.w3.org/1998/Math/MathML",
                svg: "http://www.w3.org/2000/svg"
            };
            function dt(t1) {
                switch(t1){
                    case "svg":
                        return "http://www.w3.org/2000/svg";
                    case "math":
                        return "http://www.w3.org/1998/Math/MathML";
                    default:
                        return "http://www.w3.org/1999/xhtml";
                }
            }
            function pt(t1, e) {
                return null == t1 || "http://www.w3.org/1999/xhtml" === t1 ? dt(e) : "http://www.w3.org/2000/svg" === t1 && "foreignObject" === e ? "http://www.w3.org/1999/xhtml" : t1;
            }
            var At, ft, mt = (ft = function(t1, e) {
                if (t1.namespaceURI !== ht.svg || "innerHTML" in t1) t1.innerHTML = e;
                else {
                    for((At = At || document.createElement("div")).innerHTML = "<svg>" + e.valueOf().toString() + "</svg>", e = At.firstChild; t1.firstChild;)t1.removeChild(t1.firstChild);
                    for(; e.firstChild;)t1.appendChild(e.firstChild);
                }
            }, "undefined" != typeof MSApp && MSApp.execUnsafeLocalFunction ? function(t1, e, i, n) {
                MSApp.execUnsafeLocalFunction(function() {
                    return ft(t1, e);
                });
            } : ft);
            function gt(t1, e) {
                if (e) {
                    var i = t1.firstChild;
                    if (i && i === t1.lastChild && 3 === i.nodeType) return void (i.nodeValue = e);
                }
                t1.textContent = e;
            }
            var Mt = {
                animationIterationCount: !0,
                borderImageOutset: !0,
                borderImageSlice: !0,
                borderImageWidth: !0,
                boxFlex: !0,
                boxFlexGroup: !0,
                boxOrdinalGroup: !0,
                columnCount: !0,
                columns: !0,
                flex: !0,
                flexGrow: !0,
                flexPositive: !0,
                flexShrink: !0,
                flexNegative: !0,
                flexOrder: !0,
                gridArea: !0,
                gridRow: !0,
                gridRowEnd: !0,
                gridRowSpan: !0,
                gridRowStart: !0,
                gridColumn: !0,
                gridColumnEnd: !0,
                gridColumnSpan: !0,
                gridColumnStart: !0,
                fontWeight: !0,
                lineClamp: !0,
                lineHeight: !0,
                opacity: !0,
                order: !0,
                orphans: !0,
                tabSize: !0,
                widows: !0,
                zIndex: !0,
                zoom: !0,
                fillOpacity: !0,
                floodOpacity: !0,
                stopOpacity: !0,
                strokeDasharray: !0,
                strokeDashoffset: !0,
                strokeMiterlimit: !0,
                strokeOpacity: !0,
                strokeWidth: !0
            }, vt = [
                "Webkit",
                "ms",
                "Moz",
                "O"
            ];
            function yt(t1, e, i) {
                return null == e || "boolean" == typeof e || "" === e ? "" : i || "number" != typeof e || 0 === e || Mt.hasOwnProperty(t1) && Mt[t1] ? ("" + e).trim() : e + "px";
            }
            function xt(t1, e) {
                for(var i in t1 = t1.style, e)if (e.hasOwnProperty(i)) {
                    var n = 0 === i.indexOf("--"), r = yt(i, e[i], n);
                    "float" === i && (i = "cssFloat"), n ? t1.setProperty(i, r) : t1[i] = r;
                }
            }
            Object.keys(Mt).forEach(function(t1) {
                vt.forEach(function(e) {
                    e = e + t1.charAt(0).toUpperCase() + t1.substring(1), Mt[e] = Mt[t1];
                });
            });
            var wt = r({
                menuitem: !0
            }, {
                area: !0,
                base: !0,
                br: !0,
                col: !0,
                embed: !0,
                hr: !0,
                img: !0,
                input: !0,
                keygen: !0,
                link: !0,
                meta: !0,
                param: !0,
                source: !0,
                track: !0,
                wbr: !0
            });
            function bt(t1, e) {
                if (e) {
                    if (wt[t1] && (null != e.children || null != e.dangerouslySetInnerHTML)) throw Error(s(137, t1));
                    if (null != e.dangerouslySetInnerHTML) {
                        if (null != e.children) throw Error(s(60));
                        if ("object" != typeof e.dangerouslySetInnerHTML || !("__html" in e.dangerouslySetInnerHTML)) throw Error(s(61));
                    }
                    if (null != e.style && "object" != typeof e.style) throw Error(s(62));
                }
            }
            function Tt(t1, e) {
                if (-1 === t1.indexOf("-")) return "string" == typeof e.is;
                switch(t1){
                    case "annotation-xml":
                    case "color-profile":
                    case "font-face":
                    case "font-face-src":
                    case "font-face-uri":
                    case "font-face-format":
                    case "font-face-name":
                    case "missing-glyph":
                        return !1;
                    default:
                        return !0;
                }
            }
            function Et(t1) {
                return (t1 = t1.target || t1.srcElement || window).correspondingUseElement && (t1 = t1.correspondingUseElement), 3 === t1.nodeType ? t1.parentNode : t1;
            }
            var _t = null, It = null, St = null;
            function Nt(t1) {
                if (t1 = ir(t1)) {
                    if ("function" != typeof _t) throw Error(s(280));
                    var e = t1.stateNode;
                    e && (e = rr(e), _t(t1.stateNode, t1.type, e));
                }
            }
            function Dt(t1) {
                It ? St ? St.push(t1) : St = [
                    t1
                ] : It = t1;
            }
            function Ct() {
                if (It) {
                    var t1 = It, e = St;
                    if (St = It = null, Nt(t1), e) for(t1 = 0; t1 < e.length; t1++)Nt(e[t1]);
                }
            }
            function zt(t1, e) {
                return t1(e);
            }
            function Lt(t1, e, i, n, r) {
                return t1(e, i, n, r);
            }
            function Ot() {}
            var Pt = zt, jt = !1, Rt = !1;
            function kt() {
                null === It && null === St || (Ot(), Ct());
            }
            function Ut(t1, e) {
                var i = t1.stateNode;
                if (null === i) return null;
                var n = rr(i);
                if (null === n) return null;
                i = n[e];
                t: switch(e){
                    case "onClick":
                    case "onClickCapture":
                    case "onDoubleClick":
                    case "onDoubleClickCapture":
                    case "onMouseDown":
                    case "onMouseDownCapture":
                    case "onMouseMove":
                    case "onMouseMoveCapture":
                    case "onMouseUp":
                    case "onMouseUpCapture":
                    case "onMouseEnter":
                        (n = !n.disabled) || (n = !("button" === (t1 = t1.type) || "input" === t1 || "select" === t1 || "textarea" === t1)), t1 = !n;
                        break t;
                    default:
                        t1 = !1;
                }
                if (t1) return null;
                if (i && "function" != typeof i) throw Error(s(231, e, typeof i));
                return i;
            }
            var Bt = !1;
            if (h) try {
                var Ft = {};
                Object.defineProperty(Ft, "passive", {
                    get: function() {
                        Bt = !0;
                    }
                }), window.addEventListener("test", Ft, Ft), window.removeEventListener("test", Ft, Ft);
            } catch (ft) {
                Bt = !1;
            }
            function Qt(t1, e, i, n, r, a, s, o, l) {
                var c = Array.prototype.slice.call(arguments, 3);
                try {
                    e.apply(i, c);
                } catch (t1) {
                    this.onError(t1);
                }
            }
            var Ht = !1, Vt = null, Gt = !1, Wt = null, Yt = {
                onError: function(t1) {
                    Ht = !0, Vt = t1;
                }
            };
            function Xt(t1, e, i, n, r, a, s, o, l) {
                Ht = !1, Vt = null, Qt.apply(Yt, arguments);
            }
            function Zt(t1) {
                var e = t1, i = t1;
                if (t1.alternate) for(; e.return;)e = e.return;
                else {
                    t1 = e;
                    do !!(1026 & (e = t1).flags) && (i = e.return), t1 = e.return;
                    while (t1);
                }
                return 3 === e.tag ? i : null;
            }
            function qt(t1) {
                if (13 === t1.tag) {
                    var e = t1.memoizedState;
                    if (null === e && null !== (t1 = t1.alternate) && (e = t1.memoizedState), null !== e) return e.dehydrated;
                }
                return null;
            }
            function Jt(t1) {
                if (Zt(t1) !== t1) throw Error(s(188));
            }
            function Kt(t1) {
                if (t1 = function(t1) {
                    var e = t1.alternate;
                    if (!e) {
                        if (null === (e = Zt(t1))) throw Error(s(188));
                        return e !== t1 ? null : t1;
                    }
                    for(var i = t1, n = e;;){
                        var r = i.return;
                        if (null === r) break;
                        var a = r.alternate;
                        if (null === a) {
                            if (null !== (n = r.return)) {
                                i = n;
                                continue;
                            }
                            break;
                        }
                        if (r.child === a.child) {
                            for(a = r.child; a;){
                                if (a === i) return Jt(r), t1;
                                if (a === n) return Jt(r), e;
                                a = a.sibling;
                            }
                            throw Error(s(188));
                        }
                        if (i.return !== n.return) i = r, n = a;
                        else {
                            for(var o = !1, l = r.child; l;){
                                if (l === i) {
                                    o = !0, i = r, n = a;
                                    break;
                                }
                                if (l === n) {
                                    o = !0, n = r, i = a;
                                    break;
                                }
                                l = l.sibling;
                            }
                            if (!o) {
                                for(l = a.child; l;){
                                    if (l === i) {
                                        o = !0, i = a, n = r;
                                        break;
                                    }
                                    if (l === n) {
                                        o = !0, n = a, i = r;
                                        break;
                                    }
                                    l = l.sibling;
                                }
                                if (!o) throw Error(s(189));
                            }
                        }
                        if (i.alternate !== n) throw Error(s(190));
                    }
                    if (3 !== i.tag) throw Error(s(188));
                    return i.stateNode.current === i ? t1 : e;
                }(t1), !t1) return null;
                for(var e = t1;;){
                    if (5 === e.tag || 6 === e.tag) return e;
                    if (e.child) e.child.return = e, e = e.child;
                    else {
                        if (e === t1) break;
                        for(; !e.sibling;){
                            if (!e.return || e.return === t1) return null;
                            e = e.return;
                        }
                        e.sibling.return = e.return, e = e.sibling;
                    }
                }
                return null;
            }
            function $t(t1, e) {
                for(var i = t1.alternate; null !== e;){
                    if (e === t1 || e === i) return !0;
                    e = e.return;
                }
                return !1;
            }
            var te, ee, ie, ne, re = !1, ae = [], se = null, oe = null, le = null, ce = new Map, ue = new Map, he = [], de = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
            function pe(t1, e, i, n, r) {
                return {
                    blockedOn: t1,
                    domEventName: e,
                    eventSystemFlags: 16 | i,
                    nativeEvent: r,
                    targetContainers: [
                        n
                    ]
                };
            }
            function Ae(t1, e) {
                switch(t1){
                    case "focusin":
                    case "focusout":
                        se = null;
                        break;
                    case "dragenter":
                    case "dragleave":
                        oe = null;
                        break;
                    case "mouseover":
                    case "mouseout":
                        le = null;
                        break;
                    case "pointerover":
                    case "pointerout":
                        ce.delete(e.pointerId);
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                        ue.delete(e.pointerId);
                }
            }
            function fe(t1, e, i, n, r, a) {
                return null === t1 || t1.nativeEvent !== a ? (t1 = pe(e, i, n, r, a), null !== e && null !== (e = ir(e)) && ee(e), t1) : (t1.eventSystemFlags |= n, e = t1.targetContainers, null !== r && -1 === e.indexOf(r) && e.push(r), t1);
            }
            function me(t1) {
                var e = er(t1.target);
                if (null !== e) {
                    var i = Zt(e);
                    if (null !== i) {
                        if (13 === (e = i.tag)) {
                            if (null !== (e = qt(i))) return t1.blockedOn = e, void ne(t1.lanePriority, function() {
                                a.unstable_runWithPriority(t1.priority, function() {
                                    ie(i);
                                });
                            });
                        } else if (3 === e && i.stateNode.hydrate) return void (t1.blockedOn = 3 === i.tag ? i.stateNode.containerInfo : null);
                    }
                }
                t1.blockedOn = null;
            }
            function ge(t1) {
                if (null !== t1.blockedOn) return !1;
                for(var e = t1.targetContainers; 0 < e.length;){
                    var i = Ke(t1.domEventName, t1.eventSystemFlags, e[0], t1.nativeEvent);
                    if (null !== i) return null !== (e = ir(i)) && ee(e), t1.blockedOn = i, !1;
                    e.shift();
                }
                return !0;
            }
            function Me(t1, e, i) {
                ge(t1) && i.delete(e);
            }
            function ve() {
                for(re = !1; 0 < ae.length;){
                    var t1 = ae[0];
                    if (null !== t1.blockedOn) {
                        null !== (t1 = ir(t1.blockedOn)) && te(t1);
                        break;
                    }
                    for(var e = t1.targetContainers; 0 < e.length;){
                        var i = Ke(t1.domEventName, t1.eventSystemFlags, e[0], t1.nativeEvent);
                        if (null !== i) {
                            t1.blockedOn = i;
                            break;
                        }
                        e.shift();
                    }
                    null === t1.blockedOn && ae.shift();
                }
                null !== se && ge(se) && (se = null), null !== oe && ge(oe) && (oe = null), null !== le && ge(le) && (le = null), ce.forEach(Me), ue.forEach(Me);
            }
            function ye(t1, e) {
                t1.blockedOn === e && (t1.blockedOn = null, re || (re = !0, a.unstable_scheduleCallback(a.unstable_NormalPriority, ve)));
            }
            function xe(t1) {
                function e(e) {
                    return ye(e, t1);
                }
                if (0 < ae.length) {
                    ye(ae[0], t1);
                    for(var i = 1; i < ae.length; i++){
                        var n = ae[i];
                        n.blockedOn === t1 && (n.blockedOn = null);
                    }
                }
                for(null !== se && ye(se, t1), null !== oe && ye(oe, t1), null !== le && ye(le, t1), ce.forEach(e), ue.forEach(e), i = 0; i < he.length; i++)(n = he[i]).blockedOn === t1 && (n.blockedOn = null);
                for(; 0 < he.length && null === (i = he[0]).blockedOn;)me(i), null === i.blockedOn && he.shift();
            }
            function we(t1, e) {
                var i = {};
                return i[t1.toLowerCase()] = e.toLowerCase(), i["Webkit" + t1] = "webkit" + e, i["Moz" + t1] = "moz" + e, i;
            }
            var be = {
                animationend: we("Animation", "AnimationEnd"),
                animationiteration: we("Animation", "AnimationIteration"),
                animationstart: we("Animation", "AnimationStart"),
                transitionend: we("Transition", "TransitionEnd")
            }, Te = {}, Ee = {};
            function _e(t1) {
                if (Te[t1]) return Te[t1];
                if (!be[t1]) return t1;
                var e, i = be[t1];
                for(e in i)if (i.hasOwnProperty(e) && e in Ee) return Te[t1] = i[e];
                return t1;
            }
            h && (Ee = document.createElement("div").style, "AnimationEvent" in window || (delete be.animationend.animation, delete be.animationiteration.animation, delete be.animationstart.animation), "TransitionEvent" in window || delete be.transitionend.transition);
            var Ie = _e("animationend"), Se = _e("animationiteration"), Ne = _e("animationstart"), De = _e("transitionend"), Ce = new Map, ze = new Map, Le = [
                "abort",
                "abort",
                Ie,
                "animationEnd",
                Se,
                "animationIteration",
                Ne,
                "animationStart",
                "canplay",
                "canPlay",
                "canplaythrough",
                "canPlayThrough",
                "durationchange",
                "durationChange",
                "emptied",
                "emptied",
                "encrypted",
                "encrypted",
                "ended",
                "ended",
                "error",
                "error",
                "gotpointercapture",
                "gotPointerCapture",
                "load",
                "load",
                "loadeddata",
                "loadedData",
                "loadedmetadata",
                "loadedMetadata",
                "loadstart",
                "loadStart",
                "lostpointercapture",
                "lostPointerCapture",
                "playing",
                "playing",
                "progress",
                "progress",
                "seeking",
                "seeking",
                "stalled",
                "stalled",
                "suspend",
                "suspend",
                "timeupdate",
                "timeUpdate",
                De,
                "transitionEnd",
                "waiting",
                "waiting"
            ];
            function Oe(t1, e) {
                for(var i = 0; i < t1.length; i += 2){
                    var n = t1[i], r = t1[i + 1];
                    r = "on" + (r[0].toUpperCase() + r.slice(1)), ze.set(n, e), Ce.set(n, r), c(r, [
                        n
                    ]);
                }
            }
            (0, a.unstable_now)();
            var Pe = 8;
            function je(t1) {
                if (1 & t1) return Pe = 15, 1;
                if (2 & t1) return Pe = 14, 2;
                if (4 & t1) return Pe = 13, 4;
                var e = 24 & t1;
                return 0 !== e ? (Pe = 12, e) : 32 & t1 ? (Pe = 11, 32) : 0 != (e = 192 & t1) ? (Pe = 10, e) : 256 & t1 ? (Pe = 9, 256) : 0 != (e = 3584 & t1) ? (Pe = 8, e) : 4096 & t1 ? (Pe = 7, 4096) : 0 != (e = 4186112 & t1) ? (Pe = 6, e) : 0 != (e = 62914560 & t1) ? (Pe = 5, e) : 67108864 & t1 ? (Pe = 4, 67108864) : 134217728 & t1 ? (Pe = 3, 134217728) : 0 != (e = 805306368 & t1) ? (Pe = 2, e) : 1073741824 & t1 ? (Pe = 1, 1073741824) : (Pe = 8, t1);
            }
            function Re(t1, e) {
                var i = t1.pendingLanes;
                if (0 === i) return Pe = 0;
                var n = 0, r = 0, a = t1.expiredLanes, s = t1.suspendedLanes, o = t1.pingedLanes;
                if (0 !== a) n = a, r = Pe = 15;
                else if (0 != (a = 134217727 & i)) {
                    var l = a & ~s;
                    0 !== l ? (n = je(l), r = Pe) : 0 != (o &= a) && (n = je(o), r = Pe);
                } else 0 != (a = i & ~s) ? (n = je(a), r = Pe) : 0 !== o && (n = je(o), r = Pe);
                if (0 === n) return 0;
                if (n = i & ((0 > (n = 31 - He(n)) ? 0 : 1 << n) << 1) - 1, 0 !== e && e !== n && !(e & s)) {
                    if (je(e), r <= Pe) return e;
                    Pe = r;
                }
                if (0 !== (e = t1.entangledLanes)) for(t1 = t1.entanglements, e &= n; 0 < e;)r = 1 << (i = 31 - He(e)), n |= t1[i], e &= ~r;
                return n;
            }
            function ke(t1) {
                return 0 != (t1 = -1073741825 & t1.pendingLanes) ? t1 : 1073741824 & t1 ? 1073741824 : 0;
            }
            function Ue(t1, e) {
                switch(t1){
                    case 15:
                        return 1;
                    case 14:
                        return 2;
                    case 12:
                        return 0 === (t1 = Be(24 & ~e)) ? Ue(10, e) : t1;
                    case 10:
                        return 0 === (t1 = Be(192 & ~e)) ? Ue(8, e) : t1;
                    case 8:
                        return 0 === (t1 = Be(3584 & ~e)) && 0 === (t1 = Be(4186112 & ~e)) && (t1 = 512), t1;
                    case 2:
                        return 0 === (e = Be(805306368 & ~e)) && (e = 268435456), e;
                }
                throw Error(s(358, t1));
            }
            function Be(t1) {
                return t1 & -t1;
            }
            function Fe(t1) {
                for(var e = [], i = 0; 31 > i; i++)e.push(t1);
                return e;
            }
            function Qe(t1, e, i) {
                t1.pendingLanes |= e;
                var n = e - 1;
                t1.suspendedLanes &= n, t1.pingedLanes &= n, (t1 = t1.eventTimes)[e = 31 - He(e)] = i;
            }
            var He = Math.clz32 ? Math.clz32 : function(t1) {
                return 0 === t1 ? 32 : 31 - (Ve(t1) / Ge | 0) | 0;
            }, Ve = Math.log, Ge = Math.LN2, We = a.unstable_UserBlockingPriority, Ye = a.unstable_runWithPriority, Xe = !0;
            function Ze(t1, e, i, n) {
                jt || Ot();
                var r = Je, a = jt;
                jt = !0;
                try {
                    Lt(r, t1, e, i, n);
                } finally{
                    (jt = a) || kt();
                }
            }
            function qe(t1, e, i, n) {
                Ye(We, Je.bind(null, t1, e, i, n));
            }
            function Je(t1, e, i, n) {
                var r;
                if (Xe) {
                    if ((r = !(4 & e)) && 0 < ae.length && -1 < de.indexOf(t1)) t1 = pe(null, t1, e, i, n), ae.push(t1);
                    else {
                        var a = Ke(t1, e, i, n);
                        if (null === a) r && Ae(t1, n);
                        else {
                            if (r) {
                                if (-1 < de.indexOf(t1)) return t1 = pe(a, t1, e, i, n), void ae.push(t1);
                                if (function(t1, e, i, n, r) {
                                    switch(e){
                                        case "focusin":
                                            return se = fe(se, t1, e, i, n, r), !0;
                                        case "dragenter":
                                            return oe = fe(oe, t1, e, i, n, r), !0;
                                        case "mouseover":
                                            return le = fe(le, t1, e, i, n, r), !0;
                                        case "pointerover":
                                            var a = r.pointerId;
                                            return ce.set(a, fe(ce.get(a) || null, t1, e, i, n, r)), !0;
                                        case "gotpointercapture":
                                            return a = r.pointerId, ue.set(a, fe(ue.get(a) || null, t1, e, i, n, r)), !0;
                                    }
                                    return !1;
                                }(a, t1, e, i, n)) return;
                                Ae(t1, n);
                            }
                            On(t1, e, n, null, i);
                        }
                    }
                }
            }
            function Ke(t1, e, i, n) {
                var r = Et(n);
                if (null !== (r = er(r))) {
                    var a = Zt(r);
                    if (null === a) r = null;
                    else {
                        var s = a.tag;
                        if (13 === s) {
                            if (null !== (r = qt(a))) return r;
                            r = null;
                        } else if (3 === s) {
                            if (a.stateNode.hydrate) return 3 === a.tag ? a.stateNode.containerInfo : null;
                            r = null;
                        } else a !== r && (r = null);
                    }
                }
                return On(t1, e, n, r, i), null;
            }
            var $e = null, ti = null, ei = null;
            function ii() {
                if (ei) return ei;
                var t1, e, i = ti, n = i.length, r = "value" in $e ? $e.value : $e.textContent, a = r.length;
                for(t1 = 0; t1 < n && i[t1] === r[t1]; t1++);
                var s = n - t1;
                for(e = 1; e <= s && i[n - e] === r[a - e]; e++);
                return ei = r.slice(t1, 1 < e ? 1 - e : void 0);
            }
            function ni(t1) {
                var e = t1.keyCode;
                return "charCode" in t1 ? 0 === (t1 = t1.charCode) && 13 === e && (t1 = 13) : t1 = e, 10 === t1 && (t1 = 13), 32 <= t1 || 13 === t1 ? t1 : 0;
            }
            function ri() {
                return !0;
            }
            function ai() {
                return !1;
            }
            function si(t1) {
                function e(e, i, n, r, a) {
                    for(var s in this._reactName = e, this._targetInst = n, this.type = i, this.nativeEvent = r, this.target = a, this.currentTarget = null, t1)t1.hasOwnProperty(s) && (e = t1[s], this[s] = e ? e(r) : r[s]);
                    return this.isDefaultPrevented = (null != r.defaultPrevented ? r.defaultPrevented : !1 === r.returnValue) ? ri : ai, this.isPropagationStopped = ai, this;
                }
                return r(e.prototype, {
                    preventDefault: function() {
                        this.defaultPrevented = !0;
                        var t1 = this.nativeEvent;
                        t1 && (t1.preventDefault ? t1.preventDefault() : "unknown" != typeof t1.returnValue && (t1.returnValue = !1), this.isDefaultPrevented = ri);
                    },
                    stopPropagation: function() {
                        var t1 = this.nativeEvent;
                        t1 && (t1.stopPropagation ? t1.stopPropagation() : "unknown" != typeof t1.cancelBubble && (t1.cancelBubble = !0), this.isPropagationStopped = ri);
                    },
                    persist: function() {},
                    isPersistent: ri
                }), e;
            }
            var oi, li, ci, ui = {
                eventPhase: 0,
                bubbles: 0,
                cancelable: 0,
                timeStamp: function(t1) {
                    return t1.timeStamp || Date.now();
                },
                defaultPrevented: 0,
                isTrusted: 0
            }, hi = si(ui), di = r({}, ui, {
                view: 0,
                detail: 0
            }), pi = si(di), Ai = r({}, di, {
                screenX: 0,
                screenY: 0,
                clientX: 0,
                clientY: 0,
                pageX: 0,
                pageY: 0,
                ctrlKey: 0,
                shiftKey: 0,
                altKey: 0,
                metaKey: 0,
                getModifierState: _i,
                button: 0,
                buttons: 0,
                relatedTarget: function(t1) {
                    return void 0 === t1.relatedTarget ? t1.fromElement === t1.srcElement ? t1.toElement : t1.fromElement : t1.relatedTarget;
                },
                movementX: function(t1) {
                    return "movementX" in t1 ? t1.movementX : (t1 !== ci && (ci && "mousemove" === t1.type ? (oi = t1.screenX - ci.screenX, li = t1.screenY - ci.screenY) : li = oi = 0, ci = t1), oi);
                },
                movementY: function(t1) {
                    return "movementY" in t1 ? t1.movementY : li;
                }
            }), fi = si(Ai), mi = si(r({}, Ai, {
                dataTransfer: 0
            })), gi = si(r({}, di, {
                relatedTarget: 0
            })), Mi = si(r({}, ui, {
                animationName: 0,
                elapsedTime: 0,
                pseudoElement: 0
            })), vi = r({}, ui, {
                clipboardData: function(t1) {
                    return "clipboardData" in t1 ? t1.clipboardData : window.clipboardData;
                }
            }), yi = si(vi), xi = si(r({}, ui, {
                data: 0
            })), wi = {
                Esc: "Escape",
                Spacebar: " ",
                Left: "ArrowLeft",
                Up: "ArrowUp",
                Right: "ArrowRight",
                Down: "ArrowDown",
                Del: "Delete",
                Win: "OS",
                Menu: "ContextMenu",
                Apps: "ContextMenu",
                Scroll: "ScrollLock",
                MozPrintableKey: "Unidentified"
            }, bi = {
                8: "Backspace",
                9: "Tab",
                12: "Clear",
                13: "Enter",
                16: "Shift",
                17: "Control",
                18: "Alt",
                19: "Pause",
                20: "CapsLock",
                27: "Escape",
                32: " ",
                33: "PageUp",
                34: "PageDown",
                35: "End",
                36: "Home",
                37: "ArrowLeft",
                38: "ArrowUp",
                39: "ArrowRight",
                40: "ArrowDown",
                45: "Insert",
                46: "Delete",
                112: "F1",
                113: "F2",
                114: "F3",
                115: "F4",
                116: "F5",
                117: "F6",
                118: "F7",
                119: "F8",
                120: "F9",
                121: "F10",
                122: "F11",
                123: "F12",
                144: "NumLock",
                145: "ScrollLock",
                224: "Meta"
            }, Ti = {
                Alt: "altKey",
                Control: "ctrlKey",
                Meta: "metaKey",
                Shift: "shiftKey"
            };
            function Ei(t1) {
                var e = this.nativeEvent;
                return e.getModifierState ? e.getModifierState(t1) : !!(t1 = Ti[t1]) && !!e[t1];
            }
            function _i() {
                return Ei;
            }
            var Ii = r({}, di, {
                key: function(t1) {
                    if (t1.key) {
                        var e = wi[t1.key] || t1.key;
                        if ("Unidentified" !== e) return e;
                    }
                    return "keypress" === t1.type ? 13 === (t1 = ni(t1)) ? "Enter" : String.fromCharCode(t1) : "keydown" === t1.type || "keyup" === t1.type ? bi[t1.keyCode] || "Unidentified" : "";
                },
                code: 0,
                location: 0,
                ctrlKey: 0,
                shiftKey: 0,
                altKey: 0,
                metaKey: 0,
                repeat: 0,
                locale: 0,
                getModifierState: _i,
                charCode: function(t1) {
                    return "keypress" === t1.type ? ni(t1) : 0;
                },
                keyCode: function(t1) {
                    return "keydown" === t1.type || "keyup" === t1.type ? t1.keyCode : 0;
                },
                which: function(t1) {
                    return "keypress" === t1.type ? ni(t1) : "keydown" === t1.type || "keyup" === t1.type ? t1.keyCode : 0;
                }
            }), Si = si(Ii), Ni = si(r({}, Ai, {
                pointerId: 0,
                width: 0,
                height: 0,
                pressure: 0,
                tangentialPressure: 0,
                tiltX: 0,
                tiltY: 0,
                twist: 0,
                pointerType: 0,
                isPrimary: 0
            })), Di = si(r({}, di, {
                touches: 0,
                targetTouches: 0,
                changedTouches: 0,
                altKey: 0,
                metaKey: 0,
                ctrlKey: 0,
                shiftKey: 0,
                getModifierState: _i
            })), Ci = si(r({}, ui, {
                propertyName: 0,
                elapsedTime: 0,
                pseudoElement: 0
            })), zi = r({}, Ai, {
                deltaX: function(t1) {
                    return "deltaX" in t1 ? t1.deltaX : "wheelDeltaX" in t1 ? -t1.wheelDeltaX : 0;
                },
                deltaY: function(t1) {
                    return "deltaY" in t1 ? t1.deltaY : "wheelDeltaY" in t1 ? -t1.wheelDeltaY : "wheelDelta" in t1 ? -t1.wheelDelta : 0;
                },
                deltaZ: 0,
                deltaMode: 0
            }), Li = si(zi), Oi = [
                9,
                13,
                27,
                32
            ], Pi = h && "CompositionEvent" in window, ji = null;
            h && "documentMode" in document && (ji = document.documentMode);
            var Ri = h && "TextEvent" in window && !ji, ki = h && (!Pi || ji && 8 < ji && 11 >= ji), Ui = String.fromCharCode(32), Bi = !1;
            function Fi(t1, e) {
                switch(t1){
                    case "keyup":
                        return -1 !== Oi.indexOf(e.keyCode);
                    case "keydown":
                        return 229 !== e.keyCode;
                    case "keypress":
                    case "mousedown":
                    case "focusout":
                        return !0;
                    default:
                        return !1;
                }
            }
            function Qi(t1) {
                return "object" == typeof (t1 = t1.detail) && "data" in t1 ? t1.data : null;
            }
            var Hi = !1, Vi = {
                color: !0,
                date: !0,
                datetime: !0,
                "datetime-local": !0,
                email: !0,
                month: !0,
                number: !0,
                password: !0,
                range: !0,
                search: !0,
                tel: !0,
                text: !0,
                time: !0,
                url: !0,
                week: !0
            };
            function Gi(t1) {
                var e = t1 && t1.nodeName && t1.nodeName.toLowerCase();
                return "input" === e ? !!Vi[t1.type] : "textarea" === e;
            }
            function Wi(t1, e, i, n) {
                Dt(n), 0 < (e = jn(e, "onChange")).length && (i = new hi("onChange", "change", null, i, n), t1.push({
                    event: i,
                    listeners: e
                }));
            }
            var Yi = null, Xi = null;
            function Zi(t1) {
                Sn(t1, 0);
            }
            function qi(t1) {
                if (J(nr(t1))) return t1;
            }
            function Ji(t1, e) {
                if ("change" === t1) return e;
            }
            var Ki = !1;
            if (h) {
                var $i;
                if (h) {
                    var tn = "oninput" in document;
                    if (!tn) {
                        var en = document.createElement("div");
                        en.setAttribute("oninput", "return;"), tn = "function" == typeof en.oninput;
                    }
                    $i = tn;
                } else $i = !1;
                Ki = $i && (!document.documentMode || 9 < document.documentMode);
            }
            function nn() {
                Yi && (Yi.detachEvent("onpropertychange", rn), Xi = Yi = null);
            }
            function rn(t1) {
                if ("value" === t1.propertyName && qi(Xi)) {
                    var e = [];
                    if (Wi(e, Xi, t1, Et(t1)), t1 = Zi, jt) t1(e);
                    else {
                        jt = !0;
                        try {
                            zt(t1, e);
                        } finally{
                            jt = !1, kt();
                        }
                    }
                }
            }
            function an(t1, e, i) {
                "focusin" === t1 ? (nn(), Xi = i, (Yi = e).attachEvent("onpropertychange", rn)) : "focusout" === t1 && nn();
            }
            function sn(t1) {
                if ("selectionchange" === t1 || "keyup" === t1 || "keydown" === t1) return qi(Xi);
            }
            function on(t1, e) {
                if ("click" === t1) return qi(e);
            }
            function ln(t1, e) {
                if ("input" === t1 || "change" === t1) return qi(e);
            }
            var cn = "function" == typeof Object.is ? Object.is : function(t1, e) {
                return t1 === e && (0 !== t1 || 1 / t1 == 1 / e) || t1 != t1 && e != e;
            }, un = Object.prototype.hasOwnProperty;
            function hn(t1, e) {
                if (cn(t1, e)) return !0;
                if ("object" != typeof t1 || null === t1 || "object" != typeof e || null === e) return !1;
                var i = Object.keys(t1), n = Object.keys(e);
                if (i.length !== n.length) return !1;
                for(n = 0; n < i.length; n++)if (!un.call(e, i[n]) || !cn(t1[i[n]], e[i[n]])) return !1;
                return !0;
            }
            function dn(t1) {
                for(; t1 && t1.firstChild;)t1 = t1.firstChild;
                return t1;
            }
            function pn(t1, e) {
                var i, n = dn(t1);
                for(t1 = 0; n;){
                    if (3 === n.nodeType) {
                        if (i = t1 + n.textContent.length, t1 <= e && i >= e) return {
                            node: n,
                            offset: e - t1
                        };
                        t1 = i;
                    }
                    t: {
                        for(; n;){
                            if (n.nextSibling) {
                                n = n.nextSibling;
                                break t;
                            }
                            n = n.parentNode;
                        }
                        n = void 0;
                    }
                    n = dn(n);
                }
            }
            function An(t1, e) {
                return !(!t1 || !e) && (t1 === e || (!t1 || 3 !== t1.nodeType) && (e && 3 === e.nodeType ? An(t1, e.parentNode) : "contains" in t1 ? t1.contains(e) : !!t1.compareDocumentPosition && !!(16 & t1.compareDocumentPosition(e))));
            }
            function fn() {
                for(var t1 = window, e = K(); e instanceof t1.HTMLIFrameElement;){
                    try {
                        var i = "string" == typeof e.contentWindow.location.href;
                    } catch (t1) {
                        i = !1;
                    }
                    if (!i) break;
                    e = K((t1 = e.contentWindow).document);
                }
                return e;
            }
            function mn(t1) {
                var e = t1 && t1.nodeName && t1.nodeName.toLowerCase();
                return e && ("input" === e && ("text" === t1.type || "search" === t1.type || "tel" === t1.type || "url" === t1.type || "password" === t1.type) || "textarea" === e || "true" === t1.contentEditable);
            }
            var gn = h && "documentMode" in document && 11 >= document.documentMode, Mn = null, vn = null, yn = null, xn = !1;
            function wn(t1, e, i) {
                var n = i.window === i ? i.document : 9 === i.nodeType ? i : i.ownerDocument;
                xn || null == Mn || Mn !== K(n) || (n = "selectionStart" in (n = Mn) && mn(n) ? {
                    start: n.selectionStart,
                    end: n.selectionEnd
                } : {
                    anchorNode: (n = (n.ownerDocument && n.ownerDocument.defaultView || window).getSelection()).anchorNode,
                    anchorOffset: n.anchorOffset,
                    focusNode: n.focusNode,
                    focusOffset: n.focusOffset
                }, yn && hn(yn, n) || (yn = n, 0 < (n = jn(vn, "onSelect")).length && (e = new hi("onSelect", "select", null, e, i), t1.push({
                    event: e,
                    listeners: n
                }), e.target = Mn)));
            }
            Oe("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0), Oe("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1), Oe(Le, 2);
            for(var bn = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), Tn = 0; Tn < bn.length; Tn++)ze.set(bn[Tn], 0);
            u("onMouseEnter", [
                "mouseout",
                "mouseover"
            ]), u("onMouseLeave", [
                "mouseout",
                "mouseover"
            ]), u("onPointerEnter", [
                "pointerout",
                "pointerover"
            ]), u("onPointerLeave", [
                "pointerout",
                "pointerover"
            ]), c("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), c("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), c("onBeforeInput", [
                "compositionend",
                "keypress",
                "textInput",
                "paste"
            ]), c("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), c("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), c("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
            var En = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), _n = new Set("cancel close invalid load scroll toggle".split(" ").concat(En));
            function In(t1, e, i) {
                var n = t1.type || "unknown-event";
                t1.currentTarget = i, function(t1, e, i, n, r, a, o, l, c) {
                    if (Xt.apply(this, arguments), Ht) {
                        if (!Ht) throw Error(s(198));
                        var u = Vt;
                        Ht = !1, Vt = null, Gt || (Gt = !0, Wt = u);
                    }
                }(n, e, void 0, t1), t1.currentTarget = null;
            }
            function Sn(t1, e) {
                e = !!(4 & e);
                for(var i = 0; i < t1.length; i++){
                    var n = t1[i], r = n.event;
                    n = n.listeners;
                    t: {
                        var a = void 0;
                        if (e) for(var s = n.length - 1; 0 <= s; s--){
                            var o = n[s], l = o.instance, c = o.currentTarget;
                            if (o = o.listener, l !== a && r.isPropagationStopped()) break t;
                            In(r, o, c), a = l;
                        }
                        else for(s = 0; s < n.length; s++){
                            if (l = (o = n[s]).instance, c = o.currentTarget, o = o.listener, l !== a && r.isPropagationStopped()) break t;
                            In(r, o, c), a = l;
                        }
                    }
                }
                if (Gt) throw t1 = Wt, Gt = !1, Wt = null, t1;
            }
            function Nn(t1, e) {
                var i = ar(e), n = t1 + "__bubble";
                i.has(n) || (Ln(e, t1, 2, !1), i.add(n));
            }
            var Dn = "_reactListening" + Math.random().toString(36).slice(2);
            function Cn(t1) {
                t1[Dn] || (t1[Dn] = !0, o.forEach(function(e) {
                    _n.has(e) || zn(e, !1, t1, null), zn(e, !0, t1, null);
                }));
            }
            function zn(t1, e, i, n) {
                var r = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0, a = i;
                if ("selectionchange" === t1 && 9 !== i.nodeType && (a = i.ownerDocument), null !== n && !e && _n.has(t1)) {
                    if ("scroll" !== t1) return;
                    r |= 2, a = n;
                }
                var s = ar(a), o = t1 + "__" + (e ? "capture" : "bubble");
                s.has(o) || (e && (r |= 4), Ln(a, t1, r, e), s.add(o));
            }
            function Ln(t1, e, i, n) {
                var r = ze.get(e);
                switch(void 0 === r ? 2 : r){
                    case 0:
                        r = Ze;
                        break;
                    case 1:
                        r = qe;
                        break;
                    default:
                        r = Je;
                }
                i = r.bind(null, e, i, t1), r = void 0, !Bt || "touchstart" !== e && "touchmove" !== e && "wheel" !== e || (r = !0), n ? void 0 !== r ? t1.addEventListener(e, i, {
                    capture: !0,
                    passive: r
                }) : t1.addEventListener(e, i, !0) : void 0 !== r ? t1.addEventListener(e, i, {
                    passive: r
                }) : t1.addEventListener(e, i, !1);
            }
            function On(t1, e, i, n, r) {
                var a = n;
                if (!(1 & e || 2 & e || null === n)) t: for(;;){
                    if (null === n) return;
                    var s = n.tag;
                    if (3 === s || 4 === s) {
                        var o = n.stateNode.containerInfo;
                        if (o === r || 8 === o.nodeType && o.parentNode === r) break;
                        if (4 === s) for(s = n.return; null !== s;){
                            var l = s.tag;
                            if ((3 === l || 4 === l) && ((l = s.stateNode.containerInfo) === r || 8 === l.nodeType && l.parentNode === r)) return;
                            s = s.return;
                        }
                        for(; null !== o;){
                            if (null === (s = er(o))) return;
                            if (5 === (l = s.tag) || 6 === l) {
                                n = a = s;
                                continue t;
                            }
                            o = o.parentNode;
                        }
                    }
                    n = n.return;
                }
                !function(t1, e, i) {
                    if (Rt) return t1();
                    Rt = !0;
                    try {
                        return Pt(t1, e, i);
                    } finally{
                        Rt = !1, kt();
                    }
                }(function() {
                    var n = a, r = Et(i), s = [];
                    t: {
                        var o = Ce.get(t1);
                        if (void 0 !== o) {
                            var l = hi, c = t1;
                            switch(t1){
                                case "keypress":
                                    if (0 === ni(i)) break t;
                                case "keydown":
                                case "keyup":
                                    l = Si;
                                    break;
                                case "focusin":
                                    c = "focus", l = gi;
                                    break;
                                case "focusout":
                                    c = "blur", l = gi;
                                    break;
                                case "beforeblur":
                                case "afterblur":
                                    l = gi;
                                    break;
                                case "click":
                                    if (2 === i.button) break t;
                                case "auxclick":
                                case "dblclick":
                                case "mousedown":
                                case "mousemove":
                                case "mouseup":
                                case "mouseout":
                                case "mouseover":
                                case "contextmenu":
                                    l = fi;
                                    break;
                                case "drag":
                                case "dragend":
                                case "dragenter":
                                case "dragexit":
                                case "dragleave":
                                case "dragover":
                                case "dragstart":
                                case "drop":
                                    l = mi;
                                    break;
                                case "touchcancel":
                                case "touchend":
                                case "touchmove":
                                case "touchstart":
                                    l = Di;
                                    break;
                                case Ie:
                                case Se:
                                case Ne:
                                    l = Mi;
                                    break;
                                case De:
                                    l = Ci;
                                    break;
                                case "scroll":
                                    l = pi;
                                    break;
                                case "wheel":
                                    l = Li;
                                    break;
                                case "copy":
                                case "cut":
                                case "paste":
                                    l = yi;
                                    break;
                                case "gotpointercapture":
                                case "lostpointercapture":
                                case "pointercancel":
                                case "pointerdown":
                                case "pointermove":
                                case "pointerout":
                                case "pointerover":
                                case "pointerup":
                                    l = Ni;
                            }
                            var u = !!(4 & e), h = !u && "scroll" === t1, d = u ? null !== o ? o + "Capture" : null : o;
                            u = [];
                            for(var p, A = n; null !== A;){
                                var f = (p = A).stateNode;
                                if (5 === p.tag && null !== f && (p = f, null !== d && null != (f = Ut(A, d)) && u.push(Pn(A, f, p))), h) break;
                                A = A.return;
                            }
                            0 < u.length && (o = new l(o, c, null, i, r), s.push({
                                event: o,
                                listeners: u
                            }));
                        }
                    }
                    if (!(7 & e)) {
                        if (l = "mouseout" === t1 || "pointerout" === t1, (!(o = "mouseover" === t1 || "pointerover" === t1) || 16 & e || !(c = i.relatedTarget || i.fromElement) || !er(c) && !c[$n]) && (l || o) && (o = r.window === r ? r : (o = r.ownerDocument) ? o.defaultView || o.parentWindow : window, l ? (l = n, null !== (c = (c = i.relatedTarget || i.toElement) ? er(c) : null) && (c !== (h = Zt(c)) || 5 !== c.tag && 6 !== c.tag) && (c = null)) : (l = null, c = n), l !== c)) {
                            if (u = fi, f = "onMouseLeave", d = "onMouseEnter", A = "mouse", "pointerout" !== t1 && "pointerover" !== t1 || (u = Ni, f = "onPointerLeave", d = "onPointerEnter", A = "pointer"), h = null == l ? o : nr(l), p = null == c ? o : nr(c), (o = new u(f, A + "leave", l, i, r)).target = h, o.relatedTarget = p, f = null, er(r) === n && ((u = new u(d, A + "enter", c, i, r)).target = p, u.relatedTarget = h, f = u), h = f, l && c) t: {
                                for(d = c, A = 0, p = u = l; p; p = Rn(p))A++;
                                for(p = 0, f = d; f; f = Rn(f))p++;
                                for(; 0 < A - p;)u = Rn(u), A--;
                                for(; 0 < p - A;)d = Rn(d), p--;
                                for(; A--;){
                                    if (u === d || null !== d && u === d.alternate) break t;
                                    u = Rn(u), d = Rn(d);
                                }
                                u = null;
                            }
                            else u = null;
                            null !== l && kn(s, o, l, u, !1), null !== c && null !== h && kn(s, h, c, u, !0);
                        }
                        if ("select" === (l = (o = n ? nr(n) : window).nodeName && o.nodeName.toLowerCase()) || "input" === l && "file" === o.type) var m = Ji;
                        else if (Gi(o)) {
                            if (Ki) m = ln;
                            else {
                                m = sn;
                                var g = an;
                            }
                        } else (l = o.nodeName) && "input" === l.toLowerCase() && ("checkbox" === o.type || "radio" === o.type) && (m = on);
                        switch(m && (m = m(t1, n)) ? Wi(s, m, i, r) : (g && g(t1, o, n), "focusout" === t1 && (g = o._wrapperState) && g.controlled && "number" === o.type && rt(o, "number", o.value)), g = n ? nr(n) : window, t1){
                            case "focusin":
                                (Gi(g) || "true" === g.contentEditable) && (Mn = g, vn = n, yn = null);
                                break;
                            case "focusout":
                                yn = vn = Mn = null;
                                break;
                            case "mousedown":
                                xn = !0;
                                break;
                            case "contextmenu":
                            case "mouseup":
                            case "dragend":
                                xn = !1, wn(s, i, r);
                                break;
                            case "selectionchange":
                                if (gn) break;
                            case "keydown":
                            case "keyup":
                                wn(s, i, r);
                        }
                        var M;
                        if (Pi) t: {
                            switch(t1){
                                case "compositionstart":
                                    var v = "onCompositionStart";
                                    break t;
                                case "compositionend":
                                    v = "onCompositionEnd";
                                    break t;
                                case "compositionupdate":
                                    v = "onCompositionUpdate";
                                    break t;
                            }
                            v = void 0;
                        }
                        else Hi ? Fi(t1, i) && (v = "onCompositionEnd") : "keydown" === t1 && 229 === i.keyCode && (v = "onCompositionStart");
                        v && (ki && "ko" !== i.locale && (Hi || "onCompositionStart" !== v ? "onCompositionEnd" === v && Hi && (M = ii()) : (ti = "value" in ($e = r) ? $e.value : $e.textContent, Hi = !0)), 0 < (g = jn(n, v)).length && (v = new xi(v, t1, null, i, r), s.push({
                            event: v,
                            listeners: g
                        }), (M || null !== (M = Qi(i))) && (v.data = M))), (M = Ri ? function(t1, e) {
                            switch(t1){
                                case "compositionend":
                                    return Qi(e);
                                case "keypress":
                                    return 32 !== e.which ? null : (Bi = !0, Ui);
                                case "textInput":
                                    return (t1 = e.data) === Ui && Bi ? null : t1;
                                default:
                                    return null;
                            }
                        }(t1, i) : function(t1, e) {
                            if (Hi) return "compositionend" === t1 || !Pi && Fi(t1, e) ? (t1 = ii(), ei = ti = $e = null, Hi = !1, t1) : null;
                            switch(t1){
                                case "paste":
                                default:
                                    return null;
                                case "keypress":
                                    if (!(e.ctrlKey || e.altKey || e.metaKey) || e.ctrlKey && e.altKey) {
                                        if (e.char && 1 < e.char.length) return e.char;
                                        if (e.which) return String.fromCharCode(e.which);
                                    }
                                    return null;
                                case "compositionend":
                                    return ki && "ko" !== e.locale ? null : e.data;
                            }
                        }(t1, i)) && 0 < (n = jn(n, "onBeforeInput")).length && (r = new xi("onBeforeInput", "beforeinput", null, i, r), s.push({
                            event: r,
                            listeners: n
                        }), r.data = M);
                    }
                    Sn(s, e);
                });
            }
            function Pn(t1, e, i) {
                return {
                    instance: t1,
                    listener: e,
                    currentTarget: i
                };
            }
            function jn(t1, e) {
                for(var i = e + "Capture", n = []; null !== t1;){
                    var r = t1, a = r.stateNode;
                    5 === r.tag && null !== a && (r = a, null != (a = Ut(t1, i)) && n.unshift(Pn(t1, a, r)), null != (a = Ut(t1, e)) && n.push(Pn(t1, a, r))), t1 = t1.return;
                }
                return n;
            }
            function Rn(t1) {
                if (null === t1) return null;
                do t1 = t1.return;
                while (t1 && 5 !== t1.tag);
                return t1 || null;
            }
            function kn(t1, e, i, n, r) {
                for(var a = e._reactName, s = []; null !== i && i !== n;){
                    var o = i, l = o.alternate, c = o.stateNode;
                    if (null !== l && l === n) break;
                    5 === o.tag && null !== c && (o = c, r ? null != (l = Ut(i, a)) && s.unshift(Pn(i, l, o)) : r || null != (l = Ut(i, a)) && s.push(Pn(i, l, o))), i = i.return;
                }
                0 !== s.length && t1.push({
                    event: e,
                    listeners: s
                });
            }
            function Un() {}
            var Bn = null, Fn = null;
            function Qn(t1, e) {
                switch(t1){
                    case "button":
                    case "input":
                    case "select":
                    case "textarea":
                        return !!e.autoFocus;
                }
                return !1;
            }
            function Hn(t1, e) {
                return "textarea" === t1 || "option" === t1 || "noscript" === t1 || "string" == typeof e.children || "number" == typeof e.children || "object" == typeof e.dangerouslySetInnerHTML && null !== e.dangerouslySetInnerHTML && null != e.dangerouslySetInnerHTML.__html;
            }
            var Vn = "function" == typeof setTimeout ? setTimeout : void 0, Gn = "function" == typeof clearTimeout ? clearTimeout : void 0;
            function Wn(t1) {
                (1 === t1.nodeType || 9 === t1.nodeType && null != (t1 = t1.body)) && (t1.textContent = "");
            }
            function Yn(t1) {
                for(; null != t1; t1 = t1.nextSibling){
                    var e = t1.nodeType;
                    if (1 === e || 3 === e) break;
                }
                return t1;
            }
            function Xn(t1) {
                t1 = t1.previousSibling;
                for(var e = 0; t1;){
                    if (8 === t1.nodeType) {
                        var i = t1.data;
                        if ("$" === i || "$!" === i || "$?" === i) {
                            if (0 === e) return t1;
                            e--;
                        } else "/$" === i && e++;
                    }
                    t1 = t1.previousSibling;
                }
                return null;
            }
            var Zn = 0, qn = Math.random().toString(36).slice(2), Jn = "__reactFiber$" + qn, Kn = "__reactProps$" + qn, $n = "__reactContainer$" + qn, tr = "__reactEvents$" + qn;
            function er(t1) {
                var e = t1[Jn];
                if (e) return e;
                for(var i = t1.parentNode; i;){
                    if (e = i[$n] || i[Jn]) {
                        if (i = e.alternate, null !== e.child || null !== i && null !== i.child) for(t1 = Xn(t1); null !== t1;){
                            if (i = t1[Jn]) return i;
                            t1 = Xn(t1);
                        }
                        return e;
                    }
                    i = (t1 = i).parentNode;
                }
                return null;
            }
            function ir(t1) {
                return !(t1 = t1[Jn] || t1[$n]) || 5 !== t1.tag && 6 !== t1.tag && 13 !== t1.tag && 3 !== t1.tag ? null : t1;
            }
            function nr(t1) {
                if (5 === t1.tag || 6 === t1.tag) return t1.stateNode;
                throw Error(s(33));
            }
            function rr(t1) {
                return t1[Kn] || null;
            }
            function ar(t1) {
                var e = t1[tr];
                return void 0 === e && (e = t1[tr] = new Set), e;
            }
            var sr = [], or = -1;
            function lr(t1) {
                return {
                    current: t1
                };
            }
            function cr(t1) {
                0 > or || (t1.current = sr[or], sr[or] = null, or--);
            }
            function ur(t1, e) {
                or++, sr[or] = t1.current, t1.current = e;
            }
            var hr = {}, dr = lr(hr), pr = lr(!1), Ar = hr;
            function fr(t1, e) {
                var i = t1.type.contextTypes;
                if (!i) return hr;
                var n = t1.stateNode;
                if (n && n.__reactInternalMemoizedUnmaskedChildContext === e) return n.__reactInternalMemoizedMaskedChildContext;
                var r, a = {};
                for(r in i)a[r] = e[r];
                return n && ((t1 = t1.stateNode).__reactInternalMemoizedUnmaskedChildContext = e, t1.__reactInternalMemoizedMaskedChildContext = a), a;
            }
            function mr(t1) {
                return null != t1.childContextTypes;
            }
            function gr() {
                cr(pr), cr(dr);
            }
            function Mr(t1, e, i) {
                if (dr.current !== hr) throw Error(s(168));
                ur(dr, e), ur(pr, i);
            }
            function vr(t1, e, i) {
                var n = t1.stateNode;
                if (t1 = e.childContextTypes, "function" != typeof n.getChildContext) return i;
                for(var a in n = n.getChildContext())if (!(a in t1)) throw Error(s(108, Y(e) || "Unknown", a));
                return r({}, i, n);
            }
            function yr(t1) {
                return t1 = (t1 = t1.stateNode) && t1.__reactInternalMemoizedMergedChildContext || hr, Ar = dr.current, ur(dr, t1), ur(pr, pr.current), !0;
            }
            function xr(t1, e, i) {
                var n = t1.stateNode;
                if (!n) throw Error(s(169));
                i ? (t1 = vr(t1, e, Ar), n.__reactInternalMemoizedMergedChildContext = t1, cr(pr), cr(dr), ur(dr, t1)) : cr(pr), ur(pr, i);
            }
            var wr = null, br = null, Tr = a.unstable_runWithPriority, Er = a.unstable_scheduleCallback, _r = a.unstable_cancelCallback, Ir = a.unstable_shouldYield, Sr = a.unstable_requestPaint, Nr = a.unstable_now, Dr = a.unstable_getCurrentPriorityLevel, Cr = a.unstable_ImmediatePriority, zr = a.unstable_UserBlockingPriority, Lr = a.unstable_NormalPriority, Or = a.unstable_LowPriority, Pr = a.unstable_IdlePriority, jr = {}, Rr = void 0 !== Sr ? Sr : function() {}, kr = null, Ur = null, Br = !1, Fr = Nr(), Qr = 1e4 > Fr ? Nr : function() {
                return Nr() - Fr;
            };
            function Hr() {
                switch(Dr()){
                    case Cr:
                        return 99;
                    case zr:
                        return 98;
                    case Lr:
                        return 97;
                    case Or:
                        return 96;
                    case Pr:
                        return 95;
                    default:
                        throw Error(s(332));
                }
            }
            function Vr(t1) {
                switch(t1){
                    case 99:
                        return Cr;
                    case 98:
                        return zr;
                    case 97:
                        return Lr;
                    case 96:
                        return Or;
                    case 95:
                        return Pr;
                    default:
                        throw Error(s(332));
                }
            }
            function Gr(t1, e) {
                return t1 = Vr(t1), Tr(t1, e);
            }
            function Wr(t1, e, i) {
                return t1 = Vr(t1), Er(t1, e, i);
            }
            function Yr() {
                if (null !== Ur) {
                    var t1 = Ur;
                    Ur = null, _r(t1);
                }
                Xr();
            }
            function Xr() {
                if (!Br && null !== kr) {
                    Br = !0;
                    var t1 = 0;
                    try {
                        var e = kr;
                        Gr(99, function() {
                            for(; t1 < e.length; t1++){
                                var i = e[t1];
                                do i = i(!0);
                                while (null !== i);
                            }
                        }), kr = null;
                    } catch (e) {
                        throw null !== kr && (kr = kr.slice(t1 + 1)), Er(Cr, Yr), e;
                    } finally{
                        Br = !1;
                    }
                }
            }
            var Zr = x.ReactCurrentBatchConfig;
            function qr(t1, e) {
                if (t1 && t1.defaultProps) {
                    for(var i in e = r({}, e), t1 = t1.defaultProps)void 0 === e[i] && (e[i] = t1[i]);
                    return e;
                }
                return e;
            }
            var Jr = lr(null), Kr = null, $r = null, ta = null;
            function ea() {
                ta = $r = Kr = null;
            }
            function ia(t1) {
                var e = Jr.current;
                cr(Jr), t1.type._context._currentValue = e;
            }
            function na(t1, e) {
                for(; null !== t1;){
                    var i = t1.alternate;
                    if ((t1.childLanes & e) === e) {
                        if (null === i || (i.childLanes & e) === e) break;
                        i.childLanes |= e;
                    } else t1.childLanes |= e, null !== i && (i.childLanes |= e);
                    t1 = t1.return;
                }
            }
            function ra(t1, e) {
                Kr = t1, ta = $r = null, null !== (t1 = t1.dependencies) && null !== t1.firstContext && (!!(t1.lanes & e) && (Ps = !0), t1.firstContext = null);
            }
            function aa(t1, e) {
                if (ta !== t1 && !1 !== e && 0 !== e) {
                    if ("number" == typeof e && 1073741823 !== e || (ta = t1, e = 1073741823), e = {
                        context: t1,
                        observedBits: e,
                        next: null
                    }, null === $r) {
                        if (null === Kr) throw Error(s(308));
                        $r = e, Kr.dependencies = {
                            lanes: 0,
                            firstContext: e,
                            responders: null
                        };
                    } else $r = $r.next = e;
                }
                return t1._currentValue;
            }
            var sa = !1;
            function oa(t1) {
                t1.updateQueue = {
                    baseState: t1.memoizedState,
                    firstBaseUpdate: null,
                    lastBaseUpdate: null,
                    shared: {
                        pending: null
                    },
                    effects: null
                };
            }
            function la(t1, e) {
                t1 = t1.updateQueue, e.updateQueue === t1 && (e.updateQueue = {
                    baseState: t1.baseState,
                    firstBaseUpdate: t1.firstBaseUpdate,
                    lastBaseUpdate: t1.lastBaseUpdate,
                    shared: t1.shared,
                    effects: t1.effects
                });
            }
            function ca(t1, e) {
                return {
                    eventTime: t1,
                    lane: e,
                    tag: 0,
                    payload: null,
                    callback: null,
                    next: null
                };
            }
            function ua(t1, e) {
                if (null !== (t1 = t1.updateQueue)) {
                    var i = (t1 = t1.shared).pending;
                    null === i ? e.next = e : (e.next = i.next, i.next = e), t1.pending = e;
                }
            }
            function ha(t1, e) {
                var i = t1.updateQueue, n = t1.alternate;
                if (null !== n && i === (n = n.updateQueue)) {
                    var r = null, a = null;
                    if (null !== (i = i.firstBaseUpdate)) {
                        do {
                            var s = {
                                eventTime: i.eventTime,
                                lane: i.lane,
                                tag: i.tag,
                                payload: i.payload,
                                callback: i.callback,
                                next: null
                            };
                            null === a ? r = a = s : a = a.next = s, i = i.next;
                        }while (null !== i);
                        null === a ? r = a = e : a = a.next = e;
                    } else r = a = e;
                    return i = {
                        baseState: n.baseState,
                        firstBaseUpdate: r,
                        lastBaseUpdate: a,
                        shared: n.shared,
                        effects: n.effects
                    }, void (t1.updateQueue = i);
                }
                null === (t1 = i.lastBaseUpdate) ? i.firstBaseUpdate = e : t1.next = e, i.lastBaseUpdate = e;
            }
            function da(t1, e, i, n) {
                var a = t1.updateQueue;
                sa = !1;
                var s = a.firstBaseUpdate, o = a.lastBaseUpdate, l = a.shared.pending;
                if (null !== l) {
                    a.shared.pending = null;
                    var c = l, u = c.next;
                    c.next = null, null === o ? s = u : o.next = u, o = c;
                    var h = t1.alternate;
                    if (null !== h) {
                        var d = (h = h.updateQueue).lastBaseUpdate;
                        d !== o && (null === d ? h.firstBaseUpdate = u : d.next = u, h.lastBaseUpdate = c);
                    }
                }
                if (null !== s) {
                    for(d = a.baseState, o = 0, h = u = c = null;;){
                        l = s.lane;
                        var p = s.eventTime;
                        if ((n & l) === l) {
                            null !== h && (h = h.next = {
                                eventTime: p,
                                lane: 0,
                                tag: s.tag,
                                payload: s.payload,
                                callback: s.callback,
                                next: null
                            });
                            t: {
                                var A = t1, f = s;
                                switch(l = e, p = i, f.tag){
                                    case 1:
                                        if ("function" == typeof (A = f.payload)) {
                                            d = A.call(p, d, l);
                                            break t;
                                        }
                                        d = A;
                                        break t;
                                    case 3:
                                        A.flags = -4097 & A.flags | 64;
                                    case 0:
                                        if (null == (l = "function" == typeof (A = f.payload) ? A.call(p, d, l) : A)) break t;
                                        d = r({}, d, l);
                                        break t;
                                    case 2:
                                        sa = !0;
                                }
                            }
                            null !== s.callback && (t1.flags |= 32, null === (l = a.effects) ? a.effects = [
                                s
                            ] : l.push(s));
                        } else p = {
                            eventTime: p,
                            lane: l,
                            tag: s.tag,
                            payload: s.payload,
                            callback: s.callback,
                            next: null
                        }, null === h ? (u = h = p, c = d) : h = h.next = p, o |= l;
                        if (null === (s = s.next)) {
                            if (null === (l = a.shared.pending)) break;
                            s = l.next, l.next = null, a.lastBaseUpdate = l, a.shared.pending = null;
                        }
                    }
                    null === h && (c = d), a.baseState = c, a.firstBaseUpdate = u, a.lastBaseUpdate = h, Uo |= o, t1.lanes = o, t1.memoizedState = d;
                }
            }
            function pa(t1, e, i) {
                if (t1 = e.effects, e.effects = null, null !== t1) for(e = 0; e < t1.length; e++){
                    var n = t1[e], r = n.callback;
                    if (null !== r) {
                        if (n.callback = null, n = i, "function" != typeof r) throw Error(s(191, r));
                        r.call(n);
                    }
                }
            }
            var Aa = (new n.Component).refs;
            function fa(t1, e, i, n) {
                i = null == (i = i(n, e = t1.memoizedState)) ? e : r({}, e, i), t1.memoizedState = i, 0 === t1.lanes && (t1.updateQueue.baseState = i);
            }
            var ma = {
                isMounted: function(t1) {
                    return !!(t1 = t1._reactInternals) && Zt(t1) === t1;
                },
                enqueueSetState: function(t1, e, i) {
                    t1 = t1._reactInternals;
                    var n = ul(), r = hl(t1), a = ca(n, r);
                    a.payload = e, null != i && (a.callback = i), ua(t1, a), dl(t1, r, n);
                },
                enqueueReplaceState: function(t1, e, i) {
                    t1 = t1._reactInternals;
                    var n = ul(), r = hl(t1), a = ca(n, r);
                    a.tag = 1, a.payload = e, null != i && (a.callback = i), ua(t1, a), dl(t1, r, n);
                },
                enqueueForceUpdate: function(t1, e) {
                    t1 = t1._reactInternals;
                    var i = ul(), n = hl(t1), r = ca(i, n);
                    r.tag = 2, null != e && (r.callback = e), ua(t1, r), dl(t1, n, i);
                }
            };
            function ga(t1, e, i, n, r, a, s) {
                return "function" == typeof (t1 = t1.stateNode).shouldComponentUpdate ? t1.shouldComponentUpdate(n, a, s) : !(e.prototype && e.prototype.isPureReactComponent && hn(i, n) && hn(r, a));
            }
            function Ma(t1, e, i) {
                var n = !1, r = hr, a = e.contextType;
                return "object" == typeof a && null !== a ? a = aa(a) : (r = mr(e) ? Ar : dr.current, a = (n = null != (n = e.contextTypes)) ? fr(t1, r) : hr), e = new e(i, a), t1.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, e.updater = ma, t1.stateNode = e, e._reactInternals = t1, n && ((t1 = t1.stateNode).__reactInternalMemoizedUnmaskedChildContext = r, t1.__reactInternalMemoizedMaskedChildContext = a), e;
            }
            function va(t1, e, i, n) {
                t1 = e.state, "function" == typeof e.componentWillReceiveProps && e.componentWillReceiveProps(i, n), "function" == typeof e.UNSAFE_componentWillReceiveProps && e.UNSAFE_componentWillReceiveProps(i, n), e.state !== t1 && ma.enqueueReplaceState(e, e.state, null);
            }
            function ya(t1, e, i, n) {
                var r = t1.stateNode;
                r.props = i, r.state = t1.memoizedState, r.refs = Aa, oa(t1);
                var a = e.contextType;
                "object" == typeof a && null !== a ? r.context = aa(a) : (a = mr(e) ? Ar : dr.current, r.context = fr(t1, a)), da(t1, i, r, n), r.state = t1.memoizedState, "function" == typeof (a = e.getDerivedStateFromProps) && (fa(t1, e, a, i), r.state = t1.memoizedState), "function" == typeof e.getDerivedStateFromProps || "function" == typeof r.getSnapshotBeforeUpdate || "function" != typeof r.UNSAFE_componentWillMount && "function" != typeof r.componentWillMount || (e = r.state, "function" == typeof r.componentWillMount && r.componentWillMount(), "function" == typeof r.UNSAFE_componentWillMount && r.UNSAFE_componentWillMount(), e !== r.state && ma.enqueueReplaceState(r, r.state, null), da(t1, i, r, n), r.state = t1.memoizedState), "function" == typeof r.componentDidMount && (t1.flags |= 4);
            }
            var xa = Array.isArray;
            function wa(t1, e, i) {
                if (null !== (t1 = i.ref) && "function" != typeof t1 && "object" != typeof t1) {
                    if (i._owner) {
                        if (i = i._owner) {
                            if (1 !== i.tag) throw Error(s(309));
                            var n = i.stateNode;
                        }
                        if (!n) throw Error(s(147, t1));
                        var r = "" + t1;
                        return null !== e && null !== e.ref && "function" == typeof e.ref && e.ref._stringRef === r ? e.ref : (e = function(t1) {
                            var e = n.refs;
                            e === Aa && (e = n.refs = {}), null === t1 ? delete e[r] : e[r] = t1;
                        }, e._stringRef = r, e);
                    }
                    if ("string" != typeof t1) throw Error(s(284));
                    if (!i._owner) throw Error(s(290, t1));
                }
                return t1;
            }
            function ba(t1, e) {
                if ("textarea" !== t1.type) throw Error(s(31, "[object Object]" === Object.prototype.toString.call(e) ? "object with keys {" + Object.keys(e).join(", ") + "}" : e));
            }
            function Ta(t1) {
                function e(e, i) {
                    if (t1) {
                        var n = e.lastEffect;
                        null !== n ? (n.nextEffect = i, e.lastEffect = i) : e.firstEffect = e.lastEffect = i, i.nextEffect = null, i.flags = 8;
                    }
                }
                function i(i, n) {
                    if (!t1) return null;
                    for(; null !== n;)e(i, n), n = n.sibling;
                    return null;
                }
                function n(t1, e) {
                    for(t1 = new Map; null !== e;)null !== e.key ? t1.set(e.key, e) : t1.set(e.index, e), e = e.sibling;
                    return t1;
                }
                function r(t1, e) {
                    return (t1 = Vl(t1, e)).index = 0, t1.sibling = null, t1;
                }
                function a(e, i, n) {
                    return e.index = n, t1 ? null !== (n = e.alternate) ? (n = n.index) < i ? (e.flags = 2, i) : n : (e.flags = 2, i) : i;
                }
                function o(e) {
                    return t1 && null === e.alternate && (e.flags = 2), e;
                }
                function l(t1, e, i, n) {
                    return null === e || 6 !== e.tag ? ((e = Xl(i, t1.mode, n)).return = t1, e) : ((e = r(e, i)).return = t1, e);
                }
                function c(t1, e, i, n) {
                    return null !== e && e.elementType === i.type ? ((n = r(e, i.props)).ref = wa(t1, e, i), n.return = t1, n) : ((n = Gl(i.type, i.key, i.props, null, t1.mode, n)).ref = wa(t1, e, i), n.return = t1, n);
                }
                function u(t1, e, i, n) {
                    return null === e || 4 !== e.tag || e.stateNode.containerInfo !== i.containerInfo || e.stateNode.implementation !== i.implementation ? ((e = Zl(i, t1.mode, n)).return = t1, e) : ((e = r(e, i.children || [])).return = t1, e);
                }
                function h(t1, e, i, n, a) {
                    return null === e || 7 !== e.tag ? ((e = Wl(i, t1.mode, n, a)).return = t1, e) : ((e = r(e, i)).return = t1, e);
                }
                function d(t1, e, i) {
                    if ("string" == typeof e || "number" == typeof e) return (e = Xl("" + e, t1.mode, i)).return = t1, e;
                    if ("object" == typeof e && null !== e) {
                        switch(e.$$typeof){
                            case w:
                                return (i = Gl(e.type, e.key, e.props, null, t1.mode, i)).ref = wa(t1, null, e), i.return = t1, i;
                            case b:
                                return (e = Zl(e, t1.mode, i)).return = t1, e;
                        }
                        if (xa(e) || Q(e)) return (e = Wl(e, t1.mode, i, null)).return = t1, e;
                        ba(t1, e);
                    }
                    return null;
                }
                function p(t1, e, i, n) {
                    var r = null !== e ? e.key : null;
                    if ("string" == typeof i || "number" == typeof i) return null !== r ? null : l(t1, e, "" + i, n);
                    if ("object" == typeof i && null !== i) {
                        switch(i.$$typeof){
                            case w:
                                return i.key === r ? i.type === T ? h(t1, e, i.props.children, n, r) : c(t1, e, i, n) : null;
                            case b:
                                return i.key === r ? u(t1, e, i, n) : null;
                        }
                        if (xa(i) || Q(i)) return null !== r ? null : h(t1, e, i, n, null);
                        ba(t1, i);
                    }
                    return null;
                }
                function A(t1, e, i, n, r) {
                    if ("string" == typeof n || "number" == typeof n) return l(e, t1 = t1.get(i) || null, "" + n, r);
                    if ("object" == typeof n && null !== n) {
                        switch(n.$$typeof){
                            case w:
                                return t1 = t1.get(null === n.key ? i : n.key) || null, n.type === T ? h(e, t1, n.props.children, r, n.key) : c(e, t1, n, r);
                            case b:
                                return u(e, t1 = t1.get(null === n.key ? i : n.key) || null, n, r);
                        }
                        if (xa(n) || Q(n)) return h(e, t1 = t1.get(i) || null, n, r, null);
                        ba(e, n);
                    }
                    return null;
                }
                function f(r, s, o, l) {
                    for(var c = null, u = null, h = s, f = s = 0, m = null; null !== h && f < o.length; f++){
                        h.index > f ? (m = h, h = null) : m = h.sibling;
                        var g = p(r, h, o[f], l);
                        if (null === g) {
                            null === h && (h = m);
                            break;
                        }
                        t1 && h && null === g.alternate && e(r, h), s = a(g, s, f), null === u ? c = g : u.sibling = g, u = g, h = m;
                    }
                    if (f === o.length) return i(r, h), c;
                    if (null === h) {
                        for(; f < o.length; f++)null !== (h = d(r, o[f], l)) && (s = a(h, s, f), null === u ? c = h : u.sibling = h, u = h);
                        return c;
                    }
                    for(h = n(r, h); f < o.length; f++)null !== (m = A(h, r, f, o[f], l)) && (t1 && null !== m.alternate && h.delete(null === m.key ? f : m.key), s = a(m, s, f), null === u ? c = m : u.sibling = m, u = m);
                    return t1 && h.forEach(function(t1) {
                        return e(r, t1);
                    }), c;
                }
                function m(r, o, l, c) {
                    var u = Q(l);
                    if ("function" != typeof u) throw Error(s(150));
                    if (null == (l = u.call(l))) throw Error(s(151));
                    for(var h = u = null, f = o, m = o = 0, g = null, M = l.next(); null !== f && !M.done; m++, M = l.next()){
                        f.index > m ? (g = f, f = null) : g = f.sibling;
                        var v = p(r, f, M.value, c);
                        if (null === v) {
                            null === f && (f = g);
                            break;
                        }
                        t1 && f && null === v.alternate && e(r, f), o = a(v, o, m), null === h ? u = v : h.sibling = v, h = v, f = g;
                    }
                    if (M.done) return i(r, f), u;
                    if (null === f) {
                        for(; !M.done; m++, M = l.next())null !== (M = d(r, M.value, c)) && (o = a(M, o, m), null === h ? u = M : h.sibling = M, h = M);
                        return u;
                    }
                    for(f = n(r, f); !M.done; m++, M = l.next())null !== (M = A(f, r, m, M.value, c)) && (t1 && null !== M.alternate && f.delete(null === M.key ? m : M.key), o = a(M, o, m), null === h ? u = M : h.sibling = M, h = M);
                    return t1 && f.forEach(function(t1) {
                        return e(r, t1);
                    }), u;
                }
                return function(t1, n, a, l) {
                    var c = "object" == typeof a && null !== a && a.type === T && null === a.key;
                    c && (a = a.props.children);
                    var u = "object" == typeof a && null !== a;
                    if (u) switch(a.$$typeof){
                        case w:
                            t: {
                                for(u = a.key, c = n; null !== c;){
                                    if (c.key === u) {
                                        if (7 === c.tag) {
                                            if (a.type === T) {
                                                i(t1, c.sibling), (n = r(c, a.props.children)).return = t1, t1 = n;
                                                break t;
                                            }
                                        } else if (c.elementType === a.type) {
                                            i(t1, c.sibling), (n = r(c, a.props)).ref = wa(t1, c, a), n.return = t1, t1 = n;
                                            break t;
                                        }
                                        i(t1, c);
                                        break;
                                    }
                                    e(t1, c), c = c.sibling;
                                }
                                a.type === T ? ((n = Wl(a.props.children, t1.mode, l, a.key)).return = t1, t1 = n) : ((l = Gl(a.type, a.key, a.props, null, t1.mode, l)).ref = wa(t1, n, a), l.return = t1, t1 = l);
                            }
                            return o(t1);
                        case b:
                            t: {
                                for(c = a.key; null !== n;){
                                    if (n.key === c) {
                                        if (4 === n.tag && n.stateNode.containerInfo === a.containerInfo && n.stateNode.implementation === a.implementation) {
                                            i(t1, n.sibling), (n = r(n, a.children || [])).return = t1, t1 = n;
                                            break t;
                                        }
                                        i(t1, n);
                                        break;
                                    }
                                    e(t1, n), n = n.sibling;
                                }
                                (n = Zl(a, t1.mode, l)).return = t1, t1 = n;
                            }
                            return o(t1);
                    }
                    if ("string" == typeof a || "number" == typeof a) return a = "" + a, null !== n && 6 === n.tag ? (i(t1, n.sibling), (n = r(n, a)).return = t1, t1 = n) : (i(t1, n), (n = Xl(a, t1.mode, l)).return = t1, t1 = n), o(t1);
                    if (xa(a)) return f(t1, n, a, l);
                    if (Q(a)) return m(t1, n, a, l);
                    if (u && ba(t1, a), void 0 === a && !c) switch(t1.tag){
                        case 1:
                        case 22:
                        case 0:
                        case 11:
                        case 15:
                            throw Error(s(152, Y(t1.type) || "Component"));
                    }
                    return i(t1, n);
                };
            }
            var Ea = Ta(!0), _a = Ta(!1), Ia = {}, Sa = lr(Ia), Na = lr(Ia), Da = lr(Ia);
            function Ca(t1) {
                if (t1 === Ia) throw Error(s(174));
                return t1;
            }
            function za(t1, e) {
                switch(ur(Da, e), ur(Na, t1), ur(Sa, Ia), t1 = e.nodeType){
                    case 9:
                    case 11:
                        e = (e = e.documentElement) ? e.namespaceURI : pt(null, "");
                        break;
                    default:
                        e = pt(e = (t1 = 8 === t1 ? e.parentNode : e).namespaceURI || null, t1 = t1.tagName);
                }
                cr(Sa), ur(Sa, e);
            }
            function La() {
                cr(Sa), cr(Na), cr(Da);
            }
            function Oa(t1) {
                Ca(Da.current);
                var e = Ca(Sa.current), i = pt(e, t1.type);
                e !== i && (ur(Na, t1), ur(Sa, i));
            }
            function Pa(t1) {
                Na.current === t1 && (cr(Sa), cr(Na));
            }
            var ja = lr(0);
            function Ra(t1) {
                for(var e = t1; null !== e;){
                    if (13 === e.tag) {
                        var i = e.memoizedState;
                        if (null !== i && (null === (i = i.dehydrated) || "$?" === i.data || "$!" === i.data)) return e;
                    } else if (19 === e.tag && void 0 !== e.memoizedProps.revealOrder) {
                        if (64 & e.flags) return e;
                    } else if (null !== e.child) {
                        e.child.return = e, e = e.child;
                        continue;
                    }
                    if (e === t1) break;
                    for(; null === e.sibling;){
                        if (null === e.return || e.return === t1) return null;
                        e = e.return;
                    }
                    e.sibling.return = e.return, e = e.sibling;
                }
                return null;
            }
            var ka = null, Ua = null, Ba = !1;
            function Fa(t1, e) {
                var i = Ql(5, null, null, 0);
                i.elementType = "DELETED", i.type = "DELETED", i.stateNode = e, i.return = t1, i.flags = 8, null !== t1.lastEffect ? (t1.lastEffect.nextEffect = i, t1.lastEffect = i) : t1.firstEffect = t1.lastEffect = i;
            }
            function Qa(t1, e) {
                switch(t1.tag){
                    case 5:
                        var i = t1.type;
                        return null !== (e = 1 !== e.nodeType || i.toLowerCase() !== e.nodeName.toLowerCase() ? null : e) && (t1.stateNode = e, !0);
                    case 6:
                        return null !== (e = "" === t1.pendingProps || 3 !== e.nodeType ? null : e) && (t1.stateNode = e, !0);
                    default:
                        return !1;
                }
            }
            function Ha(t1) {
                if (Ba) {
                    var e = Ua;
                    if (e) {
                        var i = e;
                        if (!Qa(t1, e)) {
                            if (!(e = Yn(i.nextSibling)) || !Qa(t1, e)) return t1.flags = -1025 & t1.flags | 2, Ba = !1, void (ka = t1);
                            Fa(ka, i);
                        }
                        ka = t1, Ua = Yn(e.firstChild);
                    } else t1.flags = -1025 & t1.flags | 2, Ba = !1, ka = t1;
                }
            }
            function Va(t1) {
                for(t1 = t1.return; null !== t1 && 5 !== t1.tag && 3 !== t1.tag && 13 !== t1.tag;)t1 = t1.return;
                ka = t1;
            }
            function Ga(t1) {
                if (t1 !== ka) return !1;
                if (!Ba) return Va(t1), Ba = !0, !1;
                var e = t1.type;
                if (5 !== t1.tag || "head" !== e && "body" !== e && !Hn(e, t1.memoizedProps)) for(e = Ua; e;)Fa(t1, e), e = Yn(e.nextSibling);
                if (Va(t1), 13 === t1.tag) {
                    if (!(t1 = null !== (t1 = t1.memoizedState) ? t1.dehydrated : null)) throw Error(s(317));
                    t: {
                        for(t1 = t1.nextSibling, e = 0; t1;){
                            if (8 === t1.nodeType) {
                                var i = t1.data;
                                if ("/$" === i) {
                                    if (0 === e) {
                                        Ua = Yn(t1.nextSibling);
                                        break t;
                                    }
                                    e--;
                                } else "$" !== i && "$!" !== i && "$?" !== i || e++;
                            }
                            t1 = t1.nextSibling;
                        }
                        Ua = null;
                    }
                } else Ua = ka ? Yn(t1.stateNode.nextSibling) : null;
                return !0;
            }
            function Wa() {
                Ua = ka = null, Ba = !1;
            }
            var Ya = [];
            function Xa() {
                for(var t1 = 0; t1 < Ya.length; t1++)Ya[t1]._workInProgressVersionPrimary = null;
                Ya.length = 0;
            }
            var Za = x.ReactCurrentDispatcher, qa = x.ReactCurrentBatchConfig, Ja = 0, Ka = null, $a = null, ts = null, es = !1, is = !1;
            function ns() {
                throw Error(s(321));
            }
            function rs(t1, e) {
                if (null === e) return !1;
                for(var i = 0; i < e.length && i < t1.length; i++)if (!cn(t1[i], e[i])) return !1;
                return !0;
            }
            function as(t1, e, i, n, r, a) {
                if (Ja = a, Ka = e, e.memoizedState = null, e.updateQueue = null, e.lanes = 0, Za.current = null === t1 || null === t1.memoizedState ? Cs : zs, t1 = i(n, r), is) {
                    a = 0;
                    do {
                        if (is = !1, !(25 > a)) throw Error(s(301));
                        a += 1, ts = $a = null, e.updateQueue = null, Za.current = Ls, t1 = i(n, r);
                    }while (is);
                }
                if (Za.current = Ds, e = null !== $a && null !== $a.next, Ja = 0, ts = $a = Ka = null, es = !1, e) throw Error(s(300));
                return t1;
            }
            function ss() {
                var t1 = {
                    memoizedState: null,
                    baseState: null,
                    baseQueue: null,
                    queue: null,
                    next: null
                };
                return null === ts ? Ka.memoizedState = ts = t1 : ts = ts.next = t1, ts;
            }
            function os() {
                if (null === $a) {
                    var t1 = Ka.alternate;
                    t1 = null !== t1 ? t1.memoizedState : null;
                } else t1 = $a.next;
                var e = null === ts ? Ka.memoizedState : ts.next;
                if (null !== e) ts = e, $a = t1;
                else {
                    if (null === t1) throw Error(s(310));
                    t1 = {
                        memoizedState: ($a = t1).memoizedState,
                        baseState: $a.baseState,
                        baseQueue: $a.baseQueue,
                        queue: $a.queue,
                        next: null
                    }, null === ts ? Ka.memoizedState = ts = t1 : ts = ts.next = t1;
                }
                return ts;
            }
            function ls(t1, e) {
                return "function" == typeof e ? e(t1) : e;
            }
            function cs(t1) {
                var e = os(), i = e.queue;
                if (null === i) throw Error(s(311));
                i.lastRenderedReducer = t1;
                var n = $a, r = n.baseQueue, a = i.pending;
                if (null !== a) {
                    if (null !== r) {
                        var o = r.next;
                        r.next = a.next, a.next = o;
                    }
                    n.baseQueue = r = a, i.pending = null;
                }
                if (null !== r) {
                    r = r.next, n = n.baseState;
                    var l = o = a = null, c = r;
                    do {
                        var u = c.lane;
                        if ((Ja & u) === u) null !== l && (l = l.next = {
                            lane: 0,
                            action: c.action,
                            eagerReducer: c.eagerReducer,
                            eagerState: c.eagerState,
                            next: null
                        }), n = c.eagerReducer === t1 ? c.eagerState : t1(n, c.action);
                        else {
                            var h = {
                                lane: u,
                                action: c.action,
                                eagerReducer: c.eagerReducer,
                                eagerState: c.eagerState,
                                next: null
                            };
                            null === l ? (o = l = h, a = n) : l = l.next = h, Ka.lanes |= u, Uo |= u;
                        }
                        c = c.next;
                    }while (null !== c && c !== r);
                    null === l ? a = n : l.next = o, cn(n, e.memoizedState) || (Ps = !0), e.memoizedState = n, e.baseState = a, e.baseQueue = l, i.lastRenderedState = n;
                }
                return [
                    e.memoizedState,
                    i.dispatch
                ];
            }
            function us(t1) {
                var e = os(), i = e.queue;
                if (null === i) throw Error(s(311));
                i.lastRenderedReducer = t1;
                var n = i.dispatch, r = i.pending, a = e.memoizedState;
                if (null !== r) {
                    i.pending = null;
                    var o = r = r.next;
                    do a = t1(a, o.action), o = o.next;
                    while (o !== r);
                    cn(a, e.memoizedState) || (Ps = !0), e.memoizedState = a, null === e.baseQueue && (e.baseState = a), i.lastRenderedState = a;
                }
                return [
                    a,
                    n
                ];
            }
            function hs(t1, e, i) {
                var n = e._getVersion;
                n = n(e._source);
                var r = e._workInProgressVersionPrimary;
                if (null !== r ? t1 = r === n : (t1 = t1.mutableReadLanes, (t1 = (Ja & t1) === t1) && (e._workInProgressVersionPrimary = n, Ya.push(e))), t1) return i(e._source);
                throw Ya.push(e), Error(s(350));
            }
            function ds(t1, e, i, n) {
                var r = Co;
                if (null === r) throw Error(s(349));
                var a = e._getVersion, o = a(e._source), l = Za.current, c = l.useState(function() {
                    return hs(r, e, i);
                }), u = c[1], h = c[0];
                c = ts;
                var d = t1.memoizedState, p = d.refs, A = p.getSnapshot, f = d.source;
                d = d.subscribe;
                var m = Ka;
                return t1.memoizedState = {
                    refs: p,
                    source: e,
                    subscribe: n
                }, l.useEffect(function() {
                    p.getSnapshot = i, p.setSnapshot = u;
                    var t1 = a(e._source);
                    if (!cn(o, t1)) {
                        t1 = i(e._source), cn(h, t1) || (u(t1), t1 = hl(m), r.mutableReadLanes |= t1 & r.pendingLanes), t1 = r.mutableReadLanes, r.entangledLanes |= t1;
                        for(var n = r.entanglements, s = t1; 0 < s;){
                            var l = 31 - He(s), c = 1 << l;
                            n[l] |= t1, s &= ~c;
                        }
                    }
                }, [
                    i,
                    e,
                    n
                ]), l.useEffect(function() {
                    return n(e._source, function() {
                        var t1 = p.getSnapshot, i = p.setSnapshot;
                        try {
                            i(t1(e._source));
                            var n = hl(m);
                            r.mutableReadLanes |= n & r.pendingLanes;
                        } catch (t1) {
                            i(function() {
                                throw t1;
                            });
                        }
                    });
                }, [
                    e,
                    n
                ]), cn(A, i) && cn(f, e) && cn(d, n) || ((t1 = {
                    pending: null,
                    dispatch: null,
                    lastRenderedReducer: ls,
                    lastRenderedState: h
                }).dispatch = u = Ns.bind(null, Ka, t1), c.queue = t1, c.baseQueue = null, h = hs(r, e, i), c.memoizedState = c.baseState = h), h;
            }
            function ps(t1, e, i) {
                return ds(os(), t1, e, i);
            }
            function As(t1) {
                var e = ss();
                return "function" == typeof t1 && (t1 = t1()), e.memoizedState = e.baseState = t1, t1 = (t1 = e.queue = {
                    pending: null,
                    dispatch: null,
                    lastRenderedReducer: ls,
                    lastRenderedState: t1
                }).dispatch = Ns.bind(null, Ka, t1), [
                    e.memoizedState,
                    t1
                ];
            }
            function fs(t1, e, i, n) {
                return t1 = {
                    tag: t1,
                    create: e,
                    destroy: i,
                    deps: n,
                    next: null
                }, null === (e = Ka.updateQueue) ? (e = {
                    lastEffect: null
                }, Ka.updateQueue = e, e.lastEffect = t1.next = t1) : null === (i = e.lastEffect) ? e.lastEffect = t1.next = t1 : (n = i.next, i.next = t1, t1.next = n, e.lastEffect = t1), t1;
            }
            function ms(t1) {
                return t1 = {
                    current: t1
                }, ss().memoizedState = t1;
            }
            function gs() {
                return os().memoizedState;
            }
            function Ms(t1, e, i, n) {
                var r = ss();
                Ka.flags |= t1, r.memoizedState = fs(1 | e, i, void 0, void 0 === n ? null : n);
            }
            function vs(t1, e, i, n) {
                var r = os();
                n = void 0 === n ? null : n;
                var a = void 0;
                if (null !== $a) {
                    var s = $a.memoizedState;
                    if (a = s.destroy, null !== n && rs(n, s.deps)) return void fs(e, i, a, n);
                }
                Ka.flags |= t1, r.memoizedState = fs(1 | e, i, a, n);
            }
            function ys(t1, e) {
                return Ms(516, 4, t1, e);
            }
            function xs(t1, e) {
                return vs(516, 4, t1, e);
            }
            function ws(t1, e) {
                return vs(4, 2, t1, e);
            }
            function bs(t1, e) {
                return "function" == typeof e ? (t1 = t1(), e(t1), function() {
                    e(null);
                }) : null != e ? (t1 = t1(), e.current = t1, function() {
                    e.current = null;
                }) : void 0;
            }
            function Ts(t1, e, i) {
                return i = null != i ? i.concat([
                    t1
                ]) : null, vs(4, 2, bs.bind(null, e, t1), i);
            }
            function Es() {}
            function _s(t1, e) {
                var i = os();
                e = void 0 === e ? null : e;
                var n = i.memoizedState;
                return null !== n && null !== e && rs(e, n[1]) ? n[0] : (i.memoizedState = [
                    t1,
                    e
                ], t1);
            }
            function Is(t1, e) {
                var i = os();
                e = void 0 === e ? null : e;
                var n = i.memoizedState;
                return null !== n && null !== e && rs(e, n[1]) ? n[0] : (t1 = t1(), i.memoizedState = [
                    t1,
                    e
                ], t1);
            }
            function Ss(t1, e) {
                var i = Hr();
                Gr(98 > i ? 98 : i, function() {
                    t1(!0);
                }), Gr(97 < i ? 97 : i, function() {
                    var i = qa.transition;
                    qa.transition = 1;
                    try {
                        t1(!1), e();
                    } finally{
                        qa.transition = i;
                    }
                });
            }
            function Ns(t1, e, i) {
                var n = ul(), r = hl(t1), a = {
                    lane: r,
                    action: i,
                    eagerReducer: null,
                    eagerState: null,
                    next: null
                }, s = e.pending;
                if (null === s ? a.next = a : (a.next = s.next, s.next = a), e.pending = a, s = t1.alternate, t1 === Ka || null !== s && s === Ka) is = es = !0;
                else {
                    if (0 === t1.lanes && (null === s || 0 === s.lanes) && null !== (s = e.lastRenderedReducer)) try {
                        var o = e.lastRenderedState, l = s(o, i);
                        if (a.eagerReducer = s, a.eagerState = l, cn(l, o)) return;
                    } catch (t1) {}
                    dl(t1, r, n);
                }
            }
            var Ds = {
                readContext: aa,
                useCallback: ns,
                useContext: ns,
                useEffect: ns,
                useImperativeHandle: ns,
                useLayoutEffect: ns,
                useMemo: ns,
                useReducer: ns,
                useRef: ns,
                useState: ns,
                useDebugValue: ns,
                useDeferredValue: ns,
                useTransition: ns,
                useMutableSource: ns,
                useOpaqueIdentifier: ns,
                unstable_isNewReconciler: !1
            }, Cs = {
                readContext: aa,
                useCallback: function(t1, e) {
                    return ss().memoizedState = [
                        t1,
                        void 0 === e ? null : e
                    ], t1;
                },
                useContext: aa,
                useEffect: ys,
                useImperativeHandle: function(t1, e, i) {
                    return i = null != i ? i.concat([
                        t1
                    ]) : null, Ms(4, 2, bs.bind(null, e, t1), i);
                },
                useLayoutEffect: function(t1, e) {
                    return Ms(4, 2, t1, e);
                },
                useMemo: function(t1, e) {
                    var i = ss();
                    return e = void 0 === e ? null : e, t1 = t1(), i.memoizedState = [
                        t1,
                        e
                    ], t1;
                },
                useReducer: function(t1, e, i) {
                    var n = ss();
                    return e = void 0 !== i ? i(e) : e, n.memoizedState = n.baseState = e, t1 = (t1 = n.queue = {
                        pending: null,
                        dispatch: null,
                        lastRenderedReducer: t1,
                        lastRenderedState: e
                    }).dispatch = Ns.bind(null, Ka, t1), [
                        n.memoizedState,
                        t1
                    ];
                },
                useRef: ms,
                useState: As,
                useDebugValue: Es,
                useDeferredValue: function(t1) {
                    var e = As(t1), i = e[0], n = e[1];
                    return ys(function() {
                        var e = qa.transition;
                        qa.transition = 1;
                        try {
                            n(t1);
                        } finally{
                            qa.transition = e;
                        }
                    }, [
                        t1
                    ]), i;
                },
                useTransition: function() {
                    var t1 = As(!1), e = t1[0];
                    return ms(t1 = Ss.bind(null, t1[1])), [
                        t1,
                        e
                    ];
                },
                useMutableSource: function(t1, e, i) {
                    var n = ss();
                    return n.memoizedState = {
                        refs: {
                            getSnapshot: e,
                            setSnapshot: null
                        },
                        source: t1,
                        subscribe: i
                    }, ds(n, t1, e, i);
                },
                useOpaqueIdentifier: function() {
                    if (Ba) {
                        var t1 = !1, e = function(t1) {
                            return {
                                $$typeof: P,
                                toString: t1,
                                valueOf: t1
                            };
                        }(function() {
                            throw t1 || (t1 = !0, i("r:" + (Zn++).toString(36))), Error(s(355));
                        }), i = As(e)[1];
                        return !(2 & Ka.mode) && (Ka.flags |= 516, fs(5, function() {
                            i("r:" + (Zn++).toString(36));
                        }, void 0, null)), e;
                    }
                    return As(e = "r:" + (Zn++).toString(36)), e;
                },
                unstable_isNewReconciler: !1
            }, zs = {
                readContext: aa,
                useCallback: _s,
                useContext: aa,
                useEffect: xs,
                useImperativeHandle: Ts,
                useLayoutEffect: ws,
                useMemo: Is,
                useReducer: cs,
                useRef: gs,
                useState: function() {
                    return cs(ls);
                },
                useDebugValue: Es,
                useDeferredValue: function(t1) {
                    var e = cs(ls), i = e[0], n = e[1];
                    return xs(function() {
                        var e = qa.transition;
                        qa.transition = 1;
                        try {
                            n(t1);
                        } finally{
                            qa.transition = e;
                        }
                    }, [
                        t1
                    ]), i;
                },
                useTransition: function() {
                    var t1 = cs(ls)[0];
                    return [
                        gs().current,
                        t1
                    ];
                },
                useMutableSource: ps,
                useOpaqueIdentifier: function() {
                    return cs(ls)[0];
                },
                unstable_isNewReconciler: !1
            }, Ls = {
                readContext: aa,
                useCallback: _s,
                useContext: aa,
                useEffect: xs,
                useImperativeHandle: Ts,
                useLayoutEffect: ws,
                useMemo: Is,
                useReducer: us,
                useRef: gs,
                useState: function() {
                    return us(ls);
                },
                useDebugValue: Es,
                useDeferredValue: function(t1) {
                    var e = us(ls), i = e[0], n = e[1];
                    return xs(function() {
                        var e = qa.transition;
                        qa.transition = 1;
                        try {
                            n(t1);
                        } finally{
                            qa.transition = e;
                        }
                    }, [
                        t1
                    ]), i;
                },
                useTransition: function() {
                    var t1 = us(ls)[0];
                    return [
                        gs().current,
                        t1
                    ];
                },
                useMutableSource: ps,
                useOpaqueIdentifier: function() {
                    return us(ls)[0];
                },
                unstable_isNewReconciler: !1
            }, Os = x.ReactCurrentOwner, Ps = !1;
            function js(t1, e, i, n) {
                e.child = null === t1 ? _a(e, null, i, n) : Ea(e, t1.child, i, n);
            }
            function Rs(t1, e, i, n, r) {
                i = i.render;
                var a = e.ref;
                return ra(e, r), n = as(t1, e, i, n, a, r), null === t1 || Ps ? (e.flags |= 1, js(t1, e, n, r), e.child) : (e.updateQueue = t1.updateQueue, e.flags &= -517, t1.lanes &= ~r, io(t1, e, r));
            }
            function ks(t1, e, i, n, r, a) {
                if (null === t1) {
                    var s = i.type;
                    return "function" != typeof s || Hl(s) || void 0 !== s.defaultProps || null !== i.compare || void 0 !== i.defaultProps ? ((t1 = Gl(i.type, null, n, e, e.mode, a)).ref = e.ref, t1.return = e, e.child = t1) : (e.tag = 15, e.type = s, Us(t1, e, s, n, r, a));
                }
                return s = t1.child, r & a || (r = s.memoizedProps, !(i = null !== (i = i.compare) ? i : hn)(r, n) || t1.ref !== e.ref) ? (e.flags |= 1, (t1 = Vl(s, n)).ref = e.ref, t1.return = e, e.child = t1) : io(t1, e, a);
            }
            function Us(t1, e, i, n, r, a) {
                if (null !== t1 && hn(t1.memoizedProps, n) && t1.ref === e.ref) {
                    if (Ps = !1, !(a & r)) return e.lanes = t1.lanes, io(t1, e, a);
                    16384 & t1.flags && (Ps = !0);
                }
                return Qs(t1, e, i, n, a);
            }
            function Bs(t1, e, i) {
                var n = e.pendingProps, r = n.children, a = null !== t1 ? t1.memoizedState : null;
                if ("hidden" === n.mode || "unstable-defer-without-hiding" === n.mode) {
                    if (4 & e.mode) {
                        if (!(1073741824 & i)) return t1 = null !== a ? a.baseLanes | i : i, e.lanes = e.childLanes = 1073741824, e.memoizedState = {
                            baseLanes: t1
                        }, yl(0, t1), null;
                        e.memoizedState = {
                            baseLanes: 0
                        }, yl(0, null !== a ? a.baseLanes : i);
                    } else e.memoizedState = {
                        baseLanes: 0
                    }, yl(0, i);
                } else null !== a ? (n = a.baseLanes | i, e.memoizedState = null) : n = i, yl(0, n);
                return js(t1, e, r, i), e.child;
            }
            function Fs(t1, e) {
                var i = e.ref;
                (null === t1 && null !== i || null !== t1 && t1.ref !== i) && (e.flags |= 128);
            }
            function Qs(t1, e, i, n, r) {
                var a = mr(i) ? Ar : dr.current;
                return a = fr(e, a), ra(e, r), i = as(t1, e, i, n, a, r), null === t1 || Ps ? (e.flags |= 1, js(t1, e, i, r), e.child) : (e.updateQueue = t1.updateQueue, e.flags &= -517, t1.lanes &= ~r, io(t1, e, r));
            }
            function Hs(t1, e, i, n, r) {
                if (mr(i)) {
                    var a = !0;
                    yr(e);
                } else a = !1;
                if (ra(e, r), null === e.stateNode) null !== t1 && (t1.alternate = null, e.alternate = null, e.flags |= 2), Ma(e, i, n), ya(e, i, n, r), n = !0;
                else if (null === t1) {
                    var s = e.stateNode, o = e.memoizedProps;
                    s.props = o;
                    var l = s.context, c = i.contextType;
                    c = "object" == typeof c && null !== c ? aa(c) : fr(e, c = mr(i) ? Ar : dr.current);
                    var u = i.getDerivedStateFromProps, h = "function" == typeof u || "function" == typeof s.getSnapshotBeforeUpdate;
                    h || "function" != typeof s.UNSAFE_componentWillReceiveProps && "function" != typeof s.componentWillReceiveProps || (o !== n || l !== c) && va(e, s, n, c), sa = !1;
                    var d = e.memoizedState;
                    s.state = d, da(e, n, s, r), l = e.memoizedState, o !== n || d !== l || pr.current || sa ? ("function" == typeof u && (fa(e, i, u, n), l = e.memoizedState), (o = sa || ga(e, i, o, n, d, l, c)) ? (h || "function" != typeof s.UNSAFE_componentWillMount && "function" != typeof s.componentWillMount || ("function" == typeof s.componentWillMount && s.componentWillMount(), "function" == typeof s.UNSAFE_componentWillMount && s.UNSAFE_componentWillMount()), "function" == typeof s.componentDidMount && (e.flags |= 4)) : ("function" == typeof s.componentDidMount && (e.flags |= 4), e.memoizedProps = n, e.memoizedState = l), s.props = n, s.state = l, s.context = c, n = o) : ("function" == typeof s.componentDidMount && (e.flags |= 4), n = !1);
                } else {
                    s = e.stateNode, la(t1, e), o = e.memoizedProps, c = e.type === e.elementType ? o : qr(e.type, o), s.props = c, h = e.pendingProps, d = s.context, l = "object" == typeof (l = i.contextType) && null !== l ? aa(l) : fr(e, l = mr(i) ? Ar : dr.current);
                    var p = i.getDerivedStateFromProps;
                    (u = "function" == typeof p || "function" == typeof s.getSnapshotBeforeUpdate) || "function" != typeof s.UNSAFE_componentWillReceiveProps && "function" != typeof s.componentWillReceiveProps || (o !== h || d !== l) && va(e, s, n, l), sa = !1, d = e.memoizedState, s.state = d, da(e, n, s, r);
                    var A = e.memoizedState;
                    o !== h || d !== A || pr.current || sa ? ("function" == typeof p && (fa(e, i, p, n), A = e.memoizedState), (c = sa || ga(e, i, c, n, d, A, l)) ? (u || "function" != typeof s.UNSAFE_componentWillUpdate && "function" != typeof s.componentWillUpdate || ("function" == typeof s.componentWillUpdate && s.componentWillUpdate(n, A, l), "function" == typeof s.UNSAFE_componentWillUpdate && s.UNSAFE_componentWillUpdate(n, A, l)), "function" == typeof s.componentDidUpdate && (e.flags |= 4), "function" == typeof s.getSnapshotBeforeUpdate && (e.flags |= 256)) : ("function" != typeof s.componentDidUpdate || o === t1.memoizedProps && d === t1.memoizedState || (e.flags |= 4), "function" != typeof s.getSnapshotBeforeUpdate || o === t1.memoizedProps && d === t1.memoizedState || (e.flags |= 256), e.memoizedProps = n, e.memoizedState = A), s.props = n, s.state = A, s.context = l, n = c) : ("function" != typeof s.componentDidUpdate || o === t1.memoizedProps && d === t1.memoizedState || (e.flags |= 4), "function" != typeof s.getSnapshotBeforeUpdate || o === t1.memoizedProps && d === t1.memoizedState || (e.flags |= 256), n = !1);
                }
                return Vs(t1, e, i, n, a, r);
            }
            function Vs(t1, e, i, n, r, a) {
                Fs(t1, e);
                var s = !!(64 & e.flags);
                if (!n && !s) return r && xr(e, i, !1), io(t1, e, a);
                n = e.stateNode, Os.current = e;
                var o = s && "function" != typeof i.getDerivedStateFromError ? null : n.render();
                return e.flags |= 1, null !== t1 && s ? (e.child = Ea(e, t1.child, null, a), e.child = Ea(e, null, o, a)) : js(t1, e, o, a), e.memoizedState = n.state, r && xr(e, i, !0), e.child;
            }
            function Gs(t1) {
                var e = t1.stateNode;
                e.pendingContext ? Mr(0, e.pendingContext, e.pendingContext !== e.context) : e.context && Mr(0, e.context, !1), za(t1, e.containerInfo);
            }
            var Ws, Ys, Xs, Zs, qs = {
                dehydrated: null,
                retryLane: 0
            };
            function Js(t1, e, i) {
                var n, r = e.pendingProps, a = ja.current, s = !1;
                return (n = !!(64 & e.flags)) || (n = (null === t1 || null !== t1.memoizedState) && !!(2 & a)), n ? (s = !0, e.flags &= -65) : null !== t1 && null === t1.memoizedState || void 0 === r.fallback || !0 === r.unstable_avoidThisFallback || (a |= 1), ur(ja, 1 & a), null === t1 ? (void 0 !== r.fallback && Ha(e), t1 = r.children, a = r.fallback, s ? (t1 = Ks(e, t1, a, i), e.child.memoizedState = {
                    baseLanes: i
                }, e.memoizedState = qs, t1) : "number" == typeof r.unstable_expectedLoadTime ? (t1 = Ks(e, t1, a, i), e.child.memoizedState = {
                    baseLanes: i
                }, e.memoizedState = qs, e.lanes = 33554432, t1) : ((i = Yl({
                    mode: "visible",
                    children: t1
                }, e.mode, i, null)).return = e, e.child = i)) : (t1.memoizedState, s ? (r = function(t1, e, i, n, r) {
                    var a = e.mode, s = t1.child;
                    t1 = s.sibling;
                    var o = {
                        mode: "hidden",
                        children: i
                    };
                    return 2 & a || e.child === s ? i = Vl(s, o) : ((i = e.child).childLanes = 0, i.pendingProps = o, null !== (s = i.lastEffect) ? (e.firstEffect = i.firstEffect, e.lastEffect = s, s.nextEffect = null) : e.firstEffect = e.lastEffect = null), null !== t1 ? n = Vl(t1, n) : (n = Wl(n, a, r, null)).flags |= 2, n.return = e, i.return = e, i.sibling = n, e.child = i, n;
                }(t1, e, r.children, r.fallback, i), s = e.child, a = t1.child.memoizedState, s.memoizedState = null === a ? {
                    baseLanes: i
                } : {
                    baseLanes: a.baseLanes | i
                }, s.childLanes = t1.childLanes & ~i, e.memoizedState = qs, r) : (i = function(t1, e, i, n) {
                    var r = t1.child;
                    return t1 = r.sibling, i = Vl(r, {
                        mode: "visible",
                        children: i
                    }), !(2 & e.mode) && (i.lanes = n), i.return = e, i.sibling = null, null !== t1 && (t1.nextEffect = null, t1.flags = 8, e.firstEffect = e.lastEffect = t1), e.child = i;
                }(t1, e, r.children, i), e.memoizedState = null, i));
            }
            function Ks(t1, e, i, n) {
                var r = t1.mode, a = t1.child;
                return e = {
                    mode: "hidden",
                    children: e
                }, 2 & r || null === a ? a = Yl(e, r, 0, null) : (a.childLanes = 0, a.pendingProps = e), i = Wl(i, r, n, null), a.return = t1, i.return = t1, a.sibling = i, t1.child = a, i;
            }
            function $s(t1, e) {
                t1.lanes |= e;
                var i = t1.alternate;
                null !== i && (i.lanes |= e), na(t1.return, e);
            }
            function to(t1, e, i, n, r, a) {
                var s = t1.memoizedState;
                null === s ? t1.memoizedState = {
                    isBackwards: e,
                    rendering: null,
                    renderingStartTime: 0,
                    last: n,
                    tail: i,
                    tailMode: r,
                    lastEffect: a
                } : (s.isBackwards = e, s.rendering = null, s.renderingStartTime = 0, s.last = n, s.tail = i, s.tailMode = r, s.lastEffect = a);
            }
            function eo(t1, e, i) {
                var n = e.pendingProps, r = n.revealOrder, a = n.tail;
                if (js(t1, e, n.children, i), 2 & (n = ja.current)) n = 1 & n | 2, e.flags |= 64;
                else {
                    if (null !== t1 && 64 & t1.flags) t: for(t1 = e.child; null !== t1;){
                        if (13 === t1.tag) null !== t1.memoizedState && $s(t1, i);
                        else if (19 === t1.tag) $s(t1, i);
                        else if (null !== t1.child) {
                            t1.child.return = t1, t1 = t1.child;
                            continue;
                        }
                        if (t1 === e) break t;
                        for(; null === t1.sibling;){
                            if (null === t1.return || t1.return === e) break t;
                            t1 = t1.return;
                        }
                        t1.sibling.return = t1.return, t1 = t1.sibling;
                    }
                    n &= 1;
                }
                if (ur(ja, n), 2 & e.mode) switch(r){
                    case "forwards":
                        for(i = e.child, r = null; null !== i;)null !== (t1 = i.alternate) && null === Ra(t1) && (r = i), i = i.sibling;
                        null === (i = r) ? (r = e.child, e.child = null) : (r = i.sibling, i.sibling = null), to(e, !1, r, i, a, e.lastEffect);
                        break;
                    case "backwards":
                        for(i = null, r = e.child, e.child = null; null !== r;){
                            if (null !== (t1 = r.alternate) && null === Ra(t1)) {
                                e.child = r;
                                break;
                            }
                            t1 = r.sibling, r.sibling = i, i = r, r = t1;
                        }
                        to(e, !0, i, null, a, e.lastEffect);
                        break;
                    case "together":
                        to(e, !1, null, null, void 0, e.lastEffect);
                        break;
                    default:
                        e.memoizedState = null;
                }
                else e.memoizedState = null;
                return e.child;
            }
            function io(t1, e, i) {
                if (null !== t1 && (e.dependencies = t1.dependencies), Uo |= e.lanes, i & e.childLanes) {
                    if (null !== t1 && e.child !== t1.child) throw Error(s(153));
                    if (null !== e.child) {
                        for(i = Vl(t1 = e.child, t1.pendingProps), e.child = i, i.return = e; null !== t1.sibling;)t1 = t1.sibling, (i = i.sibling = Vl(t1, t1.pendingProps)).return = e;
                        i.sibling = null;
                    }
                    return e.child;
                }
                return null;
            }
            function no(t1, e) {
                if (!Ba) switch(t1.tailMode){
                    case "hidden":
                        e = t1.tail;
                        for(var i = null; null !== e;)null !== e.alternate && (i = e), e = e.sibling;
                        null === i ? t1.tail = null : i.sibling = null;
                        break;
                    case "collapsed":
                        i = t1.tail;
                        for(var n = null; null !== i;)null !== i.alternate && (n = i), i = i.sibling;
                        null === n ? e || null === t1.tail ? t1.tail = null : t1.tail.sibling = null : n.sibling = null;
                }
            }
            function ro(t1, e, i) {
                var n = e.pendingProps;
                switch(e.tag){
                    case 2:
                    case 16:
                    case 15:
                    case 0:
                    case 11:
                    case 7:
                    case 8:
                    case 12:
                    case 9:
                    case 14:
                        return null;
                    case 1:
                    case 17:
                        return mr(e.type) && gr(), null;
                    case 3:
                        return La(), cr(pr), cr(dr), Xa(), (n = e.stateNode).pendingContext && (n.context = n.pendingContext, n.pendingContext = null), null !== t1 && null !== t1.child || (Ga(e) ? e.flags |= 4 : n.hydrate || (e.flags |= 256)), Ys(e), null;
                    case 5:
                        Pa(e);
                        var a = Ca(Da.current);
                        if (i = e.type, null !== t1 && null != e.stateNode) Xs(t1, e, i, n, a), t1.ref !== e.ref && (e.flags |= 128);
                        else {
                            if (!n) {
                                if (null === e.stateNode) throw Error(s(166));
                                return null;
                            }
                            if (t1 = Ca(Sa.current), Ga(e)) {
                                n = e.stateNode, i = e.type;
                                var o = e.memoizedProps;
                                switch(n[Jn] = e, n[Kn] = o, i){
                                    case "dialog":
                                        Nn("cancel", n), Nn("close", n);
                                        break;
                                    case "iframe":
                                    case "object":
                                    case "embed":
                                        Nn("load", n);
                                        break;
                                    case "video":
                                    case "audio":
                                        for(t1 = 0; t1 < En.length; t1++)Nn(En[t1], n);
                                        break;
                                    case "source":
                                        Nn("error", n);
                                        break;
                                    case "img":
                                    case "image":
                                    case "link":
                                        Nn("error", n), Nn("load", n);
                                        break;
                                    case "details":
                                        Nn("toggle", n);
                                        break;
                                    case "input":
                                        tt(n, o), Nn("invalid", n);
                                        break;
                                    case "select":
                                        n._wrapperState = {
                                            wasMultiple: !!o.multiple
                                        }, Nn("invalid", n);
                                        break;
                                    case "textarea":
                                        lt(n, o), Nn("invalid", n);
                                }
                                for(var c in bt(i, o), t1 = null, o)o.hasOwnProperty(c) && (a = o[c], "children" === c ? "string" == typeof a ? n.textContent !== a && (t1 = [
                                    "children",
                                    a
                                ]) : "number" == typeof a && n.textContent !== "" + a && (t1 = [
                                    "children",
                                    "" + a
                                ]) : l.hasOwnProperty(c) && null != a && "onScroll" === c && Nn("scroll", n));
                                switch(i){
                                    case "input":
                                        q(n), nt(n, o, !0);
                                        break;
                                    case "textarea":
                                        q(n), ut(n);
                                        break;
                                    case "select":
                                    case "option":
                                        break;
                                    default:
                                        "function" == typeof o.onClick && (n.onclick = Un);
                                }
                                n = t1, e.updateQueue = n, null !== n && (e.flags |= 4);
                            } else {
                                switch(c = 9 === a.nodeType ? a : a.ownerDocument, t1 === ht.html && (t1 = dt(i)), t1 === ht.html ? "script" === i ? ((t1 = c.createElement("div")).innerHTML = "<script></script>", t1 = t1.removeChild(t1.firstChild)) : "string" == typeof n.is ? t1 = c.createElement(i, {
                                    is: n.is
                                }) : (t1 = c.createElement(i), "select" === i && (c = t1, n.multiple ? c.multiple = !0 : n.size && (c.size = n.size))) : t1 = c.createElementNS(t1, i), t1[Jn] = e, t1[Kn] = n, Ws(t1, e, !1, !1), e.stateNode = t1, c = Tt(i, n), i){
                                    case "dialog":
                                        Nn("cancel", t1), Nn("close", t1), a = n;
                                        break;
                                    case "iframe":
                                    case "object":
                                    case "embed":
                                        Nn("load", t1), a = n;
                                        break;
                                    case "video":
                                    case "audio":
                                        for(a = 0; a < En.length; a++)Nn(En[a], t1);
                                        a = n;
                                        break;
                                    case "source":
                                        Nn("error", t1), a = n;
                                        break;
                                    case "img":
                                    case "image":
                                    case "link":
                                        Nn("error", t1), Nn("load", t1), a = n;
                                        break;
                                    case "details":
                                        Nn("toggle", t1), a = n;
                                        break;
                                    case "input":
                                        tt(t1, n), a = $(t1, n), Nn("invalid", t1);
                                        break;
                                    case "option":
                                        a = at(t1, n);
                                        break;
                                    case "select":
                                        t1._wrapperState = {
                                            wasMultiple: !!n.multiple
                                        }, a = r({}, n, {
                                            value: void 0
                                        }), Nn("invalid", t1);
                                        break;
                                    case "textarea":
                                        lt(t1, n), a = ot(t1, n), Nn("invalid", t1);
                                        break;
                                    default:
                                        a = n;
                                }
                                bt(i, a);
                                var u = a;
                                for(o in u)if (u.hasOwnProperty(o)) {
                                    var h = u[o];
                                    "style" === o ? xt(t1, h) : "dangerouslySetInnerHTML" === o ? null != (h = h ? h.__html : void 0) && mt(t1, h) : "children" === o ? "string" == typeof h ? ("textarea" !== i || "" !== h) && gt(t1, h) : "number" == typeof h && gt(t1, "" + h) : "suppressContentEditableWarning" !== o && "suppressHydrationWarning" !== o && "autoFocus" !== o && (l.hasOwnProperty(o) ? null != h && "onScroll" === o && Nn("scroll", t1) : null != h && y(t1, o, h, c));
                                }
                                switch(i){
                                    case "input":
                                        q(t1), nt(t1, n, !1);
                                        break;
                                    case "textarea":
                                        q(t1), ut(t1);
                                        break;
                                    case "option":
                                        null != n.value && t1.setAttribute("value", "" + X(n.value));
                                        break;
                                    case "select":
                                        t1.multiple = !!n.multiple, null != (o = n.value) ? st(t1, !!n.multiple, o, !1) : null != n.defaultValue && st(t1, !!n.multiple, n.defaultValue, !0);
                                        break;
                                    default:
                                        "function" == typeof a.onClick && (t1.onclick = Un);
                                }
                                Qn(i, n) && (e.flags |= 4);
                            }
                            null !== e.ref && (e.flags |= 128);
                        }
                        return null;
                    case 6:
                        if (t1 && null != e.stateNode) Zs(t1, e, t1.memoizedProps, n);
                        else {
                            if ("string" != typeof n && null === e.stateNode) throw Error(s(166));
                            i = Ca(Da.current), Ca(Sa.current), Ga(e) ? (n = e.stateNode, i = e.memoizedProps, n[Jn] = e, n.nodeValue !== i && (e.flags |= 4)) : ((n = (9 === i.nodeType ? i : i.ownerDocument).createTextNode(n))[Jn] = e, e.stateNode = n);
                        }
                        return null;
                    case 13:
                        return cr(ja), n = e.memoizedState, 64 & e.flags ? (e.lanes = i, e) : (n = null !== n, i = !1, null === t1 ? void 0 !== e.memoizedProps.fallback && Ga(e) : i = null !== t1.memoizedState, n && !i && 2 & e.mode && (null === t1 && !0 !== e.memoizedProps.unstable_avoidThisFallback || 1 & ja.current ? 0 === jo && (jo = 3) : (0 !== jo && 3 !== jo || (jo = 4), null === Co || !(134217727 & Uo) && !(134217727 & Bo) || ml(Co, Lo))), (n || i) && (e.flags |= 4), null);
                    case 4:
                        return La(), Ys(e), null === t1 && Cn(e.stateNode.containerInfo), null;
                    case 10:
                        return ia(e), null;
                    case 19:
                        if (cr(ja), null === (n = e.memoizedState)) return null;
                        if (o = !!(64 & e.flags), null === (c = n.rendering)) {
                            if (o) no(n, !1);
                            else {
                                if (0 !== jo || null !== t1 && 64 & t1.flags) for(t1 = e.child; null !== t1;){
                                    if (null !== (c = Ra(t1))) {
                                        for(e.flags |= 64, no(n, !1), null !== (o = c.updateQueue) && (e.updateQueue = o, e.flags |= 4), null === n.lastEffect && (e.firstEffect = null), e.lastEffect = n.lastEffect, n = i, i = e.child; null !== i;)t1 = n, (o = i).flags &= 2, o.nextEffect = null, o.firstEffect = null, o.lastEffect = null, null === (c = o.alternate) ? (o.childLanes = 0, o.lanes = t1, o.child = null, o.memoizedProps = null, o.memoizedState = null, o.updateQueue = null, o.dependencies = null, o.stateNode = null) : (o.childLanes = c.childLanes, o.lanes = c.lanes, o.child = c.child, o.memoizedProps = c.memoizedProps, o.memoizedState = c.memoizedState, o.updateQueue = c.updateQueue, o.type = c.type, t1 = c.dependencies, o.dependencies = null === t1 ? null : {
                                            lanes: t1.lanes,
                                            firstContext: t1.firstContext
                                        }), i = i.sibling;
                                        return ur(ja, 1 & ja.current | 2), e.child;
                                    }
                                    t1 = t1.sibling;
                                }
                                null !== n.tail && Qr() > Vo && (e.flags |= 64, o = !0, no(n, !1), e.lanes = 33554432);
                            }
                        } else {
                            if (!o) {
                                if (null !== (t1 = Ra(c))) {
                                    if (e.flags |= 64, o = !0, null !== (i = t1.updateQueue) && (e.updateQueue = i, e.flags |= 4), no(n, !0), null === n.tail && "hidden" === n.tailMode && !c.alternate && !Ba) return null !== (e = e.lastEffect = n.lastEffect) && (e.nextEffect = null), null;
                                } else 2 * Qr() - n.renderingStartTime > Vo && 1073741824 !== i && (e.flags |= 64, o = !0, no(n, !1), e.lanes = 33554432);
                            }
                            n.isBackwards ? (c.sibling = e.child, e.child = c) : (null !== (i = n.last) ? i.sibling = c : e.child = c, n.last = c);
                        }
                        return null !== n.tail ? (i = n.tail, n.rendering = i, n.tail = i.sibling, n.lastEffect = e.lastEffect, n.renderingStartTime = Qr(), i.sibling = null, e = ja.current, ur(ja, o ? 1 & e | 2 : 1 & e), i) : null;
                    case 23:
                    case 24:
                        return xl(), null !== t1 && null !== t1.memoizedState != (null !== e.memoizedState) && "unstable-defer-without-hiding" !== n.mode && (e.flags |= 4), null;
                }
                throw Error(s(156, e.tag));
            }
            function ao(t1) {
                switch(t1.tag){
                    case 1:
                        mr(t1.type) && gr();
                        var e = t1.flags;
                        return 4096 & e ? (t1.flags = -4097 & e | 64, t1) : null;
                    case 3:
                        if (La(), cr(pr), cr(dr), Xa(), 64 & (e = t1.flags)) throw Error(s(285));
                        return t1.flags = -4097 & e | 64, t1;
                    case 5:
                        return Pa(t1), null;
                    case 13:
                        return cr(ja), 4096 & (e = t1.flags) ? (t1.flags = -4097 & e | 64, t1) : null;
                    case 19:
                        return cr(ja), null;
                    case 4:
                        return La(), null;
                    case 10:
                        return ia(t1), null;
                    case 23:
                    case 24:
                        return xl(), null;
                    default:
                        return null;
                }
            }
            function so(t1, e) {
                try {
                    var i = "", n = e;
                    do i += W(n), n = n.return;
                    while (n);
                    var r = i;
                } catch (t1) {
                    r = "\nError generating stack: " + t1.message + "\n" + t1.stack;
                }
                return {
                    value: t1,
                    source: e,
                    stack: r
                };
            }
            function oo(t1, e) {
                try {
                    console.error(e.value);
                } catch (t1) {
                    setTimeout(function() {
                        throw t1;
                    });
                }
            }
            Ws = function(t1, e) {
                for(var i = e.child; null !== i;){
                    if (5 === i.tag || 6 === i.tag) t1.appendChild(i.stateNode);
                    else if (4 !== i.tag && null !== i.child) {
                        i.child.return = i, i = i.child;
                        continue;
                    }
                    if (i === e) break;
                    for(; null === i.sibling;){
                        if (null === i.return || i.return === e) return;
                        i = i.return;
                    }
                    i.sibling.return = i.return, i = i.sibling;
                }
            }, Ys = function() {}, Xs = function(t1, e, i, n) {
                var a = t1.memoizedProps;
                if (a !== n) {
                    t1 = e.stateNode, Ca(Sa.current);
                    var s, o = null;
                    switch(i){
                        case "input":
                            a = $(t1, a), n = $(t1, n), o = [];
                            break;
                        case "option":
                            a = at(t1, a), n = at(t1, n), o = [];
                            break;
                        case "select":
                            a = r({}, a, {
                                value: void 0
                            }), n = r({}, n, {
                                value: void 0
                            }), o = [];
                            break;
                        case "textarea":
                            a = ot(t1, a), n = ot(t1, n), o = [];
                            break;
                        default:
                            "function" != typeof a.onClick && "function" == typeof n.onClick && (t1.onclick = Un);
                    }
                    for(h in bt(i, n), i = null, a)if (!n.hasOwnProperty(h) && a.hasOwnProperty(h) && null != a[h]) {
                        if ("style" === h) {
                            var c = a[h];
                            for(s in c)c.hasOwnProperty(s) && (i || (i = {}), i[s] = "");
                        } else "dangerouslySetInnerHTML" !== h && "children" !== h && "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && "autoFocus" !== h && (l.hasOwnProperty(h) ? o || (o = []) : (o = o || []).push(h, null));
                    }
                    for(h in n){
                        var u = n[h];
                        if (c = null != a ? a[h] : void 0, n.hasOwnProperty(h) && u !== c && (null != u || null != c)) {
                            if ("style" === h) {
                                if (c) {
                                    for(s in c)!c.hasOwnProperty(s) || u && u.hasOwnProperty(s) || (i || (i = {}), i[s] = "");
                                    for(s in u)u.hasOwnProperty(s) && c[s] !== u[s] && (i || (i = {}), i[s] = u[s]);
                                } else i || (o || (o = []), o.push(h, i)), i = u;
                            } else "dangerouslySetInnerHTML" === h ? (u = u ? u.__html : void 0, c = c ? c.__html : void 0, null != u && c !== u && (o = o || []).push(h, u)) : "children" === h ? "string" != typeof u && "number" != typeof u || (o = o || []).push(h, "" + u) : "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && (l.hasOwnProperty(h) ? (null != u && "onScroll" === h && Nn("scroll", t1), o || c === u || (o = [])) : "object" == typeof u && null !== u && u.$$typeof === P ? u.toString() : (o = o || []).push(h, u));
                        }
                    }
                    i && (o = o || []).push("style", i);
                    var h = o;
                    (e.updateQueue = h) && (e.flags |= 4);
                }
            }, Zs = function(t1, e, i, n) {
                i !== n && (e.flags |= 4);
            };
            var lo = "function" == typeof WeakMap ? WeakMap : Map;
            function co(t1, e, i) {
                (i = ca(-1, i)).tag = 3, i.payload = {
                    element: null
                };
                var n = e.value;
                return i.callback = function() {
                    Xo || (Xo = !0, Zo = n), oo(0, e);
                }, i;
            }
            function uo(t1, e, i) {
                (i = ca(-1, i)).tag = 3;
                var n = t1.type.getDerivedStateFromError;
                if ("function" == typeof n) {
                    var r = e.value;
                    i.payload = function() {
                        return oo(0, e), n(r);
                    };
                }
                var a = t1.stateNode;
                return null !== a && "function" == typeof a.componentDidCatch && (i.callback = function() {
                    "function" != typeof n && (null === qo ? qo = new Set([
                        this
                    ]) : qo.add(this), oo(0, e));
                    var t1 = e.stack;
                    this.componentDidCatch(e.value, {
                        componentStack: null !== t1 ? t1 : ""
                    });
                }), i;
            }
            var ho = "function" == typeof WeakSet ? WeakSet : Set;
            function po(t1) {
                var e = t1.ref;
                if (null !== e) {
                    if ("function" == typeof e) try {
                        e(null);
                    } catch (e) {
                        kl(t1, e);
                    }
                    else e.current = null;
                }
            }
            function Ao(t1, e) {
                switch(e.tag){
                    case 0:
                    case 11:
                    case 15:
                    case 22:
                    case 5:
                    case 6:
                    case 4:
                    case 17:
                        return;
                    case 1:
                        if (256 & e.flags && null !== t1) {
                            var i = t1.memoizedProps, n = t1.memoizedState;
                            e = (t1 = e.stateNode).getSnapshotBeforeUpdate(e.elementType === e.type ? i : qr(e.type, i), n), t1.__reactInternalSnapshotBeforeUpdate = e;
                        }
                        return;
                    case 3:
                        return void (256 & e.flags && Wn(e.stateNode.containerInfo));
                }
                throw Error(s(163));
            }
            function fo(t1, e, i) {
                switch(i.tag){
                    case 0:
                    case 11:
                    case 15:
                    case 22:
                        if (null !== (e = null !== (e = i.updateQueue) ? e.lastEffect : null)) {
                            t1 = e = e.next;
                            do {
                                if (!(3 & ~t1.tag)) {
                                    var n = t1.create;
                                    t1.destroy = n();
                                }
                                t1 = t1.next;
                            }while (t1 !== e);
                        }
                        if (null !== (e = null !== (e = i.updateQueue) ? e.lastEffect : null)) {
                            t1 = e = e.next;
                            do {
                                var r = t1;
                                n = r.next, 4 & (r = r.tag) && 1 & r && (Pl(i, t1), Ol(i, t1)), t1 = n;
                            }while (t1 !== e);
                        }
                        return;
                    case 1:
                        return t1 = i.stateNode, 4 & i.flags && (null === e ? t1.componentDidMount() : (n = i.elementType === i.type ? e.memoizedProps : qr(i.type, e.memoizedProps), t1.componentDidUpdate(n, e.memoizedState, t1.__reactInternalSnapshotBeforeUpdate))), void (null !== (e = i.updateQueue) && pa(i, e, t1));
                    case 3:
                        if (null !== (e = i.updateQueue)) {
                            if (t1 = null, null !== i.child) switch(i.child.tag){
                                case 5:
                                case 1:
                                    t1 = i.child.stateNode;
                            }
                            pa(i, e, t1);
                        }
                        return;
                    case 5:
                        return t1 = i.stateNode, void (null === e && 4 & i.flags && Qn(i.type, i.memoizedProps) && t1.focus());
                    case 6:
                    case 4:
                    case 12:
                    case 19:
                    case 17:
                    case 20:
                    case 21:
                    case 23:
                    case 24:
                        return;
                    case 13:
                        return void (null === i.memoizedState && (i = i.alternate, null !== i && (i = i.memoizedState, null !== i && (i = i.dehydrated, null !== i && xe(i)))));
                }
                throw Error(s(163));
            }
            function mo(t1, e) {
                for(var i = t1;;){
                    if (5 === i.tag) {
                        var n = i.stateNode;
                        if (e) "function" == typeof (n = n.style).setProperty ? n.setProperty("display", "none", "important") : n.display = "none";
                        else {
                            n = i.stateNode;
                            var r = i.memoizedProps.style;
                            r = null != r && r.hasOwnProperty("display") ? r.display : null, n.style.display = yt("display", r);
                        }
                    } else if (6 === i.tag) i.stateNode.nodeValue = e ? "" : i.memoizedProps;
                    else if ((23 !== i.tag && 24 !== i.tag || null === i.memoizedState || i === t1) && null !== i.child) {
                        i.child.return = i, i = i.child;
                        continue;
                    }
                    if (i === t1) break;
                    for(; null === i.sibling;){
                        if (null === i.return || i.return === t1) return;
                        i = i.return;
                    }
                    i.sibling.return = i.return, i = i.sibling;
                }
            }
            function go(t1, e) {
                if (br && "function" == typeof br.onCommitFiberUnmount) try {
                    br.onCommitFiberUnmount(wr, e);
                } catch (t1) {}
                switch(e.tag){
                    case 0:
                    case 11:
                    case 14:
                    case 15:
                    case 22:
                        if (null !== (t1 = e.updateQueue) && null !== (t1 = t1.lastEffect)) {
                            var i = t1 = t1.next;
                            do {
                                var n = i, r = n.destroy;
                                if (n = n.tag, void 0 !== r) {
                                    if (4 & n) Pl(e, i);
                                    else {
                                        n = e;
                                        try {
                                            r();
                                        } catch (t1) {
                                            kl(n, t1);
                                        }
                                    }
                                }
                                i = i.next;
                            }while (i !== t1);
                        }
                        break;
                    case 1:
                        if (po(e), "function" == typeof (t1 = e.stateNode).componentWillUnmount) try {
                            t1.props = e.memoizedProps, t1.state = e.memoizedState, t1.componentWillUnmount();
                        } catch (t1) {
                            kl(e, t1);
                        }
                        break;
                    case 5:
                        po(e);
                        break;
                    case 4:
                        bo(t1, e);
                }
            }
            function Mo(t1) {
                t1.alternate = null, t1.child = null, t1.dependencies = null, t1.firstEffect = null, t1.lastEffect = null, t1.memoizedProps = null, t1.memoizedState = null, t1.pendingProps = null, t1.return = null, t1.updateQueue = null;
            }
            function vo(t1) {
                return 5 === t1.tag || 3 === t1.tag || 4 === t1.tag;
            }
            function yo(t1) {
                t: {
                    for(var e = t1.return; null !== e;){
                        if (vo(e)) break t;
                        e = e.return;
                    }
                    throw Error(s(160));
                }
                var i = e;
                switch(e = i.stateNode, i.tag){
                    case 5:
                        var n = !1;
                        break;
                    case 3:
                    case 4:
                        e = e.containerInfo, n = !0;
                        break;
                    default:
                        throw Error(s(161));
                }
                16 & i.flags && (gt(e, ""), i.flags &= -17);
                t: e: for(i = t1;;){
                    for(; null === i.sibling;){
                        if (null === i.return || vo(i.return)) {
                            i = null;
                            break t;
                        }
                        i = i.return;
                    }
                    for(i.sibling.return = i.return, i = i.sibling; 5 !== i.tag && 6 !== i.tag && 18 !== i.tag;){
                        if (2 & i.flags) continue e;
                        if (null === i.child || 4 === i.tag) continue e;
                        i.child.return = i, i = i.child;
                    }
                    if (!(2 & i.flags)) {
                        i = i.stateNode;
                        break t;
                    }
                }
                n ? xo(t1, i, e) : wo(t1, i, e);
            }
            function xo(t1, e, i) {
                var n = t1.tag, r = 5 === n || 6 === n;
                if (r) t1 = r ? t1.stateNode : t1.stateNode.instance, e ? 8 === i.nodeType ? i.parentNode.insertBefore(t1, e) : i.insertBefore(t1, e) : (8 === i.nodeType ? (e = i.parentNode).insertBefore(t1, i) : (e = i).appendChild(t1), null != (i = i._reactRootContainer) || null !== e.onclick || (e.onclick = Un));
                else if (4 !== n && null !== (t1 = t1.child)) for(xo(t1, e, i), t1 = t1.sibling; null !== t1;)xo(t1, e, i), t1 = t1.sibling;
            }
            function wo(t1, e, i) {
                var n = t1.tag, r = 5 === n || 6 === n;
                if (r) t1 = r ? t1.stateNode : t1.stateNode.instance, e ? i.insertBefore(t1, e) : i.appendChild(t1);
                else if (4 !== n && null !== (t1 = t1.child)) for(wo(t1, e, i), t1 = t1.sibling; null !== t1;)wo(t1, e, i), t1 = t1.sibling;
            }
            function bo(t1, e) {
                for(var i, n, r = e, a = !1;;){
                    if (!a) {
                        a = r.return;
                        t: for(;;){
                            if (null === a) throw Error(s(160));
                            switch(i = a.stateNode, a.tag){
                                case 5:
                                    n = !1;
                                    break t;
                                case 3:
                                case 4:
                                    i = i.containerInfo, n = !0;
                                    break t;
                            }
                            a = a.return;
                        }
                        a = !0;
                    }
                    if (5 === r.tag || 6 === r.tag) {
                        t: for(var o = t1, l = r, c = l;;)if (go(o, c), null !== c.child && 4 !== c.tag) c.child.return = c, c = c.child;
                        else {
                            if (c === l) break t;
                            for(; null === c.sibling;){
                                if (null === c.return || c.return === l) break t;
                                c = c.return;
                            }
                            c.sibling.return = c.return, c = c.sibling;
                        }
                        n ? (o = i, l = r.stateNode, 8 === o.nodeType ? o.parentNode.removeChild(l) : o.removeChild(l)) : i.removeChild(r.stateNode);
                    } else if (4 === r.tag) {
                        if (null !== r.child) {
                            i = r.stateNode.containerInfo, n = !0, r.child.return = r, r = r.child;
                            continue;
                        }
                    } else if (go(t1, r), null !== r.child) {
                        r.child.return = r, r = r.child;
                        continue;
                    }
                    if (r === e) break;
                    for(; null === r.sibling;){
                        if (null === r.return || r.return === e) return;
                        4 === (r = r.return).tag && (a = !1);
                    }
                    r.sibling.return = r.return, r = r.sibling;
                }
            }
            function To(t1, e) {
                switch(e.tag){
                    case 0:
                    case 11:
                    case 14:
                    case 15:
                    case 22:
                        var i = e.updateQueue;
                        if (null !== (i = null !== i ? i.lastEffect : null)) {
                            var n = i = i.next;
                            do !(3 & ~n.tag) && (t1 = n.destroy, n.destroy = void 0, void 0 !== t1 && t1()), n = n.next;
                            while (n !== i);
                        }
                        return;
                    case 1:
                    case 12:
                    case 17:
                        return;
                    case 5:
                        if (null != (i = e.stateNode)) {
                            n = e.memoizedProps;
                            var r = null !== t1 ? t1.memoizedProps : n;
                            t1 = e.type;
                            var a = e.updateQueue;
                            if (e.updateQueue = null, null !== a) {
                                for(i[Kn] = n, "input" === t1 && "radio" === n.type && null != n.name && et(i, n), Tt(t1, r), e = Tt(t1, n), r = 0; r < a.length; r += 2){
                                    var o = a[r], l = a[r + 1];
                                    "style" === o ? xt(i, l) : "dangerouslySetInnerHTML" === o ? mt(i, l) : "children" === o ? gt(i, l) : y(i, o, l, e);
                                }
                                switch(t1){
                                    case "input":
                                        it(i, n);
                                        break;
                                    case "textarea":
                                        ct(i, n);
                                        break;
                                    case "select":
                                        t1 = i._wrapperState.wasMultiple, i._wrapperState.wasMultiple = !!n.multiple, null != (a = n.value) ? st(i, !!n.multiple, a, !1) : t1 !== !!n.multiple && (null != n.defaultValue ? st(i, !!n.multiple, n.defaultValue, !0) : st(i, !!n.multiple, n.multiple ? [] : "", !1));
                                }
                            }
                        }
                        return;
                    case 6:
                        if (null === e.stateNode) throw Error(s(162));
                        return void (e.stateNode.nodeValue = e.memoizedProps);
                    case 3:
                        return void ((i = e.stateNode).hydrate && (i.hydrate = !1, xe(i.containerInfo)));
                    case 13:
                        return null !== e.memoizedState && (Ho = Qr(), mo(e.child, !0)), void Eo(e);
                    case 19:
                        return void Eo(e);
                    case 23:
                    case 24:
                        return void mo(e, null !== e.memoizedState);
                }
                throw Error(s(163));
            }
            function Eo(t1) {
                var e = t1.updateQueue;
                if (null !== e) {
                    t1.updateQueue = null;
                    var i = t1.stateNode;
                    null === i && (i = t1.stateNode = new ho), e.forEach(function(e) {
                        var n = Bl.bind(null, t1, e);
                        i.has(e) || (i.add(e), e.then(n, n));
                    });
                }
            }
            function _o(t1, e) {
                return null !== t1 && (null === (t1 = t1.memoizedState) || null !== t1.dehydrated) && null !== (e = e.memoizedState) && null === e.dehydrated;
            }
            var Io = Math.ceil, So = x.ReactCurrentDispatcher, No = x.ReactCurrentOwner, Do = 0, Co = null, zo = null, Lo = 0, Oo = 0, Po = lr(0), jo = 0, Ro = null, ko = 0, Uo = 0, Bo = 0, Fo = 0, Qo = null, Ho = 0, Vo = 1 / 0;
            function Go() {
                Vo = Qr() + 500;
            }
            var Wo, Yo = null, Xo = !1, Zo = null, qo = null, Jo = !1, Ko = null, $o = 90, tl = [], el = [], il = null, nl = 0, rl = null, al = -1, sl = 0, ol = 0, ll = null, cl = !1;
            function ul() {
                return 48 & Do ? Qr() : -1 !== al ? al : al = Qr();
            }
            function hl(t1) {
                if (!(2 & (t1 = t1.mode))) return 1;
                if (!(4 & t1)) return 99 === Hr() ? 1 : 2;
                if (0 === sl && (sl = ko), 0 !== Zr.transition) {
                    0 !== ol && (ol = null !== Qo ? Qo.pendingLanes : 0), t1 = sl;
                    var e = 4186112 & ~ol;
                    return 0 == (e &= -e) && 0 == (e = (t1 = 4186112 & ~t1) & -t1) && (e = 8192), e;
                }
                return t1 = Hr(), t1 = Ue(4 & Do && 98 === t1 ? 12 : t1 = function(t1) {
                    switch(t1){
                        case 99:
                            return 15;
                        case 98:
                            return 10;
                        case 97:
                        case 96:
                            return 8;
                        case 95:
                            return 2;
                        default:
                            return 0;
                    }
                }(t1), sl);
            }
            function dl(t1, e, i) {
                if (50 < nl) throw nl = 0, rl = null, Error(s(185));
                if (null === (t1 = pl(t1, e))) return null;
                Qe(t1, e, i), t1 === Co && (Bo |= e, 4 === jo && ml(t1, Lo));
                var n = Hr();
                1 === e ? 8 & Do && !(48 & Do) ? gl(t1) : (Al(t1, i), 0 === Do && (Go(), Yr())) : (!(4 & Do) || 98 !== n && 99 !== n || (null === il ? il = new Set([
                    t1
                ]) : il.add(t1)), Al(t1, i)), Qo = t1;
            }
            function pl(t1, e) {
                t1.lanes |= e;
                var i = t1.alternate;
                for(null !== i && (i.lanes |= e), i = t1, t1 = t1.return; null !== t1;)t1.childLanes |= e, null !== (i = t1.alternate) && (i.childLanes |= e), i = t1, t1 = t1.return;
                return 3 === i.tag ? i.stateNode : null;
            }
            function Al(t1, e) {
                for(var i = t1.callbackNode, n = t1.suspendedLanes, r = t1.pingedLanes, a = t1.expirationTimes, o = t1.pendingLanes; 0 < o;){
                    var l = 31 - He(o), c = 1 << l, u = a[l];
                    if (-1 === u) {
                        if (!(c & n) || c & r) {
                            u = e, je(c);
                            var h = Pe;
                            a[l] = 10 <= h ? u + 250 : 6 <= h ? u + 5e3 : -1;
                        }
                    } else u <= e && (t1.expiredLanes |= c);
                    o &= ~c;
                }
                if (n = Re(t1, t1 === Co ? Lo : 0), e = Pe, 0 === n) null !== i && (i !== jr && _r(i), t1.callbackNode = null, t1.callbackPriority = 0);
                else {
                    if (null !== i) {
                        if (t1.callbackPriority === e) return;
                        i !== jr && _r(i);
                    }
                    15 === e ? (i = gl.bind(null, t1), null === kr ? (kr = [
                        i
                    ], Ur = Er(Cr, Xr)) : kr.push(i), i = jr) : 14 === e ? i = Wr(99, gl.bind(null, t1)) : (i = function(t1) {
                        switch(t1){
                            case 15:
                            case 14:
                                return 99;
                            case 13:
                            case 12:
                            case 11:
                            case 10:
                                return 98;
                            case 9:
                            case 8:
                            case 7:
                            case 6:
                            case 4:
                            case 5:
                                return 97;
                            case 3:
                            case 2:
                            case 1:
                                return 95;
                            case 0:
                                return 90;
                            default:
                                throw Error(s(358, t1));
                        }
                    }(e), i = Wr(i, fl.bind(null, t1))), t1.callbackPriority = e, t1.callbackNode = i;
                }
            }
            function fl(t1) {
                if (al = -1, ol = sl = 0, 48 & Do) throw Error(s(327));
                var e = t1.callbackNode;
                if (Ll() && t1.callbackNode !== e) return null;
                var i = Re(t1, t1 === Co ? Lo : 0);
                if (0 === i) return null;
                var n = i, r = Do;
                Do |= 16;
                var a = Tl();
                for(Co === t1 && Lo === n || (Go(), wl(t1, n));;)try {
                    Il();
                    break;
                } catch (e) {
                    bl(t1, e);
                }
                if (ea(), So.current = a, Do = r, null !== zo ? n = 0 : (Co = null, Lo = 0, n = jo), ko & Bo) wl(t1, 0);
                else if (0 !== n) {
                    if (2 === n && (Do |= 64, t1.hydrate && (t1.hydrate = !1, Wn(t1.containerInfo)), 0 !== (i = ke(t1)) && (n = El(t1, i))), 1 === n) throw e = Ro, wl(t1, 0), ml(t1, i), Al(t1, Qr()), e;
                    switch(t1.finishedWork = t1.current.alternate, t1.finishedLanes = i, n){
                        case 0:
                        case 1:
                            throw Error(s(345));
                        case 2:
                        case 5:
                            Dl(t1);
                            break;
                        case 3:
                            if (ml(t1, i), (62914560 & i) === i && 10 < (n = Ho + 500 - Qr())) {
                                if (0 !== Re(t1, 0)) break;
                                if (((r = t1.suspendedLanes) & i) !== i) {
                                    ul(), t1.pingedLanes |= t1.suspendedLanes & r;
                                    break;
                                }
                                t1.timeoutHandle = Vn(Dl.bind(null, t1), n);
                                break;
                            }
                            Dl(t1);
                            break;
                        case 4:
                            if (ml(t1, i), (4186112 & i) === i) break;
                            for(n = t1.eventTimes, r = -1; 0 < i;){
                                var o = 31 - He(i);
                                a = 1 << o, (o = n[o]) > r && (r = o), i &= ~a;
                            }
                            if (i = r, 10 < (i = (120 > (i = Qr() - i) ? 120 : 480 > i ? 480 : 1080 > i ? 1080 : 1920 > i ? 1920 : 3e3 > i ? 3e3 : 4320 > i ? 4320 : 1960 * Io(i / 1960)) - i)) {
                                t1.timeoutHandle = Vn(Dl.bind(null, t1), i);
                                break;
                            }
                            Dl(t1);
                            break;
                        default:
                            throw Error(s(329));
                    }
                }
                return Al(t1, Qr()), t1.callbackNode === e ? fl.bind(null, t1) : null;
            }
            function ml(t1, e) {
                for(e &= ~Fo, e &= ~Bo, t1.suspendedLanes |= e, t1.pingedLanes &= ~e, t1 = t1.expirationTimes; 0 < e;){
                    var i = 31 - He(e), n = 1 << i;
                    t1[i] = -1, e &= ~n;
                }
            }
            function gl(t1) {
                if (48 & Do) throw Error(s(327));
                if (Ll(), t1 === Co && t1.expiredLanes & Lo) {
                    var e = Lo, i = El(t1, e);
                    ko & Bo && (i = El(t1, e = Re(t1, e)));
                } else i = El(t1, e = Re(t1, 0));
                if (0 !== t1.tag && 2 === i && (Do |= 64, t1.hydrate && (t1.hydrate = !1, Wn(t1.containerInfo)), 0 !== (e = ke(t1)) && (i = El(t1, e))), 1 === i) throw i = Ro, wl(t1, 0), ml(t1, e), Al(t1, Qr()), i;
                return t1.finishedWork = t1.current.alternate, t1.finishedLanes = e, Dl(t1), Al(t1, Qr()), null;
            }
            function Ml(t1, e) {
                var i = Do;
                Do |= 1;
                try {
                    return t1(e);
                } finally{
                    0 === (Do = i) && (Go(), Yr());
                }
            }
            function vl(t1, e) {
                var i = Do;
                Do &= -2, Do |= 8;
                try {
                    return t1(e);
                } finally{
                    0 === (Do = i) && (Go(), Yr());
                }
            }
            function yl(t1, e) {
                ur(Po, Oo), Oo |= e, ko |= e;
            }
            function xl() {
                Oo = Po.current, cr(Po);
            }
            function wl(t1, e) {
                t1.finishedWork = null, t1.finishedLanes = 0;
                var i = t1.timeoutHandle;
                if (-1 !== i && (t1.timeoutHandle = -1, Gn(i)), null !== zo) for(i = zo.return; null !== i;){
                    var n = i;
                    switch(n.tag){
                        case 1:
                            null != (n = n.type.childContextTypes) && gr();
                            break;
                        case 3:
                            La(), cr(pr), cr(dr), Xa();
                            break;
                        case 5:
                            Pa(n);
                            break;
                        case 4:
                            La();
                            break;
                        case 13:
                        case 19:
                            cr(ja);
                            break;
                        case 10:
                            ia(n);
                            break;
                        case 23:
                        case 24:
                            xl();
                    }
                    i = i.return;
                }
                Co = t1, zo = Vl(t1.current, null), Lo = Oo = ko = e, jo = 0, Ro = null, Fo = Bo = Uo = 0;
            }
            function bl(t1, e) {
                for(;;){
                    var i = zo;
                    try {
                        if (ea(), Za.current = Ds, es) {
                            for(var n = Ka.memoizedState; null !== n;){
                                var r = n.queue;
                                null !== r && (r.pending = null), n = n.next;
                            }
                            es = !1;
                        }
                        if (Ja = 0, ts = $a = Ka = null, is = !1, No.current = null, null === i || null === i.return) {
                            jo = 1, Ro = e, zo = null;
                            break;
                        }
                        t: {
                            var a = t1, s = i.return, o = i, l = e;
                            if (e = Lo, o.flags |= 2048, o.firstEffect = o.lastEffect = null, null !== l && "object" == typeof l && "function" == typeof l.then) {
                                var c = l;
                                if (!(2 & o.mode)) {
                                    var u = o.alternate;
                                    u ? (o.updateQueue = u.updateQueue, o.memoizedState = u.memoizedState, o.lanes = u.lanes) : (o.updateQueue = null, o.memoizedState = null);
                                }
                                var h = !!(1 & ja.current), d = s;
                                do {
                                    var p;
                                    if (p = 13 === d.tag) {
                                        var A = d.memoizedState;
                                        if (null !== A) p = null !== A.dehydrated;
                                        else {
                                            var f = d.memoizedProps;
                                            p = void 0 !== f.fallback && (!0 !== f.unstable_avoidThisFallback || !h);
                                        }
                                    }
                                    if (p) {
                                        var m = d.updateQueue;
                                        if (null === m) {
                                            var g = new Set;
                                            g.add(c), d.updateQueue = g;
                                        } else m.add(c);
                                        if (!(2 & d.mode)) {
                                            if (d.flags |= 64, o.flags |= 16384, o.flags &= -2981, 1 === o.tag) {
                                                if (null === o.alternate) o.tag = 17;
                                                else {
                                                    var M = ca(-1, 1);
                                                    M.tag = 2, ua(o, M);
                                                }
                                            }
                                            o.lanes |= 1;
                                            break t;
                                        }
                                        l = void 0, o = e;
                                        var v = a.pingCache;
                                        if (null === v ? (v = a.pingCache = new lo, l = new Set, v.set(c, l)) : void 0 === (l = v.get(c)) && (l = new Set, v.set(c, l)), !l.has(o)) {
                                            l.add(o);
                                            var y = Ul.bind(null, a, c, o);
                                            c.then(y, y);
                                        }
                                        d.flags |= 4096, d.lanes = e;
                                        break t;
                                    }
                                    d = d.return;
                                }while (null !== d);
                                l = Error((Y(o.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
                            }
                            5 !== jo && (jo = 2), l = so(l, o), d = s;
                            do {
                                switch(d.tag){
                                    case 3:
                                        a = l, d.flags |= 4096, e &= -e, d.lanes |= e, ha(d, co(0, a, e));
                                        break t;
                                    case 1:
                                        a = l;
                                        var x = d.type, w = d.stateNode;
                                        if (!(64 & d.flags || "function" != typeof x.getDerivedStateFromError && (null === w || "function" != typeof w.componentDidCatch || null !== qo && qo.has(w)))) {
                                            d.flags |= 4096, e &= -e, d.lanes |= e, ha(d, uo(d, a, e));
                                            break t;
                                        }
                                }
                                d = d.return;
                            }while (null !== d);
                        }
                        Nl(i);
                    } catch (t1) {
                        e = t1, zo === i && null !== i && (zo = i = i.return);
                        continue;
                    }
                    break;
                }
            }
            function Tl() {
                var t1 = So.current;
                return So.current = Ds, null === t1 ? Ds : t1;
            }
            function El(t1, e) {
                var i = Do;
                Do |= 16;
                var n = Tl();
                for(Co === t1 && Lo === e || wl(t1, e);;)try {
                    _l();
                    break;
                } catch (e) {
                    bl(t1, e);
                }
                if (ea(), Do = i, So.current = n, null !== zo) throw Error(s(261));
                return Co = null, Lo = 0, jo;
            }
            function _l() {
                for(; null !== zo;)Sl(zo);
            }
            function Il() {
                for(; null !== zo && !Ir();)Sl(zo);
            }
            function Sl(t1) {
                var e = Wo(t1.alternate, t1, Oo);
                t1.memoizedProps = t1.pendingProps, null === e ? Nl(t1) : zo = e, No.current = null;
            }
            function Nl(t1) {
                var e = t1;
                do {
                    var i = e.alternate;
                    if (t1 = e.return, 2048 & e.flags) {
                        if (null !== (i = ao(e))) return i.flags &= 2047, void (zo = i);
                        null !== t1 && (t1.firstEffect = t1.lastEffect = null, t1.flags |= 2048);
                    } else {
                        if (null !== (i = ro(i, e, Oo))) return void (zo = i);
                        if (24 !== (i = e).tag && 23 !== i.tag || null === i.memoizedState || 1073741824 & Oo || !(4 & i.mode)) {
                            for(var n = 0, r = i.child; null !== r;)n |= r.lanes | r.childLanes, r = r.sibling;
                            i.childLanes = n;
                        }
                        null !== t1 && !(2048 & t1.flags) && (null === t1.firstEffect && (t1.firstEffect = e.firstEffect), null !== e.lastEffect && (null !== t1.lastEffect && (t1.lastEffect.nextEffect = e.firstEffect), t1.lastEffect = e.lastEffect), 1 < e.flags && (null !== t1.lastEffect ? t1.lastEffect.nextEffect = e : t1.firstEffect = e, t1.lastEffect = e));
                    }
                    if (null !== (e = e.sibling)) return void (zo = e);
                    zo = e = t1;
                }while (null !== e);
                0 === jo && (jo = 5);
            }
            function Dl(t1) {
                var e = Hr();
                return Gr(99, Cl.bind(null, t1, e)), null;
            }
            function Cl(t1, e) {
                do Ll();
                while (null !== Ko);
                if (48 & Do) throw Error(s(327));
                var i = t1.finishedWork;
                if (null === i) return null;
                if (t1.finishedWork = null, t1.finishedLanes = 0, i === t1.current) throw Error(s(177));
                t1.callbackNode = null;
                var n = i.lanes | i.childLanes, r = n, a = t1.pendingLanes & ~r;
                t1.pendingLanes = r, t1.suspendedLanes = 0, t1.pingedLanes = 0, t1.expiredLanes &= r, t1.mutableReadLanes &= r, t1.entangledLanes &= r, r = t1.entanglements;
                for(var o = t1.eventTimes, l = t1.expirationTimes; 0 < a;){
                    var c = 31 - He(a), u = 1 << c;
                    r[c] = 0, o[c] = -1, l[c] = -1, a &= ~u;
                }
                if (null !== il && !(24 & n) && il.has(t1) && il.delete(t1), t1 === Co && (zo = Co = null, Lo = 0), 1 < i.flags ? null !== i.lastEffect ? (i.lastEffect.nextEffect = i, n = i.firstEffect) : n = i : n = i.firstEffect, null !== n) {
                    if (r = Do, Do |= 32, No.current = null, Bn = Xe, mn(o = fn())) {
                        if ("selectionStart" in o) l = {
                            start: o.selectionStart,
                            end: o.selectionEnd
                        };
                        else t: if (l = (l = o.ownerDocument) && l.defaultView || window, (u = l.getSelection && l.getSelection()) && 0 !== u.rangeCount) {
                            l = u.anchorNode, a = u.anchorOffset, c = u.focusNode, u = u.focusOffset;
                            try {
                                l.nodeType, c.nodeType;
                            } catch (t1) {
                                l = null;
                                break t;
                            }
                            var h = 0, d = -1, p = -1, A = 0, f = 0, m = o, g = null;
                            e: for(;;){
                                for(var M; m !== l || 0 !== a && 3 !== m.nodeType || (d = h + a), m !== c || 0 !== u && 3 !== m.nodeType || (p = h + u), 3 === m.nodeType && (h += m.nodeValue.length), null !== (M = m.firstChild);)g = m, m = M;
                                for(;;){
                                    if (m === o) break e;
                                    if (g === l && ++A === a && (d = h), g === c && ++f === u && (p = h), null !== (M = m.nextSibling)) break;
                                    g = (m = g).parentNode;
                                }
                                m = M;
                            }
                            l = -1 === d || -1 === p ? null : {
                                start: d,
                                end: p
                            };
                        } else l = null;
                        l = l || {
                            start: 0,
                            end: 0
                        };
                    } else l = null;
                    Fn = {
                        focusedElem: o,
                        selectionRange: l
                    }, Xe = !1, ll = null, cl = !1, Yo = n;
                    do try {
                        zl();
                    } catch (t1) {
                        if (null === Yo) throw Error(s(330));
                        kl(Yo, t1), Yo = Yo.nextEffect;
                    }
                    while (null !== Yo);
                    ll = null, Yo = n;
                    do try {
                        for(o = t1; null !== Yo;){
                            var v = Yo.flags;
                            if (16 & v && gt(Yo.stateNode, ""), 128 & v) {
                                var y = Yo.alternate;
                                if (null !== y) {
                                    var x = y.ref;
                                    null !== x && ("function" == typeof x ? x(null) : x.current = null);
                                }
                            }
                            switch(1038 & v){
                                case 2:
                                    yo(Yo), Yo.flags &= -3;
                                    break;
                                case 6:
                                    yo(Yo), Yo.flags &= -3, To(Yo.alternate, Yo);
                                    break;
                                case 1024:
                                    Yo.flags &= -1025;
                                    break;
                                case 1028:
                                    Yo.flags &= -1025, To(Yo.alternate, Yo);
                                    break;
                                case 4:
                                    To(Yo.alternate, Yo);
                                    break;
                                case 8:
                                    bo(o, l = Yo);
                                    var w = l.alternate;
                                    Mo(l), null !== w && Mo(w);
                            }
                            Yo = Yo.nextEffect;
                        }
                    } catch (t1) {
                        if (null === Yo) throw Error(s(330));
                        kl(Yo, t1), Yo = Yo.nextEffect;
                    }
                    while (null !== Yo);
                    if (x = Fn, y = fn(), v = x.focusedElem, o = x.selectionRange, y !== v && v && v.ownerDocument && An(v.ownerDocument.documentElement, v)) {
                        null !== o && mn(v) && (y = o.start, void 0 === (x = o.end) && (x = y), "selectionStart" in v ? (v.selectionStart = y, v.selectionEnd = Math.min(x, v.value.length)) : (x = (y = v.ownerDocument || document) && y.defaultView || window).getSelection && (x = x.getSelection(), l = v.textContent.length, w = Math.min(o.start, l), o = void 0 === o.end ? w : Math.min(o.end, l), !x.extend && w > o && (l = o, o = w, w = l), l = pn(v, w), a = pn(v, o), l && a && (1 !== x.rangeCount || x.anchorNode !== l.node || x.anchorOffset !== l.offset || x.focusNode !== a.node || x.focusOffset !== a.offset) && ((y = y.createRange()).setStart(l.node, l.offset), x.removeAllRanges(), w > o ? (x.addRange(y), x.extend(a.node, a.offset)) : (y.setEnd(a.node, a.offset), x.addRange(y))))), y = [];
                        for(x = v; x = x.parentNode;)1 === x.nodeType && y.push({
                            element: x,
                            left: x.scrollLeft,
                            top: x.scrollTop
                        });
                        for("function" == typeof v.focus && v.focus(), v = 0; v < y.length; v++)(x = y[v]).element.scrollLeft = x.left, x.element.scrollTop = x.top;
                    }
                    Xe = !!Bn, Fn = Bn = null, t1.current = i, Yo = n;
                    do try {
                        for(v = t1; null !== Yo;){
                            var b = Yo.flags;
                            if (36 & b && fo(v, Yo.alternate, Yo), 128 & b) {
                                y = void 0;
                                var T = Yo.ref;
                                if (null !== T) {
                                    var E = Yo.stateNode;
                                    Yo.tag, y = E, "function" == typeof T ? T(y) : T.current = y;
                                }
                            }
                            Yo = Yo.nextEffect;
                        }
                    } catch (t1) {
                        if (null === Yo) throw Error(s(330));
                        kl(Yo, t1), Yo = Yo.nextEffect;
                    }
                    while (null !== Yo);
                    Yo = null, Rr(), Do = r;
                } else t1.current = i;
                if (Jo) Jo = !1, Ko = t1, $o = e;
                else for(Yo = n; null !== Yo;)e = Yo.nextEffect, Yo.nextEffect = null, 8 & Yo.flags && ((b = Yo).sibling = null, b.stateNode = null), Yo = e;
                if (0 === (n = t1.pendingLanes) && (qo = null), 1 === n ? t1 === rl ? nl++ : (nl = 0, rl = t1) : nl = 0, i = i.stateNode, br && "function" == typeof br.onCommitFiberRoot) try {
                    br.onCommitFiberRoot(wr, i, void 0, !(64 & ~i.current.flags));
                } catch (t1) {}
                if (Al(t1, Qr()), Xo) throw Xo = !1, t1 = Zo, Zo = null, t1;
                return 8 & Do || Yr(), null;
            }
            function zl() {
                for(; null !== Yo;){
                    var t1 = Yo.alternate;
                    cl || null === ll || (8 & Yo.flags ? $t(Yo, ll) && (cl = !0) : 13 === Yo.tag && _o(t1, Yo) && $t(Yo, ll) && (cl = !0));
                    var e = Yo.flags;
                    256 & e && Ao(t1, Yo), !(512 & e) || Jo || (Jo = !0, Wr(97, function() {
                        return Ll(), null;
                    })), Yo = Yo.nextEffect;
                }
            }
            function Ll() {
                if (90 !== $o) {
                    var t1 = 97 < $o ? 97 : $o;
                    return $o = 90, Gr(t1, jl);
                }
                return !1;
            }
            function Ol(t1, e) {
                tl.push(e, t1), Jo || (Jo = !0, Wr(97, function() {
                    return Ll(), null;
                }));
            }
            function Pl(t1, e) {
                el.push(e, t1), Jo || (Jo = !0, Wr(97, function() {
                    return Ll(), null;
                }));
            }
            function jl() {
                if (null === Ko) return !1;
                var t1 = Ko;
                if (Ko = null, 48 & Do) throw Error(s(331));
                var e = Do;
                Do |= 32;
                var i = el;
                el = [];
                for(var n = 0; n < i.length; n += 2){
                    var r = i[n], a = i[n + 1], o = r.destroy;
                    if (r.destroy = void 0, "function" == typeof o) try {
                        o();
                    } catch (t1) {
                        if (null === a) throw Error(s(330));
                        kl(a, t1);
                    }
                }
                for(i = tl, tl = [], n = 0; n < i.length; n += 2){
                    r = i[n], a = i[n + 1];
                    try {
                        var l = r.create;
                        r.destroy = l();
                    } catch (t1) {
                        if (null === a) throw Error(s(330));
                        kl(a, t1);
                    }
                }
                for(l = t1.current.firstEffect; null !== l;)t1 = l.nextEffect, l.nextEffect = null, 8 & l.flags && (l.sibling = null, l.stateNode = null), l = t1;
                return Do = e, Yr(), !0;
            }
            function Rl(t1, e, i) {
                ua(t1, e = co(0, e = so(i, e), 1)), e = ul(), null !== (t1 = pl(t1, 1)) && (Qe(t1, 1, e), Al(t1, e));
            }
            function kl(t1, e) {
                if (3 === t1.tag) Rl(t1, t1, e);
                else for(var i = t1.return; null !== i;){
                    if (3 === i.tag) {
                        Rl(i, t1, e);
                        break;
                    }
                    if (1 === i.tag) {
                        var n = i.stateNode;
                        if ("function" == typeof i.type.getDerivedStateFromError || "function" == typeof n.componentDidCatch && (null === qo || !qo.has(n))) {
                            var r = uo(i, t1 = so(e, t1), 1);
                            if (ua(i, r), r = ul(), null !== (i = pl(i, 1))) Qe(i, 1, r), Al(i, r);
                            else if ("function" == typeof n.componentDidCatch && (null === qo || !qo.has(n))) try {
                                n.componentDidCatch(e, t1);
                            } catch (t1) {}
                            break;
                        }
                    }
                    i = i.return;
                }
            }
            function Ul(t1, e, i) {
                var n = t1.pingCache;
                null !== n && n.delete(e), e = ul(), t1.pingedLanes |= t1.suspendedLanes & i, Co === t1 && (Lo & i) === i && (4 === jo || 3 === jo && (62914560 & Lo) === Lo && 500 > Qr() - Ho ? wl(t1, 0) : Fo |= i), Al(t1, e);
            }
            function Bl(t1, e) {
                var i = t1.stateNode;
                null !== i && i.delete(e), 0 == (e = 0) && (2 & (e = t1.mode) ? 4 & e ? (0 === sl && (sl = ko), 0 === (e = Be(62914560 & ~sl)) && (e = 4194304)) : e = 99 === Hr() ? 1 : 2 : e = 1), i = ul(), null !== (t1 = pl(t1, e)) && (Qe(t1, e, i), Al(t1, i));
            }
            function Fl(t1, e, i, n) {
                this.tag = t1, this.key = i, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = e, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = n, this.flags = 0, this.lastEffect = this.firstEffect = this.nextEffect = null, this.childLanes = this.lanes = 0, this.alternate = null;
            }
            function Ql(t1, e, i, n) {
                return new Fl(t1, e, i, n);
            }
            function Hl(t1) {
                return !(!(t1 = t1.prototype) || !t1.isReactComponent);
            }
            function Vl(t1, e) {
                var i = t1.alternate;
                return null === i ? ((i = Ql(t1.tag, e, t1.key, t1.mode)).elementType = t1.elementType, i.type = t1.type, i.stateNode = t1.stateNode, i.alternate = t1, t1.alternate = i) : (i.pendingProps = e, i.type = t1.type, i.flags = 0, i.nextEffect = null, i.firstEffect = null, i.lastEffect = null), i.childLanes = t1.childLanes, i.lanes = t1.lanes, i.child = t1.child, i.memoizedProps = t1.memoizedProps, i.memoizedState = t1.memoizedState, i.updateQueue = t1.updateQueue, e = t1.dependencies, i.dependencies = null === e ? null : {
                    lanes: e.lanes,
                    firstContext: e.firstContext
                }, i.sibling = t1.sibling, i.index = t1.index, i.ref = t1.ref, i;
            }
            function Gl(t1, e, i, n, r, a) {
                var o = 2;
                if (n = t1, "function" == typeof t1) Hl(t1) && (o = 1);
                else if ("string" == typeof t1) o = 5;
                else t: switch(t1){
                    case T:
                        return Wl(i.children, r, a, e);
                    case j:
                        o = 8, r |= 16;
                        break;
                    case E:
                        o = 8, r |= 1;
                        break;
                    case _:
                        return (t1 = Ql(12, i, e, 8 | r)).elementType = _, t1.type = _, t1.lanes = a, t1;
                    case D:
                        return (t1 = Ql(13, i, e, r)).type = D, t1.elementType = D, t1.lanes = a, t1;
                    case C:
                        return (t1 = Ql(19, i, e, r)).elementType = C, t1.lanes = a, t1;
                    case R:
                        return Yl(i, r, a, e);
                    case k:
                        return (t1 = Ql(24, i, e, r)).elementType = k, t1.lanes = a, t1;
                    default:
                        if ("object" == typeof t1 && null !== t1) switch(t1.$$typeof){
                            case I:
                                o = 10;
                                break t;
                            case S:
                                o = 9;
                                break t;
                            case N:
                                o = 11;
                                break t;
                            case z:
                                o = 14;
                                break t;
                            case L:
                                o = 16, n = null;
                                break t;
                            case O:
                                o = 22;
                                break t;
                        }
                        throw Error(s(130, null == t1 ? t1 : typeof t1, ""));
                }
                return (e = Ql(o, i, e, r)).elementType = t1, e.type = n, e.lanes = a, e;
            }
            function Wl(t1, e, i, n) {
                return (t1 = Ql(7, t1, n, e)).lanes = i, t1;
            }
            function Yl(t1, e, i, n) {
                return (t1 = Ql(23, t1, n, e)).elementType = R, t1.lanes = i, t1;
            }
            function Xl(t1, e, i) {
                return (t1 = Ql(6, t1, null, e)).lanes = i, t1;
            }
            function Zl(t1, e, i) {
                return (e = Ql(4, null !== t1.children ? t1.children : [], t1.key, e)).lanes = i, e.stateNode = {
                    containerInfo: t1.containerInfo,
                    pendingChildren: null,
                    implementation: t1.implementation
                }, e;
            }
            function ql(t1, e, i) {
                this.tag = e, this.containerInfo = t1, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.pendingContext = this.context = null, this.hydrate = i, this.callbackNode = null, this.callbackPriority = 0, this.eventTimes = Fe(0), this.expirationTimes = Fe(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = Fe(0), this.mutableSourceEagerHydrationData = null;
            }
            function Jl(t1, e, i, n) {
                var r = e.current, a = ul(), o = hl(r);
                t: if (i) {
                    e: {
                        if (Zt(i = i._reactInternals) !== i || 1 !== i.tag) throw Error(s(170));
                        var l = i;
                        do {
                            switch(l.tag){
                                case 3:
                                    l = l.stateNode.context;
                                    break e;
                                case 1:
                                    if (mr(l.type)) {
                                        l = l.stateNode.__reactInternalMemoizedMergedChildContext;
                                        break e;
                                    }
                            }
                            l = l.return;
                        }while (null !== l);
                        throw Error(s(171));
                    }
                    if (1 === i.tag) {
                        var c = i.type;
                        if (mr(c)) {
                            i = vr(i, c, l);
                            break t;
                        }
                    }
                    i = l;
                } else i = hr;
                return null === e.context ? e.context = i : e.pendingContext = i, (e = ca(a, o)).payload = {
                    element: t1
                }, null !== (n = void 0 === n ? null : n) && (e.callback = n), ua(r, e), dl(r, o, a), o;
            }
            function Kl(t1) {
                return (t1 = t1.current).child ? (t1.child.tag, t1.child.stateNode) : null;
            }
            function $l(t1, e) {
                if (null !== (t1 = t1.memoizedState) && null !== t1.dehydrated) {
                    var i = t1.retryLane;
                    t1.retryLane = 0 !== i && i < e ? i : e;
                }
            }
            function tc(t1, e) {
                $l(t1, e), (t1 = t1.alternate) && $l(t1, e);
            }
            function ec(t1, e, i) {
                var n = null != i && null != i.hydrationOptions && i.hydrationOptions.mutableSources || null;
                if (i = new ql(t1, e, null != i && !0 === i.hydrate), e = Ql(3, null, null, 2 === e ? 7 : 1 === e ? 3 : 0), i.current = e, e.stateNode = i, oa(e), t1[$n] = i.current, Cn(8 === t1.nodeType ? t1.parentNode : t1), n) for(t1 = 0; t1 < n.length; t1++){
                    var r = (e = n[t1])._getVersion;
                    r = r(e._source), null == i.mutableSourceEagerHydrationData ? i.mutableSourceEagerHydrationData = [
                        e,
                        r
                    ] : i.mutableSourceEagerHydrationData.push(e, r);
                }
                this._internalRoot = i;
            }
            function ic(t1) {
                return !(!t1 || 1 !== t1.nodeType && 9 !== t1.nodeType && 11 !== t1.nodeType && (8 !== t1.nodeType || " react-mount-point-unstable " !== t1.nodeValue));
            }
            function nc(t1, e, i, n, r) {
                var a = i._reactRootContainer;
                if (a) {
                    var s = a._internalRoot;
                    if ("function" == typeof r) {
                        var o = r;
                        r = function() {
                            var t1 = Kl(s);
                            o.call(t1);
                        };
                    }
                    Jl(e, s, t1, r);
                } else {
                    if (a = i._reactRootContainer = function(t1, e) {
                        if (e || (e = !(!(e = t1 ? 9 === t1.nodeType ? t1.documentElement : t1.firstChild : null) || 1 !== e.nodeType || !e.hasAttribute("data-reactroot"))), !e) for(var i; i = t1.lastChild;)t1.removeChild(i);
                        return new ec(t1, 0, e ? {
                            hydrate: !0
                        } : void 0);
                    }(i, n), s = a._internalRoot, "function" == typeof r) {
                        var l = r;
                        r = function() {
                            var t1 = Kl(s);
                            l.call(t1);
                        };
                    }
                    vl(function() {
                        Jl(e, s, t1, r);
                    });
                }
                return Kl(s);
            }
            function rc(t1, e) {
                var i = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
                if (!ic(e)) throw Error(s(200));
                return function(t1, e, i) {
                    var n = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
                    return {
                        $$typeof: b,
                        key: null == n ? null : "" + n,
                        children: t1,
                        containerInfo: e,
                        implementation: i
                    };
                }(t1, e, null, i);
            }
            Wo = function(t1, e, i) {
                var n = e.lanes;
                if (null !== t1) {
                    if (t1.memoizedProps !== e.pendingProps || pr.current) Ps = !0;
                    else {
                        if (!(i & n)) {
                            switch(Ps = !1, e.tag){
                                case 3:
                                    Gs(e), Wa();
                                    break;
                                case 5:
                                    Oa(e);
                                    break;
                                case 1:
                                    mr(e.type) && yr(e);
                                    break;
                                case 4:
                                    za(e, e.stateNode.containerInfo);
                                    break;
                                case 10:
                                    n = e.memoizedProps.value;
                                    var r = e.type._context;
                                    ur(Jr, r._currentValue), r._currentValue = n;
                                    break;
                                case 13:
                                    if (null !== e.memoizedState) return i & e.child.childLanes ? Js(t1, e, i) : (ur(ja, 1 & ja.current), null !== (e = io(t1, e, i)) ? e.sibling : null);
                                    ur(ja, 1 & ja.current);
                                    break;
                                case 19:
                                    if (n = !!(i & e.childLanes), 64 & t1.flags) {
                                        if (n) return eo(t1, e, i);
                                        e.flags |= 64;
                                    }
                                    if (null !== (r = e.memoizedState) && (r.rendering = null, r.tail = null, r.lastEffect = null), ur(ja, ja.current), n) break;
                                    return null;
                                case 23:
                                case 24:
                                    return e.lanes = 0, Bs(t1, e, i);
                            }
                            return io(t1, e, i);
                        }
                        Ps = !!(16384 & t1.flags);
                    }
                } else Ps = !1;
                switch(e.lanes = 0, e.tag){
                    case 2:
                        if (n = e.type, null !== t1 && (t1.alternate = null, e.alternate = null, e.flags |= 2), t1 = e.pendingProps, r = fr(e, dr.current), ra(e, i), r = as(null, e, n, t1, r, i), e.flags |= 1, "object" == typeof r && null !== r && "function" == typeof r.render && void 0 === r.$$typeof) {
                            if (e.tag = 1, e.memoizedState = null, e.updateQueue = null, mr(n)) {
                                var a = !0;
                                yr(e);
                            } else a = !1;
                            e.memoizedState = null !== r.state && void 0 !== r.state ? r.state : null, oa(e);
                            var o = n.getDerivedStateFromProps;
                            "function" == typeof o && fa(e, n, o, t1), r.updater = ma, e.stateNode = r, r._reactInternals = e, ya(e, n, t1, i), e = Vs(null, e, n, !0, a, i);
                        } else e.tag = 0, js(null, e, r, i), e = e.child;
                        return e;
                    case 16:
                        r = e.elementType;
                        t: {
                            switch(null !== t1 && (t1.alternate = null, e.alternate = null, e.flags |= 2), t1 = e.pendingProps, r = (a = r._init)(r._payload), e.type = r, a = e.tag = function(t1) {
                                if ("function" == typeof t1) return Hl(t1) ? 1 : 0;
                                if (null != t1) {
                                    if ((t1 = t1.$$typeof) === N) return 11;
                                    if (t1 === z) return 14;
                                }
                                return 2;
                            }(r), t1 = qr(r, t1), a){
                                case 0:
                                    e = Qs(null, e, r, t1, i);
                                    break t;
                                case 1:
                                    e = Hs(null, e, r, t1, i);
                                    break t;
                                case 11:
                                    e = Rs(null, e, r, t1, i);
                                    break t;
                                case 14:
                                    e = ks(null, e, r, qr(r.type, t1), n, i);
                                    break t;
                            }
                            throw Error(s(306, r, ""));
                        }
                        return e;
                    case 0:
                        return n = e.type, r = e.pendingProps, Qs(t1, e, n, r = e.elementType === n ? r : qr(n, r), i);
                    case 1:
                        return n = e.type, r = e.pendingProps, Hs(t1, e, n, r = e.elementType === n ? r : qr(n, r), i);
                    case 3:
                        if (Gs(e), n = e.updateQueue, null === t1 || null === n) throw Error(s(282));
                        if (n = e.pendingProps, r = null !== (r = e.memoizedState) ? r.element : null, la(t1, e), da(e, n, null, i), (n = e.memoizedState.element) === r) Wa(), e = io(t1, e, i);
                        else {
                            if ((a = (r = e.stateNode).hydrate) && (Ua = Yn(e.stateNode.containerInfo.firstChild), ka = e, a = Ba = !0), a) {
                                if (null != (t1 = r.mutableSourceEagerHydrationData)) for(r = 0; r < t1.length; r += 2)(a = t1[r])._workInProgressVersionPrimary = t1[r + 1], Ya.push(a);
                                for(i = _a(e, null, n, i), e.child = i; i;)i.flags = -3 & i.flags | 1024, i = i.sibling;
                            } else js(t1, e, n, i), Wa();
                            e = e.child;
                        }
                        return e;
                    case 5:
                        return Oa(e), null === t1 && Ha(e), n = e.type, r = e.pendingProps, a = null !== t1 ? t1.memoizedProps : null, o = r.children, Hn(n, r) ? o = null : null !== a && Hn(n, a) && (e.flags |= 16), Fs(t1, e), js(t1, e, o, i), e.child;
                    case 6:
                        return null === t1 && Ha(e), null;
                    case 13:
                        return Js(t1, e, i);
                    case 4:
                        return za(e, e.stateNode.containerInfo), n = e.pendingProps, null === t1 ? e.child = Ea(e, null, n, i) : js(t1, e, n, i), e.child;
                    case 11:
                        return n = e.type, r = e.pendingProps, Rs(t1, e, n, r = e.elementType === n ? r : qr(n, r), i);
                    case 7:
                        return js(t1, e, e.pendingProps, i), e.child;
                    case 8:
                    case 12:
                        return js(t1, e, e.pendingProps.children, i), e.child;
                    case 10:
                        t: {
                            n = e.type._context, r = e.pendingProps, o = e.memoizedProps, a = r.value;
                            var l = e.type._context;
                            if (ur(Jr, l._currentValue), l._currentValue = a, null !== o) {
                                if (l = o.value, 0 == (a = cn(l, a) ? 0 : 0 | ("function" == typeof n._calculateChangedBits ? n._calculateChangedBits(l, a) : 1073741823))) {
                                    if (o.children === r.children && !pr.current) {
                                        e = io(t1, e, i);
                                        break t;
                                    }
                                } else for(null !== (l = e.child) && (l.return = e); null !== l;){
                                    var c = l.dependencies;
                                    if (null !== c) {
                                        o = l.child;
                                        for(var u = c.firstContext; null !== u;){
                                            if (u.context === n && u.observedBits & a) {
                                                1 === l.tag && ((u = ca(-1, i & -i)).tag = 2, ua(l, u)), l.lanes |= i, null !== (u = l.alternate) && (u.lanes |= i), na(l.return, i), c.lanes |= i;
                                                break;
                                            }
                                            u = u.next;
                                        }
                                    } else o = 10 === l.tag && l.type === e.type ? null : l.child;
                                    if (null !== o) o.return = l;
                                    else for(o = l; null !== o;){
                                        if (o === e) {
                                            o = null;
                                            break;
                                        }
                                        if (null !== (l = o.sibling)) {
                                            l.return = o.return, o = l;
                                            break;
                                        }
                                        o = o.return;
                                    }
                                    l = o;
                                }
                            }
                            js(t1, e, r.children, i), e = e.child;
                        }
                        return e;
                    case 9:
                        return r = e.type, n = (a = e.pendingProps).children, ra(e, i), n = n(r = aa(r, a.unstable_observedBits)), e.flags |= 1, js(t1, e, n, i), e.child;
                    case 14:
                        return a = qr(r = e.type, e.pendingProps), ks(t1, e, r, a = qr(r.type, a), n, i);
                    case 15:
                        return Us(t1, e, e.type, e.pendingProps, n, i);
                    case 17:
                        return n = e.type, r = e.pendingProps, r = e.elementType === n ? r : qr(n, r), null !== t1 && (t1.alternate = null, e.alternate = null, e.flags |= 2), e.tag = 1, mr(n) ? (t1 = !0, yr(e)) : t1 = !1, ra(e, i), Ma(e, n, r), ya(e, n, r, i), Vs(null, e, n, !0, t1, i);
                    case 19:
                        return eo(t1, e, i);
                    case 23:
                    case 24:
                        return Bs(t1, e, i);
                }
                throw Error(s(156, e.tag));
            }, ec.prototype.render = function(t1) {
                Jl(t1, this._internalRoot, null, null);
            }, ec.prototype.unmount = function() {
                var t1 = this._internalRoot, e = t1.containerInfo;
                Jl(null, t1, null, function() {
                    e[$n] = null;
                });
            }, te = function(t1) {
                13 === t1.tag && (dl(t1, 4, ul()), tc(t1, 4));
            }, ee = function(t1) {
                13 === t1.tag && (dl(t1, 67108864, ul()), tc(t1, 67108864));
            }, ie = function(t1) {
                if (13 === t1.tag) {
                    var e = ul(), i = hl(t1);
                    dl(t1, i, e), tc(t1, i);
                }
            }, ne = function(t1, e) {
                return e();
            }, _t = function(t1, e, i) {
                switch(e){
                    case "input":
                        if (it(t1, i), e = i.name, "radio" === i.type && null != e) {
                            for(i = t1; i.parentNode;)i = i.parentNode;
                            for(i = i.querySelectorAll("input[name=" + JSON.stringify("" + e) + '][type="radio"]'), e = 0; e < i.length; e++){
                                var n = i[e];
                                if (n !== t1 && n.form === t1.form) {
                                    var r = rr(n);
                                    if (!r) throw Error(s(90));
                                    J(n), it(n, r);
                                }
                            }
                        }
                        break;
                    case "textarea":
                        ct(t1, i);
                        break;
                    case "select":
                        null != (e = i.value) && st(t1, !!i.multiple, e, !1);
                }
            }, zt = Ml, Lt = function(t1, e, i, n, r) {
                var a = Do;
                Do |= 4;
                try {
                    return Gr(98, t1.bind(null, e, i, n, r));
                } finally{
                    0 === (Do = a) && (Go(), Yr());
                }
            }, Ot = function() {
                !(49 & Do) && (function() {
                    if (null !== il) {
                        var t1 = il;
                        il = null, t1.forEach(function(t1) {
                            t1.expiredLanes |= 24 & t1.pendingLanes, Al(t1, Qr());
                        });
                    }
                    Yr();
                }(), Ll());
            }, Pt = function(t1, e) {
                var i = Do;
                Do |= 2;
                try {
                    return t1(e);
                } finally{
                    0 === (Do = i) && (Go(), Yr());
                }
            };
            var ac = {
                Events: [
                    ir,
                    nr,
                    rr,
                    Dt,
                    Ct,
                    Ll,
                    {
                        current: !1
                    }
                ]
            }, sc = {
                findFiberByHostInstance: er,
                bundleType: 0,
                version: "17.0.2",
                rendererPackageName: "react-dom"
            }, oc = {
                bundleType: sc.bundleType,
                version: sc.version,
                rendererPackageName: sc.rendererPackageName,
                rendererConfig: sc.rendererConfig,
                overrideHookState: null,
                overrideHookStateDeletePath: null,
                overrideHookStateRenamePath: null,
                overrideProps: null,
                overridePropsDeletePath: null,
                overridePropsRenamePath: null,
                setSuspenseHandler: null,
                scheduleUpdate: null,
                currentDispatcherRef: x.ReactCurrentDispatcher,
                findHostInstanceByFiber: function(t1) {
                    return null === (t1 = Kt(t1)) ? null : t1.stateNode;
                },
                findFiberByHostInstance: sc.findFiberByHostInstance || function() {
                    return null;
                },
                findHostInstancesForRefresh: null,
                scheduleRefresh: null,
                scheduleRoot: null,
                setRefreshHandler: null,
                getCurrentFiber: null
            };
            if ("undefined" != typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
                var lc = __REACT_DEVTOOLS_GLOBAL_HOOK__;
                if (!lc.isDisabled && lc.supportsFiber) try {
                    wr = lc.inject(oc), br = lc;
                } catch (ft) {}
            }
            e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ac, e.createPortal = rc, e.findDOMNode = function(t1) {
                if (null == t1) return null;
                if (1 === t1.nodeType) return t1;
                var e = t1._reactInternals;
                if (void 0 === e) {
                    if ("function" == typeof t1.render) throw Error(s(188));
                    throw Error(s(268, Object.keys(t1)));
                }
                return null === (t1 = Kt(e)) ? null : t1.stateNode;
            }, e.flushSync = function(t1, e) {
                var i = Do;
                if (48 & i) return t1(e);
                Do |= 1;
                try {
                    if (t1) return Gr(99, t1.bind(null, e));
                } finally{
                    Do = i, Yr();
                }
            }, e.hydrate = function(t1, e, i) {
                if (!ic(e)) throw Error(s(200));
                return nc(null, t1, e, !0, i);
            }, e.render = function(t1, e, i) {
                if (!ic(e)) throw Error(s(200));
                return nc(null, t1, e, !1, i);
            }, e.unmountComponentAtNode = function(t1) {
                if (!ic(t1)) throw Error(s(40));
                return !!t1._reactRootContainer && (vl(function() {
                    nc(null, null, t1, !1, function() {
                        t1._reactRootContainer = null, t1[$n] = null;
                    });
                }), !0);
            }, e.unstable_batchedUpdates = Ml, e.unstable_createPortal = function(t1, e) {
                return rc(t1, e, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
            }, e.unstable_renderSubtreeIntoContainer = function(t1, e, i, n) {
                if (!ic(i)) throw Error(s(200));
                if (null == t1 || void 0 === t1._reactInternals) throw Error(s(38));
                return nc(t1, e, i, !1, n);
            }, e.version = "17.0.2";
        },
        961: (t1, e, i)=>{
            "use strict";
            !function t1() {
                if ("undefined" != typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" == typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE) try {
                    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(t1);
                } catch (t1) {
                    console.error(t1);
                }
            }(), t1.exports = i(551);
        },
        287: (t1, e, i)=>{
            "use strict";
            var n = i(228), r = 60103, a = 60106;
            e.Fragment = 60107, e.StrictMode = 60108, e.Profiler = 60114;
            var s = 60109, o = 60110, l = 60112;
            e.Suspense = 60113;
            var c = 60115, u = 60116;
            if ("function" == typeof Symbol && Symbol.for) {
                var h = Symbol.for;
                r = h("react.element"), a = h("react.portal"), e.Fragment = h("react.fragment"), e.StrictMode = h("react.strict_mode"), e.Profiler = h("react.profiler"), s = h("react.provider"), o = h("react.context"), l = h("react.forward_ref"), e.Suspense = h("react.suspense"), c = h("react.memo"), u = h("react.lazy");
            }
            var d = "function" == typeof Symbol && Symbol.iterator;
            function p(t1) {
                for(var e = "https://reactjs.org/docs/error-decoder.html?invariant=" + t1, i = 1; i < arguments.length; i++)e += "&args[]=" + encodeURIComponent(arguments[i]);
                return "Minified React error #" + t1 + "; visit " + e + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
            }
            var A = {
                isMounted: function() {
                    return !1;
                },
                enqueueForceUpdate: function() {},
                enqueueReplaceState: function() {},
                enqueueSetState: function() {}
            }, f = {};
            function m(t1, e, i) {
                this.props = t1, this.context = e, this.refs = f, this.updater = i || A;
            }
            function g() {}
            function M(t1, e, i) {
                this.props = t1, this.context = e, this.refs = f, this.updater = i || A;
            }
            m.prototype.isReactComponent = {}, m.prototype.setState = function(t1, e) {
                if ("object" != typeof t1 && "function" != typeof t1 && null != t1) throw Error(p(85));
                this.updater.enqueueSetState(this, t1, e, "setState");
            }, m.prototype.forceUpdate = function(t1) {
                this.updater.enqueueForceUpdate(this, t1, "forceUpdate");
            }, g.prototype = m.prototype;
            var v = M.prototype = new g;
            v.constructor = M, n(v, m.prototype), v.isPureReactComponent = !0;
            var y = {
                current: null
            }, x = Object.prototype.hasOwnProperty, w = {
                key: !0,
                ref: !0,
                __self: !0,
                __source: !0
            };
            function b(t1, e, i) {
                var n, a = {}, s = null, o = null;
                if (null != e) for(n in void 0 !== e.ref && (o = e.ref), void 0 !== e.key && (s = "" + e.key), e)x.call(e, n) && !w.hasOwnProperty(n) && (a[n] = e[n]);
                var l = arguments.length - 2;
                if (1 === l) a.children = i;
                else if (1 < l) {
                    for(var c = Array(l), u = 0; u < l; u++)c[u] = arguments[u + 2];
                    a.children = c;
                }
                if (t1 && t1.defaultProps) for(n in l = t1.defaultProps)void 0 === a[n] && (a[n] = l[n]);
                return {
                    $$typeof: r,
                    type: t1,
                    key: s,
                    ref: o,
                    props: a,
                    _owner: y.current
                };
            }
            function T(t1) {
                return "object" == typeof t1 && null !== t1 && t1.$$typeof === r;
            }
            var E = /\/+/g;
            function _(t1, e) {
                return "object" == typeof t1 && null !== t1 && null != t1.key ? function(t1) {
                    var e = {
                        "=": "=0",
                        ":": "=2"
                    };
                    return "$" + t1.replace(/[=:]/g, function(t1) {
                        return e[t1];
                    });
                }("" + t1.key) : e.toString(36);
            }
            function I(t1, e, i, n, s) {
                var o = typeof t1;
                "undefined" !== o && "boolean" !== o || (t1 = null);
                var l = !1;
                if (null === t1) l = !0;
                else switch(o){
                    case "string":
                    case "number":
                        l = !0;
                        break;
                    case "object":
                        switch(t1.$$typeof){
                            case r:
                            case a:
                                l = !0;
                        }
                }
                if (l) return s = s(l = t1), t1 = "" === n ? "." + _(l, 0) : n, Array.isArray(s) ? (i = "", null != t1 && (i = t1.replace(E, "$&/") + "/"), I(s, e, i, "", function(t1) {
                    return t1;
                })) : null != s && (T(s) && (s = function(t1, e) {
                    return {
                        $$typeof: r,
                        type: t1.type,
                        key: e,
                        ref: t1.ref,
                        props: t1.props,
                        _owner: t1._owner
                    };
                }(s, i + (!s.key || l && l.key === s.key ? "" : ("" + s.key).replace(E, "$&/") + "/") + t1)), e.push(s)), 1;
                if (l = 0, n = "" === n ? "." : n + ":", Array.isArray(t1)) for(var c = 0; c < t1.length; c++){
                    var u = n + _(o = t1[c], c);
                    l += I(o, e, i, u, s);
                }
                else if (u = function(t1) {
                    return null === t1 || "object" != typeof t1 ? null : "function" == typeof (t1 = d && t1[d] || t1["@@iterator"]) ? t1 : null;
                }(t1), "function" == typeof u) for(t1 = u.call(t1), c = 0; !(o = t1.next()).done;)l += I(o = o.value, e, i, u = n + _(o, c++), s);
                else if ("object" === o) throw e = "" + t1, Error(p(31, "[object Object]" === e ? "object with keys {" + Object.keys(t1).join(", ") + "}" : e));
                return l;
            }
            function S(t1, e, i) {
                if (null == t1) return t1;
                var n = [], r = 0;
                return I(t1, n, "", "", function(t1) {
                    return e.call(i, t1, r++);
                }), n;
            }
            function N(t1) {
                if (-1 === t1._status) {
                    var e = t1._result;
                    e = e(), t1._status = 0, t1._result = e, e.then(function(e) {
                        0 === t1._status && (e = e.default, t1._status = 1, t1._result = e);
                    }, function(e) {
                        0 === t1._status && (t1._status = 2, t1._result = e);
                    });
                }
                if (1 === t1._status) return t1._result;
                throw t1._result;
            }
            var D = {
                current: null
            };
            function C() {
                var t1 = D.current;
                if (null === t1) throw Error(p(321));
                return t1;
            }
            var z = {
                ReactCurrentDispatcher: D,
                ReactCurrentBatchConfig: {
                    transition: 0
                },
                ReactCurrentOwner: y,
                IsSomeRendererActing: {
                    current: !1
                },
                assign: n
            };
            e.Children = {
                map: S,
                forEach: function(t1, e, i) {
                    S(t1, function() {
                        e.apply(this, arguments);
                    }, i);
                },
                count: function(t1) {
                    var e = 0;
                    return S(t1, function() {
                        e++;
                    }), e;
                },
                toArray: function(t1) {
                    return S(t1, function(t1) {
                        return t1;
                    }) || [];
                },
                only: function(t1) {
                    if (!T(t1)) throw Error(p(143));
                    return t1;
                }
            }, e.Component = m, e.PureComponent = M, e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = z, e.cloneElement = function(t1, e, i) {
                if (null == t1) throw Error(p(267, t1));
                var a = n({}, t1.props), s = t1.key, o = t1.ref, l = t1._owner;
                if (null != e) {
                    if (void 0 !== e.ref && (o = e.ref, l = y.current), void 0 !== e.key && (s = "" + e.key), t1.type && t1.type.defaultProps) var c = t1.type.defaultProps;
                    for(u in e)x.call(e, u) && !w.hasOwnProperty(u) && (a[u] = void 0 === e[u] && void 0 !== c ? c[u] : e[u]);
                }
                var u = arguments.length - 2;
                if (1 === u) a.children = i;
                else if (1 < u) {
                    c = Array(u);
                    for(var h = 0; h < u; h++)c[h] = arguments[h + 2];
                    a.children = c;
                }
                return {
                    $$typeof: r,
                    type: t1.type,
                    key: s,
                    ref: o,
                    props: a,
                    _owner: l
                };
            }, e.createContext = function(t1, e) {
                return void 0 === e && (e = null), (t1 = {
                    $$typeof: o,
                    _calculateChangedBits: e,
                    _currentValue: t1,
                    _currentValue2: t1,
                    _threadCount: 0,
                    Provider: null,
                    Consumer: null
                }).Provider = {
                    $$typeof: s,
                    _context: t1
                }, t1.Consumer = t1;
            }, e.createElement = b, e.createFactory = function(t1) {
                var e = b.bind(null, t1);
                return e.type = t1, e;
            }, e.createRef = function() {
                return {
                    current: null
                };
            }, e.forwardRef = function(t1) {
                return {
                    $$typeof: l,
                    render: t1
                };
            }, e.isValidElement = T, e.lazy = function(t1) {
                return {
                    $$typeof: u,
                    _payload: {
                        _status: -1,
                        _result: t1
                    },
                    _init: N
                };
            }, e.memo = function(t1, e) {
                return {
                    $$typeof: c,
                    type: t1,
                    compare: void 0 === e ? null : e
                };
            }, e.useCallback = function(t1, e) {
                return C().useCallback(t1, e);
            }, e.useContext = function(t1, e) {
                return C().useContext(t1, e);
            }, e.useDebugValue = function() {}, e.useEffect = function(t1, e) {
                return C().useEffect(t1, e);
            }, e.useImperativeHandle = function(t1, e, i) {
                return C().useImperativeHandle(t1, e, i);
            }, e.useLayoutEffect = function(t1, e) {
                return C().useLayoutEffect(t1, e);
            }, e.useMemo = function(t1, e) {
                return C().useMemo(t1, e);
            }, e.useReducer = function(t1, e, i) {
                return C().useReducer(t1, e, i);
            }, e.useRef = function(t1) {
                return C().useRef(t1);
            }, e.useState = function(t1) {
                return C().useState(t1);
            }, e.version = "17.0.2";
        },
        540: (t1, e, i)=>{
            "use strict";
            t1.exports = i(287);
        },
        463: (t1, e)=>{
            "use strict";
            var i, n, r, a;
            if ("object" == typeof performance && "function" == typeof performance.now) {
                var s = performance;
                e.unstable_now = function() {
                    return s.now();
                };
            } else {
                var o = Date, l = o.now();
                e.unstable_now = function() {
                    return o.now() - l;
                };
            }
            if ("undefined" == typeof window || "function" != typeof MessageChannel) {
                var c = null, u = null, h = function() {
                    if (null !== c) try {
                        var t1 = e.unstable_now();
                        c(!0, t1), c = null;
                    } catch (t1) {
                        throw setTimeout(h, 0), t1;
                    }
                };
                i = function(t1) {
                    null !== c ? setTimeout(i, 0, t1) : (c = t1, setTimeout(h, 0));
                }, n = function(t1, e) {
                    u = setTimeout(t1, e);
                }, r = function() {
                    clearTimeout(u);
                }, e.unstable_shouldYield = function() {
                    return !1;
                }, a = e.unstable_forceFrameRate = function() {};
            } else {
                var d = window.setTimeout, p = window.clearTimeout;
                if ("undefined" != typeof console) {
                    var A = window.cancelAnimationFrame;
                    "function" != typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"), "function" != typeof A && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
                }
                var f = !1, m = null, g = -1, M = 5, v = 0;
                e.unstable_shouldYield = function() {
                    return e.unstable_now() >= v;
                }, a = function() {}, e.unstable_forceFrameRate = function(t1) {
                    0 > t1 || 125 < t1 ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : M = 0 < t1 ? Math.floor(1e3 / t1) : 5;
                };
                var y = new MessageChannel, x = y.port2;
                y.port1.onmessage = function() {
                    if (null !== m) {
                        var t1 = e.unstable_now();
                        v = t1 + M;
                        try {
                            m(!0, t1) ? x.postMessage(null) : (f = !1, m = null);
                        } catch (t1) {
                            throw x.postMessage(null), t1;
                        }
                    } else f = !1;
                }, i = function(t1) {
                    m = t1, f || (f = !0, x.postMessage(null));
                }, n = function(t1, i) {
                    g = d(function() {
                        t1(e.unstable_now());
                    }, i);
                }, r = function() {
                    p(g), g = -1;
                };
            }
            function w(t1, e) {
                var i = t1.length;
                t1.push(e);
                t: for(;;){
                    var n = i - 1 >>> 1, r = t1[n];
                    if (!(void 0 !== r && 0 < E(r, e))) break t;
                    t1[n] = e, t1[i] = r, i = n;
                }
            }
            function b(t1) {
                return void 0 === (t1 = t1[0]) ? null : t1;
            }
            function T(t1) {
                var e = t1[0];
                if (void 0 !== e) {
                    var i = t1.pop();
                    if (i !== e) {
                        t1[0] = i;
                        t: for(var n = 0, r = t1.length; n < r;){
                            var a = 2 * (n + 1) - 1, s = t1[a], o = a + 1, l = t1[o];
                            if (void 0 !== s && 0 > E(s, i)) void 0 !== l && 0 > E(l, s) ? (t1[n] = l, t1[o] = i, n = o) : (t1[n] = s, t1[a] = i, n = a);
                            else {
                                if (!(void 0 !== l && 0 > E(l, i))) break t;
                                t1[n] = l, t1[o] = i, n = o;
                            }
                        }
                    }
                    return e;
                }
                return null;
            }
            function E(t1, e) {
                var i = t1.sortIndex - e.sortIndex;
                return 0 !== i ? i : t1.id - e.id;
            }
            var _ = [], I = [], S = 1, N = null, D = 3, C = !1, z = !1, L = !1;
            function O(t1) {
                for(var e = b(I); null !== e;){
                    if (null === e.callback) T(I);
                    else {
                        if (!(e.startTime <= t1)) break;
                        T(I), e.sortIndex = e.expirationTime, w(_, e);
                    }
                    e = b(I);
                }
            }
            function P(t1) {
                if (L = !1, O(t1), !z) {
                    if (null !== b(_)) z = !0, i(j);
                    else {
                        var e = b(I);
                        null !== e && n(P, e.startTime - t1);
                    }
                }
            }
            function j(t1, i) {
                z = !1, L && (L = !1, r()), C = !0;
                var a = D;
                try {
                    for(O(i), N = b(_); null !== N && (!(N.expirationTime > i) || t1 && !e.unstable_shouldYield());){
                        var s = N.callback;
                        if ("function" == typeof s) {
                            N.callback = null, D = N.priorityLevel;
                            var o = s(N.expirationTime <= i);
                            i = e.unstable_now(), "function" == typeof o ? N.callback = o : N === b(_) && T(_), O(i);
                        } else T(_);
                        N = b(_);
                    }
                    if (null !== N) var l = !0;
                    else {
                        var c = b(I);
                        null !== c && n(P, c.startTime - i), l = !1;
                    }
                    return l;
                } finally{
                    N = null, D = a, C = !1;
                }
            }
            var R = a;
            e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function(t1) {
                t1.callback = null;
            }, e.unstable_continueExecution = function() {
                z || C || (z = !0, i(j));
            }, e.unstable_getCurrentPriorityLevel = function() {
                return D;
            }, e.unstable_getFirstCallbackNode = function() {
                return b(_);
            }, e.unstable_next = function(t1) {
                switch(D){
                    case 1:
                    case 2:
                    case 3:
                        var e = 3;
                        break;
                    default:
                        e = D;
                }
                var i = D;
                D = e;
                try {
                    return t1();
                } finally{
                    D = i;
                }
            }, e.unstable_pauseExecution = function() {}, e.unstable_requestPaint = R, e.unstable_runWithPriority = function(t1, e) {
                switch(t1){
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                        break;
                    default:
                        t1 = 3;
                }
                var i = D;
                D = t1;
                try {
                    return e();
                } finally{
                    D = i;
                }
            }, e.unstable_scheduleCallback = function(t1, a, s) {
                var o = e.unstable_now();
                switch(s = "object" == typeof s && null !== s && "number" == typeof (s = s.delay) && 0 < s ? o + s : o, t1){
                    case 1:
                        var l = -1;
                        break;
                    case 2:
                        l = 250;
                        break;
                    case 5:
                        l = 1073741823;
                        break;
                    case 4:
                        l = 1e4;
                        break;
                    default:
                        l = 5e3;
                }
                return t1 = {
                    id: S++,
                    callback: a,
                    priorityLevel: t1,
                    startTime: s,
                    expirationTime: l = s + l,
                    sortIndex: -1
                }, s > o ? (t1.sortIndex = s, w(I, t1), null === b(_) && t1 === b(I) && (L ? r() : L = !0, n(P, s - o))) : (t1.sortIndex = l, w(_, t1), z || C || (z = !0, i(j))), t1;
            }, e.unstable_wrapCallback = function(t1) {
                var e = D;
                return function() {
                    var i = D;
                    D = e;
                    try {
                        return t1.apply(this, arguments);
                    } finally{
                        D = i;
                    }
                };
            };
        },
        982: (t1, e, i)=>{
            "use strict";
            t1.exports = i(463);
        },
        72: (t1)=>{
            "use strict";
            var e = [];
            function i(t1) {
                for(var i = -1, n = 0; n < e.length; n++)if (e[n].identifier === t1) {
                    i = n;
                    break;
                }
                return i;
            }
            function n(t1, n) {
                for(var a = {}, s = [], o = 0; o < t1.length; o++){
                    var l = t1[o], c = n.base ? l[0] + n.base : l[0], u = a[c] || 0, h = "".concat(c, " ").concat(u);
                    a[c] = u + 1;
                    var d = i(h), p = {
                        css: l[1],
                        media: l[2],
                        sourceMap: l[3],
                        supports: l[4],
                        layer: l[5]
                    };
                    if (-1 !== d) e[d].references++, e[d].updater(p);
                    else {
                        var A = r(p, n);
                        n.byIndex = o, e.splice(o, 0, {
                            identifier: h,
                            updater: A,
                            references: 1
                        });
                    }
                    s.push(h);
                }
                return s;
            }
            function r(t1, e) {
                var i = e.domAPI(e);
                return i.update(t1), function(e) {
                    if (e) {
                        if (e.css === t1.css && e.media === t1.media && e.sourceMap === t1.sourceMap && e.supports === t1.supports && e.layer === t1.layer) return;
                        i.update(t1 = e);
                    } else i.remove();
                };
            }
            t1.exports = function(t1, r) {
                var a = n(t1 = t1 || [], r = r || {});
                return function(t1) {
                    t1 = t1 || [];
                    for(var s = 0; s < a.length; s++){
                        var o = i(a[s]);
                        e[o].references--;
                    }
                    for(var l = n(t1, r), c = 0; c < a.length; c++){
                        var u = i(a[c]);
                        0 === e[u].references && (e[u].updater(), e.splice(u, 1));
                    }
                    a = l;
                };
            };
        },
        659: (t1)=>{
            "use strict";
            var e = {};
            t1.exports = function(t1, i) {
                var n = function(t1) {
                    if (void 0 === e[t1]) {
                        var i = document.querySelector(t1);
                        if (window.HTMLIFrameElement && i instanceof window.HTMLIFrameElement) try {
                            i = i.contentDocument.head;
                        } catch (t1) {
                            i = null;
                        }
                        e[t1] = i;
                    }
                    return e[t1];
                }(t1);
                if (!n) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
                n.appendChild(i);
            };
        },
        159: (t1)=>{
            "use strict";
            t1.exports = function(t1) {
                var e = document.createElement("style");
                return t1.setAttributes(e, t1.attributes), t1.insert(e, t1.options), e;
            };
        },
        56: (t1, e, i)=>{
            "use strict";
            t1.exports = function(t1) {
                var e = i.nc;
                e && t1.setAttribute("nonce", e);
            };
        },
        825: (t1)=>{
            "use strict";
            t1.exports = function(t1) {
                if ("undefined" == typeof document) return {
                    update: function() {},
                    remove: function() {}
                };
                var e = t1.insertStyleElement(t1);
                return {
                    update: function(i) {
                        !function(t1, e, i) {
                            var n = "";
                            i.supports && (n += "@supports (".concat(i.supports, ") {")), i.media && (n += "@media ".concat(i.media, " {"));
                            var r = void 0 !== i.layer;
                            r && (n += "@layer".concat(i.layer.length > 0 ? " ".concat(i.layer) : "", " {")), n += i.css, r && (n += "}"), i.media && (n += "}"), i.supports && (n += "}");
                            var a = i.sourceMap;
                            a && "undefined" != typeof btoa && (n += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(a)))), " */")), e.styleTagTransform(n, t1, e.options);
                        }(e, t1, i);
                    },
                    remove: function() {
                        !function(t1) {
                            if (null === t1.parentNode) return !1;
                            t1.parentNode.removeChild(t1);
                        }(e);
                    }
                };
            };
        },
        113: (t1)=>{
            "use strict";
            t1.exports = function(t1, e) {
                if (e.styleSheet) e.styleSheet.cssText = t1;
                else {
                    for(; e.firstChild;)e.removeChild(e.firstChild);
                    e.appendChild(document.createTextNode(t1));
                }
            };
        },
        232: function(t1, e, i) {
            var n;
            !function(r, a) {
                "use strict";
                var s = "function", o = "undefined", l = "object", c = "string", u = "major", h = "model", d = "name", p = "type", A = "vendor", f = "version", m = "architecture", g = "console", M = "mobile", v = "tablet", y = "smarttv", x = "wearable", w = "embedded", b = "Amazon", T = "Apple", E = "ASUS", _ = "BlackBerry", I = "Browser", S = "Chrome", N = "Firefox", D = "Google", C = "Huawei", z = "LG", L = "Microsoft", O = "Motorola", P = "Opera", j = "Samsung", R = "Sharp", k = "Sony", U = "Xiaomi", B = "Zebra", F = "Facebook", Q = "Chromium OS", H = "Mac OS", V = function(t1) {
                    for(var e = {}, i = 0; i < t1.length; i++)e[t1[i].toUpperCase()] = t1[i];
                    return e;
                }, G = function(t1, e) {
                    return typeof t1 === c && -1 !== W(e).indexOf(W(t1));
                }, W = function(t1) {
                    return t1.toLowerCase();
                }, Y = function(t1, e) {
                    if (typeof t1 === c) return t1 = t1.replace(/^\s\s*/, ""), typeof e === o ? t1 : t1.substring(0, 500);
                }, X = function(t1, e) {
                    for(var i, n, r, o, c, u, h = 0; h < e.length && !c;){
                        var d = e[h], p = e[h + 1];
                        for(i = n = 0; i < d.length && !c && d[i];)if (c = d[i++].exec(t1)) for(r = 0; r < p.length; r++)u = c[++n], typeof (o = p[r]) === l && o.length > 0 ? 2 === o.length ? typeof o[1] == s ? this[o[0]] = o[1].call(this, u) : this[o[0]] = o[1] : 3 === o.length ? typeof o[1] !== s || o[1].exec && o[1].test ? this[o[0]] = u ? u.replace(o[1], o[2]) : a : this[o[0]] = u ? o[1].call(this, u, o[2]) : a : 4 === o.length && (this[o[0]] = u ? o[3].call(this, u.replace(o[1], o[2])) : a) : this[o] = u || a;
                        h += 2;
                    }
                }, Z = function(t1, e) {
                    for(var i in e)if (typeof e[i] === l && e[i].length > 0) {
                        for(var n = 0; n < e[i].length; n++)if (G(e[i][n], t1)) return "?" === i ? a : i;
                    } else if (G(e[i], t1)) return "?" === i ? a : i;
                    return t1;
                }, q = {
                    ME: "4.90",
                    "NT 3.11": "NT3.51",
                    "NT 4.0": "NT4.0",
                    2e3: "NT 5.0",
                    XP: [
                        "NT 5.1",
                        "NT 5.2"
                    ],
                    Vista: "NT 6.0",
                    7: "NT 6.1",
                    8: "NT 6.2",
                    8.1: "NT 6.3",
                    10: [
                        "NT 6.4",
                        "NT 10.0"
                    ],
                    RT: "ARM"
                }, J = {
                    browser: [
                        [
                            /\b(?:crmo|crios)\/([\w\.]+)/i
                        ],
                        [
                            f,
                            [
                                d,
                                "Chrome"
                            ]
                        ],
                        [
                            /edg(?:e|ios|a)?\/([\w\.]+)/i
                        ],
                        [
                            f,
                            [
                                d,
                                "Edge"
                            ]
                        ],
                        [
                            /(opera mini)\/([-\w\.]+)/i,
                            /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                            /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
                        ],
                        [
                            d,
                            f
                        ],
                        [
                            /opios[\/ ]+([\w\.]+)/i
                        ],
                        [
                            f,
                            [
                                d,
                                P + " Mini"
                            ]
                        ],
                        [
                            /\bop(?:rg)?x\/([\w\.]+)/i
                        ],
                        [
                            f,
                            [
                                d,
                                P + " GX"
                            ]
                        ],
                        [
                            /\bopr\/([\w\.]+)/i
                        ],
                        [
                            f,
                            [
                                d,
                                P
                            ]
                        ],
                        [
                            /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i
                        ],
                        [
                            f,
                            [
                                d,
                                "Baidu"
                            ]
                        ],
                        [
                            /(kindle)\/([\w\.]+)/i,
                            /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
                            /(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i,
                            /(?:ms|\()(ie) ([\w\.]+)/i,
                            /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
                            /(heytap|ovi)browser\/([\d\.]+)/i,
                            /(weibo)__([\d\.]+)/i
                        ],
                        [
                            d,
                            f
                        ],
                        [
                            /\bddg\/([\w\.]+)/i
                        ],
                        [
                            f,
                            [
                                d,
                                "DuckDuckGo"
                            ]
                        ],
                        [
                            /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
                        ],
                        [
                            f,
                            [
                                d,
                                "UC" + I
                            ]
                        ],
                        [
                            /microm.+\bqbcore\/([\w\.]+)/i,
                            /\bqbcore\/([\w\.]+).+microm/i,
                            /micromessenger\/([\w\.]+)/i
                        ],
                        [
                            f,
                            [
                                d,
                                "WeChat"
                            ]
                        ],
                        [
                            /konqueror\/([\w\.]+)/i
                        ],
                        [
                            f,
                            [
                                d,
                                "Konqueror"
                            ]
                        ],
                        [
                            /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
                        ],
                        [
                            f,
                            [
                                d,
                                "IE"
                            ]
                        ],
                        [
                            /ya(?:search)?browser\/([\w\.]+)/i
                        ],
                        [
                            f,
                            [
                                d,
                                "Yandex"
                            ]
                        ],
                        [
                            /slbrowser\/([\w\.]+)/i
                        ],
                        [
                            f,
                            [
                                d,
                                "Smart Lenovo " + I
                            ]
                        ],
                        [
                            /(avast|avg)\/([\w\.]+)/i
                        ],
                        [
                            [
                                d,
                                /(.+)/,
                                "$1 Secure " + I
                            ],
                            f
                        ],
                        [
                            /\bfocus\/([\w\.]+)/i
                        ],
                        [
                            f,
                            [
                                d,
                                N + " Focus"
                            ]
                        ],
                        [
                            /\bopt\/([\w\.]+)/i
                        ],
                        [
                            f,
                            [
                                d,
                                P + " Touch"
                            ]
                        ],
                        [
                            /coc_coc\w+\/([\w\.]+)/i
                        ],
                        [
                            f,
                            [
                                d,
                                "Coc Coc"
                            ]
                        ],
                        [
                            /dolfin\/([\w\.]+)/i
                        ],
                        [
                            f,
                            [
                                d,
                                "Dolphin"
                            ]
                        ],
                        [
                            /coast\/([\w\.]+)/i
                        ],
                        [
                            f,
                            [
                                d,
                                P + " Coast"
                            ]
                        ],
                        [
                            /miuibrowser\/([\w\.]+)/i
                        ],
                        [
                            f,
                            [
                                d,
                                "MIUI " + I
                            ]
                        ],
                        [
                            /fxios\/([-\w\.]+)/i
                        ],
                        [
                            f,
                            [
                                d,
                                N
                            ]
                        ],
                        [
                            /\bqihu|(qi?ho?o?|360)browser/i
                        ],
                        [
                            [
                                d,
                                "360 " + I
                            ]
                        ],
                        [
                            /(oculus|sailfish|huawei|vivo)browser\/([\w\.]+)/i
                        ],
                        [
                            [
                                d,
                                /(.+)/,
                                "$1 " + I
                            ],
                            f
                        ],
                        [
                            /samsungbrowser\/([\w\.]+)/i
                        ],
                        [
                            f,
                            [
                                d,
                                j + " Internet"
                            ]
                        ],
                        [
                            /(comodo_dragon)\/([\w\.]+)/i
                        ],
                        [
                            [
                                d,
                                /_/g,
                                " "
                            ],
                            f
                        ],
                        [
                            /metasr[\/ ]?([\d\.]+)/i
                        ],
                        [
                            f,
                            [
                                d,
                                "Sogou Explorer"
                            ]
                        ],
                        [
                            /(sogou)mo\w+\/([\d\.]+)/i
                        ],
                        [
                            [
                                d,
                                "Sogou Mobile"
                            ],
                            f
                        ],
                        [
                            /(electron)\/([\w\.]+) safari/i,
                            /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                            /m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i
                        ],
                        [
                            d,
                            f
                        ],
                        [
                            /(lbbrowser)/i,
                            /\[(linkedin)app\]/i
                        ],
                        [
                            d
                        ],
                        [
                            /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
                        ],
                        [
                            [
                                d,
                                F
                            ],
                            f
                        ],
                        [
                            /(Klarna)\/([\w\.]+)/i,
                            /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
                            /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
                            /safari (line)\/([\w\.]+)/i,
                            /\b(line)\/([\w\.]+)\/iab/i,
                            /(alipay)client\/([\w\.]+)/i,
                            /(twitter)(?:and| f.+e\/([\w\.]+))/i,
                            /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i
                        ],
                        [
                            d,
                            f
                        ],
                        [
                            /\bgsa\/([\w\.]+) .*safari\//i
                        ],
                        [
                            f,
                            [
                                d,
                                "GSA"
                            ]
                        ],
                        [
                            /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
                        ],
                        [
                            f,
                            [
                                d,
                                "TikTok"
                            ]
                        ],
                        [
                            /headlesschrome(?:\/([\w\.]+)| )/i
                        ],
                        [
                            f,
                            [
                                d,
                                S + " Headless"
                            ]
                        ],
                        [
                            / wv\).+(chrome)\/([\w\.]+)/i
                        ],
                        [
                            [
                                d,
                                S + " WebView"
                            ],
                            f
                        ],
                        [
                            /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
                        ],
                        [
                            f,
                            [
                                d,
                                "Android " + I
                            ]
                        ],
                        [
                            /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
                        ],
                        [
                            d,
                            f
                        ],
                        [
                            /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i
                        ],
                        [
                            f,
                            [
                                d,
                                "Mobile Safari"
                            ]
                        ],
                        [
                            /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i
                        ],
                        [
                            f,
                            d
                        ],
                        [
                            /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
                        ],
                        [
                            d,
                            [
                                f,
                                Z,
                                {
                                    "1.0": "/8",
                                    1.2: "/1",
                                    1.3: "/3",
                                    "2.0": "/412",
                                    "2.0.2": "/416",
                                    "2.0.3": "/417",
                                    "2.0.4": "/419",
                                    "?": "/"
                                }
                            ]
                        ],
                        [
                            /(webkit|khtml)\/([\w\.]+)/i
                        ],
                        [
                            d,
                            f
                        ],
                        [
                            /(navigator|netscape\d?)\/([-\w\.]+)/i
                        ],
                        [
                            [
                                d,
                                "Netscape"
                            ],
                            f
                        ],
                        [
                            /mobile vr; rv:([\w\.]+)\).+firefox/i
                        ],
                        [
                            f,
                            [
                                d,
                                N + " Reality"
                            ]
                        ],
                        [
                            /ekiohf.+(flow)\/([\w\.]+)/i,
                            /(swiftfox)/i,
                            /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
                            /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                            /(firefox)\/([\w\.]+)/i,
                            /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                            /(links) \(([\w\.]+)/i,
                            /panasonic;(viera)/i
                        ],
                        [
                            d,
                            f
                        ],
                        [
                            /(cobalt)\/([\w\.]+)/i
                        ],
                        [
                            d,
                            [
                                f,
                                /master.|lts./,
                                ""
                            ]
                        ]
                    ],
                    cpu: [
                        [
                            /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i
                        ],
                        [
                            [
                                m,
                                "amd64"
                            ]
                        ],
                        [
                            /(ia32(?=;))/i
                        ],
                        [
                            [
                                m,
                                W
                            ]
                        ],
                        [
                            /((?:i[346]|x)86)[;\)]/i
                        ],
                        [
                            [
                                m,
                                "ia32"
                            ]
                        ],
                        [
                            /\b(aarch64|arm(v?8e?l?|_?64))\b/i
                        ],
                        [
                            [
                                m,
                                "arm64"
                            ]
                        ],
                        [
                            /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i
                        ],
                        [
                            [
                                m,
                                "armhf"
                            ]
                        ],
                        [
                            /windows (ce|mobile); ppc;/i
                        ],
                        [
                            [
                                m,
                                "arm"
                            ]
                        ],
                        [
                            /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i
                        ],
                        [
                            [
                                m,
                                /ower/,
                                "",
                                W
                            ]
                        ],
                        [
                            /(sun4\w)[;\)]/i
                        ],
                        [
                            [
                                m,
                                "sparc"
                            ]
                        ],
                        [
                            /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
                        ],
                        [
                            [
                                m,
                                W
                            ]
                        ]
                    ],
                    device: [
                        [
                            /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
                        ],
                        [
                            h,
                            [
                                A,
                                j
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
                            /samsung[- ]([-\w]+)/i,
                            /sec-(sgh\w+)/i
                        ],
                        [
                            h,
                            [
                                A,
                                j
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
                        ],
                        [
                            h,
                            [
                                A,
                                T
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\((ipad);[-\w\),; ]+apple/i,
                            /applecoremedia\/[\w\.]+ \((ipad)/i,
                            /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
                        ],
                        [
                            h,
                            [
                                A,
                                T
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /(macintosh);/i
                        ],
                        [
                            h,
                            [
                                A,
                                T
                            ]
                        ],
                        [
                            /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
                        ],
                        [
                            h,
                            [
                                A,
                                R
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
                        ],
                        [
                            h,
                            [
                                A,
                                C
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /(?:huawei|honor)([-\w ]+)[;\)]/i,
                            /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
                        ],
                        [
                            h,
                            [
                                A,
                                C
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
                            /\b; (\w+) build\/hm\1/i,
                            /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                            /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                            /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
                            /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i
                        ],
                        [
                            [
                                h,
                                /_/g,
                                " "
                            ],
                            [
                                A,
                                U
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,
                            /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i
                        ],
                        [
                            [
                                h,
                                /_/g,
                                " "
                            ],
                            [
                                A,
                                U
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /; (\w+) bui.+ oppo/i,
                            /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
                        ],
                        [
                            h,
                            [
                                A,
                                "OPPO"
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\b(opd2\d{3}a?) bui/i
                        ],
                        [
                            h,
                            [
                                A,
                                "OPPO"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /vivo (\w+)(?: bui|\))/i,
                            /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
                        ],
                        [
                            h,
                            [
                                A,
                                "Vivo"
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
                        ],
                        [
                            h,
                            [
                                A,
                                "Realme"
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                            /\bmot(?:orola)?[- ](\w*)/i,
                            /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
                        ],
                        [
                            h,
                            [
                                A,
                                O
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\b(mz60\d|xoom[2 ]{0,2}) build\//i
                        ],
                        [
                            h,
                            [
                                A,
                                O
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
                        ],
                        [
                            h,
                            [
                                A,
                                z
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                            /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
                            /\blg-?([\d\w]+) bui/i
                        ],
                        [
                            h,
                            [
                                A,
                                z
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /(ideatab[-\w ]+)/i,
                            /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
                        ],
                        [
                            h,
                            [
                                A,
                                "Lenovo"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /(?:maemo|nokia).*(n900|lumia \d+)/i,
                            /nokia[-_ ]?([-\w\.]*)/i
                        ],
                        [
                            [
                                h,
                                /_/g,
                                " "
                            ],
                            [
                                A,
                                "Nokia"
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /(pixel c)\b/i
                        ],
                        [
                            h,
                            [
                                A,
                                D
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
                        ],
                        [
                            h,
                            [
                                A,
                                D
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
                        ],
                        [
                            h,
                            [
                                A,
                                k
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /sony tablet [ps]/i,
                            /\b(?:sony)?sgp\w+(?: bui|\))/i
                        ],
                        [
                            [
                                h,
                                "Xperia Tablet"
                            ],
                            [
                                A,
                                k
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            / (kb2005|in20[12]5|be20[12][59])\b/i,
                            /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
                        ],
                        [
                            h,
                            [
                                A,
                                "OnePlus"
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /(alexa)webm/i,
                            /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,
                            /(kf[a-z]+)( bui|\)).+silk\//i
                        ],
                        [
                            h,
                            [
                                A,
                                b
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
                        ],
                        [
                            [
                                h,
                                /(.+)/g,
                                "Fire Phone $1"
                            ],
                            [
                                A,
                                b
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /(playbook);[-\w\),; ]+(rim)/i
                        ],
                        [
                            h,
                            A,
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\b((?:bb[a-f]|st[hv])100-\d)/i,
                            /\(bb10; (\w+)/i
                        ],
                        [
                            h,
                            [
                                A,
                                _
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
                        ],
                        [
                            h,
                            [
                                A,
                                E
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
                        ],
                        [
                            h,
                            [
                                A,
                                E
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /(nexus 9)/i
                        ],
                        [
                            h,
                            [
                                A,
                                "HTC"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                            /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                            /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
                        ],
                        [
                            A,
                            [
                                h,
                                /_/g,
                                " "
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
                        ],
                        [
                            h,
                            [
                                A,
                                "Acer"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /droid.+; (m[1-5] note) bui/i,
                            /\bmz-([-\w]{2,})/i
                        ],
                        [
                            h,
                            [
                                A,
                                "Meizu"
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
                        ],
                        [
                            h,
                            [
                                A,
                                "Ulefone"
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i,
                            /(hp) ([\w ]+\w)/i,
                            /(asus)-?(\w+)/i,
                            /(microsoft); (lumia[\w ]+)/i,
                            /(lenovo)[-_ ]?([-\w]+)/i,
                            /(jolla)/i,
                            /(oppo) ?([\w ]+) bui/i
                        ],
                        [
                            A,
                            h,
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /(kobo)\s(ereader|touch)/i,
                            /(archos) (gamepad2?)/i,
                            /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                            /(kindle)\/([\w\.]+)/i,
                            /(nook)[\w ]+build\/(\w+)/i,
                            /(dell) (strea[kpr\d ]*[\dko])/i,
                            /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                            /(trinity)[- ]*(t\d{3}) bui/i,
                            /(gigaset)[- ]+(q\w{1,9}) bui/i,
                            /(vodafone) ([\w ]+)(?:\)| bui)/i
                        ],
                        [
                            A,
                            h,
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /(surface duo)/i
                        ],
                        [
                            h,
                            [
                                A,
                                L
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /droid [\d\.]+; (fp\du?)(?: b|\))/i
                        ],
                        [
                            h,
                            [
                                A,
                                "Fairphone"
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /(u304aa)/i
                        ],
                        [
                            h,
                            [
                                A,
                                "AT&T"
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\bsie-(\w*)/i
                        ],
                        [
                            h,
                            [
                                A,
                                "Siemens"
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\b(rct\w+) b/i
                        ],
                        [
                            h,
                            [
                                A,
                                "RCA"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\b(venue[\d ]{2,7}) b/i
                        ],
                        [
                            h,
                            [
                                A,
                                "Dell"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\b(q(?:mv|ta)\w+) b/i
                        ],
                        [
                            h,
                            [
                                A,
                                "Verizon"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
                        ],
                        [
                            h,
                            [
                                A,
                                "Barnes & Noble"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\b(tm\d{3}\w+) b/i
                        ],
                        [
                            h,
                            [
                                A,
                                "NuVision"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\b(k88) b/i
                        ],
                        [
                            h,
                            [
                                A,
                                "ZTE"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\b(nx\d{3}j) b/i
                        ],
                        [
                            h,
                            [
                                A,
                                "ZTE"
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\b(gen\d{3}) b.+49h/i
                        ],
                        [
                            h,
                            [
                                A,
                                "Swiss"
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\b(zur\d{3}) b/i
                        ],
                        [
                            h,
                            [
                                A,
                                "Swiss"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\b((zeki)?tb.*\b) b/i
                        ],
                        [
                            h,
                            [
                                A,
                                "Zeki"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\b([yr]\d{2}) b/i,
                            /\b(dragon[- ]+touch |dt)(\w{5}) b/i
                        ],
                        [
                            [
                                A,
                                "Dragon Touch"
                            ],
                            h,
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\b(ns-?\w{0,9}) b/i
                        ],
                        [
                            h,
                            [
                                A,
                                "Insignia"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\b((nxa|next)-?\w{0,9}) b/i
                        ],
                        [
                            h,
                            [
                                A,
                                "NextBook"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
                        ],
                        [
                            [
                                A,
                                "Voice"
                            ],
                            h,
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\b(lvtel\-)?(v1[12]) b/i
                        ],
                        [
                            [
                                A,
                                "LvTel"
                            ],
                            h,
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\b(ph-1) /i
                        ],
                        [
                            h,
                            [
                                A,
                                "Essential"
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\b(v(100md|700na|7011|917g).*\b) b/i
                        ],
                        [
                            h,
                            [
                                A,
                                "Envizen"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\b(trio[-\w\. ]+) b/i
                        ],
                        [
                            h,
                            [
                                A,
                                "MachSpeed"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\btu_(1491) b/i
                        ],
                        [
                            h,
                            [
                                A,
                                "Rotor"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /(shield[\w ]+) b/i
                        ],
                        [
                            h,
                            [
                                A,
                                "Nvidia"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /(sprint) (\w+)/i
                        ],
                        [
                            A,
                            h,
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /(kin\.[onetw]{3})/i
                        ],
                        [
                            [
                                h,
                                /\./g,
                                " "
                            ],
                            [
                                A,
                                L
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
                        ],
                        [
                            h,
                            [
                                A,
                                B
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
                        ],
                        [
                            h,
                            [
                                A,
                                B
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /smart-tv.+(samsung)/i
                        ],
                        [
                            A,
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /hbbtv.+maple;(\d+)/i
                        ],
                        [
                            [
                                h,
                                /^/,
                                "SmartTV"
                            ],
                            [
                                A,
                                j
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
                        ],
                        [
                            [
                                A,
                                z
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /(apple) ?tv/i
                        ],
                        [
                            A,
                            [
                                h,
                                T + " TV"
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /crkey/i
                        ],
                        [
                            [
                                h,
                                S + "cast"
                            ],
                            [
                                A,
                                D
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /droid.+aft(\w+)( bui|\))/i
                        ],
                        [
                            h,
                            [
                                A,
                                b
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /\(dtv[\);].+(aquos)/i,
                            /(aquos-tv[\w ]+)\)/i
                        ],
                        [
                            h,
                            [
                                A,
                                R
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /(bravia[\w ]+)( bui|\))/i
                        ],
                        [
                            h,
                            [
                                A,
                                k
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /(mitv-\w{5}) bui/i
                        ],
                        [
                            h,
                            [
                                A,
                                U
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /Hbbtv.*(technisat) (.*);/i
                        ],
                        [
                            A,
                            h,
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                            /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
                        ],
                        [
                            [
                                A,
                                Y
                            ],
                            [
                                h,
                                Y
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
                        ],
                        [
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /(ouya)/i,
                            /(nintendo) ([wids3utch]+)/i
                        ],
                        [
                            A,
                            h,
                            [
                                p,
                                g
                            ]
                        ],
                        [
                            /droid.+; (shield) bui/i
                        ],
                        [
                            h,
                            [
                                A,
                                "Nvidia"
                            ],
                            [
                                p,
                                g
                            ]
                        ],
                        [
                            /(playstation [345portablevi]+)/i
                        ],
                        [
                            h,
                            [
                                A,
                                k
                            ],
                            [
                                p,
                                g
                            ]
                        ],
                        [
                            /\b(xbox(?: one)?(?!; xbox))[\); ]/i
                        ],
                        [
                            h,
                            [
                                A,
                                L
                            ],
                            [
                                p,
                                g
                            ]
                        ],
                        [
                            /((pebble))app/i
                        ],
                        [
                            A,
                            h,
                            [
                                p,
                                x
                            ]
                        ],
                        [
                            /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
                        ],
                        [
                            h,
                            [
                                A,
                                T
                            ],
                            [
                                p,
                                x
                            ]
                        ],
                        [
                            /droid.+; (glass) \d/i
                        ],
                        [
                            h,
                            [
                                A,
                                D
                            ],
                            [
                                p,
                                x
                            ]
                        ],
                        [
                            /droid.+; (wt63?0{2,3})\)/i
                        ],
                        [
                            h,
                            [
                                A,
                                B
                            ],
                            [
                                p,
                                x
                            ]
                        ],
                        [
                            /(quest( \d| pro)?)/i
                        ],
                        [
                            h,
                            [
                                A,
                                F
                            ],
                            [
                                p,
                                x
                            ]
                        ],
                        [
                            /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
                        ],
                        [
                            A,
                            [
                                p,
                                w
                            ]
                        ],
                        [
                            /(aeobc)\b/i
                        ],
                        [
                            h,
                            [
                                A,
                                b
                            ],
                            [
                                p,
                                w
                            ]
                        ],
                        [
                            /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i
                        ],
                        [
                            h,
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
                        ],
                        [
                            h,
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
                        ],
                        [
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
                        ],
                        [
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /(android[-\w\. ]{0,9});.+buil/i
                        ],
                        [
                            h,
                            [
                                A,
                                "Generic"
                            ]
                        ]
                    ],
                    engine: [
                        [
                            /windows.+ edge\/([\w\.]+)/i
                        ],
                        [
                            f,
                            [
                                d,
                                "EdgeHTML"
                            ]
                        ],
                        [
                            /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
                        ],
                        [
                            f,
                            [
                                d,
                                "Blink"
                            ]
                        ],
                        [
                            /(presto)\/([\w\.]+)/i,
                            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
                            /ekioh(flow)\/([\w\.]+)/i,
                            /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                            /(icab)[\/ ]([23]\.[\d\.]+)/i,
                            /\b(libweb)/i
                        ],
                        [
                            d,
                            f
                        ],
                        [
                            /rv\:([\w\.]{1,9})\b.+(gecko)/i
                        ],
                        [
                            f,
                            d
                        ]
                    ],
                    os: [
                        [
                            /microsoft (windows) (vista|xp)/i
                        ],
                        [
                            d,
                            f
                        ],
                        [
                            /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i
                        ],
                        [
                            d,
                            [
                                f,
                                Z,
                                q
                            ]
                        ],
                        [
                            /windows nt 6\.2; (arm)/i,
                            /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,
                            /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
                        ],
                        [
                            [
                                f,
                                Z,
                                q
                            ],
                            [
                                d,
                                "Windows"
                            ]
                        ],
                        [
                            /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
                            /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
                            /cfnetwork\/.+darwin/i
                        ],
                        [
                            [
                                f,
                                /_/g,
                                "."
                            ],
                            [
                                d,
                                "iOS"
                            ]
                        ],
                        [
                            /(mac os x) ?([\w\. ]*)/i,
                            /(macintosh|mac_powerpc\b)(?!.+haiku)/i
                        ],
                        [
                            [
                                d,
                                H
                            ],
                            [
                                f,
                                /_/g,
                                "."
                            ]
                        ],
                        [
                            /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
                        ],
                        [
                            f,
                            d
                        ],
                        [
                            /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
                            /(blackberry)\w*\/([\w\.]*)/i,
                            /(tizen|kaios)[\/ ]([\w\.]+)/i,
                            /\((series40);/i
                        ],
                        [
                            d,
                            f
                        ],
                        [
                            /\(bb(10);/i
                        ],
                        [
                            f,
                            [
                                d,
                                _
                            ]
                        ],
                        [
                            /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i
                        ],
                        [
                            f,
                            [
                                d,
                                "Symbian"
                            ]
                        ],
                        [
                            /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
                        ],
                        [
                            f,
                            [
                                d,
                                N + " OS"
                            ]
                        ],
                        [
                            /web0s;.+rt(tv)/i,
                            /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
                        ],
                        [
                            f,
                            [
                                d,
                                "webOS"
                            ]
                        ],
                        [
                            /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
                        ],
                        [
                            f,
                            [
                                d,
                                "watchOS"
                            ]
                        ],
                        [
                            /crkey\/([\d\.]+)/i
                        ],
                        [
                            f,
                            [
                                d,
                                S + "cast"
                            ]
                        ],
                        [
                            /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
                        ],
                        [
                            [
                                d,
                                Q
                            ],
                            f
                        ],
                        [
                            /panasonic;(viera)/i,
                            /(netrange)mmh/i,
                            /(nettv)\/(\d+\.[\w\.]+)/i,
                            /(nintendo|playstation) ([wids345portablevuch]+)/i,
                            /(xbox); +xbox ([^\);]+)/i,
                            /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                            /(mint)[\/\(\) ]?(\w*)/i,
                            /(mageia|vectorlinux)[; ]/i,
                            /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                            /(hurd|linux) ?([\w\.]*)/i,
                            /(gnu) ?([\w\.]*)/i,
                            /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                            /(haiku) (\w+)/i
                        ],
                        [
                            d,
                            f
                        ],
                        [
                            /(sunos) ?([\w\.\d]*)/i
                        ],
                        [
                            [
                                d,
                                "Solaris"
                            ],
                            f
                        ],
                        [
                            /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                            /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                            /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
                            /(unix) ?([\w\.]*)/i
                        ],
                        [
                            d,
                            f
                        ]
                    ]
                }, K = function(t1, e) {
                    if (typeof t1 === l && (e = t1, t1 = a), !(this instanceof K)) return new K(t1, e).getResult();
                    var i = typeof r !== o && r.navigator ? r.navigator : a, n = t1 || (i && i.userAgent ? i.userAgent : ""), g = i && i.userAgentData ? i.userAgentData : a, y = e ? function(t1, e) {
                        var i = {};
                        for(var n in t1)e[n] && e[n].length % 2 == 0 ? i[n] = e[n].concat(t1[n]) : i[n] = t1[n];
                        return i;
                    }(J, e) : J, x = i && i.userAgent == n;
                    return this.getBrowser = function() {
                        var t1, e = {};
                        return e[d] = a, e[f] = a, X.call(e, n, y.browser), e[u] = typeof (t1 = e[f]) === c ? t1.replace(/[^\d\.]/g, "").split(".")[0] : a, x && i && i.brave && typeof i.brave.isBrave == s && (e[d] = "Brave"), e;
                    }, this.getCPU = function() {
                        var t1 = {};
                        return t1[m] = a, X.call(t1, n, y.cpu), t1;
                    }, this.getDevice = function() {
                        var t1 = {};
                        return t1[A] = a, t1[h] = a, t1[p] = a, X.call(t1, n, y.device), x && !t1[p] && g && g.mobile && (t1[p] = M), x && "Macintosh" == t1[h] && i && typeof i.standalone !== o && i.maxTouchPoints && i.maxTouchPoints > 2 && (t1[h] = "iPad", t1[p] = v), t1;
                    }, this.getEngine = function() {
                        var t1 = {};
                        return t1[d] = a, t1[f] = a, X.call(t1, n, y.engine), t1;
                    }, this.getOS = function() {
                        var t1 = {};
                        return t1[d] = a, t1[f] = a, X.call(t1, n, y.os), x && !t1[d] && g && g.platform && "Unknown" != g.platform && (t1[d] = g.platform.replace(/chrome os/i, Q).replace(/macos/i, H)), t1;
                    }, this.getResult = function() {
                        return {
                            ua: this.getUA(),
                            browser: this.getBrowser(),
                            engine: this.getEngine(),
                            os: this.getOS(),
                            device: this.getDevice(),
                            cpu: this.getCPU()
                        };
                    }, this.getUA = function() {
                        return n;
                    }, this.setUA = function(t1) {
                        return n = typeof t1 === c && t1.length > 500 ? Y(t1, 500) : t1, this;
                    }, this.setUA(n), this;
                };
                K.VERSION = "1.0.38", K.BROWSER = V([
                    d,
                    f,
                    u
                ]), K.CPU = V([
                    m
                ]), K.DEVICE = V([
                    h,
                    A,
                    p,
                    g,
                    M,
                    y,
                    v,
                    x,
                    w
                ]), K.ENGINE = K.OS = V([
                    d,
                    f
                ]), typeof e !== o ? (t1.exports && (e = t1.exports = K), e.UAParser = K) : i.amdO ? (n = (function() {
                    return K;
                }).call(e, i, e, t1)) === a || (t1.exports = n) : typeof r !== o && (r.UAParser = K);
                var $ = typeof r !== o && (r.jQuery || r.Zepto);
                if ($ && !$.ua) {
                    var tt = new K;
                    $.ua = tt.getResult(), $.ua.get = function() {
                        return tt.getUA();
                    }, $.ua.set = function(t1) {
                        tt.setUA(t1);
                        var e = tt.getResult();
                        for(var i in e)$.ua[i] = e[i];
                    };
                }
            }("object" == typeof window ? window : this);
        },
        964: (t1)=>{
            function e(t1, e, i) {
                t1.addEventListener("wheel", e, i);
            }
            t1.exports = e, t1.exports.addWheelListener = e, t1.exports.removeWheelListener = function(t1, e, i) {
                t1.removeEventListener("wheel", e, i);
            };
        },
        709: (t1)=>{
            "use strict";
            t1.exports = "data:font/woff;base64,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";
        },
        877: (t1)=>{
            "use strict";
            t1.exports = "data:font/woff2;base64,d09GMgABAAAAABwoAA4AAAAAMugAABvQAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHDYGYD9TVEFURACCDBEICtU0xA4Lgg4AATYCJAOCDgQgBYUSByAMBxs8KLMi2DgACNT2I4oSwciD/yqBB0OqDz8DOEoRqdqoY9qEtVZQUhoucrXvDh4W+x3H87R8ppxw0GyENCb2gOasWZKgXsRDIAQIkU2ygSSbDXGSQAwL6gUPpWLUsFK7FmpQMUr16n+lnHn5+kmvPalc9XrnLOlMnSEg3QXKNNNG43d7wjwQnbXYa7I+YInZdrel5Xny9n7BRpZhAkESAAQSeIKTqNsGQt1Wt/UBxWWSJhhZABZhmFo6QyWf/AqgSzwRTZ07ERgymzF2mV6mPrUF8SnQhLR3Af5a+kr3aX87ubR05FJhACsEhKCgoN23UvbevTv/1ep75k4lRXLTd5fcmpRSCsoEmYYZXlovyAEsgAUw1gpsAOIQEtUlKYcKinT08IgXMtTHZ/v76b+ra3qpRgxqQ2DX4+d7XxtAAMAV4sQjy06tCSKOntYGiDlbK+sh5iptb4IYAADOAAAAAPPzAMjkr/5CAaBsjw0gkfce0peqFrhPc4GrOUhQ3iLFrleAZEW2b7XsnwNwLpuTdsiuSwCQsaYBiIK8eGcYk/1bIq7Tdde0IzD/17I74gYIkMHbh4cExB0qAJAAAQckzaE0B3wgFkJMew4Z/iDv4MmQScLabaqZ6i12xBPHRlGHdw7keJnKNTjsdLFZDwX4p3Dw91z3/H39WxyXfAH5sFxCZ6k8UdEvW7QChWyKxIgVp8QypajKxCtXgaZSgkR0VYolqVajVp16DRoxNGnWgodPALOQULoMrUTEJHBtpNp1IHSS6bJcN70eBna9FumTLYfRYissYYIAMj8vCQAAq7l7IIBVwG0v4PMBpApQaPhD3vpfwKHUtuUAmBVIUqm018GoTKpMiZLnDr5U0nUwuiDT/HTqEvPXgwB9YQFxNhEG5AvAQLlaJezims+dpCOYjeyNQRQZIFG7O1Ld3HdsOELGQsu/jAcwxBmTiAnvM8t5tQHZTuW6Lx0out2JcxhC0+vEfmz5vG7ZcGOfvJhF+jmnqbXianJwkjIHWJMKa/xdixfRs8jXfK74ehEvum+xyDrlm/VV8NF+wSRtWyzd3Rn/YPiBJYuQa7mVGHG61tsVP18eIjT7p2YKkvMrpj9SCs4Er7D55N181bv0ioSdFinNa+2VjFZLUVPwUBaD0hLSQrISrKdSr5iZefTxvVuuujNrtGeMnAkcLYt+GR7xNaznmVxr7YaTLIJYgsHX6JqdB440pv8+GTYfTgBWpj/B9WuGgkKo0nuY8dQ033qmtHY0KV1OaOJj9Od3IFKgk8TcjV2d1NNF3T2YpjWnEmMvZENeWP1n9JYZ5J8FVMAV4rJCTSKPOGlJNtijIMEfVG9ZlXFD3jXmvPbBP1hotSwiLbSL2AfdfW9OP3WAeLntXlARPT6ZeI27Um4X3rhmZsbstGpqgMQu7fQVf24+btPZJ7Wk2XFELtzuiaVBhdLICltZLSvPzCLswi8KzL5pVAJh2+aRfVXBw8GjyPb8BzAE6iFItcmyb3Md4vdkrwv/Sw+v/mTrsqlWWB/7o5e/q5XS2sKBXvXRw8oaFkoH7m/C735r1kO72k1R7Gjz1bmJ8tiMk3v3O6jLrnR48GTOPdvPHpyP1VxFGcYlEi7MYRv6pcTgSRKhEGmve3MO+xDeHbPXJtFBLEcOTrdIaeKV3NouqVkgmNdwFJPOPOLdqu2e+3LEjsf3uhg46tjGkdqa7JAXeulfM5G8CEFXidej8CsTJHbgCVfjEhuSIiE8k9iwsx5ScEsW7umVtXNEufydMa68OQh0v6nXz2HsWBvZoDQJT9ye0LFudd2v5Zt2czGOecO2QCJbWcBYHAri2S5ooyVtHIPHiYsWVy6CZIbMaRVlzpZLKdyZVgaZilEnmL0BsXV128ow3VKbyIkqTvG5wscx1qYNJ6MaJhmsuSvcos45xRh/h5JFdsZ5GclszvL+Kjy3fjxmoqL+e0lxPuMKsje4ItBbM+dqxtXFoMOa3ON5MsVEHOfNRO3SwkgmlbznMrCGIrmm/OxBrjetrEI+2Zp12iATWcjQ+pM8kaHVlhqsSm2RNX+pff06LM1QK/aguDOOYcYoVcWMp0H6k1tgG4Gk5a82TjeJfRa4hMZ9nMm0NpDlz2TiiIbb6D8rAcmwRre2Q/SnOoBk9LMIXKvc6p8PbsIYR/y3N83/+hBL//bgGmEzcyf1qGE44/feUpYMjNnbm0X5ASbn3vo+H9SseCKsmTMCTj04bTV+xRQeCQSPoc2CDK59Rf33IOXaCfebdHmK+lP0Nht4cKcJZXZTU+XE3SxSMYpXOqYxUxL31kOLMyqScNDTphVNNLAdM6GX3083FFsVPgXaL3NOVxOoPmKC8pw7pe6Y5N418WIplZgXFWZGMdYbofjEGI2r1uKOzYmqpaA37r0VAoVl310muVUZcIDVqB7sMD1XjcTVJS2F36eSJpa1oLwKHG82yLSn4ywmGvZkktqYJcCLuZhVKY4x1MJYIj5V9IDMWs6fiL6d1AWWr6CI4SxOqqq4IJWy0kYcKUstfx7Lh5GmBFWt3rr0MjLZYGJsXNybxuRpvObko9ED90DR5GZFQbc/2duYvVo3ZzT9mw2rAWsog3l7xTbGyCTL9uUZD/leDq/tj3L4BTp8Uftld3MrdSiDxj1nIMVZvBOPdhdSICBQLJ2arYrZNLA2K67djW13TTYNazTIsThyg2kOrA26icMG5QeVQ77BZ9z8dPfKKteoE/meOZktYN++jSA1SscrsE2zsc0z2gBXh/7e6PmXUGwHS+sU9M0tsknUGWOrBPqOY/PC3yq2jXOqLaeduYsczeCuT94tN1/UfcC6hROS+VyMPN4KXxZ+YG7ugof7RBxLrZDQM0bjEzianJhdwFrc6sYkRhHQvRjF7HDR2J+F5dMYkU4QxUjlzAxaNsAVJxTsH14g4yQ6qCWo1XVkr+2ol6EL3XJATu4AO3Fq8CQ/fG5axN/H/IGTFF9jny/RB7dmLMgO/sSodAQKZKntA+PNGf+SK/L5Tm9iKvESzfqnT/YyLFDH+W5LJrIsiRac0aEBvXBxUlI/Uw0Dn3dwVTAY295BdJpyRO1ceX+cEoDYc4XrYcrYEkQbkNhA28W+8xhv85cU+/V73fX06w+Q6KVtd253s9RQCBskNJpos4eR61osPzQ1NaGsBCOsQkUiTV9wZrA8aAvIb4MiaJOn2hug7tOJVvFMVbBXdXxKfgiEZV+h+1rJqAAo0wKUPAZhn0n2QfJBdvPAX5G/Ao/MaX4zUKTNaDzat37j+vgg5E6D3xskhzcaGLReYgYTrGN7RfL7SUYepUiyfXX/mLC0bJdqcFC8Hyl6A0//rvybSGDHmAbUjJKbDxUcoExzEsF787QeKNPoLGwL+LqfFTQ6guydRYEybQryGwXifv1tkAdtDpr9ZmLdKtRkYifSK+xQMVJTX9rsObnG1opXo0Yje7GoHwQ9DnbMXS/ffn+JvwRvu3Onm6XVAnWJHeUL/rVO0vb4dlevsUd3In3zZIFWtboAdmH79hFbS0qk2w/s35VeiFxa8Pswfm+1AdnAFUdh/SZj+ooM0XqWDkDOtaOv0O+AakeBYgfaqM/+nfh7H9z4UXThEoXiVakfEhzuiZ03+5Q7RiAm0dL8vEG6QTFI23JA20HSZTsQRFlU6qLIdJk95v5XvHpEudMtD94OV8WpqbbFpQpB4+vXHI8TS0LXrysxxjs4lV/1YVdFDIyzcwWg01R9kUk9EWRAnOHbgtKlwyujYMSv5R2TLK9OknVQUQFlsNvAJwRS8RQUCvXiJ+9A8+JxVVnTscJ0TfmC4FehggE1iqsStVh9OpcyyTCuxZ2c0BGDh7+LQbJFJRiSgedrDB34bAAl0KXkcnbox4kJj0M96+xrj/gHHOmx54Nv7nWY/K+BN/r0v0UJMu+oPdMVMeLTlIULfcJtI+LERM5EOaeOcw70xxPxNy3hEWxIo0ONeCZdLVQfz8tnU/lC0RbNQPVnVdUYn6qUdpwR3Hk+f4pLcIjtxvLyHUaBMgf5lhbwjtVduLK3cioqduQUrH5/39mFii7o8bn/lwelte8pZ2qZWWnvlwQgtdy5dAOH2GKo51SEfvihVnXsNMos8w1ArPFvpyjo+FpLJbc+7PFjdQ43MFFW9OWXDXHC4pXqCxxNyjsgOuHCTtFuODsQk5mxLKCgTlvoJOdR9Prm+19uj1ar91Hx5CuiClm2pn7vyQ2J/6pXRzfmi6wisSwnIaHdnyVcHGrTZZYgMj7FqGnfNDkSrRWtC7dd1dSos7NqNuBRvdEKz94BeukTkRXa8pZ8q5z0vEBXbP5769/yC/RJTyX8elpaGd9aml7YH7vpVzxk4uSxb0J/OCGOnOWrj+i4uiSGNQIN2MzyrXgXUvzvn3LBL7gAnfrkbRfhFRfgzX2GpsYq3r+hD0ph6gPfvxGjiELpjAK9viwKwzhfr08qAP+HA4EQGOh9CZ+bIpcC/ux3hQeCmNWwN0Z8MAakAXY0/z9iIoD8HMpjwQ7srx4PJJBfXuFcaXR424jLcYXycmMTa5HK386JOl9yvmxCNk6kwOWqK02NKpC+cJtHmfjw8V0T6jKHM+XIXvWuKfFh7HllufjIcUwyqS6H+9+RCdXUcclhwMx2tAktAYqd9T0R2S/IsfZm9tTGjuqUCStb2zrEGge2xaFf8dcvrC3GQvqBZMm3Q5pK3QALjy2FTJ8rHPc8bEtg/FB66cK3Gth61JR0HSm1iVGxqkH4VGxky4aN5SWDGdTA9C3uVo5zuezQscuTmTUtB4o4CnkJ8S/SfbuB/xAt5Oafbl9SO5k5dUx2GBjU6fGQHheHwkTMdaWLxAUP78rI6mSGoiHfKXjHp+J63Qg3wmODONWh1sGXkALF/koN1QrGz2EbpXjIwKO/arQ65F30XRwxy5a3+XWhAv8lE6VWiehdGEo5e+fsWQM0chMYMYez8hOmqsxlyTpYszpl9s5sCnpxjQSsCd++DN2eKQncevNkASMT1gB/lR2VoTag2NOuqIKG4/Vg7ZBwuVEDOmhlI60F1D1jR9cqKvUjVFXgKnA7Mw2U6S02tm3InvCyAfg+a+cvy4PtnJERfLi4CB+ZlPqzmAeaqjGNFlYz6HRsUbZR0BcSuoaRBRogFtpG84Fi5/h8QbK5zbjYXIoijgcqgpSShkvpoyyb1Ra7Od1t+9dAke3/n2hrQK5/7oL/OVkdrZSNcPvzrs+Fy+/Wf4XlHGo8zDzcaDyE1X+17C7W9XnxF8wvoGbUodK0U8aVcU/wSgtOpShSVKklYw3Z7J4LH3WiUo/PG/lvrUlrVtQYN8lSZanTSYX5h7hSlpSVs4lUjJJMqmUXj2xOMhh2xN64oV1SIIotevmyLMUjotadc45/rqXFTZSSxyS9plYQBdplH0oYRxLM5nHmZ/e060h5IKqcZlKygZrNBso0i0kxAdXUHBkgDZg+GtsT6rLR1eRqijkWIg+VZ+Uxo9AIbx3nyV1Gp5fUE/df7yihSBxbgyMIFVDsbDjiZN4fRNQl799HVJyhPjhOhBrrJcs0KyNja4h4Dg1fXM8zpkZZaTx/Ewc8frPS3O3F7M1NBXvhzw9FTJ1mHzUE7401Q+FybHSCNgRmKGIjRVCWOuHqugWvsUzEGoI+Y4M7dZoJlOkjQLl7+4B3YKk2ZOW8D4pTN2sH9Oo4nJlGjz55MjOsTn9wnTloNLK7/kAp/Th8x77yVUErp6ExoUehpPU2NmI3NfiCl5//2MhP2ckGq/Gz+xI3ZGUlbNh/pl9iQ6ht/kCZ9PH/e++GAWnlZ4miu3FpZI9I14Zlww3wLX8DuJey1OmuXc1tjshrlzlOZcThYzsn5LUtu/OwLEUR/q/9NtIjJWfmYerd+c01E5njU7JDTmUcd4twS6DjQEZJ2bCJiUty+Y+Qeg0f5RcgjbxHEgtLNmgsLx3McAwUbIHMsvrbSE2Sl6w9Hu/VmStWN8TpWFXUf4pZM+Nf8pc2895MaxFtnlUZr1tVX1a0opym4dXSSNz0u9bo/5j51MzmbI2luThWQy+J+CXnrjH8F0ZphLS1wqKqUzzEKuKd4RwPKNNjZXBA+P4HxO7qzPgu8aRVYYvXdWfgdfd/Hy7ENhiKR1lWqLy5WwN97E/usvognv1I1BGKCS36l5756VMseZp8pKTcfXVnaGiINJdEoLR02bXZar+zBZ6DelWeaiRQH2gIOJjdAlWyMxlEBnFMV19/TJdBpBPEGaiiQ6V8SiR5dlRVzS3YhnfXinYguXTIE+5paNimKCp+S9HQkL4H8uiQK97eU7sVh88/JWBFZEy0qAn0PGrei+cVibSVR1VxR49E6PhGWX3z4rXBBKzhMrdKGgM//Ehglci4+Rc+bgpcutVlNoff4fX770csCoJtPXSoPqAEcDKJl44JSfAZV9nOEFWJ0HYLWebXRSoMPhykDzZotn2Oe+N3PjuFEsodgTkBOQFT8MCr30u8kVrql6F91fua9bon65Ww2Hc4XrTKq9mb5Q1TDOfc/B6cilPHojTyydBMqiQutz1PnJSv0xVTBY+ttHCPhGxKcWGnPOrpcKBUvinqhx8src45Qi88P+vEYLiQv9L3re3aIi07TnHzZ3341gMmStxh3mFaHvnGB8aIP//ak4WqlTahJGJbUIZgMOTYPWOrGNL9sSTj7ds8jPf+xedj4Owd6m3mJDz3zvni1YPXAkzgA6KVWJ/f4yCkMb9gQdvAoF6wO44bLYcS4XfPonudcScJuc/X57QPiQ/52UErfpZgrK+DYr+mBZ66eJGFCeBPjP/q7CsUQ33O+rgPHYfxSGdIIH9A4r3mfUkSkDZYb2xl+iW+iq+eLKyjDKADtZRJG1/FUwkvQwUdKoSXeGq+atJWSzmFnqoj78uM8dVjnMFcK+cgi0iTDltslNezGzZ7m7OknEOckhU7IrfIlIpCZW7Iii9eGsE5AN6bMCwVR7sKyDzyOBn+wnjzHGvojZu5TpJCZIj6lwurH4oe8eAXaOTvWFIykVQHJjiZmEV1A3cZloYdxNLI/WQWeQDcOf52X+HMrnzyp//bYHOzGpaluP6F2nU6nv2vv7wUNWBj/WgOZwf2XSN1+YrUKimRUr1iRWP8cwx+GR9jYSw5NHFthbRumYzWZSts4sqR5HEsDfunev5mPuPBw8hygSCi8uGP+cnvzJPxMR52SAujtG3b5H0Wi3zRtoOjCRpYyG19viQyKlpco9aIaqOjl0RJoBXi2oNrdml5ElSCHUNKWtAWpFQwheIovktbo11JX7AA60F0AnIeMbC0ZSs7r+20RaTKUOHXoIEODdJrGSqR6rSlPXtz8tiYcgXZJHDQiJrj/JfHwXmGRxqW9vufwphwKVGXqFxWWmJbWkRXM3JoH5rp6vATMZrE/DXdDXl9FpqEJuF91Cejq2IvJmg86i2G3JaKGE2UPOwQEHREGX0hXhvZYNKbm21RBFUVeRKED7CDClhHtVRJO7IXv7W3zS/2A2nk1YMzvNd/HxWUPfu1M/yLha47d1fHlCxJLoK4009R1j3evfvo/ae8K56Zqr4i3QqeErKhjW3TxSwFDfgFuIbX3rhpS5VE/fLTtWCZa5y2hVeso/aBPAAs9NEzp/uFNkUvPY6rr9pxDrqiqzdlp0qZ0pRjUGBADZCXeoQpTZVuzK5SLUr+85Ggk6JEHU34umzDMNfceqAAVfM06AxU0qEKvcpT8zQHC1r1g6kNhZlLnQyok1zY+OA3OxXor7G7Do9DHcpcQ93tiAOGfxeBhk1nERUV/ssdJA4SpC0eOd1DipFCLQsTUFtwCXUhpqpJkyLP5/homG3mmpm+9Lnr84XmhJmZ8EK42DWThqVJz0h9cSjnhIREt4gyoltCQ8rZOPL9bNqM0/elBvre0QUFbPYC2+hoNqPke6CZyWjXe7z3xtFxoJB5u+VLvEvsPOvPwXsW42G9RbyiVoxPPgPEPvthtJ2zoe7G20lHhO0ByZE2RbukgDkplJLE8ETqE0ZDfkNdZAs76B7Nfv5KtRCTKzmx7gvpT9oaxx6PC2MQzALlgsWcKx0RjkWffsKSMJLZffKpyo/ooHmsmb45HpEsvvRJf1JpQagJhTfvtbwn67mp/78MPXXz9Fz+i47zPuC4zSjr7OgYjFNZtjDGjqpXOudySRXGbVK2lH2MU2zek/zv06x1RcWGtc8lqTvxrMBLhZGz13Tcr76MsTqCNrOlvX1trCy7n52SIlrupOOSCuVbJyd3YgWGMcbjJ7pVuR5xZW9+L093cqqmRsj8h/mHDmm6oSO6ZlNOKsEkko9BIR3yk6eYslRiNKfaY3JRhxT0yzC2Vhw6qu1q/SCJMD+tIxobBwmcRH/ggyN6I5z0nyiYbZbuIuG7ggmzKOyH/5zQmH2CfeAQD2QAcIIQ8EBQKcPvJBi0iNjBERwBOOzI7l3gpCrnAhJnqSwNfpKS0VkASYgsyQicHWoObzFZNqaDp8y/li6SIl05opJukiTdZaT0kJ7shQsZwrHi9GuVvtJPBnIAVHplIa7zSgqy4De/QPpL76HQSgItkD5SlAV/87PJwLMWeFCYmxc0/7UQJ/SbmLQTFoPeiTPqm6z0/sXTy2+e8/98AwC4C8gBy9+8D8jRI4nrgPRXN9q7DAv65hPzkaa/c3TU4OEdb12+5j7/2Hqv+GI3ajW4BXKDp83ga8AZCs7DBUiCkxAWDlrbEjXbDX7wEipoCPOw3tUC5ZAHHbAU2ujceSdMHZMrJO46B0h/9oSBApJ5d0eJtSA1DY0dL8YWyjYjd06zrut53s35hKJBz9Bkda6dPnHqfBmT0XneNOxdx5voa1rTRlKShJs8XsbH6UMAgATw4ZZ3v5jpX6UYAADMNp8UAHD7FV/+p3+vo2ItA8AFHAAAAAH4Fx5H/jQ19v/Bjv6nEEn8hAOwu2XIXSdd1+ehCwa91GKpcyY9c8qAuz6xhSlP8iiGScezzoX3XZCHZ58YQ2Quesci6WqdweYO37pvoy2SXPXCsGFW63zuun4+jpvzhtaEOXPsBuICp43aiHDOdTut1QfgjAXWo5vzhfcN+dtd7xtzfdH0d2N3IvD+smdccNKgqjSEJO/Ac2V2igk0eV7/xDN69TdMVwR+e/maIACw2gmB+lFYY5K45glTggo53o4+DRYhEOU0OWSHry8iAcf9k5IXUSAkgYscISLMRZ5gim6Rt8DsXejDGXmwjQBwR16UQMNfLipLSL/wvwjNWvRoVatajXZRWJjScEUxBVBJOYPKGNqVhCxuEmQGrZXqslyOkOE6QDUta9WmOQFZNWqRGSaV6tVqgVt2KJOivHBjJzWjt1qDSlWTzG/XJtVOnzTuL1vionDRM2s16fFQ1To0KNWKLQXzZZ6Qgv5mCkIsux9NBgsS4VrARaLq8yFvSZf23PXSSVGqhbmcU07hiKpT1HBI5QE1Fa4k/dBaKoRMOkaZkrEmP/fS7oXVWpBUnJTis246bhRXSfB0+ubrVABAoPtc5lfdcAA=";
        },
        907: (t1)=>{
            "use strict";
            t1.exports = "data:font/woff;base64,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";
        },
        67: (t1)=>{
            "use strict";
            t1.exports = "data:font/woff2;base64,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";
        },
        356: (t1)=>{
            "use strict";
            t1.exports = "data:font/woff;base64,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";
        },
        702: (t1)=>{
            "use strict";
            t1.exports = "data:font/woff2;base64,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";
        },
        933: (t1)=>{
            "use strict";
            t1.exports = "data:font/woff;base64,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";
        },
        756: (t1)=>{
            "use strict";
            t1.exports = "data:font/woff2;base64,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";
        }
    }, e = {};
    function i(n) {
        var r = e[n];
        if (void 0 !== r) return r.exports;
        var a = e[n] = {
            id: n,
            exports: {}
        };
        return t1[n].call(a.exports, a, a.exports, i), a.exports;
    }
    i.m = t1, i.amdO = {}, i.n = (t1)=>{
        var e = t1 && t1.__esModule ? ()=>t1.default : ()=>t1;
        return i.d(e, {
            a: e
        }), e;
    }, i.d = (t1, e)=>{
        for(var n in e)i.o(e, n) && !i.o(t1, n) && Object.defineProperty(t1, n, {
            enumerable: !0,
            get: e[n]
        });
    }, i.g = function() {
        if ("object" == typeof globalThis) return globalThis;
        try {
            return this || new Function("return this")();
        } catch (t1) {
            if ("object" == typeof window) return window;
        }
    }(), i.o = (t1, e)=>Object.prototype.hasOwnProperty.call(t1, e), i.r = (t1)=>{
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t1, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(t1, "__esModule", {
            value: !0
        });
    }, i.b = document.baseURI || self.location.href, i.nc = void 0;
    var n = {};
    (()=>{
        "use strict";
        i.r(n), i.d(n, {
            ApiStore: ()=>Dn,
            Widget: ()=>$D,
            rotationModes: ()=>Yn
        });
        var t1 = {};
        i.r(t1), i.d(t1, {
            ACESFilmicToneMapping: ()=>Kr,
            AddEquation: ()=>gr,
            AddOperation: ()=>Yr,
            AdditiveAnimationBlendMode: ()=>Cs,
            AdditiveBlending: ()=>pr,
            AlphaFormat: ()=>za,
            AlwaysCompare: ()=>yo,
            AlwaysDepth: ()=>kr,
            AlwaysStencilFunc: ()=>ho,
            AmbientLight: ()=>jg,
            AnimationAction: ()=>EM,
            AnimationClip: ()=>sg,
            AnimationLoader: ()=>fg,
            AnimationMixer: ()=>IM,
            AnimationObjectGroup: ()=>TM,
            AnimationUtils: ()=>Ym,
            ArcCurve: ()=>df,
            ArrayCamera: ()=>Op,
            ArrowHelper: ()=>Mv,
            AttachedBindMode: ()=>ta,
            Audio: ()=>cM,
            AudioAnalyser: ()=>fM,
            AudioContext: ()=>qg,
            AudioListener: ()=>lM,
            AudioLoader: ()=>Jg,
            AxesHelper: ()=>vv,
            BackSide: ()=>lr,
            BasicDepthPacking: ()=>Rs,
            BasicShadowMap: ()=>nr,
            Bone: ()=>EA,
            BooleanKeyframeTrack: ()=>$m,
            Box2: ()=>UM,
            Box3: ()=>zl,
            Box3Helper: ()=>pv,
            BoxGeometry: ()=>Hu,
            BoxHelper: ()=>dv,
            BufferAttribute: ()=>au,
            BufferGeometry: ()=>bu,
            BufferGeometryLoader: ()=>Hg,
            ByteType: ()=>wa,
            Cache: ()=>lg,
            Camera: ()=>Zu,
            CameraHelper: ()=>cv,
            CanvasTexture: ()=>cf,
            CapsuleGeometry: ()=>Lf,
            CatmullRomCurve3: ()=>Mf,
            CineonToneMapping: ()=>Jr,
            CircleGeometry: ()=>Of,
            ClampToEdgeWrapping: ()=>ca,
            Clock: ()=>iM,
            Color: ()=>Yc,
            ColorKeyframeTrack: ()=>tg,
            ColorManagement: ()=>ul,
            CompressedArrayTexture: ()=>of,
            CompressedCubeTexture: ()=>lf,
            CompressedTexture: ()=>sf,
            CompressedTextureLoader: ()=>mg,
            ConeGeometry: ()=>jf,
            ConstantAlphaFactor: ()=>Pr,
            ConstantColorFactor: ()=>Lr,
            CubeCamera: ()=>Ku,
            CubeReflectionMapping: ()=>na,
            CubeRefractionMapping: ()=>ra,
            CubeTexture: ()=>$u,
            CubeTextureLoader: ()=>Mg,
            CubeUVReflectionMapping: ()=>oa,
            CubicBezierCurve: ()=>wf,
            CubicBezierCurve3: ()=>bf,
            CubicInterpolant: ()=>Zm,
            CullFaceBack: ()=>tr,
            CullFaceFront: ()=>er,
            CullFaceFrontBack: ()=>ir,
            CullFaceNone: ()=>$n,
            Curve: ()=>uf,
            CurvePath: ()=>Df,
            CustomBlending: ()=>mr,
            CustomToneMapping: ()=>$r,
            CylinderGeometry: ()=>Pf,
            Cylindrical: ()=>RM,
            Data3DTexture: ()=>El,
            DataArrayTexture: ()=>bl,
            DataTexture: ()=>_A,
            DataTextureLoader: ()=>vg,
            DataUtils: ()=>iu,
            DecrementStencilOp: ()=>to,
            DecrementWrapStencilOp: ()=>io,
            DefaultLoadingManager: ()=>ug,
            DepthFormat: ()=>ja,
            DepthStencilFormat: ()=>Ra,
            DepthTexture: ()=>kp,
            DetachedBindMode: ()=>ea,
            DirectionalLight: ()=>Pg,
            DirectionalLightHelper: ()=>sv,
            DiscreteInterpolant: ()=>Jm,
            DisplayP3ColorSpace: ()=>Vs,
            DodecahedronGeometry: ()=>kf,
            DoubleSide: ()=>cr,
            DstAlphaFactor: ()=>Sr,
            DstColorFactor: ()=>Dr,
            DynamicCopyUsage: ()=>So,
            DynamicDrawUsage: ()=>wo,
            DynamicReadUsage: ()=>Eo,
            EdgesGeometry: ()=>Hf,
            EllipseCurve: ()=>hf,
            EqualCompare: ()=>fo,
            EqualDepth: ()=>Fr,
            EqualStencilFunc: ()=>so,
            EquirectangularReflectionMapping: ()=>aa,
            EquirectangularRefractionMapping: ()=>sa,
            Euler: ()=>fc,
            EventDispatcher: ()=>Po,
            ExtrudeGeometry: ()=>Mm,
            FileLoader: ()=>Ag,
            Float16BufferAttribute: ()=>pu,
            Float32BufferAttribute: ()=>Au,
            Float64BufferAttribute: ()=>fu,
            FloatType: ()=>Ia,
            Fog: ()=>Gp,
            FogExp2: ()=>Vp,
            FramebufferTexture: ()=>af,
            FrontSide: ()=>or,
            Frustum: ()=>oh,
            GLBufferAttribute: ()=>zM,
            GLSL1: ()=>Do,
            GLSL3: ()=>Co,
            GreaterCompare: ()=>go,
            GreaterDepth: ()=>Hr,
            GreaterEqualCompare: ()=>vo,
            GreaterEqualDepth: ()=>Qr,
            GreaterEqualStencilFunc: ()=>uo,
            GreaterStencilFunc: ()=>lo,
            GridHelper: ()=>ev,
            Group: ()=>Pp,
            HalfFloatType: ()=>Sa,
            HemisphereLight: ()=>wg,
            HemisphereLightHelper: ()=>tv,
            IcosahedronGeometry: ()=>ym,
            ImageBitmapLoader: ()=>Xg,
            ImageLoader: ()=>gg,
            ImageUtils: ()=>Al,
            IncrementStencilOp: ()=>$s,
            IncrementWrapStencilOp: ()=>eo,
            InstancedBufferAttribute: ()=>DA,
            InstancedBufferGeometry: ()=>Qg,
            InstancedInterleavedBuffer: ()=>CM,
            InstancedMesh: ()=>kA,
            Int16BufferAttribute: ()=>cu,
            Int32BufferAttribute: ()=>hu,
            Int8BufferAttribute: ()=>su,
            IntType: ()=>Ea,
            InterleavedBuffer: ()=>Yp,
            InterleavedBufferAttribute: ()=>Zp,
            Interpolant: ()=>Xm,
            InterpolateDiscrete: ()=>Ts,
            InterpolateLinear: ()=>Es,
            InterpolateSmooth: ()=>_s,
            InvertStencilOp: ()=>no,
            KeepStencilOp: ()=>Js,
            KeyframeTrack: ()=>Km,
            LOD: ()=>AA,
            LatheGeometry: ()=>zf,
            Layers: ()=>mc,
            LessCompare: ()=>Ao,
            LessDepth: ()=>Ur,
            LessEqualCompare: ()=>mo,
            LessEqualDepth: ()=>Br,
            LessEqualStencilFunc: ()=>oo,
            LessStencilFunc: ()=>ao,
            Light: ()=>xg,
            LightProbe: ()=>Ug,
            Line: ()=>GA,
            Line3: ()=>QM,
            LineBasicMaterial: ()=>UA,
            LineCurve: ()=>Tf,
            LineCurve3: ()=>Ef,
            LineDashedMaterial: ()=>Fm,
            LineLoop: ()=>ZA,
            LineSegments: ()=>XA,
            LinearDisplayP3ColorSpace: ()=>Gs,
            LinearEncoding: ()=>Ps,
            LinearFilter: ()=>ma,
            LinearInterpolant: ()=>qm,
            LinearMipMapLinearFilter: ()=>ya,
            LinearMipMapNearestFilter: ()=>Ma,
            LinearMipmapLinearFilter: ()=>va,
            LinearMipmapNearestFilter: ()=>ga,
            LinearSRGBColorSpace: ()=>Hs,
            LinearToneMapping: ()=>Zr,
            LinearTransfer: ()=>Ws,
            Loader: ()=>hg,
            LoaderUtils: ()=>Fg,
            LoadingManager: ()=>cg,
            LoopOnce: ()=>xs,
            LoopPingPong: ()=>bs,
            LoopRepeat: ()=>ws,
            LuminanceAlphaFormat: ()=>Pa,
            LuminanceFormat: ()=>Oa,
            MOUSE: ()=>Jn,
            Material: ()=>qc,
            MaterialLoader: ()=>Bg,
            MathUtils: ()=>Zo,
            Matrix3: ()=>Jo,
            Matrix4: ()=>ac,
            MaxEquation: ()=>xr,
            Mesh: ()=>Fu,
            MeshBasicMaterial: ()=>Jc,
            MeshDepthMaterial: ()=>Sp,
            MeshDistanceMaterial: ()=>Np,
            MeshLambertMaterial: ()=>Um,
            MeshMatcapMaterial: ()=>Bm,
            MeshNormalMaterial: ()=>km,
            MeshPhongMaterial: ()=>jm,
            MeshPhysicalMaterial: ()=>Pm,
            MeshStandardMaterial: ()=>Om,
            MeshToonMaterial: ()=>Rm,
            MinEquation: ()=>yr,
            MirroredRepeatWrapping: ()=>ua,
            MixOperation: ()=>Wr,
            MultiplyBlending: ()=>fr,
            MultiplyOperation: ()=>Gr,
            NearestFilter: ()=>ha,
            NearestMipMapLinearFilter: ()=>fa,
            NearestMipMapNearestFilter: ()=>pa,
            NearestMipmapLinearFilter: ()=>Aa,
            NearestMipmapNearestFilter: ()=>da,
            NeverCompare: ()=>po,
            NeverDepth: ()=>Rr,
            NeverStencilFunc: ()=>ro,
            NoBlending: ()=>hr,
            NoColorSpace: ()=>Fs,
            NoToneMapping: ()=>Xr,
            NormalAnimationBlendMode: ()=>Ds,
            NormalBlending: ()=>dr,
            NotEqualCompare: ()=>Mo,
            NotEqualDepth: ()=>Vr,
            NotEqualStencilFunc: ()=>co,
            NumberKeyframeTrack: ()=>eg,
            Object3D: ()=>Dc,
            ObjectLoader: ()=>Vg,
            ObjectSpaceNormalMap: ()=>Bs,
            OctahedronGeometry: ()=>xm,
            OneFactor: ()=>br,
            OneMinusConstantAlphaFactor: ()=>jr,
            OneMinusConstantColorFactor: ()=>Or,
            OneMinusDstAlphaFactor: ()=>Nr,
            OneMinusDstColorFactor: ()=>Cr,
            OneMinusSrcAlphaFactor: ()=>Ir,
            OneMinusSrcColorFactor: ()=>Er,
            OrthographicCamera: ()=>xh,
            P3Primaries: ()=>Zs,
            PCFShadowMap: ()=>rr,
            PCFSoftShadowMap: ()=>ar,
            PMREMGenerator: ()=>Ch,
            Path: ()=>Cf,
            PerspectiveCamera: ()=>qu,
            Plane: ()=>rh,
            PlaneGeometry: ()=>uh,
            PlaneHelper: ()=>Av,
            PointLight: ()=>Lg,
            PointLightHelper: ()=>qM,
            Points: ()=>ef,
            PointsMaterial: ()=>qA,
            PolarGridHelper: ()=>iv,
            PolyhedronGeometry: ()=>Rf,
            PositionalAudio: ()=>AM,
            PropertyBinding: ()=>bM,
            PropertyMixer: ()=>mM,
            QuadraticBezierCurve: ()=>_f,
            QuadraticBezierCurve3: ()=>If,
            Quaternion: ()=>Sl,
            QuaternionKeyframeTrack: ()=>ng,
            QuaternionLinearInterpolant: ()=>ig,
            RED_GREEN_RGTC2_Format: ()=>vs,
            RED_RGTC1_Format: ()=>gs,
            REVISION: ()=>qn,
            RGBADepthPacking: ()=>ks,
            RGBAFormat: ()=>La,
            RGBAIntegerFormat: ()=>Qa,
            RGBA_ASTC_10x10_Format: ()=>hs,
            RGBA_ASTC_10x5_Format: ()=>ls,
            RGBA_ASTC_10x6_Format: ()=>cs,
            RGBA_ASTC_10x8_Format: ()=>us,
            RGBA_ASTC_12x10_Format: ()=>ds,
            RGBA_ASTC_12x12_Format: ()=>ps,
            RGBA_ASTC_4x4_Format: ()=>ts,
            RGBA_ASTC_5x4_Format: ()=>es,
            RGBA_ASTC_5x5_Format: ()=>is,
            RGBA_ASTC_6x5_Format: ()=>ns,
            RGBA_ASTC_6x6_Format: ()=>rs,
            RGBA_ASTC_8x5_Format: ()=>as,
            RGBA_ASTC_8x6_Format: ()=>ss,
            RGBA_ASTC_8x8_Format: ()=>os,
            RGBA_BPTC_Format: ()=>As,
            RGBA_ETC2_EAC_Format: ()=>$a,
            RGBA_PVRTC_2BPPV1_Format: ()=>qa,
            RGBA_PVRTC_4BPPV1_Format: ()=>Za,
            RGBA_S3TC_DXT1_Format: ()=>Va,
            RGBA_S3TC_DXT3_Format: ()=>Ga,
            RGBA_S3TC_DXT5_Format: ()=>Wa,
            RGB_BPTC_SIGNED_Format: ()=>fs,
            RGB_BPTC_UNSIGNED_Format: ()=>ms,
            RGB_ETC1_Format: ()=>Ja,
            RGB_ETC2_Format: ()=>Ka,
            RGB_PVRTC_2BPPV1_Format: ()=>Xa,
            RGB_PVRTC_4BPPV1_Format: ()=>Ya,
            RGB_S3TC_DXT1_Format: ()=>Ha,
            RGFormat: ()=>Ba,
            RGIntegerFormat: ()=>Fa,
            RawShaderMaterial: ()=>Lm,
            Ray: ()=>rc,
            Raycaster: ()=>LM,
            Rec709Primaries: ()=>Xs,
            RectAreaLight: ()=>Rg,
            RedFormat: ()=>ka,
            RedIntegerFormat: ()=>Ua,
            ReinhardToneMapping: ()=>qr,
            RenderTarget: ()=>xl,
            RepeatWrapping: ()=>la,
            ReplaceStencilOp: ()=>Ks,
            ReverseSubtractEquation: ()=>vr,
            RingGeometry: ()=>wm,
            SIGNED_RED_GREEN_RGTC2_Format: ()=>ys,
            SIGNED_RED_RGTC1_Format: ()=>Ms,
            SRGBColorSpace: ()=>Qs,
            SRGBTransfer: ()=>Ys,
            Scene: ()=>Wp,
            ShaderChunk: ()=>hh,
            ShaderLib: ()=>ph,
            ShaderMaterial: ()=>Xu,
            ShadowMaterial: ()=>zm,
            Shape: ()=>Vf,
            ShapeGeometry: ()=>bm,
            ShapePath: ()=>yv,
            ShapeUtils: ()=>fm,
            ShortType: ()=>ba,
            Skeleton: ()=>NA,
            SkeletonHelper: ()=>XM,
            SkinnedMesh: ()=>TA,
            Source: ()=>ml,
            Sphere: ()=>ql,
            SphereGeometry: ()=>Tm,
            Spherical: ()=>jM,
            SphericalHarmonics3: ()=>kg,
            SplineCurve: ()=>Sf,
            SpotLight: ()=>Sg,
            SpotLightHelper: ()=>VM,
            Sprite: ()=>uA,
            SpriteMaterial: ()=>qp,
            SrcAlphaFactor: ()=>_r,
            SrcAlphaSaturateFactor: ()=>zr,
            SrcColorFactor: ()=>Tr,
            StaticCopyUsage: ()=>Io,
            StaticDrawUsage: ()=>xo,
            StaticReadUsage: ()=>To,
            StereoCamera: ()=>eM,
            StreamCopyUsage: ()=>No,
            StreamDrawUsage: ()=>bo,
            StreamReadUsage: ()=>_o,
            StringKeyframeTrack: ()=>rg,
            SubtractEquation: ()=>Mr,
            SubtractiveBlending: ()=>Ar,
            TOUCH: ()=>Kn,
            TangentSpaceNormalMap: ()=>Us,
            TetrahedronGeometry: ()=>Em,
            Texture: ()=>vl,
            TextureLoader: ()=>yg,
            TorusGeometry: ()=>_m,
            TorusKnotGeometry: ()=>Im,
            Triangle: ()=>Qc,
            TriangleFanDrawMode: ()=>Os,
            TriangleStripDrawMode: ()=>Ls,
            TrianglesDrawMode: ()=>zs,
            TubeGeometry: ()=>Sm,
            TwoPassDoubleSide: ()=>ur,
            UVMapping: ()=>ia,
            Uint16BufferAttribute: ()=>uu,
            Uint32BufferAttribute: ()=>du,
            Uint8BufferAttribute: ()=>ou,
            Uint8ClampedBufferAttribute: ()=>lu,
            Uniform: ()=>SM,
            UniformsGroup: ()=>DM,
            UniformsLib: ()=>dh,
            UniformsUtils: ()=>Yu,
            UnsignedByteType: ()=>xa,
            UnsignedInt248Type: ()=>Ca,
            UnsignedIntType: ()=>_a,
            UnsignedShort4444Type: ()=>Na,
            UnsignedShort5551Type: ()=>Da,
            UnsignedShortType: ()=>Ta,
            VSMShadowMap: ()=>sr,
            Vector2: ()=>qo,
            Vector3: ()=>Nl,
            Vector4: ()=>yl,
            VectorKeyframeTrack: ()=>ag,
            VideoTexture: ()=>rf,
            WebGL1Renderer: ()=>Hp,
            WebGL3DRenderTarget: ()=>_l,
            WebGLArrayRenderTarget: ()=>Tl,
            WebGLCoordinateSystem: ()=>Lo,
            WebGLCubeRenderTarget: ()=>th,
            WebGLMultipleRenderTargets: ()=>Il,
            WebGLRenderTarget: ()=>wl,
            WebGLRenderer: ()=>Qp,
            WebGLUtils: ()=>Lp,
            WebGPUCoordinateSystem: ()=>Oo,
            WireframeGeometry: ()=>Nm,
            WrapAroundEnding: ()=>Ns,
            ZeroCurvatureEnding: ()=>Is,
            ZeroFactor: ()=>wr,
            ZeroSlopeEnding: ()=>Ss,
            ZeroStencilOp: ()=>qs,
            _SRGBAFormat: ()=>zo,
            createCanvasElement: ()=>nl,
            sRGBEncoding: ()=>js
        });
        var e = i(540), r = i(72), a = i.n(r), s = i(825), o = i.n(s), l = i(659), c = i.n(l), u = i(56), h = i.n(u), d = i(159), p = i.n(d), A = i(113), f = i.n(A), m = i(809), g = {};
        g.styleTagTransform = f(), g.setAttributes = h(), g.insert = c().bind(null, "head"), g.domAPI = o(), g.insertStyleElement = p(), a()(m.A, g), m.A && m.A.locals && m.A.locals;
        var M = i(875), v = {};
        v.styleTagTransform = f(), v.setAttributes = h(), v.insert = c().bind(null, "head"), v.domAPI = o(), v.insertStyleElement = p(), a()(M.A, v), M.A && M.A.locals && M.A.locals;
        var y = i(482), x = {};
        x.styleTagTransform = f(), x.setAttributes = h(), x.insert = c().bind(null, "head"), x.domAPI = o(), x.insertStyleElement = p(), a()(y.A, x), y.A && y.A.locals && y.A.locals;
        var w = i(928), b = {};
        b.styleTagTransform = f(), b.setAttributes = h(), b.insert = c().bind(null, "head"), b.domAPI = o(), b.insertStyleElement = p(), a()(w.A, b), w.A && w.A.locals && w.A.locals;
        var T = i(761), E = {};
        function _(t1) {
            for(var e = arguments.length, i = new Array(e > 1 ? e - 1 : 0), n = 1; n < e; n++)i[n - 1] = arguments[n];
            throw new Error("number" == typeof t1 ? "[MobX] minified error nr: " + t1 + (i.length ? " " + i.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + t1);
        }
        E.styleTagTransform = f(), E.setAttributes = h(), E.insert = c().bind(null, "head"), E.domAPI = o(), E.insertStyleElement = p(), a()(T.A, E), T.A && T.A.locals && T.A.locals;
        var I = {};
        function S() {
            return "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : void 0 !== i.g ? i.g : "undefined" != typeof self ? self : I;
        }
        var N = Object.assign, D = Object.getOwnPropertyDescriptor, C = Object.defineProperty, z = Object.prototype, L = [];
        Object.freeze(L);
        var O = {};
        Object.freeze(O);
        var P = "undefined" != typeof Proxy, j = Object.toString();
        function R() {
            P || _("Proxy not available");
        }
        function k(t1) {
            var e = !1;
            return function() {
                if (!e) return e = !0, t1.apply(this, arguments);
            };
        }
        var U = function() {};
        function B(t1) {
            return "function" == typeof t1;
        }
        function F(t1) {
            switch(typeof t1){
                case "string":
                case "symbol":
                case "number":
                    return !0;
            }
            return !1;
        }
        function Q(t1) {
            return null !== t1 && "object" == typeof t1;
        }
        function H(t1) {
            if (!Q(t1)) return !1;
            var e = Object.getPrototypeOf(t1);
            if (null == e) return !0;
            var i = Object.hasOwnProperty.call(e, "constructor") && e.constructor;
            return "function" == typeof i && i.toString() === j;
        }
        function V(t1) {
            var e = null == t1 ? void 0 : t1.constructor;
            return !!e && ("GeneratorFunction" === e.name || "GeneratorFunction" === e.displayName);
        }
        function G(t1, e, i) {
            C(t1, e, {
                enumerable: !1,
                writable: !0,
                configurable: !0,
                value: i
            });
        }
        function W(t1, e, i) {
            C(t1, e, {
                enumerable: !1,
                writable: !1,
                configurable: !0,
                value: i
            });
        }
        function Y(t1, e) {
            var i = "isMobX" + t1;
            return e.prototype[i] = !0, function(t1) {
                return Q(t1) && !0 === t1[i];
            };
        }
        function X(t1) {
            return null != t1 && "[object Map]" === Object.prototype.toString.call(t1);
        }
        function Z(t1) {
            return null != t1 && "[object Set]" === Object.prototype.toString.call(t1);
        }
        var q = void 0 !== Object.getOwnPropertySymbols, J = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : q ? function(t1) {
            return Object.getOwnPropertyNames(t1).concat(Object.getOwnPropertySymbols(t1));
        } : Object.getOwnPropertyNames;
        function K(t1) {
            return null === t1 ? null : "object" == typeof t1 ? "" + t1 : t1;
        }
        function $(t1, e) {
            return z.hasOwnProperty.call(t1, e);
        }
        var tt = Object.getOwnPropertyDescriptors || function(t1) {
            var e = {};
            return J(t1).forEach(function(i) {
                e[i] = D(t1, i);
            }), e;
        };
        function et(t1, e) {
            return !!(t1 & e);
        }
        function it(t1, e, i) {
            return i ? t1 |= e : t1 &= ~e, t1;
        }
        function nt(t1, e) {
            (null == e || e > t1.length) && (e = t1.length);
            for(var i = 0, n = Array(e); i < e; i++)n[i] = t1[i];
            return n;
        }
        function rt(t1, e) {
            for(var i = 0; i < e.length; i++){
                var n = e[i];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t1, ut(n.key), n);
            }
        }
        function at(t1, e, i) {
            return e && rt(t1.prototype, e), i && rt(t1, i), Object.defineProperty(t1, "prototype", {
                writable: !1
            }), t1;
        }
        function st(t1, e) {
            var i = "undefined" != typeof Symbol && t1[Symbol.iterator] || t1["@@iterator"];
            if (i) return (i = i.call(t1)).next.bind(i);
            if (Array.isArray(t1) || (i = function(t1, e) {
                if (t1) {
                    if ("string" == typeof t1) return nt(t1, e);
                    var i = ({}).toString.call(t1).slice(8, -1);
                    return "Object" === i && t1.constructor && (i = t1.constructor.name), "Map" === i || "Set" === i ? Array.from(t1) : "Arguments" === i || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i) ? nt(t1, e) : void 0;
                }
            }(t1)) || e && t1 && "number" == typeof t1.length) {
                i && (t1 = i);
                var n = 0;
                return function() {
                    return n >= t1.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: t1[n++]
                    };
                };
            }
            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }
        function ot() {
            return ot = Object.assign ? Object.assign.bind() : function(t1) {
                for(var e = 1; e < arguments.length; e++){
                    var i = arguments[e];
                    for(var n in i)({}).hasOwnProperty.call(i, n) && (t1[n] = i[n]);
                }
                return t1;
            }, ot.apply(null, arguments);
        }
        function lt(t1, e) {
            t1.prototype = Object.create(e.prototype), t1.prototype.constructor = t1, ct(t1, e);
        }
        function ct(t1, e) {
            return ct = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t1, e) {
                return t1.__proto__ = e, t1;
            }, ct(t1, e);
        }
        function ut(t1) {
            var e = function(t1) {
                if ("object" != typeof t1 || !t1) return t1;
                var e = t1[Symbol.toPrimitive];
                if (void 0 !== e) {
                    var i = e.call(t1, "string");
                    if ("object" != typeof i) return i;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(t1);
            }(t1);
            return "symbol" == typeof e ? e : e + "";
        }
        var ht = Symbol("mobx-stored-annotations");
        function dt(t1) {
            return Object.assign(function(e, i) {
                if (At(i)) return t1.decorate_20223_(e, i);
                pt(e, i, t1);
            }, t1);
        }
        function pt(t1, e, i) {
            $(t1, ht) || G(t1, ht, ot({}, t1[ht])), function(t1) {
                return t1.annotationType_ === wt;
            }(i) || (t1[ht][e] = i);
        }
        function At(t1) {
            return "object" == typeof t1 && "string" == typeof t1.kind;
        }
        var ft = Symbol("mobx administration"), mt = function() {
            function t1(t1) {
                void 0 === t1 && (t1 = "Atom"), this.name_ = void 0, this.flags_ = 0, this.observers_ = new Set, this.lastAccessedBy_ = 0, this.lowestObserverState_ = ve.NOT_TRACKING_, this.onBOL = void 0, this.onBUOL = void 0, this.name_ = t1;
            }
            var e = t1.prototype;
            return e.onBO = function() {
                this.onBOL && this.onBOL.forEach(function(t1) {
                    return t1();
                });
            }, e.onBUO = function() {
                this.onBUOL && this.onBUOL.forEach(function(t1) {
                    return t1();
                });
            }, e.reportObserved = function() {
                return Fe(this);
            }, e.reportChanged = function() {
                Ue(), Qe(this), Be();
            }, e.toString = function() {
                return this.name_;
            }, at(t1, [
                {
                    key: "isBeingObserved",
                    get: function() {
                        return et(this.flags_, t1.isBeingObservedMask_);
                    },
                    set: function(e) {
                        this.flags_ = it(this.flags_, t1.isBeingObservedMask_, e);
                    }
                },
                {
                    key: "isPendingUnobservation",
                    get: function() {
                        return et(this.flags_, t1.isPendingUnobservationMask_);
                    },
                    set: function(e) {
                        this.flags_ = it(this.flags_, t1.isPendingUnobservationMask_, e);
                    }
                },
                {
                    key: "diffValue",
                    get: function() {
                        return et(this.flags_, t1.diffValueMask_) ? 1 : 0;
                    },
                    set: function(e) {
                        this.flags_ = it(this.flags_, t1.diffValueMask_, 1 === e);
                    }
                }
            ]);
        }();
        mt.isBeingObservedMask_ = 1, mt.isPendingUnobservationMask_ = 2, mt.diffValueMask_ = 4;
        var gt = Y("Atom", mt);
        function Mt(t1, e, i) {
            void 0 === e && (e = U), void 0 === i && (i = U);
            var n = new mt(t1);
            return e !== U && ci(si, n, e, undefined), i !== U && li(n, i), n;
        }
        var vt = {
            identity: function(t1, e) {
                return t1 === e;
            },
            structural: function(t1, e) {
                return Tn(t1, e);
            },
            default: function(t1, e) {
                return Object.is ? Object.is(t1, e) : t1 === e ? 0 !== t1 || 1 / t1 == 1 / e : t1 != t1 && e != e;
            },
            shallow: function(t1, e) {
                return Tn(t1, e, 1);
            }
        };
        function yt(t1, e, i) {
            return xi(t1) ? t1 : Array.isArray(t1) ? ae.array(t1, {
                name: i
            }) : H(t1) ? ae.object(t1, void 0, {
                name: i
            }) : X(t1) ? ae.map(t1, {
                name: i
            }) : Z(t1) ? ae.set(t1, {
                name: i
            }) : "function" != typeof t1 || ri(t1) || yi(t1) ? t1 : V(t1) ? Mi(t1) : ni(i, t1);
        }
        function xt(t1) {
            return t1;
        }
        var wt = "override";
        function bt(t1, e) {
            return {
                annotationType_: t1,
                options_: e,
                make_: Tt,
                extend_: Et,
                decorate_20223_: _t
            };
        }
        function Tt(t1, e, i, n) {
            var r;
            if (null != (r = this.options_) && r.bound) return null === this.extend_(t1, e, i, !1) ? 0 : 1;
            if (n === t1.target_) return null === this.extend_(t1, e, i, !1) ? 0 : 2;
            if (ri(i.value)) return 1;
            var a = It(t1, this, e, i, !1);
            return C(n, e, a), 2;
        }
        function Et(t1, e, i, n) {
            var r = It(t1, this, e, i);
            return t1.defineProperty_(e, r, n);
        }
        function _t(t1, e) {
            var i = e.kind, n = e.name, r = e.addInitializer, a = this;
            if ("field" != i) {
                var s, o, l, c, u, h;
                if ("method" == i) return ri(t1) || (o = t1, t1 = Ae(null != (l = null == (c = a.options_) ? void 0 : c.name) ? l : n.toString(), o, null != (u = null == (h = a.options_) ? void 0 : h.autoAction) && u)), null != (s = this.options_) && s.bound && r(function() {
                    var t1 = this, e = t1[n].bind(t1);
                    e.isMobxAction = !0, t1[n] = e;
                }), t1;
                _("Cannot apply '" + a.annotationType_ + "' to '" + String(n) + "' (kind: " + i + "):\n'" + a.annotationType_ + "' can only be used on properties with a function value.");
            } else r(function() {
                pt(this, n, a);
            });
        }
        function It(t1, e, i, n, r) {
            var a, s, o, l, c, u, h, d;
            void 0 === r && (r = je.safeDescriptors), d = n, e.annotationType_, d.value;
            var p, A = n.value;
            return null != (a = e.options_) && a.bound && (A = A.bind(null != (p = t1.proxy_) ? p : t1.target_)), {
                value: Ae(null != (s = null == (o = e.options_) ? void 0 : o.name) ? s : i.toString(), A, null != (l = null == (c = e.options_) ? void 0 : c.autoAction) && l, null != (u = e.options_) && u.bound ? null != (h = t1.proxy_) ? h : t1.target_ : void 0),
                configurable: !r || t1.isPlainObject_,
                enumerable: !1,
                writable: !r
            };
        }
        function St(t1, e) {
            return {
                annotationType_: t1,
                options_: e,
                make_: Nt,
                extend_: Dt,
                decorate_20223_: Ct
            };
        }
        function Nt(t1, e, i, n) {
            var r;
            if (n === t1.target_) return null === this.extend_(t1, e, i, !1) ? 0 : 2;
            if (null != (r = this.options_) && r.bound && (!$(t1.target_, e) || !yi(t1.target_[e])) && null === this.extend_(t1, e, i, !1)) return 0;
            if (yi(i.value)) return 1;
            var a = zt(t1, this, 0, i, !1, !1);
            return C(n, e, a), 2;
        }
        function Dt(t1, e, i, n) {
            var r, a = zt(t1, this, 0, i, null == (r = this.options_) ? void 0 : r.bound);
            return t1.defineProperty_(e, a, n);
        }
        function Ct(t1, e) {
            var i, n = e.name, r = e.addInitializer;
            return yi(t1) || (t1 = Mi(t1)), null != (i = this.options_) && i.bound && r(function() {
                var t1 = this, e = t1[n].bind(t1);
                e.isMobXFlow = !0, t1[n] = e;
            }), t1;
        }
        function zt(t1, e, i, n, r, a) {
            var s;
            void 0 === a && (a = je.safeDescriptors), s = n, e.annotationType_, s.value;
            var o, l = n.value;
            return yi(l) || (l = Mi(l)), r && ((l = l.bind(null != (o = t1.proxy_) ? o : t1.target_)).isMobXFlow = !0), {
                value: l,
                configurable: !a || t1.isPlainObject_,
                enumerable: !1,
                writable: !a
            };
        }
        function Lt(t1, e) {
            return {
                annotationType_: t1,
                options_: e,
                make_: Ot,
                extend_: Pt,
                decorate_20223_: jt
            };
        }
        function Ot(t1, e, i) {
            return null === this.extend_(t1, e, i, !1) ? 0 : 1;
        }
        function Pt(t1, e, i, n) {
            var r;
            return r = i, this.annotationType_, r.get, t1.defineComputedProperty_(e, ot({}, this.options_, {
                get: i.get,
                set: i.set
            }), n);
        }
        function jt(t1, e) {
            var i = this, n = e.name;
            return (0, e.addInitializer)(function() {
                var e = nn(this)[ft], r = ot({}, i.options_, {
                    get: t1,
                    context: this
                });
                r.name || (r.name = "ObservableObject." + n.toString()), e.values_.set(n, new Me(r));
            }), function() {
                return this[ft].getObservablePropValue_(n);
            };
        }
        function Rt(t1, e) {
            return {
                annotationType_: t1,
                options_: e,
                make_: kt,
                extend_: Ut,
                decorate_20223_: Bt
            };
        }
        function kt(t1, e, i) {
            return null === this.extend_(t1, e, i, !1) ? 0 : 1;
        }
        function Ut(t1, e, i, n) {
            var r, a;
            return this.annotationType_, t1.defineObservableProperty_(e, i.value, null != (r = null == (a = this.options_) ? void 0 : a.enhancer) ? r : yt, n);
        }
        function Bt(t1, e) {
            var i = this, n = e.kind, r = e.name, a = new WeakSet;
            function s(t1, e) {
                var n, s, o = nn(t1)[ft], l = new ge(e, null != (n = null == (s = i.options_) ? void 0 : s.enhancer) ? n : yt, "ObservableObject." + r.toString(), !1);
                o.values_.set(r, l), a.add(t1);
            }
            if ("accessor" == n) return {
                get: function() {
                    return a.has(this) || s(this, t1.get.call(this)), this[ft].getObservablePropValue_(r);
                },
                set: function(t1) {
                    return a.has(this) || s(this, t1), this[ft].setObservablePropValue_(r, t1);
                },
                init: function(t1) {
                    return a.has(this) || s(this, t1), t1;
                }
            };
        }
        var Ft = "true", Qt = Ht();
        function Ht(t1) {
            return {
                annotationType_: Ft,
                options_: t1,
                make_: Vt,
                extend_: Gt,
                decorate_20223_: Wt
            };
        }
        function Vt(t1, e, i, n) {
            var r, a, s, o;
            if (i.get) return ce.make_(t1, e, i, n);
            if (i.set) {
                var l = Ae(e.toString(), i.set);
                return n === t1.target_ ? null === t1.defineProperty_(e, {
                    configurable: !je.safeDescriptors || t1.isPlainObject_,
                    set: l
                }) ? 0 : 2 : (C(n, e, {
                    configurable: !0,
                    set: l
                }), 2);
            }
            if (n !== t1.target_ && "function" == typeof i.value) return V(i.value) ? (null != (o = this.options_) && o.autoBind ? Mi.bound : Mi).make_(t1, e, i, n) : (null != (s = this.options_) && s.autoBind ? ni.bound : ni).make_(t1, e, i, n);
            var c, u = !1 === (null == (r = this.options_) ? void 0 : r.deep) ? ae.ref : ae;
            return "function" == typeof i.value && null != (a = this.options_) && a.autoBind && (i.value = i.value.bind(null != (c = t1.proxy_) ? c : t1.target_)), u.make_(t1, e, i, n);
        }
        function Gt(t1, e, i, n) {
            var r, a, s;
            return i.get ? ce.extend_(t1, e, i, n) : i.set ? t1.defineProperty_(e, {
                configurable: !je.safeDescriptors || t1.isPlainObject_,
                set: Ae(e.toString(), i.set)
            }, n) : ("function" == typeof i.value && null != (r = this.options_) && r.autoBind && (i.value = i.value.bind(null != (s = t1.proxy_) ? s : t1.target_)), (!1 === (null == (a = this.options_) ? void 0 : a.deep) ? ae.ref : ae).extend_(t1, e, i, n));
        }
        function Wt(t1, e) {
            _("'" + this.annotationType_ + "' cannot be used as a decorator");
        }
        var Yt = {
            deep: !0,
            name: void 0,
            defaultDecorator: void 0,
            proxy: !0
        };
        function Xt(t1) {
            return t1 || Yt;
        }
        Object.freeze(Yt);
        var Zt = Rt("observable"), qt = Rt("observable.ref", {
            enhancer: xt
        }), Jt = Rt("observable.shallow", {
            enhancer: function(t1, e, i) {
                return null == t1 || sn(t1) || Vi(t1) || Zi(t1) || Ki(t1) ? t1 : Array.isArray(t1) ? ae.array(t1, {
                    name: i,
                    deep: !1
                }) : H(t1) ? ae.object(t1, void 0, {
                    name: i,
                    deep: !1
                }) : X(t1) ? ae.map(t1, {
                    name: i,
                    deep: !1
                }) : Z(t1) ? ae.set(t1, {
                    name: i,
                    deep: !1
                }) : void 0;
            }
        }), Kt = Rt("observable.struct", {
            enhancer: function(t1, e) {
                return Tn(t1, e) ? e : t1;
            }
        }), $t = dt(Zt);
        function te(t1) {
            var e, i, n;
            return !0 === t1.deep ? yt : !1 === t1.deep ? xt : (e = t1.defaultDecorator) && null != (i = null == (n = e.options_) ? void 0 : n.enhancer) ? i : yt;
        }
        function ee(t1, e, i) {
            return At(e) ? Zt.decorate_20223_(t1, e) : F(e) ? void pt(t1, e, Zt) : xi(t1) ? t1 : H(t1) ? ae.object(t1, e, i) : Array.isArray(t1) ? ae.array(t1, e) : X(t1) ? ae.map(t1, e) : Z(t1) ? ae.set(t1, e) : "object" == typeof t1 && null !== t1 ? t1 : ae.box(t1, e);
        }
        N(ee, $t);
        var ie, ne, re = {
            box: function(t1, e) {
                var i = Xt(e);
                return new ge(t1, te(i), i.name, !0, i.equals);
            },
            array: function(t1, e) {
                var i = Xt(e);
                return (!1 === je.useProxies || !1 === i.proxy ? Mn : Ri)(t1, te(i), i.name);
            },
            map: function(t1, e) {
                var i = Xt(e);
                return new Xi(t1, te(i), i.name);
            },
            set: function(t1, e) {
                var i = Xt(e);
                return new Ji(t1, te(i), i.name);
            },
            object: function(t1, e, i) {
                return wn(function() {
                    return di(!1 === je.useProxies || !1 === (null == i ? void 0 : i.proxy) ? nn({}, i) : function(t1, e) {
                        var i, n;
                        return R(), null != (n = (i = (t1 = nn(t1, e))[ft]).proxy_) ? n : i.proxy_ = new Proxy(t1, Ti);
                    }({}, i), t1, e);
                });
            },
            ref: dt(qt),
            shallow: dt(Jt),
            deep: $t,
            struct: dt(Kt)
        }, ae = N(ee, re), se = "computed", oe = Lt(se), le = Lt("computed.struct", {
            equals: vt.structural
        }), ce = function(t1, e) {
            if (At(e)) return oe.decorate_20223_(t1, e);
            if (F(e)) return pt(t1, e, oe);
            if (H(t1)) return dt(Lt(se, t1));
            var i = H(e) ? e : {};
            return i.get = t1, i.name || (i.name = t1.name || ""), new Me(i);
        };
        Object.assign(ce, oe), ce.struct = dt(le);
        var ue = 0, he = 1, de = null != (ie = null == (ne = D(function() {}, "name")) ? void 0 : ne.configurable) && ie, pe = {
            value: "action",
            configurable: !0,
            writable: !1,
            enumerable: !1
        };
        function Ae(t1, e, i, n) {
            function r() {
                return function(t1, e, i, n, r) {
                    var a = function(t1, e) {
                        var i = !1, n = 0, r = je.trackingDerivation, a = !e || !r;
                        Ue();
                        var s = je.allowStateChanges;
                        a && (Se(), s = fe(!0));
                        var o = {
                            runAsAction_: a,
                            prevDerivation_: r,
                            prevAllowStateChanges_: s,
                            prevAllowStateReads_: De(!0),
                            notifySpy_: i,
                            startTime_: n,
                            actionId_: he++,
                            parentActionId_: ue
                        };
                        return ue = o.actionId_, o;
                    }(0, e);
                    try {
                        return i.apply(n, r);
                    } catch (t1) {
                        throw a.error_ = t1, t1;
                    } finally{
                        !function(t1) {
                            ue !== t1.actionId_ && _(30), ue = t1.parentActionId_, void 0 !== t1.error_ && (je.suppressReactionErrors = !0), me(t1.prevAllowStateChanges_), Ce(t1.prevAllowStateReads_), Be(), t1.runAsAction_ && Ne(t1.prevDerivation_), je.suppressReactionErrors = !1;
                        }(a);
                    }
                }(0, i, e, n || this, arguments);
            }
            return void 0 === i && (i = !1), r.isMobxAction = !0, r.toString = function() {
                return e.toString();
            }, de && (pe.value = t1, C(r, "name", pe)), r;
        }
        function fe(t1) {
            var e = je.allowStateChanges;
            return je.allowStateChanges = t1, e;
        }
        function me(t1) {
            je.allowStateChanges = t1;
        }
        var ge = function(t1) {
            function e(e, i, n, r, a) {
                var s;
                return void 0 === n && (n = "ObservableValue"), void 0 === r && (r = !0), void 0 === a && (a = vt.default), (s = t1.call(this, n) || this).enhancer = void 0, s.name_ = void 0, s.equals = void 0, s.hasUnreportedChange_ = !1, s.interceptors_ = void 0, s.changeListeners_ = void 0, s.value_ = void 0, s.dehancer = void 0, s.enhancer = i, s.name_ = n, s.equals = a, s.value_ = i(e, void 0, n), s;
            }
            lt(e, t1);
            var i = e.prototype;
            return i.dehanceValue = function(t1) {
                return void 0 !== this.dehancer ? this.dehancer(t1) : t1;
            }, i.set = function(t1) {
                this.value_, (t1 = this.prepareNewValue_(t1)) !== je.UNCHANGED && this.setNewValue_(t1);
            }, i.prepareNewValue_ = function(t1) {
                if (Ei(this)) {
                    var e = Ii(this, {
                        object: this,
                        type: Oi,
                        newValue: t1
                    });
                    if (!e) return je.UNCHANGED;
                    t1 = e.newValue;
                }
                return t1 = this.enhancer(t1, this.value_, this.name_), this.equals(this.value_, t1) ? je.UNCHANGED : t1;
            }, i.setNewValue_ = function(t1) {
                var e = this.value_;
                this.value_ = t1, this.reportChanged(), Si(this) && Di(this, {
                    type: Oi,
                    object: this,
                    newValue: t1,
                    oldValue: e
                });
            }, i.get = function() {
                return this.reportObserved(), this.dehanceValue(this.value_);
            }, i.intercept_ = function(t1) {
                return _i(this, t1);
            }, i.observe_ = function(t1, e) {
                return e && t1({
                    observableKind: "value",
                    debugObjectName: this.name_,
                    object: this,
                    type: Oi,
                    newValue: this.value_,
                    oldValue: void 0
                }), Ni(this, t1);
            }, i.raw = function() {
                return this.value_;
            }, i.toJSON = function() {
                return this.get();
            }, i.toString = function() {
                return this.name_ + "[" + this.value_ + "]";
            }, i.valueOf = function() {
                return K(this.get());
            }, i[Symbol.toPrimitive] = function() {
                return this.valueOf();
            }, e;
        }(mt), Me = function() {
            function t1(t1) {
                this.dependenciesState_ = ve.NOT_TRACKING_, this.observing_ = [], this.newObserving_ = null, this.observers_ = new Set, this.runId_ = 0, this.lastAccessedBy_ = 0, this.lowestObserverState_ = ve.UP_TO_DATE_, this.unboundDepsCount_ = 0, this.value_ = new we(null), this.name_ = void 0, this.triggeredBy_ = void 0, this.flags_ = 0, this.derivation = void 0, this.setter_ = void 0, this.isTracing_ = ye.NONE, this.scope_ = void 0, this.equals_ = void 0, this.requiresReaction_ = void 0, this.keepAlive_ = void 0, this.onBOL = void 0, this.onBUOL = void 0, t1.get || _(31), this.derivation = t1.get, this.name_ = t1.name || "ComputedValue", t1.set && (this.setter_ = Ae("ComputedValue-setter", t1.set)), this.equals_ = t1.equals || (t1.compareStructural || t1.struct ? vt.structural : vt.default), this.scope_ = t1.context, this.requiresReaction_ = t1.requiresReaction, this.keepAlive_ = !!t1.keepAlive;
            }
            var e = t1.prototype;
            return e.onBecomeStale_ = function() {
                var t1;
                (t1 = this).lowestObserverState_ === ve.UP_TO_DATE_ && (t1.lowestObserverState_ = ve.POSSIBLY_STALE_, t1.observers_.forEach(function(t1) {
                    t1.dependenciesState_ === ve.UP_TO_DATE_ && (t1.dependenciesState_ = ve.POSSIBLY_STALE_, t1.onBecomeStale_());
                }));
            }, e.onBO = function() {
                this.onBOL && this.onBOL.forEach(function(t1) {
                    return t1();
                });
            }, e.onBUO = function() {
                this.onBUOL && this.onBUOL.forEach(function(t1) {
                    return t1();
                });
            }, e.get = function() {
                if (this.isComputing && _(32, this.name_, this.derivation), 0 !== je.inBatch || 0 !== this.observers_.size || this.keepAlive_) {
                    if (Fe(this), Te(this)) {
                        var t1 = je.trackingContext;
                        this.keepAlive_ && !t1 && (je.trackingContext = this), this.trackAndCompute() && (e = this).lowestObserverState_ !== ve.STALE_ && (e.lowestObserverState_ = ve.STALE_, e.observers_.forEach(function(t1) {
                            t1.dependenciesState_ === ve.POSSIBLY_STALE_ ? t1.dependenciesState_ = ve.STALE_ : t1.dependenciesState_ === ve.UP_TO_DATE_ && (e.lowestObserverState_ = ve.UP_TO_DATE_);
                        })), je.trackingContext = t1;
                    }
                } else Te(this) && (this.warnAboutUntrackedRead_(), Ue(), this.value_ = this.computeValue_(!1), Be());
                var e, i = this.value_;
                if (be(i)) throw i.cause;
                return i;
            }, e.set = function(t1) {
                if (this.setter_) {
                    this.isRunningSetter && _(33, this.name_), this.isRunningSetter = !0;
                    try {
                        this.setter_.call(this.scope_, t1);
                    } finally{
                        this.isRunningSetter = !1;
                    }
                } else _(34, this.name_);
            }, e.trackAndCompute = function() {
                var t1 = this.value_, e = this.dependenciesState_ === ve.NOT_TRACKING_, i = this.computeValue_(!0), n = e || be(t1) || be(i) || !this.equals_(t1, i);
                return n && (this.value_ = i), n;
            }, e.computeValue_ = function(t1) {
                this.isComputing = !0;
                var e, i = fe(!1);
                if (t1) e = Ee(this, this.derivation, this.scope_);
                else if (!0 === je.disableErrorBoundaries) e = this.derivation.call(this.scope_);
                else try {
                    e = this.derivation.call(this.scope_);
                } catch (t1) {
                    e = new we(t1);
                }
                return me(i), this.isComputing = !1, e;
            }, e.suspend_ = function() {
                this.keepAlive_ || (_e(this), this.value_ = void 0);
            }, e.observe_ = function(t1, e) {
                var i = this, n = !0, r = void 0;
                return function(t1, e) {
                    var i, n, r, a;
                    void 0 === e && (e = O);
                    var s, o = null != (i = null == (n = e) ? void 0 : n.name) ? i : "Autorun";
                    if (e.scheduler || e.delay) {
                        var l = function(t1) {
                            return t1.scheduler ? t1.scheduler : t1.delay ? function(e) {
                                return setTimeout(e, t1.delay);
                            } : ai;
                        }(e), c = !1;
                        s = new He(o, function() {
                            c || (c = !0, l(function() {
                                c = !1, s.isDisposed || s.track(u);
                            }));
                        }, e.onError, e.requiresObservable);
                    } else s = new He(o, function() {
                        this.track(u);
                    }, e.onError, e.requiresObservable);
                    function u() {
                        t1(s);
                    }
                    return null != (r = e) && null != (r = r.signal) && r.aborted || s.schedule_(), s.getDisposer_(null == (a = e) ? void 0 : a.signal);
                }(function() {
                    var a = i.get();
                    if (!n || e) {
                        var s = Se();
                        t1({
                            observableKind: "computed",
                            debugObjectName: i.name_,
                            type: Oi,
                            object: i,
                            newValue: a,
                            oldValue: r
                        }), Ne(s);
                    }
                    n = !1, r = a;
                });
            }, e.warnAboutUntrackedRead_ = function() {}, e.toString = function() {
                return this.name_ + "[" + this.derivation.toString() + "]";
            }, e.valueOf = function() {
                return K(this.get());
            }, e[Symbol.toPrimitive] = function() {
                return this.valueOf();
            }, at(t1, [
                {
                    key: "isComputing",
                    get: function() {
                        return et(this.flags_, t1.isComputingMask_);
                    },
                    set: function(e) {
                        this.flags_ = it(this.flags_, t1.isComputingMask_, e);
                    }
                },
                {
                    key: "isRunningSetter",
                    get: function() {
                        return et(this.flags_, t1.isRunningSetterMask_);
                    },
                    set: function(e) {
                        this.flags_ = it(this.flags_, t1.isRunningSetterMask_, e);
                    }
                },
                {
                    key: "isBeingObserved",
                    get: function() {
                        return et(this.flags_, t1.isBeingObservedMask_);
                    },
                    set: function(e) {
                        this.flags_ = it(this.flags_, t1.isBeingObservedMask_, e);
                    }
                },
                {
                    key: "isPendingUnobservation",
                    get: function() {
                        return et(this.flags_, t1.isPendingUnobservationMask_);
                    },
                    set: function(e) {
                        this.flags_ = it(this.flags_, t1.isPendingUnobservationMask_, e);
                    }
                },
                {
                    key: "diffValue",
                    get: function() {
                        return et(this.flags_, t1.diffValueMask_) ? 1 : 0;
                    },
                    set: function(e) {
                        this.flags_ = it(this.flags_, t1.diffValueMask_, 1 === e);
                    }
                }
            ]);
        }();
        Me.isComputingMask_ = 1, Me.isRunningSetterMask_ = 2, Me.isBeingObservedMask_ = 4, Me.isPendingUnobservationMask_ = 8, Me.diffValueMask_ = 16;
        var ve, ye, xe = Y("ComputedValue", Me);
        !function(t1) {
            t1[t1.NOT_TRACKING_ = -1] = "NOT_TRACKING_", t1[t1.UP_TO_DATE_ = 0] = "UP_TO_DATE_", t1[t1.POSSIBLY_STALE_ = 1] = "POSSIBLY_STALE_", t1[t1.STALE_ = 2] = "STALE_";
        }(ve || (ve = {})), function(t1) {
            t1[t1.NONE = 0] = "NONE", t1[t1.LOG = 1] = "LOG", t1[t1.BREAK = 2] = "BREAK";
        }(ye || (ye = {}));
        var we = function(t1) {
            this.cause = void 0, this.cause = t1;
        };
        function be(t1) {
            return t1 instanceof we;
        }
        function Te(t1) {
            switch(t1.dependenciesState_){
                case ve.UP_TO_DATE_:
                    return !1;
                case ve.NOT_TRACKING_:
                case ve.STALE_:
                    return !0;
                case ve.POSSIBLY_STALE_:
                    for(var e = De(!0), i = Se(), n = t1.observing_, r = n.length, a = 0; a < r; a++){
                        var s = n[a];
                        if (xe(s)) {
                            if (je.disableErrorBoundaries) s.get();
                            else try {
                                s.get();
                            } catch (t1) {
                                return Ne(i), Ce(e), !0;
                            }
                            if (t1.dependenciesState_ === ve.STALE_) return Ne(i), Ce(e), !0;
                        }
                    }
                    return ze(t1), Ne(i), Ce(e), !1;
            }
        }
        function Ee(t1, e, i) {
            var n = De(!0);
            ze(t1), t1.newObserving_ = new Array(0 === t1.runId_ ? 100 : t1.observing_.length), t1.unboundDepsCount_ = 0, t1.runId_ = ++je.runId;
            var r, a = je.trackingDerivation;
            if (je.trackingDerivation = t1, je.inBatch++, !0 === je.disableErrorBoundaries) r = e.call(i);
            else try {
                r = e.call(i);
            } catch (t1) {
                r = new we(t1);
            }
            return je.inBatch--, je.trackingDerivation = a, function(t1) {
                for(var e = t1.observing_, i = t1.observing_ = t1.newObserving_, n = ve.UP_TO_DATE_, r = 0, a = t1.unboundDepsCount_, s = 0; s < a; s++){
                    var o = i[s];
                    0 === o.diffValue && (o.diffValue = 1, r !== s && (i[r] = o), r++), o.dependenciesState_ > n && (n = o.dependenciesState_);
                }
                for(i.length = r, t1.newObserving_ = null, a = e.length; a--;){
                    var l = e[a];
                    0 === l.diffValue && Re(l, t1), l.diffValue = 0;
                }
                for(; r--;){
                    var c = i[r];
                    1 === c.diffValue && (c.diffValue = 0, h = t1, (u = c).observers_.add(h), u.lowestObserverState_ > h.dependenciesState_ && (u.lowestObserverState_ = h.dependenciesState_));
                }
                var u, h;
                n !== ve.UP_TO_DATE_ && (t1.dependenciesState_ = n, t1.onBecomeStale_());
            }(t1), Ce(n), r;
        }
        function _e(t1) {
            var e = t1.observing_;
            t1.observing_ = [];
            for(var i = e.length; i--;)Re(e[i], t1);
            t1.dependenciesState_ = ve.NOT_TRACKING_;
        }
        function Ie(t1) {
            var e = Se();
            try {
                return t1();
            } finally{
                Ne(e);
            }
        }
        function Se() {
            var t1 = je.trackingDerivation;
            return je.trackingDerivation = null, t1;
        }
        function Ne(t1) {
            je.trackingDerivation = t1;
        }
        function De(t1) {
            var e = je.allowStateReads;
            return je.allowStateReads = t1, e;
        }
        function Ce(t1) {
            je.allowStateReads = t1;
        }
        function ze(t1) {
            if (t1.dependenciesState_ !== ve.UP_TO_DATE_) {
                t1.dependenciesState_ = ve.UP_TO_DATE_;
                for(var e = t1.observing_, i = e.length; i--;)e[i].lowestObserverState_ = ve.UP_TO_DATE_;
            }
        }
        var Le = function() {
            this.version = 6, this.UNCHANGED = {}, this.trackingDerivation = null, this.trackingContext = null, this.runId = 0, this.mobxGuid = 0, this.inBatch = 0, this.pendingUnobservations = [], this.pendingReactions = [], this.isRunningReactions = !1, this.allowStateChanges = !1, this.allowStateReads = !0, this.enforceActions = !0, this.spyListeners = [], this.globalReactionErrorHandlers = [], this.computedRequiresReaction = !1, this.reactionRequiresObservable = !1, this.observableRequiresReaction = !1, this.disableErrorBoundaries = !1, this.suppressReactionErrors = !1, this.useProxies = !0, this.verifyProxies = !1, this.safeDescriptors = !0;
        }, Oe = !0, Pe = !1, je = function() {
            var t1 = S();
            return t1.__mobxInstanceCount > 0 && !t1.__mobxGlobals && (Oe = !1), t1.__mobxGlobals && t1.__mobxGlobals.version !== (new Le).version && (Oe = !1), Oe ? t1.__mobxGlobals ? (t1.__mobxInstanceCount += 1, t1.__mobxGlobals.UNCHANGED || (t1.__mobxGlobals.UNCHANGED = {}), t1.__mobxGlobals) : (t1.__mobxInstanceCount = 1, t1.__mobxGlobals = new Le) : (setTimeout(function() {
                Pe || _(35);
            }, 1), new Le);
        }();
        function Re(t1, e) {
            t1.observers_.delete(e), 0 === t1.observers_.size && ke(t1);
        }
        function ke(t1) {
            !1 === t1.isPendingUnobservation && (t1.isPendingUnobservation = !0, je.pendingUnobservations.push(t1));
        }
        function Ue() {
            je.inBatch++;
        }
        function Be() {
            if (0 == --je.inBatch) {
                We();
                for(var t1 = je.pendingUnobservations, e = 0; e < t1.length; e++){
                    var i = t1[e];
                    i.isPendingUnobservation = !1, 0 === i.observers_.size && (i.isBeingObserved && (i.isBeingObserved = !1, i.onBUO()), i instanceof Me && i.suspend_());
                }
                je.pendingUnobservations = [];
            }
        }
        function Fe(t1) {
            var e = je.trackingDerivation;
            return null !== e ? (e.runId_ !== t1.lastAccessedBy_ && (t1.lastAccessedBy_ = e.runId_, e.newObserving_[e.unboundDepsCount_++] = t1, !t1.isBeingObserved && je.trackingContext && (t1.isBeingObserved = !0, t1.onBO())), t1.isBeingObserved) : (0 === t1.observers_.size && je.inBatch > 0 && ke(t1), !1);
        }
        function Qe(t1) {
            t1.lowestObserverState_ !== ve.STALE_ && (t1.lowestObserverState_ = ve.STALE_, t1.observers_.forEach(function(t1) {
                t1.dependenciesState_ === ve.UP_TO_DATE_ && t1.onBecomeStale_(), t1.dependenciesState_ = ve.STALE_;
            }));
        }
        var He = function() {
            function t1(t1, e, i, n) {
                void 0 === t1 && (t1 = "Reaction"), this.name_ = void 0, this.onInvalidate_ = void 0, this.errorHandler_ = void 0, this.requiresObservable_ = void 0, this.observing_ = [], this.newObserving_ = [], this.dependenciesState_ = ve.NOT_TRACKING_, this.runId_ = 0, this.unboundDepsCount_ = 0, this.flags_ = 0, this.isTracing_ = ye.NONE, this.name_ = t1, this.onInvalidate_ = e, this.errorHandler_ = i, this.requiresObservable_ = n;
            }
            var e = t1.prototype;
            return e.onBecomeStale_ = function() {
                this.schedule_();
            }, e.schedule_ = function() {
                this.isScheduled || (this.isScheduled = !0, je.pendingReactions.push(this), We());
            }, e.runReaction_ = function() {
                if (!this.isDisposed) {
                    Ue(), this.isScheduled = !1;
                    var t1 = je.trackingContext;
                    if (je.trackingContext = this, Te(this)) {
                        this.isTrackPending = !0;
                        try {
                            this.onInvalidate_();
                        } catch (t1) {
                            this.reportExceptionInDerivation_(t1);
                        }
                    }
                    je.trackingContext = t1, Be();
                }
            }, e.track = function(t1) {
                if (!this.isDisposed) {
                    Ue(), this.isRunning = !0;
                    var e = je.trackingContext;
                    je.trackingContext = this;
                    var i = Ee(this, t1, void 0);
                    je.trackingContext = e, this.isRunning = !1, this.isTrackPending = !1, this.isDisposed && _e(this), be(i) && this.reportExceptionInDerivation_(i.cause), Be();
                }
            }, e.reportExceptionInDerivation_ = function(t1) {
                var e = this;
                if (this.errorHandler_) this.errorHandler_(t1, this);
                else {
                    if (je.disableErrorBoundaries) throw t1;
                    var i = "[mobx] uncaught error in '" + this + "'";
                    je.suppressReactionErrors || console.error(i, t1), je.globalReactionErrorHandlers.forEach(function(i) {
                        return i(t1, e);
                    });
                }
            }, e.dispose = function() {
                this.isDisposed || (this.isDisposed = !0, this.isRunning || (Ue(), _e(this), Be()));
            }, e.getDisposer_ = function(t1) {
                var e = this, i = function i() {
                    e.dispose(), null == t1 || null == t1.removeEventListener || t1.removeEventListener("abort", i);
                };
                return null == t1 || null == t1.addEventListener || t1.addEventListener("abort", i), i[ft] = this, i;
            }, e.toString = function() {
                return "Reaction[" + this.name_ + "]";
            }, e.trace = function(t1) {
                void 0 === t1 && (t1 = !1);
            }, at(t1, [
                {
                    key: "isDisposed",
                    get: function() {
                        return et(this.flags_, t1.isDisposedMask_);
                    },
                    set: function(e) {
                        this.flags_ = it(this.flags_, t1.isDisposedMask_, e);
                    }
                },
                {
                    key: "isScheduled",
                    get: function() {
                        return et(this.flags_, t1.isScheduledMask_);
                    },
                    set: function(e) {
                        this.flags_ = it(this.flags_, t1.isScheduledMask_, e);
                    }
                },
                {
                    key: "isTrackPending",
                    get: function() {
                        return et(this.flags_, t1.isTrackPendingMask_);
                    },
                    set: function(e) {
                        this.flags_ = it(this.flags_, t1.isTrackPendingMask_, e);
                    }
                },
                {
                    key: "isRunning",
                    get: function() {
                        return et(this.flags_, t1.isRunningMask_);
                    },
                    set: function(e) {
                        this.flags_ = it(this.flags_, t1.isRunningMask_, e);
                    }
                },
                {
                    key: "diffValue",
                    get: function() {
                        return et(this.flags_, t1.diffValueMask_) ? 1 : 0;
                    },
                    set: function(e) {
                        this.flags_ = it(this.flags_, t1.diffValueMask_, 1 === e);
                    }
                }
            ]);
        }();
        He.isDisposedMask_ = 1, He.isScheduledMask_ = 2, He.isTrackPendingMask_ = 4, He.isRunningMask_ = 8, He.diffValueMask_ = 16;
        var Ve = 100, Ge = function(t1) {
            return t1();
        };
        function We() {
            je.inBatch > 0 || je.isRunningReactions || Ge(Ye);
        }
        function Ye() {
            je.isRunningReactions = !0;
            for(var t1 = je.pendingReactions, e = 0; t1.length > 0;){
                ++e === Ve && (console.error("[mobx] cycle in reaction: " + t1[0]), t1.splice(0));
                for(var i = t1.splice(0), n = 0, r = i.length; n < r; n++)i[n].runReaction_();
            }
            je.isRunningReactions = !1;
        }
        var Xe = Y("Reaction", He), Ze = "action", qe = "autoAction", Je = bt(Ze), Ke = bt("action.bound", {
            bound: !0
        }), $e = bt(qe, {
            autoAction: !0
        }), ti = bt("autoAction.bound", {
            autoAction: !0,
            bound: !0
        });
        function ei(t1) {
            return function(e, i) {
                return B(e) ? Ae(e.name || "<unnamed action>", e, t1) : B(i) ? Ae(e, i, t1) : At(i) ? (t1 ? $e : Je).decorate_20223_(e, i) : F(i) ? pt(e, i, t1 ? $e : Je) : F(e) ? dt(bt(t1 ? qe : Ze, {
                    name: e,
                    autoAction: t1
                })) : void 0;
            };
        }
        var ii = ei(!1);
        Object.assign(ii, Je);
        var ni = ei(!0);
        function ri(t1) {
            return B(t1) && !0 === t1.isMobxAction;
        }
        Object.assign(ni, $e), ii.bound = dt(Ke), ni.bound = dt(ti);
        var ai = function(t1) {
            return t1();
        };
        var si = "onBO", oi = "onBUO";
        function li(t1, e, i) {
            return ci(oi, t1, e, i);
        }
        function ci(t1, e, i, n) {
            var r = "function" == typeof n ? vn(e, i) : vn(e), a = B(n) ? n : i, s = t1 + "L";
            return r[s] ? r[s].add(a) : r[s] = new Set([
                a
            ]), function() {
                var t1 = r[s];
                t1 && (t1.delete(a), 0 === t1.size && delete r[s]);
            };
        }
        var ui = "always";
        function hi(t1) {
            !0 === t1.isolateGlobalState && function() {
                if ((je.pendingReactions.length || je.inBatch || je.isRunningReactions) && _(36), Pe = !0, Oe) {
                    var t1 = S();
                    0 == --t1.__mobxInstanceCount && (t1.__mobxGlobals = void 0), je = new Le;
                }
            }();
            var e, i, n = t1.useProxies, r = t1.enforceActions;
            if (void 0 !== n && (je.useProxies = n === ui || "never" !== n && "undefined" != typeof Proxy), "ifavailable" === n && (je.verifyProxies = !0), void 0 !== r) {
                var a = r === ui ? ui : "observed" === r;
                je.enforceActions = a, je.allowStateChanges = !0 !== a && a !== ui;
            }
            [
                "computedRequiresReaction",
                "reactionRequiresObservable",
                "observableRequiresReaction",
                "disableErrorBoundaries",
                "safeDescriptors"
            ].forEach(function(e) {
                e in t1 && (je[e] = !!t1[e]);
            }), je.allowStateReads = !je.observableRequiresReaction, t1.reactionScheduler && (e = t1.reactionScheduler, i = Ge, Ge = function(t1) {
                return e(function() {
                    return i(t1);
                });
            });
        }
        function di(t1, e, i, n) {
            var r = tt(e);
            return wn(function() {
                var e = nn(t1, n)[ft];
                J(r).forEach(function(t1) {
                    e.extend_(t1, r[t1], !i || !(t1 in i) || i[t1]);
                });
            }), t1;
        }
        function pi(t1) {
            var e, i = {
                name: t1.name_
            };
            return t1.observing_ && t1.observing_.length > 0 && (i.dependencies = (e = t1.observing_, Array.from(new Set(e))).map(pi)), i;
        }
        var Ai = 0;
        function fi() {
            this.message = "FLOW_CANCELLED";
        }
        fi.prototype = Object.create(Error.prototype);
        var mi = St("flow"), gi = St("flow.bound", {
            bound: !0
        }), Mi = Object.assign(function(t1, e) {
            if (At(e)) return mi.decorate_20223_(t1, e);
            if (F(e)) return pt(t1, e, mi);
            var i = t1, n = i.name || "<unnamed flow>", r = function() {
                var t1, e = arguments, r = ++Ai, a = ii(n + " - runid: " + r + " - init", i).apply(this, e), s = void 0, o = new Promise(function(e, i) {
                    var o = 0;
                    function l(t1) {
                        var e;
                        s = void 0;
                        try {
                            e = ii(n + " - runid: " + r + " - yield " + o++, a.next).call(a, t1);
                        } catch (t1) {
                            return i(t1);
                        }
                        u(e);
                    }
                    function c(t1) {
                        var e;
                        s = void 0;
                        try {
                            e = ii(n + " - runid: " + r + " - yield " + o++, a.throw).call(a, t1);
                        } catch (t1) {
                            return i(t1);
                        }
                        u(e);
                    }
                    function u(t1) {
                        if (!B(null == t1 ? void 0 : t1.then)) return t1.done ? e(t1.value) : (s = Promise.resolve(t1.value)).then(l, c);
                        t1.then(u, i);
                    }
                    t1 = i, l(void 0);
                });
                return o.cancel = ii(n + " - runid: " + r + " - cancel", function() {
                    try {
                        s && vi(s);
                        var e = a.return(void 0), i = Promise.resolve(e.value);
                        i.then(U, U), vi(i), t1(new fi);
                    } catch (e) {
                        t1(e);
                    }
                }), o;
            };
            return r.isMobXFlow = !0, r;
        }, mi);
        function vi(t1) {
            B(t1.cancel) && t1.cancel();
        }
        function yi(t1) {
            return !0 === (null == t1 ? void 0 : t1.isMobXFlow);
        }
        function xi(t1) {
            return function(t1, e) {
                return !!t1 && (void 0 !== e ? !!sn(t1) && t1[ft].values_.has(e) : sn(t1) || !!t1[ft] || gt(t1) || Xe(t1) || xe(t1));
            }(t1);
        }
        function wi(t1, e) {
            void 0 === e && (e = void 0), Ue();
            try {
                return t1.apply(e);
            } finally{
                Be();
            }
        }
        function bi(t1) {
            return t1[ft];
        }
        Mi.bound = dt(gi);
        var Ti = {
            has: function(t1, e) {
                return bi(t1).has_(e);
            },
            get: function(t1, e) {
                return bi(t1).get_(e);
            },
            set: function(t1, e, i) {
                var n;
                return !!F(e) && (null == (n = bi(t1).set_(e, i, !0)) || n);
            },
            deleteProperty: function(t1, e) {
                var i;
                return !!F(e) && (null == (i = bi(t1).delete_(e, !0)) || i);
            },
            defineProperty: function(t1, e, i) {
                var n;
                return null == (n = bi(t1).defineProperty_(e, i)) || n;
            },
            ownKeys: function(t1) {
                return bi(t1).ownKeys_();
            },
            preventExtensions: function(t1) {
                _(13);
            }
        };
        function Ei(t1) {
            return void 0 !== t1.interceptors_ && t1.interceptors_.length > 0;
        }
        function _i(t1, e) {
            var i = t1.interceptors_ || (t1.interceptors_ = []);
            return i.push(e), k(function() {
                var t1 = i.indexOf(e);
                -1 !== t1 && i.splice(t1, 1);
            });
        }
        function Ii(t1, e) {
            var i = Se();
            try {
                for(var n = [].concat(t1.interceptors_ || []), r = 0, a = n.length; r < a && ((e = n[r](e)) && !e.type && _(14), e); r++);
                return e;
            } finally{
                Ne(i);
            }
        }
        function Si(t1) {
            return void 0 !== t1.changeListeners_ && t1.changeListeners_.length > 0;
        }
        function Ni(t1, e) {
            var i = t1.changeListeners_ || (t1.changeListeners_ = []);
            return i.push(e), k(function() {
                var t1 = i.indexOf(e);
                -1 !== t1 && i.splice(t1, 1);
            });
        }
        function Di(t1, e) {
            var i = Se(), n = t1.changeListeners_;
            if (n) {
                for(var r = 0, a = (n = n.slice()).length; r < a; r++)n[r](e);
                Ne(i);
            }
        }
        var Ci = Symbol("mobx-keys");
        function zi(t1, e, i) {
            return H(t1) ? di(t1, t1, e, i) : (wn(function() {
                var n = nn(t1, i)[ft];
                if (!t1[Ci]) {
                    var r = Object.getPrototypeOf(t1), a = new Set([].concat(J(t1), J(r)));
                    a.delete("constructor"), a.delete(ft), G(r, Ci, a);
                }
                t1[Ci].forEach(function(t1) {
                    return n.make_(t1, !e || !(t1 in e) || e[t1]);
                });
            }), t1);
        }
        var Li = "splice", Oi = "update", Pi = {
            get: function(t1, e) {
                var i = t1[ft];
                return e === ft ? i : "length" === e ? i.getArrayLength_() : "string" != typeof e || isNaN(e) ? $(ki, e) ? ki[e] : t1[e] : i.get_(parseInt(e));
            },
            set: function(t1, e, i) {
                var n = t1[ft];
                return "length" === e && n.setArrayLength_(i), "symbol" == typeof e || isNaN(e) ? t1[e] = i : n.set_(parseInt(e), i), !0;
            },
            preventExtensions: function() {
                _(15);
            }
        }, ji = function() {
            function t1(t1, e, i, n) {
                void 0 === t1 && (t1 = "ObservableArray"), this.owned_ = void 0, this.legacyMode_ = void 0, this.atom_ = void 0, this.values_ = [], this.interceptors_ = void 0, this.changeListeners_ = void 0, this.enhancer_ = void 0, this.dehancer = void 0, this.proxy_ = void 0, this.lastKnownLength_ = 0, this.owned_ = i, this.legacyMode_ = n, this.atom_ = new mt(t1), this.enhancer_ = function(t1, i) {
                    return e(t1, i, "ObservableArray[..]");
                };
            }
            var e = t1.prototype;
            return e.dehanceValue_ = function(t1) {
                return void 0 !== this.dehancer ? this.dehancer(t1) : t1;
            }, e.dehanceValues_ = function(t1) {
                return void 0 !== this.dehancer && t1.length > 0 ? t1.map(this.dehancer) : t1;
            }, e.intercept_ = function(t1) {
                return _i(this, t1);
            }, e.observe_ = function(t1, e) {
                return void 0 === e && (e = !1), e && t1({
                    observableKind: "array",
                    object: this.proxy_,
                    debugObjectName: this.atom_.name_,
                    type: "splice",
                    index: 0,
                    added: this.values_.slice(),
                    addedCount: this.values_.length,
                    removed: [],
                    removedCount: 0
                }), Ni(this, t1);
            }, e.getArrayLength_ = function() {
                return this.atom_.reportObserved(), this.values_.length;
            }, e.setArrayLength_ = function(t1) {
                ("number" != typeof t1 || isNaN(t1) || t1 < 0) && _("Out of range: " + t1);
                var e = this.values_.length;
                if (t1 !== e) {
                    if (t1 > e) {
                        for(var i = new Array(t1 - e), n = 0; n < t1 - e; n++)i[n] = void 0;
                        this.spliceWithArray_(e, 0, i);
                    } else this.spliceWithArray_(t1, e - t1);
                }
            }, e.updateArrayLength_ = function(t1, e) {
                t1 !== this.lastKnownLength_ && _(16), this.lastKnownLength_ += e, this.legacyMode_ && e > 0 && gn(t1 + e + 1);
            }, e.spliceWithArray_ = function(t1, e, i) {
                var n = this;
                this.atom_;
                var r = this.values_.length;
                if (void 0 === t1 ? t1 = 0 : t1 > r ? t1 = r : t1 < 0 && (t1 = Math.max(0, r + t1)), e = 1 === arguments.length ? r - t1 : null == e ? 0 : Math.max(0, Math.min(e, r - t1)), void 0 === i && (i = L), Ei(this)) {
                    var a = Ii(this, {
                        object: this.proxy_,
                        type: Li,
                        index: t1,
                        removedCount: e,
                        added: i
                    });
                    if (!a) return L;
                    e = a.removedCount, i = a.added;
                }
                if (i = 0 === i.length ? i : i.map(function(t1) {
                    return n.enhancer_(t1, void 0);
                }), this.legacyMode_) {
                    var s = i.length - e;
                    this.updateArrayLength_(r, s);
                }
                var o = this.spliceItemsIntoValues_(t1, e, i);
                return 0 === e && 0 === i.length || this.notifyArraySplice_(t1, i, o), this.dehanceValues_(o);
            }, e.spliceItemsIntoValues_ = function(t1, e, i) {
                var n;
                if (i.length < 1e4) return (n = this.values_).splice.apply(n, [
                    t1,
                    e
                ].concat(i));
                var r = this.values_.slice(t1, t1 + e), a = this.values_.slice(t1 + e);
                this.values_.length += i.length - e;
                for(var s = 0; s < i.length; s++)this.values_[t1 + s] = i[s];
                for(var o = 0; o < a.length; o++)this.values_[t1 + i.length + o] = a[o];
                return r;
            }, e.notifyArrayChildUpdate_ = function(t1, e, i) {
                var n = !this.owned_ && !1, r = Si(this), a = r || n ? {
                    observableKind: "array",
                    object: this.proxy_,
                    type: Oi,
                    debugObjectName: this.atom_.name_,
                    index: t1,
                    newValue: e,
                    oldValue: i
                } : null;
                this.atom_.reportChanged(), r && Di(this, a);
            }, e.notifyArraySplice_ = function(t1, e, i) {
                var n = !this.owned_ && !1, r = Si(this), a = r || n ? {
                    observableKind: "array",
                    object: this.proxy_,
                    debugObjectName: this.atom_.name_,
                    type: Li,
                    index: t1,
                    removed: i,
                    added: e,
                    removedCount: i.length,
                    addedCount: e.length
                } : null;
                this.atom_.reportChanged(), r && Di(this, a);
            }, e.get_ = function(t1) {
                if (!(this.legacyMode_ && t1 >= this.values_.length)) return this.atom_.reportObserved(), this.dehanceValue_(this.values_[t1]);
                console.warn("[mobx] Out of bounds read: " + t1);
            }, e.set_ = function(t1, e) {
                var i = this.values_;
                if (this.legacyMode_ && t1 > i.length && _(17, t1, i.length), t1 < i.length) {
                    this.atom_;
                    var n = i[t1];
                    if (Ei(this)) {
                        var r = Ii(this, {
                            type: Oi,
                            object: this.proxy_,
                            index: t1,
                            newValue: e
                        });
                        if (!r) return;
                        e = r.newValue;
                    }
                    (e = this.enhancer_(e, n)) !== n && (i[t1] = e, this.notifyArrayChildUpdate_(t1, e, n));
                } else {
                    for(var a = new Array(t1 + 1 - i.length), s = 0; s < a.length - 1; s++)a[s] = void 0;
                    a[a.length - 1] = e, this.spliceWithArray_(i.length, 0, a);
                }
            }, t1;
        }();
        function Ri(t1, e, i, n) {
            return void 0 === i && (i = "ObservableArray"), void 0 === n && (n = !1), R(), wn(function() {
                var r = new ji(i, e, n, !1);
                W(r.values_, ft, r);
                var a = new Proxy(r.values_, Pi);
                return r.proxy_ = a, t1 && t1.length && r.spliceWithArray_(0, 0, t1), a;
            });
        }
        var ki = {
            clear: function() {
                return this.splice(0);
            },
            replace: function(t1) {
                var e = this[ft];
                return e.spliceWithArray_(0, e.values_.length, t1);
            },
            toJSON: function() {
                return this.slice();
            },
            splice: function(t1, e) {
                for(var i = arguments.length, n = new Array(i > 2 ? i - 2 : 0), r = 2; r < i; r++)n[r - 2] = arguments[r];
                var a = this[ft];
                switch(arguments.length){
                    case 0:
                        return [];
                    case 1:
                        return a.spliceWithArray_(t1);
                    case 2:
                        return a.spliceWithArray_(t1, e);
                }
                return a.spliceWithArray_(t1, e, n);
            },
            spliceWithArray: function(t1, e, i) {
                return this[ft].spliceWithArray_(t1, e, i);
            },
            push: function() {
                for(var t1 = this[ft], e = arguments.length, i = new Array(e), n = 0; n < e; n++)i[n] = arguments[n];
                return t1.spliceWithArray_(t1.values_.length, 0, i), t1.values_.length;
            },
            pop: function() {
                return this.splice(Math.max(this[ft].values_.length - 1, 0), 1)[0];
            },
            shift: function() {
                return this.splice(0, 1)[0];
            },
            unshift: function() {
                for(var t1 = this[ft], e = arguments.length, i = new Array(e), n = 0; n < e; n++)i[n] = arguments[n];
                return t1.spliceWithArray_(0, 0, i), t1.values_.length;
            },
            reverse: function() {
                return je.trackingDerivation && _(37, "reverse"), this.replace(this.slice().reverse()), this;
            },
            sort: function() {
                je.trackingDerivation && _(37, "sort");
                var t1 = this.slice();
                return t1.sort.apply(t1, arguments), this.replace(t1), this;
            },
            remove: function(t1) {
                var e = this[ft], i = e.dehanceValues_(e.values_).indexOf(t1);
                return i > -1 && (this.splice(i, 1), !0);
            }
        };
        function Ui(t1, e) {
            "function" == typeof Array.prototype[t1] && (ki[t1] = e(t1));
        }
        function Bi(t1) {
            return function() {
                var e = this[ft];
                e.atom_.reportObserved();
                var i = e.dehanceValues_(e.values_);
                return i[t1].apply(i, arguments);
            };
        }
        function Fi(t1) {
            return function(e, i) {
                var n = this, r = this[ft];
                return r.atom_.reportObserved(), r.dehanceValues_(r.values_)[t1](function(t1, r) {
                    return e.call(i, t1, r, n);
                });
            };
        }
        function Qi(t1) {
            return function() {
                var e = this, i = this[ft];
                i.atom_.reportObserved();
                var n = i.dehanceValues_(i.values_), r = arguments[0];
                return arguments[0] = function(t1, i, n) {
                    return r(t1, i, n, e);
                }, n[t1].apply(n, arguments);
            };
        }
        Ui("at", Bi), Ui("concat", Bi), Ui("flat", Bi), Ui("includes", Bi), Ui("indexOf", Bi), Ui("join", Bi), Ui("lastIndexOf", Bi), Ui("slice", Bi), Ui("toString", Bi), Ui("toLocaleString", Bi), Ui("toSorted", Bi), Ui("toSpliced", Bi), Ui("with", Bi), Ui("every", Fi), Ui("filter", Fi), Ui("find", Fi), Ui("findIndex", Fi), Ui("findLast", Fi), Ui("findLastIndex", Fi), Ui("flatMap", Fi), Ui("forEach", Fi), Ui("map", Fi), Ui("some", Fi), Ui("toReversed", Fi), Ui("reduce", Qi), Ui("reduceRight", Qi);
        var Hi = Y("ObservableArrayAdministration", ji);
        function Vi(t1) {
            return Q(t1) && Hi(t1[ft]);
        }
        var Gi = {}, Wi = "add", Yi = "delete", Xi = function() {
            function t1(t1, e, i) {
                var n = this;
                void 0 === e && (e = yt), void 0 === i && (i = "ObservableMap"), this.enhancer_ = void 0, this.name_ = void 0, this[ft] = Gi, this.data_ = void 0, this.hasMap_ = void 0, this.keysAtom_ = void 0, this.interceptors_ = void 0, this.changeListeners_ = void 0, this.dehancer = void 0, this.enhancer_ = e, this.name_ = i, B(Map) || _(18), wn(function() {
                    n.keysAtom_ = Mt("ObservableMap.keys()"), n.data_ = new Map, n.hasMap_ = new Map, t1 && n.merge(t1);
                });
            }
            var e = t1.prototype;
            return e.has_ = function(t1) {
                return this.data_.has(t1);
            }, e.has = function(t1) {
                var e = this;
                if (!je.trackingDerivation) return this.has_(t1);
                var i = this.hasMap_.get(t1);
                if (!i) {
                    var n = i = new ge(this.has_(t1), xt, "ObservableMap.key?", !1);
                    this.hasMap_.set(t1, n), li(n, function() {
                        return e.hasMap_.delete(t1);
                    });
                }
                return i.get();
            }, e.set = function(t1, e) {
                var i = this.has_(t1);
                if (Ei(this)) {
                    var n = Ii(this, {
                        type: i ? Oi : Wi,
                        object: this,
                        newValue: e,
                        name: t1
                    });
                    if (!n) return this;
                    e = n.newValue;
                }
                return i ? this.updateValue_(t1, e) : this.addValue_(t1, e), this;
            }, e.delete = function(t1) {
                var e = this;
                if (this.keysAtom_, Ei(this) && !Ii(this, {
                    type: Yi,
                    object: this,
                    name: t1
                })) return !1;
                if (this.has_(t1)) {
                    var i = Si(this), n = i ? {
                        observableKind: "map",
                        debugObjectName: this.name_,
                        type: Yi,
                        object: this,
                        oldValue: this.data_.get(t1).value_,
                        name: t1
                    } : null;
                    return wi(function() {
                        var i;
                        e.keysAtom_.reportChanged(), null == (i = e.hasMap_.get(t1)) || i.setNewValue_(!1), e.data_.get(t1).setNewValue_(void 0), e.data_.delete(t1);
                    }), i && Di(this, n), !0;
                }
                return !1;
            }, e.updateValue_ = function(t1, e) {
                var i = this.data_.get(t1);
                if ((e = i.prepareNewValue_(e)) !== je.UNCHANGED) {
                    var n = Si(this), r = n ? {
                        observableKind: "map",
                        debugObjectName: this.name_,
                        type: Oi,
                        object: this,
                        oldValue: i.value_,
                        name: t1,
                        newValue: e
                    } : null;
                    i.setNewValue_(e), n && Di(this, r);
                }
            }, e.addValue_ = function(t1, e) {
                var i = this;
                this.keysAtom_, wi(function() {
                    var n, r = new ge(e, i.enhancer_, "ObservableMap.key", !1);
                    i.data_.set(t1, r), e = r.value_, null == (n = i.hasMap_.get(t1)) || n.setNewValue_(!0), i.keysAtom_.reportChanged();
                });
                var n = Si(this), r = n ? {
                    observableKind: "map",
                    debugObjectName: this.name_,
                    type: Wi,
                    object: this,
                    name: t1,
                    newValue: e
                } : null;
                n && Di(this, r);
            }, e.get = function(t1) {
                return this.has(t1) ? this.dehanceValue_(this.data_.get(t1).get()) : this.dehanceValue_(void 0);
            }, e.dehanceValue_ = function(t1) {
                return void 0 !== this.dehancer ? this.dehancer(t1) : t1;
            }, e.keys = function() {
                return this.keysAtom_.reportObserved(), this.data_.keys();
            }, e.values = function() {
                var t1 = this, e = this.keys();
                return In({
                    next: function() {
                        var i = e.next(), n = i.done, r = i.value;
                        return {
                            done: n,
                            value: n ? void 0 : t1.get(r)
                        };
                    }
                });
            }, e.entries = function() {
                var t1 = this, e = this.keys();
                return In({
                    next: function() {
                        var i = e.next(), n = i.done, r = i.value;
                        return {
                            done: n,
                            value: n ? void 0 : [
                                r,
                                t1.get(r)
                            ]
                        };
                    }
                });
            }, e[Symbol.iterator] = function() {
                return this.entries();
            }, e.forEach = function(t1, e) {
                for(var i, n = st(this); !(i = n()).done;){
                    var r = i.value, a = r[0], s = r[1];
                    t1.call(e, s, a, this);
                }
            }, e.merge = function(t1) {
                var e = this;
                return Zi(t1) && (t1 = new Map(t1)), wi(function() {
                    var i, n, r;
                    H(t1) ? (function(t1) {
                        var e = Object.keys(t1);
                        if (!q) return e;
                        var i = Object.getOwnPropertySymbols(t1);
                        return i.length ? [].concat(e, i.filter(function(e) {
                            return z.propertyIsEnumerable.call(t1, e);
                        })) : e;
                    })(t1).forEach(function(i) {
                        return e.set(i, t1[i]);
                    }) : Array.isArray(t1) ? t1.forEach(function(t1) {
                        var i = t1[0], n = t1[1];
                        return e.set(i, n);
                    }) : X(t1) ? (i = t1, n = Object.getPrototypeOf(i), r = Object.getPrototypeOf(n), null !== Object.getPrototypeOf(r) && _(19, t1), t1.forEach(function(t1, i) {
                        return e.set(i, t1);
                    })) : null != t1 && _(20, t1);
                }), this;
            }, e.clear = function() {
                var t1 = this;
                wi(function() {
                    Ie(function() {
                        for(var e, i = st(t1.keys()); !(e = i()).done;){
                            var n = e.value;
                            t1.delete(n);
                        }
                    });
                });
            }, e.replace = function(t1) {
                var e = this;
                return wi(function() {
                    for(var i, n = function(t1) {
                        if (X(t1) || Zi(t1)) return t1;
                        if (Array.isArray(t1)) return new Map(t1);
                        if (H(t1)) {
                            var e = new Map;
                            for(var i in t1)e.set(i, t1[i]);
                            return e;
                        }
                        return _(21, t1);
                    }(t1), r = new Map, a = !1, s = st(e.data_.keys()); !(i = s()).done;){
                        var o = i.value;
                        if (!n.has(o)) {
                            if (e.delete(o)) a = !0;
                            else {
                                var l = e.data_.get(o);
                                r.set(o, l);
                            }
                        }
                    }
                    for(var c, u = st(n.entries()); !(c = u()).done;){
                        var h = c.value, d = h[0], p = h[1], A = e.data_.has(d);
                        if (e.set(d, p), e.data_.has(d)) {
                            var f = e.data_.get(d);
                            r.set(d, f), A || (a = !0);
                        }
                    }
                    if (!a) {
                        if (e.data_.size !== r.size) e.keysAtom_.reportChanged();
                        else for(var m = e.data_.keys(), g = r.keys(), M = m.next(), v = g.next(); !M.done;){
                            if (M.value !== v.value) {
                                e.keysAtom_.reportChanged();
                                break;
                            }
                            M = m.next(), v = g.next();
                        }
                    }
                    e.data_ = r;
                }), this;
            }, e.toString = function() {
                return "[object ObservableMap]";
            }, e.toJSON = function() {
                return Array.from(this);
            }, e.observe_ = function(t1, e) {
                return Ni(this, t1);
            }, e.intercept_ = function(t1) {
                return _i(this, t1);
            }, at(t1, [
                {
                    key: "size",
                    get: function() {
                        return this.keysAtom_.reportObserved(), this.data_.size;
                    }
                },
                {
                    key: Symbol.toStringTag,
                    get: function() {
                        return "Map";
                    }
                }
            ]);
        }(), Zi = Y("ObservableMap", Xi), qi = {}, Ji = function() {
            function t1(t1, e, i) {
                var n = this;
                void 0 === e && (e = yt), void 0 === i && (i = "ObservableSet"), this.name_ = void 0, this[ft] = qi, this.data_ = new Set, this.atom_ = void 0, this.changeListeners_ = void 0, this.interceptors_ = void 0, this.dehancer = void 0, this.enhancer_ = void 0, this.name_ = i, B(Set) || _(22), this.enhancer_ = function(t1, n) {
                    return e(t1, n, i);
                }, wn(function() {
                    n.atom_ = Mt(n.name_), t1 && n.replace(t1);
                });
            }
            var e = t1.prototype;
            return e.dehanceValue_ = function(t1) {
                return void 0 !== this.dehancer ? this.dehancer(t1) : t1;
            }, e.clear = function() {
                var t1 = this;
                wi(function() {
                    Ie(function() {
                        for(var e, i = st(t1.data_.values()); !(e = i()).done;){
                            var n = e.value;
                            t1.delete(n);
                        }
                    });
                });
            }, e.forEach = function(t1, e) {
                for(var i, n = st(this); !(i = n()).done;){
                    var r = i.value;
                    t1.call(e, r, r, this);
                }
            }, e.add = function(t1) {
                var e = this;
                if (this.atom_, Ei(this) && !Ii(this, {
                    type: Wi,
                    object: this,
                    newValue: t1
                })) return this;
                if (!this.has(t1)) {
                    wi(function() {
                        e.data_.add(e.enhancer_(t1, void 0)), e.atom_.reportChanged();
                    });
                    var i = Si(this), n = i ? {
                        observableKind: "set",
                        debugObjectName: this.name_,
                        type: Wi,
                        object: this,
                        newValue: t1
                    } : null;
                    i && Di(this, n);
                }
                return this;
            }, e.delete = function(t1) {
                var e = this;
                if (Ei(this) && !Ii(this, {
                    type: Yi,
                    object: this,
                    oldValue: t1
                })) return !1;
                if (this.has(t1)) {
                    var i = Si(this), n = i ? {
                        observableKind: "set",
                        debugObjectName: this.name_,
                        type: Yi,
                        object: this,
                        oldValue: t1
                    } : null;
                    return wi(function() {
                        e.atom_.reportChanged(), e.data_.delete(t1);
                    }), i && Di(this, n), !0;
                }
                return !1;
            }, e.has = function(t1) {
                return this.atom_.reportObserved(), this.data_.has(this.dehanceValue_(t1));
            }, e.entries = function() {
                var t1 = 0, e = Array.from(this.keys()), i = Array.from(this.values());
                return In({
                    next: function() {
                        var n = t1;
                        return t1 += 1, n < i.length ? {
                            value: [
                                e[n],
                                i[n]
                            ],
                            done: !1
                        } : {
                            done: !0
                        };
                    }
                });
            }, e.keys = function() {
                return this.values();
            }, e.values = function() {
                this.atom_.reportObserved();
                var t1 = this, e = 0, i = Array.from(this.data_.values());
                return In({
                    next: function() {
                        return e < i.length ? {
                            value: t1.dehanceValue_(i[e++]),
                            done: !1
                        } : {
                            done: !0
                        };
                    }
                });
            }, e.intersection = function(t1) {
                return Z(t1) ? t1.intersection(this) : new Set(this).intersection(t1);
            }, e.union = function(t1) {
                return Z(t1) ? t1.union(this) : new Set(this).union(t1);
            }, e.difference = function(t1) {
                return new Set(this).difference(t1);
            }, e.symmetricDifference = function(t1) {
                return Z(t1) ? t1.symmetricDifference(this) : new Set(this).symmetricDifference(t1);
            }, e.isSubsetOf = function(t1) {
                return new Set(this).isSubsetOf(t1);
            }, e.isSupersetOf = function(t1) {
                return new Set(this).isSupersetOf(t1);
            }, e.isDisjointFrom = function(t1) {
                return Z(t1) ? t1.isDisjointFrom(this) : new Set(this).isDisjointFrom(t1);
            }, e.replace = function(t1) {
                var e = this;
                return Ki(t1) && (t1 = new Set(t1)), wi(function() {
                    Array.isArray(t1) || Z(t1) ? (e.clear(), t1.forEach(function(t1) {
                        return e.add(t1);
                    })) : null != t1 && _("Cannot initialize set from " + t1);
                }), this;
            }, e.observe_ = function(t1, e) {
                return Ni(this, t1);
            }, e.intercept_ = function(t1) {
                return _i(this, t1);
            }, e.toJSON = function() {
                return Array.from(this);
            }, e.toString = function() {
                return "[object ObservableSet]";
            }, e[Symbol.iterator] = function() {
                return this.values();
            }, at(t1, [
                {
                    key: "size",
                    get: function() {
                        return this.atom_.reportObserved(), this.data_.size;
                    }
                },
                {
                    key: Symbol.toStringTag,
                    get: function() {
                        return "Set";
                    }
                }
            ]);
        }(), Ki = Y("ObservableSet", Ji), $i = Object.create(null), tn = "remove", en = function() {
            function t1(t1, e, i, n) {
                void 0 === e && (e = new Map), void 0 === n && (n = Qt), this.target_ = void 0, this.values_ = void 0, this.name_ = void 0, this.defaultAnnotation_ = void 0, this.keysAtom_ = void 0, this.changeListeners_ = void 0, this.interceptors_ = void 0, this.proxy_ = void 0, this.isPlainObject_ = void 0, this.appliedAnnotations_ = void 0, this.pendingKeys_ = void 0, this.target_ = t1, this.values_ = e, this.name_ = i, this.defaultAnnotation_ = n, this.keysAtom_ = new mt("ObservableObject.keys"), this.isPlainObject_ = H(this.target_);
            }
            var e = t1.prototype;
            return e.getObservablePropValue_ = function(t1) {
                return this.values_.get(t1).get();
            }, e.setObservablePropValue_ = function(t1, e) {
                var i = this.values_.get(t1);
                if (i instanceof Me) return i.set(e), !0;
                if (Ei(this)) {
                    var n = Ii(this, {
                        type: Oi,
                        object: this.proxy_ || this.target_,
                        name: t1,
                        newValue: e
                    });
                    if (!n) return null;
                    e = n.newValue;
                }
                if ((e = i.prepareNewValue_(e)) !== je.UNCHANGED) {
                    var r = Si(this), a = r ? {
                        type: Oi,
                        observableKind: "object",
                        debugObjectName: this.name_,
                        object: this.proxy_ || this.target_,
                        oldValue: i.value_,
                        name: t1,
                        newValue: e
                    } : null;
                    i.setNewValue_(e), r && Di(this, a);
                }
                return !0;
            }, e.get_ = function(t1) {
                return je.trackingDerivation && !$(this.target_, t1) && this.has_(t1), this.target_[t1];
            }, e.set_ = function(t1, e, i) {
                return void 0 === i && (i = !1), $(this.target_, t1) ? this.values_.has(t1) ? this.setObservablePropValue_(t1, e) : i ? Reflect.set(this.target_, t1, e) : (this.target_[t1] = e, !0) : this.extend_(t1, {
                    value: e,
                    enumerable: !0,
                    writable: !0,
                    configurable: !0
                }, this.defaultAnnotation_, i);
            }, e.has_ = function(t1) {
                if (!je.trackingDerivation) return t1 in this.target_;
                this.pendingKeys_ || (this.pendingKeys_ = new Map);
                var e = this.pendingKeys_.get(t1);
                return e || (e = new ge(t1 in this.target_, xt, "ObservableObject.key?", !1), this.pendingKeys_.set(t1, e)), e.get();
            }, e.make_ = function(t1, e) {
                if (!0 === e && (e = this.defaultAnnotation_), !1 !== e) {
                    if (!(t1 in this.target_)) {
                        var i;
                        if (null != (i = this.target_[ht]) && i[t1]) return;
                        _(1, e.annotationType_, this.name_ + "." + t1.toString());
                    }
                    for(var n = this.target_; n && n !== z;){
                        var r = D(n, t1);
                        if (r) {
                            var a = e.make_(this, t1, r, n);
                            if (0 === a) return;
                            if (1 === a) break;
                        }
                        n = Object.getPrototypeOf(n);
                    }
                    on(this, 0, t1);
                }
            }, e.extend_ = function(t1, e, i, n) {
                if (void 0 === n && (n = !1), !0 === i && (i = this.defaultAnnotation_), !1 === i) return this.defineProperty_(t1, e, n);
                var r = i.extend_(this, t1, e, n);
                return r && on(this, 0, t1), r;
            }, e.defineProperty_ = function(t1, e, i) {
                void 0 === i && (i = !1), this.keysAtom_;
                try {
                    Ue();
                    var n = this.delete_(t1);
                    if (!n) return n;
                    if (Ei(this)) {
                        var r = Ii(this, {
                            object: this.proxy_ || this.target_,
                            name: t1,
                            type: Wi,
                            newValue: e.value
                        });
                        if (!r) return null;
                        var a = r.newValue;
                        e.value !== a && (e = ot({}, e, {
                            value: a
                        }));
                    }
                    if (i) {
                        if (!Reflect.defineProperty(this.target_, t1, e)) return !1;
                    } else C(this.target_, t1, e);
                    this.notifyPropertyAddition_(t1, e.value);
                } finally{
                    Be();
                }
                return !0;
            }, e.defineObservableProperty_ = function(t1, e, i, n) {
                void 0 === n && (n = !1), this.keysAtom_;
                try {
                    Ue();
                    var r = this.delete_(t1);
                    if (!r) return r;
                    if (Ei(this)) {
                        var a = Ii(this, {
                            object: this.proxy_ || this.target_,
                            name: t1,
                            type: Wi,
                            newValue: e
                        });
                        if (!a) return null;
                        e = a.newValue;
                    }
                    var s = an(t1), o = {
                        configurable: !je.safeDescriptors || this.isPlainObject_,
                        enumerable: !0,
                        get: s.get,
                        set: s.set
                    };
                    if (n) {
                        if (!Reflect.defineProperty(this.target_, t1, o)) return !1;
                    } else C(this.target_, t1, o);
                    var l = new ge(e, i, "ObservableObject.key", !1);
                    this.values_.set(t1, l), this.notifyPropertyAddition_(t1, l.value_);
                } finally{
                    Be();
                }
                return !0;
            }, e.defineComputedProperty_ = function(t1, e, i) {
                void 0 === i && (i = !1), this.keysAtom_;
                try {
                    Ue();
                    var n = this.delete_(t1);
                    if (!n) return n;
                    if (Ei(this) && !Ii(this, {
                        object: this.proxy_ || this.target_,
                        name: t1,
                        type: Wi,
                        newValue: void 0
                    })) return null;
                    e.name || (e.name = "ObservableObject.key"), e.context = this.proxy_ || this.target_;
                    var r = an(t1), a = {
                        configurable: !je.safeDescriptors || this.isPlainObject_,
                        enumerable: !1,
                        get: r.get,
                        set: r.set
                    };
                    if (i) {
                        if (!Reflect.defineProperty(this.target_, t1, a)) return !1;
                    } else C(this.target_, t1, a);
                    this.values_.set(t1, new Me(e)), this.notifyPropertyAddition_(t1, void 0);
                } finally{
                    Be();
                }
                return !0;
            }, e.delete_ = function(t1, e) {
                if (void 0 === e && (e = !1), this.keysAtom_, !$(this.target_, t1)) return !0;
                if (Ei(this) && !Ii(this, {
                    object: this.proxy_ || this.target_,
                    name: t1,
                    type: tn
                })) return null;
                try {
                    var i;
                    Ue();
                    var n, r = Si(this), a = this.values_.get(t1), s = void 0;
                    if (!a && r && (s = null == (n = D(this.target_, t1)) ? void 0 : n.value), e) {
                        if (!Reflect.deleteProperty(this.target_, t1)) return !1;
                    } else delete this.target_[t1];
                    if (a && (this.values_.delete(t1), a instanceof ge && (s = a.value_), Qe(a)), this.keysAtom_.reportChanged(), null == (i = this.pendingKeys_) || null == (i = i.get(t1)) || i.set(t1 in this.target_), r) {
                        var o = {
                            type: tn,
                            observableKind: "object",
                            object: this.proxy_ || this.target_,
                            debugObjectName: this.name_,
                            oldValue: s,
                            name: t1
                        };
                        r && Di(this, o);
                    }
                } finally{
                    Be();
                }
                return !0;
            }, e.observe_ = function(t1, e) {
                return Ni(this, t1);
            }, e.intercept_ = function(t1) {
                return _i(this, t1);
            }, e.notifyPropertyAddition_ = function(t1, e) {
                var i, n = Si(this);
                if (n) {
                    var r = n ? {
                        type: Wi,
                        observableKind: "object",
                        debugObjectName: this.name_,
                        object: this.proxy_ || this.target_,
                        name: t1,
                        newValue: e
                    } : null;
                    n && Di(this, r);
                }
                null == (i = this.pendingKeys_) || null == (i = i.get(t1)) || i.set(!0), this.keysAtom_.reportChanged();
            }, e.ownKeys_ = function() {
                return this.keysAtom_.reportObserved(), J(this.target_);
            }, e.keys_ = function() {
                return this.keysAtom_.reportObserved(), Object.keys(this.target_);
            }, t1;
        }();
        function nn(t1, e) {
            var i;
            if ($(t1, ft)) return t1;
            var n = null != (i = null == e ? void 0 : e.name) ? i : "ObservableObject", r = new en(t1, new Map, String(n), function(t1) {
                var e;
                return t1 ? null != (e = t1.defaultDecorator) ? e : Ht(t1) : void 0;
            }(e));
            return G(t1, ft, r), t1;
        }
        var rn = Y("ObservableObjectAdministration", en);
        function an(t1) {
            return $i[t1] || ($i[t1] = {
                get: function() {
                    return this[ft].getObservablePropValue_(t1);
                },
                set: function(e) {
                    return this[ft].setObservablePropValue_(t1, e);
                }
            });
        }
        function sn(t1) {
            return !!Q(t1) && rn(t1[ft]);
        }
        function on(t1, e, i) {
            var n;
            null == (n = t1.target_[ht]) || delete n[i];
        }
        var ln, cn, un = fn(0), hn = function() {
            var t1 = !1, e = {};
            return Object.defineProperty(e, "0", {
                set: function() {
                    t1 = !0;
                }
            }), Object.create(e)[0] = 1, !1 === t1;
        }(), dn = 0, pn = function() {};
        ln = pn, cn = Array.prototype, Object.setPrototypeOf ? Object.setPrototypeOf(ln.prototype, cn) : void 0 !== ln.prototype.__proto__ ? ln.prototype.__proto__ = cn : ln.prototype = cn;
        var An = function(t1) {
            function e(e, i, n, r) {
                var a;
                return void 0 === n && (n = "ObservableArray"), void 0 === r && (r = !1), a = t1.call(this) || this, wn(function() {
                    var t1 = new ji(n, i, r, !0);
                    t1.proxy_ = a, W(a, ft, t1), e && e.length && a.spliceWithArray(0, 0, e), hn && Object.defineProperty(a, "0", un);
                }), a;
            }
            lt(e, t1);
            var i = e.prototype;
            return i.concat = function() {
                this[ft].atom_.reportObserved();
                for(var t1 = arguments.length, e = new Array(t1), i = 0; i < t1; i++)e[i] = arguments[i];
                return Array.prototype.concat.apply(this.slice(), e.map(function(t1) {
                    return Vi(t1) ? t1.slice() : t1;
                }));
            }, i[Symbol.iterator] = function() {
                var t1 = this, e = 0;
                return In({
                    next: function() {
                        return e < t1.length ? {
                            value: t1[e++],
                            done: !1
                        } : {
                            done: !0,
                            value: void 0
                        };
                    }
                });
            }, at(e, [
                {
                    key: "length",
                    get: function() {
                        return this[ft].getArrayLength_();
                    },
                    set: function(t1) {
                        this[ft].setArrayLength_(t1);
                    }
                },
                {
                    key: Symbol.toStringTag,
                    get: function() {
                        return "Array";
                    }
                }
            ]);
        }(pn);
        function fn(t1) {
            return {
                enumerable: !1,
                configurable: !0,
                get: function() {
                    return this[ft].get_(t1);
                },
                set: function(e) {
                    this[ft].set_(t1, e);
                }
            };
        }
        function mn(t1) {
            C(An.prototype, "" + t1, fn(t1));
        }
        function gn(t1) {
            if (t1 > dn) {
                for(var e = dn; e < t1 + 100; e++)mn(e);
                dn = t1;
            }
        }
        function Mn(t1, e, i) {
            return new An(t1, e, i);
        }
        function vn(t1, e) {
            if ("object" == typeof t1 && null !== t1) {
                if (Vi(t1)) return void 0 !== e && _(23), t1[ft].atom_;
                if (Ki(t1)) return t1.atom_;
                if (Zi(t1)) {
                    if (void 0 === e) return t1.keysAtom_;
                    var i = t1.data_.get(e) || t1.hasMap_.get(e);
                    return i || _(25, e, xn(t1)), i;
                }
                if (sn(t1)) {
                    if (!e) return _(26);
                    var n = t1[ft].values_.get(e);
                    return n || _(27, e, xn(t1)), n;
                }
                if (gt(t1) || xe(t1) || Xe(t1)) return t1;
            } else if (B(t1) && Xe(t1[ft])) return t1[ft];
            _(28);
        }
        function yn(t1, e) {
            return t1 || _(29), void 0 !== e ? yn(vn(t1, e)) : gt(t1) || xe(t1) || Xe(t1) || Zi(t1) || Ki(t1) ? t1 : t1[ft] ? t1[ft] : void _(24, t1);
        }
        function xn(t1, e) {
            var i;
            if (void 0 !== e) i = vn(t1, e);
            else {
                if (ri(t1)) return t1.name;
                i = sn(t1) || Zi(t1) || Ki(t1) ? yn(t1) : vn(t1);
            }
            return i.name_;
        }
        function wn(t1) {
            var e = Se(), i = fe(!0);
            Ue();
            try {
                return t1();
            } finally{
                Be(), me(i), Ne(e);
            }
        }
        Object.entries(ki).forEach(function(t1) {
            var e = t1[0], i = t1[1];
            "concat" !== e && G(An.prototype, e, i);
        }), gn(1e3);
        var bn = z.toString;
        function Tn(t1, e, i) {
            return void 0 === i && (i = -1), En(t1, e, i);
        }
        function En(t1, e, i, n, r) {
            if (t1 === e) return 0 !== t1 || 1 / t1 == 1 / e;
            if (null == t1 || null == e) return !1;
            if (t1 != t1) return e != e;
            var a = typeof t1;
            if ("function" !== a && "object" !== a && "object" != typeof e) return !1;
            var s = bn.call(t1);
            if (s !== bn.call(e)) return !1;
            switch(s){
                case "[object RegExp]":
                case "[object String]":
                    return "" + t1 == "" + e;
                case "[object Number]":
                    return +t1 != +t1 ? +e != +e : 0 == +t1 ? 1 / +t1 == 1 / e : +t1 == +e;
                case "[object Date]":
                case "[object Boolean]":
                    return +t1 == +e;
                case "[object Symbol]":
                    return "undefined" != typeof Symbol && Symbol.valueOf.call(t1) === Symbol.valueOf.call(e);
                case "[object Map]":
                case "[object Set]":
                    i >= 0 && i++;
            }
            t1 = _n(t1), e = _n(e);
            var o = "[object Array]" === s;
            if (!o) {
                if ("object" != typeof t1 || "object" != typeof e) return !1;
                var l = t1.constructor, c = e.constructor;
                if (l !== c && !(B(l) && l instanceof l && B(c) && c instanceof c) && "constructor" in t1 && "constructor" in e) return !1;
            }
            if (0 === i) return !1;
            i < 0 && (i = -1), r = r || [];
            for(var u = (n = n || []).length; u--;)if (n[u] === t1) return r[u] === e;
            if (n.push(t1), r.push(e), o) {
                if ((u = t1.length) !== e.length) return !1;
                for(; u--;)if (!En(t1[u], e[u], i - 1, n, r)) return !1;
            } else {
                var h, d = Object.keys(t1);
                if (u = d.length, Object.keys(e).length !== u) return !1;
                for(; u--;)if (!$(e, h = d[u]) || !En(t1[h], e[h], i - 1, n, r)) return !1;
            }
            return n.pop(), r.pop(), !0;
        }
        function _n(t1) {
            return Vi(t1) ? t1.slice() : X(t1) || Zi(t1) || Z(t1) || Ki(t1) ? Array.from(t1.entries()) : t1;
        }
        function In(t1) {
            return t1[Symbol.iterator] = Sn, t1;
        }
        function Sn() {
            return this;
        }
        function Nn(t1, e, i) {
            return (e = function(t1) {
                var e = function(t1) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var e = t1[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e)) in t1 ? Object.defineProperty(t1, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = i, t1;
        }
        [
            "Symbol",
            "Map",
            "Set"
        ].forEach(function(t1) {
            void 0 === S()[t1] && _("MobX requires global '" + t1 + "' to be available or polyfilled");
        }), "object" == typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ && __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
            spy: function(t1) {
                return console.warn("[mobx.spy] Is a no-op in production builds"), function() {};
            },
            extras: {
                getDebugName: xn
            },
            $mobx: ft
        }), hi({
            useProxies: "never"
        });
        const Dn = class {
            constructor(t1){
                Nn(this, "API_URL", null), Nn(this, "getBrandingData", (t1)=>t1 ? {
                        name: t1.company_name,
                        url: t1.company_url
                    } : null), Nn(this, "getParsedData", async (t1)=>{
                    var e, i, n, r, a, s;
                    const o = await this.loadJson(t1.json.value), l = this.getBrandingData(t1.widget_branding), c = t1.original_plans_img || [], u = t1.styled_plan_img || [], h = t1.floors.map((t1, e)=>{
                        var i, n;
                        return {
                            ...t1,
                            original_plan_img: null !== (i = null !== (n = u[e]) && void 0 !== n ? n : c[e]) && void 0 !== i ? i : null
                        };
                    });
                    return {
                        raw: t1,
                        parsed: {
                            locale: (null === (e = t1.widget_branding) || void 0 === e ? void 0 : e.widget_language) || "en",
                            logo: (null === (i = t1.widget_branding) || void 0 === i ? void 0 : i.logo_path) || null,
                            floors: h,
                            branding: l,
                            json: o,
                            bareshell: null !== (n = null === (r = t1.hidden_furniture) || void 0 === r ? void 0 : r.enabled) && void 0 !== n && n,
                            hasTopViewMask: null !== (a = t1.has_top_view_room_ids) && void 0 !== a && a,
                            hasMiddleCutMasks: null !== (s = t1.has_middle_cut_room_ids) && void 0 !== s && s
                        }
                    };
                }), Nn(this, "loadFurnitureData", async ()=>{
                    const t1 = "".concat(this.API_URL, "/api/furniture"), e = await fetch(t1);
                    return await e.json();
                }), Nn(this, "loadCrmWidgetData", async (t1)=>{
                    const e = "".concat(this.API_URL, "/api/crm/plans/").concat(t1, "/widget"), i = await fetch(e, {
                        headers: {
                            "Widget-Version": "2.8.5"
                        }
                    }), n = await i.json();
                    return this.getParsedData(n);
                }), Nn(this, "loadWidgetData", async (t1)=>{
                    const e = "".concat(this.API_URL, "/api/plans/").concat(t1, "/v2/widget"), i = await fetch(e, {
                        headers: {
                            "Widget-Version": "2.8.5"
                        }
                    }), n = await i.json();
                    return this.getParsedData(n);
                }), Nn(this, "loadEditorData", async (t1, e)=>{
                    const i = "".concat(this.API_URL, "/api/plans/").concat(t1, "/editor?token=").concat(e), n = await fetch(i);
                    return await n.json();
                }), Nn(this, "loadPanoramaData", async (t1)=>{
                    const e = "".concat(this.API_URL, "/api/plans/").concat(t1, "/panorama"), i = await fetch(e);
                    return await i.json();
                }), Nn(this, "loadJson", async (t1)=>{
                    const e = await fetch(t1);
                    return await e.json();
                }), zi(this), this.API_URL = t1;
            }
        }, Cn = JSON.parse('{"create-points":"\u0421\u043E\u0437\u0434\u0430\u0432\u0430\u0439\u0442\u0435 \u0442\u043E\u0447\u043A\u0438","delete-points":"\u0423\u0434\u0430\u043B\u044F\u0439\u0442\u0435 \u0442\u043E\u0447\u043A\u0438","research-plan":"\u0418\u0441\u0441\u043B\u0435\u0434\u043E\u0432\u0430\u0442\u044C \u043F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u043A\u0443","rotate-plan":"\u0412\u0440\u0430\u0449\u0430\u0442\u044C \u043F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u043A\u0443","ok":"\u041E\u043A","made-by-link":"https://hart-estate.ru/","made-by-text":"hart-estate.ru","instructions-hint-text":"","floor":"$0 \u044D\u0442\u0430\u0436"}'), zn = JSON.parse('{"create-points":"Create a point","delete-points":"Remove point","research-plan":"Research plan","rotate-plan":"Rotate plan","ok":"Ok","made-by-link":"https://getfloorplan.com/","made-by-text":"getfloorplan.com","instructions-hint-text":"","floor":"$0 floor","floorNumberEndings":{"1":"st","2":"nd","3":"d","rest":"th"}}'), Ln = JSON.parse('{"research-plan":"klicken","rotate-plan":"drehen","ok":"Ok","made-by-link":"","made-by-text":"","instructions-hint-text":"","floor":"$0 boden"}'), On = JSON.parse('{"research-plan":"Explora el dise\xf1o","rotate-plan":"Girar dise\xf1o","rotate":"Comenzar","stop":"Detener","plan":"Disposici\xf3n","off":"Apagar","on":"Encender","ok":"Ok","menu":"Men\xfa","wasd":"WASD","view-from-above":"Vista desde arriba","free-camera":"Revisi\xf3n gratuita","shadows":"Oscuridad","hide-walls":"Ocultar paredes","show-walls":"Mostrar paredes","hide-doors":"Ocultar puertas","show-doors":"Mostrar puertas","material":"Material","texture":"Textura","color":"Color","wall-color":"Color de la pared","wall-texture":"Textura de la pared","upload-wall-texture":"Textura de la pared de carga","made-by-link":"","made-by-text":"","instructions-hint-text":"","floor":"$0 piso"}'), Pn = JSON.parse('{"create-points":"\u8A08\u6E2C\u958B\u59CB","delete-points":"\u78BA\u5B9A","research-plan":"\u30BF\u30C3\u30D7\u3057\u3066\u79FB\u52D5","rotate-plan":"\u30C9\u30E9\u30C3\u30B0\u3067\u79FB\u52D5","ok":"Ok","made-by-link":"","made-by-text":"","instructions-hint-text":"","floor":"$0 \u968E"}');
        function jn(t1, e, i) {
            return (e = function(t1) {
                var e = function(t1) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var e = t1[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e)) in t1 ? Object.defineProperty(t1, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = i, t1;
        }
        hi({
            useProxies: "never"
        });
        const Rn = new class {
            constructor(){
                jn(this, "availableLocales", [
                    "ru",
                    "en",
                    "de",
                    "es",
                    "ja"
                ]), jn(this, "locales", {
                    ru: Cn,
                    en: zn,
                    de: Ln,
                    es: On,
                    ja: Pn
                }), jn(this, "currentLocale", "en"), jn(this, "getLocaleText", (t1)=>this.localeData[t1]), jn(this, "setCurrentLocale", (t1)=>{
                    this.availableLocales.some((e)=>e === t1) && (this.currentLocale = t1);
                }), zi(this);
            }
            get localeData() {
                return this.locales[this.currentLocale];
            }
        };
        function kn(t1, e, i) {
            return (e = function(t1) {
                var e = function(t1) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var e = t1[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e)) in t1 ? Object.defineProperty(t1, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = i, t1;
        }
        hi({
            useProxies: "never"
        });
        const Un = new class {
            constructor(){
                kn(this, "controlsVisible", !0), kn(this, "currentFloorIndex", 0), kn(this, "configParams", null), kn(this, "listeners", {
                    resize: []
                }), zi(this);
            }
            get primaryCameraPointId() {
                var t1;
                if (!this.config.json) return null;
                const e = this.config.json.Floors[this.currentFloorIndex];
                if (this.config.primaryCameraPointId && e.CameraPoints.some((t1)=>{
                    let { ID: e } = t1;
                    return e === this.config.primaryCameraPointId;
                })) return this.config.primaryCameraPointId;
                const i = e.PrimaryCameraPointId || null, n = (null === (t1 = this.config.json.Meta) || void 0 === t1 ? void 0 : t1.PrimaryCameraPointId) || null;
                return i || n;
            }
            get initialPanoramaRoomId() {
                if (!this.config.json) return null;
                const { Rooms: t1 } = this.config.json.Floors[this.currentFloorIndex].Units[0], e = [
                    ...t1
                ].sort((t1, e)=>e.Area - t1.Area), i = e.find((t1)=>{
                    let { Type: e } = t1;
                    return "Living" === e;
                }), n = e[0];
                return (null == i ? void 0 : i.ID) || (null == n ? void 0 : n.ID) || null;
            }
            get config() {
                return this.getFloorConfig(this.currentFloorIndex);
            }
            get prevFloorIndex() {
                const t1 = this.currentFloorIndex - 1;
                return t1 < 0 ? this.configParams.floors.length - 1 : t1;
            }
            get nextFloorIndex() {
                return (this.currentFloorIndex + 1) % this.configParams.floors.length;
            }
            get dictionaryOverrides() {
                return this.configParams.dictionaryOverrides;
            }
            get autoRotatePanarama() {
                return this.configParams.autoRotate;
            }
            get instructionVisible() {
                return this.configParams.instructionVisible;
            }
            get scales() {
                return this.config.scales;
            }
            isCapable(t1) {
                var e;
                return Boolean(null === (e = this.configParams) || void 0 === e || null === (e = e.capabilities) || void 0 === e || null === (e = e[t1]) || void 0 === e ? void 0 : e.enabled);
            }
            getFloorConfig(t1) {
                const e = this.getFloorParamByKey("original_plan_img", t1), i = this.getFloorParamByKey("styled_plan_img", t1), n = this.getFloorParamByKey("original_plans_img", t1), r = this.getFloorParamByKey("top_view_img", t1), a = this.getFloorParamByKey("panorama", t1), s = this.getFloorParamByKey("rotate", t1);
                return {
                    ...this.configParams,
                    originalPlans: n,
                    planImage: i || e,
                    rotationData: s,
                    panoramaData: a,
                    topViewImage: r
                };
            }
            setCurrentFloorIndex(t1) {
                this.currentFloorIndex = t1;
            }
            setPrevFloorIndex() {
                this.setCurrentFloorIndex(this.prevFloorIndex);
            }
            setNextFloorIndex() {
                this.setCurrentFloorIndex(this.nextFloorIndex);
            }
            getFloorParamByKey(t1, e) {
                return this.configParams.floors[e][t1];
            }
            isTabIncluded(t1) {
                return this.config.tabs.find((e)=>e === t1);
            }
            setConfig(t1) {
                this.configParams = t1, Rn.setCurrentLocale(t1.locale), this.dispatchEvent("resize", {
                    width: t1.width,
                    height: t1.height
                });
            }
            hideControls() {
                this.controlsVisible = !1;
            }
            showControls() {
                this.controlsVisible = !0;
            }
            addEventListener(t1, e) {
                this.listeners[t1] && this.listeners[t1].push(e);
            }
            dispatchEvent(t1) {
                let e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                this.listeners[t1] && this.listeners[t1].forEach((t1)=>t1(e));
            }
        }, Bn = [
            [
                "requestFullscreen",
                "exitFullscreen",
                "fullscreenElement",
                "fullscreenEnabled",
                "fullscreenchange",
                "fullscreenerror"
            ],
            [
                "webkitRequestFullscreen",
                "webkitExitFullscreen",
                "webkitFullscreenElement",
                "webkitFullscreenEnabled",
                "webkitfullscreenchange",
                "webkitfullscreenerror"
            ],
            [
                "webkitRequestFullScreen",
                "webkitCancelFullScreen",
                "webkitCurrentFullScreenElement",
                "webkitCancelFullScreen",
                "webkitfullscreenchange",
                "webkitfullscreenerror"
            ],
            [
                "mozRequestFullScreen",
                "mozCancelFullScreen",
                "mozFullScreenElement",
                "mozFullScreenEnabled",
                "mozfullscreenchange",
                "mozfullscreenerror"
            ],
            [
                "msRequestFullscreen",
                "msExitFullscreen",
                "msFullscreenElement",
                "msFullscreenEnabled",
                "MSFullscreenChange",
                "MSFullscreenError"
            ]
        ], Fn = (()=>{
            if ("undefined" == typeof document) return !1;
            const t1 = Bn[0], e = {};
            for (const i of Bn){
                const n = i?.[1];
                if (n in document) {
                    for (const [n, r] of i.entries())e[t1[n]] = r;
                    return e;
                }
            }
            return !1;
        })(), Qn = {
            change: Fn.fullscreenchange,
            error: Fn.fullscreenerror
        };
        let Hn = {
            request: (t1 = document.documentElement, e)=>new Promise((i, n)=>{
                    const r = ()=>{
                        Hn.off("change", r), i();
                    };
                    Hn.on("change", r);
                    const a = t1[Fn.requestFullscreen](e);
                    a instanceof Promise && a.then(r).catch(n);
                }),
            exit: ()=>new Promise((t1, e)=>{
                    if (!Hn.isFullscreen) return void t1();
                    const i = ()=>{
                        Hn.off("change", i), t1();
                    };
                    Hn.on("change", i);
                    const n = document[Fn.exitFullscreen]();
                    n instanceof Promise && n.then(i).catch(e);
                }),
            toggle: (t1, e)=>Hn.isFullscreen ? Hn.exit() : Hn.request(t1, e),
            onchange (t1) {
                Hn.on("change", t1);
            },
            onerror (t1) {
                Hn.on("error", t1);
            },
            on (t1, e) {
                const i = Qn[t1];
                i && document.addEventListener(i, e, !1);
            },
            off (t1, e) {
                const i = Qn[t1];
                i && document.removeEventListener(i, e, !1);
            },
            raw: Fn
        };
        Object.defineProperties(Hn, {
            isFullscreen: {
                get: ()=>Boolean(document[Fn.fullscreenElement])
            },
            element: {
                enumerable: !0,
                get: ()=>document[Fn.fullscreenElement] ?? void 0
            },
            isEnabled: {
                enumerable: !0,
                get: ()=>Boolean(document[Fn.fullscreenEnabled])
            }
        }), Fn || (Hn = {
            isEnabled: !1
        });
        const Vn = Hn;
        function Gn(t1, e, i) {
            return (e = function(t1) {
                var e = function(t1) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var e = t1[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e)) in t1 ? Object.defineProperty(t1, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = i, t1;
        }
        hi({
            useProxies: "never"
        });
        const Wn = new class {
            constructor(){
                Gn(this, "enabled", Vn.isEnabled), Gn(this, "active", !1), Gn(this, "element", null), Gn(this, "width", null), Gn(this, "height", null), zi(this);
            }
            init() {
                this.element = document.querySelector("#widget-application"), this.enabled && (this.resize(Un.config), Vn.on("change", ()=>{
                    setTimeout(()=>{
                        this.active = Vn.isFullscreen, this.active ? Un.setConfig({
                            ...Un.config,
                            width: window.innerWidth,
                            height: window.innerHeight
                        }) : Un.setConfig({
                            ...Un.config,
                            width: this.width,
                            height: this.height
                        });
                    }, 100);
                }));
            }
            async enter() {
                return await Vn.request(this.element);
            }
            async exit() {
                return await Vn.exit();
            }
            resize(t1) {
                let { width: e, height: i } = t1;
                this.width = e, this.height = i;
            }
        }, Yn = {
            DEFAULT: 0,
            THREESIXTY: 1
        }, Xn = {
            tabs: [
                "rotation",
                "area",
                "panorama"
            ],
            logo: null,
            logoUrl: null,
            width: 1920,
            height: 1080,
            resizable: !0,
            rotationMode: Yn.DEFAULT,
            floors: [],
            panoramaFov: 75,
            preloadPerPanoramaCount: 3,
            forcePreloadNonCached: !0,
            forceTopViewOnMap: !1,
            topViewResolutionUpscale: 2,
            enableCameraTransitionBetweenPanoramas: !1,
            enableCameraRotationBetweenPanoramas: !0,
            primaryCameraPointId: null,
            json: null,
            locale: "en",
            API_URL: "https://backend.estate.hart-digital.com",
            branding: null,
            colors: {
                main: "#FAC62D",
                mainText: "#413E3E"
            },
            panoramaIcons: {
                spot: "data:image/png;base64,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",
                interactiveSpot: "data:image/png;base64,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",
                door: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABAAAAAQACAYAAAB/HSuDAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAACcTSURBVHgB7d3rcRzHucfhd0/pu3kiOKsIREfAZQSiIxAUgagICEYgKQJREZiOQFAEpiMgHIHpCHC6uQNhuMSde5md//NUda1l0/SlJC3e30x3VwEAAAAAAAAAAAAAAAAAAAAAAAAAe7EoAICJu7i4eNI+lm09Gf3T7xaLxYcCAAAAjlMf+NtatfVrW+8vbvZ++DWrAgAAAKZvGPpPhoH+PxcP977/+wsAAACYlmHof9nW748c+q/za1vLAgAAAA5nY+jflfciAAB8yiGAAMDODcP4d22thrUP/YDA54vF4l0BAAIAALAbF+uD+Z61dVLrE/wP4bzWEeC8ACCcAAAAbM0w9L9o69s63NC/6awFgOcFAAAAPN7F+rq+ny+2d4jfLrwsAAjnDQAA4EHaMP2kfTyt9Z7+/rT/SU1fPw/g68Vi8aEAINRXBQBwh2Ho78N+H/r78H8MQ/9Y/+970tbPBQChvAEAAFxrGPpPar2ff1XHz1kAAEQTAACAP12sr+u7PMRvVfPzv7YBAJDKFgAACNeG/v5K/+XAv6p5W7b1rgAgkAAAAIEu1tf1Pav1K/7LytFjhwAAQCQBAABCDEP/5UF+x3aI37ak/u8GAAEAAOZqdF1f+tA/5v8DAGIJAAAwI6Pr+p4NnwZeAOAjAQAAjtzGdX39ib+hHwD4jAAAAEdoY+hfFQDAHQQAADgSbehf1nov/6oM/QDAAwkAADBho+v6VmXoBwC+gAAAABMzuq6vv96/LACALRAAAGACRkO/6/oAgJ0QAADgAIZD/PqJ/X3gd10fALBzAgAA7Mkw9F8+5XddHwCwVwIAAOzQxnV9hn4A4GAEAADYso2hf1UAABMgAADAFrShf1nrV/tXZegHACZIAACARxpO7n9W66f9ywIAmDABAAAewHV9AMCxEgAA4Baj6/oM/QDAURMAAGDDMPSvan2IXx/8Df0AwNETAACg/hz6L5/yu64PAJgdAQCAWK7rAwCSCAAARBmu6+tP+g39AEAUAQCA2Rtd17cqQz8AEEoAAGCWRtf19Sf9ywIACCcAADAbo6HfdX0AABsEAACO1nCIXz+x39APAHAHAQCAozK6ru/Z8GnoBwC4BwEAgMnbuK6vP/E39AMAPJAAAMAkbQz9qwIA4IsIAABMRhv6l7Xey78qQz8AwFYJAAAc1HBy/+V+/qcFAMBOCAAA7N3our7+ev+yAADYOQEAgL0YDf2u6wMAOAABAICdGA7x66/094HfdX0AAAcmAACwNcPQf/mU33V9AAATIgAA8EVc1wcAcBwEAAAebLiu7/IQv1UBADB5AgAA99KG/v5K/+XAvyoAAI6KAADAjYaT+5/V+hX/ZQEAcLQEAAA+4bo+AIB5EgAAwo2u6zP0AwDMmAAAEGh0Xd+z4dPQDwAwcwIAQIjR0N+f8vcn/oZ+AIAgAgDAjA1D/0m5rg8AIJ4AADAzbehf1vpJv6EfAIA/CQAAMzC6rm9Vhn4AAK4hAAAcqdF1ff1J/7IAAOAWAgDAERkN/a7rAwDgQQQAgAkbDvHrJ/b3gd91fQAAPJoAADAxo+v6Lg/xM/QDAPDFBACACdi4rq8/8Tf0AwCwVQIAwIFsDP2rAgCAHRIAAPaoDf3LWu/nX5WhHwCAPRIAAHZsOLn/Wa2f9i8LAAAOQAAA2AHX9QEAMDUCAMAWjK7rM/QDADBJAgDAI42G/j7w98Hf0A8AwGQJAAAPMAz9l0/5XdcHAMDREAAA7uC6PgAA5kAAALjGcF1ff9Jv6AcAYBYEAIDB6Lq+VRn6AQCYGQEAiDYa+k/aWhYAAMyUAADEGYZ+1/UBABBFAABmb3Rdn6EfAIBYAgAwS6Pr+p4Nn4Z+AACiCQDAbGxc19ef+Bv6AQBgIAAAR21j6F8VAABwLQEAODpt6F/Wei//qgz9AABwLwIAcBRG1/X1/fxPCwAAeBABAJis0XV9/fX+ZQEAAI8mAACTMhr6XdcHAABbJAAABzUc4tdf6e8Dv+v6AABgRwQAYO+Gof/yKb/r+gAAYA8EAGAvXNcHAACHJQAAOzNc13d5iN+qADi40Vkr/WaVHmeXBcflfFh/tPV2sVi8K+BeFgWwRcPQ31/tX5WhH5ie121YOK0ww1tYP7T1smy7Yn7Oa/3X9psCbuUNAOCLDU+T+pOkk/IkCWBS2t+j+9P+X8vgz3wt2/q1/bn+qn0+byHgvIBrCQDAo7iuD2D62t+rf6r1U39IsGzrffvz/scWAX4u4DMCAHAvo+v6DP0AR6D9fbs/9T8pyPNT+/P/Ly0CvC7gEwIAcKPRdX3Phk9DP8ARGJ78nxTkOm1/HfzXmwDwKQEA+MRo6O9P+fsTf0M/wBEZ9kF77R/WbwKcuSUArggAwOXQf1Ku6wM4asNNLKcFXOpbYf5awEcCAIQafkjsT/oN/QDzcVrA2NP2M8+JKwJhTQCAIKPr+lZl6AeYlSHsflfAph/aelOAAABzN7qurz/pXxYAc/WigOv0twBWi8XirCCcAAAzNBr6XdcHkMPTf7hZ/7norCCcAAAzMBzi10/s7z/8ua4PIMzoewC43jcFCABwrEbX9V0e4mfoB8i1LOA2AhmUAABHZeO6vv5FZugHoPN9ALfz1wiUAACTtzH0rwoAPrcsALiDAAATNLrKaVWGfgDudl4AcAcBACZiOLn/Wa2f9i8LAO7vQwHAHQQAOCDX9QGwJecFAHcQAGDPDP0AbNtisfjQvl/OyrYxAG4hAMAeDAf5/dDWyzL0A7Abf5QAAMAt/qeAnWrDfx/637d1WoZ/AHbn5wKAWwgAsCP9qX9bv7d/+FMZ/AHYsb4NoH28LQC4gQAAOzBc4/fP8iomAPv1Y7kRAIAbCACwZcN+//7kf1kAsEeLxeK8fbwuALiGAADb96oM/wAcSIsA/SyA3woANggAsEXt6f9JrU/6B4CDaRHgpEQAADYIALBdrwoAJmCIAL8UAAwEANiS4en/sgBgIloE6G+lfd/WeQEQTwCA7fmuAGBiWgR40z6e1/pwwPMCIJYAAFswnPy/KgCYoH47QFunbX1d6xjQtwb8Ua4MBIjyVQHb8LQA4Ai0CHDWPs4KvkB7+LGs9dbHVVsv2vqmgMnzBgBshwAAAMQY3io5G94s6T8H9bdL3DwBEycAwHY8KQCAUEMQOKl1CDgvYJIEAAAAYCuGENAjgCsoYYIEAAAAYKuGKyhfFzApAgAAALB1/XyA8iYATIoAAAAA7MTwJsC7AiZBAAAAAHbpbwVMggAAAADsTD8YsFwRCJMgAAAAALt2WsDBCQAAAMBODW8BnBVwUAIAAACwD/8o4KAEAAAAYB/OCjgoAQAAANiH8wIOSgAAAAB2brFYfCjgoAQAAABgX/5dwMEIAAAAABBAAAAAAIAAAgAAAAAEEAAAAAAggAAAAAAAAQQAAAAACCAAAAAAQAABAAAAAAIIAAAAABBAAAAAAIAAAgAAAAAEEAAAAAAggAAAAAAAAQQAAAAACCAAAAAAQAABAAAAAAIIAAAAABBAAAAAAIAAAgAAAAAEEAAAAAAggAAAAAAAAQQAAAAACCAAAAAAQAABAAAAAAIIAAAAABBAAAAAAIAAAgAAAAAEEAAAAAAggAAAAAAAAQQAAAAACCAAAAAAQAABAAAAAAIIAAAAABBAAAAAAIAAAgAAAAAEEAAAAAAggAAAAAAAAQQAAAAACCAAAAAAQAABAAAAAAIIAAAAABBAAAAAAIAAAgAAAAAEEAAAAAAggAAAAAAAAQQAAAAACCAAAAAAQAABAAAAAAIIAAAAABBAAAAAAIAAAgAAAAAEEAAAAAAggAAAAAAAAQQAAAAACCAAAAAAQAABAAAAAAIIAAAAABBAAAAAAIAAAgAAAAAEEAAAAAAggAAAAAAAAQQAAAAACCAAAAAAQAABAAAAAAIIAAAAABBAAAAAAIAAAgAAAAAEEAAAAAAggAAAAAAAAQQAAAAACCAAAAAAQAABAAAAAAIIAAAAABBAAAAAAIAAAgAAAAAEEAAAAAAggAAAAAAAAQQAAAAACCAAAAAAQAABAAAAAAIIAAAAABBAAAAAAIAAAgAAAAAEEAAAAAAggAAAAAAAAQQAAAAACCAAAAAAQAABAAAAAAIIAAAAABBAAAAAAIAAAgAAAAAEEAAAAAAggAAAAAAAAQQAAAAACCAAAAAAQAABAAAAAAIIAAAAABBAAAAAAIAAAgAAAAAEEAAAAAAggAAAAAAAAQQAAAAACCAAAAAAQAABAAAAAAIIAAAAABBAAAAAAIAAAgAAAAAEEAAAAAAggAAAAAAAAQQAAAAACCAAAAAAQAABAAAAAAIIAAAAABBAAAAAAIAAAgAAAAAEEAAAAAAggAAAAAAAAQQAAAAACCAAAAAAQAABAAAAAAIIAAAAABBAAAAAAIAAAgAAAAAEEAAAAAAggAAAAAAAAQQAAAAACCAAAAAAQAABAAAAAAIIAAAAABBAAAAAAIAAAgAAAAAEEAAAAAAggAAAAAAAAQQAAAAACCAAAAAAQAABAAAAAAIIAAAAABBAAAAAAIAAAgAAAAAEEAAAAAAggAAAAAAAAQQAAAAACCAAAAAAQAABAAAAAAIIAAAAABBAAAAAAIAAAgAAAAAEEAAAAAAggAAAAAAAAQQAAAAACCAAAAAAQAABAAAAAAIIAAAAABBAAAAAAIAAAgAAAAAEEAAAAAAggAAAAAAAAQQAAAAACCAAAAAAQAABAAAAAAIIAAAAABBAAAAAAIAAAgAAAAAEEAAAAAAggAAAAAAAAQQAAAAACCAAAAAAQAABAAAAAAIIAAAAABBAAAAAAIAAAgAAAAAEEAAAAAAggAAAAAAAAQQAAAAACCAAAAAAQAABAAAAAAIIAAAAABBAAAAAAIAAAgAAAAAEEAAAAAAggAAAAAAAAQQAAAAACCAAAAAAQAABAAAAAAIIAAAAABBAAAAAAIAAAgAAAAAEEAAAAAAggAAAAAAAAQQAAAAACCAAAAAAQAABAAAAAAIIAAAAABBAAAAAAIAAAgAAAAAEEAAAAAAggAAAAAAAAQQAAAAACCAAAAAAQAABAAAAAAIIAAAAABBAAAAAAIAAAgAAAAAEEAAAAAAggAAAAAAAAQQAAAAACCAAAAAAQAABAAAAAAIIAAAAABBAAAAAAIAAAgAAAAAEEAAAAAAggAAAAAAAAQQAAAAACCAAAAAAQAABAAAAAAIIAAAAABBAAAAAAIAAAgAAAAAEEAAAAAAggAAAAAAAAQQAAAAACCAAAAAAQAABAAAAAAIIAAAAABBAAAAAAIAAAgAAAAAEEAAAAAAggAAAAAAAAQQAAAAACCAAAAAAQAABAAAAAAIIAAAAABBAAAAAAIAAAgAAAAAEEAAAAAAggAAAAAAAAQQAAAAACCAAAAAAQAABAAAAAAIIAAAAABBAAAAAAIAAAgAAAAAEEAAAAAAggAAAAAAAAQQAAAAACCAAAAAAQAABAAAAAAIIAAAAABBAAAAAAIAAAgAAAAAEEAAAAAAggAAAAAAAAQQAAAAACCAAAAAAQAABAAAAAAIIAAAAABBAAAAAAIAAAgAAAAAEEAAAAAAggAAAAAAAAQQAAAAACCAAAAAAQAABAAAAAAIIAAAAABBAAAAAAIAAAgAAAAAEEAAAAAAggAAAAAAAAQQAAAAACCAAAAAAQAABAAAAAAIIAAAAABBAAAAAAIAAAgAAAAAEEAAAAAAggAAAAAAAAQQAAAAACCAAAAAAQAABAAAAAAIIAAAAABBAAAAAAIAAAgAAAAAEEAAAAAAggAAAAAAAAQQAAAAACCAAAAAAQAABAAAAAAIIAAAAABBAAAAAAIAAAgAAAAAEEAAAAAAggAAAAAAAAQQAAAAACCAAAAAAQAABAAAAAAIIAAAAABBAAAAAAIAAAgAAAAAEEAAAAAAggAAAAAAAAQQAAAAACCAAAAAAQAABAAAAAAIIAAAAABBAAAAAAIAAAgAAAAAEEAAAAAAggAAAAAAAAQQAAAAACCAAAAAAQAABAAAAAAIIAAAAABBAAAAAAIAAAgAAAAAEEAAAAAAggAAAAAAAAQQAAAAACCAAAAAAQAABAAAAAAIIAAAAABBAAAAAAIAAAgAAAAAEEAAAAAAggAAAAAAAAQQAAAAACCAAAAAAQAABAAAAAAIIAAAAABBAAAAAAIAAAgAAAAAEEAAAAAAggAAAAAAAAQQAAAAACCAAAAAAQAABAAAAAAIIAAAAABBAAAAAAIAAAgAAAAAEEAAAAAAgwFcFAFD1oa1/tXU+rO5JW8thfVMAwFETAAAgVx/6f2vr7WKxOLvtF15cXCzbx6qtV7UOAgDAkbEFAAAy/dLW123wf3nX8N+1X3Pe1pu2vm5/+H1dvSUAABwJAQAAspy39XwY/D/UI4xCwOsCAI6GAAAAOd7Vevg/qy1ov89p+/ixAICjIAAAQIbzWg//57VF7ff7udZbAgCAiRMAAGD+zms9/D/qlf+79C0BZTsAAEyeAAAA8/d620/+Nw3bAc4KAJgsAQAA5u3N8IR+H7wFAAATJgAAwLztbSgfDhc8KwBgkgQAAJivP3b96v81vAUAABMlAADAfL2pPRveAtjJYYMAwJcRAABgvt7VYfyjAIDJEQAAYJ4+tKfxhwoAh/rPBQBuIQAAwDyd1+HYAgAAEyQAAMA8/bcO57wAgMkRAAAAACCAAAAAAAABBAAAAAAIIAAAAABAAAEAAAAAAggAAAAAEEAAAAAAgAACAAAAAAQQAAAAACCAAAAAAAABBAAAAAAIIAAAAABAAAEAAAAAAggAAAAAEEAAAAAAgAACAAAAAAQQAAAAACCAAAAAAAABBAAAAAAIIAAAAABAAAEAAAAAAggAAAAAEEAAAAAAgAACAAAAAAQQAABgnv5Sh/OkAIDJEQAAYJ6WdTjLAgAmRwAAgHl6cnFxcagn8U8LAJgcAQAA5utFHcazAgAmRwAAgPn6rvbs4uKiP/1fFgAwOQIAAMzX0wNsA3hZAMAkCQAAMF99+N/bQN5iw7IO8NYBAHA/AgAAzNsPw2C+D6cFAEyWAAAA89bfAvh77ViLDCfl6T8ATJoAAADz188C+Kl2ZHjDYGe/PwCwHQIAAGR42Qb1V7Vlw/D/e63fNAAAJkwAAIAcp21g//u2zgRov8+L9vHPcu0fABwFAQAAsvSh/fdhz/6j9KsF23pT67MFPPkHgCMhAABAnmVbv7Yh/v1DQkD7tU+HbQTvy4F/AHB0vioAINWy1iGgH+D3rq0/hs8Pw7/+ZPg1fX1bXvUHgKMmAAAAfdBfDQsAmClbAAAAACCAAAAAAAABBAAAAAAIIAAAAABAAAEAAAAAAggAAAAAEEAAAAAAgAACAAAAAAQQAAAAACCAAAAAAAABBAAAAAAIIAAAAABAAAEAAAAAAggAAAAAEEAAAAAAgAACAAAAAAQQAAAAACCAAAAAAAABBAAAAAAIIAAAAABAAAEAAAAAAggAAAAAEEAAAAAAgAACAAAAAAQQAAAAACCAAAAAAAABBAAAAAAIIAAAAABAAAEAAAAAAggAAAAAEEAAAAAAgAACAAAAAAQQAAAAACCAAAAAAAABBAAAAAAIIAAAAABAAAEAAAAAAggAAAAAEEAAAAAAgAACAAAAAAQQAAAAACCAAAAAAAABBAAAAAAIIAAAAABAAAEAAAAAAggAAAAAEEAAAAAAgAACAAAAAAQQAAAAACCAAAAAAAABBAAAAAAIIAAAAABAAAEAAAAAAggAAAAAEEAAAAAAgAACAAAAAAQQAAAAACCAAAAAAAABBAAAAAAIIAAAAABAAAEAAAAAAggAAAAAEEAAAAAAgAACAAAAAAQQAAAAACCAAAAAAAABBAAAAAAIIAAAAABAAAEAAAAAAggAAAAAEEAAAAAAgAACAAAAAAQQAAAAACCAAAAAAAABBAAAAAAIIAAAAABAAAEAAAAAAggAAAAAEEAAAAAAgAACAAAAAAQQAAAAACCAAAAAAAABBAAAAAAIIAAAAABAAAEAAAAAAggAAAAAEEAAAAAAgAACAAAAAAQQAAAAACCAAAAAAAABBAAAAAAIIAAAAABAAAEAAAAAAggAAAAAEEAAAAAAgAACAAAAAAQQAAAAACCAAAAAAAABBAAAAAAIIAAAAABAAAEAAAAAAggAAAAAEEAAAAAAgAACAAAAAAQQAAAAACCAAAAAAAABBAAAAAAIIAAAAABAAAEAAAAAAggAAAAAEEAAAAAAgAACAAAAAAQQAAAAACCAAAAAAAABBAAAAAAIIAAAAABAAAEAAAAAAggAAAAAEEAAAAAAgAACAAAAAAQQAAAAACCAAAAAAAABBAAAAAAIIAAAAABAAAEAAAAAAggAAAAAEEAAAAAAgAACAAAAAAQQAAAAACCAAAAAAAABBAAAAAAIIAAAAABAAAEAAAAAAggAAAAAEEAAAAAAgAACAAAAAAQQAAAAACCAAAAAAAABBAAAAAAIIAAAAABAAAEAAAAAAggAAAAAEEAAAAAAgAACAAAAAAQQAAAAACCAAAAAAAABBAAAAAAIIAAAAABAAAEAAAAAAggAAAAAEEAAAAAAgAACAAAAAAQQAAAAACCAAAAAAAABBAAAAAAIIAAAAABAAAEAAAAAAggAAAAAEEAAAAAAgAACAAAAAAQQAAAAACCAAAAAAAABBAAAAAAIIAAAAABAAAEAAAAAAggAAAAAEEAAAAAAgAACAAAAAAQQAAAAACCAAAAAAAABBAAAAAAIIAAAAABAAAEAAAAAAggAAAAAEEAAAAAAgAACAAAAAAQQAAAAACCAAAAAAAABBAAAAAAIIAAAAABAAAEAAAAAAggAAAAAEEAAAAAAgAACAAAAAAQQAAAAACCAAAAAAAABBAAAAAAIIAAAAABAAAEAAAAAAggAAAAAEEAAAAAAgAACAAAAAAQQAAAAACCAAAAAAAABBAAAAAAIIAAAAABAAAEAAAAAAggAAAAAEEAAAAAAgAACAAAAAAQQAAAAACCAAAAAAAABBAAAAAAIIAAAAABAAAEAAAAAAggAAAAAEEAAAAAAgAACAAAAQMH8CQAAAAAQQAAAAACAAAIAAAAABBAAAAAAIIAAAAAAAAEEAAAAAAggAAAAAEAAAQAAAAACCAAAAAAQQAAAAACAAAIAAAAABBAAAAAAIIAAAAAAAAEEAAAAAAggAAAAAEAAAQAAAAACCAAAAAAQQAAAAACAAAIAAAAABBAAAAAAIIAAAAAAAAEEAAAAAAggAAAAAEAAAQAAAAACCAAAAAAQQAAAAACAAAIAAAAABBAAAAAAIIAAAAAAAAEEAAAAAAggAAAAAEAAAQAAAAACCAAAAAAQQAAAAACAAAIAAAAABBAAAAAAIIAAAAAAAAEEAAAAAAggAAAAAEAAAQAAAAACCAAAAAAQQAAAAACAAAIAAAAABBAAAAAAIIAAAAAAAAEEAAAAAAggAAAAAEAAAQAAAAACCAAAAAAQQAAAAACAAAIAAAAABBAAAAAAIIAAAAAAAAEEAAAAAAggAAAAAEAAAQAAAAACCAAAAAAQQAAAAACAAAIAAAAABBAAAAAAIIAAAAAAAAEEAAAAAAggAAAAAEAAAQAAAAACCAAAAAAQQAAAAACAAAIAAAAABBAAAAAAIIAAAAAAAAEEAAAAAAggAAAAAEAAAQAAAAACCAAAAAAQQAAAAACAAAIAAAAABBAAAAAAIIAAAAAAAAEEAAAAAAggAAAAAEAAAQAAAAACCAAAAAAQQAAAAACAAAIAAAAABBAAAAAAIIAAAAAAAAEEAAAAAAggAAAAAEAAAQAAAAACCAAAAAAQQAAAAACAAAIAAAAABBAAAAAAIIAAAAAAAAEEAAAAAAggAAAAAEAAAQAAAAACCAAAAAAQQAAAAACAAAIAAAAABBAAAAAAIIAAAAAAAAEEAAAAAAggAAAAAEAAAQAAAAACCAAAAAAQQAAAAACAAAIAAAAABBAAAAAAIIAAAAAAAAEEAAAAAAggAAAAAEAAAQAAAAACCAAAAAAQQAAAAACAAAIAAAAABBAAAAAAIIAAAAAAAAEEAAAAAAggAAAAAEAAAQAAAAACCAAAAAAQQAAAAACAAAIAAAAABBAAAAAAIIAAAAAAAAEEAAAAAAggAAAAAEAAAQAAAAACCAAAAAAQQAAAAACAAAIAAAAABBAAAAAAIIAAAAAAAAEEAAAAAAggAAAAAEAAAQAAAAACCAAAAAAQQAAAAACAAAIAAAAABBAAAAAAIIAAAAAAAAEEAAAAAAggAAAAAEAAAQAAAAACCAAAAAAQQAAAAACAAAIAAAAABBAAAAAAIIAAAAAAAAEEAAAAAAggAAAAAEAAAQAAAAACCAAAAAAQQAAAAACAAAIAAAAABBAAAACAfflLAQcjAAAAAPvypICDEQAAAICdu7i4eFrAQQkAAADAPiwLOCgBAAAA2IcXBRyUAAAAAOzDswIOSgAAAAB26uLi4qRsAYCDEwAAAIBde1XAwQkAAADAzrSn/334XxZwcAIAAACwE234X7aP0wImQQAAAAC2bhj+fy9gMgQAAABgq0bD/7KAyRAAAACArWnD/4v28c8y/MPkfFUAAABfaHjq/2tbqwImyRsAAADAo7Sh/0lbq7b66/7vy/APk+YNAACAMH1oq/Wg1j+XBQ/3f209rfWfP08KOAoCAABAgGHoP2nr2/KUFiCSAAAAMHNt+H/VPl6WJ7UA0QQAAICZGg5l+3utX9UGIJwAAAAwQ23470N/P5jNU38APnILAADAzBj+AbiOAAAAMCOj1/4N/wB8QgAAAJiX/uR/WQCwQQAAAJiJ9vT/pAz/ANxAAAAAmI9XBQA3EAAAAGagPf1/UZ7+A3ALAQAAYB5eFADcQgAAAJiHbwsAbiEAwHZ8KAA4kOHqP9f+AXArAQC2410BwOEsCwDuIADAdggAABySp/8A3EkAgC1YLBZ9C8BZAQAATJQAANvzSwHAYTiLBoA7CQCwJYvF4m37OC8A2L/zAm5juyaUAADb9n0BwJ61CH1e3gKA2/y7AAEAtqn9AHbWPn4rANi/fxRwk7cFCACwAy/Lq5gA7N+bAm5yVoAAANs23AjwvEQAAPZoeAvNNgD43JthmwzEEwBgB4YvmR4BzgoA9ufHAja9LuAjAQB2pEeAtnoE8KUDwF607503JT7D2GtP/+GKAAA71r50TtvH17U+HPC8AGC3+o00tgJA1bvh5zBgIADAHgxvA5y01UPA39r6pa1/FQBs2WgbmghAsvNa/8wFjHxVwF61H8z6NTQfr6K5uLh40j6etrUa1jdtPSkA+ALtu+Zd+47pEeD38r1CnvO2nnv1Hz4nAMABDTcGnNVov2b7gW1VV1HgWfnBDYBHGCLAX2sdAZYFGfqWy5fDz1jAhkUBk9Z+eOsx4DII9M9vCoDHep24J7h9l5y2j+9KCGC+ztv6frgOE7iBAABHpv0Qt6xPg8CzAuC+IgNAN3x/rNo6Kd8dzEN/yt/PVDo1+MP9CABw5JwjAPAgsQFgbPTd0ZfvDI7NeVvv+qdX/eFhBACYoWHbwKqugsCyAOgEAABiOQQQZqgf/FTrMv5z/+PRa599OUcAAAACCQAQYLgG582wLl/9XJVzBAAAIIYAAIGG/XJvh/XR6PrBF+UcAQAAmB0BAPhoOD23r8ttA5eHQ10GgWUBAABHSwAArjU6R+BN/+ON6wf7co4AAAAcEQEAuJfhHIG+Pm4buOb6QecIAADAhAkAwKMM5wicDeuj0TkC/bMHAecIAADARAgAwNbcco7Aqlw/CAAAByUAADtzxzkCrh8EAIA9EgCAvbnHOQKuHwQAgB0RAICDucc5Aq4fBACALREAgElxjgAAAOyGAABM2jXnCPQtAqtyjgAAADyIAAAclWHbwNthfTTaNvCinCMAAADXEgCAo3fDtoFVOUcAAAD+JAAAszPaNnAZBJZ19YaAcwQAAIgkAACzd8v1g5dBwDkCAADMngAAxLnH9YM9CDhHAACAWREAAOrO6wd7EFgWAAAcMQEA4BrXXD+4rKsg0JdzBAAAOCoCAMA93HKOwKqugoBtAwAATJYAAPAI9zhHwPWDAABMigAAsCV3nCPg+kEAAA5KAADYkWvOEehbBFZ1FQRcPwgAwN4IAAB7MmwbeFvOEQAA4AAEAIADueEcgc0gsCwAANgCAQBgQkbbBi7PEVjW+i2BF+UcAQAAvoAAADBhN1w/uCrnCAAA8EACAMAR2TxHoBtdP9jfEnCOAAAA1xIAAI7cLdcPXgaBZQEAEE8AAJiZa64fXNbntw0AABBGAACYuRvOERgHAecIAAAEEAAAwtxw/eCqrqJADwLOEQAAmBkBAIDbzhFYlesHAQBmQQAA4DN3nCPg+kEAgCMkAABwp3ucI+D6QQCAiRMAAHiwG84R2AwCywIAYDIEAAC2YrRt4PIcgWVdBQHnCAAAHJgAAMBODNsG3tTVOQJ9i8CqnCMAAHAQAgAAezFsG3g7rI9G1w++KOcIAADslAAAwMHccv3gZRBYFgAAWyEAADAZd1w/2JdzBAAAHkkAAGCybrl+8EU5RwAA4EEEAACOxg3XD67q6i2BHgScIwAAcA0BAICjdss5Aqty/SAAwJ8EAABmxTkCAADXEwAAmLVbzhFY1VUQsG0AAJg9AQCAKPc4R8D1gwDALAkAAMRzjgAAkEAAAIAN15wj0LcIrOoqCLh+EAA4OgIAANxh2DbwdlgfDdsGLpdzBACAyRMAAOARRtsGPhq2DazKOQIAwEQJAACwBaNtA5fnCCxrvV3gRTlHAACYAAEAAHbglusHL4OAcwQAgL0SAABgD+5x/WAPAs4RAAB2RgAAgAO54/rBHgSWBQCwJQIAAEzENdcPLusqCPTlHAEA4NEEAACYqFvOEViV6wcf60MBQKhFAQBHa+McAdcP3u1vLay8LQAIJAAAwIxsnCPg+sHP/XXYagEAcQQAAJixjXME0q8fPG/D/9cFAKEEAAAIEn6OwJsWAL4vAAglAABAuGHbwKrmf47A8+HqRQCIJAAAAJ8YbRt4UfM5R+CPNvyvCgCCCQAAwK2GbQOrOu5zBL4erlUEgFgCAADwYKPrB/tbAlM/R+B1G/5PCwDCCQAAwBcbXT94GQSWNQ3v2vD/1wIABAAAYPs2rh/s6xDnCLyr9cF/HwoAEAAAgN275vrBXZ8j8FtbLw3/AAAAcGD9HIG2Xrb1tq3/XGxH/31eFgAAADBN/RyBtk7aetPWu4uH6YP/6fCmAQBwDVsAAIBJ2jhHoH/2P/6/4V/+d1vntd7n/3axWJwVAAAAAAAAAAAAAAAAAAAAAAAAAAAATMH/A9LZxHhsGzQfAAAAAElFTkSuQmCC"
            },
            dictionaryOverrides: null,
            instructionVisible: !0,
            autoRotate: !1,
            scales: [
                "x1",
                "x2",
                "x05"
            ],
            enableGyroscope: !0,
            scaleButtonType: "img",
            floorNumberEndingsVisible: !1,
            interactiveDoors: !1,
            interactiveCameraPoints: !1
        }, Zn = Xn, qn = "158", Jn = {
            LEFT: 0,
            MIDDLE: 1,
            RIGHT: 2,
            ROTATE: 0,
            DOLLY: 1,
            PAN: 2
        }, Kn = {
            ROTATE: 0,
            PAN: 1,
            DOLLY_PAN: 2,
            DOLLY_ROTATE: 3
        }, $n = 0, tr = 1, er = 2, ir = 3, nr = 0, rr = 1, ar = 2, sr = 3, or = 0, lr = 1, cr = 2, ur = 2, hr = 0, dr = 1, pr = 2, Ar = 3, fr = 4, mr = 5, gr = 100, Mr = 101, vr = 102, yr = 103, xr = 104, wr = 200, br = 201, Tr = 202, Er = 203, _r = 204, Ir = 205, Sr = 206, Nr = 207, Dr = 208, Cr = 209, zr = 210, Lr = 211, Or = 212, Pr = 213, jr = 214, Rr = 0, kr = 1, Ur = 2, Br = 3, Fr = 4, Qr = 5, Hr = 6, Vr = 7, Gr = 0, Wr = 1, Yr = 2, Xr = 0, Zr = 1, qr = 2, Jr = 3, Kr = 4, $r = 5, ta = "attached", ea = "detached", ia = 300, na = 301, ra = 302, aa = 303, sa = 304, oa = 306, la = 1e3, ca = 1001, ua = 1002, ha = 1003, da = 1004, pa = 1004, Aa = 1005, fa = 1005, ma = 1006, ga = 1007, Ma = 1007, va = 1008, ya = 1008, xa = 1009, wa = 1010, ba = 1011, Ta = 1012, Ea = 1013, _a = 1014, Ia = 1015, Sa = 1016, Na = 1017, Da = 1018, Ca = 1020, za = 1021, La = 1023, Oa = 1024, Pa = 1025, ja = 1026, Ra = 1027, ka = 1028, Ua = 1029, Ba = 1030, Fa = 1031, Qa = 1033, Ha = 33776, Va = 33777, Ga = 33778, Wa = 33779, Ya = 35840, Xa = 35841, Za = 35842, qa = 35843, Ja = 36196, Ka = 37492, $a = 37496, ts = 37808, es = 37809, is = 37810, ns = 37811, rs = 37812, as = 37813, ss = 37814, os = 37815, ls = 37816, cs = 37817, us = 37818, hs = 37819, ds = 37820, ps = 37821, As = 36492, fs = 36494, ms = 36495, gs = 36283, Ms = 36284, vs = 36285, ys = 36286, xs = 2200, ws = 2201, bs = 2202, Ts = 2300, Es = 2301, _s = 2302, Is = 2400, Ss = 2401, Ns = 2402, Ds = 2500, Cs = 2501, zs = 0, Ls = 1, Os = 2, Ps = 3e3, js = 3001, Rs = 3200, ks = 3201, Us = 0, Bs = 1, Fs = "", Qs = "srgb", Hs = "srgb-linear", Vs = "display-p3", Gs = "display-p3-linear", Ws = "linear", Ys = "srgb", Xs = "rec709", Zs = "p3", qs = 0, Js = 7680, Ks = 7681, $s = 7682, to = 7683, eo = 34055, io = 34056, no = 5386, ro = 512, ao = 513, so = 514, oo = 515, lo = 516, co = 517, uo = 518, ho = 519, po = 512, Ao = 513, fo = 514, mo = 515, go = 516, Mo = 517, vo = 518, yo = 519, xo = 35044, wo = 35048, bo = 35040, To = 35045, Eo = 35049, _o = 35041, Io = 35046, So = 35050, No = 35042, Do = "100", Co = "300 es", zo = 1035, Lo = 2e3, Oo = 2001;
        class Po {
            addEventListener(t1, e) {
                void 0 === this._listeners && (this._listeners = {});
                const i = this._listeners;
                void 0 === i[t1] && (i[t1] = []), -1 === i[t1].indexOf(e) && i[t1].push(e);
            }
            hasEventListener(t1, e) {
                if (void 0 === this._listeners) return !1;
                const i = this._listeners;
                return void 0 !== i[t1] && -1 !== i[t1].indexOf(e);
            }
            removeEventListener(t1, e) {
                if (void 0 === this._listeners) return;
                const i = this._listeners[t1];
                if (void 0 !== i) {
                    const t1 = i.indexOf(e);
                    -1 !== t1 && i.splice(t1, 1);
                }
            }
            dispatchEvent(t1) {
                if (void 0 === this._listeners) return;
                const e = this._listeners[t1.type];
                if (void 0 !== e) {
                    t1.target = this;
                    const i = e.slice(0);
                    for(let e = 0, n = i.length; e < n; e++)i[e].call(this, t1);
                    t1.target = null;
                }
            }
        }
        const jo = [
            "00",
            "01",
            "02",
            "03",
            "04",
            "05",
            "06",
            "07",
            "08",
            "09",
            "0a",
            "0b",
            "0c",
            "0d",
            "0e",
            "0f",
            "10",
            "11",
            "12",
            "13",
            "14",
            "15",
            "16",
            "17",
            "18",
            "19",
            "1a",
            "1b",
            "1c",
            "1d",
            "1e",
            "1f",
            "20",
            "21",
            "22",
            "23",
            "24",
            "25",
            "26",
            "27",
            "28",
            "29",
            "2a",
            "2b",
            "2c",
            "2d",
            "2e",
            "2f",
            "30",
            "31",
            "32",
            "33",
            "34",
            "35",
            "36",
            "37",
            "38",
            "39",
            "3a",
            "3b",
            "3c",
            "3d",
            "3e",
            "3f",
            "40",
            "41",
            "42",
            "43",
            "44",
            "45",
            "46",
            "47",
            "48",
            "49",
            "4a",
            "4b",
            "4c",
            "4d",
            "4e",
            "4f",
            "50",
            "51",
            "52",
            "53",
            "54",
            "55",
            "56",
            "57",
            "58",
            "59",
            "5a",
            "5b",
            "5c",
            "5d",
            "5e",
            "5f",
            "60",
            "61",
            "62",
            "63",
            "64",
            "65",
            "66",
            "67",
            "68",
            "69",
            "6a",
            "6b",
            "6c",
            "6d",
            "6e",
            "6f",
            "70",
            "71",
            "72",
            "73",
            "74",
            "75",
            "76",
            "77",
            "78",
            "79",
            "7a",
            "7b",
            "7c",
            "7d",
            "7e",
            "7f",
            "80",
            "81",
            "82",
            "83",
            "84",
            "85",
            "86",
            "87",
            "88",
            "89",
            "8a",
            "8b",
            "8c",
            "8d",
            "8e",
            "8f",
            "90",
            "91",
            "92",
            "93",
            "94",
            "95",
            "96",
            "97",
            "98",
            "99",
            "9a",
            "9b",
            "9c",
            "9d",
            "9e",
            "9f",
            "a0",
            "a1",
            "a2",
            "a3",
            "a4",
            "a5",
            "a6",
            "a7",
            "a8",
            "a9",
            "aa",
            "ab",
            "ac",
            "ad",
            "ae",
            "af",
            "b0",
            "b1",
            "b2",
            "b3",
            "b4",
            "b5",
            "b6",
            "b7",
            "b8",
            "b9",
            "ba",
            "bb",
            "bc",
            "bd",
            "be",
            "bf",
            "c0",
            "c1",
            "c2",
            "c3",
            "c4",
            "c5",
            "c6",
            "c7",
            "c8",
            "c9",
            "ca",
            "cb",
            "cc",
            "cd",
            "ce",
            "cf",
            "d0",
            "d1",
            "d2",
            "d3",
            "d4",
            "d5",
            "d6",
            "d7",
            "d8",
            "d9",
            "da",
            "db",
            "dc",
            "dd",
            "de",
            "df",
            "e0",
            "e1",
            "e2",
            "e3",
            "e4",
            "e5",
            "e6",
            "e7",
            "e8",
            "e9",
            "ea",
            "eb",
            "ec",
            "ed",
            "ee",
            "ef",
            "f0",
            "f1",
            "f2",
            "f3",
            "f4",
            "f5",
            "f6",
            "f7",
            "f8",
            "f9",
            "fa",
            "fb",
            "fc",
            "fd",
            "fe",
            "ff"
        ];
        let Ro = 1234567;
        const ko = Math.PI / 180, Uo = 180 / Math.PI;
        function Bo() {
            const t1 = 4294967295 * Math.random() | 0, e = 4294967295 * Math.random() | 0, i = 4294967295 * Math.random() | 0, n = 4294967295 * Math.random() | 0;
            return (jo[255 & t1] + jo[t1 >> 8 & 255] + jo[t1 >> 16 & 255] + jo[t1 >> 24 & 255] + "-" + jo[255 & e] + jo[e >> 8 & 255] + "-" + jo[e >> 16 & 15 | 64] + jo[e >> 24 & 255] + "-" + jo[63 & i | 128] + jo[i >> 8 & 255] + "-" + jo[i >> 16 & 255] + jo[i >> 24 & 255] + jo[255 & n] + jo[n >> 8 & 255] + jo[n >> 16 & 255] + jo[n >> 24 & 255]).toLowerCase();
        }
        function Fo(t1, e, i) {
            return Math.max(e, Math.min(i, t1));
        }
        function Qo(t1, e) {
            return (t1 % e + e) % e;
        }
        function Ho(t1, e, i) {
            return (1 - i) * t1 + i * e;
        }
        function Vo(t1) {
            return !(t1 & t1 - 1) && 0 !== t1;
        }
        function Go(t1) {
            return Math.pow(2, Math.ceil(Math.log(t1) / Math.LN2));
        }
        function Wo(t1) {
            return Math.pow(2, Math.floor(Math.log(t1) / Math.LN2));
        }
        function Yo(t1, e) {
            switch(e.constructor){
                case Float32Array:
                    return t1;
                case Uint32Array:
                    return t1 / 4294967295;
                case Uint16Array:
                    return t1 / 65535;
                case Uint8Array:
                    return t1 / 255;
                case Int32Array:
                    return Math.max(t1 / 2147483647, -1);
                case Int16Array:
                    return Math.max(t1 / 32767, -1);
                case Int8Array:
                    return Math.max(t1 / 127, -1);
                default:
                    throw new Error("Invalid component type.");
            }
        }
        function Xo(t1, e) {
            switch(e.constructor){
                case Float32Array:
                    return t1;
                case Uint32Array:
                    return Math.round(4294967295 * t1);
                case Uint16Array:
                    return Math.round(65535 * t1);
                case Uint8Array:
                    return Math.round(255 * t1);
                case Int32Array:
                    return Math.round(2147483647 * t1);
                case Int16Array:
                    return Math.round(32767 * t1);
                case Int8Array:
                    return Math.round(127 * t1);
                default:
                    throw new Error("Invalid component type.");
            }
        }
        const Zo = {
            DEG2RAD: ko,
            RAD2DEG: Uo,
            generateUUID: Bo,
            clamp: Fo,
            euclideanModulo: Qo,
            mapLinear: function(t1, e, i, n, r) {
                return n + (t1 - e) * (r - n) / (i - e);
            },
            inverseLerp: function(t1, e, i) {
                return t1 !== e ? (i - t1) / (e - t1) : 0;
            },
            lerp: Ho,
            damp: function(t1, e, i, n) {
                return Ho(t1, e, 1 - Math.exp(-i * n));
            },
            pingpong: function(t1, e = 1) {
                return e - Math.abs(Qo(t1, 2 * e) - e);
            },
            smoothstep: function(t1, e, i) {
                return t1 <= e ? 0 : t1 >= i ? 1 : (t1 = (t1 - e) / (i - e)) * t1 * (3 - 2 * t1);
            },
            smootherstep: function(t1, e, i) {
                return t1 <= e ? 0 : t1 >= i ? 1 : (t1 = (t1 - e) / (i - e)) * t1 * t1 * (t1 * (6 * t1 - 15) + 10);
            },
            randInt: function(t1, e) {
                return t1 + Math.floor(Math.random() * (e - t1 + 1));
            },
            randFloat: function(t1, e) {
                return t1 + Math.random() * (e - t1);
            },
            randFloatSpread: function(t1) {
                return t1 * (.5 - Math.random());
            },
            seededRandom: function(t1) {
                void 0 !== t1 && (Ro = t1);
                let e = Ro += 1831565813;
                return e = Math.imul(e ^ e >>> 15, 1 | e), e ^= e + Math.imul(e ^ e >>> 7, 61 | e), ((e ^ e >>> 14) >>> 0) / 4294967296;
            },
            degToRad: function(t1) {
                return t1 * ko;
            },
            radToDeg: function(t1) {
                return t1 * Uo;
            },
            isPowerOfTwo: Vo,
            ceilPowerOfTwo: Go,
            floorPowerOfTwo: Wo,
            setQuaternionFromProperEuler: function(t1, e, i, n, r) {
                const a = Math.cos, s = Math.sin, o = a(i / 2), l = s(i / 2), c = a((e + n) / 2), u = s((e + n) / 2), h = a((e - n) / 2), d = s((e - n) / 2), p = a((n - e) / 2), A = s((n - e) / 2);
                switch(r){
                    case "XYX":
                        t1.set(o * u, l * h, l * d, o * c);
                        break;
                    case "YZY":
                        t1.set(l * d, o * u, l * h, o * c);
                        break;
                    case "ZXZ":
                        t1.set(l * h, l * d, o * u, o * c);
                        break;
                    case "XZX":
                        t1.set(o * u, l * A, l * p, o * c);
                        break;
                    case "YXY":
                        t1.set(l * p, o * u, l * A, o * c);
                        break;
                    case "ZYZ":
                        t1.set(l * A, l * p, o * u, o * c);
                        break;
                    default:
                        console.warn("THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: " + r);
                }
            },
            normalize: Xo,
            denormalize: Yo
        };
        class qo {
            constructor(t1 = 0, e = 0){
                qo.prototype.isVector2 = !0, this.x = t1, this.y = e;
            }
            get width() {
                return this.x;
            }
            set width(t1) {
                this.x = t1;
            }
            get height() {
                return this.y;
            }
            set height(t1) {
                this.y = t1;
            }
            set(t1, e) {
                return this.x = t1, this.y = e, this;
            }
            setScalar(t1) {
                return this.x = t1, this.y = t1, this;
            }
            setX(t1) {
                return this.x = t1, this;
            }
            setY(t1) {
                return this.y = t1, this;
            }
            setComponent(t1, e) {
                switch(t1){
                    case 0:
                        this.x = e;
                        break;
                    case 1:
                        this.y = e;
                        break;
                    default:
                        throw new Error("index is out of range: " + t1);
                }
                return this;
            }
            getComponent(t1) {
                switch(t1){
                    case 0:
                        return this.x;
                    case 1:
                        return this.y;
                    default:
                        throw new Error("index is out of range: " + t1);
                }
            }
            clone() {
                return new this.constructor(this.x, this.y);
            }
            copy(t1) {
                return this.x = t1.x, this.y = t1.y, this;
            }
            add(t1) {
                return this.x += t1.x, this.y += t1.y, this;
            }
            addScalar(t1) {
                return this.x += t1, this.y += t1, this;
            }
            addVectors(t1, e) {
                return this.x = t1.x + e.x, this.y = t1.y + e.y, this;
            }
            addScaledVector(t1, e) {
                return this.x += t1.x * e, this.y += t1.y * e, this;
            }
            sub(t1) {
                return this.x -= t1.x, this.y -= t1.y, this;
            }
            subScalar(t1) {
                return this.x -= t1, this.y -= t1, this;
            }
            subVectors(t1, e) {
                return this.x = t1.x - e.x, this.y = t1.y - e.y, this;
            }
            multiply(t1) {
                return this.x *= t1.x, this.y *= t1.y, this;
            }
            multiplyScalar(t1) {
                return this.x *= t1, this.y *= t1, this;
            }
            divide(t1) {
                return this.x /= t1.x, this.y /= t1.y, this;
            }
            divideScalar(t1) {
                return this.multiplyScalar(1 / t1);
            }
            applyMatrix3(t1) {
                const e = this.x, i = this.y, n = t1.elements;
                return this.x = n[0] * e + n[3] * i + n[6], this.y = n[1] * e + n[4] * i + n[7], this;
            }
            min(t1) {
                return this.x = Math.min(this.x, t1.x), this.y = Math.min(this.y, t1.y), this;
            }
            max(t1) {
                return this.x = Math.max(this.x, t1.x), this.y = Math.max(this.y, t1.y), this;
            }
            clamp(t1, e) {
                return this.x = Math.max(t1.x, Math.min(e.x, this.x)), this.y = Math.max(t1.y, Math.min(e.y, this.y)), this;
            }
            clampScalar(t1, e) {
                return this.x = Math.max(t1, Math.min(e, this.x)), this.y = Math.max(t1, Math.min(e, this.y)), this;
            }
            clampLength(t1, e) {
                const i = this.length();
                return this.divideScalar(i || 1).multiplyScalar(Math.max(t1, Math.min(e, i)));
            }
            floor() {
                return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this;
            }
            ceil() {
                return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this;
            }
            round() {
                return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
            }
            roundToZero() {
                return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this;
            }
            negate() {
                return this.x = -this.x, this.y = -this.y, this;
            }
            dot(t1) {
                return this.x * t1.x + this.y * t1.y;
            }
            cross(t1) {
                return this.x * t1.y - this.y * t1.x;
            }
            lengthSq() {
                return this.x * this.x + this.y * this.y;
            }
            length() {
                return Math.sqrt(this.x * this.x + this.y * this.y);
            }
            manhattanLength() {
                return Math.abs(this.x) + Math.abs(this.y);
            }
            normalize() {
                return this.divideScalar(this.length() || 1);
            }
            angle() {
                return Math.atan2(-this.y, -this.x) + Math.PI;
            }
            angleTo(t1) {
                const e = Math.sqrt(this.lengthSq() * t1.lengthSq());
                if (0 === e) return Math.PI / 2;
                const i = this.dot(t1) / e;
                return Math.acos(Fo(i, -1, 1));
            }
            distanceTo(t1) {
                return Math.sqrt(this.distanceToSquared(t1));
            }
            distanceToSquared(t1) {
                const e = this.x - t1.x, i = this.y - t1.y;
                return e * e + i * i;
            }
            manhattanDistanceTo(t1) {
                return Math.abs(this.x - t1.x) + Math.abs(this.y - t1.y);
            }
            setLength(t1) {
                return this.normalize().multiplyScalar(t1);
            }
            lerp(t1, e) {
                return this.x += (t1.x - this.x) * e, this.y += (t1.y - this.y) * e, this;
            }
            lerpVectors(t1, e, i) {
                return this.x = t1.x + (e.x - t1.x) * i, this.y = t1.y + (e.y - t1.y) * i, this;
            }
            equals(t1) {
                return t1.x === this.x && t1.y === this.y;
            }
            fromArray(t1, e = 0) {
                return this.x = t1[e], this.y = t1[e + 1], this;
            }
            toArray(t1 = [], e = 0) {
                return t1[e] = this.x, t1[e + 1] = this.y, t1;
            }
            fromBufferAttribute(t1, e) {
                return this.x = t1.getX(e), this.y = t1.getY(e), this;
            }
            rotateAround(t1, e) {
                const i = Math.cos(e), n = Math.sin(e), r = this.x - t1.x, a = this.y - t1.y;
                return this.x = r * i - a * n + t1.x, this.y = r * n + a * i + t1.y, this;
            }
            random() {
                return this.x = Math.random(), this.y = Math.random(), this;
            }
            *[Symbol.iterator]() {
                yield this.x, yield this.y;
            }
        }
        class Jo {
            constructor(t1, e, i, n, r, a, s, o, l){
                Jo.prototype.isMatrix3 = !0, this.elements = [
                    1,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    1
                ], void 0 !== t1 && this.set(t1, e, i, n, r, a, s, o, l);
            }
            set(t1, e, i, n, r, a, s, o, l) {
                const c = this.elements;
                return c[0] = t1, c[1] = n, c[2] = s, c[3] = e, c[4] = r, c[5] = o, c[6] = i, c[7] = a, c[8] = l, this;
            }
            identity() {
                return this.set(1, 0, 0, 0, 1, 0, 0, 0, 1), this;
            }
            copy(t1) {
                const e = this.elements, i = t1.elements;
                return e[0] = i[0], e[1] = i[1], e[2] = i[2], e[3] = i[3], e[4] = i[4], e[5] = i[5], e[6] = i[6], e[7] = i[7], e[8] = i[8], this;
            }
            extractBasis(t1, e, i) {
                return t1.setFromMatrix3Column(this, 0), e.setFromMatrix3Column(this, 1), i.setFromMatrix3Column(this, 2), this;
            }
            setFromMatrix4(t1) {
                const e = t1.elements;
                return this.set(e[0], e[4], e[8], e[1], e[5], e[9], e[2], e[6], e[10]), this;
            }
            multiply(t1) {
                return this.multiplyMatrices(this, t1);
            }
            premultiply(t1) {
                return this.multiplyMatrices(t1, this);
            }
            multiplyMatrices(t1, e) {
                const i = t1.elements, n = e.elements, r = this.elements, a = i[0], s = i[3], o = i[6], l = i[1], c = i[4], u = i[7], h = i[2], d = i[5], p = i[8], A = n[0], f = n[3], m = n[6], g = n[1], M = n[4], v = n[7], y = n[2], x = n[5], w = n[8];
                return r[0] = a * A + s * g + o * y, r[3] = a * f + s * M + o * x, r[6] = a * m + s * v + o * w, r[1] = l * A + c * g + u * y, r[4] = l * f + c * M + u * x, r[7] = l * m + c * v + u * w, r[2] = h * A + d * g + p * y, r[5] = h * f + d * M + p * x, r[8] = h * m + d * v + p * w, this;
            }
            multiplyScalar(t1) {
                const e = this.elements;
                return e[0] *= t1, e[3] *= t1, e[6] *= t1, e[1] *= t1, e[4] *= t1, e[7] *= t1, e[2] *= t1, e[5] *= t1, e[8] *= t1, this;
            }
            determinant() {
                const t1 = this.elements, e = t1[0], i = t1[1], n = t1[2], r = t1[3], a = t1[4], s = t1[5], o = t1[6], l = t1[7], c = t1[8];
                return e * a * c - e * s * l - i * r * c + i * s * o + n * r * l - n * a * o;
            }
            invert() {
                const t1 = this.elements, e = t1[0], i = t1[1], n = t1[2], r = t1[3], a = t1[4], s = t1[5], o = t1[6], l = t1[7], c = t1[8], u = c * a - s * l, h = s * o - c * r, d = l * r - a * o, p = e * u + i * h + n * d;
                if (0 === p) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
                const A = 1 / p;
                return t1[0] = u * A, t1[1] = (n * l - c * i) * A, t1[2] = (s * i - n * a) * A, t1[3] = h * A, t1[4] = (c * e - n * o) * A, t1[5] = (n * r - s * e) * A, t1[6] = d * A, t1[7] = (i * o - l * e) * A, t1[8] = (a * e - i * r) * A, this;
            }
            transpose() {
                let t1;
                const e = this.elements;
                return t1 = e[1], e[1] = e[3], e[3] = t1, t1 = e[2], e[2] = e[6], e[6] = t1, t1 = e[5], e[5] = e[7], e[7] = t1, this;
            }
            getNormalMatrix(t1) {
                return this.setFromMatrix4(t1).invert().transpose();
            }
            transposeIntoArray(t1) {
                const e = this.elements;
                return t1[0] = e[0], t1[1] = e[3], t1[2] = e[6], t1[3] = e[1], t1[4] = e[4], t1[5] = e[7], t1[6] = e[2], t1[7] = e[5], t1[8] = e[8], this;
            }
            setUvTransform(t1, e, i, n, r, a, s) {
                const o = Math.cos(r), l = Math.sin(r);
                return this.set(i * o, i * l, -i * (o * a + l * s) + a + t1, -n * l, n * o, -n * (-l * a + o * s) + s + e, 0, 0, 1), this;
            }
            scale(t1, e) {
                return this.premultiply(Ko.makeScale(t1, e)), this;
            }
            rotate(t1) {
                return this.premultiply(Ko.makeRotation(-t1)), this;
            }
            translate(t1, e) {
                return this.premultiply(Ko.makeTranslation(t1, e)), this;
            }
            makeTranslation(t1, e) {
                return t1.isVector2 ? this.set(1, 0, t1.x, 0, 1, t1.y, 0, 0, 1) : this.set(1, 0, t1, 0, 1, e, 0, 0, 1), this;
            }
            makeRotation(t1) {
                const e = Math.cos(t1), i = Math.sin(t1);
                return this.set(e, -i, 0, i, e, 0, 0, 0, 1), this;
            }
            makeScale(t1, e) {
                return this.set(t1, 0, 0, 0, e, 0, 0, 0, 1), this;
            }
            equals(t1) {
                const e = this.elements, i = t1.elements;
                for(let t1 = 0; t1 < 9; t1++)if (e[t1] !== i[t1]) return !1;
                return !0;
            }
            fromArray(t1, e = 0) {
                for(let i = 0; i < 9; i++)this.elements[i] = t1[i + e];
                return this;
            }
            toArray(t1 = [], e = 0) {
                const i = this.elements;
                return t1[e] = i[0], t1[e + 1] = i[1], t1[e + 2] = i[2], t1[e + 3] = i[3], t1[e + 4] = i[4], t1[e + 5] = i[5], t1[e + 6] = i[6], t1[e + 7] = i[7], t1[e + 8] = i[8], t1;
            }
            clone() {
                return (new this.constructor).fromArray(this.elements);
            }
        }
        const Ko = new Jo;
        function $o(t1) {
            for(let e = t1.length - 1; e >= 0; --e)if (t1[e] >= 65535) return !0;
            return !1;
        }
        const tl = {
            Int8Array: Int8Array,
            Uint8Array: Uint8Array,
            Uint8ClampedArray: Uint8ClampedArray,
            Int16Array: Int16Array,
            Uint16Array: Uint16Array,
            Int32Array: Int32Array,
            Uint32Array: Uint32Array,
            Float32Array: Float32Array,
            Float64Array: Float64Array
        };
        function el(t1, e) {
            return new tl[t1](e);
        }
        function il(t1) {
            return document.createElementNS("http://www.w3.org/1999/xhtml", t1);
        }
        function nl() {
            const t1 = il("canvas");
            return t1.style.display = "block", t1;
        }
        const rl = {};
        function al(t1) {
            t1 in rl || (rl[t1] = !0, console.warn(t1));
        }
        const sl = (new Jo).set(.8224621, .177538, 0, .0331941, .9668058, 0, .0170827, .0723974, .9105199), ol = (new Jo).set(1.2249401, -0.2249404, 0, -0.0420569, 1.0420571, 0, -0.0196376, -0.0786361, 1.0982735), ll = {
            [Hs]: {
                transfer: Ws,
                primaries: Xs,
                toReference: (t1)=>t1,
                fromReference: (t1)=>t1
            },
            [Qs]: {
                transfer: Ys,
                primaries: Xs,
                toReference: (t1)=>t1.convertSRGBToLinear(),
                fromReference: (t1)=>t1.convertLinearToSRGB()
            },
            [Gs]: {
                transfer: Ws,
                primaries: Zs,
                toReference: (t1)=>t1.applyMatrix3(ol),
                fromReference: (t1)=>t1.applyMatrix3(sl)
            },
            [Vs]: {
                transfer: Ys,
                primaries: Zs,
                toReference: (t1)=>t1.convertSRGBToLinear().applyMatrix3(ol),
                fromReference: (t1)=>t1.applyMatrix3(sl).convertLinearToSRGB()
            }
        }, cl = new Set([
            Hs,
            Gs
        ]), ul = {
            enabled: !0,
            _workingColorSpace: Hs,
            get legacyMode () {
                return console.warn("THREE.ColorManagement: .legacyMode=false renamed to .enabled=true in r150."), !this.enabled;
            },
            set legacyMode (t){
                console.warn("THREE.ColorManagement: .legacyMode=false renamed to .enabled=true in r150."), this.enabled = !t;
            },
            get workingColorSpace () {
                return this._workingColorSpace;
            },
            set workingColorSpace (t){
                if (!cl.has(t)) throw new Error(`Unsupported working color space, "${t}".`);
                this._workingColorSpace = t;
            },
            convert: function(t1, e, i) {
                if (!1 === this.enabled || e === i || !e || !i) return t1;
                const n = ll[e].toReference;
                return (0, ll[i].fromReference)(n(t1));
            },
            fromWorkingColorSpace: function(t1, e) {
                return this.convert(t1, this._workingColorSpace, e);
            },
            toWorkingColorSpace: function(t1, e) {
                return this.convert(t1, e, this._workingColorSpace);
            },
            getPrimaries: function(t1) {
                return ll[t1].primaries;
            },
            getTransfer: function(t1) {
                return t1 === Fs ? Ws : ll[t1].transfer;
            }
        };
        function hl(t1) {
            return t1 < .04045 ? .0773993808 * t1 : Math.pow(.9478672986 * t1 + .0521327014, 2.4);
        }
        function dl(t1) {
            return t1 < .0031308 ? 12.92 * t1 : 1.055 * Math.pow(t1, .41666) - .055;
        }
        let pl;
        class Al {
            static getDataURL(t1) {
                if (/^data:/i.test(t1.src)) return t1.src;
                if ("undefined" == typeof HTMLCanvasElement) return t1.src;
                let e;
                if (t1 instanceof HTMLCanvasElement) e = t1;
                else {
                    void 0 === pl && (pl = il("canvas")), pl.width = t1.width, pl.height = t1.height;
                    const i = pl.getContext("2d");
                    t1 instanceof ImageData ? i.putImageData(t1, 0, 0) : i.drawImage(t1, 0, 0, t1.width, t1.height), e = pl;
                }
                return e.width > 2048 || e.height > 2048 ? (console.warn("THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons", t1), e.toDataURL("image/jpeg", .6)) : e.toDataURL("image/png");
            }
            static sRGBToLinear(t1) {
                if ("undefined" != typeof HTMLImageElement && t1 instanceof HTMLImageElement || "undefined" != typeof HTMLCanvasElement && t1 instanceof HTMLCanvasElement || "undefined" != typeof ImageBitmap && t1 instanceof ImageBitmap) {
                    const e = il("canvas");
                    e.width = t1.width, e.height = t1.height;
                    const i = e.getContext("2d");
                    i.drawImage(t1, 0, 0, t1.width, t1.height);
                    const n = i.getImageData(0, 0, t1.width, t1.height), r = n.data;
                    for(let t1 = 0; t1 < r.length; t1++)r[t1] = 255 * hl(r[t1] / 255);
                    return i.putImageData(n, 0, 0), e;
                }
                if (t1.data) {
                    const e = t1.data.slice(0);
                    for(let t1 = 0; t1 < e.length; t1++)e instanceof Uint8Array || e instanceof Uint8ClampedArray ? e[t1] = Math.floor(255 * hl(e[t1] / 255)) : e[t1] = hl(e[t1]);
                    return {
                        data: e,
                        width: t1.width,
                        height: t1.height
                    };
                }
                return console.warn("THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied."), t1;
            }
        }
        let fl = 0;
        class ml {
            constructor(t1 = null){
                this.isSource = !0, Object.defineProperty(this, "id", {
                    value: fl++
                }), this.uuid = Bo(), this.data = t1, this.version = 0;
            }
            set needsUpdate(t1) {
                !0 === t1 && this.version++;
            }
            toJSON(t1) {
                const e = void 0 === t1 || "string" == typeof t1;
                if (!e && void 0 !== t1.images[this.uuid]) return t1.images[this.uuid];
                const i = {
                    uuid: this.uuid,
                    url: ""
                }, n = this.data;
                if (null !== n) {
                    let t1;
                    if (Array.isArray(n)) {
                        t1 = [];
                        for(let e = 0, i = n.length; e < i; e++)n[e].isDataTexture ? t1.push(gl(n[e].image)) : t1.push(gl(n[e]));
                    } else t1 = gl(n);
                    i.url = t1;
                }
                return e || (t1.images[this.uuid] = i), i;
            }
        }
        function gl(t1) {
            return "undefined" != typeof HTMLImageElement && t1 instanceof HTMLImageElement || "undefined" != typeof HTMLCanvasElement && t1 instanceof HTMLCanvasElement || "undefined" != typeof ImageBitmap && t1 instanceof ImageBitmap ? Al.getDataURL(t1) : t1.data ? {
                data: Array.from(t1.data),
                width: t1.width,
                height: t1.height,
                type: t1.data.constructor.name
            } : (console.warn("THREE.Texture: Unable to serialize Texture."), {});
        }
        let Ml = 0;
        class vl extends Po {
            constructor(t1 = vl.DEFAULT_IMAGE, e = vl.DEFAULT_MAPPING, i = ca, n = ca, r = ma, a = va, s = La, o = xa, l = vl.DEFAULT_ANISOTROPY, c = Fs){
                super(), this.isTexture = !0, Object.defineProperty(this, "id", {
                    value: Ml++
                }), this.uuid = Bo(), this.name = "", this.source = new ml(t1), this.mipmaps = [], this.mapping = e, this.channel = 0, this.wrapS = i, this.wrapT = n, this.magFilter = r, this.minFilter = a, this.anisotropy = l, this.format = s, this.internalFormat = null, this.type = o, this.offset = new qo(0, 0), this.repeat = new qo(1, 1), this.center = new qo(0, 0), this.rotation = 0, this.matrixAutoUpdate = !0, this.matrix = new Jo, this.generateMipmaps = !0, this.premultiplyAlpha = !1, this.flipY = !0, this.unpackAlignment = 4, "string" == typeof c ? this.colorSpace = c : (al("THREE.Texture: Property .encoding has been replaced by .colorSpace."), this.colorSpace = c === js ? Qs : Fs), this.userData = {}, this.version = 0, this.onUpdate = null, this.isRenderTargetTexture = !1, this.needsPMREMUpdate = !1;
            }
            get image() {
                return this.source.data;
            }
            set image(t1 = null) {
                this.source.data = t1;
            }
            updateMatrix() {
                this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
            }
            clone() {
                return (new this.constructor).copy(this);
            }
            copy(t1) {
                return this.name = t1.name, this.source = t1.source, this.mipmaps = t1.mipmaps.slice(0), this.mapping = t1.mapping, this.channel = t1.channel, this.wrapS = t1.wrapS, this.wrapT = t1.wrapT, this.magFilter = t1.magFilter, this.minFilter = t1.minFilter, this.anisotropy = t1.anisotropy, this.format = t1.format, this.internalFormat = t1.internalFormat, this.type = t1.type, this.offset.copy(t1.offset), this.repeat.copy(t1.repeat), this.center.copy(t1.center), this.rotation = t1.rotation, this.matrixAutoUpdate = t1.matrixAutoUpdate, this.matrix.copy(t1.matrix), this.generateMipmaps = t1.generateMipmaps, this.premultiplyAlpha = t1.premultiplyAlpha, this.flipY = t1.flipY, this.unpackAlignment = t1.unpackAlignment, this.colorSpace = t1.colorSpace, this.userData = JSON.parse(JSON.stringify(t1.userData)), this.needsUpdate = !0, this;
            }
            toJSON(t1) {
                const e = void 0 === t1 || "string" == typeof t1;
                if (!e && void 0 !== t1.textures[this.uuid]) return t1.textures[this.uuid];
                const i = {
                    metadata: {
                        version: 4.6,
                        type: "Texture",
                        generator: "Texture.toJSON"
                    },
                    uuid: this.uuid,
                    name: this.name,
                    image: this.source.toJSON(t1).uuid,
                    mapping: this.mapping,
                    channel: this.channel,
                    repeat: [
                        this.repeat.x,
                        this.repeat.y
                    ],
                    offset: [
                        this.offset.x,
                        this.offset.y
                    ],
                    center: [
                        this.center.x,
                        this.center.y
                    ],
                    rotation: this.rotation,
                    wrap: [
                        this.wrapS,
                        this.wrapT
                    ],
                    format: this.format,
                    internalFormat: this.internalFormat,
                    type: this.type,
                    colorSpace: this.colorSpace,
                    minFilter: this.minFilter,
                    magFilter: this.magFilter,
                    anisotropy: this.anisotropy,
                    flipY: this.flipY,
                    generateMipmaps: this.generateMipmaps,
                    premultiplyAlpha: this.premultiplyAlpha,
                    unpackAlignment: this.unpackAlignment
                };
                return Object.keys(this.userData).length > 0 && (i.userData = this.userData), e || (t1.textures[this.uuid] = i), i;
            }
            dispose() {
                this.dispatchEvent({
                    type: "dispose"
                });
            }
            transformUv(t1) {
                if (this.mapping !== ia) return t1;
                if (t1.applyMatrix3(this.matrix), t1.x < 0 || t1.x > 1) switch(this.wrapS){
                    case la:
                        t1.x = t1.x - Math.floor(t1.x);
                        break;
                    case ca:
                        t1.x = t1.x < 0 ? 0 : 1;
                        break;
                    case ua:
                        1 === Math.abs(Math.floor(t1.x) % 2) ? t1.x = Math.ceil(t1.x) - t1.x : t1.x = t1.x - Math.floor(t1.x);
                }
                if (t1.y < 0 || t1.y > 1) switch(this.wrapT){
                    case la:
                        t1.y = t1.y - Math.floor(t1.y);
                        break;
                    case ca:
                        t1.y = t1.y < 0 ? 0 : 1;
                        break;
                    case ua:
                        1 === Math.abs(Math.floor(t1.y) % 2) ? t1.y = Math.ceil(t1.y) - t1.y : t1.y = t1.y - Math.floor(t1.y);
                }
                return this.flipY && (t1.y = 1 - t1.y), t1;
            }
            set needsUpdate(t1) {
                !0 === t1 && (this.version++, this.source.needsUpdate = !0);
            }
            get encoding() {
                return al("THREE.Texture: Property .encoding has been replaced by .colorSpace."), this.colorSpace === Qs ? js : Ps;
            }
            set encoding(t1) {
                al("THREE.Texture: Property .encoding has been replaced by .colorSpace."), this.colorSpace = t1 === js ? Qs : Fs;
            }
        }
        vl.DEFAULT_IMAGE = null, vl.DEFAULT_MAPPING = ia, vl.DEFAULT_ANISOTROPY = 1;
        class yl {
            constructor(t1 = 0, e = 0, i = 0, n = 1){
                yl.prototype.isVector4 = !0, this.x = t1, this.y = e, this.z = i, this.w = n;
            }
            get width() {
                return this.z;
            }
            set width(t1) {
                this.z = t1;
            }
            get height() {
                return this.w;
            }
            set height(t1) {
                this.w = t1;
            }
            set(t1, e, i, n) {
                return this.x = t1, this.y = e, this.z = i, this.w = n, this;
            }
            setScalar(t1) {
                return this.x = t1, this.y = t1, this.z = t1, this.w = t1, this;
            }
            setX(t1) {
                return this.x = t1, this;
            }
            setY(t1) {
                return this.y = t1, this;
            }
            setZ(t1) {
                return this.z = t1, this;
            }
            setW(t1) {
                return this.w = t1, this;
            }
            setComponent(t1, e) {
                switch(t1){
                    case 0:
                        this.x = e;
                        break;
                    case 1:
                        this.y = e;
                        break;
                    case 2:
                        this.z = e;
                        break;
                    case 3:
                        this.w = e;
                        break;
                    default:
                        throw new Error("index is out of range: " + t1);
                }
                return this;
            }
            getComponent(t1) {
                switch(t1){
                    case 0:
                        return this.x;
                    case 1:
                        return this.y;
                    case 2:
                        return this.z;
                    case 3:
                        return this.w;
                    default:
                        throw new Error("index is out of range: " + t1);
                }
            }
            clone() {
                return new this.constructor(this.x, this.y, this.z, this.w);
            }
            copy(t1) {
                return this.x = t1.x, this.y = t1.y, this.z = t1.z, this.w = void 0 !== t1.w ? t1.w : 1, this;
            }
            add(t1) {
                return this.x += t1.x, this.y += t1.y, this.z += t1.z, this.w += t1.w, this;
            }
            addScalar(t1) {
                return this.x += t1, this.y += t1, this.z += t1, this.w += t1, this;
            }
            addVectors(t1, e) {
                return this.x = t1.x + e.x, this.y = t1.y + e.y, this.z = t1.z + e.z, this.w = t1.w + e.w, this;
            }
            addScaledVector(t1, e) {
                return this.x += t1.x * e, this.y += t1.y * e, this.z += t1.z * e, this.w += t1.w * e, this;
            }
            sub(t1) {
                return this.x -= t1.x, this.y -= t1.y, this.z -= t1.z, this.w -= t1.w, this;
            }
            subScalar(t1) {
                return this.x -= t1, this.y -= t1, this.z -= t1, this.w -= t1, this;
            }
            subVectors(t1, e) {
                return this.x = t1.x - e.x, this.y = t1.y - e.y, this.z = t1.z - e.z, this.w = t1.w - e.w, this;
            }
            multiply(t1) {
                return this.x *= t1.x, this.y *= t1.y, this.z *= t1.z, this.w *= t1.w, this;
            }
            multiplyScalar(t1) {
                return this.x *= t1, this.y *= t1, this.z *= t1, this.w *= t1, this;
            }
            applyMatrix4(t1) {
                const e = this.x, i = this.y, n = this.z, r = this.w, a = t1.elements;
                return this.x = a[0] * e + a[4] * i + a[8] * n + a[12] * r, this.y = a[1] * e + a[5] * i + a[9] * n + a[13] * r, this.z = a[2] * e + a[6] * i + a[10] * n + a[14] * r, this.w = a[3] * e + a[7] * i + a[11] * n + a[15] * r, this;
            }
            divideScalar(t1) {
                return this.multiplyScalar(1 / t1);
            }
            setAxisAngleFromQuaternion(t1) {
                this.w = 2 * Math.acos(t1.w);
                const e = Math.sqrt(1 - t1.w * t1.w);
                return e < 1e-4 ? (this.x = 1, this.y = 0, this.z = 0) : (this.x = t1.x / e, this.y = t1.y / e, this.z = t1.z / e), this;
            }
            setAxisAngleFromRotationMatrix(t1) {
                let e, i, n, r;
                const a = .01, s = .1, o = t1.elements, l = o[0], c = o[4], u = o[8], h = o[1], d = o[5], p = o[9], A = o[2], f = o[6], m = o[10];
                if (Math.abs(c - h) < a && Math.abs(u - A) < a && Math.abs(p - f) < a) {
                    if (Math.abs(c + h) < s && Math.abs(u + A) < s && Math.abs(p + f) < s && Math.abs(l + d + m - 3) < s) return this.set(1, 0, 0, 0), this;
                    e = Math.PI;
                    const t1 = (l + 1) / 2, o = (d + 1) / 2, g = (m + 1) / 2, M = (c + h) / 4, v = (u + A) / 4, y = (p + f) / 4;
                    return t1 > o && t1 > g ? t1 < a ? (i = 0, n = .707106781, r = .707106781) : (i = Math.sqrt(t1), n = M / i, r = v / i) : o > g ? o < a ? (i = .707106781, n = 0, r = .707106781) : (n = Math.sqrt(o), i = M / n, r = y / n) : g < a ? (i = .707106781, n = .707106781, r = 0) : (r = Math.sqrt(g), i = v / r, n = y / r), this.set(i, n, r, e), this;
                }
                let g = Math.sqrt((f - p) * (f - p) + (u - A) * (u - A) + (h - c) * (h - c));
                return Math.abs(g) < .001 && (g = 1), this.x = (f - p) / g, this.y = (u - A) / g, this.z = (h - c) / g, this.w = Math.acos((l + d + m - 1) / 2), this;
            }
            min(t1) {
                return this.x = Math.min(this.x, t1.x), this.y = Math.min(this.y, t1.y), this.z = Math.min(this.z, t1.z), this.w = Math.min(this.w, t1.w), this;
            }
            max(t1) {
                return this.x = Math.max(this.x, t1.x), this.y = Math.max(this.y, t1.y), this.z = Math.max(this.z, t1.z), this.w = Math.max(this.w, t1.w), this;
            }
            clamp(t1, e) {
                return this.x = Math.max(t1.x, Math.min(e.x, this.x)), this.y = Math.max(t1.y, Math.min(e.y, this.y)), this.z = Math.max(t1.z, Math.min(e.z, this.z)), this.w = Math.max(t1.w, Math.min(e.w, this.w)), this;
            }
            clampScalar(t1, e) {
                return this.x = Math.max(t1, Math.min(e, this.x)), this.y = Math.max(t1, Math.min(e, this.y)), this.z = Math.max(t1, Math.min(e, this.z)), this.w = Math.max(t1, Math.min(e, this.w)), this;
            }
            clampLength(t1, e) {
                const i = this.length();
                return this.divideScalar(i || 1).multiplyScalar(Math.max(t1, Math.min(e, i)));
            }
            floor() {
                return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this.w = Math.floor(this.w), this;
            }
            ceil() {
                return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this.w = Math.ceil(this.w), this;
            }
            round() {
                return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this.w = Math.round(this.w), this;
            }
            roundToZero() {
                return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this.z = Math.trunc(this.z), this.w = Math.trunc(this.w), this;
            }
            negate() {
                return this.x = -this.x, this.y = -this.y, this.z = -this.z, this.w = -this.w, this;
            }
            dot(t1) {
                return this.x * t1.x + this.y * t1.y + this.z * t1.z + this.w * t1.w;
            }
            lengthSq() {
                return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
            }
            length() {
                return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
            }
            manhattanLength() {
                return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
            }
            normalize() {
                return this.divideScalar(this.length() || 1);
            }
            setLength(t1) {
                return this.normalize().multiplyScalar(t1);
            }
            lerp(t1, e) {
                return this.x += (t1.x - this.x) * e, this.y += (t1.y - this.y) * e, this.z += (t1.z - this.z) * e, this.w += (t1.w - this.w) * e, this;
            }
            lerpVectors(t1, e, i) {
                return this.x = t1.x + (e.x - t1.x) * i, this.y = t1.y + (e.y - t1.y) * i, this.z = t1.z + (e.z - t1.z) * i, this.w = t1.w + (e.w - t1.w) * i, this;
            }
            equals(t1) {
                return t1.x === this.x && t1.y === this.y && t1.z === this.z && t1.w === this.w;
            }
            fromArray(t1, e = 0) {
                return this.x = t1[e], this.y = t1[e + 1], this.z = t1[e + 2], this.w = t1[e + 3], this;
            }
            toArray(t1 = [], e = 0) {
                return t1[e] = this.x, t1[e + 1] = this.y, t1[e + 2] = this.z, t1[e + 3] = this.w, t1;
            }
            fromBufferAttribute(t1, e) {
                return this.x = t1.getX(e), this.y = t1.getY(e), this.z = t1.getZ(e), this.w = t1.getW(e), this;
            }
            random() {
                return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this.w = Math.random(), this;
            }
            *[Symbol.iterator]() {
                yield this.x, yield this.y, yield this.z, yield this.w;
            }
        }
        class xl extends Po {
            constructor(t1 = 1, e = 1, i = {}){
                super(), this.isRenderTarget = !0, this.width = t1, this.height = e, this.depth = 1, this.scissor = new yl(0, 0, t1, e), this.scissorTest = !1, this.viewport = new yl(0, 0, t1, e);
                const n = {
                    width: t1,
                    height: e,
                    depth: 1
                };
                void 0 !== i.encoding && (al("THREE.WebGLRenderTarget: option.encoding has been replaced by option.colorSpace."), i.colorSpace = i.encoding === js ? Qs : Fs), i = Object.assign({
                    generateMipmaps: !1,
                    internalFormat: null,
                    minFilter: ma,
                    depthBuffer: !0,
                    stencilBuffer: !1,
                    depthTexture: null,
                    samples: 0
                }, i), this.texture = new vl(n, i.mapping, i.wrapS, i.wrapT, i.magFilter, i.minFilter, i.format, i.type, i.anisotropy, i.colorSpace), this.texture.isRenderTargetTexture = !0, this.texture.flipY = !1, this.texture.generateMipmaps = i.generateMipmaps, this.texture.internalFormat = i.internalFormat, this.depthBuffer = i.depthBuffer, this.stencilBuffer = i.stencilBuffer, this.depthTexture = i.depthTexture, this.samples = i.samples;
            }
            setSize(t1, e, i = 1) {
                this.width === t1 && this.height === e && this.depth === i || (this.width = t1, this.height = e, this.depth = i, this.texture.image.width = t1, this.texture.image.height = e, this.texture.image.depth = i, this.dispose()), this.viewport.set(0, 0, t1, e), this.scissor.set(0, 0, t1, e);
            }
            clone() {
                return (new this.constructor).copy(this);
            }
            copy(t1) {
                this.width = t1.width, this.height = t1.height, this.depth = t1.depth, this.scissor.copy(t1.scissor), this.scissorTest = t1.scissorTest, this.viewport.copy(t1.viewport), this.texture = t1.texture.clone(), this.texture.isRenderTargetTexture = !0;
                const e = Object.assign({}, t1.texture.image);
                return this.texture.source = new ml(e), this.depthBuffer = t1.depthBuffer, this.stencilBuffer = t1.stencilBuffer, null !== t1.depthTexture && (this.depthTexture = t1.depthTexture.clone()), this.samples = t1.samples, this;
            }
            dispose() {
                this.dispatchEvent({
                    type: "dispose"
                });
            }
        }
        class wl extends xl {
            constructor(t1 = 1, e = 1, i = {}){
                super(t1, e, i), this.isWebGLRenderTarget = !0;
            }
        }
        class bl extends vl {
            constructor(t1 = null, e = 1, i = 1, n = 1){
                super(null), this.isDataArrayTexture = !0, this.image = {
                    data: t1,
                    width: e,
                    height: i,
                    depth: n
                }, this.magFilter = ha, this.minFilter = ha, this.wrapR = ca, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
            }
        }
        class Tl extends wl {
            constructor(t1 = 1, e = 1, i = 1){
                super(t1, e), this.isWebGLArrayRenderTarget = !0, this.depth = i, this.texture = new bl(null, t1, e, i), this.texture.isRenderTargetTexture = !0;
            }
        }
        class El extends vl {
            constructor(t1 = null, e = 1, i = 1, n = 1){
                super(null), this.isData3DTexture = !0, this.image = {
                    data: t1,
                    width: e,
                    height: i,
                    depth: n
                }, this.magFilter = ha, this.minFilter = ha, this.wrapR = ca, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
            }
        }
        class _l extends wl {
            constructor(t1 = 1, e = 1, i = 1){
                super(t1, e), this.isWebGL3DRenderTarget = !0, this.depth = i, this.texture = new El(null, t1, e, i), this.texture.isRenderTargetTexture = !0;
            }
        }
        class Il extends wl {
            constructor(t1 = 1, e = 1, i = 1, n = {}){
                super(t1, e, n), this.isWebGLMultipleRenderTargets = !0;
                const r = this.texture;
                this.texture = [];
                for(let t1 = 0; t1 < i; t1++)this.texture[t1] = r.clone(), this.texture[t1].isRenderTargetTexture = !0;
            }
            setSize(t1, e, i = 1) {
                if (this.width !== t1 || this.height !== e || this.depth !== i) {
                    this.width = t1, this.height = e, this.depth = i;
                    for(let n = 0, r = this.texture.length; n < r; n++)this.texture[n].image.width = t1, this.texture[n].image.height = e, this.texture[n].image.depth = i;
                    this.dispose();
                }
                this.viewport.set(0, 0, t1, e), this.scissor.set(0, 0, t1, e);
            }
            copy(t1) {
                this.dispose(), this.width = t1.width, this.height = t1.height, this.depth = t1.depth, this.scissor.copy(t1.scissor), this.scissorTest = t1.scissorTest, this.viewport.copy(t1.viewport), this.depthBuffer = t1.depthBuffer, this.stencilBuffer = t1.stencilBuffer, null !== t1.depthTexture && (this.depthTexture = t1.depthTexture.clone()), this.texture.length = 0;
                for(let e = 0, i = t1.texture.length; e < i; e++)this.texture[e] = t1.texture[e].clone(), this.texture[e].isRenderTargetTexture = !0;
                return this;
            }
        }
        class Sl {
            constructor(t1 = 0, e = 0, i = 0, n = 1){
                this.isQuaternion = !0, this._x = t1, this._y = e, this._z = i, this._w = n;
            }
            static slerpFlat(t1, e, i, n, r, a, s) {
                let o = i[n + 0], l = i[n + 1], c = i[n + 2], u = i[n + 3];
                const h = r[a + 0], d = r[a + 1], p = r[a + 2], A = r[a + 3];
                if (0 === s) return t1[e + 0] = o, t1[e + 1] = l, t1[e + 2] = c, void (t1[e + 3] = u);
                if (1 === s) return t1[e + 0] = h, t1[e + 1] = d, t1[e + 2] = p, void (t1[e + 3] = A);
                if (u !== A || o !== h || l !== d || c !== p) {
                    let t1 = 1 - s;
                    const e = o * h + l * d + c * p + u * A, i = e >= 0 ? 1 : -1, n = 1 - e * e;
                    if (n > Number.EPSILON) {
                        const r = Math.sqrt(n), a = Math.atan2(r, e * i);
                        t1 = Math.sin(t1 * a) / r, s = Math.sin(s * a) / r;
                    }
                    const r = s * i;
                    if (o = o * t1 + h * r, l = l * t1 + d * r, c = c * t1 + p * r, u = u * t1 + A * r, t1 === 1 - s) {
                        const t1 = 1 / Math.sqrt(o * o + l * l + c * c + u * u);
                        o *= t1, l *= t1, c *= t1, u *= t1;
                    }
                }
                t1[e] = o, t1[e + 1] = l, t1[e + 2] = c, t1[e + 3] = u;
            }
            static multiplyQuaternionsFlat(t1, e, i, n, r, a) {
                const s = i[n], o = i[n + 1], l = i[n + 2], c = i[n + 3], u = r[a], h = r[a + 1], d = r[a + 2], p = r[a + 3];
                return t1[e] = s * p + c * u + o * d - l * h, t1[e + 1] = o * p + c * h + l * u - s * d, t1[e + 2] = l * p + c * d + s * h - o * u, t1[e + 3] = c * p - s * u - o * h - l * d, t1;
            }
            get x() {
                return this._x;
            }
            set x(t1) {
                this._x = t1, this._onChangeCallback();
            }
            get y() {
                return this._y;
            }
            set y(t1) {
                this._y = t1, this._onChangeCallback();
            }
            get z() {
                return this._z;
            }
            set z(t1) {
                this._z = t1, this._onChangeCallback();
            }
            get w() {
                return this._w;
            }
            set w(t1) {
                this._w = t1, this._onChangeCallback();
            }
            set(t1, e, i, n) {
                return this._x = t1, this._y = e, this._z = i, this._w = n, this._onChangeCallback(), this;
            }
            clone() {
                return new this.constructor(this._x, this._y, this._z, this._w);
            }
            copy(t1) {
                return this._x = t1.x, this._y = t1.y, this._z = t1.z, this._w = t1.w, this._onChangeCallback(), this;
            }
            setFromEuler(t1, e) {
                const i = t1._x, n = t1._y, r = t1._z, a = t1._order, s = Math.cos, o = Math.sin, l = s(i / 2), c = s(n / 2), u = s(r / 2), h = o(i / 2), d = o(n / 2), p = o(r / 2);
                switch(a){
                    case "XYZ":
                        this._x = h * c * u + l * d * p, this._y = l * d * u - h * c * p, this._z = l * c * p + h * d * u, this._w = l * c * u - h * d * p;
                        break;
                    case "YXZ":
                        this._x = h * c * u + l * d * p, this._y = l * d * u - h * c * p, this._z = l * c * p - h * d * u, this._w = l * c * u + h * d * p;
                        break;
                    case "ZXY":
                        this._x = h * c * u - l * d * p, this._y = l * d * u + h * c * p, this._z = l * c * p + h * d * u, this._w = l * c * u - h * d * p;
                        break;
                    case "ZYX":
                        this._x = h * c * u - l * d * p, this._y = l * d * u + h * c * p, this._z = l * c * p - h * d * u, this._w = l * c * u + h * d * p;
                        break;
                    case "YZX":
                        this._x = h * c * u + l * d * p, this._y = l * d * u + h * c * p, this._z = l * c * p - h * d * u, this._w = l * c * u - h * d * p;
                        break;
                    case "XZY":
                        this._x = h * c * u - l * d * p, this._y = l * d * u - h * c * p, this._z = l * c * p + h * d * u, this._w = l * c * u + h * d * p;
                        break;
                    default:
                        console.warn("THREE.Quaternion: .setFromEuler() encountered an unknown order: " + a);
                }
                return !1 !== e && this._onChangeCallback(), this;
            }
            setFromAxisAngle(t1, e) {
                const i = e / 2, n = Math.sin(i);
                return this._x = t1.x * n, this._y = t1.y * n, this._z = t1.z * n, this._w = Math.cos(i), this._onChangeCallback(), this;
            }
            setFromRotationMatrix(t1) {
                const e = t1.elements, i = e[0], n = e[4], r = e[8], a = e[1], s = e[5], o = e[9], l = e[2], c = e[6], u = e[10], h = i + s + u;
                if (h > 0) {
                    const t1 = .5 / Math.sqrt(h + 1);
                    this._w = .25 / t1, this._x = (c - o) * t1, this._y = (r - l) * t1, this._z = (a - n) * t1;
                } else if (i > s && i > u) {
                    const t1 = 2 * Math.sqrt(1 + i - s - u);
                    this._w = (c - o) / t1, this._x = .25 * t1, this._y = (n + a) / t1, this._z = (r + l) / t1;
                } else if (s > u) {
                    const t1 = 2 * Math.sqrt(1 + s - i - u);
                    this._w = (r - l) / t1, this._x = (n + a) / t1, this._y = .25 * t1, this._z = (o + c) / t1;
                } else {
                    const t1 = 2 * Math.sqrt(1 + u - i - s);
                    this._w = (a - n) / t1, this._x = (r + l) / t1, this._y = (o + c) / t1, this._z = .25 * t1;
                }
                return this._onChangeCallback(), this;
            }
            setFromUnitVectors(t1, e) {
                let i = t1.dot(e) + 1;
                return i < Number.EPSILON ? (i = 0, Math.abs(t1.x) > Math.abs(t1.z) ? (this._x = -t1.y, this._y = t1.x, this._z = 0, this._w = i) : (this._x = 0, this._y = -t1.z, this._z = t1.y, this._w = i)) : (this._x = t1.y * e.z - t1.z * e.y, this._y = t1.z * e.x - t1.x * e.z, this._z = t1.x * e.y - t1.y * e.x, this._w = i), this.normalize();
            }
            angleTo(t1) {
                return 2 * Math.acos(Math.abs(Fo(this.dot(t1), -1, 1)));
            }
            rotateTowards(t1, e) {
                const i = this.angleTo(t1);
                if (0 === i) return this;
                const n = Math.min(1, e / i);
                return this.slerp(t1, n), this;
            }
            identity() {
                return this.set(0, 0, 0, 1);
            }
            invert() {
                return this.conjugate();
            }
            conjugate() {
                return this._x *= -1, this._y *= -1, this._z *= -1, this._onChangeCallback(), this;
            }
            dot(t1) {
                return this._x * t1._x + this._y * t1._y + this._z * t1._z + this._w * t1._w;
            }
            lengthSq() {
                return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
            }
            length() {
                return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
            }
            normalize() {
                let t1 = this.length();
                return 0 === t1 ? (this._x = 0, this._y = 0, this._z = 0, this._w = 1) : (t1 = 1 / t1, this._x = this._x * t1, this._y = this._y * t1, this._z = this._z * t1, this._w = this._w * t1), this._onChangeCallback(), this;
            }
            multiply(t1) {
                return this.multiplyQuaternions(this, t1);
            }
            premultiply(t1) {
                return this.multiplyQuaternions(t1, this);
            }
            multiplyQuaternions(t1, e) {
                const i = t1._x, n = t1._y, r = t1._z, a = t1._w, s = e._x, o = e._y, l = e._z, c = e._w;
                return this._x = i * c + a * s + n * l - r * o, this._y = n * c + a * o + r * s - i * l, this._z = r * c + a * l + i * o - n * s, this._w = a * c - i * s - n * o - r * l, this._onChangeCallback(), this;
            }
            slerp(t1, e) {
                if (0 === e) return this;
                if (1 === e) return this.copy(t1);
                const i = this._x, n = this._y, r = this._z, a = this._w;
                let s = a * t1._w + i * t1._x + n * t1._y + r * t1._z;
                if (s < 0 ? (this._w = -t1._w, this._x = -t1._x, this._y = -t1._y, this._z = -t1._z, s = -s) : this.copy(t1), s >= 1) return this._w = a, this._x = i, this._y = n, this._z = r, this;
                const o = 1 - s * s;
                if (o <= Number.EPSILON) {
                    const t1 = 1 - e;
                    return this._w = t1 * a + e * this._w, this._x = t1 * i + e * this._x, this._y = t1 * n + e * this._y, this._z = t1 * r + e * this._z, this.normalize(), this._onChangeCallback(), this;
                }
                const l = Math.sqrt(o), c = Math.atan2(l, s), u = Math.sin((1 - e) * c) / l, h = Math.sin(e * c) / l;
                return this._w = a * u + this._w * h, this._x = i * u + this._x * h, this._y = n * u + this._y * h, this._z = r * u + this._z * h, this._onChangeCallback(), this;
            }
            slerpQuaternions(t1, e, i) {
                return this.copy(t1).slerp(e, i);
            }
            random() {
                const t1 = Math.random(), e = Math.sqrt(1 - t1), i = Math.sqrt(t1), n = 2 * Math.PI * Math.random(), r = 2 * Math.PI * Math.random();
                return this.set(e * Math.cos(n), i * Math.sin(r), i * Math.cos(r), e * Math.sin(n));
            }
            equals(t1) {
                return t1._x === this._x && t1._y === this._y && t1._z === this._z && t1._w === this._w;
            }
            fromArray(t1, e = 0) {
                return this._x = t1[e], this._y = t1[e + 1], this._z = t1[e + 2], this._w = t1[e + 3], this._onChangeCallback(), this;
            }
            toArray(t1 = [], e = 0) {
                return t1[e] = this._x, t1[e + 1] = this._y, t1[e + 2] = this._z, t1[e + 3] = this._w, t1;
            }
            fromBufferAttribute(t1, e) {
                return this._x = t1.getX(e), this._y = t1.getY(e), this._z = t1.getZ(e), this._w = t1.getW(e), this;
            }
            toJSON() {
                return this.toArray();
            }
            _onChange(t1) {
                return this._onChangeCallback = t1, this;
            }
            _onChangeCallback() {}
            *[Symbol.iterator]() {
                yield this._x, yield this._y, yield this._z, yield this._w;
            }
        }
        class Nl {
            constructor(t1 = 0, e = 0, i = 0){
                Nl.prototype.isVector3 = !0, this.x = t1, this.y = e, this.z = i;
            }
            set(t1, e, i) {
                return void 0 === i && (i = this.z), this.x = t1, this.y = e, this.z = i, this;
            }
            setScalar(t1) {
                return this.x = t1, this.y = t1, this.z = t1, this;
            }
            setX(t1) {
                return this.x = t1, this;
            }
            setY(t1) {
                return this.y = t1, this;
            }
            setZ(t1) {
                return this.z = t1, this;
            }
            setComponent(t1, e) {
                switch(t1){
                    case 0:
                        this.x = e;
                        break;
                    case 1:
                        this.y = e;
                        break;
                    case 2:
                        this.z = e;
                        break;
                    default:
                        throw new Error("index is out of range: " + t1);
                }
                return this;
            }
            getComponent(t1) {
                switch(t1){
                    case 0:
                        return this.x;
                    case 1:
                        return this.y;
                    case 2:
                        return this.z;
                    default:
                        throw new Error("index is out of range: " + t1);
                }
            }
            clone() {
                return new this.constructor(this.x, this.y, this.z);
            }
            copy(t1) {
                return this.x = t1.x, this.y = t1.y, this.z = t1.z, this;
            }
            add(t1) {
                return this.x += t1.x, this.y += t1.y, this.z += t1.z, this;
            }
            addScalar(t1) {
                return this.x += t1, this.y += t1, this.z += t1, this;
            }
            addVectors(t1, e) {
                return this.x = t1.x + e.x, this.y = t1.y + e.y, this.z = t1.z + e.z, this;
            }
            addScaledVector(t1, e) {
                return this.x += t1.x * e, this.y += t1.y * e, this.z += t1.z * e, this;
            }
            sub(t1) {
                return this.x -= t1.x, this.y -= t1.y, this.z -= t1.z, this;
            }
            subScalar(t1) {
                return this.x -= t1, this.y -= t1, this.z -= t1, this;
            }
            subVectors(t1, e) {
                return this.x = t1.x - e.x, this.y = t1.y - e.y, this.z = t1.z - e.z, this;
            }
            multiply(t1) {
                return this.x *= t1.x, this.y *= t1.y, this.z *= t1.z, this;
            }
            multiplyScalar(t1) {
                return this.x *= t1, this.y *= t1, this.z *= t1, this;
            }
            multiplyVectors(t1, e) {
                return this.x = t1.x * e.x, this.y = t1.y * e.y, this.z = t1.z * e.z, this;
            }
            applyEuler(t1) {
                return this.applyQuaternion(Cl.setFromEuler(t1));
            }
            applyAxisAngle(t1, e) {
                return this.applyQuaternion(Cl.setFromAxisAngle(t1, e));
            }
            applyMatrix3(t1) {
                const e = this.x, i = this.y, n = this.z, r = t1.elements;
                return this.x = r[0] * e + r[3] * i + r[6] * n, this.y = r[1] * e + r[4] * i + r[7] * n, this.z = r[2] * e + r[5] * i + r[8] * n, this;
            }
            applyNormalMatrix(t1) {
                return this.applyMatrix3(t1).normalize();
            }
            applyMatrix4(t1) {
                const e = this.x, i = this.y, n = this.z, r = t1.elements, a = 1 / (r[3] * e + r[7] * i + r[11] * n + r[15]);
                return this.x = (r[0] * e + r[4] * i + r[8] * n + r[12]) * a, this.y = (r[1] * e + r[5] * i + r[9] * n + r[13]) * a, this.z = (r[2] * e + r[6] * i + r[10] * n + r[14]) * a, this;
            }
            applyQuaternion(t1) {
                const e = this.x, i = this.y, n = this.z, r = t1.x, a = t1.y, s = t1.z, o = t1.w, l = 2 * (a * n - s * i), c = 2 * (s * e - r * n), u = 2 * (r * i - a * e);
                return this.x = e + o * l + a * u - s * c, this.y = i + o * c + s * l - r * u, this.z = n + o * u + r * c - a * l, this;
            }
            project(t1) {
                return this.applyMatrix4(t1.matrixWorldInverse).applyMatrix4(t1.projectionMatrix);
            }
            unproject(t1) {
                return this.applyMatrix4(t1.projectionMatrixInverse).applyMatrix4(t1.matrixWorld);
            }
            transformDirection(t1) {
                const e = this.x, i = this.y, n = this.z, r = t1.elements;
                return this.x = r[0] * e + r[4] * i + r[8] * n, this.y = r[1] * e + r[5] * i + r[9] * n, this.z = r[2] * e + r[6] * i + r[10] * n, this.normalize();
            }
            divide(t1) {
                return this.x /= t1.x, this.y /= t1.y, this.z /= t1.z, this;
            }
            divideScalar(t1) {
                return this.multiplyScalar(1 / t1);
            }
            min(t1) {
                return this.x = Math.min(this.x, t1.x), this.y = Math.min(this.y, t1.y), this.z = Math.min(this.z, t1.z), this;
            }
            max(t1) {
                return this.x = Math.max(this.x, t1.x), this.y = Math.max(this.y, t1.y), this.z = Math.max(this.z, t1.z), this;
            }
            clamp(t1, e) {
                return this.x = Math.max(t1.x, Math.min(e.x, this.x)), this.y = Math.max(t1.y, Math.min(e.y, this.y)), this.z = Math.max(t1.z, Math.min(e.z, this.z)), this;
            }
            clampScalar(t1, e) {
                return this.x = Math.max(t1, Math.min(e, this.x)), this.y = Math.max(t1, Math.min(e, this.y)), this.z = Math.max(t1, Math.min(e, this.z)), this;
            }
            clampLength(t1, e) {
                const i = this.length();
                return this.divideScalar(i || 1).multiplyScalar(Math.max(t1, Math.min(e, i)));
            }
            floor() {
                return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this;
            }
            ceil() {
                return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this;
            }
            round() {
                return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this;
            }
            roundToZero() {
                return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this.z = Math.trunc(this.z), this;
            }
            negate() {
                return this.x = -this.x, this.y = -this.y, this.z = -this.z, this;
            }
            dot(t1) {
                return this.x * t1.x + this.y * t1.y + this.z * t1.z;
            }
            lengthSq() {
                return this.x * this.x + this.y * this.y + this.z * this.z;
            }
            length() {
                return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
            }
            manhattanLength() {
                return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
            }
            normalize() {
                return this.divideScalar(this.length() || 1);
            }
            setLength(t1) {
                return this.normalize().multiplyScalar(t1);
            }
            lerp(t1, e) {
                return this.x += (t1.x - this.x) * e, this.y += (t1.y - this.y) * e, this.z += (t1.z - this.z) * e, this;
            }
            lerpVectors(t1, e, i) {
                return this.x = t1.x + (e.x - t1.x) * i, this.y = t1.y + (e.y - t1.y) * i, this.z = t1.z + (e.z - t1.z) * i, this;
            }
            cross(t1) {
                return this.crossVectors(this, t1);
            }
            crossVectors(t1, e) {
                const i = t1.x, n = t1.y, r = t1.z, a = e.x, s = e.y, o = e.z;
                return this.x = n * o - r * s, this.y = r * a - i * o, this.z = i * s - n * a, this;
            }
            projectOnVector(t1) {
                const e = t1.lengthSq();
                if (0 === e) return this.set(0, 0, 0);
                const i = t1.dot(this) / e;
                return this.copy(t1).multiplyScalar(i);
            }
            projectOnPlane(t1) {
                return Dl.copy(this).projectOnVector(t1), this.sub(Dl);
            }
            reflect(t1) {
                return this.sub(Dl.copy(t1).multiplyScalar(2 * this.dot(t1)));
            }
            angleTo(t1) {
                const e = Math.sqrt(this.lengthSq() * t1.lengthSq());
                if (0 === e) return Math.PI / 2;
                const i = this.dot(t1) / e;
                return Math.acos(Fo(i, -1, 1));
            }
            distanceTo(t1) {
                return Math.sqrt(this.distanceToSquared(t1));
            }
            distanceToSquared(t1) {
                const e = this.x - t1.x, i = this.y - t1.y, n = this.z - t1.z;
                return e * e + i * i + n * n;
            }
            manhattanDistanceTo(t1) {
                return Math.abs(this.x - t1.x) + Math.abs(this.y - t1.y) + Math.abs(this.z - t1.z);
            }
            setFromSpherical(t1) {
                return this.setFromSphericalCoords(t1.radius, t1.phi, t1.theta);
            }
            setFromSphericalCoords(t1, e, i) {
                const n = Math.sin(e) * t1;
                return this.x = n * Math.sin(i), this.y = Math.cos(e) * t1, this.z = n * Math.cos(i), this;
            }
            setFromCylindrical(t1) {
                return this.setFromCylindricalCoords(t1.radius, t1.theta, t1.y);
            }
            setFromCylindricalCoords(t1, e, i) {
                return this.x = t1 * Math.sin(e), this.y = i, this.z = t1 * Math.cos(e), this;
            }
            setFromMatrixPosition(t1) {
                const e = t1.elements;
                return this.x = e[12], this.y = e[13], this.z = e[14], this;
            }
            setFromMatrixScale(t1) {
                const e = this.setFromMatrixColumn(t1, 0).length(), i = this.setFromMatrixColumn(t1, 1).length(), n = this.setFromMatrixColumn(t1, 2).length();
                return this.x = e, this.y = i, this.z = n, this;
            }
            setFromMatrixColumn(t1, e) {
                return this.fromArray(t1.elements, 4 * e);
            }
            setFromMatrix3Column(t1, e) {
                return this.fromArray(t1.elements, 3 * e);
            }
            setFromEuler(t1) {
                return this.x = t1._x, this.y = t1._y, this.z = t1._z, this;
            }
            setFromColor(t1) {
                return this.x = t1.r, this.y = t1.g, this.z = t1.b, this;
            }
            equals(t1) {
                return t1.x === this.x && t1.y === this.y && t1.z === this.z;
            }
            fromArray(t1, e = 0) {
                return this.x = t1[e], this.y = t1[e + 1], this.z = t1[e + 2], this;
            }
            toArray(t1 = [], e = 0) {
                return t1[e] = this.x, t1[e + 1] = this.y, t1[e + 2] = this.z, t1;
            }
            fromBufferAttribute(t1, e) {
                return this.x = t1.getX(e), this.y = t1.getY(e), this.z = t1.getZ(e), this;
            }
            random() {
                return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this;
            }
            randomDirection() {
                const t1 = 2 * (Math.random() - .5), e = Math.random() * Math.PI * 2, i = Math.sqrt(1 - t1 ** 2);
                return this.x = i * Math.cos(e), this.y = i * Math.sin(e), this.z = t1, this;
            }
            *[Symbol.iterator]() {
                yield this.x, yield this.y, yield this.z;
            }
        }
        const Dl = new Nl, Cl = new Sl;
        class zl {
            constructor(t1 = new Nl(1 / 0, 1 / 0, 1 / 0), e = new Nl(-1 / 0, -1 / 0, -1 / 0)){
                this.isBox3 = !0, this.min = t1, this.max = e;
            }
            set(t1, e) {
                return this.min.copy(t1), this.max.copy(e), this;
            }
            setFromArray(t1) {
                this.makeEmpty();
                for(let e = 0, i = t1.length; e < i; e += 3)this.expandByPoint(Ol.fromArray(t1, e));
                return this;
            }
            setFromBufferAttribute(t1) {
                this.makeEmpty();
                for(let e = 0, i = t1.count; e < i; e++)this.expandByPoint(Ol.fromBufferAttribute(t1, e));
                return this;
            }
            setFromPoints(t1) {
                this.makeEmpty();
                for(let e = 0, i = t1.length; e < i; e++)this.expandByPoint(t1[e]);
                return this;
            }
            setFromCenterAndSize(t1, e) {
                const i = Ol.copy(e).multiplyScalar(.5);
                return this.min.copy(t1).sub(i), this.max.copy(t1).add(i), this;
            }
            setFromObject(t1, e = !1) {
                return this.makeEmpty(), this.expandByObject(t1, e);
            }
            clone() {
                return (new this.constructor).copy(this);
            }
            copy(t1) {
                return this.min.copy(t1.min), this.max.copy(t1.max), this;
            }
            makeEmpty() {
                return this.min.x = this.min.y = this.min.z = 1 / 0, this.max.x = this.max.y = this.max.z = -1 / 0, this;
            }
            isEmpty() {
                return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
            }
            getCenter(t1) {
                return this.isEmpty() ? t1.set(0, 0, 0) : t1.addVectors(this.min, this.max).multiplyScalar(.5);
            }
            getSize(t1) {
                return this.isEmpty() ? t1.set(0, 0, 0) : t1.subVectors(this.max, this.min);
            }
            expandByPoint(t1) {
                return this.min.min(t1), this.max.max(t1), this;
            }
            expandByVector(t1) {
                return this.min.sub(t1), this.max.add(t1), this;
            }
            expandByScalar(t1) {
                return this.min.addScalar(-t1), this.max.addScalar(t1), this;
            }
            expandByObject(t1, e = !1) {
                t1.updateWorldMatrix(!1, !1);
                const i = t1.geometry;
                if (void 0 !== i) {
                    const n = i.getAttribute("position");
                    if (!0 === e && void 0 !== n && !0 !== t1.isInstancedMesh) for(let e = 0, i = n.count; e < i; e++)!0 === t1.isMesh ? t1.getVertexPosition(e, Ol) : Ol.fromBufferAttribute(n, e), Ol.applyMatrix4(t1.matrixWorld), this.expandByPoint(Ol);
                    else void 0 !== t1.boundingBox ? (null === t1.boundingBox && t1.computeBoundingBox(), Pl.copy(t1.boundingBox)) : (null === i.boundingBox && i.computeBoundingBox(), Pl.copy(i.boundingBox)), Pl.applyMatrix4(t1.matrixWorld), this.union(Pl);
                }
                const n = t1.children;
                for(let t1 = 0, i = n.length; t1 < i; t1++)this.expandByObject(n[t1], e);
                return this;
            }
            containsPoint(t1) {
                return !(t1.x < this.min.x || t1.x > this.max.x || t1.y < this.min.y || t1.y > this.max.y || t1.z < this.min.z || t1.z > this.max.z);
            }
            containsBox(t1) {
                return this.min.x <= t1.min.x && t1.max.x <= this.max.x && this.min.y <= t1.min.y && t1.max.y <= this.max.y && this.min.z <= t1.min.z && t1.max.z <= this.max.z;
            }
            getParameter(t1, e) {
                return e.set((t1.x - this.min.x) / (this.max.x - this.min.x), (t1.y - this.min.y) / (this.max.y - this.min.y), (t1.z - this.min.z) / (this.max.z - this.min.z));
            }
            intersectsBox(t1) {
                return !(t1.max.x < this.min.x || t1.min.x > this.max.x || t1.max.y < this.min.y || t1.min.y > this.max.y || t1.max.z < this.min.z || t1.min.z > this.max.z);
            }
            intersectsSphere(t1) {
                return this.clampPoint(t1.center, Ol), Ol.distanceToSquared(t1.center) <= t1.radius * t1.radius;
            }
            intersectsPlane(t1) {
                let e, i;
                return t1.normal.x > 0 ? (e = t1.normal.x * this.min.x, i = t1.normal.x * this.max.x) : (e = t1.normal.x * this.max.x, i = t1.normal.x * this.min.x), t1.normal.y > 0 ? (e += t1.normal.y * this.min.y, i += t1.normal.y * this.max.y) : (e += t1.normal.y * this.max.y, i += t1.normal.y * this.min.y), t1.normal.z > 0 ? (e += t1.normal.z * this.min.z, i += t1.normal.z * this.max.z) : (e += t1.normal.z * this.max.z, i += t1.normal.z * this.min.z), e <= -t1.constant && i >= -t1.constant;
            }
            intersectsTriangle(t1) {
                if (this.isEmpty()) return !1;
                this.getCenter(Ql), Hl.subVectors(this.max, Ql), jl.subVectors(t1.a, Ql), Rl.subVectors(t1.b, Ql), kl.subVectors(t1.c, Ql), Ul.subVectors(Rl, jl), Bl.subVectors(kl, Rl), Fl.subVectors(jl, kl);
                let e = [
                    0,
                    -Ul.z,
                    Ul.y,
                    0,
                    -Bl.z,
                    Bl.y,
                    0,
                    -Fl.z,
                    Fl.y,
                    Ul.z,
                    0,
                    -Ul.x,
                    Bl.z,
                    0,
                    -Bl.x,
                    Fl.z,
                    0,
                    -Fl.x,
                    -Ul.y,
                    Ul.x,
                    0,
                    -Bl.y,
                    Bl.x,
                    0,
                    -Fl.y,
                    Fl.x,
                    0
                ];
                return !!Wl(e, jl, Rl, kl, Hl) && (e = [
                    1,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    1
                ], !!Wl(e, jl, Rl, kl, Hl) && (Vl.crossVectors(Ul, Bl), e = [
                    Vl.x,
                    Vl.y,
                    Vl.z
                ], Wl(e, jl, Rl, kl, Hl)));
            }
            clampPoint(t1, e) {
                return e.copy(t1).clamp(this.min, this.max);
            }
            distanceToPoint(t1) {
                return this.clampPoint(t1, Ol).distanceTo(t1);
            }
            getBoundingSphere(t1) {
                return this.isEmpty() ? t1.makeEmpty() : (this.getCenter(t1.center), t1.radius = .5 * this.getSize(Ol).length()), t1;
            }
            intersect(t1) {
                return this.min.max(t1.min), this.max.min(t1.max), this.isEmpty() && this.makeEmpty(), this;
            }
            union(t1) {
                return this.min.min(t1.min), this.max.max(t1.max), this;
            }
            applyMatrix4(t1) {
                return this.isEmpty() || (Ll[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(t1), Ll[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(t1), Ll[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(t1), Ll[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(t1), Ll[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(t1), Ll[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(t1), Ll[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(t1), Ll[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(t1), this.setFromPoints(Ll)), this;
            }
            translate(t1) {
                return this.min.add(t1), this.max.add(t1), this;
            }
            equals(t1) {
                return t1.min.equals(this.min) && t1.max.equals(this.max);
            }
        }
        const Ll = [
            new Nl,
            new Nl,
            new Nl,
            new Nl,
            new Nl,
            new Nl,
            new Nl,
            new Nl
        ], Ol = new Nl, Pl = new zl, jl = new Nl, Rl = new Nl, kl = new Nl, Ul = new Nl, Bl = new Nl, Fl = new Nl, Ql = new Nl, Hl = new Nl, Vl = new Nl, Gl = new Nl;
        function Wl(t1, e, i, n, r) {
            for(let a = 0, s = t1.length - 3; a <= s; a += 3){
                Gl.fromArray(t1, a);
                const s = r.x * Math.abs(Gl.x) + r.y * Math.abs(Gl.y) + r.z * Math.abs(Gl.z), o = e.dot(Gl), l = i.dot(Gl), c = n.dot(Gl);
                if (Math.max(-Math.max(o, l, c), Math.min(o, l, c)) > s) return !1;
            }
            return !0;
        }
        const Yl = new zl, Xl = new Nl, Zl = new Nl;
        class ql {
            constructor(t1 = new Nl, e = -1){
                this.center = t1, this.radius = e;
            }
            set(t1, e) {
                return this.center.copy(t1), this.radius = e, this;
            }
            setFromPoints(t1, e) {
                const i = this.center;
                void 0 !== e ? i.copy(e) : Yl.setFromPoints(t1).getCenter(i);
                let n = 0;
                for(let e = 0, r = t1.length; e < r; e++)n = Math.max(n, i.distanceToSquared(t1[e]));
                return this.radius = Math.sqrt(n), this;
            }
            copy(t1) {
                return this.center.copy(t1.center), this.radius = t1.radius, this;
            }
            isEmpty() {
                return this.radius < 0;
            }
            makeEmpty() {
                return this.center.set(0, 0, 0), this.radius = -1, this;
            }
            containsPoint(t1) {
                return t1.distanceToSquared(this.center) <= this.radius * this.radius;
            }
            distanceToPoint(t1) {
                return t1.distanceTo(this.center) - this.radius;
            }
            intersectsSphere(t1) {
                const e = this.radius + t1.radius;
                return t1.center.distanceToSquared(this.center) <= e * e;
            }
            intersectsBox(t1) {
                return t1.intersectsSphere(this);
            }
            intersectsPlane(t1) {
                return Math.abs(t1.distanceToPoint(this.center)) <= this.radius;
            }
            clampPoint(t1, e) {
                const i = this.center.distanceToSquared(t1);
                return e.copy(t1), i > this.radius * this.radius && (e.sub(this.center).normalize(), e.multiplyScalar(this.radius).add(this.center)), e;
            }
            getBoundingBox(t1) {
                return this.isEmpty() ? (t1.makeEmpty(), t1) : (t1.set(this.center, this.center), t1.expandByScalar(this.radius), t1);
            }
            applyMatrix4(t1) {
                return this.center.applyMatrix4(t1), this.radius = this.radius * t1.getMaxScaleOnAxis(), this;
            }
            translate(t1) {
                return this.center.add(t1), this;
            }
            expandByPoint(t1) {
                if (this.isEmpty()) return this.center.copy(t1), this.radius = 0, this;
                Xl.subVectors(t1, this.center);
                const e = Xl.lengthSq();
                if (e > this.radius * this.radius) {
                    const t1 = Math.sqrt(e), i = .5 * (t1 - this.radius);
                    this.center.addScaledVector(Xl, i / t1), this.radius += i;
                }
                return this;
            }
            union(t1) {
                return t1.isEmpty() ? this : this.isEmpty() ? (this.copy(t1), this) : (!0 === this.center.equals(t1.center) ? this.radius = Math.max(this.radius, t1.radius) : (Zl.subVectors(t1.center, this.center).setLength(t1.radius), this.expandByPoint(Xl.copy(t1.center).add(Zl)), this.expandByPoint(Xl.copy(t1.center).sub(Zl))), this);
            }
            equals(t1) {
                return t1.center.equals(this.center) && t1.radius === this.radius;
            }
            clone() {
                return (new this.constructor).copy(this);
            }
        }
        const Jl = new Nl, Kl = new Nl, $l = new Nl, tc = new Nl, ec = new Nl, ic = new Nl, nc = new Nl;
        class rc {
            constructor(t1 = new Nl, e = new Nl(0, 0, -1)){
                this.origin = t1, this.direction = e;
            }
            set(t1, e) {
                return this.origin.copy(t1), this.direction.copy(e), this;
            }
            copy(t1) {
                return this.origin.copy(t1.origin), this.direction.copy(t1.direction), this;
            }
            at(t1, e) {
                return e.copy(this.origin).addScaledVector(this.direction, t1);
            }
            lookAt(t1) {
                return this.direction.copy(t1).sub(this.origin).normalize(), this;
            }
            recast(t1) {
                return this.origin.copy(this.at(t1, Jl)), this;
            }
            closestPointToPoint(t1, e) {
                e.subVectors(t1, this.origin);
                const i = e.dot(this.direction);
                return i < 0 ? e.copy(this.origin) : e.copy(this.origin).addScaledVector(this.direction, i);
            }
            distanceToPoint(t1) {
                return Math.sqrt(this.distanceSqToPoint(t1));
            }
            distanceSqToPoint(t1) {
                const e = Jl.subVectors(t1, this.origin).dot(this.direction);
                return e < 0 ? this.origin.distanceToSquared(t1) : (Jl.copy(this.origin).addScaledVector(this.direction, e), Jl.distanceToSquared(t1));
            }
            distanceSqToSegment(t1, e, i, n) {
                Kl.copy(t1).add(e).multiplyScalar(.5), $l.copy(e).sub(t1).normalize(), tc.copy(this.origin).sub(Kl);
                const r = .5 * t1.distanceTo(e), a = -this.direction.dot($l), s = tc.dot(this.direction), o = -tc.dot($l), l = tc.lengthSq(), c = Math.abs(1 - a * a);
                let u, h, d, p;
                if (c > 0) {
                    if (u = a * o - s, h = a * s - o, p = r * c, u >= 0) {
                        if (h >= -p) {
                            if (h <= p) {
                                const t1 = 1 / c;
                                u *= t1, h *= t1, d = u * (u + a * h + 2 * s) + h * (a * u + h + 2 * o) + l;
                            } else h = r, u = Math.max(0, -(a * h + s)), d = -u * u + h * (h + 2 * o) + l;
                        } else h = -r, u = Math.max(0, -(a * h + s)), d = -u * u + h * (h + 2 * o) + l;
                    } else h <= -p ? (u = Math.max(0, -(-a * r + s)), h = u > 0 ? -r : Math.min(Math.max(-r, -o), r), d = -u * u + h * (h + 2 * o) + l) : h <= p ? (u = 0, h = Math.min(Math.max(-r, -o), r), d = h * (h + 2 * o) + l) : (u = Math.max(0, -(a * r + s)), h = u > 0 ? r : Math.min(Math.max(-r, -o), r), d = -u * u + h * (h + 2 * o) + l);
                } else h = a > 0 ? -r : r, u = Math.max(0, -(a * h + s)), d = -u * u + h * (h + 2 * o) + l;
                return i && i.copy(this.origin).addScaledVector(this.direction, u), n && n.copy(Kl).addScaledVector($l, h), d;
            }
            intersectSphere(t1, e) {
                Jl.subVectors(t1.center, this.origin);
                const i = Jl.dot(this.direction), n = Jl.dot(Jl) - i * i, r = t1.radius * t1.radius;
                if (n > r) return null;
                const a = Math.sqrt(r - n), s = i - a, o = i + a;
                return o < 0 ? null : s < 0 ? this.at(o, e) : this.at(s, e);
            }
            intersectsSphere(t1) {
                return this.distanceSqToPoint(t1.center) <= t1.radius * t1.radius;
            }
            distanceToPlane(t1) {
                const e = t1.normal.dot(this.direction);
                if (0 === e) return 0 === t1.distanceToPoint(this.origin) ? 0 : null;
                const i = -(this.origin.dot(t1.normal) + t1.constant) / e;
                return i >= 0 ? i : null;
            }
            intersectPlane(t1, e) {
                const i = this.distanceToPlane(t1);
                return null === i ? null : this.at(i, e);
            }
            intersectsPlane(t1) {
                const e = t1.distanceToPoint(this.origin);
                return 0 === e || t1.normal.dot(this.direction) * e < 0;
            }
            intersectBox(t1, e) {
                let i, n, r, a, s, o;
                const l = 1 / this.direction.x, c = 1 / this.direction.y, u = 1 / this.direction.z, h = this.origin;
                return l >= 0 ? (i = (t1.min.x - h.x) * l, n = (t1.max.x - h.x) * l) : (i = (t1.max.x - h.x) * l, n = (t1.min.x - h.x) * l), c >= 0 ? (r = (t1.min.y - h.y) * c, a = (t1.max.y - h.y) * c) : (r = (t1.max.y - h.y) * c, a = (t1.min.y - h.y) * c), i > a || r > n ? null : ((r > i || isNaN(i)) && (i = r), (a < n || isNaN(n)) && (n = a), u >= 0 ? (s = (t1.min.z - h.z) * u, o = (t1.max.z - h.z) * u) : (s = (t1.max.z - h.z) * u, o = (t1.min.z - h.z) * u), i > o || s > n ? null : ((s > i || i != i) && (i = s), (o < n || n != n) && (n = o), n < 0 ? null : this.at(i >= 0 ? i : n, e)));
            }
            intersectsBox(t1) {
                return null !== this.intersectBox(t1, Jl);
            }
            intersectTriangle(t1, e, i, n, r) {
                ec.subVectors(e, t1), ic.subVectors(i, t1), nc.crossVectors(ec, ic);
                let a, s = this.direction.dot(nc);
                if (s > 0) {
                    if (n) return null;
                    a = 1;
                } else {
                    if (!(s < 0)) return null;
                    a = -1, s = -s;
                }
                tc.subVectors(this.origin, t1);
                const o = a * this.direction.dot(ic.crossVectors(tc, ic));
                if (o < 0) return null;
                const l = a * this.direction.dot(ec.cross(tc));
                if (l < 0) return null;
                if (o + l > s) return null;
                const c = -a * tc.dot(nc);
                return c < 0 ? null : this.at(c / s, r);
            }
            applyMatrix4(t1) {
                return this.origin.applyMatrix4(t1), this.direction.transformDirection(t1), this;
            }
            equals(t1) {
                return t1.origin.equals(this.origin) && t1.direction.equals(this.direction);
            }
            clone() {
                return (new this.constructor).copy(this);
            }
        }
        class ac {
            constructor(t1, e, i, n, r, a, s, o, l, c, u, h, d, p, A, f){
                ac.prototype.isMatrix4 = !0, this.elements = [
                    1,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    1
                ], void 0 !== t1 && this.set(t1, e, i, n, r, a, s, o, l, c, u, h, d, p, A, f);
            }
            set(t1, e, i, n, r, a, s, o, l, c, u, h, d, p, A, f) {
                const m = this.elements;
                return m[0] = t1, m[4] = e, m[8] = i, m[12] = n, m[1] = r, m[5] = a, m[9] = s, m[13] = o, m[2] = l, m[6] = c, m[10] = u, m[14] = h, m[3] = d, m[7] = p, m[11] = A, m[15] = f, this;
            }
            identity() {
                return this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
            }
            clone() {
                return (new ac).fromArray(this.elements);
            }
            copy(t1) {
                const e = this.elements, i = t1.elements;
                return e[0] = i[0], e[1] = i[1], e[2] = i[2], e[3] = i[3], e[4] = i[4], e[5] = i[5], e[6] = i[6], e[7] = i[7], e[8] = i[8], e[9] = i[9], e[10] = i[10], e[11] = i[11], e[12] = i[12], e[13] = i[13], e[14] = i[14], e[15] = i[15], this;
            }
            copyPosition(t1) {
                const e = this.elements, i = t1.elements;
                return e[12] = i[12], e[13] = i[13], e[14] = i[14], this;
            }
            setFromMatrix3(t1) {
                const e = t1.elements;
                return this.set(e[0], e[3], e[6], 0, e[1], e[4], e[7], 0, e[2], e[5], e[8], 0, 0, 0, 0, 1), this;
            }
            extractBasis(t1, e, i) {
                return t1.setFromMatrixColumn(this, 0), e.setFromMatrixColumn(this, 1), i.setFromMatrixColumn(this, 2), this;
            }
            makeBasis(t1, e, i) {
                return this.set(t1.x, e.x, i.x, 0, t1.y, e.y, i.y, 0, t1.z, e.z, i.z, 0, 0, 0, 0, 1), this;
            }
            extractRotation(t1) {
                const e = this.elements, i = t1.elements, n = 1 / sc.setFromMatrixColumn(t1, 0).length(), r = 1 / sc.setFromMatrixColumn(t1, 1).length(), a = 1 / sc.setFromMatrixColumn(t1, 2).length();
                return e[0] = i[0] * n, e[1] = i[1] * n, e[2] = i[2] * n, e[3] = 0, e[4] = i[4] * r, e[5] = i[5] * r, e[6] = i[6] * r, e[7] = 0, e[8] = i[8] * a, e[9] = i[9] * a, e[10] = i[10] * a, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, this;
            }
            makeRotationFromEuler(t1) {
                const e = this.elements, i = t1.x, n = t1.y, r = t1.z, a = Math.cos(i), s = Math.sin(i), o = Math.cos(n), l = Math.sin(n), c = Math.cos(r), u = Math.sin(r);
                if ("XYZ" === t1.order) {
                    const t1 = a * c, i = a * u, n = s * c, r = s * u;
                    e[0] = o * c, e[4] = -o * u, e[8] = l, e[1] = i + n * l, e[5] = t1 - r * l, e[9] = -s * o, e[2] = r - t1 * l, e[6] = n + i * l, e[10] = a * o;
                } else if ("YXZ" === t1.order) {
                    const t1 = o * c, i = o * u, n = l * c, r = l * u;
                    e[0] = t1 + r * s, e[4] = n * s - i, e[8] = a * l, e[1] = a * u, e[5] = a * c, e[9] = -s, e[2] = i * s - n, e[6] = r + t1 * s, e[10] = a * o;
                } else if ("ZXY" === t1.order) {
                    const t1 = o * c, i = o * u, n = l * c, r = l * u;
                    e[0] = t1 - r * s, e[4] = -a * u, e[8] = n + i * s, e[1] = i + n * s, e[5] = a * c, e[9] = r - t1 * s, e[2] = -a * l, e[6] = s, e[10] = a * o;
                } else if ("ZYX" === t1.order) {
                    const t1 = a * c, i = a * u, n = s * c, r = s * u;
                    e[0] = o * c, e[4] = n * l - i, e[8] = t1 * l + r, e[1] = o * u, e[5] = r * l + t1, e[9] = i * l - n, e[2] = -l, e[6] = s * o, e[10] = a * o;
                } else if ("YZX" === t1.order) {
                    const t1 = a * o, i = a * l, n = s * o, r = s * l;
                    e[0] = o * c, e[4] = r - t1 * u, e[8] = n * u + i, e[1] = u, e[5] = a * c, e[9] = -s * c, e[2] = -l * c, e[6] = i * u + n, e[10] = t1 - r * u;
                } else if ("XZY" === t1.order) {
                    const t1 = a * o, i = a * l, n = s * o, r = s * l;
                    e[0] = o * c, e[4] = -u, e[8] = l * c, e[1] = t1 * u + r, e[5] = a * c, e[9] = i * u - n, e[2] = n * u - i, e[6] = s * c, e[10] = r * u + t1;
                }
                return e[3] = 0, e[7] = 0, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, this;
            }
            makeRotationFromQuaternion(t1) {
                return this.compose(lc, t1, cc);
            }
            lookAt(t1, e, i) {
                const n = this.elements;
                return dc.subVectors(t1, e), 0 === dc.lengthSq() && (dc.z = 1), dc.normalize(), uc.crossVectors(i, dc), 0 === uc.lengthSq() && (1 === Math.abs(i.z) ? dc.x += 1e-4 : dc.z += 1e-4, dc.normalize(), uc.crossVectors(i, dc)), uc.normalize(), hc.crossVectors(dc, uc), n[0] = uc.x, n[4] = hc.x, n[8] = dc.x, n[1] = uc.y, n[5] = hc.y, n[9] = dc.y, n[2] = uc.z, n[6] = hc.z, n[10] = dc.z, this;
            }
            multiply(t1) {
                return this.multiplyMatrices(this, t1);
            }
            premultiply(t1) {
                return this.multiplyMatrices(t1, this);
            }
            multiplyMatrices(t1, e) {
                const i = t1.elements, n = e.elements, r = this.elements, a = i[0], s = i[4], o = i[8], l = i[12], c = i[1], u = i[5], h = i[9], d = i[13], p = i[2], A = i[6], f = i[10], m = i[14], g = i[3], M = i[7], v = i[11], y = i[15], x = n[0], w = n[4], b = n[8], T = n[12], E = n[1], _ = n[5], I = n[9], S = n[13], N = n[2], D = n[6], C = n[10], z = n[14], L = n[3], O = n[7], P = n[11], j = n[15];
                return r[0] = a * x + s * E + o * N + l * L, r[4] = a * w + s * _ + o * D + l * O, r[8] = a * b + s * I + o * C + l * P, r[12] = a * T + s * S + o * z + l * j, r[1] = c * x + u * E + h * N + d * L, r[5] = c * w + u * _ + h * D + d * O, r[9] = c * b + u * I + h * C + d * P, r[13] = c * T + u * S + h * z + d * j, r[2] = p * x + A * E + f * N + m * L, r[6] = p * w + A * _ + f * D + m * O, r[10] = p * b + A * I + f * C + m * P, r[14] = p * T + A * S + f * z + m * j, r[3] = g * x + M * E + v * N + y * L, r[7] = g * w + M * _ + v * D + y * O, r[11] = g * b + M * I + v * C + y * P, r[15] = g * T + M * S + v * z + y * j, this;
            }
            multiplyScalar(t1) {
                const e = this.elements;
                return e[0] *= t1, e[4] *= t1, e[8] *= t1, e[12] *= t1, e[1] *= t1, e[5] *= t1, e[9] *= t1, e[13] *= t1, e[2] *= t1, e[6] *= t1, e[10] *= t1, e[14] *= t1, e[3] *= t1, e[7] *= t1, e[11] *= t1, e[15] *= t1, this;
            }
            determinant() {
                const t1 = this.elements, e = t1[0], i = t1[4], n = t1[8], r = t1[12], a = t1[1], s = t1[5], o = t1[9], l = t1[13], c = t1[2], u = t1[6], h = t1[10], d = t1[14];
                return t1[3] * (+r * o * u - n * l * u - r * s * h + i * l * h + n * s * d - i * o * d) + t1[7] * (+e * o * d - e * l * h + r * a * h - n * a * d + n * l * c - r * o * c) + t1[11] * (+e * l * u - e * s * d - r * a * u + i * a * d + r * s * c - i * l * c) + t1[15] * (-n * s * c - e * o * u + e * s * h + n * a * u - i * a * h + i * o * c);
            }
            transpose() {
                const t1 = this.elements;
                let e;
                return e = t1[1], t1[1] = t1[4], t1[4] = e, e = t1[2], t1[2] = t1[8], t1[8] = e, e = t1[6], t1[6] = t1[9], t1[9] = e, e = t1[3], t1[3] = t1[12], t1[12] = e, e = t1[7], t1[7] = t1[13], t1[13] = e, e = t1[11], t1[11] = t1[14], t1[14] = e, this;
            }
            setPosition(t1, e, i) {
                const n = this.elements;
                return t1.isVector3 ? (n[12] = t1.x, n[13] = t1.y, n[14] = t1.z) : (n[12] = t1, n[13] = e, n[14] = i), this;
            }
            invert() {
                const t1 = this.elements, e = t1[0], i = t1[1], n = t1[2], r = t1[3], a = t1[4], s = t1[5], o = t1[6], l = t1[7], c = t1[8], u = t1[9], h = t1[10], d = t1[11], p = t1[12], A = t1[13], f = t1[14], m = t1[15], g = u * f * l - A * h * l + A * o * d - s * f * d - u * o * m + s * h * m, M = p * h * l - c * f * l - p * o * d + a * f * d + c * o * m - a * h * m, v = c * A * l - p * u * l + p * s * d - a * A * d - c * s * m + a * u * m, y = p * u * o - c * A * o - p * s * h + a * A * h + c * s * f - a * u * f, x = e * g + i * M + n * v + r * y;
                if (0 === x) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
                const w = 1 / x;
                return t1[0] = g * w, t1[1] = (A * h * r - u * f * r - A * n * d + i * f * d + u * n * m - i * h * m) * w, t1[2] = (s * f * r - A * o * r + A * n * l - i * f * l - s * n * m + i * o * m) * w, t1[3] = (u * o * r - s * h * r - u * n * l + i * h * l + s * n * d - i * o * d) * w, t1[4] = M * w, t1[5] = (c * f * r - p * h * r + p * n * d - e * f * d - c * n * m + e * h * m) * w, t1[6] = (p * o * r - a * f * r - p * n * l + e * f * l + a * n * m - e * o * m) * w, t1[7] = (a * h * r - c * o * r + c * n * l - e * h * l - a * n * d + e * o * d) * w, t1[8] = v * w, t1[9] = (p * u * r - c * A * r - p * i * d + e * A * d + c * i * m - e * u * m) * w, t1[10] = (a * A * r - p * s * r + p * i * l - e * A * l - a * i * m + e * s * m) * w, t1[11] = (c * s * r - a * u * r - c * i * l + e * u * l + a * i * d - e * s * d) * w, t1[12] = y * w, t1[13] = (c * A * n - p * u * n + p * i * h - e * A * h - c * i * f + e * u * f) * w, t1[14] = (p * s * n - a * A * n - p * i * o + e * A * o + a * i * f - e * s * f) * w, t1[15] = (a * u * n - c * s * n + c * i * o - e * u * o - a * i * h + e * s * h) * w, this;
            }
            scale(t1) {
                const e = this.elements, i = t1.x, n = t1.y, r = t1.z;
                return e[0] *= i, e[4] *= n, e[8] *= r, e[1] *= i, e[5] *= n, e[9] *= r, e[2] *= i, e[6] *= n, e[10] *= r, e[3] *= i, e[7] *= n, e[11] *= r, this;
            }
            getMaxScaleOnAxis() {
                const t1 = this.elements, e = t1[0] * t1[0] + t1[1] * t1[1] + t1[2] * t1[2], i = t1[4] * t1[4] + t1[5] * t1[5] + t1[6] * t1[6], n = t1[8] * t1[8] + t1[9] * t1[9] + t1[10] * t1[10];
                return Math.sqrt(Math.max(e, i, n));
            }
            makeTranslation(t1, e, i) {
                return t1.isVector3 ? this.set(1, 0, 0, t1.x, 0, 1, 0, t1.y, 0, 0, 1, t1.z, 0, 0, 0, 1) : this.set(1, 0, 0, t1, 0, 1, 0, e, 0, 0, 1, i, 0, 0, 0, 1), this;
            }
            makeRotationX(t1) {
                const e = Math.cos(t1), i = Math.sin(t1);
                return this.set(1, 0, 0, 0, 0, e, -i, 0, 0, i, e, 0, 0, 0, 0, 1), this;
            }
            makeRotationY(t1) {
                const e = Math.cos(t1), i = Math.sin(t1);
                return this.set(e, 0, i, 0, 0, 1, 0, 0, -i, 0, e, 0, 0, 0, 0, 1), this;
            }
            makeRotationZ(t1) {
                const e = Math.cos(t1), i = Math.sin(t1);
                return this.set(e, -i, 0, 0, i, e, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
            }
            makeRotationAxis(t1, e) {
                const i = Math.cos(e), n = Math.sin(e), r = 1 - i, a = t1.x, s = t1.y, o = t1.z, l = r * a, c = r * s;
                return this.set(l * a + i, l * s - n * o, l * o + n * s, 0, l * s + n * o, c * s + i, c * o - n * a, 0, l * o - n * s, c * o + n * a, r * o * o + i, 0, 0, 0, 0, 1), this;
            }
            makeScale(t1, e, i) {
                return this.set(t1, 0, 0, 0, 0, e, 0, 0, 0, 0, i, 0, 0, 0, 0, 1), this;
            }
            makeShear(t1, e, i, n, r, a) {
                return this.set(1, i, r, 0, t1, 1, a, 0, e, n, 1, 0, 0, 0, 0, 1), this;
            }
            compose(t1, e, i) {
                const n = this.elements, r = e._x, a = e._y, s = e._z, o = e._w, l = r + r, c = a + a, u = s + s, h = r * l, d = r * c, p = r * u, A = a * c, f = a * u, m = s * u, g = o * l, M = o * c, v = o * u, y = i.x, x = i.y, w = i.z;
                return n[0] = (1 - (A + m)) * y, n[1] = (d + v) * y, n[2] = (p - M) * y, n[3] = 0, n[4] = (d - v) * x, n[5] = (1 - (h + m)) * x, n[6] = (f + g) * x, n[7] = 0, n[8] = (p + M) * w, n[9] = (f - g) * w, n[10] = (1 - (h + A)) * w, n[11] = 0, n[12] = t1.x, n[13] = t1.y, n[14] = t1.z, n[15] = 1, this;
            }
            decompose(t1, e, i) {
                const n = this.elements;
                let r = sc.set(n[0], n[1], n[2]).length();
                const a = sc.set(n[4], n[5], n[6]).length(), s = sc.set(n[8], n[9], n[10]).length();
                this.determinant() < 0 && (r = -r), t1.x = n[12], t1.y = n[13], t1.z = n[14], oc.copy(this);
                const o = 1 / r, l = 1 / a, c = 1 / s;
                return oc.elements[0] *= o, oc.elements[1] *= o, oc.elements[2] *= o, oc.elements[4] *= l, oc.elements[5] *= l, oc.elements[6] *= l, oc.elements[8] *= c, oc.elements[9] *= c, oc.elements[10] *= c, e.setFromRotationMatrix(oc), i.x = r, i.y = a, i.z = s, this;
            }
            makePerspective(t1, e, i, n, r, a, s = Lo) {
                const o = this.elements, l = 2 * r / (e - t1), c = 2 * r / (i - n), u = (e + t1) / (e - t1), h = (i + n) / (i - n);
                let d, p;
                if (s === Lo) d = -(a + r) / (a - r), p = -2 * a * r / (a - r);
                else {
                    if (s !== Oo) throw new Error("THREE.Matrix4.makePerspective(): Invalid coordinate system: " + s);
                    d = -a / (a - r), p = -a * r / (a - r);
                }
                return o[0] = l, o[4] = 0, o[8] = u, o[12] = 0, o[1] = 0, o[5] = c, o[9] = h, o[13] = 0, o[2] = 0, o[6] = 0, o[10] = d, o[14] = p, o[3] = 0, o[7] = 0, o[11] = -1, o[15] = 0, this;
            }
            makeOrthographic(t1, e, i, n, r, a, s = Lo) {
                const o = this.elements, l = 1 / (e - t1), c = 1 / (i - n), u = 1 / (a - r), h = (e + t1) * l, d = (i + n) * c;
                let p, A;
                if (s === Lo) p = (a + r) * u, A = -2 * u;
                else {
                    if (s !== Oo) throw new Error("THREE.Matrix4.makeOrthographic(): Invalid coordinate system: " + s);
                    p = r * u, A = -1 * u;
                }
                return o[0] = 2 * l, o[4] = 0, o[8] = 0, o[12] = -h, o[1] = 0, o[5] = 2 * c, o[9] = 0, o[13] = -d, o[2] = 0, o[6] = 0, o[10] = A, o[14] = -p, o[3] = 0, o[7] = 0, o[11] = 0, o[15] = 1, this;
            }
            equals(t1) {
                const e = this.elements, i = t1.elements;
                for(let t1 = 0; t1 < 16; t1++)if (e[t1] !== i[t1]) return !1;
                return !0;
            }
            fromArray(t1, e = 0) {
                for(let i = 0; i < 16; i++)this.elements[i] = t1[i + e];
                return this;
            }
            toArray(t1 = [], e = 0) {
                const i = this.elements;
                return t1[e] = i[0], t1[e + 1] = i[1], t1[e + 2] = i[2], t1[e + 3] = i[3], t1[e + 4] = i[4], t1[e + 5] = i[5], t1[e + 6] = i[6], t1[e + 7] = i[7], t1[e + 8] = i[8], t1[e + 9] = i[9], t1[e + 10] = i[10], t1[e + 11] = i[11], t1[e + 12] = i[12], t1[e + 13] = i[13], t1[e + 14] = i[14], t1[e + 15] = i[15], t1;
            }
        }
        const sc = new Nl, oc = new ac, lc = new Nl(0, 0, 0), cc = new Nl(1, 1, 1), uc = new Nl, hc = new Nl, dc = new Nl, pc = new ac, Ac = new Sl;
        class fc {
            constructor(t1 = 0, e = 0, i = 0, n = fc.DEFAULT_ORDER){
                this.isEuler = !0, this._x = t1, this._y = e, this._z = i, this._order = n;
            }
            get x() {
                return this._x;
            }
            set x(t1) {
                this._x = t1, this._onChangeCallback();
            }
            get y() {
                return this._y;
            }
            set y(t1) {
                this._y = t1, this._onChangeCallback();
            }
            get z() {
                return this._z;
            }
            set z(t1) {
                this._z = t1, this._onChangeCallback();
            }
            get order() {
                return this._order;
            }
            set order(t1) {
                this._order = t1, this._onChangeCallback();
            }
            set(t1, e, i, n = this._order) {
                return this._x = t1, this._y = e, this._z = i, this._order = n, this._onChangeCallback(), this;
            }
            clone() {
                return new this.constructor(this._x, this._y, this._z, this._order);
            }
            copy(t1) {
                return this._x = t1._x, this._y = t1._y, this._z = t1._z, this._order = t1._order, this._onChangeCallback(), this;
            }
            setFromRotationMatrix(t1, e = this._order, i = !0) {
                const n = t1.elements, r = n[0], a = n[4], s = n[8], o = n[1], l = n[5], c = n[9], u = n[2], h = n[6], d = n[10];
                switch(e){
                    case "XYZ":
                        this._y = Math.asin(Fo(s, -1, 1)), Math.abs(s) < .9999999 ? (this._x = Math.atan2(-c, d), this._z = Math.atan2(-a, r)) : (this._x = Math.atan2(h, l), this._z = 0);
                        break;
                    case "YXZ":
                        this._x = Math.asin(-Fo(c, -1, 1)), Math.abs(c) < .9999999 ? (this._y = Math.atan2(s, d), this._z = Math.atan2(o, l)) : (this._y = Math.atan2(-u, r), this._z = 0);
                        break;
                    case "ZXY":
                        this._x = Math.asin(Fo(h, -1, 1)), Math.abs(h) < .9999999 ? (this._y = Math.atan2(-u, d), this._z = Math.atan2(-a, l)) : (this._y = 0, this._z = Math.atan2(o, r));
                        break;
                    case "ZYX":
                        this._y = Math.asin(-Fo(u, -1, 1)), Math.abs(u) < .9999999 ? (this._x = Math.atan2(h, d), this._z = Math.atan2(o, r)) : (this._x = 0, this._z = Math.atan2(-a, l));
                        break;
                    case "YZX":
                        this._z = Math.asin(Fo(o, -1, 1)), Math.abs(o) < .9999999 ? (this._x = Math.atan2(-c, l), this._y = Math.atan2(-u, r)) : (this._x = 0, this._y = Math.atan2(s, d));
                        break;
                    case "XZY":
                        this._z = Math.asin(-Fo(a, -1, 1)), Math.abs(a) < .9999999 ? (this._x = Math.atan2(h, l), this._y = Math.atan2(s, r)) : (this._x = Math.atan2(-c, d), this._y = 0);
                        break;
                    default:
                        console.warn("THREE.Euler: .setFromRotationMatrix() encountered an unknown order: " + e);
                }
                return this._order = e, !0 === i && this._onChangeCallback(), this;
            }
            setFromQuaternion(t1, e, i) {
                return pc.makeRotationFromQuaternion(t1), this.setFromRotationMatrix(pc, e, i);
            }
            setFromVector3(t1, e = this._order) {
                return this.set(t1.x, t1.y, t1.z, e);
            }
            reorder(t1) {
                return Ac.setFromEuler(this), this.setFromQuaternion(Ac, t1);
            }
            equals(t1) {
                return t1._x === this._x && t1._y === this._y && t1._z === this._z && t1._order === this._order;
            }
            fromArray(t1) {
                return this._x = t1[0], this._y = t1[1], this._z = t1[2], void 0 !== t1[3] && (this._order = t1[3]), this._onChangeCallback(), this;
            }
            toArray(t1 = [], e = 0) {
                return t1[e] = this._x, t1[e + 1] = this._y, t1[e + 2] = this._z, t1[e + 3] = this._order, t1;
            }
            _onChange(t1) {
                return this._onChangeCallback = t1, this;
            }
            _onChangeCallback() {}
            *[Symbol.iterator]() {
                yield this._x, yield this._y, yield this._z, yield this._order;
            }
        }
        fc.DEFAULT_ORDER = "XYZ";
        class mc {
            constructor(){
                this.mask = 1;
            }
            set(t1) {
                this.mask = 1 << t1 >>> 0;
            }
            enable(t1) {
                this.mask |= 1 << t1;
            }
            enableAll() {
                this.mask = -1;
            }
            toggle(t1) {
                this.mask ^= 1 << t1;
            }
            disable(t1) {
                this.mask &= ~(1 << t1);
            }
            disableAll() {
                this.mask = 0;
            }
            test(t1) {
                return !!(this.mask & t1.mask);
            }
            isEnabled(t1) {
                return !!(this.mask & 1 << t1);
            }
        }
        let gc = 0;
        const Mc = new Nl, vc = new Sl, yc = new ac, xc = new Nl, wc = new Nl, bc = new Nl, Tc = new Sl, Ec = new Nl(1, 0, 0), _c = new Nl(0, 1, 0), Ic = new Nl(0, 0, 1), Sc = {
            type: "added"
        }, Nc = {
            type: "removed"
        };
        class Dc extends Po {
            constructor(){
                super(), this.isObject3D = !0, Object.defineProperty(this, "id", {
                    value: gc++
                }), this.uuid = Bo(), this.name = "", this.type = "Object3D", this.parent = null, this.children = [], this.up = Dc.DEFAULT_UP.clone();
                const t1 = new Nl, e = new fc, i = new Sl, n = new Nl(1, 1, 1);
                e._onChange(function() {
                    i.setFromEuler(e, !1);
                }), i._onChange(function() {
                    e.setFromQuaternion(i, void 0, !1);
                }), Object.defineProperties(this, {
                    position: {
                        configurable: !0,
                        enumerable: !0,
                        value: t1
                    },
                    rotation: {
                        configurable: !0,
                        enumerable: !0,
                        value: e
                    },
                    quaternion: {
                        configurable: !0,
                        enumerable: !0,
                        value: i
                    },
                    scale: {
                        configurable: !0,
                        enumerable: !0,
                        value: n
                    },
                    modelViewMatrix: {
                        value: new ac
                    },
                    normalMatrix: {
                        value: new Jo
                    }
                }), this.matrix = new ac, this.matrixWorld = new ac, this.matrixAutoUpdate = Dc.DEFAULT_MATRIX_AUTO_UPDATE, this.matrixWorldNeedsUpdate = !1, this.matrixWorldAutoUpdate = Dc.DEFAULT_MATRIX_WORLD_AUTO_UPDATE, this.layers = new mc, this.visible = !0, this.castShadow = !1, this.receiveShadow = !1, this.frustumCulled = !0, this.renderOrder = 0, this.animations = [], this.userData = {};
            }
            onBeforeRender() {}
            onAfterRender() {}
            applyMatrix4(t1) {
                this.matrixAutoUpdate && this.updateMatrix(), this.matrix.premultiply(t1), this.matrix.decompose(this.position, this.quaternion, this.scale);
            }
            applyQuaternion(t1) {
                return this.quaternion.premultiply(t1), this;
            }
            setRotationFromAxisAngle(t1, e) {
                this.quaternion.setFromAxisAngle(t1, e);
            }
            setRotationFromEuler(t1) {
                this.quaternion.setFromEuler(t1, !0);
            }
            setRotationFromMatrix(t1) {
                this.quaternion.setFromRotationMatrix(t1);
            }
            setRotationFromQuaternion(t1) {
                this.quaternion.copy(t1);
            }
            rotateOnAxis(t1, e) {
                return vc.setFromAxisAngle(t1, e), this.quaternion.multiply(vc), this;
            }
            rotateOnWorldAxis(t1, e) {
                return vc.setFromAxisAngle(t1, e), this.quaternion.premultiply(vc), this;
            }
            rotateX(t1) {
                return this.rotateOnAxis(Ec, t1);
            }
            rotateY(t1) {
                return this.rotateOnAxis(_c, t1);
            }
            rotateZ(t1) {
                return this.rotateOnAxis(Ic, t1);
            }
            translateOnAxis(t1, e) {
                return Mc.copy(t1).applyQuaternion(this.quaternion), this.position.add(Mc.multiplyScalar(e)), this;
            }
            translateX(t1) {
                return this.translateOnAxis(Ec, t1);
            }
            translateY(t1) {
                return this.translateOnAxis(_c, t1);
            }
            translateZ(t1) {
                return this.translateOnAxis(Ic, t1);
            }
            localToWorld(t1) {
                return this.updateWorldMatrix(!0, !1), t1.applyMatrix4(this.matrixWorld);
            }
            worldToLocal(t1) {
                return this.updateWorldMatrix(!0, !1), t1.applyMatrix4(yc.copy(this.matrixWorld).invert());
            }
            lookAt(t1, e, i) {
                t1.isVector3 ? xc.copy(t1) : xc.set(t1, e, i);
                const n = this.parent;
                this.updateWorldMatrix(!0, !1), wc.setFromMatrixPosition(this.matrixWorld), this.isCamera || this.isLight ? yc.lookAt(wc, xc, this.up) : yc.lookAt(xc, wc, this.up), this.quaternion.setFromRotationMatrix(yc), n && (yc.extractRotation(n.matrixWorld), vc.setFromRotationMatrix(yc), this.quaternion.premultiply(vc.invert()));
            }
            add(t1) {
                if (arguments.length > 1) {
                    for(let t1 = 0; t1 < arguments.length; t1++)this.add(arguments[t1]);
                    return this;
                }
                return t1 === this ? (console.error("THREE.Object3D.add: object can't be added as a child of itself.", t1), this) : (t1 && t1.isObject3D ? (null !== t1.parent && t1.parent.remove(t1), t1.parent = this, this.children.push(t1), t1.dispatchEvent(Sc)) : console.error("THREE.Object3D.add: object not an instance of THREE.Object3D.", t1), this);
            }
            remove(t1) {
                if (arguments.length > 1) {
                    for(let t1 = 0; t1 < arguments.length; t1++)this.remove(arguments[t1]);
                    return this;
                }
                const e = this.children.indexOf(t1);
                return -1 !== e && (t1.parent = null, this.children.splice(e, 1), t1.dispatchEvent(Nc)), this;
            }
            removeFromParent() {
                const t1 = this.parent;
                return null !== t1 && t1.remove(this), this;
            }
            clear() {
                return this.remove(...this.children);
            }
            attach(t1) {
                return this.updateWorldMatrix(!0, !1), yc.copy(this.matrixWorld).invert(), null !== t1.parent && (t1.parent.updateWorldMatrix(!0, !1), yc.multiply(t1.parent.matrixWorld)), t1.applyMatrix4(yc), this.add(t1), t1.updateWorldMatrix(!1, !0), this;
            }
            getObjectById(t1) {
                return this.getObjectByProperty("id", t1);
            }
            getObjectByName(t1) {
                return this.getObjectByProperty("name", t1);
            }
            getObjectByProperty(t1, e) {
                if (this[t1] === e) return this;
                for(let i = 0, n = this.children.length; i < n; i++){
                    const n = this.children[i].getObjectByProperty(t1, e);
                    if (void 0 !== n) return n;
                }
            }
            getObjectsByProperty(t1, e) {
                let i = [];
                this[t1] === e && i.push(this);
                for(let n = 0, r = this.children.length; n < r; n++){
                    const r = this.children[n].getObjectsByProperty(t1, e);
                    r.length > 0 && (i = i.concat(r));
                }
                return i;
            }
            getWorldPosition(t1) {
                return this.updateWorldMatrix(!0, !1), t1.setFromMatrixPosition(this.matrixWorld);
            }
            getWorldQuaternion(t1) {
                return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose(wc, t1, bc), t1;
            }
            getWorldScale(t1) {
                return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose(wc, Tc, t1), t1;
            }
            getWorldDirection(t1) {
                this.updateWorldMatrix(!0, !1);
                const e = this.matrixWorld.elements;
                return t1.set(e[8], e[9], e[10]).normalize();
            }
            raycast() {}
            traverse(t1) {
                t1(this);
                const e = this.children;
                for(let i = 0, n = e.length; i < n; i++)e[i].traverse(t1);
            }
            traverseVisible(t1) {
                if (!1 === this.visible) return;
                t1(this);
                const e = this.children;
                for(let i = 0, n = e.length; i < n; i++)e[i].traverseVisible(t1);
            }
            traverseAncestors(t1) {
                const e = this.parent;
                null !== e && (t1(e), e.traverseAncestors(t1));
            }
            updateMatrix() {
                this.matrix.compose(this.position, this.quaternion, this.scale), this.matrixWorldNeedsUpdate = !0;
            }
            updateMatrixWorld(t1) {
                this.matrixAutoUpdate && this.updateMatrix(), (this.matrixWorldNeedsUpdate || t1) && (null === this.parent ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix), this.matrixWorldNeedsUpdate = !1, t1 = !0);
                const e = this.children;
                for(let i = 0, n = e.length; i < n; i++){
                    const n = e[i];
                    !0 !== n.matrixWorldAutoUpdate && !0 !== t1 || n.updateMatrixWorld(t1);
                }
            }
            updateWorldMatrix(t1, e) {
                const i = this.parent;
                if (!0 === t1 && null !== i && !0 === i.matrixWorldAutoUpdate && i.updateWorldMatrix(!0, !1), this.matrixAutoUpdate && this.updateMatrix(), null === this.parent ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix), !0 === e) {
                    const t1 = this.children;
                    for(let e = 0, i = t1.length; e < i; e++){
                        const i = t1[e];
                        !0 === i.matrixWorldAutoUpdate && i.updateWorldMatrix(!1, !0);
                    }
                }
            }
            toJSON(t1) {
                const e = void 0 === t1 || "string" == typeof t1, i = {};
                e && (t1 = {
                    geometries: {},
                    materials: {},
                    textures: {},
                    images: {},
                    shapes: {},
                    skeletons: {},
                    animations: {},
                    nodes: {}
                }, i.metadata = {
                    version: 4.6,
                    type: "Object",
                    generator: "Object3D.toJSON"
                });
                const n = {};
                function r(e, i) {
                    return void 0 === e[i.uuid] && (e[i.uuid] = i.toJSON(t1)), i.uuid;
                }
                if (n.uuid = this.uuid, n.type = this.type, "" !== this.name && (n.name = this.name), !0 === this.castShadow && (n.castShadow = !0), !0 === this.receiveShadow && (n.receiveShadow = !0), !1 === this.visible && (n.visible = !1), !1 === this.frustumCulled && (n.frustumCulled = !1), 0 !== this.renderOrder && (n.renderOrder = this.renderOrder), Object.keys(this.userData).length > 0 && (n.userData = this.userData), n.layers = this.layers.mask, n.matrix = this.matrix.toArray(), n.up = this.up.toArray(), !1 === this.matrixAutoUpdate && (n.matrixAutoUpdate = !1), this.isInstancedMesh && (n.type = "InstancedMesh", n.count = this.count, n.instanceMatrix = this.instanceMatrix.toJSON(), null !== this.instanceColor && (n.instanceColor = this.instanceColor.toJSON())), this.isScene) this.background && (this.background.isColor ? n.background = this.background.toJSON() : this.background.isTexture && (n.background = this.background.toJSON(t1).uuid)), this.environment && this.environment.isTexture && !0 !== this.environment.isRenderTargetTexture && (n.environment = this.environment.toJSON(t1).uuid);
                else if (this.isMesh || this.isLine || this.isPoints) {
                    n.geometry = r(t1.geometries, this.geometry);
                    const e = this.geometry.parameters;
                    if (void 0 !== e && void 0 !== e.shapes) {
                        const i = e.shapes;
                        if (Array.isArray(i)) for(let e = 0, n = i.length; e < n; e++){
                            const n = i[e];
                            r(t1.shapes, n);
                        }
                        else r(t1.shapes, i);
                    }
                }
                if (this.isSkinnedMesh && (n.bindMode = this.bindMode, n.bindMatrix = this.bindMatrix.toArray(), void 0 !== this.skeleton && (r(t1.skeletons, this.skeleton), n.skeleton = this.skeleton.uuid)), void 0 !== this.material) {
                    if (Array.isArray(this.material)) {
                        const e = [];
                        for(let i = 0, n = this.material.length; i < n; i++)e.push(r(t1.materials, this.material[i]));
                        n.material = e;
                    } else n.material = r(t1.materials, this.material);
                }
                if (this.children.length > 0) {
                    n.children = [];
                    for(let e = 0; e < this.children.length; e++)n.children.push(this.children[e].toJSON(t1).object);
                }
                if (this.animations.length > 0) {
                    n.animations = [];
                    for(let e = 0; e < this.animations.length; e++){
                        const i = this.animations[e];
                        n.animations.push(r(t1.animations, i));
                    }
                }
                if (e) {
                    const e = a(t1.geometries), n = a(t1.materials), r = a(t1.textures), s = a(t1.images), o = a(t1.shapes), l = a(t1.skeletons), c = a(t1.animations), u = a(t1.nodes);
                    e.length > 0 && (i.geometries = e), n.length > 0 && (i.materials = n), r.length > 0 && (i.textures = r), s.length > 0 && (i.images = s), o.length > 0 && (i.shapes = o), l.length > 0 && (i.skeletons = l), c.length > 0 && (i.animations = c), u.length > 0 && (i.nodes = u);
                }
                return i.object = n, i;
                function a(t1) {
                    const e = [];
                    for(const i in t1){
                        const n = t1[i];
                        delete n.metadata, e.push(n);
                    }
                    return e;
                }
            }
            clone(t1) {
                return (new this.constructor).copy(this, t1);
            }
            copy(t1, e = !0) {
                if (this.name = t1.name, this.up.copy(t1.up), this.position.copy(t1.position), this.rotation.order = t1.rotation.order, this.quaternion.copy(t1.quaternion), this.scale.copy(t1.scale), this.matrix.copy(t1.matrix), this.matrixWorld.copy(t1.matrixWorld), this.matrixAutoUpdate = t1.matrixAutoUpdate, this.matrixWorldNeedsUpdate = t1.matrixWorldNeedsUpdate, this.matrixWorldAutoUpdate = t1.matrixWorldAutoUpdate, this.layers.mask = t1.layers.mask, this.visible = t1.visible, this.castShadow = t1.castShadow, this.receiveShadow = t1.receiveShadow, this.frustumCulled = t1.frustumCulled, this.renderOrder = t1.renderOrder, this.animations = t1.animations.slice(), this.userData = JSON.parse(JSON.stringify(t1.userData)), !0 === e) for(let e = 0; e < t1.children.length; e++){
                    const i = t1.children[e];
                    this.add(i.clone());
                }
                return this;
            }
        }
        Dc.DEFAULT_UP = new Nl(0, 1, 0), Dc.DEFAULT_MATRIX_AUTO_UPDATE = !0, Dc.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = !0;
        const Cc = new Nl, zc = new Nl, Lc = new Nl, Oc = new Nl, Pc = new Nl, jc = new Nl, Rc = new Nl, kc = new Nl, Uc = new Nl, Bc = new Nl;
        let Fc = !1;
        class Qc {
            constructor(t1 = new Nl, e = new Nl, i = new Nl){
                this.a = t1, this.b = e, this.c = i;
            }
            static getNormal(t1, e, i, n) {
                n.subVectors(i, e), Cc.subVectors(t1, e), n.cross(Cc);
                const r = n.lengthSq();
                return r > 0 ? n.multiplyScalar(1 / Math.sqrt(r)) : n.set(0, 0, 0);
            }
            static getBarycoord(t1, e, i, n, r) {
                Cc.subVectors(n, e), zc.subVectors(i, e), Lc.subVectors(t1, e);
                const a = Cc.dot(Cc), s = Cc.dot(zc), o = Cc.dot(Lc), l = zc.dot(zc), c = zc.dot(Lc), u = a * l - s * s;
                if (0 === u) return r.set(-2, -1, -1);
                const h = 1 / u, d = (l * o - s * c) * h, p = (a * c - s * o) * h;
                return r.set(1 - d - p, p, d);
            }
            static containsPoint(t1, e, i, n) {
                return this.getBarycoord(t1, e, i, n, Oc), Oc.x >= 0 && Oc.y >= 0 && Oc.x + Oc.y <= 1;
            }
            static getUV(t1, e, i, n, r, a, s, o) {
                return !1 === Fc && (console.warn("THREE.Triangle.getUV() has been renamed to THREE.Triangle.getInterpolation()."), Fc = !0), this.getInterpolation(t1, e, i, n, r, a, s, o);
            }
            static getInterpolation(t1, e, i, n, r, a, s, o) {
                return this.getBarycoord(t1, e, i, n, Oc), o.setScalar(0), o.addScaledVector(r, Oc.x), o.addScaledVector(a, Oc.y), o.addScaledVector(s, Oc.z), o;
            }
            static isFrontFacing(t1, e, i, n) {
                return Cc.subVectors(i, e), zc.subVectors(t1, e), Cc.cross(zc).dot(n) < 0;
            }
            set(t1, e, i) {
                return this.a.copy(t1), this.b.copy(e), this.c.copy(i), this;
            }
            setFromPointsAndIndices(t1, e, i, n) {
                return this.a.copy(t1[e]), this.b.copy(t1[i]), this.c.copy(t1[n]), this;
            }
            setFromAttributeAndIndices(t1, e, i, n) {
                return this.a.fromBufferAttribute(t1, e), this.b.fromBufferAttribute(t1, i), this.c.fromBufferAttribute(t1, n), this;
            }
            clone() {
                return (new this.constructor).copy(this);
            }
            copy(t1) {
                return this.a.copy(t1.a), this.b.copy(t1.b), this.c.copy(t1.c), this;
            }
            getArea() {
                return Cc.subVectors(this.c, this.b), zc.subVectors(this.a, this.b), .5 * Cc.cross(zc).length();
            }
            getMidpoint(t1) {
                return t1.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
            }
            getNormal(t1) {
                return Qc.getNormal(this.a, this.b, this.c, t1);
            }
            getPlane(t1) {
                return t1.setFromCoplanarPoints(this.a, this.b, this.c);
            }
            getBarycoord(t1, e) {
                return Qc.getBarycoord(t1, this.a, this.b, this.c, e);
            }
            getUV(t1, e, i, n, r) {
                return !1 === Fc && (console.warn("THREE.Triangle.getUV() has been renamed to THREE.Triangle.getInterpolation()."), Fc = !0), Qc.getInterpolation(t1, this.a, this.b, this.c, e, i, n, r);
            }
            getInterpolation(t1, e, i, n, r) {
                return Qc.getInterpolation(t1, this.a, this.b, this.c, e, i, n, r);
            }
            containsPoint(t1) {
                return Qc.containsPoint(t1, this.a, this.b, this.c);
            }
            isFrontFacing(t1) {
                return Qc.isFrontFacing(this.a, this.b, this.c, t1);
            }
            intersectsBox(t1) {
                return t1.intersectsTriangle(this);
            }
            closestPointToPoint(t1, e) {
                const i = this.a, n = this.b, r = this.c;
                let a, s;
                Pc.subVectors(n, i), jc.subVectors(r, i), kc.subVectors(t1, i);
                const o = Pc.dot(kc), l = jc.dot(kc);
                if (o <= 0 && l <= 0) return e.copy(i);
                Uc.subVectors(t1, n);
                const c = Pc.dot(Uc), u = jc.dot(Uc);
                if (c >= 0 && u <= c) return e.copy(n);
                const h = o * u - c * l;
                if (h <= 0 && o >= 0 && c <= 0) return a = o / (o - c), e.copy(i).addScaledVector(Pc, a);
                Bc.subVectors(t1, r);
                const d = Pc.dot(Bc), p = jc.dot(Bc);
                if (p >= 0 && d <= p) return e.copy(r);
                const A = d * l - o * p;
                if (A <= 0 && l >= 0 && p <= 0) return s = l / (l - p), e.copy(i).addScaledVector(jc, s);
                const f = c * p - d * u;
                if (f <= 0 && u - c >= 0 && d - p >= 0) return Rc.subVectors(r, n), s = (u - c) / (u - c + (d - p)), e.copy(n).addScaledVector(Rc, s);
                const m = 1 / (f + A + h);
                return a = A * m, s = h * m, e.copy(i).addScaledVector(Pc, a).addScaledVector(jc, s);
            }
            equals(t1) {
                return t1.a.equals(this.a) && t1.b.equals(this.b) && t1.c.equals(this.c);
            }
        }
        const Hc = {
            aliceblue: 15792383,
            antiquewhite: 16444375,
            aqua: 65535,
            aquamarine: 8388564,
            azure: 15794175,
            beige: 16119260,
            bisque: 16770244,
            black: 0,
            blanchedalmond: 16772045,
            blue: 255,
            blueviolet: 9055202,
            brown: 10824234,
            burlywood: 14596231,
            cadetblue: 6266528,
            chartreuse: 8388352,
            chocolate: 13789470,
            coral: 16744272,
            cornflowerblue: 6591981,
            cornsilk: 16775388,
            crimson: 14423100,
            cyan: 65535,
            darkblue: 139,
            darkcyan: 35723,
            darkgoldenrod: 12092939,
            darkgray: 11119017,
            darkgreen: 25600,
            darkgrey: 11119017,
            darkkhaki: 12433259,
            darkmagenta: 9109643,
            darkolivegreen: 5597999,
            darkorange: 16747520,
            darkorchid: 10040012,
            darkred: 9109504,
            darksalmon: 15308410,
            darkseagreen: 9419919,
            darkslateblue: 4734347,
            darkslategray: 3100495,
            darkslategrey: 3100495,
            darkturquoise: 52945,
            darkviolet: 9699539,
            deeppink: 16716947,
            deepskyblue: 49151,
            dimgray: 6908265,
            dimgrey: 6908265,
            dodgerblue: 2003199,
            firebrick: 11674146,
            floralwhite: 16775920,
            forestgreen: 2263842,
            fuchsia: 16711935,
            gainsboro: 14474460,
            ghostwhite: 16316671,
            gold: 16766720,
            goldenrod: 14329120,
            gray: 8421504,
            green: 32768,
            greenyellow: 11403055,
            grey: 8421504,
            honeydew: 15794160,
            hotpink: 16738740,
            indianred: 13458524,
            indigo: 4915330,
            ivory: 16777200,
            khaki: 15787660,
            lavender: 15132410,
            lavenderblush: 16773365,
            lawngreen: 8190976,
            lemonchiffon: 16775885,
            lightblue: 11393254,
            lightcoral: 15761536,
            lightcyan: 14745599,
            lightgoldenrodyellow: 16448210,
            lightgray: 13882323,
            lightgreen: 9498256,
            lightgrey: 13882323,
            lightpink: 16758465,
            lightsalmon: 16752762,
            lightseagreen: 2142890,
            lightskyblue: 8900346,
            lightslategray: 7833753,
            lightslategrey: 7833753,
            lightsteelblue: 11584734,
            lightyellow: 16777184,
            lime: 65280,
            limegreen: 3329330,
            linen: 16445670,
            magenta: 16711935,
            maroon: 8388608,
            mediumaquamarine: 6737322,
            mediumblue: 205,
            mediumorchid: 12211667,
            mediumpurple: 9662683,
            mediumseagreen: 3978097,
            mediumslateblue: 8087790,
            mediumspringgreen: 64154,
            mediumturquoise: 4772300,
            mediumvioletred: 13047173,
            midnightblue: 1644912,
            mintcream: 16121850,
            mistyrose: 16770273,
            moccasin: 16770229,
            navajowhite: 16768685,
            navy: 128,
            oldlace: 16643558,
            olive: 8421376,
            olivedrab: 7048739,
            orange: 16753920,
            orangered: 16729344,
            orchid: 14315734,
            palegoldenrod: 15657130,
            palegreen: 10025880,
            paleturquoise: 11529966,
            palevioletred: 14381203,
            papayawhip: 16773077,
            peachpuff: 16767673,
            peru: 13468991,
            pink: 16761035,
            plum: 14524637,
            powderblue: 11591910,
            purple: 8388736,
            rebeccapurple: 6697881,
            red: 16711680,
            rosybrown: 12357519,
            royalblue: 4286945,
            saddlebrown: 9127187,
            salmon: 16416882,
            sandybrown: 16032864,
            seagreen: 3050327,
            seashell: 16774638,
            sienna: 10506797,
            silver: 12632256,
            skyblue: 8900331,
            slateblue: 6970061,
            slategray: 7372944,
            slategrey: 7372944,
            snow: 16775930,
            springgreen: 65407,
            steelblue: 4620980,
            tan: 13808780,
            teal: 32896,
            thistle: 14204888,
            tomato: 16737095,
            turquoise: 4251856,
            violet: 15631086,
            wheat: 16113331,
            white: 16777215,
            whitesmoke: 16119285,
            yellow: 16776960,
            yellowgreen: 10145074
        }, Vc = {
            h: 0,
            s: 0,
            l: 0
        }, Gc = {
            h: 0,
            s: 0,
            l: 0
        };
        function Wc(t1, e, i) {
            return i < 0 && (i += 1), i > 1 && (i -= 1), i < 1 / 6 ? t1 + 6 * (e - t1) * i : i < .5 ? e : i < 2 / 3 ? t1 + 6 * (e - t1) * (2 / 3 - i) : t1;
        }
        class Yc {
            constructor(t1, e, i){
                return this.isColor = !0, this.r = 1, this.g = 1, this.b = 1, this.set(t1, e, i);
            }
            set(t1, e, i) {
                if (void 0 === e && void 0 === i) {
                    const e = t1;
                    e && e.isColor ? this.copy(e) : "number" == typeof e ? this.setHex(e) : "string" == typeof e && this.setStyle(e);
                } else this.setRGB(t1, e, i);
                return this;
            }
            setScalar(t1) {
                return this.r = t1, this.g = t1, this.b = t1, this;
            }
            setHex(t1, e = Qs) {
                return t1 = Math.floor(t1), this.r = (t1 >> 16 & 255) / 255, this.g = (t1 >> 8 & 255) / 255, this.b = (255 & t1) / 255, ul.toWorkingColorSpace(this, e), this;
            }
            setRGB(t1, e, i, n = ul.workingColorSpace) {
                return this.r = t1, this.g = e, this.b = i, ul.toWorkingColorSpace(this, n), this;
            }
            setHSL(t1, e, i, n = ul.workingColorSpace) {
                if (t1 = Qo(t1, 1), e = Fo(e, 0, 1), i = Fo(i, 0, 1), 0 === e) this.r = this.g = this.b = i;
                else {
                    const n = i <= .5 ? i * (1 + e) : i + e - i * e, r = 2 * i - n;
                    this.r = Wc(r, n, t1 + 1 / 3), this.g = Wc(r, n, t1), this.b = Wc(r, n, t1 - 1 / 3);
                }
                return ul.toWorkingColorSpace(this, n), this;
            }
            setStyle(t1, e = Qs) {
                function i(e) {
                    void 0 !== e && parseFloat(e) < 1 && console.warn("THREE.Color: Alpha component of " + t1 + " will be ignored.");
                }
                let n;
                if (n = /^(\w+)\(([^\)]*)\)/.exec(t1)) {
                    let r;
                    const a = n[1], s = n[2];
                    switch(a){
                        case "rgb":
                        case "rgba":
                            if (r = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(s)) return i(r[4]), this.setRGB(Math.min(255, parseInt(r[1], 10)) / 255, Math.min(255, parseInt(r[2], 10)) / 255, Math.min(255, parseInt(r[3], 10)) / 255, e);
                            if (r = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(s)) return i(r[4]), this.setRGB(Math.min(100, parseInt(r[1], 10)) / 100, Math.min(100, parseInt(r[2], 10)) / 100, Math.min(100, parseInt(r[3], 10)) / 100, e);
                            break;
                        case "hsl":
                        case "hsla":
                            if (r = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(s)) return i(r[4]), this.setHSL(parseFloat(r[1]) / 360, parseFloat(r[2]) / 100, parseFloat(r[3]) / 100, e);
                            break;
                        default:
                            console.warn("THREE.Color: Unknown color model " + t1);
                    }
                } else if (n = /^\#([A-Fa-f\d]+)$/.exec(t1)) {
                    const i = n[1], r = i.length;
                    if (3 === r) return this.setRGB(parseInt(i.charAt(0), 16) / 15, parseInt(i.charAt(1), 16) / 15, parseInt(i.charAt(2), 16) / 15, e);
                    if (6 === r) return this.setHex(parseInt(i, 16), e);
                    console.warn("THREE.Color: Invalid hex color " + t1);
                } else if (t1 && t1.length > 0) return this.setColorName(t1, e);
                return this;
            }
            setColorName(t1, e = Qs) {
                const i = Hc[t1.toLowerCase()];
                return void 0 !== i ? this.setHex(i, e) : console.warn("THREE.Color: Unknown color " + t1), this;
            }
            clone() {
                return new this.constructor(this.r, this.g, this.b);
            }
            copy(t1) {
                return this.r = t1.r, this.g = t1.g, this.b = t1.b, this;
            }
            copySRGBToLinear(t1) {
                return this.r = hl(t1.r), this.g = hl(t1.g), this.b = hl(t1.b), this;
            }
            copyLinearToSRGB(t1) {
                return this.r = dl(t1.r), this.g = dl(t1.g), this.b = dl(t1.b), this;
            }
            convertSRGBToLinear() {
                return this.copySRGBToLinear(this), this;
            }
            convertLinearToSRGB() {
                return this.copyLinearToSRGB(this), this;
            }
            getHex(t1 = Qs) {
                return ul.fromWorkingColorSpace(Xc.copy(this), t1), 65536 * Math.round(Fo(255 * Xc.r, 0, 255)) + 256 * Math.round(Fo(255 * Xc.g, 0, 255)) + Math.round(Fo(255 * Xc.b, 0, 255));
            }
            getHexString(t1 = Qs) {
                return ("000000" + this.getHex(t1).toString(16)).slice(-6);
            }
            getHSL(t1, e = ul.workingColorSpace) {
                ul.fromWorkingColorSpace(Xc.copy(this), e);
                const i = Xc.r, n = Xc.g, r = Xc.b, a = Math.max(i, n, r), s = Math.min(i, n, r);
                let o, l;
                const c = (s + a) / 2;
                if (s === a) o = 0, l = 0;
                else {
                    const t1 = a - s;
                    switch(l = c <= .5 ? t1 / (a + s) : t1 / (2 - a - s), a){
                        case i:
                            o = (n - r) / t1 + (n < r ? 6 : 0);
                            break;
                        case n:
                            o = (r - i) / t1 + 2;
                            break;
                        case r:
                            o = (i - n) / t1 + 4;
                    }
                    o /= 6;
                }
                return t1.h = o, t1.s = l, t1.l = c, t1;
            }
            getRGB(t1, e = ul.workingColorSpace) {
                return ul.fromWorkingColorSpace(Xc.copy(this), e), t1.r = Xc.r, t1.g = Xc.g, t1.b = Xc.b, t1;
            }
            getStyle(t1 = Qs) {
                ul.fromWorkingColorSpace(Xc.copy(this), t1);
                const e = Xc.r, i = Xc.g, n = Xc.b;
                return t1 !== Qs ? `color(${t1} ${e.toFixed(3)} ${i.toFixed(3)} ${n.toFixed(3)})` : `rgb(${Math.round(255 * e)},${Math.round(255 * i)},${Math.round(255 * n)})`;
            }
            offsetHSL(t1, e, i) {
                return this.getHSL(Vc), this.setHSL(Vc.h + t1, Vc.s + e, Vc.l + i);
            }
            add(t1) {
                return this.r += t1.r, this.g += t1.g, this.b += t1.b, this;
            }
            addColors(t1, e) {
                return this.r = t1.r + e.r, this.g = t1.g + e.g, this.b = t1.b + e.b, this;
            }
            addScalar(t1) {
                return this.r += t1, this.g += t1, this.b += t1, this;
            }
            sub(t1) {
                return this.r = Math.max(0, this.r - t1.r), this.g = Math.max(0, this.g - t1.g), this.b = Math.max(0, this.b - t1.b), this;
            }
            multiply(t1) {
                return this.r *= t1.r, this.g *= t1.g, this.b *= t1.b, this;
            }
            multiplyScalar(t1) {
                return this.r *= t1, this.g *= t1, this.b *= t1, this;
            }
            lerp(t1, e) {
                return this.r += (t1.r - this.r) * e, this.g += (t1.g - this.g) * e, this.b += (t1.b - this.b) * e, this;
            }
            lerpColors(t1, e, i) {
                return this.r = t1.r + (e.r - t1.r) * i, this.g = t1.g + (e.g - t1.g) * i, this.b = t1.b + (e.b - t1.b) * i, this;
            }
            lerpHSL(t1, e) {
                this.getHSL(Vc), t1.getHSL(Gc);
                const i = Ho(Vc.h, Gc.h, e), n = Ho(Vc.s, Gc.s, e), r = Ho(Vc.l, Gc.l, e);
                return this.setHSL(i, n, r), this;
            }
            setFromVector3(t1) {
                return this.r = t1.x, this.g = t1.y, this.b = t1.z, this;
            }
            applyMatrix3(t1) {
                const e = this.r, i = this.g, n = this.b, r = t1.elements;
                return this.r = r[0] * e + r[3] * i + r[6] * n, this.g = r[1] * e + r[4] * i + r[7] * n, this.b = r[2] * e + r[5] * i + r[8] * n, this;
            }
            equals(t1) {
                return t1.r === this.r && t1.g === this.g && t1.b === this.b;
            }
            fromArray(t1, e = 0) {
                return this.r = t1[e], this.g = t1[e + 1], this.b = t1[e + 2], this;
            }
            toArray(t1 = [], e = 0) {
                return t1[e] = this.r, t1[e + 1] = this.g, t1[e + 2] = this.b, t1;
            }
            fromBufferAttribute(t1, e) {
                return this.r = t1.getX(e), this.g = t1.getY(e), this.b = t1.getZ(e), this;
            }
            toJSON() {
                return this.getHex();
            }
            *[Symbol.iterator]() {
                yield this.r, yield this.g, yield this.b;
            }
        }
        const Xc = new Yc;
        Yc.NAMES = Hc;
        let Zc = 0;
        class qc extends Po {
            constructor(){
                super(), this.isMaterial = !0, Object.defineProperty(this, "id", {
                    value: Zc++
                }), this.uuid = Bo(), this.name = "", this.type = "Material", this.blending = dr, this.side = or, this.vertexColors = !1, this.opacity = 1, this.transparent = !1, this.alphaHash = !1, this.blendSrc = _r, this.blendDst = Ir, this.blendEquation = gr, this.blendSrcAlpha = null, this.blendDstAlpha = null, this.blendEquationAlpha = null, this.blendColor = new Yc(0, 0, 0), this.blendAlpha = 0, this.depthFunc = Br, this.depthTest = !0, this.depthWrite = !0, this.stencilWriteMask = 255, this.stencilFunc = ho, this.stencilRef = 0, this.stencilFuncMask = 255, this.stencilFail = Js, this.stencilZFail = Js, this.stencilZPass = Js, this.stencilWrite = !1, this.clippingPlanes = null, this.clipIntersection = !1, this.clipShadows = !1, this.shadowSide = null, this.colorWrite = !0, this.precision = null, this.polygonOffset = !1, this.polygonOffsetFactor = 0, this.polygonOffsetUnits = 0, this.dithering = !1, this.alphaToCoverage = !1, this.premultipliedAlpha = !1, this.forceSinglePass = !1, this.visible = !0, this.toneMapped = !0, this.userData = {}, this.version = 0, this._alphaTest = 0;
            }
            get alphaTest() {
                return this._alphaTest;
            }
            set alphaTest(t1) {
                this._alphaTest > 0 != t1 > 0 && this.version++, this._alphaTest = t1;
            }
            onBuild() {}
            onBeforeRender() {}
            onBeforeCompile() {}
            customProgramCacheKey() {
                return this.onBeforeCompile.toString();
            }
            setValues(t1) {
                if (void 0 !== t1) for(const e in t1){
                    const i = t1[e];
                    if (void 0 === i) {
                        console.warn(`THREE.Material: parameter '${e}' has value of undefined.`);
                        continue;
                    }
                    const n = this[e];
                    void 0 !== n ? n && n.isColor ? n.set(i) : n && n.isVector3 && i && i.isVector3 ? n.copy(i) : this[e] = i : console.warn(`THREE.Material: '${e}' is not a property of THREE.${this.type}.`);
                }
            }
            toJSON(t1) {
                const e = void 0 === t1 || "string" == typeof t1;
                e && (t1 = {
                    textures: {},
                    images: {}
                });
                const i = {
                    metadata: {
                        version: 4.6,
                        type: "Material",
                        generator: "Material.toJSON"
                    }
                };
                function n(t1) {
                    const e = [];
                    for(const i in t1){
                        const n = t1[i];
                        delete n.metadata, e.push(n);
                    }
                    return e;
                }
                if (i.uuid = this.uuid, i.type = this.type, "" !== this.name && (i.name = this.name), this.color && this.color.isColor && (i.color = this.color.getHex()), void 0 !== this.roughness && (i.roughness = this.roughness), void 0 !== this.metalness && (i.metalness = this.metalness), void 0 !== this.sheen && (i.sheen = this.sheen), this.sheenColor && this.sheenColor.isColor && (i.sheenColor = this.sheenColor.getHex()), void 0 !== this.sheenRoughness && (i.sheenRoughness = this.sheenRoughness), this.emissive && this.emissive.isColor && (i.emissive = this.emissive.getHex()), this.emissiveIntensity && 1 !== this.emissiveIntensity && (i.emissiveIntensity = this.emissiveIntensity), this.specular && this.specular.isColor && (i.specular = this.specular.getHex()), void 0 !== this.specularIntensity && (i.specularIntensity = this.specularIntensity), this.specularColor && this.specularColor.isColor && (i.specularColor = this.specularColor.getHex()), void 0 !== this.shininess && (i.shininess = this.shininess), void 0 !== this.clearcoat && (i.clearcoat = this.clearcoat), void 0 !== this.clearcoatRoughness && (i.clearcoatRoughness = this.clearcoatRoughness), this.clearcoatMap && this.clearcoatMap.isTexture && (i.clearcoatMap = this.clearcoatMap.toJSON(t1).uuid), this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture && (i.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(t1).uuid), this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture && (i.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(t1).uuid, i.clearcoatNormalScale = this.clearcoatNormalScale.toArray()), void 0 !== this.iridescence && (i.iridescence = this.iridescence), void 0 !== this.iridescenceIOR && (i.iridescenceIOR = this.iridescenceIOR), void 0 !== this.iridescenceThicknessRange && (i.iridescenceThicknessRange = this.iridescenceThicknessRange), this.iridescenceMap && this.iridescenceMap.isTexture && (i.iridescenceMap = this.iridescenceMap.toJSON(t1).uuid), this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture && (i.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(t1).uuid), void 0 !== this.anisotropy && (i.anisotropy = this.anisotropy), void 0 !== this.anisotropyRotation && (i.anisotropyRotation = this.anisotropyRotation), this.anisotropyMap && this.anisotropyMap.isTexture && (i.anisotropyMap = this.anisotropyMap.toJSON(t1).uuid), this.map && this.map.isTexture && (i.map = this.map.toJSON(t1).uuid), this.matcap && this.matcap.isTexture && (i.matcap = this.matcap.toJSON(t1).uuid), this.alphaMap && this.alphaMap.isTexture && (i.alphaMap = this.alphaMap.toJSON(t1).uuid), this.lightMap && this.lightMap.isTexture && (i.lightMap = this.lightMap.toJSON(t1).uuid, i.lightMapIntensity = this.lightMapIntensity), this.aoMap && this.aoMap.isTexture && (i.aoMap = this.aoMap.toJSON(t1).uuid, i.aoMapIntensity = this.aoMapIntensity), this.bumpMap && this.bumpMap.isTexture && (i.bumpMap = this.bumpMap.toJSON(t1).uuid, i.bumpScale = this.bumpScale), this.normalMap && this.normalMap.isTexture && (i.normalMap = this.normalMap.toJSON(t1).uuid, i.normalMapType = this.normalMapType, i.normalScale = this.normalScale.toArray()), this.displacementMap && this.displacementMap.isTexture && (i.displacementMap = this.displacementMap.toJSON(t1).uuid, i.displacementScale = this.displacementScale, i.displacementBias = this.displacementBias), this.roughnessMap && this.roughnessMap.isTexture && (i.roughnessMap = this.roughnessMap.toJSON(t1).uuid), this.metalnessMap && this.metalnessMap.isTexture && (i.metalnessMap = this.metalnessMap.toJSON(t1).uuid), this.emissiveMap && this.emissiveMap.isTexture && (i.emissiveMap = this.emissiveMap.toJSON(t1).uuid), this.specularMap && this.specularMap.isTexture && (i.specularMap = this.specularMap.toJSON(t1).uuid), this.specularIntensityMap && this.specularIntensityMap.isTexture && (i.specularIntensityMap = this.specularIntensityMap.toJSON(t1).uuid), this.specularColorMap && this.specularColorMap.isTexture && (i.specularColorMap = this.specularColorMap.toJSON(t1).uuid), this.envMap && this.envMap.isTexture && (i.envMap = this.envMap.toJSON(t1).uuid, void 0 !== this.combine && (i.combine = this.combine)), void 0 !== this.envMapIntensity && (i.envMapIntensity = this.envMapIntensity), void 0 !== this.reflectivity && (i.reflectivity = this.reflectivity), void 0 !== this.refractionRatio && (i.refractionRatio = this.refractionRatio), this.gradientMap && this.gradientMap.isTexture && (i.gradientMap = this.gradientMap.toJSON(t1).uuid), void 0 !== this.transmission && (i.transmission = this.transmission), this.transmissionMap && this.transmissionMap.isTexture && (i.transmissionMap = this.transmissionMap.toJSON(t1).uuid), void 0 !== this.thickness && (i.thickness = this.thickness), this.thicknessMap && this.thicknessMap.isTexture && (i.thicknessMap = this.thicknessMap.toJSON(t1).uuid), void 0 !== this.attenuationDistance && this.attenuationDistance !== 1 / 0 && (i.attenuationDistance = this.attenuationDistance), void 0 !== this.attenuationColor && (i.attenuationColor = this.attenuationColor.getHex()), void 0 !== this.size && (i.size = this.size), null !== this.shadowSide && (i.shadowSide = this.shadowSide), void 0 !== this.sizeAttenuation && (i.sizeAttenuation = this.sizeAttenuation), this.blending !== dr && (i.blending = this.blending), this.side !== or && (i.side = this.side), !0 === this.vertexColors && (i.vertexColors = !0), this.opacity < 1 && (i.opacity = this.opacity), !0 === this.transparent && (i.transparent = !0), this.blendSrc !== _r && (i.blendSrc = this.blendSrc), this.blendDst !== Ir && (i.blendDst = this.blendDst), this.blendEquation !== gr && (i.blendEquation = this.blendEquation), null !== this.blendSrcAlpha && (i.blendSrcAlpha = this.blendSrcAlpha), null !== this.blendDstAlpha && (i.blendDstAlpha = this.blendDstAlpha), null !== this.blendEquationAlpha && (i.blendEquationAlpha = this.blendEquationAlpha), this.blendColor && this.blendColor.isColor && (i.blendColor = this.blendColor.getHex()), 0 !== this.blendAlpha && (i.blendAlpha = this.blendAlpha), this.depthFunc !== Br && (i.depthFunc = this.depthFunc), !1 === this.depthTest && (i.depthTest = this.depthTest), !1 === this.depthWrite && (i.depthWrite = this.depthWrite), !1 === this.colorWrite && (i.colorWrite = this.colorWrite), 255 !== this.stencilWriteMask && (i.stencilWriteMask = this.stencilWriteMask), this.stencilFunc !== ho && (i.stencilFunc = this.stencilFunc), 0 !== this.stencilRef && (i.stencilRef = this.stencilRef), 255 !== this.stencilFuncMask && (i.stencilFuncMask = this.stencilFuncMask), this.stencilFail !== Js && (i.stencilFail = this.stencilFail), this.stencilZFail !== Js && (i.stencilZFail = this.stencilZFail), this.stencilZPass !== Js && (i.stencilZPass = this.stencilZPass), !0 === this.stencilWrite && (i.stencilWrite = this.stencilWrite), void 0 !== this.rotation && 0 !== this.rotation && (i.rotation = this.rotation), !0 === this.polygonOffset && (i.polygonOffset = !0), 0 !== this.polygonOffsetFactor && (i.polygonOffsetFactor = this.polygonOffsetFactor), 0 !== this.polygonOffsetUnits && (i.polygonOffsetUnits = this.polygonOffsetUnits), void 0 !== this.linewidth && 1 !== this.linewidth && (i.linewidth = this.linewidth), void 0 !== this.dashSize && (i.dashSize = this.dashSize), void 0 !== this.gapSize && (i.gapSize = this.gapSize), void 0 !== this.scale && (i.scale = this.scale), !0 === this.dithering && (i.dithering = !0), this.alphaTest > 0 && (i.alphaTest = this.alphaTest), !0 === this.alphaHash && (i.alphaHash = !0), !0 === this.alphaToCoverage && (i.alphaToCoverage = !0), !0 === this.premultipliedAlpha && (i.premultipliedAlpha = !0), !0 === this.forceSinglePass && (i.forceSinglePass = !0), !0 === this.wireframe && (i.wireframe = !0), this.wireframeLinewidth > 1 && (i.wireframeLinewidth = this.wireframeLinewidth), "round" !== this.wireframeLinecap && (i.wireframeLinecap = this.wireframeLinecap), "round" !== this.wireframeLinejoin && (i.wireframeLinejoin = this.wireframeLinejoin), !0 === this.flatShading && (i.flatShading = !0), !1 === this.visible && (i.visible = !1), !1 === this.toneMapped && (i.toneMapped = !1), !1 === this.fog && (i.fog = !1), Object.keys(this.userData).length > 0 && (i.userData = this.userData), e) {
                    const e = n(t1.textures), r = n(t1.images);
                    e.length > 0 && (i.textures = e), r.length > 0 && (i.images = r);
                }
                return i;
            }
            clone() {
                return (new this.constructor).copy(this);
            }
            copy(t1) {
                this.name = t1.name, this.blending = t1.blending, this.side = t1.side, this.vertexColors = t1.vertexColors, this.opacity = t1.opacity, this.transparent = t1.transparent, this.blendSrc = t1.blendSrc, this.blendDst = t1.blendDst, this.blendEquation = t1.blendEquation, this.blendSrcAlpha = t1.blendSrcAlpha, this.blendDstAlpha = t1.blendDstAlpha, this.blendEquationAlpha = t1.blendEquationAlpha, this.blendColor.copy(t1.blendColor), this.blendAlpha = t1.blendAlpha, this.depthFunc = t1.depthFunc, this.depthTest = t1.depthTest, this.depthWrite = t1.depthWrite, this.stencilWriteMask = t1.stencilWriteMask, this.stencilFunc = t1.stencilFunc, this.stencilRef = t1.stencilRef, this.stencilFuncMask = t1.stencilFuncMask, this.stencilFail = t1.stencilFail, this.stencilZFail = t1.stencilZFail, this.stencilZPass = t1.stencilZPass, this.stencilWrite = t1.stencilWrite;
                const e = t1.clippingPlanes;
                let i = null;
                if (null !== e) {
                    const t1 = e.length;
                    i = new Array(t1);
                    for(let n = 0; n !== t1; ++n)i[n] = e[n].clone();
                }
                return this.clippingPlanes = i, this.clipIntersection = t1.clipIntersection, this.clipShadows = t1.clipShadows, this.shadowSide = t1.shadowSide, this.colorWrite = t1.colorWrite, this.precision = t1.precision, this.polygonOffset = t1.polygonOffset, this.polygonOffsetFactor = t1.polygonOffsetFactor, this.polygonOffsetUnits = t1.polygonOffsetUnits, this.dithering = t1.dithering, this.alphaTest = t1.alphaTest, this.alphaHash = t1.alphaHash, this.alphaToCoverage = t1.alphaToCoverage, this.premultipliedAlpha = t1.premultipliedAlpha, this.forceSinglePass = t1.forceSinglePass, this.visible = t1.visible, this.toneMapped = t1.toneMapped, this.userData = JSON.parse(JSON.stringify(t1.userData)), this;
            }
            dispose() {
                this.dispatchEvent({
                    type: "dispose"
                });
            }
            set needsUpdate(t1) {
                !0 === t1 && this.version++;
            }
        }
        class Jc extends qc {
            constructor(t1){
                super(), this.isMeshBasicMaterial = !0, this.type = "MeshBasicMaterial", this.color = new Yc(16777215), this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.combine = Gr, this.reflectivity = 1, this.refractionRatio = .98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.fog = !0, this.setValues(t1);
            }
            copy(t1) {
                return super.copy(t1), this.color.copy(t1.color), this.map = t1.map, this.lightMap = t1.lightMap, this.lightMapIntensity = t1.lightMapIntensity, this.aoMap = t1.aoMap, this.aoMapIntensity = t1.aoMapIntensity, this.specularMap = t1.specularMap, this.alphaMap = t1.alphaMap, this.envMap = t1.envMap, this.combine = t1.combine, this.reflectivity = t1.reflectivity, this.refractionRatio = t1.refractionRatio, this.wireframe = t1.wireframe, this.wireframeLinewidth = t1.wireframeLinewidth, this.wireframeLinecap = t1.wireframeLinecap, this.wireframeLinejoin = t1.wireframeLinejoin, this.fog = t1.fog, this;
            }
        }
        const Kc = $c();
        function $c() {
            const t1 = new ArrayBuffer(4), e = new Float32Array(t1), i = new Uint32Array(t1), n = new Uint32Array(512), r = new Uint32Array(512);
            for(let t1 = 0; t1 < 256; ++t1){
                const e = t1 - 127;
                e < -27 ? (n[t1] = 0, n[256 | t1] = 32768, r[t1] = 24, r[256 | t1] = 24) : e < -14 ? (n[t1] = 1024 >> -e - 14, n[256 | t1] = 1024 >> -e - 14 | 32768, r[t1] = -e - 1, r[256 | t1] = -e - 1) : e <= 15 ? (n[t1] = e + 15 << 10, n[256 | t1] = e + 15 << 10 | 32768, r[t1] = 13, r[256 | t1] = 13) : e < 128 ? (n[t1] = 31744, n[256 | t1] = 64512, r[t1] = 24, r[256 | t1] = 24) : (n[t1] = 31744, n[256 | t1] = 64512, r[t1] = 13, r[256 | t1] = 13);
            }
            const a = new Uint32Array(2048), s = new Uint32Array(64), o = new Uint32Array(64);
            for(let t1 = 1; t1 < 1024; ++t1){
                let e = t1 << 13, i = 0;
                for(; !(8388608 & e);)e <<= 1, i -= 8388608;
                e &= -8388609, i += 947912704, a[t1] = e | i;
            }
            for(let t1 = 1024; t1 < 2048; ++t1)a[t1] = 939524096 + (t1 - 1024 << 13);
            for(let t1 = 1; t1 < 31; ++t1)s[t1] = t1 << 23;
            s[31] = 1199570944, s[32] = 2147483648;
            for(let t1 = 33; t1 < 63; ++t1)s[t1] = 2147483648 + (t1 - 32 << 23);
            s[63] = 3347054592;
            for(let t1 = 1; t1 < 64; ++t1)32 !== t1 && (o[t1] = 1024);
            return {
                floatView: e,
                uint32View: i,
                baseTable: n,
                shiftTable: r,
                mantissaTable: a,
                exponentTable: s,
                offsetTable: o
            };
        }
        function tu(t1) {
            Math.abs(t1) > 65504 && console.warn("THREE.DataUtils.toHalfFloat(): Value out of range."), t1 = Fo(t1, -65504, 65504), Kc.floatView[0] = t1;
            const e = Kc.uint32View[0], i = e >> 23 & 511;
            return Kc.baseTable[i] + ((8388607 & e) >> Kc.shiftTable[i]);
        }
        function eu(t1) {
            const e = t1 >> 10;
            return Kc.uint32View[0] = Kc.mantissaTable[Kc.offsetTable[e] + (1023 & t1)] + Kc.exponentTable[e], Kc.floatView[0];
        }
        const iu = {
            toHalfFloat: tu,
            fromHalfFloat: eu
        }, nu = new Nl, ru = new qo;
        class au {
            constructor(t1, e, i = !1){
                if (Array.isArray(t1)) throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
                this.isBufferAttribute = !0, this.name = "", this.array = t1, this.itemSize = e, this.count = void 0 !== t1 ? t1.length / e : 0, this.normalized = i, this.usage = xo, this.updateRange = {
                    offset: 0,
                    count: -1
                }, this.gpuType = Ia, this.version = 0;
            }
            onUploadCallback() {}
            set needsUpdate(t1) {
                !0 === t1 && this.version++;
            }
            setUsage(t1) {
                return this.usage = t1, this;
            }
            copy(t1) {
                return this.name = t1.name, this.array = new t1.array.constructor(t1.array), this.itemSize = t1.itemSize, this.count = t1.count, this.normalized = t1.normalized, this.usage = t1.usage, this.gpuType = t1.gpuType, this;
            }
            copyAt(t1, e, i) {
                t1 *= this.itemSize, i *= e.itemSize;
                for(let n = 0, r = this.itemSize; n < r; n++)this.array[t1 + n] = e.array[i + n];
                return this;
            }
            copyArray(t1) {
                return this.array.set(t1), this;
            }
            applyMatrix3(t1) {
                if (2 === this.itemSize) for(let e = 0, i = this.count; e < i; e++)ru.fromBufferAttribute(this, e), ru.applyMatrix3(t1), this.setXY(e, ru.x, ru.y);
                else if (3 === this.itemSize) for(let e = 0, i = this.count; e < i; e++)nu.fromBufferAttribute(this, e), nu.applyMatrix3(t1), this.setXYZ(e, nu.x, nu.y, nu.z);
                return this;
            }
            applyMatrix4(t1) {
                for(let e = 0, i = this.count; e < i; e++)nu.fromBufferAttribute(this, e), nu.applyMatrix4(t1), this.setXYZ(e, nu.x, nu.y, nu.z);
                return this;
            }
            applyNormalMatrix(t1) {
                for(let e = 0, i = this.count; e < i; e++)nu.fromBufferAttribute(this, e), nu.applyNormalMatrix(t1), this.setXYZ(e, nu.x, nu.y, nu.z);
                return this;
            }
            transformDirection(t1) {
                for(let e = 0, i = this.count; e < i; e++)nu.fromBufferAttribute(this, e), nu.transformDirection(t1), this.setXYZ(e, nu.x, nu.y, nu.z);
                return this;
            }
            set(t1, e = 0) {
                return this.array.set(t1, e), this;
            }
            getComponent(t1, e) {
                let i = this.array[t1 * this.itemSize + e];
                return this.normalized && (i = Yo(i, this.array)), i;
            }
            setComponent(t1, e, i) {
                return this.normalized && (i = Xo(i, this.array)), this.array[t1 * this.itemSize + e] = i, this;
            }
            getX(t1) {
                let e = this.array[t1 * this.itemSize];
                return this.normalized && (e = Yo(e, this.array)), e;
            }
            setX(t1, e) {
                return this.normalized && (e = Xo(e, this.array)), this.array[t1 * this.itemSize] = e, this;
            }
            getY(t1) {
                let e = this.array[t1 * this.itemSize + 1];
                return this.normalized && (e = Yo(e, this.array)), e;
            }
            setY(t1, e) {
                return this.normalized && (e = Xo(e, this.array)), this.array[t1 * this.itemSize + 1] = e, this;
            }
            getZ(t1) {
                let e = this.array[t1 * this.itemSize + 2];
                return this.normalized && (e = Yo(e, this.array)), e;
            }
            setZ(t1, e) {
                return this.normalized && (e = Xo(e, this.array)), this.array[t1 * this.itemSize + 2] = e, this;
            }
            getW(t1) {
                let e = this.array[t1 * this.itemSize + 3];
                return this.normalized && (e = Yo(e, this.array)), e;
            }
            setW(t1, e) {
                return this.normalized && (e = Xo(e, this.array)), this.array[t1 * this.itemSize + 3] = e, this;
            }
            setXY(t1, e, i) {
                return t1 *= this.itemSize, this.normalized && (e = Xo(e, this.array), i = Xo(i, this.array)), this.array[t1 + 0] = e, this.array[t1 + 1] = i, this;
            }
            setXYZ(t1, e, i, n) {
                return t1 *= this.itemSize, this.normalized && (e = Xo(e, this.array), i = Xo(i, this.array), n = Xo(n, this.array)), this.array[t1 + 0] = e, this.array[t1 + 1] = i, this.array[t1 + 2] = n, this;
            }
            setXYZW(t1, e, i, n, r) {
                return t1 *= this.itemSize, this.normalized && (e = Xo(e, this.array), i = Xo(i, this.array), n = Xo(n, this.array), r = Xo(r, this.array)), this.array[t1 + 0] = e, this.array[t1 + 1] = i, this.array[t1 + 2] = n, this.array[t1 + 3] = r, this;
            }
            onUpload(t1) {
                return this.onUploadCallback = t1, this;
            }
            clone() {
                return new this.constructor(this.array, this.itemSize).copy(this);
            }
            toJSON() {
                const t1 = {
                    itemSize: this.itemSize,
                    type: this.array.constructor.name,
                    array: Array.from(this.array),
                    normalized: this.normalized
                };
                return "" !== this.name && (t1.name = this.name), this.usage !== xo && (t1.usage = this.usage), 0 === this.updateRange.offset && -1 === this.updateRange.count || (t1.updateRange = this.updateRange), t1;
            }
        }
        class su extends au {
            constructor(t1, e, i){
                super(new Int8Array(t1), e, i);
            }
        }
        class ou extends au {
            constructor(t1, e, i){
                super(new Uint8Array(t1), e, i);
            }
        }
        class lu extends au {
            constructor(t1, e, i){
                super(new Uint8ClampedArray(t1), e, i);
            }
        }
        class cu extends au {
            constructor(t1, e, i){
                super(new Int16Array(t1), e, i);
            }
        }
        class uu extends au {
            constructor(t1, e, i){
                super(new Uint16Array(t1), e, i);
            }
        }
        class hu extends au {
            constructor(t1, e, i){
                super(new Int32Array(t1), e, i);
            }
        }
        class du extends au {
            constructor(t1, e, i){
                super(new Uint32Array(t1), e, i);
            }
        }
        class pu extends au {
            constructor(t1, e, i){
                super(new Uint16Array(t1), e, i), this.isFloat16BufferAttribute = !0;
            }
            getX(t1) {
                let e = eu(this.array[t1 * this.itemSize]);
                return this.normalized && (e = Yo(e, this.array)), e;
            }
            setX(t1, e) {
                return this.normalized && (e = Xo(e, this.array)), this.array[t1 * this.itemSize] = tu(e), this;
            }
            getY(t1) {
                let e = eu(this.array[t1 * this.itemSize + 1]);
                return this.normalized && (e = Yo(e, this.array)), e;
            }
            setY(t1, e) {
                return this.normalized && (e = Xo(e, this.array)), this.array[t1 * this.itemSize + 1] = tu(e), this;
            }
            getZ(t1) {
                let e = eu(this.array[t1 * this.itemSize + 2]);
                return this.normalized && (e = Yo(e, this.array)), e;
            }
            setZ(t1, e) {
                return this.normalized && (e = Xo(e, this.array)), this.array[t1 * this.itemSize + 2] = tu(e), this;
            }
            getW(t1) {
                let e = eu(this.array[t1 * this.itemSize + 3]);
                return this.normalized && (e = Yo(e, this.array)), e;
            }
            setW(t1, e) {
                return this.normalized && (e = Xo(e, this.array)), this.array[t1 * this.itemSize + 3] = tu(e), this;
            }
            setXY(t1, e, i) {
                return t1 *= this.itemSize, this.normalized && (e = Xo(e, this.array), i = Xo(i, this.array)), this.array[t1 + 0] = tu(e), this.array[t1 + 1] = tu(i), this;
            }
            setXYZ(t1, e, i, n) {
                return t1 *= this.itemSize, this.normalized && (e = Xo(e, this.array), i = Xo(i, this.array), n = Xo(n, this.array)), this.array[t1 + 0] = tu(e), this.array[t1 + 1] = tu(i), this.array[t1 + 2] = tu(n), this;
            }
            setXYZW(t1, e, i, n, r) {
                return t1 *= this.itemSize, this.normalized && (e = Xo(e, this.array), i = Xo(i, this.array), n = Xo(n, this.array), r = Xo(r, this.array)), this.array[t1 + 0] = tu(e), this.array[t1 + 1] = tu(i), this.array[t1 + 2] = tu(n), this.array[t1 + 3] = tu(r), this;
            }
        }
        class Au extends au {
            constructor(t1, e, i){
                super(new Float32Array(t1), e, i);
            }
        }
        class fu extends au {
            constructor(t1, e, i){
                super(new Float64Array(t1), e, i);
            }
        }
        let mu = 0;
        const gu = new ac, Mu = new Dc, vu = new Nl, yu = new zl, xu = new zl, wu = new Nl;
        class bu extends Po {
            constructor(){
                super(), this.isBufferGeometry = !0, Object.defineProperty(this, "id", {
                    value: mu++
                }), this.uuid = Bo(), this.name = "", this.type = "BufferGeometry", this.index = null, this.attributes = {}, this.morphAttributes = {}, this.morphTargetsRelative = !1, this.groups = [], this.boundingBox = null, this.boundingSphere = null, this.drawRange = {
                    start: 0,
                    count: 1 / 0
                }, this.userData = {};
            }
            getIndex() {
                return this.index;
            }
            setIndex(t1) {
                return Array.isArray(t1) ? this.index = new ($o(t1) ? du : uu)(t1, 1) : this.index = t1, this;
            }
            getAttribute(t1) {
                return this.attributes[t1];
            }
            setAttribute(t1, e) {
                return this.attributes[t1] = e, this;
            }
            deleteAttribute(t1) {
                return delete this.attributes[t1], this;
            }
            hasAttribute(t1) {
                return void 0 !== this.attributes[t1];
            }
            addGroup(t1, e, i = 0) {
                this.groups.push({
                    start: t1,
                    count: e,
                    materialIndex: i
                });
            }
            clearGroups() {
                this.groups = [];
            }
            setDrawRange(t1, e) {
                this.drawRange.start = t1, this.drawRange.count = e;
            }
            applyMatrix4(t1) {
                const e = this.attributes.position;
                void 0 !== e && (e.applyMatrix4(t1), e.needsUpdate = !0);
                const i = this.attributes.normal;
                if (void 0 !== i) {
                    const e = (new Jo).getNormalMatrix(t1);
                    i.applyNormalMatrix(e), i.needsUpdate = !0;
                }
                const n = this.attributes.tangent;
                return void 0 !== n && (n.transformDirection(t1), n.needsUpdate = !0), null !== this.boundingBox && this.computeBoundingBox(), null !== this.boundingSphere && this.computeBoundingSphere(), this;
            }
            applyQuaternion(t1) {
                return gu.makeRotationFromQuaternion(t1), this.applyMatrix4(gu), this;
            }
            rotateX(t1) {
                return gu.makeRotationX(t1), this.applyMatrix4(gu), this;
            }
            rotateY(t1) {
                return gu.makeRotationY(t1), this.applyMatrix4(gu), this;
            }
            rotateZ(t1) {
                return gu.makeRotationZ(t1), this.applyMatrix4(gu), this;
            }
            translate(t1, e, i) {
                return gu.makeTranslation(t1, e, i), this.applyMatrix4(gu), this;
            }
            scale(t1, e, i) {
                return gu.makeScale(t1, e, i), this.applyMatrix4(gu), this;
            }
            lookAt(t1) {
                return Mu.lookAt(t1), Mu.updateMatrix(), this.applyMatrix4(Mu.matrix), this;
            }
            center() {
                return this.computeBoundingBox(), this.boundingBox.getCenter(vu).negate(), this.translate(vu.x, vu.y, vu.z), this;
            }
            setFromPoints(t1) {
                const e = [];
                for(let i = 0, n = t1.length; i < n; i++){
                    const n = t1[i];
                    e.push(n.x, n.y, n.z || 0);
                }
                return this.setAttribute("position", new Au(e, 3)), this;
            }
            computeBoundingBox() {
                null === this.boundingBox && (this.boundingBox = new zl);
                const t1 = this.attributes.position, e = this.morphAttributes.position;
                if (t1 && t1.isGLBufferAttribute) return console.error('THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box. Alternatively set "mesh.frustumCulled" to "false".', this), void this.boundingBox.set(new Nl(-1 / 0, -1 / 0, -1 / 0), new Nl(1 / 0, 1 / 0, 1 / 0));
                if (void 0 !== t1) {
                    if (this.boundingBox.setFromBufferAttribute(t1), e) for(let t1 = 0, i = e.length; t1 < i; t1++){
                        const i = e[t1];
                        yu.setFromBufferAttribute(i), this.morphTargetsRelative ? (wu.addVectors(this.boundingBox.min, yu.min), this.boundingBox.expandByPoint(wu), wu.addVectors(this.boundingBox.max, yu.max), this.boundingBox.expandByPoint(wu)) : (this.boundingBox.expandByPoint(yu.min), this.boundingBox.expandByPoint(yu.max));
                    }
                } else this.boundingBox.makeEmpty();
                (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) && console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
            }
            computeBoundingSphere() {
                null === this.boundingSphere && (this.boundingSphere = new ql);
                const t1 = this.attributes.position, e = this.morphAttributes.position;
                if (t1 && t1.isGLBufferAttribute) return console.error('THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere. Alternatively set "mesh.frustumCulled" to "false".', this), void this.boundingSphere.set(new Nl, 1 / 0);
                if (t1) {
                    const i = this.boundingSphere.center;
                    if (yu.setFromBufferAttribute(t1), e) for(let t1 = 0, i = e.length; t1 < i; t1++){
                        const i = e[t1];
                        xu.setFromBufferAttribute(i), this.morphTargetsRelative ? (wu.addVectors(yu.min, xu.min), yu.expandByPoint(wu), wu.addVectors(yu.max, xu.max), yu.expandByPoint(wu)) : (yu.expandByPoint(xu.min), yu.expandByPoint(xu.max));
                    }
                    yu.getCenter(i);
                    let n = 0;
                    for(let e = 0, r = t1.count; e < r; e++)wu.fromBufferAttribute(t1, e), n = Math.max(n, i.distanceToSquared(wu));
                    if (e) for(let r = 0, a = e.length; r < a; r++){
                        const a = e[r], s = this.morphTargetsRelative;
                        for(let e = 0, r = a.count; e < r; e++)wu.fromBufferAttribute(a, e), s && (vu.fromBufferAttribute(t1, e), wu.add(vu)), n = Math.max(n, i.distanceToSquared(wu));
                    }
                    this.boundingSphere.radius = Math.sqrt(n), isNaN(this.boundingSphere.radius) && console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
                }
            }
            computeTangents() {
                const t1 = this.index, e = this.attributes;
                if (null === t1 || void 0 === e.position || void 0 === e.normal || void 0 === e.uv) return void console.error("THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)");
                const i = t1.array, n = e.position.array, r = e.normal.array, a = e.uv.array, s = n.length / 3;
                !1 === this.hasAttribute("tangent") && this.setAttribute("tangent", new au(new Float32Array(4 * s), 4));
                const o = this.getAttribute("tangent").array, l = [], c = [];
                for(let t1 = 0; t1 < s; t1++)l[t1] = new Nl, c[t1] = new Nl;
                const u = new Nl, h = new Nl, d = new Nl, p = new qo, A = new qo, f = new qo, m = new Nl, g = new Nl;
                function M(t1, e, i) {
                    u.fromArray(n, 3 * t1), h.fromArray(n, 3 * e), d.fromArray(n, 3 * i), p.fromArray(a, 2 * t1), A.fromArray(a, 2 * e), f.fromArray(a, 2 * i), h.sub(u), d.sub(u), A.sub(p), f.sub(p);
                    const r = 1 / (A.x * f.y - f.x * A.y);
                    isFinite(r) && (m.copy(h).multiplyScalar(f.y).addScaledVector(d, -A.y).multiplyScalar(r), g.copy(d).multiplyScalar(A.x).addScaledVector(h, -f.x).multiplyScalar(r), l[t1].add(m), l[e].add(m), l[i].add(m), c[t1].add(g), c[e].add(g), c[i].add(g));
                }
                let v = this.groups;
                0 === v.length && (v = [
                    {
                        start: 0,
                        count: i.length
                    }
                ]);
                for(let t1 = 0, e = v.length; t1 < e; ++t1){
                    const e = v[t1], n = e.start;
                    for(let t1 = n, r = n + e.count; t1 < r; t1 += 3)M(i[t1 + 0], i[t1 + 1], i[t1 + 2]);
                }
                const y = new Nl, x = new Nl, w = new Nl, b = new Nl;
                function T(t1) {
                    w.fromArray(r, 3 * t1), b.copy(w);
                    const e = l[t1];
                    y.copy(e), y.sub(w.multiplyScalar(w.dot(e))).normalize(), x.crossVectors(b, e);
                    const i = x.dot(c[t1]) < 0 ? -1 : 1;
                    o[4 * t1] = y.x, o[4 * t1 + 1] = y.y, o[4 * t1 + 2] = y.z, o[4 * t1 + 3] = i;
                }
                for(let t1 = 0, e = v.length; t1 < e; ++t1){
                    const e = v[t1], n = e.start;
                    for(let t1 = n, r = n + e.count; t1 < r; t1 += 3)T(i[t1 + 0]), T(i[t1 + 1]), T(i[t1 + 2]);
                }
            }
            computeVertexNormals() {
                const t1 = this.index, e = this.getAttribute("position");
                if (void 0 !== e) {
                    let i = this.getAttribute("normal");
                    if (void 0 === i) i = new au(new Float32Array(3 * e.count), 3), this.setAttribute("normal", i);
                    else for(let t1 = 0, e = i.count; t1 < e; t1++)i.setXYZ(t1, 0, 0, 0);
                    const n = new Nl, r = new Nl, a = new Nl, s = new Nl, o = new Nl, l = new Nl, c = new Nl, u = new Nl;
                    if (t1) for(let h = 0, d = t1.count; h < d; h += 3){
                        const d = t1.getX(h + 0), p = t1.getX(h + 1), A = t1.getX(h + 2);
                        n.fromBufferAttribute(e, d), r.fromBufferAttribute(e, p), a.fromBufferAttribute(e, A), c.subVectors(a, r), u.subVectors(n, r), c.cross(u), s.fromBufferAttribute(i, d), o.fromBufferAttribute(i, p), l.fromBufferAttribute(i, A), s.add(c), o.add(c), l.add(c), i.setXYZ(d, s.x, s.y, s.z), i.setXYZ(p, o.x, o.y, o.z), i.setXYZ(A, l.x, l.y, l.z);
                    }
                    else for(let t1 = 0, s = e.count; t1 < s; t1 += 3)n.fromBufferAttribute(e, t1 + 0), r.fromBufferAttribute(e, t1 + 1), a.fromBufferAttribute(e, t1 + 2), c.subVectors(a, r), u.subVectors(n, r), c.cross(u), i.setXYZ(t1 + 0, c.x, c.y, c.z), i.setXYZ(t1 + 1, c.x, c.y, c.z), i.setXYZ(t1 + 2, c.x, c.y, c.z);
                    this.normalizeNormals(), i.needsUpdate = !0;
                }
            }
            normalizeNormals() {
                const t1 = this.attributes.normal;
                for(let e = 0, i = t1.count; e < i; e++)wu.fromBufferAttribute(t1, e), wu.normalize(), t1.setXYZ(e, wu.x, wu.y, wu.z);
            }
            toNonIndexed() {
                function t1(t1, e) {
                    const i = t1.array, n = t1.itemSize, r = t1.normalized, a = new i.constructor(e.length * n);
                    let s = 0, o = 0;
                    for(let r = 0, l = e.length; r < l; r++){
                        s = t1.isInterleavedBufferAttribute ? e[r] * t1.data.stride + t1.offset : e[r] * n;
                        for(let t1 = 0; t1 < n; t1++)a[o++] = i[s++];
                    }
                    return new au(a, n, r);
                }
                if (null === this.index) return console.warn("THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed."), this;
                const e = new bu, i = this.index.array, n = this.attributes;
                for(const r in n){
                    const a = t1(n[r], i);
                    e.setAttribute(r, a);
                }
                const r = this.morphAttributes;
                for(const n in r){
                    const a = [], s = r[n];
                    for(let e = 0, n = s.length; e < n; e++){
                        const n = t1(s[e], i);
                        a.push(n);
                    }
                    e.morphAttributes[n] = a;
                }
                e.morphTargetsRelative = this.morphTargetsRelative;
                const a = this.groups;
                for(let t1 = 0, i = a.length; t1 < i; t1++){
                    const i = a[t1];
                    e.addGroup(i.start, i.count, i.materialIndex);
                }
                return e;
            }
            toJSON() {
                const t1 = {
                    metadata: {
                        version: 4.6,
                        type: "BufferGeometry",
                        generator: "BufferGeometry.toJSON"
                    }
                };
                if (t1.uuid = this.uuid, t1.type = this.type, "" !== this.name && (t1.name = this.name), Object.keys(this.userData).length > 0 && (t1.userData = this.userData), void 0 !== this.parameters) {
                    const e = this.parameters;
                    for(const i in e)void 0 !== e[i] && (t1[i] = e[i]);
                    return t1;
                }
                t1.data = {
                    attributes: {}
                };
                const e = this.index;
                null !== e && (t1.data.index = {
                    type: e.array.constructor.name,
                    array: Array.prototype.slice.call(e.array)
                });
                const i = this.attributes;
                for(const e in i){
                    const n = i[e];
                    t1.data.attributes[e] = n.toJSON(t1.data);
                }
                const n = {};
                let r = !1;
                for(const e in this.morphAttributes){
                    const i = this.morphAttributes[e], a = [];
                    for(let e = 0, n = i.length; e < n; e++){
                        const n = i[e];
                        a.push(n.toJSON(t1.data));
                    }
                    a.length > 0 && (n[e] = a, r = !0);
                }
                r && (t1.data.morphAttributes = n, t1.data.morphTargetsRelative = this.morphTargetsRelative);
                const a = this.groups;
                a.length > 0 && (t1.data.groups = JSON.parse(JSON.stringify(a)));
                const s = this.boundingSphere;
                return null !== s && (t1.data.boundingSphere = {
                    center: s.center.toArray(),
                    radius: s.radius
                }), t1;
            }
            clone() {
                return (new this.constructor).copy(this);
            }
            copy(t1) {
                this.index = null, this.attributes = {}, this.morphAttributes = {}, this.groups = [], this.boundingBox = null, this.boundingSphere = null;
                const e = {};
                this.name = t1.name;
                const i = t1.index;
                null !== i && this.setIndex(i.clone(e));
                const n = t1.attributes;
                for(const t1 in n){
                    const i = n[t1];
                    this.setAttribute(t1, i.clone(e));
                }
                const r = t1.morphAttributes;
                for(const t1 in r){
                    const i = [], n = r[t1];
                    for(let t1 = 0, r = n.length; t1 < r; t1++)i.push(n[t1].clone(e));
                    this.morphAttributes[t1] = i;
                }
                this.morphTargetsRelative = t1.morphTargetsRelative;
                const a = t1.groups;
                for(let t1 = 0, e = a.length; t1 < e; t1++){
                    const e = a[t1];
                    this.addGroup(e.start, e.count, e.materialIndex);
                }
                const s = t1.boundingBox;
                null !== s && (this.boundingBox = s.clone());
                const o = t1.boundingSphere;
                return null !== o && (this.boundingSphere = o.clone()), this.drawRange.start = t1.drawRange.start, this.drawRange.count = t1.drawRange.count, this.userData = t1.userData, this;
            }
            dispose() {
                this.dispatchEvent({
                    type: "dispose"
                });
            }
        }
        const Tu = new ac, Eu = new rc, _u = new ql, Iu = new Nl, Su = new Nl, Nu = new Nl, Du = new Nl, Cu = new Nl, zu = new Nl, Lu = new qo, Ou = new qo, Pu = new qo, ju = new Nl, Ru = new Nl, ku = new Nl, Uu = new Nl, Bu = new Nl;
        class Fu extends Dc {
            constructor(t1 = new bu, e = new Jc){
                super(), this.isMesh = !0, this.type = "Mesh", this.geometry = t1, this.material = e, this.updateMorphTargets();
            }
            copy(t1, e) {
                return super.copy(t1, e), void 0 !== t1.morphTargetInfluences && (this.morphTargetInfluences = t1.morphTargetInfluences.slice()), void 0 !== t1.morphTargetDictionary && (this.morphTargetDictionary = Object.assign({}, t1.morphTargetDictionary)), this.material = Array.isArray(t1.material) ? t1.material.slice() : t1.material, this.geometry = t1.geometry, this;
            }
            updateMorphTargets() {
                const t1 = this.geometry.morphAttributes, e = Object.keys(t1);
                if (e.length > 0) {
                    const i = t1[e[0]];
                    if (void 0 !== i) {
                        this.morphTargetInfluences = [], this.morphTargetDictionary = {};
                        for(let t1 = 0, e = i.length; t1 < e; t1++){
                            const e = i[t1].name || String(t1);
                            this.morphTargetInfluences.push(0), this.morphTargetDictionary[e] = t1;
                        }
                    }
                }
            }
            getVertexPosition(t1, e) {
                const i = this.geometry, n = i.attributes.position, r = i.morphAttributes.position, a = i.morphTargetsRelative;
                e.fromBufferAttribute(n, t1);
                const s = this.morphTargetInfluences;
                if (r && s) {
                    zu.set(0, 0, 0);
                    for(let i = 0, n = r.length; i < n; i++){
                        const n = s[i], o = r[i];
                        0 !== n && (Cu.fromBufferAttribute(o, t1), a ? zu.addScaledVector(Cu, n) : zu.addScaledVector(Cu.sub(e), n));
                    }
                    e.add(zu);
                }
                return e;
            }
            raycast(t1, e) {
                const i = this.geometry, n = this.material, r = this.matrixWorld;
                if (void 0 !== n) {
                    if (null === i.boundingSphere && i.computeBoundingSphere(), _u.copy(i.boundingSphere), _u.applyMatrix4(r), Eu.copy(t1.ray).recast(t1.near), !1 === _u.containsPoint(Eu.origin)) {
                        if (null === Eu.intersectSphere(_u, Iu)) return;
                        if (Eu.origin.distanceToSquared(Iu) > (t1.far - t1.near) ** 2) return;
                    }
                    Tu.copy(r).invert(), Eu.copy(t1.ray).applyMatrix4(Tu), null !== i.boundingBox && !1 === Eu.intersectsBox(i.boundingBox) || this._computeIntersections(t1, e, Eu);
                }
            }
            _computeIntersections(t1, e, i) {
                let n;
                const r = this.geometry, a = this.material, s = r.index, o = r.attributes.position, l = r.attributes.uv, c = r.attributes.uv1, u = r.attributes.normal, h = r.groups, d = r.drawRange;
                if (null !== s) {
                    if (Array.isArray(a)) for(let r = 0, o = h.length; r < o; r++){
                        const o = h[r], p = a[o.materialIndex];
                        for(let r = Math.max(o.start, d.start), a = Math.min(s.count, Math.min(o.start + o.count, d.start + d.count)); r < a; r += 3)n = Qu(this, p, t1, i, l, c, u, s.getX(r), s.getX(r + 1), s.getX(r + 2)), n && (n.faceIndex = Math.floor(r / 3), n.face.materialIndex = o.materialIndex, e.push(n));
                    }
                    else for(let r = Math.max(0, d.start), o = Math.min(s.count, d.start + d.count); r < o; r += 3)n = Qu(this, a, t1, i, l, c, u, s.getX(r), s.getX(r + 1), s.getX(r + 2)), n && (n.faceIndex = Math.floor(r / 3), e.push(n));
                } else if (void 0 !== o) {
                    if (Array.isArray(a)) for(let r = 0, s = h.length; r < s; r++){
                        const s = h[r], p = a[s.materialIndex];
                        for(let r = Math.max(s.start, d.start), a = Math.min(o.count, Math.min(s.start + s.count, d.start + d.count)); r < a; r += 3)n = Qu(this, p, t1, i, l, c, u, r, r + 1, r + 2), n && (n.faceIndex = Math.floor(r / 3), n.face.materialIndex = s.materialIndex, e.push(n));
                    }
                    else for(let r = Math.max(0, d.start), s = Math.min(o.count, d.start + d.count); r < s; r += 3)n = Qu(this, a, t1, i, l, c, u, r, r + 1, r + 2), n && (n.faceIndex = Math.floor(r / 3), e.push(n));
                }
            }
        }
        function Qu(t1, e, i, n, r, a, s, o, l, c) {
            t1.getVertexPosition(o, Su), t1.getVertexPosition(l, Nu), t1.getVertexPosition(c, Du);
            const u = function(t1, e, i, n, r, a, s, o) {
                let l;
                if (l = e.side === lr ? n.intersectTriangle(s, a, r, !0, o) : n.intersectTriangle(r, a, s, e.side === or, o), null === l) return null;
                Bu.copy(o), Bu.applyMatrix4(t1.matrixWorld);
                const c = i.ray.origin.distanceTo(Bu);
                return c < i.near || c > i.far ? null : {
                    distance: c,
                    point: Bu.clone(),
                    object: t1
                };
            }(t1, e, i, n, Su, Nu, Du, Uu);
            if (u) {
                r && (Lu.fromBufferAttribute(r, o), Ou.fromBufferAttribute(r, l), Pu.fromBufferAttribute(r, c), u.uv = Qc.getInterpolation(Uu, Su, Nu, Du, Lu, Ou, Pu, new qo)), a && (Lu.fromBufferAttribute(a, o), Ou.fromBufferAttribute(a, l), Pu.fromBufferAttribute(a, c), u.uv1 = Qc.getInterpolation(Uu, Su, Nu, Du, Lu, Ou, Pu, new qo), u.uv2 = u.uv1), s && (ju.fromBufferAttribute(s, o), Ru.fromBufferAttribute(s, l), ku.fromBufferAttribute(s, c), u.normal = Qc.getInterpolation(Uu, Su, Nu, Du, ju, Ru, ku, new Nl), u.normal.dot(n.direction) > 0 && u.normal.multiplyScalar(-1));
                const t1 = {
                    a: o,
                    b: l,
                    c: c,
                    normal: new Nl,
                    materialIndex: 0
                };
                Qc.getNormal(Su, Nu, Du, t1.normal), u.face = t1;
            }
            return u;
        }
        class Hu extends bu {
            constructor(t1 = 1, e = 1, i = 1, n = 1, r = 1, a = 1){
                super(), this.type = "BoxGeometry", this.parameters = {
                    width: t1,
                    height: e,
                    depth: i,
                    widthSegments: n,
                    heightSegments: r,
                    depthSegments: a
                };
                const s = this;
                n = Math.floor(n), r = Math.floor(r), a = Math.floor(a);
                const o = [], l = [], c = [], u = [];
                let h = 0, d = 0;
                function p(t1, e, i, n, r, a, p, A, f, m, g) {
                    const M = a / f, v = p / m, y = a / 2, x = p / 2, w = A / 2, b = f + 1, T = m + 1;
                    let E = 0, _ = 0;
                    const I = new Nl;
                    for(let a = 0; a < T; a++){
                        const s = a * v - x;
                        for(let o = 0; o < b; o++){
                            const h = o * M - y;
                            I[t1] = h * n, I[e] = s * r, I[i] = w, l.push(I.x, I.y, I.z), I[t1] = 0, I[e] = 0, I[i] = A > 0 ? 1 : -1, c.push(I.x, I.y, I.z), u.push(o / f), u.push(1 - a / m), E += 1;
                        }
                    }
                    for(let t1 = 0; t1 < m; t1++)for(let e = 0; e < f; e++){
                        const i = h + e + b * t1, n = h + e + b * (t1 + 1), r = h + (e + 1) + b * (t1 + 1), a = h + (e + 1) + b * t1;
                        o.push(i, n, a), o.push(n, r, a), _ += 6;
                    }
                    s.addGroup(d, _, g), d += _, h += E;
                }
                p("z", "y", "x", -1, -1, i, e, t1, a, r, 0), p("z", "y", "x", 1, -1, i, e, -t1, a, r, 1), p("x", "z", "y", 1, 1, t1, i, e, n, a, 2), p("x", "z", "y", 1, -1, t1, i, -e, n, a, 3), p("x", "y", "z", 1, -1, t1, e, i, n, r, 4), p("x", "y", "z", -1, -1, t1, e, -i, n, r, 5), this.setIndex(o), this.setAttribute("position", new Au(l, 3)), this.setAttribute("normal", new Au(c, 3)), this.setAttribute("uv", new Au(u, 2));
            }
            copy(t1) {
                return super.copy(t1), this.parameters = Object.assign({}, t1.parameters), this;
            }
            static fromJSON(t1) {
                return new Hu(t1.width, t1.height, t1.depth, t1.widthSegments, t1.heightSegments, t1.depthSegments);
            }
        }
        function Vu(t1) {
            const e = {};
            for(const i in t1){
                e[i] = {};
                for(const n in t1[i]){
                    const r = t1[i][n];
                    r && (r.isColor || r.isMatrix3 || r.isMatrix4 || r.isVector2 || r.isVector3 || r.isVector4 || r.isTexture || r.isQuaternion) ? r.isRenderTargetTexture ? (console.warn("UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms()."), e[i][n] = null) : e[i][n] = r.clone() : Array.isArray(r) ? e[i][n] = r.slice() : e[i][n] = r;
                }
            }
            return e;
        }
        function Gu(t1) {
            const e = {};
            for(let i = 0; i < t1.length; i++){
                const n = Vu(t1[i]);
                for(const t1 in n)e[t1] = n[t1];
            }
            return e;
        }
        function Wu(t1) {
            return null === t1.getRenderTarget() ? t1.outputColorSpace : ul.workingColorSpace;
        }
        const Yu = {
            clone: Vu,
            merge: Gu
        };
        class Xu extends qc {
            constructor(t1){
                super(), this.isShaderMaterial = !0, this.type = "ShaderMaterial", this.defines = {}, this.uniforms = {}, this.uniformsGroups = [], this.vertexShader = "void main() {\n	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}", this.fragmentShader = "void main() {\n	gl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}", this.linewidth = 1, this.wireframe = !1, this.wireframeLinewidth = 1, this.fog = !1, this.lights = !1, this.clipping = !1, this.forceSinglePass = !0, this.extensions = {
                    derivatives: !1,
                    fragDepth: !1,
                    drawBuffers: !1,
                    shaderTextureLOD: !1
                }, this.defaultAttributeValues = {
                    color: [
                        1,
                        1,
                        1
                    ],
                    uv: [
                        0,
                        0
                    ],
                    uv1: [
                        0,
                        0
                    ]
                }, this.index0AttributeName = void 0, this.uniformsNeedUpdate = !1, this.glslVersion = null, void 0 !== t1 && this.setValues(t1);
            }
            copy(t1) {
                return super.copy(t1), this.fragmentShader = t1.fragmentShader, this.vertexShader = t1.vertexShader, this.uniforms = Vu(t1.uniforms), this.uniformsGroups = function(t1) {
                    const e = [];
                    for(let i = 0; i < t1.length; i++)e.push(t1[i].clone());
                    return e;
                }(t1.uniformsGroups), this.defines = Object.assign({}, t1.defines), this.wireframe = t1.wireframe, this.wireframeLinewidth = t1.wireframeLinewidth, this.fog = t1.fog, this.lights = t1.lights, this.clipping = t1.clipping, this.extensions = Object.assign({}, t1.extensions), this.glslVersion = t1.glslVersion, this;
            }
            toJSON(t1) {
                const e = super.toJSON(t1);
                e.glslVersion = this.glslVersion, e.uniforms = {};
                for(const i in this.uniforms){
                    const n = this.uniforms[i].value;
                    n && n.isTexture ? e.uniforms[i] = {
                        type: "t",
                        value: n.toJSON(t1).uuid
                    } : n && n.isColor ? e.uniforms[i] = {
                        type: "c",
                        value: n.getHex()
                    } : n && n.isVector2 ? e.uniforms[i] = {
                        type: "v2",
                        value: n.toArray()
                    } : n && n.isVector3 ? e.uniforms[i] = {
                        type: "v3",
                        value: n.toArray()
                    } : n && n.isVector4 ? e.uniforms[i] = {
                        type: "v4",
                        value: n.toArray()
                    } : n && n.isMatrix3 ? e.uniforms[i] = {
                        type: "m3",
                        value: n.toArray()
                    } : n && n.isMatrix4 ? e.uniforms[i] = {
                        type: "m4",
                        value: n.toArray()
                    } : e.uniforms[i] = {
                        value: n
                    };
                }
                Object.keys(this.defines).length > 0 && (e.defines = this.defines), e.vertexShader = this.vertexShader, e.fragmentShader = this.fragmentShader, e.lights = this.lights, e.clipping = this.clipping;
                const i = {};
                for(const t1 in this.extensions)!0 === this.extensions[t1] && (i[t1] = !0);
                return Object.keys(i).length > 0 && (e.extensions = i), e;
            }
        }
        class Zu extends Dc {
            constructor(){
                super(), this.isCamera = !0, this.type = "Camera", this.matrixWorldInverse = new ac, this.projectionMatrix = new ac, this.projectionMatrixInverse = new ac, this.coordinateSystem = Lo;
            }
            copy(t1, e) {
                return super.copy(t1, e), this.matrixWorldInverse.copy(t1.matrixWorldInverse), this.projectionMatrix.copy(t1.projectionMatrix), this.projectionMatrixInverse.copy(t1.projectionMatrixInverse), this.coordinateSystem = t1.coordinateSystem, this;
            }
            getWorldDirection(t1) {
                return super.getWorldDirection(t1).negate();
            }
            updateMatrixWorld(t1) {
                super.updateMatrixWorld(t1), this.matrixWorldInverse.copy(this.matrixWorld).invert();
            }
            updateWorldMatrix(t1, e) {
                super.updateWorldMatrix(t1, e), this.matrixWorldInverse.copy(this.matrixWorld).invert();
            }
            clone() {
                return (new this.constructor).copy(this);
            }
        }
        class qu extends Zu {
            constructor(t1 = 50, e = 1, i = .1, n = 2e3){
                super(), this.isPerspectiveCamera = !0, this.type = "PerspectiveCamera", this.fov = t1, this.zoom = 1, this.near = i, this.far = n, this.focus = 10, this.aspect = e, this.view = null, this.filmGauge = 35, this.filmOffset = 0, this.updateProjectionMatrix();
            }
            copy(t1, e) {
                return super.copy(t1, e), this.fov = t1.fov, this.zoom = t1.zoom, this.near = t1.near, this.far = t1.far, this.focus = t1.focus, this.aspect = t1.aspect, this.view = null === t1.view ? null : Object.assign({}, t1.view), this.filmGauge = t1.filmGauge, this.filmOffset = t1.filmOffset, this;
            }
            setFocalLength(t1) {
                const e = .5 * this.getFilmHeight() / t1;
                this.fov = 2 * Uo * Math.atan(e), this.updateProjectionMatrix();
            }
            getFocalLength() {
                const t1 = Math.tan(.5 * ko * this.fov);
                return .5 * this.getFilmHeight() / t1;
            }
            getEffectiveFOV() {
                return 2 * Uo * Math.atan(Math.tan(.5 * ko * this.fov) / this.zoom);
            }
            getFilmWidth() {
                return this.filmGauge * Math.min(this.aspect, 1);
            }
            getFilmHeight() {
                return this.filmGauge / Math.max(this.aspect, 1);
            }
            setViewOffset(t1, e, i, n, r, a) {
                this.aspect = t1 / e, null === this.view && (this.view = {
                    enabled: !0,
                    fullWidth: 1,
                    fullHeight: 1,
                    offsetX: 0,
                    offsetY: 0,
                    width: 1,
                    height: 1
                }), this.view.enabled = !0, this.view.fullWidth = t1, this.view.fullHeight = e, this.view.offsetX = i, this.view.offsetY = n, this.view.width = r, this.view.height = a, this.updateProjectionMatrix();
            }
            clearViewOffset() {
                null !== this.view && (this.view.enabled = !1), this.updateProjectionMatrix();
            }
            updateProjectionMatrix() {
                const t1 = this.near;
                let e = t1 * Math.tan(.5 * ko * this.fov) / this.zoom, i = 2 * e, n = this.aspect * i, r = -0.5 * n;
                const a = this.view;
                if (null !== this.view && this.view.enabled) {
                    const t1 = a.fullWidth, s = a.fullHeight;
                    r += a.offsetX * n / t1, e -= a.offsetY * i / s, n *= a.width / t1, i *= a.height / s;
                }
                const s = this.filmOffset;
                0 !== s && (r += t1 * s / this.getFilmWidth()), this.projectionMatrix.makePerspective(r, r + n, e, e - i, t1, this.far, this.coordinateSystem), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
            }
            toJSON(t1) {
                const e = super.toJSON(t1);
                return e.object.fov = this.fov, e.object.zoom = this.zoom, e.object.near = this.near, e.object.far = this.far, e.object.focus = this.focus, e.object.aspect = this.aspect, null !== this.view && (e.object.view = Object.assign({}, this.view)), e.object.filmGauge = this.filmGauge, e.object.filmOffset = this.filmOffset, e;
            }
        }
        const Ju = -90;
        class Ku extends Dc {
            constructor(t1, e, i){
                super(), this.type = "CubeCamera", this.renderTarget = i, this.coordinateSystem = null, this.activeMipmapLevel = 0;
                const n = new qu(Ju, 1, t1, e);
                n.layers = this.layers, this.add(n);
                const r = new qu(Ju, 1, t1, e);
                r.layers = this.layers, this.add(r);
                const a = new qu(Ju, 1, t1, e);
                a.layers = this.layers, this.add(a);
                const s = new qu(Ju, 1, t1, e);
                s.layers = this.layers, this.add(s);
                const o = new qu(Ju, 1, t1, e);
                o.layers = this.layers, this.add(o);
                const l = new qu(Ju, 1, t1, e);
                l.layers = this.layers, this.add(l);
            }
            updateCoordinateSystem() {
                const t1 = this.coordinateSystem, e = this.children.concat(), [i, n, r, a, s, o] = e;
                for (const t1 of e)this.remove(t1);
                if (t1 === Lo) i.up.set(0, 1, 0), i.lookAt(1, 0, 0), n.up.set(0, 1, 0), n.lookAt(-1, 0, 0), r.up.set(0, 0, -1), r.lookAt(0, 1, 0), a.up.set(0, 0, 1), a.lookAt(0, -1, 0), s.up.set(0, 1, 0), s.lookAt(0, 0, 1), o.up.set(0, 1, 0), o.lookAt(0, 0, -1);
                else {
                    if (t1 !== Oo) throw new Error("THREE.CubeCamera.updateCoordinateSystem(): Invalid coordinate system: " + t1);
                    i.up.set(0, -1, 0), i.lookAt(-1, 0, 0), n.up.set(0, -1, 0), n.lookAt(1, 0, 0), r.up.set(0, 0, 1), r.lookAt(0, 1, 0), a.up.set(0, 0, -1), a.lookAt(0, -1, 0), s.up.set(0, -1, 0), s.lookAt(0, 0, 1), o.up.set(0, -1, 0), o.lookAt(0, 0, -1);
                }
                for (const t1 of e)this.add(t1), t1.updateMatrixWorld();
            }
            update(t1, e) {
                null === this.parent && this.updateMatrixWorld();
                const { renderTarget: i, activeMipmapLevel: n } = this;
                this.coordinateSystem !== t1.coordinateSystem && (this.coordinateSystem = t1.coordinateSystem, this.updateCoordinateSystem());
                const [r, a, s, o, l, c] = this.children, u = t1.getRenderTarget(), h = t1.getActiveCubeFace(), d = t1.getActiveMipmapLevel(), p = t1.xr.enabled;
                t1.xr.enabled = !1;
                const A = i.texture.generateMipmaps;
                i.texture.generateMipmaps = !1, t1.setRenderTarget(i, 0, n), t1.render(e, r), t1.setRenderTarget(i, 1, n), t1.render(e, a), t1.setRenderTarget(i, 2, n), t1.render(e, s), t1.setRenderTarget(i, 3, n), t1.render(e, o), t1.setRenderTarget(i, 4, n), t1.render(e, l), i.texture.generateMipmaps = A, t1.setRenderTarget(i, 5, n), t1.render(e, c), t1.setRenderTarget(u, h, d), t1.xr.enabled = p, i.texture.needsPMREMUpdate = !0;
            }
        }
        class $u extends vl {
            constructor(t1, e, i, n, r, a, s, o, l, c){
                super(t1 = void 0 !== t1 ? t1 : [], e = void 0 !== e ? e : na, i, n, r, a, s, o, l, c), this.isCubeTexture = !0, this.flipY = !1;
            }
            get images() {
                return this.image;
            }
            set images(t1) {
                this.image = t1;
            }
        }
        class th extends wl {
            constructor(t1 = 1, e = {}){
                super(t1, t1, e), this.isWebGLCubeRenderTarget = !0;
                const i = {
                    width: t1,
                    height: t1,
                    depth: 1
                }, n = [
                    i,
                    i,
                    i,
                    i,
                    i,
                    i
                ];
                void 0 !== e.encoding && (al("THREE.WebGLCubeRenderTarget: option.encoding has been replaced by option.colorSpace."), e.colorSpace = e.encoding === js ? Qs : Fs), this.texture = new $u(n, e.mapping, e.wrapS, e.wrapT, e.magFilter, e.minFilter, e.format, e.type, e.anisotropy, e.colorSpace), this.texture.isRenderTargetTexture = !0, this.texture.generateMipmaps = void 0 !== e.generateMipmaps && e.generateMipmaps, this.texture.minFilter = void 0 !== e.minFilter ? e.minFilter : ma;
            }
            fromEquirectangularTexture(t1, e) {
                this.texture.type = e.type, this.texture.colorSpace = e.colorSpace, this.texture.generateMipmaps = e.generateMipmaps, this.texture.minFilter = e.minFilter, this.texture.magFilter = e.magFilter;
                const i = {
                    tEquirect: {
                        value: null
                    }
                }, n = "\n\n				varying vec3 vWorldDirection;\n\n				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\n					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n\n				}\n\n				void main() {\n\n					vWorldDirection = transformDirection( position, modelMatrix );\n\n					#include <begin_vertex>\n					#include <project_vertex>\n\n				}\n			", r = "\n\n				uniform sampler2D tEquirect;\n\n				varying vec3 vWorldDirection;\n\n				#include <common>\n\n				void main() {\n\n					vec3 direction = normalize( vWorldDirection );\n\n					vec2 sampleUV = equirectUv( direction );\n\n					gl_FragColor = texture2D( tEquirect, sampleUV );\n\n				}\n			", a = new Hu(5, 5, 5), s = new Xu({
                    name: "CubemapFromEquirect",
                    uniforms: Vu(i),
                    vertexShader: n,
                    fragmentShader: r,
                    side: lr,
                    blending: hr
                });
                s.uniforms.tEquirect.value = e;
                const o = new Fu(a, s), l = e.minFilter;
                return e.minFilter === va && (e.minFilter = ma), new Ku(1, 10, this).update(t1, o), e.minFilter = l, o.geometry.dispose(), o.material.dispose(), this;
            }
            clear(t1, e, i, n) {
                const r = t1.getRenderTarget();
                for(let r = 0; r < 6; r++)t1.setRenderTarget(this, r), t1.clear(e, i, n);
                t1.setRenderTarget(r);
            }
        }
        const eh = new Nl, ih = new Nl, nh = new Jo;
        class rh {
            constructor(t1 = new Nl(1, 0, 0), e = 0){
                this.isPlane = !0, this.normal = t1, this.constant = e;
            }
            set(t1, e) {
                return this.normal.copy(t1), this.constant = e, this;
            }
            setComponents(t1, e, i, n) {
                return this.normal.set(t1, e, i), this.constant = n, this;
            }
            setFromNormalAndCoplanarPoint(t1, e) {
                return this.normal.copy(t1), this.constant = -e.dot(this.normal), this;
            }
            setFromCoplanarPoints(t1, e, i) {
                const n = eh.subVectors(i, e).cross(ih.subVectors(t1, e)).normalize();
                return this.setFromNormalAndCoplanarPoint(n, t1), this;
            }
            copy(t1) {
                return this.normal.copy(t1.normal), this.constant = t1.constant, this;
            }
            normalize() {
                const t1 = 1 / this.normal.length();
                return this.normal.multiplyScalar(t1), this.constant *= t1, this;
            }
            negate() {
                return this.constant *= -1, this.normal.negate(), this;
            }
            distanceToPoint(t1) {
                return this.normal.dot(t1) + this.constant;
            }
            distanceToSphere(t1) {
                return this.distanceToPoint(t1.center) - t1.radius;
            }
            projectPoint(t1, e) {
                return e.copy(t1).addScaledVector(this.normal, -this.distanceToPoint(t1));
            }
            intersectLine(t1, e) {
                const i = t1.delta(eh), n = this.normal.dot(i);
                if (0 === n) return 0 === this.distanceToPoint(t1.start) ? e.copy(t1.start) : null;
                const r = -(t1.start.dot(this.normal) + this.constant) / n;
                return r < 0 || r > 1 ? null : e.copy(t1.start).addScaledVector(i, r);
            }
            intersectsLine(t1) {
                const e = this.distanceToPoint(t1.start), i = this.distanceToPoint(t1.end);
                return e < 0 && i > 0 || i < 0 && e > 0;
            }
            intersectsBox(t1) {
                return t1.intersectsPlane(this);
            }
            intersectsSphere(t1) {
                return t1.intersectsPlane(this);
            }
            coplanarPoint(t1) {
                return t1.copy(this.normal).multiplyScalar(-this.constant);
            }
            applyMatrix4(t1, e) {
                const i = e || nh.getNormalMatrix(t1), n = this.coplanarPoint(eh).applyMatrix4(t1), r = this.normal.applyMatrix3(i).normalize();
                return this.constant = -n.dot(r), this;
            }
            translate(t1) {
                return this.constant -= t1.dot(this.normal), this;
            }
            equals(t1) {
                return t1.normal.equals(this.normal) && t1.constant === this.constant;
            }
            clone() {
                return (new this.constructor).copy(this);
            }
        }
        const ah = new ql, sh = new Nl;
        class oh {
            constructor(t1 = new rh, e = new rh, i = new rh, n = new rh, r = new rh, a = new rh){
                this.planes = [
                    t1,
                    e,
                    i,
                    n,
                    r,
                    a
                ];
            }
            set(t1, e, i, n, r, a) {
                const s = this.planes;
                return s[0].copy(t1), s[1].copy(e), s[2].copy(i), s[3].copy(n), s[4].copy(r), s[5].copy(a), this;
            }
            copy(t1) {
                const e = this.planes;
                for(let i = 0; i < 6; i++)e[i].copy(t1.planes[i]);
                return this;
            }
            setFromProjectionMatrix(t1, e = Lo) {
                const i = this.planes, n = t1.elements, r = n[0], a = n[1], s = n[2], o = n[3], l = n[4], c = n[5], u = n[6], h = n[7], d = n[8], p = n[9], A = n[10], f = n[11], m = n[12], g = n[13], M = n[14], v = n[15];
                if (i[0].setComponents(o - r, h - l, f - d, v - m).normalize(), i[1].setComponents(o + r, h + l, f + d, v + m).normalize(), i[2].setComponents(o + a, h + c, f + p, v + g).normalize(), i[3].setComponents(o - a, h - c, f - p, v - g).normalize(), i[4].setComponents(o - s, h - u, f - A, v - M).normalize(), e === Lo) i[5].setComponents(o + s, h + u, f + A, v + M).normalize();
                else {
                    if (e !== Oo) throw new Error("THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: " + e);
                    i[5].setComponents(s, u, A, M).normalize();
                }
                return this;
            }
            intersectsObject(t1) {
                if (void 0 !== t1.boundingSphere) null === t1.boundingSphere && t1.computeBoundingSphere(), ah.copy(t1.boundingSphere).applyMatrix4(t1.matrixWorld);
                else {
                    const e = t1.geometry;
                    null === e.boundingSphere && e.computeBoundingSphere(), ah.copy(e.boundingSphere).applyMatrix4(t1.matrixWorld);
                }
                return this.intersectsSphere(ah);
            }
            intersectsSprite(t1) {
                return ah.center.set(0, 0, 0), ah.radius = .7071067811865476, ah.applyMatrix4(t1.matrixWorld), this.intersectsSphere(ah);
            }
            intersectsSphere(t1) {
                const e = this.planes, i = t1.center, n = -t1.radius;
                for(let t1 = 0; t1 < 6; t1++)if (e[t1].distanceToPoint(i) < n) return !1;
                return !0;
            }
            intersectsBox(t1) {
                const e = this.planes;
                for(let i = 0; i < 6; i++){
                    const n = e[i];
                    if (sh.x = n.normal.x > 0 ? t1.max.x : t1.min.x, sh.y = n.normal.y > 0 ? t1.max.y : t1.min.y, sh.z = n.normal.z > 0 ? t1.max.z : t1.min.z, n.distanceToPoint(sh) < 0) return !1;
                }
                return !0;
            }
            containsPoint(t1) {
                const e = this.planes;
                for(let i = 0; i < 6; i++)if (e[i].distanceToPoint(t1) < 0) return !1;
                return !0;
            }
            clone() {
                return (new this.constructor).copy(this);
            }
        }
        function lh() {
            let t1 = null, e = !1, i = null, n = null;
            function r(e, a) {
                i(e, a), n = t1.requestAnimationFrame(r);
            }
            return {
                start: function() {
                    !0 !== e && null !== i && (n = t1.requestAnimationFrame(r), e = !0);
                },
                stop: function() {
                    t1.cancelAnimationFrame(n), e = !1;
                },
                setAnimationLoop: function(t1) {
                    i = t1;
                },
                setContext: function(e) {
                    t1 = e;
                }
            };
        }
        function ch(t1, e) {
            const i = e.isWebGL2, n = new WeakMap;
            return {
                get: function(t1) {
                    return t1.isInterleavedBufferAttribute && (t1 = t1.data), n.get(t1);
                },
                remove: function(e) {
                    e.isInterleavedBufferAttribute && (e = e.data);
                    const i = n.get(e);
                    i && (t1.deleteBuffer(i.buffer), n.delete(e));
                },
                update: function(e, r) {
                    if (e.isGLBufferAttribute) {
                        const t1 = n.get(e);
                        return void ((!t1 || t1.version < e.version) && n.set(e, {
                            buffer: e.buffer,
                            type: e.type,
                            bytesPerElement: e.elementSize,
                            version: e.version
                        }));
                    }
                    e.isInterleavedBufferAttribute && (e = e.data);
                    const a = n.get(e);
                    void 0 === a ? n.set(e, function(e, n) {
                        const r = e.array, a = e.usage, s = t1.createBuffer();
                        let o;
                        if (t1.bindBuffer(n, s), t1.bufferData(n, r, a), e.onUploadCallback(), r instanceof Float32Array) o = t1.FLOAT;
                        else if (r instanceof Uint16Array) {
                            if (e.isFloat16BufferAttribute) {
                                if (!i) throw new Error("THREE.WebGLAttributes: Usage of Float16BufferAttribute requires WebGL2.");
                                o = t1.HALF_FLOAT;
                            } else o = t1.UNSIGNED_SHORT;
                        } else if (r instanceof Int16Array) o = t1.SHORT;
                        else if (r instanceof Uint32Array) o = t1.UNSIGNED_INT;
                        else if (r instanceof Int32Array) o = t1.INT;
                        else if (r instanceof Int8Array) o = t1.BYTE;
                        else if (r instanceof Uint8Array) o = t1.UNSIGNED_BYTE;
                        else {
                            if (!(r instanceof Uint8ClampedArray)) throw new Error("THREE.WebGLAttributes: Unsupported buffer data format: " + r);
                            o = t1.UNSIGNED_BYTE;
                        }
                        return {
                            buffer: s,
                            type: o,
                            bytesPerElement: r.BYTES_PER_ELEMENT,
                            version: e.version
                        };
                    }(e, r)) : a.version < e.version && (function(e, n, r) {
                        const a = n.array, s = n.updateRange;
                        t1.bindBuffer(r, e), -1 === s.count ? t1.bufferSubData(r, 0, a) : (i ? t1.bufferSubData(r, s.offset * a.BYTES_PER_ELEMENT, a, s.offset, s.count) : t1.bufferSubData(r, s.offset * a.BYTES_PER_ELEMENT, a.subarray(s.offset, s.offset + s.count)), s.count = -1), n.onUploadCallback();
                    }(a.buffer, e, r), a.version = e.version);
                }
            };
        }
        class uh extends bu {
            constructor(t1 = 1, e = 1, i = 1, n = 1){
                super(), this.type = "PlaneGeometry", this.parameters = {
                    width: t1,
                    height: e,
                    widthSegments: i,
                    heightSegments: n
                };
                const r = t1 / 2, a = e / 2, s = Math.floor(i), o = Math.floor(n), l = s + 1, c = o + 1, u = t1 / s, h = e / o, d = [], p = [], A = [], f = [];
                for(let t1 = 0; t1 < c; t1++){
                    const e = t1 * h - a;
                    for(let i = 0; i < l; i++){
                        const n = i * u - r;
                        p.push(n, -e, 0), A.push(0, 0, 1), f.push(i / s), f.push(1 - t1 / o);
                    }
                }
                for(let t1 = 0; t1 < o; t1++)for(let e = 0; e < s; e++){
                    const i = e + l * t1, n = e + l * (t1 + 1), r = e + 1 + l * (t1 + 1), a = e + 1 + l * t1;
                    d.push(i, n, a), d.push(n, r, a);
                }
                this.setIndex(d), this.setAttribute("position", new Au(p, 3)), this.setAttribute("normal", new Au(A, 3)), this.setAttribute("uv", new Au(f, 2));
            }
            copy(t1) {
                return super.copy(t1), this.parameters = Object.assign({}, t1.parameters), this;
            }
            static fromJSON(t1) {
                return new uh(t1.width, t1.height, t1.widthSegments, t1.heightSegments);
            }
        }
        const hh = {
            alphahash_fragment: "#ifdef USE_ALPHAHASH\n	if ( diffuseColor.a < getAlphaHashThreshold( vPosition ) ) discard;\n#endif",
            alphahash_pars_fragment: "#ifdef USE_ALPHAHASH\n	const float ALPHA_HASH_SCALE = 0.05;\n	float hash2D( vec2 value ) {\n		return fract( 1.0e4 * sin( 17.0 * value.x + 0.1 * value.y ) * ( 0.1 + abs( sin( 13.0 * value.y + value.x ) ) ) );\n	}\n	float hash3D( vec3 value ) {\n		return hash2D( vec2( hash2D( value.xy ), value.z ) );\n	}\n	float getAlphaHashThreshold( vec3 position ) {\n		float maxDeriv = max(\n			length( dFdx( position.xyz ) ),\n			length( dFdy( position.xyz ) )\n		);\n		float pixScale = 1.0 / ( ALPHA_HASH_SCALE * maxDeriv );\n		vec2 pixScales = vec2(\n			exp2( floor( log2( pixScale ) ) ),\n			exp2( ceil( log2( pixScale ) ) )\n		);\n		vec2 alpha = vec2(\n			hash3D( floor( pixScales.x * position.xyz ) ),\n			hash3D( floor( pixScales.y * position.xyz ) )\n		);\n		float lerpFactor = fract( log2( pixScale ) );\n		float x = ( 1.0 - lerpFactor ) * alpha.x + lerpFactor * alpha.y;\n		float a = min( lerpFactor, 1.0 - lerpFactor );\n		vec3 cases = vec3(\n			x * x / ( 2.0 * a * ( 1.0 - a ) ),\n			( x - 0.5 * a ) / ( 1.0 - a ),\n			1.0 - ( ( 1.0 - x ) * ( 1.0 - x ) / ( 2.0 * a * ( 1.0 - a ) ) )\n		);\n		float threshold = ( x < ( 1.0 - a ) )\n			? ( ( x < a ) ? cases.x : cases.y )\n			: cases.z;\n		return clamp( threshold , 1.0e-6, 1.0 );\n	}\n#endif",
            alphamap_fragment: "#ifdef USE_ALPHAMAP\n	diffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;\n#endif",
            alphamap_pars_fragment: "#ifdef USE_ALPHAMAP\n	uniform sampler2D alphaMap;\n#endif",
            alphatest_fragment: "#ifdef USE_ALPHATEST\n	if ( diffuseColor.a < alphaTest ) discard;\n#endif",
            alphatest_pars_fragment: "#ifdef USE_ALPHATEST\n	uniform float alphaTest;\n#endif",
            aomap_fragment: "#ifdef USE_AOMAP\n	float ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;\n	reflectedLight.indirectDiffuse *= ambientOcclusion;\n	#if defined( USE_CLEARCOAT ) \n		clearcoatSpecularIndirect *= ambientOcclusion;\n	#endif\n	#if defined( USE_SHEEN ) \n		sheenSpecularIndirect *= ambientOcclusion;\n	#endif\n	#if defined( USE_ENVMAP ) && defined( STANDARD )\n		float dotNV = saturate( dot( geometryNormal, geometryViewDir ) );\n		reflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\n	#endif\n#endif",
            aomap_pars_fragment: "#ifdef USE_AOMAP\n	uniform sampler2D aoMap;\n	uniform float aoMapIntensity;\n#endif",
            begin_vertex: "vec3 transformed = vec3( position );\n#ifdef USE_ALPHAHASH\n	vPosition = vec3( position );\n#endif",
            beginnormal_vertex: "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n	vec3 objectTangent = vec3( tangent.xyz );\n#endif",
            bsdfs: "float G_BlinnPhong_Implicit( ) {\n	return 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n	return RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float dotVH = saturate( dot( viewDir, halfDir ) );\n	vec3 F = F_Schlick( specularColor, 1.0, dotVH );\n	float G = G_BlinnPhong_Implicit( );\n	float D = D_BlinnPhong( shininess, dotNH );\n	return F * ( G * D );\n} // validated",
            iridescence_fragment: "#ifdef USE_IRIDESCENCE\n	const mat3 XYZ_TO_REC709 = mat3(\n		 3.2404542, -0.9692660,  0.0556434,\n		-1.5371385,  1.8760108, -0.2040259,\n		-0.4985314,  0.0415560,  1.0572252\n	);\n	vec3 Fresnel0ToIor( vec3 fresnel0 ) {\n		vec3 sqrtF0 = sqrt( fresnel0 );\n		return ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );\n	}\n	vec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {\n		return pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );\n	}\n	float IorToFresnel0( float transmittedIor, float incidentIor ) {\n		return pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));\n	}\n	vec3 evalSensitivity( float OPD, vec3 shift ) {\n		float phase = 2.0 * PI * OPD * 1.0e-9;\n		vec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );\n		vec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );\n		vec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );\n		vec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );\n		xyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );\n		xyz /= 1.0685e-7;\n		vec3 rgb = XYZ_TO_REC709 * xyz;\n		return rgb;\n	}\n	vec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {\n		vec3 I;\n		float iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );\n		float sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );\n		float cosTheta2Sq = 1.0 - sinTheta2Sq;\n		if ( cosTheta2Sq < 0.0 ) {\n			return vec3( 1.0 );\n		}\n		float cosTheta2 = sqrt( cosTheta2Sq );\n		float R0 = IorToFresnel0( iridescenceIOR, outsideIOR );\n		float R12 = F_Schlick( R0, 1.0, cosTheta1 );\n		float T121 = 1.0 - R12;\n		float phi12 = 0.0;\n		if ( iridescenceIOR < outsideIOR ) phi12 = PI;\n		float phi21 = PI - phi12;\n		vec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );		vec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );\n		vec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );\n		vec3 phi23 = vec3( 0.0 );\n		if ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;\n		if ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;\n		if ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;\n		float OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;\n		vec3 phi = vec3( phi21 ) + phi23;\n		vec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );\n		vec3 r123 = sqrt( R123 );\n		vec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );\n		vec3 C0 = R12 + Rs;\n		I = C0;\n		vec3 Cm = Rs - T121;\n		for ( int m = 1; m <= 2; ++ m ) {\n			Cm *= r123;\n			vec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );\n			I += Cm * Sm;\n		}\n		return max( I, vec3( 0.0 ) );\n	}\n#endif",
            bumpmap_pars_fragment: "#ifdef USE_BUMPMAP\n	uniform sampler2D bumpMap;\n	uniform float bumpScale;\n	vec2 dHdxy_fwd() {\n		vec2 dSTdx = dFdx( vBumpMapUv );\n		vec2 dSTdy = dFdy( vBumpMapUv );\n		float Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;\n		float dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;\n		float dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;\n		return vec2( dBx, dBy );\n	}\n	vec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n		vec3 vSigmaX = normalize( dFdx( surf_pos.xyz ) );\n		vec3 vSigmaY = normalize( dFdy( surf_pos.xyz ) );\n		vec3 vN = surf_norm;\n		vec3 R1 = cross( vSigmaY, vN );\n		vec3 R2 = cross( vN, vSigmaX );\n		float fDet = dot( vSigmaX, R1 ) * faceDirection;\n		vec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n		return normalize( abs( fDet ) * surf_norm - vGrad );\n	}\n#endif",
            clipping_planes_fragment: "#if NUM_CLIPPING_PLANES > 0\n	vec4 plane;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n		plane = clippingPlanes[ i ];\n		if ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n	}\n	#pragma unroll_loop_end\n	#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n		bool clipped = true;\n		#pragma unroll_loop_start\n		for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n			plane = clippingPlanes[ i ];\n			clipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n		}\n		#pragma unroll_loop_end\n		if ( clipped ) discard;\n	#endif\n#endif",
            clipping_planes_pars_fragment: "#if NUM_CLIPPING_PLANES > 0\n	varying vec3 vClipPosition;\n	uniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif",
            clipping_planes_pars_vertex: "#if NUM_CLIPPING_PLANES > 0\n	varying vec3 vClipPosition;\n#endif",
            clipping_planes_vertex: "#if NUM_CLIPPING_PLANES > 0\n	vClipPosition = - mvPosition.xyz;\n#endif",
            color_fragment: "#if defined( USE_COLOR_ALPHA )\n	diffuseColor *= vColor;\n#elif defined( USE_COLOR )\n	diffuseColor.rgb *= vColor;\n#endif",
            color_pars_fragment: "#if defined( USE_COLOR_ALPHA )\n	varying vec4 vColor;\n#elif defined( USE_COLOR )\n	varying vec3 vColor;\n#endif",
            color_pars_vertex: "#if defined( USE_COLOR_ALPHA )\n	varying vec4 vColor;\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n	varying vec3 vColor;\n#endif",
            color_vertex: "#if defined( USE_COLOR_ALPHA )\n	vColor = vec4( 1.0 );\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n	vColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n	vColor *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n	vColor.xyz *= instanceColor.xyz;\n#endif",
            common: "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nvec3 pow2( const in vec3 x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\nfloat average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }\nhighp float rand( const in vec2 uv ) {\n	const highp float a = 12.9898, b = 78.233, c = 43758.5453;\n	highp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n	return fract( sin( sn ) * c );\n}\n#ifdef HIGH_PRECISION\n	float precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n	float precisionSafeLength( vec3 v ) {\n		float maxComponent = max3( abs( v ) );\n		return length( v / maxComponent ) * maxComponent;\n	}\n#endif\nstruct IncidentLight {\n	vec3 color;\n	vec3 direction;\n	bool visible;\n};\nstruct ReflectedLight {\n	vec3 directDiffuse;\n	vec3 directSpecular;\n	vec3 indirectDiffuse;\n	vec3 indirectSpecular;\n};\n#ifdef USE_ALPHAHASH\n	varying vec3 vPosition;\n#endif\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n	return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n	return normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nmat3 transposeMat3( const in mat3 m ) {\n	mat3 tmp;\n	tmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n	tmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n	tmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n	return tmp;\n}\nfloat luminance( const in vec3 rgb ) {\n	const vec3 weights = vec3( 0.2126729, 0.7151522, 0.0721750 );\n	return dot( weights, rgb );\n}\nbool isPerspectiveMatrix( mat4 m ) {\n	return m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n	float u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n	float v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n	return vec2( u, v );\n}\nvec3 BRDF_Lambert( const in vec3 diffuseColor ) {\n	return RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\n	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nfloat F_Schlick( const in float f0, const in float f90, const in float dotVH ) {\n	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n} // validated",
            cube_uv_reflection_fragment: "#ifdef ENVMAP_TYPE_CUBE_UV\n	#define cubeUV_minMipLevel 4.0\n	#define cubeUV_minTileSize 16.0\n	float getFace( vec3 direction ) {\n		vec3 absDirection = abs( direction );\n		float face = - 1.0;\n		if ( absDirection.x > absDirection.z ) {\n			if ( absDirection.x > absDirection.y )\n				face = direction.x > 0.0 ? 0.0 : 3.0;\n			else\n				face = direction.y > 0.0 ? 1.0 : 4.0;\n		} else {\n			if ( absDirection.z > absDirection.y )\n				face = direction.z > 0.0 ? 2.0 : 5.0;\n			else\n				face = direction.y > 0.0 ? 1.0 : 4.0;\n		}\n		return face;\n	}\n	vec2 getUV( vec3 direction, float face ) {\n		vec2 uv;\n		if ( face == 0.0 ) {\n			uv = vec2( direction.z, direction.y ) / abs( direction.x );\n		} else if ( face == 1.0 ) {\n			uv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n		} else if ( face == 2.0 ) {\n			uv = vec2( - direction.x, direction.y ) / abs( direction.z );\n		} else if ( face == 3.0 ) {\n			uv = vec2( - direction.z, direction.y ) / abs( direction.x );\n		} else if ( face == 4.0 ) {\n			uv = vec2( - direction.x, direction.z ) / abs( direction.y );\n		} else {\n			uv = vec2( direction.x, direction.y ) / abs( direction.z );\n		}\n		return 0.5 * ( uv + 1.0 );\n	}\n	vec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n		float face = getFace( direction );\n		float filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n		mipInt = max( mipInt, cubeUV_minMipLevel );\n		float faceSize = exp2( mipInt );\n		highp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;\n		if ( face > 2.0 ) {\n			uv.y += faceSize;\n			face -= 3.0;\n		}\n		uv.x += face * faceSize;\n		uv.x += filterInt * 3.0 * cubeUV_minTileSize;\n		uv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );\n		uv.x *= CUBEUV_TEXEL_WIDTH;\n		uv.y *= CUBEUV_TEXEL_HEIGHT;\n		#ifdef texture2DGradEXT\n			return texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;\n		#else\n			return texture2D( envMap, uv ).rgb;\n		#endif\n	}\n	#define cubeUV_r0 1.0\n	#define cubeUV_v0 0.339\n	#define cubeUV_m0 - 2.0\n	#define cubeUV_r1 0.8\n	#define cubeUV_v1 0.276\n	#define cubeUV_m1 - 1.0\n	#define cubeUV_r4 0.4\n	#define cubeUV_v4 0.046\n	#define cubeUV_m4 2.0\n	#define cubeUV_r5 0.305\n	#define cubeUV_v5 0.016\n	#define cubeUV_m5 3.0\n	#define cubeUV_r6 0.21\n	#define cubeUV_v6 0.0038\n	#define cubeUV_m6 4.0\n	float roughnessToMip( float roughness ) {\n		float mip = 0.0;\n		if ( roughness >= cubeUV_r1 ) {\n			mip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;\n		} else if ( roughness >= cubeUV_r4 ) {\n			mip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;\n		} else if ( roughness >= cubeUV_r5 ) {\n			mip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;\n		} else if ( roughness >= cubeUV_r6 ) {\n			mip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;\n		} else {\n			mip = - 2.0 * log2( 1.16 * roughness );		}\n		return mip;\n	}\n	vec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n		float mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );\n		float mipF = fract( mip );\n		float mipInt = floor( mip );\n		vec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n		if ( mipF == 0.0 ) {\n			return vec4( color0, 1.0 );\n		} else {\n			vec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n			return vec4( mix( color0, color1, mipF ), 1.0 );\n		}\n	}\n#endif",
            defaultnormal_vertex: "vec3 transformedNormal = objectNormal;\n#ifdef USE_INSTANCING\n	mat3 m = mat3( instanceMatrix );\n	transformedNormal /= vec3( dot( m[ 0 ], m[ 0 ] ), dot( m[ 1 ], m[ 1 ] ), dot( m[ 2 ], m[ 2 ] ) );\n	transformedNormal = m * transformedNormal;\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n	transformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n	vec3 transformedTangent = ( modelViewMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n	#ifdef FLIP_SIDED\n		transformedTangent = - transformedTangent;\n	#endif\n#endif",
            displacementmap_pars_vertex: "#ifdef USE_DISPLACEMENTMAP\n	uniform sampler2D displacementMap;\n	uniform float displacementScale;\n	uniform float displacementBias;\n#endif",
            displacementmap_vertex: "#ifdef USE_DISPLACEMENTMAP\n	transformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );\n#endif",
            emissivemap_fragment: "#ifdef USE_EMISSIVEMAP\n	vec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );\n	totalEmissiveRadiance *= emissiveColor.rgb;\n#endif",
            emissivemap_pars_fragment: "#ifdef USE_EMISSIVEMAP\n	uniform sampler2D emissiveMap;\n#endif",
            colorspace_fragment: "gl_FragColor = linearToOutputTexel( gl_FragColor );",
            colorspace_pars_fragment: "\nconst mat3 LINEAR_SRGB_TO_LINEAR_DISPLAY_P3 = mat3(\n	vec3( 0.8224621, 0.177538, 0.0 ),\n	vec3( 0.0331941, 0.9668058, 0.0 ),\n	vec3( 0.0170827, 0.0723974, 0.9105199 )\n);\nconst mat3 LINEAR_DISPLAY_P3_TO_LINEAR_SRGB = mat3(\n	vec3( 1.2249401, - 0.2249404, 0.0 ),\n	vec3( - 0.0420569, 1.0420571, 0.0 ),\n	vec3( - 0.0196376, - 0.0786361, 1.0982735 )\n);\nvec4 LinearSRGBToLinearDisplayP3( in vec4 value ) {\n	return vec4( value.rgb * LINEAR_SRGB_TO_LINEAR_DISPLAY_P3, value.a );\n}\nvec4 LinearDisplayP3ToLinearSRGB( in vec4 value ) {\n	return vec4( value.rgb * LINEAR_DISPLAY_P3_TO_LINEAR_SRGB, value.a );\n}\nvec4 LinearTransferOETF( in vec4 value ) {\n	return value;\n}\nvec4 sRGBTransferOETF( in vec4 value ) {\n	return vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}\nvec4 LinearToLinear( in vec4 value ) {\n	return value;\n}\nvec4 LinearTosRGB( in vec4 value ) {\n	return sRGBTransferOETF( value );\n}",
            envmap_fragment: "#ifdef USE_ENVMAP\n	#ifdef ENV_WORLDPOS\n		vec3 cameraToFrag;\n		if ( isOrthographic ) {\n			cameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n		} else {\n			cameraToFrag = normalize( vWorldPosition - cameraPosition );\n		}\n		vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n		#ifdef ENVMAP_MODE_REFLECTION\n			vec3 reflectVec = reflect( cameraToFrag, worldNormal );\n		#else\n			vec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n		#endif\n	#else\n		vec3 reflectVec = vReflect;\n	#endif\n	#ifdef ENVMAP_TYPE_CUBE\n		vec4 envColor = textureCube( envMap, vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n	#else\n		vec4 envColor = vec4( 0.0 );\n	#endif\n	#ifdef ENVMAP_BLENDING_MULTIPLY\n		outgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n	#elif defined( ENVMAP_BLENDING_MIX )\n		outgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n	#elif defined( ENVMAP_BLENDING_ADD )\n		outgoingLight += envColor.xyz * specularStrength * reflectivity;\n	#endif\n#endif",
            envmap_common_pars_fragment: "#ifdef USE_ENVMAP\n	uniform float envMapIntensity;\n	uniform float flipEnvMap;\n	#ifdef ENVMAP_TYPE_CUBE\n		uniform samplerCube envMap;\n	#else\n		uniform sampler2D envMap;\n	#endif\n	\n#endif",
            envmap_pars_fragment: "#ifdef USE_ENVMAP\n	uniform float reflectivity;\n	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n		#define ENV_WORLDPOS\n	#endif\n	#ifdef ENV_WORLDPOS\n		varying vec3 vWorldPosition;\n		uniform float refractionRatio;\n	#else\n		varying vec3 vReflect;\n	#endif\n#endif",
            envmap_pars_vertex: "#ifdef USE_ENVMAP\n	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n		#define ENV_WORLDPOS\n	#endif\n	#ifdef ENV_WORLDPOS\n		\n		varying vec3 vWorldPosition;\n	#else\n		varying vec3 vReflect;\n		uniform float refractionRatio;\n	#endif\n#endif",
            envmap_physical_pars_fragment: "#ifdef USE_ENVMAP\n	vec3 getIBLIrradiance( const in vec3 normal ) {\n		#ifdef ENVMAP_TYPE_CUBE_UV\n			vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n			vec4 envMapColor = textureCubeUV( envMap, worldNormal, 1.0 );\n			return PI * envMapColor.rgb * envMapIntensity;\n		#else\n			return vec3( 0.0 );\n		#endif\n	}\n	vec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\n		#ifdef ENVMAP_TYPE_CUBE_UV\n			vec3 reflectVec = reflect( - viewDir, normal );\n			reflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );\n			reflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n			vec4 envMapColor = textureCubeUV( envMap, reflectVec, roughness );\n			return envMapColor.rgb * envMapIntensity;\n		#else\n			return vec3( 0.0 );\n		#endif\n	}\n	#ifdef USE_ANISOTROPY\n		vec3 getIBLAnisotropyRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in vec3 bitangent, const in float anisotropy ) {\n			#ifdef ENVMAP_TYPE_CUBE_UV\n				vec3 bentNormal = cross( bitangent, viewDir );\n				bentNormal = normalize( cross( bentNormal, bitangent ) );\n				bentNormal = normalize( mix( bentNormal, normal, pow2( pow2( 1.0 - anisotropy * ( 1.0 - roughness ) ) ) ) );\n				return getIBLRadiance( viewDir, bentNormal, roughness );\n			#else\n				return vec3( 0.0 );\n			#endif\n		}\n	#endif\n#endif",
            envmap_vertex: "#ifdef USE_ENVMAP\n	#ifdef ENV_WORLDPOS\n		vWorldPosition = worldPosition.xyz;\n	#else\n		vec3 cameraToVertex;\n		if ( isOrthographic ) {\n			cameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n		} else {\n			cameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n		}\n		vec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n		#ifdef ENVMAP_MODE_REFLECTION\n			vReflect = reflect( cameraToVertex, worldNormal );\n		#else\n			vReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n		#endif\n	#endif\n#endif",
            fog_vertex: "#ifdef USE_FOG\n	vFogDepth = - mvPosition.z;\n#endif",
            fog_pars_vertex: "#ifdef USE_FOG\n	varying float vFogDepth;\n#endif",
            fog_fragment: "#ifdef USE_FOG\n	#ifdef FOG_EXP2\n		float fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\n	#else\n		float fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\n	#endif\n	gl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif",
            fog_pars_fragment: "#ifdef USE_FOG\n	uniform vec3 fogColor;\n	varying float vFogDepth;\n	#ifdef FOG_EXP2\n		uniform float fogDensity;\n	#else\n		uniform float fogNear;\n		uniform float fogFar;\n	#endif\n#endif",
            gradientmap_pars_fragment: "#ifdef USE_GRADIENTMAP\n	uniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n	float dotNL = dot( normal, lightDirection );\n	vec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n	#ifdef USE_GRADIENTMAP\n		return vec3( texture2D( gradientMap, coord ).r );\n	#else\n		vec2 fw = fwidth( coord ) * 0.5;\n		return mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );\n	#endif\n}",
            lightmap_fragment: "#ifdef USE_LIGHTMAP\n	vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n	vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n	reflectedLight.indirectDiffuse += lightMapIrradiance;\n#endif",
            lightmap_pars_fragment: "#ifdef USE_LIGHTMAP\n	uniform sampler2D lightMap;\n	uniform float lightMapIntensity;\n#endif",
            lights_lambert_fragment: "LambertMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularStrength = specularStrength;",
            lights_lambert_pars_fragment: "varying vec3 vViewPosition;\nstruct LambertMaterial {\n	vec3 diffuseColor;\n	float specularStrength;\n};\nvoid RE_Direct_Lambert( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_Lambert\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Lambert",
            lights_pars_begin: "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\n#if defined( USE_LIGHT_PROBES )\n	uniform vec3 lightProbe[ 9 ];\n#endif\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n	float x = normal.x, y = normal.y, z = normal.z;\n	vec3 result = shCoefficients[ 0 ] * 0.886227;\n	result += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n	result += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n	result += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n	result += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n	result += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n	result += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n	result += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n	result += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n	return result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {\n	vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n	vec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n	return irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n	vec3 irradiance = ambientLightColor;\n	return irradiance;\n}\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n	#if defined ( LEGACY_LIGHTS )\n		if ( cutoffDistance > 0.0 && decayExponent > 0.0 ) {\n			return pow( saturate( - lightDistance / cutoffDistance + 1.0 ), decayExponent );\n		}\n		return 1.0;\n	#else\n		float distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n		if ( cutoffDistance > 0.0 ) {\n			distanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n		}\n		return distanceFalloff;\n	#endif\n}\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\n	return smoothstep( coneCosine, penumbraCosine, angleCosine );\n}\n#if NUM_DIR_LIGHTS > 0\n	struct DirectionalLight {\n		vec3 direction;\n		vec3 color;\n	};\n	uniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n	void getDirectionalLightInfo( const in DirectionalLight directionalLight, out IncidentLight light ) {\n		light.color = directionalLight.color;\n		light.direction = directionalLight.direction;\n		light.visible = true;\n	}\n#endif\n#if NUM_POINT_LIGHTS > 0\n	struct PointLight {\n		vec3 position;\n		vec3 color;\n		float distance;\n		float decay;\n	};\n	uniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n	void getPointLightInfo( const in PointLight pointLight, const in vec3 geometryPosition, out IncidentLight light ) {\n		vec3 lVector = pointLight.position - geometryPosition;\n		light.direction = normalize( lVector );\n		float lightDistance = length( lVector );\n		light.color = pointLight.color;\n		light.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\n		light.visible = ( light.color != vec3( 0.0 ) );\n	}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n	struct SpotLight {\n		vec3 position;\n		vec3 direction;\n		vec3 color;\n		float distance;\n		float decay;\n		float coneCos;\n		float penumbraCos;\n	};\n	uniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n	void getSpotLightInfo( const in SpotLight spotLight, const in vec3 geometryPosition, out IncidentLight light ) {\n		vec3 lVector = spotLight.position - geometryPosition;\n		light.direction = normalize( lVector );\n		float angleCos = dot( light.direction, spotLight.direction );\n		float spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n		if ( spotAttenuation > 0.0 ) {\n			float lightDistance = length( lVector );\n			light.color = spotLight.color * spotAttenuation;\n			light.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\n			light.visible = ( light.color != vec3( 0.0 ) );\n		} else {\n			light.color = vec3( 0.0 );\n			light.visible = false;\n		}\n	}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n	struct RectAreaLight {\n		vec3 color;\n		vec3 position;\n		vec3 halfWidth;\n		vec3 halfHeight;\n	};\n	uniform sampler2D ltc_1;	uniform sampler2D ltc_2;\n	uniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n	struct HemisphereLight {\n		vec3 direction;\n		vec3 skyColor;\n		vec3 groundColor;\n	};\n	uniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n	vec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {\n		float dotNL = dot( normal, hemiLight.direction );\n		float hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n		vec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n		return irradiance;\n	}\n#endif",
            lights_toon_fragment: "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;",
            lights_toon_pars_fragment: "varying vec3 vViewPosition;\nstruct ToonMaterial {\n	vec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n	vec3 irradiance = getGradientIrradiance( geometryNormal, directLight.direction ) * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_Toon\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Toon",
            lights_phong_fragment: "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;",
            lights_phong_pars_fragment: "varying vec3 vViewPosition;\nstruct BlinnPhongMaterial {\n	vec3 diffuseColor;\n	vec3 specularColor;\n	float specularShininess;\n	float specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n	reflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometryViewDir, geometryNormal, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_BlinnPhong\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_BlinnPhong",
            lights_physical_fragment: "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nvec3 dxy = max( abs( dFdx( nonPerturbedNormal ) ), abs( dFdy( nonPerturbedNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\nmaterial.roughness = min( material.roughness, 1.0 );\n#ifdef IOR\n	material.ior = ior;\n	#ifdef USE_SPECULAR\n		float specularIntensityFactor = specularIntensity;\n		vec3 specularColorFactor = specularColor;\n		#ifdef USE_SPECULAR_COLORMAP\n			specularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;\n		#endif\n		#ifdef USE_SPECULAR_INTENSITYMAP\n			specularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;\n		#endif\n		material.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\n	#else\n		float specularIntensityFactor = 1.0;\n		vec3 specularColorFactor = vec3( 1.0 );\n		material.specularF90 = 1.0;\n	#endif\n	material.specularColor = mix( min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );\n#else\n	material.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );\n	material.specularF90 = 1.0;\n#endif\n#ifdef USE_CLEARCOAT\n	material.clearcoat = clearcoat;\n	material.clearcoatRoughness = clearcoatRoughness;\n	material.clearcoatF0 = vec3( 0.04 );\n	material.clearcoatF90 = 1.0;\n	#ifdef USE_CLEARCOATMAP\n		material.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;\n	#endif\n	#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n		material.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;\n	#endif\n	material.clearcoat = saturate( material.clearcoat );	material.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n	material.clearcoatRoughness += geometryRoughness;\n	material.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_IRIDESCENCE\n	material.iridescence = iridescence;\n	material.iridescenceIOR = iridescenceIOR;\n	#ifdef USE_IRIDESCENCEMAP\n		material.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;\n	#endif\n	#ifdef USE_IRIDESCENCE_THICKNESSMAP\n		material.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;\n	#else\n		material.iridescenceThickness = iridescenceThicknessMaximum;\n	#endif\n#endif\n#ifdef USE_SHEEN\n	material.sheenColor = sheenColor;\n	#ifdef USE_SHEEN_COLORMAP\n		material.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;\n	#endif\n	material.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );\n	#ifdef USE_SHEEN_ROUGHNESSMAP\n		material.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;\n	#endif\n#endif\n#ifdef USE_ANISOTROPY\n	#ifdef USE_ANISOTROPYMAP\n		mat2 anisotropyMat = mat2( anisotropyVector.x, anisotropyVector.y, - anisotropyVector.y, anisotropyVector.x );\n		vec3 anisotropyPolar = texture2D( anisotropyMap, vAnisotropyMapUv ).rgb;\n		vec2 anisotropyV = anisotropyMat * normalize( 2.0 * anisotropyPolar.rg - vec2( 1.0 ) ) * anisotropyPolar.b;\n	#else\n		vec2 anisotropyV = anisotropyVector;\n	#endif\n	material.anisotropy = length( anisotropyV );\n	anisotropyV /= material.anisotropy;\n	material.anisotropy = saturate( material.anisotropy );\n	material.alphaT = mix( pow2( material.roughness ), 1.0, pow2( material.anisotropy ) );\n	material.anisotropyT = tbn[ 0 ] * anisotropyV.x - tbn[ 1 ] * anisotropyV.y;\n	material.anisotropyB = tbn[ 1 ] * anisotropyV.x + tbn[ 0 ] * anisotropyV.y;\n#endif",
            lights_physical_pars_fragment: "struct PhysicalMaterial {\n	vec3 diffuseColor;\n	float roughness;\n	vec3 specularColor;\n	float specularF90;\n	#ifdef USE_CLEARCOAT\n		float clearcoat;\n		float clearcoatRoughness;\n		vec3 clearcoatF0;\n		float clearcoatF90;\n	#endif\n	#ifdef USE_IRIDESCENCE\n		float iridescence;\n		float iridescenceIOR;\n		float iridescenceThickness;\n		vec3 iridescenceFresnel;\n		vec3 iridescenceF0;\n	#endif\n	#ifdef USE_SHEEN\n		vec3 sheenColor;\n		float sheenRoughness;\n	#endif\n	#ifdef IOR\n		float ior;\n	#endif\n	#ifdef USE_TRANSMISSION\n		float transmission;\n		float transmissionAlpha;\n		float thickness;\n		float attenuationDistance;\n		vec3 attenuationColor;\n	#endif\n	#ifdef USE_ANISOTROPY\n		float anisotropy;\n		float alphaT;\n		vec3 anisotropyT;\n		vec3 anisotropyB;\n	#endif\n};\nvec3 clearcoatSpecularDirect = vec3( 0.0 );\nvec3 clearcoatSpecularIndirect = vec3( 0.0 );\nvec3 sheenSpecularDirect = vec3( 0.0 );\nvec3 sheenSpecularIndirect = vec3(0.0 );\nvec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {\n    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );\n    float x2 = x * x;\n    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );\n    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );\n}\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n	float a2 = pow2( alpha );\n	float gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n	float gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n	return 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n	float a2 = pow2( alpha );\n	float denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n	return RECIPROCAL_PI * a2 / pow2( denom );\n}\n#ifdef USE_ANISOTROPY\n	float V_GGX_SmithCorrelated_Anisotropic( const in float alphaT, const in float alphaB, const in float dotTV, const in float dotBV, const in float dotTL, const in float dotBL, const in float dotNV, const in float dotNL ) {\n		float gv = dotNL * length( vec3( alphaT * dotTV, alphaB * dotBV, dotNV ) );\n		float gl = dotNV * length( vec3( alphaT * dotTL, alphaB * dotBL, dotNL ) );\n		float v = 0.5 / ( gv + gl );\n		return saturate(v);\n	}\n	float D_GGX_Anisotropic( const in float alphaT, const in float alphaB, const in float dotNH, const in float dotTH, const in float dotBH ) {\n		float a2 = alphaT * alphaB;\n		highp vec3 v = vec3( alphaB * dotTH, alphaT * dotBH, a2 * dotNH );\n		highp float v2 = dot( v, v );\n		float w2 = a2 / v2;\n		return RECIPROCAL_PI * a2 * pow2 ( w2 );\n	}\n#endif\n#ifdef USE_CLEARCOAT\n	vec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {\n		vec3 f0 = material.clearcoatF0;\n		float f90 = material.clearcoatF90;\n		float roughness = material.clearcoatRoughness;\n		float alpha = pow2( roughness );\n		vec3 halfDir = normalize( lightDir + viewDir );\n		float dotNL = saturate( dot( normal, lightDir ) );\n		float dotNV = saturate( dot( normal, viewDir ) );\n		float dotNH = saturate( dot( normal, halfDir ) );\n		float dotVH = saturate( dot( viewDir, halfDir ) );\n		vec3 F = F_Schlick( f0, f90, dotVH );\n		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n		float D = D_GGX( alpha, dotNH );\n		return F * ( V * D );\n	}\n#endif\nvec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {\n	vec3 f0 = material.specularColor;\n	float f90 = material.specularF90;\n	float roughness = material.roughness;\n	float alpha = pow2( roughness );\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNL = saturate( dot( normal, lightDir ) );\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float dotVH = saturate( dot( viewDir, halfDir ) );\n	vec3 F = F_Schlick( f0, f90, dotVH );\n	#ifdef USE_IRIDESCENCE\n		F = mix( F, material.iridescenceFresnel, material.iridescence );\n	#endif\n	#ifdef USE_ANISOTROPY\n		float dotTL = dot( material.anisotropyT, lightDir );\n		float dotTV = dot( material.anisotropyT, viewDir );\n		float dotTH = dot( material.anisotropyT, halfDir );\n		float dotBL = dot( material.anisotropyB, lightDir );\n		float dotBV = dot( material.anisotropyB, viewDir );\n		float dotBH = dot( material.anisotropyB, halfDir );\n		float V = V_GGX_SmithCorrelated_Anisotropic( material.alphaT, alpha, dotTV, dotBV, dotTL, dotBL, dotNV, dotNL );\n		float D = D_GGX_Anisotropic( material.alphaT, alpha, dotNH, dotTH, dotBH );\n	#else\n		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n		float D = D_GGX( alpha, dotNH );\n	#endif\n	return F * ( V * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n	const float LUT_SIZE = 64.0;\n	const float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n	const float LUT_BIAS = 0.5 / LUT_SIZE;\n	float dotNV = saturate( dot( N, V ) );\n	vec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n	uv = uv * LUT_SCALE + LUT_BIAS;\n	return uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n	float l = length( f );\n	return max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n	float x = dot( v1, v2 );\n	float y = abs( x );\n	float a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n	float b = 3.4175940 + ( 4.1616724 + y ) * y;\n	float v = a / b;\n	float theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n	return cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n	vec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n	vec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n	vec3 lightNormal = cross( v1, v2 );\n	if( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n	vec3 T1, T2;\n	T1 = normalize( V - N * dot( V, N ) );\n	T2 = - cross( N, T1 );\n	mat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n	vec3 coords[ 4 ];\n	coords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n	coords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n	coords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n	coords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n	coords[ 0 ] = normalize( coords[ 0 ] );\n	coords[ 1 ] = normalize( coords[ 1 ] );\n	coords[ 2 ] = normalize( coords[ 2 ] );\n	coords[ 3 ] = normalize( coords[ 3 ] );\n	vec3 vectorFormFactor = vec3( 0.0 );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n	float result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n	return vec3( result );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie( float roughness, float dotNH ) {\n	float alpha = pow2( roughness );\n	float invAlpha = 1.0 / alpha;\n	float cos2h = dotNH * dotNH;\n	float sin2h = max( 1.0 - cos2h, 0.0078125 );\n	return ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\n}\nfloat V_Neubelt( float dotNV, float dotNL ) {\n	return saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );\n}\nvec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNL = saturate( dot( normal, lightDir ) );\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float D = D_Charlie( sheenRoughness, dotNH );\n	float V = V_Neubelt( dotNV, dotNL );\n	return sheenColor * ( D * V );\n}\n#endif\nfloat IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float r2 = roughness * roughness;\n	float a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;\n	float b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;\n	float DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );\n	return saturate( DG * RECIPROCAL_PI );\n}\nvec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n	float dotNV = saturate( dot( normal, viewDir ) );\n	const vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n	const vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n	vec4 r = roughness * c0 + c1;\n	float a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n	vec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;\n	return fab;\n}\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\n	vec2 fab = DFGApprox( normal, viewDir, roughness );\n	return specularColor * fab.x + specularF90 * fab.y;\n}\n#ifdef USE_IRIDESCENCE\nvoid computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#else\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#endif\n	vec2 fab = DFGApprox( normal, viewDir, roughness );\n	#ifdef USE_IRIDESCENCE\n		vec3 Fr = mix( specularColor, iridescenceF0, iridescence );\n	#else\n		vec3 Fr = specularColor;\n	#endif\n	vec3 FssEss = Fr * fab.x + specularF90 * fab.y;\n	float Ess = fab.x + fab.y;\n	float Ems = 1.0 - Ess;\n	vec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;	vec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n	singleScatter += FssEss;\n	multiScatter += Fms * Ems;\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n	void RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n		vec3 normal = geometryNormal;\n		vec3 viewDir = geometryViewDir;\n		vec3 position = geometryPosition;\n		vec3 lightPos = rectAreaLight.position;\n		vec3 halfWidth = rectAreaLight.halfWidth;\n		vec3 halfHeight = rectAreaLight.halfHeight;\n		vec3 lightColor = rectAreaLight.color;\n		float roughness = material.roughness;\n		vec3 rectCoords[ 4 ];\n		rectCoords[ 0 ] = lightPos + halfWidth - halfHeight;		rectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n		rectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n		rectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n		vec2 uv = LTC_Uv( normal, viewDir, roughness );\n		vec4 t1 = texture2D( ltc_1, uv );\n		vec4 t2 = texture2D( ltc_2, uv );\n		mat3 mInv = mat3(\n			vec3( t1.x, 0, t1.y ),\n			vec3(    0, 1,    0 ),\n			vec3( t1.z, 0, t1.w )\n		);\n		vec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n		reflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n		reflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n	}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	#ifdef USE_CLEARCOAT\n		float dotNLcc = saturate( dot( geometryClearcoatNormal, directLight.direction ) );\n		vec3 ccIrradiance = dotNLcc * directLight.color;\n		clearcoatSpecularDirect += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometryViewDir, geometryClearcoatNormal, material );\n	#endif\n	#ifdef USE_SHEEN\n		sheenSpecularDirect += irradiance * BRDF_Sheen( directLight.direction, geometryViewDir, geometryNormal, material.sheenColor, material.sheenRoughness );\n	#endif\n	reflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometryViewDir, geometryNormal, material );\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n	#ifdef USE_CLEARCOAT\n		clearcoatSpecularIndirect += clearcoatRadiance * EnvironmentBRDF( geometryClearcoatNormal, geometryViewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n	#endif\n	#ifdef USE_SHEEN\n		sheenSpecularIndirect += irradiance * material.sheenColor * IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );\n	#endif\n	vec3 singleScattering = vec3( 0.0 );\n	vec3 multiScattering = vec3( 0.0 );\n	vec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n	#ifdef USE_IRIDESCENCE\n		computeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );\n	#else\n		computeMultiscattering( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );\n	#endif\n	vec3 totalScattering = singleScattering + multiScattering;\n	vec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );\n	reflectedLight.indirectSpecular += radiance * singleScattering;\n	reflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\n	reflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\n}\n#define RE_Direct				RE_Direct_Physical\n#define RE_Direct_RectArea		RE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular		RE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n	return saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}",
            lights_fragment_begin: "\nvec3 geometryPosition = - vViewPosition;\nvec3 geometryNormal = normal;\nvec3 geometryViewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\nvec3 geometryClearcoatNormal = vec3( 0.0 );\n#ifdef USE_CLEARCOAT\n	geometryClearcoatNormal = clearcoatNormal;\n#endif\n#ifdef USE_IRIDESCENCE\n	float dotNVi = saturate( dot( normal, geometryViewDir ) );\n	if ( material.iridescenceThickness == 0.0 ) {\n		material.iridescence = 0.0;\n	} else {\n		material.iridescence = saturate( material.iridescence );\n	}\n	if ( material.iridescence > 0.0 ) {\n		material.iridescenceFresnel = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );\n		material.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );\n	}\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n	PointLight pointLight;\n	#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n	PointLightShadow pointLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n		pointLight = pointLights[ i ];\n		getPointLightInfo( pointLight, geometryPosition, directLight );\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\n		pointLightShadow = pointLightShadows[ i ];\n		directLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n	SpotLight spotLight;\n	vec4 spotColor;\n	vec3 spotLightCoord;\n	bool inSpotLightMap;\n	#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n	SpotLightShadow spotLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n		spotLight = spotLights[ i ];\n		getSpotLightInfo( spotLight, geometryPosition, directLight );\n		#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n		#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX\n		#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n		#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS\n		#else\n		#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n		#endif\n		#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )\n			spotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;\n			inSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );\n			spotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );\n			directLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;\n		#endif\n		#undef SPOT_LIGHT_MAP_INDEX\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n		spotLightShadow = spotLightShadows[ i ];\n		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n	DirectionalLight directionalLight;\n	#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n	DirectionalLightShadow directionalLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n		directionalLight = directionalLights[ i ];\n		getDirectionalLightInfo( directionalLight, directLight );\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n		directionalLightShadow = directionalLightShadows[ i ];\n		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n	RectAreaLight rectAreaLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n		rectAreaLight = rectAreaLights[ i ];\n		RE_Direct_RectArea( rectAreaLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n	vec3 iblIrradiance = vec3( 0.0 );\n	vec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n	#if defined( USE_LIGHT_PROBES )\n		irradiance += getLightProbeIrradiance( lightProbe, geometryNormal );\n	#endif\n	#if ( NUM_HEMI_LIGHTS > 0 )\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n			irradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometryNormal );\n		}\n		#pragma unroll_loop_end\n	#endif\n#endif\n#if defined( RE_IndirectSpecular )\n	vec3 radiance = vec3( 0.0 );\n	vec3 clearcoatRadiance = vec3( 0.0 );\n#endif",
            lights_fragment_maps: "#if defined( RE_IndirectDiffuse )\n	#ifdef USE_LIGHTMAP\n		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n		vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n		irradiance += lightMapIrradiance;\n	#endif\n	#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n		iblIrradiance += getIBLIrradiance( geometryNormal );\n	#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n	#ifdef USE_ANISOTROPY\n		radiance += getIBLAnisotropyRadiance( geometryViewDir, geometryNormal, material.roughness, material.anisotropyB, material.anisotropy );\n	#else\n		radiance += getIBLRadiance( geometryViewDir, geometryNormal, material.roughness );\n	#endif\n	#ifdef USE_CLEARCOAT\n		clearcoatRadiance += getIBLRadiance( geometryViewDir, geometryClearcoatNormal, material.clearcoatRoughness );\n	#endif\n#endif",
            lights_fragment_end: "#if defined( RE_IndirectDiffuse )\n	RE_IndirectDiffuse( irradiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n	RE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif",
            logdepthbuf_fragment: "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n	gl_FragDepthEXT = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif",
            logdepthbuf_pars_fragment: "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n	uniform float logDepthBufFC;\n	varying float vFragDepth;\n	varying float vIsPerspective;\n#endif",
            logdepthbuf_pars_vertex: "#ifdef USE_LOGDEPTHBUF\n	#ifdef USE_LOGDEPTHBUF_EXT\n		varying float vFragDepth;\n		varying float vIsPerspective;\n	#else\n		uniform float logDepthBufFC;\n	#endif\n#endif",
            logdepthbuf_vertex: "#ifdef USE_LOGDEPTHBUF\n	#ifdef USE_LOGDEPTHBUF_EXT\n		vFragDepth = 1.0 + gl_Position.w;\n		vIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n	#else\n		if ( isPerspectiveMatrix( projectionMatrix ) ) {\n			gl_Position.z = log2( max( EPSILON, gl_Position.w + 1.0 ) ) * logDepthBufFC - 1.0;\n			gl_Position.z *= gl_Position.w;\n		}\n	#endif\n#endif",
            map_fragment: "#ifdef USE_MAP\n	vec4 sampledDiffuseColor = texture2D( map, vMapUv );\n	#ifdef DECODE_VIDEO_TEXTURE\n		sampledDiffuseColor = vec4( mix( pow( sampledDiffuseColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), sampledDiffuseColor.rgb * 0.0773993808, vec3( lessThanEqual( sampledDiffuseColor.rgb, vec3( 0.04045 ) ) ) ), sampledDiffuseColor.w );\n	\n	#endif\n	diffuseColor *= sampledDiffuseColor;\n#endif",
            map_pars_fragment: "#ifdef USE_MAP\n	uniform sampler2D map;\n#endif",
            map_particle_fragment: "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n	#if defined( USE_POINTS_UV )\n		vec2 uv = vUv;\n	#else\n		vec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n	#endif\n#endif\n#ifdef USE_MAP\n	diffuseColor *= texture2D( map, uv );\n#endif\n#ifdef USE_ALPHAMAP\n	diffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif",
            map_particle_pars_fragment: "#if defined( USE_POINTS_UV )\n	varying vec2 vUv;\n#else\n	#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n		uniform mat3 uvTransform;\n	#endif\n#endif\n#ifdef USE_MAP\n	uniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n	uniform sampler2D alphaMap;\n#endif",
            metalnessmap_fragment: "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n	vec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );\n	metalnessFactor *= texelMetalness.b;\n#endif",
            metalnessmap_pars_fragment: "#ifdef USE_METALNESSMAP\n	uniform sampler2D metalnessMap;\n#endif",
            morphcolor_vertex: "#if defined( USE_MORPHCOLORS ) && defined( MORPHTARGETS_TEXTURE )\n	vColor *= morphTargetBaseInfluence;\n	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n		#if defined( USE_COLOR_ALPHA )\n			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];\n		#elif defined( USE_COLOR )\n			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];\n		#endif\n	}\n#endif",
            morphnormal_vertex: "#ifdef USE_MORPHNORMALS\n	objectNormal *= morphTargetBaseInfluence;\n	#ifdef MORPHTARGETS_TEXTURE\n		for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n			if ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];\n		}\n	#else\n		objectNormal += morphNormal0 * morphTargetInfluences[ 0 ];\n		objectNormal += morphNormal1 * morphTargetInfluences[ 1 ];\n		objectNormal += morphNormal2 * morphTargetInfluences[ 2 ];\n		objectNormal += morphNormal3 * morphTargetInfluences[ 3 ];\n	#endif\n#endif",
            morphtarget_pars_vertex: "#ifdef USE_MORPHTARGETS\n	uniform float morphTargetBaseInfluence;\n	#ifdef MORPHTARGETS_TEXTURE\n		uniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n		uniform sampler2DArray morphTargetsTexture;\n		uniform ivec2 morphTargetsTextureSize;\n		vec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {\n			int texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;\n			int y = texelIndex / morphTargetsTextureSize.x;\n			int x = texelIndex - y * morphTargetsTextureSize.x;\n			ivec3 morphUV = ivec3( x, y, morphTargetIndex );\n			return texelFetch( morphTargetsTexture, morphUV, 0 );\n		}\n	#else\n		#ifndef USE_MORPHNORMALS\n			uniform float morphTargetInfluences[ 8 ];\n		#else\n			uniform float morphTargetInfluences[ 4 ];\n		#endif\n	#endif\n#endif",
            morphtarget_vertex: "#ifdef USE_MORPHTARGETS\n	transformed *= morphTargetBaseInfluence;\n	#ifdef MORPHTARGETS_TEXTURE\n		for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n			if ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];\n		}\n	#else\n		transformed += morphTarget0 * morphTargetInfluences[ 0 ];\n		transformed += morphTarget1 * morphTargetInfluences[ 1 ];\n		transformed += morphTarget2 * morphTargetInfluences[ 2 ];\n		transformed += morphTarget3 * morphTargetInfluences[ 3 ];\n		#ifndef USE_MORPHNORMALS\n			transformed += morphTarget4 * morphTargetInfluences[ 4 ];\n			transformed += morphTarget5 * morphTargetInfluences[ 5 ];\n			transformed += morphTarget6 * morphTargetInfluences[ 6 ];\n			transformed += morphTarget7 * morphTargetInfluences[ 7 ];\n		#endif\n	#endif\n#endif",
            normal_fragment_begin: "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n	vec3 fdx = dFdx( vViewPosition );\n	vec3 fdy = dFdy( vViewPosition );\n	vec3 normal = normalize( cross( fdx, fdy ) );\n#else\n	vec3 normal = normalize( vNormal );\n	#ifdef DOUBLE_SIDED\n		normal *= faceDirection;\n	#endif\n#endif\n#if defined( USE_NORMALMAP_TANGENTSPACE ) || defined( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY )\n	#ifdef USE_TANGENT\n		mat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n	#else\n		mat3 tbn = getTangentFrame( - vViewPosition, normal,\n		#if defined( USE_NORMALMAP )\n			vNormalMapUv\n		#elif defined( USE_CLEARCOAT_NORMALMAP )\n			vClearcoatNormalMapUv\n		#else\n			vUv\n		#endif\n		);\n	#endif\n	#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n		tbn[0] *= faceDirection;\n		tbn[1] *= faceDirection;\n	#endif\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	#ifdef USE_TANGENT\n		mat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n	#else\n		mat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );\n	#endif\n	#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n		tbn2[0] *= faceDirection;\n		tbn2[1] *= faceDirection;\n	#endif\n#endif\nvec3 nonPerturbedNormal = normal;",
            normal_fragment_maps: "#ifdef USE_NORMALMAP_OBJECTSPACE\n	normal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n	#ifdef FLIP_SIDED\n		normal = - normal;\n	#endif\n	#ifdef DOUBLE_SIDED\n		normal = normal * faceDirection;\n	#endif\n	normal = normalize( normalMatrix * normal );\n#elif defined( USE_NORMALMAP_TANGENTSPACE )\n	vec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n	mapN.xy *= normalScale;\n	normal = normalize( tbn * mapN );\n#elif defined( USE_BUMPMAP )\n	normal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif",
            normal_pars_fragment: "#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n	#ifdef USE_TANGENT\n		varying vec3 vTangent;\n		varying vec3 vBitangent;\n	#endif\n#endif",
            normal_pars_vertex: "#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n	#ifdef USE_TANGENT\n		varying vec3 vTangent;\n		varying vec3 vBitangent;\n	#endif\n#endif",
            normal_vertex: "#ifndef FLAT_SHADED\n	vNormal = normalize( transformedNormal );\n	#ifdef USE_TANGENT\n		vTangent = normalize( transformedTangent );\n		vBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n	#endif\n#endif",
            normalmap_pars_fragment: "#ifdef USE_NORMALMAP\n	uniform sampler2D normalMap;\n	uniform vec2 normalScale;\n#endif\n#ifdef USE_NORMALMAP_OBJECTSPACE\n	uniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) )\n	mat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {\n		vec3 q0 = dFdx( eye_pos.xyz );\n		vec3 q1 = dFdy( eye_pos.xyz );\n		vec2 st0 = dFdx( uv.st );\n		vec2 st1 = dFdy( uv.st );\n		vec3 N = surf_norm;\n		vec3 q1perp = cross( q1, N );\n		vec3 q0perp = cross( N, q0 );\n		vec3 T = q1perp * st0.x + q0perp * st1.x;\n		vec3 B = q1perp * st0.y + q0perp * st1.y;\n		float det = max( dot( T, T ), dot( B, B ) );\n		float scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );\n		return mat3( T * scale, B * scale, N );\n	}\n#endif",
            clearcoat_normal_fragment_begin: "#ifdef USE_CLEARCOAT\n	vec3 clearcoatNormal = nonPerturbedNormal;\n#endif",
            clearcoat_normal_fragment_maps: "#ifdef USE_CLEARCOAT_NORMALMAP\n	vec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;\n	clearcoatMapN.xy *= clearcoatNormalScale;\n	clearcoatNormal = normalize( tbn2 * clearcoatMapN );\n#endif",
            clearcoat_pars_fragment: "#ifdef USE_CLEARCOATMAP\n	uniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	uniform sampler2D clearcoatNormalMap;\n	uniform vec2 clearcoatNormalScale;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	uniform sampler2D clearcoatRoughnessMap;\n#endif",
            iridescence_pars_fragment: "#ifdef USE_IRIDESCENCEMAP\n	uniform sampler2D iridescenceMap;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	uniform sampler2D iridescenceThicknessMap;\n#endif",
            opaque_fragment: "#ifdef OPAQUE\ndiffuseColor.a = 1.0;\n#endif\n#ifdef USE_TRANSMISSION\ndiffuseColor.a *= material.transmissionAlpha;\n#endif\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );",
            packing: "vec3 packNormalToRGB( const in vec3 normal ) {\n	return normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n	return 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;\nconst vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256., 256. );\nconst vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );\nconst float ShiftRight8 = 1. / 256.;\nvec4 packDepthToRGBA( const in float v ) {\n	vec4 r = vec4( fract( v * PackFactors ), v );\n	r.yzw -= r.xyz * ShiftRight8;	return r * PackUpscale;\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n	return dot( v, UnpackFactors );\n}\nvec2 packDepthToRG( in highp float v ) {\n	return packDepthToRGBA( v ).yx;\n}\nfloat unpackRGToDepth( const in highp vec2 v ) {\n	return unpackRGBAToDepth( vec4( v.xy, 0.0, 0.0 ) );\n}\nvec4 pack2HalfToRGBA( vec2 v ) {\n	vec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\n	return vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\n}\nvec2 unpackRGBATo2Half( vec4 v ) {\n	return vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n	return ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {\n	return depth * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n	return ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {\n	return ( near * far ) / ( ( far - near ) * depth - far );\n}",
            premultiplied_alpha_fragment: "#ifdef PREMULTIPLIED_ALPHA\n	gl_FragColor.rgb *= gl_FragColor.a;\n#endif",
            project_vertex: "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_INSTANCING\n	mvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;",
            dithering_fragment: "#ifdef DITHERING\n	gl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif",
            dithering_pars_fragment: "#ifdef DITHERING\n	vec3 dithering( vec3 color ) {\n		float grid_position = rand( gl_FragCoord.xy );\n		vec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n		dither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n		return color + dither_shift_RGB;\n	}\n#endif",
            roughnessmap_fragment: "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n	vec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );\n	roughnessFactor *= texelRoughness.g;\n#endif",
            roughnessmap_pars_fragment: "#ifdef USE_ROUGHNESSMAP\n	uniform sampler2D roughnessMap;\n#endif",
            shadowmap_pars_fragment: "#if NUM_SPOT_LIGHT_COORDS > 0\n	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#if NUM_SPOT_LIGHT_MAPS > 0\n	uniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];\n#endif\n#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		uniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n		struct DirectionalLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n		uniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n		struct SpotLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		uniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n		struct PointLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n			float shadowCameraNear;\n			float shadowCameraFar;\n		};\n		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n	#endif\n	float texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n		return step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n	}\n	vec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\n		return unpackRGBATo2Half( texture2D( shadow, uv ) );\n	}\n	float VSMShadow (sampler2D shadow, vec2 uv, float compare ){\n		float occlusion = 1.0;\n		vec2 distribution = texture2DDistribution( shadow, uv );\n		float hard_shadow = step( compare , distribution.x );\n		if (hard_shadow != 1.0 ) {\n			float distance = compare - distribution.x ;\n			float variance = max( 0.00000, distribution.y * distribution.y );\n			float softness_probability = variance / (variance + distance * distance );			softness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );			occlusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\n		}\n		return occlusion;\n	}\n	float getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n		float shadow = 1.0;\n		shadowCoord.xyz /= shadowCoord.w;\n		shadowCoord.z += shadowBias;\n		bool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n		bool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n		if ( frustumTest ) {\n		#if defined( SHADOWMAP_TYPE_PCF )\n			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n			float dx0 = - texelSize.x * shadowRadius;\n			float dy0 = - texelSize.y * shadowRadius;\n			float dx1 = + texelSize.x * shadowRadius;\n			float dy1 = + texelSize.y * shadowRadius;\n			float dx2 = dx0 / 2.0;\n			float dy2 = dy0 / 2.0;\n			float dx3 = dx1 / 2.0;\n			float dy3 = dy1 / 2.0;\n			shadow = (\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n			) * ( 1.0 / 17.0 );\n		#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n			float dx = texelSize.x;\n			float dy = texelSize.y;\n			vec2 uv = shadowCoord.xy;\n			vec2 f = fract( uv * shadowMapSize + 0.5 );\n			uv -= f * texelSize;\n			shadow = (\n				texture2DCompare( shadowMap, uv, shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\n					 f.x ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\n					 f.x ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\n					 f.y ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\n					 f.y ) +\n				mix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),\n						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\n						  f.x ),\n					 mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),\n						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\n						  f.x ),\n					 f.y )\n			) * ( 1.0 / 9.0 );\n		#elif defined( SHADOWMAP_TYPE_VSM )\n			shadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\n		#else\n			shadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n		#endif\n		}\n		return shadow;\n	}\n	vec2 cubeToUV( vec3 v, float texelSizeY ) {\n		vec3 absV = abs( v );\n		float scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n		absV *= scaleToCube;\n		v *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n		vec2 planar = v.xy;\n		float almostATexel = 1.5 * texelSizeY;\n		float almostOne = 1.0 - almostATexel;\n		if ( absV.z >= almostOne ) {\n			if ( v.z > 0.0 )\n				planar.x = 4.0 - v.x;\n		} else if ( absV.x >= almostOne ) {\n			float signX = sign( v.x );\n			planar.x = v.z * signX + 2.0 * signX;\n		} else if ( absV.y >= almostOne ) {\n			float signY = sign( v.y );\n			planar.x = v.x + 2.0 * signY + 2.0;\n			planar.y = v.z * signY - 2.0;\n		}\n		return vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n	}\n	float getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n		vec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n		vec3 lightToPosition = shadowCoord.xyz;\n		float dp = ( length( lightToPosition ) - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );		dp += shadowBias;\n		vec3 bd3D = normalize( lightToPosition );\n		#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\n			vec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n			return (\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n			) * ( 1.0 / 9.0 );\n		#else\n			return texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n		#endif\n	}\n#endif",
            shadowmap_pars_vertex: "#if NUM_SPOT_LIGHT_COORDS > 0\n	uniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];\n	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		uniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n		struct DirectionalLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n		struct SpotLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		uniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n		struct PointLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n			float shadowCameraNear;\n			float shadowCameraFar;\n		};\n		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n	#endif\n#endif",
            shadowmap_vertex: "#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )\n	vec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n	vec4 shadowWorldPosition;\n#endif\n#if defined( USE_SHADOWMAP )\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n			vDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n		}\n		#pragma unroll_loop_end\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n			vPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n		}\n		#pragma unroll_loop_end\n	#endif\n#endif\n#if NUM_SPOT_LIGHT_COORDS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {\n		shadowWorldPosition = worldPosition;\n		#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n			shadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;\n		#endif\n		vSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;\n	}\n	#pragma unroll_loop_end\n#endif",
            shadowmask_pars_fragment: "float getShadowMask() {\n	float shadow = 1.0;\n	#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n	DirectionalLightShadow directionalLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n		directionalLight = directionalLightShadows[ i ];\n		shadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n	SpotLightShadow spotLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n		spotLight = spotLightShadows[ i ];\n		shadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n	PointLightShadow pointLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n		pointLight = pointLightShadows[ i ];\n		shadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#endif\n	return shadow;\n}",
            skinbase_vertex: "#ifdef USE_SKINNING\n	mat4 boneMatX = getBoneMatrix( skinIndex.x );\n	mat4 boneMatY = getBoneMatrix( skinIndex.y );\n	mat4 boneMatZ = getBoneMatrix( skinIndex.z );\n	mat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif",
            skinning_pars_vertex: "#ifdef USE_SKINNING\n	uniform mat4 bindMatrix;\n	uniform mat4 bindMatrixInverse;\n	uniform highp sampler2D boneTexture;\n	uniform int boneTextureSize;\n	mat4 getBoneMatrix( const in float i ) {\n		float j = i * 4.0;\n		float x = mod( j, float( boneTextureSize ) );\n		float y = floor( j / float( boneTextureSize ) );\n		float dx = 1.0 / float( boneTextureSize );\n		float dy = 1.0 / float( boneTextureSize );\n		y = dy * ( y + 0.5 );\n		vec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );\n		vec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );\n		vec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );\n		vec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );\n		mat4 bone = mat4( v1, v2, v3, v4 );\n		return bone;\n	}\n#endif",
            skinning_vertex: "#ifdef USE_SKINNING\n	vec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n	vec4 skinned = vec4( 0.0 );\n	skinned += boneMatX * skinVertex * skinWeight.x;\n	skinned += boneMatY * skinVertex * skinWeight.y;\n	skinned += boneMatZ * skinVertex * skinWeight.z;\n	skinned += boneMatW * skinVertex * skinWeight.w;\n	transformed = ( bindMatrixInverse * skinned ).xyz;\n#endif",
            skinnormal_vertex: "#ifdef USE_SKINNING\n	mat4 skinMatrix = mat4( 0.0 );\n	skinMatrix += skinWeight.x * boneMatX;\n	skinMatrix += skinWeight.y * boneMatY;\n	skinMatrix += skinWeight.z * boneMatZ;\n	skinMatrix += skinWeight.w * boneMatW;\n	skinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n	objectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n	#ifdef USE_TANGENT\n		objectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n	#endif\n#endif",
            specularmap_fragment: "float specularStrength;\n#ifdef USE_SPECULARMAP\n	vec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );\n	specularStrength = texelSpecular.r;\n#else\n	specularStrength = 1.0;\n#endif",
            specularmap_pars_fragment: "#ifdef USE_SPECULARMAP\n	uniform sampler2D specularMap;\n#endif",
            tonemapping_fragment: "#if defined( TONE_MAPPING )\n	gl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif",
            tonemapping_pars_fragment: "#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n	return saturate( toneMappingExposure * color );\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n	color *= toneMappingExposure;\n	return saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 OptimizedCineonToneMapping( vec3 color ) {\n	color *= toneMappingExposure;\n	color = max( vec3( 0.0 ), color - 0.004 );\n	return pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n	vec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n	vec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n	return a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n	const mat3 ACESInputMat = mat3(\n		vec3( 0.59719, 0.07600, 0.02840 ),		vec3( 0.35458, 0.90834, 0.13383 ),\n		vec3( 0.04823, 0.01566, 0.83777 )\n	);\n	const mat3 ACESOutputMat = mat3(\n		vec3(  1.60475, -0.10208, -0.00327 ),		vec3( -0.53108,  1.10813, -0.07276 ),\n		vec3( -0.07367, -0.00605,  1.07602 )\n	);\n	color *= toneMappingExposure / 0.6;\n	color = ACESInputMat * color;\n	color = RRTAndODTFit( color );\n	color = ACESOutputMat * color;\n	return saturate( color );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }",
            transmission_fragment: "#ifdef USE_TRANSMISSION\n	material.transmission = transmission;\n	material.transmissionAlpha = 1.0;\n	material.thickness = thickness;\n	material.attenuationDistance = attenuationDistance;\n	material.attenuationColor = attenuationColor;\n	#ifdef USE_TRANSMISSIONMAP\n		material.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;\n	#endif\n	#ifdef USE_THICKNESSMAP\n		material.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;\n	#endif\n	vec3 pos = vWorldPosition;\n	vec3 v = normalize( cameraPosition - pos );\n	vec3 n = inverseTransformDirection( normal, viewMatrix );\n	vec4 transmitted = getIBLVolumeRefraction(\n		n, v, material.roughness, material.diffuseColor, material.specularColor, material.specularF90,\n		pos, modelMatrix, viewMatrix, projectionMatrix, material.ior, material.thickness,\n		material.attenuationColor, material.attenuationDistance );\n	material.transmissionAlpha = mix( material.transmissionAlpha, transmitted.a, material.transmission );\n	totalDiffuse = mix( totalDiffuse, transmitted.rgb, material.transmission );\n#endif",
            transmission_pars_fragment: "#ifdef USE_TRANSMISSION\n	uniform float transmission;\n	uniform float thickness;\n	uniform float attenuationDistance;\n	uniform vec3 attenuationColor;\n	#ifdef USE_TRANSMISSIONMAP\n		uniform sampler2D transmissionMap;\n	#endif\n	#ifdef USE_THICKNESSMAP\n		uniform sampler2D thicknessMap;\n	#endif\n	uniform vec2 transmissionSamplerSize;\n	uniform sampler2D transmissionSamplerMap;\n	uniform mat4 modelMatrix;\n	uniform mat4 projectionMatrix;\n	varying vec3 vWorldPosition;\n	float w0( float a ) {\n		return ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );\n	}\n	float w1( float a ) {\n		return ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );\n	}\n	float w2( float a ){\n		return ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );\n	}\n	float w3( float a ) {\n		return ( 1.0 / 6.0 ) * ( a * a * a );\n	}\n	float g0( float a ) {\n		return w0( a ) + w1( a );\n	}\n	float g1( float a ) {\n		return w2( a ) + w3( a );\n	}\n	float h0( float a ) {\n		return - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );\n	}\n	float h1( float a ) {\n		return 1.0 + w3( a ) / ( w2( a ) + w3( a ) );\n	}\n	vec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {\n		uv = uv * texelSize.zw + 0.5;\n		vec2 iuv = floor( uv );\n		vec2 fuv = fract( uv );\n		float g0x = g0( fuv.x );\n		float g1x = g1( fuv.x );\n		float h0x = h0( fuv.x );\n		float h1x = h1( fuv.x );\n		float h0y = h0( fuv.y );\n		float h1y = h1( fuv.y );\n		vec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n		vec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n		vec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n		vec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n		return g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +\n			g1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );\n	}\n	vec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {\n		vec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );\n		vec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );\n		vec2 fLodSizeInv = 1.0 / fLodSize;\n		vec2 cLodSizeInv = 1.0 / cLodSize;\n		vec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );\n		vec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );\n		return mix( fSample, cSample, fract( lod ) );\n	}\n	vec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {\n		vec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\n		vec3 modelScale;\n		modelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\n		modelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\n		modelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\n		return normalize( refractionVector ) * thickness * modelScale;\n	}\n	float applyIorToRoughness( const in float roughness, const in float ior ) {\n		return roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\n	}\n	vec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {\n		float lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\n		return textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );\n	}\n	vec3 volumeAttenuation( const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {\n		if ( isinf( attenuationDistance ) ) {\n			return vec3( 1.0 );\n		} else {\n			vec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\n			vec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );			return transmittance;\n		}\n	}\n	vec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,\n		const in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,\n		const in mat4 viewMatrix, const in mat4 projMatrix, const in float ior, const in float thickness,\n		const in vec3 attenuationColor, const in float attenuationDistance ) {\n		vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\n		vec3 refractedRayExit = position + transmissionRay;\n		vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n		vec2 refractionCoords = ndcPos.xy / ndcPos.w;\n		refractionCoords += 1.0;\n		refractionCoords /= 2.0;\n		vec4 transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\n		vec3 transmittance = diffuseColor * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance );\n		vec3 attenuatedColor = transmittance * transmittedLight.rgb;\n		vec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\n		float transmittanceFactor = ( transmittance.r + transmittance.g + transmittance.b ) / 3.0;\n		return vec4( ( 1.0 - F ) * attenuatedColor, 1.0 - ( 1.0 - transmittedLight.a ) * transmittanceFactor );\n	}\n#endif",
            uv_pars_fragment: "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n	varying vec2 vUv;\n#endif\n#ifdef USE_MAP\n	varying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n	varying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n	varying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n	varying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n	varying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n	varying vec2 vNormalMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n	varying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n	varying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n	varying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n	varying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n	varying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	varying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	varying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n	varying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	varying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n	varying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n	varying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n	varying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n	varying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n	varying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n	uniform mat3 transmissionMapTransform;\n	varying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n	uniform mat3 thicknessMapTransform;\n	varying vec2 vThicknessMapUv;\n#endif",
            uv_pars_vertex: "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n	varying vec2 vUv;\n#endif\n#ifdef USE_MAP\n	uniform mat3 mapTransform;\n	varying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n	uniform mat3 alphaMapTransform;\n	varying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n	uniform mat3 lightMapTransform;\n	varying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n	uniform mat3 aoMapTransform;\n	varying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n	uniform mat3 bumpMapTransform;\n	varying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n	uniform mat3 normalMapTransform;\n	varying vec2 vNormalMapUv;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n	uniform mat3 displacementMapTransform;\n	varying vec2 vDisplacementMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n	uniform mat3 emissiveMapTransform;\n	varying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n	uniform mat3 metalnessMapTransform;\n	varying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n	uniform mat3 roughnessMapTransform;\n	varying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n	uniform mat3 anisotropyMapTransform;\n	varying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n	uniform mat3 clearcoatMapTransform;\n	varying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	uniform mat3 clearcoatNormalMapTransform;\n	varying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	uniform mat3 clearcoatRoughnessMapTransform;\n	varying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n	uniform mat3 sheenColorMapTransform;\n	varying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n	uniform mat3 sheenRoughnessMapTransform;\n	varying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n	uniform mat3 iridescenceMapTransform;\n	varying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	uniform mat3 iridescenceThicknessMapTransform;\n	varying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n	uniform mat3 specularMapTransform;\n	varying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n	uniform mat3 specularColorMapTransform;\n	varying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n	uniform mat3 specularIntensityMapTransform;\n	varying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n	uniform mat3 transmissionMapTransform;\n	varying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n	uniform mat3 thicknessMapTransform;\n	varying vec2 vThicknessMapUv;\n#endif",
            uv_vertex: "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n	vUv = vec3( uv, 1 ).xy;\n#endif\n#ifdef USE_MAP\n	vMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ALPHAMAP\n	vAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_LIGHTMAP\n	vLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_AOMAP\n	vAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_BUMPMAP\n	vBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_NORMALMAP\n	vNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n	vDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_EMISSIVEMAP\n	vEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_METALNESSMAP\n	vMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ROUGHNESSMAP\n	vRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ANISOTROPYMAP\n	vAnisotropyMapUv = ( anisotropyMapTransform * vec3( ANISOTROPYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOATMAP\n	vClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	vClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	vClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n	vIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	vIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n	vSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n	vSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULARMAP\n	vSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n	vSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n	vSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n	vTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_THICKNESSMAP\n	vThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;\n#endif",
            worldpos_vertex: "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0\n	vec4 worldPosition = vec4( transformed, 1.0 );\n	#ifdef USE_INSTANCING\n		worldPosition = instanceMatrix * worldPosition;\n	#endif\n	worldPosition = modelMatrix * worldPosition;\n#endif",
            background_vert: "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n	vUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n	gl_Position = vec4( position.xy, 1.0, 1.0 );\n}",
            background_frag: "uniform sampler2D t2D;\nuniform float backgroundIntensity;\nvarying vec2 vUv;\nvoid main() {\n	vec4 texColor = texture2D( t2D, vUv );\n	#ifdef DECODE_VIDEO_TEXTURE\n		texColor = vec4( mix( pow( texColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), texColor.rgb * 0.0773993808, vec3( lessThanEqual( texColor.rgb, vec3( 0.04045 ) ) ) ), texColor.w );\n	#endif\n	texColor.rgb *= backgroundIntensity;\n	gl_FragColor = texColor;\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n}",
            backgroundCube_vert: "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n	gl_Position.z = gl_Position.w;\n}",
            backgroundCube_frag: "#ifdef ENVMAP_TYPE_CUBE\n	uniform samplerCube envMap;\n#elif defined( ENVMAP_TYPE_CUBE_UV )\n	uniform sampler2D envMap;\n#endif\nuniform float flipEnvMap;\nuniform float backgroundBlurriness;\nuniform float backgroundIntensity;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n	#ifdef ENVMAP_TYPE_CUBE\n		vec4 texColor = textureCube( envMap, vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );\n	#elif defined( ENVMAP_TYPE_CUBE_UV )\n		vec4 texColor = textureCubeUV( envMap, vWorldDirection, backgroundBlurriness );\n	#else\n		vec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n	#endif\n	texColor.rgb *= backgroundIntensity;\n	gl_FragColor = texColor;\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n}",
            cube_vert: "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n	gl_Position.z = gl_Position.w;\n}",
            cube_frag: "uniform samplerCube tCube;\nuniform float tFlip;\nuniform float opacity;\nvarying vec3 vWorldDirection;\nvoid main() {\n	vec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );\n	gl_FragColor = texColor;\n	gl_FragColor.a *= opacity;\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n}",
            depth_vert: "#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n	#include <uv_vertex>\n	#include <skinbase_vertex>\n	#ifdef USE_DISPLACEMENTMAP\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vHighPrecisionZW = gl_Position.zw;\n}",
            depth_frag: "#if DEPTH_PACKING == 3200\n	uniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( 1.0 );\n	#if DEPTH_PACKING == 3200\n		diffuseColor.a = opacity;\n	#endif\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <logdepthbuf_fragment>\n	float fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;\n	#if DEPTH_PACKING == 3200\n		gl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n	#elif DEPTH_PACKING == 3201\n		gl_FragColor = packDepthToRGBA( fragCoordZ );\n	#endif\n}",
            distanceRGBA_vert: "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <skinbase_vertex>\n	#ifdef USE_DISPLACEMENTMAP\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <worldpos_vertex>\n	#include <clipping_planes_vertex>\n	vWorldPosition = worldPosition.xyz;\n}",
            distanceRGBA_frag: "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( 1.0 );\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	float dist = length( vWorldPosition - referencePosition );\n	dist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n	dist = saturate( dist );\n	gl_FragColor = packDepthToRGBA( dist );\n}",
            equirect_vert: "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n}",
            equirect_frag: "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vec3 direction = normalize( vWorldDirection );\n	vec2 sampleUV = equirectUv( direction );\n	gl_FragColor = texture2D( tEquirect, sampleUV );\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n}",
            linedashed_vert: "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	vLineDistance = scale * lineDistance;\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n}",
            linedashed_frag: "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	if ( mod( vLineDistance, totalSize ) > dashSize ) {\n		discard;\n	}\n	vec3 outgoingLight = vec3( 0.0 );\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n}",
            meshbasic_vert: "#include <common>\n#include <uv_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinbase_vertex>\n		#include <skinnormal_vertex>\n		#include <defaultnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <fog_vertex>\n}",
            meshbasic_frag: "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <specularmap_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	#ifdef USE_LIGHTMAP\n		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n		reflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;\n	#else\n		reflectedLight.indirectDiffuse += vec3( 1.0 );\n	#endif\n	#include <aomap_fragment>\n	reflectedLight.indirectDiffuse *= diffuseColor.rgb;\n	vec3 outgoingLight = reflectedLight.indirectDiffuse;\n	#include <envmap_fragment>\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}",
            meshlambert_vert: "#define LAMBERT\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}",
            meshlambert_frag: "#define LAMBERT\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_lambert_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <specularmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_lambert_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n	#include <envmap_fragment>\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}",
            meshmatcap_vert: "#define MATCAP\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n	vViewPosition = - mvPosition.xyz;\n}",
            meshmatcap_frag: "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	vec3 viewDir = normalize( vViewPosition );\n	vec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n	vec3 y = cross( viewDir, x );\n	vec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n	#ifdef USE_MATCAP\n		vec4 matcapColor = texture2D( matcap, uv );\n	#else\n		vec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );\n	#endif\n	vec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}",
            meshnormal_vert: "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n	varying vec3 vViewPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n	vViewPosition = - mvPosition.xyz;\n#endif\n}",
            meshnormal_frag: "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n	varying vec3 vViewPosition;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	#include <logdepthbuf_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	gl_FragColor = vec4( packNormalToRGB( normal ), opacity );\n	#ifdef OPAQUE\n		gl_FragColor.a = 1.0;\n	#endif\n}",
            meshphong_vert: "#define PHONG\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}",
            meshphong_frag: "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <specularmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_phong_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n	#include <envmap_fragment>\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}",
            meshphysical_vert: "#define STANDARD\nvarying vec3 vViewPosition;\n#ifdef USE_TRANSMISSION\n	varying vec3 vWorldPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n	vWorldPosition = worldPosition.xyz;\n#endif\n}",
            meshphysical_frag: "#define STANDARD\n#ifdef PHYSICAL\n	#define IOR\n	#define USE_SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef IOR\n	uniform float ior;\n#endif\n#ifdef USE_SPECULAR\n	uniform float specularIntensity;\n	uniform vec3 specularColor;\n	#ifdef USE_SPECULAR_COLORMAP\n		uniform sampler2D specularColorMap;\n	#endif\n	#ifdef USE_SPECULAR_INTENSITYMAP\n		uniform sampler2D specularIntensityMap;\n	#endif\n#endif\n#ifdef USE_CLEARCOAT\n	uniform float clearcoat;\n	uniform float clearcoatRoughness;\n#endif\n#ifdef USE_IRIDESCENCE\n	uniform float iridescence;\n	uniform float iridescenceIOR;\n	uniform float iridescenceThicknessMinimum;\n	uniform float iridescenceThicknessMaximum;\n#endif\n#ifdef USE_SHEEN\n	uniform vec3 sheenColor;\n	uniform float sheenRoughness;\n	#ifdef USE_SHEEN_COLORMAP\n		uniform sampler2D sheenColorMap;\n	#endif\n	#ifdef USE_SHEEN_ROUGHNESSMAP\n		uniform sampler2D sheenRoughnessMap;\n	#endif\n#endif\n#ifdef USE_ANISOTROPY\n	uniform vec2 anisotropyVector;\n	#ifdef USE_ANISOTROPYMAP\n		uniform sampler2D anisotropyMap;\n	#endif\n#endif\nvarying vec3 vViewPosition;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <iridescence_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_physical_pars_fragment>\n#include <transmission_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <iridescence_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <roughnessmap_fragment>\n	#include <metalnessmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <clearcoat_normal_fragment_begin>\n	#include <clearcoat_normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_physical_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n	vec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n	#include <transmission_fragment>\n	vec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n	#ifdef USE_SHEEN\n		float sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );\n		outgoingLight = outgoingLight * sheenEnergyComp + sheenSpecularDirect + sheenSpecularIndirect;\n	#endif\n	#ifdef USE_CLEARCOAT\n		float dotNVcc = saturate( dot( geometryClearcoatNormal, geometryViewDir ) );\n		vec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\n		outgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + ( clearcoatSpecularDirect + clearcoatSpecularIndirect ) * material.clearcoat;\n	#endif\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}",
            meshtoon_vert: "#define TOON\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}",
            meshtoon_frag: "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_toon_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}",
            points_vert: "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\n#ifdef USE_POINTS_UV\n	varying vec2 vUv;\n	uniform mat3 uvTransform;\n#endif\nvoid main() {\n	#ifdef USE_POINTS_UV\n		vUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n	#endif\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <project_vertex>\n	gl_PointSize = size;\n	#ifdef USE_SIZEATTENUATION\n		bool isPerspective = isPerspectiveMatrix( projectionMatrix );\n		if ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n	#endif\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <worldpos_vertex>\n	#include <fog_vertex>\n}",
            points_frag: "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec3 outgoingLight = vec3( 0.0 );\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_particle_fragment>\n	#include <color_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n}",
            shadow_vert: "#include <common>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}",
            shadow_frag: "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <logdepthbuf_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n	#include <logdepthbuf_fragment>\n	gl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n}",
            sprite_vert: "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	vec4 mvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );\n	vec2 scale;\n	scale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );\n	scale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );\n	#ifndef USE_SIZEATTENUATION\n		bool isPerspective = isPerspectiveMatrix( projectionMatrix );\n		if ( isPerspective ) scale *= - mvPosition.z;\n	#endif\n	vec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n	vec2 rotatedPosition;\n	rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n	rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n	mvPosition.xy += rotatedPosition;\n	gl_Position = projectionMatrix * mvPosition;\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n}",
            sprite_frag: "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec3 outgoingLight = vec3( 0.0 );\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n}"
        }, dh = {
            common: {
                diffuse: {
                    value: new Yc(16777215)
                },
                opacity: {
                    value: 1
                },
                map: {
                    value: null
                },
                mapTransform: {
                    value: new Jo
                },
                alphaMap: {
                    value: null
                },
                alphaMapTransform: {
                    value: new Jo
                },
                alphaTest: {
                    value: 0
                }
            },
            specularmap: {
                specularMap: {
                    value: null
                },
                specularMapTransform: {
                    value: new Jo
                }
            },
            envmap: {
                envMap: {
                    value: null
                },
                flipEnvMap: {
                    value: -1
                },
                reflectivity: {
                    value: 1
                },
                ior: {
                    value: 1.5
                },
                refractionRatio: {
                    value: .98
                }
            },
            aomap: {
                aoMap: {
                    value: null
                },
                aoMapIntensity: {
                    value: 1
                },
                aoMapTransform: {
                    value: new Jo
                }
            },
            lightmap: {
                lightMap: {
                    value: null
                },
                lightMapIntensity: {
                    value: 1
                },
                lightMapTransform: {
                    value: new Jo
                }
            },
            bumpmap: {
                bumpMap: {
                    value: null
                },
                bumpMapTransform: {
                    value: new Jo
                },
                bumpScale: {
                    value: 1
                }
            },
            normalmap: {
                normalMap: {
                    value: null
                },
                normalMapTransform: {
                    value: new Jo
                },
                normalScale: {
                    value: new qo(1, 1)
                }
            },
            displacementmap: {
                displacementMap: {
                    value: null
                },
                displacementMapTransform: {
                    value: new Jo
                },
                displacementScale: {
                    value: 1
                },
                displacementBias: {
                    value: 0
                }
            },
            emissivemap: {
                emissiveMap: {
                    value: null
                },
                emissiveMapTransform: {
                    value: new Jo
                }
            },
            metalnessmap: {
                metalnessMap: {
                    value: null
                },
                metalnessMapTransform: {
                    value: new Jo
                }
            },
            roughnessmap: {
                roughnessMap: {
                    value: null
                },
                roughnessMapTransform: {
                    value: new Jo
                }
            },
            gradientmap: {
                gradientMap: {
                    value: null
                }
            },
            fog: {
                fogDensity: {
                    value: 25e-5
                },
                fogNear: {
                    value: 1
                },
                fogFar: {
                    value: 2e3
                },
                fogColor: {
                    value: new Yc(16777215)
                }
            },
            lights: {
                ambientLightColor: {
                    value: []
                },
                lightProbe: {
                    value: []
                },
                directionalLights: {
                    value: [],
                    properties: {
                        direction: {},
                        color: {}
                    }
                },
                directionalLightShadows: {
                    value: [],
                    properties: {
                        shadowBias: {},
                        shadowNormalBias: {},
                        shadowRadius: {},
                        shadowMapSize: {}
                    }
                },
                directionalShadowMap: {
                    value: []
                },
                directionalShadowMatrix: {
                    value: []
                },
                spotLights: {
                    value: [],
                    properties: {
                        color: {},
                        position: {},
                        direction: {},
                        distance: {},
                        coneCos: {},
                        penumbraCos: {},
                        decay: {}
                    }
                },
                spotLightShadows: {
                    value: [],
                    properties: {
                        shadowBias: {},
                        shadowNormalBias: {},
                        shadowRadius: {},
                        shadowMapSize: {}
                    }
                },
                spotLightMap: {
                    value: []
                },
                spotShadowMap: {
                    value: []
                },
                spotLightMatrix: {
                    value: []
                },
                pointLights: {
                    value: [],
                    properties: {
                        color: {},
                        position: {},
                        decay: {},
                        distance: {}
                    }
                },
                pointLightShadows: {
                    value: [],
                    properties: {
                        shadowBias: {},
                        shadowNormalBias: {},
                        shadowRadius: {},
                        shadowMapSize: {},
                        shadowCameraNear: {},
                        shadowCameraFar: {}
                    }
                },
                pointShadowMap: {
                    value: []
                },
                pointShadowMatrix: {
                    value: []
                },
                hemisphereLights: {
                    value: [],
                    properties: {
                        direction: {},
                        skyColor: {},
                        groundColor: {}
                    }
                },
                rectAreaLights: {
                    value: [],
                    properties: {
                        color: {},
                        position: {},
                        width: {},
                        height: {}
                    }
                },
                ltc_1: {
                    value: null
                },
                ltc_2: {
                    value: null
                }
            },
            points: {
                diffuse: {
                    value: new Yc(16777215)
                },
                opacity: {
                    value: 1
                },
                size: {
                    value: 1
                },
                scale: {
                    value: 1
                },
                map: {
                    value: null
                },
                alphaMap: {
                    value: null
                },
                alphaMapTransform: {
                    value: new Jo
                },
                alphaTest: {
                    value: 0
                },
                uvTransform: {
                    value: new Jo
                }
            },
            sprite: {
                diffuse: {
                    value: new Yc(16777215)
                },
                opacity: {
                    value: 1
                },
                center: {
                    value: new qo(.5, .5)
                },
                rotation: {
                    value: 0
                },
                map: {
                    value: null
                },
                mapTransform: {
                    value: new Jo
                },
                alphaMap: {
                    value: null
                },
                alphaMapTransform: {
                    value: new Jo
                },
                alphaTest: {
                    value: 0
                }
            }
        }, ph = {
            basic: {
                uniforms: Gu([
                    dh.common,
                    dh.specularmap,
                    dh.envmap,
                    dh.aomap,
                    dh.lightmap,
                    dh.fog
                ]),
                vertexShader: hh.meshbasic_vert,
                fragmentShader: hh.meshbasic_frag
            },
            lambert: {
                uniforms: Gu([
                    dh.common,
                    dh.specularmap,
                    dh.envmap,
                    dh.aomap,
                    dh.lightmap,
                    dh.emissivemap,
                    dh.bumpmap,
                    dh.normalmap,
                    dh.displacementmap,
                    dh.fog,
                    dh.lights,
                    {
                        emissive: {
                            value: new Yc(0)
                        }
                    }
                ]),
                vertexShader: hh.meshlambert_vert,
                fragmentShader: hh.meshlambert_frag
            },
            phong: {
                uniforms: Gu([
                    dh.common,
                    dh.specularmap,
                    dh.envmap,
                    dh.aomap,
                    dh.lightmap,
                    dh.emissivemap,
                    dh.bumpmap,
                    dh.normalmap,
                    dh.displacementmap,
                    dh.fog,
                    dh.lights,
                    {
                        emissive: {
                            value: new Yc(0)
                        },
                        specular: {
                            value: new Yc(1118481)
                        },
                        shininess: {
                            value: 30
                        }
                    }
                ]),
                vertexShader: hh.meshphong_vert,
                fragmentShader: hh.meshphong_frag
            },
            standard: {
                uniforms: Gu([
                    dh.common,
                    dh.envmap,
                    dh.aomap,
                    dh.lightmap,
                    dh.emissivemap,
                    dh.bumpmap,
                    dh.normalmap,
                    dh.displacementmap,
                    dh.roughnessmap,
                    dh.metalnessmap,
                    dh.fog,
                    dh.lights,
                    {
                        emissive: {
                            value: new Yc(0)
                        },
                        roughness: {
                            value: 1
                        },
                        metalness: {
                            value: 0
                        },
                        envMapIntensity: {
                            value: 1
                        }
                    }
                ]),
                vertexShader: hh.meshphysical_vert,
                fragmentShader: hh.meshphysical_frag
            },
            toon: {
                uniforms: Gu([
                    dh.common,
                    dh.aomap,
                    dh.lightmap,
                    dh.emissivemap,
                    dh.bumpmap,
                    dh.normalmap,
                    dh.displacementmap,
                    dh.gradientmap,
                    dh.fog,
                    dh.lights,
                    {
                        emissive: {
                            value: new Yc(0)
                        }
                    }
                ]),
                vertexShader: hh.meshtoon_vert,
                fragmentShader: hh.meshtoon_frag
            },
            matcap: {
                uniforms: Gu([
                    dh.common,
                    dh.bumpmap,
                    dh.normalmap,
                    dh.displacementmap,
                    dh.fog,
                    {
                        matcap: {
                            value: null
                        }
                    }
                ]),
                vertexShader: hh.meshmatcap_vert,
                fragmentShader: hh.meshmatcap_frag
            },
            points: {
                uniforms: Gu([
                    dh.points,
                    dh.fog
                ]),
                vertexShader: hh.points_vert,
                fragmentShader: hh.points_frag
            },
            dashed: {
                uniforms: Gu([
                    dh.common,
                    dh.fog,
                    {
                        scale: {
                            value: 1
                        },
                        dashSize: {
                            value: 1
                        },
                        totalSize: {
                            value: 2
                        }
                    }
                ]),
                vertexShader: hh.linedashed_vert,
                fragmentShader: hh.linedashed_frag
            },
            depth: {
                uniforms: Gu([
                    dh.common,
                    dh.displacementmap
                ]),
                vertexShader: hh.depth_vert,
                fragmentShader: hh.depth_frag
            },
            normal: {
                uniforms: Gu([
                    dh.common,
                    dh.bumpmap,
                    dh.normalmap,
                    dh.displacementmap,
                    {
                        opacity: {
                            value: 1
                        }
                    }
                ]),
                vertexShader: hh.meshnormal_vert,
                fragmentShader: hh.meshnormal_frag
            },
            sprite: {
                uniforms: Gu([
                    dh.sprite,
                    dh.fog
                ]),
                vertexShader: hh.sprite_vert,
                fragmentShader: hh.sprite_frag
            },
            background: {
                uniforms: {
                    uvTransform: {
                        value: new Jo
                    },
                    t2D: {
                        value: null
                    },
                    backgroundIntensity: {
                        value: 1
                    }
                },
                vertexShader: hh.background_vert,
                fragmentShader: hh.background_frag
            },
            backgroundCube: {
                uniforms: {
                    envMap: {
                        value: null
                    },
                    flipEnvMap: {
                        value: -1
                    },
                    backgroundBlurriness: {
                        value: 0
                    },
                    backgroundIntensity: {
                        value: 1
                    }
                },
                vertexShader: hh.backgroundCube_vert,
                fragmentShader: hh.backgroundCube_frag
            },
            cube: {
                uniforms: {
                    tCube: {
                        value: null
                    },
                    tFlip: {
                        value: -1
                    },
                    opacity: {
                        value: 1
                    }
                },
                vertexShader: hh.cube_vert,
                fragmentShader: hh.cube_frag
            },
            equirect: {
                uniforms: {
                    tEquirect: {
                        value: null
                    }
                },
                vertexShader: hh.equirect_vert,
                fragmentShader: hh.equirect_frag
            },
            distanceRGBA: {
                uniforms: Gu([
                    dh.common,
                    dh.displacementmap,
                    {
                        referencePosition: {
                            value: new Nl
                        },
                        nearDistance: {
                            value: 1
                        },
                        farDistance: {
                            value: 1e3
                        }
                    }
                ]),
                vertexShader: hh.distanceRGBA_vert,
                fragmentShader: hh.distanceRGBA_frag
            },
            shadow: {
                uniforms: Gu([
                    dh.lights,
                    dh.fog,
                    {
                        color: {
                            value: new Yc(0)
                        },
                        opacity: {
                            value: 1
                        }
                    }
                ]),
                vertexShader: hh.shadow_vert,
                fragmentShader: hh.shadow_frag
            }
        };
        ph.physical = {
            uniforms: Gu([
                ph.standard.uniforms,
                {
                    clearcoat: {
                        value: 0
                    },
                    clearcoatMap: {
                        value: null
                    },
                    clearcoatMapTransform: {
                        value: new Jo
                    },
                    clearcoatNormalMap: {
                        value: null
                    },
                    clearcoatNormalMapTransform: {
                        value: new Jo
                    },
                    clearcoatNormalScale: {
                        value: new qo(1, 1)
                    },
                    clearcoatRoughness: {
                        value: 0
                    },
                    clearcoatRoughnessMap: {
                        value: null
                    },
                    clearcoatRoughnessMapTransform: {
                        value: new Jo
                    },
                    iridescence: {
                        value: 0
                    },
                    iridescenceMap: {
                        value: null
                    },
                    iridescenceMapTransform: {
                        value: new Jo
                    },
                    iridescenceIOR: {
                        value: 1.3
                    },
                    iridescenceThicknessMinimum: {
                        value: 100
                    },
                    iridescenceThicknessMaximum: {
                        value: 400
                    },
                    iridescenceThicknessMap: {
                        value: null
                    },
                    iridescenceThicknessMapTransform: {
                        value: new Jo
                    },
                    sheen: {
                        value: 0
                    },
                    sheenColor: {
                        value: new Yc(0)
                    },
                    sheenColorMap: {
                        value: null
                    },
                    sheenColorMapTransform: {
                        value: new Jo
                    },
                    sheenRoughness: {
                        value: 1
                    },
                    sheenRoughnessMap: {
                        value: null
                    },
                    sheenRoughnessMapTransform: {
                        value: new Jo
                    },
                    transmission: {
                        value: 0
                    },
                    transmissionMap: {
                        value: null
                    },
                    transmissionMapTransform: {
                        value: new Jo
                    },
                    transmissionSamplerSize: {
                        value: new qo
                    },
                    transmissionSamplerMap: {
                        value: null
                    },
                    thickness: {
                        value: 0
                    },
                    thicknessMap: {
                        value: null
                    },
                    thicknessMapTransform: {
                        value: new Jo
                    },
                    attenuationDistance: {
                        value: 0
                    },
                    attenuationColor: {
                        value: new Yc(0)
                    },
                    specularColor: {
                        value: new Yc(1, 1, 1)
                    },
                    specularColorMap: {
                        value: null
                    },
                    specularColorMapTransform: {
                        value: new Jo
                    },
                    specularIntensity: {
                        value: 1
                    },
                    specularIntensityMap: {
                        value: null
                    },
                    specularIntensityMapTransform: {
                        value: new Jo
                    },
                    anisotropyVector: {
                        value: new qo
                    },
                    anisotropyMap: {
                        value: null
                    },
                    anisotropyMapTransform: {
                        value: new Jo
                    }
                }
            ]),
            vertexShader: hh.meshphysical_vert,
            fragmentShader: hh.meshphysical_frag
        };
        const Ah = {
            r: 0,
            b: 0,
            g: 0
        };
        function fh(t1, e, i, n, r, a, s) {
            const o = new Yc(0);
            let l, c, u = !0 === a ? 0 : 1, h = null, d = 0, p = null;
            function A(e, i) {
                e.getRGB(Ah, Wu(t1)), n.buffers.color.setClear(Ah.r, Ah.g, Ah.b, i, s);
            }
            return {
                getClearColor: function() {
                    return o;
                },
                setClearColor: function(t1, e = 1) {
                    o.set(t1), u = e, A(o, u);
                },
                getClearAlpha: function() {
                    return u;
                },
                setClearAlpha: function(t1) {
                    u = t1, A(o, u);
                },
                render: function(a, f) {
                    let m = !1, g = !0 === f.isScene ? f.background : null;
                    g && g.isTexture && (g = (f.backgroundBlurriness > 0 ? i : e).get(g)), null === g ? A(o, u) : g && g.isColor && (A(g, 1), m = !0);
                    const M = t1.xr.getEnvironmentBlendMode();
                    "additive" === M ? n.buffers.color.setClear(0, 0, 0, 1, s) : "alpha-blend" === M && n.buffers.color.setClear(0, 0, 0, 0, s), (t1.autoClear || m) && t1.clear(t1.autoClearColor, t1.autoClearDepth, t1.autoClearStencil), g && (g.isCubeTexture || g.mapping === oa) ? (void 0 === c && (c = new Fu(new Hu(1, 1, 1), new Xu({
                        name: "BackgroundCubeMaterial",
                        uniforms: Vu(ph.backgroundCube.uniforms),
                        vertexShader: ph.backgroundCube.vertexShader,
                        fragmentShader: ph.backgroundCube.fragmentShader,
                        side: lr,
                        depthTest: !1,
                        depthWrite: !1,
                        fog: !1
                    })), c.geometry.deleteAttribute("normal"), c.geometry.deleteAttribute("uv"), c.onBeforeRender = function(t1, e, i) {
                        this.matrixWorld.copyPosition(i.matrixWorld);
                    }, Object.defineProperty(c.material, "envMap", {
                        get: function() {
                            return this.uniforms.envMap.value;
                        }
                    }), r.update(c)), c.material.uniforms.envMap.value = g, c.material.uniforms.flipEnvMap.value = g.isCubeTexture && !1 === g.isRenderTargetTexture ? -1 : 1, c.material.uniforms.backgroundBlurriness.value = f.backgroundBlurriness, c.material.uniforms.backgroundIntensity.value = f.backgroundIntensity, c.material.toneMapped = ul.getTransfer(g.colorSpace) !== Ys, h === g && d === g.version && p === t1.toneMapping || (c.material.needsUpdate = !0, h = g, d = g.version, p = t1.toneMapping), c.layers.enableAll(), a.unshift(c, c.geometry, c.material, 0, 0, null)) : g && g.isTexture && (void 0 === l && (l = new Fu(new uh(2, 2), new Xu({
                        name: "BackgroundMaterial",
                        uniforms: Vu(ph.background.uniforms),
                        vertexShader: ph.background.vertexShader,
                        fragmentShader: ph.background.fragmentShader,
                        side: or,
                        depthTest: !1,
                        depthWrite: !1,
                        fog: !1
                    })), l.geometry.deleteAttribute("normal"), Object.defineProperty(l.material, "map", {
                        get: function() {
                            return this.uniforms.t2D.value;
                        }
                    }), r.update(l)), l.material.uniforms.t2D.value = g, l.material.uniforms.backgroundIntensity.value = f.backgroundIntensity, l.material.toneMapped = ul.getTransfer(g.colorSpace) !== Ys, !0 === g.matrixAutoUpdate && g.updateMatrix(), l.material.uniforms.uvTransform.value.copy(g.matrix), h === g && d === g.version && p === t1.toneMapping || (l.material.needsUpdate = !0, h = g, d = g.version, p = t1.toneMapping), l.layers.enableAll(), a.unshift(l, l.geometry, l.material, 0, 0, null));
                }
            };
        }
        function mh(t1, e, i, n) {
            const r = t1.getParameter(t1.MAX_VERTEX_ATTRIBS), a = n.isWebGL2 ? null : e.get("OES_vertex_array_object"), s = n.isWebGL2 || null !== a, o = {}, l = p(null);
            let c = l, u = !1;
            function h(e) {
                return n.isWebGL2 ? t1.bindVertexArray(e) : a.bindVertexArrayOES(e);
            }
            function d(e) {
                return n.isWebGL2 ? t1.deleteVertexArray(e) : a.deleteVertexArrayOES(e);
            }
            function p(t1) {
                const e = [], i = [], n = [];
                for(let t1 = 0; t1 < r; t1++)e[t1] = 0, i[t1] = 0, n[t1] = 0;
                return {
                    geometry: null,
                    program: null,
                    wireframe: !1,
                    newAttributes: e,
                    enabledAttributes: i,
                    attributeDivisors: n,
                    object: t1,
                    attributes: {},
                    index: null
                };
            }
            function A() {
                const t1 = c.newAttributes;
                for(let e = 0, i = t1.length; e < i; e++)t1[e] = 0;
            }
            function f(t1) {
                m(t1, 0);
            }
            function m(i, r) {
                const a = c.newAttributes, s = c.enabledAttributes, o = c.attributeDivisors;
                a[i] = 1, 0 === s[i] && (t1.enableVertexAttribArray(i), s[i] = 1), o[i] !== r && ((n.isWebGL2 ? t1 : e.get("ANGLE_instanced_arrays"))[n.isWebGL2 ? "vertexAttribDivisor" : "vertexAttribDivisorANGLE"](i, r), o[i] = r);
            }
            function g() {
                const e = c.newAttributes, i = c.enabledAttributes;
                for(let n = 0, r = i.length; n < r; n++)i[n] !== e[n] && (t1.disableVertexAttribArray(n), i[n] = 0);
            }
            function M(e, i, n, r, a, s, o) {
                !0 === o ? t1.vertexAttribIPointer(e, i, n, a, s) : t1.vertexAttribPointer(e, i, n, r, a, s);
            }
            function v() {
                y(), u = !0, c !== l && (c = l, h(c.object));
            }
            function y() {
                l.geometry = null, l.program = null, l.wireframe = !1;
            }
            return {
                setup: function(r, l, d, v, y) {
                    let x = !1;
                    if (s) {
                        const e = function(e, i, r) {
                            const s = !0 === r.wireframe;
                            let l = o[e.id];
                            void 0 === l && (l = {}, o[e.id] = l);
                            let c = l[i.id];
                            void 0 === c && (c = {}, l[i.id] = c);
                            let u = c[s];
                            return void 0 === u && (u = p(n.isWebGL2 ? t1.createVertexArray() : a.createVertexArrayOES()), c[s] = u), u;
                        }(v, d, l);
                        c !== e && (c = e, h(c.object)), x = function(t1, e, i, n) {
                            const r = c.attributes, a = e.attributes;
                            let s = 0;
                            const o = i.getAttributes();
                            for(const e in o)if (o[e].location >= 0) {
                                const i = r[e];
                                let n = a[e];
                                if (void 0 === n && ("instanceMatrix" === e && t1.instanceMatrix && (n = t1.instanceMatrix), "instanceColor" === e && t1.instanceColor && (n = t1.instanceColor)), void 0 === i) return !0;
                                if (i.attribute !== n) return !0;
                                if (n && i.data !== n.data) return !0;
                                s++;
                            }
                            return c.attributesNum !== s || c.index !== n;
                        }(r, v, d, y), x && function(t1, e, i, n) {
                            const r = {}, a = e.attributes;
                            let s = 0;
                            const o = i.getAttributes();
                            for(const e in o)if (o[e].location >= 0) {
                                let i = a[e];
                                void 0 === i && ("instanceMatrix" === e && t1.instanceMatrix && (i = t1.instanceMatrix), "instanceColor" === e && t1.instanceColor && (i = t1.instanceColor));
                                const n = {};
                                n.attribute = i, i && i.data && (n.data = i.data), r[e] = n, s++;
                            }
                            c.attributes = r, c.attributesNum = s, c.index = n;
                        }(r, v, d, y);
                    } else {
                        const t1 = !0 === l.wireframe;
                        c.geometry === v.id && c.program === d.id && c.wireframe === t1 || (c.geometry = v.id, c.program = d.id, c.wireframe = t1, x = !0);
                    }
                    null !== y && i.update(y, t1.ELEMENT_ARRAY_BUFFER), (x || u) && (u = !1, function(r, a, s, o) {
                        if (!1 === n.isWebGL2 && (r.isInstancedMesh || o.isInstancedBufferGeometry) && null === e.get("ANGLE_instanced_arrays")) return;
                        A();
                        const l = o.attributes, c = s.getAttributes(), u = a.defaultAttributeValues;
                        for(const e in c){
                            const a = c[e];
                            if (a.location >= 0) {
                                let s = l[e];
                                if (void 0 === s && ("instanceMatrix" === e && r.instanceMatrix && (s = r.instanceMatrix), "instanceColor" === e && r.instanceColor && (s = r.instanceColor)), void 0 !== s) {
                                    const e = s.normalized, l = s.itemSize, c = i.get(s);
                                    if (void 0 === c) continue;
                                    const u = c.buffer, h = c.type, d = c.bytesPerElement, p = !0 === n.isWebGL2 && (h === t1.INT || h === t1.UNSIGNED_INT || s.gpuType === Ea);
                                    if (s.isInterleavedBufferAttribute) {
                                        const i = s.data, n = i.stride, c = s.offset;
                                        if (i.isInstancedInterleavedBuffer) {
                                            for(let t1 = 0; t1 < a.locationSize; t1++)m(a.location + t1, i.meshPerAttribute);
                                            !0 !== r.isInstancedMesh && void 0 === o._maxInstanceCount && (o._maxInstanceCount = i.meshPerAttribute * i.count);
                                        } else for(let t1 = 0; t1 < a.locationSize; t1++)f(a.location + t1);
                                        t1.bindBuffer(t1.ARRAY_BUFFER, u);
                                        for(let t1 = 0; t1 < a.locationSize; t1++)M(a.location + t1, l / a.locationSize, h, e, n * d, (c + l / a.locationSize * t1) * d, p);
                                    } else {
                                        if (s.isInstancedBufferAttribute) {
                                            for(let t1 = 0; t1 < a.locationSize; t1++)m(a.location + t1, s.meshPerAttribute);
                                            !0 !== r.isInstancedMesh && void 0 === o._maxInstanceCount && (o._maxInstanceCount = s.meshPerAttribute * s.count);
                                        } else for(let t1 = 0; t1 < a.locationSize; t1++)f(a.location + t1);
                                        t1.bindBuffer(t1.ARRAY_BUFFER, u);
                                        for(let t1 = 0; t1 < a.locationSize; t1++)M(a.location + t1, l / a.locationSize, h, e, l * d, l / a.locationSize * t1 * d, p);
                                    }
                                } else if (void 0 !== u) {
                                    const i = u[e];
                                    if (void 0 !== i) switch(i.length){
                                        case 2:
                                            t1.vertexAttrib2fv(a.location, i);
                                            break;
                                        case 3:
                                            t1.vertexAttrib3fv(a.location, i);
                                            break;
                                        case 4:
                                            t1.vertexAttrib4fv(a.location, i);
                                            break;
                                        default:
                                            t1.vertexAttrib1fv(a.location, i);
                                    }
                                }
                            }
                        }
                        g();
                    }(r, l, d, v), null !== y && t1.bindBuffer(t1.ELEMENT_ARRAY_BUFFER, i.get(y).buffer));
                },
                reset: v,
                resetDefaultState: y,
                dispose: function() {
                    v();
                    for(const t1 in o){
                        const e = o[t1];
                        for(const t1 in e){
                            const i = e[t1];
                            for(const t1 in i)d(i[t1].object), delete i[t1];
                            delete e[t1];
                        }
                        delete o[t1];
                    }
                },
                releaseStatesOfGeometry: function(t1) {
                    if (void 0 === o[t1.id]) return;
                    const e = o[t1.id];
                    for(const t1 in e){
                        const i = e[t1];
                        for(const t1 in i)d(i[t1].object), delete i[t1];
                        delete e[t1];
                    }
                    delete o[t1.id];
                },
                releaseStatesOfProgram: function(t1) {
                    for(const e in o){
                        const i = o[e];
                        if (void 0 === i[t1.id]) continue;
                        const n = i[t1.id];
                        for(const t1 in n)d(n[t1].object), delete n[t1];
                        delete i[t1.id];
                    }
                },
                initAttributes: A,
                enableAttribute: f,
                disableUnusedAttributes: g
            };
        }
        function gh(t1, e, i, n) {
            const r = n.isWebGL2;
            let a;
            this.setMode = function(t1) {
                a = t1;
            }, this.render = function(e, n) {
                t1.drawArrays(a, e, n), i.update(n, a, 1);
            }, this.renderInstances = function(n, s, o) {
                if (0 === o) return;
                let l, c;
                if (r) l = t1, c = "drawArraysInstanced";
                else if (l = e.get("ANGLE_instanced_arrays"), c = "drawArraysInstancedANGLE", null === l) return void console.error("THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
                l[c](a, n, s, o), i.update(s, a, o);
            };
        }
        function Mh(t1, e, i) {
            let n;
            function r(e) {
                if ("highp" === e) {
                    if (t1.getShaderPrecisionFormat(t1.VERTEX_SHADER, t1.HIGH_FLOAT).precision > 0 && t1.getShaderPrecisionFormat(t1.FRAGMENT_SHADER, t1.HIGH_FLOAT).precision > 0) return "highp";
                    e = "mediump";
                }
                return "mediump" === e && t1.getShaderPrecisionFormat(t1.VERTEX_SHADER, t1.MEDIUM_FLOAT).precision > 0 && t1.getShaderPrecisionFormat(t1.FRAGMENT_SHADER, t1.MEDIUM_FLOAT).precision > 0 ? "mediump" : "lowp";
            }
            const a = "undefined" != typeof WebGL2RenderingContext && "WebGL2RenderingContext" === t1.constructor.name;
            let s = void 0 !== i.precision ? i.precision : "highp";
            const o = r(s);
            o !== s && (console.warn("THREE.WebGLRenderer:", s, "not supported, using", o, "instead."), s = o);
            const l = a || e.has("WEBGL_draw_buffers"), c = !0 === i.logarithmicDepthBuffer, u = t1.getParameter(t1.MAX_TEXTURE_IMAGE_UNITS), h = t1.getParameter(t1.MAX_VERTEX_TEXTURE_IMAGE_UNITS), d = t1.getParameter(t1.MAX_TEXTURE_SIZE), p = t1.getParameter(t1.MAX_CUBE_MAP_TEXTURE_SIZE), A = t1.getParameter(t1.MAX_VERTEX_ATTRIBS), f = t1.getParameter(t1.MAX_VERTEX_UNIFORM_VECTORS), m = t1.getParameter(t1.MAX_VARYING_VECTORS), g = t1.getParameter(t1.MAX_FRAGMENT_UNIFORM_VECTORS), M = h > 0, v = a || e.has("OES_texture_float");
            return {
                isWebGL2: a,
                drawBuffers: l,
                getMaxAnisotropy: function() {
                    if (void 0 !== n) return n;
                    if (!0 === e.has("EXT_texture_filter_anisotropic")) {
                        const i = e.get("EXT_texture_filter_anisotropic");
                        n = t1.getParameter(i.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
                    } else n = 0;
                    return n;
                },
                getMaxPrecision: r,
                precision: s,
                logarithmicDepthBuffer: c,
                maxTextures: u,
                maxVertexTextures: h,
                maxTextureSize: d,
                maxCubemapSize: p,
                maxAttributes: A,
                maxVertexUniforms: f,
                maxVaryings: m,
                maxFragmentUniforms: g,
                vertexTextures: M,
                floatFragmentTextures: v,
                floatVertexTextures: M && v,
                maxSamples: a ? t1.getParameter(t1.MAX_SAMPLES) : 0
            };
        }
        function vh(t1) {
            const e = this;
            let i = null, n = 0, r = !1, a = !1;
            const s = new rh, o = new Jo, l = {
                value: null,
                needsUpdate: !1
            };
            function c(t1, i, n, r) {
                const a = null !== t1 ? t1.length : 0;
                let c = null;
                if (0 !== a) {
                    if (c = l.value, !0 !== r || null === c) {
                        const e = n + 4 * a, r = i.matrixWorldInverse;
                        o.getNormalMatrix(r), (null === c || c.length < e) && (c = new Float32Array(e));
                        for(let e = 0, i = n; e !== a; ++e, i += 4)s.copy(t1[e]).applyMatrix4(r, o), s.normal.toArray(c, i), c[i + 3] = s.constant;
                    }
                    l.value = c, l.needsUpdate = !0;
                }
                return e.numPlanes = a, e.numIntersection = 0, c;
            }
            this.uniform = l, this.numPlanes = 0, this.numIntersection = 0, this.init = function(t1, e) {
                const i = 0 !== t1.length || e || 0 !== n || r;
                return r = e, n = t1.length, i;
            }, this.beginShadows = function() {
                a = !0, c(null);
            }, this.endShadows = function() {
                a = !1;
            }, this.setGlobalState = function(t1, e) {
                i = c(t1, e, 0);
            }, this.setState = function(s, o, u) {
                const h = s.clippingPlanes, d = s.clipIntersection, p = s.clipShadows, A = t1.get(s);
                if (!r || null === h || 0 === h.length || a && !p) a ? c(null) : (l.value !== i && (l.value = i, l.needsUpdate = n > 0), e.numPlanes = n, e.numIntersection = 0);
                else {
                    const t1 = a ? 0 : n, e = 4 * t1;
                    let r = A.clippingState || null;
                    l.value = r, r = c(h, o, e, u);
                    for(let t1 = 0; t1 !== e; ++t1)r[t1] = i[t1];
                    A.clippingState = r, this.numIntersection = d ? this.numPlanes : 0, this.numPlanes += t1;
                }
            };
        }
        function yh(t1) {
            let e = new WeakMap;
            function i(t1, e) {
                return e === aa ? t1.mapping = na : e === sa && (t1.mapping = ra), t1;
            }
            function n(t1) {
                const i = t1.target;
                i.removeEventListener("dispose", n);
                const r = e.get(i);
                void 0 !== r && (e.delete(i), r.dispose());
            }
            return {
                get: function(r) {
                    if (r && r.isTexture && !1 === r.isRenderTargetTexture) {
                        const a = r.mapping;
                        if (a === aa || a === sa) {
                            if (e.has(r)) return i(e.get(r).texture, r.mapping);
                            {
                                const a = r.image;
                                if (a && a.height > 0) {
                                    const s = new th(a.height / 2);
                                    return s.fromEquirectangularTexture(t1, r), e.set(r, s), r.addEventListener("dispose", n), i(s.texture, r.mapping);
                                }
                                return null;
                            }
                        }
                    }
                    return r;
                },
                dispose: function() {
                    e = new WeakMap;
                }
            };
        }
        class xh extends Zu {
            constructor(t1 = -1, e = 1, i = 1, n = -1, r = .1, a = 2e3){
                super(), this.isOrthographicCamera = !0, this.type = "OrthographicCamera", this.zoom = 1, this.view = null, this.left = t1, this.right = e, this.top = i, this.bottom = n, this.near = r, this.far = a, this.updateProjectionMatrix();
            }
            copy(t1, e) {
                return super.copy(t1, e), this.left = t1.left, this.right = t1.right, this.top = t1.top, this.bottom = t1.bottom, this.near = t1.near, this.far = t1.far, this.zoom = t1.zoom, this.view = null === t1.view ? null : Object.assign({}, t1.view), this;
            }
            setViewOffset(t1, e, i, n, r, a) {
                null === this.view && (this.view = {
                    enabled: !0,
                    fullWidth: 1,
                    fullHeight: 1,
                    offsetX: 0,
                    offsetY: 0,
                    width: 1,
                    height: 1
                }), this.view.enabled = !0, this.view.fullWidth = t1, this.view.fullHeight = e, this.view.offsetX = i, this.view.offsetY = n, this.view.width = r, this.view.height = a, this.updateProjectionMatrix();
            }
            clearViewOffset() {
                null !== this.view && (this.view.enabled = !1), this.updateProjectionMatrix();
            }
            updateProjectionMatrix() {
                const t1 = (this.right - this.left) / (2 * this.zoom), e = (this.top - this.bottom) / (2 * this.zoom), i = (this.right + this.left) / 2, n = (this.top + this.bottom) / 2;
                let r = i - t1, a = i + t1, s = n + e, o = n - e;
                if (null !== this.view && this.view.enabled) {
                    const t1 = (this.right - this.left) / this.view.fullWidth / this.zoom, e = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
                    r += t1 * this.view.offsetX, a = r + t1 * this.view.width, s -= e * this.view.offsetY, o = s - e * this.view.height;
                }
                this.projectionMatrix.makeOrthographic(r, a, s, o, this.near, this.far, this.coordinateSystem), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
            }
            toJSON(t1) {
                const e = super.toJSON(t1);
                return e.object.zoom = this.zoom, e.object.left = this.left, e.object.right = this.right, e.object.top = this.top, e.object.bottom = this.bottom, e.object.near = this.near, e.object.far = this.far, null !== this.view && (e.object.view = Object.assign({}, this.view)), e;
            }
        }
        const wh = [
            .125,
            .215,
            .35,
            .446,
            .526,
            .582
        ], bh = new xh, Th = new Yc;
        let Eh = null, _h = 0, Ih = 0;
        const Sh = (1 + Math.sqrt(5)) / 2, Nh = 1 / Sh, Dh = [
            new Nl(1, 1, 1),
            new Nl(-1, 1, 1),
            new Nl(1, 1, -1),
            new Nl(-1, 1, -1),
            new Nl(0, Sh, Nh),
            new Nl(0, Sh, -Nh),
            new Nl(Nh, 0, Sh),
            new Nl(-Nh, 0, Sh),
            new Nl(Sh, Nh, 0),
            new Nl(-Sh, Nh, 0)
        ];
        class Ch {
            constructor(t1){
                this._renderer = t1, this._pingPongRenderTarget = null, this._lodMax = 0, this._cubeSize = 0, this._lodPlanes = [], this._sizeLods = [], this._sigmas = [], this._blurMaterial = null, this._cubemapMaterial = null, this._equirectMaterial = null, this._compileMaterial(this._blurMaterial);
            }
            fromScene(t1, e = 0, i = .1, n = 100) {
                Eh = this._renderer.getRenderTarget(), _h = this._renderer.getActiveCubeFace(), Ih = this._renderer.getActiveMipmapLevel(), this._setSize(256);
                const r = this._allocateTargets();
                return r.depthBuffer = !0, this._sceneToCubeUV(t1, i, n, r), e > 0 && this._blur(r, 0, 0, e), this._applyPMREM(r), this._cleanup(r), r;
            }
            fromEquirectangular(t1, e = null) {
                return this._fromTexture(t1, e);
            }
            fromCubemap(t1, e = null) {
                return this._fromTexture(t1, e);
            }
            compileCubemapShader() {
                null === this._cubemapMaterial && (this._cubemapMaterial = Ph(), this._compileMaterial(this._cubemapMaterial));
            }
            compileEquirectangularShader() {
                null === this._equirectMaterial && (this._equirectMaterial = Oh(), this._compileMaterial(this._equirectMaterial));
            }
            dispose() {
                this._dispose(), null !== this._cubemapMaterial && this._cubemapMaterial.dispose(), null !== this._equirectMaterial && this._equirectMaterial.dispose();
            }
            _setSize(t1) {
                this._lodMax = Math.floor(Math.log2(t1)), this._cubeSize = Math.pow(2, this._lodMax);
            }
            _dispose() {
                null !== this._blurMaterial && this._blurMaterial.dispose(), null !== this._pingPongRenderTarget && this._pingPongRenderTarget.dispose();
                for(let t1 = 0; t1 < this._lodPlanes.length; t1++)this._lodPlanes[t1].dispose();
            }
            _cleanup(t1) {
                this._renderer.setRenderTarget(Eh, _h, Ih), t1.scissorTest = !1, Lh(t1, 0, 0, t1.width, t1.height);
            }
            _fromTexture(t1, e) {
                t1.mapping === na || t1.mapping === ra ? this._setSize(0 === t1.image.length ? 16 : t1.image[0].width || t1.image[0].image.width) : this._setSize(t1.image.width / 4), Eh = this._renderer.getRenderTarget(), _h = this._renderer.getActiveCubeFace(), Ih = this._renderer.getActiveMipmapLevel();
                const i = e || this._allocateTargets();
                return this._textureToCubeUV(t1, i), this._applyPMREM(i), this._cleanup(i), i;
            }
            _allocateTargets() {
                const t1 = 3 * Math.max(this._cubeSize, 112), e = 4 * this._cubeSize, i = {
                    magFilter: ma,
                    minFilter: ma,
                    generateMipmaps: !1,
                    type: Sa,
                    format: La,
                    colorSpace: Hs,
                    depthBuffer: !1
                }, n = zh(t1, e, i);
                if (null === this._pingPongRenderTarget || this._pingPongRenderTarget.width !== t1 || this._pingPongRenderTarget.height !== e) {
                    null !== this._pingPongRenderTarget && this._dispose(), this._pingPongRenderTarget = zh(t1, e, i);
                    const { _lodMax: n } = this;
                    ({ sizeLods: this._sizeLods, lodPlanes: this._lodPlanes, sigmas: this._sigmas } = function(t1) {
                        const e = [], i = [], n = [];
                        let r = t1;
                        const a = t1 - 4 + 1 + wh.length;
                        for(let s = 0; s < a; s++){
                            const a = Math.pow(2, r);
                            i.push(a);
                            let o = 1 / a;
                            s > t1 - 4 ? o = wh[s - t1 + 4 - 1] : 0 === s && (o = 0), n.push(o);
                            const l = 1 / (a - 2), c = -l, u = 1 + l, h = [
                                c,
                                c,
                                u,
                                c,
                                u,
                                u,
                                c,
                                c,
                                u,
                                u,
                                c,
                                u
                            ], d = 6, p = 6, A = 3, f = 2, m = 1, g = new Float32Array(A * p * d), M = new Float32Array(f * p * d), v = new Float32Array(m * p * d);
                            for(let t1 = 0; t1 < d; t1++){
                                const e = t1 % 3 * 2 / 3 - 1, i = t1 > 2 ? 0 : -1, n = [
                                    e,
                                    i,
                                    0,
                                    e + 2 / 3,
                                    i,
                                    0,
                                    e + 2 / 3,
                                    i + 1,
                                    0,
                                    e,
                                    i,
                                    0,
                                    e + 2 / 3,
                                    i + 1,
                                    0,
                                    e,
                                    i + 1,
                                    0
                                ];
                                g.set(n, A * p * t1), M.set(h, f * p * t1);
                                const r = [
                                    t1,
                                    t1,
                                    t1,
                                    t1,
                                    t1,
                                    t1
                                ];
                                v.set(r, m * p * t1);
                            }
                            const y = new bu;
                            y.setAttribute("position", new au(g, A)), y.setAttribute("uv", new au(M, f)), y.setAttribute("faceIndex", new au(v, m)), e.push(y), r > 4 && r--;
                        }
                        return {
                            lodPlanes: e,
                            sizeLods: i,
                            sigmas: n
                        };
                    }(n)), this._blurMaterial = function(t1, e, i) {
                        const n = new Float32Array(20), r = new Nl(0, 1, 0);
                        return new Xu({
                            name: "SphericalGaussianBlur",
                            defines: {
                                n: 20,
                                CUBEUV_TEXEL_WIDTH: 1 / e,
                                CUBEUV_TEXEL_HEIGHT: 1 / i,
                                CUBEUV_MAX_MIP: `${t1}.0`
                            },
                            uniforms: {
                                envMap: {
                                    value: null
                                },
                                samples: {
                                    value: 1
                                },
                                weights: {
                                    value: n
                                },
                                latitudinal: {
                                    value: !1
                                },
                                dTheta: {
                                    value: 0
                                },
                                mipInt: {
                                    value: 0
                                },
                                poleAxis: {
                                    value: r
                                }
                            },
                            vertexShader: "\n\n		precision mediump float;\n		precision mediump int;\n\n		attribute float faceIndex;\n\n		varying vec3 vOutputDirection;\n\n		// RH coordinate system; PMREM face-indexing convention\n		vec3 getDirection( vec2 uv, float face ) {\n\n			uv = 2.0 * uv - 1.0;\n\n			vec3 direction = vec3( uv, 1.0 );\n\n			if ( face == 0.0 ) {\n\n				direction = direction.zyx; // ( 1, v, u ) pos x\n\n			} else if ( face == 1.0 ) {\n\n				direction = direction.xzy;\n				direction.xz *= -1.0; // ( -u, 1, -v ) pos y\n\n			} else if ( face == 2.0 ) {\n\n				direction.x *= -1.0; // ( -u, v, 1 ) pos z\n\n			} else if ( face == 3.0 ) {\n\n				direction = direction.zyx;\n				direction.xz *= -1.0; // ( -1, v, -u ) neg x\n\n			} else if ( face == 4.0 ) {\n\n				direction = direction.xzy;\n				direction.xy *= -1.0; // ( -u, -1, v ) neg y\n\n			} else if ( face == 5.0 ) {\n\n				direction.z *= -1.0; // ( u, v, -1 ) neg z\n\n			}\n\n			return direction;\n\n		}\n\n		void main() {\n\n			vOutputDirection = getDirection( uv, faceIndex );\n			gl_Position = vec4( position, 1.0 );\n\n		}\n	",
                            fragmentShader: "\n\n			precision mediump float;\n			precision mediump int;\n\n			varying vec3 vOutputDirection;\n\n			uniform sampler2D envMap;\n			uniform int samples;\n			uniform float weights[ n ];\n			uniform bool latitudinal;\n			uniform float dTheta;\n			uniform float mipInt;\n			uniform vec3 poleAxis;\n\n			#define ENVMAP_TYPE_CUBE_UV\n			#include <cube_uv_reflection_fragment>\n\n			vec3 getSample( float theta, vec3 axis ) {\n\n				float cosTheta = cos( theta );\n				// Rodrigues' axis-angle rotation\n				vec3 sampleDirection = vOutputDirection * cosTheta\n					+ cross( axis, vOutputDirection ) * sin( theta )\n					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );\n\n				return bilinearCubeUV( envMap, sampleDirection, mipInt );\n\n			}\n\n			void main() {\n\n				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );\n\n				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {\n\n					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );\n\n				}\n\n				axis = normalize( axis );\n\n				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );\n\n				for ( int i = 1; i < n; i++ ) {\n\n					if ( i >= samples ) {\n\n						break;\n\n					}\n\n					float theta = dTheta * float( i );\n					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );\n					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );\n\n				}\n\n			}\n		",
                            blending: hr,
                            depthTest: !1,
                            depthWrite: !1
                        });
                    }(n, t1, e);
                }
                return n;
            }
            _compileMaterial(t1) {
                const e = new Fu(this._lodPlanes[0], t1);
                this._renderer.compile(e, bh);
            }
            _sceneToCubeUV(t1, e, i, n) {
                const r = new qu(90, 1, e, i), a = [
                    1,
                    -1,
                    1,
                    1,
                    1,
                    1
                ], s = [
                    1,
                    1,
                    1,
                    -1,
                    -1,
                    -1
                ], o = this._renderer, l = o.autoClear, c = o.toneMapping;
                o.getClearColor(Th), o.toneMapping = Xr, o.autoClear = !1;
                const u = new Jc({
                    name: "PMREM.Background",
                    side: lr,
                    depthWrite: !1,
                    depthTest: !1
                }), h = new Fu(new Hu, u);
                let d = !1;
                const p = t1.background;
                p ? p.isColor && (u.color.copy(p), t1.background = null, d = !0) : (u.color.copy(Th), d = !0);
                for(let e = 0; e < 6; e++){
                    const i = e % 3;
                    0 === i ? (r.up.set(0, a[e], 0), r.lookAt(s[e], 0, 0)) : 1 === i ? (r.up.set(0, 0, a[e]), r.lookAt(0, s[e], 0)) : (r.up.set(0, a[e], 0), r.lookAt(0, 0, s[e]));
                    const l = this._cubeSize;
                    Lh(n, i * l, e > 2 ? l : 0, l, l), o.setRenderTarget(n), d && o.render(h, r), o.render(t1, r);
                }
                h.geometry.dispose(), h.material.dispose(), o.toneMapping = c, o.autoClear = l, t1.background = p;
            }
            _textureToCubeUV(t1, e) {
                const i = this._renderer, n = t1.mapping === na || t1.mapping === ra;
                n ? (null === this._cubemapMaterial && (this._cubemapMaterial = Ph()), this._cubemapMaterial.uniforms.flipEnvMap.value = !1 === t1.isRenderTargetTexture ? -1 : 1) : null === this._equirectMaterial && (this._equirectMaterial = Oh());
                const r = n ? this._cubemapMaterial : this._equirectMaterial, a = new Fu(this._lodPlanes[0], r);
                r.uniforms.envMap.value = t1;
                const s = this._cubeSize;
                Lh(e, 0, 0, 3 * s, 2 * s), i.setRenderTarget(e), i.render(a, bh);
            }
            _applyPMREM(t1) {
                const e = this._renderer, i = e.autoClear;
                e.autoClear = !1;
                for(let e = 1; e < this._lodPlanes.length; e++){
                    const i = Math.sqrt(this._sigmas[e] * this._sigmas[e] - this._sigmas[e - 1] * this._sigmas[e - 1]), n = Dh[(e - 1) % Dh.length];
                    this._blur(t1, e - 1, e, i, n);
                }
                e.autoClear = i;
            }
            _blur(t1, e, i, n, r) {
                const a = this._pingPongRenderTarget;
                this._halfBlur(t1, a, e, i, n, "latitudinal", r), this._halfBlur(a, t1, i, i, n, "longitudinal", r);
            }
            _halfBlur(t1, e, i, n, r, a, s) {
                const o = this._renderer, l = this._blurMaterial;
                "latitudinal" !== a && "longitudinal" !== a && console.error("blur direction must be either latitudinal or longitudinal!");
                const c = new Fu(this._lodPlanes[n], l), u = l.uniforms, h = this._sizeLods[i] - 1, d = isFinite(r) ? Math.PI / (2 * h) : 2 * Math.PI / 39, p = r / d, A = isFinite(r) ? 1 + Math.floor(3 * p) : 20;
                A > 20 && console.warn(`sigmaRadians, ${r}, is too large and will clip, as it requested ${A} samples when the maximum is set to 20`);
                const f = [];
                let m = 0;
                for(let t1 = 0; t1 < 20; ++t1){
                    const e = t1 / p, i = Math.exp(-e * e / 2);
                    f.push(i), 0 === t1 ? m += i : t1 < A && (m += 2 * i);
                }
                for(let t1 = 0; t1 < f.length; t1++)f[t1] = f[t1] / m;
                u.envMap.value = t1.texture, u.samples.value = A, u.weights.value = f, u.latitudinal.value = "latitudinal" === a, s && (u.poleAxis.value = s);
                const { _lodMax: g } = this;
                u.dTheta.value = d, u.mipInt.value = g - i;
                const M = this._sizeLods[n];
                Lh(e, 3 * M * (n > g - 4 ? n - g + 4 : 0), 4 * (this._cubeSize - M), 3 * M, 2 * M), o.setRenderTarget(e), o.render(c, bh);
            }
        }
        function zh(t1, e, i) {
            const n = new wl(t1, e, i);
            return n.texture.mapping = oa, n.texture.name = "PMREM.cubeUv", n.scissorTest = !0, n;
        }
        function Lh(t1, e, i, n, r) {
            t1.viewport.set(e, i, n, r), t1.scissor.set(e, i, n, r);
        }
        function Oh() {
            return new Xu({
                name: "EquirectangularToCubeUV",
                uniforms: {
                    envMap: {
                        value: null
                    }
                },
                vertexShader: "\n\n		precision mediump float;\n		precision mediump int;\n\n		attribute float faceIndex;\n\n		varying vec3 vOutputDirection;\n\n		// RH coordinate system; PMREM face-indexing convention\n		vec3 getDirection( vec2 uv, float face ) {\n\n			uv = 2.0 * uv - 1.0;\n\n			vec3 direction = vec3( uv, 1.0 );\n\n			if ( face == 0.0 ) {\n\n				direction = direction.zyx; // ( 1, v, u ) pos x\n\n			} else if ( face == 1.0 ) {\n\n				direction = direction.xzy;\n				direction.xz *= -1.0; // ( -u, 1, -v ) pos y\n\n			} else if ( face == 2.0 ) {\n\n				direction.x *= -1.0; // ( -u, v, 1 ) pos z\n\n			} else if ( face == 3.0 ) {\n\n				direction = direction.zyx;\n				direction.xz *= -1.0; // ( -1, v, -u ) neg x\n\n			} else if ( face == 4.0 ) {\n\n				direction = direction.xzy;\n				direction.xy *= -1.0; // ( -u, -1, v ) neg y\n\n			} else if ( face == 5.0 ) {\n\n				direction.z *= -1.0; // ( u, v, -1 ) neg z\n\n			}\n\n			return direction;\n\n		}\n\n		void main() {\n\n			vOutputDirection = getDirection( uv, faceIndex );\n			gl_Position = vec4( position, 1.0 );\n\n		}\n	",
                fragmentShader: "\n\n			precision mediump float;\n			precision mediump int;\n\n			varying vec3 vOutputDirection;\n\n			uniform sampler2D envMap;\n\n			#include <common>\n\n			void main() {\n\n				vec3 outputDirection = normalize( vOutputDirection );\n				vec2 uv = equirectUv( outputDirection );\n\n				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );\n\n			}\n		",
                blending: hr,
                depthTest: !1,
                depthWrite: !1
            });
        }
        function Ph() {
            return new Xu({
                name: "CubemapToCubeUV",
                uniforms: {
                    envMap: {
                        value: null
                    },
                    flipEnvMap: {
                        value: -1
                    }
                },
                vertexShader: "\n\n		precision mediump float;\n		precision mediump int;\n\n		attribute float faceIndex;\n\n		varying vec3 vOutputDirection;\n\n		// RH coordinate system; PMREM face-indexing convention\n		vec3 getDirection( vec2 uv, float face ) {\n\n			uv = 2.0 * uv - 1.0;\n\n			vec3 direction = vec3( uv, 1.0 );\n\n			if ( face == 0.0 ) {\n\n				direction = direction.zyx; // ( 1, v, u ) pos x\n\n			} else if ( face == 1.0 ) {\n\n				direction = direction.xzy;\n				direction.xz *= -1.0; // ( -u, 1, -v ) pos y\n\n			} else if ( face == 2.0 ) {\n\n				direction.x *= -1.0; // ( -u, v, 1 ) pos z\n\n			} else if ( face == 3.0 ) {\n\n				direction = direction.zyx;\n				direction.xz *= -1.0; // ( -1, v, -u ) neg x\n\n			} else if ( face == 4.0 ) {\n\n				direction = direction.xzy;\n				direction.xy *= -1.0; // ( -u, -1, v ) neg y\n\n			} else if ( face == 5.0 ) {\n\n				direction.z *= -1.0; // ( u, v, -1 ) neg z\n\n			}\n\n			return direction;\n\n		}\n\n		void main() {\n\n			vOutputDirection = getDirection( uv, faceIndex );\n			gl_Position = vec4( position, 1.0 );\n\n		}\n	",
                fragmentShader: "\n\n			precision mediump float;\n			precision mediump int;\n\n			uniform float flipEnvMap;\n\n			varying vec3 vOutputDirection;\n\n			uniform samplerCube envMap;\n\n			void main() {\n\n				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );\n\n			}\n		",
                blending: hr,
                depthTest: !1,
                depthWrite: !1
            });
        }
        function jh(t1) {
            let e = new WeakMap, i = null;
            function n(t1) {
                const i = t1.target;
                i.removeEventListener("dispose", n);
                const r = e.get(i);
                void 0 !== r && (e.delete(i), r.dispose());
            }
            return {
                get: function(r) {
                    if (r && r.isTexture) {
                        const a = r.mapping, s = a === aa || a === sa, o = a === na || a === ra;
                        if (s || o) {
                            if (r.isRenderTargetTexture && !0 === r.needsPMREMUpdate) {
                                r.needsPMREMUpdate = !1;
                                let n = e.get(r);
                                return null === i && (i = new Ch(t1)), n = s ? i.fromEquirectangular(r, n) : i.fromCubemap(r, n), e.set(r, n), n.texture;
                            }
                            if (e.has(r)) return e.get(r).texture;
                            {
                                const a = r.image;
                                if (s && a && a.height > 0 || o && a && function(t1) {
                                    let e = 0;
                                    for(let i = 0; i < 6; i++)void 0 !== t1[i] && e++;
                                    return 6 === e;
                                }(a)) {
                                    null === i && (i = new Ch(t1));
                                    const a = s ? i.fromEquirectangular(r) : i.fromCubemap(r);
                                    return e.set(r, a), r.addEventListener("dispose", n), a.texture;
                                }
                                return null;
                            }
                        }
                    }
                    return r;
                },
                dispose: function() {
                    e = new WeakMap, null !== i && (i.dispose(), i = null);
                }
            };
        }
        function Rh(t1) {
            const e = {};
            function i(i) {
                if (void 0 !== e[i]) return e[i];
                let n;
                switch(i){
                    case "WEBGL_depth_texture":
                        n = t1.getExtension("WEBGL_depth_texture") || t1.getExtension("MOZ_WEBGL_depth_texture") || t1.getExtension("WEBKIT_WEBGL_depth_texture");
                        break;
                    case "EXT_texture_filter_anisotropic":
                        n = t1.getExtension("EXT_texture_filter_anisotropic") || t1.getExtension("MOZ_EXT_texture_filter_anisotropic") || t1.getExtension("WEBKIT_EXT_texture_filter_anisotropic");
                        break;
                    case "WEBGL_compressed_texture_s3tc":
                        n = t1.getExtension("WEBGL_compressed_texture_s3tc") || t1.getExtension("MOZ_WEBGL_compressed_texture_s3tc") || t1.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc");
                        break;
                    case "WEBGL_compressed_texture_pvrtc":
                        n = t1.getExtension("WEBGL_compressed_texture_pvrtc") || t1.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc");
                        break;
                    default:
                        n = t1.getExtension(i);
                }
                return e[i] = n, n;
            }
            return {
                has: function(t1) {
                    return null !== i(t1);
                },
                init: function(t1) {
                    t1.isWebGL2 ? i("EXT_color_buffer_float") : (i("WEBGL_depth_texture"), i("OES_texture_float"), i("OES_texture_half_float"), i("OES_texture_half_float_linear"), i("OES_standard_derivatives"), i("OES_element_index_uint"), i("OES_vertex_array_object"), i("ANGLE_instanced_arrays")), i("OES_texture_float_linear"), i("EXT_color_buffer_half_float"), i("WEBGL_multisampled_render_to_texture");
                },
                get: function(t1) {
                    const e = i(t1);
                    return null === e && console.warn("THREE.WebGLRenderer: " + t1 + " extension not supported."), e;
                }
            };
        }
        function kh(t1, e, i, n) {
            const r = {}, a = new WeakMap;
            function s(t1) {
                const o = t1.target;
                null !== o.index && e.remove(o.index);
                for(const t1 in o.attributes)e.remove(o.attributes[t1]);
                for(const t1 in o.morphAttributes){
                    const i = o.morphAttributes[t1];
                    for(let t1 = 0, n = i.length; t1 < n; t1++)e.remove(i[t1]);
                }
                o.removeEventListener("dispose", s), delete r[o.id];
                const l = a.get(o);
                l && (e.remove(l), a.delete(o)), n.releaseStatesOfGeometry(o), !0 === o.isInstancedBufferGeometry && delete o._maxInstanceCount, i.memory.geometries--;
            }
            function o(t1) {
                const i = [], n = t1.index, r = t1.attributes.position;
                let s = 0;
                if (null !== n) {
                    const t1 = n.array;
                    s = n.version;
                    for(let e = 0, n = t1.length; e < n; e += 3){
                        const n = t1[e + 0], r = t1[e + 1], a = t1[e + 2];
                        i.push(n, r, r, a, a, n);
                    }
                } else {
                    if (void 0 === r) return;
                    {
                        const t1 = r.array;
                        s = r.version;
                        for(let e = 0, n = t1.length / 3 - 1; e < n; e += 3){
                            const t1 = e + 0, n = e + 1, r = e + 2;
                            i.push(t1, n, n, r, r, t1);
                        }
                    }
                }
                const o = new ($o(i) ? du : uu)(i, 1);
                o.version = s;
                const l = a.get(t1);
                l && e.remove(l), a.set(t1, o);
            }
            return {
                get: function(t1, e) {
                    return !0 === r[e.id] || (e.addEventListener("dispose", s), r[e.id] = !0, i.memory.geometries++), e;
                },
                update: function(i) {
                    const n = i.attributes;
                    for(const i in n)e.update(n[i], t1.ARRAY_BUFFER);
                    const r = i.morphAttributes;
                    for(const i in r){
                        const n = r[i];
                        for(let i = 0, r = n.length; i < r; i++)e.update(n[i], t1.ARRAY_BUFFER);
                    }
                },
                getWireframeAttribute: function(t1) {
                    const e = a.get(t1);
                    if (e) {
                        const i = t1.index;
                        null !== i && e.version < i.version && o(t1);
                    } else o(t1);
                    return a.get(t1);
                }
            };
        }
        function Uh(t1, e, i, n) {
            const r = n.isWebGL2;
            let a, s, o;
            this.setMode = function(t1) {
                a = t1;
            }, this.setIndex = function(t1) {
                s = t1.type, o = t1.bytesPerElement;
            }, this.render = function(e, n) {
                t1.drawElements(a, n, s, e * o), i.update(n, a, 1);
            }, this.renderInstances = function(n, l, c) {
                if (0 === c) return;
                let u, h;
                if (r) u = t1, h = "drawElementsInstanced";
                else if (u = e.get("ANGLE_instanced_arrays"), h = "drawElementsInstancedANGLE", null === u) return void console.error("THREE.WebGLIndexedBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
                u[h](a, l, s, n * o, c), i.update(l, a, c);
            };
        }
        function Bh(t1) {
            const e = {
                frame: 0,
                calls: 0,
                triangles: 0,
                points: 0,
                lines: 0
            };
            return {
                memory: {
                    geometries: 0,
                    textures: 0
                },
                render: e,
                programs: null,
                autoReset: !0,
                reset: function() {
                    e.calls = 0, e.triangles = 0, e.points = 0, e.lines = 0;
                },
                update: function(i, n, r) {
                    switch(e.calls++, n){
                        case t1.TRIANGLES:
                            e.triangles += r * (i / 3);
                            break;
                        case t1.LINES:
                            e.lines += r * (i / 2);
                            break;
                        case t1.LINE_STRIP:
                            e.lines += r * (i - 1);
                            break;
                        case t1.LINE_LOOP:
                            e.lines += r * i;
                            break;
                        case t1.POINTS:
                            e.points += r * i;
                            break;
                        default:
                            console.error("THREE.WebGLInfo: Unknown draw mode:", n);
                    }
                }
            };
        }
        function Fh(t1, e) {
            return t1[0] - e[0];
        }
        function Qh(t1, e) {
            return Math.abs(e[1]) - Math.abs(t1[1]);
        }
        function Hh(t1, e, i) {
            const n = {}, r = new Float32Array(8), a = new WeakMap, s = new yl, o = [];
            for(let t1 = 0; t1 < 8; t1++)o[t1] = [
                t1,
                0
            ];
            return {
                update: function(l, c, u) {
                    const h = l.morphTargetInfluences;
                    if (!0 === e.isWebGL2) {
                        const d = c.morphAttributes.position || c.morphAttributes.normal || c.morphAttributes.color, p = void 0 !== d ? d.length : 0;
                        let A = a.get(c);
                        if (void 0 === A || A.count !== p) {
                            void 0 !== A && A.texture.dispose();
                            const g = void 0 !== c.morphAttributes.position, M = void 0 !== c.morphAttributes.normal, v = void 0 !== c.morphAttributes.color, y = c.morphAttributes.position || [], x = c.morphAttributes.normal || [], w = c.morphAttributes.color || [];
                            let b = 0;
                            !0 === g && (b = 1), !0 === M && (b = 2), !0 === v && (b = 3);
                            let T = c.attributes.position.count * b, E = 1;
                            T > e.maxTextureSize && (E = Math.ceil(T / e.maxTextureSize), T = e.maxTextureSize);
                            const _ = new Float32Array(T * E * 4 * p), I = new bl(_, T, E, p);
                            I.type = Ia, I.needsUpdate = !0;
                            const S = 4 * b;
                            for(let D = 0; D < p; D++){
                                const C = y[D], z = x[D], L = w[D], O = T * E * 4 * D;
                                for(let P = 0; P < C.count; P++){
                                    const j = P * S;
                                    !0 === g && (s.fromBufferAttribute(C, P), _[O + j + 0] = s.x, _[O + j + 1] = s.y, _[O + j + 2] = s.z, _[O + j + 3] = 0), !0 === M && (s.fromBufferAttribute(z, P), _[O + j + 4] = s.x, _[O + j + 5] = s.y, _[O + j + 6] = s.z, _[O + j + 7] = 0), !0 === v && (s.fromBufferAttribute(L, P), _[O + j + 8] = s.x, _[O + j + 9] = s.y, _[O + j + 10] = s.z, _[O + j + 11] = 4 === L.itemSize ? s.w : 1);
                                }
                            }
                            function N() {
                                I.dispose(), a.delete(c), c.removeEventListener("dispose", N);
                            }
                            A = {
                                count: p,
                                texture: I,
                                size: new qo(T, E)
                            }, a.set(c, A), c.addEventListener("dispose", N);
                        }
                        let f = 0;
                        for(let R = 0; R < h.length; R++)f += h[R];
                        const m = c.morphTargetsRelative ? 1 : 1 - f;
                        u.getUniforms().setValue(t1, "morphTargetBaseInfluence", m), u.getUniforms().setValue(t1, "morphTargetInfluences", h), u.getUniforms().setValue(t1, "morphTargetsTexture", A.texture, i), u.getUniforms().setValue(t1, "morphTargetsTextureSize", A.size);
                    } else {
                        const k = void 0 === h ? 0 : h.length;
                        let U = n[c.id];
                        if (void 0 === U || U.length !== k) {
                            U = [];
                            for(let V = 0; V < k; V++)U[V] = [
                                V,
                                0
                            ];
                            n[c.id] = U;
                        }
                        for(let G = 0; G < k; G++){
                            const W = U[G];
                            W[0] = G, W[1] = h[G];
                        }
                        U.sort(Qh);
                        for(let Y = 0; Y < 8; Y++)Y < k && U[Y][1] ? (o[Y][0] = U[Y][0], o[Y][1] = U[Y][1]) : (o[Y][0] = Number.MAX_SAFE_INTEGER, o[Y][1] = 0);
                        o.sort(Fh);
                        const B = c.morphAttributes.position, F = c.morphAttributes.normal;
                        let Q = 0;
                        for(let X = 0; X < 8; X++){
                            const Z = o[X], q = Z[0], J = Z[1];
                            q !== Number.MAX_SAFE_INTEGER && J ? (B && c.getAttribute("morphTarget" + X) !== B[q] && c.setAttribute("morphTarget" + X, B[q]), F && c.getAttribute("morphNormal" + X) !== F[q] && c.setAttribute("morphNormal" + X, F[q]), r[X] = J, Q += J) : (B && !0 === c.hasAttribute("morphTarget" + X) && c.deleteAttribute("morphTarget" + X), F && !0 === c.hasAttribute("morphNormal" + X) && c.deleteAttribute("morphNormal" + X), r[X] = 0);
                        }
                        const H = c.morphTargetsRelative ? 1 : 1 - Q;
                        u.getUniforms().setValue(t1, "morphTargetBaseInfluence", H), u.getUniforms().setValue(t1, "morphTargetInfluences", r);
                    }
                }
            };
        }
        function Vh(t1, e, i, n) {
            let r = new WeakMap;
            function a(t1) {
                const e = t1.target;
                e.removeEventListener("dispose", a), i.remove(e.instanceMatrix), null !== e.instanceColor && i.remove(e.instanceColor);
            }
            return {
                update: function(s) {
                    const o = n.render.frame, l = s.geometry, c = e.get(s, l);
                    if (r.get(c) !== o && (e.update(c), r.set(c, o)), s.isInstancedMesh && (!1 === s.hasEventListener("dispose", a) && s.addEventListener("dispose", a), r.get(s) !== o && (i.update(s.instanceMatrix, t1.ARRAY_BUFFER), null !== s.instanceColor && i.update(s.instanceColor, t1.ARRAY_BUFFER), r.set(s, o))), s.isSkinnedMesh) {
                        const t1 = s.skeleton;
                        r.get(t1) !== o && (t1.update(), r.set(t1, o));
                    }
                    return c;
                },
                dispose: function() {
                    r = new WeakMap;
                }
            };
        }
        const Gh = new vl, Wh = new bl, Yh = new El, Xh = new $u, Zh = [], qh = [], Jh = new Float32Array(16), Kh = new Float32Array(9), $h = new Float32Array(4);
        function td(t1, e, i) {
            const n = t1[0];
            if (n <= 0 || n > 0) return t1;
            const r = e * i;
            let a = Zh[r];
            if (void 0 === a && (a = new Float32Array(r), Zh[r] = a), 0 !== e) {
                n.toArray(a, 0);
                for(let n = 1, r = 0; n !== e; ++n)r += i, t1[n].toArray(a, r);
            }
            return a;
        }
        function ed(t1, e) {
            if (t1.length !== e.length) return !1;
            for(let i = 0, n = t1.length; i < n; i++)if (t1[i] !== e[i]) return !1;
            return !0;
        }
        function id(t1, e) {
            for(let i = 0, n = e.length; i < n; i++)t1[i] = e[i];
        }
        function nd(t1, e) {
            let i = qh[e];
            void 0 === i && (i = new Int32Array(e), qh[e] = i);
            for(let n = 0; n !== e; ++n)i[n] = t1.allocateTextureUnit();
            return i;
        }
        function rd(t1, e) {
            const i = this.cache;
            i[0] !== e && (t1.uniform1f(this.addr, e), i[0] = e);
        }
        function ad(t1, e) {
            const i = this.cache;
            if (void 0 !== e.x) i[0] === e.x && i[1] === e.y || (t1.uniform2f(this.addr, e.x, e.y), i[0] = e.x, i[1] = e.y);
            else {
                if (ed(i, e)) return;
                t1.uniform2fv(this.addr, e), id(i, e);
            }
        }
        function sd(t1, e) {
            const i = this.cache;
            if (void 0 !== e.x) i[0] === e.x && i[1] === e.y && i[2] === e.z || (t1.uniform3f(this.addr, e.x, e.y, e.z), i[0] = e.x, i[1] = e.y, i[2] = e.z);
            else if (void 0 !== e.r) i[0] === e.r && i[1] === e.g && i[2] === e.b || (t1.uniform3f(this.addr, e.r, e.g, e.b), i[0] = e.r, i[1] = e.g, i[2] = e.b);
            else {
                if (ed(i, e)) return;
                t1.uniform3fv(this.addr, e), id(i, e);
            }
        }
        function od(t1, e) {
            const i = this.cache;
            if (void 0 !== e.x) i[0] === e.x && i[1] === e.y && i[2] === e.z && i[3] === e.w || (t1.uniform4f(this.addr, e.x, e.y, e.z, e.w), i[0] = e.x, i[1] = e.y, i[2] = e.z, i[3] = e.w);
            else {
                if (ed(i, e)) return;
                t1.uniform4fv(this.addr, e), id(i, e);
            }
        }
        function ld(t1, e) {
            const i = this.cache, n = e.elements;
            if (void 0 === n) {
                if (ed(i, e)) return;
                t1.uniformMatrix2fv(this.addr, !1, e), id(i, e);
            } else {
                if (ed(i, n)) return;
                $h.set(n), t1.uniformMatrix2fv(this.addr, !1, $h), id(i, n);
            }
        }
        function cd(t1, e) {
            const i = this.cache, n = e.elements;
            if (void 0 === n) {
                if (ed(i, e)) return;
                t1.uniformMatrix3fv(this.addr, !1, e), id(i, e);
            } else {
                if (ed(i, n)) return;
                Kh.set(n), t1.uniformMatrix3fv(this.addr, !1, Kh), id(i, n);
            }
        }
        function ud(t1, e) {
            const i = this.cache, n = e.elements;
            if (void 0 === n) {
                if (ed(i, e)) return;
                t1.uniformMatrix4fv(this.addr, !1, e), id(i, e);
            } else {
                if (ed(i, n)) return;
                Jh.set(n), t1.uniformMatrix4fv(this.addr, !1, Jh), id(i, n);
            }
        }
        function hd(t1, e) {
            const i = this.cache;
            i[0] !== e && (t1.uniform1i(this.addr, e), i[0] = e);
        }
        function dd(t1, e) {
            const i = this.cache;
            if (void 0 !== e.x) i[0] === e.x && i[1] === e.y || (t1.uniform2i(this.addr, e.x, e.y), i[0] = e.x, i[1] = e.y);
            else {
                if (ed(i, e)) return;
                t1.uniform2iv(this.addr, e), id(i, e);
            }
        }
        function pd(t1, e) {
            const i = this.cache;
            if (void 0 !== e.x) i[0] === e.x && i[1] === e.y && i[2] === e.z || (t1.uniform3i(this.addr, e.x, e.y, e.z), i[0] = e.x, i[1] = e.y, i[2] = e.z);
            else {
                if (ed(i, e)) return;
                t1.uniform3iv(this.addr, e), id(i, e);
            }
        }
        function Ad(t1, e) {
            const i = this.cache;
            if (void 0 !== e.x) i[0] === e.x && i[1] === e.y && i[2] === e.z && i[3] === e.w || (t1.uniform4i(this.addr, e.x, e.y, e.z, e.w), i[0] = e.x, i[1] = e.y, i[2] = e.z, i[3] = e.w);
            else {
                if (ed(i, e)) return;
                t1.uniform4iv(this.addr, e), id(i, e);
            }
        }
        function fd(t1, e) {
            const i = this.cache;
            i[0] !== e && (t1.uniform1ui(this.addr, e), i[0] = e);
        }
        function md(t1, e) {
            const i = this.cache;
            if (void 0 !== e.x) i[0] === e.x && i[1] === e.y || (t1.uniform2ui(this.addr, e.x, e.y), i[0] = e.x, i[1] = e.y);
            else {
                if (ed(i, e)) return;
                t1.uniform2uiv(this.addr, e), id(i, e);
            }
        }
        function gd(t1, e) {
            const i = this.cache;
            if (void 0 !== e.x) i[0] === e.x && i[1] === e.y && i[2] === e.z || (t1.uniform3ui(this.addr, e.x, e.y, e.z), i[0] = e.x, i[1] = e.y, i[2] = e.z);
            else {
                if (ed(i, e)) return;
                t1.uniform3uiv(this.addr, e), id(i, e);
            }
        }
        function Md(t1, e) {
            const i = this.cache;
            if (void 0 !== e.x) i[0] === e.x && i[1] === e.y && i[2] === e.z && i[3] === e.w || (t1.uniform4ui(this.addr, e.x, e.y, e.z, e.w), i[0] = e.x, i[1] = e.y, i[2] = e.z, i[3] = e.w);
            else {
                if (ed(i, e)) return;
                t1.uniform4uiv(this.addr, e), id(i, e);
            }
        }
        function vd(t1, e, i) {
            const n = this.cache, r = i.allocateTextureUnit();
            n[0] !== r && (t1.uniform1i(this.addr, r), n[0] = r), i.setTexture2D(e || Gh, r);
        }
        function yd(t1, e, i) {
            const n = this.cache, r = i.allocateTextureUnit();
            n[0] !== r && (t1.uniform1i(this.addr, r), n[0] = r), i.setTexture3D(e || Yh, r);
        }
        function xd(t1, e, i) {
            const n = this.cache, r = i.allocateTextureUnit();
            n[0] !== r && (t1.uniform1i(this.addr, r), n[0] = r), i.setTextureCube(e || Xh, r);
        }
        function wd(t1, e, i) {
            const n = this.cache, r = i.allocateTextureUnit();
            n[0] !== r && (t1.uniform1i(this.addr, r), n[0] = r), i.setTexture2DArray(e || Wh, r);
        }
        function bd(t1, e) {
            t1.uniform1fv(this.addr, e);
        }
        function Td(t1, e) {
            const i = td(e, this.size, 2);
            t1.uniform2fv(this.addr, i);
        }
        function Ed(t1, e) {
            const i = td(e, this.size, 3);
            t1.uniform3fv(this.addr, i);
        }
        function _d(t1, e) {
            const i = td(e, this.size, 4);
            t1.uniform4fv(this.addr, i);
        }
        function Id(t1, e) {
            const i = td(e, this.size, 4);
            t1.uniformMatrix2fv(this.addr, !1, i);
        }
        function Sd(t1, e) {
            const i = td(e, this.size, 9);
            t1.uniformMatrix3fv(this.addr, !1, i);
        }
        function Nd(t1, e) {
            const i = td(e, this.size, 16);
            t1.uniformMatrix4fv(this.addr, !1, i);
        }
        function Dd(t1, e) {
            t1.uniform1iv(this.addr, e);
        }
        function Cd(t1, e) {
            t1.uniform2iv(this.addr, e);
        }
        function zd(t1, e) {
            t1.uniform3iv(this.addr, e);
        }
        function Ld(t1, e) {
            t1.uniform4iv(this.addr, e);
        }
        function Od(t1, e) {
            t1.uniform1uiv(this.addr, e);
        }
        function Pd(t1, e) {
            t1.uniform2uiv(this.addr, e);
        }
        function jd(t1, e) {
            t1.uniform3uiv(this.addr, e);
        }
        function Rd(t1, e) {
            t1.uniform4uiv(this.addr, e);
        }
        function kd(t1, e, i) {
            const n = this.cache, r = e.length, a = nd(i, r);
            ed(n, a) || (t1.uniform1iv(this.addr, a), id(n, a));
            for(let t1 = 0; t1 !== r; ++t1)i.setTexture2D(e[t1] || Gh, a[t1]);
        }
        function Ud(t1, e, i) {
            const n = this.cache, r = e.length, a = nd(i, r);
            ed(n, a) || (t1.uniform1iv(this.addr, a), id(n, a));
            for(let t1 = 0; t1 !== r; ++t1)i.setTexture3D(e[t1] || Yh, a[t1]);
        }
        function Bd(t1, e, i) {
            const n = this.cache, r = e.length, a = nd(i, r);
            ed(n, a) || (t1.uniform1iv(this.addr, a), id(n, a));
            for(let t1 = 0; t1 !== r; ++t1)i.setTextureCube(e[t1] || Xh, a[t1]);
        }
        function Fd(t1, e, i) {
            const n = this.cache, r = e.length, a = nd(i, r);
            ed(n, a) || (t1.uniform1iv(this.addr, a), id(n, a));
            for(let t1 = 0; t1 !== r; ++t1)i.setTexture2DArray(e[t1] || Wh, a[t1]);
        }
        class Qd {
            constructor(t1, e, i){
                this.id = t1, this.addr = i, this.cache = [], this.setValue = function(t1) {
                    switch(t1){
                        case 5126:
                            return rd;
                        case 35664:
                            return ad;
                        case 35665:
                            return sd;
                        case 35666:
                            return od;
                        case 35674:
                            return ld;
                        case 35675:
                            return cd;
                        case 35676:
                            return ud;
                        case 5124:
                        case 35670:
                            return hd;
                        case 35667:
                        case 35671:
                            return dd;
                        case 35668:
                        case 35672:
                            return pd;
                        case 35669:
                        case 35673:
                            return Ad;
                        case 5125:
                            return fd;
                        case 36294:
                            return md;
                        case 36295:
                            return gd;
                        case 36296:
                            return Md;
                        case 35678:
                        case 36198:
                        case 36298:
                        case 36306:
                        case 35682:
                            return vd;
                        case 35679:
                        case 36299:
                        case 36307:
                            return yd;
                        case 35680:
                        case 36300:
                        case 36308:
                        case 36293:
                            return xd;
                        case 36289:
                        case 36303:
                        case 36311:
                        case 36292:
                            return wd;
                    }
                }(e.type);
            }
        }
        class Hd {
            constructor(t1, e, i){
                this.id = t1, this.addr = i, this.cache = [], this.size = e.size, this.setValue = function(t1) {
                    switch(t1){
                        case 5126:
                            return bd;
                        case 35664:
                            return Td;
                        case 35665:
                            return Ed;
                        case 35666:
                            return _d;
                        case 35674:
                            return Id;
                        case 35675:
                            return Sd;
                        case 35676:
                            return Nd;
                        case 5124:
                        case 35670:
                            return Dd;
                        case 35667:
                        case 35671:
                            return Cd;
                        case 35668:
                        case 35672:
                            return zd;
                        case 35669:
                        case 35673:
                            return Ld;
                        case 5125:
                            return Od;
                        case 36294:
                            return Pd;
                        case 36295:
                            return jd;
                        case 36296:
                            return Rd;
                        case 35678:
                        case 36198:
                        case 36298:
                        case 36306:
                        case 35682:
                            return kd;
                        case 35679:
                        case 36299:
                        case 36307:
                            return Ud;
                        case 35680:
                        case 36300:
                        case 36308:
                        case 36293:
                            return Bd;
                        case 36289:
                        case 36303:
                        case 36311:
                        case 36292:
                            return Fd;
                    }
                }(e.type);
            }
        }
        class Vd {
            constructor(t1){
                this.id = t1, this.seq = [], this.map = {};
            }
            setValue(t1, e, i) {
                const n = this.seq;
                for(let r = 0, a = n.length; r !== a; ++r){
                    const a = n[r];
                    a.setValue(t1, e[a.id], i);
                }
            }
        }
        const Gd = /(\w+)(\])?(\[|\.)?/g;
        function Wd(t1, e) {
            t1.seq.push(e), t1.map[e.id] = e;
        }
        function Yd(t1, e, i) {
            const n = t1.name, r = n.length;
            for(Gd.lastIndex = 0;;){
                const a = Gd.exec(n), s = Gd.lastIndex;
                let o = a[1];
                const l = "]" === a[2], c = a[3];
                if (l && (o |= 0), void 0 === c || "[" === c && s + 2 === r) {
                    Wd(i, void 0 === c ? new Qd(o, t1, e) : new Hd(o, t1, e));
                    break;
                }
                {
                    let t1 = i.map[o];
                    void 0 === t1 && (t1 = new Vd(o), Wd(i, t1)), i = t1;
                }
            }
        }
        class Xd {
            constructor(t1, e){
                this.seq = [], this.map = {};
                const i = t1.getProgramParameter(e, t1.ACTIVE_UNIFORMS);
                for(let n = 0; n < i; ++n){
                    const i = t1.getActiveUniform(e, n);
                    Yd(i, t1.getUniformLocation(e, i.name), this);
                }
            }
            setValue(t1, e, i, n) {
                const r = this.map[e];
                void 0 !== r && r.setValue(t1, i, n);
            }
            setOptional(t1, e, i) {
                const n = e[i];
                void 0 !== n && this.setValue(t1, i, n);
            }
            static upload(t1, e, i, n) {
                for(let r = 0, a = e.length; r !== a; ++r){
                    const a = e[r], s = i[a.id];
                    !1 !== s.needsUpdate && a.setValue(t1, s.value, n);
                }
            }
            static seqWithValue(t1, e) {
                const i = [];
                for(let n = 0, r = t1.length; n !== r; ++n){
                    const r = t1[n];
                    r.id in e && i.push(r);
                }
                return i;
            }
        }
        function Zd(t1, e, i) {
            const n = t1.createShader(e);
            return t1.shaderSource(n, i), t1.compileShader(n), n;
        }
        const qd = 37297;
        let Jd = 0;
        function Kd(t1, e, i) {
            const n = t1.getShaderParameter(e, t1.COMPILE_STATUS), r = t1.getShaderInfoLog(e).trim();
            if (n && "" === r) return "";
            const a = /ERROR: 0:(\d+)/.exec(r);
            if (a) {
                const n = parseInt(a[1]);
                return i.toUpperCase() + "\n\n" + r + "\n\n" + function(t1, e) {
                    const i = t1.split("\n"), n = [], r = Math.max(e - 6, 0), a = Math.min(e + 6, i.length);
                    for(let t1 = r; t1 < a; t1++){
                        const r = t1 + 1;
                        n.push(`${r === e ? ">" : " "} ${r}: ${i[t1]}`);
                    }
                    return n.join("\n");
                }(t1.getShaderSource(e), n);
            }
            return r;
        }
        function $d(t1, e) {
            const i = function(t1) {
                const e = ul.getPrimaries(ul.workingColorSpace), i = ul.getPrimaries(t1);
                let n;
                switch(e === i ? n = "" : e === Zs && i === Xs ? n = "LinearDisplayP3ToLinearSRGB" : e === Xs && i === Zs && (n = "LinearSRGBToLinearDisplayP3"), t1){
                    case Hs:
                    case Gs:
                        return [
                            n,
                            "LinearTransferOETF"
                        ];
                    case Qs:
                    case Vs:
                        return [
                            n,
                            "sRGBTransferOETF"
                        ];
                    default:
                        return console.warn("THREE.WebGLProgram: Unsupported color space:", t1), [
                            n,
                            "LinearTransferOETF"
                        ];
                }
            }(e);
            return `vec4 ${t1}( vec4 value ) { return ${i[0]}( ${i[1]}( value ) ); }`;
        }
        function tp(t1, e) {
            let i;
            switch(e){
                case Zr:
                    i = "Linear";
                    break;
                case qr:
                    i = "Reinhard";
                    break;
                case Jr:
                    i = "OptimizedCineon";
                    break;
                case Kr:
                    i = "ACESFilmic";
                    break;
                case $r:
                    i = "Custom";
                    break;
                default:
                    console.warn("THREE.WebGLProgram: Unsupported toneMapping:", e), i = "Linear";
            }
            return "vec3 " + t1 + "( vec3 color ) { return " + i + "ToneMapping( color ); }";
        }
        function ep(t1) {
            return "" !== t1;
        }
        function ip(t1, e) {
            const i = e.numSpotLightShadows + e.numSpotLightMaps - e.numSpotLightShadowsWithMaps;
            return t1.replace(/NUM_DIR_LIGHTS/g, e.numDirLights).replace(/NUM_SPOT_LIGHTS/g, e.numSpotLights).replace(/NUM_SPOT_LIGHT_MAPS/g, e.numSpotLightMaps).replace(/NUM_SPOT_LIGHT_COORDS/g, i).replace(/NUM_RECT_AREA_LIGHTS/g, e.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, e.numPointLights).replace(/NUM_HEMI_LIGHTS/g, e.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, e.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, e.numSpotLightShadowsWithMaps).replace(/NUM_SPOT_LIGHT_SHADOWS/g, e.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, e.numPointLightShadows);
        }
        function np(t1, e) {
            return t1.replace(/NUM_CLIPPING_PLANES/g, e.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, e.numClippingPlanes - e.numClipIntersection);
        }
        const rp = /^[ \t]*#include +<([\w\d./]+)>/gm;
        function ap(t1) {
            return t1.replace(rp, op);
        }
        const sp = new Map([
            [
                "encodings_fragment",
                "colorspace_fragment"
            ],
            [
                "encodings_pars_fragment",
                "colorspace_pars_fragment"
            ],
            [
                "output_fragment",
                "opaque_fragment"
            ]
        ]);
        function op(t1, e) {
            let i = hh[e];
            if (void 0 === i) {
                const t1 = sp.get(e);
                if (void 0 === t1) throw new Error("Can not resolve #include <" + e + ">");
                i = hh[t1], console.warn('THREE.WebGLRenderer: Shader chunk "%s" has been deprecated. Use "%s" instead.', e, t1);
            }
            return ap(i);
        }
        const lp = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
        function cp(t1) {
            return t1.replace(lp, up);
        }
        function up(t1, e, i, n) {
            let r = "";
            for(let t1 = parseInt(e); t1 < parseInt(i); t1++)r += n.replace(/\[\s*i\s*\]/g, "[ " + t1 + " ]").replace(/UNROLLED_LOOP_INDEX/g, t1);
            return r;
        }
        function hp(t1) {
            let e = "precision " + t1.precision + " float;\nprecision " + t1.precision + " int;";
            return "highp" === t1.precision ? e += "\n#define HIGH_PRECISION" : "mediump" === t1.precision ? e += "\n#define MEDIUM_PRECISION" : "lowp" === t1.precision && (e += "\n#define LOW_PRECISION"), e;
        }
        function dp(t1, e, i, n) {
            const r = t1.getContext(), a = i.defines;
            let s = i.vertexShader, o = i.fragmentShader;
            const l = function(t1) {
                let e = "SHADOWMAP_TYPE_BASIC";
                return t1.shadowMapType === rr ? e = "SHADOWMAP_TYPE_PCF" : t1.shadowMapType === ar ? e = "SHADOWMAP_TYPE_PCF_SOFT" : t1.shadowMapType === sr && (e = "SHADOWMAP_TYPE_VSM"), e;
            }(i), c = function(t1) {
                let e = "ENVMAP_TYPE_CUBE";
                if (t1.envMap) switch(t1.envMapMode){
                    case na:
                    case ra:
                        e = "ENVMAP_TYPE_CUBE";
                        break;
                    case oa:
                        e = "ENVMAP_TYPE_CUBE_UV";
                }
                return e;
            }(i), u = function(t1) {
                let e = "ENVMAP_MODE_REFLECTION";
                return t1.envMap && t1.envMapMode === ra && (e = "ENVMAP_MODE_REFRACTION"), e;
            }(i), h = function(t1) {
                let e = "ENVMAP_BLENDING_NONE";
                if (t1.envMap) switch(t1.combine){
                    case Gr:
                        e = "ENVMAP_BLENDING_MULTIPLY";
                        break;
                    case Wr:
                        e = "ENVMAP_BLENDING_MIX";
                        break;
                    case Yr:
                        e = "ENVMAP_BLENDING_ADD";
                }
                return e;
            }(i), d = function(t1) {
                const e = t1.envMapCubeUVHeight;
                if (null === e) return null;
                const i = Math.log2(e) - 2, n = 1 / e;
                return {
                    texelWidth: 1 / (3 * Math.max(Math.pow(2, i), 112)),
                    texelHeight: n,
                    maxMip: i
                };
            }(i), p = i.isWebGL2 ? "" : function(t1) {
                return [
                    t1.extensionDerivatives || t1.envMapCubeUVHeight || t1.bumpMap || t1.normalMapTangentSpace || t1.clearcoatNormalMap || t1.flatShading || "physical" === t1.shaderID ? "#extension GL_OES_standard_derivatives : enable" : "",
                    (t1.extensionFragDepth || t1.logarithmicDepthBuffer) && t1.rendererExtensionFragDepth ? "#extension GL_EXT_frag_depth : enable" : "",
                    t1.extensionDrawBuffers && t1.rendererExtensionDrawBuffers ? "#extension GL_EXT_draw_buffers : require" : "",
                    (t1.extensionShaderTextureLOD || t1.envMap || t1.transmission) && t1.rendererExtensionShaderTextureLod ? "#extension GL_EXT_shader_texture_lod : enable" : ""
                ].filter(ep).join("\n");
            }(i), A = function(t1) {
                const e = [];
                for(const i in t1){
                    const n = t1[i];
                    !1 !== n && e.push("#define " + i + " " + n);
                }
                return e.join("\n");
            }(a), f = r.createProgram();
            let m, g, M = i.glslVersion ? "#version " + i.glslVersion + "\n" : "";
            i.isRawShaderMaterial ? (m = [
                "#define SHADER_TYPE " + i.shaderType,
                "#define SHADER_NAME " + i.shaderName,
                A
            ].filter(ep).join("\n"), m.length > 0 && (m += "\n"), g = [
                p,
                "#define SHADER_TYPE " + i.shaderType,
                "#define SHADER_NAME " + i.shaderName,
                A
            ].filter(ep).join("\n"), g.length > 0 && (g += "\n")) : (m = [
                hp(i),
                "#define SHADER_TYPE " + i.shaderType,
                "#define SHADER_NAME " + i.shaderName,
                A,
                i.instancing ? "#define USE_INSTANCING" : "",
                i.instancingColor ? "#define USE_INSTANCING_COLOR" : "",
                i.useFog && i.fog ? "#define USE_FOG" : "",
                i.useFog && i.fogExp2 ? "#define FOG_EXP2" : "",
                i.map ? "#define USE_MAP" : "",
                i.envMap ? "#define USE_ENVMAP" : "",
                i.envMap ? "#define " + u : "",
                i.lightMap ? "#define USE_LIGHTMAP" : "",
                i.aoMap ? "#define USE_AOMAP" : "",
                i.bumpMap ? "#define USE_BUMPMAP" : "",
                i.normalMap ? "#define USE_NORMALMAP" : "",
                i.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
                i.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
                i.displacementMap ? "#define USE_DISPLACEMENTMAP" : "",
                i.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
                i.anisotropy ? "#define USE_ANISOTROPY" : "",
                i.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
                i.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
                i.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
                i.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
                i.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
                i.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
                i.specularMap ? "#define USE_SPECULARMAP" : "",
                i.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
                i.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
                i.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
                i.metalnessMap ? "#define USE_METALNESSMAP" : "",
                i.alphaMap ? "#define USE_ALPHAMAP" : "",
                i.alphaHash ? "#define USE_ALPHAHASH" : "",
                i.transmission ? "#define USE_TRANSMISSION" : "",
                i.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
                i.thicknessMap ? "#define USE_THICKNESSMAP" : "",
                i.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
                i.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
                i.mapUv ? "#define MAP_UV " + i.mapUv : "",
                i.alphaMapUv ? "#define ALPHAMAP_UV " + i.alphaMapUv : "",
                i.lightMapUv ? "#define LIGHTMAP_UV " + i.lightMapUv : "",
                i.aoMapUv ? "#define AOMAP_UV " + i.aoMapUv : "",
                i.emissiveMapUv ? "#define EMISSIVEMAP_UV " + i.emissiveMapUv : "",
                i.bumpMapUv ? "#define BUMPMAP_UV " + i.bumpMapUv : "",
                i.normalMapUv ? "#define NORMALMAP_UV " + i.normalMapUv : "",
                i.displacementMapUv ? "#define DISPLACEMENTMAP_UV " + i.displacementMapUv : "",
                i.metalnessMapUv ? "#define METALNESSMAP_UV " + i.metalnessMapUv : "",
                i.roughnessMapUv ? "#define ROUGHNESSMAP_UV " + i.roughnessMapUv : "",
                i.anisotropyMapUv ? "#define ANISOTROPYMAP_UV " + i.anisotropyMapUv : "",
                i.clearcoatMapUv ? "#define CLEARCOATMAP_UV " + i.clearcoatMapUv : "",
                i.clearcoatNormalMapUv ? "#define CLEARCOAT_NORMALMAP_UV " + i.clearcoatNormalMapUv : "",
                i.clearcoatRoughnessMapUv ? "#define CLEARCOAT_ROUGHNESSMAP_UV " + i.clearcoatRoughnessMapUv : "",
                i.iridescenceMapUv ? "#define IRIDESCENCEMAP_UV " + i.iridescenceMapUv : "",
                i.iridescenceThicknessMapUv ? "#define IRIDESCENCE_THICKNESSMAP_UV " + i.iridescenceThicknessMapUv : "",
                i.sheenColorMapUv ? "#define SHEEN_COLORMAP_UV " + i.sheenColorMapUv : "",
                i.sheenRoughnessMapUv ? "#define SHEEN_ROUGHNESSMAP_UV " + i.sheenRoughnessMapUv : "",
                i.specularMapUv ? "#define SPECULARMAP_UV " + i.specularMapUv : "",
                i.specularColorMapUv ? "#define SPECULAR_COLORMAP_UV " + i.specularColorMapUv : "",
                i.specularIntensityMapUv ? "#define SPECULAR_INTENSITYMAP_UV " + i.specularIntensityMapUv : "",
                i.transmissionMapUv ? "#define TRANSMISSIONMAP_UV " + i.transmissionMapUv : "",
                i.thicknessMapUv ? "#define THICKNESSMAP_UV " + i.thicknessMapUv : "",
                i.vertexTangents && !1 === i.flatShading ? "#define USE_TANGENT" : "",
                i.vertexColors ? "#define USE_COLOR" : "",
                i.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
                i.vertexUv1s ? "#define USE_UV1" : "",
                i.vertexUv2s ? "#define USE_UV2" : "",
                i.vertexUv3s ? "#define USE_UV3" : "",
                i.pointsUvs ? "#define USE_POINTS_UV" : "",
                i.flatShading ? "#define FLAT_SHADED" : "",
                i.skinning ? "#define USE_SKINNING" : "",
                i.morphTargets ? "#define USE_MORPHTARGETS" : "",
                i.morphNormals && !1 === i.flatShading ? "#define USE_MORPHNORMALS" : "",
                i.morphColors && i.isWebGL2 ? "#define USE_MORPHCOLORS" : "",
                i.morphTargetsCount > 0 && i.isWebGL2 ? "#define MORPHTARGETS_TEXTURE" : "",
                i.morphTargetsCount > 0 && i.isWebGL2 ? "#define MORPHTARGETS_TEXTURE_STRIDE " + i.morphTextureStride : "",
                i.morphTargetsCount > 0 && i.isWebGL2 ? "#define MORPHTARGETS_COUNT " + i.morphTargetsCount : "",
                i.doubleSided ? "#define DOUBLE_SIDED" : "",
                i.flipSided ? "#define FLIP_SIDED" : "",
                i.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
                i.shadowMapEnabled ? "#define " + l : "",
                i.sizeAttenuation ? "#define USE_SIZEATTENUATION" : "",
                i.numLightProbes > 0 ? "#define USE_LIGHT_PROBES" : "",
                i.useLegacyLights ? "#define LEGACY_LIGHTS" : "",
                i.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
                i.logarithmicDepthBuffer && i.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "",
                "uniform mat4 modelMatrix;",
                "uniform mat4 modelViewMatrix;",
                "uniform mat4 projectionMatrix;",
                "uniform mat4 viewMatrix;",
                "uniform mat3 normalMatrix;",
                "uniform vec3 cameraPosition;",
                "uniform bool isOrthographic;",
                "#ifdef USE_INSTANCING",
                "	attribute mat4 instanceMatrix;",
                "#endif",
                "#ifdef USE_INSTANCING_COLOR",
                "	attribute vec3 instanceColor;",
                "#endif",
                "attribute vec3 position;",
                "attribute vec3 normal;",
                "attribute vec2 uv;",
                "#ifdef USE_UV1",
                "	attribute vec2 uv1;",
                "#endif",
                "#ifdef USE_UV2",
                "	attribute vec2 uv2;",
                "#endif",
                "#ifdef USE_UV3",
                "	attribute vec2 uv3;",
                "#endif",
                "#ifdef USE_TANGENT",
                "	attribute vec4 tangent;",
                "#endif",
                "#if defined( USE_COLOR_ALPHA )",
                "	attribute vec4 color;",
                "#elif defined( USE_COLOR )",
                "	attribute vec3 color;",
                "#endif",
                "#if ( defined( USE_MORPHTARGETS ) && ! defined( MORPHTARGETS_TEXTURE ) )",
                "	attribute vec3 morphTarget0;",
                "	attribute vec3 morphTarget1;",
                "	attribute vec3 morphTarget2;",
                "	attribute vec3 morphTarget3;",
                "	#ifdef USE_MORPHNORMALS",
                "		attribute vec3 morphNormal0;",
                "		attribute vec3 morphNormal1;",
                "		attribute vec3 morphNormal2;",
                "		attribute vec3 morphNormal3;",
                "	#else",
                "		attribute vec3 morphTarget4;",
                "		attribute vec3 morphTarget5;",
                "		attribute vec3 morphTarget6;",
                "		attribute vec3 morphTarget7;",
                "	#endif",
                "#endif",
                "#ifdef USE_SKINNING",
                "	attribute vec4 skinIndex;",
                "	attribute vec4 skinWeight;",
                "#endif",
                "\n"
            ].filter(ep).join("\n"), g = [
                p,
                hp(i),
                "#define SHADER_TYPE " + i.shaderType,
                "#define SHADER_NAME " + i.shaderName,
                A,
                i.useFog && i.fog ? "#define USE_FOG" : "",
                i.useFog && i.fogExp2 ? "#define FOG_EXP2" : "",
                i.map ? "#define USE_MAP" : "",
                i.matcap ? "#define USE_MATCAP" : "",
                i.envMap ? "#define USE_ENVMAP" : "",
                i.envMap ? "#define " + c : "",
                i.envMap ? "#define " + u : "",
                i.envMap ? "#define " + h : "",
                d ? "#define CUBEUV_TEXEL_WIDTH " + d.texelWidth : "",
                d ? "#define CUBEUV_TEXEL_HEIGHT " + d.texelHeight : "",
                d ? "#define CUBEUV_MAX_MIP " + d.maxMip + ".0" : "",
                i.lightMap ? "#define USE_LIGHTMAP" : "",
                i.aoMap ? "#define USE_AOMAP" : "",
                i.bumpMap ? "#define USE_BUMPMAP" : "",
                i.normalMap ? "#define USE_NORMALMAP" : "",
                i.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
                i.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
                i.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
                i.anisotropy ? "#define USE_ANISOTROPY" : "",
                i.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
                i.clearcoat ? "#define USE_CLEARCOAT" : "",
                i.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
                i.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
                i.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
                i.iridescence ? "#define USE_IRIDESCENCE" : "",
                i.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
                i.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
                i.specularMap ? "#define USE_SPECULARMAP" : "",
                i.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
                i.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
                i.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
                i.metalnessMap ? "#define USE_METALNESSMAP" : "",
                i.alphaMap ? "#define USE_ALPHAMAP" : "",
                i.alphaTest ? "#define USE_ALPHATEST" : "",
                i.alphaHash ? "#define USE_ALPHAHASH" : "",
                i.sheen ? "#define USE_SHEEN" : "",
                i.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
                i.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
                i.transmission ? "#define USE_TRANSMISSION" : "",
                i.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
                i.thicknessMap ? "#define USE_THICKNESSMAP" : "",
                i.vertexTangents && !1 === i.flatShading ? "#define USE_TANGENT" : "",
                i.vertexColors || i.instancingColor ? "#define USE_COLOR" : "",
                i.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
                i.vertexUv1s ? "#define USE_UV1" : "",
                i.vertexUv2s ? "#define USE_UV2" : "",
                i.vertexUv3s ? "#define USE_UV3" : "",
                i.pointsUvs ? "#define USE_POINTS_UV" : "",
                i.gradientMap ? "#define USE_GRADIENTMAP" : "",
                i.flatShading ? "#define FLAT_SHADED" : "",
                i.doubleSided ? "#define DOUBLE_SIDED" : "",
                i.flipSided ? "#define FLIP_SIDED" : "",
                i.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
                i.shadowMapEnabled ? "#define " + l : "",
                i.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : "",
                i.numLightProbes > 0 ? "#define USE_LIGHT_PROBES" : "",
                i.useLegacyLights ? "#define LEGACY_LIGHTS" : "",
                i.decodeVideoTexture ? "#define DECODE_VIDEO_TEXTURE" : "",
                i.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
                i.logarithmicDepthBuffer && i.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "",
                "uniform mat4 viewMatrix;",
                "uniform vec3 cameraPosition;",
                "uniform bool isOrthographic;",
                i.toneMapping !== Xr ? "#define TONE_MAPPING" : "",
                i.toneMapping !== Xr ? hh.tonemapping_pars_fragment : "",
                i.toneMapping !== Xr ? tp("toneMapping", i.toneMapping) : "",
                i.dithering ? "#define DITHERING" : "",
                i.opaque ? "#define OPAQUE" : "",
                hh.colorspace_pars_fragment,
                $d("linearToOutputTexel", i.outputColorSpace),
                i.useDepthPacking ? "#define DEPTH_PACKING " + i.depthPacking : "",
                "\n"
            ].filter(ep).join("\n")), s = ap(s), s = ip(s, i), s = np(s, i), o = ap(o), o = ip(o, i), o = np(o, i), s = cp(s), o = cp(o), i.isWebGL2 && !0 !== i.isRawShaderMaterial && (M = "#version 300 es\n", m = [
                "precision mediump sampler2DArray;",
                "#define attribute in",
                "#define varying out",
                "#define texture2D texture"
            ].join("\n") + "\n" + m, g = [
                "precision mediump sampler2DArray;",
                "#define varying in",
                i.glslVersion === Co ? "" : "layout(location = 0) out highp vec4 pc_fragColor;",
                i.glslVersion === Co ? "" : "#define gl_FragColor pc_fragColor",
                "#define gl_FragDepthEXT gl_FragDepth",
                "#define texture2D texture",
                "#define textureCube texture",
                "#define texture2DProj textureProj",
                "#define texture2DLodEXT textureLod",
                "#define texture2DProjLodEXT textureProjLod",
                "#define textureCubeLodEXT textureLod",
                "#define texture2DGradEXT textureGrad",
                "#define texture2DProjGradEXT textureProjGrad",
                "#define textureCubeGradEXT textureGrad"
            ].join("\n") + "\n" + g);
            const v = M + m + s, y = M + g + o, x = Zd(r, r.VERTEX_SHADER, v), w = Zd(r, r.FRAGMENT_SHADER, y);
            function b(e) {
                if (t1.debug.checkShaderErrors) {
                    const i = r.getProgramInfoLog(f).trim(), n = r.getShaderInfoLog(x).trim(), a = r.getShaderInfoLog(w).trim();
                    let s = !0, o = !0;
                    if (!1 === r.getProgramParameter(f, r.LINK_STATUS)) {
                        if (s = !1, "function" == typeof t1.debug.onShaderError) t1.debug.onShaderError(r, f, x, w);
                        else {
                            const t1 = Kd(r, x, "vertex"), e = Kd(r, w, "fragment");
                            console.error("THREE.WebGLProgram: Shader Error " + r.getError() + " - VALIDATE_STATUS " + r.getProgramParameter(f, r.VALIDATE_STATUS) + "\n\nProgram Info Log: " + i + "\n" + t1 + "\n" + e);
                        }
                    } else "" !== i ? console.warn("THREE.WebGLProgram: Program Info Log:", i) : "" !== n && "" !== a || (o = !1);
                    o && (e.diagnostics = {
                        runnable: s,
                        programLog: i,
                        vertexShader: {
                            log: n,
                            prefix: m
                        },
                        fragmentShader: {
                            log: a,
                            prefix: g
                        }
                    });
                }
                r.deleteShader(x), r.deleteShader(w), T = new Xd(r, f), E = function(t1, e) {
                    const i = {}, n = t1.getProgramParameter(e, t1.ACTIVE_ATTRIBUTES);
                    for(let r = 0; r < n; r++){
                        const n = t1.getActiveAttrib(e, r), a = n.name;
                        let s = 1;
                        n.type === t1.FLOAT_MAT2 && (s = 2), n.type === t1.FLOAT_MAT3 && (s = 3), n.type === t1.FLOAT_MAT4 && (s = 4), i[a] = {
                            type: n.type,
                            location: t1.getAttribLocation(e, a),
                            locationSize: s
                        };
                    }
                    return i;
                }(r, f);
            }
            let T, E;
            r.attachShader(f, x), r.attachShader(f, w), void 0 !== i.index0AttributeName ? r.bindAttribLocation(f, 0, i.index0AttributeName) : !0 === i.morphTargets && r.bindAttribLocation(f, 0, "position"), r.linkProgram(f), this.getUniforms = function() {
                return void 0 === T && b(this), T;
            }, this.getAttributes = function() {
                return void 0 === E && b(this), E;
            };
            let _ = !1 === i.rendererExtensionParallelShaderCompile;
            return this.isReady = function() {
                return !1 === _ && (_ = r.getProgramParameter(f, qd)), _;
            }, this.destroy = function() {
                n.releaseStatesOfProgram(this), r.deleteProgram(f), this.program = void 0;
            }, this.type = i.shaderType, this.name = i.shaderName, this.id = Jd++, this.cacheKey = e, this.usedTimes = 1, this.program = f, this.vertexShader = x, this.fragmentShader = w, this;
        }
        let pp = 0;
        class Ap {
            constructor(){
                this.shaderCache = new Map, this.materialCache = new Map;
            }
            update(t1) {
                const e = t1.vertexShader, i = t1.fragmentShader, n = this._getShaderStage(e), r = this._getShaderStage(i), a = this._getShaderCacheForMaterial(t1);
                return !1 === a.has(n) && (a.add(n), n.usedTimes++), !1 === a.has(r) && (a.add(r), r.usedTimes++), this;
            }
            remove(t1) {
                const e = this.materialCache.get(t1);
                for (const t1 of e)t1.usedTimes--, 0 === t1.usedTimes && this.shaderCache.delete(t1.code);
                return this.materialCache.delete(t1), this;
            }
            getVertexShaderID(t1) {
                return this._getShaderStage(t1.vertexShader).id;
            }
            getFragmentShaderID(t1) {
                return this._getShaderStage(t1.fragmentShader).id;
            }
            dispose() {
                this.shaderCache.clear(), this.materialCache.clear();
            }
            _getShaderCacheForMaterial(t1) {
                const e = this.materialCache;
                let i = e.get(t1);
                return void 0 === i && (i = new Set, e.set(t1, i)), i;
            }
            _getShaderStage(t1) {
                const e = this.shaderCache;
                let i = e.get(t1);
                return void 0 === i && (i = new fp(t1), e.set(t1, i)), i;
            }
        }
        class fp {
            constructor(t1){
                this.id = pp++, this.code = t1, this.usedTimes = 0;
            }
        }
        function mp(t1, e, i, n, r, a, s) {
            const o = new mc, l = new Ap, c = [], u = r.isWebGL2, h = r.logarithmicDepthBuffer, d = r.vertexTextures;
            let p = r.precision;
            const A = {
                MeshDepthMaterial: "depth",
                MeshDistanceMaterial: "distanceRGBA",
                MeshNormalMaterial: "normal",
                MeshBasicMaterial: "basic",
                MeshLambertMaterial: "lambert",
                MeshPhongMaterial: "phong",
                MeshToonMaterial: "toon",
                MeshStandardMaterial: "physical",
                MeshPhysicalMaterial: "physical",
                MeshMatcapMaterial: "matcap",
                LineBasicMaterial: "basic",
                LineDashedMaterial: "dashed",
                PointsMaterial: "points",
                ShadowMaterial: "shadow",
                SpriteMaterial: "sprite"
            };
            function f(t1) {
                return 0 === t1 ? "uv" : `uv${t1}`;
            }
            return {
                getParameters: function(a, o, c, m, g) {
                    const M = m.fog, v = g.geometry, y = a.isMeshStandardMaterial ? m.environment : null, x = (a.isMeshStandardMaterial ? i : e).get(a.envMap || y), w = x && x.mapping === oa ? x.image.height : null, b = A[a.type];
                    null !== a.precision && (p = r.getMaxPrecision(a.precision), p !== a.precision && console.warn("THREE.WebGLProgram.getParameters:", a.precision, "not supported, using", p, "instead."));
                    const T = v.morphAttributes.position || v.morphAttributes.normal || v.morphAttributes.color, E = void 0 !== T ? T.length : 0;
                    let _, I, S, N, D = 0;
                    if (void 0 !== v.morphAttributes.position && (D = 1), void 0 !== v.morphAttributes.normal && (D = 2), void 0 !== v.morphAttributes.color && (D = 3), b) {
                        const t1 = ph[b];
                        _ = t1.vertexShader, I = t1.fragmentShader;
                    } else _ = a.vertexShader, I = a.fragmentShader, l.update(a), S = l.getVertexShaderID(a), N = l.getFragmentShaderID(a);
                    const C = t1.getRenderTarget(), z = !0 === g.isInstancedMesh, L = !!a.map, O = !!a.matcap, P = !!x, j = !!a.aoMap, R = !!a.lightMap, k = !!a.bumpMap, U = !!a.normalMap, B = !!a.displacementMap, F = !!a.emissiveMap, Q = !!a.metalnessMap, H = !!a.roughnessMap, V = a.anisotropy > 0, G = a.clearcoat > 0, W = a.iridescence > 0, Y = a.sheen > 0, X = a.transmission > 0, Z = V && !!a.anisotropyMap, q = G && !!a.clearcoatMap, J = G && !!a.clearcoatNormalMap, K = G && !!a.clearcoatRoughnessMap, $ = W && !!a.iridescenceMap, tt = W && !!a.iridescenceThicknessMap, et = Y && !!a.sheenColorMap, it = Y && !!a.sheenRoughnessMap, nt = !!a.specularMap, rt = !!a.specularColorMap, at = !!a.specularIntensityMap, st = X && !!a.transmissionMap, ot = X && !!a.thicknessMap, lt = !!a.gradientMap, ct = !!a.alphaMap, ut = a.alphaTest > 0, ht = !!a.alphaHash, dt = !!a.extensions, pt = !!v.attributes.uv1, At = !!v.attributes.uv2, ft = !!v.attributes.uv3;
                    let mt = Xr;
                    return a.toneMapped && (null !== C && !0 !== C.isXRRenderTarget || (mt = t1.toneMapping)), {
                        isWebGL2: u,
                        shaderID: b,
                        shaderType: a.type,
                        shaderName: a.name,
                        vertexShader: _,
                        fragmentShader: I,
                        defines: a.defines,
                        customVertexShaderID: S,
                        customFragmentShaderID: N,
                        isRawShaderMaterial: !0 === a.isRawShaderMaterial,
                        glslVersion: a.glslVersion,
                        precision: p,
                        instancing: z,
                        instancingColor: z && null !== g.instanceColor,
                        supportsVertexTextures: d,
                        outputColorSpace: null === C ? t1.outputColorSpace : !0 === C.isXRRenderTarget ? C.texture.colorSpace : Hs,
                        map: L,
                        matcap: O,
                        envMap: P,
                        envMapMode: P && x.mapping,
                        envMapCubeUVHeight: w,
                        aoMap: j,
                        lightMap: R,
                        bumpMap: k,
                        normalMap: U,
                        displacementMap: d && B,
                        emissiveMap: F,
                        normalMapObjectSpace: U && a.normalMapType === Bs,
                        normalMapTangentSpace: U && a.normalMapType === Us,
                        metalnessMap: Q,
                        roughnessMap: H,
                        anisotropy: V,
                        anisotropyMap: Z,
                        clearcoat: G,
                        clearcoatMap: q,
                        clearcoatNormalMap: J,
                        clearcoatRoughnessMap: K,
                        iridescence: W,
                        iridescenceMap: $,
                        iridescenceThicknessMap: tt,
                        sheen: Y,
                        sheenColorMap: et,
                        sheenRoughnessMap: it,
                        specularMap: nt,
                        specularColorMap: rt,
                        specularIntensityMap: at,
                        transmission: X,
                        transmissionMap: st,
                        thicknessMap: ot,
                        gradientMap: lt,
                        opaque: !1 === a.transparent && a.blending === dr,
                        alphaMap: ct,
                        alphaTest: ut,
                        alphaHash: ht,
                        combine: a.combine,
                        mapUv: L && f(a.map.channel),
                        aoMapUv: j && f(a.aoMap.channel),
                        lightMapUv: R && f(a.lightMap.channel),
                        bumpMapUv: k && f(a.bumpMap.channel),
                        normalMapUv: U && f(a.normalMap.channel),
                        displacementMapUv: B && f(a.displacementMap.channel),
                        emissiveMapUv: F && f(a.emissiveMap.channel),
                        metalnessMapUv: Q && f(a.metalnessMap.channel),
                        roughnessMapUv: H && f(a.roughnessMap.channel),
                        anisotropyMapUv: Z && f(a.anisotropyMap.channel),
                        clearcoatMapUv: q && f(a.clearcoatMap.channel),
                        clearcoatNormalMapUv: J && f(a.clearcoatNormalMap.channel),
                        clearcoatRoughnessMapUv: K && f(a.clearcoatRoughnessMap.channel),
                        iridescenceMapUv: $ && f(a.iridescenceMap.channel),
                        iridescenceThicknessMapUv: tt && f(a.iridescenceThicknessMap.channel),
                        sheenColorMapUv: et && f(a.sheenColorMap.channel),
                        sheenRoughnessMapUv: it && f(a.sheenRoughnessMap.channel),
                        specularMapUv: nt && f(a.specularMap.channel),
                        specularColorMapUv: rt && f(a.specularColorMap.channel),
                        specularIntensityMapUv: at && f(a.specularIntensityMap.channel),
                        transmissionMapUv: st && f(a.transmissionMap.channel),
                        thicknessMapUv: ot && f(a.thicknessMap.channel),
                        alphaMapUv: ct && f(a.alphaMap.channel),
                        vertexTangents: !!v.attributes.tangent && (U || V),
                        vertexColors: a.vertexColors,
                        vertexAlphas: !0 === a.vertexColors && !!v.attributes.color && 4 === v.attributes.color.itemSize,
                        vertexUv1s: pt,
                        vertexUv2s: At,
                        vertexUv3s: ft,
                        pointsUvs: !0 === g.isPoints && !!v.attributes.uv && (L || ct),
                        fog: !!M,
                        useFog: !0 === a.fog,
                        fogExp2: M && M.isFogExp2,
                        flatShading: !0 === a.flatShading,
                        sizeAttenuation: !0 === a.sizeAttenuation,
                        logarithmicDepthBuffer: h,
                        skinning: !0 === g.isSkinnedMesh,
                        morphTargets: void 0 !== v.morphAttributes.position,
                        morphNormals: void 0 !== v.morphAttributes.normal,
                        morphColors: void 0 !== v.morphAttributes.color,
                        morphTargetsCount: E,
                        morphTextureStride: D,
                        numDirLights: o.directional.length,
                        numPointLights: o.point.length,
                        numSpotLights: o.spot.length,
                        numSpotLightMaps: o.spotLightMap.length,
                        numRectAreaLights: o.rectArea.length,
                        numHemiLights: o.hemi.length,
                        numDirLightShadows: o.directionalShadowMap.length,
                        numPointLightShadows: o.pointShadowMap.length,
                        numSpotLightShadows: o.spotShadowMap.length,
                        numSpotLightShadowsWithMaps: o.numSpotLightShadowsWithMaps,
                        numLightProbes: o.numLightProbes,
                        numClippingPlanes: s.numPlanes,
                        numClipIntersection: s.numIntersection,
                        dithering: a.dithering,
                        shadowMapEnabled: t1.shadowMap.enabled && c.length > 0,
                        shadowMapType: t1.shadowMap.type,
                        toneMapping: mt,
                        useLegacyLights: t1._useLegacyLights,
                        decodeVideoTexture: L && !0 === a.map.isVideoTexture && ul.getTransfer(a.map.colorSpace) === Ys,
                        premultipliedAlpha: a.premultipliedAlpha,
                        doubleSided: a.side === cr,
                        flipSided: a.side === lr,
                        useDepthPacking: a.depthPacking >= 0,
                        depthPacking: a.depthPacking || 0,
                        index0AttributeName: a.index0AttributeName,
                        extensionDerivatives: dt && !0 === a.extensions.derivatives,
                        extensionFragDepth: dt && !0 === a.extensions.fragDepth,
                        extensionDrawBuffers: dt && !0 === a.extensions.drawBuffers,
                        extensionShaderTextureLOD: dt && !0 === a.extensions.shaderTextureLOD,
                        rendererExtensionFragDepth: u || n.has("EXT_frag_depth"),
                        rendererExtensionDrawBuffers: u || n.has("WEBGL_draw_buffers"),
                        rendererExtensionShaderTextureLod: u || n.has("EXT_shader_texture_lod"),
                        rendererExtensionParallelShaderCompile: n.has("KHR_parallel_shader_compile"),
                        customProgramCacheKey: a.customProgramCacheKey()
                    };
                },
                getProgramCacheKey: function(e) {
                    const i = [];
                    if (e.shaderID ? i.push(e.shaderID) : (i.push(e.customVertexShaderID), i.push(e.customFragmentShaderID)), void 0 !== e.defines) for(const t1 in e.defines)i.push(t1), i.push(e.defines[t1]);
                    return !1 === e.isRawShaderMaterial && (function(t1, e) {
                        t1.push(e.precision), t1.push(e.outputColorSpace), t1.push(e.envMapMode), t1.push(e.envMapCubeUVHeight), t1.push(e.mapUv), t1.push(e.alphaMapUv), t1.push(e.lightMapUv), t1.push(e.aoMapUv), t1.push(e.bumpMapUv), t1.push(e.normalMapUv), t1.push(e.displacementMapUv), t1.push(e.emissiveMapUv), t1.push(e.metalnessMapUv), t1.push(e.roughnessMapUv), t1.push(e.anisotropyMapUv), t1.push(e.clearcoatMapUv), t1.push(e.clearcoatNormalMapUv), t1.push(e.clearcoatRoughnessMapUv), t1.push(e.iridescenceMapUv), t1.push(e.iridescenceThicknessMapUv), t1.push(e.sheenColorMapUv), t1.push(e.sheenRoughnessMapUv), t1.push(e.specularMapUv), t1.push(e.specularColorMapUv), t1.push(e.specularIntensityMapUv), t1.push(e.transmissionMapUv), t1.push(e.thicknessMapUv), t1.push(e.combine), t1.push(e.fogExp2), t1.push(e.sizeAttenuation), t1.push(e.morphTargetsCount), t1.push(e.morphAttributeCount), t1.push(e.numDirLights), t1.push(e.numPointLights), t1.push(e.numSpotLights), t1.push(e.numSpotLightMaps), t1.push(e.numHemiLights), t1.push(e.numRectAreaLights), t1.push(e.numDirLightShadows), t1.push(e.numPointLightShadows), t1.push(e.numSpotLightShadows), t1.push(e.numSpotLightShadowsWithMaps), t1.push(e.numLightProbes), t1.push(e.shadowMapType), t1.push(e.toneMapping), t1.push(e.numClippingPlanes), t1.push(e.numClipIntersection), t1.push(e.depthPacking);
                    }(i, e), function(t1, e) {
                        o.disableAll(), e.isWebGL2 && o.enable(0), e.supportsVertexTextures && o.enable(1), e.instancing && o.enable(2), e.instancingColor && o.enable(3), e.matcap && o.enable(4), e.envMap && o.enable(5), e.normalMapObjectSpace && o.enable(6), e.normalMapTangentSpace && o.enable(7), e.clearcoat && o.enable(8), e.iridescence && o.enable(9), e.alphaTest && o.enable(10), e.vertexColors && o.enable(11), e.vertexAlphas && o.enable(12), e.vertexUv1s && o.enable(13), e.vertexUv2s && o.enable(14), e.vertexUv3s && o.enable(15), e.vertexTangents && o.enable(16), e.anisotropy && o.enable(17), e.alphaHash && o.enable(18), t1.push(o.mask), o.disableAll(), e.fog && o.enable(0), e.useFog && o.enable(1), e.flatShading && o.enable(2), e.logarithmicDepthBuffer && o.enable(3), e.skinning && o.enable(4), e.morphTargets && o.enable(5), e.morphNormals && o.enable(6), e.morphColors && o.enable(7), e.premultipliedAlpha && o.enable(8), e.shadowMapEnabled && o.enable(9), e.useLegacyLights && o.enable(10), e.doubleSided && o.enable(11), e.flipSided && o.enable(12), e.useDepthPacking && o.enable(13), e.dithering && o.enable(14), e.transmission && o.enable(15), e.sheen && o.enable(16), e.opaque && o.enable(17), e.pointsUvs && o.enable(18), e.decodeVideoTexture && o.enable(19), t1.push(o.mask);
                    }(i, e), i.push(t1.outputColorSpace)), i.push(e.customProgramCacheKey), i.join();
                },
                getUniforms: function(t1) {
                    const e = A[t1.type];
                    let i;
                    if (e) {
                        const t1 = ph[e];
                        i = Yu.clone(t1.uniforms);
                    } else i = t1.uniforms;
                    return i;
                },
                acquireProgram: function(e, i) {
                    let n;
                    for(let t1 = 0, e = c.length; t1 < e; t1++){
                        const e = c[t1];
                        if (e.cacheKey === i) {
                            n = e, ++n.usedTimes;
                            break;
                        }
                    }
                    return void 0 === n && (n = new dp(t1, i, e, a), c.push(n)), n;
                },
                releaseProgram: function(t1) {
                    if (0 == --t1.usedTimes) {
                        const e = c.indexOf(t1);
                        c[e] = c[c.length - 1], c.pop(), t1.destroy();
                    }
                },
                releaseShaderCache: function(t1) {
                    l.remove(t1);
                },
                programs: c,
                dispose: function() {
                    l.dispose();
                }
            };
        }
        function gp() {
            let t1 = new WeakMap;
            return {
                get: function(e) {
                    let i = t1.get(e);
                    return void 0 === i && (i = {}, t1.set(e, i)), i;
                },
                remove: function(e) {
                    t1.delete(e);
                },
                update: function(e, i, n) {
                    t1.get(e)[i] = n;
                },
                dispose: function() {
                    t1 = new WeakMap;
                }
            };
        }
        function Mp(t1, e) {
            return t1.groupOrder !== e.groupOrder ? t1.groupOrder - e.groupOrder : t1.renderOrder !== e.renderOrder ? t1.renderOrder - e.renderOrder : t1.material.id !== e.material.id ? t1.material.id - e.material.id : t1.z !== e.z ? t1.z - e.z : t1.id - e.id;
        }
        function vp(t1, e) {
            return t1.groupOrder !== e.groupOrder ? t1.groupOrder - e.groupOrder : t1.renderOrder !== e.renderOrder ? t1.renderOrder - e.renderOrder : t1.z !== e.z ? e.z - t1.z : t1.id - e.id;
        }
        function yp() {
            const t1 = [];
            let e = 0;
            const i = [], n = [], r = [];
            function a(i, n, r, a, s, o) {
                let l = t1[e];
                return void 0 === l ? (l = {
                    id: i.id,
                    object: i,
                    geometry: n,
                    material: r,
                    groupOrder: a,
                    renderOrder: i.renderOrder,
                    z: s,
                    group: o
                }, t1[e] = l) : (l.id = i.id, l.object = i, l.geometry = n, l.material = r, l.groupOrder = a, l.renderOrder = i.renderOrder, l.z = s, l.group = o), e++, l;
            }
            return {
                opaque: i,
                transmissive: n,
                transparent: r,
                init: function() {
                    e = 0, i.length = 0, n.length = 0, r.length = 0;
                },
                push: function(t1, e, s, o, l, c) {
                    const u = a(t1, e, s, o, l, c);
                    s.transmission > 0 ? n.push(u) : !0 === s.transparent ? r.push(u) : i.push(u);
                },
                unshift: function(t1, e, s, o, l, c) {
                    const u = a(t1, e, s, o, l, c);
                    s.transmission > 0 ? n.unshift(u) : !0 === s.transparent ? r.unshift(u) : i.unshift(u);
                },
                finish: function() {
                    for(let i = e, n = t1.length; i < n; i++){
                        const e = t1[i];
                        if (null === e.id) break;
                        e.id = null, e.object = null, e.geometry = null, e.material = null, e.group = null;
                    }
                },
                sort: function(t1, e) {
                    i.length > 1 && i.sort(t1 || Mp), n.length > 1 && n.sort(e || vp), r.length > 1 && r.sort(e || vp);
                }
            };
        }
        function xp() {
            let t1 = new WeakMap;
            return {
                get: function(e, i) {
                    const n = t1.get(e);
                    let r;
                    return void 0 === n ? (r = new yp, t1.set(e, [
                        r
                    ])) : i >= n.length ? (r = new yp, n.push(r)) : r = n[i], r;
                },
                dispose: function() {
                    t1 = new WeakMap;
                }
            };
        }
        function wp() {
            const t1 = {};
            return {
                get: function(e) {
                    if (void 0 !== t1[e.id]) return t1[e.id];
                    let i;
                    switch(e.type){
                        case "DirectionalLight":
                            i = {
                                direction: new Nl,
                                color: new Yc
                            };
                            break;
                        case "SpotLight":
                            i = {
                                position: new Nl,
                                direction: new Nl,
                                color: new Yc,
                                distance: 0,
                                coneCos: 0,
                                penumbraCos: 0,
                                decay: 0
                            };
                            break;
                        case "PointLight":
                            i = {
                                position: new Nl,
                                color: new Yc,
                                distance: 0,
                                decay: 0
                            };
                            break;
                        case "HemisphereLight":
                            i = {
                                direction: new Nl,
                                skyColor: new Yc,
                                groundColor: new Yc
                            };
                            break;
                        case "RectAreaLight":
                            i = {
                                color: new Yc,
                                position: new Nl,
                                halfWidth: new Nl,
                                halfHeight: new Nl
                            };
                    }
                    return t1[e.id] = i, i;
                }
            };
        }
        let bp = 0;
        function Tp(t1, e) {
            return (e.castShadow ? 2 : 0) - (t1.castShadow ? 2 : 0) + (e.map ? 1 : 0) - (t1.map ? 1 : 0);
        }
        function Ep(t1, e) {
            const i = new wp, n = function() {
                const t1 = {};
                return {
                    get: function(e) {
                        if (void 0 !== t1[e.id]) return t1[e.id];
                        let i;
                        switch(e.type){
                            case "DirectionalLight":
                            case "SpotLight":
                                i = {
                                    shadowBias: 0,
                                    shadowNormalBias: 0,
                                    shadowRadius: 1,
                                    shadowMapSize: new qo
                                };
                                break;
                            case "PointLight":
                                i = {
                                    shadowBias: 0,
                                    shadowNormalBias: 0,
                                    shadowRadius: 1,
                                    shadowMapSize: new qo,
                                    shadowCameraNear: 1,
                                    shadowCameraFar: 1e3
                                };
                        }
                        return t1[e.id] = i, i;
                    }
                };
            }(), r = {
                version: 0,
                hash: {
                    directionalLength: -1,
                    pointLength: -1,
                    spotLength: -1,
                    rectAreaLength: -1,
                    hemiLength: -1,
                    numDirectionalShadows: -1,
                    numPointShadows: -1,
                    numSpotShadows: -1,
                    numSpotMaps: -1,
                    numLightProbes: -1
                },
                ambient: [
                    0,
                    0,
                    0
                ],
                probe: [],
                directional: [],
                directionalShadow: [],
                directionalShadowMap: [],
                directionalShadowMatrix: [],
                spot: [],
                spotLightMap: [],
                spotShadow: [],
                spotShadowMap: [],
                spotLightMatrix: [],
                rectArea: [],
                rectAreaLTC1: null,
                rectAreaLTC2: null,
                point: [],
                pointShadow: [],
                pointShadowMap: [],
                pointShadowMatrix: [],
                hemi: [],
                numSpotLightShadowsWithMaps: 0,
                numLightProbes: 0
            };
            for(let t1 = 0; t1 < 9; t1++)r.probe.push(new Nl);
            const a = new Nl, s = new ac, o = new ac;
            return {
                setup: function(a, s) {
                    let o = 0, l = 0, c = 0;
                    for(let t1 = 0; t1 < 9; t1++)r.probe[t1].set(0, 0, 0);
                    let u = 0, h = 0, d = 0, p = 0, A = 0, f = 0, m = 0, g = 0, M = 0, v = 0, y = 0;
                    a.sort(Tp);
                    const x = !0 === s ? Math.PI : 1;
                    for(let t1 = 0, e = a.length; t1 < e; t1++){
                        const e = a[t1], s = e.color, w = e.intensity, b = e.distance, T = e.shadow && e.shadow.map ? e.shadow.map.texture : null;
                        if (e.isAmbientLight) o += s.r * w * x, l += s.g * w * x, c += s.b * w * x;
                        else if (e.isLightProbe) {
                            for(let t1 = 0; t1 < 9; t1++)r.probe[t1].addScaledVector(e.sh.coefficients[t1], w);
                            y++;
                        } else if (e.isDirectionalLight) {
                            const t1 = i.get(e);
                            if (t1.color.copy(e.color).multiplyScalar(e.intensity * x), e.castShadow) {
                                const t1 = e.shadow, i = n.get(e);
                                i.shadowBias = t1.bias, i.shadowNormalBias = t1.normalBias, i.shadowRadius = t1.radius, i.shadowMapSize = t1.mapSize, r.directionalShadow[u] = i, r.directionalShadowMap[u] = T, r.directionalShadowMatrix[u] = e.shadow.matrix, f++;
                            }
                            r.directional[u] = t1, u++;
                        } else if (e.isSpotLight) {
                            const t1 = i.get(e);
                            t1.position.setFromMatrixPosition(e.matrixWorld), t1.color.copy(s).multiplyScalar(w * x), t1.distance = b, t1.coneCos = Math.cos(e.angle), t1.penumbraCos = Math.cos(e.angle * (1 - e.penumbra)), t1.decay = e.decay, r.spot[d] = t1;
                            const a = e.shadow;
                            if (e.map && (r.spotLightMap[M] = e.map, M++, a.updateMatrices(e), e.castShadow && v++), r.spotLightMatrix[d] = a.matrix, e.castShadow) {
                                const t1 = n.get(e);
                                t1.shadowBias = a.bias, t1.shadowNormalBias = a.normalBias, t1.shadowRadius = a.radius, t1.shadowMapSize = a.mapSize, r.spotShadow[d] = t1, r.spotShadowMap[d] = T, g++;
                            }
                            d++;
                        } else if (e.isRectAreaLight) {
                            const t1 = i.get(e);
                            t1.color.copy(s).multiplyScalar(w), t1.halfWidth.set(.5 * e.width, 0, 0), t1.halfHeight.set(0, .5 * e.height, 0), r.rectArea[p] = t1, p++;
                        } else if (e.isPointLight) {
                            const t1 = i.get(e);
                            if (t1.color.copy(e.color).multiplyScalar(e.intensity * x), t1.distance = e.distance, t1.decay = e.decay, e.castShadow) {
                                const t1 = e.shadow, i = n.get(e);
                                i.shadowBias = t1.bias, i.shadowNormalBias = t1.normalBias, i.shadowRadius = t1.radius, i.shadowMapSize = t1.mapSize, i.shadowCameraNear = t1.camera.near, i.shadowCameraFar = t1.camera.far, r.pointShadow[h] = i, r.pointShadowMap[h] = T, r.pointShadowMatrix[h] = e.shadow.matrix, m++;
                            }
                            r.point[h] = t1, h++;
                        } else if (e.isHemisphereLight) {
                            const t1 = i.get(e);
                            t1.skyColor.copy(e.color).multiplyScalar(w * x), t1.groundColor.copy(e.groundColor).multiplyScalar(w * x), r.hemi[A] = t1, A++;
                        }
                    }
                    p > 0 && (e.isWebGL2 || !0 === t1.has("OES_texture_float_linear") ? (r.rectAreaLTC1 = dh.LTC_FLOAT_1, r.rectAreaLTC2 = dh.LTC_FLOAT_2) : !0 === t1.has("OES_texture_half_float_linear") ? (r.rectAreaLTC1 = dh.LTC_HALF_1, r.rectAreaLTC2 = dh.LTC_HALF_2) : console.error("THREE.WebGLRenderer: Unable to use RectAreaLight. Missing WebGL extensions.")), r.ambient[0] = o, r.ambient[1] = l, r.ambient[2] = c;
                    const w = r.hash;
                    w.directionalLength === u && w.pointLength === h && w.spotLength === d && w.rectAreaLength === p && w.hemiLength === A && w.numDirectionalShadows === f && w.numPointShadows === m && w.numSpotShadows === g && w.numSpotMaps === M && w.numLightProbes === y || (r.directional.length = u, r.spot.length = d, r.rectArea.length = p, r.point.length = h, r.hemi.length = A, r.directionalShadow.length = f, r.directionalShadowMap.length = f, r.pointShadow.length = m, r.pointShadowMap.length = m, r.spotShadow.length = g, r.spotShadowMap.length = g, r.directionalShadowMatrix.length = f, r.pointShadowMatrix.length = m, r.spotLightMatrix.length = g + M - v, r.spotLightMap.length = M, r.numSpotLightShadowsWithMaps = v, r.numLightProbes = y, w.directionalLength = u, w.pointLength = h, w.spotLength = d, w.rectAreaLength = p, w.hemiLength = A, w.numDirectionalShadows = f, w.numPointShadows = m, w.numSpotShadows = g, w.numSpotMaps = M, w.numLightProbes = y, r.version = bp++);
                },
                setupView: function(t1, e) {
                    let i = 0, n = 0, l = 0, c = 0, u = 0;
                    const h = e.matrixWorldInverse;
                    for(let e = 0, d = t1.length; e < d; e++){
                        const d = t1[e];
                        if (d.isDirectionalLight) {
                            const t1 = r.directional[i];
                            t1.direction.setFromMatrixPosition(d.matrixWorld), a.setFromMatrixPosition(d.target.matrixWorld), t1.direction.sub(a), t1.direction.transformDirection(h), i++;
                        } else if (d.isSpotLight) {
                            const t1 = r.spot[l];
                            t1.position.setFromMatrixPosition(d.matrixWorld), t1.position.applyMatrix4(h), t1.direction.setFromMatrixPosition(d.matrixWorld), a.setFromMatrixPosition(d.target.matrixWorld), t1.direction.sub(a), t1.direction.transformDirection(h), l++;
                        } else if (d.isRectAreaLight) {
                            const t1 = r.rectArea[c];
                            t1.position.setFromMatrixPosition(d.matrixWorld), t1.position.applyMatrix4(h), o.identity(), s.copy(d.matrixWorld), s.premultiply(h), o.extractRotation(s), t1.halfWidth.set(.5 * d.width, 0, 0), t1.halfHeight.set(0, .5 * d.height, 0), t1.halfWidth.applyMatrix4(o), t1.halfHeight.applyMatrix4(o), c++;
                        } else if (d.isPointLight) {
                            const t1 = r.point[n];
                            t1.position.setFromMatrixPosition(d.matrixWorld), t1.position.applyMatrix4(h), n++;
                        } else if (d.isHemisphereLight) {
                            const t1 = r.hemi[u];
                            t1.direction.setFromMatrixPosition(d.matrixWorld), t1.direction.transformDirection(h), u++;
                        }
                    }
                },
                state: r
            };
        }
        function _p(t1, e) {
            const i = new Ep(t1, e), n = [], r = [];
            return {
                init: function() {
                    n.length = 0, r.length = 0;
                },
                state: {
                    lightsArray: n,
                    shadowsArray: r,
                    lights: i
                },
                setupLights: function(t1) {
                    i.setup(n, t1);
                },
                setupLightsView: function(t1) {
                    i.setupView(n, t1);
                },
                pushLight: function(t1) {
                    n.push(t1);
                },
                pushShadow: function(t1) {
                    r.push(t1);
                }
            };
        }
        function Ip(t1, e) {
            let i = new WeakMap;
            return {
                get: function(n, r = 0) {
                    const a = i.get(n);
                    let s;
                    return void 0 === a ? (s = new _p(t1, e), i.set(n, [
                        s
                    ])) : r >= a.length ? (s = new _p(t1, e), a.push(s)) : s = a[r], s;
                },
                dispose: function() {
                    i = new WeakMap;
                }
            };
        }
        class Sp extends qc {
            constructor(t1){
                super(), this.isMeshDepthMaterial = !0, this.type = "MeshDepthMaterial", this.depthPacking = Rs, this.map = null, this.alphaMap = null, this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.wireframe = !1, this.wireframeLinewidth = 1, this.setValues(t1);
            }
            copy(t1) {
                return super.copy(t1), this.depthPacking = t1.depthPacking, this.map = t1.map, this.alphaMap = t1.alphaMap, this.displacementMap = t1.displacementMap, this.displacementScale = t1.displacementScale, this.displacementBias = t1.displacementBias, this.wireframe = t1.wireframe, this.wireframeLinewidth = t1.wireframeLinewidth, this;
            }
        }
        class Np extends qc {
            constructor(t1){
                super(), this.isMeshDistanceMaterial = !0, this.type = "MeshDistanceMaterial", this.map = null, this.alphaMap = null, this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.setValues(t1);
            }
            copy(t1) {
                return super.copy(t1), this.map = t1.map, this.alphaMap = t1.alphaMap, this.displacementMap = t1.displacementMap, this.displacementScale = t1.displacementScale, this.displacementBias = t1.displacementBias, this;
            }
        }
        function Dp(t1, e, i) {
            let n = new oh;
            const r = new qo, a = new qo, s = new yl, o = new Sp({
                depthPacking: ks
            }), l = new Np, c = {}, u = i.maxTextureSize, h = {
                [or]: lr,
                [lr]: or,
                [cr]: cr
            }, d = new Xu({
                defines: {
                    VSM_SAMPLES: 8
                },
                uniforms: {
                    shadow_pass: {
                        value: null
                    },
                    resolution: {
                        value: new qo
                    },
                    radius: {
                        value: 4
                    }
                },
                vertexShader: "void main() {\n	gl_Position = vec4( position, 1.0 );\n}",
                fragmentShader: "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\n#include <packing>\nvoid main() {\n	const float samples = float( VSM_SAMPLES );\n	float mean = 0.0;\n	float squared_mean = 0.0;\n	float uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );\n	float uvStart = samples <= 1.0 ? 0.0 : - 1.0;\n	for ( float i = 0.0; i < samples; i ++ ) {\n		float uvOffset = uvStart + i * uvStride;\n		#ifdef HORIZONTAL_PASS\n			vec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );\n			mean += distribution.x;\n			squared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n		#else\n			float depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );\n			mean += depth;\n			squared_mean += depth * depth;\n		#endif\n	}\n	mean = mean / samples;\n	squared_mean = squared_mean / samples;\n	float std_dev = sqrt( squared_mean - mean * mean );\n	gl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );\n}"
            }), p = d.clone();
            p.defines.HORIZONTAL_PASS = 1;
            const A = new bu;
            A.setAttribute("position", new au(new Float32Array([
                -1,
                -1,
                .5,
                3,
                -1,
                .5,
                -1,
                3,
                .5
            ]), 3));
            const f = new Fu(A, d), m = this;
            this.enabled = !1, this.autoUpdate = !0, this.needsUpdate = !1, this.type = rr;
            let g = this.type;
            function M(i, n) {
                const a = e.update(f);
                d.defines.VSM_SAMPLES !== i.blurSamples && (d.defines.VSM_SAMPLES = i.blurSamples, p.defines.VSM_SAMPLES = i.blurSamples, d.needsUpdate = !0, p.needsUpdate = !0), null === i.mapPass && (i.mapPass = new wl(r.x, r.y)), d.uniforms.shadow_pass.value = i.map.texture, d.uniforms.resolution.value = i.mapSize, d.uniforms.radius.value = i.radius, t1.setRenderTarget(i.mapPass), t1.clear(), t1.renderBufferDirect(n, null, a, d, f, null), p.uniforms.shadow_pass.value = i.mapPass.texture, p.uniforms.resolution.value = i.mapSize, p.uniforms.radius.value = i.radius, t1.setRenderTarget(i.map), t1.clear(), t1.renderBufferDirect(n, null, a, p, f, null);
            }
            function v(e, i, n, r) {
                let a = null;
                const s = !0 === n.isPointLight ? e.customDistanceMaterial : e.customDepthMaterial;
                if (void 0 !== s) a = s;
                else if (a = !0 === n.isPointLight ? l : o, t1.localClippingEnabled && !0 === i.clipShadows && Array.isArray(i.clippingPlanes) && 0 !== i.clippingPlanes.length || i.displacementMap && 0 !== i.displacementScale || i.alphaMap && i.alphaTest > 0 || i.map && i.alphaTest > 0) {
                    const t1 = a.uuid, e = i.uuid;
                    let n = c[t1];
                    void 0 === n && (n = {}, c[t1] = n);
                    let r = n[e];
                    void 0 === r && (r = a.clone(), n[e] = r), a = r;
                }
                return a.visible = i.visible, a.wireframe = i.wireframe, a.side = r === sr ? null !== i.shadowSide ? i.shadowSide : i.side : null !== i.shadowSide ? i.shadowSide : h[i.side], a.alphaMap = i.alphaMap, a.alphaTest = i.alphaTest, a.map = i.map, a.clipShadows = i.clipShadows, a.clippingPlanes = i.clippingPlanes, a.clipIntersection = i.clipIntersection, a.displacementMap = i.displacementMap, a.displacementScale = i.displacementScale, a.displacementBias = i.displacementBias, a.wireframeLinewidth = i.wireframeLinewidth, a.linewidth = i.linewidth, !0 === n.isPointLight && !0 === a.isMeshDistanceMaterial && (t1.properties.get(a).light = n), a;
            }
            function y(i, r, a, s, o) {
                if (!1 === i.visible) return;
                if (i.layers.test(r.layers) && (i.isMesh || i.isLine || i.isPoints) && (i.castShadow || i.receiveShadow && o === sr) && (!i.frustumCulled || n.intersectsObject(i))) {
                    i.modelViewMatrix.multiplyMatrices(a.matrixWorldInverse, i.matrixWorld);
                    const n = e.update(i), r = i.material;
                    if (Array.isArray(r)) {
                        const e = n.groups;
                        for(let l = 0, c = e.length; l < c; l++){
                            const c = e[l], u = r[c.materialIndex];
                            if (u && u.visible) {
                                const e = v(i, u, s, o);
                                t1.renderBufferDirect(a, null, n, e, i, c);
                            }
                        }
                    } else if (r.visible) {
                        const e = v(i, r, s, o);
                        t1.renderBufferDirect(a, null, n, e, i, null);
                    }
                }
                const l = i.children;
                for(let t1 = 0, e = l.length; t1 < e; t1++)y(l[t1], r, a, s, o);
            }
            this.render = function(e, i, o) {
                if (!1 === m.enabled) return;
                if (!1 === m.autoUpdate && !1 === m.needsUpdate) return;
                if (0 === e.length) return;
                const l = t1.getRenderTarget(), c = t1.getActiveCubeFace(), h = t1.getActiveMipmapLevel(), d = t1.state;
                d.setBlending(hr), d.buffers.color.setClear(1, 1, 1, 1), d.buffers.depth.setTest(!0), d.setScissorTest(!1);
                const p = g !== sr && this.type === sr, A = g === sr && this.type !== sr;
                for(let l = 0, c = e.length; l < c; l++){
                    const c = e[l], h = c.shadow;
                    if (void 0 === h) {
                        console.warn("THREE.WebGLShadowMap:", c, "has no shadow.");
                        continue;
                    }
                    if (!1 === h.autoUpdate && !1 === h.needsUpdate) continue;
                    r.copy(h.mapSize);
                    const f = h.getFrameExtents();
                    if (r.multiply(f), a.copy(h.mapSize), (r.x > u || r.y > u) && (r.x > u && (a.x = Math.floor(u / f.x), r.x = a.x * f.x, h.mapSize.x = a.x), r.y > u && (a.y = Math.floor(u / f.y), r.y = a.y * f.y, h.mapSize.y = a.y)), null === h.map || !0 === p || !0 === A) {
                        const t1 = this.type !== sr ? {
                            minFilter: ha,
                            magFilter: ha
                        } : {};
                        null !== h.map && h.map.dispose(), h.map = new wl(r.x, r.y, t1), h.map.texture.name = c.name + ".shadowMap", h.camera.updateProjectionMatrix();
                    }
                    t1.setRenderTarget(h.map), t1.clear();
                    const m = h.getViewportCount();
                    for(let t1 = 0; t1 < m; t1++){
                        const e = h.getViewport(t1);
                        s.set(a.x * e.x, a.y * e.y, a.x * e.z, a.y * e.w), d.viewport(s), h.updateMatrices(c, t1), n = h.getFrustum(), y(i, o, h.camera, c, this.type);
                    }
                    !0 !== h.isPointLightShadow && this.type === sr && M(h, o), h.needsUpdate = !1;
                }
                g = this.type, m.needsUpdate = !1, t1.setRenderTarget(l, c, h);
            };
        }
        function Cp(t1, e, i) {
            const n = i.isWebGL2, r = new function() {
                let e = !1;
                const i = new yl;
                let n = null;
                const r = new yl(0, 0, 0, 0);
                return {
                    setMask: function(i) {
                        n === i || e || (t1.colorMask(i, i, i, i), n = i);
                    },
                    setLocked: function(t1) {
                        e = t1;
                    },
                    setClear: function(e, n, a, s, o) {
                        !0 === o && (e *= s, n *= s, a *= s), i.set(e, n, a, s), !1 === r.equals(i) && (t1.clearColor(e, n, a, s), r.copy(i));
                    },
                    reset: function() {
                        e = !1, n = null, r.set(-1, 0, 0, 0);
                    }
                };
            }, a = new function() {
                let e = !1, i = null, n = null, r = null;
                return {
                    setTest: function(e) {
                        e ? Q(t1.DEPTH_TEST) : H(t1.DEPTH_TEST);
                    },
                    setMask: function(n) {
                        i === n || e || (t1.depthMask(n), i = n);
                    },
                    setFunc: function(e) {
                        if (n !== e) {
                            switch(e){
                                case Rr:
                                    t1.depthFunc(t1.NEVER);
                                    break;
                                case kr:
                                    t1.depthFunc(t1.ALWAYS);
                                    break;
                                case Ur:
                                    t1.depthFunc(t1.LESS);
                                    break;
                                case Br:
                                    t1.depthFunc(t1.LEQUAL);
                                    break;
                                case Fr:
                                    t1.depthFunc(t1.EQUAL);
                                    break;
                                case Qr:
                                    t1.depthFunc(t1.GEQUAL);
                                    break;
                                case Hr:
                                    t1.depthFunc(t1.GREATER);
                                    break;
                                case Vr:
                                    t1.depthFunc(t1.NOTEQUAL);
                                    break;
                                default:
                                    t1.depthFunc(t1.LEQUAL);
                            }
                            n = e;
                        }
                    },
                    setLocked: function(t1) {
                        e = t1;
                    },
                    setClear: function(e) {
                        r !== e && (t1.clearDepth(e), r = e);
                    },
                    reset: function() {
                        e = !1, i = null, n = null, r = null;
                    }
                };
            }, s = new function() {
                let e = !1, i = null, n = null, r = null, a = null, s = null, o = null, l = null, c = null;
                return {
                    setTest: function(i) {
                        e || (i ? Q(t1.STENCIL_TEST) : H(t1.STENCIL_TEST));
                    },
                    setMask: function(n) {
                        i === n || e || (t1.stencilMask(n), i = n);
                    },
                    setFunc: function(e, i, s) {
                        n === e && r === i && a === s || (t1.stencilFunc(e, i, s), n = e, r = i, a = s);
                    },
                    setOp: function(e, i, n) {
                        s === e && o === i && l === n || (t1.stencilOp(e, i, n), s = e, o = i, l = n);
                    },
                    setLocked: function(t1) {
                        e = t1;
                    },
                    setClear: function(e) {
                        c !== e && (t1.clearStencil(e), c = e);
                    },
                    reset: function() {
                        e = !1, i = null, n = null, r = null, a = null, s = null, o = null, l = null, c = null;
                    }
                };
            }, o = new WeakMap, l = new WeakMap;
            let c = {}, u = {}, h = new WeakMap, d = [], p = null, A = !1, f = null, m = null, g = null, M = null, v = null, y = null, x = null, w = new Yc(0, 0, 0), b = 0, T = !1, E = null, _ = null, I = null, S = null, N = null;
            const D = t1.getParameter(t1.MAX_COMBINED_TEXTURE_IMAGE_UNITS);
            let C = !1, z = 0;
            const L = t1.getParameter(t1.VERSION);
            -1 !== L.indexOf("WebGL") ? (z = parseFloat(/^WebGL (\d)/.exec(L)[1]), C = z >= 1) : -1 !== L.indexOf("OpenGL ES") && (z = parseFloat(/^OpenGL ES (\d)/.exec(L)[1]), C = z >= 2);
            let O = null, P = {};
            const j = t1.getParameter(t1.SCISSOR_BOX), R = t1.getParameter(t1.VIEWPORT), k = (new yl).fromArray(j), U = (new yl).fromArray(R);
            function B(e, i, r, a) {
                const s = new Uint8Array(4), o = t1.createTexture();
                t1.bindTexture(e, o), t1.texParameteri(e, t1.TEXTURE_MIN_FILTER, t1.NEAREST), t1.texParameteri(e, t1.TEXTURE_MAG_FILTER, t1.NEAREST);
                for(let o = 0; o < r; o++)!n || e !== t1.TEXTURE_3D && e !== t1.TEXTURE_2D_ARRAY ? t1.texImage2D(i + o, 0, t1.RGBA, 1, 1, 0, t1.RGBA, t1.UNSIGNED_BYTE, s) : t1.texImage3D(i, 0, t1.RGBA, 1, 1, a, 0, t1.RGBA, t1.UNSIGNED_BYTE, s);
                return o;
            }
            const F = {};
            function Q(e) {
                !0 !== c[e] && (t1.enable(e), c[e] = !0);
            }
            function H(e) {
                !1 !== c[e] && (t1.disable(e), c[e] = !1);
            }
            F[t1.TEXTURE_2D] = B(t1.TEXTURE_2D, t1.TEXTURE_2D, 1), F[t1.TEXTURE_CUBE_MAP] = B(t1.TEXTURE_CUBE_MAP, t1.TEXTURE_CUBE_MAP_POSITIVE_X, 6), n && (F[t1.TEXTURE_2D_ARRAY] = B(t1.TEXTURE_2D_ARRAY, t1.TEXTURE_2D_ARRAY, 1, 1), F[t1.TEXTURE_3D] = B(t1.TEXTURE_3D, t1.TEXTURE_3D, 1, 1)), r.setClear(0, 0, 0, 1), a.setClear(1), s.setClear(0), Q(t1.DEPTH_TEST), a.setFunc(Br), Y(!1), X(tr), Q(t1.CULL_FACE), W(hr);
            const V = {
                [gr]: t1.FUNC_ADD,
                [Mr]: t1.FUNC_SUBTRACT,
                [vr]: t1.FUNC_REVERSE_SUBTRACT
            };
            if (n) V[yr] = t1.MIN, V[xr] = t1.MAX;
            else {
                const t1 = e.get("EXT_blend_minmax");
                null !== t1 && (V[yr] = t1.MIN_EXT, V[xr] = t1.MAX_EXT);
            }
            const G = {
                [wr]: t1.ZERO,
                [br]: t1.ONE,
                [Tr]: t1.SRC_COLOR,
                [_r]: t1.SRC_ALPHA,
                [zr]: t1.SRC_ALPHA_SATURATE,
                [Dr]: t1.DST_COLOR,
                [Sr]: t1.DST_ALPHA,
                [Er]: t1.ONE_MINUS_SRC_COLOR,
                [Ir]: t1.ONE_MINUS_SRC_ALPHA,
                [Cr]: t1.ONE_MINUS_DST_COLOR,
                [Nr]: t1.ONE_MINUS_DST_ALPHA,
                [Lr]: t1.CONSTANT_COLOR,
                [Or]: t1.ONE_MINUS_CONSTANT_COLOR,
                [Pr]: t1.CONSTANT_ALPHA,
                [jr]: t1.ONE_MINUS_CONSTANT_ALPHA
            };
            function W(e, i, n, r, a, s, o, l, c, u) {
                if (e !== hr) {
                    if (!1 === A && (Q(t1.BLEND), A = !0), e === mr) a = a || i, s = s || n, o = o || r, i === m && a === v || (t1.blendEquationSeparate(V[i], V[a]), m = i, v = a), n === g && r === M && s === y && o === x || (t1.blendFuncSeparate(G[n], G[r], G[s], G[o]), g = n, M = r, y = s, x = o), !1 !== l.equals(w) && c === b || (t1.blendColor(l.r, l.g, l.b, c), w.copy(l), b = c), f = e, T = !1;
                    else if (e !== f || u !== T) {
                        if (m === gr && v === gr || (t1.blendEquation(t1.FUNC_ADD), m = gr, v = gr), u) switch(e){
                            case dr:
                                t1.blendFuncSeparate(t1.ONE, t1.ONE_MINUS_SRC_ALPHA, t1.ONE, t1.ONE_MINUS_SRC_ALPHA);
                                break;
                            case pr:
                                t1.blendFunc(t1.ONE, t1.ONE);
                                break;
                            case Ar:
                                t1.blendFuncSeparate(t1.ZERO, t1.ONE_MINUS_SRC_COLOR, t1.ZERO, t1.ONE);
                                break;
                            case fr:
                                t1.blendFuncSeparate(t1.ZERO, t1.SRC_COLOR, t1.ZERO, t1.SRC_ALPHA);
                                break;
                            default:
                                console.error("THREE.WebGLState: Invalid blending: ", e);
                        }
                        else switch(e){
                            case dr:
                                t1.blendFuncSeparate(t1.SRC_ALPHA, t1.ONE_MINUS_SRC_ALPHA, t1.ONE, t1.ONE_MINUS_SRC_ALPHA);
                                break;
                            case pr:
                                t1.blendFunc(t1.SRC_ALPHA, t1.ONE);
                                break;
                            case Ar:
                                t1.blendFuncSeparate(t1.ZERO, t1.ONE_MINUS_SRC_COLOR, t1.ZERO, t1.ONE);
                                break;
                            case fr:
                                t1.blendFunc(t1.ZERO, t1.SRC_COLOR);
                                break;
                            default:
                                console.error("THREE.WebGLState: Invalid blending: ", e);
                        }
                        g = null, M = null, y = null, x = null, w.set(0, 0, 0), b = 0, f = e, T = u;
                    }
                } else !0 === A && (H(t1.BLEND), A = !1);
            }
            function Y(e) {
                E !== e && (e ? t1.frontFace(t1.CW) : t1.frontFace(t1.CCW), E = e);
            }
            function X(e) {
                e !== $n ? (Q(t1.CULL_FACE), e !== _ && (e === tr ? t1.cullFace(t1.BACK) : e === er ? t1.cullFace(t1.FRONT) : t1.cullFace(t1.FRONT_AND_BACK))) : H(t1.CULL_FACE), _ = e;
            }
            function Z(e, i, n) {
                e ? (Q(t1.POLYGON_OFFSET_FILL), S === i && N === n || (t1.polygonOffset(i, n), S = i, N = n)) : H(t1.POLYGON_OFFSET_FILL);
            }
            return {
                buffers: {
                    color: r,
                    depth: a,
                    stencil: s
                },
                enable: Q,
                disable: H,
                bindFramebuffer: function(e, i) {
                    return u[e] !== i && (t1.bindFramebuffer(e, i), u[e] = i, n && (e === t1.DRAW_FRAMEBUFFER && (u[t1.FRAMEBUFFER] = i), e === t1.FRAMEBUFFER && (u[t1.DRAW_FRAMEBUFFER] = i)), !0);
                },
                drawBuffers: function(n, r) {
                    let a = d, s = !1;
                    if (n) {
                        if (a = h.get(r), void 0 === a && (a = [], h.set(r, a)), n.isWebGLMultipleRenderTargets) {
                            const e = n.texture;
                            if (a.length !== e.length || a[0] !== t1.COLOR_ATTACHMENT0) {
                                for(let i = 0, n = e.length; i < n; i++)a[i] = t1.COLOR_ATTACHMENT0 + i;
                                a.length = e.length, s = !0;
                            }
                        } else a[0] !== t1.COLOR_ATTACHMENT0 && (a[0] = t1.COLOR_ATTACHMENT0, s = !0);
                    } else a[0] !== t1.BACK && (a[0] = t1.BACK, s = !0);
                    s && (i.isWebGL2 ? t1.drawBuffers(a) : e.get("WEBGL_draw_buffers").drawBuffersWEBGL(a));
                },
                useProgram: function(e) {
                    return p !== e && (t1.useProgram(e), p = e, !0);
                },
                setBlending: W,
                setMaterial: function(e, i) {
                    e.side === cr ? H(t1.CULL_FACE) : Q(t1.CULL_FACE);
                    let n = e.side === lr;
                    i && (n = !n), Y(n), e.blending === dr && !1 === e.transparent ? W(hr) : W(e.blending, e.blendEquation, e.blendSrc, e.blendDst, e.blendEquationAlpha, e.blendSrcAlpha, e.blendDstAlpha, e.blendColor, e.blendAlpha, e.premultipliedAlpha), a.setFunc(e.depthFunc), a.setTest(e.depthTest), a.setMask(e.depthWrite), r.setMask(e.colorWrite);
                    const o = e.stencilWrite;
                    s.setTest(o), o && (s.setMask(e.stencilWriteMask), s.setFunc(e.stencilFunc, e.stencilRef, e.stencilFuncMask), s.setOp(e.stencilFail, e.stencilZFail, e.stencilZPass)), Z(e.polygonOffset, e.polygonOffsetFactor, e.polygonOffsetUnits), !0 === e.alphaToCoverage ? Q(t1.SAMPLE_ALPHA_TO_COVERAGE) : H(t1.SAMPLE_ALPHA_TO_COVERAGE);
                },
                setFlipSided: Y,
                setCullFace: X,
                setLineWidth: function(e) {
                    e !== I && (C && t1.lineWidth(e), I = e);
                },
                setPolygonOffset: Z,
                setScissorTest: function(e) {
                    e ? Q(t1.SCISSOR_TEST) : H(t1.SCISSOR_TEST);
                },
                activeTexture: function(e) {
                    void 0 === e && (e = t1.TEXTURE0 + D - 1), O !== e && (t1.activeTexture(e), O = e);
                },
                bindTexture: function(e, i, n) {
                    void 0 === n && (n = null === O ? t1.TEXTURE0 + D - 1 : O);
                    let r = P[n];
                    void 0 === r && (r = {
                        type: void 0,
                        texture: void 0
                    }, P[n] = r), r.type === e && r.texture === i || (O !== n && (t1.activeTexture(n), O = n), t1.bindTexture(e, i || F[e]), r.type = e, r.texture = i);
                },
                unbindTexture: function() {
                    const e = P[O];
                    void 0 !== e && void 0 !== e.type && (t1.bindTexture(e.type, null), e.type = void 0, e.texture = void 0);
                },
                compressedTexImage2D: function() {
                    try {
                        t1.compressedTexImage2D.apply(t1, arguments);
                    } catch (t1) {
                        console.error("THREE.WebGLState:", t1);
                    }
                },
                compressedTexImage3D: function() {
                    try {
                        t1.compressedTexImage3D.apply(t1, arguments);
                    } catch (t1) {
                        console.error("THREE.WebGLState:", t1);
                    }
                },
                texImage2D: function() {
                    try {
                        t1.texImage2D.apply(t1, arguments);
                    } catch (t1) {
                        console.error("THREE.WebGLState:", t1);
                    }
                },
                texImage3D: function() {
                    try {
                        t1.texImage3D.apply(t1, arguments);
                    } catch (t1) {
                        console.error("THREE.WebGLState:", t1);
                    }
                },
                updateUBOMapping: function(e, i) {
                    let n = l.get(i);
                    void 0 === n && (n = new WeakMap, l.set(i, n));
                    let r = n.get(e);
                    void 0 === r && (r = t1.getUniformBlockIndex(i, e.name), n.set(e, r));
                },
                uniformBlockBinding: function(e, i) {
                    const n = l.get(i).get(e);
                    o.get(i) !== n && (t1.uniformBlockBinding(i, n, e.__bindingPointIndex), o.set(i, n));
                },
                texStorage2D: function() {
                    try {
                        t1.texStorage2D.apply(t1, arguments);
                    } catch (t1) {
                        console.error("THREE.WebGLState:", t1);
                    }
                },
                texStorage3D: function() {
                    try {
                        t1.texStorage3D.apply(t1, arguments);
                    } catch (t1) {
                        console.error("THREE.WebGLState:", t1);
                    }
                },
                texSubImage2D: function() {
                    try {
                        t1.texSubImage2D.apply(t1, arguments);
                    } catch (t1) {
                        console.error("THREE.WebGLState:", t1);
                    }
                },
                texSubImage3D: function() {
                    try {
                        t1.texSubImage3D.apply(t1, arguments);
                    } catch (t1) {
                        console.error("THREE.WebGLState:", t1);
                    }
                },
                compressedTexSubImage2D: function() {
                    try {
                        t1.compressedTexSubImage2D.apply(t1, arguments);
                    } catch (t1) {
                        console.error("THREE.WebGLState:", t1);
                    }
                },
                compressedTexSubImage3D: function() {
                    try {
                        t1.compressedTexSubImage3D.apply(t1, arguments);
                    } catch (t1) {
                        console.error("THREE.WebGLState:", t1);
                    }
                },
                scissor: function(e) {
                    !1 === k.equals(e) && (t1.scissor(e.x, e.y, e.z, e.w), k.copy(e));
                },
                viewport: function(e) {
                    !1 === U.equals(e) && (t1.viewport(e.x, e.y, e.z, e.w), U.copy(e));
                },
                reset: function() {
                    t1.disable(t1.BLEND), t1.disable(t1.CULL_FACE), t1.disable(t1.DEPTH_TEST), t1.disable(t1.POLYGON_OFFSET_FILL), t1.disable(t1.SCISSOR_TEST), t1.disable(t1.STENCIL_TEST), t1.disable(t1.SAMPLE_ALPHA_TO_COVERAGE), t1.blendEquation(t1.FUNC_ADD), t1.blendFunc(t1.ONE, t1.ZERO), t1.blendFuncSeparate(t1.ONE, t1.ZERO, t1.ONE, t1.ZERO), t1.blendColor(0, 0, 0, 0), t1.colorMask(!0, !0, !0, !0), t1.clearColor(0, 0, 0, 0), t1.depthMask(!0), t1.depthFunc(t1.LESS), t1.clearDepth(1), t1.stencilMask(4294967295), t1.stencilFunc(t1.ALWAYS, 0, 4294967295), t1.stencilOp(t1.KEEP, t1.KEEP, t1.KEEP), t1.clearStencil(0), t1.cullFace(t1.BACK), t1.frontFace(t1.CCW), t1.polygonOffset(0, 0), t1.activeTexture(t1.TEXTURE0), t1.bindFramebuffer(t1.FRAMEBUFFER, null), !0 === n && (t1.bindFramebuffer(t1.DRAW_FRAMEBUFFER, null), t1.bindFramebuffer(t1.READ_FRAMEBUFFER, null)), t1.useProgram(null), t1.lineWidth(1), t1.scissor(0, 0, t1.canvas.width, t1.canvas.height), t1.viewport(0, 0, t1.canvas.width, t1.canvas.height), c = {}, O = null, P = {}, u = {}, h = new WeakMap, d = [], p = null, A = !1, f = null, m = null, g = null, M = null, v = null, y = null, x = null, w = new Yc(0, 0, 0), b = 0, T = !1, E = null, _ = null, I = null, S = null, N = null, k.set(0, 0, t1.canvas.width, t1.canvas.height), U.set(0, 0, t1.canvas.width, t1.canvas.height), r.reset(), a.reset(), s.reset();
                }
            };
        }
        function zp(t1, e, i, n, r, a, s) {
            const o = r.isWebGL2, l = r.maxTextures, c = r.maxCubemapSize, u = r.maxTextureSize, h = r.maxSamples, d = e.has("WEBGL_multisampled_render_to_texture") ? e.get("WEBGL_multisampled_render_to_texture") : null, p = "undefined" != typeof navigator && /OculusBrowser/g.test(navigator.userAgent), A = new WeakMap;
            let f;
            const m = new WeakMap;
            let g = !1;
            try {
                g = "undefined" != typeof OffscreenCanvas && null !== new OffscreenCanvas(1, 1).getContext("2d");
            } catch (t1) {}
            function M(t1, e) {
                return g ? new OffscreenCanvas(t1, e) : il("canvas");
            }
            function v(t1, e, i, n) {
                let r = 1;
                if ((t1.width > n || t1.height > n) && (r = n / Math.max(t1.width, t1.height)), r < 1 || !0 === e) {
                    if ("undefined" != typeof HTMLImageElement && t1 instanceof HTMLImageElement || "undefined" != typeof HTMLCanvasElement && t1 instanceof HTMLCanvasElement || "undefined" != typeof ImageBitmap && t1 instanceof ImageBitmap) {
                        const n = e ? Wo : Math.floor, a = n(r * t1.width), s = n(r * t1.height);
                        void 0 === f && (f = M(a, s));
                        const o = i ? M(a, s) : f;
                        return o.width = a, o.height = s, o.getContext("2d").drawImage(t1, 0, 0, a, s), console.warn("THREE.WebGLRenderer: Texture has been resized from (" + t1.width + "x" + t1.height + ") to (" + a + "x" + s + ")."), o;
                    }
                    return "data" in t1 && console.warn("THREE.WebGLRenderer: Image in DataTexture is too big (" + t1.width + "x" + t1.height + ")."), t1;
                }
                return t1;
            }
            function y(t1) {
                return Vo(t1.width) && Vo(t1.height);
            }
            function x(t1, e) {
                return t1.generateMipmaps && e && t1.minFilter !== ha && t1.minFilter !== ma;
            }
            function w(e) {
                t1.generateMipmap(e);
            }
            function b(i, n, r, a, s = !1) {
                if (!1 === o) return n;
                if (null !== i) {
                    if (void 0 !== t1[i]) return t1[i];
                    console.warn("THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format '" + i + "'");
                }
                let l = n;
                if (n === t1.RED && (r === t1.FLOAT && (l = t1.R32F), r === t1.HALF_FLOAT && (l = t1.R16F), r === t1.UNSIGNED_BYTE && (l = t1.R8)), n === t1.RED_INTEGER && (r === t1.UNSIGNED_BYTE && (l = t1.R8UI), r === t1.UNSIGNED_SHORT && (l = t1.R16UI), r === t1.UNSIGNED_INT && (l = t1.R32UI), r === t1.BYTE && (l = t1.R8I), r === t1.SHORT && (l = t1.R16I), r === t1.INT && (l = t1.R32I)), n === t1.RG && (r === t1.FLOAT && (l = t1.RG32F), r === t1.HALF_FLOAT && (l = t1.RG16F), r === t1.UNSIGNED_BYTE && (l = t1.RG8)), n === t1.RGBA) {
                    const e = s ? Ws : ul.getTransfer(a);
                    r === t1.FLOAT && (l = t1.RGBA32F), r === t1.HALF_FLOAT && (l = t1.RGBA16F), r === t1.UNSIGNED_BYTE && (l = e === Ys ? t1.SRGB8_ALPHA8 : t1.RGBA8), r === t1.UNSIGNED_SHORT_4_4_4_4 && (l = t1.RGBA4), r === t1.UNSIGNED_SHORT_5_5_5_1 && (l = t1.RGB5_A1);
                }
                return l !== t1.R16F && l !== t1.R32F && l !== t1.RG16F && l !== t1.RG32F && l !== t1.RGBA16F && l !== t1.RGBA32F || e.get("EXT_color_buffer_float"), l;
            }
            function T(t1, e, i) {
                return !0 === x(t1, i) || t1.isFramebufferTexture && t1.minFilter !== ha && t1.minFilter !== ma ? Math.log2(Math.max(e.width, e.height)) + 1 : void 0 !== t1.mipmaps && t1.mipmaps.length > 0 ? t1.mipmaps.length : t1.isCompressedTexture && Array.isArray(t1.image) ? e.mipmaps.length : 1;
            }
            function E(e) {
                return e === ha || e === da || e === Aa ? t1.NEAREST : t1.LINEAR;
            }
            function _(t1) {
                const e = t1.target;
                e.removeEventListener("dispose", _), function(t1) {
                    const e = n.get(t1);
                    if (void 0 === e.__webglInit) return;
                    const i = t1.source, r = m.get(i);
                    if (r) {
                        const n = r[e.__cacheKey];
                        n.usedTimes--, 0 === n.usedTimes && S(t1), 0 === Object.keys(r).length && m.delete(i);
                    }
                    n.remove(t1);
                }(e), e.isVideoTexture && A.delete(e);
            }
            function I(e) {
                const i = e.target;
                i.removeEventListener("dispose", I), function(e) {
                    const i = e.texture, r = n.get(e), a = n.get(i);
                    if (void 0 !== a.__webglTexture && (t1.deleteTexture(a.__webglTexture), s.memory.textures--), e.depthTexture && e.depthTexture.dispose(), e.isWebGLCubeRenderTarget) for(let e = 0; e < 6; e++){
                        if (Array.isArray(r.__webglFramebuffer[e])) for(let i = 0; i < r.__webglFramebuffer[e].length; i++)t1.deleteFramebuffer(r.__webglFramebuffer[e][i]);
                        else t1.deleteFramebuffer(r.__webglFramebuffer[e]);
                        r.__webglDepthbuffer && t1.deleteRenderbuffer(r.__webglDepthbuffer[e]);
                    }
                    else {
                        if (Array.isArray(r.__webglFramebuffer)) for(let e = 0; e < r.__webglFramebuffer.length; e++)t1.deleteFramebuffer(r.__webglFramebuffer[e]);
                        else t1.deleteFramebuffer(r.__webglFramebuffer);
                        if (r.__webglDepthbuffer && t1.deleteRenderbuffer(r.__webglDepthbuffer), r.__webglMultisampledFramebuffer && t1.deleteFramebuffer(r.__webglMultisampledFramebuffer), r.__webglColorRenderbuffer) for(let e = 0; e < r.__webglColorRenderbuffer.length; e++)r.__webglColorRenderbuffer[e] && t1.deleteRenderbuffer(r.__webglColorRenderbuffer[e]);
                        r.__webglDepthRenderbuffer && t1.deleteRenderbuffer(r.__webglDepthRenderbuffer);
                    }
                    if (e.isWebGLMultipleRenderTargets) for(let e = 0, r = i.length; e < r; e++){
                        const r = n.get(i[e]);
                        r.__webglTexture && (t1.deleteTexture(r.__webglTexture), s.memory.textures--), n.remove(i[e]);
                    }
                    n.remove(i), n.remove(e);
                }(i);
            }
            function S(e) {
                const i = n.get(e);
                t1.deleteTexture(i.__webglTexture);
                const r = e.source;
                delete m.get(r)[i.__cacheKey], s.memory.textures--;
            }
            let N = 0;
            function D(e, r) {
                const a = n.get(e);
                if (e.isVideoTexture && function(t1) {
                    const e = s.render.frame;
                    A.get(t1) !== e && (A.set(t1, e), t1.update());
                }(e), !1 === e.isRenderTargetTexture && e.version > 0 && a.__version !== e.version) {
                    const t1 = e.image;
                    if (null === t1) console.warn("THREE.WebGLRenderer: Texture marked for update but no image data found.");
                    else {
                        if (!1 !== t1.complete) return void j(a, e, r);
                        console.warn("THREE.WebGLRenderer: Texture marked for update but image is incomplete");
                    }
                }
                i.bindTexture(t1.TEXTURE_2D, a.__webglTexture, t1.TEXTURE0 + r);
            }
            const C = {
                [la]: t1.REPEAT,
                [ca]: t1.CLAMP_TO_EDGE,
                [ua]: t1.MIRRORED_REPEAT
            }, z = {
                [ha]: t1.NEAREST,
                [da]: t1.NEAREST_MIPMAP_NEAREST,
                [Aa]: t1.NEAREST_MIPMAP_LINEAR,
                [ma]: t1.LINEAR,
                [ga]: t1.LINEAR_MIPMAP_NEAREST,
                [va]: t1.LINEAR_MIPMAP_LINEAR
            }, L = {
                [po]: t1.NEVER,
                [yo]: t1.ALWAYS,
                [Ao]: t1.LESS,
                [mo]: t1.LEQUAL,
                [fo]: t1.EQUAL,
                [vo]: t1.GEQUAL,
                [go]: t1.GREATER,
                [Mo]: t1.NOTEQUAL
            };
            function O(i, a, s) {
                if (s ? (t1.texParameteri(i, t1.TEXTURE_WRAP_S, C[a.wrapS]), t1.texParameteri(i, t1.TEXTURE_WRAP_T, C[a.wrapT]), i !== t1.TEXTURE_3D && i !== t1.TEXTURE_2D_ARRAY || t1.texParameteri(i, t1.TEXTURE_WRAP_R, C[a.wrapR]), t1.texParameteri(i, t1.TEXTURE_MAG_FILTER, z[a.magFilter]), t1.texParameteri(i, t1.TEXTURE_MIN_FILTER, z[a.minFilter])) : (t1.texParameteri(i, t1.TEXTURE_WRAP_S, t1.CLAMP_TO_EDGE), t1.texParameteri(i, t1.TEXTURE_WRAP_T, t1.CLAMP_TO_EDGE), i !== t1.TEXTURE_3D && i !== t1.TEXTURE_2D_ARRAY || t1.texParameteri(i, t1.TEXTURE_WRAP_R, t1.CLAMP_TO_EDGE), a.wrapS === ca && a.wrapT === ca || console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.wrapS and Texture.wrapT should be set to THREE.ClampToEdgeWrapping."), t1.texParameteri(i, t1.TEXTURE_MAG_FILTER, E(a.magFilter)), t1.texParameteri(i, t1.TEXTURE_MIN_FILTER, E(a.minFilter)), a.minFilter !== ha && a.minFilter !== ma && console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.minFilter should be set to THREE.NearestFilter or THREE.LinearFilter.")), a.compareFunction && (t1.texParameteri(i, t1.TEXTURE_COMPARE_MODE, t1.COMPARE_REF_TO_TEXTURE), t1.texParameteri(i, t1.TEXTURE_COMPARE_FUNC, L[a.compareFunction])), !0 === e.has("EXT_texture_filter_anisotropic")) {
                    const s = e.get("EXT_texture_filter_anisotropic");
                    if (a.magFilter === ha) return;
                    if (a.minFilter !== Aa && a.minFilter !== va) return;
                    if (a.type === Ia && !1 === e.has("OES_texture_float_linear")) return;
                    if (!1 === o && a.type === Sa && !1 === e.has("OES_texture_half_float_linear")) return;
                    (a.anisotropy > 1 || n.get(a).__currentAnisotropy) && (t1.texParameterf(i, s.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(a.anisotropy, r.getMaxAnisotropy())), n.get(a).__currentAnisotropy = a.anisotropy);
                }
            }
            function P(e, i) {
                let n = !1;
                void 0 === e.__webglInit && (e.__webglInit = !0, i.addEventListener("dispose", _));
                const r = i.source;
                let a = m.get(r);
                void 0 === a && (a = {}, m.set(r, a));
                const o = function(t1) {
                    const e = [];
                    return e.push(t1.wrapS), e.push(t1.wrapT), e.push(t1.wrapR || 0), e.push(t1.magFilter), e.push(t1.minFilter), e.push(t1.anisotropy), e.push(t1.internalFormat), e.push(t1.format), e.push(t1.type), e.push(t1.generateMipmaps), e.push(t1.premultiplyAlpha), e.push(t1.flipY), e.push(t1.unpackAlignment), e.push(t1.colorSpace), e.join();
                }(i);
                if (o !== e.__cacheKey) {
                    void 0 === a[o] && (a[o] = {
                        texture: t1.createTexture(),
                        usedTimes: 0
                    }, s.memory.textures++, n = !0), a[o].usedTimes++;
                    const r = a[e.__cacheKey];
                    void 0 !== r && (a[e.__cacheKey].usedTimes--, 0 === r.usedTimes && S(i)), e.__cacheKey = o, e.__webglTexture = a[o].texture;
                }
                return n;
            }
            function j(e, r, s) {
                let l = t1.TEXTURE_2D;
                (r.isDataArrayTexture || r.isCompressedArrayTexture) && (l = t1.TEXTURE_2D_ARRAY), r.isData3DTexture && (l = t1.TEXTURE_3D);
                const c = P(e, r), h = r.source;
                i.bindTexture(l, e.__webglTexture, t1.TEXTURE0 + s);
                const d = n.get(h);
                if (h.version !== d.__version || !0 === c) {
                    i.activeTexture(t1.TEXTURE0 + s);
                    const e = ul.getPrimaries(ul.workingColorSpace), n = r.colorSpace === Fs ? null : ul.getPrimaries(r.colorSpace), p = r.colorSpace === Fs || e === n ? t1.NONE : t1.BROWSER_DEFAULT_WEBGL;
                    t1.pixelStorei(t1.UNPACK_FLIP_Y_WEBGL, r.flipY), t1.pixelStorei(t1.UNPACK_PREMULTIPLY_ALPHA_WEBGL, r.premultiplyAlpha), t1.pixelStorei(t1.UNPACK_ALIGNMENT, r.unpackAlignment), t1.pixelStorei(t1.UNPACK_COLORSPACE_CONVERSION_WEBGL, p);
                    const A = function(t1) {
                        return !o && (t1.wrapS !== ca || t1.wrapT !== ca || t1.minFilter !== ha && t1.minFilter !== ma);
                    }(r) && !1 === y(r.image);
                    let f = v(r.image, A, !1, u);
                    f = Q(r, f);
                    const m = y(f) || o, g = a.convert(r.format, r.colorSpace);
                    let M, E = a.convert(r.type), _ = b(r.internalFormat, g, E, r.colorSpace, r.isVideoTexture);
                    O(l, r, m);
                    const I = r.mipmaps, S = o && !0 !== r.isVideoTexture, N = void 0 === d.__version || !0 === c, D = T(r, f, m);
                    if (r.isDepthTexture) _ = t1.DEPTH_COMPONENT, o ? _ = r.type === Ia ? t1.DEPTH_COMPONENT32F : r.type === _a ? t1.DEPTH_COMPONENT24 : r.type === Ca ? t1.DEPTH24_STENCIL8 : t1.DEPTH_COMPONENT16 : r.type === Ia && console.error("WebGLRenderer: Floating point depth texture requires WebGL2."), r.format === ja && _ === t1.DEPTH_COMPONENT && r.type !== Ta && r.type !== _a && (console.warn("THREE.WebGLRenderer: Use UnsignedShortType or UnsignedIntType for DepthFormat DepthTexture."), r.type = _a, E = a.convert(r.type)), r.format === Ra && _ === t1.DEPTH_COMPONENT && (_ = t1.DEPTH_STENCIL, r.type !== Ca && (console.warn("THREE.WebGLRenderer: Use UnsignedInt248Type for DepthStencilFormat DepthTexture."), r.type = Ca, E = a.convert(r.type))), N && (S ? i.texStorage2D(t1.TEXTURE_2D, 1, _, f.width, f.height) : i.texImage2D(t1.TEXTURE_2D, 0, _, f.width, f.height, 0, g, E, null));
                    else if (r.isDataTexture) {
                        if (I.length > 0 && m) {
                            S && N && i.texStorage2D(t1.TEXTURE_2D, D, _, I[0].width, I[0].height);
                            for(let e = 0, n = I.length; e < n; e++)M = I[e], S ? i.texSubImage2D(t1.TEXTURE_2D, e, 0, 0, M.width, M.height, g, E, M.data) : i.texImage2D(t1.TEXTURE_2D, e, _, M.width, M.height, 0, g, E, M.data);
                            r.generateMipmaps = !1;
                        } else S ? (N && i.texStorage2D(t1.TEXTURE_2D, D, _, f.width, f.height), i.texSubImage2D(t1.TEXTURE_2D, 0, 0, 0, f.width, f.height, g, E, f.data)) : i.texImage2D(t1.TEXTURE_2D, 0, _, f.width, f.height, 0, g, E, f.data);
                    } else if (r.isCompressedTexture) {
                        if (r.isCompressedArrayTexture) {
                            S && N && i.texStorage3D(t1.TEXTURE_2D_ARRAY, D, _, I[0].width, I[0].height, f.depth);
                            for(let e = 0, n = I.length; e < n; e++)M = I[e], r.format !== La ? null !== g ? S ? i.compressedTexSubImage3D(t1.TEXTURE_2D_ARRAY, e, 0, 0, 0, M.width, M.height, f.depth, g, M.data, 0, 0) : i.compressedTexImage3D(t1.TEXTURE_2D_ARRAY, e, _, M.width, M.height, f.depth, 0, M.data, 0, 0) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()") : S ? i.texSubImage3D(t1.TEXTURE_2D_ARRAY, e, 0, 0, 0, M.width, M.height, f.depth, g, E, M.data) : i.texImage3D(t1.TEXTURE_2D_ARRAY, e, _, M.width, M.height, f.depth, 0, g, E, M.data);
                        } else {
                            S && N && i.texStorage2D(t1.TEXTURE_2D, D, _, I[0].width, I[0].height);
                            for(let e = 0, n = I.length; e < n; e++)M = I[e], r.format !== La ? null !== g ? S ? i.compressedTexSubImage2D(t1.TEXTURE_2D, e, 0, 0, M.width, M.height, g, M.data) : i.compressedTexImage2D(t1.TEXTURE_2D, e, _, M.width, M.height, 0, M.data) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()") : S ? i.texSubImage2D(t1.TEXTURE_2D, e, 0, 0, M.width, M.height, g, E, M.data) : i.texImage2D(t1.TEXTURE_2D, e, _, M.width, M.height, 0, g, E, M.data);
                        }
                    } else if (r.isDataArrayTexture) S ? (N && i.texStorage3D(t1.TEXTURE_2D_ARRAY, D, _, f.width, f.height, f.depth), i.texSubImage3D(t1.TEXTURE_2D_ARRAY, 0, 0, 0, 0, f.width, f.height, f.depth, g, E, f.data)) : i.texImage3D(t1.TEXTURE_2D_ARRAY, 0, _, f.width, f.height, f.depth, 0, g, E, f.data);
                    else if (r.isData3DTexture) S ? (N && i.texStorage3D(t1.TEXTURE_3D, D, _, f.width, f.height, f.depth), i.texSubImage3D(t1.TEXTURE_3D, 0, 0, 0, 0, f.width, f.height, f.depth, g, E, f.data)) : i.texImage3D(t1.TEXTURE_3D, 0, _, f.width, f.height, f.depth, 0, g, E, f.data);
                    else if (r.isFramebufferTexture) {
                        if (N) {
                            if (S) i.texStorage2D(t1.TEXTURE_2D, D, _, f.width, f.height);
                            else {
                                let e = f.width, n = f.height;
                                for(let r = 0; r < D; r++)i.texImage2D(t1.TEXTURE_2D, r, _, e, n, 0, g, E, null), e >>= 1, n >>= 1;
                            }
                        }
                    } else if (I.length > 0 && m) {
                        S && N && i.texStorage2D(t1.TEXTURE_2D, D, _, I[0].width, I[0].height);
                        for(let e = 0, n = I.length; e < n; e++)M = I[e], S ? i.texSubImage2D(t1.TEXTURE_2D, e, 0, 0, g, E, M) : i.texImage2D(t1.TEXTURE_2D, e, _, g, E, M);
                        r.generateMipmaps = !1;
                    } else S ? (N && i.texStorage2D(t1.TEXTURE_2D, D, _, f.width, f.height), i.texSubImage2D(t1.TEXTURE_2D, 0, 0, 0, g, E, f)) : i.texImage2D(t1.TEXTURE_2D, 0, _, g, E, f);
                    x(r, m) && w(l), d.__version = h.version, r.onUpdate && r.onUpdate(r);
                }
                e.__version = r.version;
            }
            function R(e, r, s, o, l, c) {
                const u = a.convert(s.format, s.colorSpace), h = a.convert(s.type), p = b(s.internalFormat, u, h, s.colorSpace);
                if (!n.get(r).__hasExternalTextures) {
                    const e = Math.max(1, r.width >> c), n = Math.max(1, r.height >> c);
                    l === t1.TEXTURE_3D || l === t1.TEXTURE_2D_ARRAY ? i.texImage3D(l, c, p, e, n, r.depth, 0, u, h, null) : i.texImage2D(l, c, p, e, n, 0, u, h, null);
                }
                i.bindFramebuffer(t1.FRAMEBUFFER, e), F(r) ? d.framebufferTexture2DMultisampleEXT(t1.FRAMEBUFFER, o, l, n.get(s).__webglTexture, 0, B(r)) : (l === t1.TEXTURE_2D || l >= t1.TEXTURE_CUBE_MAP_POSITIVE_X && l <= t1.TEXTURE_CUBE_MAP_NEGATIVE_Z) && t1.framebufferTexture2D(t1.FRAMEBUFFER, o, l, n.get(s).__webglTexture, c), i.bindFramebuffer(t1.FRAMEBUFFER, null);
            }
            function k(e, i, n) {
                if (t1.bindRenderbuffer(t1.RENDERBUFFER, e), i.depthBuffer && !i.stencilBuffer) {
                    let r = !0 === o ? t1.DEPTH_COMPONENT24 : t1.DEPTH_COMPONENT16;
                    if (n || F(i)) {
                        const e = i.depthTexture;
                        e && e.isDepthTexture && (e.type === Ia ? r = t1.DEPTH_COMPONENT32F : e.type === _a && (r = t1.DEPTH_COMPONENT24));
                        const n = B(i);
                        F(i) ? d.renderbufferStorageMultisampleEXT(t1.RENDERBUFFER, n, r, i.width, i.height) : t1.renderbufferStorageMultisample(t1.RENDERBUFFER, n, r, i.width, i.height);
                    } else t1.renderbufferStorage(t1.RENDERBUFFER, r, i.width, i.height);
                    t1.framebufferRenderbuffer(t1.FRAMEBUFFER, t1.DEPTH_ATTACHMENT, t1.RENDERBUFFER, e);
                } else if (i.depthBuffer && i.stencilBuffer) {
                    const r = B(i);
                    n && !1 === F(i) ? t1.renderbufferStorageMultisample(t1.RENDERBUFFER, r, t1.DEPTH24_STENCIL8, i.width, i.height) : F(i) ? d.renderbufferStorageMultisampleEXT(t1.RENDERBUFFER, r, t1.DEPTH24_STENCIL8, i.width, i.height) : t1.renderbufferStorage(t1.RENDERBUFFER, t1.DEPTH_STENCIL, i.width, i.height), t1.framebufferRenderbuffer(t1.FRAMEBUFFER, t1.DEPTH_STENCIL_ATTACHMENT, t1.RENDERBUFFER, e);
                } else {
                    const e = !0 === i.isWebGLMultipleRenderTargets ? i.texture : [
                        i.texture
                    ];
                    for(let r = 0; r < e.length; r++){
                        const s = e[r], o = a.convert(s.format, s.colorSpace), l = a.convert(s.type), c = b(s.internalFormat, o, l, s.colorSpace), u = B(i);
                        n && !1 === F(i) ? t1.renderbufferStorageMultisample(t1.RENDERBUFFER, u, c, i.width, i.height) : F(i) ? d.renderbufferStorageMultisampleEXT(t1.RENDERBUFFER, u, c, i.width, i.height) : t1.renderbufferStorage(t1.RENDERBUFFER, c, i.width, i.height);
                    }
                }
                t1.bindRenderbuffer(t1.RENDERBUFFER, null);
            }
            function U(e) {
                const r = n.get(e), a = !0 === e.isWebGLCubeRenderTarget;
                if (e.depthTexture && !r.__autoAllocateDepthBuffer) {
                    if (a) throw new Error("target.depthTexture not supported in Cube render targets");
                    !function(e, r) {
                        if (r && r.isWebGLCubeRenderTarget) throw new Error("Depth Texture with cube render targets is not supported");
                        if (i.bindFramebuffer(t1.FRAMEBUFFER, e), !r.depthTexture || !r.depthTexture.isDepthTexture) throw new Error("renderTarget.depthTexture must be an instance of THREE.DepthTexture");
                        n.get(r.depthTexture).__webglTexture && r.depthTexture.image.width === r.width && r.depthTexture.image.height === r.height || (r.depthTexture.image.width = r.width, r.depthTexture.image.height = r.height, r.depthTexture.needsUpdate = !0), D(r.depthTexture, 0);
                        const a = n.get(r.depthTexture).__webglTexture, s = B(r);
                        if (r.depthTexture.format === ja) F(r) ? d.framebufferTexture2DMultisampleEXT(t1.FRAMEBUFFER, t1.DEPTH_ATTACHMENT, t1.TEXTURE_2D, a, 0, s) : t1.framebufferTexture2D(t1.FRAMEBUFFER, t1.DEPTH_ATTACHMENT, t1.TEXTURE_2D, a, 0);
                        else {
                            if (r.depthTexture.format !== Ra) throw new Error("Unknown depthTexture format");
                            F(r) ? d.framebufferTexture2DMultisampleEXT(t1.FRAMEBUFFER, t1.DEPTH_STENCIL_ATTACHMENT, t1.TEXTURE_2D, a, 0, s) : t1.framebufferTexture2D(t1.FRAMEBUFFER, t1.DEPTH_STENCIL_ATTACHMENT, t1.TEXTURE_2D, a, 0);
                        }
                    }(r.__webglFramebuffer, e);
                } else if (a) {
                    r.__webglDepthbuffer = [];
                    for(let n = 0; n < 6; n++)i.bindFramebuffer(t1.FRAMEBUFFER, r.__webglFramebuffer[n]), r.__webglDepthbuffer[n] = t1.createRenderbuffer(), k(r.__webglDepthbuffer[n], e, !1);
                } else i.bindFramebuffer(t1.FRAMEBUFFER, r.__webglFramebuffer), r.__webglDepthbuffer = t1.createRenderbuffer(), k(r.__webglDepthbuffer, e, !1);
                i.bindFramebuffer(t1.FRAMEBUFFER, null);
            }
            function B(t1) {
                return Math.min(h, t1.samples);
            }
            function F(t1) {
                const i = n.get(t1);
                return o && t1.samples > 0 && !0 === e.has("WEBGL_multisampled_render_to_texture") && !1 !== i.__useRenderToTexture;
            }
            function Q(t1, i) {
                const n = t1.colorSpace, r = t1.format, a = t1.type;
                return !0 === t1.isCompressedTexture || !0 === t1.isVideoTexture || t1.format === zo || n !== Hs && n !== Fs && (ul.getTransfer(n) === Ys ? !1 === o ? !0 === e.has("EXT_sRGB") && r === La ? (t1.format = zo, t1.minFilter = ma, t1.generateMipmaps = !1) : i = Al.sRGBToLinear(i) : r === La && a === xa || console.warn("THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.") : console.error("THREE.WebGLTextures: Unsupported texture color space:", n)), i;
            }
            this.allocateTextureUnit = function() {
                const t1 = N;
                return t1 >= l && console.warn("THREE.WebGLTextures: Trying to use " + t1 + " texture units while this GPU supports only " + l), N += 1, t1;
            }, this.resetTextureUnits = function() {
                N = 0;
            }, this.setTexture2D = D, this.setTexture2DArray = function(e, r) {
                const a = n.get(e);
                e.version > 0 && a.__version !== e.version ? j(a, e, r) : i.bindTexture(t1.TEXTURE_2D_ARRAY, a.__webglTexture, t1.TEXTURE0 + r);
            }, this.setTexture3D = function(e, r) {
                const a = n.get(e);
                e.version > 0 && a.__version !== e.version ? j(a, e, r) : i.bindTexture(t1.TEXTURE_3D, a.__webglTexture, t1.TEXTURE0 + r);
            }, this.setTextureCube = function(e, r) {
                const s = n.get(e);
                e.version > 0 && s.__version !== e.version ? function(e, r, s) {
                    if (6 !== r.image.length) return;
                    const l = P(e, r), u = r.source;
                    i.bindTexture(t1.TEXTURE_CUBE_MAP, e.__webglTexture, t1.TEXTURE0 + s);
                    const h = n.get(u);
                    if (u.version !== h.__version || !0 === l) {
                        i.activeTexture(t1.TEXTURE0 + s);
                        const e = ul.getPrimaries(ul.workingColorSpace), n = r.colorSpace === Fs ? null : ul.getPrimaries(r.colorSpace), d = r.colorSpace === Fs || e === n ? t1.NONE : t1.BROWSER_DEFAULT_WEBGL;
                        t1.pixelStorei(t1.UNPACK_FLIP_Y_WEBGL, r.flipY), t1.pixelStorei(t1.UNPACK_PREMULTIPLY_ALPHA_WEBGL, r.premultiplyAlpha), t1.pixelStorei(t1.UNPACK_ALIGNMENT, r.unpackAlignment), t1.pixelStorei(t1.UNPACK_COLORSPACE_CONVERSION_WEBGL, d);
                        const p = r.isCompressedTexture || r.image[0].isCompressedTexture, A = r.image[0] && r.image[0].isDataTexture, f = [];
                        for(let t1 = 0; t1 < 6; t1++)f[t1] = p || A ? A ? r.image[t1].image : r.image[t1] : v(r.image[t1], !1, !0, c), f[t1] = Q(r, f[t1]);
                        const m = f[0], g = y(m) || o, M = a.convert(r.format, r.colorSpace), E = a.convert(r.type), _ = b(r.internalFormat, M, E, r.colorSpace), I = o && !0 !== r.isVideoTexture, S = void 0 === h.__version || !0 === l;
                        let N, D = T(r, m, g);
                        if (O(t1.TEXTURE_CUBE_MAP, r, g), p) {
                            I && S && i.texStorage2D(t1.TEXTURE_CUBE_MAP, D, _, m.width, m.height);
                            for(let e = 0; e < 6; e++){
                                N = f[e].mipmaps;
                                for(let n = 0; n < N.length; n++){
                                    const a = N[n];
                                    r.format !== La ? null !== M ? I ? i.compressedTexSubImage2D(t1.TEXTURE_CUBE_MAP_POSITIVE_X + e, n, 0, 0, a.width, a.height, M, a.data) : i.compressedTexImage2D(t1.TEXTURE_CUBE_MAP_POSITIVE_X + e, n, _, a.width, a.height, 0, a.data) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()") : I ? i.texSubImage2D(t1.TEXTURE_CUBE_MAP_POSITIVE_X + e, n, 0, 0, a.width, a.height, M, E, a.data) : i.texImage2D(t1.TEXTURE_CUBE_MAP_POSITIVE_X + e, n, _, a.width, a.height, 0, M, E, a.data);
                                }
                            }
                        } else {
                            N = r.mipmaps, I && S && (N.length > 0 && D++, i.texStorage2D(t1.TEXTURE_CUBE_MAP, D, _, f[0].width, f[0].height));
                            for(let e = 0; e < 6; e++)if (A) {
                                I ? i.texSubImage2D(t1.TEXTURE_CUBE_MAP_POSITIVE_X + e, 0, 0, 0, f[e].width, f[e].height, M, E, f[e].data) : i.texImage2D(t1.TEXTURE_CUBE_MAP_POSITIVE_X + e, 0, _, f[e].width, f[e].height, 0, M, E, f[e].data);
                                for(let n = 0; n < N.length; n++){
                                    const r = N[n].image[e].image;
                                    I ? i.texSubImage2D(t1.TEXTURE_CUBE_MAP_POSITIVE_X + e, n + 1, 0, 0, r.width, r.height, M, E, r.data) : i.texImage2D(t1.TEXTURE_CUBE_MAP_POSITIVE_X + e, n + 1, _, r.width, r.height, 0, M, E, r.data);
                                }
                            } else {
                                I ? i.texSubImage2D(t1.TEXTURE_CUBE_MAP_POSITIVE_X + e, 0, 0, 0, M, E, f[e]) : i.texImage2D(t1.TEXTURE_CUBE_MAP_POSITIVE_X + e, 0, _, M, E, f[e]);
                                for(let n = 0; n < N.length; n++){
                                    const r = N[n];
                                    I ? i.texSubImage2D(t1.TEXTURE_CUBE_MAP_POSITIVE_X + e, n + 1, 0, 0, M, E, r.image[e]) : i.texImage2D(t1.TEXTURE_CUBE_MAP_POSITIVE_X + e, n + 1, _, M, E, r.image[e]);
                                }
                            }
                        }
                        x(r, g) && w(t1.TEXTURE_CUBE_MAP), h.__version = u.version, r.onUpdate && r.onUpdate(r);
                    }
                    e.__version = r.version;
                }(s, e, r) : i.bindTexture(t1.TEXTURE_CUBE_MAP, s.__webglTexture, t1.TEXTURE0 + r);
            }, this.rebindTextures = function(e, i, r) {
                const a = n.get(e);
                void 0 !== i && R(a.__webglFramebuffer, e, e.texture, t1.COLOR_ATTACHMENT0, t1.TEXTURE_2D, 0), void 0 !== r && U(e);
            }, this.setupRenderTarget = function(e) {
                const l = e.texture, c = n.get(e), u = n.get(l);
                e.addEventListener("dispose", I), !0 !== e.isWebGLMultipleRenderTargets && (void 0 === u.__webglTexture && (u.__webglTexture = t1.createTexture()), u.__version = l.version, s.memory.textures++);
                const h = !0 === e.isWebGLCubeRenderTarget, d = !0 === e.isWebGLMultipleRenderTargets, p = y(e) || o;
                if (h) {
                    c.__webglFramebuffer = [];
                    for(let e = 0; e < 6; e++)if (o && l.mipmaps && l.mipmaps.length > 0) {
                        c.__webglFramebuffer[e] = [];
                        for(let i = 0; i < l.mipmaps.length; i++)c.__webglFramebuffer[e][i] = t1.createFramebuffer();
                    } else c.__webglFramebuffer[e] = t1.createFramebuffer();
                } else {
                    if (o && l.mipmaps && l.mipmaps.length > 0) {
                        c.__webglFramebuffer = [];
                        for(let e = 0; e < l.mipmaps.length; e++)c.__webglFramebuffer[e] = t1.createFramebuffer();
                    } else c.__webglFramebuffer = t1.createFramebuffer();
                    if (d) {
                        if (r.drawBuffers) {
                            const i = e.texture;
                            for(let e = 0, r = i.length; e < r; e++){
                                const r = n.get(i[e]);
                                void 0 === r.__webglTexture && (r.__webglTexture = t1.createTexture(), s.memory.textures++);
                            }
                        } else console.warn("THREE.WebGLRenderer: WebGLMultipleRenderTargets can only be used with WebGL2 or WEBGL_draw_buffers extension.");
                    }
                    if (o && e.samples > 0 && !1 === F(e)) {
                        const n = d ? l : [
                            l
                        ];
                        c.__webglMultisampledFramebuffer = t1.createFramebuffer(), c.__webglColorRenderbuffer = [], i.bindFramebuffer(t1.FRAMEBUFFER, c.__webglMultisampledFramebuffer);
                        for(let i = 0; i < n.length; i++){
                            const r = n[i];
                            c.__webglColorRenderbuffer[i] = t1.createRenderbuffer(), t1.bindRenderbuffer(t1.RENDERBUFFER, c.__webglColorRenderbuffer[i]);
                            const s = a.convert(r.format, r.colorSpace), o = a.convert(r.type), l = b(r.internalFormat, s, o, r.colorSpace, !0 === e.isXRRenderTarget), u = B(e);
                            t1.renderbufferStorageMultisample(t1.RENDERBUFFER, u, l, e.width, e.height), t1.framebufferRenderbuffer(t1.FRAMEBUFFER, t1.COLOR_ATTACHMENT0 + i, t1.RENDERBUFFER, c.__webglColorRenderbuffer[i]);
                        }
                        t1.bindRenderbuffer(t1.RENDERBUFFER, null), e.depthBuffer && (c.__webglDepthRenderbuffer = t1.createRenderbuffer(), k(c.__webglDepthRenderbuffer, e, !0)), i.bindFramebuffer(t1.FRAMEBUFFER, null);
                    }
                }
                if (h) {
                    i.bindTexture(t1.TEXTURE_CUBE_MAP, u.__webglTexture), O(t1.TEXTURE_CUBE_MAP, l, p);
                    for(let i = 0; i < 6; i++)if (o && l.mipmaps && l.mipmaps.length > 0) for(let n = 0; n < l.mipmaps.length; n++)R(c.__webglFramebuffer[i][n], e, l, t1.COLOR_ATTACHMENT0, t1.TEXTURE_CUBE_MAP_POSITIVE_X + i, n);
                    else R(c.__webglFramebuffer[i], e, l, t1.COLOR_ATTACHMENT0, t1.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0);
                    x(l, p) && w(t1.TEXTURE_CUBE_MAP), i.unbindTexture();
                } else if (d) {
                    const r = e.texture;
                    for(let a = 0, s = r.length; a < s; a++){
                        const s = r[a], o = n.get(s);
                        i.bindTexture(t1.TEXTURE_2D, o.__webglTexture), O(t1.TEXTURE_2D, s, p), R(c.__webglFramebuffer, e, s, t1.COLOR_ATTACHMENT0 + a, t1.TEXTURE_2D, 0), x(s, p) && w(t1.TEXTURE_2D);
                    }
                    i.unbindTexture();
                } else {
                    let n = t1.TEXTURE_2D;
                    if ((e.isWebGL3DRenderTarget || e.isWebGLArrayRenderTarget) && (o ? n = e.isWebGL3DRenderTarget ? t1.TEXTURE_3D : t1.TEXTURE_2D_ARRAY : console.error("THREE.WebGLTextures: THREE.Data3DTexture and THREE.DataArrayTexture only supported with WebGL2.")), i.bindTexture(n, u.__webglTexture), O(n, l, p), o && l.mipmaps && l.mipmaps.length > 0) for(let i = 0; i < l.mipmaps.length; i++)R(c.__webglFramebuffer[i], e, l, t1.COLOR_ATTACHMENT0, n, i);
                    else R(c.__webglFramebuffer, e, l, t1.COLOR_ATTACHMENT0, n, 0);
                    x(l, p) && w(n), i.unbindTexture();
                }
                e.depthBuffer && U(e);
            }, this.updateRenderTargetMipmap = function(e) {
                const r = y(e) || o, a = !0 === e.isWebGLMultipleRenderTargets ? e.texture : [
                    e.texture
                ];
                for(let s = 0, o = a.length; s < o; s++){
                    const o = a[s];
                    if (x(o, r)) {
                        const r = e.isWebGLCubeRenderTarget ? t1.TEXTURE_CUBE_MAP : t1.TEXTURE_2D, a = n.get(o).__webglTexture;
                        i.bindTexture(r, a), w(r), i.unbindTexture();
                    }
                }
            }, this.updateMultisampleRenderTarget = function(e) {
                if (o && e.samples > 0 && !1 === F(e)) {
                    const r = e.isWebGLMultipleRenderTargets ? e.texture : [
                        e.texture
                    ], a = e.width, s = e.height;
                    let o = t1.COLOR_BUFFER_BIT;
                    const l = [], c = e.stencilBuffer ? t1.DEPTH_STENCIL_ATTACHMENT : t1.DEPTH_ATTACHMENT, u = n.get(e), h = !0 === e.isWebGLMultipleRenderTargets;
                    if (h) for(let e = 0; e < r.length; e++)i.bindFramebuffer(t1.FRAMEBUFFER, u.__webglMultisampledFramebuffer), t1.framebufferRenderbuffer(t1.FRAMEBUFFER, t1.COLOR_ATTACHMENT0 + e, t1.RENDERBUFFER, null), i.bindFramebuffer(t1.FRAMEBUFFER, u.__webglFramebuffer), t1.framebufferTexture2D(t1.DRAW_FRAMEBUFFER, t1.COLOR_ATTACHMENT0 + e, t1.TEXTURE_2D, null, 0);
                    i.bindFramebuffer(t1.READ_FRAMEBUFFER, u.__webglMultisampledFramebuffer), i.bindFramebuffer(t1.DRAW_FRAMEBUFFER, u.__webglFramebuffer);
                    for(let i = 0; i < r.length; i++){
                        l.push(t1.COLOR_ATTACHMENT0 + i), e.depthBuffer && l.push(c);
                        const d = void 0 !== u.__ignoreDepthValues && u.__ignoreDepthValues;
                        if (!1 === d && (e.depthBuffer && (o |= t1.DEPTH_BUFFER_BIT), e.stencilBuffer && (o |= t1.STENCIL_BUFFER_BIT)), h && t1.framebufferRenderbuffer(t1.READ_FRAMEBUFFER, t1.COLOR_ATTACHMENT0, t1.RENDERBUFFER, u.__webglColorRenderbuffer[i]), !0 === d && (t1.invalidateFramebuffer(t1.READ_FRAMEBUFFER, [
                            c
                        ]), t1.invalidateFramebuffer(t1.DRAW_FRAMEBUFFER, [
                            c
                        ])), h) {
                            const e = n.get(r[i]).__webglTexture;
                            t1.framebufferTexture2D(t1.DRAW_FRAMEBUFFER, t1.COLOR_ATTACHMENT0, t1.TEXTURE_2D, e, 0);
                        }
                        t1.blitFramebuffer(0, 0, a, s, 0, 0, a, s, o, t1.NEAREST), p && t1.invalidateFramebuffer(t1.READ_FRAMEBUFFER, l);
                    }
                    if (i.bindFramebuffer(t1.READ_FRAMEBUFFER, null), i.bindFramebuffer(t1.DRAW_FRAMEBUFFER, null), h) for(let e = 0; e < r.length; e++){
                        i.bindFramebuffer(t1.FRAMEBUFFER, u.__webglMultisampledFramebuffer), t1.framebufferRenderbuffer(t1.FRAMEBUFFER, t1.COLOR_ATTACHMENT0 + e, t1.RENDERBUFFER, u.__webglColorRenderbuffer[e]);
                        const a = n.get(r[e]).__webglTexture;
                        i.bindFramebuffer(t1.FRAMEBUFFER, u.__webglFramebuffer), t1.framebufferTexture2D(t1.DRAW_FRAMEBUFFER, t1.COLOR_ATTACHMENT0 + e, t1.TEXTURE_2D, a, 0);
                    }
                    i.bindFramebuffer(t1.DRAW_FRAMEBUFFER, u.__webglMultisampledFramebuffer);
                }
            }, this.setupDepthRenderbuffer = U, this.setupFrameBufferTexture = R, this.useMultisampledRTT = F;
        }
        function Lp(t1, e, i) {
            const n = i.isWebGL2;
            return {
                convert: function(i, r = Fs) {
                    let a;
                    const s = ul.getTransfer(r);
                    if (i === xa) return t1.UNSIGNED_BYTE;
                    if (i === Na) return t1.UNSIGNED_SHORT_4_4_4_4;
                    if (i === Da) return t1.UNSIGNED_SHORT_5_5_5_1;
                    if (i === wa) return t1.BYTE;
                    if (i === ba) return t1.SHORT;
                    if (i === Ta) return t1.UNSIGNED_SHORT;
                    if (i === Ea) return t1.INT;
                    if (i === _a) return t1.UNSIGNED_INT;
                    if (i === Ia) return t1.FLOAT;
                    if (i === Sa) return n ? t1.HALF_FLOAT : (a = e.get("OES_texture_half_float"), null !== a ? a.HALF_FLOAT_OES : null);
                    if (i === za) return t1.ALPHA;
                    if (i === La) return t1.RGBA;
                    if (i === Oa) return t1.LUMINANCE;
                    if (i === Pa) return t1.LUMINANCE_ALPHA;
                    if (i === ja) return t1.DEPTH_COMPONENT;
                    if (i === Ra) return t1.DEPTH_STENCIL;
                    if (i === zo) return a = e.get("EXT_sRGB"), null !== a ? a.SRGB_ALPHA_EXT : null;
                    if (i === ka) return t1.RED;
                    if (i === Ua) return t1.RED_INTEGER;
                    if (i === Ba) return t1.RG;
                    if (i === Fa) return t1.RG_INTEGER;
                    if (i === Qa) return t1.RGBA_INTEGER;
                    if (i === Ha || i === Va || i === Ga || i === Wa) {
                        if (s === Ys) {
                            if (a = e.get("WEBGL_compressed_texture_s3tc_srgb"), null === a) return null;
                            if (i === Ha) return a.COMPRESSED_SRGB_S3TC_DXT1_EXT;
                            if (i === Va) return a.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
                            if (i === Ga) return a.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
                            if (i === Wa) return a.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
                        } else {
                            if (a = e.get("WEBGL_compressed_texture_s3tc"), null === a) return null;
                            if (i === Ha) return a.COMPRESSED_RGB_S3TC_DXT1_EXT;
                            if (i === Va) return a.COMPRESSED_RGBA_S3TC_DXT1_EXT;
                            if (i === Ga) return a.COMPRESSED_RGBA_S3TC_DXT3_EXT;
                            if (i === Wa) return a.COMPRESSED_RGBA_S3TC_DXT5_EXT;
                        }
                    }
                    if (i === Ya || i === Xa || i === Za || i === qa) {
                        if (a = e.get("WEBGL_compressed_texture_pvrtc"), null === a) return null;
                        if (i === Ya) return a.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
                        if (i === Xa) return a.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
                        if (i === Za) return a.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
                        if (i === qa) return a.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
                    }
                    if (i === Ja) return a = e.get("WEBGL_compressed_texture_etc1"), null !== a ? a.COMPRESSED_RGB_ETC1_WEBGL : null;
                    if (i === Ka || i === $a) {
                        if (a = e.get("WEBGL_compressed_texture_etc"), null === a) return null;
                        if (i === Ka) return s === Ys ? a.COMPRESSED_SRGB8_ETC2 : a.COMPRESSED_RGB8_ETC2;
                        if (i === $a) return s === Ys ? a.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : a.COMPRESSED_RGBA8_ETC2_EAC;
                    }
                    if (i === ts || i === es || i === is || i === ns || i === rs || i === as || i === ss || i === os || i === ls || i === cs || i === us || i === hs || i === ds || i === ps) {
                        if (a = e.get("WEBGL_compressed_texture_astc"), null === a) return null;
                        if (i === ts) return s === Ys ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : a.COMPRESSED_RGBA_ASTC_4x4_KHR;
                        if (i === es) return s === Ys ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : a.COMPRESSED_RGBA_ASTC_5x4_KHR;
                        if (i === is) return s === Ys ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : a.COMPRESSED_RGBA_ASTC_5x5_KHR;
                        if (i === ns) return s === Ys ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : a.COMPRESSED_RGBA_ASTC_6x5_KHR;
                        if (i === rs) return s === Ys ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : a.COMPRESSED_RGBA_ASTC_6x6_KHR;
                        if (i === as) return s === Ys ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : a.COMPRESSED_RGBA_ASTC_8x5_KHR;
                        if (i === ss) return s === Ys ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : a.COMPRESSED_RGBA_ASTC_8x6_KHR;
                        if (i === os) return s === Ys ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : a.COMPRESSED_RGBA_ASTC_8x8_KHR;
                        if (i === ls) return s === Ys ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : a.COMPRESSED_RGBA_ASTC_10x5_KHR;
                        if (i === cs) return s === Ys ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : a.COMPRESSED_RGBA_ASTC_10x6_KHR;
                        if (i === us) return s === Ys ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : a.COMPRESSED_RGBA_ASTC_10x8_KHR;
                        if (i === hs) return s === Ys ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : a.COMPRESSED_RGBA_ASTC_10x10_KHR;
                        if (i === ds) return s === Ys ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : a.COMPRESSED_RGBA_ASTC_12x10_KHR;
                        if (i === ps) return s === Ys ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : a.COMPRESSED_RGBA_ASTC_12x12_KHR;
                    }
                    if (i === As || i === fs || i === ms) {
                        if (a = e.get("EXT_texture_compression_bptc"), null === a) return null;
                        if (i === As) return s === Ys ? a.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : a.COMPRESSED_RGBA_BPTC_UNORM_EXT;
                        if (i === fs) return a.COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT;
                        if (i === ms) return a.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT;
                    }
                    if (i === gs || i === Ms || i === vs || i === ys) {
                        if (a = e.get("EXT_texture_compression_rgtc"), null === a) return null;
                        if (i === As) return a.COMPRESSED_RED_RGTC1_EXT;
                        if (i === Ms) return a.COMPRESSED_SIGNED_RED_RGTC1_EXT;
                        if (i === vs) return a.COMPRESSED_RED_GREEN_RGTC2_EXT;
                        if (i === ys) return a.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
                    }
                    return i === Ca ? n ? t1.UNSIGNED_INT_24_8 : (a = e.get("WEBGL_depth_texture"), null !== a ? a.UNSIGNED_INT_24_8_WEBGL : null) : void 0 !== t1[i] ? t1[i] : null;
                }
            };
        }
        class Op extends qu {
            constructor(t1 = []){
                super(), this.isArrayCamera = !0, this.cameras = t1;
            }
        }
        class Pp extends Dc {
            constructor(){
                super(), this.isGroup = !0, this.type = "Group";
            }
        }
        const jp = {
            type: "move"
        };
        class Rp {
            constructor(){
                this._targetRay = null, this._grip = null, this._hand = null;
            }
            getHandSpace() {
                return null === this._hand && (this._hand = new Pp, this._hand.matrixAutoUpdate = !1, this._hand.visible = !1, this._hand.joints = {}, this._hand.inputState = {
                    pinching: !1
                }), this._hand;
            }
            getTargetRaySpace() {
                return null === this._targetRay && (this._targetRay = new Pp, this._targetRay.matrixAutoUpdate = !1, this._targetRay.visible = !1, this._targetRay.hasLinearVelocity = !1, this._targetRay.linearVelocity = new Nl, this._targetRay.hasAngularVelocity = !1, this._targetRay.angularVelocity = new Nl), this._targetRay;
            }
            getGripSpace() {
                return null === this._grip && (this._grip = new Pp, this._grip.matrixAutoUpdate = !1, this._grip.visible = !1, this._grip.hasLinearVelocity = !1, this._grip.linearVelocity = new Nl, this._grip.hasAngularVelocity = !1, this._grip.angularVelocity = new Nl), this._grip;
            }
            dispatchEvent(t1) {
                return null !== this._targetRay && this._targetRay.dispatchEvent(t1), null !== this._grip && this._grip.dispatchEvent(t1), null !== this._hand && this._hand.dispatchEvent(t1), this;
            }
            connect(t1) {
                if (t1 && t1.hand) {
                    const e = this._hand;
                    if (e) for (const i of t1.hand.values())this._getHandJoint(e, i);
                }
                return this.dispatchEvent({
                    type: "connected",
                    data: t1
                }), this;
            }
            disconnect(t1) {
                return this.dispatchEvent({
                    type: "disconnected",
                    data: t1
                }), null !== this._targetRay && (this._targetRay.visible = !1), null !== this._grip && (this._grip.visible = !1), null !== this._hand && (this._hand.visible = !1), this;
            }
            update(t1, e, i) {
                let n = null, r = null, a = null;
                const s = this._targetRay, o = this._grip, l = this._hand;
                if (t1 && "visible-blurred" !== e.session.visibilityState) {
                    if (l && t1.hand) {
                        a = !0;
                        for (const n of t1.hand.values()){
                            const t1 = e.getJointPose(n, i), r = this._getHandJoint(l, n);
                            null !== t1 && (r.matrix.fromArray(t1.transform.matrix), r.matrix.decompose(r.position, r.rotation, r.scale), r.matrixWorldNeedsUpdate = !0, r.jointRadius = t1.radius), r.visible = null !== t1;
                        }
                        const n = l.joints["index-finger-tip"], r = l.joints["thumb-tip"], s = n.position.distanceTo(r.position), o = .02, c = .005;
                        l.inputState.pinching && s > o + c ? (l.inputState.pinching = !1, this.dispatchEvent({
                            type: "pinchend",
                            handedness: t1.handedness,
                            target: this
                        })) : !l.inputState.pinching && s <= o - c && (l.inputState.pinching = !0, this.dispatchEvent({
                            type: "pinchstart",
                            handedness: t1.handedness,
                            target: this
                        }));
                    } else null !== o && t1.gripSpace && (r = e.getPose(t1.gripSpace, i), null !== r && (o.matrix.fromArray(r.transform.matrix), o.matrix.decompose(o.position, o.rotation, o.scale), o.matrixWorldNeedsUpdate = !0, r.linearVelocity ? (o.hasLinearVelocity = !0, o.linearVelocity.copy(r.linearVelocity)) : o.hasLinearVelocity = !1, r.angularVelocity ? (o.hasAngularVelocity = !0, o.angularVelocity.copy(r.angularVelocity)) : o.hasAngularVelocity = !1));
                    null !== s && (n = e.getPose(t1.targetRaySpace, i), null === n && null !== r && (n = r), null !== n && (s.matrix.fromArray(n.transform.matrix), s.matrix.decompose(s.position, s.rotation, s.scale), s.matrixWorldNeedsUpdate = !0, n.linearVelocity ? (s.hasLinearVelocity = !0, s.linearVelocity.copy(n.linearVelocity)) : s.hasLinearVelocity = !1, n.angularVelocity ? (s.hasAngularVelocity = !0, s.angularVelocity.copy(n.angularVelocity)) : s.hasAngularVelocity = !1, this.dispatchEvent(jp)));
                }
                return null !== s && (s.visible = null !== n), null !== o && (o.visible = null !== r), null !== l && (l.visible = null !== a), this;
            }
            _getHandJoint(t1, e) {
                if (void 0 === t1.joints[e.jointName]) {
                    const i = new Pp;
                    i.matrixAutoUpdate = !1, i.visible = !1, t1.joints[e.jointName] = i, t1.add(i);
                }
                return t1.joints[e.jointName];
            }
        }
        class kp extends vl {
            constructor(t1, e, i, n, r, a, s, o, l, c){
                if ((c = void 0 !== c ? c : ja) !== ja && c !== Ra) throw new Error("DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat");
                void 0 === i && c === ja && (i = _a), void 0 === i && c === Ra && (i = Ca), super(null, n, r, a, s, o, c, i, l), this.isDepthTexture = !0, this.image = {
                    width: t1,
                    height: e
                }, this.magFilter = void 0 !== s ? s : ha, this.minFilter = void 0 !== o ? o : ha, this.flipY = !1, this.generateMipmaps = !1, this.compareFunction = null;
            }
            copy(t1) {
                return super.copy(t1), this.compareFunction = t1.compareFunction, this;
            }
            toJSON(t1) {
                const e = super.toJSON(t1);
                return null !== this.compareFunction && (e.compareFunction = this.compareFunction), e;
            }
        }
        class Up extends Po {
            constructor(t1, e){
                super();
                const i = this;
                let n = null, r = 1, a = null, s = "local-floor", o = 1, l = null, c = null, u = null, h = null, d = null, p = null;
                const A = e.getContextAttributes();
                let f = null, m = null;
                const g = [], M = [], v = new qu;
                v.layers.enable(1), v.viewport = new yl;
                const y = new qu;
                y.layers.enable(2), y.viewport = new yl;
                const x = [
                    v,
                    y
                ], w = new Op;
                w.layers.enable(1), w.layers.enable(2);
                let b = null, T = null;
                function E(t1) {
                    const e = M.indexOf(t1.inputSource);
                    if (-1 === e) return;
                    const i = g[e];
                    void 0 !== i && (i.update(t1.inputSource, t1.frame, l || a), i.dispatchEvent({
                        type: t1.type,
                        data: t1.inputSource
                    }));
                }
                function _() {
                    n.removeEventListener("select", E), n.removeEventListener("selectstart", E), n.removeEventListener("selectend", E), n.removeEventListener("squeeze", E), n.removeEventListener("squeezestart", E), n.removeEventListener("squeezeend", E), n.removeEventListener("end", _), n.removeEventListener("inputsourceschange", I);
                    for(let t1 = 0; t1 < g.length; t1++){
                        const e = M[t1];
                        null !== e && (M[t1] = null, g[t1].disconnect(e));
                    }
                    b = null, T = null, t1.setRenderTarget(f), d = null, h = null, u = null, n = null, m = null, z.stop(), i.isPresenting = !1, i.dispatchEvent({
                        type: "sessionend"
                    });
                }
                function I(t1) {
                    for(let e = 0; e < t1.removed.length; e++){
                        const i = t1.removed[e], n = M.indexOf(i);
                        n >= 0 && (M[n] = null, g[n].disconnect(i));
                    }
                    for(let e = 0; e < t1.added.length; e++){
                        const i = t1.added[e];
                        let n = M.indexOf(i);
                        if (-1 === n) {
                            for(let t1 = 0; t1 < g.length; t1++){
                                if (t1 >= M.length) {
                                    M.push(i), n = t1;
                                    break;
                                }
                                if (null === M[t1]) {
                                    M[t1] = i, n = t1;
                                    break;
                                }
                            }
                            if (-1 === n) break;
                        }
                        const r = g[n];
                        r && r.connect(i);
                    }
                }
                this.cameraAutoUpdate = !0, this.enabled = !1, this.isPresenting = !1, this.getController = function(t1) {
                    let e = g[t1];
                    return void 0 === e && (e = new Rp, g[t1] = e), e.getTargetRaySpace();
                }, this.getControllerGrip = function(t1) {
                    let e = g[t1];
                    return void 0 === e && (e = new Rp, g[t1] = e), e.getGripSpace();
                }, this.getHand = function(t1) {
                    let e = g[t1];
                    return void 0 === e && (e = new Rp, g[t1] = e), e.getHandSpace();
                }, this.setFramebufferScaleFactor = function(t1) {
                    r = t1, !0 === i.isPresenting && console.warn("THREE.WebXRManager: Cannot change framebuffer scale while presenting.");
                }, this.setReferenceSpaceType = function(t1) {
                    s = t1, !0 === i.isPresenting && console.warn("THREE.WebXRManager: Cannot change reference space type while presenting.");
                }, this.getReferenceSpace = function() {
                    return l || a;
                }, this.setReferenceSpace = function(t1) {
                    l = t1;
                }, this.getBaseLayer = function() {
                    return null !== h ? h : d;
                }, this.getBinding = function() {
                    return u;
                }, this.getFrame = function() {
                    return p;
                }, this.getSession = function() {
                    return n;
                }, this.setSession = async function(c) {
                    if (n = c, null !== n) {
                        if (f = t1.getRenderTarget(), n.addEventListener("select", E), n.addEventListener("selectstart", E), n.addEventListener("selectend", E), n.addEventListener("squeeze", E), n.addEventListener("squeezestart", E), n.addEventListener("squeezeend", E), n.addEventListener("end", _), n.addEventListener("inputsourceschange", I), !0 !== A.xrCompatible && await e.makeXRCompatible(), void 0 === n.renderState.layers || !1 === t1.capabilities.isWebGL2) {
                            const i = {
                                antialias: void 0 !== n.renderState.layers || A.antialias,
                                alpha: !0,
                                depth: A.depth,
                                stencil: A.stencil,
                                framebufferScaleFactor: r
                            };
                            d = new XRWebGLLayer(n, e, i), n.updateRenderState({
                                baseLayer: d
                            }), m = new wl(d.framebufferWidth, d.framebufferHeight, {
                                format: La,
                                type: xa,
                                colorSpace: t1.outputColorSpace,
                                stencilBuffer: A.stencil
                            });
                        } else {
                            let i = null, a = null, s = null;
                            A.depth && (s = A.stencil ? e.DEPTH24_STENCIL8 : e.DEPTH_COMPONENT24, i = A.stencil ? Ra : ja, a = A.stencil ? Ca : _a);
                            const o = {
                                colorFormat: e.RGBA8,
                                depthFormat: s,
                                scaleFactor: r
                            };
                            u = new XRWebGLBinding(n, e), h = u.createProjectionLayer(o), n.updateRenderState({
                                layers: [
                                    h
                                ]
                            }), m = new wl(h.textureWidth, h.textureHeight, {
                                format: La,
                                type: xa,
                                depthTexture: new kp(h.textureWidth, h.textureHeight, a, void 0, void 0, void 0, void 0, void 0, void 0, i),
                                stencilBuffer: A.stencil,
                                colorSpace: t1.outputColorSpace,
                                samples: A.antialias ? 4 : 0
                            }), t1.properties.get(m).__ignoreDepthValues = h.ignoreDepthValues;
                        }
                        m.isXRRenderTarget = !0, this.setFoveation(o), l = null, a = await n.requestReferenceSpace(s), z.setContext(n), z.start(), i.isPresenting = !0, i.dispatchEvent({
                            type: "sessionstart"
                        });
                    }
                }, this.getEnvironmentBlendMode = function() {
                    if (null !== n) return n.environmentBlendMode;
                };
                const S = new Nl, N = new Nl;
                function D(t1, e) {
                    null === e ? t1.matrixWorld.copy(t1.matrix) : t1.matrixWorld.multiplyMatrices(e.matrixWorld, t1.matrix), t1.matrixWorldInverse.copy(t1.matrixWorld).invert();
                }
                this.updateCamera = function(t1) {
                    if (null === n) return;
                    w.near = y.near = v.near = t1.near, w.far = y.far = v.far = t1.far, b === w.near && T === w.far || (n.updateRenderState({
                        depthNear: w.near,
                        depthFar: w.far
                    }), b = w.near, T = w.far);
                    const e = t1.parent, i = w.cameras;
                    D(w, e);
                    for(let t1 = 0; t1 < i.length; t1++)D(i[t1], e);
                    2 === i.length ? function(t1, e, i) {
                        S.setFromMatrixPosition(e.matrixWorld), N.setFromMatrixPosition(i.matrixWorld);
                        const n = S.distanceTo(N), r = e.projectionMatrix.elements, a = i.projectionMatrix.elements, s = r[14] / (r[10] - 1), o = r[14] / (r[10] + 1), l = (r[9] + 1) / r[5], c = (r[9] - 1) / r[5], u = (r[8] - 1) / r[0], h = (a[8] + 1) / a[0], d = s * u, p = s * h, A = n / (-u + h), f = A * -u;
                        e.matrixWorld.decompose(t1.position, t1.quaternion, t1.scale), t1.translateX(f), t1.translateZ(A), t1.matrixWorld.compose(t1.position, t1.quaternion, t1.scale), t1.matrixWorldInverse.copy(t1.matrixWorld).invert();
                        const m = s + A, g = o + A, M = d - f, v = p + (n - f), y = l * o / g * m, x = c * o / g * m;
                        t1.projectionMatrix.makePerspective(M, v, y, x, m, g), t1.projectionMatrixInverse.copy(t1.projectionMatrix).invert();
                    }(w, v, y) : w.projectionMatrix.copy(v.projectionMatrix), function(t1, e, i) {
                        null === i ? t1.matrix.copy(e.matrixWorld) : (t1.matrix.copy(i.matrixWorld), t1.matrix.invert(), t1.matrix.multiply(e.matrixWorld)), t1.matrix.decompose(t1.position, t1.quaternion, t1.scale), t1.updateMatrixWorld(!0), t1.projectionMatrix.copy(e.projectionMatrix), t1.projectionMatrixInverse.copy(e.projectionMatrixInverse), t1.isPerspectiveCamera && (t1.fov = 2 * Uo * Math.atan(1 / t1.projectionMatrix.elements[5]), t1.zoom = 1);
                    }(t1, w, e);
                }, this.getCamera = function() {
                    return w;
                }, this.getFoveation = function() {
                    if (null !== h || null !== d) return o;
                }, this.setFoveation = function(t1) {
                    o = t1, null !== h && (h.fixedFoveation = t1), null !== d && void 0 !== d.fixedFoveation && (d.fixedFoveation = t1);
                };
                let C = null;
                const z = new lh;
                z.setAnimationLoop(function(e, n) {
                    if (c = n.getViewerPose(l || a), p = n, null !== c) {
                        const e = c.views;
                        null !== d && (t1.setRenderTargetFramebuffer(m, d.framebuffer), t1.setRenderTarget(m));
                        let i = !1;
                        e.length !== w.cameras.length && (w.cameras.length = 0, i = !0);
                        for(let n = 0; n < e.length; n++){
                            const r = e[n];
                            let a = null;
                            if (null !== d) a = d.getViewport(r);
                            else {
                                const e = u.getViewSubImage(h, r);
                                a = e.viewport, 0 === n && (t1.setRenderTargetTextures(m, e.colorTexture, h.ignoreDepthValues ? void 0 : e.depthStencilTexture), t1.setRenderTarget(m));
                            }
                            let s = x[n];
                            void 0 === s && (s = new qu, s.layers.enable(n), s.viewport = new yl, x[n] = s), s.matrix.fromArray(r.transform.matrix), s.matrix.decompose(s.position, s.quaternion, s.scale), s.projectionMatrix.fromArray(r.projectionMatrix), s.projectionMatrixInverse.copy(s.projectionMatrix).invert(), s.viewport.set(a.x, a.y, a.width, a.height), 0 === n && (w.matrix.copy(s.matrix), w.matrix.decompose(w.position, w.quaternion, w.scale)), !0 === i && w.cameras.push(s);
                        }
                    }
                    for(let t1 = 0; t1 < g.length; t1++){
                        const e = M[t1], i = g[t1];
                        null !== e && void 0 !== i && i.update(e, n, l || a);
                    }
                    C && C(e, n), n.detectedPlanes && i.dispatchEvent({
                        type: "planesdetected",
                        data: n
                    }), p = null;
                }), this.setAnimationLoop = function(t1) {
                    C = t1;
                }, this.dispose = function() {};
            }
        }
        function Bp(t1, e) {
            function i(t1, e) {
                !0 === t1.matrixAutoUpdate && t1.updateMatrix(), e.value.copy(t1.matrix);
            }
            function n(n, r) {
                n.opacity.value = r.opacity, r.color && n.diffuse.value.copy(r.color), r.emissive && n.emissive.value.copy(r.emissive).multiplyScalar(r.emissiveIntensity), r.map && (n.map.value = r.map, i(r.map, n.mapTransform)), r.alphaMap && (n.alphaMap.value = r.alphaMap, i(r.alphaMap, n.alphaMapTransform)), r.bumpMap && (n.bumpMap.value = r.bumpMap, i(r.bumpMap, n.bumpMapTransform), n.bumpScale.value = r.bumpScale, r.side === lr && (n.bumpScale.value *= -1)), r.normalMap && (n.normalMap.value = r.normalMap, i(r.normalMap, n.normalMapTransform), n.normalScale.value.copy(r.normalScale), r.side === lr && n.normalScale.value.negate()), r.displacementMap && (n.displacementMap.value = r.displacementMap, i(r.displacementMap, n.displacementMapTransform), n.displacementScale.value = r.displacementScale, n.displacementBias.value = r.displacementBias), r.emissiveMap && (n.emissiveMap.value = r.emissiveMap, i(r.emissiveMap, n.emissiveMapTransform)), r.specularMap && (n.specularMap.value = r.specularMap, i(r.specularMap, n.specularMapTransform)), r.alphaTest > 0 && (n.alphaTest.value = r.alphaTest);
                const a = e.get(r).envMap;
                if (a && (n.envMap.value = a, n.flipEnvMap.value = a.isCubeTexture && !1 === a.isRenderTargetTexture ? -1 : 1, n.reflectivity.value = r.reflectivity, n.ior.value = r.ior, n.refractionRatio.value = r.refractionRatio), r.lightMap) {
                    n.lightMap.value = r.lightMap;
                    const e = !0 === t1._useLegacyLights ? Math.PI : 1;
                    n.lightMapIntensity.value = r.lightMapIntensity * e, i(r.lightMap, n.lightMapTransform);
                }
                r.aoMap && (n.aoMap.value = r.aoMap, n.aoMapIntensity.value = r.aoMapIntensity, i(r.aoMap, n.aoMapTransform));
            }
            return {
                refreshFogUniforms: function(e, i) {
                    i.color.getRGB(e.fogColor.value, Wu(t1)), i.isFog ? (e.fogNear.value = i.near, e.fogFar.value = i.far) : i.isFogExp2 && (e.fogDensity.value = i.density);
                },
                refreshMaterialUniforms: function(t1, r, a, s, o) {
                    r.isMeshBasicMaterial || r.isMeshLambertMaterial ? n(t1, r) : r.isMeshToonMaterial ? (n(t1, r), function(t1, e) {
                        e.gradientMap && (t1.gradientMap.value = e.gradientMap);
                    }(t1, r)) : r.isMeshPhongMaterial ? (n(t1, r), function(t1, e) {
                        t1.specular.value.copy(e.specular), t1.shininess.value = Math.max(e.shininess, 1e-4);
                    }(t1, r)) : r.isMeshStandardMaterial ? (n(t1, r), function(t1, n) {
                        t1.metalness.value = n.metalness, n.metalnessMap && (t1.metalnessMap.value = n.metalnessMap, i(n.metalnessMap, t1.metalnessMapTransform)), t1.roughness.value = n.roughness, n.roughnessMap && (t1.roughnessMap.value = n.roughnessMap, i(n.roughnessMap, t1.roughnessMapTransform));
                        e.get(n).envMap && (t1.envMapIntensity.value = n.envMapIntensity);
                    }(t1, r), r.isMeshPhysicalMaterial && function(t1, e, n) {
                        t1.ior.value = e.ior, e.sheen > 0 && (t1.sheenColor.value.copy(e.sheenColor).multiplyScalar(e.sheen), t1.sheenRoughness.value = e.sheenRoughness, e.sheenColorMap && (t1.sheenColorMap.value = e.sheenColorMap, i(e.sheenColorMap, t1.sheenColorMapTransform)), e.sheenRoughnessMap && (t1.sheenRoughnessMap.value = e.sheenRoughnessMap, i(e.sheenRoughnessMap, t1.sheenRoughnessMapTransform))), e.clearcoat > 0 && (t1.clearcoat.value = e.clearcoat, t1.clearcoatRoughness.value = e.clearcoatRoughness, e.clearcoatMap && (t1.clearcoatMap.value = e.clearcoatMap, i(e.clearcoatMap, t1.clearcoatMapTransform)), e.clearcoatRoughnessMap && (t1.clearcoatRoughnessMap.value = e.clearcoatRoughnessMap, i(e.clearcoatRoughnessMap, t1.clearcoatRoughnessMapTransform)), e.clearcoatNormalMap && (t1.clearcoatNormalMap.value = e.clearcoatNormalMap, i(e.clearcoatNormalMap, t1.clearcoatNormalMapTransform), t1.clearcoatNormalScale.value.copy(e.clearcoatNormalScale), e.side === lr && t1.clearcoatNormalScale.value.negate())), e.iridescence > 0 && (t1.iridescence.value = e.iridescence, t1.iridescenceIOR.value = e.iridescenceIOR, t1.iridescenceThicknessMinimum.value = e.iridescenceThicknessRange[0], t1.iridescenceThicknessMaximum.value = e.iridescenceThicknessRange[1], e.iridescenceMap && (t1.iridescenceMap.value = e.iridescenceMap, i(e.iridescenceMap, t1.iridescenceMapTransform)), e.iridescenceThicknessMap && (t1.iridescenceThicknessMap.value = e.iridescenceThicknessMap, i(e.iridescenceThicknessMap, t1.iridescenceThicknessMapTransform))), e.transmission > 0 && (t1.transmission.value = e.transmission, t1.transmissionSamplerMap.value = n.texture, t1.transmissionSamplerSize.value.set(n.width, n.height), e.transmissionMap && (t1.transmissionMap.value = e.transmissionMap, i(e.transmissionMap, t1.transmissionMapTransform)), t1.thickness.value = e.thickness, e.thicknessMap && (t1.thicknessMap.value = e.thicknessMap, i(e.thicknessMap, t1.thicknessMapTransform)), t1.attenuationDistance.value = e.attenuationDistance, t1.attenuationColor.value.copy(e.attenuationColor)), e.anisotropy > 0 && (t1.anisotropyVector.value.set(e.anisotropy * Math.cos(e.anisotropyRotation), e.anisotropy * Math.sin(e.anisotropyRotation)), e.anisotropyMap && (t1.anisotropyMap.value = e.anisotropyMap, i(e.anisotropyMap, t1.anisotropyMapTransform))), t1.specularIntensity.value = e.specularIntensity, t1.specularColor.value.copy(e.specularColor), e.specularColorMap && (t1.specularColorMap.value = e.specularColorMap, i(e.specularColorMap, t1.specularColorMapTransform)), e.specularIntensityMap && (t1.specularIntensityMap.value = e.specularIntensityMap, i(e.specularIntensityMap, t1.specularIntensityMapTransform));
                    }(t1, r, o)) : r.isMeshMatcapMaterial ? (n(t1, r), function(t1, e) {
                        e.matcap && (t1.matcap.value = e.matcap);
                    }(t1, r)) : r.isMeshDepthMaterial ? n(t1, r) : r.isMeshDistanceMaterial ? (n(t1, r), function(t1, i) {
                        const n = e.get(i).light;
                        t1.referencePosition.value.setFromMatrixPosition(n.matrixWorld), t1.nearDistance.value = n.shadow.camera.near, t1.farDistance.value = n.shadow.camera.far;
                    }(t1, r)) : r.isMeshNormalMaterial ? n(t1, r) : r.isLineBasicMaterial ? (function(t1, e) {
                        t1.diffuse.value.copy(e.color), t1.opacity.value = e.opacity, e.map && (t1.map.value = e.map, i(e.map, t1.mapTransform));
                    }(t1, r), r.isLineDashedMaterial && function(t1, e) {
                        t1.dashSize.value = e.dashSize, t1.totalSize.value = e.dashSize + e.gapSize, t1.scale.value = e.scale;
                    }(t1, r)) : r.isPointsMaterial ? function(t1, e, n, r) {
                        t1.diffuse.value.copy(e.color), t1.opacity.value = e.opacity, t1.size.value = e.size * n, t1.scale.value = .5 * r, e.map && (t1.map.value = e.map, i(e.map, t1.uvTransform)), e.alphaMap && (t1.alphaMap.value = e.alphaMap, i(e.alphaMap, t1.alphaMapTransform)), e.alphaTest > 0 && (t1.alphaTest.value = e.alphaTest);
                    }(t1, r, a, s) : r.isSpriteMaterial ? function(t1, e) {
                        t1.diffuse.value.copy(e.color), t1.opacity.value = e.opacity, t1.rotation.value = e.rotation, e.map && (t1.map.value = e.map, i(e.map, t1.mapTransform)), e.alphaMap && (t1.alphaMap.value = e.alphaMap, i(e.alphaMap, t1.alphaMapTransform)), e.alphaTest > 0 && (t1.alphaTest.value = e.alphaTest);
                    }(t1, r) : r.isShadowMaterial ? (t1.color.value.copy(r.color), t1.opacity.value = r.opacity) : r.isShaderMaterial && (r.uniformsNeedUpdate = !1);
                }
            };
        }
        function Fp(t1, e, i, n) {
            let r = {}, a = {}, s = [];
            const o = i.isWebGL2 ? t1.getParameter(t1.MAX_UNIFORM_BUFFER_BINDINGS) : 0;
            function l(t1, e, i) {
                const n = t1.value;
                if (void 0 === i[e]) {
                    if ("number" == typeof n) i[e] = n;
                    else {
                        const t1 = Array.isArray(n) ? n : [
                            n
                        ], r = [];
                        for(let e = 0; e < t1.length; e++)r.push(t1[e].clone());
                        i[e] = r;
                    }
                    return !0;
                }
                if ("number" == typeof n) {
                    if (i[e] !== n) return i[e] = n, !0;
                } else {
                    const t1 = Array.isArray(i[e]) ? i[e] : [
                        i[e]
                    ], r = Array.isArray(n) ? n : [
                        n
                    ];
                    for(let e = 0; e < t1.length; e++){
                        const i = t1[e];
                        if (!1 === i.equals(r[e])) return i.copy(r[e]), !0;
                    }
                }
                return !1;
            }
            function c(t1) {
                const e = {
                    boundary: 0,
                    storage: 0
                };
                return "number" == typeof t1 ? (e.boundary = 4, e.storage = 4) : t1.isVector2 ? (e.boundary = 8, e.storage = 8) : t1.isVector3 || t1.isColor ? (e.boundary = 16, e.storage = 12) : t1.isVector4 ? (e.boundary = 16, e.storage = 16) : t1.isMatrix3 ? (e.boundary = 48, e.storage = 48) : t1.isMatrix4 ? (e.boundary = 64, e.storage = 64) : t1.isTexture ? console.warn("THREE.WebGLRenderer: Texture samplers can not be part of an uniforms group.") : console.warn("THREE.WebGLRenderer: Unsupported uniform value type.", t1), e;
            }
            function u(e) {
                const i = e.target;
                i.removeEventListener("dispose", u);
                const n = s.indexOf(i.__bindingPointIndex);
                s.splice(n, 1), t1.deleteBuffer(r[i.id]), delete r[i.id], delete a[i.id];
            }
            return {
                bind: function(t1, e) {
                    const i = e.program;
                    n.uniformBlockBinding(t1, i);
                },
                update: function(i, h) {
                    let d = r[i.id];
                    void 0 === d && (function(t1) {
                        const e = t1.uniforms;
                        let i = 0;
                        let n = 0;
                        for(let t1 = 0, r = e.length; t1 < r; t1++){
                            const r = e[t1], a = {
                                boundary: 0,
                                storage: 0
                            }, s = Array.isArray(r.value) ? r.value : [
                                r.value
                            ];
                            for(let t1 = 0, e = s.length; t1 < e; t1++){
                                const e = c(s[t1]);
                                a.boundary += e.boundary, a.storage += e.storage;
                            }
                            r.__data = new Float32Array(a.storage / Float32Array.BYTES_PER_ELEMENT), r.__offset = i, t1 > 0 && (n = i % 16, 0 !== n && 16 - n - a.boundary < 0 && (i += 16 - n, r.__offset = i)), i += a.storage;
                        }
                        n = i % 16, n > 0 && (i += 16 - n), t1.__size = i, t1.__cache = {};
                    }(i), d = function(e) {
                        const i = function() {
                            for(let t1 = 0; t1 < o; t1++)if (-1 === s.indexOf(t1)) return s.push(t1), t1;
                            return console.error("THREE.WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached."), 0;
                        }();
                        e.__bindingPointIndex = i;
                        const n = t1.createBuffer(), r = e.__size, a = e.usage;
                        return t1.bindBuffer(t1.UNIFORM_BUFFER, n), t1.bufferData(t1.UNIFORM_BUFFER, r, a), t1.bindBuffer(t1.UNIFORM_BUFFER, null), t1.bindBufferBase(t1.UNIFORM_BUFFER, i, n), n;
                    }(i), r[i.id] = d, i.addEventListener("dispose", u));
                    const p = h.program;
                    n.updateUBOMapping(i, p);
                    const A = e.render.frame;
                    a[i.id] !== A && (function(e) {
                        const i = r[e.id], n = e.uniforms, a = e.__cache;
                        t1.bindBuffer(t1.UNIFORM_BUFFER, i);
                        for(let e = 0, i = n.length; e < i; e++){
                            const i = n[e];
                            if (!0 === l(i, e, a)) {
                                const e = i.__offset, n = Array.isArray(i.value) ? i.value : [
                                    i.value
                                ];
                                let r = 0;
                                for(let a = 0; a < n.length; a++){
                                    const s = n[a], o = c(s);
                                    "number" == typeof s ? (i.__data[0] = s, t1.bufferSubData(t1.UNIFORM_BUFFER, e + r, i.__data)) : s.isMatrix3 ? (i.__data[0] = s.elements[0], i.__data[1] = s.elements[1], i.__data[2] = s.elements[2], i.__data[3] = s.elements[0], i.__data[4] = s.elements[3], i.__data[5] = s.elements[4], i.__data[6] = s.elements[5], i.__data[7] = s.elements[0], i.__data[8] = s.elements[6], i.__data[9] = s.elements[7], i.__data[10] = s.elements[8], i.__data[11] = s.elements[0]) : (s.toArray(i.__data, r), r += o.storage / Float32Array.BYTES_PER_ELEMENT);
                                }
                                t1.bufferSubData(t1.UNIFORM_BUFFER, e, i.__data);
                            }
                        }
                        t1.bindBuffer(t1.UNIFORM_BUFFER, null);
                    }(i), a[i.id] = A);
                },
                dispose: function() {
                    for(const e in r)t1.deleteBuffer(r[e]);
                    s = [], r = {}, a = {};
                }
            };
        }
        class Qp {
            constructor(t1 = {}){
                const { canvas: e = nl(), context: i = null, depth: n = !0, stencil: r = !0, alpha: a = !1, antialias: s = !1, premultipliedAlpha: o = !0, preserveDrawingBuffer: l = !1, powerPreference: c = "default", failIfMajorPerformanceCaveat: u = !1 } = t1;
                let h;
                this.isWebGLRenderer = !0, h = null !== i ? i.getContextAttributes().alpha : a;
                const d = new Uint32Array(4), p = new Int32Array(4);
                let A = null, f = null;
                const m = [], g = [];
                this.domElement = e, this.debug = {
                    checkShaderErrors: !0,
                    onShaderError: null
                }, this.autoClear = !0, this.autoClearColor = !0, this.autoClearDepth = !0, this.autoClearStencil = !0, this.sortObjects = !0, this.clippingPlanes = [], this.localClippingEnabled = !1, this._outputColorSpace = Qs, this._useLegacyLights = !1, this.toneMapping = Xr, this.toneMappingExposure = 1;
                const M = this;
                let v = !1, y = 0, x = 0, w = null, b = -1, T = null;
                const E = new yl, _ = new yl;
                let I = null;
                const S = new Yc(0);
                let N = 0, D = e.width, C = e.height, z = 1, L = null, O = null;
                const P = new yl(0, 0, D, C), j = new yl(0, 0, D, C);
                let R = !1;
                const k = new oh;
                let U = !1, B = !1, F = null;
                const Q = new ac, H = new qo, V = new Nl, G = {
                    background: null,
                    fog: null,
                    environment: null,
                    overrideMaterial: null,
                    isScene: !0
                };
                function W() {
                    return null === w ? z : 1;
                }
                let Y, X, Z, q, J, K, $, tt, et, it, nt, rt, at, st, ot, lt, ct, ut, ht, dt, pt, At, ft, mt, gt = i;
                function Mt(t1, i) {
                    for(let n = 0; n < t1.length; n++){
                        const r = t1[n], a = e.getContext(r, i);
                        if (null !== a) return a;
                    }
                    return null;
                }
                try {
                    const t1 = {
                        alpha: !0,
                        depth: n,
                        stencil: r,
                        antialias: s,
                        premultipliedAlpha: o,
                        preserveDrawingBuffer: l,
                        powerPreference: c,
                        failIfMajorPerformanceCaveat: u
                    };
                    if ("setAttribute" in e && e.setAttribute("data-engine", `three.js r${qn}`), e.addEventListener("webglcontextlost", xt, !1), e.addEventListener("webglcontextrestored", wt, !1), e.addEventListener("webglcontextcreationerror", bt, !1), null === gt) {
                        const e = [
                            "webgl2",
                            "webgl",
                            "experimental-webgl"
                        ];
                        if (!0 === M.isWebGL1Renderer && e.shift(), gt = Mt(e, t1), null === gt) throw Mt(e) ? new Error("Error creating WebGL context with your selected attributes.") : new Error("Error creating WebGL context.");
                    }
                    "undefined" != typeof WebGLRenderingContext && gt instanceof WebGLRenderingContext && console.warn("THREE.WebGLRenderer: WebGL 1 support was deprecated in r153 and will be removed in r163."), void 0 === gt.getShaderPrecisionFormat && (gt.getShaderPrecisionFormat = function() {
                        return {
                            rangeMin: 1,
                            rangeMax: 1,
                            precision: 1
                        };
                    });
                } catch (t1) {
                    throw console.error("THREE.WebGLRenderer: " + t1.message), t1;
                }
                function vt() {
                    Y = new Rh(gt), X = new Mh(gt, Y, t1), Y.init(X), At = new Lp(gt, Y, X), Z = new Cp(gt, Y, X), q = new Bh(gt), J = new gp, K = new zp(gt, Y, Z, J, X, At, q), $ = new yh(M), tt = new jh(M), et = new ch(gt, X), ft = new mh(gt, Y, et, X), it = new kh(gt, et, q, ft), nt = new Vh(gt, it, et, q), ht = new Hh(gt, X, K), lt = new vh(J), rt = new mp(M, $, tt, Y, X, ft, lt), at = new Bp(M, J), st = new xp, ot = new Ip(Y, X), ut = new fh(M, $, tt, Z, nt, h, o), ct = new Dp(M, nt, X), mt = new Fp(gt, q, X, Z), dt = new gh(gt, Y, q, X), pt = new Uh(gt, Y, q, X), q.programs = rt.programs, M.capabilities = X, M.extensions = Y, M.properties = J, M.renderLists = st, M.shadowMap = ct, M.state = Z, M.info = q;
                }
                vt();
                const yt = new Up(M, gt);
                function xt(t1) {
                    t1.preventDefault(), console.log("THREE.WebGLRenderer: Context Lost."), v = !0;
                }
                function wt() {
                    console.log("THREE.WebGLRenderer: Context Restored."), v = !1;
                    const t1 = q.autoReset, e = ct.enabled, i = ct.autoUpdate, n = ct.needsUpdate, r = ct.type;
                    vt(), q.autoReset = t1, ct.enabled = e, ct.autoUpdate = i, ct.needsUpdate = n, ct.type = r;
                }
                function bt(t1) {
                    console.error("THREE.WebGLRenderer: A WebGL context could not be created. Reason: ", t1.statusMessage);
                }
                function Tt(t1) {
                    const e = t1.target;
                    e.removeEventListener("dispose", Tt), function(t1) {
                        (function(t1) {
                            const e = J.get(t1).programs;
                            void 0 !== e && (e.forEach(function(t1) {
                                rt.releaseProgram(t1);
                            }), t1.isShaderMaterial && rt.releaseShaderCache(t1));
                        })(t1), J.remove(t1);
                    }(e);
                }
                function Et(t1, e, i) {
                    !0 === t1.transparent && t1.side === cr && !1 === t1.forceSinglePass ? (t1.side = lr, t1.needsUpdate = !0, Ot(t1, e, i), t1.side = or, t1.needsUpdate = !0, Ot(t1, e, i), t1.side = cr) : Ot(t1, e, i);
                }
                this.xr = yt, this.getContext = function() {
                    return gt;
                }, this.getContextAttributes = function() {
                    return gt.getContextAttributes();
                }, this.forceContextLoss = function() {
                    const t1 = Y.get("WEBGL_lose_context");
                    t1 && t1.loseContext();
                }, this.forceContextRestore = function() {
                    const t1 = Y.get("WEBGL_lose_context");
                    t1 && t1.restoreContext();
                }, this.getPixelRatio = function() {
                    return z;
                }, this.setPixelRatio = function(t1) {
                    void 0 !== t1 && (z = t1, this.setSize(D, C, !1));
                }, this.getSize = function(t1) {
                    return t1.set(D, C);
                }, this.setSize = function(t1, i, n = !0) {
                    yt.isPresenting ? console.warn("THREE.WebGLRenderer: Can't change size while VR device is presenting.") : (D = t1, C = i, e.width = Math.floor(t1 * z), e.height = Math.floor(i * z), !0 === n && (e.style.width = t1 + "px", e.style.height = i + "px"), this.setViewport(0, 0, t1, i));
                }, this.getDrawingBufferSize = function(t1) {
                    return t1.set(D * z, C * z).floor();
                }, this.setDrawingBufferSize = function(t1, i, n) {
                    D = t1, C = i, z = n, e.width = Math.floor(t1 * n), e.height = Math.floor(i * n), this.setViewport(0, 0, t1, i);
                }, this.getCurrentViewport = function(t1) {
                    return t1.copy(E);
                }, this.getViewport = function(t1) {
                    return t1.copy(P);
                }, this.setViewport = function(t1, e, i, n) {
                    t1.isVector4 ? P.set(t1.x, t1.y, t1.z, t1.w) : P.set(t1, e, i, n), Z.viewport(E.copy(P).multiplyScalar(z).floor());
                }, this.getScissor = function(t1) {
                    return t1.copy(j);
                }, this.setScissor = function(t1, e, i, n) {
                    t1.isVector4 ? j.set(t1.x, t1.y, t1.z, t1.w) : j.set(t1, e, i, n), Z.scissor(_.copy(j).multiplyScalar(z).floor());
                }, this.getScissorTest = function() {
                    return R;
                }, this.setScissorTest = function(t1) {
                    Z.setScissorTest(R = t1);
                }, this.setOpaqueSort = function(t1) {
                    L = t1;
                }, this.setTransparentSort = function(t1) {
                    O = t1;
                }, this.getClearColor = function(t1) {
                    return t1.copy(ut.getClearColor());
                }, this.setClearColor = function() {
                    ut.setClearColor.apply(ut, arguments);
                }, this.getClearAlpha = function() {
                    return ut.getClearAlpha();
                }, this.setClearAlpha = function() {
                    ut.setClearAlpha.apply(ut, arguments);
                }, this.clear = function(t1 = !0, e = !0, i = !0) {
                    let n = 0;
                    if (t1) {
                        let t1 = !1;
                        if (null !== w) {
                            const e = w.texture.format;
                            t1 = e === Qa || e === Fa || e === Ua;
                        }
                        if (t1) {
                            const t1 = w.texture.type, e = t1 === xa || t1 === _a || t1 === Ta || t1 === Ca || t1 === Na || t1 === Da, i = ut.getClearColor(), n = ut.getClearAlpha(), r = i.r, a = i.g, s = i.b;
                            e ? (d[0] = r, d[1] = a, d[2] = s, d[3] = n, gt.clearBufferuiv(gt.COLOR, 0, d)) : (p[0] = r, p[1] = a, p[2] = s, p[3] = n, gt.clearBufferiv(gt.COLOR, 0, p));
                        } else n |= gt.COLOR_BUFFER_BIT;
                    }
                    e && (n |= gt.DEPTH_BUFFER_BIT), i && (n |= gt.STENCIL_BUFFER_BIT, this.state.buffers.stencil.setMask(4294967295)), gt.clear(n);
                }, this.clearColor = function() {
                    this.clear(!0, !1, !1);
                }, this.clearDepth = function() {
                    this.clear(!1, !0, !1);
                }, this.clearStencil = function() {
                    this.clear(!1, !1, !0);
                }, this.dispose = function() {
                    e.removeEventListener("webglcontextlost", xt, !1), e.removeEventListener("webglcontextrestored", wt, !1), e.removeEventListener("webglcontextcreationerror", bt, !1), st.dispose(), ot.dispose(), J.dispose(), $.dispose(), tt.dispose(), nt.dispose(), ft.dispose(), mt.dispose(), rt.dispose(), yt.dispose(), yt.removeEventListener("sessionstart", It), yt.removeEventListener("sessionend", St), F && (F.dispose(), F = null), Nt.stop();
                }, this.renderBufferDirect = function(t1, e, i, n, r, a) {
                    null === e && (e = G);
                    const s = r.isMesh && r.matrixWorld.determinant() < 0, o = function(t1, e, i, n, r) {
                        !0 !== e.isScene && (e = G), K.resetTextureUnits();
                        const a = e.fog, s = n.isMeshStandardMaterial ? e.environment : null, o = null === w ? M.outputColorSpace : !0 === w.isXRRenderTarget ? w.texture.colorSpace : Hs, l = (n.isMeshStandardMaterial ? tt : $).get(n.envMap || s), c = !0 === n.vertexColors && !!i.attributes.color && 4 === i.attributes.color.itemSize, u = !!i.attributes.tangent && (!!n.normalMap || n.anisotropy > 0), h = !!i.morphAttributes.position, d = !!i.morphAttributes.normal, p = !!i.morphAttributes.color;
                        let A = Xr;
                        n.toneMapped && (null !== w && !0 !== w.isXRRenderTarget || (A = M.toneMapping));
                        const m = i.morphAttributes.position || i.morphAttributes.normal || i.morphAttributes.color, g = void 0 !== m ? m.length : 0, v = J.get(n), y = f.state.lights;
                        if (!0 === U && (!0 === B || t1 !== T)) {
                            const e = t1 === T && n.id === b;
                            lt.setState(n, t1, e);
                        }
                        let x = !1;
                        n.version === v.__version ? v.needsLights && v.lightsStateVersion !== y.state.version || v.outputColorSpace !== o || r.isInstancedMesh && !1 === v.instancing ? x = !0 : r.isInstancedMesh || !0 !== v.instancing ? r.isSkinnedMesh && !1 === v.skinning ? x = !0 : r.isSkinnedMesh || !0 !== v.skinning ? r.isInstancedMesh && !0 === v.instancingColor && null === r.instanceColor || r.isInstancedMesh && !1 === v.instancingColor && null !== r.instanceColor || v.envMap !== l || !0 === n.fog && v.fog !== a ? x = !0 : void 0 === v.numClippingPlanes || v.numClippingPlanes === lt.numPlanes && v.numIntersection === lt.numIntersection ? (v.vertexAlphas !== c || v.vertexTangents !== u || v.morphTargets !== h || v.morphNormals !== d || v.morphColors !== p || v.toneMapping !== A || !0 === X.isWebGL2 && v.morphTargetsCount !== g) && (x = !0) : x = !0 : x = !0 : x = !0 : (x = !0, v.__version = n.version);
                        let E = v.currentProgram;
                        !0 === x && (E = Ot(n, e, r));
                        let _ = !1, I = !1, S = !1;
                        const N = E.getUniforms(), D = v.uniforms;
                        if (Z.useProgram(E.program) && (_ = !0, I = !0, S = !0), n.id !== b && (b = n.id, I = !0), _ || T !== t1) {
                            N.setValue(gt, "projectionMatrix", t1.projectionMatrix), N.setValue(gt, "viewMatrix", t1.matrixWorldInverse);
                            const e = N.map.cameraPosition;
                            void 0 !== e && e.setValue(gt, V.setFromMatrixPosition(t1.matrixWorld)), X.logarithmicDepthBuffer && N.setValue(gt, "logDepthBufFC", 2 / (Math.log(t1.far + 1) / Math.LN2)), (n.isMeshPhongMaterial || n.isMeshToonMaterial || n.isMeshLambertMaterial || n.isMeshBasicMaterial || n.isMeshStandardMaterial || n.isShaderMaterial) && N.setValue(gt, "isOrthographic", !0 === t1.isOrthographicCamera), T !== t1 && (T = t1, I = !0, S = !0);
                        }
                        if (r.isSkinnedMesh) {
                            N.setOptional(gt, r, "bindMatrix"), N.setOptional(gt, r, "bindMatrixInverse");
                            const t1 = r.skeleton;
                            t1 && (X.floatVertexTextures ? (null === t1.boneTexture && t1.computeBoneTexture(), N.setValue(gt, "boneTexture", t1.boneTexture, K), N.setValue(gt, "boneTextureSize", t1.boneTextureSize)) : console.warn("THREE.WebGLRenderer: SkinnedMesh can only be used with WebGL 2. With WebGL 1 OES_texture_float and vertex textures support is required."));
                        }
                        const L = i.morphAttributes;
                        var O, P;
                        if ((void 0 !== L.position || void 0 !== L.normal || void 0 !== L.color && !0 === X.isWebGL2) && ht.update(r, i, E), (I || v.receiveShadow !== r.receiveShadow) && (v.receiveShadow = r.receiveShadow, N.setValue(gt, "receiveShadow", r.receiveShadow)), n.isMeshGouraudMaterial && null !== n.envMap && (D.envMap.value = l, D.flipEnvMap.value = l.isCubeTexture && !1 === l.isRenderTargetTexture ? -1 : 1), I && (N.setValue(gt, "toneMappingExposure", M.toneMappingExposure), v.needsLights && (P = S, (O = D).ambientLightColor.needsUpdate = P, O.lightProbe.needsUpdate = P, O.directionalLights.needsUpdate = P, O.directionalLightShadows.needsUpdate = P, O.pointLights.needsUpdate = P, O.pointLightShadows.needsUpdate = P, O.spotLights.needsUpdate = P, O.spotLightShadows.needsUpdate = P, O.rectAreaLights.needsUpdate = P, O.hemisphereLights.needsUpdate = P), a && !0 === n.fog && at.refreshFogUniforms(D, a), at.refreshMaterialUniforms(D, n, z, C, F), Xd.upload(gt, Pt(v), D, K)), n.isShaderMaterial && !0 === n.uniformsNeedUpdate && (Xd.upload(gt, Pt(v), D, K), n.uniformsNeedUpdate = !1), n.isSpriteMaterial && N.setValue(gt, "center", r.center), N.setValue(gt, "modelViewMatrix", r.modelViewMatrix), N.setValue(gt, "normalMatrix", r.normalMatrix), N.setValue(gt, "modelMatrix", r.matrixWorld), n.isShaderMaterial || n.isRawShaderMaterial) {
                            const t1 = n.uniformsGroups;
                            for(let e = 0, i = t1.length; e < i; e++)if (X.isWebGL2) {
                                const i = t1[e];
                                mt.update(i, E), mt.bind(i, E);
                            } else console.warn("THREE.WebGLRenderer: Uniform Buffer Objects can only be used with WebGL 2.");
                        }
                        return E;
                    }(t1, e, i, n, r);
                    Z.setMaterial(n, s);
                    let l = i.index, c = 1;
                    if (!0 === n.wireframe) {
                        if (l = it.getWireframeAttribute(i), void 0 === l) return;
                        c = 2;
                    }
                    const u = i.drawRange, h = i.attributes.position;
                    let d = u.start * c, p = (u.start + u.count) * c;
                    null !== a && (d = Math.max(d, a.start * c), p = Math.min(p, (a.start + a.count) * c)), null !== l ? (d = Math.max(d, 0), p = Math.min(p, l.count)) : null != h && (d = Math.max(d, 0), p = Math.min(p, h.count));
                    const A = p - d;
                    if (A < 0 || A === 1 / 0) return;
                    let m;
                    ft.setup(r, n, o, i, l);
                    let g = dt;
                    if (null !== l && (m = et.get(l), g = pt, g.setIndex(m)), r.isMesh) !0 === n.wireframe ? (Z.setLineWidth(n.wireframeLinewidth * W()), g.setMode(gt.LINES)) : g.setMode(gt.TRIANGLES);
                    else if (r.isLine) {
                        let t1 = n.linewidth;
                        void 0 === t1 && (t1 = 1), Z.setLineWidth(t1 * W()), r.isLineSegments ? g.setMode(gt.LINES) : r.isLineLoop ? g.setMode(gt.LINE_LOOP) : g.setMode(gt.LINE_STRIP);
                    } else r.isPoints ? g.setMode(gt.POINTS) : r.isSprite && g.setMode(gt.TRIANGLES);
                    if (r.isInstancedMesh) g.renderInstances(d, A, r.count);
                    else if (i.isInstancedBufferGeometry) {
                        const t1 = void 0 !== i._maxInstanceCount ? i._maxInstanceCount : 1 / 0, e = Math.min(i.instanceCount, t1);
                        g.renderInstances(d, A, e);
                    } else g.render(d, A);
                }, this.compile = function(t1, e, i = null) {
                    null === i && (i = t1), f = ot.get(i), f.init(), g.push(f), i.traverseVisible(function(t1) {
                        t1.isLight && t1.layers.test(e.layers) && (f.pushLight(t1), t1.castShadow && f.pushShadow(t1));
                    }), t1 !== i && t1.traverseVisible(function(t1) {
                        t1.isLight && t1.layers.test(e.layers) && (f.pushLight(t1), t1.castShadow && f.pushShadow(t1));
                    }), f.setupLights(M._useLegacyLights);
                    const n = new Set;
                    return t1.traverse(function(t1) {
                        const e = t1.material;
                        if (e) {
                            if (Array.isArray(e)) for(let r = 0; r < e.length; r++){
                                const a = e[r];
                                Et(a, i, t1), n.add(a);
                            }
                            else Et(e, i, t1), n.add(e);
                        }
                    }), g.pop(), f = null, n;
                }, this.compileAsync = function(t1, e, i = null) {
                    const n = this.compile(t1, e, i);
                    return new Promise((e)=>{
                        function i() {
                            n.forEach(function(t1) {
                                J.get(t1).currentProgram.isReady() && n.delete(t1);
                            }), 0 !== n.size ? setTimeout(i, 10) : e(t1);
                        }
                        null !== Y.get("KHR_parallel_shader_compile") ? i() : setTimeout(i, 10);
                    });
                };
                let _t = null;
                function It() {
                    Nt.stop();
                }
                function St() {
                    Nt.start();
                }
                const Nt = new lh;
                function Dt(t1, e, i, n) {
                    if (!1 === t1.visible) return;
                    if (t1.layers.test(e.layers)) {
                        if (t1.isGroup) i = t1.renderOrder;
                        else if (t1.isLOD) !0 === t1.autoUpdate && t1.update(e);
                        else if (t1.isLight) f.pushLight(t1), t1.castShadow && f.pushShadow(t1);
                        else if (t1.isSprite) {
                            if (!t1.frustumCulled || k.intersectsSprite(t1)) {
                                n && V.setFromMatrixPosition(t1.matrixWorld).applyMatrix4(Q);
                                const e = nt.update(t1), r = t1.material;
                                r.visible && A.push(t1, e, r, i, V.z, null);
                            }
                        } else if ((t1.isMesh || t1.isLine || t1.isPoints) && (!t1.frustumCulled || k.intersectsObject(t1))) {
                            const e = nt.update(t1), r = t1.material;
                            if (n && (void 0 !== t1.boundingSphere ? (null === t1.boundingSphere && t1.computeBoundingSphere(), V.copy(t1.boundingSphere.center)) : (null === e.boundingSphere && e.computeBoundingSphere(), V.copy(e.boundingSphere.center)), V.applyMatrix4(t1.matrixWorld).applyMatrix4(Q)), Array.isArray(r)) {
                                const n = e.groups;
                                for(let a = 0, s = n.length; a < s; a++){
                                    const s = n[a], o = r[s.materialIndex];
                                    o && o.visible && A.push(t1, e, o, i, V.z, s);
                                }
                            } else r.visible && A.push(t1, e, r, i, V.z, null);
                        }
                    }
                    const r = t1.children;
                    for(let t1 = 0, a = r.length; t1 < a; t1++)Dt(r[t1], e, i, n);
                }
                function Ct(t1, e, i, n) {
                    const r = t1.opaque, a = t1.transmissive, s = t1.transparent;
                    f.setupLightsView(i), !0 === U && lt.setGlobalState(M.clippingPlanes, i), a.length > 0 && function(t1, e, i, n) {
                        if (null !== (!0 === i.isScene ? i.overrideMaterial : null)) return;
                        const r = X.isWebGL2;
                        null === F && (F = new wl(1, 1, {
                            generateMipmaps: !0,
                            type: Y.has("EXT_color_buffer_half_float") ? Sa : xa,
                            minFilter: va,
                            samples: r ? 4 : 0
                        })), M.getDrawingBufferSize(H), r ? F.setSize(H.x, H.y) : F.setSize(Wo(H.x), Wo(H.y));
                        const a = M.getRenderTarget();
                        M.setRenderTarget(F), M.getClearColor(S), N = M.getClearAlpha(), N < 1 && M.setClearColor(16777215, .5), M.clear();
                        const s = M.toneMapping;
                        M.toneMapping = Xr, zt(t1, i, n), K.updateMultisampleRenderTarget(F), K.updateRenderTargetMipmap(F);
                        let o = !1;
                        for(let t1 = 0, r = e.length; t1 < r; t1++){
                            const r = e[t1], a = r.object, s = r.geometry, l = r.material, c = r.group;
                            if (l.side === cr && a.layers.test(n.layers)) {
                                const t1 = l.side;
                                l.side = lr, l.needsUpdate = !0, Lt(a, i, n, s, l, c), l.side = t1, l.needsUpdate = !0, o = !0;
                            }
                        }
                        !0 === o && (K.updateMultisampleRenderTarget(F), K.updateRenderTargetMipmap(F)), M.setRenderTarget(a), M.setClearColor(S, N), M.toneMapping = s;
                    }(r, a, e, i), n && Z.viewport(E.copy(n)), r.length > 0 && zt(r, e, i), a.length > 0 && zt(a, e, i), s.length > 0 && zt(s, e, i), Z.buffers.depth.setTest(!0), Z.buffers.depth.setMask(!0), Z.buffers.color.setMask(!0), Z.setPolygonOffset(!1);
                }
                function zt(t1, e, i) {
                    const n = !0 === e.isScene ? e.overrideMaterial : null;
                    for(let r = 0, a = t1.length; r < a; r++){
                        const a = t1[r], s = a.object, o = a.geometry, l = null === n ? a.material : n, c = a.group;
                        s.layers.test(i.layers) && Lt(s, e, i, o, l, c);
                    }
                }
                function Lt(t1, e, i, n, r, a) {
                    t1.onBeforeRender(M, e, i, n, r, a), t1.modelViewMatrix.multiplyMatrices(i.matrixWorldInverse, t1.matrixWorld), t1.normalMatrix.getNormalMatrix(t1.modelViewMatrix), r.onBeforeRender(M, e, i, n, t1, a), !0 === r.transparent && r.side === cr && !1 === r.forceSinglePass ? (r.side = lr, r.needsUpdate = !0, M.renderBufferDirect(i, e, n, r, t1, a), r.side = or, r.needsUpdate = !0, M.renderBufferDirect(i, e, n, r, t1, a), r.side = cr) : M.renderBufferDirect(i, e, n, r, t1, a), t1.onAfterRender(M, e, i, n, r, a);
                }
                function Ot(t1, e, i) {
                    !0 !== e.isScene && (e = G);
                    const n = J.get(t1), r = f.state.lights, a = f.state.shadowsArray, s = r.state.version, o = rt.getParameters(t1, r.state, a, e, i), l = rt.getProgramCacheKey(o);
                    let c = n.programs;
                    n.environment = t1.isMeshStandardMaterial ? e.environment : null, n.fog = e.fog, n.envMap = (t1.isMeshStandardMaterial ? tt : $).get(t1.envMap || n.environment), void 0 === c && (t1.addEventListener("dispose", Tt), c = new Map, n.programs = c);
                    let u = c.get(l);
                    if (void 0 !== u) {
                        if (n.currentProgram === u && n.lightsStateVersion === s) return jt(t1, o), u;
                    } else o.uniforms = rt.getUniforms(t1), t1.onBuild(i, o, M), t1.onBeforeCompile(o, M), u = rt.acquireProgram(o, l), c.set(l, u), n.uniforms = o.uniforms;
                    const h = n.uniforms;
                    return (t1.isShaderMaterial || t1.isRawShaderMaterial) && !0 !== t1.clipping || (h.clippingPlanes = lt.uniform), jt(t1, o), n.needsLights = function(t1) {
                        return t1.isMeshLambertMaterial || t1.isMeshToonMaterial || t1.isMeshPhongMaterial || t1.isMeshStandardMaterial || t1.isShadowMaterial || t1.isShaderMaterial && !0 === t1.lights;
                    }(t1), n.lightsStateVersion = s, n.needsLights && (h.ambientLightColor.value = r.state.ambient, h.lightProbe.value = r.state.probe, h.directionalLights.value = r.state.directional, h.directionalLightShadows.value = r.state.directionalShadow, h.spotLights.value = r.state.spot, h.spotLightShadows.value = r.state.spotShadow, h.rectAreaLights.value = r.state.rectArea, h.ltc_1.value = r.state.rectAreaLTC1, h.ltc_2.value = r.state.rectAreaLTC2, h.pointLights.value = r.state.point, h.pointLightShadows.value = r.state.pointShadow, h.hemisphereLights.value = r.state.hemi, h.directionalShadowMap.value = r.state.directionalShadowMap, h.directionalShadowMatrix.value = r.state.directionalShadowMatrix, h.spotShadowMap.value = r.state.spotShadowMap, h.spotLightMatrix.value = r.state.spotLightMatrix, h.spotLightMap.value = r.state.spotLightMap, h.pointShadowMap.value = r.state.pointShadowMap, h.pointShadowMatrix.value = r.state.pointShadowMatrix), n.currentProgram = u, n.uniformsList = null, u;
                }
                function Pt(t1) {
                    if (null === t1.uniformsList) {
                        const e = t1.currentProgram.getUniforms();
                        t1.uniformsList = Xd.seqWithValue(e.seq, t1.uniforms);
                    }
                    return t1.uniformsList;
                }
                function jt(t1, e) {
                    const i = J.get(t1);
                    i.outputColorSpace = e.outputColorSpace, i.instancing = e.instancing, i.instancingColor = e.instancingColor, i.skinning = e.skinning, i.morphTargets = e.morphTargets, i.morphNormals = e.morphNormals, i.morphColors = e.morphColors, i.morphTargetsCount = e.morphTargetsCount, i.numClippingPlanes = e.numClippingPlanes, i.numIntersection = e.numClipIntersection, i.vertexAlphas = e.vertexAlphas, i.vertexTangents = e.vertexTangents, i.toneMapping = e.toneMapping;
                }
                Nt.setAnimationLoop(function(t1) {
                    _t && _t(t1);
                }), "undefined" != typeof self && Nt.setContext(self), this.setAnimationLoop = function(t1) {
                    _t = t1, yt.setAnimationLoop(t1), null === t1 ? Nt.stop() : Nt.start();
                }, yt.addEventListener("sessionstart", It), yt.addEventListener("sessionend", St), this.render = function(t1, e) {
                    if (void 0 !== e && !0 !== e.isCamera) return void console.error("THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.");
                    if (!0 === v) return;
                    !0 === t1.matrixWorldAutoUpdate && t1.updateMatrixWorld(), null === e.parent && !0 === e.matrixWorldAutoUpdate && e.updateMatrixWorld(), !0 === yt.enabled && !0 === yt.isPresenting && (!0 === yt.cameraAutoUpdate && yt.updateCamera(e), e = yt.getCamera()), !0 === t1.isScene && t1.onBeforeRender(M, t1, e, w), f = ot.get(t1, g.length), f.init(), g.push(f), Q.multiplyMatrices(e.projectionMatrix, e.matrixWorldInverse), k.setFromProjectionMatrix(Q), B = this.localClippingEnabled, U = lt.init(this.clippingPlanes, B), A = st.get(t1, m.length), A.init(), m.push(A), Dt(t1, e, 0, M.sortObjects), A.finish(), !0 === M.sortObjects && A.sort(L, O), this.info.render.frame++, !0 === U && lt.beginShadows();
                    const i = f.state.shadowsArray;
                    if (ct.render(i, t1, e), !0 === U && lt.endShadows(), !0 === this.info.autoReset && this.info.reset(), ut.render(A, t1), f.setupLights(M._useLegacyLights), e.isArrayCamera) {
                        const i = e.cameras;
                        for(let e = 0, n = i.length; e < n; e++){
                            const n = i[e];
                            Ct(A, t1, n, n.viewport);
                        }
                    } else Ct(A, t1, e);
                    null !== w && (K.updateMultisampleRenderTarget(w), K.updateRenderTargetMipmap(w)), !0 === t1.isScene && t1.onAfterRender(M, t1, e), ft.resetDefaultState(), b = -1, T = null, g.pop(), f = g.length > 0 ? g[g.length - 1] : null, m.pop(), A = m.length > 0 ? m[m.length - 1] : null;
                }, this.getActiveCubeFace = function() {
                    return y;
                }, this.getActiveMipmapLevel = function() {
                    return x;
                }, this.getRenderTarget = function() {
                    return w;
                }, this.setRenderTargetTextures = function(t1, e, i) {
                    J.get(t1.texture).__webglTexture = e, J.get(t1.depthTexture).__webglTexture = i;
                    const n = J.get(t1);
                    n.__hasExternalTextures = !0, n.__hasExternalTextures && (n.__autoAllocateDepthBuffer = void 0 === i, n.__autoAllocateDepthBuffer || !0 === Y.has("WEBGL_multisampled_render_to_texture") && (console.warn("THREE.WebGLRenderer: Render-to-texture extension was disabled because an external texture was provided"), n.__useRenderToTexture = !1));
                }, this.setRenderTargetFramebuffer = function(t1, e) {
                    const i = J.get(t1);
                    i.__webglFramebuffer = e, i.__useDefaultFramebuffer = void 0 === e;
                }, this.setRenderTarget = function(t1, e = 0, i = 0) {
                    w = t1, y = e, x = i;
                    let n = !0, r = null, a = !1, s = !1;
                    if (t1) {
                        const o = J.get(t1);
                        void 0 !== o.__useDefaultFramebuffer ? (Z.bindFramebuffer(gt.FRAMEBUFFER, null), n = !1) : void 0 === o.__webglFramebuffer ? K.setupRenderTarget(t1) : o.__hasExternalTextures && K.rebindTextures(t1, J.get(t1.texture).__webglTexture, J.get(t1.depthTexture).__webglTexture);
                        const l = t1.texture;
                        (l.isData3DTexture || l.isDataArrayTexture || l.isCompressedArrayTexture) && (s = !0);
                        const c = J.get(t1).__webglFramebuffer;
                        t1.isWebGLCubeRenderTarget ? (r = Array.isArray(c[e]) ? c[e][i] : c[e], a = !0) : r = X.isWebGL2 && t1.samples > 0 && !1 === K.useMultisampledRTT(t1) ? J.get(t1).__webglMultisampledFramebuffer : Array.isArray(c) ? c[i] : c, E.copy(t1.viewport), _.copy(t1.scissor), I = t1.scissorTest;
                    } else E.copy(P).multiplyScalar(z).floor(), _.copy(j).multiplyScalar(z).floor(), I = R;
                    if (Z.bindFramebuffer(gt.FRAMEBUFFER, r) && X.drawBuffers && n && Z.drawBuffers(t1, r), Z.viewport(E), Z.scissor(_), Z.setScissorTest(I), a) {
                        const n = J.get(t1.texture);
                        gt.framebufferTexture2D(gt.FRAMEBUFFER, gt.COLOR_ATTACHMENT0, gt.TEXTURE_CUBE_MAP_POSITIVE_X + e, n.__webglTexture, i);
                    } else if (s) {
                        const n = J.get(t1.texture), r = e || 0;
                        gt.framebufferTextureLayer(gt.FRAMEBUFFER, gt.COLOR_ATTACHMENT0, n.__webglTexture, i || 0, r);
                    }
                    b = -1;
                }, this.readRenderTargetPixels = function(t1, e, i, n, r, a, s) {
                    if (!t1 || !t1.isWebGLRenderTarget) return void console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
                    let o = J.get(t1).__webglFramebuffer;
                    if (t1.isWebGLCubeRenderTarget && void 0 !== s && (o = o[s]), o) {
                        Z.bindFramebuffer(gt.FRAMEBUFFER, o);
                        try {
                            const s = t1.texture, o = s.format, l = s.type;
                            if (o !== La && At.convert(o) !== gt.getParameter(gt.IMPLEMENTATION_COLOR_READ_FORMAT)) return void console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.");
                            const c = l === Sa && (Y.has("EXT_color_buffer_half_float") || X.isWebGL2 && Y.has("EXT_color_buffer_float"));
                            if (!(l === xa || At.convert(l) === gt.getParameter(gt.IMPLEMENTATION_COLOR_READ_TYPE) || l === Ia && (X.isWebGL2 || Y.has("OES_texture_float") || Y.has("WEBGL_color_buffer_float")) || c)) return void console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.");
                            e >= 0 && e <= t1.width - n && i >= 0 && i <= t1.height - r && gt.readPixels(e, i, n, r, At.convert(o), At.convert(l), a);
                        } finally{
                            const t1 = null !== w ? J.get(w).__webglFramebuffer : null;
                            Z.bindFramebuffer(gt.FRAMEBUFFER, t1);
                        }
                    }
                }, this.copyFramebufferToTexture = function(t1, e, i = 0) {
                    const n = Math.pow(2, -i), r = Math.floor(e.image.width * n), a = Math.floor(e.image.height * n);
                    K.setTexture2D(e, 0), gt.copyTexSubImage2D(gt.TEXTURE_2D, i, 0, 0, t1.x, t1.y, r, a), Z.unbindTexture();
                }, this.copyTextureToTexture = function(t1, e, i, n = 0) {
                    const r = e.image.width, a = e.image.height, s = At.convert(i.format), o = At.convert(i.type);
                    K.setTexture2D(i, 0), gt.pixelStorei(gt.UNPACK_FLIP_Y_WEBGL, i.flipY), gt.pixelStorei(gt.UNPACK_PREMULTIPLY_ALPHA_WEBGL, i.premultiplyAlpha), gt.pixelStorei(gt.UNPACK_ALIGNMENT, i.unpackAlignment), e.isDataTexture ? gt.texSubImage2D(gt.TEXTURE_2D, n, t1.x, t1.y, r, a, s, o, e.image.data) : e.isCompressedTexture ? gt.compressedTexSubImage2D(gt.TEXTURE_2D, n, t1.x, t1.y, e.mipmaps[0].width, e.mipmaps[0].height, s, e.mipmaps[0].data) : gt.texSubImage2D(gt.TEXTURE_2D, n, t1.x, t1.y, s, o, e.image), 0 === n && i.generateMipmaps && gt.generateMipmap(gt.TEXTURE_2D), Z.unbindTexture();
                }, this.copyTextureToTexture3D = function(t1, e, i, n, r = 0) {
                    if (M.isWebGL1Renderer) return void console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: can only be used with WebGL2.");
                    const a = t1.max.x - t1.min.x + 1, s = t1.max.y - t1.min.y + 1, o = t1.max.z - t1.min.z + 1, l = At.convert(n.format), c = At.convert(n.type);
                    let u;
                    if (n.isData3DTexture) K.setTexture3D(n, 0), u = gt.TEXTURE_3D;
                    else {
                        if (!n.isDataArrayTexture) return void console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: only supports THREE.DataTexture3D and THREE.DataTexture2DArray.");
                        K.setTexture2DArray(n, 0), u = gt.TEXTURE_2D_ARRAY;
                    }
                    gt.pixelStorei(gt.UNPACK_FLIP_Y_WEBGL, n.flipY), gt.pixelStorei(gt.UNPACK_PREMULTIPLY_ALPHA_WEBGL, n.premultiplyAlpha), gt.pixelStorei(gt.UNPACK_ALIGNMENT, n.unpackAlignment);
                    const h = gt.getParameter(gt.UNPACK_ROW_LENGTH), d = gt.getParameter(gt.UNPACK_IMAGE_HEIGHT), p = gt.getParameter(gt.UNPACK_SKIP_PIXELS), A = gt.getParameter(gt.UNPACK_SKIP_ROWS), f = gt.getParameter(gt.UNPACK_SKIP_IMAGES), m = i.isCompressedTexture ? i.mipmaps[0] : i.image;
                    gt.pixelStorei(gt.UNPACK_ROW_LENGTH, m.width), gt.pixelStorei(gt.UNPACK_IMAGE_HEIGHT, m.height), gt.pixelStorei(gt.UNPACK_SKIP_PIXELS, t1.min.x), gt.pixelStorei(gt.UNPACK_SKIP_ROWS, t1.min.y), gt.pixelStorei(gt.UNPACK_SKIP_IMAGES, t1.min.z), i.isDataTexture || i.isData3DTexture ? gt.texSubImage3D(u, r, e.x, e.y, e.z, a, s, o, l, c, m.data) : i.isCompressedArrayTexture ? (console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: untested support for compressed srcTexture."), gt.compressedTexSubImage3D(u, r, e.x, e.y, e.z, a, s, o, l, m.data)) : gt.texSubImage3D(u, r, e.x, e.y, e.z, a, s, o, l, c, m), gt.pixelStorei(gt.UNPACK_ROW_LENGTH, h), gt.pixelStorei(gt.UNPACK_IMAGE_HEIGHT, d), gt.pixelStorei(gt.UNPACK_SKIP_PIXELS, p), gt.pixelStorei(gt.UNPACK_SKIP_ROWS, A), gt.pixelStorei(gt.UNPACK_SKIP_IMAGES, f), 0 === r && n.generateMipmaps && gt.generateMipmap(u), Z.unbindTexture();
                }, this.initTexture = function(t1) {
                    t1.isCubeTexture ? K.setTextureCube(t1, 0) : t1.isData3DTexture ? K.setTexture3D(t1, 0) : t1.isDataArrayTexture || t1.isCompressedArrayTexture ? K.setTexture2DArray(t1, 0) : K.setTexture2D(t1, 0), Z.unbindTexture();
                }, this.resetState = function() {
                    y = 0, x = 0, w = null, Z.reset(), ft.reset();
                }, "undefined" != typeof __THREE_DEVTOOLS__ && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
                    detail: this
                }));
            }
            get coordinateSystem() {
                return Lo;
            }
            get outputColorSpace() {
                return this._outputColorSpace;
            }
            set outputColorSpace(t1) {
                this._outputColorSpace = t1;
                const e = this.getContext();
                e.drawingBufferColorSpace = t1 === Vs ? "display-p3" : "srgb", e.unpackColorSpace = ul.workingColorSpace === Gs ? "display-p3" : "srgb";
            }
            get physicallyCorrectLights() {
                return console.warn("THREE.WebGLRenderer: The property .physicallyCorrectLights has been removed. Set renderer.useLegacyLights instead."), !this.useLegacyLights;
            }
            set physicallyCorrectLights(t1) {
                console.warn("THREE.WebGLRenderer: The property .physicallyCorrectLights has been removed. Set renderer.useLegacyLights instead."), this.useLegacyLights = !t1;
            }
            get outputEncoding() {
                return console.warn("THREE.WebGLRenderer: Property .outputEncoding has been removed. Use .outputColorSpace instead."), this.outputColorSpace === Qs ? js : Ps;
            }
            set outputEncoding(t1) {
                console.warn("THREE.WebGLRenderer: Property .outputEncoding has been removed. Use .outputColorSpace instead."), this.outputColorSpace = t1 === js ? Qs : Hs;
            }
            get useLegacyLights() {
                return console.warn("THREE.WebGLRenderer: The property .useLegacyLights has been deprecated. Migrate your lighting according to the following guide: https://discourse.threejs.org/t/updates-to-lighting-in-three-js-r155/53733."), this._useLegacyLights;
            }
            set useLegacyLights(t1) {
                console.warn("THREE.WebGLRenderer: The property .useLegacyLights has been deprecated. Migrate your lighting according to the following guide: https://discourse.threejs.org/t/updates-to-lighting-in-three-js-r155/53733."), this._useLegacyLights = t1;
            }
        }
        class Hp extends Qp {
        }
        Hp.prototype.isWebGL1Renderer = !0;
        class Vp {
            constructor(t1, e = 25e-5){
                this.isFogExp2 = !0, this.name = "", this.color = new Yc(t1), this.density = e;
            }
            clone() {
                return new Vp(this.color, this.density);
            }
            toJSON() {
                return {
                    type: "FogExp2",
                    name: this.name,
                    color: this.color.getHex(),
                    density: this.density
                };
            }
        }
        class Gp {
            constructor(t1, e = 1, i = 1e3){
                this.isFog = !0, this.name = "", this.color = new Yc(t1), this.near = e, this.far = i;
            }
            clone() {
                return new Gp(this.color, this.near, this.far);
            }
            toJSON() {
                return {
                    type: "Fog",
                    name: this.name,
                    color: this.color.getHex(),
                    near: this.near,
                    far: this.far
                };
            }
        }
        class Wp extends Dc {
            constructor(){
                super(), this.isScene = !0, this.type = "Scene", this.background = null, this.environment = null, this.fog = null, this.backgroundBlurriness = 0, this.backgroundIntensity = 1, this.overrideMaterial = null, "undefined" != typeof __THREE_DEVTOOLS__ && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
                    detail: this
                }));
            }
            copy(t1, e) {
                return super.copy(t1, e), null !== t1.background && (this.background = t1.background.clone()), null !== t1.environment && (this.environment = t1.environment.clone()), null !== t1.fog && (this.fog = t1.fog.clone()), this.backgroundBlurriness = t1.backgroundBlurriness, this.backgroundIntensity = t1.backgroundIntensity, null !== t1.overrideMaterial && (this.overrideMaterial = t1.overrideMaterial.clone()), this.matrixAutoUpdate = t1.matrixAutoUpdate, this;
            }
            toJSON(t1) {
                const e = super.toJSON(t1);
                return null !== this.fog && (e.object.fog = this.fog.toJSON()), this.backgroundBlurriness > 0 && (e.object.backgroundBlurriness = this.backgroundBlurriness), 1 !== this.backgroundIntensity && (e.object.backgroundIntensity = this.backgroundIntensity), e;
            }
        }
        class Yp {
            constructor(t1, e){
                this.isInterleavedBuffer = !0, this.array = t1, this.stride = e, this.count = void 0 !== t1 ? t1.length / e : 0, this.usage = xo, this.updateRange = {
                    offset: 0,
                    count: -1
                }, this.version = 0, this.uuid = Bo();
            }
            onUploadCallback() {}
            set needsUpdate(t1) {
                !0 === t1 && this.version++;
            }
            setUsage(t1) {
                return this.usage = t1, this;
            }
            copy(t1) {
                return this.array = new t1.array.constructor(t1.array), this.count = t1.count, this.stride = t1.stride, this.usage = t1.usage, this;
            }
            copyAt(t1, e, i) {
                t1 *= this.stride, i *= e.stride;
                for(let n = 0, r = this.stride; n < r; n++)this.array[t1 + n] = e.array[i + n];
                return this;
            }
            set(t1, e = 0) {
                return this.array.set(t1, e), this;
            }
            clone(t1) {
                void 0 === t1.arrayBuffers && (t1.arrayBuffers = {}), void 0 === this.array.buffer._uuid && (this.array.buffer._uuid = Bo()), void 0 === t1.arrayBuffers[this.array.buffer._uuid] && (t1.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer);
                const e = new this.array.constructor(t1.arrayBuffers[this.array.buffer._uuid]), i = new this.constructor(e, this.stride);
                return i.setUsage(this.usage), i;
            }
            onUpload(t1) {
                return this.onUploadCallback = t1, this;
            }
            toJSON(t1) {
                return void 0 === t1.arrayBuffers && (t1.arrayBuffers = {}), void 0 === this.array.buffer._uuid && (this.array.buffer._uuid = Bo()), void 0 === t1.arrayBuffers[this.array.buffer._uuid] && (t1.arrayBuffers[this.array.buffer._uuid] = Array.from(new Uint32Array(this.array.buffer))), {
                    uuid: this.uuid,
                    buffer: this.array.buffer._uuid,
                    type: this.array.constructor.name,
                    stride: this.stride
                };
            }
        }
        const Xp = new Nl;
        class Zp {
            constructor(t1, e, i, n = !1){
                this.isInterleavedBufferAttribute = !0, this.name = "", this.data = t1, this.itemSize = e, this.offset = i, this.normalized = n;
            }
            get count() {
                return this.data.count;
            }
            get array() {
                return this.data.array;
            }
            set needsUpdate(t1) {
                this.data.needsUpdate = t1;
            }
            applyMatrix4(t1) {
                for(let e = 0, i = this.data.count; e < i; e++)Xp.fromBufferAttribute(this, e), Xp.applyMatrix4(t1), this.setXYZ(e, Xp.x, Xp.y, Xp.z);
                return this;
            }
            applyNormalMatrix(t1) {
                for(let e = 0, i = this.count; e < i; e++)Xp.fromBufferAttribute(this, e), Xp.applyNormalMatrix(t1), this.setXYZ(e, Xp.x, Xp.y, Xp.z);
                return this;
            }
            transformDirection(t1) {
                for(let e = 0, i = this.count; e < i; e++)Xp.fromBufferAttribute(this, e), Xp.transformDirection(t1), this.setXYZ(e, Xp.x, Xp.y, Xp.z);
                return this;
            }
            setX(t1, e) {
                return this.normalized && (e = Xo(e, this.array)), this.data.array[t1 * this.data.stride + this.offset] = e, this;
            }
            setY(t1, e) {
                return this.normalized && (e = Xo(e, this.array)), this.data.array[t1 * this.data.stride + this.offset + 1] = e, this;
            }
            setZ(t1, e) {
                return this.normalized && (e = Xo(e, this.array)), this.data.array[t1 * this.data.stride + this.offset + 2] = e, this;
            }
            setW(t1, e) {
                return this.normalized && (e = Xo(e, this.array)), this.data.array[t1 * this.data.stride + this.offset + 3] = e, this;
            }
            getX(t1) {
                let e = this.data.array[t1 * this.data.stride + this.offset];
                return this.normalized && (e = Yo(e, this.array)), e;
            }
            getY(t1) {
                let e = this.data.array[t1 * this.data.stride + this.offset + 1];
                return this.normalized && (e = Yo(e, this.array)), e;
            }
            getZ(t1) {
                let e = this.data.array[t1 * this.data.stride + this.offset + 2];
                return this.normalized && (e = Yo(e, this.array)), e;
            }
            getW(t1) {
                let e = this.data.array[t1 * this.data.stride + this.offset + 3];
                return this.normalized && (e = Yo(e, this.array)), e;
            }
            setXY(t1, e, i) {
                return t1 = t1 * this.data.stride + this.offset, this.normalized && (e = Xo(e, this.array), i = Xo(i, this.array)), this.data.array[t1 + 0] = e, this.data.array[t1 + 1] = i, this;
            }
            setXYZ(t1, e, i, n) {
                return t1 = t1 * this.data.stride + this.offset, this.normalized && (e = Xo(e, this.array), i = Xo(i, this.array), n = Xo(n, this.array)), this.data.array[t1 + 0] = e, this.data.array[t1 + 1] = i, this.data.array[t1 + 2] = n, this;
            }
            setXYZW(t1, e, i, n, r) {
                return t1 = t1 * this.data.stride + this.offset, this.normalized && (e = Xo(e, this.array), i = Xo(i, this.array), n = Xo(n, this.array), r = Xo(r, this.array)), this.data.array[t1 + 0] = e, this.data.array[t1 + 1] = i, this.data.array[t1 + 2] = n, this.data.array[t1 + 3] = r, this;
            }
            clone(t1) {
                if (void 0 === t1) {
                    console.log("THREE.InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will de-interleave buffer data.");
                    const t1 = [];
                    for(let e = 0; e < this.count; e++){
                        const i = e * this.data.stride + this.offset;
                        for(let e = 0; e < this.itemSize; e++)t1.push(this.data.array[i + e]);
                    }
                    return new au(new this.array.constructor(t1), this.itemSize, this.normalized);
                }
                return void 0 === t1.interleavedBuffers && (t1.interleavedBuffers = {}), void 0 === t1.interleavedBuffers[this.data.uuid] && (t1.interleavedBuffers[this.data.uuid] = this.data.clone(t1)), new Zp(t1.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
            }
            toJSON(t1) {
                if (void 0 === t1) {
                    console.log("THREE.InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will de-interleave buffer data.");
                    const t1 = [];
                    for(let e = 0; e < this.count; e++){
                        const i = e * this.data.stride + this.offset;
                        for(let e = 0; e < this.itemSize; e++)t1.push(this.data.array[i + e]);
                    }
                    return {
                        itemSize: this.itemSize,
                        type: this.array.constructor.name,
                        array: t1,
                        normalized: this.normalized
                    };
                }
                return void 0 === t1.interleavedBuffers && (t1.interleavedBuffers = {}), void 0 === t1.interleavedBuffers[this.data.uuid] && (t1.interleavedBuffers[this.data.uuid] = this.data.toJSON(t1)), {
                    isInterleavedBufferAttribute: !0,
                    itemSize: this.itemSize,
                    data: this.data.uuid,
                    offset: this.offset,
                    normalized: this.normalized
                };
            }
        }
        class qp extends qc {
            constructor(t1){
                super(), this.isSpriteMaterial = !0, this.type = "SpriteMaterial", this.color = new Yc(16777215), this.map = null, this.alphaMap = null, this.rotation = 0, this.sizeAttenuation = !0, this.transparent = !0, this.fog = !0, this.setValues(t1);
            }
            copy(t1) {
                return super.copy(t1), this.color.copy(t1.color), this.map = t1.map, this.alphaMap = t1.alphaMap, this.rotation = t1.rotation, this.sizeAttenuation = t1.sizeAttenuation, this.fog = t1.fog, this;
            }
        }
        let Jp;
        const Kp = new Nl, $p = new Nl, tA = new Nl, eA = new qo, iA = new qo, nA = new ac, rA = new Nl, aA = new Nl, sA = new Nl, oA = new qo, lA = new qo, cA = new qo;
        class uA extends Dc {
            constructor(t1 = new qp){
                if (super(), this.isSprite = !0, this.type = "Sprite", void 0 === Jp) {
                    Jp = new bu;
                    const t1 = new Float32Array([
                        -0.5,
                        -0.5,
                        0,
                        0,
                        0,
                        .5,
                        -0.5,
                        0,
                        1,
                        0,
                        .5,
                        .5,
                        0,
                        1,
                        1,
                        -0.5,
                        .5,
                        0,
                        0,
                        1
                    ]), e = new Yp(t1, 5);
                    Jp.setIndex([
                        0,
                        1,
                        2,
                        0,
                        2,
                        3
                    ]), Jp.setAttribute("position", new Zp(e, 3, 0, !1)), Jp.setAttribute("uv", new Zp(e, 2, 3, !1));
                }
                this.geometry = Jp, this.material = t1, this.center = new qo(.5, .5);
            }
            raycast(t1, e) {
                null === t1.camera && console.error('THREE.Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.'), $p.setFromMatrixScale(this.matrixWorld), nA.copy(t1.camera.matrixWorld), this.modelViewMatrix.multiplyMatrices(t1.camera.matrixWorldInverse, this.matrixWorld), tA.setFromMatrixPosition(this.modelViewMatrix), t1.camera.isPerspectiveCamera && !1 === this.material.sizeAttenuation && $p.multiplyScalar(-tA.z);
                const i = this.material.rotation;
                let n, r;
                0 !== i && (r = Math.cos(i), n = Math.sin(i));
                const a = this.center;
                hA(rA.set(-0.5, -0.5, 0), tA, a, $p, n, r), hA(aA.set(.5, -0.5, 0), tA, a, $p, n, r), hA(sA.set(.5, .5, 0), tA, a, $p, n, r), oA.set(0, 0), lA.set(1, 0), cA.set(1, 1);
                let s = t1.ray.intersectTriangle(rA, aA, sA, !1, Kp);
                if (null === s && (hA(aA.set(-0.5, .5, 0), tA, a, $p, n, r), lA.set(0, 1), s = t1.ray.intersectTriangle(rA, sA, aA, !1, Kp), null === s)) return;
                const o = t1.ray.origin.distanceTo(Kp);
                o < t1.near || o > t1.far || e.push({
                    distance: o,
                    point: Kp.clone(),
                    uv: Qc.getInterpolation(Kp, rA, aA, sA, oA, lA, cA, new qo),
                    face: null,
                    object: this
                });
            }
            copy(t1, e) {
                return super.copy(t1, e), void 0 !== t1.center && this.center.copy(t1.center), this.material = t1.material, this;
            }
        }
        function hA(t1, e, i, n, r, a) {
            eA.subVectors(t1, i).addScalar(.5).multiply(n), void 0 !== r ? (iA.x = a * eA.x - r * eA.y, iA.y = r * eA.x + a * eA.y) : iA.copy(eA), t1.copy(e), t1.x += iA.x, t1.y += iA.y, t1.applyMatrix4(nA);
        }
        const dA = new Nl, pA = new Nl;
        class AA extends Dc {
            constructor(){
                super(), this._currentLevel = 0, this.type = "LOD", Object.defineProperties(this, {
                    levels: {
                        enumerable: !0,
                        value: []
                    },
                    isLOD: {
                        value: !0
                    }
                }), this.autoUpdate = !0;
            }
            copy(t1) {
                super.copy(t1, !1);
                const e = t1.levels;
                for(let t1 = 0, i = e.length; t1 < i; t1++){
                    const i = e[t1];
                    this.addLevel(i.object.clone(), i.distance, i.hysteresis);
                }
                return this.autoUpdate = t1.autoUpdate, this;
            }
            addLevel(t1, e = 0, i = 0) {
                e = Math.abs(e);
                const n = this.levels;
                let r;
                for(r = 0; r < n.length && !(e < n[r].distance); r++);
                return n.splice(r, 0, {
                    distance: e,
                    hysteresis: i,
                    object: t1
                }), this.add(t1), this;
            }
            getCurrentLevel() {
                return this._currentLevel;
            }
            getObjectForDistance(t1) {
                const e = this.levels;
                if (e.length > 0) {
                    let i, n;
                    for(i = 1, n = e.length; i < n; i++){
                        let n = e[i].distance;
                        if (e[i].object.visible && (n -= n * e[i].hysteresis), t1 < n) break;
                    }
                    return e[i - 1].object;
                }
                return null;
            }
            raycast(t1, e) {
                if (this.levels.length > 0) {
                    dA.setFromMatrixPosition(this.matrixWorld);
                    const i = t1.ray.origin.distanceTo(dA);
                    this.getObjectForDistance(i).raycast(t1, e);
                }
            }
            update(t1) {
                const e = this.levels;
                if (e.length > 1) {
                    dA.setFromMatrixPosition(t1.matrixWorld), pA.setFromMatrixPosition(this.matrixWorld);
                    const i = dA.distanceTo(pA) / t1.zoom;
                    let n, r;
                    for(e[0].object.visible = !0, n = 1, r = e.length; n < r; n++){
                        let t1 = e[n].distance;
                        if (e[n].object.visible && (t1 -= t1 * e[n].hysteresis), !(i >= t1)) break;
                        e[n - 1].object.visible = !1, e[n].object.visible = !0;
                    }
                    for(this._currentLevel = n - 1; n < r; n++)e[n].object.visible = !1;
                }
            }
            toJSON(t1) {
                const e = super.toJSON(t1);
                !1 === this.autoUpdate && (e.object.autoUpdate = !1), e.object.levels = [];
                const i = this.levels;
                for(let t1 = 0, n = i.length; t1 < n; t1++){
                    const n = i[t1];
                    e.object.levels.push({
                        object: n.object.uuid,
                        distance: n.distance,
                        hysteresis: n.hysteresis
                    });
                }
                return e;
            }
        }
        const fA = new Nl, mA = new yl, gA = new yl, MA = new Nl, vA = new ac, yA = new Nl, xA = new ql, wA = new ac, bA = new rc;
        class TA extends Fu {
            constructor(t1, e){
                super(t1, e), this.isSkinnedMesh = !0, this.type = "SkinnedMesh", this.bindMode = ta, this.bindMatrix = new ac, this.bindMatrixInverse = new ac, this.boundingBox = null, this.boundingSphere = null;
            }
            computeBoundingBox() {
                const t1 = this.geometry;
                null === this.boundingBox && (this.boundingBox = new zl), this.boundingBox.makeEmpty();
                const e = t1.getAttribute("position");
                for(let t1 = 0; t1 < e.count; t1++)this.getVertexPosition(t1, yA), this.boundingBox.expandByPoint(yA);
            }
            computeBoundingSphere() {
                const t1 = this.geometry;
                null === this.boundingSphere && (this.boundingSphere = new ql), this.boundingSphere.makeEmpty();
                const e = t1.getAttribute("position");
                for(let t1 = 0; t1 < e.count; t1++)this.getVertexPosition(t1, yA), this.boundingSphere.expandByPoint(yA);
            }
            copy(t1, e) {
                return super.copy(t1, e), this.bindMode = t1.bindMode, this.bindMatrix.copy(t1.bindMatrix), this.bindMatrixInverse.copy(t1.bindMatrixInverse), this.skeleton = t1.skeleton, null !== t1.boundingBox && (this.boundingBox = t1.boundingBox.clone()), null !== t1.boundingSphere && (this.boundingSphere = t1.boundingSphere.clone()), this;
            }
            raycast(t1, e) {
                const i = this.material, n = this.matrixWorld;
                void 0 !== i && (null === this.boundingSphere && this.computeBoundingSphere(), xA.copy(this.boundingSphere), xA.applyMatrix4(n), !1 !== t1.ray.intersectsSphere(xA) && (wA.copy(n).invert(), bA.copy(t1.ray).applyMatrix4(wA), null !== this.boundingBox && !1 === bA.intersectsBox(this.boundingBox) || this._computeIntersections(t1, e, bA)));
            }
            getVertexPosition(t1, e) {
                return super.getVertexPosition(t1, e), this.applyBoneTransform(t1, e), e;
            }
            bind(t1, e) {
                this.skeleton = t1, void 0 === e && (this.updateMatrixWorld(!0), this.skeleton.calculateInverses(), e = this.matrixWorld), this.bindMatrix.copy(e), this.bindMatrixInverse.copy(e).invert();
            }
            pose() {
                this.skeleton.pose();
            }
            normalizeSkinWeights() {
                const t1 = new yl, e = this.geometry.attributes.skinWeight;
                for(let i = 0, n = e.count; i < n; i++){
                    t1.fromBufferAttribute(e, i);
                    const n = 1 / t1.manhattanLength();
                    n !== 1 / 0 ? t1.multiplyScalar(n) : t1.set(1, 0, 0, 0), e.setXYZW(i, t1.x, t1.y, t1.z, t1.w);
                }
            }
            updateMatrixWorld(t1) {
                super.updateMatrixWorld(t1), this.bindMode === ta ? this.bindMatrixInverse.copy(this.matrixWorld).invert() : this.bindMode === ea ? this.bindMatrixInverse.copy(this.bindMatrix).invert() : console.warn("THREE.SkinnedMesh: Unrecognized bindMode: " + this.bindMode);
            }
            applyBoneTransform(t1, e) {
                const i = this.skeleton, n = this.geometry;
                mA.fromBufferAttribute(n.attributes.skinIndex, t1), gA.fromBufferAttribute(n.attributes.skinWeight, t1), fA.copy(e).applyMatrix4(this.bindMatrix), e.set(0, 0, 0);
                for(let t1 = 0; t1 < 4; t1++){
                    const n = gA.getComponent(t1);
                    if (0 !== n) {
                        const r = mA.getComponent(t1);
                        vA.multiplyMatrices(i.bones[r].matrixWorld, i.boneInverses[r]), e.addScaledVector(MA.copy(fA).applyMatrix4(vA), n);
                    }
                }
                return e.applyMatrix4(this.bindMatrixInverse);
            }
            boneTransform(t1, e) {
                return console.warn("THREE.SkinnedMesh: .boneTransform() was renamed to .applyBoneTransform() in r151."), this.applyBoneTransform(t1, e);
            }
        }
        class EA extends Dc {
            constructor(){
                super(), this.isBone = !0, this.type = "Bone";
            }
        }
        class _A extends vl {
            constructor(t1 = null, e = 1, i = 1, n, r, a, s, o, l = ha, c = ha, u, h){
                super(null, a, s, o, l, c, n, r, u, h), this.isDataTexture = !0, this.image = {
                    data: t1,
                    width: e,
                    height: i
                }, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
            }
        }
        const IA = new ac, SA = new ac;
        class NA {
            constructor(t1 = [], e = []){
                this.uuid = Bo(), this.bones = t1.slice(0), this.boneInverses = e, this.boneMatrices = null, this.boneTexture = null, this.boneTextureSize = 0, this.init();
            }
            init() {
                const t1 = this.bones, e = this.boneInverses;
                if (this.boneMatrices = new Float32Array(16 * t1.length), 0 === e.length) this.calculateInverses();
                else if (t1.length !== e.length) {
                    console.warn("THREE.Skeleton: Number of inverse bone matrices does not match amount of bones."), this.boneInverses = [];
                    for(let t1 = 0, e = this.bones.length; t1 < e; t1++)this.boneInverses.push(new ac);
                }
            }
            calculateInverses() {
                this.boneInverses.length = 0;
                for(let t1 = 0, e = this.bones.length; t1 < e; t1++){
                    const e = new ac;
                    this.bones[t1] && e.copy(this.bones[t1].matrixWorld).invert(), this.boneInverses.push(e);
                }
            }
            pose() {
                for(let t1 = 0, e = this.bones.length; t1 < e; t1++){
                    const e = this.bones[t1];
                    e && e.matrixWorld.copy(this.boneInverses[t1]).invert();
                }
                for(let t1 = 0, e = this.bones.length; t1 < e; t1++){
                    const e = this.bones[t1];
                    e && (e.parent && e.parent.isBone ? (e.matrix.copy(e.parent.matrixWorld).invert(), e.matrix.multiply(e.matrixWorld)) : e.matrix.copy(e.matrixWorld), e.matrix.decompose(e.position, e.quaternion, e.scale));
                }
            }
            update() {
                const t1 = this.bones, e = this.boneInverses, i = this.boneMatrices, n = this.boneTexture;
                for(let n = 0, r = t1.length; n < r; n++){
                    const r = t1[n] ? t1[n].matrixWorld : SA;
                    IA.multiplyMatrices(r, e[n]), IA.toArray(i, 16 * n);
                }
                null !== n && (n.needsUpdate = !0);
            }
            clone() {
                return new NA(this.bones, this.boneInverses);
            }
            computeBoneTexture() {
                let t1 = Math.sqrt(4 * this.bones.length);
                t1 = Go(t1), t1 = Math.max(t1, 4);
                const e = new Float32Array(t1 * t1 * 4);
                e.set(this.boneMatrices);
                const i = new _A(e, t1, t1, La, Ia);
                return i.needsUpdate = !0, this.boneMatrices = e, this.boneTexture = i, this.boneTextureSize = t1, this;
            }
            getBoneByName(t1) {
                for(let e = 0, i = this.bones.length; e < i; e++){
                    const i = this.bones[e];
                    if (i.name === t1) return i;
                }
            }
            dispose() {
                null !== this.boneTexture && (this.boneTexture.dispose(), this.boneTexture = null);
            }
            fromJSON(t1, e) {
                this.uuid = t1.uuid;
                for(let i = 0, n = t1.bones.length; i < n; i++){
                    const n = t1.bones[i];
                    let r = e[n];
                    void 0 === r && (console.warn("THREE.Skeleton: No bone found with UUID:", n), r = new EA), this.bones.push(r), this.boneInverses.push((new ac).fromArray(t1.boneInverses[i]));
                }
                return this.init(), this;
            }
            toJSON() {
                const t1 = {
                    metadata: {
                        version: 4.6,
                        type: "Skeleton",
                        generator: "Skeleton.toJSON"
                    },
                    bones: [],
                    boneInverses: []
                };
                t1.uuid = this.uuid;
                const e = this.bones, i = this.boneInverses;
                for(let n = 0, r = e.length; n < r; n++){
                    const r = e[n];
                    t1.bones.push(r.uuid);
                    const a = i[n];
                    t1.boneInverses.push(a.toArray());
                }
                return t1;
            }
        }
        class DA extends au {
            constructor(t1, e, i, n = 1){
                super(t1, e, i), this.isInstancedBufferAttribute = !0, this.meshPerAttribute = n;
            }
            copy(t1) {
                return super.copy(t1), this.meshPerAttribute = t1.meshPerAttribute, this;
            }
            toJSON() {
                const t1 = super.toJSON();
                return t1.meshPerAttribute = this.meshPerAttribute, t1.isInstancedBufferAttribute = !0, t1;
            }
        }
        const CA = new ac, zA = new ac, LA = [], OA = new zl, PA = new ac, jA = new Fu, RA = new ql;
        class kA extends Fu {
            constructor(t1, e, i){
                super(t1, e), this.isInstancedMesh = !0, this.instanceMatrix = new DA(new Float32Array(16 * i), 16), this.instanceColor = null, this.count = i, this.boundingBox = null, this.boundingSphere = null;
                for(let t1 = 0; t1 < i; t1++)this.setMatrixAt(t1, PA);
            }
            computeBoundingBox() {
                const t1 = this.geometry, e = this.count;
                null === this.boundingBox && (this.boundingBox = new zl), null === t1.boundingBox && t1.computeBoundingBox(), this.boundingBox.makeEmpty();
                for(let i = 0; i < e; i++)this.getMatrixAt(i, CA), OA.copy(t1.boundingBox).applyMatrix4(CA), this.boundingBox.union(OA);
            }
            computeBoundingSphere() {
                const t1 = this.geometry, e = this.count;
                null === this.boundingSphere && (this.boundingSphere = new ql), null === t1.boundingSphere && t1.computeBoundingSphere(), this.boundingSphere.makeEmpty();
                for(let i = 0; i < e; i++)this.getMatrixAt(i, CA), RA.copy(t1.boundingSphere).applyMatrix4(CA), this.boundingSphere.union(RA);
            }
            copy(t1, e) {
                return super.copy(t1, e), this.instanceMatrix.copy(t1.instanceMatrix), null !== t1.instanceColor && (this.instanceColor = t1.instanceColor.clone()), this.count = t1.count, null !== t1.boundingBox && (this.boundingBox = t1.boundingBox.clone()), null !== t1.boundingSphere && (this.boundingSphere = t1.boundingSphere.clone()), this;
            }
            getColorAt(t1, e) {
                e.fromArray(this.instanceColor.array, 3 * t1);
            }
            getMatrixAt(t1, e) {
                e.fromArray(this.instanceMatrix.array, 16 * t1);
            }
            raycast(t1, e) {
                const i = this.matrixWorld, n = this.count;
                if (jA.geometry = this.geometry, jA.material = this.material, void 0 !== jA.material && (null === this.boundingSphere && this.computeBoundingSphere(), RA.copy(this.boundingSphere), RA.applyMatrix4(i), !1 !== t1.ray.intersectsSphere(RA))) for(let r = 0; r < n; r++){
                    this.getMatrixAt(r, CA), zA.multiplyMatrices(i, CA), jA.matrixWorld = zA, jA.raycast(t1, LA);
                    for(let t1 = 0, i = LA.length; t1 < i; t1++){
                        const i = LA[t1];
                        i.instanceId = r, i.object = this, e.push(i);
                    }
                    LA.length = 0;
                }
            }
            setColorAt(t1, e) {
                null === this.instanceColor && (this.instanceColor = new DA(new Float32Array(3 * this.instanceMatrix.count), 3)), e.toArray(this.instanceColor.array, 3 * t1);
            }
            setMatrixAt(t1, e) {
                e.toArray(this.instanceMatrix.array, 16 * t1);
            }
            updateMorphTargets() {}
            dispose() {
                this.dispatchEvent({
                    type: "dispose"
                });
            }
        }
        class UA extends qc {
            constructor(t1){
                super(), this.isLineBasicMaterial = !0, this.type = "LineBasicMaterial", this.color = new Yc(16777215), this.map = null, this.linewidth = 1, this.linecap = "round", this.linejoin = "round", this.fog = !0, this.setValues(t1);
            }
            copy(t1) {
                return super.copy(t1), this.color.copy(t1.color), this.map = t1.map, this.linewidth = t1.linewidth, this.linecap = t1.linecap, this.linejoin = t1.linejoin, this.fog = t1.fog, this;
            }
        }
        const BA = new Nl, FA = new Nl, QA = new ac, HA = new rc, VA = new ql;
        class GA extends Dc {
            constructor(t1 = new bu, e = new UA){
                super(), this.isLine = !0, this.type = "Line", this.geometry = t1, this.material = e, this.updateMorphTargets();
            }
            copy(t1, e) {
                return super.copy(t1, e), this.material = Array.isArray(t1.material) ? t1.material.slice() : t1.material, this.geometry = t1.geometry, this;
            }
            computeLineDistances() {
                const t1 = this.geometry;
                if (null === t1.index) {
                    const e = t1.attributes.position, i = [
                        0
                    ];
                    for(let t1 = 1, n = e.count; t1 < n; t1++)BA.fromBufferAttribute(e, t1 - 1), FA.fromBufferAttribute(e, t1), i[t1] = i[t1 - 1], i[t1] += BA.distanceTo(FA);
                    t1.setAttribute("lineDistance", new Au(i, 1));
                } else console.warn("THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
                return this;
            }
            raycast(t1, e) {
                const i = this.geometry, n = this.matrixWorld, r = t1.params.Line.threshold, a = i.drawRange;
                if (null === i.boundingSphere && i.computeBoundingSphere(), VA.copy(i.boundingSphere), VA.applyMatrix4(n), VA.radius += r, !1 === t1.ray.intersectsSphere(VA)) return;
                QA.copy(n).invert(), HA.copy(t1.ray).applyMatrix4(QA);
                const s = r / ((this.scale.x + this.scale.y + this.scale.z) / 3), o = s * s, l = new Nl, c = new Nl, u = new Nl, h = new Nl, d = this.isLineSegments ? 2 : 1, p = i.index, A = i.attributes.position;
                if (null !== p) for(let i = Math.max(0, a.start), n = Math.min(p.count, a.start + a.count) - 1; i < n; i += d){
                    const n = p.getX(i), r = p.getX(i + 1);
                    if (l.fromBufferAttribute(A, n), c.fromBufferAttribute(A, r), HA.distanceSqToSegment(l, c, h, u) > o) continue;
                    h.applyMatrix4(this.matrixWorld);
                    const a = t1.ray.origin.distanceTo(h);
                    a < t1.near || a > t1.far || e.push({
                        distance: a,
                        point: u.clone().applyMatrix4(this.matrixWorld),
                        index: i,
                        face: null,
                        faceIndex: null,
                        object: this
                    });
                }
                else for(let i = Math.max(0, a.start), n = Math.min(A.count, a.start + a.count) - 1; i < n; i += d){
                    if (l.fromBufferAttribute(A, i), c.fromBufferAttribute(A, i + 1), HA.distanceSqToSegment(l, c, h, u) > o) continue;
                    h.applyMatrix4(this.matrixWorld);
                    const n = t1.ray.origin.distanceTo(h);
                    n < t1.near || n > t1.far || e.push({
                        distance: n,
                        point: u.clone().applyMatrix4(this.matrixWorld),
                        index: i,
                        face: null,
                        faceIndex: null,
                        object: this
                    });
                }
            }
            updateMorphTargets() {
                const t1 = this.geometry.morphAttributes, e = Object.keys(t1);
                if (e.length > 0) {
                    const i = t1[e[0]];
                    if (void 0 !== i) {
                        this.morphTargetInfluences = [], this.morphTargetDictionary = {};
                        for(let t1 = 0, e = i.length; t1 < e; t1++){
                            const e = i[t1].name || String(t1);
                            this.morphTargetInfluences.push(0), this.morphTargetDictionary[e] = t1;
                        }
                    }
                }
            }
        }
        const WA = new Nl, YA = new Nl;
        class XA extends GA {
            constructor(t1, e){
                super(t1, e), this.isLineSegments = !0, this.type = "LineSegments";
            }
            computeLineDistances() {
                const t1 = this.geometry;
                if (null === t1.index) {
                    const e = t1.attributes.position, i = [];
                    for(let t1 = 0, n = e.count; t1 < n; t1 += 2)WA.fromBufferAttribute(e, t1), YA.fromBufferAttribute(e, t1 + 1), i[t1] = 0 === t1 ? 0 : i[t1 - 1], i[t1 + 1] = i[t1] + WA.distanceTo(YA);
                    t1.setAttribute("lineDistance", new Au(i, 1));
                } else console.warn("THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
                return this;
            }
        }
        class ZA extends GA {
            constructor(t1, e){
                super(t1, e), this.isLineLoop = !0, this.type = "LineLoop";
            }
        }
        class qA extends qc {
            constructor(t1){
                super(), this.isPointsMaterial = !0, this.type = "PointsMaterial", this.color = new Yc(16777215), this.map = null, this.alphaMap = null, this.size = 1, this.sizeAttenuation = !0, this.fog = !0, this.setValues(t1);
            }
            copy(t1) {
                return super.copy(t1), this.color.copy(t1.color), this.map = t1.map, this.alphaMap = t1.alphaMap, this.size = t1.size, this.sizeAttenuation = t1.sizeAttenuation, this.fog = t1.fog, this;
            }
        }
        const JA = new ac, KA = new rc, $A = new ql, tf = new Nl;
        class ef extends Dc {
            constructor(t1 = new bu, e = new qA){
                super(), this.isPoints = !0, this.type = "Points", this.geometry = t1, this.material = e, this.updateMorphTargets();
            }
            copy(t1, e) {
                return super.copy(t1, e), this.material = Array.isArray(t1.material) ? t1.material.slice() : t1.material, this.geometry = t1.geometry, this;
            }
            raycast(t1, e) {
                const i = this.geometry, n = this.matrixWorld, r = t1.params.Points.threshold, a = i.drawRange;
                if (null === i.boundingSphere && i.computeBoundingSphere(), $A.copy(i.boundingSphere), $A.applyMatrix4(n), $A.radius += r, !1 === t1.ray.intersectsSphere($A)) return;
                JA.copy(n).invert(), KA.copy(t1.ray).applyMatrix4(JA);
                const s = r / ((this.scale.x + this.scale.y + this.scale.z) / 3), o = s * s, l = i.index, c = i.attributes.position;
                if (null !== l) for(let i = Math.max(0, a.start), r = Math.min(l.count, a.start + a.count); i < r; i++){
                    const r = l.getX(i);
                    tf.fromBufferAttribute(c, r), nf(tf, r, o, n, t1, e, this);
                }
                else for(let i = Math.max(0, a.start), r = Math.min(c.count, a.start + a.count); i < r; i++)tf.fromBufferAttribute(c, i), nf(tf, i, o, n, t1, e, this);
            }
            updateMorphTargets() {
                const t1 = this.geometry.morphAttributes, e = Object.keys(t1);
                if (e.length > 0) {
                    const i = t1[e[0]];
                    if (void 0 !== i) {
                        this.morphTargetInfluences = [], this.morphTargetDictionary = {};
                        for(let t1 = 0, e = i.length; t1 < e; t1++){
                            const e = i[t1].name || String(t1);
                            this.morphTargetInfluences.push(0), this.morphTargetDictionary[e] = t1;
                        }
                    }
                }
            }
        }
        function nf(t1, e, i, n, r, a, s) {
            const o = KA.distanceSqToPoint(t1);
            if (o < i) {
                const i = new Nl;
                KA.closestPointToPoint(t1, i), i.applyMatrix4(n);
                const l = r.ray.origin.distanceTo(i);
                if (l < r.near || l > r.far) return;
                a.push({
                    distance: l,
                    distanceToRay: Math.sqrt(o),
                    point: i,
                    index: e,
                    face: null,
                    object: s
                });
            }
        }
        class rf extends vl {
            constructor(t1, e, i, n, r, a, s, o, l){
                super(t1, e, i, n, r, a, s, o, l), this.isVideoTexture = !0, this.minFilter = void 0 !== a ? a : ma, this.magFilter = void 0 !== r ? r : ma, this.generateMipmaps = !1;
                const c = this;
                "requestVideoFrameCallback" in t1 && t1.requestVideoFrameCallback(function e() {
                    c.needsUpdate = !0, t1.requestVideoFrameCallback(e);
                });
            }
            clone() {
                return new this.constructor(this.image).copy(this);
            }
            update() {
                const t1 = this.image;
                !1 == "requestVideoFrameCallback" in t1 && t1.readyState >= t1.HAVE_CURRENT_DATA && (this.needsUpdate = !0);
            }
        }
        class af extends vl {
            constructor(t1, e){
                super({
                    width: t1,
                    height: e
                }), this.isFramebufferTexture = !0, this.magFilter = ha, this.minFilter = ha, this.generateMipmaps = !1, this.needsUpdate = !0;
            }
        }
        class sf extends vl {
            constructor(t1, e, i, n, r, a, s, o, l, c, u, h){
                super(null, a, s, o, l, c, n, r, u, h), this.isCompressedTexture = !0, this.image = {
                    width: e,
                    height: i
                }, this.mipmaps = t1, this.flipY = !1, this.generateMipmaps = !1;
            }
        }
        class of extends sf {
            constructor(t1, e, i, n, r, a){
                super(t1, e, i, r, a), this.isCompressedArrayTexture = !0, this.image.depth = n, this.wrapR = ca;
            }
        }
        class lf extends sf {
            constructor(t1, e, i){
                super(void 0, t1[0].width, t1[0].height, e, i, na), this.isCompressedCubeTexture = !0, this.isCubeTexture = !0, this.image = t1;
            }
        }
        class cf extends vl {
            constructor(t1, e, i, n, r, a, s, o, l){
                super(t1, e, i, n, r, a, s, o, l), this.isCanvasTexture = !0, this.needsUpdate = !0;
            }
        }
        class uf {
            constructor(){
                this.type = "Curve", this.arcLengthDivisions = 200;
            }
            getPoint() {
                return console.warn("THREE.Curve: .getPoint() not implemented."), null;
            }
            getPointAt(t1, e) {
                const i = this.getUtoTmapping(t1);
                return this.getPoint(i, e);
            }
            getPoints(t1 = 5) {
                const e = [];
                for(let i = 0; i <= t1; i++)e.push(this.getPoint(i / t1));
                return e;
            }
            getSpacedPoints(t1 = 5) {
                const e = [];
                for(let i = 0; i <= t1; i++)e.push(this.getPointAt(i / t1));
                return e;
            }
            getLength() {
                const t1 = this.getLengths();
                return t1[t1.length - 1];
            }
            getLengths(t1 = this.arcLengthDivisions) {
                if (this.cacheArcLengths && this.cacheArcLengths.length === t1 + 1 && !this.needsUpdate) return this.cacheArcLengths;
                this.needsUpdate = !1;
                const e = [];
                let i, n = this.getPoint(0), r = 0;
                e.push(0);
                for(let a = 1; a <= t1; a++)i = this.getPoint(a / t1), r += i.distanceTo(n), e.push(r), n = i;
                return this.cacheArcLengths = e, e;
            }
            updateArcLengths() {
                this.needsUpdate = !0, this.getLengths();
            }
            getUtoTmapping(t1, e) {
                const i = this.getLengths();
                let n = 0;
                const r = i.length;
                let a;
                a = e || t1 * i[r - 1];
                let s, o = 0, l = r - 1;
                for(; o <= l;)if (n = Math.floor(o + (l - o) / 2), s = i[n] - a, s < 0) o = n + 1;
                else {
                    if (!(s > 0)) {
                        l = n;
                        break;
                    }
                    l = n - 1;
                }
                if (n = l, i[n] === a) return n / (r - 1);
                const c = i[n];
                return (n + (a - c) / (i[n + 1] - c)) / (r - 1);
            }
            getTangent(t1, e) {
                const i = 1e-4;
                let n = t1 - i, r = t1 + i;
                n < 0 && (n = 0), r > 1 && (r = 1);
                const a = this.getPoint(n), s = this.getPoint(r), o = e || (a.isVector2 ? new qo : new Nl);
                return o.copy(s).sub(a).normalize(), o;
            }
            getTangentAt(t1, e) {
                const i = this.getUtoTmapping(t1);
                return this.getTangent(i, e);
            }
            computeFrenetFrames(t1, e) {
                const i = new Nl, n = [], r = [], a = [], s = new Nl, o = new ac;
                for(let e = 0; e <= t1; e++){
                    const i = e / t1;
                    n[e] = this.getTangentAt(i, new Nl);
                }
                r[0] = new Nl, a[0] = new Nl;
                let l = Number.MAX_VALUE;
                const c = Math.abs(n[0].x), u = Math.abs(n[0].y), h = Math.abs(n[0].z);
                c <= l && (l = c, i.set(1, 0, 0)), u <= l && (l = u, i.set(0, 1, 0)), h <= l && i.set(0, 0, 1), s.crossVectors(n[0], i).normalize(), r[0].crossVectors(n[0], s), a[0].crossVectors(n[0], r[0]);
                for(let e = 1; e <= t1; e++){
                    if (r[e] = r[e - 1].clone(), a[e] = a[e - 1].clone(), s.crossVectors(n[e - 1], n[e]), s.length() > Number.EPSILON) {
                        s.normalize();
                        const t1 = Math.acos(Fo(n[e - 1].dot(n[e]), -1, 1));
                        r[e].applyMatrix4(o.makeRotationAxis(s, t1));
                    }
                    a[e].crossVectors(n[e], r[e]);
                }
                if (!0 === e) {
                    let e = Math.acos(Fo(r[0].dot(r[t1]), -1, 1));
                    e /= t1, n[0].dot(s.crossVectors(r[0], r[t1])) > 0 && (e = -e);
                    for(let i = 1; i <= t1; i++)r[i].applyMatrix4(o.makeRotationAxis(n[i], e * i)), a[i].crossVectors(n[i], r[i]);
                }
                return {
                    tangents: n,
                    normals: r,
                    binormals: a
                };
            }
            clone() {
                return (new this.constructor).copy(this);
            }
            copy(t1) {
                return this.arcLengthDivisions = t1.arcLengthDivisions, this;
            }
            toJSON() {
                const t1 = {
                    metadata: {
                        version: 4.6,
                        type: "Curve",
                        generator: "Curve.toJSON"
                    }
                };
                return t1.arcLengthDivisions = this.arcLengthDivisions, t1.type = this.type, t1;
            }
            fromJSON(t1) {
                return this.arcLengthDivisions = t1.arcLengthDivisions, this;
            }
        }
        class hf extends uf {
            constructor(t1 = 0, e = 0, i = 1, n = 1, r = 0, a = 2 * Math.PI, s = !1, o = 0){
                super(), this.isEllipseCurve = !0, this.type = "EllipseCurve", this.aX = t1, this.aY = e, this.xRadius = i, this.yRadius = n, this.aStartAngle = r, this.aEndAngle = a, this.aClockwise = s, this.aRotation = o;
            }
            getPoint(t1, e) {
                const i = e || new qo, n = 2 * Math.PI;
                let r = this.aEndAngle - this.aStartAngle;
                const a = Math.abs(r) < Number.EPSILON;
                for(; r < 0;)r += n;
                for(; r > n;)r -= n;
                r < Number.EPSILON && (r = a ? 0 : n), !0 !== this.aClockwise || a || (r === n ? r = -n : r -= n);
                const s = this.aStartAngle + t1 * r;
                let o = this.aX + this.xRadius * Math.cos(s), l = this.aY + this.yRadius * Math.sin(s);
                if (0 !== this.aRotation) {
                    const t1 = Math.cos(this.aRotation), e = Math.sin(this.aRotation), i = o - this.aX, n = l - this.aY;
                    o = i * t1 - n * e + this.aX, l = i * e + n * t1 + this.aY;
                }
                return i.set(o, l);
            }
            copy(t1) {
                return super.copy(t1), this.aX = t1.aX, this.aY = t1.aY, this.xRadius = t1.xRadius, this.yRadius = t1.yRadius, this.aStartAngle = t1.aStartAngle, this.aEndAngle = t1.aEndAngle, this.aClockwise = t1.aClockwise, this.aRotation = t1.aRotation, this;
            }
            toJSON() {
                const t1 = super.toJSON();
                return t1.aX = this.aX, t1.aY = this.aY, t1.xRadius = this.xRadius, t1.yRadius = this.yRadius, t1.aStartAngle = this.aStartAngle, t1.aEndAngle = this.aEndAngle, t1.aClockwise = this.aClockwise, t1.aRotation = this.aRotation, t1;
            }
            fromJSON(t1) {
                return super.fromJSON(t1), this.aX = t1.aX, this.aY = t1.aY, this.xRadius = t1.xRadius, this.yRadius = t1.yRadius, this.aStartAngle = t1.aStartAngle, this.aEndAngle = t1.aEndAngle, this.aClockwise = t1.aClockwise, this.aRotation = t1.aRotation, this;
            }
        }
        class df extends hf {
            constructor(t1, e, i, n, r, a){
                super(t1, e, i, i, n, r, a), this.isArcCurve = !0, this.type = "ArcCurve";
            }
        }
        function pf() {
            let t1 = 0, e = 0, i = 0, n = 0;
            function r(r, a, s, o) {
                t1 = r, e = s, i = -3 * r + 3 * a - 2 * s - o, n = 2 * r - 2 * a + s + o;
            }
            return {
                initCatmullRom: function(t1, e, i, n, a) {
                    r(e, i, a * (i - t1), a * (n - e));
                },
                initNonuniformCatmullRom: function(t1, e, i, n, a, s, o) {
                    let l = (e - t1) / a - (i - t1) / (a + s) + (i - e) / s, c = (i - e) / s - (n - e) / (s + o) + (n - i) / o;
                    l *= s, c *= s, r(e, i, l, c);
                },
                calc: function(r) {
                    const a = r * r;
                    return t1 + e * r + i * a + n * (a * r);
                }
            };
        }
        const Af = new Nl, ff = new pf, mf = new pf, gf = new pf;
        class Mf extends uf {
            constructor(t1 = [], e = !1, i = "centripetal", n = .5){
                super(), this.isCatmullRomCurve3 = !0, this.type = "CatmullRomCurve3", this.points = t1, this.closed = e, this.curveType = i, this.tension = n;
            }
            getPoint(t1, e = new Nl) {
                const i = e, n = this.points, r = n.length, a = (r - (this.closed ? 0 : 1)) * t1;
                let s, o, l = Math.floor(a), c = a - l;
                this.closed ? l += l > 0 ? 0 : (Math.floor(Math.abs(l) / r) + 1) * r : 0 === c && l === r - 1 && (l = r - 2, c = 1), this.closed || l > 0 ? s = n[(l - 1) % r] : (Af.subVectors(n[0], n[1]).add(n[0]), s = Af);
                const u = n[l % r], h = n[(l + 1) % r];
                if (this.closed || l + 2 < r ? o = n[(l + 2) % r] : (Af.subVectors(n[r - 1], n[r - 2]).add(n[r - 1]), o = Af), "centripetal" === this.curveType || "chordal" === this.curveType) {
                    const t1 = "chordal" === this.curveType ? .5 : .25;
                    let e = Math.pow(s.distanceToSquared(u), t1), i = Math.pow(u.distanceToSquared(h), t1), n = Math.pow(h.distanceToSquared(o), t1);
                    i < 1e-4 && (i = 1), e < 1e-4 && (e = i), n < 1e-4 && (n = i), ff.initNonuniformCatmullRom(s.x, u.x, h.x, o.x, e, i, n), mf.initNonuniformCatmullRom(s.y, u.y, h.y, o.y, e, i, n), gf.initNonuniformCatmullRom(s.z, u.z, h.z, o.z, e, i, n);
                } else "catmullrom" === this.curveType && (ff.initCatmullRom(s.x, u.x, h.x, o.x, this.tension), mf.initCatmullRom(s.y, u.y, h.y, o.y, this.tension), gf.initCatmullRom(s.z, u.z, h.z, o.z, this.tension));
                return i.set(ff.calc(c), mf.calc(c), gf.calc(c)), i;
            }
            copy(t1) {
                super.copy(t1), this.points = [];
                for(let e = 0, i = t1.points.length; e < i; e++){
                    const i = t1.points[e];
                    this.points.push(i.clone());
                }
                return this.closed = t1.closed, this.curveType = t1.curveType, this.tension = t1.tension, this;
            }
            toJSON() {
                const t1 = super.toJSON();
                t1.points = [];
                for(let e = 0, i = this.points.length; e < i; e++){
                    const i = this.points[e];
                    t1.points.push(i.toArray());
                }
                return t1.closed = this.closed, t1.curveType = this.curveType, t1.tension = this.tension, t1;
            }
            fromJSON(t1) {
                super.fromJSON(t1), this.points = [];
                for(let e = 0, i = t1.points.length; e < i; e++){
                    const i = t1.points[e];
                    this.points.push((new Nl).fromArray(i));
                }
                return this.closed = t1.closed, this.curveType = t1.curveType, this.tension = t1.tension, this;
            }
        }
        function vf(t1, e, i, n, r) {
            const a = .5 * (n - e), s = .5 * (r - i), o = t1 * t1;
            return (2 * i - 2 * n + a + s) * (t1 * o) + (-3 * i + 3 * n - 2 * a - s) * o + a * t1 + i;
        }
        function yf(t1, e, i, n) {
            return function(t1, e) {
                const i = 1 - t1;
                return i * i * e;
            }(t1, e) + function(t1, e) {
                return 2 * (1 - t1) * t1 * e;
            }(t1, i) + function(t1, e) {
                return t1 * t1 * e;
            }(t1, n);
        }
        function xf(t1, e, i, n, r) {
            return function(t1, e) {
                const i = 1 - t1;
                return i * i * i * e;
            }(t1, e) + function(t1, e) {
                const i = 1 - t1;
                return 3 * i * i * t1 * e;
            }(t1, i) + function(t1, e) {
                return 3 * (1 - t1) * t1 * t1 * e;
            }(t1, n) + function(t1, e) {
                return t1 * t1 * t1 * e;
            }(t1, r);
        }
        class wf extends uf {
            constructor(t1 = new qo, e = new qo, i = new qo, n = new qo){
                super(), this.isCubicBezierCurve = !0, this.type = "CubicBezierCurve", this.v0 = t1, this.v1 = e, this.v2 = i, this.v3 = n;
            }
            getPoint(t1, e = new qo) {
                const i = e, n = this.v0, r = this.v1, a = this.v2, s = this.v3;
                return i.set(xf(t1, n.x, r.x, a.x, s.x), xf(t1, n.y, r.y, a.y, s.y)), i;
            }
            copy(t1) {
                return super.copy(t1), this.v0.copy(t1.v0), this.v1.copy(t1.v1), this.v2.copy(t1.v2), this.v3.copy(t1.v3), this;
            }
            toJSON() {
                const t1 = super.toJSON();
                return t1.v0 = this.v0.toArray(), t1.v1 = this.v1.toArray(), t1.v2 = this.v2.toArray(), t1.v3 = this.v3.toArray(), t1;
            }
            fromJSON(t1) {
                return super.fromJSON(t1), this.v0.fromArray(t1.v0), this.v1.fromArray(t1.v1), this.v2.fromArray(t1.v2), this.v3.fromArray(t1.v3), this;
            }
        }
        class bf extends uf {
            constructor(t1 = new Nl, e = new Nl, i = new Nl, n = new Nl){
                super(), this.isCubicBezierCurve3 = !0, this.type = "CubicBezierCurve3", this.v0 = t1, this.v1 = e, this.v2 = i, this.v3 = n;
            }
            getPoint(t1, e = new Nl) {
                const i = e, n = this.v0, r = this.v1, a = this.v2, s = this.v3;
                return i.set(xf(t1, n.x, r.x, a.x, s.x), xf(t1, n.y, r.y, a.y, s.y), xf(t1, n.z, r.z, a.z, s.z)), i;
            }
            copy(t1) {
                return super.copy(t1), this.v0.copy(t1.v0), this.v1.copy(t1.v1), this.v2.copy(t1.v2), this.v3.copy(t1.v3), this;
            }
            toJSON() {
                const t1 = super.toJSON();
                return t1.v0 = this.v0.toArray(), t1.v1 = this.v1.toArray(), t1.v2 = this.v2.toArray(), t1.v3 = this.v3.toArray(), t1;
            }
            fromJSON(t1) {
                return super.fromJSON(t1), this.v0.fromArray(t1.v0), this.v1.fromArray(t1.v1), this.v2.fromArray(t1.v2), this.v3.fromArray(t1.v3), this;
            }
        }
        class Tf extends uf {
            constructor(t1 = new qo, e = new qo){
                super(), this.isLineCurve = !0, this.type = "LineCurve", this.v1 = t1, this.v2 = e;
            }
            getPoint(t1, e = new qo) {
                const i = e;
                return 1 === t1 ? i.copy(this.v2) : (i.copy(this.v2).sub(this.v1), i.multiplyScalar(t1).add(this.v1)), i;
            }
            getPointAt(t1, e) {
                return this.getPoint(t1, e);
            }
            getTangent(t1, e = new qo) {
                return e.subVectors(this.v2, this.v1).normalize();
            }
            getTangentAt(t1, e) {
                return this.getTangent(t1, e);
            }
            copy(t1) {
                return super.copy(t1), this.v1.copy(t1.v1), this.v2.copy(t1.v2), this;
            }
            toJSON() {
                const t1 = super.toJSON();
                return t1.v1 = this.v1.toArray(), t1.v2 = this.v2.toArray(), t1;
            }
            fromJSON(t1) {
                return super.fromJSON(t1), this.v1.fromArray(t1.v1), this.v2.fromArray(t1.v2), this;
            }
        }
        class Ef extends uf {
            constructor(t1 = new Nl, e = new Nl){
                super(), this.isLineCurve3 = !0, this.type = "LineCurve3", this.v1 = t1, this.v2 = e;
            }
            getPoint(t1, e = new Nl) {
                const i = e;
                return 1 === t1 ? i.copy(this.v2) : (i.copy(this.v2).sub(this.v1), i.multiplyScalar(t1).add(this.v1)), i;
            }
            getPointAt(t1, e) {
                return this.getPoint(t1, e);
            }
            getTangent(t1, e = new Nl) {
                return e.subVectors(this.v2, this.v1).normalize();
            }
            getTangentAt(t1, e) {
                return this.getTangent(t1, e);
            }
            copy(t1) {
                return super.copy(t1), this.v1.copy(t1.v1), this.v2.copy(t1.v2), this;
            }
            toJSON() {
                const t1 = super.toJSON();
                return t1.v1 = this.v1.toArray(), t1.v2 = this.v2.toArray(), t1;
            }
            fromJSON(t1) {
                return super.fromJSON(t1), this.v1.fromArray(t1.v1), this.v2.fromArray(t1.v2), this;
            }
        }
        class _f extends uf {
            constructor(t1 = new qo, e = new qo, i = new qo){
                super(), this.isQuadraticBezierCurve = !0, this.type = "QuadraticBezierCurve", this.v0 = t1, this.v1 = e, this.v2 = i;
            }
            getPoint(t1, e = new qo) {
                const i = e, n = this.v0, r = this.v1, a = this.v2;
                return i.set(yf(t1, n.x, r.x, a.x), yf(t1, n.y, r.y, a.y)), i;
            }
            copy(t1) {
                return super.copy(t1), this.v0.copy(t1.v0), this.v1.copy(t1.v1), this.v2.copy(t1.v2), this;
            }
            toJSON() {
                const t1 = super.toJSON();
                return t1.v0 = this.v0.toArray(), t1.v1 = this.v1.toArray(), t1.v2 = this.v2.toArray(), t1;
            }
            fromJSON(t1) {
                return super.fromJSON(t1), this.v0.fromArray(t1.v0), this.v1.fromArray(t1.v1), this.v2.fromArray(t1.v2), this;
            }
        }
        class If extends uf {
            constructor(t1 = new Nl, e = new Nl, i = new Nl){
                super(), this.isQuadraticBezierCurve3 = !0, this.type = "QuadraticBezierCurve3", this.v0 = t1, this.v1 = e, this.v2 = i;
            }
            getPoint(t1, e = new Nl) {
                const i = e, n = this.v0, r = this.v1, a = this.v2;
                return i.set(yf(t1, n.x, r.x, a.x), yf(t1, n.y, r.y, a.y), yf(t1, n.z, r.z, a.z)), i;
            }
            copy(t1) {
                return super.copy(t1), this.v0.copy(t1.v0), this.v1.copy(t1.v1), this.v2.copy(t1.v2), this;
            }
            toJSON() {
                const t1 = super.toJSON();
                return t1.v0 = this.v0.toArray(), t1.v1 = this.v1.toArray(), t1.v2 = this.v2.toArray(), t1;
            }
            fromJSON(t1) {
                return super.fromJSON(t1), this.v0.fromArray(t1.v0), this.v1.fromArray(t1.v1), this.v2.fromArray(t1.v2), this;
            }
        }
        class Sf extends uf {
            constructor(t1 = []){
                super(), this.isSplineCurve = !0, this.type = "SplineCurve", this.points = t1;
            }
            getPoint(t1, e = new qo) {
                const i = e, n = this.points, r = (n.length - 1) * t1, a = Math.floor(r), s = r - a, o = n[0 === a ? a : a - 1], l = n[a], c = n[a > n.length - 2 ? n.length - 1 : a + 1], u = n[a > n.length - 3 ? n.length - 1 : a + 2];
                return i.set(vf(s, o.x, l.x, c.x, u.x), vf(s, o.y, l.y, c.y, u.y)), i;
            }
            copy(t1) {
                super.copy(t1), this.points = [];
                for(let e = 0, i = t1.points.length; e < i; e++){
                    const i = t1.points[e];
                    this.points.push(i.clone());
                }
                return this;
            }
            toJSON() {
                const t1 = super.toJSON();
                t1.points = [];
                for(let e = 0, i = this.points.length; e < i; e++){
                    const i = this.points[e];
                    t1.points.push(i.toArray());
                }
                return t1;
            }
            fromJSON(t1) {
                super.fromJSON(t1), this.points = [];
                for(let e = 0, i = t1.points.length; e < i; e++){
                    const i = t1.points[e];
                    this.points.push((new qo).fromArray(i));
                }
                return this;
            }
        }
        var Nf = Object.freeze({
            __proto__: null,
            ArcCurve: df,
            CatmullRomCurve3: Mf,
            CubicBezierCurve: wf,
            CubicBezierCurve3: bf,
            EllipseCurve: hf,
            LineCurve: Tf,
            LineCurve3: Ef,
            QuadraticBezierCurve: _f,
            QuadraticBezierCurve3: If,
            SplineCurve: Sf
        });
        class Df extends uf {
            constructor(){
                super(), this.type = "CurvePath", this.curves = [], this.autoClose = !1;
            }
            add(t1) {
                this.curves.push(t1);
            }
            closePath() {
                const t1 = this.curves[0].getPoint(0), e = this.curves[this.curves.length - 1].getPoint(1);
                if (!t1.equals(e)) {
                    const i = !0 === t1.isVector2 ? "LineCurve" : "LineCurve3";
                    this.curves.push(new Nf[i](e, t1));
                }
                return this;
            }
            getPoint(t1, e) {
                const i = t1 * this.getLength(), n = this.getCurveLengths();
                let r = 0;
                for(; r < n.length;){
                    if (n[r] >= i) {
                        const t1 = n[r] - i, a = this.curves[r], s = a.getLength(), o = 0 === s ? 0 : 1 - t1 / s;
                        return a.getPointAt(o, e);
                    }
                    r++;
                }
                return null;
            }
            getLength() {
                const t1 = this.getCurveLengths();
                return t1[t1.length - 1];
            }
            updateArcLengths() {
                this.needsUpdate = !0, this.cacheLengths = null, this.getCurveLengths();
            }
            getCurveLengths() {
                if (this.cacheLengths && this.cacheLengths.length === this.curves.length) return this.cacheLengths;
                const t1 = [];
                let e = 0;
                for(let i = 0, n = this.curves.length; i < n; i++)e += this.curves[i].getLength(), t1.push(e);
                return this.cacheLengths = t1, t1;
            }
            getSpacedPoints(t1 = 40) {
                const e = [];
                for(let i = 0; i <= t1; i++)e.push(this.getPoint(i / t1));
                return this.autoClose && e.push(e[0]), e;
            }
            getPoints(t1 = 12) {
                const e = [];
                let i;
                for(let n = 0, r = this.curves; n < r.length; n++){
                    const a = r[n], s = a.isEllipseCurve ? 2 * t1 : a.isLineCurve || a.isLineCurve3 ? 1 : a.isSplineCurve ? t1 * a.points.length : t1, o = a.getPoints(s);
                    for(let t1 = 0; t1 < o.length; t1++){
                        const n = o[t1];
                        i && i.equals(n) || (e.push(n), i = n);
                    }
                }
                return this.autoClose && e.length > 1 && !e[e.length - 1].equals(e[0]) && e.push(e[0]), e;
            }
            copy(t1) {
                super.copy(t1), this.curves = [];
                for(let e = 0, i = t1.curves.length; e < i; e++){
                    const i = t1.curves[e];
                    this.curves.push(i.clone());
                }
                return this.autoClose = t1.autoClose, this;
            }
            toJSON() {
                const t1 = super.toJSON();
                t1.autoClose = this.autoClose, t1.curves = [];
                for(let e = 0, i = this.curves.length; e < i; e++){
                    const i = this.curves[e];
                    t1.curves.push(i.toJSON());
                }
                return t1;
            }
            fromJSON(t1) {
                super.fromJSON(t1), this.autoClose = t1.autoClose, this.curves = [];
                for(let e = 0, i = t1.curves.length; e < i; e++){
                    const i = t1.curves[e];
                    this.curves.push((new Nf[i.type]).fromJSON(i));
                }
                return this;
            }
        }
        class Cf extends Df {
            constructor(t1){
                super(), this.type = "Path", this.currentPoint = new qo, t1 && this.setFromPoints(t1);
            }
            setFromPoints(t1) {
                this.moveTo(t1[0].x, t1[0].y);
                for(let e = 1, i = t1.length; e < i; e++)this.lineTo(t1[e].x, t1[e].y);
                return this;
            }
            moveTo(t1, e) {
                return this.currentPoint.set(t1, e), this;
            }
            lineTo(t1, e) {
                const i = new Tf(this.currentPoint.clone(), new qo(t1, e));
                return this.curves.push(i), this.currentPoint.set(t1, e), this;
            }
            quadraticCurveTo(t1, e, i, n) {
                const r = new _f(this.currentPoint.clone(), new qo(t1, e), new qo(i, n));
                return this.curves.push(r), this.currentPoint.set(i, n), this;
            }
            bezierCurveTo(t1, e, i, n, r, a) {
                const s = new wf(this.currentPoint.clone(), new qo(t1, e), new qo(i, n), new qo(r, a));
                return this.curves.push(s), this.currentPoint.set(r, a), this;
            }
            splineThru(t1) {
                const e = [
                    this.currentPoint.clone()
                ].concat(t1), i = new Sf(e);
                return this.curves.push(i), this.currentPoint.copy(t1[t1.length - 1]), this;
            }
            arc(t1, e, i, n, r, a) {
                const s = this.currentPoint.x, o = this.currentPoint.y;
                return this.absarc(t1 + s, e + o, i, n, r, a), this;
            }
            absarc(t1, e, i, n, r, a) {
                return this.absellipse(t1, e, i, i, n, r, a), this;
            }
            ellipse(t1, e, i, n, r, a, s, o) {
                const l = this.currentPoint.x, c = this.currentPoint.y;
                return this.absellipse(t1 + l, e + c, i, n, r, a, s, o), this;
            }
            absellipse(t1, e, i, n, r, a, s, o) {
                const l = new hf(t1, e, i, n, r, a, s, o);
                if (this.curves.length > 0) {
                    const t1 = l.getPoint(0);
                    t1.equals(this.currentPoint) || this.lineTo(t1.x, t1.y);
                }
                this.curves.push(l);
                const c = l.getPoint(1);
                return this.currentPoint.copy(c), this;
            }
            copy(t1) {
                return super.copy(t1), this.currentPoint.copy(t1.currentPoint), this;
            }
            toJSON() {
                const t1 = super.toJSON();
                return t1.currentPoint = this.currentPoint.toArray(), t1;
            }
            fromJSON(t1) {
                return super.fromJSON(t1), this.currentPoint.fromArray(t1.currentPoint), this;
            }
        }
        class zf extends bu {
            constructor(t1 = [
                new qo(0, -0.5),
                new qo(.5, 0),
                new qo(0, .5)
            ], e = 12, i = 0, n = 2 * Math.PI){
                super(), this.type = "LatheGeometry", this.parameters = {
                    points: t1,
                    segments: e,
                    phiStart: i,
                    phiLength: n
                }, e = Math.floor(e), n = Fo(n, 0, 2 * Math.PI);
                const r = [], a = [], s = [], o = [], l = [], c = 1 / e, u = new Nl, h = new qo, d = new Nl, p = new Nl, A = new Nl;
                let f = 0, m = 0;
                for(let e = 0; e <= t1.length - 1; e++)switch(e){
                    case 0:
                        f = t1[e + 1].x - t1[e].x, m = t1[e + 1].y - t1[e].y, d.x = 1 * m, d.y = -f, d.z = 0 * m, A.copy(d), d.normalize(), o.push(d.x, d.y, d.z);
                        break;
                    case t1.length - 1:
                        o.push(A.x, A.y, A.z);
                        break;
                    default:
                        f = t1[e + 1].x - t1[e].x, m = t1[e + 1].y - t1[e].y, d.x = 1 * m, d.y = -f, d.z = 0 * m, p.copy(d), d.x += A.x, d.y += A.y, d.z += A.z, d.normalize(), o.push(d.x, d.y, d.z), A.copy(p);
                }
                for(let r = 0; r <= e; r++){
                    const d = i + r * c * n, p = Math.sin(d), A = Math.cos(d);
                    for(let i = 0; i <= t1.length - 1; i++){
                        u.x = t1[i].x * p, u.y = t1[i].y, u.z = t1[i].x * A, a.push(u.x, u.y, u.z), h.x = r / e, h.y = i / (t1.length - 1), s.push(h.x, h.y);
                        const n = o[3 * i + 0] * p, c = o[3 * i + 1], d = o[3 * i + 0] * A;
                        l.push(n, c, d);
                    }
                }
                for(let i = 0; i < e; i++)for(let e = 0; e < t1.length - 1; e++){
                    const n = e + i * t1.length, a = n, s = n + t1.length, o = n + t1.length + 1, l = n + 1;
                    r.push(a, s, l), r.push(o, l, s);
                }
                this.setIndex(r), this.setAttribute("position", new Au(a, 3)), this.setAttribute("uv", new Au(s, 2)), this.setAttribute("normal", new Au(l, 3));
            }
            copy(t1) {
                return super.copy(t1), this.parameters = Object.assign({}, t1.parameters), this;
            }
            static fromJSON(t1) {
                return new zf(t1.points, t1.segments, t1.phiStart, t1.phiLength);
            }
        }
        class Lf extends zf {
            constructor(t1 = 1, e = 1, i = 4, n = 8){
                const r = new Cf;
                r.absarc(0, -e / 2, t1, 1.5 * Math.PI, 0), r.absarc(0, e / 2, t1, 0, .5 * Math.PI), super(r.getPoints(i), n), this.type = "CapsuleGeometry", this.parameters = {
                    radius: t1,
                    length: e,
                    capSegments: i,
                    radialSegments: n
                };
            }
            static fromJSON(t1) {
                return new Lf(t1.radius, t1.length, t1.capSegments, t1.radialSegments);
            }
        }
        class Of extends bu {
            constructor(t1 = 1, e = 32, i = 0, n = 2 * Math.PI){
                super(), this.type = "CircleGeometry", this.parameters = {
                    radius: t1,
                    segments: e,
                    thetaStart: i,
                    thetaLength: n
                }, e = Math.max(3, e);
                const r = [], a = [], s = [], o = [], l = new Nl, c = new qo;
                a.push(0, 0, 0), s.push(0, 0, 1), o.push(.5, .5);
                for(let r = 0, u = 3; r <= e; r++, u += 3){
                    const h = i + r / e * n;
                    l.x = t1 * Math.cos(h), l.y = t1 * Math.sin(h), a.push(l.x, l.y, l.z), s.push(0, 0, 1), c.x = (a[u] / t1 + 1) / 2, c.y = (a[u + 1] / t1 + 1) / 2, o.push(c.x, c.y);
                }
                for(let t1 = 1; t1 <= e; t1++)r.push(t1, t1 + 1, 0);
                this.setIndex(r), this.setAttribute("position", new Au(a, 3)), this.setAttribute("normal", new Au(s, 3)), this.setAttribute("uv", new Au(o, 2));
            }
            copy(t1) {
                return super.copy(t1), this.parameters = Object.assign({}, t1.parameters), this;
            }
            static fromJSON(t1) {
                return new Of(t1.radius, t1.segments, t1.thetaStart, t1.thetaLength);
            }
        }
        class Pf extends bu {
            constructor(t1 = 1, e = 1, i = 1, n = 32, r = 1, a = !1, s = 0, o = 2 * Math.PI){
                super(), this.type = "CylinderGeometry", this.parameters = {
                    radiusTop: t1,
                    radiusBottom: e,
                    height: i,
                    radialSegments: n,
                    heightSegments: r,
                    openEnded: a,
                    thetaStart: s,
                    thetaLength: o
                };
                const l = this;
                n = Math.floor(n), r = Math.floor(r);
                const c = [], u = [], h = [], d = [];
                let p = 0;
                const A = [], f = i / 2;
                let m = 0;
                function g(i) {
                    const r = p, a = new qo, A = new Nl;
                    let g = 0;
                    const M = !0 === i ? t1 : e, v = !0 === i ? 1 : -1;
                    for(let t1 = 1; t1 <= n; t1++)u.push(0, f * v, 0), h.push(0, v, 0), d.push(.5, .5), p++;
                    const y = p;
                    for(let t1 = 0; t1 <= n; t1++){
                        const e = t1 / n * o + s, i = Math.cos(e), r = Math.sin(e);
                        A.x = M * r, A.y = f * v, A.z = M * i, u.push(A.x, A.y, A.z), h.push(0, v, 0), a.x = .5 * i + .5, a.y = .5 * r * v + .5, d.push(a.x, a.y), p++;
                    }
                    for(let t1 = 0; t1 < n; t1++){
                        const e = r + t1, n = y + t1;
                        !0 === i ? c.push(n, n + 1, e) : c.push(n + 1, n, e), g += 3;
                    }
                    l.addGroup(m, g, !0 === i ? 1 : 2), m += g;
                }
                !function() {
                    const a = new Nl, g = new Nl;
                    let M = 0;
                    const v = (e - t1) / i;
                    for(let l = 0; l <= r; l++){
                        const c = [], m = l / r, M = m * (e - t1) + t1;
                        for(let t1 = 0; t1 <= n; t1++){
                            const e = t1 / n, r = e * o + s, l = Math.sin(r), A = Math.cos(r);
                            g.x = M * l, g.y = -m * i + f, g.z = M * A, u.push(g.x, g.y, g.z), a.set(l, v, A).normalize(), h.push(a.x, a.y, a.z), d.push(e, 1 - m), c.push(p++);
                        }
                        A.push(c);
                    }
                    for(let t1 = 0; t1 < n; t1++)for(let e = 0; e < r; e++){
                        const i = A[e][t1], n = A[e + 1][t1], r = A[e + 1][t1 + 1], a = A[e][t1 + 1];
                        c.push(i, n, a), c.push(n, r, a), M += 6;
                    }
                    l.addGroup(m, M, 0), m += M;
                }(), !1 === a && (t1 > 0 && g(!0), e > 0 && g(!1)), this.setIndex(c), this.setAttribute("position", new Au(u, 3)), this.setAttribute("normal", new Au(h, 3)), this.setAttribute("uv", new Au(d, 2));
            }
            copy(t1) {
                return super.copy(t1), this.parameters = Object.assign({}, t1.parameters), this;
            }
            static fromJSON(t1) {
                return new Pf(t1.radiusTop, t1.radiusBottom, t1.height, t1.radialSegments, t1.heightSegments, t1.openEnded, t1.thetaStart, t1.thetaLength);
            }
        }
        class jf extends Pf {
            constructor(t1 = 1, e = 1, i = 32, n = 1, r = !1, a = 0, s = 2 * Math.PI){
                super(0, t1, e, i, n, r, a, s), this.type = "ConeGeometry", this.parameters = {
                    radius: t1,
                    height: e,
                    radialSegments: i,
                    heightSegments: n,
                    openEnded: r,
                    thetaStart: a,
                    thetaLength: s
                };
            }
            static fromJSON(t1) {
                return new jf(t1.radius, t1.height, t1.radialSegments, t1.heightSegments, t1.openEnded, t1.thetaStart, t1.thetaLength);
            }
        }
        class Rf extends bu {
            constructor(t1 = [], e = [], i = 1, n = 0){
                super(), this.type = "PolyhedronGeometry", this.parameters = {
                    vertices: t1,
                    indices: e,
                    radius: i,
                    detail: n
                };
                const r = [], a = [];
                function s(t1, e, i, n) {
                    const r = n + 1, a = [];
                    for(let n = 0; n <= r; n++){
                        a[n] = [];
                        const s = t1.clone().lerp(i, n / r), o = e.clone().lerp(i, n / r), l = r - n;
                        for(let t1 = 0; t1 <= l; t1++)a[n][t1] = 0 === t1 && n === r ? s : s.clone().lerp(o, t1 / l);
                    }
                    for(let t1 = 0; t1 < r; t1++)for(let e = 0; e < 2 * (r - t1) - 1; e++){
                        const i = Math.floor(e / 2);
                        e % 2 == 0 ? (o(a[t1][i + 1]), o(a[t1 + 1][i]), o(a[t1][i])) : (o(a[t1][i + 1]), o(a[t1 + 1][i + 1]), o(a[t1 + 1][i]));
                    }
                }
                function o(t1) {
                    r.push(t1.x, t1.y, t1.z);
                }
                function l(e, i) {
                    const n = 3 * e;
                    i.x = t1[n + 0], i.y = t1[n + 1], i.z = t1[n + 2];
                }
                function c(t1, e, i, n) {
                    n < 0 && 1 === t1.x && (a[e] = t1.x - 1), 0 === i.x && 0 === i.z && (a[e] = n / 2 / Math.PI + .5);
                }
                function u(t1) {
                    return Math.atan2(t1.z, -t1.x);
                }
                !function(t1) {
                    const i = new Nl, n = new Nl, r = new Nl;
                    for(let a = 0; a < e.length; a += 3)l(e[a + 0], i), l(e[a + 1], n), l(e[a + 2], r), s(i, n, r, t1);
                }(n), function(t1) {
                    const e = new Nl;
                    for(let i = 0; i < r.length; i += 3)e.x = r[i + 0], e.y = r[i + 1], e.z = r[i + 2], e.normalize().multiplyScalar(t1), r[i + 0] = e.x, r[i + 1] = e.y, r[i + 2] = e.z;
                }(i), function() {
                    const t1 = new Nl;
                    for(let i = 0; i < r.length; i += 3){
                        t1.x = r[i + 0], t1.y = r[i + 1], t1.z = r[i + 2];
                        const n = u(t1) / 2 / Math.PI + .5, s = (e = t1, Math.atan2(-e.y, Math.sqrt(e.x * e.x + e.z * e.z)) / Math.PI + .5);
                        a.push(n, 1 - s);
                    }
                    var e;
                    (function() {
                        const t1 = new Nl, e = new Nl, i = new Nl, n = new Nl, s = new qo, o = new qo, l = new qo;
                        for(let h = 0, d = 0; h < r.length; h += 9, d += 6){
                            t1.set(r[h + 0], r[h + 1], r[h + 2]), e.set(r[h + 3], r[h + 4], r[h + 5]), i.set(r[h + 6], r[h + 7], r[h + 8]), s.set(a[d + 0], a[d + 1]), o.set(a[d + 2], a[d + 3]), l.set(a[d + 4], a[d + 5]), n.copy(t1).add(e).add(i).divideScalar(3);
                            const p = u(n);
                            c(s, d + 0, t1, p), c(o, d + 2, e, p), c(l, d + 4, i, p);
                        }
                    })(), function() {
                        for(let t1 = 0; t1 < a.length; t1 += 6){
                            const e = a[t1 + 0], i = a[t1 + 2], n = a[t1 + 4], r = Math.max(e, i, n), s = Math.min(e, i, n);
                            r > .9 && s < .1 && (e < .2 && (a[t1 + 0] += 1), i < .2 && (a[t1 + 2] += 1), n < .2 && (a[t1 + 4] += 1));
                        }
                    }();
                }(), this.setAttribute("position", new Au(r, 3)), this.setAttribute("normal", new Au(r.slice(), 3)), this.setAttribute("uv", new Au(a, 2)), 0 === n ? this.computeVertexNormals() : this.normalizeNormals();
            }
            copy(t1) {
                return super.copy(t1), this.parameters = Object.assign({}, t1.parameters), this;
            }
            static fromJSON(t1) {
                return new Rf(t1.vertices, t1.indices, t1.radius, t1.details);
            }
        }
        class kf extends Rf {
            constructor(t1 = 1, e = 0){
                const i = (1 + Math.sqrt(5)) / 2, n = 1 / i;
                super([
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    1,
                    -1,
                    1,
                    -1,
                    -1,
                    1,
                    1,
                    1,
                    -1,
                    -1,
                    1,
                    -1,
                    1,
                    1,
                    1,
                    -1,
                    1,
                    1,
                    1,
                    0,
                    -n,
                    -i,
                    0,
                    -n,
                    i,
                    0,
                    n,
                    -i,
                    0,
                    n,
                    i,
                    -n,
                    -i,
                    0,
                    -n,
                    i,
                    0,
                    n,
                    -i,
                    0,
                    n,
                    i,
                    0,
                    -i,
                    0,
                    -n,
                    i,
                    0,
                    -n,
                    -i,
                    0,
                    n,
                    i,
                    0,
                    n
                ], [
                    3,
                    11,
                    7,
                    3,
                    7,
                    15,
                    3,
                    15,
                    13,
                    7,
                    19,
                    17,
                    7,
                    17,
                    6,
                    7,
                    6,
                    15,
                    17,
                    4,
                    8,
                    17,
                    8,
                    10,
                    17,
                    10,
                    6,
                    8,
                    0,
                    16,
                    8,
                    16,
                    2,
                    8,
                    2,
                    10,
                    0,
                    12,
                    1,
                    0,
                    1,
                    18,
                    0,
                    18,
                    16,
                    6,
                    10,
                    2,
                    6,
                    2,
                    13,
                    6,
                    13,
                    15,
                    2,
                    16,
                    18,
                    2,
                    18,
                    3,
                    2,
                    3,
                    13,
                    18,
                    1,
                    9,
                    18,
                    9,
                    11,
                    18,
                    11,
                    3,
                    4,
                    14,
                    12,
                    4,
                    12,
                    0,
                    4,
                    0,
                    8,
                    11,
                    9,
                    5,
                    11,
                    5,
                    19,
                    11,
                    19,
                    7,
                    19,
                    5,
                    14,
                    19,
                    14,
                    4,
                    19,
                    4,
                    17,
                    1,
                    12,
                    14,
                    1,
                    14,
                    5,
                    1,
                    5,
                    9
                ], t1, e), this.type = "DodecahedronGeometry", this.parameters = {
                    radius: t1,
                    detail: e
                };
            }
            static fromJSON(t1) {
                return new kf(t1.radius, t1.detail);
            }
        }
        const Uf = new Nl, Bf = new Nl, Ff = new Nl, Qf = new Qc;
        class Hf extends bu {
            constructor(t1 = null, e = 1){
                if (super(), this.type = "EdgesGeometry", this.parameters = {
                    geometry: t1,
                    thresholdAngle: e
                }, null !== t1) {
                    const i = 4, n = Math.pow(10, i), r = Math.cos(ko * e), a = t1.getIndex(), s = t1.getAttribute("position"), o = a ? a.count : s.count, l = [
                        0,
                        0,
                        0
                    ], c = [
                        "a",
                        "b",
                        "c"
                    ], u = new Array(3), h = {}, d = [];
                    for(let t1 = 0; t1 < o; t1 += 3){
                        a ? (l[0] = a.getX(t1), l[1] = a.getX(t1 + 1), l[2] = a.getX(t1 + 2)) : (l[0] = t1, l[1] = t1 + 1, l[2] = t1 + 2);
                        const { a: e, b: i, c: o } = Qf;
                        if (e.fromBufferAttribute(s, l[0]), i.fromBufferAttribute(s, l[1]), o.fromBufferAttribute(s, l[2]), Qf.getNormal(Ff), u[0] = `${Math.round(e.x * n)},${Math.round(e.y * n)},${Math.round(e.z * n)}`, u[1] = `${Math.round(i.x * n)},${Math.round(i.y * n)},${Math.round(i.z * n)}`, u[2] = `${Math.round(o.x * n)},${Math.round(o.y * n)},${Math.round(o.z * n)}`, u[0] !== u[1] && u[1] !== u[2] && u[2] !== u[0]) for(let t1 = 0; t1 < 3; t1++){
                            const e = (t1 + 1) % 3, i = u[t1], n = u[e], a = Qf[c[t1]], s = Qf[c[e]], o = `${i}_${n}`, p = `${n}_${i}`;
                            p in h && h[p] ? (Ff.dot(h[p].normal) <= r && (d.push(a.x, a.y, a.z), d.push(s.x, s.y, s.z)), h[p] = null) : o in h || (h[o] = {
                                index0: l[t1],
                                index1: l[e],
                                normal: Ff.clone()
                            });
                        }
                    }
                    for(const t1 in h)if (h[t1]) {
                        const { index0: e, index1: i } = h[t1];
                        Uf.fromBufferAttribute(s, e), Bf.fromBufferAttribute(s, i), d.push(Uf.x, Uf.y, Uf.z), d.push(Bf.x, Bf.y, Bf.z);
                    }
                    this.setAttribute("position", new Au(d, 3));
                }
            }
            copy(t1) {
                return super.copy(t1), this.parameters = Object.assign({}, t1.parameters), this;
            }
        }
        class Vf extends Cf {
            constructor(t1){
                super(t1), this.uuid = Bo(), this.type = "Shape", this.holes = [];
            }
            getPointsHoles(t1) {
                const e = [];
                for(let i = 0, n = this.holes.length; i < n; i++)e[i] = this.holes[i].getPoints(t1);
                return e;
            }
            extractPoints(t1) {
                return {
                    shape: this.getPoints(t1),
                    holes: this.getPointsHoles(t1)
                };
            }
            copy(t1) {
                super.copy(t1), this.holes = [];
                for(let e = 0, i = t1.holes.length; e < i; e++){
                    const i = t1.holes[e];
                    this.holes.push(i.clone());
                }
                return this;
            }
            toJSON() {
                const t1 = super.toJSON();
                t1.uuid = this.uuid, t1.holes = [];
                for(let e = 0, i = this.holes.length; e < i; e++){
                    const i = this.holes[e];
                    t1.holes.push(i.toJSON());
                }
                return t1;
            }
            fromJSON(t1) {
                super.fromJSON(t1), this.uuid = t1.uuid, this.holes = [];
                for(let e = 0, i = t1.holes.length; e < i; e++){
                    const i = t1.holes[e];
                    this.holes.push((new Cf).fromJSON(i));
                }
                return this;
            }
        }
        function Gf(t1, e, i, n, r) {
            let a, s;
            if (r === function(t1, e, i, n) {
                let r = 0;
                for(let a = e, s = i - n; a < i; a += n)r += (t1[s] - t1[a]) * (t1[a + 1] + t1[s + 1]), s = a;
                return r;
            }(t1, e, i, n) > 0) for(a = e; a < i; a += n)s = dm(a, t1[a], t1[a + 1], s);
            else for(a = i - n; a >= e; a -= n)s = dm(a, t1[a], t1[a + 1], s);
            return s && sm(s, s.next) && (pm(s), s = s.next), s;
        }
        function Wf(t1, e) {
            if (!t1) return t1;
            e || (e = t1);
            let i, n = t1;
            do if (i = !1, n.steiner || !sm(n, n.next) && 0 !== am(n.prev, n, n.next)) n = n.next;
            else {
                if (pm(n), n = e = n.prev, n === n.next) break;
                i = !0;
            }
            while (i || n !== e);
            return e;
        }
        function Yf(t1, e, i, n, r, a, s) {
            if (!t1) return;
            !s && a && function(t1, e, i, n) {
                let r = t1;
                do 0 === r.z && (r.z = em(r.x, r.y, e, i, n)), r.prevZ = r.prev, r.nextZ = r.next, r = r.next;
                while (r !== t1);
                r.prevZ.nextZ = null, r.prevZ = null, function(t1) {
                    let e, i, n, r, a, s, o, l, c = 1;
                    do {
                        for(i = t1, t1 = null, a = null, s = 0; i;){
                            for(s++, n = i, o = 0, e = 0; e < c && (o++, n = n.nextZ, n); e++);
                            for(l = c; o > 0 || l > 0 && n;)0 !== o && (0 === l || !n || i.z <= n.z) ? (r = i, i = i.nextZ, o--) : (r = n, n = n.nextZ, l--), a ? a.nextZ = r : t1 = r, r.prevZ = a, a = r;
                            i = n;
                        }
                        a.nextZ = null, c *= 2;
                    }while (s > 1);
                }(r);
            }(t1, n, r, a);
            let o, l, c = t1;
            for(; t1.prev !== t1.next;)if (o = t1.prev, l = t1.next, a ? Zf(t1, n, r, a) : Xf(t1)) e.push(o.i / i | 0), e.push(t1.i / i | 0), e.push(l.i / i | 0), pm(t1), t1 = l.next, c = l.next;
            else if ((t1 = l) === c) {
                s ? 1 === s ? Yf(t1 = qf(Wf(t1), e, i), e, i, n, r, a, 2) : 2 === s && Jf(t1, e, i, n, r, a) : Yf(Wf(t1), e, i, n, r, a, 1);
                break;
            }
        }
        function Xf(t1) {
            const e = t1.prev, i = t1, n = t1.next;
            if (am(e, i, n) >= 0) return !1;
            const r = e.x, a = i.x, s = n.x, o = e.y, l = i.y, c = n.y, u = r < a ? r < s ? r : s : a < s ? a : s, h = o < l ? o < c ? o : c : l < c ? l : c, d = r > a ? r > s ? r : s : a > s ? a : s, p = o > l ? o > c ? o : c : l > c ? l : c;
            let A = n.next;
            for(; A !== e;){
                if (A.x >= u && A.x <= d && A.y >= h && A.y <= p && nm(r, o, a, l, s, c, A.x, A.y) && am(A.prev, A, A.next) >= 0) return !1;
                A = A.next;
            }
            return !0;
        }
        function Zf(t1, e, i, n) {
            const r = t1.prev, a = t1, s = t1.next;
            if (am(r, a, s) >= 0) return !1;
            const o = r.x, l = a.x, c = s.x, u = r.y, h = a.y, d = s.y, p = o < l ? o < c ? o : c : l < c ? l : c, A = u < h ? u < d ? u : d : h < d ? h : d, f = o > l ? o > c ? o : c : l > c ? l : c, m = u > h ? u > d ? u : d : h > d ? h : d, g = em(p, A, e, i, n), M = em(f, m, e, i, n);
            let v = t1.prevZ, y = t1.nextZ;
            for(; v && v.z >= g && y && y.z <= M;){
                if (v.x >= p && v.x <= f && v.y >= A && v.y <= m && v !== r && v !== s && nm(o, u, l, h, c, d, v.x, v.y) && am(v.prev, v, v.next) >= 0) return !1;
                if (v = v.prevZ, y.x >= p && y.x <= f && y.y >= A && y.y <= m && y !== r && y !== s && nm(o, u, l, h, c, d, y.x, y.y) && am(y.prev, y, y.next) >= 0) return !1;
                y = y.nextZ;
            }
            for(; v && v.z >= g;){
                if (v.x >= p && v.x <= f && v.y >= A && v.y <= m && v !== r && v !== s && nm(o, u, l, h, c, d, v.x, v.y) && am(v.prev, v, v.next) >= 0) return !1;
                v = v.prevZ;
            }
            for(; y && y.z <= M;){
                if (y.x >= p && y.x <= f && y.y >= A && y.y <= m && y !== r && y !== s && nm(o, u, l, h, c, d, y.x, y.y) && am(y.prev, y, y.next) >= 0) return !1;
                y = y.nextZ;
            }
            return !0;
        }
        function qf(t1, e, i) {
            let n = t1;
            do {
                const r = n.prev, a = n.next.next;
                !sm(r, a) && om(r, n, n.next, a) && um(r, a) && um(a, r) && (e.push(r.i / i | 0), e.push(n.i / i | 0), e.push(a.i / i | 0), pm(n), pm(n.next), n = t1 = a), n = n.next;
            }while (n !== t1);
            return Wf(n);
        }
        function Jf(t1, e, i, n, r, a) {
            let s = t1;
            do {
                let t1 = s.next.next;
                for(; t1 !== s.prev;){
                    if (s.i !== t1.i && rm(s, t1)) {
                        let o = hm(s, t1);
                        return s = Wf(s, s.next), o = Wf(o, o.next), Yf(s, e, i, n, r, a, 0), void Yf(o, e, i, n, r, a, 0);
                    }
                    t1 = t1.next;
                }
                s = s.next;
            }while (s !== t1);
        }
        function Kf(t1, e) {
            return t1.x - e.x;
        }
        function $f(t1, e) {
            const i = function(t1, e) {
                let i, n = e, r = -1 / 0;
                const a = t1.x, s = t1.y;
                do {
                    if (s <= n.y && s >= n.next.y && n.next.y !== n.y) {
                        const t1 = n.x + (s - n.y) * (n.next.x - n.x) / (n.next.y - n.y);
                        if (t1 <= a && t1 > r && (r = t1, i = n.x < n.next.x ? n : n.next, t1 === a)) return i;
                    }
                    n = n.next;
                }while (n !== e);
                if (!i) return null;
                const o = i, l = i.x, c = i.y;
                let u, h = 1 / 0;
                n = i;
                do a >= n.x && n.x >= l && a !== n.x && nm(s < c ? a : r, s, l, c, s < c ? r : a, s, n.x, n.y) && (u = Math.abs(s - n.y) / (a - n.x), um(n, t1) && (u < h || u === h && (n.x > i.x || n.x === i.x && tm(i, n))) && (i = n, h = u)), n = n.next;
                while (n !== o);
                return i;
            }(t1, e);
            if (!i) return e;
            const n = hm(i, t1);
            return Wf(n, n.next), Wf(i, i.next);
        }
        function tm(t1, e) {
            return am(t1.prev, t1, e.prev) < 0 && am(e.next, t1, t1.next) < 0;
        }
        function em(t1, e, i, n, r) {
            return (t1 = 1431655765 & ((t1 = 858993459 & ((t1 = 252645135 & ((t1 = 16711935 & ((t1 = (t1 - i) * r | 0) | t1 << 8)) | t1 << 4)) | t1 << 2)) | t1 << 1)) | (e = 1431655765 & ((e = 858993459 & ((e = 252645135 & ((e = 16711935 & ((e = (e - n) * r | 0) | e << 8)) | e << 4)) | e << 2)) | e << 1)) << 1;
        }
        function im(t1) {
            let e = t1, i = t1;
            do (e.x < i.x || e.x === i.x && e.y < i.y) && (i = e), e = e.next;
            while (e !== t1);
            return i;
        }
        function nm(t1, e, i, n, r, a, s, o) {
            return (r - s) * (e - o) >= (t1 - s) * (a - o) && (t1 - s) * (n - o) >= (i - s) * (e - o) && (i - s) * (a - o) >= (r - s) * (n - o);
        }
        function rm(t1, e) {
            return t1.next.i !== e.i && t1.prev.i !== e.i && !function(t1, e) {
                let i = t1;
                do {
                    if (i.i !== t1.i && i.next.i !== t1.i && i.i !== e.i && i.next.i !== e.i && om(i, i.next, t1, e)) return !0;
                    i = i.next;
                }while (i !== t1);
                return !1;
            }(t1, e) && (um(t1, e) && um(e, t1) && function(t1, e) {
                let i = t1, n = !1;
                const r = (t1.x + e.x) / 2, a = (t1.y + e.y) / 2;
                do i.y > a != i.next.y > a && i.next.y !== i.y && r < (i.next.x - i.x) * (a - i.y) / (i.next.y - i.y) + i.x && (n = !n), i = i.next;
                while (i !== t1);
                return n;
            }(t1, e) && (am(t1.prev, t1, e.prev) || am(t1, e.prev, e)) || sm(t1, e) && am(t1.prev, t1, t1.next) > 0 && am(e.prev, e, e.next) > 0);
        }
        function am(t1, e, i) {
            return (e.y - t1.y) * (i.x - e.x) - (e.x - t1.x) * (i.y - e.y);
        }
        function sm(t1, e) {
            return t1.x === e.x && t1.y === e.y;
        }
        function om(t1, e, i, n) {
            const r = cm(am(t1, e, i)), a = cm(am(t1, e, n)), s = cm(am(i, n, t1)), o = cm(am(i, n, e));
            return r !== a && s !== o || !(0 !== r || !lm(t1, i, e)) || !(0 !== a || !lm(t1, n, e)) || !(0 !== s || !lm(i, t1, n)) || !(0 !== o || !lm(i, e, n));
        }
        function lm(t1, e, i) {
            return e.x <= Math.max(t1.x, i.x) && e.x >= Math.min(t1.x, i.x) && e.y <= Math.max(t1.y, i.y) && e.y >= Math.min(t1.y, i.y);
        }
        function cm(t1) {
            return t1 > 0 ? 1 : t1 < 0 ? -1 : 0;
        }
        function um(t1, e) {
            return am(t1.prev, t1, t1.next) < 0 ? am(t1, e, t1.next) >= 0 && am(t1, t1.prev, e) >= 0 : am(t1, e, t1.prev) < 0 || am(t1, t1.next, e) < 0;
        }
        function hm(t1, e) {
            const i = new Am(t1.i, t1.x, t1.y), n = new Am(e.i, e.x, e.y), r = t1.next, a = e.prev;
            return t1.next = e, e.prev = t1, i.next = r, r.prev = i, n.next = i, i.prev = n, a.next = n, n.prev = a, n;
        }
        function dm(t1, e, i, n) {
            const r = new Am(t1, e, i);
            return n ? (r.next = n.next, r.prev = n, n.next.prev = r, n.next = r) : (r.prev = r, r.next = r), r;
        }
        function pm(t1) {
            t1.next.prev = t1.prev, t1.prev.next = t1.next, t1.prevZ && (t1.prevZ.nextZ = t1.nextZ), t1.nextZ && (t1.nextZ.prevZ = t1.prevZ);
        }
        function Am(t1, e, i) {
            this.i = t1, this.x = e, this.y = i, this.prev = null, this.next = null, this.z = 0, this.prevZ = null, this.nextZ = null, this.steiner = !1;
        }
        class fm {
            static area(t1) {
                const e = t1.length;
                let i = 0;
                for(let n = e - 1, r = 0; r < e; n = r++)i += t1[n].x * t1[r].y - t1[r].x * t1[n].y;
                return .5 * i;
            }
            static isClockWise(t1) {
                return fm.area(t1) < 0;
            }
            static triangulateShape(t1, e) {
                const i = [], n = [], r = [];
                mm(t1), gm(i, t1);
                let a = t1.length;
                e.forEach(mm);
                for(let t1 = 0; t1 < e.length; t1++)n.push(a), a += e[t1].length, gm(i, e[t1]);
                const s = function(t1, e, i = 2) {
                    const n = e && e.length, r = n ? e[0] * i : t1.length;
                    let a = Gf(t1, 0, r, i, !0);
                    const s = [];
                    if (!a || a.next === a.prev) return s;
                    let o, l, c, u, h, d, p;
                    if (n && (a = function(t1, e, i, n) {
                        const r = [];
                        let a, s, o, l, c;
                        for(a = 0, s = e.length; a < s; a++)o = e[a] * n, l = a < s - 1 ? e[a + 1] * n : t1.length, c = Gf(t1, o, l, n, !1), c === c.next && (c.steiner = !0), r.push(im(c));
                        for(r.sort(Kf), a = 0; a < r.length; a++)i = $f(r[a], i);
                        return i;
                    }(t1, e, a, i)), t1.length > 80 * i) {
                        o = c = t1[0], l = u = t1[1];
                        for(let e = i; e < r; e += i)h = t1[e], d = t1[e + 1], h < o && (o = h), d < l && (l = d), h > c && (c = h), d > u && (u = d);
                        p = Math.max(c - o, u - l), p = 0 !== p ? 32767 / p : 0;
                    }
                    return Yf(a, s, i, o, l, p, 0), s;
                }(i, n);
                for(let t1 = 0; t1 < s.length; t1 += 3)r.push(s.slice(t1, t1 + 3));
                return r;
            }
        }
        function mm(t1) {
            const e = t1.length;
            e > 2 && t1[e - 1].equals(t1[0]) && t1.pop();
        }
        function gm(t1, e) {
            for(let i = 0; i < e.length; i++)t1.push(e[i].x), t1.push(e[i].y);
        }
        class Mm extends bu {
            constructor(t1 = new Vf([
                new qo(.5, .5),
                new qo(-0.5, .5),
                new qo(-0.5, -0.5),
                new qo(.5, -0.5)
            ]), e = {}){
                super(), this.type = "ExtrudeGeometry", this.parameters = {
                    shapes: t1,
                    options: e
                }, t1 = Array.isArray(t1) ? t1 : [
                    t1
                ];
                const i = this, n = [], r = [];
                for(let e = 0, i = t1.length; e < i; e++)a(t1[e]);
                function a(t1) {
                    const a = [], s = void 0 !== e.curveSegments ? e.curveSegments : 12, o = void 0 !== e.steps ? e.steps : 1, l = void 0 !== e.depth ? e.depth : 1;
                    let c = void 0 === e.bevelEnabled || e.bevelEnabled, u = void 0 !== e.bevelThickness ? e.bevelThickness : .2, h = void 0 !== e.bevelSize ? e.bevelSize : u - .1, d = void 0 !== e.bevelOffset ? e.bevelOffset : 0, p = void 0 !== e.bevelSegments ? e.bevelSegments : 3;
                    const A = e.extrudePath, f = void 0 !== e.UVGenerator ? e.UVGenerator : vm;
                    let m, g, M, v, y, x = !1;
                    A && (m = A.getSpacedPoints(o), x = !0, c = !1, g = A.computeFrenetFrames(o, !1), M = new Nl, v = new Nl, y = new Nl), c || (p = 0, u = 0, h = 0, d = 0);
                    const w = t1.extractPoints(s);
                    let b = w.shape;
                    const T = w.holes;
                    if (!fm.isClockWise(b)) {
                        b = b.reverse();
                        for(let t1 = 0, e = T.length; t1 < e; t1++){
                            const e = T[t1];
                            fm.isClockWise(e) && (T[t1] = e.reverse());
                        }
                    }
                    const E = fm.triangulateShape(b, T), _ = b;
                    for(let t1 = 0, e = T.length; t1 < e; t1++){
                        const e = T[t1];
                        b = b.concat(e);
                    }
                    function I(t1, e, i) {
                        return e || console.error("THREE.ExtrudeGeometry: vec does not exist"), t1.clone().addScaledVector(e, i);
                    }
                    const S = b.length, N = E.length;
                    function D(t1, e, i) {
                        let n, r, a;
                        const s = t1.x - e.x, o = t1.y - e.y, l = i.x - t1.x, c = i.y - t1.y, u = s * s + o * o, h = s * c - o * l;
                        if (Math.abs(h) > Number.EPSILON) {
                            const h = Math.sqrt(u), d = Math.sqrt(l * l + c * c), p = e.x - o / h, A = e.y + s / h, f = ((i.x - c / d - p) * c - (i.y + l / d - A) * l) / (s * c - o * l);
                            n = p + s * f - t1.x, r = A + o * f - t1.y;
                            const m = n * n + r * r;
                            if (m <= 2) return new qo(n, r);
                            a = Math.sqrt(m / 2);
                        } else {
                            let t1 = !1;
                            s > Number.EPSILON ? l > Number.EPSILON && (t1 = !0) : s < -Number.EPSILON ? l < -Number.EPSILON && (t1 = !0) : Math.sign(o) === Math.sign(c) && (t1 = !0), t1 ? (n = -o, r = s, a = Math.sqrt(u)) : (n = s, r = o, a = Math.sqrt(u / 2));
                        }
                        return new qo(n / a, r / a);
                    }
                    const C = [];
                    for(let t1 = 0, e = _.length, i = e - 1, n = t1 + 1; t1 < e; t1++, i++, n++)i === e && (i = 0), n === e && (n = 0), C[t1] = D(_[t1], _[i], _[n]);
                    const z = [];
                    let L, O = C.concat();
                    for(let t1 = 0, e = T.length; t1 < e; t1++){
                        const e = T[t1];
                        L = [];
                        for(let t1 = 0, i = e.length, n = i - 1, r = t1 + 1; t1 < i; t1++, n++, r++)n === i && (n = 0), r === i && (r = 0), L[t1] = D(e[t1], e[n], e[r]);
                        z.push(L), O = O.concat(L);
                    }
                    for(let t1 = 0; t1 < p; t1++){
                        const e = t1 / p, i = u * Math.cos(e * Math.PI / 2), n = h * Math.sin(e * Math.PI / 2) + d;
                        for(let t1 = 0, e = _.length; t1 < e; t1++){
                            const e = I(_[t1], C[t1], n);
                            R(e.x, e.y, -i);
                        }
                        for(let t1 = 0, e = T.length; t1 < e; t1++){
                            const e = T[t1];
                            L = z[t1];
                            for(let t1 = 0, r = e.length; t1 < r; t1++){
                                const r = I(e[t1], L[t1], n);
                                R(r.x, r.y, -i);
                            }
                        }
                    }
                    const P = h + d;
                    for(let t1 = 0; t1 < S; t1++){
                        const e = c ? I(b[t1], O[t1], P) : b[t1];
                        x ? (v.copy(g.normals[0]).multiplyScalar(e.x), M.copy(g.binormals[0]).multiplyScalar(e.y), y.copy(m[0]).add(v).add(M), R(y.x, y.y, y.z)) : R(e.x, e.y, 0);
                    }
                    for(let t1 = 1; t1 <= o; t1++)for(let e = 0; e < S; e++){
                        const i = c ? I(b[e], O[e], P) : b[e];
                        x ? (v.copy(g.normals[t1]).multiplyScalar(i.x), M.copy(g.binormals[t1]).multiplyScalar(i.y), y.copy(m[t1]).add(v).add(M), R(y.x, y.y, y.z)) : R(i.x, i.y, l / o * t1);
                    }
                    for(let t1 = p - 1; t1 >= 0; t1--){
                        const e = t1 / p, i = u * Math.cos(e * Math.PI / 2), n = h * Math.sin(e * Math.PI / 2) + d;
                        for(let t1 = 0, e = _.length; t1 < e; t1++){
                            const e = I(_[t1], C[t1], n);
                            R(e.x, e.y, l + i);
                        }
                        for(let t1 = 0, e = T.length; t1 < e; t1++){
                            const e = T[t1];
                            L = z[t1];
                            for(let t1 = 0, r = e.length; t1 < r; t1++){
                                const r = I(e[t1], L[t1], n);
                                x ? R(r.x, r.y + m[o - 1].y, m[o - 1].x + i) : R(r.x, r.y, l + i);
                            }
                        }
                    }
                    function j(t1, e) {
                        let i = t1.length;
                        for(; --i >= 0;){
                            const n = i;
                            let r = i - 1;
                            r < 0 && (r = t1.length - 1);
                            for(let t1 = 0, i = o + 2 * p; t1 < i; t1++){
                                const i = S * t1, a = S * (t1 + 1);
                                U(e + n + i, e + r + i, e + r + a, e + n + a);
                            }
                        }
                    }
                    function R(t1, e, i) {
                        a.push(t1), a.push(e), a.push(i);
                    }
                    function k(t1, e, r) {
                        B(t1), B(e), B(r);
                        const a = n.length / 3, s = f.generateTopUV(i, n, a - 3, a - 2, a - 1);
                        F(s[0]), F(s[1]), F(s[2]);
                    }
                    function U(t1, e, r, a) {
                        B(t1), B(e), B(a), B(e), B(r), B(a);
                        const s = n.length / 3, o = f.generateSideWallUV(i, n, s - 6, s - 3, s - 2, s - 1);
                        F(o[0]), F(o[1]), F(o[3]), F(o[1]), F(o[2]), F(o[3]);
                    }
                    function B(t1) {
                        n.push(a[3 * t1 + 0]), n.push(a[3 * t1 + 1]), n.push(a[3 * t1 + 2]);
                    }
                    function F(t1) {
                        r.push(t1.x), r.push(t1.y);
                    }
                    !function() {
                        const t1 = n.length / 3;
                        if (c) {
                            let t1 = 0, e = S * t1;
                            for(let t1 = 0; t1 < N; t1++){
                                const i = E[t1];
                                k(i[2] + e, i[1] + e, i[0] + e);
                            }
                            t1 = o + 2 * p, e = S * t1;
                            for(let t1 = 0; t1 < N; t1++){
                                const i = E[t1];
                                k(i[0] + e, i[1] + e, i[2] + e);
                            }
                        } else {
                            for(let t1 = 0; t1 < N; t1++){
                                const e = E[t1];
                                k(e[2], e[1], e[0]);
                            }
                            for(let t1 = 0; t1 < N; t1++){
                                const e = E[t1];
                                k(e[0] + S * o, e[1] + S * o, e[2] + S * o);
                            }
                        }
                        i.addGroup(t1, n.length / 3 - t1, 0);
                    }(), function() {
                        const t1 = n.length / 3;
                        let e = 0;
                        j(_, e), e += _.length;
                        for(let t1 = 0, i = T.length; t1 < i; t1++){
                            const i = T[t1];
                            j(i, e), e += i.length;
                        }
                        i.addGroup(t1, n.length / 3 - t1, 1);
                    }();
                }
                this.setAttribute("position", new Au(n, 3)), this.setAttribute("uv", new Au(r, 2)), this.computeVertexNormals();
            }
            copy(t1) {
                return super.copy(t1), this.parameters = Object.assign({}, t1.parameters), this;
            }
            toJSON() {
                const t1 = super.toJSON();
                return function(t1, e, i) {
                    if (i.shapes = [], Array.isArray(t1)) for(let e = 0, n = t1.length; e < n; e++){
                        const n = t1[e];
                        i.shapes.push(n.uuid);
                    }
                    else i.shapes.push(t1.uuid);
                    return i.options = Object.assign({}, e), void 0 !== e.extrudePath && (i.options.extrudePath = e.extrudePath.toJSON()), i;
                }(this.parameters.shapes, this.parameters.options, t1);
            }
            static fromJSON(t1, e) {
                const i = [];
                for(let n = 0, r = t1.shapes.length; n < r; n++){
                    const r = e[t1.shapes[n]];
                    i.push(r);
                }
                const n = t1.options.extrudePath;
                return void 0 !== n && (t1.options.extrudePath = (new Nf[n.type]).fromJSON(n)), new Mm(i, t1.options);
            }
        }
        const vm = {
            generateTopUV: function(t1, e, i, n, r) {
                const a = e[3 * i], s = e[3 * i + 1], o = e[3 * n], l = e[3 * n + 1], c = e[3 * r], u = e[3 * r + 1];
                return [
                    new qo(a, s),
                    new qo(o, l),
                    new qo(c, u)
                ];
            },
            generateSideWallUV: function(t1, e, i, n, r, a) {
                const s = e[3 * i], o = e[3 * i + 1], l = e[3 * i + 2], c = e[3 * n], u = e[3 * n + 1], h = e[3 * n + 2], d = e[3 * r], p = e[3 * r + 1], A = e[3 * r + 2], f = e[3 * a], m = e[3 * a + 1], g = e[3 * a + 2];
                return Math.abs(o - u) < Math.abs(s - c) ? [
                    new qo(s, 1 - l),
                    new qo(c, 1 - h),
                    new qo(d, 1 - A),
                    new qo(f, 1 - g)
                ] : [
                    new qo(o, 1 - l),
                    new qo(u, 1 - h),
                    new qo(p, 1 - A),
                    new qo(m, 1 - g)
                ];
            }
        };
        class ym extends Rf {
            constructor(t1 = 1, e = 0){
                const i = (1 + Math.sqrt(5)) / 2;
                super([
                    -1,
                    i,
                    0,
                    1,
                    i,
                    0,
                    -1,
                    -i,
                    0,
                    1,
                    -i,
                    0,
                    0,
                    -1,
                    i,
                    0,
                    1,
                    i,
                    0,
                    -1,
                    -i,
                    0,
                    1,
                    -i,
                    i,
                    0,
                    -1,
                    i,
                    0,
                    1,
                    -i,
                    0,
                    -1,
                    -i,
                    0,
                    1
                ], [
                    0,
                    11,
                    5,
                    0,
                    5,
                    1,
                    0,
                    1,
                    7,
                    0,
                    7,
                    10,
                    0,
                    10,
                    11,
                    1,
                    5,
                    9,
                    5,
                    11,
                    4,
                    11,
                    10,
                    2,
                    10,
                    7,
                    6,
                    7,
                    1,
                    8,
                    3,
                    9,
                    4,
                    3,
                    4,
                    2,
                    3,
                    2,
                    6,
                    3,
                    6,
                    8,
                    3,
                    8,
                    9,
                    4,
                    9,
                    5,
                    2,
                    4,
                    11,
                    6,
                    2,
                    10,
                    8,
                    6,
                    7,
                    9,
                    8,
                    1
                ], t1, e), this.type = "IcosahedronGeometry", this.parameters = {
                    radius: t1,
                    detail: e
                };
            }
            static fromJSON(t1) {
                return new ym(t1.radius, t1.detail);
            }
        }
        class xm extends Rf {
            constructor(t1 = 1, e = 0){
                super([
                    1,
                    0,
                    0,
                    -1,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    -1,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    -1
                ], [
                    0,
                    2,
                    4,
                    0,
                    4,
                    3,
                    0,
                    3,
                    5,
                    0,
                    5,
                    2,
                    1,
                    2,
                    5,
                    1,
                    5,
                    3,
                    1,
                    3,
                    4,
                    1,
                    4,
                    2
                ], t1, e), this.type = "OctahedronGeometry", this.parameters = {
                    radius: t1,
                    detail: e
                };
            }
            static fromJSON(t1) {
                return new xm(t1.radius, t1.detail);
            }
        }
        class wm extends bu {
            constructor(t1 = .5, e = 1, i = 32, n = 1, r = 0, a = 2 * Math.PI){
                super(), this.type = "RingGeometry", this.parameters = {
                    innerRadius: t1,
                    outerRadius: e,
                    thetaSegments: i,
                    phiSegments: n,
                    thetaStart: r,
                    thetaLength: a
                }, i = Math.max(3, i);
                const s = [], o = [], l = [], c = [];
                let u = t1;
                const h = (e - t1) / (n = Math.max(1, n)), d = new Nl, p = new qo;
                for(let t1 = 0; t1 <= n; t1++){
                    for(let t1 = 0; t1 <= i; t1++){
                        const n = r + t1 / i * a;
                        d.x = u * Math.cos(n), d.y = u * Math.sin(n), o.push(d.x, d.y, d.z), l.push(0, 0, 1), p.x = (d.x / e + 1) / 2, p.y = (d.y / e + 1) / 2, c.push(p.x, p.y);
                    }
                    u += h;
                }
                for(let t1 = 0; t1 < n; t1++){
                    const e = t1 * (i + 1);
                    for(let t1 = 0; t1 < i; t1++){
                        const n = t1 + e, r = n, a = n + i + 1, o = n + i + 2, l = n + 1;
                        s.push(r, a, l), s.push(a, o, l);
                    }
                }
                this.setIndex(s), this.setAttribute("position", new Au(o, 3)), this.setAttribute("normal", new Au(l, 3)), this.setAttribute("uv", new Au(c, 2));
            }
            copy(t1) {
                return super.copy(t1), this.parameters = Object.assign({}, t1.parameters), this;
            }
            static fromJSON(t1) {
                return new wm(t1.innerRadius, t1.outerRadius, t1.thetaSegments, t1.phiSegments, t1.thetaStart, t1.thetaLength);
            }
        }
        class bm extends bu {
            constructor(t1 = new Vf([
                new qo(0, .5),
                new qo(-0.5, -0.5),
                new qo(.5, -0.5)
            ]), e = 12){
                super(), this.type = "ShapeGeometry", this.parameters = {
                    shapes: t1,
                    curveSegments: e
                };
                const i = [], n = [], r = [], a = [];
                let s = 0, o = 0;
                if (!1 === Array.isArray(t1)) l(t1);
                else for(let e = 0; e < t1.length; e++)l(t1[e]), this.addGroup(s, o, e), s += o, o = 0;
                function l(t1) {
                    const s = n.length / 3, l = t1.extractPoints(e);
                    let c = l.shape;
                    const u = l.holes;
                    !1 === fm.isClockWise(c) && (c = c.reverse());
                    for(let t1 = 0, e = u.length; t1 < e; t1++){
                        const e = u[t1];
                        !0 === fm.isClockWise(e) && (u[t1] = e.reverse());
                    }
                    const h = fm.triangulateShape(c, u);
                    for(let t1 = 0, e = u.length; t1 < e; t1++){
                        const e = u[t1];
                        c = c.concat(e);
                    }
                    for(let t1 = 0, e = c.length; t1 < e; t1++){
                        const e = c[t1];
                        n.push(e.x, e.y, 0), r.push(0, 0, 1), a.push(e.x, e.y);
                    }
                    for(let t1 = 0, e = h.length; t1 < e; t1++){
                        const e = h[t1], n = e[0] + s, r = e[1] + s, a = e[2] + s;
                        i.push(n, r, a), o += 3;
                    }
                }
                this.setIndex(i), this.setAttribute("position", new Au(n, 3)), this.setAttribute("normal", new Au(r, 3)), this.setAttribute("uv", new Au(a, 2));
            }
            copy(t1) {
                return super.copy(t1), this.parameters = Object.assign({}, t1.parameters), this;
            }
            toJSON() {
                const t1 = super.toJSON();
                return function(t1, e) {
                    if (e.shapes = [], Array.isArray(t1)) for(let i = 0, n = t1.length; i < n; i++){
                        const n = t1[i];
                        e.shapes.push(n.uuid);
                    }
                    else e.shapes.push(t1.uuid);
                    return e;
                }(this.parameters.shapes, t1);
            }
            static fromJSON(t1, e) {
                const i = [];
                for(let n = 0, r = t1.shapes.length; n < r; n++){
                    const r = e[t1.shapes[n]];
                    i.push(r);
                }
                return new bm(i, t1.curveSegments);
            }
        }
        class Tm extends bu {
            constructor(t1 = 1, e = 32, i = 16, n = 0, r = 2 * Math.PI, a = 0, s = Math.PI){
                super(), this.type = "SphereGeometry", this.parameters = {
                    radius: t1,
                    widthSegments: e,
                    heightSegments: i,
                    phiStart: n,
                    phiLength: r,
                    thetaStart: a,
                    thetaLength: s
                }, e = Math.max(3, Math.floor(e)), i = Math.max(2, Math.floor(i));
                const o = Math.min(a + s, Math.PI);
                let l = 0;
                const c = [], u = new Nl, h = new Nl, d = [], p = [], A = [], f = [];
                for(let d = 0; d <= i; d++){
                    const m = [], g = d / i;
                    let M = 0;
                    0 === d && 0 === a ? M = .5 / e : d === i && o === Math.PI && (M = -0.5 / e);
                    for(let i = 0; i <= e; i++){
                        const o = i / e;
                        u.x = -t1 * Math.cos(n + o * r) * Math.sin(a + g * s), u.y = t1 * Math.cos(a + g * s), u.z = t1 * Math.sin(n + o * r) * Math.sin(a + g * s), p.push(u.x, u.y, u.z), h.copy(u).normalize(), A.push(h.x, h.y, h.z), f.push(o + M, 1 - g), m.push(l++);
                    }
                    c.push(m);
                }
                for(let t1 = 0; t1 < i; t1++)for(let n = 0; n < e; n++){
                    const e = c[t1][n + 1], r = c[t1][n], s = c[t1 + 1][n], l = c[t1 + 1][n + 1];
                    (0 !== t1 || a > 0) && d.push(e, r, l), (t1 !== i - 1 || o < Math.PI) && d.push(r, s, l);
                }
                this.setIndex(d), this.setAttribute("position", new Au(p, 3)), this.setAttribute("normal", new Au(A, 3)), this.setAttribute("uv", new Au(f, 2));
            }
            copy(t1) {
                return super.copy(t1), this.parameters = Object.assign({}, t1.parameters), this;
            }
            static fromJSON(t1) {
                return new Tm(t1.radius, t1.widthSegments, t1.heightSegments, t1.phiStart, t1.phiLength, t1.thetaStart, t1.thetaLength);
            }
        }
        class Em extends Rf {
            constructor(t1 = 1, e = 0){
                super([
                    1,
                    1,
                    1,
                    -1,
                    -1,
                    1,
                    -1,
                    1,
                    -1,
                    1,
                    -1,
                    -1
                ], [
                    2,
                    1,
                    0,
                    0,
                    3,
                    2,
                    1,
                    3,
                    0,
                    2,
                    3,
                    1
                ], t1, e), this.type = "TetrahedronGeometry", this.parameters = {
                    radius: t1,
                    detail: e
                };
            }
            static fromJSON(t1) {
                return new Em(t1.radius, t1.detail);
            }
        }
        class _m extends bu {
            constructor(t1 = 1, e = .4, i = 12, n = 48, r = 2 * Math.PI){
                super(), this.type = "TorusGeometry", this.parameters = {
                    radius: t1,
                    tube: e,
                    radialSegments: i,
                    tubularSegments: n,
                    arc: r
                }, i = Math.floor(i), n = Math.floor(n);
                const a = [], s = [], o = [], l = [], c = new Nl, u = new Nl, h = new Nl;
                for(let a = 0; a <= i; a++)for(let d = 0; d <= n; d++){
                    const p = d / n * r, A = a / i * Math.PI * 2;
                    u.x = (t1 + e * Math.cos(A)) * Math.cos(p), u.y = (t1 + e * Math.cos(A)) * Math.sin(p), u.z = e * Math.sin(A), s.push(u.x, u.y, u.z), c.x = t1 * Math.cos(p), c.y = t1 * Math.sin(p), h.subVectors(u, c).normalize(), o.push(h.x, h.y, h.z), l.push(d / n), l.push(a / i);
                }
                for(let t1 = 1; t1 <= i; t1++)for(let e = 1; e <= n; e++){
                    const i = (n + 1) * t1 + e - 1, r = (n + 1) * (t1 - 1) + e - 1, s = (n + 1) * (t1 - 1) + e, o = (n + 1) * t1 + e;
                    a.push(i, r, o), a.push(r, s, o);
                }
                this.setIndex(a), this.setAttribute("position", new Au(s, 3)), this.setAttribute("normal", new Au(o, 3)), this.setAttribute("uv", new Au(l, 2));
            }
            copy(t1) {
                return super.copy(t1), this.parameters = Object.assign({}, t1.parameters), this;
            }
            static fromJSON(t1) {
                return new _m(t1.radius, t1.tube, t1.radialSegments, t1.tubularSegments, t1.arc);
            }
        }
        class Im extends bu {
            constructor(t1 = 1, e = .4, i = 64, n = 8, r = 2, a = 3){
                super(), this.type = "TorusKnotGeometry", this.parameters = {
                    radius: t1,
                    tube: e,
                    tubularSegments: i,
                    radialSegments: n,
                    p: r,
                    q: a
                }, i = Math.floor(i), n = Math.floor(n);
                const s = [], o = [], l = [], c = [], u = new Nl, h = new Nl, d = new Nl, p = new Nl, A = new Nl, f = new Nl, m = new Nl;
                for(let s = 0; s <= i; ++s){
                    const M = s / i * r * Math.PI * 2;
                    g(M, r, a, t1, d), g(M + .01, r, a, t1, p), f.subVectors(p, d), m.addVectors(p, d), A.crossVectors(f, m), m.crossVectors(A, f), A.normalize(), m.normalize();
                    for(let t1 = 0; t1 <= n; ++t1){
                        const r = t1 / n * Math.PI * 2, a = -e * Math.cos(r), p = e * Math.sin(r);
                        u.x = d.x + (a * m.x + p * A.x), u.y = d.y + (a * m.y + p * A.y), u.z = d.z + (a * m.z + p * A.z), o.push(u.x, u.y, u.z), h.subVectors(u, d).normalize(), l.push(h.x, h.y, h.z), c.push(s / i), c.push(t1 / n);
                    }
                }
                for(let t1 = 1; t1 <= i; t1++)for(let e = 1; e <= n; e++){
                    const i = (n + 1) * (t1 - 1) + (e - 1), r = (n + 1) * t1 + (e - 1), a = (n + 1) * t1 + e, o = (n + 1) * (t1 - 1) + e;
                    s.push(i, r, o), s.push(r, a, o);
                }
                function g(t1, e, i, n, r) {
                    const a = Math.cos(t1), s = Math.sin(t1), o = i / e * t1, l = Math.cos(o);
                    r.x = n * (2 + l) * .5 * a, r.y = n * (2 + l) * s * .5, r.z = n * Math.sin(o) * .5;
                }
                this.setIndex(s), this.setAttribute("position", new Au(o, 3)), this.setAttribute("normal", new Au(l, 3)), this.setAttribute("uv", new Au(c, 2));
            }
            copy(t1) {
                return super.copy(t1), this.parameters = Object.assign({}, t1.parameters), this;
            }
            static fromJSON(t1) {
                return new Im(t1.radius, t1.tube, t1.tubularSegments, t1.radialSegments, t1.p, t1.q);
            }
        }
        class Sm extends bu {
            constructor(t1 = new If(new Nl(-1, -1, 0), new Nl(-1, 1, 0), new Nl(1, 1, 0)), e = 64, i = 1, n = 8, r = !1){
                super(), this.type = "TubeGeometry", this.parameters = {
                    path: t1,
                    tubularSegments: e,
                    radius: i,
                    radialSegments: n,
                    closed: r
                };
                const a = t1.computeFrenetFrames(e, r);
                this.tangents = a.tangents, this.normals = a.normals, this.binormals = a.binormals;
                const s = new Nl, o = new Nl, l = new qo;
                let c = new Nl;
                const u = [], h = [], d = [], p = [];
                function A(r) {
                    c = t1.getPointAt(r / e, c);
                    const l = a.normals[r], d = a.binormals[r];
                    for(let t1 = 0; t1 <= n; t1++){
                        const e = t1 / n * Math.PI * 2, r = Math.sin(e), a = -Math.cos(e);
                        o.x = a * l.x + r * d.x, o.y = a * l.y + r * d.y, o.z = a * l.z + r * d.z, o.normalize(), h.push(o.x, o.y, o.z), s.x = c.x + i * o.x, s.y = c.y + i * o.y, s.z = c.z + i * o.z, u.push(s.x, s.y, s.z);
                    }
                }
                !function() {
                    for(let t1 = 0; t1 < e; t1++)A(t1);
                    A(!1 === r ? e : 0), function() {
                        for(let t1 = 0; t1 <= e; t1++)for(let i = 0; i <= n; i++)l.x = t1 / e, l.y = i / n, d.push(l.x, l.y);
                    }(), function() {
                        for(let t1 = 1; t1 <= e; t1++)for(let e = 1; e <= n; e++){
                            const i = (n + 1) * (t1 - 1) + (e - 1), r = (n + 1) * t1 + (e - 1), a = (n + 1) * t1 + e, s = (n + 1) * (t1 - 1) + e;
                            p.push(i, r, s), p.push(r, a, s);
                        }
                    }();
                }(), this.setIndex(p), this.setAttribute("position", new Au(u, 3)), this.setAttribute("normal", new Au(h, 3)), this.setAttribute("uv", new Au(d, 2));
            }
            copy(t1) {
                return super.copy(t1), this.parameters = Object.assign({}, t1.parameters), this;
            }
            toJSON() {
                const t1 = super.toJSON();
                return t1.path = this.parameters.path.toJSON(), t1;
            }
            static fromJSON(t1) {
                return new Sm((new Nf[t1.path.type]).fromJSON(t1.path), t1.tubularSegments, t1.radius, t1.radialSegments, t1.closed);
            }
        }
        class Nm extends bu {
            constructor(t1 = null){
                if (super(), this.type = "WireframeGeometry", this.parameters = {
                    geometry: t1
                }, null !== t1) {
                    const e = [], i = new Set, n = new Nl, r = new Nl;
                    if (null !== t1.index) {
                        const a = t1.attributes.position, s = t1.index;
                        let o = t1.groups;
                        0 === o.length && (o = [
                            {
                                start: 0,
                                count: s.count,
                                materialIndex: 0
                            }
                        ]);
                        for(let t1 = 0, l = o.length; t1 < l; ++t1){
                            const l = o[t1], c = l.start;
                            for(let t1 = c, o = c + l.count; t1 < o; t1 += 3)for(let o = 0; o < 3; o++){
                                const l = s.getX(t1 + o), c = s.getX(t1 + (o + 1) % 3);
                                n.fromBufferAttribute(a, l), r.fromBufferAttribute(a, c), !0 === Dm(n, r, i) && (e.push(n.x, n.y, n.z), e.push(r.x, r.y, r.z));
                            }
                        }
                    } else {
                        const a = t1.attributes.position;
                        for(let t1 = 0, s = a.count / 3; t1 < s; t1++)for(let s = 0; s < 3; s++){
                            const o = 3 * t1 + s, l = 3 * t1 + (s + 1) % 3;
                            n.fromBufferAttribute(a, o), r.fromBufferAttribute(a, l), !0 === Dm(n, r, i) && (e.push(n.x, n.y, n.z), e.push(r.x, r.y, r.z));
                        }
                    }
                    this.setAttribute("position", new Au(e, 3));
                }
            }
            copy(t1) {
                return super.copy(t1), this.parameters = Object.assign({}, t1.parameters), this;
            }
        }
        function Dm(t1, e, i) {
            const n = `${t1.x},${t1.y},${t1.z}-${e.x},${e.y},${e.z}`, r = `${e.x},${e.y},${e.z}-${t1.x},${t1.y},${t1.z}`;
            return !0 !== i.has(n) && !0 !== i.has(r) && (i.add(n), i.add(r), !0);
        }
        var Cm = Object.freeze({
            __proto__: null,
            BoxGeometry: Hu,
            CapsuleGeometry: Lf,
            CircleGeometry: Of,
            ConeGeometry: jf,
            CylinderGeometry: Pf,
            DodecahedronGeometry: kf,
            EdgesGeometry: Hf,
            ExtrudeGeometry: Mm,
            IcosahedronGeometry: ym,
            LatheGeometry: zf,
            OctahedronGeometry: xm,
            PlaneGeometry: uh,
            PolyhedronGeometry: Rf,
            RingGeometry: wm,
            ShapeGeometry: bm,
            SphereGeometry: Tm,
            TetrahedronGeometry: Em,
            TorusGeometry: _m,
            TorusKnotGeometry: Im,
            TubeGeometry: Sm,
            WireframeGeometry: Nm
        });
        class zm extends qc {
            constructor(t1){
                super(), this.isShadowMaterial = !0, this.type = "ShadowMaterial", this.color = new Yc(0), this.transparent = !0, this.fog = !0, this.setValues(t1);
            }
            copy(t1) {
                return super.copy(t1), this.color.copy(t1.color), this.fog = t1.fog, this;
            }
        }
        class Lm extends Xu {
            constructor(t1){
                super(t1), this.isRawShaderMaterial = !0, this.type = "RawShaderMaterial";
            }
        }
        class Om extends qc {
            constructor(t1){
                super(), this.isMeshStandardMaterial = !0, this.defines = {
                    STANDARD: ""
                }, this.type = "MeshStandardMaterial", this.color = new Yc(16777215), this.roughness = 1, this.metalness = 0, this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.emissive = new Yc(0), this.emissiveIntensity = 1, this.emissiveMap = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = Us, this.normalScale = new qo(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.roughnessMap = null, this.metalnessMap = null, this.alphaMap = null, this.envMap = null, this.envMapIntensity = 1, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.flatShading = !1, this.fog = !0, this.setValues(t1);
            }
            copy(t1) {
                return super.copy(t1), this.defines = {
                    STANDARD: ""
                }, this.color.copy(t1.color), this.roughness = t1.roughness, this.metalness = t1.metalness, this.map = t1.map, this.lightMap = t1.lightMap, this.lightMapIntensity = t1.lightMapIntensity, this.aoMap = t1.aoMap, this.aoMapIntensity = t1.aoMapIntensity, this.emissive.copy(t1.emissive), this.emissiveMap = t1.emissiveMap, this.emissiveIntensity = t1.emissiveIntensity, this.bumpMap = t1.bumpMap, this.bumpScale = t1.bumpScale, this.normalMap = t1.normalMap, this.normalMapType = t1.normalMapType, this.normalScale.copy(t1.normalScale), this.displacementMap = t1.displacementMap, this.displacementScale = t1.displacementScale, this.displacementBias = t1.displacementBias, this.roughnessMap = t1.roughnessMap, this.metalnessMap = t1.metalnessMap, this.alphaMap = t1.alphaMap, this.envMap = t1.envMap, this.envMapIntensity = t1.envMapIntensity, this.wireframe = t1.wireframe, this.wireframeLinewidth = t1.wireframeLinewidth, this.wireframeLinecap = t1.wireframeLinecap, this.wireframeLinejoin = t1.wireframeLinejoin, this.flatShading = t1.flatShading, this.fog = t1.fog, this;
            }
        }
        class Pm extends Om {
            constructor(t1){
                super(), this.isMeshPhysicalMaterial = !0, this.defines = {
                    STANDARD: "",
                    PHYSICAL: ""
                }, this.type = "MeshPhysicalMaterial", this.anisotropyRotation = 0, this.anisotropyMap = null, this.clearcoatMap = null, this.clearcoatRoughness = 0, this.clearcoatRoughnessMap = null, this.clearcoatNormalScale = new qo(1, 1), this.clearcoatNormalMap = null, this.ior = 1.5, Object.defineProperty(this, "reflectivity", {
                    get: function() {
                        return Fo(2.5 * (this.ior - 1) / (this.ior + 1), 0, 1);
                    },
                    set: function(t1) {
                        this.ior = (1 + .4 * t1) / (1 - .4 * t1);
                    }
                }), this.iridescenceMap = null, this.iridescenceIOR = 1.3, this.iridescenceThicknessRange = [
                    100,
                    400
                ], this.iridescenceThicknessMap = null, this.sheenColor = new Yc(0), this.sheenColorMap = null, this.sheenRoughness = 1, this.sheenRoughnessMap = null, this.transmissionMap = null, this.thickness = 0, this.thicknessMap = null, this.attenuationDistance = 1 / 0, this.attenuationColor = new Yc(1, 1, 1), this.specularIntensity = 1, this.specularIntensityMap = null, this.specularColor = new Yc(1, 1, 1), this.specularColorMap = null, this._anisotropy = 0, this._clearcoat = 0, this._iridescence = 0, this._sheen = 0, this._transmission = 0, this.setValues(t1);
            }
            get anisotropy() {
                return this._anisotropy;
            }
            set anisotropy(t1) {
                this._anisotropy > 0 != t1 > 0 && this.version++, this._anisotropy = t1;
            }
            get clearcoat() {
                return this._clearcoat;
            }
            set clearcoat(t1) {
                this._clearcoat > 0 != t1 > 0 && this.version++, this._clearcoat = t1;
            }
            get iridescence() {
                return this._iridescence;
            }
            set iridescence(t1) {
                this._iridescence > 0 != t1 > 0 && this.version++, this._iridescence = t1;
            }
            get sheen() {
                return this._sheen;
            }
            set sheen(t1) {
                this._sheen > 0 != t1 > 0 && this.version++, this._sheen = t1;
            }
            get transmission() {
                return this._transmission;
            }
            set transmission(t1) {
                this._transmission > 0 != t1 > 0 && this.version++, this._transmission = t1;
            }
            copy(t1) {
                return super.copy(t1), this.defines = {
                    STANDARD: "",
                    PHYSICAL: ""
                }, this.anisotropy = t1.anisotropy, this.anisotropyRotation = t1.anisotropyRotation, this.anisotropyMap = t1.anisotropyMap, this.clearcoat = t1.clearcoat, this.clearcoatMap = t1.clearcoatMap, this.clearcoatRoughness = t1.clearcoatRoughness, this.clearcoatRoughnessMap = t1.clearcoatRoughnessMap, this.clearcoatNormalMap = t1.clearcoatNormalMap, this.clearcoatNormalScale.copy(t1.clearcoatNormalScale), this.ior = t1.ior, this.iridescence = t1.iridescence, this.iridescenceMap = t1.iridescenceMap, this.iridescenceIOR = t1.iridescenceIOR, this.iridescenceThicknessRange = [
                    ...t1.iridescenceThicknessRange
                ], this.iridescenceThicknessMap = t1.iridescenceThicknessMap, this.sheen = t1.sheen, this.sheenColor.copy(t1.sheenColor), this.sheenColorMap = t1.sheenColorMap, this.sheenRoughness = t1.sheenRoughness, this.sheenRoughnessMap = t1.sheenRoughnessMap, this.transmission = t1.transmission, this.transmissionMap = t1.transmissionMap, this.thickness = t1.thickness, this.thicknessMap = t1.thicknessMap, this.attenuationDistance = t1.attenuationDistance, this.attenuationColor.copy(t1.attenuationColor), this.specularIntensity = t1.specularIntensity, this.specularIntensityMap = t1.specularIntensityMap, this.specularColor.copy(t1.specularColor), this.specularColorMap = t1.specularColorMap, this;
            }
        }
        class jm extends qc {
            constructor(t1){
                super(), this.isMeshPhongMaterial = !0, this.type = "MeshPhongMaterial", this.color = new Yc(16777215), this.specular = new Yc(1118481), this.shininess = 30, this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.emissive = new Yc(0), this.emissiveIntensity = 1, this.emissiveMap = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = Us, this.normalScale = new qo(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.combine = Gr, this.reflectivity = 1, this.refractionRatio = .98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.flatShading = !1, this.fog = !0, this.setValues(t1);
            }
            copy(t1) {
                return super.copy(t1), this.color.copy(t1.color), this.specular.copy(t1.specular), this.shininess = t1.shininess, this.map = t1.map, this.lightMap = t1.lightMap, this.lightMapIntensity = t1.lightMapIntensity, this.aoMap = t1.aoMap, this.aoMapIntensity = t1.aoMapIntensity, this.emissive.copy(t1.emissive), this.emissiveMap = t1.emissiveMap, this.emissiveIntensity = t1.emissiveIntensity, this.bumpMap = t1.bumpMap, this.bumpScale = t1.bumpScale, this.normalMap = t1.normalMap, this.normalMapType = t1.normalMapType, this.normalScale.copy(t1.normalScale), this.displacementMap = t1.displacementMap, this.displacementScale = t1.displacementScale, this.displacementBias = t1.displacementBias, this.specularMap = t1.specularMap, this.alphaMap = t1.alphaMap, this.envMap = t1.envMap, this.combine = t1.combine, this.reflectivity = t1.reflectivity, this.refractionRatio = t1.refractionRatio, this.wireframe = t1.wireframe, this.wireframeLinewidth = t1.wireframeLinewidth, this.wireframeLinecap = t1.wireframeLinecap, this.wireframeLinejoin = t1.wireframeLinejoin, this.flatShading = t1.flatShading, this.fog = t1.fog, this;
            }
        }
        class Rm extends qc {
            constructor(t1){
                super(), this.isMeshToonMaterial = !0, this.defines = {
                    TOON: ""
                }, this.type = "MeshToonMaterial", this.color = new Yc(16777215), this.map = null, this.gradientMap = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.emissive = new Yc(0), this.emissiveIntensity = 1, this.emissiveMap = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = Us, this.normalScale = new qo(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.alphaMap = null, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.fog = !0, this.setValues(t1);
            }
            copy(t1) {
                return super.copy(t1), this.color.copy(t1.color), this.map = t1.map, this.gradientMap = t1.gradientMap, this.lightMap = t1.lightMap, this.lightMapIntensity = t1.lightMapIntensity, this.aoMap = t1.aoMap, this.aoMapIntensity = t1.aoMapIntensity, this.emissive.copy(t1.emissive), this.emissiveMap = t1.emissiveMap, this.emissiveIntensity = t1.emissiveIntensity, this.bumpMap = t1.bumpMap, this.bumpScale = t1.bumpScale, this.normalMap = t1.normalMap, this.normalMapType = t1.normalMapType, this.normalScale.copy(t1.normalScale), this.displacementMap = t1.displacementMap, this.displacementScale = t1.displacementScale, this.displacementBias = t1.displacementBias, this.alphaMap = t1.alphaMap, this.wireframe = t1.wireframe, this.wireframeLinewidth = t1.wireframeLinewidth, this.wireframeLinecap = t1.wireframeLinecap, this.wireframeLinejoin = t1.wireframeLinejoin, this.fog = t1.fog, this;
            }
        }
        class km extends qc {
            constructor(t1){
                super(), this.isMeshNormalMaterial = !0, this.type = "MeshNormalMaterial", this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = Us, this.normalScale = new qo(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.wireframe = !1, this.wireframeLinewidth = 1, this.flatShading = !1, this.setValues(t1);
            }
            copy(t1) {
                return super.copy(t1), this.bumpMap = t1.bumpMap, this.bumpScale = t1.bumpScale, this.normalMap = t1.normalMap, this.normalMapType = t1.normalMapType, this.normalScale.copy(t1.normalScale), this.displacementMap = t1.displacementMap, this.displacementScale = t1.displacementScale, this.displacementBias = t1.displacementBias, this.wireframe = t1.wireframe, this.wireframeLinewidth = t1.wireframeLinewidth, this.flatShading = t1.flatShading, this;
            }
        }
        class Um extends qc {
            constructor(t1){
                super(), this.isMeshLambertMaterial = !0, this.type = "MeshLambertMaterial", this.color = new Yc(16777215), this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.emissive = new Yc(0), this.emissiveIntensity = 1, this.emissiveMap = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = Us, this.normalScale = new qo(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.combine = Gr, this.reflectivity = 1, this.refractionRatio = .98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.flatShading = !1, this.fog = !0, this.setValues(t1);
            }
            copy(t1) {
                return super.copy(t1), this.color.copy(t1.color), this.map = t1.map, this.lightMap = t1.lightMap, this.lightMapIntensity = t1.lightMapIntensity, this.aoMap = t1.aoMap, this.aoMapIntensity = t1.aoMapIntensity, this.emissive.copy(t1.emissive), this.emissiveMap = t1.emissiveMap, this.emissiveIntensity = t1.emissiveIntensity, this.bumpMap = t1.bumpMap, this.bumpScale = t1.bumpScale, this.normalMap = t1.normalMap, this.normalMapType = t1.normalMapType, this.normalScale.copy(t1.normalScale), this.displacementMap = t1.displacementMap, this.displacementScale = t1.displacementScale, this.displacementBias = t1.displacementBias, this.specularMap = t1.specularMap, this.alphaMap = t1.alphaMap, this.envMap = t1.envMap, this.combine = t1.combine, this.reflectivity = t1.reflectivity, this.refractionRatio = t1.refractionRatio, this.wireframe = t1.wireframe, this.wireframeLinewidth = t1.wireframeLinewidth, this.wireframeLinecap = t1.wireframeLinecap, this.wireframeLinejoin = t1.wireframeLinejoin, this.flatShading = t1.flatShading, this.fog = t1.fog, this;
            }
        }
        class Bm extends qc {
            constructor(t1){
                super(), this.isMeshMatcapMaterial = !0, this.defines = {
                    MATCAP: ""
                }, this.type = "MeshMatcapMaterial", this.color = new Yc(16777215), this.matcap = null, this.map = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = Us, this.normalScale = new qo(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.alphaMap = null, this.flatShading = !1, this.fog = !0, this.setValues(t1);
            }
            copy(t1) {
                return super.copy(t1), this.defines = {
                    MATCAP: ""
                }, this.color.copy(t1.color), this.matcap = t1.matcap, this.map = t1.map, this.bumpMap = t1.bumpMap, this.bumpScale = t1.bumpScale, this.normalMap = t1.normalMap, this.normalMapType = t1.normalMapType, this.normalScale.copy(t1.normalScale), this.displacementMap = t1.displacementMap, this.displacementScale = t1.displacementScale, this.displacementBias = t1.displacementBias, this.alphaMap = t1.alphaMap, this.flatShading = t1.flatShading, this.fog = t1.fog, this;
            }
        }
        class Fm extends UA {
            constructor(t1){
                super(), this.isLineDashedMaterial = !0, this.type = "LineDashedMaterial", this.scale = 1, this.dashSize = 3, this.gapSize = 1, this.setValues(t1);
            }
            copy(t1) {
                return super.copy(t1), this.scale = t1.scale, this.dashSize = t1.dashSize, this.gapSize = t1.gapSize, this;
            }
        }
        function Qm(t1, e, i) {
            return !t1 || !i && t1.constructor === e ? t1 : "number" == typeof e.BYTES_PER_ELEMENT ? new e(t1) : Array.prototype.slice.call(t1);
        }
        function Hm(t1) {
            return ArrayBuffer.isView(t1) && !(t1 instanceof DataView);
        }
        function Vm(t1) {
            const e = t1.length, i = new Array(e);
            for(let t1 = 0; t1 !== e; ++t1)i[t1] = t1;
            return i.sort(function(e, i) {
                return t1[e] - t1[i];
            }), i;
        }
        function Gm(t1, e, i) {
            const n = t1.length, r = new t1.constructor(n);
            for(let a = 0, s = 0; s !== n; ++a){
                const n = i[a] * e;
                for(let i = 0; i !== e; ++i)r[s++] = t1[n + i];
            }
            return r;
        }
        function Wm(t1, e, i, n) {
            let r = 1, a = t1[0];
            for(; void 0 !== a && void 0 === a[n];)a = t1[r++];
            if (void 0 === a) return;
            let s = a[n];
            if (void 0 !== s) {
                if (Array.isArray(s)) do s = a[n], void 0 !== s && (e.push(a.time), i.push.apply(i, s)), a = t1[r++];
                while (void 0 !== a);
                else if (void 0 !== s.toArray) do s = a[n], void 0 !== s && (e.push(a.time), s.toArray(i, i.length)), a = t1[r++];
                while (void 0 !== a);
                else do s = a[n], void 0 !== s && (e.push(a.time), i.push(s)), a = t1[r++];
                while (void 0 !== a);
            }
        }
        const Ym = {
            convertArray: Qm,
            isTypedArray: Hm,
            getKeyframeOrder: Vm,
            sortedArray: Gm,
            flattenJSON: Wm,
            subclip: function(t1, e, i, n, r = 30) {
                const a = t1.clone();
                a.name = e;
                const s = [];
                for(let t1 = 0; t1 < a.tracks.length; ++t1){
                    const e = a.tracks[t1], o = e.getValueSize(), l = [], c = [];
                    for(let t1 = 0; t1 < e.times.length; ++t1){
                        const a = e.times[t1] * r;
                        if (!(a < i || a >= n)) {
                            l.push(e.times[t1]);
                            for(let i = 0; i < o; ++i)c.push(e.values[t1 * o + i]);
                        }
                    }
                    0 !== l.length && (e.times = Qm(l, e.times.constructor), e.values = Qm(c, e.values.constructor), s.push(e));
                }
                a.tracks = s;
                let o = 1 / 0;
                for(let t1 = 0; t1 < a.tracks.length; ++t1)o > a.tracks[t1].times[0] && (o = a.tracks[t1].times[0]);
                for(let t1 = 0; t1 < a.tracks.length; ++t1)a.tracks[t1].shift(-1 * o);
                return a.resetDuration(), a;
            },
            makeClipAdditive: function(t1, e = 0, i = t1, n = 30) {
                n <= 0 && (n = 30);
                const r = i.tracks.length, a = e / n;
                for(let e = 0; e < r; ++e){
                    const n = i.tracks[e], r = n.ValueTypeName;
                    if ("bool" === r || "string" === r) continue;
                    const s = t1.tracks.find(function(t1) {
                        return t1.name === n.name && t1.ValueTypeName === r;
                    });
                    if (void 0 === s) continue;
                    let o = 0;
                    const l = n.getValueSize();
                    n.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline && (o = l / 3);
                    let c = 0;
                    const u = s.getValueSize();
                    s.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline && (c = u / 3);
                    const h = n.times.length - 1;
                    let d;
                    if (a <= n.times[0]) {
                        const t1 = o, e = l - o;
                        d = n.values.slice(t1, e);
                    } else if (a >= n.times[h]) {
                        const t1 = h * l + o, e = t1 + l - o;
                        d = n.values.slice(t1, e);
                    } else {
                        const t1 = n.createInterpolant(), e = o, i = l - o;
                        t1.evaluate(a), d = t1.resultBuffer.slice(e, i);
                    }
                    "quaternion" === r && (new Sl).fromArray(d).normalize().conjugate().toArray(d);
                    const p = s.times.length;
                    for(let t1 = 0; t1 < p; ++t1){
                        const e = t1 * u + c;
                        if ("quaternion" === r) Sl.multiplyQuaternionsFlat(s.values, e, d, 0, s.values, e);
                        else {
                            const t1 = u - 2 * c;
                            for(let i = 0; i < t1; ++i)s.values[e + i] -= d[i];
                        }
                    }
                }
                return t1.blendMode = Cs, t1;
            }
        };
        class Xm {
            constructor(t1, e, i, n){
                this.parameterPositions = t1, this._cachedIndex = 0, this.resultBuffer = void 0 !== n ? n : new e.constructor(i), this.sampleValues = e, this.valueSize = i, this.settings = null, this.DefaultSettings_ = {};
            }
            evaluate(t1) {
                const e = this.parameterPositions;
                let i = this._cachedIndex, n = e[i], r = e[i - 1];
                t: {
                    e: {
                        let a;
                        i: {
                            n: if (!(t1 < n)) {
                                for(let a = i + 2;;){
                                    if (void 0 === n) {
                                        if (t1 < r) break n;
                                        return i = e.length, this._cachedIndex = i, this.copySampleValue_(i - 1);
                                    }
                                    if (i === a) break;
                                    if (r = n, n = e[++i], t1 < n) break e;
                                }
                                a = e.length;
                                break i;
                            }
                            if (t1 >= r) break t;
                            {
                                const s = e[1];
                                t1 < s && (i = 2, r = s);
                                for(let a = i - 2;;){
                                    if (void 0 === r) return this._cachedIndex = 0, this.copySampleValue_(0);
                                    if (i === a) break;
                                    if (n = r, r = e[--i - 1], t1 >= r) break e;
                                }
                                a = i, i = 0;
                            }
                        }
                        for(; i < a;){
                            const n = i + a >>> 1;
                            t1 < e[n] ? a = n : i = n + 1;
                        }
                        if (n = e[i], r = e[i - 1], void 0 === r) return this._cachedIndex = 0, this.copySampleValue_(0);
                        if (void 0 === n) return i = e.length, this._cachedIndex = i, this.copySampleValue_(i - 1);
                    }
                    this._cachedIndex = i, this.intervalChanged_(i, r, n);
                }
                return this.interpolate_(i, r, t1, n);
            }
            getSettings_() {
                return this.settings || this.DefaultSettings_;
            }
            copySampleValue_(t1) {
                const e = this.resultBuffer, i = this.sampleValues, n = this.valueSize, r = t1 * n;
                for(let t1 = 0; t1 !== n; ++t1)e[t1] = i[r + t1];
                return e;
            }
            interpolate_() {
                throw new Error("call to abstract method");
            }
            intervalChanged_() {}
        }
        class Zm extends Xm {
            constructor(t1, e, i, n){
                super(t1, e, i, n), this._weightPrev = -0, this._offsetPrev = -0, this._weightNext = -0, this._offsetNext = -0, this.DefaultSettings_ = {
                    endingStart: Is,
                    endingEnd: Is
                };
            }
            intervalChanged_(t1, e, i) {
                const n = this.parameterPositions;
                let r = t1 - 2, a = t1 + 1, s = n[r], o = n[a];
                if (void 0 === s) switch(this.getSettings_().endingStart){
                    case Ss:
                        r = t1, s = 2 * e - i;
                        break;
                    case Ns:
                        r = n.length - 2, s = e + n[r] - n[r + 1];
                        break;
                    default:
                        r = t1, s = i;
                }
                if (void 0 === o) switch(this.getSettings_().endingEnd){
                    case Ss:
                        a = t1, o = 2 * i - e;
                        break;
                    case Ns:
                        a = 1, o = i + n[1] - n[0];
                        break;
                    default:
                        a = t1 - 1, o = e;
                }
                const l = .5 * (i - e), c = this.valueSize;
                this._weightPrev = l / (e - s), this._weightNext = l / (o - i), this._offsetPrev = r * c, this._offsetNext = a * c;
            }
            interpolate_(t1, e, i, n) {
                const r = this.resultBuffer, a = this.sampleValues, s = this.valueSize, o = t1 * s, l = o - s, c = this._offsetPrev, u = this._offsetNext, h = this._weightPrev, d = this._weightNext, p = (i - e) / (n - e), A = p * p, f = A * p, m = -h * f + 2 * h * A - h * p, g = (1 + h) * f + (-1.5 - 2 * h) * A + (-0.5 + h) * p + 1, M = (-1 - d) * f + (1.5 + d) * A + .5 * p, v = d * f - d * A;
                for(let t1 = 0; t1 !== s; ++t1)r[t1] = m * a[c + t1] + g * a[l + t1] + M * a[o + t1] + v * a[u + t1];
                return r;
            }
        }
        class qm extends Xm {
            constructor(t1, e, i, n){
                super(t1, e, i, n);
            }
            interpolate_(t1, e, i, n) {
                const r = this.resultBuffer, a = this.sampleValues, s = this.valueSize, o = t1 * s, l = o - s, c = (i - e) / (n - e), u = 1 - c;
                for(let t1 = 0; t1 !== s; ++t1)r[t1] = a[l + t1] * u + a[o + t1] * c;
                return r;
            }
        }
        class Jm extends Xm {
            constructor(t1, e, i, n){
                super(t1, e, i, n);
            }
            interpolate_(t1) {
                return this.copySampleValue_(t1 - 1);
            }
        }
        class Km {
            constructor(t1, e, i, n){
                if (void 0 === t1) throw new Error("THREE.KeyframeTrack: track name is undefined");
                if (void 0 === e || 0 === e.length) throw new Error("THREE.KeyframeTrack: no keyframes in track named " + t1);
                this.name = t1, this.times = Qm(e, this.TimeBufferType), this.values = Qm(i, this.ValueBufferType), this.setInterpolation(n || this.DefaultInterpolation);
            }
            static toJSON(t1) {
                const e = t1.constructor;
                let i;
                if (e.toJSON !== this.toJSON) i = e.toJSON(t1);
                else {
                    i = {
                        name: t1.name,
                        times: Qm(t1.times, Array),
                        values: Qm(t1.values, Array)
                    };
                    const e = t1.getInterpolation();
                    e !== t1.DefaultInterpolation && (i.interpolation = e);
                }
                return i.type = t1.ValueTypeName, i;
            }
            InterpolantFactoryMethodDiscrete(t1) {
                return new Jm(this.times, this.values, this.getValueSize(), t1);
            }
            InterpolantFactoryMethodLinear(t1) {
                return new qm(this.times, this.values, this.getValueSize(), t1);
            }
            InterpolantFactoryMethodSmooth(t1) {
                return new Zm(this.times, this.values, this.getValueSize(), t1);
            }
            setInterpolation(t1) {
                let e;
                switch(t1){
                    case Ts:
                        e = this.InterpolantFactoryMethodDiscrete;
                        break;
                    case Es:
                        e = this.InterpolantFactoryMethodLinear;
                        break;
                    case _s:
                        e = this.InterpolantFactoryMethodSmooth;
                }
                if (void 0 === e) {
                    const e = "unsupported interpolation for " + this.ValueTypeName + " keyframe track named " + this.name;
                    if (void 0 === this.createInterpolant) {
                        if (t1 === this.DefaultInterpolation) throw new Error(e);
                        this.setInterpolation(this.DefaultInterpolation);
                    }
                    return console.warn("THREE.KeyframeTrack:", e), this;
                }
                return this.createInterpolant = e, this;
            }
            getInterpolation() {
                switch(this.createInterpolant){
                    case this.InterpolantFactoryMethodDiscrete:
                        return Ts;
                    case this.InterpolantFactoryMethodLinear:
                        return Es;
                    case this.InterpolantFactoryMethodSmooth:
                        return _s;
                }
            }
            getValueSize() {
                return this.values.length / this.times.length;
            }
            shift(t1) {
                if (0 !== t1) {
                    const e = this.times;
                    for(let i = 0, n = e.length; i !== n; ++i)e[i] += t1;
                }
                return this;
            }
            scale(t1) {
                if (1 !== t1) {
                    const e = this.times;
                    for(let i = 0, n = e.length; i !== n; ++i)e[i] *= t1;
                }
                return this;
            }
            trim(t1, e) {
                const i = this.times, n = i.length;
                let r = 0, a = n - 1;
                for(; r !== n && i[r] < t1;)++r;
                for(; -1 !== a && i[a] > e;)--a;
                if (++a, 0 !== r || a !== n) {
                    r >= a && (a = Math.max(a, 1), r = a - 1);
                    const t1 = this.getValueSize();
                    this.times = i.slice(r, a), this.values = this.values.slice(r * t1, a * t1);
                }
                return this;
            }
            validate() {
                let t1 = !0;
                const e = this.getValueSize();
                e - Math.floor(e) != 0 && (console.error("THREE.KeyframeTrack: Invalid value size in track.", this), t1 = !1);
                const i = this.times, n = this.values, r = i.length;
                0 === r && (console.error("THREE.KeyframeTrack: Track is empty.", this), t1 = !1);
                let a = null;
                for(let e = 0; e !== r; e++){
                    const n = i[e];
                    if ("number" == typeof n && isNaN(n)) {
                        console.error("THREE.KeyframeTrack: Time is not a valid number.", this, e, n), t1 = !1;
                        break;
                    }
                    if (null !== a && a > n) {
                        console.error("THREE.KeyframeTrack: Out of order keys.", this, e, n, a), t1 = !1;
                        break;
                    }
                    a = n;
                }
                if (void 0 !== n && Hm(n)) for(let e = 0, i = n.length; e !== i; ++e){
                    const i = n[e];
                    if (isNaN(i)) {
                        console.error("THREE.KeyframeTrack: Value is not a valid number.", this, e, i), t1 = !1;
                        break;
                    }
                }
                return t1;
            }
            optimize() {
                const t1 = this.times.slice(), e = this.values.slice(), i = this.getValueSize(), n = this.getInterpolation() === _s, r = t1.length - 1;
                let a = 1;
                for(let s = 1; s < r; ++s){
                    let r = !1;
                    const o = t1[s];
                    if (o !== t1[s + 1] && (1 !== s || o !== t1[0])) {
                        if (n) r = !0;
                        else {
                            const t1 = s * i, n = t1 - i, a = t1 + i;
                            for(let s = 0; s !== i; ++s){
                                const i = e[t1 + s];
                                if (i !== e[n + s] || i !== e[a + s]) {
                                    r = !0;
                                    break;
                                }
                            }
                        }
                    }
                    if (r) {
                        if (s !== a) {
                            t1[a] = t1[s];
                            const n = s * i, r = a * i;
                            for(let t1 = 0; t1 !== i; ++t1)e[r + t1] = e[n + t1];
                        }
                        ++a;
                    }
                }
                if (r > 0) {
                    t1[a] = t1[r];
                    for(let t1 = r * i, n = a * i, s = 0; s !== i; ++s)e[n + s] = e[t1 + s];
                    ++a;
                }
                return a !== t1.length ? (this.times = t1.slice(0, a), this.values = e.slice(0, a * i)) : (this.times = t1, this.values = e), this;
            }
            clone() {
                const t1 = this.times.slice(), e = this.values.slice(), i = new this.constructor(this.name, t1, e);
                return i.createInterpolant = this.createInterpolant, i;
            }
        }
        Km.prototype.TimeBufferType = Float32Array, Km.prototype.ValueBufferType = Float32Array, Km.prototype.DefaultInterpolation = Es;
        class $m extends Km {
        }
        $m.prototype.ValueTypeName = "bool", $m.prototype.ValueBufferType = Array, $m.prototype.DefaultInterpolation = Ts, $m.prototype.InterpolantFactoryMethodLinear = void 0, $m.prototype.InterpolantFactoryMethodSmooth = void 0;
        class tg extends Km {
        }
        tg.prototype.ValueTypeName = "color";
        class eg extends Km {
        }
        eg.prototype.ValueTypeName = "number";
        class ig extends Xm {
            constructor(t1, e, i, n){
                super(t1, e, i, n);
            }
            interpolate_(t1, e, i, n) {
                const r = this.resultBuffer, a = this.sampleValues, s = this.valueSize, o = (i - e) / (n - e);
                let l = t1 * s;
                for(let t1 = l + s; l !== t1; l += 4)Sl.slerpFlat(r, 0, a, l - s, a, l, o);
                return r;
            }
        }
        class ng extends Km {
            InterpolantFactoryMethodLinear(t1) {
                return new ig(this.times, this.values, this.getValueSize(), t1);
            }
        }
        ng.prototype.ValueTypeName = "quaternion", ng.prototype.DefaultInterpolation = Es, ng.prototype.InterpolantFactoryMethodSmooth = void 0;
        class rg extends Km {
        }
        rg.prototype.ValueTypeName = "string", rg.prototype.ValueBufferType = Array, rg.prototype.DefaultInterpolation = Ts, rg.prototype.InterpolantFactoryMethodLinear = void 0, rg.prototype.InterpolantFactoryMethodSmooth = void 0;
        class ag extends Km {
        }
        ag.prototype.ValueTypeName = "vector";
        class sg {
            constructor(t1, e = -1, i, n = Ds){
                this.name = t1, this.tracks = i, this.duration = e, this.blendMode = n, this.uuid = Bo(), this.duration < 0 && this.resetDuration();
            }
            static parse(t1) {
                const e = [], i = t1.tracks, n = 1 / (t1.fps || 1);
                for(let t1 = 0, r = i.length; t1 !== r; ++t1)e.push(og(i[t1]).scale(n));
                const r = new this(t1.name, t1.duration, e, t1.blendMode);
                return r.uuid = t1.uuid, r;
            }
            static toJSON(t1) {
                const e = [], i = t1.tracks, n = {
                    name: t1.name,
                    duration: t1.duration,
                    tracks: e,
                    uuid: t1.uuid,
                    blendMode: t1.blendMode
                };
                for(let t1 = 0, n = i.length; t1 !== n; ++t1)e.push(Km.toJSON(i[t1]));
                return n;
            }
            static CreateFromMorphTargetSequence(t1, e, i, n) {
                const r = e.length, a = [];
                for(let t1 = 0; t1 < r; t1++){
                    let s = [], o = [];
                    s.push((t1 + r - 1) % r, t1, (t1 + 1) % r), o.push(0, 1, 0);
                    const l = Vm(s);
                    s = Gm(s, 1, l), o = Gm(o, 1, l), n || 0 !== s[0] || (s.push(r), o.push(o[0])), a.push(new eg(".morphTargetInfluences[" + e[t1].name + "]", s, o).scale(1 / i));
                }
                return new this(t1, -1, a);
            }
            static findByName(t1, e) {
                let i = t1;
                if (!Array.isArray(t1)) {
                    const e = t1;
                    i = e.geometry && e.geometry.animations || e.animations;
                }
                for(let t1 = 0; t1 < i.length; t1++)if (i[t1].name === e) return i[t1];
                return null;
            }
            static CreateClipsFromMorphTargetSequences(t1, e, i) {
                const n = {}, r = /^([\w-]*?)([\d]+)$/;
                for(let e = 0, i = t1.length; e < i; e++){
                    const i = t1[e], a = i.name.match(r);
                    if (a && a.length > 1) {
                        const t1 = a[1];
                        let e = n[t1];
                        e || (n[t1] = e = []), e.push(i);
                    }
                }
                const a = [];
                for(const t1 in n)a.push(this.CreateFromMorphTargetSequence(t1, n[t1], e, i));
                return a;
            }
            static parseAnimation(t1, e) {
                if (!t1) return console.error("THREE.AnimationClip: No animation in JSONLoader data."), null;
                const i = function(t1, e, i, n, r) {
                    if (0 !== i.length) {
                        const a = [], s = [];
                        Wm(i, a, s, n), 0 !== a.length && r.push(new t1(e, a, s));
                    }
                }, n = [], r = t1.name || "default", a = t1.fps || 30, s = t1.blendMode;
                let o = t1.length || -1;
                const l = t1.hierarchy || [];
                for(let t1 = 0; t1 < l.length; t1++){
                    const r = l[t1].keys;
                    if (r && 0 !== r.length) {
                        if (r[0].morphTargets) {
                            const t1 = {};
                            let e;
                            for(e = 0; e < r.length; e++)if (r[e].morphTargets) for(let i = 0; i < r[e].morphTargets.length; i++)t1[r[e].morphTargets[i]] = -1;
                            for(const i in t1){
                                const t1 = [], a = [];
                                for(let n = 0; n !== r[e].morphTargets.length; ++n){
                                    const n = r[e];
                                    t1.push(n.time), a.push(n.morphTarget === i ? 1 : 0);
                                }
                                n.push(new eg(".morphTargetInfluence[" + i + "]", t1, a));
                            }
                            o = t1.length * a;
                        } else {
                            const a = ".bones[" + e[t1].name + "]";
                            i(ag, a + ".position", r, "pos", n), i(ng, a + ".quaternion", r, "rot", n), i(ag, a + ".scale", r, "scl", n);
                        }
                    }
                }
                return 0 === n.length ? null : new this(r, o, n, s);
            }
            resetDuration() {
                let t1 = 0;
                for(let e = 0, i = this.tracks.length; e !== i; ++e){
                    const i = this.tracks[e];
                    t1 = Math.max(t1, i.times[i.times.length - 1]);
                }
                return this.duration = t1, this;
            }
            trim() {
                for(let t1 = 0; t1 < this.tracks.length; t1++)this.tracks[t1].trim(0, this.duration);
                return this;
            }
            validate() {
                let t1 = !0;
                for(let e = 0; e < this.tracks.length; e++)t1 = t1 && this.tracks[e].validate();
                return t1;
            }
            optimize() {
                for(let t1 = 0; t1 < this.tracks.length; t1++)this.tracks[t1].optimize();
                return this;
            }
            clone() {
                const t1 = [];
                for(let e = 0; e < this.tracks.length; e++)t1.push(this.tracks[e].clone());
                return new this.constructor(this.name, this.duration, t1, this.blendMode);
            }
            toJSON() {
                return this.constructor.toJSON(this);
            }
        }
        function og(t1) {
            if (void 0 === t1.type) throw new Error("THREE.KeyframeTrack: track type undefined, can not parse");
            const e = function(t1) {
                switch(t1.toLowerCase()){
                    case "scalar":
                    case "double":
                    case "float":
                    case "number":
                    case "integer":
                        return eg;
                    case "vector":
                    case "vector2":
                    case "vector3":
                    case "vector4":
                        return ag;
                    case "color":
                        return tg;
                    case "quaternion":
                        return ng;
                    case "bool":
                    case "boolean":
                        return $m;
                    case "string":
                        return rg;
                }
                throw new Error("THREE.KeyframeTrack: Unsupported typeName: " + t1);
            }(t1.type);
            if (void 0 === t1.times) {
                const e = [], i = [];
                Wm(t1.keys, e, i, "value"), t1.times = e, t1.values = i;
            }
            return void 0 !== e.parse ? e.parse(t1) : new e(t1.name, t1.times, t1.values, t1.interpolation);
        }
        const lg = {
            enabled: !1,
            files: {},
            add: function(t1, e) {
                !1 !== this.enabled && (this.files[t1] = e);
            },
            get: function(t1) {
                if (!1 !== this.enabled) return this.files[t1];
            },
            remove: function(t1) {
                delete this.files[t1];
            },
            clear: function() {
                this.files = {};
            }
        };
        class cg {
            constructor(t1, e, i){
                const n = this;
                let r, a = !1, s = 0, o = 0;
                const l = [];
                this.onStart = void 0, this.onLoad = t1, this.onProgress = e, this.onError = i, this.itemStart = function(t1) {
                    o++, !1 === a && void 0 !== n.onStart && n.onStart(t1, s, o), a = !0;
                }, this.itemEnd = function(t1) {
                    s++, void 0 !== n.onProgress && n.onProgress(t1, s, o), s === o && (a = !1, void 0 !== n.onLoad && n.onLoad());
                }, this.itemError = function(t1) {
                    void 0 !== n.onError && n.onError(t1);
                }, this.resolveURL = function(t1) {
                    return r ? r(t1) : t1;
                }, this.setURLModifier = function(t1) {
                    return r = t1, this;
                }, this.addHandler = function(t1, e) {
                    return l.push(t1, e), this;
                }, this.removeHandler = function(t1) {
                    const e = l.indexOf(t1);
                    return -1 !== e && l.splice(e, 2), this;
                }, this.getHandler = function(t1) {
                    for(let e = 0, i = l.length; e < i; e += 2){
                        const i = l[e], n = l[e + 1];
                        if (i.global && (i.lastIndex = 0), i.test(t1)) return n;
                    }
                    return null;
                };
            }
        }
        const ug = new cg;
        class hg {
            constructor(t1){
                this.manager = void 0 !== t1 ? t1 : ug, this.crossOrigin = "anonymous", this.withCredentials = !1, this.path = "", this.resourcePath = "", this.requestHeader = {};
            }
            load() {}
            loadAsync(t1, e) {
                const i = this;
                return new Promise(function(n, r) {
                    i.load(t1, n, e, r);
                });
            }
            parse() {}
            setCrossOrigin(t1) {
                return this.crossOrigin = t1, this;
            }
            setWithCredentials(t1) {
                return this.withCredentials = t1, this;
            }
            setPath(t1) {
                return this.path = t1, this;
            }
            setResourcePath(t1) {
                return this.resourcePath = t1, this;
            }
            setRequestHeader(t1) {
                return this.requestHeader = t1, this;
            }
        }
        hg.DEFAULT_MATERIAL_NAME = "__DEFAULT";
        const dg = {};
        class pg extends Error {
            constructor(t1, e){
                super(t1), this.response = e;
            }
        }
        class Ag extends hg {
            constructor(t1){
                super(t1);
            }
            load(t1, e, i, n) {
                void 0 === t1 && (t1 = ""), void 0 !== this.path && (t1 = this.path + t1), t1 = this.manager.resolveURL(t1);
                const r = lg.get(t1);
                if (void 0 !== r) return this.manager.itemStart(t1), setTimeout(()=>{
                    e && e(r), this.manager.itemEnd(t1);
                }, 0), r;
                if (void 0 !== dg[t1]) return void dg[t1].push({
                    onLoad: e,
                    onProgress: i,
                    onError: n
                });
                dg[t1] = [], dg[t1].push({
                    onLoad: e,
                    onProgress: i,
                    onError: n
                });
                const a = new Request(t1, {
                    headers: new Headers(this.requestHeader),
                    credentials: this.withCredentials ? "include" : "same-origin"
                }), s = this.mimeType, o = this.responseType;
                fetch(a).then((e)=>{
                    if (200 === e.status || 0 === e.status) {
                        if (0 === e.status && console.warn("THREE.FileLoader: HTTP Status 0 received."), "undefined" == typeof ReadableStream || void 0 === e.body || void 0 === e.body.getReader) return e;
                        const i = dg[t1], n = e.body.getReader(), r = e.headers.get("Content-Length") || e.headers.get("X-File-Size"), a = r ? parseInt(r) : 0, s = 0 !== a;
                        let o = 0;
                        const l = new ReadableStream({
                            start (t1) {
                                !function e() {
                                    n.read().then(({ done: n, value: r })=>{
                                        if (n) t1.close();
                                        else {
                                            o += r.byteLength;
                                            const n = new ProgressEvent("progress", {
                                                lengthComputable: s,
                                                loaded: o,
                                                total: a
                                            });
                                            for(let t1 = 0, e = i.length; t1 < e; t1++){
                                                const e = i[t1];
                                                e.onProgress && e.onProgress(n);
                                            }
                                            t1.enqueue(r), e();
                                        }
                                    });
                                }();
                            }
                        });
                        return new Response(l);
                    }
                    throw new pg(`fetch for "${e.url}" responded with ${e.status}: ${e.statusText}`, e);
                }).then((t1)=>{
                    switch(o){
                        case "arraybuffer":
                            return t1.arrayBuffer();
                        case "blob":
                            return t1.blob();
                        case "document":
                            return t1.text().then((t1)=>(new DOMParser).parseFromString(t1, s));
                        case "json":
                            return t1.json();
                        default:
                            if (void 0 === s) return t1.text();
                            {
                                const e = /charset="?([^;"\s]*)"?/i.exec(s), i = e && e[1] ? e[1].toLowerCase() : void 0, n = new TextDecoder(i);
                                return t1.arrayBuffer().then((t1)=>n.decode(t1));
                            }
                    }
                }).then((e)=>{
                    lg.add(t1, e);
                    const i = dg[t1];
                    delete dg[t1];
                    for(let t1 = 0, n = i.length; t1 < n; t1++){
                        const n = i[t1];
                        n.onLoad && n.onLoad(e);
                    }
                }).catch((e)=>{
                    const i = dg[t1];
                    if (void 0 === i) throw this.manager.itemError(t1), e;
                    delete dg[t1];
                    for(let t1 = 0, n = i.length; t1 < n; t1++){
                        const n = i[t1];
                        n.onError && n.onError(e);
                    }
                    this.manager.itemError(t1);
                }).finally(()=>{
                    this.manager.itemEnd(t1);
                }), this.manager.itemStart(t1);
            }
            setResponseType(t1) {
                return this.responseType = t1, this;
            }
            setMimeType(t1) {
                return this.mimeType = t1, this;
            }
        }
        class fg extends hg {
            constructor(t1){
                super(t1);
            }
            load(t1, e, i, n) {
                const r = this, a = new Ag(this.manager);
                a.setPath(this.path), a.setRequestHeader(this.requestHeader), a.setWithCredentials(this.withCredentials), a.load(t1, function(i) {
                    try {
                        e(r.parse(JSON.parse(i)));
                    } catch (e) {
                        n ? n(e) : console.error(e), r.manager.itemError(t1);
                    }
                }, i, n);
            }
            parse(t1) {
                const e = [];
                for(let i = 0; i < t1.length; i++){
                    const n = sg.parse(t1[i]);
                    e.push(n);
                }
                return e;
            }
        }
        class mg extends hg {
            constructor(t1){
                super(t1);
            }
            load(t1, e, i, n) {
                const r = this, a = [], s = new sf, o = new Ag(this.manager);
                o.setPath(this.path), o.setResponseType("arraybuffer"), o.setRequestHeader(this.requestHeader), o.setWithCredentials(r.withCredentials);
                let l = 0;
                function c(c) {
                    o.load(t1[c], function(t1) {
                        const i = r.parse(t1, !0);
                        a[c] = {
                            width: i.width,
                            height: i.height,
                            format: i.format,
                            mipmaps: i.mipmaps
                        }, l += 1, 6 === l && (1 === i.mipmapCount && (s.minFilter = ma), s.image = a, s.format = i.format, s.needsUpdate = !0, e && e(s));
                    }, i, n);
                }
                if (Array.isArray(t1)) for(let e = 0, i = t1.length; e < i; ++e)c(e);
                else o.load(t1, function(t1) {
                    const i = r.parse(t1, !0);
                    if (i.isCubemap) {
                        const t1 = i.mipmaps.length / i.mipmapCount;
                        for(let e = 0; e < t1; e++){
                            a[e] = {
                                mipmaps: []
                            };
                            for(let t1 = 0; t1 < i.mipmapCount; t1++)a[e].mipmaps.push(i.mipmaps[e * i.mipmapCount + t1]), a[e].format = i.format, a[e].width = i.width, a[e].height = i.height;
                        }
                        s.image = a;
                    } else s.image.width = i.width, s.image.height = i.height, s.mipmaps = i.mipmaps;
                    1 === i.mipmapCount && (s.minFilter = ma), s.format = i.format, s.needsUpdate = !0, e && e(s);
                }, i, n);
                return s;
            }
        }
        class gg extends hg {
            constructor(t1){
                super(t1);
            }
            load(t1, e, i, n) {
                void 0 !== this.path && (t1 = this.path + t1), t1 = this.manager.resolveURL(t1);
                const r = this, a = lg.get(t1);
                if (void 0 !== a) return r.manager.itemStart(t1), setTimeout(function() {
                    e && e(a), r.manager.itemEnd(t1);
                }, 0), a;
                const s = il("img");
                function o() {
                    c(), lg.add(t1, this), e && e(this), r.manager.itemEnd(t1);
                }
                function l(e) {
                    c(), n && n(e), r.manager.itemError(t1), r.manager.itemEnd(t1);
                }
                function c() {
                    s.removeEventListener("load", o, !1), s.removeEventListener("error", l, !1);
                }
                return s.addEventListener("load", o, !1), s.addEventListener("error", l, !1), "data:" !== t1.slice(0, 5) && void 0 !== this.crossOrigin && (s.crossOrigin = this.crossOrigin), r.manager.itemStart(t1), s.src = t1, s;
            }
        }
        class Mg extends hg {
            constructor(t1){
                super(t1);
            }
            load(t1, e, i, n) {
                const r = new $u;
                r.colorSpace = Qs;
                const a = new gg(this.manager);
                a.setCrossOrigin(this.crossOrigin), a.setPath(this.path);
                let s = 0;
                function o(i) {
                    a.load(t1[i], function(t1) {
                        r.images[i] = t1, s++, 6 === s && (r.needsUpdate = !0, e && e(r));
                    }, void 0, n);
                }
                for(let e = 0; e < t1.length; ++e)o(e);
                return r;
            }
        }
        class vg extends hg {
            constructor(t1){
                super(t1);
            }
            load(t1, e, i, n) {
                const r = this, a = new _A, s = new Ag(this.manager);
                return s.setResponseType("arraybuffer"), s.setRequestHeader(this.requestHeader), s.setPath(this.path), s.setWithCredentials(r.withCredentials), s.load(t1, function(t1) {
                    let i;
                    try {
                        i = r.parse(t1);
                    } catch (t1) {
                        if (void 0 === n) return void console.error(t1);
                        n(t1);
                    }
                    void 0 !== i.image ? a.image = i.image : void 0 !== i.data && (a.image.width = i.width, a.image.height = i.height, a.image.data = i.data), a.wrapS = void 0 !== i.wrapS ? i.wrapS : ca, a.wrapT = void 0 !== i.wrapT ? i.wrapT : ca, a.magFilter = void 0 !== i.magFilter ? i.magFilter : ma, a.minFilter = void 0 !== i.minFilter ? i.minFilter : ma, a.anisotropy = void 0 !== i.anisotropy ? i.anisotropy : 1, void 0 !== i.colorSpace ? a.colorSpace = i.colorSpace : void 0 !== i.encoding && (a.encoding = i.encoding), void 0 !== i.flipY && (a.flipY = i.flipY), void 0 !== i.format && (a.format = i.format), void 0 !== i.type && (a.type = i.type), void 0 !== i.mipmaps && (a.mipmaps = i.mipmaps, a.minFilter = va), 1 === i.mipmapCount && (a.minFilter = ma), void 0 !== i.generateMipmaps && (a.generateMipmaps = i.generateMipmaps), a.needsUpdate = !0, e && e(a, i);
                }, i, n), a;
            }
        }
        class yg extends hg {
            constructor(t1){
                super(t1);
            }
            load(t1, e, i, n) {
                const r = new vl, a = new gg(this.manager);
                return a.setCrossOrigin(this.crossOrigin), a.setPath(this.path), a.load(t1, function(t1) {
                    r.image = t1, r.needsUpdate = !0, void 0 !== e && e(r);
                }, i, n), r;
            }
        }
        class xg extends Dc {
            constructor(t1, e = 1){
                super(), this.isLight = !0, this.type = "Light", this.color = new Yc(t1), this.intensity = e;
            }
            dispose() {}
            copy(t1, e) {
                return super.copy(t1, e), this.color.copy(t1.color), this.intensity = t1.intensity, this;
            }
            toJSON(t1) {
                const e = super.toJSON(t1);
                return e.object.color = this.color.getHex(), e.object.intensity = this.intensity, void 0 !== this.groundColor && (e.object.groundColor = this.groundColor.getHex()), void 0 !== this.distance && (e.object.distance = this.distance), void 0 !== this.angle && (e.object.angle = this.angle), void 0 !== this.decay && (e.object.decay = this.decay), void 0 !== this.penumbra && (e.object.penumbra = this.penumbra), void 0 !== this.shadow && (e.object.shadow = this.shadow.toJSON()), e;
            }
        }
        class wg extends xg {
            constructor(t1, e, i){
                super(t1, i), this.isHemisphereLight = !0, this.type = "HemisphereLight", this.position.copy(Dc.DEFAULT_UP), this.updateMatrix(), this.groundColor = new Yc(e);
            }
            copy(t1, e) {
                return super.copy(t1, e), this.groundColor.copy(t1.groundColor), this;
            }
        }
        const bg = new ac, Tg = new Nl, Eg = new Nl;
        class _g {
            constructor(t1){
                this.camera = t1, this.bias = 0, this.normalBias = 0, this.radius = 1, this.blurSamples = 8, this.mapSize = new qo(512, 512), this.map = null, this.mapPass = null, this.matrix = new ac, this.autoUpdate = !0, this.needsUpdate = !1, this._frustum = new oh, this._frameExtents = new qo(1, 1), this._viewportCount = 1, this._viewports = [
                    new yl(0, 0, 1, 1)
                ];
            }
            getViewportCount() {
                return this._viewportCount;
            }
            getFrustum() {
                return this._frustum;
            }
            updateMatrices(t1) {
                const e = this.camera, i = this.matrix;
                Tg.setFromMatrixPosition(t1.matrixWorld), e.position.copy(Tg), Eg.setFromMatrixPosition(t1.target.matrixWorld), e.lookAt(Eg), e.updateMatrixWorld(), bg.multiplyMatrices(e.projectionMatrix, e.matrixWorldInverse), this._frustum.setFromProjectionMatrix(bg), i.set(.5, 0, 0, .5, 0, .5, 0, .5, 0, 0, .5, .5, 0, 0, 0, 1), i.multiply(bg);
            }
            getViewport(t1) {
                return this._viewports[t1];
            }
            getFrameExtents() {
                return this._frameExtents;
            }
            dispose() {
                this.map && this.map.dispose(), this.mapPass && this.mapPass.dispose();
            }
            copy(t1) {
                return this.camera = t1.camera.clone(), this.bias = t1.bias, this.radius = t1.radius, this.mapSize.copy(t1.mapSize), this;
            }
            clone() {
                return (new this.constructor).copy(this);
            }
            toJSON() {
                const t1 = {};
                return 0 !== this.bias && (t1.bias = this.bias), 0 !== this.normalBias && (t1.normalBias = this.normalBias), 1 !== this.radius && (t1.radius = this.radius), 512 === this.mapSize.x && 512 === this.mapSize.y || (t1.mapSize = this.mapSize.toArray()), t1.camera = this.camera.toJSON(!1).object, delete t1.camera.matrix, t1;
            }
        }
        class Ig extends _g {
            constructor(){
                super(new qu(50, 1, .5, 500)), this.isSpotLightShadow = !0, this.focus = 1;
            }
            updateMatrices(t1) {
                const e = this.camera, i = 2 * Uo * t1.angle * this.focus, n = this.mapSize.width / this.mapSize.height, r = t1.distance || e.far;
                i === e.fov && n === e.aspect && r === e.far || (e.fov = i, e.aspect = n, e.far = r, e.updateProjectionMatrix()), super.updateMatrices(t1);
            }
            copy(t1) {
                return super.copy(t1), this.focus = t1.focus, this;
            }
        }
        class Sg extends xg {
            constructor(t1, e, i = 0, n = Math.PI / 3, r = 0, a = 2){
                super(t1, e), this.isSpotLight = !0, this.type = "SpotLight", this.position.copy(Dc.DEFAULT_UP), this.updateMatrix(), this.target = new Dc, this.distance = i, this.angle = n, this.penumbra = r, this.decay = a, this.map = null, this.shadow = new Ig;
            }
            get power() {
                return this.intensity * Math.PI;
            }
            set power(t1) {
                this.intensity = t1 / Math.PI;
            }
            dispose() {
                this.shadow.dispose();
            }
            copy(t1, e) {
                return super.copy(t1, e), this.distance = t1.distance, this.angle = t1.angle, this.penumbra = t1.penumbra, this.decay = t1.decay, this.target = t1.target.clone(), this.shadow = t1.shadow.clone(), this;
            }
        }
        const Ng = new ac, Dg = new Nl, Cg = new Nl;
        class zg extends _g {
            constructor(){
                super(new qu(90, 1, .5, 500)), this.isPointLightShadow = !0, this._frameExtents = new qo(4, 2), this._viewportCount = 6, this._viewports = [
                    new yl(2, 1, 1, 1),
                    new yl(0, 1, 1, 1),
                    new yl(3, 1, 1, 1),
                    new yl(1, 1, 1, 1),
                    new yl(3, 0, 1, 1),
                    new yl(1, 0, 1, 1)
                ], this._cubeDirections = [
                    new Nl(1, 0, 0),
                    new Nl(-1, 0, 0),
                    new Nl(0, 0, 1),
                    new Nl(0, 0, -1),
                    new Nl(0, 1, 0),
                    new Nl(0, -1, 0)
                ], this._cubeUps = [
                    new Nl(0, 1, 0),
                    new Nl(0, 1, 0),
                    new Nl(0, 1, 0),
                    new Nl(0, 1, 0),
                    new Nl(0, 0, 1),
                    new Nl(0, 0, -1)
                ];
            }
            updateMatrices(t1, e = 0) {
                const i = this.camera, n = this.matrix, r = t1.distance || i.far;
                r !== i.far && (i.far = r, i.updateProjectionMatrix()), Dg.setFromMatrixPosition(t1.matrixWorld), i.position.copy(Dg), Cg.copy(i.position), Cg.add(this._cubeDirections[e]), i.up.copy(this._cubeUps[e]), i.lookAt(Cg), i.updateMatrixWorld(), n.makeTranslation(-Dg.x, -Dg.y, -Dg.z), Ng.multiplyMatrices(i.projectionMatrix, i.matrixWorldInverse), this._frustum.setFromProjectionMatrix(Ng);
            }
        }
        class Lg extends xg {
            constructor(t1, e, i = 0, n = 2){
                super(t1, e), this.isPointLight = !0, this.type = "PointLight", this.distance = i, this.decay = n, this.shadow = new zg;
            }
            get power() {
                return 4 * this.intensity * Math.PI;
            }
            set power(t1) {
                this.intensity = t1 / (4 * Math.PI);
            }
            dispose() {
                this.shadow.dispose();
            }
            copy(t1, e) {
                return super.copy(t1, e), this.distance = t1.distance, this.decay = t1.decay, this.shadow = t1.shadow.clone(), this;
            }
        }
        class Og extends _g {
            constructor(){
                super(new xh(-5, 5, 5, -5, .5, 500)), this.isDirectionalLightShadow = !0;
            }
        }
        class Pg extends xg {
            constructor(t1, e){
                super(t1, e), this.isDirectionalLight = !0, this.type = "DirectionalLight", this.position.copy(Dc.DEFAULT_UP), this.updateMatrix(), this.target = new Dc, this.shadow = new Og;
            }
            dispose() {
                this.shadow.dispose();
            }
            copy(t1) {
                return super.copy(t1), this.target = t1.target.clone(), this.shadow = t1.shadow.clone(), this;
            }
        }
        class jg extends xg {
            constructor(t1, e){
                super(t1, e), this.isAmbientLight = !0, this.type = "AmbientLight";
            }
        }
        class Rg extends xg {
            constructor(t1, e, i = 10, n = 10){
                super(t1, e), this.isRectAreaLight = !0, this.type = "RectAreaLight", this.width = i, this.height = n;
            }
            get power() {
                return this.intensity * this.width * this.height * Math.PI;
            }
            set power(t1) {
                this.intensity = t1 / (this.width * this.height * Math.PI);
            }
            copy(t1) {
                return super.copy(t1), this.width = t1.width, this.height = t1.height, this;
            }
            toJSON(t1) {
                const e = super.toJSON(t1);
                return e.object.width = this.width, e.object.height = this.height, e;
            }
        }
        class kg {
            constructor(){
                this.isSphericalHarmonics3 = !0, this.coefficients = [];
                for(let t1 = 0; t1 < 9; t1++)this.coefficients.push(new Nl);
            }
            set(t1) {
                for(let e = 0; e < 9; e++)this.coefficients[e].copy(t1[e]);
                return this;
            }
            zero() {
                for(let t1 = 0; t1 < 9; t1++)this.coefficients[t1].set(0, 0, 0);
                return this;
            }
            getAt(t1, e) {
                const i = t1.x, n = t1.y, r = t1.z, a = this.coefficients;
                return e.copy(a[0]).multiplyScalar(.282095), e.addScaledVector(a[1], .488603 * n), e.addScaledVector(a[2], .488603 * r), e.addScaledVector(a[3], .488603 * i), e.addScaledVector(a[4], i * n * 1.092548), e.addScaledVector(a[5], n * r * 1.092548), e.addScaledVector(a[6], .315392 * (3 * r * r - 1)), e.addScaledVector(a[7], i * r * 1.092548), e.addScaledVector(a[8], .546274 * (i * i - n * n)), e;
            }
            getIrradianceAt(t1, e) {
                const i = t1.x, n = t1.y, r = t1.z, a = this.coefficients;
                return e.copy(a[0]).multiplyScalar(.886227), e.addScaledVector(a[1], 1.023328 * n), e.addScaledVector(a[2], 1.023328 * r), e.addScaledVector(a[3], 1.023328 * i), e.addScaledVector(a[4], .858086 * i * n), e.addScaledVector(a[5], .858086 * n * r), e.addScaledVector(a[6], .743125 * r * r - .247708), e.addScaledVector(a[7], .858086 * i * r), e.addScaledVector(a[8], .429043 * (i * i - n * n)), e;
            }
            add(t1) {
                for(let e = 0; e < 9; e++)this.coefficients[e].add(t1.coefficients[e]);
                return this;
            }
            addScaledSH(t1, e) {
                for(let i = 0; i < 9; i++)this.coefficients[i].addScaledVector(t1.coefficients[i], e);
                return this;
            }
            scale(t1) {
                for(let e = 0; e < 9; e++)this.coefficients[e].multiplyScalar(t1);
                return this;
            }
            lerp(t1, e) {
                for(let i = 0; i < 9; i++)this.coefficients[i].lerp(t1.coefficients[i], e);
                return this;
            }
            equals(t1) {
                for(let e = 0; e < 9; e++)if (!this.coefficients[e].equals(t1.coefficients[e])) return !1;
                return !0;
            }
            copy(t1) {
                return this.set(t1.coefficients);
            }
            clone() {
                return (new this.constructor).copy(this);
            }
            fromArray(t1, e = 0) {
                const i = this.coefficients;
                for(let n = 0; n < 9; n++)i[n].fromArray(t1, e + 3 * n);
                return this;
            }
            toArray(t1 = [], e = 0) {
                const i = this.coefficients;
                for(let n = 0; n < 9; n++)i[n].toArray(t1, e + 3 * n);
                return t1;
            }
            static getBasisAt(t1, e) {
                const i = t1.x, n = t1.y, r = t1.z;
                e[0] = .282095, e[1] = .488603 * n, e[2] = .488603 * r, e[3] = .488603 * i, e[4] = 1.092548 * i * n, e[5] = 1.092548 * n * r, e[6] = .315392 * (3 * r * r - 1), e[7] = 1.092548 * i * r, e[8] = .546274 * (i * i - n * n);
            }
        }
        class Ug extends xg {
            constructor(t1 = new kg, e = 1){
                super(void 0, e), this.isLightProbe = !0, this.sh = t1;
            }
            copy(t1) {
                return super.copy(t1), this.sh.copy(t1.sh), this;
            }
            fromJSON(t1) {
                return this.intensity = t1.intensity, this.sh.fromArray(t1.sh), this;
            }
            toJSON(t1) {
                const e = super.toJSON(t1);
                return e.object.sh = this.sh.toArray(), e;
            }
        }
        class Bg extends hg {
            constructor(t1){
                super(t1), this.textures = {};
            }
            load(t1, e, i, n) {
                const r = this, a = new Ag(r.manager);
                a.setPath(r.path), a.setRequestHeader(r.requestHeader), a.setWithCredentials(r.withCredentials), a.load(t1, function(i) {
                    try {
                        e(r.parse(JSON.parse(i)));
                    } catch (e) {
                        n ? n(e) : console.error(e), r.manager.itemError(t1);
                    }
                }, i, n);
            }
            parse(t1) {
                const e = this.textures;
                function i(t1) {
                    return void 0 === e[t1] && console.warn("THREE.MaterialLoader: Undefined texture", t1), e[t1];
                }
                const n = Bg.createMaterialFromType(t1.type);
                if (void 0 !== t1.uuid && (n.uuid = t1.uuid), void 0 !== t1.name && (n.name = t1.name), void 0 !== t1.color && void 0 !== n.color && n.color.setHex(t1.color), void 0 !== t1.roughness && (n.roughness = t1.roughness), void 0 !== t1.metalness && (n.metalness = t1.metalness), void 0 !== t1.sheen && (n.sheen = t1.sheen), void 0 !== t1.sheenColor && (n.sheenColor = (new Yc).setHex(t1.sheenColor)), void 0 !== t1.sheenRoughness && (n.sheenRoughness = t1.sheenRoughness), void 0 !== t1.emissive && void 0 !== n.emissive && n.emissive.setHex(t1.emissive), void 0 !== t1.specular && void 0 !== n.specular && n.specular.setHex(t1.specular), void 0 !== t1.specularIntensity && (n.specularIntensity = t1.specularIntensity), void 0 !== t1.specularColor && void 0 !== n.specularColor && n.specularColor.setHex(t1.specularColor), void 0 !== t1.shininess && (n.shininess = t1.shininess), void 0 !== t1.clearcoat && (n.clearcoat = t1.clearcoat), void 0 !== t1.clearcoatRoughness && (n.clearcoatRoughness = t1.clearcoatRoughness), void 0 !== t1.iridescence && (n.iridescence = t1.iridescence), void 0 !== t1.iridescenceIOR && (n.iridescenceIOR = t1.iridescenceIOR), void 0 !== t1.iridescenceThicknessRange && (n.iridescenceThicknessRange = t1.iridescenceThicknessRange), void 0 !== t1.transmission && (n.transmission = t1.transmission), void 0 !== t1.thickness && (n.thickness = t1.thickness), void 0 !== t1.attenuationDistance && (n.attenuationDistance = t1.attenuationDistance), void 0 !== t1.attenuationColor && void 0 !== n.attenuationColor && n.attenuationColor.setHex(t1.attenuationColor), void 0 !== t1.anisotropy && (n.anisotropy = t1.anisotropy), void 0 !== t1.anisotropyRotation && (n.anisotropyRotation = t1.anisotropyRotation), void 0 !== t1.fog && (n.fog = t1.fog), void 0 !== t1.flatShading && (n.flatShading = t1.flatShading), void 0 !== t1.blending && (n.blending = t1.blending), void 0 !== t1.combine && (n.combine = t1.combine), void 0 !== t1.side && (n.side = t1.side), void 0 !== t1.shadowSide && (n.shadowSide = t1.shadowSide), void 0 !== t1.opacity && (n.opacity = t1.opacity), void 0 !== t1.transparent && (n.transparent = t1.transparent), void 0 !== t1.alphaTest && (n.alphaTest = t1.alphaTest), void 0 !== t1.alphaHash && (n.alphaHash = t1.alphaHash), void 0 !== t1.depthFunc && (n.depthFunc = t1.depthFunc), void 0 !== t1.depthTest && (n.depthTest = t1.depthTest), void 0 !== t1.depthWrite && (n.depthWrite = t1.depthWrite), void 0 !== t1.colorWrite && (n.colorWrite = t1.colorWrite), void 0 !== t1.blendSrc && (n.blendSrc = t1.blendSrc), void 0 !== t1.blendDst && (n.blendDst = t1.blendDst), void 0 !== t1.blendEquation && (n.blendEquation = t1.blendEquation), void 0 !== t1.blendSrcAlpha && (n.blendSrcAlpha = t1.blendSrcAlpha), void 0 !== t1.blendDstAlpha && (n.blendDstAlpha = t1.blendDstAlpha), void 0 !== t1.blendEquationAlpha && (n.blendEquationAlpha = t1.blendEquationAlpha), void 0 !== t1.blendColor && void 0 !== n.blendColor && n.blendColor.setHex(t1.blendColor), void 0 !== t1.blendAlpha && (n.blendAlpha = t1.blendAlpha), void 0 !== t1.stencilWriteMask && (n.stencilWriteMask = t1.stencilWriteMask), void 0 !== t1.stencilFunc && (n.stencilFunc = t1.stencilFunc), void 0 !== t1.stencilRef && (n.stencilRef = t1.stencilRef), void 0 !== t1.stencilFuncMask && (n.stencilFuncMask = t1.stencilFuncMask), void 0 !== t1.stencilFail && (n.stencilFail = t1.stencilFail), void 0 !== t1.stencilZFail && (n.stencilZFail = t1.stencilZFail), void 0 !== t1.stencilZPass && (n.stencilZPass = t1.stencilZPass), void 0 !== t1.stencilWrite && (n.stencilWrite = t1.stencilWrite), void 0 !== t1.wireframe && (n.wireframe = t1.wireframe), void 0 !== t1.wireframeLinewidth && (n.wireframeLinewidth = t1.wireframeLinewidth), void 0 !== t1.wireframeLinecap && (n.wireframeLinecap = t1.wireframeLinecap), void 0 !== t1.wireframeLinejoin && (n.wireframeLinejoin = t1.wireframeLinejoin), void 0 !== t1.rotation && (n.rotation = t1.rotation), void 0 !== t1.linewidth && (n.linewidth = t1.linewidth), void 0 !== t1.dashSize && (n.dashSize = t1.dashSize), void 0 !== t1.gapSize && (n.gapSize = t1.gapSize), void 0 !== t1.scale && (n.scale = t1.scale), void 0 !== t1.polygonOffset && (n.polygonOffset = t1.polygonOffset), void 0 !== t1.polygonOffsetFactor && (n.polygonOffsetFactor = t1.polygonOffsetFactor), void 0 !== t1.polygonOffsetUnits && (n.polygonOffsetUnits = t1.polygonOffsetUnits), void 0 !== t1.dithering && (n.dithering = t1.dithering), void 0 !== t1.alphaToCoverage && (n.alphaToCoverage = t1.alphaToCoverage), void 0 !== t1.premultipliedAlpha && (n.premultipliedAlpha = t1.premultipliedAlpha), void 0 !== t1.forceSinglePass && (n.forceSinglePass = t1.forceSinglePass), void 0 !== t1.visible && (n.visible = t1.visible), void 0 !== t1.toneMapped && (n.toneMapped = t1.toneMapped), void 0 !== t1.userData && (n.userData = t1.userData), void 0 !== t1.vertexColors && ("number" == typeof t1.vertexColors ? n.vertexColors = t1.vertexColors > 0 : n.vertexColors = t1.vertexColors), void 0 !== t1.uniforms) for(const e in t1.uniforms){
                    const r = t1.uniforms[e];
                    switch(n.uniforms[e] = {}, r.type){
                        case "t":
                            n.uniforms[e].value = i(r.value);
                            break;
                        case "c":
                            n.uniforms[e].value = (new Yc).setHex(r.value);
                            break;
                        case "v2":
                            n.uniforms[e].value = (new qo).fromArray(r.value);
                            break;
                        case "v3":
                            n.uniforms[e].value = (new Nl).fromArray(r.value);
                            break;
                        case "v4":
                            n.uniforms[e].value = (new yl).fromArray(r.value);
                            break;
                        case "m3":
                            n.uniforms[e].value = (new Jo).fromArray(r.value);
                            break;
                        case "m4":
                            n.uniforms[e].value = (new ac).fromArray(r.value);
                            break;
                        default:
                            n.uniforms[e].value = r.value;
                    }
                }
                if (void 0 !== t1.defines && (n.defines = t1.defines), void 0 !== t1.vertexShader && (n.vertexShader = t1.vertexShader), void 0 !== t1.fragmentShader && (n.fragmentShader = t1.fragmentShader), void 0 !== t1.glslVersion && (n.glslVersion = t1.glslVersion), void 0 !== t1.extensions) for(const e in t1.extensions)n.extensions[e] = t1.extensions[e];
                if (void 0 !== t1.lights && (n.lights = t1.lights), void 0 !== t1.clipping && (n.clipping = t1.clipping), void 0 !== t1.size && (n.size = t1.size), void 0 !== t1.sizeAttenuation && (n.sizeAttenuation = t1.sizeAttenuation), void 0 !== t1.map && (n.map = i(t1.map)), void 0 !== t1.matcap && (n.matcap = i(t1.matcap)), void 0 !== t1.alphaMap && (n.alphaMap = i(t1.alphaMap)), void 0 !== t1.bumpMap && (n.bumpMap = i(t1.bumpMap)), void 0 !== t1.bumpScale && (n.bumpScale = t1.bumpScale), void 0 !== t1.normalMap && (n.normalMap = i(t1.normalMap)), void 0 !== t1.normalMapType && (n.normalMapType = t1.normalMapType), void 0 !== t1.normalScale) {
                    let e = t1.normalScale;
                    !1 === Array.isArray(e) && (e = [
                        e,
                        e
                    ]), n.normalScale = (new qo).fromArray(e);
                }
                return void 0 !== t1.displacementMap && (n.displacementMap = i(t1.displacementMap)), void 0 !== t1.displacementScale && (n.displacementScale = t1.displacementScale), void 0 !== t1.displacementBias && (n.displacementBias = t1.displacementBias), void 0 !== t1.roughnessMap && (n.roughnessMap = i(t1.roughnessMap)), void 0 !== t1.metalnessMap && (n.metalnessMap = i(t1.metalnessMap)), void 0 !== t1.emissiveMap && (n.emissiveMap = i(t1.emissiveMap)), void 0 !== t1.emissiveIntensity && (n.emissiveIntensity = t1.emissiveIntensity), void 0 !== t1.specularMap && (n.specularMap = i(t1.specularMap)), void 0 !== t1.specularIntensityMap && (n.specularIntensityMap = i(t1.specularIntensityMap)), void 0 !== t1.specularColorMap && (n.specularColorMap = i(t1.specularColorMap)), void 0 !== t1.envMap && (n.envMap = i(t1.envMap)), void 0 !== t1.envMapIntensity && (n.envMapIntensity = t1.envMapIntensity), void 0 !== t1.reflectivity && (n.reflectivity = t1.reflectivity), void 0 !== t1.refractionRatio && (n.refractionRatio = t1.refractionRatio), void 0 !== t1.lightMap && (n.lightMap = i(t1.lightMap)), void 0 !== t1.lightMapIntensity && (n.lightMapIntensity = t1.lightMapIntensity), void 0 !== t1.aoMap && (n.aoMap = i(t1.aoMap)), void 0 !== t1.aoMapIntensity && (n.aoMapIntensity = t1.aoMapIntensity), void 0 !== t1.gradientMap && (n.gradientMap = i(t1.gradientMap)), void 0 !== t1.clearcoatMap && (n.clearcoatMap = i(t1.clearcoatMap)), void 0 !== t1.clearcoatRoughnessMap && (n.clearcoatRoughnessMap = i(t1.clearcoatRoughnessMap)), void 0 !== t1.clearcoatNormalMap && (n.clearcoatNormalMap = i(t1.clearcoatNormalMap)), void 0 !== t1.clearcoatNormalScale && (n.clearcoatNormalScale = (new qo).fromArray(t1.clearcoatNormalScale)), void 0 !== t1.iridescenceMap && (n.iridescenceMap = i(t1.iridescenceMap)), void 0 !== t1.iridescenceThicknessMap && (n.iridescenceThicknessMap = i(t1.iridescenceThicknessMap)), void 0 !== t1.transmissionMap && (n.transmissionMap = i(t1.transmissionMap)), void 0 !== t1.thicknessMap && (n.thicknessMap = i(t1.thicknessMap)), void 0 !== t1.anisotropyMap && (n.anisotropyMap = i(t1.anisotropyMap)), void 0 !== t1.sheenColorMap && (n.sheenColorMap = i(t1.sheenColorMap)), void 0 !== t1.sheenRoughnessMap && (n.sheenRoughnessMap = i(t1.sheenRoughnessMap)), n;
            }
            setTextures(t1) {
                return this.textures = t1, this;
            }
            static createMaterialFromType(t1) {
                return new ({
                    ShadowMaterial: zm,
                    SpriteMaterial: qp,
                    RawShaderMaterial: Lm,
                    ShaderMaterial: Xu,
                    PointsMaterial: qA,
                    MeshPhysicalMaterial: Pm,
                    MeshStandardMaterial: Om,
                    MeshPhongMaterial: jm,
                    MeshToonMaterial: Rm,
                    MeshNormalMaterial: km,
                    MeshLambertMaterial: Um,
                    MeshDepthMaterial: Sp,
                    MeshDistanceMaterial: Np,
                    MeshBasicMaterial: Jc,
                    MeshMatcapMaterial: Bm,
                    LineDashedMaterial: Fm,
                    LineBasicMaterial: UA,
                    Material: qc
                })[t1];
            }
        }
        class Fg {
            static decodeText(t1) {
                if ("undefined" != typeof TextDecoder) return (new TextDecoder).decode(t1);
                let e = "";
                for(let i = 0, n = t1.length; i < n; i++)e += String.fromCharCode(t1[i]);
                try {
                    return decodeURIComponent(escape(e));
                } catch (t1) {
                    return e;
                }
            }
            static extractUrlBase(t1) {
                const e = t1.lastIndexOf("/");
                return -1 === e ? "./" : t1.slice(0, e + 1);
            }
            static resolveURL(t1, e) {
                return "string" != typeof t1 || "" === t1 ? "" : (/^https?:\/\//i.test(e) && /^\//.test(t1) && (e = e.replace(/(^https?:\/\/[^\/]+).*/i, "$1")), /^(https?:)?\/\//i.test(t1) || /^data:.*,.*$/i.test(t1) || /^blob:.*$/i.test(t1) ? t1 : e + t1);
            }
        }
        class Qg extends bu {
            constructor(){
                super(), this.isInstancedBufferGeometry = !0, this.type = "InstancedBufferGeometry", this.instanceCount = 1 / 0;
            }
            copy(t1) {
                return super.copy(t1), this.instanceCount = t1.instanceCount, this;
            }
            toJSON() {
                const t1 = super.toJSON();
                return t1.instanceCount = this.instanceCount, t1.isInstancedBufferGeometry = !0, t1;
            }
        }
        class Hg extends hg {
            constructor(t1){
                super(t1);
            }
            load(t1, e, i, n) {
                const r = this, a = new Ag(r.manager);
                a.setPath(r.path), a.setRequestHeader(r.requestHeader), a.setWithCredentials(r.withCredentials), a.load(t1, function(i) {
                    try {
                        e(r.parse(JSON.parse(i)));
                    } catch (e) {
                        n ? n(e) : console.error(e), r.manager.itemError(t1);
                    }
                }, i, n);
            }
            parse(t1) {
                const e = {}, i = {};
                function n(t1, n) {
                    if (void 0 !== e[n]) return e[n];
                    const r = t1.interleavedBuffers[n], a = function(t1, e) {
                        if (void 0 !== i[e]) return i[e];
                        const n = t1.arrayBuffers[e], r = new Uint32Array(n).buffer;
                        return i[e] = r, r;
                    }(t1, r.buffer), s = el(r.type, a), o = new Yp(s, r.stride);
                    return o.uuid = r.uuid, e[n] = o, o;
                }
                const r = t1.isInstancedBufferGeometry ? new Qg : new bu, a = t1.data.index;
                if (void 0 !== a) {
                    const t1 = el(a.type, a.array);
                    r.setIndex(new au(t1, 1));
                }
                const s = t1.data.attributes;
                for(const e in s){
                    const i = s[e];
                    let a;
                    if (i.isInterleavedBufferAttribute) {
                        const e = n(t1.data, i.data);
                        a = new Zp(e, i.itemSize, i.offset, i.normalized);
                    } else {
                        const t1 = el(i.type, i.array);
                        a = new (i.isInstancedBufferAttribute ? DA : au)(t1, i.itemSize, i.normalized);
                    }
                    void 0 !== i.name && (a.name = i.name), void 0 !== i.usage && a.setUsage(i.usage), void 0 !== i.updateRange && (a.updateRange.offset = i.updateRange.offset, a.updateRange.count = i.updateRange.count), r.setAttribute(e, a);
                }
                const o = t1.data.morphAttributes;
                if (o) for(const e in o){
                    const i = o[e], a = [];
                    for(let e = 0, r = i.length; e < r; e++){
                        const r = i[e];
                        let s;
                        if (r.isInterleavedBufferAttribute) {
                            const e = n(t1.data, r.data);
                            s = new Zp(e, r.itemSize, r.offset, r.normalized);
                        } else {
                            const t1 = el(r.type, r.array);
                            s = new au(t1, r.itemSize, r.normalized);
                        }
                        void 0 !== r.name && (s.name = r.name), a.push(s);
                    }
                    r.morphAttributes[e] = a;
                }
                t1.data.morphTargetsRelative && (r.morphTargetsRelative = !0);
                const l = t1.data.groups || t1.data.drawcalls || t1.data.offsets;
                if (void 0 !== l) for(let t1 = 0, e = l.length; t1 !== e; ++t1){
                    const e = l[t1];
                    r.addGroup(e.start, e.count, e.materialIndex);
                }
                const c = t1.data.boundingSphere;
                if (void 0 !== c) {
                    const t1 = new Nl;
                    void 0 !== c.center && t1.fromArray(c.center), r.boundingSphere = new ql(t1, c.radius);
                }
                return t1.name && (r.name = t1.name), t1.userData && (r.userData = t1.userData), r;
            }
        }
        class Vg extends hg {
            constructor(t1){
                super(t1);
            }
            load(t1, e, i, n) {
                const r = this, a = "" === this.path ? Fg.extractUrlBase(t1) : this.path;
                this.resourcePath = this.resourcePath || a;
                const s = new Ag(this.manager);
                s.setPath(this.path), s.setRequestHeader(this.requestHeader), s.setWithCredentials(this.withCredentials), s.load(t1, function(i) {
                    let a = null;
                    try {
                        a = JSON.parse(i);
                    } catch (e) {
                        return void 0 !== n && n(e), void console.error("THREE:ObjectLoader: Can't parse " + t1 + ".", e.message);
                    }
                    const s = a.metadata;
                    if (void 0 === s || void 0 === s.type || "geometry" === s.type.toLowerCase()) return void 0 !== n && n(new Error("THREE.ObjectLoader: Can't load " + t1)), void console.error("THREE.ObjectLoader: Can't load " + t1);
                    r.parse(a, e);
                }, i, n);
            }
            async loadAsync(t1, e) {
                const i = "" === this.path ? Fg.extractUrlBase(t1) : this.path;
                this.resourcePath = this.resourcePath || i;
                const n = new Ag(this.manager);
                n.setPath(this.path), n.setRequestHeader(this.requestHeader), n.setWithCredentials(this.withCredentials);
                const r = await n.loadAsync(t1, e), a = JSON.parse(r), s = a.metadata;
                if (void 0 === s || void 0 === s.type || "geometry" === s.type.toLowerCase()) throw new Error("THREE.ObjectLoader: Can't load " + t1);
                return await this.parseAsync(a);
            }
            parse(t1, e) {
                const i = this.parseAnimations(t1.animations), n = this.parseShapes(t1.shapes), r = this.parseGeometries(t1.geometries, n), a = this.parseImages(t1.images, function() {
                    void 0 !== e && e(l);
                }), s = this.parseTextures(t1.textures, a), o = this.parseMaterials(t1.materials, s), l = this.parseObject(t1.object, r, o, s, i), c = this.parseSkeletons(t1.skeletons, l);
                if (this.bindSkeletons(l, c), void 0 !== e) {
                    let t1 = !1;
                    for(const e in a)if (a[e].data instanceof HTMLImageElement) {
                        t1 = !0;
                        break;
                    }
                    !1 === t1 && e(l);
                }
                return l;
            }
            async parseAsync(t1) {
                const e = this.parseAnimations(t1.animations), i = this.parseShapes(t1.shapes), n = this.parseGeometries(t1.geometries, i), r = await this.parseImagesAsync(t1.images), a = this.parseTextures(t1.textures, r), s = this.parseMaterials(t1.materials, a), o = this.parseObject(t1.object, n, s, a, e), l = this.parseSkeletons(t1.skeletons, o);
                return this.bindSkeletons(o, l), o;
            }
            parseShapes(t1) {
                const e = {};
                if (void 0 !== t1) for(let i = 0, n = t1.length; i < n; i++){
                    const n = (new Vf).fromJSON(t1[i]);
                    e[n.uuid] = n;
                }
                return e;
            }
            parseSkeletons(t1, e) {
                const i = {}, n = {};
                if (e.traverse(function(t1) {
                    t1.isBone && (n[t1.uuid] = t1);
                }), void 0 !== t1) for(let e = 0, r = t1.length; e < r; e++){
                    const r = (new NA).fromJSON(t1[e], n);
                    i[r.uuid] = r;
                }
                return i;
            }
            parseGeometries(t1, e) {
                const i = {};
                if (void 0 !== t1) {
                    const n = new Hg;
                    for(let r = 0, a = t1.length; r < a; r++){
                        let a;
                        const s = t1[r];
                        switch(s.type){
                            case "BufferGeometry":
                            case "InstancedBufferGeometry":
                                a = n.parse(s);
                                break;
                            default:
                                s.type in Cm ? a = Cm[s.type].fromJSON(s, e) : console.warn(`THREE.ObjectLoader: Unsupported geometry type "${s.type}"`);
                        }
                        a.uuid = s.uuid, void 0 !== s.name && (a.name = s.name), void 0 !== s.userData && (a.userData = s.userData), i[s.uuid] = a;
                    }
                }
                return i;
            }
            parseMaterials(t1, e) {
                const i = {}, n = {};
                if (void 0 !== t1) {
                    const r = new Bg;
                    r.setTextures(e);
                    for(let e = 0, a = t1.length; e < a; e++){
                        const a = t1[e];
                        void 0 === i[a.uuid] && (i[a.uuid] = r.parse(a)), n[a.uuid] = i[a.uuid];
                    }
                }
                return n;
            }
            parseAnimations(t1) {
                const e = {};
                if (void 0 !== t1) for(let i = 0; i < t1.length; i++){
                    const n = t1[i], r = sg.parse(n);
                    e[r.uuid] = r;
                }
                return e;
            }
            parseImages(t1, e) {
                const i = this, n = {};
                let r;
                function a(t1) {
                    if ("string" == typeof t1) {
                        const e = t1;
                        return function(t1) {
                            return i.manager.itemStart(t1), r.load(t1, function() {
                                i.manager.itemEnd(t1);
                            }, void 0, function() {
                                i.manager.itemError(t1), i.manager.itemEnd(t1);
                            });
                        }(/^(\/\/)|([a-z]+:(\/\/)?)/i.test(e) ? e : i.resourcePath + e);
                    }
                    return t1.data ? {
                        data: el(t1.type, t1.data),
                        width: t1.width,
                        height: t1.height
                    } : null;
                }
                if (void 0 !== t1 && t1.length > 0) {
                    const i = new cg(e);
                    r = new gg(i), r.setCrossOrigin(this.crossOrigin);
                    for(let e = 0, i = t1.length; e < i; e++){
                        const i = t1[e], r = i.url;
                        if (Array.isArray(r)) {
                            const t1 = [];
                            for(let e = 0, i = r.length; e < i; e++){
                                const i = a(r[e]);
                                null !== i && (i instanceof HTMLImageElement ? t1.push(i) : t1.push(new _A(i.data, i.width, i.height)));
                            }
                            n[i.uuid] = new ml(t1);
                        } else {
                            const t1 = a(i.url);
                            n[i.uuid] = new ml(t1);
                        }
                    }
                }
                return n;
            }
            async parseImagesAsync(t1) {
                const e = this, i = {};
                let n;
                async function r(t1) {
                    if ("string" == typeof t1) {
                        const i = t1, r = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(i) ? i : e.resourcePath + i;
                        return await n.loadAsync(r);
                    }
                    return t1.data ? {
                        data: el(t1.type, t1.data),
                        width: t1.width,
                        height: t1.height
                    } : null;
                }
                if (void 0 !== t1 && t1.length > 0) {
                    n = new gg(this.manager), n.setCrossOrigin(this.crossOrigin);
                    for(let e = 0, n = t1.length; e < n; e++){
                        const n = t1[e], a = n.url;
                        if (Array.isArray(a)) {
                            const t1 = [];
                            for(let e = 0, i = a.length; e < i; e++){
                                const i = a[e], n = await r(i);
                                null !== n && (n instanceof HTMLImageElement ? t1.push(n) : t1.push(new _A(n.data, n.width, n.height)));
                            }
                            i[n.uuid] = new ml(t1);
                        } else {
                            const t1 = await r(n.url);
                            i[n.uuid] = new ml(t1);
                        }
                    }
                }
                return i;
            }
            parseTextures(t1, e) {
                function i(t1, e) {
                    return "number" == typeof t1 ? t1 : (console.warn("THREE.ObjectLoader.parseTexture: Constant should be in numeric form.", t1), e[t1]);
                }
                const n = {};
                if (void 0 !== t1) for(let r = 0, a = t1.length; r < a; r++){
                    const a = t1[r];
                    void 0 === a.image && console.warn('THREE.ObjectLoader: No "image" specified for', a.uuid), void 0 === e[a.image] && console.warn("THREE.ObjectLoader: Undefined image", a.image);
                    const s = e[a.image], o = s.data;
                    let l;
                    Array.isArray(o) ? (l = new $u, 6 === o.length && (l.needsUpdate = !0)) : (l = o && o.data ? new _A : new vl, o && (l.needsUpdate = !0)), l.source = s, l.uuid = a.uuid, void 0 !== a.name && (l.name = a.name), void 0 !== a.mapping && (l.mapping = i(a.mapping, Gg)), void 0 !== a.channel && (l.channel = a.channel), void 0 !== a.offset && l.offset.fromArray(a.offset), void 0 !== a.repeat && l.repeat.fromArray(a.repeat), void 0 !== a.center && l.center.fromArray(a.center), void 0 !== a.rotation && (l.rotation = a.rotation), void 0 !== a.wrap && (l.wrapS = i(a.wrap[0], Wg), l.wrapT = i(a.wrap[1], Wg)), void 0 !== a.format && (l.format = a.format), void 0 !== a.internalFormat && (l.internalFormat = a.internalFormat), void 0 !== a.type && (l.type = a.type), void 0 !== a.colorSpace && (l.colorSpace = a.colorSpace), void 0 !== a.encoding && (l.encoding = a.encoding), void 0 !== a.minFilter && (l.minFilter = i(a.minFilter, Yg)), void 0 !== a.magFilter && (l.magFilter = i(a.magFilter, Yg)), void 0 !== a.anisotropy && (l.anisotropy = a.anisotropy), void 0 !== a.flipY && (l.flipY = a.flipY), void 0 !== a.generateMipmaps && (l.generateMipmaps = a.generateMipmaps), void 0 !== a.premultiplyAlpha && (l.premultiplyAlpha = a.premultiplyAlpha), void 0 !== a.unpackAlignment && (l.unpackAlignment = a.unpackAlignment), void 0 !== a.compareFunction && (l.compareFunction = a.compareFunction), void 0 !== a.userData && (l.userData = a.userData), n[a.uuid] = l;
                }
                return n;
            }
            parseObject(t1, e, i, n, r) {
                let a, s, o;
                function l(t1) {
                    return void 0 === e[t1] && console.warn("THREE.ObjectLoader: Undefined geometry", t1), e[t1];
                }
                function c(t1) {
                    if (void 0 !== t1) {
                        if (Array.isArray(t1)) {
                            const e = [];
                            for(let n = 0, r = t1.length; n < r; n++){
                                const r = t1[n];
                                void 0 === i[r] && console.warn("THREE.ObjectLoader: Undefined material", r), e.push(i[r]);
                            }
                            return e;
                        }
                        return void 0 === i[t1] && console.warn("THREE.ObjectLoader: Undefined material", t1), i[t1];
                    }
                }
                function u(t1) {
                    return void 0 === n[t1] && console.warn("THREE.ObjectLoader: Undefined texture", t1), n[t1];
                }
                switch(t1.type){
                    case "Scene":
                        a = new Wp, void 0 !== t1.background && (Number.isInteger(t1.background) ? a.background = new Yc(t1.background) : a.background = u(t1.background)), void 0 !== t1.environment && (a.environment = u(t1.environment)), void 0 !== t1.fog && ("Fog" === t1.fog.type ? a.fog = new Gp(t1.fog.color, t1.fog.near, t1.fog.far) : "FogExp2" === t1.fog.type && (a.fog = new Vp(t1.fog.color, t1.fog.density)), "" !== t1.fog.name && (a.fog.name = t1.fog.name)), void 0 !== t1.backgroundBlurriness && (a.backgroundBlurriness = t1.backgroundBlurriness), void 0 !== t1.backgroundIntensity && (a.backgroundIntensity = t1.backgroundIntensity);
                        break;
                    case "PerspectiveCamera":
                        a = new qu(t1.fov, t1.aspect, t1.near, t1.far), void 0 !== t1.focus && (a.focus = t1.focus), void 0 !== t1.zoom && (a.zoom = t1.zoom), void 0 !== t1.filmGauge && (a.filmGauge = t1.filmGauge), void 0 !== t1.filmOffset && (a.filmOffset = t1.filmOffset), void 0 !== t1.view && (a.view = Object.assign({}, t1.view));
                        break;
                    case "OrthographicCamera":
                        a = new xh(t1.left, t1.right, t1.top, t1.bottom, t1.near, t1.far), void 0 !== t1.zoom && (a.zoom = t1.zoom), void 0 !== t1.view && (a.view = Object.assign({}, t1.view));
                        break;
                    case "AmbientLight":
                        a = new jg(t1.color, t1.intensity);
                        break;
                    case "DirectionalLight":
                        a = new Pg(t1.color, t1.intensity);
                        break;
                    case "PointLight":
                        a = new Lg(t1.color, t1.intensity, t1.distance, t1.decay);
                        break;
                    case "RectAreaLight":
                        a = new Rg(t1.color, t1.intensity, t1.width, t1.height);
                        break;
                    case "SpotLight":
                        a = new Sg(t1.color, t1.intensity, t1.distance, t1.angle, t1.penumbra, t1.decay);
                        break;
                    case "HemisphereLight":
                        a = new wg(t1.color, t1.groundColor, t1.intensity);
                        break;
                    case "LightProbe":
                        a = (new Ug).fromJSON(t1);
                        break;
                    case "SkinnedMesh":
                        s = l(t1.geometry), o = c(t1.material), a = new TA(s, o), void 0 !== t1.bindMode && (a.bindMode = t1.bindMode), void 0 !== t1.bindMatrix && a.bindMatrix.fromArray(t1.bindMatrix), void 0 !== t1.skeleton && (a.skeleton = t1.skeleton);
                        break;
                    case "Mesh":
                        s = l(t1.geometry), o = c(t1.material), a = new Fu(s, o);
                        break;
                    case "InstancedMesh":
                        s = l(t1.geometry), o = c(t1.material);
                        const e1 = t1.count, i1 = t1.instanceMatrix, n1 = t1.instanceColor;
                        a = new kA(s, o, e1), a.instanceMatrix = new DA(new Float32Array(i1.array), 16), void 0 !== n1 && (a.instanceColor = new DA(new Float32Array(n1.array), n1.itemSize));
                        break;
                    case "LOD":
                        a = new AA;
                        break;
                    case "Line":
                        a = new GA(l(t1.geometry), c(t1.material));
                        break;
                    case "LineLoop":
                        a = new ZA(l(t1.geometry), c(t1.material));
                        break;
                    case "LineSegments":
                        a = new XA(l(t1.geometry), c(t1.material));
                        break;
                    case "PointCloud":
                    case "Points":
                        a = new ef(l(t1.geometry), c(t1.material));
                        break;
                    case "Sprite":
                        a = new uA(c(t1.material));
                        break;
                    case "Group":
                        a = new Pp;
                        break;
                    case "Bone":
                        a = new EA;
                        break;
                    default:
                        a = new Dc;
                }
                if (a.uuid = t1.uuid, void 0 !== t1.name && (a.name = t1.name), void 0 !== t1.matrix ? (a.matrix.fromArray(t1.matrix), void 0 !== t1.matrixAutoUpdate && (a.matrixAutoUpdate = t1.matrixAutoUpdate), a.matrixAutoUpdate && a.matrix.decompose(a.position, a.quaternion, a.scale)) : (void 0 !== t1.position && a.position.fromArray(t1.position), void 0 !== t1.rotation && a.rotation.fromArray(t1.rotation), void 0 !== t1.quaternion && a.quaternion.fromArray(t1.quaternion), void 0 !== t1.scale && a.scale.fromArray(t1.scale)), void 0 !== t1.up && a.up.fromArray(t1.up), void 0 !== t1.castShadow && (a.castShadow = t1.castShadow), void 0 !== t1.receiveShadow && (a.receiveShadow = t1.receiveShadow), t1.shadow && (void 0 !== t1.shadow.bias && (a.shadow.bias = t1.shadow.bias), void 0 !== t1.shadow.normalBias && (a.shadow.normalBias = t1.shadow.normalBias), void 0 !== t1.shadow.radius && (a.shadow.radius = t1.shadow.radius), void 0 !== t1.shadow.mapSize && a.shadow.mapSize.fromArray(t1.shadow.mapSize), void 0 !== t1.shadow.camera && (a.shadow.camera = this.parseObject(t1.shadow.camera))), void 0 !== t1.visible && (a.visible = t1.visible), void 0 !== t1.frustumCulled && (a.frustumCulled = t1.frustumCulled), void 0 !== t1.renderOrder && (a.renderOrder = t1.renderOrder), void 0 !== t1.userData && (a.userData = t1.userData), void 0 !== t1.layers && (a.layers.mask = t1.layers), void 0 !== t1.children) {
                    const s = t1.children;
                    for(let t1 = 0; t1 < s.length; t1++)a.add(this.parseObject(s[t1], e, i, n, r));
                }
                if (void 0 !== t1.animations) {
                    const e = t1.animations;
                    for(let t1 = 0; t1 < e.length; t1++){
                        const i = e[t1];
                        a.animations.push(r[i]);
                    }
                }
                if ("LOD" === t1.type) {
                    void 0 !== t1.autoUpdate && (a.autoUpdate = t1.autoUpdate);
                    const e = t1.levels;
                    for(let t1 = 0; t1 < e.length; t1++){
                        const i = e[t1], n = a.getObjectByProperty("uuid", i.object);
                        void 0 !== n && a.addLevel(n, i.distance, i.hysteresis);
                    }
                }
                return a;
            }
            bindSkeletons(t1, e) {
                0 !== Object.keys(e).length && t1.traverse(function(t1) {
                    if (!0 === t1.isSkinnedMesh && void 0 !== t1.skeleton) {
                        const i = e[t1.skeleton];
                        void 0 === i ? console.warn("THREE.ObjectLoader: No skeleton found with UUID:", t1.skeleton) : t1.bind(i, t1.bindMatrix);
                    }
                });
            }
        }
        const Gg = {
            UVMapping: ia,
            CubeReflectionMapping: na,
            CubeRefractionMapping: ra,
            EquirectangularReflectionMapping: aa,
            EquirectangularRefractionMapping: sa,
            CubeUVReflectionMapping: oa
        }, Wg = {
            RepeatWrapping: la,
            ClampToEdgeWrapping: ca,
            MirroredRepeatWrapping: ua
        }, Yg = {
            NearestFilter: ha,
            NearestMipmapNearestFilter: da,
            NearestMipmapLinearFilter: Aa,
            LinearFilter: ma,
            LinearMipmapNearestFilter: ga,
            LinearMipmapLinearFilter: va
        };
        class Xg extends hg {
            constructor(t1){
                super(t1), this.isImageBitmapLoader = !0, "undefined" == typeof createImageBitmap && console.warn("THREE.ImageBitmapLoader: createImageBitmap() not supported."), "undefined" == typeof fetch && console.warn("THREE.ImageBitmapLoader: fetch() not supported."), this.options = {
                    premultiplyAlpha: "none"
                };
            }
            setOptions(t1) {
                return this.options = t1, this;
            }
            load(t1, e, i, n) {
                void 0 === t1 && (t1 = ""), void 0 !== this.path && (t1 = this.path + t1), t1 = this.manager.resolveURL(t1);
                const r = this, a = lg.get(t1);
                if (void 0 !== a) return r.manager.itemStart(t1), setTimeout(function() {
                    e && e(a), r.manager.itemEnd(t1);
                }, 0), a;
                const s = {};
                s.credentials = "anonymous" === this.crossOrigin ? "same-origin" : "include", s.headers = this.requestHeader, fetch(t1, s).then(function(t1) {
                    return t1.blob();
                }).then(function(t1) {
                    return createImageBitmap(t1, Object.assign(r.options, {
                        colorSpaceConversion: "none"
                    }));
                }).then(function(i) {
                    lg.add(t1, i), e && e(i), r.manager.itemEnd(t1);
                }).catch(function(e) {
                    n && n(e), r.manager.itemError(t1), r.manager.itemEnd(t1);
                }), r.manager.itemStart(t1);
            }
        }
        let Zg;
        class qg {
            static getContext() {
                return void 0 === Zg && (Zg = new (window.AudioContext || window.webkitAudioContext)), Zg;
            }
            static setContext(t1) {
                Zg = t1;
            }
        }
        class Jg extends hg {
            constructor(t1){
                super(t1);
            }
            load(t1, e, i, n) {
                const r = this, a = new Ag(this.manager);
                function s(e) {
                    n ? n(e) : console.error(e), r.manager.itemError(t1);
                }
                a.setResponseType("arraybuffer"), a.setPath(this.path), a.setRequestHeader(this.requestHeader), a.setWithCredentials(this.withCredentials), a.load(t1, function(t1) {
                    try {
                        const i = t1.slice(0);
                        qg.getContext().decodeAudioData(i, function(t1) {
                            e(t1);
                        }, s);
                    } catch (t1) {
                        s(t1);
                    }
                }, i, n);
            }
        }
        const Kg = new ac, $g = new ac, tM = new ac;
        class eM {
            constructor(){
                this.type = "StereoCamera", this.aspect = 1, this.eyeSep = .064, this.cameraL = new qu, this.cameraL.layers.enable(1), this.cameraL.matrixAutoUpdate = !1, this.cameraR = new qu, this.cameraR.layers.enable(2), this.cameraR.matrixAutoUpdate = !1, this._cache = {
                    focus: null,
                    fov: null,
                    aspect: null,
                    near: null,
                    far: null,
                    zoom: null,
                    eyeSep: null
                };
            }
            update(t1) {
                const e = this._cache;
                if (e.focus !== t1.focus || e.fov !== t1.fov || e.aspect !== t1.aspect * this.aspect || e.near !== t1.near || e.far !== t1.far || e.zoom !== t1.zoom || e.eyeSep !== this.eyeSep) {
                    e.focus = t1.focus, e.fov = t1.fov, e.aspect = t1.aspect * this.aspect, e.near = t1.near, e.far = t1.far, e.zoom = t1.zoom, e.eyeSep = this.eyeSep, tM.copy(t1.projectionMatrix);
                    const i = e.eyeSep / 2, n = i * e.near / e.focus, r = e.near * Math.tan(ko * e.fov * .5) / e.zoom;
                    let a, s;
                    $g.elements[12] = -i, Kg.elements[12] = i, a = -r * e.aspect + n, s = r * e.aspect + n, tM.elements[0] = 2 * e.near / (s - a), tM.elements[8] = (s + a) / (s - a), this.cameraL.projectionMatrix.copy(tM), a = -r * e.aspect - n, s = r * e.aspect - n, tM.elements[0] = 2 * e.near / (s - a), tM.elements[8] = (s + a) / (s - a), this.cameraR.projectionMatrix.copy(tM);
                }
                this.cameraL.matrixWorld.copy(t1.matrixWorld).multiply($g), this.cameraR.matrixWorld.copy(t1.matrixWorld).multiply(Kg);
            }
        }
        class iM {
            constructor(t1 = !0){
                this.autoStart = t1, this.startTime = 0, this.oldTime = 0, this.elapsedTime = 0, this.running = !1;
            }
            start() {
                this.startTime = nM(), this.oldTime = this.startTime, this.elapsedTime = 0, this.running = !0;
            }
            stop() {
                this.getElapsedTime(), this.running = !1, this.autoStart = !1;
            }
            getElapsedTime() {
                return this.getDelta(), this.elapsedTime;
            }
            getDelta() {
                let t1 = 0;
                if (this.autoStart && !this.running) return this.start(), 0;
                if (this.running) {
                    const e = nM();
                    t1 = (e - this.oldTime) / 1e3, this.oldTime = e, this.elapsedTime += t1;
                }
                return t1;
            }
        }
        function nM() {
            return ("undefined" == typeof performance ? Date : performance).now();
        }
        const rM = new Nl, aM = new Sl, sM = new Nl, oM = new Nl;
        class lM extends Dc {
            constructor(){
                super(), this.type = "AudioListener", this.context = qg.getContext(), this.gain = this.context.createGain(), this.gain.connect(this.context.destination), this.filter = null, this.timeDelta = 0, this._clock = new iM;
            }
            getInput() {
                return this.gain;
            }
            removeFilter() {
                return null !== this.filter && (this.gain.disconnect(this.filter), this.filter.disconnect(this.context.destination), this.gain.connect(this.context.destination), this.filter = null), this;
            }
            getFilter() {
                return this.filter;
            }
            setFilter(t1) {
                return null !== this.filter ? (this.gain.disconnect(this.filter), this.filter.disconnect(this.context.destination)) : this.gain.disconnect(this.context.destination), this.filter = t1, this.gain.connect(this.filter), this.filter.connect(this.context.destination), this;
            }
            getMasterVolume() {
                return this.gain.gain.value;
            }
            setMasterVolume(t1) {
                return this.gain.gain.setTargetAtTime(t1, this.context.currentTime, .01), this;
            }
            updateMatrixWorld(t1) {
                super.updateMatrixWorld(t1);
                const e = this.context.listener, i = this.up;
                if (this.timeDelta = this._clock.getDelta(), this.matrixWorld.decompose(rM, aM, sM), oM.set(0, 0, -1).applyQuaternion(aM), e.positionX) {
                    const t1 = this.context.currentTime + this.timeDelta;
                    e.positionX.linearRampToValueAtTime(rM.x, t1), e.positionY.linearRampToValueAtTime(rM.y, t1), e.positionZ.linearRampToValueAtTime(rM.z, t1), e.forwardX.linearRampToValueAtTime(oM.x, t1), e.forwardY.linearRampToValueAtTime(oM.y, t1), e.forwardZ.linearRampToValueAtTime(oM.z, t1), e.upX.linearRampToValueAtTime(i.x, t1), e.upY.linearRampToValueAtTime(i.y, t1), e.upZ.linearRampToValueAtTime(i.z, t1);
                } else e.setPosition(rM.x, rM.y, rM.z), e.setOrientation(oM.x, oM.y, oM.z, i.x, i.y, i.z);
            }
        }
        class cM extends Dc {
            constructor(t1){
                super(), this.type = "Audio", this.listener = t1, this.context = t1.context, this.gain = this.context.createGain(), this.gain.connect(t1.getInput()), this.autoplay = !1, this.buffer = null, this.detune = 0, this.loop = !1, this.loopStart = 0, this.loopEnd = 0, this.offset = 0, this.duration = void 0, this.playbackRate = 1, this.isPlaying = !1, this.hasPlaybackControl = !0, this.source = null, this.sourceType = "empty", this._startedAt = 0, this._progress = 0, this._connected = !1, this.filters = [];
            }
            getOutput() {
                return this.gain;
            }
            setNodeSource(t1) {
                return this.hasPlaybackControl = !1, this.sourceType = "audioNode", this.source = t1, this.connect(), this;
            }
            setMediaElementSource(t1) {
                return this.hasPlaybackControl = !1, this.sourceType = "mediaNode", this.source = this.context.createMediaElementSource(t1), this.connect(), this;
            }
            setMediaStreamSource(t1) {
                return this.hasPlaybackControl = !1, this.sourceType = "mediaStreamNode", this.source = this.context.createMediaStreamSource(t1), this.connect(), this;
            }
            setBuffer(t1) {
                return this.buffer = t1, this.sourceType = "buffer", this.autoplay && this.play(), this;
            }
            play(t1 = 0) {
                if (!0 === this.isPlaying) return void console.warn("THREE.Audio: Audio is already playing.");
                if (!1 === this.hasPlaybackControl) return void console.warn("THREE.Audio: this Audio has no playback control.");
                this._startedAt = this.context.currentTime + t1;
                const e = this.context.createBufferSource();
                return e.buffer = this.buffer, e.loop = this.loop, e.loopStart = this.loopStart, e.loopEnd = this.loopEnd, e.onended = this.onEnded.bind(this), e.start(this._startedAt, this._progress + this.offset, this.duration), this.isPlaying = !0, this.source = e, this.setDetune(this.detune), this.setPlaybackRate(this.playbackRate), this.connect();
            }
            pause() {
                if (!1 !== this.hasPlaybackControl) return !0 === this.isPlaying && (this._progress += Math.max(this.context.currentTime - this._startedAt, 0) * this.playbackRate, !0 === this.loop && (this._progress = this._progress % (this.duration || this.buffer.duration)), this.source.stop(), this.source.onended = null, this.isPlaying = !1), this;
                console.warn("THREE.Audio: this Audio has no playback control.");
            }
            stop() {
                if (!1 !== this.hasPlaybackControl) return this._progress = 0, null !== this.source && (this.source.stop(), this.source.onended = null), this.isPlaying = !1, this;
                console.warn("THREE.Audio: this Audio has no playback control.");
            }
            connect() {
                if (this.filters.length > 0) {
                    this.source.connect(this.filters[0]);
                    for(let t1 = 1, e = this.filters.length; t1 < e; t1++)this.filters[t1 - 1].connect(this.filters[t1]);
                    this.filters[this.filters.length - 1].connect(this.getOutput());
                } else this.source.connect(this.getOutput());
                return this._connected = !0, this;
            }
            disconnect() {
                if (!1 !== this._connected) {
                    if (this.filters.length > 0) {
                        this.source.disconnect(this.filters[0]);
                        for(let t1 = 1, e = this.filters.length; t1 < e; t1++)this.filters[t1 - 1].disconnect(this.filters[t1]);
                        this.filters[this.filters.length - 1].disconnect(this.getOutput());
                    } else this.source.disconnect(this.getOutput());
                    return this._connected = !1, this;
                }
            }
            getFilters() {
                return this.filters;
            }
            setFilters(t1) {
                return t1 || (t1 = []), !0 === this._connected ? (this.disconnect(), this.filters = t1.slice(), this.connect()) : this.filters = t1.slice(), this;
            }
            setDetune(t1) {
                if (this.detune = t1, void 0 !== this.source.detune) return !0 === this.isPlaying && this.source.detune.setTargetAtTime(this.detune, this.context.currentTime, .01), this;
            }
            getDetune() {
                return this.detune;
            }
            getFilter() {
                return this.getFilters()[0];
            }
            setFilter(t1) {
                return this.setFilters(t1 ? [
                    t1
                ] : []);
            }
            setPlaybackRate(t1) {
                if (!1 !== this.hasPlaybackControl) return this.playbackRate = t1, !0 === this.isPlaying && this.source.playbackRate.setTargetAtTime(this.playbackRate, this.context.currentTime, .01), this;
                console.warn("THREE.Audio: this Audio has no playback control.");
            }
            getPlaybackRate() {
                return this.playbackRate;
            }
            onEnded() {
                this.isPlaying = !1;
            }
            getLoop() {
                return !1 === this.hasPlaybackControl ? (console.warn("THREE.Audio: this Audio has no playback control."), !1) : this.loop;
            }
            setLoop(t1) {
                if (!1 !== this.hasPlaybackControl) return this.loop = t1, !0 === this.isPlaying && (this.source.loop = this.loop), this;
                console.warn("THREE.Audio: this Audio has no playback control.");
            }
            setLoopStart(t1) {
                return this.loopStart = t1, this;
            }
            setLoopEnd(t1) {
                return this.loopEnd = t1, this;
            }
            getVolume() {
                return this.gain.gain.value;
            }
            setVolume(t1) {
                return this.gain.gain.setTargetAtTime(t1, this.context.currentTime, .01), this;
            }
        }
        const uM = new Nl, hM = new Sl, dM = new Nl, pM = new Nl;
        class AM extends cM {
            constructor(t1){
                super(t1), this.panner = this.context.createPanner(), this.panner.panningModel = "HRTF", this.panner.connect(this.gain);
            }
            connect() {
                super.connect(), this.panner.connect(this.gain);
            }
            disconnect() {
                super.disconnect(), this.panner.disconnect(this.gain);
            }
            getOutput() {
                return this.panner;
            }
            getRefDistance() {
                return this.panner.refDistance;
            }
            setRefDistance(t1) {
                return this.panner.refDistance = t1, this;
            }
            getRolloffFactor() {
                return this.panner.rolloffFactor;
            }
            setRolloffFactor(t1) {
                return this.panner.rolloffFactor = t1, this;
            }
            getDistanceModel() {
                return this.panner.distanceModel;
            }
            setDistanceModel(t1) {
                return this.panner.distanceModel = t1, this;
            }
            getMaxDistance() {
                return this.panner.maxDistance;
            }
            setMaxDistance(t1) {
                return this.panner.maxDistance = t1, this;
            }
            setDirectionalCone(t1, e, i) {
                return this.panner.coneInnerAngle = t1, this.panner.coneOuterAngle = e, this.panner.coneOuterGain = i, this;
            }
            updateMatrixWorld(t1) {
                if (super.updateMatrixWorld(t1), !0 === this.hasPlaybackControl && !1 === this.isPlaying) return;
                this.matrixWorld.decompose(uM, hM, dM), pM.set(0, 0, 1).applyQuaternion(hM);
                const e = this.panner;
                if (e.positionX) {
                    const t1 = this.context.currentTime + this.listener.timeDelta;
                    e.positionX.linearRampToValueAtTime(uM.x, t1), e.positionY.linearRampToValueAtTime(uM.y, t1), e.positionZ.linearRampToValueAtTime(uM.z, t1), e.orientationX.linearRampToValueAtTime(pM.x, t1), e.orientationY.linearRampToValueAtTime(pM.y, t1), e.orientationZ.linearRampToValueAtTime(pM.z, t1);
                } else e.setPosition(uM.x, uM.y, uM.z), e.setOrientation(pM.x, pM.y, pM.z);
            }
        }
        class fM {
            constructor(t1, e = 2048){
                this.analyser = t1.context.createAnalyser(), this.analyser.fftSize = e, this.data = new Uint8Array(this.analyser.frequencyBinCount), t1.getOutput().connect(this.analyser);
            }
            getFrequencyData() {
                return this.analyser.getByteFrequencyData(this.data), this.data;
            }
            getAverageFrequency() {
                let t1 = 0;
                const e = this.getFrequencyData();
                for(let i = 0; i < e.length; i++)t1 += e[i];
                return t1 / e.length;
            }
        }
        class mM {
            constructor(t1, e, i){
                let n, r, a;
                switch(this.binding = t1, this.valueSize = i, e){
                    case "quaternion":
                        n = this._slerp, r = this._slerpAdditive, a = this._setAdditiveIdentityQuaternion, this.buffer = new Float64Array(6 * i), this._workIndex = 5;
                        break;
                    case "string":
                    case "bool":
                        n = this._select, r = this._select, a = this._setAdditiveIdentityOther, this.buffer = new Array(5 * i);
                        break;
                    default:
                        n = this._lerp, r = this._lerpAdditive, a = this._setAdditiveIdentityNumeric, this.buffer = new Float64Array(5 * i);
                }
                this._mixBufferRegion = n, this._mixBufferRegionAdditive = r, this._setIdentity = a, this._origIndex = 3, this._addIndex = 4, this.cumulativeWeight = 0, this.cumulativeWeightAdditive = 0, this.useCount = 0, this.referenceCount = 0;
            }
            accumulate(t1, e) {
                const i = this.buffer, n = this.valueSize, r = t1 * n + n;
                let a = this.cumulativeWeight;
                if (0 === a) {
                    for(let t1 = 0; t1 !== n; ++t1)i[r + t1] = i[t1];
                    a = e;
                } else {
                    a += e;
                    const t1 = e / a;
                    this._mixBufferRegion(i, r, 0, t1, n);
                }
                this.cumulativeWeight = a;
            }
            accumulateAdditive(t1) {
                const e = this.buffer, i = this.valueSize, n = i * this._addIndex;
                0 === this.cumulativeWeightAdditive && this._setIdentity(), this._mixBufferRegionAdditive(e, n, 0, t1, i), this.cumulativeWeightAdditive += t1;
            }
            apply(t1) {
                const e = this.valueSize, i = this.buffer, n = t1 * e + e, r = this.cumulativeWeight, a = this.cumulativeWeightAdditive, s = this.binding;
                if (this.cumulativeWeight = 0, this.cumulativeWeightAdditive = 0, r < 1) {
                    const t1 = e * this._origIndex;
                    this._mixBufferRegion(i, n, t1, 1 - r, e);
                }
                a > 0 && this._mixBufferRegionAdditive(i, n, this._addIndex * e, 1, e);
                for(let t1 = e, r = e + e; t1 !== r; ++t1)if (i[t1] !== i[t1 + e]) {
                    s.setValue(i, n);
                    break;
                }
            }
            saveOriginalState() {
                const t1 = this.binding, e = this.buffer, i = this.valueSize, n = i * this._origIndex;
                t1.getValue(e, n);
                for(let t1 = i, r = n; t1 !== r; ++t1)e[t1] = e[n + t1 % i];
                this._setIdentity(), this.cumulativeWeight = 0, this.cumulativeWeightAdditive = 0;
            }
            restoreOriginalState() {
                const t1 = 3 * this.valueSize;
                this.binding.setValue(this.buffer, t1);
            }
            _setAdditiveIdentityNumeric() {
                const t1 = this._addIndex * this.valueSize, e = t1 + this.valueSize;
                for(let i = t1; i < e; i++)this.buffer[i] = 0;
            }
            _setAdditiveIdentityQuaternion() {
                this._setAdditiveIdentityNumeric(), this.buffer[this._addIndex * this.valueSize + 3] = 1;
            }
            _setAdditiveIdentityOther() {
                const t1 = this._origIndex * this.valueSize, e = this._addIndex * this.valueSize;
                for(let i = 0; i < this.valueSize; i++)this.buffer[e + i] = this.buffer[t1 + i];
            }
            _select(t1, e, i, n, r) {
                if (n >= .5) for(let n = 0; n !== r; ++n)t1[e + n] = t1[i + n];
            }
            _slerp(t1, e, i, n) {
                Sl.slerpFlat(t1, e, t1, e, t1, i, n);
            }
            _slerpAdditive(t1, e, i, n, r) {
                const a = this._workIndex * r;
                Sl.multiplyQuaternionsFlat(t1, a, t1, e, t1, i), Sl.slerpFlat(t1, e, t1, e, t1, a, n);
            }
            _lerp(t1, e, i, n, r) {
                const a = 1 - n;
                for(let s = 0; s !== r; ++s){
                    const r = e + s;
                    t1[r] = t1[r] * a + t1[i + s] * n;
                }
            }
            _lerpAdditive(t1, e, i, n, r) {
                for(let a = 0; a !== r; ++a){
                    const r = e + a;
                    t1[r] = t1[r] + t1[i + a] * n;
                }
            }
        }
        const gM = "\\[\\]\\.:\\/", MM = new RegExp("[" + gM + "]", "g"), vM = "[^" + gM + "]", yM = "[^" + gM.replace("\\.", "") + "]", xM = new RegExp("^" + /((?:WC+[\/:])*)/.source.replace("WC", vM) + /(WCOD+)?/.source.replace("WCOD", yM) + /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace("WC", vM) + /\.(WC+)(?:\[(.+)\])?/.source.replace("WC", vM) + "$"), wM = [
            "material",
            "materials",
            "bones",
            "map"
        ];
        class bM {
            constructor(t1, e, i){
                this.path = e, this.parsedPath = i || bM.parseTrackName(e), this.node = bM.findNode(t1, this.parsedPath.nodeName), this.rootNode = t1, this.getValue = this._getValue_unbound, this.setValue = this._setValue_unbound;
            }
            static create(t1, e, i) {
                return t1 && t1.isAnimationObjectGroup ? new bM.Composite(t1, e, i) : new bM(t1, e, i);
            }
            static sanitizeNodeName(t1) {
                return t1.replace(/\s/g, "_").replace(MM, "");
            }
            static parseTrackName(t1) {
                const e = xM.exec(t1);
                if (null === e) throw new Error("PropertyBinding: Cannot parse trackName: " + t1);
                const i = {
                    nodeName: e[2],
                    objectName: e[3],
                    objectIndex: e[4],
                    propertyName: e[5],
                    propertyIndex: e[6]
                }, n = i.nodeName && i.nodeName.lastIndexOf(".");
                if (void 0 !== n && -1 !== n) {
                    const t1 = i.nodeName.substring(n + 1);
                    -1 !== wM.indexOf(t1) && (i.nodeName = i.nodeName.substring(0, n), i.objectName = t1);
                }
                if (null === i.propertyName || 0 === i.propertyName.length) throw new Error("PropertyBinding: can not parse propertyName from trackName: " + t1);
                return i;
            }
            static findNode(t1, e) {
                if (void 0 === e || "" === e || "." === e || -1 === e || e === t1.name || e === t1.uuid) return t1;
                if (t1.skeleton) {
                    const i = t1.skeleton.getBoneByName(e);
                    if (void 0 !== i) return i;
                }
                if (t1.children) {
                    const i = function(t1) {
                        for(let n = 0; n < t1.length; n++){
                            const r = t1[n];
                            if (r.name === e || r.uuid === e) return r;
                            const a = i(r.children);
                            if (a) return a;
                        }
                        return null;
                    }, n = i(t1.children);
                    if (n) return n;
                }
                return null;
            }
            _getValue_unavailable() {}
            _setValue_unavailable() {}
            _getValue_direct(t1, e) {
                t1[e] = this.targetObject[this.propertyName];
            }
            _getValue_array(t1, e) {
                const i = this.resolvedProperty;
                for(let n = 0, r = i.length; n !== r; ++n)t1[e++] = i[n];
            }
            _getValue_arrayElement(t1, e) {
                t1[e] = this.resolvedProperty[this.propertyIndex];
            }
            _getValue_toArray(t1, e) {
                this.resolvedProperty.toArray(t1, e);
            }
            _setValue_direct(t1, e) {
                this.targetObject[this.propertyName] = t1[e];
            }
            _setValue_direct_setNeedsUpdate(t1, e) {
                this.targetObject[this.propertyName] = t1[e], this.targetObject.needsUpdate = !0;
            }
            _setValue_direct_setMatrixWorldNeedsUpdate(t1, e) {
                this.targetObject[this.propertyName] = t1[e], this.targetObject.matrixWorldNeedsUpdate = !0;
            }
            _setValue_array(t1, e) {
                const i = this.resolvedProperty;
                for(let n = 0, r = i.length; n !== r; ++n)i[n] = t1[e++];
            }
            _setValue_array_setNeedsUpdate(t1, e) {
                const i = this.resolvedProperty;
                for(let n = 0, r = i.length; n !== r; ++n)i[n] = t1[e++];
                this.targetObject.needsUpdate = !0;
            }
            _setValue_array_setMatrixWorldNeedsUpdate(t1, e) {
                const i = this.resolvedProperty;
                for(let n = 0, r = i.length; n !== r; ++n)i[n] = t1[e++];
                this.targetObject.matrixWorldNeedsUpdate = !0;
            }
            _setValue_arrayElement(t1, e) {
                this.resolvedProperty[this.propertyIndex] = t1[e];
            }
            _setValue_arrayElement_setNeedsUpdate(t1, e) {
                this.resolvedProperty[this.propertyIndex] = t1[e], this.targetObject.needsUpdate = !0;
            }
            _setValue_arrayElement_setMatrixWorldNeedsUpdate(t1, e) {
                this.resolvedProperty[this.propertyIndex] = t1[e], this.targetObject.matrixWorldNeedsUpdate = !0;
            }
            _setValue_fromArray(t1, e) {
                this.resolvedProperty.fromArray(t1, e);
            }
            _setValue_fromArray_setNeedsUpdate(t1, e) {
                this.resolvedProperty.fromArray(t1, e), this.targetObject.needsUpdate = !0;
            }
            _setValue_fromArray_setMatrixWorldNeedsUpdate(t1, e) {
                this.resolvedProperty.fromArray(t1, e), this.targetObject.matrixWorldNeedsUpdate = !0;
            }
            _getValue_unbound(t1, e) {
                this.bind(), this.getValue(t1, e);
            }
            _setValue_unbound(t1, e) {
                this.bind(), this.setValue(t1, e);
            }
            bind() {
                let t1 = this.node;
                const e = this.parsedPath, i = e.objectName, n = e.propertyName;
                let r = e.propertyIndex;
                if (t1 || (t1 = bM.findNode(this.rootNode, e.nodeName), this.node = t1), this.getValue = this._getValue_unavailable, this.setValue = this._setValue_unavailable, !t1) return void console.warn("THREE.PropertyBinding: No target node found for track: " + this.path + ".");
                if (i) {
                    let n = e.objectIndex;
                    switch(i){
                        case "materials":
                            if (!t1.material) return void console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
                            if (!t1.material.materials) return void console.error("THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.", this);
                            t1 = t1.material.materials;
                            break;
                        case "bones":
                            if (!t1.skeleton) return void console.error("THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.", this);
                            t1 = t1.skeleton.bones;
                            for(let e = 0; e < t1.length; e++)if (t1[e].name === n) {
                                n = e;
                                break;
                            }
                            break;
                        case "map":
                            if ("map" in t1) {
                                t1 = t1.map;
                                break;
                            }
                            if (!t1.material) return void console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
                            if (!t1.material.map) return void console.error("THREE.PropertyBinding: Can not bind to material.map as node.material does not have a map.", this);
                            t1 = t1.material.map;
                            break;
                        default:
                            if (void 0 === t1[i]) return void console.error("THREE.PropertyBinding: Can not bind to objectName of node undefined.", this);
                            t1 = t1[i];
                    }
                    if (void 0 !== n) {
                        if (void 0 === t1[n]) return void console.error("THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.", this, t1);
                        t1 = t1[n];
                    }
                }
                const a = t1[n];
                if (void 0 === a) {
                    const i = e.nodeName;
                    return void console.error("THREE.PropertyBinding: Trying to update property for track: " + i + "." + n + " but it wasn't found.", t1);
                }
                let s = this.Versioning.None;
                this.targetObject = t1, void 0 !== t1.needsUpdate ? s = this.Versioning.NeedsUpdate : void 0 !== t1.matrixWorldNeedsUpdate && (s = this.Versioning.MatrixWorldNeedsUpdate);
                let o = this.BindingType.Direct;
                if (void 0 !== r) {
                    if ("morphTargetInfluences" === n) {
                        if (!t1.geometry) return void console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.", this);
                        if (!t1.geometry.morphAttributes) return void console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.", this);
                        void 0 !== t1.morphTargetDictionary[r] && (r = t1.morphTargetDictionary[r]);
                    }
                    o = this.BindingType.ArrayElement, this.resolvedProperty = a, this.propertyIndex = r;
                } else void 0 !== a.fromArray && void 0 !== a.toArray ? (o = this.BindingType.HasFromToArray, this.resolvedProperty = a) : Array.isArray(a) ? (o = this.BindingType.EntireArray, this.resolvedProperty = a) : this.propertyName = n;
                this.getValue = this.GetterByBindingType[o], this.setValue = this.SetterByBindingTypeAndVersioning[o][s];
            }
            unbind() {
                this.node = null, this.getValue = this._getValue_unbound, this.setValue = this._setValue_unbound;
            }
        }
        bM.Composite = class {
            constructor(t1, e, i){
                const n = i || bM.parseTrackName(e);
                this._targetGroup = t1, this._bindings = t1.subscribe_(e, n);
            }
            getValue(t1, e) {
                this.bind();
                const i = this._targetGroup.nCachedObjects_, n = this._bindings[i];
                void 0 !== n && n.getValue(t1, e);
            }
            setValue(t1, e) {
                const i = this._bindings;
                for(let n = this._targetGroup.nCachedObjects_, r = i.length; n !== r; ++n)i[n].setValue(t1, e);
            }
            bind() {
                const t1 = this._bindings;
                for(let e = this._targetGroup.nCachedObjects_, i = t1.length; e !== i; ++e)t1[e].bind();
            }
            unbind() {
                const t1 = this._bindings;
                for(let e = this._targetGroup.nCachedObjects_, i = t1.length; e !== i; ++e)t1[e].unbind();
            }
        }, bM.prototype.BindingType = {
            Direct: 0,
            EntireArray: 1,
            ArrayElement: 2,
            HasFromToArray: 3
        }, bM.prototype.Versioning = {
            None: 0,
            NeedsUpdate: 1,
            MatrixWorldNeedsUpdate: 2
        }, bM.prototype.GetterByBindingType = [
            bM.prototype._getValue_direct,
            bM.prototype._getValue_array,
            bM.prototype._getValue_arrayElement,
            bM.prototype._getValue_toArray
        ], bM.prototype.SetterByBindingTypeAndVersioning = [
            [
                bM.prototype._setValue_direct,
                bM.prototype._setValue_direct_setNeedsUpdate,
                bM.prototype._setValue_direct_setMatrixWorldNeedsUpdate
            ],
            [
                bM.prototype._setValue_array,
                bM.prototype._setValue_array_setNeedsUpdate,
                bM.prototype._setValue_array_setMatrixWorldNeedsUpdate
            ],
            [
                bM.prototype._setValue_arrayElement,
                bM.prototype._setValue_arrayElement_setNeedsUpdate,
                bM.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
            ],
            [
                bM.prototype._setValue_fromArray,
                bM.prototype._setValue_fromArray_setNeedsUpdate,
                bM.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
            ]
        ];
        class TM {
            constructor(){
                this.isAnimationObjectGroup = !0, this.uuid = Bo(), this._objects = Array.prototype.slice.call(arguments), this.nCachedObjects_ = 0;
                const t1 = {};
                this._indicesByUUID = t1;
                for(let e = 0, i = arguments.length; e !== i; ++e)t1[arguments[e].uuid] = e;
                this._paths = [], this._parsedPaths = [], this._bindings = [], this._bindingsIndicesByPath = {};
                const e = this;
                this.stats = {
                    objects: {
                        get total () {
                            return e._objects.length;
                        },
                        get inUse () {
                            return this.total - e.nCachedObjects_;
                        }
                    },
                    get bindingsPerObject () {
                        return e._bindings.length;
                    }
                };
            }
            add() {
                const t1 = this._objects, e = this._indicesByUUID, i = this._paths, n = this._parsedPaths, r = this._bindings, a = r.length;
                let s, o = t1.length, l = this.nCachedObjects_;
                for(let c = 0, u = arguments.length; c !== u; ++c){
                    const u = arguments[c], h = u.uuid;
                    let d = e[h];
                    if (void 0 === d) {
                        d = o++, e[h] = d, t1.push(u);
                        for(let t1 = 0, e = a; t1 !== e; ++t1)r[t1].push(new bM(u, i[t1], n[t1]));
                    } else if (d < l) {
                        s = t1[d];
                        const o = --l, c = t1[o];
                        e[c.uuid] = d, t1[d] = c, e[h] = o, t1[o] = u;
                        for(let t1 = 0, e = a; t1 !== e; ++t1){
                            const e = r[t1], a = e[o];
                            let s = e[d];
                            e[d] = a, void 0 === s && (s = new bM(u, i[t1], n[t1])), e[o] = s;
                        }
                    } else t1[d] !== s && console.error("THREE.AnimationObjectGroup: Different objects with the same UUID detected. Clean the caches or recreate your infrastructure when reloading scenes.");
                }
                this.nCachedObjects_ = l;
            }
            remove() {
                const t1 = this._objects, e = this._indicesByUUID, i = this._bindings, n = i.length;
                let r = this.nCachedObjects_;
                for(let a = 0, s = arguments.length; a !== s; ++a){
                    const s = arguments[a], o = s.uuid, l = e[o];
                    if (void 0 !== l && l >= r) {
                        const a = r++, c = t1[a];
                        e[c.uuid] = l, t1[l] = c, e[o] = a, t1[a] = s;
                        for(let t1 = 0, e = n; t1 !== e; ++t1){
                            const e = i[t1], n = e[a], r = e[l];
                            e[l] = n, e[a] = r;
                        }
                    }
                }
                this.nCachedObjects_ = r;
            }
            uncache() {
                const t1 = this._objects, e = this._indicesByUUID, i = this._bindings, n = i.length;
                let r = this.nCachedObjects_, a = t1.length;
                for(let s = 0, o = arguments.length; s !== o; ++s){
                    const o = arguments[s].uuid, l = e[o];
                    if (void 0 !== l) {
                        if (delete e[o], l < r) {
                            const s = --r, o = t1[s], c = --a, u = t1[c];
                            e[o.uuid] = l, t1[l] = o, e[u.uuid] = s, t1[s] = u, t1.pop();
                            for(let t1 = 0, e = n; t1 !== e; ++t1){
                                const e = i[t1], n = e[s], r = e[c];
                                e[l] = n, e[s] = r, e.pop();
                            }
                        } else {
                            const r = --a, s = t1[r];
                            r > 0 && (e[s.uuid] = l), t1[l] = s, t1.pop();
                            for(let t1 = 0, e = n; t1 !== e; ++t1){
                                const e = i[t1];
                                e[l] = e[r], e.pop();
                            }
                        }
                    }
                }
                this.nCachedObjects_ = r;
            }
            subscribe_(t1, e) {
                const i = this._bindingsIndicesByPath;
                let n = i[t1];
                const r = this._bindings;
                if (void 0 !== n) return r[n];
                const a = this._paths, s = this._parsedPaths, o = this._objects, l = o.length, c = this.nCachedObjects_, u = new Array(l);
                n = r.length, i[t1] = n, a.push(t1), s.push(e), r.push(u);
                for(let i = c, n = o.length; i !== n; ++i){
                    const n = o[i];
                    u[i] = new bM(n, t1, e);
                }
                return u;
            }
            unsubscribe_(t1) {
                const e = this._bindingsIndicesByPath, i = e[t1];
                if (void 0 !== i) {
                    const n = this._paths, r = this._parsedPaths, a = this._bindings, s = a.length - 1, o = a[s];
                    e[t1[s]] = i, a[i] = o, a.pop(), r[i] = r[s], r.pop(), n[i] = n[s], n.pop();
                }
            }
        }
        class EM {
            constructor(t1, e, i = null, n = e.blendMode){
                this._mixer = t1, this._clip = e, this._localRoot = i, this.blendMode = n;
                const r = e.tracks, a = r.length, s = new Array(a), o = {
                    endingStart: Is,
                    endingEnd: Is
                };
                for(let t1 = 0; t1 !== a; ++t1){
                    const e = r[t1].createInterpolant(null);
                    s[t1] = e, e.settings = o;
                }
                this._interpolantSettings = o, this._interpolants = s, this._propertyBindings = new Array(a), this._cacheIndex = null, this._byClipCacheIndex = null, this._timeScaleInterpolant = null, this._weightInterpolant = null, this.loop = ws, this._loopCount = -1, this._startTime = null, this.time = 0, this.timeScale = 1, this._effectiveTimeScale = 1, this.weight = 1, this._effectiveWeight = 1, this.repetitions = 1 / 0, this.paused = !1, this.enabled = !0, this.clampWhenFinished = !1, this.zeroSlopeAtStart = !0, this.zeroSlopeAtEnd = !0;
            }
            play() {
                return this._mixer._activateAction(this), this;
            }
            stop() {
                return this._mixer._deactivateAction(this), this.reset();
            }
            reset() {
                return this.paused = !1, this.enabled = !0, this.time = 0, this._loopCount = -1, this._startTime = null, this.stopFading().stopWarping();
            }
            isRunning() {
                return this.enabled && !this.paused && 0 !== this.timeScale && null === this._startTime && this._mixer._isActiveAction(this);
            }
            isScheduled() {
                return this._mixer._isActiveAction(this);
            }
            startAt(t1) {
                return this._startTime = t1, this;
            }
            setLoop(t1, e) {
                return this.loop = t1, this.repetitions = e, this;
            }
            setEffectiveWeight(t1) {
                return this.weight = t1, this._effectiveWeight = this.enabled ? t1 : 0, this.stopFading();
            }
            getEffectiveWeight() {
                return this._effectiveWeight;
            }
            fadeIn(t1) {
                return this._scheduleFading(t1, 0, 1);
            }
            fadeOut(t1) {
                return this._scheduleFading(t1, 1, 0);
            }
            crossFadeFrom(t1, e, i) {
                if (t1.fadeOut(e), this.fadeIn(e), i) {
                    const i = this._clip.duration, n = t1._clip.duration, r = n / i, a = i / n;
                    t1.warp(1, r, e), this.warp(a, 1, e);
                }
                return this;
            }
            crossFadeTo(t1, e, i) {
                return t1.crossFadeFrom(this, e, i);
            }
            stopFading() {
                const t1 = this._weightInterpolant;
                return null !== t1 && (this._weightInterpolant = null, this._mixer._takeBackControlInterpolant(t1)), this;
            }
            setEffectiveTimeScale(t1) {
                return this.timeScale = t1, this._effectiveTimeScale = this.paused ? 0 : t1, this.stopWarping();
            }
            getEffectiveTimeScale() {
                return this._effectiveTimeScale;
            }
            setDuration(t1) {
                return this.timeScale = this._clip.duration / t1, this.stopWarping();
            }
            syncWith(t1) {
                return this.time = t1.time, this.timeScale = t1.timeScale, this.stopWarping();
            }
            halt(t1) {
                return this.warp(this._effectiveTimeScale, 0, t1);
            }
            warp(t1, e, i) {
                const n = this._mixer, r = n.time, a = this.timeScale;
                let s = this._timeScaleInterpolant;
                null === s && (s = n._lendControlInterpolant(), this._timeScaleInterpolant = s);
                const o = s.parameterPositions, l = s.sampleValues;
                return o[0] = r, o[1] = r + i, l[0] = t1 / a, l[1] = e / a, this;
            }
            stopWarping() {
                const t1 = this._timeScaleInterpolant;
                return null !== t1 && (this._timeScaleInterpolant = null, this._mixer._takeBackControlInterpolant(t1)), this;
            }
            getMixer() {
                return this._mixer;
            }
            getClip() {
                return this._clip;
            }
            getRoot() {
                return this._localRoot || this._mixer._root;
            }
            _update(t1, e, i, n) {
                if (!this.enabled) return void this._updateWeight(t1);
                const r = this._startTime;
                if (null !== r) {
                    const n = (t1 - r) * i;
                    n < 0 || 0 === i ? e = 0 : (this._startTime = null, e = i * n);
                }
                e *= this._updateTimeScale(t1);
                const a = this._updateTime(e), s = this._updateWeight(t1);
                if (s > 0) {
                    const t1 = this._interpolants, e = this._propertyBindings;
                    if (this.blendMode === Cs) for(let i = 0, n = t1.length; i !== n; ++i)t1[i].evaluate(a), e[i].accumulateAdditive(s);
                    else for(let i = 0, r = t1.length; i !== r; ++i)t1[i].evaluate(a), e[i].accumulate(n, s);
                }
            }
            _updateWeight(t1) {
                let e = 0;
                if (this.enabled) {
                    e = this.weight;
                    const i = this._weightInterpolant;
                    if (null !== i) {
                        const n = i.evaluate(t1)[0];
                        e *= n, t1 > i.parameterPositions[1] && (this.stopFading(), 0 === n && (this.enabled = !1));
                    }
                }
                return this._effectiveWeight = e, e;
            }
            _updateTimeScale(t1) {
                let e = 0;
                if (!this.paused) {
                    e = this.timeScale;
                    const i = this._timeScaleInterpolant;
                    null !== i && (e *= i.evaluate(t1)[0], t1 > i.parameterPositions[1] && (this.stopWarping(), 0 === e ? this.paused = !0 : this.timeScale = e));
                }
                return this._effectiveTimeScale = e, e;
            }
            _updateTime(t1) {
                const e = this._clip.duration, i = this.loop;
                let n = this.time + t1, r = this._loopCount;
                const a = i === bs;
                if (0 === t1) return -1 === r || !a || 1 & ~r ? n : e - n;
                if (i === xs) {
                    -1 === r && (this._loopCount = 0, this._setEndings(!0, !0, !1));
                    t: {
                        if (n >= e) n = e;
                        else {
                            if (!(n < 0)) {
                                this.time = n;
                                break t;
                            }
                            n = 0;
                        }
                        this.clampWhenFinished ? this.paused = !0 : this.enabled = !1, this.time = n, this._mixer.dispatchEvent({
                            type: "finished",
                            action: this,
                            direction: t1 < 0 ? -1 : 1
                        });
                    }
                } else {
                    if (-1 === r && (t1 >= 0 ? (r = 0, this._setEndings(!0, 0 === this.repetitions, a)) : this._setEndings(0 === this.repetitions, !0, a)), n >= e || n < 0) {
                        const i = Math.floor(n / e);
                        n -= e * i, r += Math.abs(i);
                        const s = this.repetitions - r;
                        if (s <= 0) this.clampWhenFinished ? this.paused = !0 : this.enabled = !1, n = t1 > 0 ? e : 0, this.time = n, this._mixer.dispatchEvent({
                            type: "finished",
                            action: this,
                            direction: t1 > 0 ? 1 : -1
                        });
                        else {
                            if (1 === s) {
                                const e = t1 < 0;
                                this._setEndings(e, !e, a);
                            } else this._setEndings(!1, !1, a);
                            this._loopCount = r, this.time = n, this._mixer.dispatchEvent({
                                type: "loop",
                                action: this,
                                loopDelta: i
                            });
                        }
                    } else this.time = n;
                    if (a && !(1 & ~r)) return e - n;
                }
                return n;
            }
            _setEndings(t1, e, i) {
                const n = this._interpolantSettings;
                i ? (n.endingStart = Ss, n.endingEnd = Ss) : (n.endingStart = t1 ? this.zeroSlopeAtStart ? Ss : Is : Ns, n.endingEnd = e ? this.zeroSlopeAtEnd ? Ss : Is : Ns);
            }
            _scheduleFading(t1, e, i) {
                const n = this._mixer, r = n.time;
                let a = this._weightInterpolant;
                null === a && (a = n._lendControlInterpolant(), this._weightInterpolant = a);
                const s = a.parameterPositions, o = a.sampleValues;
                return s[0] = r, o[0] = e, s[1] = r + t1, o[1] = i, this;
            }
        }
        const _M = new Float32Array(1);
        class IM extends Po {
            constructor(t1){
                super(), this._root = t1, this._initMemoryManager(), this._accuIndex = 0, this.time = 0, this.timeScale = 1;
            }
            _bindAction(t1, e) {
                const i = t1._localRoot || this._root, n = t1._clip.tracks, r = n.length, a = t1._propertyBindings, s = t1._interpolants, o = i.uuid, l = this._bindingsByRootAndName;
                let c = l[o];
                void 0 === c && (c = {}, l[o] = c);
                for(let t1 = 0; t1 !== r; ++t1){
                    const r = n[t1], l = r.name;
                    let u = c[l];
                    if (void 0 !== u) ++u.referenceCount, a[t1] = u;
                    else {
                        if (u = a[t1], void 0 !== u) {
                            null === u._cacheIndex && (++u.referenceCount, this._addInactiveBinding(u, o, l));
                            continue;
                        }
                        const n = e && e._propertyBindings[t1].binding.parsedPath;
                        u = new mM(bM.create(i, l, n), r.ValueTypeName, r.getValueSize()), ++u.referenceCount, this._addInactiveBinding(u, o, l), a[t1] = u;
                    }
                    s[t1].resultBuffer = u.buffer;
                }
            }
            _activateAction(t1) {
                if (!this._isActiveAction(t1)) {
                    if (null === t1._cacheIndex) {
                        const e = (t1._localRoot || this._root).uuid, i = t1._clip.uuid, n = this._actionsByClip[i];
                        this._bindAction(t1, n && n.knownActions[0]), this._addInactiveAction(t1, i, e);
                    }
                    const e = t1._propertyBindings;
                    for(let t1 = 0, i = e.length; t1 !== i; ++t1){
                        const i = e[t1];
                        0 == i.useCount++ && (this._lendBinding(i), i.saveOriginalState());
                    }
                    this._lendAction(t1);
                }
            }
            _deactivateAction(t1) {
                if (this._isActiveAction(t1)) {
                    const e = t1._propertyBindings;
                    for(let t1 = 0, i = e.length; t1 !== i; ++t1){
                        const i = e[t1];
                        0 == --i.useCount && (i.restoreOriginalState(), this._takeBackBinding(i));
                    }
                    this._takeBackAction(t1);
                }
            }
            _initMemoryManager() {
                this._actions = [], this._nActiveActions = 0, this._actionsByClip = {}, this._bindings = [], this._nActiveBindings = 0, this._bindingsByRootAndName = {}, this._controlInterpolants = [], this._nActiveControlInterpolants = 0;
                const t1 = this;
                this.stats = {
                    actions: {
                        get total () {
                            return t1._actions.length;
                        },
                        get inUse () {
                            return t1._nActiveActions;
                        }
                    },
                    bindings: {
                        get total () {
                            return t1._bindings.length;
                        },
                        get inUse () {
                            return t1._nActiveBindings;
                        }
                    },
                    controlInterpolants: {
                        get total () {
                            return t1._controlInterpolants.length;
                        },
                        get inUse () {
                            return t1._nActiveControlInterpolants;
                        }
                    }
                };
            }
            _isActiveAction(t1) {
                const e = t1._cacheIndex;
                return null !== e && e < this._nActiveActions;
            }
            _addInactiveAction(t1, e, i) {
                const n = this._actions, r = this._actionsByClip;
                let a = r[e];
                if (void 0 === a) a = {
                    knownActions: [
                        t1
                    ],
                    actionByRoot: {}
                }, t1._byClipCacheIndex = 0, r[e] = a;
                else {
                    const e = a.knownActions;
                    t1._byClipCacheIndex = e.length, e.push(t1);
                }
                t1._cacheIndex = n.length, n.push(t1), a.actionByRoot[i] = t1;
            }
            _removeInactiveAction(t1) {
                const e = this._actions, i = e[e.length - 1], n = t1._cacheIndex;
                i._cacheIndex = n, e[n] = i, e.pop(), t1._cacheIndex = null;
                const r = t1._clip.uuid, a = this._actionsByClip, s = a[r], o = s.knownActions, l = o[o.length - 1], c = t1._byClipCacheIndex;
                l._byClipCacheIndex = c, o[c] = l, o.pop(), t1._byClipCacheIndex = null, delete s.actionByRoot[(t1._localRoot || this._root).uuid], 0 === o.length && delete a[r], this._removeInactiveBindingsForAction(t1);
            }
            _removeInactiveBindingsForAction(t1) {
                const e = t1._propertyBindings;
                for(let t1 = 0, i = e.length; t1 !== i; ++t1){
                    const i = e[t1];
                    0 == --i.referenceCount && this._removeInactiveBinding(i);
                }
            }
            _lendAction(t1) {
                const e = this._actions, i = t1._cacheIndex, n = this._nActiveActions++, r = e[n];
                t1._cacheIndex = n, e[n] = t1, r._cacheIndex = i, e[i] = r;
            }
            _takeBackAction(t1) {
                const e = this._actions, i = t1._cacheIndex, n = --this._nActiveActions, r = e[n];
                t1._cacheIndex = n, e[n] = t1, r._cacheIndex = i, e[i] = r;
            }
            _addInactiveBinding(t1, e, i) {
                const n = this._bindingsByRootAndName, r = this._bindings;
                let a = n[e];
                void 0 === a && (a = {}, n[e] = a), a[i] = t1, t1._cacheIndex = r.length, r.push(t1);
            }
            _removeInactiveBinding(t1) {
                const e = this._bindings, i = t1.binding, n = i.rootNode.uuid, r = i.path, a = this._bindingsByRootAndName, s = a[n], o = e[e.length - 1], l = t1._cacheIndex;
                o._cacheIndex = l, e[l] = o, e.pop(), delete s[r], 0 === Object.keys(s).length && delete a[n];
            }
            _lendBinding(t1) {
                const e = this._bindings, i = t1._cacheIndex, n = this._nActiveBindings++, r = e[n];
                t1._cacheIndex = n, e[n] = t1, r._cacheIndex = i, e[i] = r;
            }
            _takeBackBinding(t1) {
                const e = this._bindings, i = t1._cacheIndex, n = --this._nActiveBindings, r = e[n];
                t1._cacheIndex = n, e[n] = t1, r._cacheIndex = i, e[i] = r;
            }
            _lendControlInterpolant() {
                const t1 = this._controlInterpolants, e = this._nActiveControlInterpolants++;
                let i = t1[e];
                return void 0 === i && (i = new qm(new Float32Array(2), new Float32Array(2), 1, _M), i.__cacheIndex = e, t1[e] = i), i;
            }
            _takeBackControlInterpolant(t1) {
                const e = this._controlInterpolants, i = t1.__cacheIndex, n = --this._nActiveControlInterpolants, r = e[n];
                t1.__cacheIndex = n, e[n] = t1, r.__cacheIndex = i, e[i] = r;
            }
            clipAction(t1, e, i) {
                const n = e || this._root, r = n.uuid;
                let a = "string" == typeof t1 ? sg.findByName(n, t1) : t1;
                const s = null !== a ? a.uuid : t1, o = this._actionsByClip[s];
                let l = null;
                if (void 0 === i && (i = null !== a ? a.blendMode : Ds), void 0 !== o) {
                    const t1 = o.actionByRoot[r];
                    if (void 0 !== t1 && t1.blendMode === i) return t1;
                    l = o.knownActions[0], null === a && (a = l._clip);
                }
                if (null === a) return null;
                const c = new EM(this, a, e, i);
                return this._bindAction(c, l), this._addInactiveAction(c, s, r), c;
            }
            existingAction(t1, e) {
                const i = e || this._root, n = i.uuid, r = "string" == typeof t1 ? sg.findByName(i, t1) : t1, a = r ? r.uuid : t1, s = this._actionsByClip[a];
                return void 0 !== s && s.actionByRoot[n] || null;
            }
            stopAllAction() {
                const t1 = this._actions;
                for(let e = this._nActiveActions - 1; e >= 0; --e)t1[e].stop();
                return this;
            }
            update(t1) {
                t1 *= this.timeScale;
                const e = this._actions, i = this._nActiveActions, n = this.time += t1, r = Math.sign(t1), a = this._accuIndex ^= 1;
                for(let s = 0; s !== i; ++s)e[s]._update(n, t1, r, a);
                const s = this._bindings, o = this._nActiveBindings;
                for(let t1 = 0; t1 !== o; ++t1)s[t1].apply(a);
                return this;
            }
            setTime(t1) {
                this.time = 0;
                for(let t1 = 0; t1 < this._actions.length; t1++)this._actions[t1].time = 0;
                return this.update(t1);
            }
            getRoot() {
                return this._root;
            }
            uncacheClip(t1) {
                const e = this._actions, i = t1.uuid, n = this._actionsByClip, r = n[i];
                if (void 0 !== r) {
                    const t1 = r.knownActions;
                    for(let i = 0, n = t1.length; i !== n; ++i){
                        const n = t1[i];
                        this._deactivateAction(n);
                        const r = n._cacheIndex, a = e[e.length - 1];
                        n._cacheIndex = null, n._byClipCacheIndex = null, a._cacheIndex = r, e[r] = a, e.pop(), this._removeInactiveBindingsForAction(n);
                    }
                    delete n[i];
                }
            }
            uncacheRoot(t1) {
                const e = t1.uuid, i = this._actionsByClip;
                for(const t1 in i){
                    const n = i[t1].actionByRoot[e];
                    void 0 !== n && (this._deactivateAction(n), this._removeInactiveAction(n));
                }
                const n = this._bindingsByRootAndName[e];
                if (void 0 !== n) for(const t1 in n){
                    const e = n[t1];
                    e.restoreOriginalState(), this._removeInactiveBinding(e);
                }
            }
            uncacheAction(t1, e) {
                const i = this.existingAction(t1, e);
                null !== i && (this._deactivateAction(i), this._removeInactiveAction(i));
            }
        }
        class SM {
            constructor(t1){
                this.value = t1;
            }
            clone() {
                return new SM(void 0 === this.value.clone ? this.value : this.value.clone());
            }
        }
        let NM = 0;
        class DM extends Po {
            constructor(){
                super(), this.isUniformsGroup = !0, Object.defineProperty(this, "id", {
                    value: NM++
                }), this.name = "", this.usage = xo, this.uniforms = [];
            }
            add(t1) {
                return this.uniforms.push(t1), this;
            }
            remove(t1) {
                const e = this.uniforms.indexOf(t1);
                return -1 !== e && this.uniforms.splice(e, 1), this;
            }
            setName(t1) {
                return this.name = t1, this;
            }
            setUsage(t1) {
                return this.usage = t1, this;
            }
            dispose() {
                return this.dispatchEvent({
                    type: "dispose"
                }), this;
            }
            copy(t1) {
                this.name = t1.name, this.usage = t1.usage;
                const e = t1.uniforms;
                this.uniforms.length = 0;
                for(let t1 = 0, i = e.length; t1 < i; t1++)this.uniforms.push(e[t1].clone());
                return this;
            }
            clone() {
                return (new this.constructor).copy(this);
            }
        }
        class CM extends Yp {
            constructor(t1, e, i = 1){
                super(t1, e), this.isInstancedInterleavedBuffer = !0, this.meshPerAttribute = i;
            }
            copy(t1) {
                return super.copy(t1), this.meshPerAttribute = t1.meshPerAttribute, this;
            }
            clone(t1) {
                const e = super.clone(t1);
                return e.meshPerAttribute = this.meshPerAttribute, e;
            }
            toJSON(t1) {
                const e = super.toJSON(t1);
                return e.isInstancedInterleavedBuffer = !0, e.meshPerAttribute = this.meshPerAttribute, e;
            }
        }
        class zM {
            constructor(t1, e, i, n, r){
                this.isGLBufferAttribute = !0, this.name = "", this.buffer = t1, this.type = e, this.itemSize = i, this.elementSize = n, this.count = r, this.version = 0;
            }
            set needsUpdate(t1) {
                !0 === t1 && this.version++;
            }
            setBuffer(t1) {
                return this.buffer = t1, this;
            }
            setType(t1, e) {
                return this.type = t1, this.elementSize = e, this;
            }
            setItemSize(t1) {
                return this.itemSize = t1, this;
            }
            setCount(t1) {
                return this.count = t1, this;
            }
        }
        class LM {
            constructor(t1, e, i = 0, n = 1 / 0){
                this.ray = new rc(t1, e), this.near = i, this.far = n, this.camera = null, this.layers = new mc, this.params = {
                    Mesh: {},
                    Line: {
                        threshold: 1
                    },
                    LOD: {},
                    Points: {
                        threshold: 1
                    },
                    Sprite: {}
                };
            }
            set(t1, e) {
                this.ray.set(t1, e);
            }
            setFromCamera(t1, e) {
                e.isPerspectiveCamera ? (this.ray.origin.setFromMatrixPosition(e.matrixWorld), this.ray.direction.set(t1.x, t1.y, .5).unproject(e).sub(this.ray.origin).normalize(), this.camera = e) : e.isOrthographicCamera ? (this.ray.origin.set(t1.x, t1.y, (e.near + e.far) / (e.near - e.far)).unproject(e), this.ray.direction.set(0, 0, -1).transformDirection(e.matrixWorld), this.camera = e) : console.error("THREE.Raycaster: Unsupported camera type: " + e.type);
            }
            intersectObject(t1, e = !0, i = []) {
                return PM(t1, this, i, e), i.sort(OM), i;
            }
            intersectObjects(t1, e = !0, i = []) {
                for(let n = 0, r = t1.length; n < r; n++)PM(t1[n], this, i, e);
                return i.sort(OM), i;
            }
        }
        function OM(t1, e) {
            return t1.distance - e.distance;
        }
        function PM(t1, e, i, n) {
            if (t1.layers.test(e.layers) && t1.raycast(e, i), !0 === n) {
                const n = t1.children;
                for(let t1 = 0, r = n.length; t1 < r; t1++)PM(n[t1], e, i, !0);
            }
        }
        class jM {
            constructor(t1 = 1, e = 0, i = 0){
                return this.radius = t1, this.phi = e, this.theta = i, this;
            }
            set(t1, e, i) {
                return this.radius = t1, this.phi = e, this.theta = i, this;
            }
            copy(t1) {
                return this.radius = t1.radius, this.phi = t1.phi, this.theta = t1.theta, this;
            }
            makeSafe() {
                const t1 = 1e-6;
                return this.phi = Math.max(t1, Math.min(Math.PI - t1, this.phi)), this;
            }
            setFromVector3(t1) {
                return this.setFromCartesianCoords(t1.x, t1.y, t1.z);
            }
            setFromCartesianCoords(t1, e, i) {
                return this.radius = Math.sqrt(t1 * t1 + e * e + i * i), 0 === this.radius ? (this.theta = 0, this.phi = 0) : (this.theta = Math.atan2(t1, i), this.phi = Math.acos(Fo(e / this.radius, -1, 1))), this;
            }
            clone() {
                return (new this.constructor).copy(this);
            }
        }
        class RM {
            constructor(t1 = 1, e = 0, i = 0){
                return this.radius = t1, this.theta = e, this.y = i, this;
            }
            set(t1, e, i) {
                return this.radius = t1, this.theta = e, this.y = i, this;
            }
            copy(t1) {
                return this.radius = t1.radius, this.theta = t1.theta, this.y = t1.y, this;
            }
            setFromVector3(t1) {
                return this.setFromCartesianCoords(t1.x, t1.y, t1.z);
            }
            setFromCartesianCoords(t1, e, i) {
                return this.radius = Math.sqrt(t1 * t1 + i * i), this.theta = Math.atan2(t1, i), this.y = e, this;
            }
            clone() {
                return (new this.constructor).copy(this);
            }
        }
        const kM = new qo;
        class UM {
            constructor(t1 = new qo(1 / 0, 1 / 0), e = new qo(-1 / 0, -1 / 0)){
                this.isBox2 = !0, this.min = t1, this.max = e;
            }
            set(t1, e) {
                return this.min.copy(t1), this.max.copy(e), this;
            }
            setFromPoints(t1) {
                this.makeEmpty();
                for(let e = 0, i = t1.length; e < i; e++)this.expandByPoint(t1[e]);
                return this;
            }
            setFromCenterAndSize(t1, e) {
                const i = kM.copy(e).multiplyScalar(.5);
                return this.min.copy(t1).sub(i), this.max.copy(t1).add(i), this;
            }
            clone() {
                return (new this.constructor).copy(this);
            }
            copy(t1) {
                return this.min.copy(t1.min), this.max.copy(t1.max), this;
            }
            makeEmpty() {
                return this.min.x = this.min.y = 1 / 0, this.max.x = this.max.y = -1 / 0, this;
            }
            isEmpty() {
                return this.max.x < this.min.x || this.max.y < this.min.y;
            }
            getCenter(t1) {
                return this.isEmpty() ? t1.set(0, 0) : t1.addVectors(this.min, this.max).multiplyScalar(.5);
            }
            getSize(t1) {
                return this.isEmpty() ? t1.set(0, 0) : t1.subVectors(this.max, this.min);
            }
            expandByPoint(t1) {
                return this.min.min(t1), this.max.max(t1), this;
            }
            expandByVector(t1) {
                return this.min.sub(t1), this.max.add(t1), this;
            }
            expandByScalar(t1) {
                return this.min.addScalar(-t1), this.max.addScalar(t1), this;
            }
            containsPoint(t1) {
                return !(t1.x < this.min.x || t1.x > this.max.x || t1.y < this.min.y || t1.y > this.max.y);
            }
            containsBox(t1) {
                return this.min.x <= t1.min.x && t1.max.x <= this.max.x && this.min.y <= t1.min.y && t1.max.y <= this.max.y;
            }
            getParameter(t1, e) {
                return e.set((t1.x - this.min.x) / (this.max.x - this.min.x), (t1.y - this.min.y) / (this.max.y - this.min.y));
            }
            intersectsBox(t1) {
                return !(t1.max.x < this.min.x || t1.min.x > this.max.x || t1.max.y < this.min.y || t1.min.y > this.max.y);
            }
            clampPoint(t1, e) {
                return e.copy(t1).clamp(this.min, this.max);
            }
            distanceToPoint(t1) {
                return this.clampPoint(t1, kM).distanceTo(t1);
            }
            intersect(t1) {
                return this.min.max(t1.min), this.max.min(t1.max), this.isEmpty() && this.makeEmpty(), this;
            }
            union(t1) {
                return this.min.min(t1.min), this.max.max(t1.max), this;
            }
            translate(t1) {
                return this.min.add(t1), this.max.add(t1), this;
            }
            equals(t1) {
                return t1.min.equals(this.min) && t1.max.equals(this.max);
            }
        }
        const BM = new Nl, FM = new Nl;
        class QM {
            constructor(t1 = new Nl, e = new Nl){
                this.start = t1, this.end = e;
            }
            set(t1, e) {
                return this.start.copy(t1), this.end.copy(e), this;
            }
            copy(t1) {
                return this.start.copy(t1.start), this.end.copy(t1.end), this;
            }
            getCenter(t1) {
                return t1.addVectors(this.start, this.end).multiplyScalar(.5);
            }
            delta(t1) {
                return t1.subVectors(this.end, this.start);
            }
            distanceSq() {
                return this.start.distanceToSquared(this.end);
            }
            distance() {
                return this.start.distanceTo(this.end);
            }
            at(t1, e) {
                return this.delta(e).multiplyScalar(t1).add(this.start);
            }
            closestPointToPointParameter(t1, e) {
                BM.subVectors(t1, this.start), FM.subVectors(this.end, this.start);
                const i = FM.dot(FM);
                let n = FM.dot(BM) / i;
                return e && (n = Fo(n, 0, 1)), n;
            }
            closestPointToPoint(t1, e, i) {
                const n = this.closestPointToPointParameter(t1, e);
                return this.delta(i).multiplyScalar(n).add(this.start);
            }
            applyMatrix4(t1) {
                return this.start.applyMatrix4(t1), this.end.applyMatrix4(t1), this;
            }
            equals(t1) {
                return t1.start.equals(this.start) && t1.end.equals(this.end);
            }
            clone() {
                return (new this.constructor).copy(this);
            }
        }
        const HM = new Nl;
        class VM extends Dc {
            constructor(t1, e){
                super(), this.light = t1, this.matrix = t1.matrixWorld, this.matrixAutoUpdate = !1, this.color = e, this.type = "SpotLightHelper";
                const i = new bu, n = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    1,
                    0,
                    1,
                    0,
                    0,
                    0,
                    -1,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    0,
                    0,
                    0,
                    0,
                    -1,
                    1
                ];
                for(let t1 = 0, e = 1, i = 32; t1 < i; t1++, e++){
                    const r = t1 / i * Math.PI * 2, a = e / i * Math.PI * 2;
                    n.push(Math.cos(r), Math.sin(r), 1, Math.cos(a), Math.sin(a), 1);
                }
                i.setAttribute("position", new Au(n, 3));
                const r = new UA({
                    fog: !1,
                    toneMapped: !1
                });
                this.cone = new XA(i, r), this.add(this.cone), this.update();
            }
            dispose() {
                this.cone.geometry.dispose(), this.cone.material.dispose();
            }
            update() {
                this.light.updateWorldMatrix(!0, !1), this.light.target.updateWorldMatrix(!0, !1);
                const t1 = this.light.distance ? this.light.distance : 1e3, e = t1 * Math.tan(this.light.angle);
                this.cone.scale.set(e, e, t1), HM.setFromMatrixPosition(this.light.target.matrixWorld), this.cone.lookAt(HM), void 0 !== this.color ? this.cone.material.color.set(this.color) : this.cone.material.color.copy(this.light.color);
            }
        }
        const GM = new Nl, WM = new ac, YM = new ac;
        class XM extends XA {
            constructor(t1){
                const e = ZM(t1), i = new bu, n = [], r = [], a = new Yc(0, 0, 1), s = new Yc(0, 1, 0);
                for(let t1 = 0; t1 < e.length; t1++){
                    const i = e[t1];
                    i.parent && i.parent.isBone && (n.push(0, 0, 0), n.push(0, 0, 0), r.push(a.r, a.g, a.b), r.push(s.r, s.g, s.b));
                }
                i.setAttribute("position", new Au(n, 3)), i.setAttribute("color", new Au(r, 3)), super(i, new UA({
                    vertexColors: !0,
                    depthTest: !1,
                    depthWrite: !1,
                    toneMapped: !1,
                    transparent: !0
                })), this.isSkeletonHelper = !0, this.type = "SkeletonHelper", this.root = t1, this.bones = e, this.matrix = t1.matrixWorld, this.matrixAutoUpdate = !1;
            }
            updateMatrixWorld(t1) {
                const e = this.bones, i = this.geometry, n = i.getAttribute("position");
                YM.copy(this.root.matrixWorld).invert();
                for(let t1 = 0, i = 0; t1 < e.length; t1++){
                    const r = e[t1];
                    r.parent && r.parent.isBone && (WM.multiplyMatrices(YM, r.matrixWorld), GM.setFromMatrixPosition(WM), n.setXYZ(i, GM.x, GM.y, GM.z), WM.multiplyMatrices(YM, r.parent.matrixWorld), GM.setFromMatrixPosition(WM), n.setXYZ(i + 1, GM.x, GM.y, GM.z), i += 2);
                }
                i.getAttribute("position").needsUpdate = !0, super.updateMatrixWorld(t1);
            }
            dispose() {
                this.geometry.dispose(), this.material.dispose();
            }
        }
        function ZM(t1) {
            const e = [];
            !0 === t1.isBone && e.push(t1);
            for(let i = 0; i < t1.children.length; i++)e.push.apply(e, ZM(t1.children[i]));
            return e;
        }
        class qM extends Fu {
            constructor(t1, e, i){
                super(new Tm(e, 4, 2), new Jc({
                    wireframe: !0,
                    fog: !1,
                    toneMapped: !1
                })), this.light = t1, this.color = i, this.type = "PointLightHelper", this.matrix = this.light.matrixWorld, this.matrixAutoUpdate = !1, this.update();
            }
            dispose() {
                this.geometry.dispose(), this.material.dispose();
            }
            update() {
                this.light.updateWorldMatrix(!0, !1), void 0 !== this.color ? this.material.color.set(this.color) : this.material.color.copy(this.light.color);
            }
        }
        const JM = new Nl, KM = new Yc, $M = new Yc;
        class tv extends Dc {
            constructor(t1, e, i){
                super(), this.light = t1, this.matrix = t1.matrixWorld, this.matrixAutoUpdate = !1, this.color = i, this.type = "HemisphereLightHelper";
                const n = new xm(e);
                n.rotateY(.5 * Math.PI), this.material = new Jc({
                    wireframe: !0,
                    fog: !1,
                    toneMapped: !1
                }), void 0 === this.color && (this.material.vertexColors = !0);
                const r = n.getAttribute("position"), a = new Float32Array(3 * r.count);
                n.setAttribute("color", new au(a, 3)), this.add(new Fu(n, this.material)), this.update();
            }
            dispose() {
                this.children[0].geometry.dispose(), this.children[0].material.dispose();
            }
            update() {
                const t1 = this.children[0];
                if (void 0 !== this.color) this.material.color.set(this.color);
                else {
                    const e = t1.geometry.getAttribute("color");
                    KM.copy(this.light.color), $M.copy(this.light.groundColor);
                    for(let t1 = 0, i = e.count; t1 < i; t1++){
                        const n = t1 < i / 2 ? KM : $M;
                        e.setXYZ(t1, n.r, n.g, n.b);
                    }
                    e.needsUpdate = !0;
                }
                this.light.updateWorldMatrix(!0, !1), t1.lookAt(JM.setFromMatrixPosition(this.light.matrixWorld).negate());
            }
        }
        class ev extends XA {
            constructor(t1 = 10, e = 10, i = 4473924, n = 8947848){
                i = new Yc(i), n = new Yc(n);
                const r = e / 2, a = t1 / e, s = t1 / 2, o = [], l = [];
                for(let t1 = 0, c = 0, u = -s; t1 <= e; t1++, u += a){
                    o.push(-s, 0, u, s, 0, u), o.push(u, 0, -s, u, 0, s);
                    const e = t1 === r ? i : n;
                    e.toArray(l, c), c += 3, e.toArray(l, c), c += 3, e.toArray(l, c), c += 3, e.toArray(l, c), c += 3;
                }
                const c = new bu;
                c.setAttribute("position", new Au(o, 3)), c.setAttribute("color", new Au(l, 3)), super(c, new UA({
                    vertexColors: !0,
                    toneMapped: !1
                })), this.type = "GridHelper";
            }
            dispose() {
                this.geometry.dispose(), this.material.dispose();
            }
        }
        class iv extends XA {
            constructor(t1 = 10, e = 16, i = 8, n = 64, r = 4473924, a = 8947848){
                r = new Yc(r), a = new Yc(a);
                const s = [], o = [];
                if (e > 1) for(let i = 0; i < e; i++){
                    const n = i / e * (2 * Math.PI), l = Math.sin(n) * t1, c = Math.cos(n) * t1;
                    s.push(0, 0, 0), s.push(l, 0, c);
                    const u = 1 & i ? r : a;
                    o.push(u.r, u.g, u.b), o.push(u.r, u.g, u.b);
                }
                for(let e = 0; e < i; e++){
                    const l = 1 & e ? r : a, c = t1 - t1 / i * e;
                    for(let t1 = 0; t1 < n; t1++){
                        let e = t1 / n * (2 * Math.PI), i = Math.sin(e) * c, r = Math.cos(e) * c;
                        s.push(i, 0, r), o.push(l.r, l.g, l.b), e = (t1 + 1) / n * (2 * Math.PI), i = Math.sin(e) * c, r = Math.cos(e) * c, s.push(i, 0, r), o.push(l.r, l.g, l.b);
                    }
                }
                const l = new bu;
                l.setAttribute("position", new Au(s, 3)), l.setAttribute("color", new Au(o, 3)), super(l, new UA({
                    vertexColors: !0,
                    toneMapped: !1
                })), this.type = "PolarGridHelper";
            }
            dispose() {
                this.geometry.dispose(), this.material.dispose();
            }
        }
        const nv = new Nl, rv = new Nl, av = new Nl;
        class sv extends Dc {
            constructor(t1, e, i){
                super(), this.light = t1, this.matrix = t1.matrixWorld, this.matrixAutoUpdate = !1, this.color = i, this.type = "DirectionalLightHelper", void 0 === e && (e = 1);
                let n = new bu;
                n.setAttribute("position", new Au([
                    -e,
                    e,
                    0,
                    e,
                    e,
                    0,
                    e,
                    -e,
                    0,
                    -e,
                    -e,
                    0,
                    -e,
                    e,
                    0
                ], 3));
                const r = new UA({
                    fog: !1,
                    toneMapped: !1
                });
                this.lightPlane = new GA(n, r), this.add(this.lightPlane), n = new bu, n.setAttribute("position", new Au([
                    0,
                    0,
                    0,
                    0,
                    0,
                    1
                ], 3)), this.targetLine = new GA(n, r), this.add(this.targetLine), this.update();
            }
            dispose() {
                this.lightPlane.geometry.dispose(), this.lightPlane.material.dispose(), this.targetLine.geometry.dispose(), this.targetLine.material.dispose();
            }
            update() {
                this.light.updateWorldMatrix(!0, !1), this.light.target.updateWorldMatrix(!0, !1), nv.setFromMatrixPosition(this.light.matrixWorld), rv.setFromMatrixPosition(this.light.target.matrixWorld), av.subVectors(rv, nv), this.lightPlane.lookAt(rv), void 0 !== this.color ? (this.lightPlane.material.color.set(this.color), this.targetLine.material.color.set(this.color)) : (this.lightPlane.material.color.copy(this.light.color), this.targetLine.material.color.copy(this.light.color)), this.targetLine.lookAt(rv), this.targetLine.scale.z = av.length();
            }
        }
        const ov = new Nl, lv = new Zu;
        class cv extends XA {
            constructor(t1){
                const e = new bu, i = new UA({
                    color: 16777215,
                    vertexColors: !0,
                    toneMapped: !1
                }), n = [], r = [], a = {};
                function s(t1, e) {
                    o(t1), o(e);
                }
                function o(t1) {
                    n.push(0, 0, 0), r.push(0, 0, 0), void 0 === a[t1] && (a[t1] = []), a[t1].push(n.length / 3 - 1);
                }
                s("n1", "n2"), s("n2", "n4"), s("n4", "n3"), s("n3", "n1"), s("f1", "f2"), s("f2", "f4"), s("f4", "f3"), s("f3", "f1"), s("n1", "f1"), s("n2", "f2"), s("n3", "f3"), s("n4", "f4"), s("p", "n1"), s("p", "n2"), s("p", "n3"), s("p", "n4"), s("u1", "u2"), s("u2", "u3"), s("u3", "u1"), s("c", "t"), s("p", "c"), s("cn1", "cn2"), s("cn3", "cn4"), s("cf1", "cf2"), s("cf3", "cf4"), e.setAttribute("position", new Au(n, 3)), e.setAttribute("color", new Au(r, 3)), super(e, i), this.type = "CameraHelper", this.camera = t1, this.camera.updateProjectionMatrix && this.camera.updateProjectionMatrix(), this.matrix = t1.matrixWorld, this.matrixAutoUpdate = !1, this.pointMap = a, this.update();
                const l = new Yc(16755200), c = new Yc(16711680), u = new Yc(43775), h = new Yc(16777215), d = new Yc(3355443);
                this.setColors(l, c, u, h, d);
            }
            setColors(t1, e, i, n, r) {
                const a = this.geometry.getAttribute("color");
                a.setXYZ(0, t1.r, t1.g, t1.b), a.setXYZ(1, t1.r, t1.g, t1.b), a.setXYZ(2, t1.r, t1.g, t1.b), a.setXYZ(3, t1.r, t1.g, t1.b), a.setXYZ(4, t1.r, t1.g, t1.b), a.setXYZ(5, t1.r, t1.g, t1.b), a.setXYZ(6, t1.r, t1.g, t1.b), a.setXYZ(7, t1.r, t1.g, t1.b), a.setXYZ(8, t1.r, t1.g, t1.b), a.setXYZ(9, t1.r, t1.g, t1.b), a.setXYZ(10, t1.r, t1.g, t1.b), a.setXYZ(11, t1.r, t1.g, t1.b), a.setXYZ(12, t1.r, t1.g, t1.b), a.setXYZ(13, t1.r, t1.g, t1.b), a.setXYZ(14, t1.r, t1.g, t1.b), a.setXYZ(15, t1.r, t1.g, t1.b), a.setXYZ(16, t1.r, t1.g, t1.b), a.setXYZ(17, t1.r, t1.g, t1.b), a.setXYZ(18, t1.r, t1.g, t1.b), a.setXYZ(19, t1.r, t1.g, t1.b), a.setXYZ(20, t1.r, t1.g, t1.b), a.setXYZ(21, t1.r, t1.g, t1.b), a.setXYZ(22, t1.r, t1.g, t1.b), a.setXYZ(23, t1.r, t1.g, t1.b), a.setXYZ(24, e.r, e.g, e.b), a.setXYZ(25, e.r, e.g, e.b), a.setXYZ(26, e.r, e.g, e.b), a.setXYZ(27, e.r, e.g, e.b), a.setXYZ(28, e.r, e.g, e.b), a.setXYZ(29, e.r, e.g, e.b), a.setXYZ(30, e.r, e.g, e.b), a.setXYZ(31, e.r, e.g, e.b), a.setXYZ(32, i.r, i.g, i.b), a.setXYZ(33, i.r, i.g, i.b), a.setXYZ(34, i.r, i.g, i.b), a.setXYZ(35, i.r, i.g, i.b), a.setXYZ(36, i.r, i.g, i.b), a.setXYZ(37, i.r, i.g, i.b), a.setXYZ(38, n.r, n.g, n.b), a.setXYZ(39, n.r, n.g, n.b), a.setXYZ(40, r.r, r.g, r.b), a.setXYZ(41, r.r, r.g, r.b), a.setXYZ(42, r.r, r.g, r.b), a.setXYZ(43, r.r, r.g, r.b), a.setXYZ(44, r.r, r.g, r.b), a.setXYZ(45, r.r, r.g, r.b), a.setXYZ(46, r.r, r.g, r.b), a.setXYZ(47, r.r, r.g, r.b), a.setXYZ(48, r.r, r.g, r.b), a.setXYZ(49, r.r, r.g, r.b), a.needsUpdate = !0;
            }
            update() {
                const t1 = this.geometry, e = this.pointMap;
                lv.projectionMatrixInverse.copy(this.camera.projectionMatrixInverse), uv("c", e, t1, lv, 0, 0, -1), uv("t", e, t1, lv, 0, 0, 1), uv("n1", e, t1, lv, -1, -1, -1), uv("n2", e, t1, lv, 1, -1, -1), uv("n3", e, t1, lv, -1, 1, -1), uv("n4", e, t1, lv, 1, 1, -1), uv("f1", e, t1, lv, -1, -1, 1), uv("f2", e, t1, lv, 1, -1, 1), uv("f3", e, t1, lv, -1, 1, 1), uv("f4", e, t1, lv, 1, 1, 1), uv("u1", e, t1, lv, .7, 1.1, -1), uv("u2", e, t1, lv, -0.7, 1.1, -1), uv("u3", e, t1, lv, 0, 2, -1), uv("cf1", e, t1, lv, -1, 0, 1), uv("cf2", e, t1, lv, 1, 0, 1), uv("cf3", e, t1, lv, 0, -1, 1), uv("cf4", e, t1, lv, 0, 1, 1), uv("cn1", e, t1, lv, -1, 0, -1), uv("cn2", e, t1, lv, 1, 0, -1), uv("cn3", e, t1, lv, 0, -1, -1), uv("cn4", e, t1, lv, 0, 1, -1), t1.getAttribute("position").needsUpdate = !0;
            }
            dispose() {
                this.geometry.dispose(), this.material.dispose();
            }
        }
        function uv(t1, e, i, n, r, a, s) {
            ov.set(r, a, s).unproject(n);
            const o = e[t1];
            if (void 0 !== o) {
                const t1 = i.getAttribute("position");
                for(let e = 0, i = o.length; e < i; e++)t1.setXYZ(o[e], ov.x, ov.y, ov.z);
            }
        }
        const hv = new zl;
        class dv extends XA {
            constructor(t1, e = 16776960){
                const i = new Uint16Array([
                    0,
                    1,
                    1,
                    2,
                    2,
                    3,
                    3,
                    0,
                    4,
                    5,
                    5,
                    6,
                    6,
                    7,
                    7,
                    4,
                    0,
                    4,
                    1,
                    5,
                    2,
                    6,
                    3,
                    7
                ]), n = new Float32Array(24), r = new bu;
                r.setIndex(new au(i, 1)), r.setAttribute("position", new au(n, 3)), super(r, new UA({
                    color: e,
                    toneMapped: !1
                })), this.object = t1, this.type = "BoxHelper", this.matrixAutoUpdate = !1, this.update();
            }
            update(t1) {
                if (void 0 !== t1 && console.warn("THREE.BoxHelper: .update() has no longer arguments."), void 0 !== this.object && hv.setFromObject(this.object), hv.isEmpty()) return;
                const e = hv.min, i = hv.max, n = this.geometry.attributes.position, r = n.array;
                r[0] = i.x, r[1] = i.y, r[2] = i.z, r[3] = e.x, r[4] = i.y, r[5] = i.z, r[6] = e.x, r[7] = e.y, r[8] = i.z, r[9] = i.x, r[10] = e.y, r[11] = i.z, r[12] = i.x, r[13] = i.y, r[14] = e.z, r[15] = e.x, r[16] = i.y, r[17] = e.z, r[18] = e.x, r[19] = e.y, r[20] = e.z, r[21] = i.x, r[22] = e.y, r[23] = e.z, n.needsUpdate = !0, this.geometry.computeBoundingSphere();
            }
            setFromObject(t1) {
                return this.object = t1, this.update(), this;
            }
            copy(t1, e) {
                return super.copy(t1, e), this.object = t1.object, this;
            }
            dispose() {
                this.geometry.dispose(), this.material.dispose();
            }
        }
        class pv extends XA {
            constructor(t1, e = 16776960){
                const i = new Uint16Array([
                    0,
                    1,
                    1,
                    2,
                    2,
                    3,
                    3,
                    0,
                    4,
                    5,
                    5,
                    6,
                    6,
                    7,
                    7,
                    4,
                    0,
                    4,
                    1,
                    5,
                    2,
                    6,
                    3,
                    7
                ]), n = new bu;
                n.setIndex(new au(i, 1)), n.setAttribute("position", new Au([
                    1,
                    1,
                    1,
                    -1,
                    1,
                    1,
                    -1,
                    -1,
                    1,
                    1,
                    -1,
                    1,
                    1,
                    1,
                    -1,
                    -1,
                    1,
                    -1,
                    -1,
                    -1,
                    -1,
                    1,
                    -1,
                    -1
                ], 3)), super(n, new UA({
                    color: e,
                    toneMapped: !1
                })), this.box = t1, this.type = "Box3Helper", this.geometry.computeBoundingSphere();
            }
            updateMatrixWorld(t1) {
                const e = this.box;
                e.isEmpty() || (e.getCenter(this.position), e.getSize(this.scale), this.scale.multiplyScalar(.5), super.updateMatrixWorld(t1));
            }
            dispose() {
                this.geometry.dispose(), this.material.dispose();
            }
        }
        class Av extends GA {
            constructor(t1, e = 1, i = 16776960){
                const n = i, r = new bu;
                r.setAttribute("position", new Au([
                    1,
                    -1,
                    0,
                    -1,
                    1,
                    0,
                    -1,
                    -1,
                    0,
                    1,
                    1,
                    0,
                    -1,
                    1,
                    0,
                    -1,
                    -1,
                    0,
                    1,
                    -1,
                    0,
                    1,
                    1,
                    0
                ], 3)), r.computeBoundingSphere(), super(r, new UA({
                    color: n,
                    toneMapped: !1
                })), this.type = "PlaneHelper", this.plane = t1, this.size = e;
                const a = new bu;
                a.setAttribute("position", new Au([
                    1,
                    1,
                    0,
                    -1,
                    1,
                    0,
                    -1,
                    -1,
                    0,
                    1,
                    1,
                    0,
                    -1,
                    -1,
                    0,
                    1,
                    -1,
                    0
                ], 3)), a.computeBoundingSphere(), this.add(new Fu(a, new Jc({
                    color: n,
                    opacity: .2,
                    transparent: !0,
                    depthWrite: !1,
                    toneMapped: !1
                })));
            }
            updateMatrixWorld(t1) {
                this.position.set(0, 0, 0), this.scale.set(.5 * this.size, .5 * this.size, 1), this.lookAt(this.plane.normal), this.translateZ(-this.plane.constant), super.updateMatrixWorld(t1);
            }
            dispose() {
                this.geometry.dispose(), this.material.dispose(), this.children[0].geometry.dispose(), this.children[0].material.dispose();
            }
        }
        const fv = new Nl;
        let mv, gv;
        class Mv extends Dc {
            constructor(t1 = new Nl(0, 0, 1), e = new Nl(0, 0, 0), i = 1, n = 16776960, r = .2 * i, a = .2 * r){
                super(), this.type = "ArrowHelper", void 0 === mv && (mv = new bu, mv.setAttribute("position", new Au([
                    0,
                    0,
                    0,
                    0,
                    1,
                    0
                ], 3)), gv = new Pf(0, .5, 1, 5, 1), gv.translate(0, -0.5, 0)), this.position.copy(e), this.line = new GA(mv, new UA({
                    color: n,
                    toneMapped: !1
                })), this.line.matrixAutoUpdate = !1, this.add(this.line), this.cone = new Fu(gv, new Jc({
                    color: n,
                    toneMapped: !1
                })), this.cone.matrixAutoUpdate = !1, this.add(this.cone), this.setDirection(t1), this.setLength(i, r, a);
            }
            setDirection(t1) {
                if (t1.y > .99999) this.quaternion.set(0, 0, 0, 1);
                else if (t1.y < -0.99999) this.quaternion.set(1, 0, 0, 0);
                else {
                    fv.set(t1.z, 0, -t1.x).normalize();
                    const e = Math.acos(t1.y);
                    this.quaternion.setFromAxisAngle(fv, e);
                }
            }
            setLength(t1, e = .2 * t1, i = .2 * e) {
                this.line.scale.set(1, Math.max(1e-4, t1 - e), 1), this.line.updateMatrix(), this.cone.scale.set(i, e, i), this.cone.position.y = t1, this.cone.updateMatrix();
            }
            setColor(t1) {
                this.line.material.color.set(t1), this.cone.material.color.set(t1);
            }
            copy(t1) {
                return super.copy(t1, !1), this.line.copy(t1.line), this.cone.copy(t1.cone), this;
            }
            dispose() {
                this.line.geometry.dispose(), this.line.material.dispose(), this.cone.geometry.dispose(), this.cone.material.dispose();
            }
        }
        class vv extends XA {
            constructor(t1 = 1){
                const e = [
                    0,
                    0,
                    0,
                    t1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    t1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    t1
                ], i = new bu;
                i.setAttribute("position", new Au(e, 3)), i.setAttribute("color", new Au([
                    1,
                    0,
                    0,
                    1,
                    .6,
                    0,
                    0,
                    1,
                    0,
                    .6,
                    1,
                    0,
                    0,
                    0,
                    1,
                    0,
                    .6,
                    1
                ], 3)), super(i, new UA({
                    vertexColors: !0,
                    toneMapped: !1
                })), this.type = "AxesHelper";
            }
            setColors(t1, e, i) {
                const n = new Yc, r = this.geometry.attributes.color.array;
                return n.set(t1), n.toArray(r, 0), n.toArray(r, 3), n.set(e), n.toArray(r, 6), n.toArray(r, 9), n.set(i), n.toArray(r, 12), n.toArray(r, 15), this.geometry.attributes.color.needsUpdate = !0, this;
            }
            dispose() {
                this.geometry.dispose(), this.material.dispose();
            }
        }
        class yv {
            constructor(){
                this.type = "ShapePath", this.color = new Yc, this.subPaths = [], this.currentPath = null;
            }
            moveTo(t1, e) {
                return this.currentPath = new Cf, this.subPaths.push(this.currentPath), this.currentPath.moveTo(t1, e), this;
            }
            lineTo(t1, e) {
                return this.currentPath.lineTo(t1, e), this;
            }
            quadraticCurveTo(t1, e, i, n) {
                return this.currentPath.quadraticCurveTo(t1, e, i, n), this;
            }
            bezierCurveTo(t1, e, i, n, r, a) {
                return this.currentPath.bezierCurveTo(t1, e, i, n, r, a), this;
            }
            splineThru(t1) {
                return this.currentPath.splineThru(t1), this;
            }
            toShapes(t1) {
                function e(t1, e) {
                    const i = e.length;
                    let n = !1;
                    for(let r = i - 1, a = 0; a < i; r = a++){
                        let i = e[r], s = e[a], o = s.x - i.x, l = s.y - i.y;
                        if (Math.abs(l) > Number.EPSILON) {
                            if (l < 0 && (i = e[a], o = -o, s = e[r], l = -l), t1.y < i.y || t1.y > s.y) continue;
                            if (t1.y === i.y) {
                                if (t1.x === i.x) return !0;
                            } else {
                                const e = l * (t1.x - i.x) - o * (t1.y - i.y);
                                if (0 === e) return !0;
                                if (e < 0) continue;
                                n = !n;
                            }
                        } else {
                            if (t1.y !== i.y) continue;
                            if (s.x <= t1.x && t1.x <= i.x || i.x <= t1.x && t1.x <= s.x) return !0;
                        }
                    }
                    return n;
                }
                const i = fm.isClockWise, n = this.subPaths;
                if (0 === n.length) return [];
                let r, a, s;
                const o = [];
                if (1 === n.length) return a = n[0], s = new Vf, s.curves = a.curves, o.push(s), o;
                let l = !i(n[0].getPoints());
                l = t1 ? !l : l;
                const c = [], u = [];
                let h, d, p = [], A = 0;
                u[A] = void 0, p[A] = [];
                for(let e = 0, s = n.length; e < s; e++)a = n[e], h = a.getPoints(), r = i(h), r = t1 ? !r : r, r ? (!l && u[A] && A++, u[A] = {
                    s: new Vf,
                    p: h
                }, u[A].s.curves = a.curves, l && A++, p[A] = []) : p[A].push({
                    h: a,
                    p: h[0]
                });
                if (!u[0]) return function(t1) {
                    const e = [];
                    for(let i = 0, n = t1.length; i < n; i++){
                        const n = t1[i], r = new Vf;
                        r.curves = n.curves, e.push(r);
                    }
                    return e;
                }(n);
                if (u.length > 1) {
                    let t1 = !1, i = 0;
                    for(let t1 = 0, e = u.length; t1 < e; t1++)c[t1] = [];
                    for(let n = 0, r = u.length; n < r; n++){
                        const r = p[n];
                        for(let a = 0; a < r.length; a++){
                            const s = r[a];
                            let o = !0;
                            for(let r = 0; r < u.length; r++)e(s.p, u[r].p) && (n !== r && i++, o ? (o = !1, c[r].push(s)) : t1 = !0);
                            o && c[n].push(s);
                        }
                    }
                    i > 0 && !1 === t1 && (p = c);
                }
                for(let t1 = 0, e = u.length; t1 < e; t1++){
                    s = u[t1].s, o.push(s), d = p[t1];
                    for(let t1 = 0, e = d.length; t1 < e; t1++)s.holes.push(d[t1].h);
                }
                return o;
            }
        }
        function xv(t1, e) {
            if (e === zs) return console.warn("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Geometry already defined as triangles."), t1;
            if (e === Os || e === Ls) {
                let i = t1.getIndex();
                if (null === i) {
                    const e = [], n = t1.getAttribute("position");
                    if (void 0 === n) return console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Undefined position attribute. Processing not possible."), t1;
                    for(let t1 = 0; t1 < n.count; t1++)e.push(t1);
                    t1.setIndex(e), i = t1.getIndex();
                }
                const n = i.count - 2, r = [];
                if (e === Os) for(let t1 = 1; t1 <= n; t1++)r.push(i.getX(0)), r.push(i.getX(t1)), r.push(i.getX(t1 + 1));
                else for(let t1 = 0; t1 < n; t1++)t1 % 2 == 0 ? (r.push(i.getX(t1)), r.push(i.getX(t1 + 1)), r.push(i.getX(t1 + 2))) : (r.push(i.getX(t1 + 2)), r.push(i.getX(t1 + 1)), r.push(i.getX(t1)));
                r.length / 3 !== n && console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unable to generate correct amount of triangles.");
                const a = t1.clone();
                return a.setIndex(r), a.clearGroups(), a;
            }
            return console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unknown draw mode:", e), t1;
        }
        "undefined" != typeof __THREE_DEVTOOLS__ && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("register", {
            detail: {
                revision: qn
            }
        })), "undefined" != typeof window && (window.__THREE__ ? console.warn("WARNING: Multiple instances of Three.js being imported.") : window.__THREE__ = qn);
        class wv extends hg {
            constructor(t1){
                super(t1), this.dracoLoader = null, this.ktx2Loader = null, this.meshoptDecoder = null, this.pluginCallbacks = [], this.register(function(t1) {
                    return new Sv(t1);
                }), this.register(function(t1) {
                    return new jv(t1);
                }), this.register(function(t1) {
                    return new Rv(t1);
                }), this.register(function(t1) {
                    return new kv(t1);
                }), this.register(function(t1) {
                    return new Dv(t1);
                }), this.register(function(t1) {
                    return new Cv(t1);
                }), this.register(function(t1) {
                    return new zv(t1);
                }), this.register(function(t1) {
                    return new Lv(t1);
                }), this.register(function(t1) {
                    return new Iv(t1);
                }), this.register(function(t1) {
                    return new Ov(t1);
                }), this.register(function(t1) {
                    return new Nv(t1);
                }), this.register(function(t1) {
                    return new Pv(t1);
                }), this.register(function(t1) {
                    return new Ev(t1);
                }), this.register(function(t1) {
                    return new Uv(t1);
                }), this.register(function(t1) {
                    return new Bv(t1);
                });
            }
            load(t1, e, i, n) {
                const r = this;
                let a;
                a = "" !== this.resourcePath ? this.resourcePath : "" !== this.path ? this.path : Fg.extractUrlBase(t1), this.manager.itemStart(t1);
                const s = function(e) {
                    n ? n(e) : console.error(e), r.manager.itemError(t1), r.manager.itemEnd(t1);
                }, o = new Ag(this.manager);
                o.setPath(this.path), o.setResponseType("arraybuffer"), o.setRequestHeader(this.requestHeader), o.setWithCredentials(this.withCredentials), o.load(t1, function(i) {
                    try {
                        r.parse(i, a, function(i) {
                            e(i), r.manager.itemEnd(t1);
                        }, s);
                    } catch (t1) {
                        s(t1);
                    }
                }, i, s);
            }
            setDRACOLoader(t1) {
                return this.dracoLoader = t1, this;
            }
            setDDSLoader() {
                throw new Error('THREE.GLTFLoader: "MSFT_texture_dds" no longer supported. Please update to "KHR_texture_basisu".');
            }
            setKTX2Loader(t1) {
                return this.ktx2Loader = t1, this;
            }
            setMeshoptDecoder(t1) {
                return this.meshoptDecoder = t1, this;
            }
            register(t1) {
                return -1 === this.pluginCallbacks.indexOf(t1) && this.pluginCallbacks.push(t1), this;
            }
            unregister(t1) {
                return -1 !== this.pluginCallbacks.indexOf(t1) && this.pluginCallbacks.splice(this.pluginCallbacks.indexOf(t1), 1), this;
            }
            parse(t1, e, i, n) {
                let r;
                const a = {}, s = {}, o = new TextDecoder;
                if ("string" == typeof t1) r = JSON.parse(t1);
                else if (t1 instanceof ArrayBuffer) {
                    if (o.decode(new Uint8Array(t1, 0, 4)) === Fv) {
                        try {
                            a[Tv.KHR_BINARY_GLTF] = new Qv(t1);
                        } catch (t1) {
                            return void (n && n(t1));
                        }
                        r = JSON.parse(a[Tv.KHR_BINARY_GLTF].content);
                    } else r = JSON.parse(o.decode(t1));
                } else r = t1;
                if (void 0 === r.asset || r.asset.version[0] < 2) return void (n && n(new Error("THREE.GLTFLoader: Unsupported asset. glTF versions >=2.0 are supported.")));
                const l = new uy(r, {
                    path: e || this.resourcePath || "",
                    crossOrigin: this.crossOrigin,
                    requestHeader: this.requestHeader,
                    manager: this.manager,
                    ktx2Loader: this.ktx2Loader,
                    meshoptDecoder: this.meshoptDecoder
                });
                l.fileLoader.setRequestHeader(this.requestHeader);
                for(let t1 = 0; t1 < this.pluginCallbacks.length; t1++){
                    const e = this.pluginCallbacks[t1](l);
                    e.name || console.error("THREE.GLTFLoader: Invalid plugin found: missing name"), s[e.name] = e, a[e.name] = !0;
                }
                if (r.extensionsUsed) for(let t1 = 0; t1 < r.extensionsUsed.length; ++t1){
                    const e = r.extensionsUsed[t1], i = r.extensionsRequired || [];
                    switch(e){
                        case Tv.KHR_MATERIALS_UNLIT:
                            a[e] = new _v;
                            break;
                        case Tv.KHR_DRACO_MESH_COMPRESSION:
                            a[e] = new Hv(r, this.dracoLoader);
                            break;
                        case Tv.KHR_TEXTURE_TRANSFORM:
                            a[e] = new Vv;
                            break;
                        case Tv.KHR_MESH_QUANTIZATION:
                            a[e] = new Gv;
                            break;
                        default:
                            i.indexOf(e) >= 0 && void 0 === s[e] && console.warn('THREE.GLTFLoader: Unknown extension "' + e + '".');
                    }
                }
                l.setExtensions(a), l.setPlugins(s), l.parse(i, n);
            }
            parseAsync(t1, e) {
                const i = this;
                return new Promise(function(n, r) {
                    i.parse(t1, e, n, r);
                });
            }
        }
        function bv() {
            let t1 = {};
            return {
                get: function(e) {
                    return t1[e];
                },
                add: function(e, i) {
                    t1[e] = i;
                },
                remove: function(e) {
                    delete t1[e];
                },
                removeAll: function() {
                    t1 = {};
                }
            };
        }
        const Tv = {
            KHR_BINARY_GLTF: "KHR_binary_glTF",
            KHR_DRACO_MESH_COMPRESSION: "KHR_draco_mesh_compression",
            KHR_LIGHTS_PUNCTUAL: "KHR_lights_punctual",
            KHR_MATERIALS_CLEARCOAT: "KHR_materials_clearcoat",
            KHR_MATERIALS_IOR: "KHR_materials_ior",
            KHR_MATERIALS_SHEEN: "KHR_materials_sheen",
            KHR_MATERIALS_SPECULAR: "KHR_materials_specular",
            KHR_MATERIALS_TRANSMISSION: "KHR_materials_transmission",
            KHR_MATERIALS_IRIDESCENCE: "KHR_materials_iridescence",
            KHR_MATERIALS_ANISOTROPY: "KHR_materials_anisotropy",
            KHR_MATERIALS_UNLIT: "KHR_materials_unlit",
            KHR_MATERIALS_VOLUME: "KHR_materials_volume",
            KHR_TEXTURE_BASISU: "KHR_texture_basisu",
            KHR_TEXTURE_TRANSFORM: "KHR_texture_transform",
            KHR_MESH_QUANTIZATION: "KHR_mesh_quantization",
            KHR_MATERIALS_EMISSIVE_STRENGTH: "KHR_materials_emissive_strength",
            EXT_TEXTURE_WEBP: "EXT_texture_webp",
            EXT_TEXTURE_AVIF: "EXT_texture_avif",
            EXT_MESHOPT_COMPRESSION: "EXT_meshopt_compression",
            EXT_MESH_GPU_INSTANCING: "EXT_mesh_gpu_instancing"
        };
        class Ev {
            constructor(t1){
                this.parser = t1, this.name = Tv.KHR_LIGHTS_PUNCTUAL, this.cache = {
                    refs: {},
                    uses: {}
                };
            }
            _markDefs() {
                const t1 = this.parser, e = this.parser.json.nodes || [];
                for(let i = 0, n = e.length; i < n; i++){
                    const n = e[i];
                    n.extensions && n.extensions[this.name] && void 0 !== n.extensions[this.name].light && t1._addNodeRef(this.cache, n.extensions[this.name].light);
                }
            }
            _loadLight(t1) {
                const e = this.parser, i = "light:" + t1;
                let n = e.cache.get(i);
                if (n) return n;
                const r = e.json, a = ((r.extensions && r.extensions[this.name] || {}).lights || [])[t1];
                let s;
                const o = new Yc(16777215);
                void 0 !== a.color && o.setRGB(a.color[0], a.color[1], a.color[2], Hs);
                const l = void 0 !== a.range ? a.range : 0;
                switch(a.type){
                    case "directional":
                        s = new Pg(o), s.target.position.set(0, 0, -1), s.add(s.target);
                        break;
                    case "point":
                        s = new Lg(o), s.distance = l;
                        break;
                    case "spot":
                        s = new Sg(o), s.distance = l, a.spot = a.spot || {}, a.spot.innerConeAngle = void 0 !== a.spot.innerConeAngle ? a.spot.innerConeAngle : 0, a.spot.outerConeAngle = void 0 !== a.spot.outerConeAngle ? a.spot.outerConeAngle : Math.PI / 4, s.angle = a.spot.outerConeAngle, s.penumbra = 1 - a.spot.innerConeAngle / a.spot.outerConeAngle, s.target.position.set(0, 0, -1), s.add(s.target);
                        break;
                    default:
                        throw new Error("THREE.GLTFLoader: Unexpected light type: " + a.type);
                }
                return s.position.set(0, 0, 0), s.decay = 2, ry(s, a), void 0 !== a.intensity && (s.intensity = a.intensity), s.name = e.createUniqueName(a.name || "light_" + t1), n = Promise.resolve(s), e.cache.add(i, n), n;
            }
            getDependency(t1, e) {
                if ("light" === t1) return this._loadLight(e);
            }
            createNodeAttachment(t1) {
                const e = this, i = this.parser, n = i.json.nodes[t1], r = (n.extensions && n.extensions[this.name] || {}).light;
                return void 0 === r ? null : this._loadLight(r).then(function(t1) {
                    return i._getNodeRef(e.cache, r, t1);
                });
            }
        }
        class _v {
            constructor(){
                this.name = Tv.KHR_MATERIALS_UNLIT;
            }
            getMaterialType() {
                return Jc;
            }
            extendParams(t1, e, i) {
                const n = [];
                t1.color = new Yc(1, 1, 1), t1.opacity = 1;
                const r = e.pbrMetallicRoughness;
                if (r) {
                    if (Array.isArray(r.baseColorFactor)) {
                        const e = r.baseColorFactor;
                        t1.color.setRGB(e[0], e[1], e[2], Hs), t1.opacity = e[3];
                    }
                    void 0 !== r.baseColorTexture && n.push(i.assignTexture(t1, "map", r.baseColorTexture, Qs));
                }
                return Promise.all(n);
            }
        }
        class Iv {
            constructor(t1){
                this.parser = t1, this.name = Tv.KHR_MATERIALS_EMISSIVE_STRENGTH;
            }
            extendMaterialParams(t1, e) {
                const i = this.parser.json.materials[t1];
                if (!i.extensions || !i.extensions[this.name]) return Promise.resolve();
                const n = i.extensions[this.name].emissiveStrength;
                return void 0 !== n && (e.emissiveIntensity = n), Promise.resolve();
            }
        }
        class Sv {
            constructor(t1){
                this.parser = t1, this.name = Tv.KHR_MATERIALS_CLEARCOAT;
            }
            getMaterialType(t1) {
                const e = this.parser.json.materials[t1];
                return e.extensions && e.extensions[this.name] ? Pm : null;
            }
            extendMaterialParams(t1, e) {
                const i = this.parser, n = i.json.materials[t1];
                if (!n.extensions || !n.extensions[this.name]) return Promise.resolve();
                const r = [], a = n.extensions[this.name];
                if (void 0 !== a.clearcoatFactor && (e.clearcoat = a.clearcoatFactor), void 0 !== a.clearcoatTexture && r.push(i.assignTexture(e, "clearcoatMap", a.clearcoatTexture)), void 0 !== a.clearcoatRoughnessFactor && (e.clearcoatRoughness = a.clearcoatRoughnessFactor), void 0 !== a.clearcoatRoughnessTexture && r.push(i.assignTexture(e, "clearcoatRoughnessMap", a.clearcoatRoughnessTexture)), void 0 !== a.clearcoatNormalTexture && (r.push(i.assignTexture(e, "clearcoatNormalMap", a.clearcoatNormalTexture)), void 0 !== a.clearcoatNormalTexture.scale)) {
                    const t1 = a.clearcoatNormalTexture.scale;
                    e.clearcoatNormalScale = new qo(t1, t1);
                }
                return Promise.all(r);
            }
        }
        class Nv {
            constructor(t1){
                this.parser = t1, this.name = Tv.KHR_MATERIALS_IRIDESCENCE;
            }
            getMaterialType(t1) {
                const e = this.parser.json.materials[t1];
                return e.extensions && e.extensions[this.name] ? Pm : null;
            }
            extendMaterialParams(t1, e) {
                const i = this.parser, n = i.json.materials[t1];
                if (!n.extensions || !n.extensions[this.name]) return Promise.resolve();
                const r = [], a = n.extensions[this.name];
                return void 0 !== a.iridescenceFactor && (e.iridescence = a.iridescenceFactor), void 0 !== a.iridescenceTexture && r.push(i.assignTexture(e, "iridescenceMap", a.iridescenceTexture)), void 0 !== a.iridescenceIor && (e.iridescenceIOR = a.iridescenceIor), void 0 === e.iridescenceThicknessRange && (e.iridescenceThicknessRange = [
                    100,
                    400
                ]), void 0 !== a.iridescenceThicknessMinimum && (e.iridescenceThicknessRange[0] = a.iridescenceThicknessMinimum), void 0 !== a.iridescenceThicknessMaximum && (e.iridescenceThicknessRange[1] = a.iridescenceThicknessMaximum), void 0 !== a.iridescenceThicknessTexture && r.push(i.assignTexture(e, "iridescenceThicknessMap", a.iridescenceThicknessTexture)), Promise.all(r);
            }
        }
        class Dv {
            constructor(t1){
                this.parser = t1, this.name = Tv.KHR_MATERIALS_SHEEN;
            }
            getMaterialType(t1) {
                const e = this.parser.json.materials[t1];
                return e.extensions && e.extensions[this.name] ? Pm : null;
            }
            extendMaterialParams(t1, e) {
                const i = this.parser, n = i.json.materials[t1];
                if (!n.extensions || !n.extensions[this.name]) return Promise.resolve();
                const r = [];
                e.sheenColor = new Yc(0, 0, 0), e.sheenRoughness = 0, e.sheen = 1;
                const a = n.extensions[this.name];
                if (void 0 !== a.sheenColorFactor) {
                    const t1 = a.sheenColorFactor;
                    e.sheenColor.setRGB(t1[0], t1[1], t1[2], Hs);
                }
                return void 0 !== a.sheenRoughnessFactor && (e.sheenRoughness = a.sheenRoughnessFactor), void 0 !== a.sheenColorTexture && r.push(i.assignTexture(e, "sheenColorMap", a.sheenColorTexture, Qs)), void 0 !== a.sheenRoughnessTexture && r.push(i.assignTexture(e, "sheenRoughnessMap", a.sheenRoughnessTexture)), Promise.all(r);
            }
        }
        class Cv {
            constructor(t1){
                this.parser = t1, this.name = Tv.KHR_MATERIALS_TRANSMISSION;
            }
            getMaterialType(t1) {
                const e = this.parser.json.materials[t1];
                return e.extensions && e.extensions[this.name] ? Pm : null;
            }
            extendMaterialParams(t1, e) {
                const i = this.parser, n = i.json.materials[t1];
                if (!n.extensions || !n.extensions[this.name]) return Promise.resolve();
                const r = [], a = n.extensions[this.name];
                return void 0 !== a.transmissionFactor && (e.transmission = a.transmissionFactor), void 0 !== a.transmissionTexture && r.push(i.assignTexture(e, "transmissionMap", a.transmissionTexture)), Promise.all(r);
            }
        }
        class zv {
            constructor(t1){
                this.parser = t1, this.name = Tv.KHR_MATERIALS_VOLUME;
            }
            getMaterialType(t1) {
                const e = this.parser.json.materials[t1];
                return e.extensions && e.extensions[this.name] ? Pm : null;
            }
            extendMaterialParams(t1, e) {
                const i = this.parser, n = i.json.materials[t1];
                if (!n.extensions || !n.extensions[this.name]) return Promise.resolve();
                const r = [], a = n.extensions[this.name];
                e.thickness = void 0 !== a.thicknessFactor ? a.thicknessFactor : 0, void 0 !== a.thicknessTexture && r.push(i.assignTexture(e, "thicknessMap", a.thicknessTexture)), e.attenuationDistance = a.attenuationDistance || 1 / 0;
                const s = a.attenuationColor || [
                    1,
                    1,
                    1
                ];
                return e.attenuationColor = (new Yc).setRGB(s[0], s[1], s[2], Hs), Promise.all(r);
            }
        }
        class Lv {
            constructor(t1){
                this.parser = t1, this.name = Tv.KHR_MATERIALS_IOR;
            }
            getMaterialType(t1) {
                const e = this.parser.json.materials[t1];
                return e.extensions && e.extensions[this.name] ? Pm : null;
            }
            extendMaterialParams(t1, e) {
                const i = this.parser.json.materials[t1];
                if (!i.extensions || !i.extensions[this.name]) return Promise.resolve();
                const n = i.extensions[this.name];
                return e.ior = void 0 !== n.ior ? n.ior : 1.5, Promise.resolve();
            }
        }
        class Ov {
            constructor(t1){
                this.parser = t1, this.name = Tv.KHR_MATERIALS_SPECULAR;
            }
            getMaterialType(t1) {
                const e = this.parser.json.materials[t1];
                return e.extensions && e.extensions[this.name] ? Pm : null;
            }
            extendMaterialParams(t1, e) {
                const i = this.parser, n = i.json.materials[t1];
                if (!n.extensions || !n.extensions[this.name]) return Promise.resolve();
                const r = [], a = n.extensions[this.name];
                e.specularIntensity = void 0 !== a.specularFactor ? a.specularFactor : 1, void 0 !== a.specularTexture && r.push(i.assignTexture(e, "specularIntensityMap", a.specularTexture));
                const s = a.specularColorFactor || [
                    1,
                    1,
                    1
                ];
                return e.specularColor = (new Yc).setRGB(s[0], s[1], s[2], Hs), void 0 !== a.specularColorTexture && r.push(i.assignTexture(e, "specularColorMap", a.specularColorTexture, Qs)), Promise.all(r);
            }
        }
        class Pv {
            constructor(t1){
                this.parser = t1, this.name = Tv.KHR_MATERIALS_ANISOTROPY;
            }
            getMaterialType(t1) {
                const e = this.parser.json.materials[t1];
                return e.extensions && e.extensions[this.name] ? Pm : null;
            }
            extendMaterialParams(t1, e) {
                const i = this.parser, n = i.json.materials[t1];
                if (!n.extensions || !n.extensions[this.name]) return Promise.resolve();
                const r = [], a = n.extensions[this.name];
                return void 0 !== a.anisotropyStrength && (e.anisotropy = a.anisotropyStrength), void 0 !== a.anisotropyRotation && (e.anisotropyRotation = a.anisotropyRotation), void 0 !== a.anisotropyTexture && r.push(i.assignTexture(e, "anisotropyMap", a.anisotropyTexture)), Promise.all(r);
            }
        }
        class jv {
            constructor(t1){
                this.parser = t1, this.name = Tv.KHR_TEXTURE_BASISU;
            }
            loadTexture(t1) {
                const e = this.parser, i = e.json, n = i.textures[t1];
                if (!n.extensions || !n.extensions[this.name]) return null;
                const r = n.extensions[this.name], a = e.options.ktx2Loader;
                if (!a) {
                    if (i.extensionsRequired && i.extensionsRequired.indexOf(this.name) >= 0) throw new Error("THREE.GLTFLoader: setKTX2Loader must be called before loading KTX2 textures");
                    return null;
                }
                return e.loadTextureImage(t1, r.source, a);
            }
        }
        class Rv {
            constructor(t1){
                this.parser = t1, this.name = Tv.EXT_TEXTURE_WEBP, this.isSupported = null;
            }
            loadTexture(t1) {
                const e = this.name, i = this.parser, n = i.json, r = n.textures[t1];
                if (!r.extensions || !r.extensions[e]) return null;
                const a = r.extensions[e], s = n.images[a.source];
                let o = i.textureLoader;
                if (s.uri) {
                    const t1 = i.options.manager.getHandler(s.uri);
                    null !== t1 && (o = t1);
                }
                return this.detectSupport().then(function(r) {
                    if (r) return i.loadTextureImage(t1, a.source, o);
                    if (n.extensionsRequired && n.extensionsRequired.indexOf(e) >= 0) throw new Error("THREE.GLTFLoader: WebP required by asset but unsupported.");
                    return i.loadTexture(t1);
                });
            }
            detectSupport() {
                return this.isSupported || (this.isSupported = new Promise(function(t1) {
                    const e = new Image;
                    e.src = "data:image/webp;base64,UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA", e.onload = e.onerror = function() {
                        t1(1 === e.height);
                    };
                })), this.isSupported;
            }
        }
        class kv {
            constructor(t1){
                this.parser = t1, this.name = Tv.EXT_TEXTURE_AVIF, this.isSupported = null;
            }
            loadTexture(t1) {
                const e = this.name, i = this.parser, n = i.json, r = n.textures[t1];
                if (!r.extensions || !r.extensions[e]) return null;
                const a = r.extensions[e], s = n.images[a.source];
                let o = i.textureLoader;
                if (s.uri) {
                    const t1 = i.options.manager.getHandler(s.uri);
                    null !== t1 && (o = t1);
                }
                return this.detectSupport().then(function(r) {
                    if (r) return i.loadTextureImage(t1, a.source, o);
                    if (n.extensionsRequired && n.extensionsRequired.indexOf(e) >= 0) throw new Error("THREE.GLTFLoader: AVIF required by asset but unsupported.");
                    return i.loadTexture(t1);
                });
            }
            detectSupport() {
                return this.isSupported || (this.isSupported = new Promise(function(t1) {
                    const e = new Image;
                    e.src = "data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAABcAAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAEAAAABAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQAMAAAAABNjb2xybmNseAACAAIABoAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAAB9tZGF0EgAKCBgABogQEDQgMgkQAAAAB8dSLfI=", e.onload = e.onerror = function() {
                        t1(1 === e.height);
                    };
                })), this.isSupported;
            }
        }
        class Uv {
            constructor(t1){
                this.name = Tv.EXT_MESHOPT_COMPRESSION, this.parser = t1;
            }
            loadBufferView(t1) {
                const e = this.parser.json, i = e.bufferViews[t1];
                if (i.extensions && i.extensions[this.name]) {
                    const t1 = i.extensions[this.name], n = this.parser.getDependency("buffer", t1.buffer), r = this.parser.options.meshoptDecoder;
                    if (!r || !r.supported) {
                        if (e.extensionsRequired && e.extensionsRequired.indexOf(this.name) >= 0) throw new Error("THREE.GLTFLoader: setMeshoptDecoder must be called before loading compressed files");
                        return null;
                    }
                    return n.then(function(e) {
                        const i = t1.byteOffset || 0, n = t1.byteLength || 0, a = t1.count, s = t1.byteStride, o = new Uint8Array(e, i, n);
                        return r.decodeGltfBufferAsync ? r.decodeGltfBufferAsync(a, s, o, t1.mode, t1.filter).then(function(t1) {
                            return t1.buffer;
                        }) : r.ready.then(function() {
                            const e = new ArrayBuffer(a * s);
                            return r.decodeGltfBuffer(new Uint8Array(e), a, s, o, t1.mode, t1.filter), e;
                        });
                    });
                }
                return null;
            }
        }
        class Bv {
            constructor(t1){
                this.name = Tv.EXT_MESH_GPU_INSTANCING, this.parser = t1;
            }
            createNodeMesh(t1) {
                const e = this.parser.json, i = e.nodes[t1];
                if (!i.extensions || !i.extensions[this.name] || void 0 === i.mesh) return null;
                const n = e.meshes[i.mesh];
                for (const t1 of n.primitives)if (t1.mode !== Zv.TRIANGLES && t1.mode !== Zv.TRIANGLE_STRIP && t1.mode !== Zv.TRIANGLE_FAN && void 0 !== t1.mode) return null;
                const r = i.extensions[this.name].attributes, a = [], s = {};
                for(const t1 in r)a.push(this.parser.getDependency("accessor", r[t1]).then((e)=>(s[t1] = e, s[t1])));
                return a.length < 1 ? null : (a.push(this.parser.createNodeMesh(t1)), Promise.all(a).then((t1)=>{
                    const e = t1.pop(), i = e.isGroup ? e.children : [
                        e
                    ], n = t1[0].count, r = [];
                    for (const t1 of i){
                        const e = new ac, i = new Nl, a = new Sl, o = new Nl(1, 1, 1), l = new kA(t1.geometry, t1.material, n);
                        for(let t1 = 0; t1 < n; t1++)s.TRANSLATION && i.fromBufferAttribute(s.TRANSLATION, t1), s.ROTATION && a.fromBufferAttribute(s.ROTATION, t1), s.SCALE && o.fromBufferAttribute(s.SCALE, t1), l.setMatrixAt(t1, e.compose(i, a, o));
                        for(const e in s)if ("_COLOR_0" === e) {
                            const t1 = s[e];
                            l.instanceColor = new DA(t1.array, t1.itemSize, t1.normalized);
                        } else "TRANSLATION" !== e && "ROTATION" !== e && "SCALE" !== e && t1.geometry.setAttribute(e, s[e]);
                        Dc.prototype.copy.call(l, t1), this.parser.assignFinalMaterial(l), r.push(l);
                    }
                    return e.isGroup ? (e.clear(), e.add(...r), e) : r[0];
                }));
            }
        }
        const Fv = "glTF";
        class Qv {
            constructor(t1){
                this.name = Tv.KHR_BINARY_GLTF, this.content = null, this.body = null;
                const e = new DataView(t1, 0, 12), i = new TextDecoder;
                if (this.header = {
                    magic: i.decode(new Uint8Array(t1.slice(0, 4))),
                    version: e.getUint32(4, !0),
                    length: e.getUint32(8, !0)
                }, this.header.magic !== Fv) throw new Error("THREE.GLTFLoader: Unsupported glTF-Binary header.");
                if (this.header.version < 2) throw new Error("THREE.GLTFLoader: Legacy binary file detected.");
                const n = this.header.length - 12, r = new DataView(t1, 12);
                let a = 0;
                for(; a < n;){
                    const e = r.getUint32(a, !0);
                    a += 4;
                    const n = r.getUint32(a, !0);
                    if (a += 4, 1313821514 === n) {
                        const n = new Uint8Array(t1, 12 + a, e);
                        this.content = i.decode(n);
                    } else if (5130562 === n) {
                        const i = 12 + a;
                        this.body = t1.slice(i, i + e);
                    }
                    a += e;
                }
                if (null === this.content) throw new Error("THREE.GLTFLoader: JSON content not found.");
            }
        }
        class Hv {
            constructor(t1, e){
                if (!e) throw new Error("THREE.GLTFLoader: No DRACOLoader instance provided.");
                this.name = Tv.KHR_DRACO_MESH_COMPRESSION, this.json = t1, this.dracoLoader = e, this.dracoLoader.preload();
            }
            decodePrimitive(t1, e) {
                const i = this.json, n = this.dracoLoader, r = t1.extensions[this.name].bufferView, a = t1.extensions[this.name].attributes, s = {}, o = {}, l = {};
                for(const t1 in a){
                    const e = ty[t1] || t1.toLowerCase();
                    s[e] = a[t1];
                }
                for(const e in t1.attributes){
                    const n = ty[e] || e.toLowerCase();
                    if (void 0 !== a[e]) {
                        const r = i.accessors[t1.attributes[e]], a = qv[r.componentType];
                        l[n] = a.name, o[n] = !0 === r.normalized;
                    }
                }
                return e.getDependency("bufferView", r).then(function(t1) {
                    return new Promise(function(e) {
                        n.decodeDracoFile(t1, function(t1) {
                            for(const e in t1.attributes){
                                const i = t1.attributes[e], n = o[e];
                                void 0 !== n && (i.normalized = n);
                            }
                            e(t1);
                        }, s, l);
                    });
                });
            }
        }
        class Vv {
            constructor(){
                this.name = Tv.KHR_TEXTURE_TRANSFORM;
            }
            extendTexture(t1, e) {
                return void 0 !== e.texCoord && e.texCoord !== t1.channel || void 0 !== e.offset || void 0 !== e.rotation || void 0 !== e.scale ? (t1 = t1.clone(), void 0 !== e.texCoord && (t1.channel = e.texCoord), void 0 !== e.offset && t1.offset.fromArray(e.offset), void 0 !== e.rotation && (t1.rotation = e.rotation), void 0 !== e.scale && t1.repeat.fromArray(e.scale), t1.needsUpdate = !0, t1) : t1;
            }
        }
        class Gv {
            constructor(){
                this.name = Tv.KHR_MESH_QUANTIZATION;
            }
        }
        class Wv extends Xm {
            constructor(t1, e, i, n){
                super(t1, e, i, n);
            }
            copySampleValue_(t1) {
                const e = this.resultBuffer, i = this.sampleValues, n = this.valueSize, r = t1 * n * 3 + n;
                for(let t1 = 0; t1 !== n; t1++)e[t1] = i[r + t1];
                return e;
            }
            interpolate_(t1, e, i, n) {
                const r = this.resultBuffer, a = this.sampleValues, s = this.valueSize, o = 2 * s, l = 3 * s, c = n - e, u = (i - e) / c, h = u * u, d = h * u, p = t1 * l, A = p - l, f = -2 * d + 3 * h, m = d - h, g = 1 - f, M = m - h + u;
                for(let t1 = 0; t1 !== s; t1++){
                    const e = a[A + t1 + s], i = a[A + t1 + o] * c, n = a[p + t1 + s], l = a[p + t1] * c;
                    r[t1] = g * e + M * i + f * n + m * l;
                }
                return r;
            }
        }
        const Yv = new Sl;
        class Xv extends Wv {
            interpolate_(t1, e, i, n) {
                const r = super.interpolate_(t1, e, i, n);
                return Yv.fromArray(r).normalize().toArray(r), r;
            }
        }
        const Zv = {
            FLOAT: 5126,
            FLOAT_MAT3: 35675,
            FLOAT_MAT4: 35676,
            FLOAT_VEC2: 35664,
            FLOAT_VEC3: 35665,
            FLOAT_VEC4: 35666,
            LINEAR: 9729,
            REPEAT: 10497,
            SAMPLER_2D: 35678,
            POINTS: 0,
            LINES: 1,
            LINE_LOOP: 2,
            LINE_STRIP: 3,
            TRIANGLES: 4,
            TRIANGLE_STRIP: 5,
            TRIANGLE_FAN: 6,
            UNSIGNED_BYTE: 5121,
            UNSIGNED_SHORT: 5123
        }, qv = {
            5120: Int8Array,
            5121: Uint8Array,
            5122: Int16Array,
            5123: Uint16Array,
            5125: Uint32Array,
            5126: Float32Array
        }, Jv = {
            9728: ha,
            9729: ma,
            9984: da,
            9985: ga,
            9986: Aa,
            9987: va
        }, Kv = {
            33071: ca,
            33648: ua,
            10497: la
        }, $v = {
            SCALAR: 1,
            VEC2: 2,
            VEC3: 3,
            VEC4: 4,
            MAT2: 4,
            MAT3: 9,
            MAT4: 16
        }, ty = {
            POSITION: "position",
            NORMAL: "normal",
            TANGENT: "tangent",
            TEXCOORD_0: "uv",
            TEXCOORD_1: "uv1",
            TEXCOORD_2: "uv2",
            TEXCOORD_3: "uv3",
            COLOR_0: "color",
            WEIGHTS_0: "skinWeight",
            JOINTS_0: "skinIndex"
        }, ey = {
            scale: "scale",
            translation: "position",
            rotation: "quaternion",
            weights: "morphTargetInfluences"
        }, iy = {
            CUBICSPLINE: void 0,
            LINEAR: Es,
            STEP: Ts
        };
        function ny(t1, e, i) {
            for(const n in i.extensions)void 0 === t1[n] && (e.userData.gltfExtensions = e.userData.gltfExtensions || {}, e.userData.gltfExtensions[n] = i.extensions[n]);
        }
        function ry(t1, e) {
            void 0 !== e.extras && ("object" == typeof e.extras ? Object.assign(t1.userData, e.extras) : console.warn("THREE.GLTFLoader: Ignoring primitive type .extras, " + e.extras));
        }
        function ay(t1, e) {
            if (t1.updateMorphTargets(), void 0 !== e.weights) for(let i = 0, n = e.weights.length; i < n; i++)t1.morphTargetInfluences[i] = e.weights[i];
            if (e.extras && Array.isArray(e.extras.targetNames)) {
                const i = e.extras.targetNames;
                if (t1.morphTargetInfluences.length === i.length) {
                    t1.morphTargetDictionary = {};
                    for(let e = 0, n = i.length; e < n; e++)t1.morphTargetDictionary[i[e]] = e;
                } else console.warn("THREE.GLTFLoader: Invalid extras.targetNames length. Ignoring names.");
            }
        }
        function sy(t1) {
            let e;
            const i = t1.extensions && t1.extensions[Tv.KHR_DRACO_MESH_COMPRESSION];
            if (e = i ? "draco:" + i.bufferView + ":" + i.indices + ":" + oy(i.attributes) : t1.indices + ":" + oy(t1.attributes) + ":" + t1.mode, void 0 !== t1.targets) for(let i = 0, n = t1.targets.length; i < n; i++)e += ":" + oy(t1.targets[i]);
            return e;
        }
        function oy(t1) {
            let e = "";
            const i = Object.keys(t1).sort();
            for(let n = 0, r = i.length; n < r; n++)e += i[n] + ":" + t1[i[n]] + ";";
            return e;
        }
        function ly(t1) {
            switch(t1){
                case Int8Array:
                    return 1 / 127;
                case Uint8Array:
                    return 1 / 255;
                case Int16Array:
                    return 1 / 32767;
                case Uint16Array:
                    return 1 / 65535;
                default:
                    throw new Error("THREE.GLTFLoader: Unsupported normalized accessor component type.");
            }
        }
        const cy = new ac;
        class uy {
            constructor(t1 = {}, e = {}){
                this.json = t1, this.extensions = {}, this.plugins = {}, this.options = e, this.cache = new bv, this.associations = new Map, this.primitiveCache = {}, this.nodeCache = {}, this.meshCache = {
                    refs: {},
                    uses: {}
                }, this.cameraCache = {
                    refs: {},
                    uses: {}
                }, this.lightCache = {
                    refs: {},
                    uses: {}
                }, this.sourceCache = {}, this.textureCache = {}, this.nodeNamesUsed = {};
                let i = !1, n = !1, r = -1;
                "undefined" != typeof navigator && (i = !0 === /^((?!chrome|android).)*safari/i.test(navigator.userAgent), n = navigator.userAgent.indexOf("Firefox") > -1, r = n ? navigator.userAgent.match(/Firefox\/([0-9]+)\./)[1] : -1), "undefined" == typeof createImageBitmap || i || n && r < 98 ? this.textureLoader = new yg(this.options.manager) : this.textureLoader = new Xg(this.options.manager), this.textureLoader.setCrossOrigin(this.options.crossOrigin), this.textureLoader.setRequestHeader(this.options.requestHeader), this.fileLoader = new Ag(this.options.manager), this.fileLoader.setResponseType("arraybuffer"), "use-credentials" === this.options.crossOrigin && this.fileLoader.setWithCredentials(!0);
            }
            setExtensions(t1) {
                this.extensions = t1;
            }
            setPlugins(t1) {
                this.plugins = t1;
            }
            parse(t1, e) {
                const i = this, n = this.json, r = this.extensions;
                this.cache.removeAll(), this.nodeCache = {}, this._invokeAll(function(t1) {
                    return t1._markDefs && t1._markDefs();
                }), Promise.all(this._invokeAll(function(t1) {
                    return t1.beforeRoot && t1.beforeRoot();
                })).then(function() {
                    return Promise.all([
                        i.getDependencies("scene"),
                        i.getDependencies("animation"),
                        i.getDependencies("camera")
                    ]);
                }).then(function(e) {
                    const a = {
                        scene: e[0][n.scene || 0],
                        scenes: e[0],
                        animations: e[1],
                        cameras: e[2],
                        asset: n.asset,
                        parser: i,
                        userData: {}
                    };
                    return ny(r, a, n), ry(a, n), Promise.all(i._invokeAll(function(t1) {
                        return t1.afterRoot && t1.afterRoot(a);
                    })).then(function() {
                        t1(a);
                    });
                }).catch(e);
            }
            _markDefs() {
                const t1 = this.json.nodes || [], e = this.json.skins || [], i = this.json.meshes || [];
                for(let i = 0, n = e.length; i < n; i++){
                    const n = e[i].joints;
                    for(let e = 0, i = n.length; e < i; e++)t1[n[e]].isBone = !0;
                }
                for(let e = 0, n = t1.length; e < n; e++){
                    const n = t1[e];
                    void 0 !== n.mesh && (this._addNodeRef(this.meshCache, n.mesh), void 0 !== n.skin && (i[n.mesh].isSkinnedMesh = !0)), void 0 !== n.camera && this._addNodeRef(this.cameraCache, n.camera);
                }
            }
            _addNodeRef(t1, e) {
                void 0 !== e && (void 0 === t1.refs[e] && (t1.refs[e] = t1.uses[e] = 0), t1.refs[e]++);
            }
            _getNodeRef(t1, e, i) {
                if (t1.refs[e] <= 1) return i;
                const n = i.clone(), r = (t1, e)=>{
                    const i = this.associations.get(t1);
                    null != i && this.associations.set(e, i);
                    for (const [i, n] of t1.children.entries())r(n, e.children[i]);
                };
                return r(i, n), n.name += "_instance_" + t1.uses[e]++, n;
            }
            _invokeOne(t1) {
                const e = Object.values(this.plugins);
                e.push(this);
                for(let i = 0; i < e.length; i++){
                    const n = t1(e[i]);
                    if (n) return n;
                }
                return null;
            }
            _invokeAll(t1) {
                const e = Object.values(this.plugins);
                e.unshift(this);
                const i = [];
                for(let n = 0; n < e.length; n++){
                    const r = t1(e[n]);
                    r && i.push(r);
                }
                return i;
            }
            getDependency(t1, e) {
                const i = t1 + ":" + e;
                let n = this.cache.get(i);
                if (!n) {
                    switch(t1){
                        case "scene":
                            n = this.loadScene(e);
                            break;
                        case "node":
                            n = this._invokeOne(function(t1) {
                                return t1.loadNode && t1.loadNode(e);
                            });
                            break;
                        case "mesh":
                            n = this._invokeOne(function(t1) {
                                return t1.loadMesh && t1.loadMesh(e);
                            });
                            break;
                        case "accessor":
                            n = this.loadAccessor(e);
                            break;
                        case "bufferView":
                            n = this._invokeOne(function(t1) {
                                return t1.loadBufferView && t1.loadBufferView(e);
                            });
                            break;
                        case "buffer":
                            n = this.loadBuffer(e);
                            break;
                        case "material":
                            n = this._invokeOne(function(t1) {
                                return t1.loadMaterial && t1.loadMaterial(e);
                            });
                            break;
                        case "texture":
                            n = this._invokeOne(function(t1) {
                                return t1.loadTexture && t1.loadTexture(e);
                            });
                            break;
                        case "skin":
                            n = this.loadSkin(e);
                            break;
                        case "animation":
                            n = this._invokeOne(function(t1) {
                                return t1.loadAnimation && t1.loadAnimation(e);
                            });
                            break;
                        case "camera":
                            n = this.loadCamera(e);
                            break;
                        default:
                            if (n = this._invokeOne(function(i) {
                                return i != this && i.getDependency && i.getDependency(t1, e);
                            }), !n) throw new Error("Unknown type: " + t1);
                    }
                    this.cache.add(i, n);
                }
                return n;
            }
            getDependencies(t1) {
                let e = this.cache.get(t1);
                if (!e) {
                    const i = this, n = this.json[t1 + ("mesh" === t1 ? "es" : "s")] || [];
                    e = Promise.all(n.map(function(e, n) {
                        return i.getDependency(t1, n);
                    })), this.cache.add(t1, e);
                }
                return e;
            }
            loadBuffer(t1) {
                const e = this.json.buffers[t1], i = this.fileLoader;
                if (e.type && "arraybuffer" !== e.type) throw new Error("THREE.GLTFLoader: " + e.type + " buffer type is not supported.");
                if (void 0 === e.uri && 0 === t1) return Promise.resolve(this.extensions[Tv.KHR_BINARY_GLTF].body);
                const n = this.options;
                return new Promise(function(t1, r) {
                    i.load(Fg.resolveURL(e.uri, n.path), t1, void 0, function() {
                        r(new Error('THREE.GLTFLoader: Failed to load buffer "' + e.uri + '".'));
                    });
                });
            }
            loadBufferView(t1) {
                const e = this.json.bufferViews[t1];
                return this.getDependency("buffer", e.buffer).then(function(t1) {
                    const i = e.byteLength || 0, n = e.byteOffset || 0;
                    return t1.slice(n, n + i);
                });
            }
            loadAccessor(t1) {
                const e = this, i = this.json, n = this.json.accessors[t1];
                if (void 0 === n.bufferView && void 0 === n.sparse) {
                    const t1 = $v[n.type], e = qv[n.componentType], i = !0 === n.normalized, r = new e(n.count * t1);
                    return Promise.resolve(new au(r, t1, i));
                }
                const r = [];
                return void 0 !== n.bufferView ? r.push(this.getDependency("bufferView", n.bufferView)) : r.push(null), void 0 !== n.sparse && (r.push(this.getDependency("bufferView", n.sparse.indices.bufferView)), r.push(this.getDependency("bufferView", n.sparse.values.bufferView))), Promise.all(r).then(function(t1) {
                    const r = t1[0], a = $v[n.type], s = qv[n.componentType], o = s.BYTES_PER_ELEMENT, l = o * a, c = n.byteOffset || 0, u = void 0 !== n.bufferView ? i.bufferViews[n.bufferView].byteStride : void 0, h = !0 === n.normalized;
                    let d, p;
                    if (u && u !== l) {
                        const t1 = Math.floor(c / u), i = "InterleavedBuffer:" + n.bufferView + ":" + n.componentType + ":" + t1 + ":" + n.count;
                        let l = e.cache.get(i);
                        l || (d = new s(r, t1 * u, n.count * u / o), l = new Yp(d, u / o), e.cache.add(i, l)), p = new Zp(l, a, c % u / o, h);
                    } else d = null === r ? new s(n.count * a) : new s(r, c, n.count * a), p = new au(d, a, h);
                    if (void 0 !== n.sparse) {
                        const e = $v.SCALAR, i = qv[n.sparse.indices.componentType], o = n.sparse.indices.byteOffset || 0, l = n.sparse.values.byteOffset || 0, c = new i(t1[1], o, n.sparse.count * e), u = new s(t1[2], l, n.sparse.count * a);
                        null !== r && (p = new au(p.array.slice(), p.itemSize, p.normalized));
                        for(let t1 = 0, e = c.length; t1 < e; t1++){
                            const e = c[t1];
                            if (p.setX(e, u[t1 * a]), a >= 2 && p.setY(e, u[t1 * a + 1]), a >= 3 && p.setZ(e, u[t1 * a + 2]), a >= 4 && p.setW(e, u[t1 * a + 3]), a >= 5) throw new Error("THREE.GLTFLoader: Unsupported itemSize in sparse BufferAttribute.");
                        }
                    }
                    return p;
                });
            }
            loadTexture(t1) {
                const e = this.json, i = this.options, n = e.textures[t1].source, r = e.images[n];
                let a = this.textureLoader;
                if (r.uri) {
                    const t1 = i.manager.getHandler(r.uri);
                    null !== t1 && (a = t1);
                }
                return this.loadTextureImage(t1, n, a);
            }
            loadTextureImage(t1, e, i) {
                const n = this, r = this.json, a = r.textures[t1], s = r.images[e], o = (s.uri || s.bufferView) + ":" + a.sampler;
                if (this.textureCache[o]) return this.textureCache[o];
                const l = this.loadImageSource(e, i).then(function(e) {
                    e.flipY = !1, e.name = a.name || s.name || "", "" === e.name && "string" == typeof s.uri && !1 === s.uri.startsWith("data:image/") && (e.name = s.uri);
                    const i = (r.samplers || {})[a.sampler] || {};
                    return e.magFilter = Jv[i.magFilter] || ma, e.minFilter = Jv[i.minFilter] || va, e.wrapS = Kv[i.wrapS] || la, e.wrapT = Kv[i.wrapT] || la, n.associations.set(e, {
                        textures: t1
                    }), e;
                }).catch(function() {
                    return null;
                });
                return this.textureCache[o] = l, l;
            }
            loadImageSource(t1, e) {
                const i = this.json, n = this.options;
                if (void 0 !== this.sourceCache[t1]) return this.sourceCache[t1].then((t1)=>t1.clone());
                const r = i.images[t1], a = self.URL || self.webkitURL;
                let s = r.uri || "", o = !1;
                if (void 0 !== r.bufferView) s = this.getDependency("bufferView", r.bufferView).then(function(t1) {
                    o = !0;
                    const e = new Blob([
                        t1
                    ], {
                        type: r.mimeType
                    });
                    return s = a.createObjectURL(e), s;
                });
                else if (void 0 === r.uri) throw new Error("THREE.GLTFLoader: Image " + t1 + " is missing URI and bufferView");
                const l = Promise.resolve(s).then(function(t1) {
                    return new Promise(function(i, r) {
                        let a = i;
                        !0 === e.isImageBitmapLoader && (a = function(t1) {
                            const e = new vl(t1);
                            e.needsUpdate = !0, i(e);
                        }), e.load(Fg.resolveURL(t1, n.path), a, void 0, r);
                    });
                }).then(function(t1) {
                    var e;
                    return !0 === o && a.revokeObjectURL(s), t1.userData.mimeType = r.mimeType || ((e = r.uri).search(/\.jpe?g($|\?)/i) > 0 || 0 === e.search(/^data\:image\/jpeg/) ? "image/jpeg" : e.search(/\.webp($|\?)/i) > 0 || 0 === e.search(/^data\:image\/webp/) ? "image/webp" : "image/png"), t1;
                }).catch(function(t1) {
                    throw console.error("THREE.GLTFLoader: Couldn't load texture", s), t1;
                });
                return this.sourceCache[t1] = l, l;
            }
            assignTexture(t1, e, i, n) {
                const r = this;
                return this.getDependency("texture", i.index).then(function(a) {
                    if (!a) return null;
                    if (void 0 !== i.texCoord && i.texCoord > 0 && ((a = a.clone()).channel = i.texCoord), r.extensions[Tv.KHR_TEXTURE_TRANSFORM]) {
                        const t1 = void 0 !== i.extensions ? i.extensions[Tv.KHR_TEXTURE_TRANSFORM] : void 0;
                        if (t1) {
                            const e = r.associations.get(a);
                            a = r.extensions[Tv.KHR_TEXTURE_TRANSFORM].extendTexture(a, t1), r.associations.set(a, e);
                        }
                    }
                    return void 0 !== n && (a.colorSpace = n), t1[e] = a, a;
                });
            }
            assignFinalMaterial(t1) {
                const e = t1.geometry;
                let i = t1.material;
                const n = void 0 === e.attributes.tangent, r = void 0 !== e.attributes.color, a = void 0 === e.attributes.normal;
                if (t1.isPoints) {
                    const t1 = "PointsMaterial:" + i.uuid;
                    let e = this.cache.get(t1);
                    e || (e = new qA, qc.prototype.copy.call(e, i), e.color.copy(i.color), e.map = i.map, e.sizeAttenuation = !1, this.cache.add(t1, e)), i = e;
                } else if (t1.isLine) {
                    const t1 = "LineBasicMaterial:" + i.uuid;
                    let e = this.cache.get(t1);
                    e || (e = new UA, qc.prototype.copy.call(e, i), e.color.copy(i.color), e.map = i.map, this.cache.add(t1, e)), i = e;
                }
                if (n || r || a) {
                    let t1 = "ClonedMaterial:" + i.uuid + ":";
                    n && (t1 += "derivative-tangents:"), r && (t1 += "vertex-colors:"), a && (t1 += "flat-shading:");
                    let e = this.cache.get(t1);
                    e || (e = i.clone(), r && (e.vertexColors = !0), a && (e.flatShading = !0), n && (e.normalScale && (e.normalScale.y *= -1), e.clearcoatNormalScale && (e.clearcoatNormalScale.y *= -1)), this.cache.add(t1, e), this.associations.set(e, this.associations.get(i))), i = e;
                }
                t1.material = i;
            }
            getMaterialType() {
                return Om;
            }
            loadMaterial(t1) {
                const e = this, i = this.json, n = this.extensions, r = i.materials[t1];
                let a;
                const s = {}, o = [];
                if ((r.extensions || {})[Tv.KHR_MATERIALS_UNLIT]) {
                    const t1 = n[Tv.KHR_MATERIALS_UNLIT];
                    a = t1.getMaterialType(), o.push(t1.extendParams(s, r, e));
                } else {
                    const i = r.pbrMetallicRoughness || {};
                    if (s.color = new Yc(1, 1, 1), s.opacity = 1, Array.isArray(i.baseColorFactor)) {
                        const t1 = i.baseColorFactor;
                        s.color.setRGB(t1[0], t1[1], t1[2], Hs), s.opacity = t1[3];
                    }
                    void 0 !== i.baseColorTexture && o.push(e.assignTexture(s, "map", i.baseColorTexture, Qs)), s.metalness = void 0 !== i.metallicFactor ? i.metallicFactor : 1, s.roughness = void 0 !== i.roughnessFactor ? i.roughnessFactor : 1, void 0 !== i.metallicRoughnessTexture && (o.push(e.assignTexture(s, "metalnessMap", i.metallicRoughnessTexture)), o.push(e.assignTexture(s, "roughnessMap", i.metallicRoughnessTexture))), a = this._invokeOne(function(e) {
                        return e.getMaterialType && e.getMaterialType(t1);
                    }), o.push(Promise.all(this._invokeAll(function(e) {
                        return e.extendMaterialParams && e.extendMaterialParams(t1, s);
                    })));
                }
                !0 === r.doubleSided && (s.side = cr);
                const l = r.alphaMode || "OPAQUE";
                if ("BLEND" === l ? (s.transparent = !0, s.depthWrite = !1) : (s.transparent = !1, "MASK" === l && (s.alphaTest = void 0 !== r.alphaCutoff ? r.alphaCutoff : .5)), void 0 !== r.normalTexture && a !== Jc && (o.push(e.assignTexture(s, "normalMap", r.normalTexture)), s.normalScale = new qo(1, 1), void 0 !== r.normalTexture.scale)) {
                    const t1 = r.normalTexture.scale;
                    s.normalScale.set(t1, t1);
                }
                if (void 0 !== r.occlusionTexture && a !== Jc && (o.push(e.assignTexture(s, "aoMap", r.occlusionTexture)), void 0 !== r.occlusionTexture.strength && (s.aoMapIntensity = r.occlusionTexture.strength)), void 0 !== r.emissiveFactor && a !== Jc) {
                    const t1 = r.emissiveFactor;
                    s.emissive = (new Yc).setRGB(t1[0], t1[1], t1[2], Hs);
                }
                return void 0 !== r.emissiveTexture && a !== Jc && o.push(e.assignTexture(s, "emissiveMap", r.emissiveTexture, Qs)), Promise.all(o).then(function() {
                    const i = new a(s);
                    return r.name && (i.name = r.name), ry(i, r), e.associations.set(i, {
                        materials: t1
                    }), r.extensions && ny(n, i, r), i;
                });
            }
            createUniqueName(t1) {
                const e = bM.sanitizeNodeName(t1 || "");
                return e in this.nodeNamesUsed ? e + "_" + ++this.nodeNamesUsed[e] : (this.nodeNamesUsed[e] = 0, e);
            }
            loadGeometries(t1) {
                const e = this, i = this.extensions, n = this.primitiveCache;
                function r(t1) {
                    return i[Tv.KHR_DRACO_MESH_COMPRESSION].decodePrimitive(t1, e).then(function(i) {
                        return hy(i, t1, e);
                    });
                }
                const a = [];
                for(let i = 0, s = t1.length; i < s; i++){
                    const s = t1[i], o = sy(s), l = n[o];
                    if (l) a.push(l.promise);
                    else {
                        let t1;
                        t1 = s.extensions && s.extensions[Tv.KHR_DRACO_MESH_COMPRESSION] ? r(s) : hy(new bu, s, e), n[o] = {
                            primitive: s,
                            promise: t1
                        }, a.push(t1);
                    }
                }
                return Promise.all(a);
            }
            loadMesh(t1) {
                const e = this, i = this.json, n = this.extensions, r = i.meshes[t1], a = r.primitives, s = [];
                for(let t1 = 0, e = a.length; t1 < e; t1++){
                    const e = void 0 === a[t1].material ? (void 0 === (o = this.cache).DefaultMaterial && (o.DefaultMaterial = new Om({
                        color: 16777215,
                        emissive: 0,
                        metalness: 1,
                        roughness: 1,
                        transparent: !1,
                        depthTest: !0,
                        side: or
                    })), o.DefaultMaterial) : this.getDependency("material", a[t1].material);
                    s.push(e);
                }
                var o;
                return s.push(e.loadGeometries(a)), Promise.all(s).then(function(i) {
                    const s = i.slice(0, i.length - 1), o = i[i.length - 1], l = [];
                    for(let i = 0, c = o.length; i < c; i++){
                        const c = o[i], u = a[i];
                        let h;
                        const d = s[i];
                        if (u.mode === Zv.TRIANGLES || u.mode === Zv.TRIANGLE_STRIP || u.mode === Zv.TRIANGLE_FAN || void 0 === u.mode) h = !0 === r.isSkinnedMesh ? new TA(c, d) : new Fu(c, d), !0 === h.isSkinnedMesh && h.normalizeSkinWeights(), u.mode === Zv.TRIANGLE_STRIP ? h.geometry = xv(h.geometry, Ls) : u.mode === Zv.TRIANGLE_FAN && (h.geometry = xv(h.geometry, Os));
                        else if (u.mode === Zv.LINES) h = new XA(c, d);
                        else if (u.mode === Zv.LINE_STRIP) h = new GA(c, d);
                        else if (u.mode === Zv.LINE_LOOP) h = new ZA(c, d);
                        else {
                            if (u.mode !== Zv.POINTS) throw new Error("THREE.GLTFLoader: Primitive mode unsupported: " + u.mode);
                            h = new ef(c, d);
                        }
                        Object.keys(h.geometry.morphAttributes).length > 0 && ay(h, r), h.name = e.createUniqueName(r.name || "mesh_" + t1), ry(h, r), u.extensions && ny(n, h, u), e.assignFinalMaterial(h), l.push(h);
                    }
                    for(let i = 0, n = l.length; i < n; i++)e.associations.set(l[i], {
                        meshes: t1,
                        primitives: i
                    });
                    if (1 === l.length) return r.extensions && ny(n, l[0], r), l[0];
                    const c = new Pp;
                    r.extensions && ny(n, c, r), e.associations.set(c, {
                        meshes: t1
                    });
                    for(let t1 = 0, e = l.length; t1 < e; t1++)c.add(l[t1]);
                    return c;
                });
            }
            loadCamera(t1) {
                let e;
                const i = this.json.cameras[t1], n = i[i.type];
                if (n) return "perspective" === i.type ? e = new qu(Zo.radToDeg(n.yfov), n.aspectRatio || 1, n.znear || 1, n.zfar || 2e6) : "orthographic" === i.type && (e = new xh(-n.xmag, n.xmag, n.ymag, -n.ymag, n.znear, n.zfar)), i.name && (e.name = this.createUniqueName(i.name)), ry(e, i), Promise.resolve(e);
                console.warn("THREE.GLTFLoader: Missing camera parameters.");
            }
            loadSkin(t1) {
                const e = this.json.skins[t1], i = [];
                for(let t1 = 0, n = e.joints.length; t1 < n; t1++)i.push(this._loadNodeShallow(e.joints[t1]));
                return void 0 !== e.inverseBindMatrices ? i.push(this.getDependency("accessor", e.inverseBindMatrices)) : i.push(null), Promise.all(i).then(function(t1) {
                    const i = t1.pop(), n = t1, r = [], a = [];
                    for(let t1 = 0, s = n.length; t1 < s; t1++){
                        const s = n[t1];
                        if (s) {
                            r.push(s);
                            const e = new ac;
                            null !== i && e.fromArray(i.array, 16 * t1), a.push(e);
                        } else console.warn('THREE.GLTFLoader: Joint "%s" could not be found.', e.joints[t1]);
                    }
                    return new NA(r, a);
                });
            }
            loadAnimation(t1) {
                const e = this.json, i = this, n = e.animations[t1], r = n.name ? n.name : "animation_" + t1, a = [], s = [], o = [], l = [], c = [];
                for(let t1 = 0, e = n.channels.length; t1 < e; t1++){
                    const e = n.channels[t1], i = n.samplers[e.sampler], r = e.target, u = r.node, h = void 0 !== n.parameters ? n.parameters[i.input] : i.input, d = void 0 !== n.parameters ? n.parameters[i.output] : i.output;
                    void 0 !== r.node && (a.push(this.getDependency("node", u)), s.push(this.getDependency("accessor", h)), o.push(this.getDependency("accessor", d)), l.push(i), c.push(r));
                }
                return Promise.all([
                    Promise.all(a),
                    Promise.all(s),
                    Promise.all(o),
                    Promise.all(l),
                    Promise.all(c)
                ]).then(function(t1) {
                    const e = t1[0], n = t1[1], a = t1[2], s = t1[3], o = t1[4], l = [];
                    for(let t1 = 0, r = e.length; t1 < r; t1++){
                        const r = e[t1], c = n[t1], u = a[t1], h = s[t1], d = o[t1];
                        if (void 0 === r) continue;
                        r.updateMatrix && r.updateMatrix();
                        const p = i._createAnimationTracks(r, c, u, h, d);
                        if (p) for(let t1 = 0; t1 < p.length; t1++)l.push(p[t1]);
                    }
                    return new sg(r, void 0, l);
                });
            }
            createNodeMesh(t1) {
                const e = this.json, i = this, n = e.nodes[t1];
                return void 0 === n.mesh ? null : i.getDependency("mesh", n.mesh).then(function(t1) {
                    const e = i._getNodeRef(i.meshCache, n.mesh, t1);
                    return void 0 !== n.weights && e.traverse(function(t1) {
                        if (t1.isMesh) for(let e = 0, i = n.weights.length; e < i; e++)t1.morphTargetInfluences[e] = n.weights[e];
                    }), e;
                });
            }
            loadNode(t1) {
                const e = this, i = this.json.nodes[t1], n = e._loadNodeShallow(t1), r = [], a = i.children || [];
                for(let t1 = 0, i = a.length; t1 < i; t1++)r.push(e.getDependency("node", a[t1]));
                const s = void 0 === i.skin ? Promise.resolve(null) : e.getDependency("skin", i.skin);
                return Promise.all([
                    n,
                    Promise.all(r),
                    s
                ]).then(function(t1) {
                    const e = t1[0], i = t1[1], n = t1[2];
                    null !== n && e.traverse(function(t1) {
                        t1.isSkinnedMesh && t1.bind(n, cy);
                    });
                    for(let t1 = 0, n = i.length; t1 < n; t1++)e.add(i[t1]);
                    return e;
                });
            }
            _loadNodeShallow(t1) {
                const e = this.json, i = this.extensions, n = this;
                if (void 0 !== this.nodeCache[t1]) return this.nodeCache[t1];
                const r = e.nodes[t1], a = r.name ? n.createUniqueName(r.name) : "", s = [], o = n._invokeOne(function(e) {
                    return e.createNodeMesh && e.createNodeMesh(t1);
                });
                return o && s.push(o), void 0 !== r.camera && s.push(n.getDependency("camera", r.camera).then(function(t1) {
                    return n._getNodeRef(n.cameraCache, r.camera, t1);
                })), n._invokeAll(function(e) {
                    return e.createNodeAttachment && e.createNodeAttachment(t1);
                }).forEach(function(t1) {
                    s.push(t1);
                }), this.nodeCache[t1] = Promise.all(s).then(function(e) {
                    let s;
                    if (s = !0 === r.isBone ? new EA : e.length > 1 ? new Pp : 1 === e.length ? e[0] : new Dc, s !== e[0]) for(let t1 = 0, i = e.length; t1 < i; t1++)s.add(e[t1]);
                    if (r.name && (s.userData.name = r.name, s.name = a), ry(s, r), r.extensions && ny(i, s, r), void 0 !== r.matrix) {
                        const t1 = new ac;
                        t1.fromArray(r.matrix), s.applyMatrix4(t1);
                    } else void 0 !== r.translation && s.position.fromArray(r.translation), void 0 !== r.rotation && s.quaternion.fromArray(r.rotation), void 0 !== r.scale && s.scale.fromArray(r.scale);
                    return n.associations.has(s) || n.associations.set(s, {}), n.associations.get(s).nodes = t1, s;
                }), this.nodeCache[t1];
            }
            loadScene(t1) {
                const e = this.extensions, i = this.json.scenes[t1], n = this, r = new Pp;
                i.name && (r.name = n.createUniqueName(i.name)), ry(r, i), i.extensions && ny(e, r, i);
                const a = i.nodes || [], s = [];
                for(let t1 = 0, e = a.length; t1 < e; t1++)s.push(n.getDependency("node", a[t1]));
                return Promise.all(s).then(function(t1) {
                    for(let e = 0, i = t1.length; e < i; e++)r.add(t1[e]);
                    return n.associations = ((t1)=>{
                        const e = new Map;
                        for (const [t1, i] of n.associations)(t1 instanceof qc || t1 instanceof vl) && e.set(t1, i);
                        return t1.traverse((t1)=>{
                            const i = n.associations.get(t1);
                            null != i && e.set(t1, i);
                        }), e;
                    })(r), r;
                });
            }
            _createAnimationTracks(t1, e, i, n, r) {
                const a = [], s = t1.name ? t1.name : t1.uuid, o = [];
                let l;
                switch(ey[r.path] === ey.weights ? t1.traverse(function(t1) {
                    t1.morphTargetInfluences && o.push(t1.name ? t1.name : t1.uuid);
                }) : o.push(s), ey[r.path]){
                    case ey.weights:
                        l = eg;
                        break;
                    case ey.rotation:
                        l = ng;
                        break;
                    case ey.position:
                    case ey.scale:
                        l = ag;
                        break;
                    default:
                        l = 1 === i.itemSize ? eg : ag;
                }
                const c = void 0 !== n.interpolation ? iy[n.interpolation] : Es, u = this._getArrayFromAccessor(i);
                for(let t1 = 0, i = o.length; t1 < i; t1++){
                    const i = new l(o[t1] + "." + ey[r.path], e.array, u, c);
                    "CUBICSPLINE" === n.interpolation && this._createCubicSplineTrackInterpolant(i), a.push(i);
                }
                return a;
            }
            _getArrayFromAccessor(t1) {
                let e = t1.array;
                if (t1.normalized) {
                    const t1 = ly(e.constructor), i = new Float32Array(e.length);
                    for(let n = 0, r = e.length; n < r; n++)i[n] = e[n] * t1;
                    e = i;
                }
                return e;
            }
            _createCubicSplineTrackInterpolant(t1) {
                t1.createInterpolant = function(t1) {
                    return new (this instanceof ng ? Xv : Wv)(this.times, this.values, this.getValueSize() / 3, t1);
                }, t1.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline = !0;
            }
        }
        function hy(t1, e, i) {
            const n = e.attributes, r = [];
            function a(e, n) {
                return i.getDependency("accessor", e).then(function(e) {
                    t1.setAttribute(n, e);
                });
            }
            for(const e in n){
                const i = ty[e] || e.toLowerCase();
                i in t1.attributes || r.push(a(n[e], i));
            }
            if (void 0 !== e.indices && !t1.index) {
                const n = i.getDependency("accessor", e.indices).then(function(e) {
                    t1.setIndex(e);
                });
                r.push(n);
            }
            return ul.workingColorSpace !== Hs && "COLOR_0" in n && console.warn(`THREE.GLTFLoader: Converting vertex colors from "srgb-linear" to "${ul.workingColorSpace}" not supported.`), ry(t1, e), function(t1, e, i) {
                const n = e.attributes, r = new zl;
                if (void 0 === n.POSITION) return;
                {
                    const t1 = i.json.accessors[n.POSITION], e = t1.min, a = t1.max;
                    if (void 0 === e || void 0 === a) return void console.warn("THREE.GLTFLoader: Missing min/max properties for accessor POSITION.");
                    if (r.set(new Nl(e[0], e[1], e[2]), new Nl(a[0], a[1], a[2])), t1.normalized) {
                        const e = ly(qv[t1.componentType]);
                        r.min.multiplyScalar(e), r.max.multiplyScalar(e);
                    }
                }
                const a = e.targets;
                if (void 0 !== a) {
                    const t1 = new Nl, e = new Nl;
                    for(let n = 0, r = a.length; n < r; n++){
                        const r = a[n];
                        if (void 0 !== r.POSITION) {
                            const n = i.json.accessors[r.POSITION], a = n.min, s = n.max;
                            if (void 0 !== a && void 0 !== s) {
                                if (e.setX(Math.max(Math.abs(a[0]), Math.abs(s[0]))), e.setY(Math.max(Math.abs(a[1]), Math.abs(s[1]))), e.setZ(Math.max(Math.abs(a[2]), Math.abs(s[2]))), n.normalized) {
                                    const t1 = ly(qv[n.componentType]);
                                    e.multiplyScalar(t1);
                                }
                                t1.max(e);
                            } else console.warn("THREE.GLTFLoader: Missing min/max properties for accessor POSITION.");
                        }
                    }
                    r.expandByVector(t1);
                }
                t1.boundingBox = r;
                const s = new ql;
                r.getCenter(s.center), s.radius = r.min.distanceTo(r.max) / 2, t1.boundingSphere = s;
            }(t1, e, i), Promise.all(r).then(function() {
                return void 0 !== e.targets ? function(t1, e, i) {
                    let n = !1, r = !1, a = !1;
                    for(let t1 = 0, i = e.length; t1 < i; t1++){
                        const i = e[t1];
                        if (void 0 !== i.POSITION && (n = !0), void 0 !== i.NORMAL && (r = !0), void 0 !== i.COLOR_0 && (a = !0), n && r && a) break;
                    }
                    if (!n && !r && !a) return Promise.resolve(t1);
                    const s = [], o = [], l = [];
                    for(let c = 0, u = e.length; c < u; c++){
                        const u = e[c];
                        if (n) {
                            const e = void 0 !== u.POSITION ? i.getDependency("accessor", u.POSITION) : t1.attributes.position;
                            s.push(e);
                        }
                        if (r) {
                            const e = void 0 !== u.NORMAL ? i.getDependency("accessor", u.NORMAL) : t1.attributes.normal;
                            o.push(e);
                        }
                        if (a) {
                            const e = void 0 !== u.COLOR_0 ? i.getDependency("accessor", u.COLOR_0) : t1.attributes.color;
                            l.push(e);
                        }
                    }
                    return Promise.all([
                        Promise.all(s),
                        Promise.all(o),
                        Promise.all(l)
                    ]).then(function(e) {
                        const i = e[0], s = e[1], o = e[2];
                        return n && (t1.morphAttributes.position = i), r && (t1.morphAttributes.normal = s), a && (t1.morphAttributes.color = o), t1.morphTargetsRelative = !0, t1;
                    });
                }(t1, e.targets, i) : t1;
            });
        }
        const dy = {
            Handedness: Object.freeze({
                NONE: "none",
                LEFT: "left",
                RIGHT: "right"
            }),
            ComponentState: Object.freeze({
                DEFAULT: "default",
                TOUCHED: "touched",
                PRESSED: "pressed"
            }),
            ComponentProperty: Object.freeze({
                BUTTON: "button",
                X_AXIS: "xAxis",
                Y_AXIS: "yAxis",
                STATE: "state"
            }),
            ComponentType: Object.freeze({
                TRIGGER: "trigger",
                SQUEEZE: "squeeze",
                TOUCHPAD: "touchpad",
                THUMBSTICK: "thumbstick",
                BUTTON: "button"
            }),
            ButtonTouchThreshold: .05,
            AxisTouchThreshold: .1,
            VisualResponseProperty: Object.freeze({
                TRANSFORM: "transform",
                VISIBILITY: "visibility"
            })
        };
        async function py(t1) {
            const e = await fetch(t1);
            if (e.ok) return e.json();
            throw new Error(e.statusText);
        }
        const Ay = {
            xAxis: 0,
            yAxis: 0,
            button: 0,
            state: dy.ComponentState.DEFAULT
        };
        class fy {
            constructor(t1){
                this.componentProperty = t1.componentProperty, this.states = t1.states, this.valueNodeName = t1.valueNodeName, this.valueNodeProperty = t1.valueNodeProperty, this.valueNodeProperty === dy.VisualResponseProperty.TRANSFORM && (this.minNodeName = t1.minNodeName, this.maxNodeName = t1.maxNodeName), this.value = 0, this.updateFromComponent(Ay);
            }
            updateFromComponent({ xAxis: t1, yAxis: e, button: i, state: n }) {
                const { normalizedXAxis: r, normalizedYAxis: a } = function(t1 = 0, e = 0) {
                    let i = t1, n = e;
                    if (Math.sqrt(t1 * t1 + e * e) > 1) {
                        const r = Math.atan2(e, t1);
                        i = Math.cos(r), n = Math.sin(r);
                    }
                    return {
                        normalizedXAxis: .5 * i + .5,
                        normalizedYAxis: .5 * n + .5
                    };
                }(t1, e);
                switch(this.componentProperty){
                    case dy.ComponentProperty.X_AXIS:
                        this.value = this.states.includes(n) ? r : .5;
                        break;
                    case dy.ComponentProperty.Y_AXIS:
                        this.value = this.states.includes(n) ? a : .5;
                        break;
                    case dy.ComponentProperty.BUTTON:
                        this.value = this.states.includes(n) ? i : 0;
                        break;
                    case dy.ComponentProperty.STATE:
                        this.valueNodeProperty === dy.VisualResponseProperty.VISIBILITY ? this.value = this.states.includes(n) : this.value = this.states.includes(n) ? 1 : 0;
                        break;
                    default:
                        throw new Error(`Unexpected visualResponse componentProperty ${this.componentProperty}`);
                }
            }
        }
        class my {
            constructor(t1, e){
                if (!(t1 && e && e.visualResponses && e.gamepadIndices && 0 !== Object.keys(e.gamepadIndices).length)) throw new Error("Invalid arguments supplied");
                this.id = t1, this.type = e.type, this.rootNodeName = e.rootNodeName, this.touchPointNodeName = e.touchPointNodeName, this.visualResponses = {}, Object.keys(e.visualResponses).forEach((t1)=>{
                    const i = new fy(e.visualResponses[t1]);
                    this.visualResponses[t1] = i;
                }), this.gamepadIndices = Object.assign({}, e.gamepadIndices), this.values = {
                    state: dy.ComponentState.DEFAULT,
                    button: void 0 !== this.gamepadIndices.button ? 0 : void 0,
                    xAxis: void 0 !== this.gamepadIndices.xAxis ? 0 : void 0,
                    yAxis: void 0 !== this.gamepadIndices.yAxis ? 0 : void 0
                };
            }
            get data() {
                return {
                    id: this.id,
                    ...this.values
                };
            }
            updateFromGamepad(t1) {
                if (this.values.state = dy.ComponentState.DEFAULT, void 0 !== this.gamepadIndices.button && t1.buttons.length > this.gamepadIndices.button) {
                    const e = t1.buttons[this.gamepadIndices.button];
                    this.values.button = e.value, this.values.button = this.values.button < 0 ? 0 : this.values.button, this.values.button = this.values.button > 1 ? 1 : this.values.button, e.pressed || 1 === this.values.button ? this.values.state = dy.ComponentState.PRESSED : (e.touched || this.values.button > dy.ButtonTouchThreshold) && (this.values.state = dy.ComponentState.TOUCHED);
                }
                void 0 !== this.gamepadIndices.xAxis && t1.axes.length > this.gamepadIndices.xAxis && (this.values.xAxis = t1.axes[this.gamepadIndices.xAxis], this.values.xAxis = this.values.xAxis < -1 ? -1 : this.values.xAxis, this.values.xAxis = this.values.xAxis > 1 ? 1 : this.values.xAxis, this.values.state === dy.ComponentState.DEFAULT && Math.abs(this.values.xAxis) > dy.AxisTouchThreshold && (this.values.state = dy.ComponentState.TOUCHED)), void 0 !== this.gamepadIndices.yAxis && t1.axes.length > this.gamepadIndices.yAxis && (this.values.yAxis = t1.axes[this.gamepadIndices.yAxis], this.values.yAxis = this.values.yAxis < -1 ? -1 : this.values.yAxis, this.values.yAxis = this.values.yAxis > 1 ? 1 : this.values.yAxis, this.values.state === dy.ComponentState.DEFAULT && Math.abs(this.values.yAxis) > dy.AxisTouchThreshold && (this.values.state = dy.ComponentState.TOUCHED)), Object.values(this.visualResponses).forEach((t1)=>{
                    t1.updateFromComponent(this.values);
                });
            }
        }
        class gy {
            constructor(t1, e, i){
                if (!t1) throw new Error("No xrInputSource supplied");
                if (!e) throw new Error("No profile supplied");
                this.xrInputSource = t1, this.assetUrl = i, this.id = e.profileId, this.layoutDescription = e.layouts[t1.handedness], this.components = {}, Object.keys(this.layoutDescription.components).forEach((t1)=>{
                    const e = this.layoutDescription.components[t1];
                    this.components[t1] = new my(t1, e);
                }), this.updateFromGamepad();
            }
            get gripSpace() {
                return this.xrInputSource.gripSpace;
            }
            get targetRaySpace() {
                return this.xrInputSource.targetRaySpace;
            }
            get data() {
                const t1 = [];
                return Object.values(this.components).forEach((e)=>{
                    t1.push(e.data);
                }), t1;
            }
            updateFromGamepad() {
                Object.values(this.components).forEach((t1)=>{
                    t1.updateFromGamepad(this.xrInputSource.gamepad);
                });
            }
        }
        class My extends Dc {
            constructor(){
                super(), this.motionController = null, this.envMap = null;
            }
            setEnvironmentMap(t1) {
                return this.envMap == t1 || (this.envMap = t1, this.traverse((t1)=>{
                    t1.isMesh && (t1.material.envMap = this.envMap, t1.material.needsUpdate = !0);
                })), this;
            }
            updateMatrixWorld(t1) {
                super.updateMatrixWorld(t1), this.motionController && (this.motionController.updateFromGamepad(), Object.values(this.motionController.components).forEach((t1)=>{
                    Object.values(t1.visualResponses).forEach((t1)=>{
                        const { valueNode: e, minNode: i, maxNode: n, value: r, valueNodeProperty: a } = t1;
                        e && (a === dy.VisualResponseProperty.VISIBILITY ? e.visible = r : a === dy.VisualResponseProperty.TRANSFORM && (e.quaternion.slerpQuaternions(i.quaternion, n.quaternion, r), e.position.lerpVectors(i.position, n.position, r)));
                    });
                }));
            }
        }
        function vy(t1, e) {
            !function(t1, e) {
                Object.values(t1.components).forEach((t1)=>{
                    const { type: i, touchPointNodeName: n, visualResponses: r } = t1;
                    if (i === dy.ComponentType.TOUCHPAD) {
                        if (t1.touchPointNode = e.getObjectByName(n), t1.touchPointNode) {
                            const e = new Tm(.001), i = new Jc({
                                color: 255
                            }), n = new Fu(e, i);
                            t1.touchPointNode.add(n);
                        } else console.warn(`Could not find touch dot, ${t1.touchPointNodeName}, in touchpad component ${t1.id}`);
                    }
                    Object.values(r).forEach((t1)=>{
                        const { valueNodeName: i, minNodeName: n, maxNodeName: r, valueNodeProperty: a } = t1;
                        if (a === dy.VisualResponseProperty.TRANSFORM) {
                            if (t1.minNode = e.getObjectByName(n), t1.maxNode = e.getObjectByName(r), !t1.minNode) return void console.warn(`Could not find ${n} in the model`);
                            if (!t1.maxNode) return void console.warn(`Could not find ${r} in the model`);
                        }
                        t1.valueNode = e.getObjectByName(i), t1.valueNode || console.warn(`Could not find ${i} in the model`);
                    });
                });
            }(t1.motionController, e), t1.envMap && e.traverse((e)=>{
                e.isMesh && (e.material.envMap = t1.envMap, e.material.needsUpdate = !0);
            }), t1.add(e);
        }
        class yy {
            constructor(t1 = null){
                this.gltfLoader = t1, this.path = "https://cdn.jsdelivr.net/npm/@webxr-input-profiles/assets@1.0/dist/profiles", this._assetCache = {}, this.gltfLoader || (this.gltfLoader = new wv);
            }
            createControllerModel(t1) {
                const e = new My;
                let i = null;
                return t1.addEventListener("connected", (t1)=>{
                    const n = t1.data;
                    "tracked-pointer" === n.targetRayMode && n.gamepad && (async function(t1, e, i = null, n = !0) {
                        if (!t1) throw new Error("No xrInputSource supplied");
                        if (!e) throw new Error("No basePath supplied");
                        const r = await async function(t1) {
                            if (!t1) throw new Error("No basePath supplied");
                            return await py(`${t1}/profilesList.json`);
                        }(e);
                        let a;
                        if (t1.profiles.some((t1)=>{
                            const i = r[t1];
                            return i && (a = {
                                profileId: t1,
                                profilePath: `${e}/${i.path}`,
                                deprecated: !!i.deprecated
                            }), !!a;
                        }), !a) {
                            if (!i) throw new Error("No matching profile name found");
                            const t1 = r[i];
                            if (!t1) throw new Error(`No matching profile name found and default profile "${i}" missing.`);
                            a = {
                                profileId: i,
                                profilePath: `${e}/${t1.path}`,
                                deprecated: !!t1.deprecated
                            };
                        }
                        const s = await py(a.profilePath);
                        let o;
                        if (n) {
                            let e;
                            if (e = "any" === t1.handedness ? s.layouts[Object.keys(s.layouts)[0]] : s.layouts[t1.handedness], !e) throw new Error(`No matching handedness, ${t1.handedness}, in profile ${a.profileId}`);
                            e.assetPath && (o = a.profilePath.replace("profile.json", e.assetPath));
                        }
                        return {
                            profile: s,
                            assetPath: o
                        };
                    })(n, this.path, "generic-trigger").then(({ profile: t1, assetPath: r })=>{
                        e.motionController = new gy(n, t1, r);
                        const a = this._assetCache[e.motionController.assetUrl];
                        if (a) i = a.scene.clone(), vy(e, i);
                        else {
                            if (!this.gltfLoader) throw new Error("GLTFLoader not set.");
                            this.gltfLoader.setPath(""), this.gltfLoader.load(e.motionController.assetUrl, (t1)=>{
                                this._assetCache[e.motionController.assetUrl] = t1, i = t1.scene.clone(), vy(e, i);
                            }, null, ()=>{
                                throw new Error(`Asset ${e.motionController.assetUrl} missing or malformed.`);
                            });
                        }
                    }).catch((t1)=>{
                        console.warn(t1);
                    });
                }), t1.addEventListener("disconnected", ()=>{
                    e.motionController = null, e.remove(i), i = null;
                }), e;
            }
        }
        const xy = new ac, wy = new Nl;
        class by {
            constructor(t1, e, i, n, r){
                let a;
                this.controller = e, this.handModel = t1, this.envMap = null, r && r.primitive && "sphere" !== r.primitive ? "box" === r.primitive && (a = new Hu(1, 1, 1)) : a = new Tm(1, 10, 10);
                const s = new Om;
                this.handMesh = new kA(a, s, 30), this.handMesh.frustumCulled = !1, this.handMesh.instanceMatrix.setUsage(wo), this.handMesh.castShadow = !0, this.handMesh.receiveShadow = !0, this.handModel.add(this.handMesh), this.joints = [
                    "wrist",
                    "thumb-metacarpal",
                    "thumb-phalanx-proximal",
                    "thumb-phalanx-distal",
                    "thumb-tip",
                    "index-finger-metacarpal",
                    "index-finger-phalanx-proximal",
                    "index-finger-phalanx-intermediate",
                    "index-finger-phalanx-distal",
                    "index-finger-tip",
                    "middle-finger-metacarpal",
                    "middle-finger-phalanx-proximal",
                    "middle-finger-phalanx-intermediate",
                    "middle-finger-phalanx-distal",
                    "middle-finger-tip",
                    "ring-finger-metacarpal",
                    "ring-finger-phalanx-proximal",
                    "ring-finger-phalanx-intermediate",
                    "ring-finger-phalanx-distal",
                    "ring-finger-tip",
                    "pinky-finger-metacarpal",
                    "pinky-finger-phalanx-proximal",
                    "pinky-finger-phalanx-intermediate",
                    "pinky-finger-phalanx-distal",
                    "pinky-finger-tip"
                ];
            }
            updateMesh() {
                const t1 = this.controller.joints;
                let e = 0;
                for(let i = 0; i < this.joints.length; i++){
                    const n = t1[this.joints[i]];
                    n.visible && (wy.setScalar(n.jointRadius || .008), xy.compose(n.position, n.quaternion, wy), this.handMesh.setMatrixAt(i, xy), e++);
                }
                this.handMesh.count = e, this.handMesh.instanceMatrix.needsUpdate = !0;
            }
        }
        class Ty {
            constructor(t1, e, i, n, r = null){
                this.controller = e, this.handModel = t1, this.bones = [], null === r && (r = new wv).setPath(i || "https://cdn.jsdelivr.net/npm/@webxr-input-profiles/assets@1.0/dist/profiles/generic-hand/"), r.load(`${n}.glb`, (t1)=>{
                    const e = t1.scene.children[0];
                    this.handModel.add(e);
                    const i = e.getObjectByProperty("type", "SkinnedMesh");
                    i.frustumCulled = !1, i.castShadow = !0, i.receiveShadow = !0, [
                        "wrist",
                        "thumb-metacarpal",
                        "thumb-phalanx-proximal",
                        "thumb-phalanx-distal",
                        "thumb-tip",
                        "index-finger-metacarpal",
                        "index-finger-phalanx-proximal",
                        "index-finger-phalanx-intermediate",
                        "index-finger-phalanx-distal",
                        "index-finger-tip",
                        "middle-finger-metacarpal",
                        "middle-finger-phalanx-proximal",
                        "middle-finger-phalanx-intermediate",
                        "middle-finger-phalanx-distal",
                        "middle-finger-tip",
                        "ring-finger-metacarpal",
                        "ring-finger-phalanx-proximal",
                        "ring-finger-phalanx-intermediate",
                        "ring-finger-phalanx-distal",
                        "ring-finger-tip",
                        "pinky-finger-metacarpal",
                        "pinky-finger-phalanx-proximal",
                        "pinky-finger-phalanx-intermediate",
                        "pinky-finger-phalanx-distal",
                        "pinky-finger-tip"
                    ].forEach((t1)=>{
                        const i = e.getObjectByName(t1);
                        void 0 !== i ? i.jointName = t1 : console.warn(`Couldn't find ${t1} in ${n} hand mesh`), this.bones.push(i);
                    });
                });
            }
            updateMesh() {
                const t1 = this.controller.joints;
                for(let e = 0; e < this.bones.length; e++){
                    const i = this.bones[e];
                    if (i) {
                        const e = t1[i.jointName];
                        if (e.visible) {
                            const t1 = e.position;
                            i.position.copy(t1), i.quaternion.copy(e.quaternion);
                        }
                    }
                }
            }
        }
        class Ey extends Dc {
            constructor(t1){
                super(), this.controller = t1, this.motionController = null, this.envMap = null, this.mesh = null;
            }
            updateMatrixWorld(t1) {
                super.updateMatrixWorld(t1), this.motionController && this.motionController.updateMesh();
            }
        }
        class _y {
            constructor(){
                this.path = null;
            }
            setPath(t1) {
                return this.path = t1, this;
            }
            createHandModel(t1, e) {
                const i = new Ey(t1);
                return t1.addEventListener("connected", (n)=>{
                    const r = n.data;
                    r.hand && !i.motionController && (i.xrInputSource = r, void 0 === e || "spheres" === e ? i.motionController = new by(i, t1, this.path, r.handedness, {
                        primitive: "sphere"
                    }) : "boxes" === e ? i.motionController = new by(i, t1, this.path, r.handedness, {
                        primitive: "box"
                    }) : "mesh" === e && (i.motionController = new Ty(i, t1, this.path, r.handedness))), t1.visible = !0;
                }), t1.addEventListener("disconnected", ()=>{
                    t1.visible = !1;
                }), i;
            }
        }
        function Iy(t1) {
            return Math.sqrt(Math.pow(t1[1][0] - t1[0][0], 2) + Math.pow(t1[1][1] - t1[0][1], 2));
        }
        const Sy = 3.280839895, Ny = (t1)=>{
            t1.preventDefault();
        }, Dy = async (t1)=>{
            const e = new Promise((e)=>{
                const i = new Image;
                i.onload = ()=>e(i), i.src = t1;
            });
            return await e;
        }, Cy = (t1, e, i, n, r, a)=>{
            let s = a;
            n < 2 * s && (s = n / 2), r < 2 * a && (s = r / 2), t1.beginPath(), t1.moveTo(e + s, i), t1.arcTo(e + n, i, e + n, i + r, s), t1.arcTo(e + n, i + r, e, i + r, s), t1.arcTo(e, i + r, e, i, s), t1.arcTo(e, i, e + n, i, s), t1.closePath();
        }, zy = function(t1) {
            var e, i;
            let n = null !== (e = null === (i = Un.dictionaryOverrides) || void 0 === i ? void 0 : i[t1]) && void 0 !== e ? e : Rn.getLocaleText(t1);
            for(var r = arguments.length, a = new Array(r > 1 ? r - 1 : 0), s = 1; s < r; s++)a[s - 1] = arguments[s];
            return Un.config.floorNumberEndingsVisible && "floor" === t1 ? a.reduce((t1, e, i)=>{
                var n;
                return t1.replaceAll("$".concat(i), e + (null !== (n = Rn.getLocaleText("floorNumberEndings")[e]) && void 0 !== n ? n : Rn.getLocaleText("floorNumberEndings").rest));
            }, n) : a.reduce((t1, e, i)=>t1.replaceAll("$".concat(i), e), n);
        }, Ly = (t1)=>{
            const e = Math.floor(t1 * Sy), i = 12 * (t1 * Sy - e);
            return "".concat(e, "'").concat(Math.round(i), '"');
        };
        function Oy(t1, e, i) {
            (function(t1, e) {
                if (e.has(t1)) throw new TypeError("Cannot initialize the same private elements twice on an object");
            })(t1, e), e.set(t1, i);
        }
        function Py(t1, e) {
            return t1.get(Ry(t1, e));
        }
        function jy(t1, e, i) {
            return t1.set(Ry(t1, e), i), i;
        }
        function Ry(t1, e, i) {
            if ("function" == typeof t1 ? t1 === e : t1.has(e)) return arguments.length < 3 ? e : i;
            throw new TypeError("Private element is not present on this object");
        }
        var ky = new WeakMap, Uy = new WeakMap;
        const By = new class {
            constructor(){
                Oy(this, ky, void 0), Oy(this, Uy, void 0), jy(ky, this, {}), jy(Uy, this, {});
            }
            async get(t1) {
                return t1 ? (Py(ky, this)[t1] || await this.cache(t1), Py(ky, this)[t1]) : null;
            }
            async cache(t1) {
                if (!t1) return void console.warn("Cache empty url skipped!");
                if (this.isCached(t1)) return;
                if (this.isLoading(t1)) return await function(t1, e) {
                    let i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 100;
                    return new Promise((n)=>{
                        const r = setInterval(()=>{
                            t1() || (clearInterval(r), n(e));
                        }, i);
                    });
                }(()=>this.isLoading(t1)), void console.log("Await texture resolved");
                Py(Uy, this)[t1] = !0;
                const e = await (new yg).loadAsync(t1);
                e.center = new qo(.5, .5), e.colorSpace = Qs, e.minFilter = ya, e.magFilter = ma, e.anisotropy = 8, Py(ky, this)[t1] = e, Py(Uy, this)[t1] = !1;
            }
            isCached(t1) {
                return null != Py(ky, this)[t1];
            }
            isLoading(t1) {
                return Py(Uy, this)[t1];
            }
            invalidate(t1) {
                delete Py(ky, this)[t1], delete Py(Uy, this)[t1];
            }
            clear() {
                jy(ky, this, {}), jy(Uy, this, {});
            }
        };
        var Fy = function(t1) {
            return URL.createObjectURL(new Blob([
                t1
            ], {
                type: "text/javascript"
            }));
        };
        try {
            URL.revokeObjectURL(Fy(""));
        } catch (t1) {
            Fy = function(t1) {
                return "data:application/javascript;charset=UTF-8," + encodeURI(t1);
            };
        }
        var Qy = Uint8Array, Hy = Uint16Array, Vy = Uint32Array, Gy = new Qy([
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1,
            1,
            1,
            1,
            2,
            2,
            2,
            2,
            3,
            3,
            3,
            3,
            4,
            4,
            4,
            4,
            5,
            5,
            5,
            5,
            0,
            0,
            0,
            0
        ]), Wy = new Qy([
            0,
            0,
            0,
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            4,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            8,
            8,
            9,
            9,
            10,
            10,
            11,
            11,
            12,
            12,
            13,
            13,
            0,
            0
        ]), Yy = new Qy([
            16,
            17,
            18,
            0,
            8,
            7,
            9,
            6,
            10,
            5,
            11,
            4,
            12,
            3,
            13,
            2,
            14,
            1,
            15
        ]), Xy = function(t1, e) {
            for(var i = new Hy(31), n = 0; n < 31; ++n)i[n] = e += 1 << t1[n - 1];
            var r = new Vy(i[30]);
            for(n = 1; n < 30; ++n)for(var a = i[n]; a < i[n + 1]; ++a)r[a] = a - i[n] << 5 | n;
            return [
                i,
                r
            ];
        }, Zy = Xy(Gy, 2), qy = Zy[0], Jy = Zy[1];
        qy[28] = 258, Jy[258] = 28;
        for(var Ky = Xy(Wy, 0), $y = Ky[0], tx = (Ky[1], new Hy(32768)), ex = 0; ex < 32768; ++ex){
            var ix = (43690 & ex) >>> 1 | (21845 & ex) << 1;
            ix = (61680 & (ix = (52428 & ix) >>> 2 | (13107 & ix) << 2)) >>> 4 | (3855 & ix) << 4, tx[ex] = ((65280 & ix) >>> 8 | (255 & ix) << 8) >>> 1;
        }
        var nx = function(t1, e, i) {
            for(var n = t1.length, r = 0, a = new Hy(e); r < n; ++r)++a[t1[r] - 1];
            var s, o = new Hy(e);
            for(r = 0; r < e; ++r)o[r] = o[r - 1] + a[r - 1] << 1;
            if (i) {
                s = new Hy(1 << e);
                var l = 15 - e;
                for(r = 0; r < n; ++r)if (t1[r]) for(var c = r << 4 | t1[r], u = e - t1[r], h = o[t1[r] - 1]++ << u, d = h | (1 << u) - 1; h <= d; ++h)s[tx[h] >>> l] = c;
            } else for(s = new Hy(n), r = 0; r < n; ++r)t1[r] && (s[r] = tx[o[t1[r] - 1]++] >>> 15 - t1[r]);
            return s;
        }, rx = new Qy(288);
        for(ex = 0; ex < 144; ++ex)rx[ex] = 8;
        for(ex = 144; ex < 256; ++ex)rx[ex] = 9;
        for(ex = 256; ex < 280; ++ex)rx[ex] = 7;
        for(ex = 280; ex < 288; ++ex)rx[ex] = 8;
        var ax = new Qy(32);
        for(ex = 0; ex < 32; ++ex)ax[ex] = 5;
        var sx = nx(rx, 9, 1), ox = nx(ax, 5, 1), lx = function(t1) {
            for(var e = t1[0], i = 1; i < t1.length; ++i)t1[i] > e && (e = t1[i]);
            return e;
        }, cx = function(t1, e, i) {
            var n = e / 8 | 0;
            return (t1[n] | t1[n + 1] << 8) >> (7 & e) & i;
        }, ux = function(t1, e) {
            var i = e / 8 | 0;
            return (t1[i] | t1[i + 1] << 8 | t1[i + 2] << 16) >> (7 & e);
        }, hx = function(t1, e, i) {
            var n = t1.length;
            if (!n || i && !i.l && n < 5) return e || new Qy(0);
            var r = !e || i, a = !i || i.i;
            i || (i = {}), e || (e = new Qy(3 * n));
            var s, o = function(t1) {
                var i = e.length;
                if (t1 > i) {
                    var n = new Qy(Math.max(2 * i, t1));
                    n.set(e), e = n;
                }
            }, l = i.f || 0, c = i.p || 0, u = i.b || 0, h = i.l, d = i.d, p = i.m, A = i.n, f = 8 * n;
            do {
                if (!h) {
                    i.f = l = cx(t1, c, 1);
                    var m = cx(t1, c + 1, 3);
                    if (c += 3, !m) {
                        var g = t1[s = c, (S = (s / 8 | 0) + (7 & s && 1) + 4) - 4] | t1[S - 3] << 8, M = S + g;
                        if (M > n) {
                            if (a) throw "unexpected EOF";
                            break;
                        }
                        r && o(u + g), e.set(t1.subarray(S, M), u), i.b = u += g, i.p = c = 8 * M;
                        continue;
                    }
                    if (1 == m) h = sx, d = ox, p = 9, A = 5;
                    else {
                        if (2 != m) throw "invalid block type";
                        var v = cx(t1, c, 31) + 257, y = cx(t1, c + 10, 15) + 4, x = v + cx(t1, c + 5, 31) + 1;
                        c += 14;
                        for(var w = new Qy(x), b = new Qy(19), T = 0; T < y; ++T)b[Yy[T]] = cx(t1, c + 3 * T, 7);
                        c += 3 * y;
                        var E = lx(b), _ = (1 << E) - 1, I = nx(b, E, 1);
                        for(T = 0; T < x;){
                            var S, N = I[cx(t1, c, _)];
                            if (c += 15 & N, (S = N >>> 4) < 16) w[T++] = S;
                            else {
                                var D = 0, C = 0;
                                for(16 == S ? (C = 3 + cx(t1, c, 3), c += 2, D = w[T - 1]) : 17 == S ? (C = 3 + cx(t1, c, 7), c += 3) : 18 == S && (C = 11 + cx(t1, c, 127), c += 7); C--;)w[T++] = D;
                            }
                        }
                        var z = w.subarray(0, v), L = w.subarray(v);
                        p = lx(z), A = lx(L), h = nx(z, p, 1), d = nx(L, A, 1);
                    }
                    if (c > f) {
                        if (a) throw "unexpected EOF";
                        break;
                    }
                }
                r && o(u + 131072);
                for(var O = (1 << p) - 1, P = (1 << A) - 1, j = c;; j = c){
                    var R = (D = h[ux(t1, c) & O]) >>> 4;
                    if ((c += 15 & D) > f) {
                        if (a) throw "unexpected EOF";
                        break;
                    }
                    if (!D) throw "invalid length/literal";
                    if (R < 256) e[u++] = R;
                    else {
                        if (256 == R) {
                            j = c, h = null;
                            break;
                        }
                        var k = R - 254;
                        if (R > 264) {
                            var U = Gy[T = R - 257];
                            k = cx(t1, c, (1 << U) - 1) + qy[T], c += U;
                        }
                        var B = d[ux(t1, c) & P], F = B >>> 4;
                        if (!B) throw "invalid distance";
                        if (c += 15 & B, L = $y[F], F > 3 && (U = Wy[F], L += ux(t1, c) & (1 << U) - 1, c += U), c > f) {
                            if (a) throw "unexpected EOF";
                            break;
                        }
                        r && o(u + 131072);
                        for(var Q = u + k; u < Q; u += 4)e[u] = e[u - L], e[u + 1] = e[u + 1 - L], e[u + 2] = e[u + 2 - L], e[u + 3] = e[u + 3 - L];
                        u = Q;
                    }
                }
                i.l = h, i.p = j, i.b = u, h && (l = 1, i.m = p, i.d = d, i.n = A);
            }while (!l);
            return u == e.length ? e : function(t1, e, i) {
                (null == e || e < 0) && (e = 0), (null == i || i > t1.length) && (i = t1.length);
                var n = new (t1 instanceof Hy ? Hy : t1 instanceof Vy ? Vy : Qy)(i - e);
                return n.set(t1.subarray(e, i)), n;
            }(e, 0, u);
        }, dx = new Qy(0);
        function px(t1, e) {
            return hx((function(t1) {
                if (8 != (15 & t1[0]) || t1[0] >>> 4 > 7 || (t1[0] << 8 | t1[1]) % 31) throw "invalid zlib data";
                if (32 & t1[1]) throw "invalid zlib data: preset dictionaries not supported";
            }(t1), t1.subarray(2, -4)), e);
        }
        var Ax = "undefined" != typeof TextDecoder && new TextDecoder;
        try {
            Ax.decode(dx, {
                stream: !0
            });
        } catch (t1) {}
        class fx extends vg {
            constructor(t1){
                super(t1), this.type = Sa;
            }
            parse(t1) {
                const e = 65536, i = 14, n = 65537, r = Math.pow(2.7182818, 2.2), a = {
                    l: 0,
                    c: 0,
                    lc: 0
                };
                function s(t1, e, i, n, r) {
                    for(; i < t1;)e = e << 8 | R(n, r), i += 8;
                    i -= t1, a.l = e >> i & (1 << t1) - 1, a.c = e, a.lc = i;
                }
                const o = new Array(59);
                function l(t1) {
                    return 63 & t1;
                }
                function c(t1) {
                    return t1 >> 6;
                }
                const u = {
                    c: 0,
                    lc: 0
                };
                function h(t1, e, i, n) {
                    t1 = t1 << 8 | R(i, n), e += 8, u.c = t1, u.lc = e;
                }
                const d = {
                    c: 0,
                    lc: 0
                };
                function p(t1, e, i, n, r, a, s, o, l) {
                    if (t1 == e) {
                        n < 8 && (h(i, n, r, a), i = u.c, n = u.lc);
                        let t1 = i >> (n -= 8);
                        if (t1 = new Uint8Array([
                            t1
                        ])[0], o.value + t1 > l) return !1;
                        const e = s[o.value - 1];
                        for(; t1-- > 0;)s[o.value++] = e;
                    } else {
                        if (!(o.value < l)) return !1;
                        s[o.value++] = t1;
                    }
                    d.c = i, d.lc = n;
                }
                function A(t1) {
                    return 65535 & t1;
                }
                function f(t1) {
                    const e = A(t1);
                    return e > 32767 ? e - 65536 : e;
                }
                const m = {
                    a: 0,
                    b: 0
                };
                function g(t1, e) {
                    const i = f(t1), n = f(e), r = i + (1 & n) + (n >> 1), a = r, s = r - n;
                    m.a = a, m.b = s;
                }
                function M(t1, e) {
                    const i = A(t1), n = A(e), r = i - (n >> 1) & 65535, a = n + r - 32768 & 65535;
                    m.a = a, m.b = r;
                }
                function v(t1, e, i, n, r, a, s) {
                    const o = s < 16384, l = i > r ? r : i;
                    let c, u, h = 1;
                    for(; h <= l;)h <<= 1;
                    for(h >>= 1, c = h, h >>= 1; h >= 1;){
                        u = 0;
                        const s = u + a * (r - c), l = a * h, d = a * c, p = n * h, A = n * c;
                        let f, v, y, x;
                        for(; u <= s; u += d){
                            let r = u;
                            const a = u + n * (i - c);
                            for(; r <= a; r += A){
                                const i = r + p, n = r + l, a = n + p;
                                o ? (g(t1[r + e], t1[n + e]), f = m.a, y = m.b, g(t1[i + e], t1[a + e]), v = m.a, x = m.b, g(f, v), t1[r + e] = m.a, t1[i + e] = m.b, g(y, x), t1[n + e] = m.a, t1[a + e] = m.b) : (M(t1[r + e], t1[n + e]), f = m.a, y = m.b, M(t1[i + e], t1[a + e]), v = m.a, x = m.b, M(f, v), t1[r + e] = m.a, t1[i + e] = m.b, M(y, x), t1[n + e] = m.a, t1[a + e] = m.b);
                            }
                            if (i & h) {
                                const i = r + l;
                                o ? g(t1[r + e], t1[i + e]) : M(t1[r + e], t1[i + e]), f = m.a, t1[i + e] = m.b, t1[r + e] = f;
                            }
                        }
                        if (r & h) {
                            let r = u;
                            const a = u + n * (i - c);
                            for(; r <= a; r += A){
                                const i = r + p;
                                o ? g(t1[r + e], t1[i + e]) : M(t1[r + e], t1[i + e]), f = m.a, t1[i + e] = m.b, t1[r + e] = f;
                            }
                        }
                        c = h, h >>= 1;
                    }
                    return u;
                }
                function y(t1, e, r, A, f, m) {
                    const g = r.value, M = j(e, r), v = j(e, r);
                    r.value += 4;
                    const y = j(e, r);
                    if (r.value += 4, M < 0 || M >= n || v < 0 || v >= n) throw new Error("Something wrong with HUF_ENCSIZE");
                    const x = new Array(n), w = new Array(16384);
                    if (function(t1) {
                        for(let e = 0; e < 16384; e++)t1[e] = {}, t1[e].len = 0, t1[e].lit = 0, t1[e].p = null;
                    }(w), function(t1, e, i, r, l, c) {
                        const u = e;
                        let h = 0, d = 0;
                        for(; r <= l; r++){
                            if (u.value - e.value > i) return !1;
                            s(6, h, d, t1, u);
                            const n = a.l;
                            if (h = a.c, d = a.lc, c[r] = n, 63 == n) {
                                if (u.value - e.value > i) throw new Error("Something wrong with hufUnpackEncTable");
                                s(8, h, d, t1, u);
                                let n = a.l + 6;
                                if (h = a.c, d = a.lc, r + n > l + 1) throw new Error("Something wrong with hufUnpackEncTable");
                                for(; n--;)c[r++] = 0;
                                r--;
                            } else if (n >= 59) {
                                let t1 = n - 59 + 2;
                                if (r + t1 > l + 1) throw new Error("Something wrong with hufUnpackEncTable");
                                for(; t1--;)c[r++] = 0;
                                r--;
                            }
                        }
                        !function(t1) {
                            for(let t1 = 0; t1 <= 58; ++t1)o[t1] = 0;
                            for(let e = 0; e < n; ++e)o[t1[e]] += 1;
                            let e = 0;
                            for(let t1 = 58; t1 > 0; --t1){
                                const i = e + o[t1] >> 1;
                                o[t1] = e, e = i;
                            }
                            for(let e = 0; e < n; ++e){
                                const i = t1[e];
                                i > 0 && (t1[e] = i | o[i]++ << 6);
                            }
                        }(c);
                    }(t1, r, A - (r.value - g), M, v, x), y > 8 * (A - (r.value - g))) throw new Error("Something wrong with hufUncompress");
                    !function(t1, e, n, r) {
                        for(; e <= n; e++){
                            const n = c(t1[e]), a = l(t1[e]);
                            if (n >> a) throw new Error("Invalid table entry");
                            if (a > i) {
                                const t1 = r[n >> a - i];
                                if (t1.len) throw new Error("Invalid table entry");
                                if (t1.lit++, t1.p) {
                                    const e = t1.p;
                                    t1.p = new Array(t1.lit);
                                    for(let i = 0; i < t1.lit - 1; ++i)t1.p[i] = e[i];
                                } else t1.p = new Array(1);
                                t1.p[t1.lit - 1] = e;
                            } else if (a) {
                                let t1 = 0;
                                for(let s = 1 << i - a; s > 0; s--){
                                    const s = r[(n << i - a) + t1];
                                    if (s.len || s.p) throw new Error("Invalid table entry");
                                    s.len = a, s.lit = e, t1++;
                                }
                            }
                        }
                    }(x, M, v, w), function(t1, e, n, r, a, s, o, A, f) {
                        let m = 0, g = 0;
                        const M = o, v = Math.trunc(r.value + (a + 7) / 8);
                        for(; r.value < v;)for(h(m, g, n, r), m = u.c, g = u.lc; g >= i;){
                            const a = e[m >> g - i & 16383];
                            if (a.len) g -= a.len, p(a.lit, s, m, g, n, r, A, f, M), m = d.c, g = d.lc;
                            else {
                                if (!a.p) throw new Error("hufDecode issues");
                                let e;
                                for(e = 0; e < a.lit; e++){
                                    const i = l(t1[a.p[e]]);
                                    for(; g < i && r.value < v;)h(m, g, n, r), m = u.c, g = u.lc;
                                    if (g >= i && c(t1[a.p[e]]) == (m >> g - i & (1 << i) - 1)) {
                                        g -= i, p(a.p[e], s, m, g, n, r, A, f, M), m = d.c, g = d.lc;
                                        break;
                                    }
                                }
                                if (e == a.lit) throw new Error("hufDecode issues");
                            }
                        }
                        const y = 8 - a & 7;
                        for(m >>= y, g -= y; g > 0;){
                            const t1 = e[m << i - g & 16383];
                            if (!t1.len) throw new Error("hufDecode issues");
                            g -= t1.len, p(t1.lit, s, m, g, n, r, A, f, M), m = d.c, g = d.lc;
                        }
                    }(x, w, t1, r, y, v, m, f, {
                        value: 0
                    });
                }
                function x(t1) {
                    for(let e = 1; e < t1.length; e++){
                        const i = t1[e - 1] + t1[e] - 128;
                        t1[e] = i;
                    }
                }
                function w(t1, e) {
                    let i = 0, n = Math.floor((t1.length + 1) / 2), r = 0;
                    const a = t1.length - 1;
                    for(; !(r > a || (e[r++] = t1[i++], r > a));)e[r++] = t1[n++];
                }
                function b(t1) {
                    let e = t1.byteLength;
                    const i = new Array;
                    let n = 0;
                    const r = new DataView(t1);
                    for(; e > 0;){
                        const t1 = r.getInt8(n++);
                        if (t1 < 0) {
                            const a = -t1;
                            e -= a + 1;
                            for(let t1 = 0; t1 < a; t1++)i.push(r.getUint8(n++));
                        } else {
                            const a = t1;
                            e -= 2;
                            const s = r.getUint8(n++);
                            for(let t1 = 0; t1 < a + 1; t1++)i.push(s);
                        }
                    }
                    return i;
                }
                function T(t1, e, i) {
                    let n, r = 1;
                    for(; r < 64;)n = e[t1.value], 65280 == n ? r = 64 : n >> 8 == 255 ? r += 255 & n : (i[r] = n, r++), t1.value++;
                }
                function E(t1) {
                    const e = .5 * Math.cos(.7853975), i = .5 * Math.cos(3.14159 / 16), n = .5 * Math.cos(3.14159 / 8), r = .5 * Math.cos(3 * 3.14159 / 16), a = .5 * Math.cos(.981746875), s = .5 * Math.cos(3 * 3.14159 / 8), o = .5 * Math.cos(1.374445625), l = new Array(4), c = new Array(4), u = new Array(4), h = new Array(4);
                    for(let d = 0; d < 8; ++d){
                        const p = 8 * d;
                        l[0] = n * t1[p + 2], l[1] = s * t1[p + 2], l[2] = n * t1[p + 6], l[3] = s * t1[p + 6], c[0] = i * t1[p + 1] + r * t1[p + 3] + a * t1[p + 5] + o * t1[p + 7], c[1] = r * t1[p + 1] - o * t1[p + 3] - i * t1[p + 5] - a * t1[p + 7], c[2] = a * t1[p + 1] - i * t1[p + 3] + o * t1[p + 5] + r * t1[p + 7], c[3] = o * t1[p + 1] - a * t1[p + 3] + r * t1[p + 5] - i * t1[p + 7], u[0] = e * (t1[p + 0] + t1[p + 4]), u[3] = e * (t1[p + 0] - t1[p + 4]), u[1] = l[0] + l[3], u[2] = l[1] - l[2], h[0] = u[0] + u[1], h[1] = u[3] + u[2], h[2] = u[3] - u[2], h[3] = u[0] - u[1], t1[p + 0] = h[0] + c[0], t1[p + 1] = h[1] + c[1], t1[p + 2] = h[2] + c[2], t1[p + 3] = h[3] + c[3], t1[p + 4] = h[3] - c[3], t1[p + 5] = h[2] - c[2], t1[p + 6] = h[1] - c[1], t1[p + 7] = h[0] - c[0];
                    }
                    for(let d = 0; d < 8; ++d)l[0] = n * t1[16 + d], l[1] = s * t1[16 + d], l[2] = n * t1[48 + d], l[3] = s * t1[48 + d], c[0] = i * t1[8 + d] + r * t1[24 + d] + a * t1[40 + d] + o * t1[56 + d], c[1] = r * t1[8 + d] - o * t1[24 + d] - i * t1[40 + d] - a * t1[56 + d], c[2] = a * t1[8 + d] - i * t1[24 + d] + o * t1[40 + d] + r * t1[56 + d], c[3] = o * t1[8 + d] - a * t1[24 + d] + r * t1[40 + d] - i * t1[56 + d], u[0] = e * (t1[d] + t1[32 + d]), u[3] = e * (t1[d] - t1[32 + d]), u[1] = l[0] + l[3], u[2] = l[1] - l[2], h[0] = u[0] + u[1], h[1] = u[3] + u[2], h[2] = u[3] - u[2], h[3] = u[0] - u[1], t1[0 + d] = h[0] + c[0], t1[8 + d] = h[1] + c[1], t1[16 + d] = h[2] + c[2], t1[24 + d] = h[3] + c[3], t1[32 + d] = h[3] - c[3], t1[40 + d] = h[2] - c[2], t1[48 + d] = h[1] - c[1], t1[56 + d] = h[0] - c[0];
                }
                function _(t1) {
                    for(let e = 0; e < 64; ++e){
                        const i = t1[0][e], n = t1[1][e], r = t1[2][e];
                        t1[0][e] = i + 1.5747 * r, t1[1][e] = i - .1873 * n - .4682 * r, t1[2][e] = i + 1.8556 * n;
                    }
                }
                function I(t1, e, i) {
                    for(let a = 0; a < 64; ++a)e[i + a] = iu.toHalfFloat((n = t1[a]) <= 1 ? Math.sign(n) * Math.pow(Math.abs(n), 2.2) : Math.sign(n) * Math.pow(r, Math.abs(n) - 1));
                    var n;
                }
                function S(t1) {
                    return new DataView(t1.array.buffer, t1.offset.value, t1.size);
                }
                function N(t1) {
                    const e = t1.viewer.buffer.slice(t1.offset.value, t1.offset.value + t1.size), i = new Uint8Array(b(e)), n = new Uint8Array(i.length);
                    return x(i), w(i, n), new DataView(n.buffer);
                }
                function D(t1) {
                    const e = px(t1.array.slice(t1.offset.value, t1.offset.value + t1.size)), i = new Uint8Array(e.length);
                    return x(e), w(e, i), new DataView(i.buffer);
                }
                function C(t1) {
                    const i = t1.viewer, n = {
                        value: t1.offset.value
                    }, r = new Uint16Array(t1.width * t1.scanlineBlockSize * (t1.channels * t1.type)), a = new Uint8Array(8192);
                    let s = 0;
                    const o = new Array(t1.channels);
                    for(let e = 0; e < t1.channels; e++)o[e] = {}, o[e].start = s, o[e].end = o[e].start, o[e].nx = t1.width, o[e].ny = t1.lines, o[e].size = t1.type, s += o[e].nx * o[e].ny * o[e].size;
                    const l = H(i, n), c = H(i, n);
                    if (c >= 8192) throw new Error("Something is wrong with PIZ_COMPRESSION BITMAP_SIZE");
                    if (l <= c) for(let t1 = 0; t1 < c - l + 1; t1++)a[t1 + l] = k(i, n);
                    const u = new Uint16Array(e), h = function(t1, i) {
                        let n = 0;
                        for(let r = 0; r < e; ++r)(0 == r || t1[r >> 3] & 1 << (7 & r)) && (i[n++] = r);
                        const r = n - 1;
                        for(; n < e;)i[n++] = 0;
                        return r;
                    }(a, u), d = j(i, n);
                    y(t1.array, i, n, d, r, s);
                    for(let e = 0; e < t1.channels; ++e){
                        const t1 = o[e];
                        for(let i = 0; i < o[e].size; ++i)v(r, t1.start + i, t1.nx, t1.size, t1.ny, t1.nx * t1.size, h);
                    }
                    !function(t1, e, i) {
                        for(let n = 0; n < i; ++n)e[n] = t1[e[n]];
                    }(u, r, s);
                    let p = 0;
                    const A = new Uint8Array(r.buffer.byteLength);
                    for(let e = 0; e < t1.lines; e++)for(let e = 0; e < t1.channels; e++){
                        const t1 = o[e], i = t1.nx * t1.size, n = new Uint8Array(r.buffer, 2 * t1.end, 2 * i);
                        A.set(n, p), p += 2 * i, t1.end += i;
                    }
                    return new DataView(A.buffer);
                }
                function z(t1) {
                    const e = px(t1.array.slice(t1.offset.value, t1.offset.value + t1.size)), i = t1.lines * t1.channels * t1.width, n = 1 == t1.type ? new Uint16Array(i) : new Uint32Array(i);
                    let r = 0, a = 0;
                    const s = new Array(4);
                    for(let i = 0; i < t1.lines; i++)for(let i = 0; i < t1.channels; i++){
                        let i = 0;
                        switch(t1.type){
                            case 1:
                                s[0] = r, s[1] = s[0] + t1.width, r = s[1] + t1.width;
                                for(let r = 0; r < t1.width; ++r)i += e[s[0]++] << 8 | e[s[1]++], n[a] = i, a++;
                                break;
                            case 2:
                                s[0] = r, s[1] = s[0] + t1.width, s[2] = s[1] + t1.width, r = s[2] + t1.width;
                                for(let r = 0; r < t1.width; ++r)i += e[s[0]++] << 24 | e[s[1]++] << 16 | e[s[2]++] << 8, n[a] = i, a++;
                        }
                    }
                    return new DataView(n.buffer);
                }
                function L(t1) {
                    const e = t1.viewer, i = {
                        value: t1.offset.value
                    }, n = new Uint8Array(t1.width * t1.lines * (t1.channels * t1.type * 2)), r = {
                        version: U(e, i),
                        unknownUncompressedSize: U(e, i),
                        unknownCompressedSize: U(e, i),
                        acCompressedSize: U(e, i),
                        dcCompressedSize: U(e, i),
                        rleCompressedSize: U(e, i),
                        rleUncompressedSize: U(e, i),
                        rleRawSize: U(e, i),
                        totalAcUncompressedCount: U(e, i),
                        totalDcUncompressedCount: U(e, i),
                        acCompression: U(e, i)
                    };
                    if (r.version < 2) throw new Error("EXRLoader.parse: " + Z.compression + " version " + r.version + " is unsupported");
                    const a = new Array;
                    let s = H(e, i) - 2;
                    for(; s > 0;){
                        const t1 = O(e.buffer, i), n = k(e, i), r = n >> 2 & 3, o = new Int8Array([
                            (n >> 4) - 1
                        ])[0], l = k(e, i);
                        a.push({
                            name: t1,
                            index: o,
                            type: l,
                            compression: r
                        }), s -= t1.length + 3;
                    }
                    const o = Z.channels, l = new Array(t1.channels);
                    for(let e = 0; e < t1.channels; ++e){
                        const i = l[e] = {}, n = o[e];
                        i.name = n.name, i.compression = 0, i.decoded = !1, i.type = n.pixelType, i.pLinear = n.pLinear, i.width = t1.width, i.height = t1.lines;
                    }
                    const c = {
                        idx: new Array(3)
                    };
                    for(let e = 0; e < t1.channels; ++e){
                        const t1 = l[e];
                        for(let i = 0; i < a.length; ++i){
                            const n = a[i];
                            t1.name == n.name && (t1.compression = n.compression, n.index >= 0 && (c.idx[n.index] = e), t1.offset = e);
                        }
                    }
                    let u, h, d;
                    if (r.acCompressedSize > 0) switch(r.acCompression){
                        case 0:
                            u = new Uint16Array(r.totalAcUncompressedCount), y(t1.array, e, i, r.acCompressedSize, u, r.totalAcUncompressedCount);
                            break;
                        case 1:
                            const n1 = px(t1.array.slice(i.value, i.value + r.totalAcUncompressedCount));
                            u = new Uint16Array(n1.buffer), i.value += r.totalAcUncompressedCount;
                    }
                    if (r.dcCompressedSize > 0) {
                        const e = {
                            array: t1.array,
                            offset: i,
                            size: r.dcCompressedSize
                        };
                        h = new Uint16Array(D(e).buffer), i.value += r.dcCompressedSize;
                    }
                    r.rleRawSize > 0 && (d = b(px(t1.array.slice(i.value, i.value + r.rleCompressedSize)).buffer), i.value += r.rleCompressedSize);
                    let p = 0;
                    const A = new Array(l.length);
                    for(let t1 = 0; t1 < A.length; ++t1)A[t1] = new Array;
                    for(let e = 0; e < t1.lines; ++e)for(let e = 0; e < l.length; ++e)A[e].push(p), p += l[e].width * t1.type * 2;
                    !function(t1, e, i, n, r, a) {
                        let s = new DataView(a.buffer);
                        const o = i[t1.idx[0]].width, l = i[t1.idx[0]].height, c = Math.floor(o / 8), u = Math.ceil(o / 8), h = Math.ceil(l / 8), d = o - 8 * (u - 1), p = l - 8 * (h - 1), A = {
                            value: 0
                        }, f = new Array(3), m = new Array(3), g = new Array(3), M = new Array(3), v = new Array(3);
                        for(let i = 0; i < 3; ++i)v[i] = e[t1.idx[i]], f[i] = i < 1 ? 0 : f[i - 1] + u * h, m[i] = new Float32Array(64), g[i] = new Uint16Array(64), M[i] = new Uint16Array(64 * u);
                        for(let e = 0; e < h; ++e){
                            let a = 8;
                            e == h - 1 && (a = p);
                            let o = 8;
                            for(let t1 = 0; t1 < u; ++t1){
                                t1 == u - 1 && (o = d);
                                for(let t1 = 0; t1 < 3; ++t1)g[t1].fill(0), g[t1][0] = r[f[t1]++], T(A, n, g[t1]), y = g[t1], (x = m[t1])[0] = Q(y[0]), x[1] = Q(y[1]), x[2] = Q(y[5]), x[3] = Q(y[6]), x[4] = Q(y[14]), x[5] = Q(y[15]), x[6] = Q(y[27]), x[7] = Q(y[28]), x[8] = Q(y[2]), x[9] = Q(y[4]), x[10] = Q(y[7]), x[11] = Q(y[13]), x[12] = Q(y[16]), x[13] = Q(y[26]), x[14] = Q(y[29]), x[15] = Q(y[42]), x[16] = Q(y[3]), x[17] = Q(y[8]), x[18] = Q(y[12]), x[19] = Q(y[17]), x[20] = Q(y[25]), x[21] = Q(y[30]), x[22] = Q(y[41]), x[23] = Q(y[43]), x[24] = Q(y[9]), x[25] = Q(y[11]), x[26] = Q(y[18]), x[27] = Q(y[24]), x[28] = Q(y[31]), x[29] = Q(y[40]), x[30] = Q(y[44]), x[31] = Q(y[53]), x[32] = Q(y[10]), x[33] = Q(y[19]), x[34] = Q(y[23]), x[35] = Q(y[32]), x[36] = Q(y[39]), x[37] = Q(y[45]), x[38] = Q(y[52]), x[39] = Q(y[54]), x[40] = Q(y[20]), x[41] = Q(y[22]), x[42] = Q(y[33]), x[43] = Q(y[38]), x[44] = Q(y[46]), x[45] = Q(y[51]), x[46] = Q(y[55]), x[47] = Q(y[60]), x[48] = Q(y[21]), x[49] = Q(y[34]), x[50] = Q(y[37]), x[51] = Q(y[47]), x[52] = Q(y[50]), x[53] = Q(y[56]), x[54] = Q(y[59]), x[55] = Q(y[61]), x[56] = Q(y[35]), x[57] = Q(y[36]), x[58] = Q(y[48]), x[59] = Q(y[49]), x[60] = Q(y[57]), x[61] = Q(y[58]), x[62] = Q(y[62]), x[63] = Q(y[63]), E(m[t1]);
                                _(m);
                                for(let e = 0; e < 3; ++e)I(m[e], M[e], 64 * t1);
                            }
                            let l = 0;
                            for(let n = 0; n < 3; ++n){
                                const r = i[t1.idx[n]].type;
                                for(let t1 = 8 * e; t1 < 8 * e + a; ++t1){
                                    l = v[n][t1];
                                    for(let e = 0; e < c; ++e){
                                        const i = 64 * e + 8 * (7 & t1);
                                        s.setUint16(l + 0 * r, M[n][i + 0], !0), s.setUint16(l + 2 * r, M[n][i + 1], !0), s.setUint16(l + 4 * r, M[n][i + 2], !0), s.setUint16(l + 6 * r, M[n][i + 3], !0), s.setUint16(l + 8 * r, M[n][i + 4], !0), s.setUint16(l + 10 * r, M[n][i + 5], !0), s.setUint16(l + 12 * r, M[n][i + 6], !0), s.setUint16(l + 14 * r, M[n][i + 7], !0), l += 16 * r;
                                    }
                                }
                                if (c != u) for(let t1 = 8 * e; t1 < 8 * e + a; ++t1){
                                    const e = v[n][t1] + 8 * c * 2 * r, i = 64 * c + 8 * (7 & t1);
                                    for(let t1 = 0; t1 < o; ++t1)s.setUint16(e + 2 * t1 * r, M[n][i + t1], !0);
                                }
                            }
                        }
                        var y, x;
                        const w = new Uint16Array(o);
                        s = new DataView(a.buffer);
                        for(let e = 0; e < 3; ++e){
                            i[t1.idx[e]].decoded = !0;
                            const n = i[t1.idx[e]].type;
                            if (2 == i[e].type) for(let t1 = 0; t1 < l; ++t1){
                                const i = v[e][t1];
                                for(let t1 = 0; t1 < o; ++t1)w[t1] = s.getUint16(i + 2 * t1 * n, !0);
                                for(let t1 = 0; t1 < o; ++t1)s.setFloat32(i + 2 * t1 * n, Q(w[t1]), !0);
                            }
                        }
                    }(c, A, l, u, h, n);
                    for(let e = 0; e < l.length; ++e){
                        const i = l[e];
                        if (!i.decoded) {
                            if (2 !== i.compression) throw new Error("EXRLoader.parse: unsupported channel compression");
                            {
                                let r = 0, a = 0;
                                for(let s = 0; s < t1.lines; ++s){
                                    let t1 = A[e][r];
                                    for(let e = 0; e < i.width; ++e){
                                        for(let e = 0; e < 2 * i.type; ++e)n[t1++] = d[a + e * i.width * i.height];
                                        a++;
                                    }
                                    r++;
                                }
                            }
                        }
                    }
                    return new DataView(n.buffer);
                }
                function O(t1, e) {
                    const i = new Uint8Array(t1);
                    let n = 0;
                    for(; 0 != i[e.value + n];)n += 1;
                    const r = (new TextDecoder).decode(i.slice(e.value, e.value + n));
                    return e.value = e.value + n + 1, r;
                }
                function P(t1, e) {
                    const i = t1.getInt32(e.value, !0);
                    return e.value = e.value + 4, i;
                }
                function j(t1, e) {
                    const i = t1.getUint32(e.value, !0);
                    return e.value = e.value + 4, i;
                }
                function R(t1, e) {
                    const i = t1[e.value];
                    return e.value = e.value + 1, i;
                }
                function k(t1, e) {
                    const i = t1.getUint8(e.value);
                    return e.value = e.value + 1, i;
                }
                const U = function(t1, e) {
                    let i;
                    return i = "getBigInt64" in DataView.prototype ? Number(t1.getBigInt64(e.value, !0)) : t1.getUint32(e.value + 4, !0) + Number(t1.getUint32(e.value, !0) << 32), e.value += 8, i;
                };
                function B(t1, e) {
                    const i = t1.getFloat32(e.value, !0);
                    return e.value += 4, i;
                }
                function F(t1, e) {
                    return iu.toHalfFloat(B(t1, e));
                }
                function Q(t1) {
                    const e = (31744 & t1) >> 10, i = 1023 & t1;
                    return (t1 >> 15 ? -1 : 1) * (e ? 31 === e ? i ? NaN : 1 / 0 : Math.pow(2, e - 15) * (1 + i / 1024) : i / 1024 * 6103515625e-14);
                }
                function H(t1, e) {
                    const i = t1.getUint16(e.value, !0);
                    return e.value += 2, i;
                }
                function V(t1, e) {
                    return Q(H(t1, e));
                }
                function G(t1, e, i, n, r) {
                    return "string" === n || "stringvector" === n || "iccProfile" === n ? function(t1, e, i) {
                        const n = (new TextDecoder).decode(new Uint8Array(t1).slice(e.value, e.value + i));
                        return e.value = e.value + i, n;
                    }(e, i, r) : "chlist" === n ? function(t1, e, i, n) {
                        const r = i.value, a = [];
                        for(; i.value < r + n - 1;){
                            const n = O(e, i), r = P(t1, i), s = k(t1, i);
                            i.value += 3;
                            const o = P(t1, i), l = P(t1, i);
                            a.push({
                                name: n,
                                pixelType: r,
                                pLinear: s,
                                xSampling: o,
                                ySampling: l
                            });
                        }
                        return i.value += 1, a;
                    }(t1, e, i, r) : "chromaticities" === n ? function(t1, e) {
                        return {
                            redX: B(t1, e),
                            redY: B(t1, e),
                            greenX: B(t1, e),
                            greenY: B(t1, e),
                            blueX: B(t1, e),
                            blueY: B(t1, e),
                            whiteX: B(t1, e),
                            whiteY: B(t1, e)
                        };
                    }(t1, i) : "compression" === n ? function(t1, e) {
                        return [
                            "NO_COMPRESSION",
                            "RLE_COMPRESSION",
                            "ZIPS_COMPRESSION",
                            "ZIP_COMPRESSION",
                            "PIZ_COMPRESSION",
                            "PXR24_COMPRESSION",
                            "B44_COMPRESSION",
                            "B44A_COMPRESSION",
                            "DWAA_COMPRESSION",
                            "DWAB_COMPRESSION"
                        ][k(t1, e)];
                    }(t1, i) : "box2i" === n ? function(t1, e) {
                        return {
                            xMin: j(t1, e),
                            yMin: j(t1, e),
                            xMax: j(t1, e),
                            yMax: j(t1, e)
                        };
                    }(t1, i) : "lineOrder" === n ? function(t1, e) {
                        return [
                            "INCREASING_Y"
                        ][k(t1, e)];
                    }(t1, i) : "float" === n ? B(t1, i) : "v2f" === n ? function(t1, e) {
                        return [
                            B(t1, e),
                            B(t1, e)
                        ];
                    }(t1, i) : "v3f" === n ? function(t1, e) {
                        return [
                            B(t1, e),
                            B(t1, e),
                            B(t1, e)
                        ];
                    }(t1, i) : "int" === n ? P(t1, i) : "rational" === n ? function(t1, e) {
                        return [
                            P(t1, e),
                            j(t1, e)
                        ];
                    }(t1, i) : "timecode" === n ? function(t1, e) {
                        return [
                            j(t1, e),
                            j(t1, e)
                        ];
                    }(t1, i) : "preview" === n ? (i.value += r, "skipped") : void (i.value += r);
                }
                const W = new DataView(t1), Y = new Uint8Array(t1), X = {
                    value: 0
                }, Z = function(t1, e, i) {
                    const n = {};
                    if (20000630 != t1.getUint32(0, !0)) throw new Error("THREE.EXRLoader: Provided file doesn't appear to be in OpenEXR format.");
                    n.version = t1.getUint8(4);
                    const r = t1.getUint8(5);
                    n.spec = {
                        singleTile: !!(2 & r),
                        longName: !!(4 & r),
                        deepFormat: !!(8 & r),
                        multiPart: !!(16 & r)
                    }, i.value = 8;
                    let a = !0;
                    for(; a;){
                        const r = O(e, i);
                        if (0 == r) a = !1;
                        else {
                            const a = O(e, i), s = G(t1, e, i, a, j(t1, i));
                            void 0 === s ? console.warn(`THREE.EXRLoader: Skipped unknown header attribute type '${a}'.`) : n[r] = s;
                        }
                    }
                    if (-5 & r) throw console.error("THREE.EXRHeader:", n), new Error("THREE.EXRLoader: Provided file is currently unsupported.");
                    return n;
                }(W, t1, X), q = function(t1, e, i, n, r) {
                    const a = {
                        size: 0,
                        viewer: e,
                        array: i,
                        offset: n,
                        width: t1.dataWindow.xMax - t1.dataWindow.xMin + 1,
                        height: t1.dataWindow.yMax - t1.dataWindow.yMin + 1,
                        channels: t1.channels.length,
                        bytesPerLine: null,
                        lines: null,
                        inputSize: null,
                        type: t1.channels[0].pixelType,
                        uncompress: null,
                        getter: null,
                        format: null,
                        colorSpace: Hs
                    };
                    switch(t1.compression){
                        case "NO_COMPRESSION":
                            a.lines = 1, a.uncompress = S;
                            break;
                        case "RLE_COMPRESSION":
                            a.lines = 1, a.uncompress = N;
                            break;
                        case "ZIPS_COMPRESSION":
                            a.lines = 1, a.uncompress = D;
                            break;
                        case "ZIP_COMPRESSION":
                            a.lines = 16, a.uncompress = D;
                            break;
                        case "PIZ_COMPRESSION":
                            a.lines = 32, a.uncompress = C;
                            break;
                        case "PXR24_COMPRESSION":
                            a.lines = 16, a.uncompress = z;
                            break;
                        case "DWAA_COMPRESSION":
                            a.lines = 32, a.uncompress = L;
                            break;
                        case "DWAB_COMPRESSION":
                            a.lines = 256, a.uncompress = L;
                            break;
                        default:
                            throw new Error("EXRLoader.parse: " + t1.compression + " is unsupported");
                    }
                    if (a.scanlineBlockSize = a.lines, 1 == a.type) switch(r){
                        case Ia:
                            a.getter = V, a.inputSize = 2;
                            break;
                        case Sa:
                            a.getter = H, a.inputSize = 2;
                    }
                    else {
                        if (2 != a.type) throw new Error("EXRLoader.parse: unsupported pixelType " + a.type + " for " + t1.compression + ".");
                        switch(r){
                            case Ia:
                                a.getter = B, a.inputSize = 4;
                                break;
                            case Sa:
                                a.getter = F, a.inputSize = 4;
                        }
                    }
                    a.blockCount = (t1.dataWindow.yMax + 1) / a.scanlineBlockSize;
                    for(let t1 = 0; t1 < a.blockCount; t1++)U(e, n);
                    a.outputChannels = 3 == a.channels ? 4 : a.channels;
                    const s = a.width * a.height * a.outputChannels;
                    switch(r){
                        case Ia:
                            a.byteArray = new Float32Array(s), a.channels < a.outputChannels && a.byteArray.fill(1, 0, s);
                            break;
                        case Sa:
                            a.byteArray = new Uint16Array(s), a.channels < a.outputChannels && a.byteArray.fill(15360, 0, s);
                            break;
                        default:
                            console.error("THREE.EXRLoader: unsupported type: ", r);
                    }
                    return a.bytesPerLine = a.width * a.inputSize * a.channels, 4 == a.outputChannels ? (a.format = La, a.colorSpace = Hs) : (a.format = ka, a.colorSpace = Fs), a;
                }(Z, W, Y, X, this.type), J = {
                    value: 0
                }, K = {
                    R: 0,
                    G: 1,
                    B: 2,
                    A: 3,
                    Y: 0
                };
                for(let t1 = 0; t1 < q.height / q.scanlineBlockSize; t1++){
                    const e = j(W, X);
                    q.size = j(W, X), q.lines = e + q.scanlineBlockSize > q.height ? q.height - e : q.scanlineBlockSize;
                    const i = q.size < q.lines * q.bytesPerLine ? q.uncompress(q) : S(q);
                    X.value += q.size;
                    for(let e = 0; e < q.scanlineBlockSize; e++){
                        const n = e + t1 * q.scanlineBlockSize;
                        if (n >= q.height) break;
                        for(let t1 = 0; t1 < q.channels; t1++){
                            const r = K[Z.channels[t1].name];
                            for(let a = 0; a < q.width; a++){
                                J.value = (e * (q.channels * q.width) + t1 * q.width + a) * q.inputSize;
                                const s = (q.height - 1 - n) * (q.width * q.outputChannels) + a * q.outputChannels + r;
                                q.byteArray[s] = q.getter(i, J);
                            }
                        }
                    }
                }
                return {
                    header: Z,
                    width: q.width,
                    height: q.height,
                    data: q.byteArray,
                    format: q.format,
                    colorSpace: q.colorSpace,
                    type: this.type
                };
            }
            setDataType(t1) {
                return this.type = t1, this;
            }
            load(t1, e, i, n) {
                return super.load(t1, function(t1, i) {
                    t1.colorSpace = i.colorSpace, t1.minFilter = ma, t1.magFilter = ma, t1.generateMipmaps = !1, t1.flipY = !1, e && e(t1, i);
                }, i, n);
            }
        }
        const mx = (t1)=>{
            const e = new vl(t1);
            return e.center = new qo(.5, .5), e.colorSpace = Qs, e.minFilter = ya, e.magFilter = ma, e.needsUpdate = !0, e;
        }, gx = (t1, e, i)=>t1.find((t1)=>t1.ID === e).Vertices.map((t1)=>{
                const e = i.find((e)=>e.ID === t1);
                return [
                    e.Location.X,
                    e.Location.Y
                ];
            }), Mx = (t1, e)=>{
            const { Rooms: i } = t1.Floors[Un.currentFloorIndex].Units[0];
            return i.find((t1)=>{
                let { ID: i } = t1;
                return i === e;
            }) || null;
        }, vx = (t1, e)=>{
            const { CameraPoints: i } = t1.Floors[Un.currentFloorIndex];
            return (null == i ? void 0 : i.find((t1)=>{
                let { ID: i } = t1;
                return i === e;
            })) || null;
        }, yx = (t1, e)=>e.reduce((e, i)=>{
                const n = Iy([
                    t1,
                    [
                        i.userData.left,
                        i.userData.top
                    ]
                ]);
                return n < e.length ? {
                    panorama: i,
                    length: n
                } : e;
            }, {
                length: 1 / 0,
                panorama: null
            }), xx = async (t1, e)=>await new Promise((i)=>{
                const n = setInterval(()=>{
                    if (e < 0 && t1.opacity <= 0 || e > 0 && t1.opacity >= 1) return clearInterval(n), i();
                    t1.opacity = Math.min(1, t1.opacity + e);
                }, 1);
            }), wx = async (t1)=>await xx(t1, -0.01), bx = async (t1)=>await xx(t1, .01), Tx = (t1)=>Zo.DEG2RAD * t1, Ex = (t1)=>Zo.RAD2DEG * t1, _x = async (t1)=>{
            const e = new fx;
            return e.type = Ia, new Promise((i)=>{
                e.load(t1, (t1, e)=>i(e));
            });
        }, Ix = (t1, e, i)=>{
            const { data: n, width: r, height: a } = i, s = n.length / a, o = (Math.round(a - e * a) - 1) * s + 4 * Math.round(t1 * r), [l, c, u, h] = n.slice(o, o + 4);
            return {
                R: l,
                G: c,
                B: u,
                A: h
            };
        }, Sx = (t1, e, i)=>{
            const { data: n, width: r, height: a } = i, s = 4 * r, o = (Math.round(a - e * a) - 1) * s + 4 * Math.round(t1 * r), [l, c, u, h] = n.slice(o, o + 4);
            return {
                R: l,
                G: c,
                B: u,
                A: h
            };
        }, Nx = (t1, e)=>{
            const i = t1.X - e.X, n = t1.Y - e.Y;
            return i * i + n * n;
        }, Dx = (t1, e, i)=>{
            const n = t1.clone().sub(e).normalize(), r = t1.clone().sub(i).normalize();
            return n.cross(r);
        };
        function Cx(t1, e, i) {
            return (e = function(t1) {
                var e = function(t1) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var e = t1[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e)) in t1 ? Object.defineProperty(t1, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = i, t1;
        }
        const zx = class extends Pp {
            constructor(t1, e){
                super(), Cx(this, "_tempPointer", new qo), Cx(this, "_raycaster", new LM), Cx(this, "_tempMatrix", new ac), Cx(this, "_pointer", new qo), Cx(this, "deepChildren", []), Cx(this, "_hoverElement", void 0), Cx(this, "controller1", void 0), Cx(this, "controller2", void 0), Cx(this, "_renderer", void 0), Cx(this, "_camera", void 0), Cx(this, "updateDeepChildren", ()=>{
                    const t1 = [];
                    this.traverse((e)=>{
                        e.interactive && t1.push(e);
                    }, []), this.deepChildren = t1;
                }), this._camera = e, this._renderer = t1, this._renderer.domElement.addEventListener("pointermove", this.onPointerEvent.bind(this)), this._renderer.domElement.addEventListener("pointerdown", this.onPointerDown.bind(this)), this._renderer.domElement.addEventListener("pointerup", this.onPointerEvent.bind(this)), this._renderer.domElement.addEventListener("mousemove", this.onPointerEvent.bind(this)), this.controller1 = this.createController(0), this.controller2 = this.createController(1);
            }
            get hover() {
                return this._pointer.hover || this.controller1.hover || this.controller2.hover;
            }
            get cursor() {
                return this._pointer._hoverElement ? this._pointer._hoverElement.isLinkSphere ? "" : this._pointer._hoverElement.isDoor ? "url(".concat("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIHZpZXdCb3g9IjAgMCA1MCA1MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzE1MThfOTMyKSI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTAuMjc1NCA2LjIyOTIxQzEwLjI3NTQgNS44OTk4NiAxMC40ODgyIDUuNjA4MzMgMTAuODAxOCA1LjUwODJMMjcuMDYzNyAwLjMxNTAxNEMyNy41NTE2IDAuMTU5MTkxIDI4LjA1IDAuNTIzNTEyIDI4LjA1IDEuMDM2MDJWNDguOTk2OEMyOC4wNSA0OS40ODQ0IDI3LjU5NTggNDkuODQ0OCAyNy4xMjEzIDQ5LjczMzdMMTAuODU5NCA0NS45MjUzQzEwLjUxNzMgNDUuODQ1MyAxMC4yNzU0IDQ1LjU0IDEwLjI3NTQgNDUuMTg4NVY2LjIyOTIxWk0yNS40MDI3IDI2LjExMDhDMjQuOTg1IDI2LjExMDggMjQuNjQ2NCAyNS43NzIgMjQuNjQ2NCAyNS4zNTRWMjQuMjE4OEMyNC42NDY0IDIzLjgwMDggMjQuOTg1IDIzLjQ2MTkgMjUuNDAyNyAyMy40NjE5QzI1LjgyMDUgMjMuNDYxOSAyNi4xNTkxIDIzLjgwMDggMjYuMTU5MSAyNC4yMTg4VjI1LjM1NEMyNi4xNTkxIDI1Ljc3MiAyNS44MjA1IDI2LjExMDggMjUuNDAyNyAyNi4xMTA4Wk0zMC42OTczIDUuMjk3ODhDMzAuNjk3MyA1LjcxNTg4IDMxLjAzNTkgNi4wNTQ3MiAzMS40NTM2IDYuMDU0NzJIMzguMjYwOUMzOC42Nzg3IDYuMDU0NzIgMzkuMDE3MyA2LjM5MzU3IDM5LjAxNzMgNi44MTE1NlY0My44OTY1QzM5LjAxNzMgNDQuMzE0NSAzOC42Nzg3IDQ0LjY1MzMgMzguMjYwOSA0NC42NTMzSDMxLjQ1MzZDMzEuMDM1OSA0NC42NTMzIDMwLjY5NzMgNDQuOTkyMiAzMC42OTczIDQ1LjQxMDJDMzAuNjk3MyA0NS44MjgyIDMxLjAzNTkgNDYuMTY3IDMxLjQ1MzYgNDYuMTY3SDM5Ljc3MzdDNDAuMTkxNCA0Ni4xNjcgNDAuNTMgNDUuODI4MiA0MC41MyA0NS40MTAyVjUuMjk3ODhDNDAuNTMgNC44Nzk5IDQwLjE5MTQgNC41NDEwNSAzOS43NzM3IDQuNTQxMDVIMzEuNDUzNkMzMS4wMzU5IDQuNTQxMDUgMzAuNjk3MyA0Ljg3OTkgMzAuNjk3MyA1LjI5Nzg4WiIgZmlsbD0id2hpdGUiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF8xNTE4XzkzMiI+CjxyZWN0IHdpZHRoPSIzNi45NjI5IiBoZWlnaHQ9IjQ5Ljk1MTIiIGZpbGw9IndoaXRlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg2LjU0Mjk3KSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=", ") 25 25, pointer") : "pointer" : "";
            }
            add() {
                super.add(...arguments), this.updateDeepChildren();
            }
            createControllerLine(t1) {
                const e = new Tf(new Nl(0, 0, 0), new Nl(0, 0, -500)), i = new Sm(e, 100, .002, 100, !1), n = new Om({
                    color: new Yc(16777215),
                    side: cr
                }), r = new Fu(i, n);
                return r.isVrControllerLine = !0, r.defaultDistance = 500, r.renderOrder = 7, t1.distanceLine = r, t1.add(r), r;
            }
            createControllerCircle(t1) {
                const e = document.createElement("canvas"), i = e.getContext("2d");
                e.width = 128, e.height = 128, i.beginPath(), i.arc(e.width / 2, e.height / 2, e.width / 4, 0, 2 * Math.PI, !1), i.strokeStyle = "rgba(255, 255, 255, 1)", i.fillStyle = "rgba(20, 20, 20, 0.26)", i.lineWidth = 10, i.fill(), i.stroke();
                const n = mx(e), r = new qp({
                    color: new Yc(16777215),
                    sizeAttenuation: !1,
                    transparent: !0,
                    side: cr,
                    map: n,
                    opacity: 1
                }), a = new uA(r);
                return a.isVrControllerCircle = !0, a.scale.setScalar(.05), a.renderOrder = 7, t1.distanceCircle = a, t1.add(a), a;
            }
            createController(t1) {
                const e = this._renderer.xr.getController(t1);
                e.isVrController = !0, this.createControllerLine(e), this.createControllerCircle(e);
                const i = new yy, n = new _y, r = this._renderer.xr.getControllerGrip(t1);
                r.add(i.createControllerModel(r)), r.isVrControllerGrip = !0;
                const a = this._renderer.xr.getHand(t1);
                return a.add(n.createHandModel(a, "mesh")), a.isVrHand = !0, e.addEventListener("move", this.onXRControllerEvent.bind(this)), e.addEventListener("select", this.onXRControllerEvent.bind(this)), this.add(e, r, a), e;
            }
            getIntersections() {
                return this._raycaster.intersectObjects(this.deepChildren, !1).filter((t1)=>t1.object.visible && t1.object.parent).sort((t1)=>t1.object.isLinkSphere ? 1 : -1);
            }
            onPointerDown(t1) {
                let { clientX: e, clientY: i } = t1;
                this._tempPointer.x = Number(e.toFixed(0)), this._tempPointer.y = Number(i.toFixed(0));
            }
            onPointerEvent(t1) {
                var e;
                const i = Math.abs(this._tempPointer.x - Number(t1.clientX.toFixed(0))) < 10, n = Math.abs(this._tempPointer.y - Number(t1.clientY.toFixed(0))) < 10, r = "pointerup" === t1.type ? "click" : t1.type;
                if (!("click" !== r || i && n)) return;
                const a = this._renderer.domElement.getBoundingClientRect();
                this._pointer.x = (t1.clientX - a.left) / a.width * 2 - 1, this._pointer.y = -(t1.clientY - a.top) / a.height * 2 + 1, this._raycaster.setFromCamera(this._pointer, this._camera);
                const s = this.getIntersections();
                s.length > 0 && this.onIntersection(s, r, this._pointer) || (null === (e = this._pointer._hoverElement) || void 0 === e || e.dispatchEvent({
                    type: "hoverend",
                    controller: null
                }), this._pointer._hoverElement = null, this._pointer.hover = !1);
            }
            onXRControllerEvent(t1) {
                var e;
                const i = {
                    move: "mousemove",
                    select: "click"
                }, n = t1.target;
                this._tempMatrix.identity().extractRotation(n.matrixWorld), this._raycaster.ray.origin.setFromMatrixPosition(n.matrixWorld), this._raycaster.ray.direction.set(0, 0, -1).applyMatrix4(this._tempMatrix);
                const r = this.getIntersections();
                r.length > 0 && this.onIntersection(r, i[t1.type], n) ? n.distanceCircle.material.depthTest = !1 : (n.distanceCircle.material.depthTest = !0, this.updateControllerPointer(n, 500), null === (e = n._hoverElement) || void 0 === e || e.dispatchEvent({
                    type: "hoverend",
                    controller: n
                }), n._hoverElement = null, n.hover = !1);
            }
            onIntersection(t1, e, i) {
                this.deepChildren.forEach((e)=>{
                    if (!e.isLinkSphere) return;
                    const n = t1.some((t1)=>t1.object.uuid === e.uuid);
                    e.dispatchEvent({
                        type: n ? "hoverstart" : "hoverend",
                        controller: i
                    });
                });
                const n = t1[0];
                if (!n) return null;
                const { object: r } = n, a = {
                    x: n.uv.x,
                    y: 1 - n.uv.y
                };
                return r.dispatchEvent({
                    type: "hoverstart",
                    data: a,
                    controller: i
                }), r.dispatchEvent({
                    type: e,
                    data: a,
                    controller: i
                }), i && i.isVrController && this.updateControllerPointer(i, n.distance), i._hoverElement && i._hoverElement.uuid !== r.uuid && i._hoverElement.dispatchEvent({
                    type: "hoverend",
                    controller: i
                }), i._hoverElement = r, i.hover = !0, r;
            }
            updateControllerPointer(t1, e) {
                t1.distanceCircle.position.z = -e;
                const i = e / t1.distanceLine.defaultDistance;
                t1.distanceLine.scale.set(1, 1, i);
            }
        }, Lx = [
            "StraightStair_01",
            "StraightStairWithTurn_01",
            "HelicalStair_01",
            "QuarterLandingStair_01",
            "HalfLandingStair_01"
        ];
        var Ox = i(232), Px = i.n(Ox);
        function jx(t1, e, i) {
            return (e = function(t1) {
                var e = function(t1) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var e = t1[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e)) in t1 ? Object.defineProperty(t1, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = i, t1;
        }
        hi({
            useProxies: "never"
        });
        const Rx = "granted", kx = new class {
            constructor(){
                jx(this, "parser", null), jx(this, "deviceOrientationStatus", "denied"), jx(this, "setDeviceOrientationStatus", (t1)=>(this.deviceOrientationStatus = t1, t1)), jx(this, "requestDeviceOrientation", async ()=>{
                    try {
                        return DeviceOrientationEvent.requestPermission ? await DeviceOrientationEvent.requestPermission().then((t1)=>this.setDeviceOrientationStatus(t1)) : this.setDeviceOrientationStatus(Rx);
                    } catch (t1) {
                        console.log(t1);
                    }
                }), zi(this), this.parser = new (Px());
            }
            get device() {
                return this.parser.getDevice();
            }
            get isMobile() {
                return "mobile" === this.device.type;
            }
            get isTablet() {
                return "tablet" === this.device.type;
            }
            get isMobileDevice() {
                return this.isMobile || this.isTablet;
            }
            get deviceOrientationGranted() {
                return this.deviceOrientationStatus === Rx;
            }
        };
        function Ux(t1, e, i) {
            return (e = function(t1) {
                var e = function(t1) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var e = t1[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e)) in t1 ? Object.defineProperty(t1, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = i, t1;
        }
        const Bx = class extends Fu {
            constructor(t1){
                super(), Ux(this, "interactive", !0), Ux(this, "_visible", !0), Ux(this, "isDoor", !0), this.userData = t1, this.position.copy(t1.position), this.rotation.copy(t1.rotation), this.renderOrder = 3, this.visible = !1, this.createGeometry(), this.createMaterial(), this.onHoverEnd(), this.addEventListeners();
            }
            get visible() {
                return this._visible;
            }
            set visible(t1) {
                this._visible = t1, this.sprite && (this.sprite.visible = t1 ? kx.isMobileDevice : t1);
            }
            createGeometry() {
                return this.geometry = new uh(this.userData.width, this.userData.height, 10, 10), this;
            }
            async createMaterial() {
                const t1 = new Om({
                    color: new Yc(16777215),
                    transparent: !0,
                    depthTest: !1,
                    side: cr,
                    opacity: 0
                });
                return this.material = t1, this;
            }
            addEventListeners() {
                return this.addEventListener("select", ()=>this.onClick()), this.addEventListener("click", ()=>this.onClick()), this.addEventListener("hoverstart", ()=>this.onHoverStart()), this.addEventListener("hoverend", ()=>this.onHoverEnd()), this;
            }
            dispose() {
                this.material.dispose(), this.removeFromParent();
            }
            onHoverStart() {}
            onHoverEnd() {}
            onClick() {}
        };
        function Fx(t1) {
            if (void 0 === t1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return t1;
        }
        function Qx(t1, e) {
            t1.prototype = Object.create(e.prototype), t1.prototype.constructor = t1, t1.__proto__ = e;
        }
        var Hx, Vx, Gx, Wx, Yx, Xx, Zx, qx, Jx, Kx, $x, tw, ew, iw, nw, rw, aw, sw = {
            autoSleep: 120,
            force3D: "auto",
            nullTargetWarn: 1,
            units: {
                lineHeight: ""
            }
        }, ow = {
            duration: .5,
            overwrite: !1,
            delay: 0
        }, lw = 1e8, cw = 1e-8, uw = 2 * Math.PI, hw = uw / 4, dw = 0, pw = Math.sqrt, Aw = Math.cos, fw = Math.sin, mw = function(t1) {
            return "string" == typeof t1;
        }, gw = function(t1) {
            return "function" == typeof t1;
        }, Mw = function(t1) {
            return "number" == typeof t1;
        }, vw = function(t1) {
            return void 0 === t1;
        }, yw = function(t1) {
            return "object" == typeof t1;
        }, xw = function(t1) {
            return !1 !== t1;
        }, ww = function() {
            return "undefined" != typeof window;
        }, bw = function(t1) {
            return gw(t1) || mw(t1);
        }, Tw = "function" == typeof ArrayBuffer && ArrayBuffer.isView || function() {}, Ew = Array.isArray, _w = /(?:-?\.?\d|\.)+/gi, Iw = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, Sw = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, Nw = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, Dw = /[+-]=-?[.\d]+/, Cw = /[^,'"\[\]\s]+/gi, zw = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i, Lw = {}, Ow = {}, Pw = function(t1) {
            return (Ow = ub(t1, Lw)) && uE;
        }, jw = function(t1, e) {
            return console.warn("Invalid property", t1, "set to", e, "Missing plugin? gsap.registerPlugin()");
        }, Rw = function(t1, e) {
            return !e && console.warn(t1);
        }, kw = function(t1, e) {
            return t1 && (Lw[t1] = e) && Ow && (Ow[t1] = e) || Lw;
        }, Uw = function() {
            return 0;
        }, Bw = {
            suppressEvents: !0,
            isStart: !0,
            kill: !1
        }, Fw = {
            suppressEvents: !0,
            kill: !1
        }, Qw = {
            suppressEvents: !0
        }, Hw = {}, Vw = [], Gw = {}, Ww = {}, Yw = {}, Xw = 30, Zw = [], qw = "", Jw = function(t1) {
            var e, i, n = t1[0];
            if (yw(n) || gw(n) || (t1 = [
                t1
            ]), !(e = (n._gsap || {}).harness)) {
                for(i = Zw.length; i-- && !Zw[i].targetTest(n););
                e = Zw[i];
            }
            for(i = t1.length; i--;)t1[i] && (t1[i]._gsap || (t1[i]._gsap = new TT(t1[i], e))) || t1.splice(i, 1);
            return t1;
        }, Kw = function(t1) {
            return t1._gsap || Jw(Fb(t1))[0]._gsap;
        }, $w = function(t1, e, i) {
            return (i = t1[e]) && gw(i) ? t1[e]() : vw(i) && t1.getAttribute && t1.getAttribute(e) || i;
        }, tb = function(t1, e) {
            return (t1 = t1.split(",")).forEach(e) || t1;
        }, eb = function(t1) {
            return Math.round(1e5 * t1) / 1e5 || 0;
        }, ib = function(t1) {
            return Math.round(1e7 * t1) / 1e7 || 0;
        }, nb = function(t1, e) {
            var i = e.charAt(0), n = parseFloat(e.substr(2));
            return t1 = parseFloat(t1), "+" === i ? t1 + n : "-" === i ? t1 - n : "*" === i ? t1 * n : t1 / n;
        }, rb = function(t1, e) {
            for(var i = e.length, n = 0; t1.indexOf(e[n]) < 0 && ++n < i;);
            return n < i;
        }, ab = function() {
            var t1, e, i = Vw.length, n = Vw.slice(0);
            for(Gw = {}, Vw.length = 0, t1 = 0; t1 < i; t1++)(e = n[t1]) && e._lazy && (e.render(e._lazy[0], e._lazy[1], !0)._lazy = 0);
        }, sb = function(t1, e, i, n) {
            Vw.length && !Vx && ab(), t1.render(e, i, n || Vx && e < 0 && (t1._initted || t1._startAt)), Vw.length && !Vx && ab();
        }, ob = function(t1) {
            var e = parseFloat(t1);
            return (e || 0 === e) && (t1 + "").match(Cw).length < 2 ? e : mw(t1) ? t1.trim() : t1;
        }, lb = function(t1) {
            return t1;
        }, cb = function(t1, e) {
            for(var i in e)i in t1 || (t1[i] = e[i]);
            return t1;
        }, ub = function(t1, e) {
            for(var i in e)t1[i] = e[i];
            return t1;
        }, hb = function t1(e, i) {
            for(var n in i)"__proto__" !== n && "constructor" !== n && "prototype" !== n && (e[n] = yw(i[n]) ? t1(e[n] || (e[n] = {}), i[n]) : i[n]);
            return e;
        }, db = function(t1, e) {
            var i, n = {};
            for(i in t1)i in e || (n[i] = t1[i]);
            return n;
        }, pb = function(t1) {
            var e, i = t1.parent || Wx, n = t1.keyframes ? (e = Ew(t1.keyframes), function(t1, i) {
                for(var n in i)n in t1 || "duration" === n && e || "ease" === n || (t1[n] = i[n]);
            }) : cb;
            if (xw(t1.inherit)) for(; i;)n(t1, i.vars.defaults), i = i.parent || i._dp;
            return t1;
        }, Ab = function(t1, e, i, n, r) {
            void 0 === i && (i = "_first"), void 0 === n && (n = "_last");
            var a, s = t1[n];
            if (r) for(a = e[r]; s && s[r] > a;)s = s._prev;
            return s ? (e._next = s._next, s._next = e) : (e._next = t1[i], t1[i] = e), e._next ? e._next._prev = e : t1[n] = e, e._prev = s, e.parent = e._dp = t1, e;
        }, fb = function(t1, e, i, n) {
            void 0 === i && (i = "_first"), void 0 === n && (n = "_last");
            var r = e._prev, a = e._next;
            r ? r._next = a : t1[i] === e && (t1[i] = a), a ? a._prev = r : t1[n] === e && (t1[n] = r), e._next = e._prev = e.parent = null;
        }, mb = function(t1, e) {
            t1.parent && (!e || t1.parent.autoRemoveChildren) && t1.parent.remove && t1.parent.remove(t1), t1._act = 0;
        }, gb = function(t1, e) {
            if (t1 && (!e || e._end > t1._dur || e._start < 0)) for(var i = t1; i;)i._dirty = 1, i = i.parent;
            return t1;
        }, Mb = function(t1, e, i, n) {
            return t1._startAt && (Vx ? t1._startAt.revert(Fw) : t1.vars.immediateRender && !t1.vars.autoRevert || t1._startAt.render(e, !0, n));
        }, vb = function t1(e) {
            return !e || e._ts && t1(e.parent);
        }, yb = function(t1) {
            return t1._repeat ? xb(t1._tTime, t1 = t1.duration() + t1._rDelay) * t1 : 0;
        }, xb = function(t1, e) {
            var i = Math.floor(t1 /= e);
            return t1 && i === t1 ? i - 1 : i;
        }, wb = function(t1, e) {
            return (t1 - e._start) * e._ts + (e._ts >= 0 ? 0 : e._dirty ? e.totalDuration() : e._tDur);
        }, bb = function(t1) {
            return t1._end = ib(t1._start + (t1._tDur / Math.abs(t1._ts || t1._rts || cw) || 0));
        }, Tb = function(t1, e) {
            var i = t1._dp;
            return i && i.smoothChildTiming && t1._ts && (t1._start = ib(i._time - (t1._ts > 0 ? e / t1._ts : ((t1._dirty ? t1.totalDuration() : t1._tDur) - e) / -t1._ts)), bb(t1), i._dirty || gb(i, t1)), t1;
        }, Eb = function(t1, e) {
            var i;
            if ((e._time || !e._dur && e._initted || e._start < t1._time && (e._dur || !e.add)) && (i = wb(t1.rawTime(), e), (!e._dur || Rb(0, e.totalDuration(), i) - e._tTime > cw) && e.render(i, !0)), gb(t1, e)._dp && t1._initted && t1._time >= t1._dur && t1._ts) {
                if (t1._dur < t1.duration()) for(i = t1; i._dp;)i.rawTime() >= 0 && i.totalTime(i._tTime), i = i._dp;
                t1._zTime = -0.00000001;
            }
        }, _b = function(t1, e, i, n) {
            return e.parent && mb(e), e._start = ib((Mw(i) ? i : i || t1 !== Wx ? Ob(t1, i, e) : t1._time) + e._delay), e._end = ib(e._start + (e.totalDuration() / Math.abs(e.timeScale()) || 0)), Ab(t1, e, "_first", "_last", t1._sort ? "_start" : 0), Db(e) || (t1._recent = e), n || Eb(t1, e), t1._ts < 0 && Tb(t1, t1._tTime), t1;
        }, Ib = function(t1, e) {
            return (Lw.ScrollTrigger || jw("scrollTrigger", e)) && Lw.ScrollTrigger.create(e, t1);
        }, Sb = function(t1, e, i, n, r) {
            return zT(t1, e, r), t1._initted ? !i && t1._pt && !Vx && (t1._dur && !1 !== t1.vars.lazy || !t1._dur && t1.vars.lazy) && Jx !== hT.frame ? (Vw.push(t1), t1._lazy = [
                r,
                n
            ], 1) : void 0 : 1;
        }, Nb = function t1(e) {
            var i = e.parent;
            return i && i._ts && i._initted && !i._lock && (i.rawTime() < 0 || t1(i));
        }, Db = function(t1) {
            var e = t1.data;
            return "isFromStart" === e || "isStart" === e;
        }, Cb = function(t1, e, i, n) {
            var r = t1._repeat, a = ib(e) || 0, s = t1._tTime / t1._tDur;
            return s && !n && (t1._time *= a / t1._dur), t1._dur = a, t1._tDur = r ? r < 0 ? 1e10 : ib(a * (r + 1) + t1._rDelay * r) : a, s > 0 && !n && Tb(t1, t1._tTime = t1._tDur * s), t1.parent && bb(t1), i || gb(t1.parent, t1), t1;
        }, zb = function(t1) {
            return t1 instanceof _T ? gb(t1) : Cb(t1, t1._dur);
        }, Lb = {
            _start: 0,
            endTime: Uw,
            totalDuration: Uw
        }, Ob = function t1(e, i, n) {
            var r, a, s, o = e.labels, l = e._recent || Lb, c = e.duration() >= lw ? l.endTime(!1) : e._dur;
            return mw(i) && (isNaN(i) || i in o) ? (a = i.charAt(0), s = "%" === i.substr(-1), r = i.indexOf("="), "<" === a || ">" === a ? (r >= 0 && (i = i.replace(/=/, "")), ("<" === a ? l._start : l.endTime(l._repeat >= 0)) + (parseFloat(i.substr(1)) || 0) * (s ? (r < 0 ? l : n).totalDuration() / 100 : 1)) : r < 0 ? (i in o || (o[i] = c), o[i]) : (a = parseFloat(i.charAt(r - 1) + i.substr(r + 1)), s && n && (a = a / 100 * (Ew(n) ? n[0] : n).totalDuration()), r > 1 ? t1(e, i.substr(0, r - 1), n) + a : c + a)) : null == i ? c : +i;
        }, Pb = function(t1, e, i) {
            var n, r, a = Mw(e[1]), s = (a ? 2 : 1) + (t1 < 2 ? 0 : 1), o = e[s];
            if (a && (o.duration = e[1]), o.parent = i, t1) {
                for(n = o, r = i; r && !("immediateRender" in n);)n = r.vars.defaults || {}, r = xw(r.vars.inherit) && r.parent;
                o.immediateRender = xw(n.immediateRender), t1 < 2 ? o.runBackwards = 1 : o.startAt = e[s - 1];
            }
            return new RT(e[0], o, e[s + 1]);
        }, jb = function(t1, e) {
            return t1 || 0 === t1 ? e(t1) : e;
        }, Rb = function(t1, e, i) {
            return i < t1 ? t1 : i > e ? e : i;
        }, kb = function(t1, e) {
            return mw(t1) && (e = zw.exec(t1)) ? e[1] : "";
        }, Ub = [].slice, Bb = function(t1, e) {
            return t1 && yw(t1) && "length" in t1 && (!e && !t1.length || t1.length - 1 in t1 && yw(t1[0])) && !t1.nodeType && t1 !== Yx;
        }, Fb = function(t1, e, i) {
            return Gx && !e && Gx.selector ? Gx.selector(t1) : !mw(t1) || i || !Xx && dT() ? Ew(t1) ? function(t1, e, i) {
                return void 0 === i && (i = []), t1.forEach(function(t1) {
                    var n;
                    return mw(t1) && !e || Bb(t1, 1) ? (n = i).push.apply(n, Fb(t1)) : i.push(t1);
                }) || i;
            }(t1, i) : Bb(t1) ? Ub.call(t1, 0) : t1 ? [
                t1
            ] : [] : Ub.call((e || Zx).querySelectorAll(t1), 0);
        }, Qb = function(t1) {
            return t1 = Fb(t1)[0] || Rw("Invalid scope") || {}, function(e) {
                var i = t1.current || t1.nativeElement || t1;
                return Fb(e, i.querySelectorAll ? i : i === t1 ? Rw("Invalid scope") || Zx.createElement("div") : t1);
            };
        }, Hb = function(t1) {
            return t1.sort(function() {
                return .5 - Math.random();
            });
        }, Vb = function(t1) {
            if (gw(t1)) return t1;
            var e = yw(t1) ? t1 : {
                each: t1
            }, i = vT(e.ease), n = e.from || 0, r = parseFloat(e.base) || 0, a = {}, s = n > 0 && n < 1, o = isNaN(n) || s, l = e.axis, c = n, u = n;
            return mw(n) ? c = u = ({
                center: .5,
                edges: .5,
                end: 1
            })[n] || 0 : !s && o && (c = n[0], u = n[1]), function(t1, s, h) {
                var d, p, A, f, m, g, M, v, y, x = (h || e).length, w = a[x];
                if (!w) {
                    if (!(y = "auto" === e.grid ? 0 : (e.grid || [
                        1,
                        lw
                    ])[1])) {
                        for(M = -lw; M < (M = h[y++].getBoundingClientRect().left) && y < x;);
                        y < x && y--;
                    }
                    for(w = a[x] = [], d = o ? Math.min(y, x) * c - .5 : n % y, p = y === lw ? 0 : o ? x * u / y - .5 : n / y | 0, M = 0, v = lw, g = 0; g < x; g++)A = g % y - d, f = p - (g / y | 0), w[g] = m = l ? Math.abs("y" === l ? f : A) : pw(A * A + f * f), m > M && (M = m), m < v && (v = m);
                    "random" === n && Hb(w), w.max = M - v, w.min = v, w.v = x = (parseFloat(e.amount) || parseFloat(e.each) * (y > x ? x - 1 : l ? "y" === l ? x / y : y : Math.max(y, x / y)) || 0) * ("edges" === n ? -1 : 1), w.b = x < 0 ? r - x : r, w.u = kb(e.amount || e.each) || 0, i = i && x < 0 ? gT(i) : i;
                }
                return x = (w[t1] - w.min) / w.max || 0, ib(w.b + (i ? i(x) : x) * w.v) + w.u;
            };
        }, Gb = function(t1) {
            var e = Math.pow(10, ((t1 + "").split(".")[1] || "").length);
            return function(i) {
                var n = ib(Math.round(parseFloat(i) / t1) * t1 * e);
                return (n - n % 1) / e + (Mw(i) ? 0 : kb(i));
            };
        }, Wb = function(t1, e) {
            var i, n, r = Ew(t1);
            return !r && yw(t1) && (i = r = t1.radius || lw, t1.values ? (t1 = Fb(t1.values), (n = !Mw(t1[0])) && (i *= i)) : t1 = Gb(t1.increment)), jb(e, r ? gw(t1) ? function(e) {
                return n = t1(e), Math.abs(n - e) <= i ? n : e;
            } : function(e) {
                for(var r, a, s = parseFloat(n ? e.x : e), o = parseFloat(n ? e.y : 0), l = lw, c = 0, u = t1.length; u--;)(r = n ? (r = t1[u].x - s) * r + (a = t1[u].y - o) * a : Math.abs(t1[u] - s)) < l && (l = r, c = u);
                return c = !i || l <= i ? t1[c] : e, n || c === e || Mw(e) ? c : c + kb(e);
            } : Gb(t1));
        }, Yb = function(t1, e, i, n) {
            return jb(Ew(t1) ? !e : !0 === i ? (i = 0, false) : !n, function() {
                return Ew(t1) ? t1[~~(Math.random() * t1.length)] : (i = i || 1e-5, n = i < 1 ? Math.pow(10, (i + "").length - 2) : 1) && Math.floor(Math.round((t1 - i / 2 + Math.random() * (e - t1 + .99 * i)) / i) * i * n) / n;
            });
        }, Xb = function(t1, e, i) {
            return jb(i, function(i) {
                return t1[~~e(i)];
            });
        }, Zb = function(t1) {
            for(var e, i, n, r, a = 0, s = ""; ~(e = t1.indexOf("random(", a));)n = t1.indexOf(")", e), r = "[" === t1.charAt(e + 7), i = t1.substr(e + 7, n - e - 7).match(r ? Cw : _w), s += t1.substr(a, e - a) + Yb(r ? i : +i[0], r ? 0 : +i[1], +i[2] || 1e-5), a = n + 1;
            return s + t1.substr(a, t1.length - a);
        }, qb = function(t1, e, i, n, r) {
            var a = e - t1, s = n - i;
            return jb(r, function(e) {
                return i + ((e - t1) / a * s || 0);
            });
        }, Jb = function(t1, e, i) {
            var n, r, a, s = t1.labels, o = lw;
            for(n in s)(r = s[n] - e) < 0 == !!i && r && o > (r = Math.abs(r)) && (a = n, o = r);
            return a;
        }, Kb = function(t1, e, i) {
            var n, r, a, s = t1.vars, o = s[e], l = Gx, c = t1._ctx;
            if (o) return n = s[e + "Params"], r = s.callbackScope || t1, i && Vw.length && ab(), c && (Gx = c), a = n ? o.apply(r, n) : o.call(r), Gx = l, a;
        }, $b = function(t1) {
            return mb(t1), t1.scrollTrigger && t1.scrollTrigger.kill(!!Vx), t1.progress() < 1 && Kb(t1, "onInterrupt"), t1;
        }, tT = [], eT = function(t1) {
            if (t1) {
                if (t1 = !t1.name && t1.default || t1, ww() || t1.headless) {
                    var e = t1.name, i = gw(t1), n = e && !i && t1.init ? function() {
                        this._props = [];
                    } : t1, r = {
                        init: Uw,
                        render: WT,
                        add: DT,
                        kill: XT,
                        modifier: YT,
                        rawVars: 0
                    }, a = {
                        targetTest: 0,
                        get: 0,
                        getSetter: QT,
                        aliases: {},
                        register: 0
                    };
                    if (dT(), t1 !== n) {
                        if (Ww[e]) return;
                        cb(n, cb(db(t1, r), a)), ub(n.prototype, ub(r, db(t1, a))), Ww[n.prop = e] = n, t1.targetTest && (Zw.push(n), Hw[e] = 1), e = ("css" === e ? "CSS" : e.charAt(0).toUpperCase() + e.substr(1)) + "Plugin";
                    }
                    kw(e, n), t1.register && t1.register(uE, n, JT);
                } else tT.push(t1);
            }
        }, iT = 255, nT = {
            aqua: [
                0,
                iT,
                iT
            ],
            lime: [
                0,
                iT,
                0
            ],
            silver: [
                192,
                192,
                192
            ],
            black: [
                0,
                0,
                0
            ],
            maroon: [
                128,
                0,
                0
            ],
            teal: [
                0,
                128,
                128
            ],
            blue: [
                0,
                0,
                iT
            ],
            navy: [
                0,
                0,
                128
            ],
            white: [
                iT,
                iT,
                iT
            ],
            olive: [
                128,
                128,
                0
            ],
            yellow: [
                iT,
                iT,
                0
            ],
            orange: [
                iT,
                165,
                0
            ],
            gray: [
                128,
                128,
                128
            ],
            purple: [
                128,
                0,
                128
            ],
            green: [
                0,
                128,
                0
            ],
            red: [
                iT,
                0,
                0
            ],
            pink: [
                iT,
                192,
                203
            ],
            cyan: [
                0,
                iT,
                iT
            ],
            transparent: [
                iT,
                iT,
                iT,
                0
            ]
        }, rT = function(t1, e, i) {
            return (6 * (t1 += t1 < 0 ? 1 : t1 > 1 ? -1 : 0) < 1 ? e + (i - e) * t1 * 6 : t1 < .5 ? i : 3 * t1 < 2 ? e + (i - e) * (2 / 3 - t1) * 6 : e) * iT + .5 | 0;
        }, aT = function(t1, e, i) {
            var n, r, a, s, o, l, c, u, h, d, p = t1 ? Mw(t1) ? [
                t1 >> 16,
                t1 >> 8 & iT,
                t1 & iT
            ] : 0 : nT.black;
            if (!p) {
                if ("," === t1.substr(-1) && (t1 = t1.substr(0, t1.length - 1)), nT[t1]) p = nT[t1];
                else if ("#" === t1.charAt(0)) {
                    if (t1.length < 6 && (n = t1.charAt(1), r = t1.charAt(2), a = t1.charAt(3), t1 = "#" + n + n + r + r + a + a + (5 === t1.length ? t1.charAt(4) + t1.charAt(4) : "")), 9 === t1.length) return [
                        (p = parseInt(t1.substr(1, 6), 16)) >> 16,
                        p >> 8 & iT,
                        p & iT,
                        parseInt(t1.substr(7), 16) / 255
                    ];
                    p = [
                        (t1 = parseInt(t1.substr(1), 16)) >> 16,
                        t1 >> 8 & iT,
                        t1 & iT
                    ];
                } else if ("hsl" === t1.substr(0, 3)) {
                    if (p = d = t1.match(_w), e) {
                        if (~t1.indexOf("=")) return p = t1.match(Iw), i && p.length < 4 && (p[3] = 1), p;
                    } else s = +p[0] % 360 / 360, o = +p[1] / 100, n = 2 * (l = +p[2] / 100) - (r = l <= .5 ? l * (o + 1) : l + o - l * o), p.length > 3 && (p[3] *= 1), p[0] = rT(s + 1 / 3, n, r), p[1] = rT(s, n, r), p[2] = rT(s - 1 / 3, n, r);
                } else p = t1.match(_w) || nT.transparent;
                p = p.map(Number);
            }
            return e && !d && (n = p[0] / iT, r = p[1] / iT, a = p[2] / iT, l = ((c = Math.max(n, r, a)) + (u = Math.min(n, r, a))) / 2, c === u ? s = o = 0 : (h = c - u, o = l > .5 ? h / (2 - c - u) : h / (c + u), s = c === n ? (r - a) / h + (r < a ? 6 : 0) : c === r ? (a - n) / h + 2 : (n - r) / h + 4, s *= 60), p[0] = ~~(s + .5), p[1] = ~~(100 * o + .5), p[2] = ~~(100 * l + .5)), i && p.length < 4 && (p[3] = 1), p;
        }, sT = function(t1) {
            var e = [], i = [], n = -1;
            return t1.split(lT).forEach(function(t1) {
                var r = t1.match(Sw) || [];
                e.push.apply(e, r), i.push(n += r.length + 1);
            }), e.c = i, e;
        }, oT = function(t1, e, i) {
            var n, r, a, s, o = "", l = (t1 + o).match(lT), c = e ? "hsla(" : "rgba(", u = 0;
            if (!l) return t1;
            if (l = l.map(function(t1) {
                return (t1 = aT(t1, e, 1)) && c + (e ? t1[0] + "," + t1[1] + "%," + t1[2] + "%," + t1[3] : t1.join(",")) + ")";
            }), i && (a = sT(t1), (n = i.c).join(o) !== a.c.join(o))) for(s = (r = t1.replace(lT, "1").split(Sw)).length - 1; u < s; u++)o += r[u] + (~n.indexOf(u) ? l.shift() || c + "0,0,0,0)" : (a.length ? a : l.length ? l : i).shift());
            if (!r) for(s = (r = t1.split(lT)).length - 1; u < s; u++)o += r[u] + l[u];
            return o + r[s];
        }, lT = function() {
            var t1, e = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b";
            for(t1 in nT)e += "|" + t1 + "\\b";
            return new RegExp(e + ")", "gi");
        }(), cT = /hsl[a]?\(/, uT = function(t1) {
            var e, i = t1.join(" ");
            if (lT.lastIndex = 0, lT.test(i)) return e = cT.test(i), t1[1] = oT(t1[1], e), t1[0] = oT(t1[0], e, sT(t1[1])), !0;
        }, hT = function() {
            var t1, e, i, n, r, a, s = Date.now, o = 500, l = 33, c = s(), u = c, h = 1e3 / 240, d = h, p = [], A = function i(A) {
                var f, m, g, M, v = s() - u, y = !0 === A;
                if ((v > o || v < 0) && (c += v - l), ((f = (g = (u += v) - c) - d) > 0 || y) && (M = ++n.frame, r = g - 1e3 * n.time, n.time = g /= 1e3, d += f + (f >= h ? 4 : h - f), m = 1), y || (t1 = e(i)), m) for(a = 0; a < p.length; a++)p[a](g, r, M, A);
            };
            return n = {
                time: 0,
                frame: 0,
                tick: function() {
                    A(!0);
                },
                deltaRatio: function(t1) {
                    return r / (1e3 / (t1 || 60));
                },
                wake: function() {
                    qx && (!Xx && ww() && (Yx = Xx = window, Zx = Yx.document || {}, Lw.gsap = uE, (Yx.gsapVersions || (Yx.gsapVersions = [])).push(uE.version), Pw(Ow || Yx.GreenSockGlobals || !Yx.gsap && Yx || {}), tT.forEach(eT)), i = "undefined" != typeof requestAnimationFrame && requestAnimationFrame, t1 && n.sleep(), e = i || function(t1) {
                        return setTimeout(t1, d - 1e3 * n.time + 1 | 0);
                    }, $x = 1, A(2));
                },
                sleep: function() {
                    (i ? cancelAnimationFrame : clearTimeout)(t1), $x = 0, e = Uw;
                },
                lagSmoothing: function(t1, e) {
                    o = t1 || 1 / 0, l = Math.min(e || 33, o);
                },
                fps: function(t1) {
                    h = 1e3 / (t1 || 240), d = 1e3 * n.time + h;
                },
                add: function(t1, e, i) {
                    var r = e ? function(e, i, a, s) {
                        t1(e, i, a, s), n.remove(r);
                    } : t1;
                    return n.remove(t1), p[i ? "unshift" : "push"](r), dT(), r;
                },
                remove: function(t1, e) {
                    ~(e = p.indexOf(t1)) && p.splice(e, 1) && a >= e && a--;
                },
                _listeners: p
            }, n;
        }(), dT = function() {
            return !$x && hT.wake();
        }, pT = {}, AT = /^[\d.\-M][\d.\-,\s]/, fT = /["']/g, mT = function(t1) {
            for(var e, i, n, r = {}, a = t1.substr(1, t1.length - 3).split(":"), s = a[0], o = 1, l = a.length; o < l; o++)i = a[o], e = o !== l - 1 ? i.lastIndexOf(",") : i.length, n = i.substr(0, e), r[s] = isNaN(n) ? n.replace(fT, "").trim() : +n, s = i.substr(e + 1).trim();
            return r;
        }, gT = function(t1) {
            return function(e) {
                return 1 - t1(1 - e);
            };
        }, MT = function t1(e, i) {
            for(var n, r = e._first; r;)r instanceof _T ? t1(r, i) : !r.vars.yoyoEase || r._yoyo && r._repeat || r._yoyo === i || (r.timeline ? t1(r.timeline, i) : (n = r._ease, r._ease = r._yEase, r._yEase = n, r._yoyo = i)), r = r._next;
        }, vT = function(t1, e) {
            return t1 && (gw(t1) ? t1 : pT[t1] || function(t1) {
                var e, i, n, r, a = (t1 + "").split("("), s = pT[a[0]];
                return s && a.length > 1 && s.config ? s.config.apply(null, ~t1.indexOf("{") ? [
                    mT(a[1])
                ] : (e = t1, i = e.indexOf("(") + 1, n = e.indexOf(")"), r = e.indexOf("(", i), e.substring(i, ~r && r < n ? e.indexOf(")", n + 1) : n)).split(",").map(ob)) : pT._CE && AT.test(t1) ? pT._CE("", t1) : s;
            }(t1)) || e;
        }, yT = function(t1, e, i, n) {
            void 0 === i && (i = function(t1) {
                return 1 - e(1 - t1);
            }), void 0 === n && (n = function(t1) {
                return t1 < .5 ? e(2 * t1) / 2 : 1 - e(2 * (1 - t1)) / 2;
            });
            var r, a = {
                easeIn: e,
                easeOut: i,
                easeInOut: n
            };
            return tb(t1, function(t1) {
                for(var e in pT[t1] = Lw[t1] = a, pT[r = t1.toLowerCase()] = i, a)pT[r + ("easeIn" === e ? ".in" : "easeOut" === e ? ".out" : ".inOut")] = pT[t1 + "." + e] = a[e];
            }), a;
        }, xT = function(t1) {
            return function(e) {
                return e < .5 ? (1 - t1(1 - 2 * e)) / 2 : .5 + t1(2 * (e - .5)) / 2;
            };
        }, wT = function t1(e, i, n) {
            var r = i >= 1 ? i : 1, a = (n || (e ? .3 : .45)) / (i < 1 ? i : 1), s = a / uw * (Math.asin(1 / r) || 0), o = function(t1) {
                return 1 === t1 ? 1 : r * Math.pow(2, -10 * t1) * fw((t1 - s) * a) + 1;
            }, l = "out" === e ? o : "in" === e ? function(t1) {
                return 1 - o(1 - t1);
            } : xT(o);
            return a = uw / a, l.config = function(i, n) {
                return t1(e, i, n);
            }, l;
        }, bT = function t1(e, i) {
            void 0 === i && (i = 1.70158);
            var n = function(t1) {
                return t1 ? --t1 * t1 * ((i + 1) * t1 + i) + 1 : 0;
            }, r = "out" === e ? n : "in" === e ? function(t1) {
                return 1 - n(1 - t1);
            } : xT(n);
            return r.config = function(i) {
                return t1(e, i);
            }, r;
        };
        tb("Linear,Quad,Cubic,Quart,Quint,Strong", function(t1, e) {
            var i = e < 5 ? e + 1 : e;
            yT(t1 + ",Power" + (i - 1), e ? function(t1) {
                return Math.pow(t1, i);
            } : function(t1) {
                return t1;
            }, function(t1) {
                return 1 - Math.pow(1 - t1, i);
            }, function(t1) {
                return t1 < .5 ? Math.pow(2 * t1, i) / 2 : 1 - Math.pow(2 * (1 - t1), i) / 2;
            });
        }), pT.Linear.easeNone = pT.none = pT.Linear.easeIn, yT("Elastic", wT("in"), wT("out"), wT()), tw = 7.5625, nw = 2 * (iw = 1 / (ew = 2.75)), rw = 2.5 * iw, yT("Bounce", function(t1) {
            return 1 - aw(1 - t1);
        }, aw = function(t1) {
            return t1 < iw ? tw * t1 * t1 : t1 < nw ? tw * Math.pow(t1 - 1.5 / ew, 2) + .75 : t1 < rw ? tw * (t1 -= 2.25 / ew) * t1 + .9375 : tw * Math.pow(t1 - 2.625 / ew, 2) + .984375;
        }), yT("Expo", function(t1) {
            return t1 ? Math.pow(2, 10 * (t1 - 1)) : 0;
        }), yT("Circ", function(t1) {
            return -(pw(1 - t1 * t1) - 1);
        }), yT("Sine", function(t1) {
            return 1 === t1 ? 1 : 1 - Aw(t1 * hw);
        }), yT("Back", bT("in"), bT("out"), bT()), pT.SteppedEase = pT.steps = Lw.SteppedEase = {
            config: function(t1, e) {
                void 0 === t1 && (t1 = 1);
                var i = 1 / t1, n = t1 + (e ? 0 : 1), r = e ? 1 : 0;
                return function(t1) {
                    return ((n * Rb(0, .99999999, t1) | 0) + r) * i;
                };
            }
        }, ow.ease = pT["quad.out"], tb("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(t1) {
            return qw += t1 + "," + t1 + "Params,";
        });
        var TT = function(t1, e) {
            this.id = dw++, t1._gsap = this, this.target = t1, this.harness = e, this.get = e ? e.get : $w, this.set = e ? e.getSetter : QT;
        }, ET = function() {
            function t1(t1) {
                this.vars = t1, this._delay = +t1.delay || 0, (this._repeat = t1.repeat === 1 / 0 ? -2 : t1.repeat || 0) && (this._rDelay = t1.repeatDelay || 0, this._yoyo = !!t1.yoyo || !!t1.yoyoEase), this._ts = 1, Cb(this, +t1.duration, 1, 1), this.data = t1.data, Gx && (this._ctx = Gx, Gx.data.push(this)), $x || hT.wake();
            }
            var e = t1.prototype;
            return e.delay = function(t1) {
                return t1 || 0 === t1 ? (this.parent && this.parent.smoothChildTiming && this.startTime(this._start + t1 - this._delay), this._delay = t1, this) : this._delay;
            }, e.duration = function(t1) {
                return arguments.length ? this.totalDuration(this._repeat > 0 ? t1 + (t1 + this._rDelay) * this._repeat : t1) : this.totalDuration() && this._dur;
            }, e.totalDuration = function(t1) {
                return arguments.length ? (this._dirty = 0, Cb(this, this._repeat < 0 ? t1 : (t1 - this._repeat * this._rDelay) / (this._repeat + 1))) : this._tDur;
            }, e.totalTime = function(t1, e) {
                if (dT(), !arguments.length) return this._tTime;
                var i = this._dp;
                if (i && i.smoothChildTiming && this._ts) {
                    for(Tb(this, t1), !i._dp || i.parent || Eb(i, this); i && i.parent;)i.parent._time !== i._start + (i._ts >= 0 ? i._tTime / i._ts : (i.totalDuration() - i._tTime) / -i._ts) && i.totalTime(i._tTime, !0), i = i.parent;
                    !this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && t1 < this._tDur || this._ts < 0 && t1 > 0 || !this._tDur && !t1) && _b(this._dp, this, this._start - this._delay);
                }
                return (this._tTime !== t1 || !this._dur && !e || this._initted && Math.abs(this._zTime) === cw || !t1 && !this._initted && (this.add || this._ptLookup)) && (this._ts || (this._pTime = t1), sb(this, t1, e)), this;
            }, e.time = function(t1, e) {
                return arguments.length ? this.totalTime(Math.min(this.totalDuration(), t1 + yb(this)) % (this._dur + this._rDelay) || (t1 ? this._dur : 0), e) : this._time;
            }, e.totalProgress = function(t1, e) {
                return arguments.length ? this.totalTime(this.totalDuration() * t1, e) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.rawTime() > 0 ? 1 : 0;
            }, e.progress = function(t1, e) {
                return arguments.length ? this.totalTime(this.duration() * (!this._yoyo || 1 & this.iteration() ? t1 : 1 - t1) + yb(this), e) : this.duration() ? Math.min(1, this._time / this._dur) : this.rawTime() > 0 ? 1 : 0;
            }, e.iteration = function(t1, e) {
                var i = this.duration() + this._rDelay;
                return arguments.length ? this.totalTime(this._time + (t1 - 1) * i, e) : this._repeat ? xb(this._tTime, i) + 1 : 1;
            }, e.timeScale = function(t1, e) {
                if (!arguments.length) return -0.00000001 === this._rts ? 0 : this._rts;
                if (this._rts === t1) return this;
                var i = this.parent && this._ts ? wb(this.parent._time, this) : this._tTime;
                return this._rts = +t1 || 0, this._ts = this._ps || -0.00000001 === t1 ? 0 : this._rts, this.totalTime(Rb(-Math.abs(this._delay), this._tDur, i), !1 !== e), bb(this), function(t1) {
                    for(var e = t1.parent; e && e.parent;)e._dirty = 1, e.totalDuration(), e = e.parent;
                    return t1;
                }(this);
            }, e.paused = function(t1) {
                return arguments.length ? (this._ps !== t1 && (this._ps = t1, t1 ? (this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()), this._ts = this._act = 0) : (dT(), this._ts = this._rts, this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, 1 === this.progress() && Math.abs(this._zTime) !== cw && (this._tTime -= cw)))), this) : this._ps;
            }, e.startTime = function(t1) {
                if (arguments.length) {
                    this._start = t1;
                    var e = this.parent || this._dp;
                    return e && (e._sort || !this.parent) && _b(e, this, t1 - this._delay), this;
                }
                return this._start;
            }, e.endTime = function(t1) {
                return this._start + (xw(t1) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
            }, e.rawTime = function(t1) {
                var e = this.parent || this._dp;
                return e ? t1 && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : this._ts ? wb(e.rawTime(t1), this) : this._tTime : this._tTime;
            }, e.revert = function(t1) {
                void 0 === t1 && (t1 = Qw);
                var e = Vx;
                return Vx = t1, (this._initted || this._startAt) && (this.timeline && this.timeline.revert(t1), this.totalTime(-0.01, t1.suppressEvents)), "nested" !== this.data && !1 !== t1.kill && this.kill(), Vx = e, this;
            }, e.globalTime = function(t1) {
                for(var e = this, i = arguments.length ? t1 : e.rawTime(); e;)i = e._start + i / (Math.abs(e._ts) || 1), e = e._dp;
                return !this.parent && this._sat ? this._sat.globalTime(t1) : i;
            }, e.repeat = function(t1) {
                return arguments.length ? (this._repeat = t1 === 1 / 0 ? -2 : t1, zb(this)) : -2 === this._repeat ? 1 / 0 : this._repeat;
            }, e.repeatDelay = function(t1) {
                if (arguments.length) {
                    var e = this._time;
                    return this._rDelay = t1, zb(this), e ? this.time(e) : this;
                }
                return this._rDelay;
            }, e.yoyo = function(t1) {
                return arguments.length ? (this._yoyo = t1, this) : this._yoyo;
            }, e.seek = function(t1, e) {
                return this.totalTime(Ob(this, t1), xw(e));
            }, e.restart = function(t1, e) {
                return this.play().totalTime(t1 ? -this._delay : 0, xw(e));
            }, e.play = function(t1, e) {
                return null != t1 && this.seek(t1, e), this.reversed(!1).paused(!1);
            }, e.reverse = function(t1, e) {
                return null != t1 && this.seek(t1 || this.totalDuration(), e), this.reversed(!0).paused(!1);
            }, e.pause = function(t1, e) {
                return null != t1 && this.seek(t1, e), this.paused(!0);
            }, e.resume = function() {
                return this.paused(!1);
            }, e.reversed = function(t1) {
                return arguments.length ? (!!t1 !== this.reversed() && this.timeScale(-this._rts || (t1 ? -0.00000001 : 0)), this) : this._rts < 0;
            }, e.invalidate = function() {
                return this._initted = this._act = 0, this._zTime = -0.00000001, this;
            }, e.isActive = function() {
                var t1, e = this.parent || this._dp, i = this._start;
                return !(e && !(this._ts && this._initted && e.isActive() && (t1 = e.rawTime(!0)) >= i && t1 < this.endTime(!0) - cw));
            }, e.eventCallback = function(t1, e, i) {
                var n = this.vars;
                return arguments.length > 1 ? (e ? (n[t1] = e, i && (n[t1 + "Params"] = i), "onUpdate" === t1 && (this._onUpdate = e)) : delete n[t1], this) : n[t1];
            }, e.then = function(t1) {
                var e = this;
                return new Promise(function(i) {
                    var n = gw(t1) ? t1 : lb, r = function() {
                        var t1 = e.then;
                        e.then = null, gw(n) && (n = n(e)) && (n.then || n === e) && (e.then = t1), i(n), e.then = t1;
                    };
                    e._initted && 1 === e.totalProgress() && e._ts >= 0 || !e._tTime && e._ts < 0 ? r() : e._prom = r;
                });
            }, e.kill = function() {
                $b(this);
            }, t1;
        }();
        cb(ET.prototype, {
            _time: 0,
            _start: 0,
            _end: 0,
            _tTime: 0,
            _tDur: 0,
            _dirty: 0,
            _repeat: 0,
            _yoyo: !1,
            parent: null,
            _initted: !1,
            _rDelay: 0,
            _ts: 1,
            _dp: 0,
            ratio: 0,
            _zTime: -0.00000001,
            _prom: 0,
            _ps: !1,
            _rts: 1
        });
        var _T = function(t1) {
            function e(e, i) {
                var n;
                return void 0 === e && (e = {}), (n = t1.call(this, e) || this).labels = {}, n.smoothChildTiming = !!e.smoothChildTiming, n.autoRemoveChildren = !!e.autoRemoveChildren, n._sort = xw(e.sortChildren), Wx && _b(e.parent || Wx, Fx(n), i), e.reversed && n.reverse(), e.paused && n.paused(!0), e.scrollTrigger && Ib(Fx(n), e.scrollTrigger), n;
            }
            Qx(e, t1);
            var i = e.prototype;
            return i.to = function(t1, e, i) {
                return Pb(0, arguments, this), this;
            }, i.from = function(t1, e, i) {
                return Pb(1, arguments, this), this;
            }, i.fromTo = function(t1, e, i, n) {
                return Pb(2, arguments, this), this;
            }, i.set = function(t1, e, i) {
                return e.duration = 0, e.parent = this, pb(e).repeatDelay || (e.repeat = 0), e.immediateRender = !!e.immediateRender, new RT(t1, e, Ob(this, i), 1), this;
            }, i.call = function(t1, e, i) {
                return _b(this, RT.delayedCall(0, t1, e), i);
            }, i.staggerTo = function(t1, e, i, n, r, a, s) {
                return i.duration = e, i.stagger = i.stagger || n, i.onComplete = a, i.onCompleteParams = s, i.parent = this, new RT(t1, i, Ob(this, r)), this;
            }, i.staggerFrom = function(t1, e, i, n, r, a, s) {
                return i.runBackwards = 1, pb(i).immediateRender = xw(i.immediateRender), this.staggerTo(t1, e, i, n, r, a, s);
            }, i.staggerFromTo = function(t1, e, i, n, r, a, s, o) {
                return n.startAt = i, pb(n).immediateRender = xw(n.immediateRender), this.staggerTo(t1, e, n, r, a, s, o);
            }, i.render = function(t1, e, i) {
                var n, r, a, s, o, l, c, u, h, d, p, A, f = this._time, m = this._dirty ? this.totalDuration() : this._tDur, g = this._dur, M = t1 <= 0 ? 0 : ib(t1), v = this._zTime < 0 != t1 < 0 && (this._initted || !g);
                if (this !== Wx && M > m && t1 >= 0 && (M = m), M !== this._tTime || i || v) {
                    if (f !== this._time && g && (M += this._time - f, t1 += this._time - f), n = M, h = this._start, l = !(u = this._ts), v && (g || (f = this._zTime), (t1 || !e) && (this._zTime = t1)), this._repeat) {
                        if (p = this._yoyo, o = g + this._rDelay, this._repeat < -1 && t1 < 0) return this.totalTime(100 * o + t1, e, i);
                        if (n = ib(M % o), M === m ? (s = this._repeat, n = g) : ((s = ~~(M / o)) && s === M / o && (n = g, s--), n > g && (n = g)), d = xb(this._tTime, o), !f && this._tTime && d !== s && this._tTime - d * o - this._dur <= 0 && (d = s), p && 1 & s && (n = g - n, A = 1), s !== d && !this._lock) {
                            var y = p && 1 & d, x = y === (p && 1 & s);
                            if (s < d && (y = !y), f = y ? 0 : M % g ? g : M, this._lock = 1, this.render(f || (A ? 0 : ib(s * o)), e, !g)._lock = 0, this._tTime = M, !e && this.parent && Kb(this, "onRepeat"), this.vars.repeatRefresh && !A && (this.invalidate()._lock = 1), f && f !== this._time || l !== !this._ts || this.vars.onRepeat && !this.parent && !this._act) return this;
                            if (g = this._dur, m = this._tDur, x && (this._lock = 2, f = y ? g : -0.0001, this.render(f, !0), this.vars.repeatRefresh && !A && this.invalidate()), this._lock = 0, !this._ts && !l) return this;
                            MT(this, A);
                        }
                    }
                    if (this._hasPause && !this._forcing && this._lock < 2 && (c = function(t1, e, i) {
                        var n;
                        if (i > e) for(n = t1._first; n && n._start <= i;){
                            if ("isPause" === n.data && n._start > e) return n;
                            n = n._next;
                        }
                        else for(n = t1._last; n && n._start >= i;){
                            if ("isPause" === n.data && n._start < e) return n;
                            n = n._prev;
                        }
                    }(this, ib(f), ib(n)), c && (M -= n - (n = c._start))), this._tTime = M, this._time = n, this._act = !u, this._initted || (this._onUpdate = this.vars.onUpdate, this._initted = 1, this._zTime = t1, f = 0), !f && n && !e && !s && (Kb(this, "onStart"), this._tTime !== M)) return this;
                    if (n >= f && t1 >= 0) for(r = this._first; r;){
                        if (a = r._next, (r._act || n >= r._start) && r._ts && c !== r) {
                            if (r.parent !== this) return this.render(t1, e, i);
                            if (r.render(r._ts > 0 ? (n - r._start) * r._ts : (r._dirty ? r.totalDuration() : r._tDur) + (n - r._start) * r._ts, e, i), n !== this._time || !this._ts && !l) {
                                c = 0, a && (M += this._zTime = -0.00000001);
                                break;
                            }
                        }
                        r = a;
                    }
                    else {
                        r = this._last;
                        for(var w = t1 < 0 ? t1 : n; r;){
                            if (a = r._prev, (r._act || w <= r._end) && r._ts && c !== r) {
                                if (r.parent !== this) return this.render(t1, e, i);
                                if (r.render(r._ts > 0 ? (w - r._start) * r._ts : (r._dirty ? r.totalDuration() : r._tDur) + (w - r._start) * r._ts, e, i || Vx && (r._initted || r._startAt)), n !== this._time || !this._ts && !l) {
                                    c = 0, a && (M += this._zTime = w ? -0.00000001 : cw);
                                    break;
                                }
                            }
                            r = a;
                        }
                    }
                    if (c && !e && (this.pause(), c.render(n >= f ? 0 : -0.00000001)._zTime = n >= f ? 1 : -1, this._ts)) return this._start = h, bb(this), this.render(t1, e, i);
                    this._onUpdate && !e && Kb(this, "onUpdate", !0), (M === m && this._tTime >= this.totalDuration() || !M && f) && (h !== this._start && Math.abs(u) === Math.abs(this._ts) || this._lock || ((t1 || !g) && (M === m && this._ts > 0 || !M && this._ts < 0) && mb(this, 1), e || t1 < 0 && !f || !M && !f && m || (Kb(this, M === m && t1 >= 0 ? "onComplete" : "onReverseComplete", !0), this._prom && !(M < m && this.timeScale() > 0) && this._prom())));
                }
                return this;
            }, i.add = function(t1, e) {
                var i = this;
                if (Mw(e) || (e = Ob(this, e, t1)), !(t1 instanceof ET)) {
                    if (Ew(t1)) return t1.forEach(function(t1) {
                        return i.add(t1, e);
                    }), this;
                    if (mw(t1)) return this.addLabel(t1, e);
                    if (!gw(t1)) return this;
                    t1 = RT.delayedCall(0, t1);
                }
                return this !== t1 ? _b(this, t1, e) : this;
            }, i.getChildren = function(t1, e, i, n) {
                void 0 === t1 && (t1 = !0), void 0 === e && (e = !0), void 0 === i && (i = !0), void 0 === n && (n = -lw);
                for(var r = [], a = this._first; a;)a._start >= n && (a instanceof RT ? e && r.push(a) : (i && r.push(a), t1 && r.push.apply(r, a.getChildren(!0, e, i)))), a = a._next;
                return r;
            }, i.getById = function(t1) {
                for(var e = this.getChildren(1, 1, 1), i = e.length; i--;)if (e[i].vars.id === t1) return e[i];
            }, i.remove = function(t1) {
                return mw(t1) ? this.removeLabel(t1) : gw(t1) ? this.killTweensOf(t1) : (fb(this, t1), t1 === this._recent && (this._recent = this._last), gb(this));
            }, i.totalTime = function(e, i) {
                return arguments.length ? (this._forcing = 1, !this._dp && this._ts && (this._start = ib(hT.time - (this._ts > 0 ? e / this._ts : (this.totalDuration() - e) / -this._ts))), t1.prototype.totalTime.call(this, e, i), this._forcing = 0, this) : this._tTime;
            }, i.addLabel = function(t1, e) {
                return this.labels[t1] = Ob(this, e), this;
            }, i.removeLabel = function(t1) {
                return delete this.labels[t1], this;
            }, i.addPause = function(t1, e, i) {
                var n = RT.delayedCall(0, e || Uw, i);
                return n.data = "isPause", this._hasPause = 1, _b(this, n, Ob(this, t1));
            }, i.removePause = function(t1) {
                var e = this._first;
                for(t1 = Ob(this, t1); e;)e._start === t1 && "isPause" === e.data && mb(e), e = e._next;
            }, i.killTweensOf = function(t1, e, i) {
                for(var n = this.getTweensOf(t1, i), r = n.length; r--;)IT !== n[r] && n[r].kill(t1, e);
                return this;
            }, i.getTweensOf = function(t1, e) {
                for(var i, n = [], r = Fb(t1), a = this._first, s = Mw(e); a;)a instanceof RT ? rb(a._targets, r) && (s ? (!IT || a._initted && a._ts) && a.globalTime(0) <= e && a.globalTime(a.totalDuration()) > e : !e || a.isActive()) && n.push(a) : (i = a.getTweensOf(r, e)).length && n.push.apply(n, i), a = a._next;
                return n;
            }, i.tweenTo = function(t1, e) {
                e = e || {};
                var i, n = this, r = Ob(n, t1), a = e, s = a.startAt, o = a.onStart, l = a.onStartParams, c = a.immediateRender, u = RT.to(n, cb({
                    ease: e.ease || "none",
                    lazy: !1,
                    immediateRender: !1,
                    time: r,
                    overwrite: "auto",
                    duration: e.duration || Math.abs((r - (s && "time" in s ? s.time : n._time)) / n.timeScale()) || cw,
                    onStart: function() {
                        if (n.pause(), !i) {
                            var t1 = e.duration || Math.abs((r - (s && "time" in s ? s.time : n._time)) / n.timeScale());
                            u._dur !== t1 && Cb(u, t1, 0, 1).render(u._time, !0, !0), i = 1;
                        }
                        o && o.apply(u, l || []);
                    }
                }, e));
                return c ? u.render(0) : u;
            }, i.tweenFromTo = function(t1, e, i) {
                return this.tweenTo(e, cb({
                    startAt: {
                        time: Ob(this, t1)
                    }
                }, i));
            }, i.recent = function() {
                return this._recent;
            }, i.nextLabel = function(t1) {
                return void 0 === t1 && (t1 = this._time), Jb(this, Ob(this, t1));
            }, i.previousLabel = function(t1) {
                return void 0 === t1 && (t1 = this._time), Jb(this, Ob(this, t1), 1);
            }, i.currentLabel = function(t1) {
                return arguments.length ? this.seek(t1, !0) : this.previousLabel(this._time + cw);
            }, i.shiftChildren = function(t1, e, i) {
                void 0 === i && (i = 0);
                for(var n, r = this._first, a = this.labels; r;)r._start >= i && (r._start += t1, r._end += t1), r = r._next;
                if (e) for(n in a)a[n] >= i && (a[n] += t1);
                return gb(this);
            }, i.invalidate = function(e) {
                var i = this._first;
                for(this._lock = 0; i;)i.invalidate(e), i = i._next;
                return t1.prototype.invalidate.call(this, e);
            }, i.clear = function(t1) {
                void 0 === t1 && (t1 = !0);
                for(var e, i = this._first; i;)e = i._next, this.remove(i), i = e;
                return this._dp && (this._time = this._tTime = this._pTime = 0), t1 && (this.labels = {}), gb(this);
            }, i.totalDuration = function(t1) {
                var e, i, n, r = 0, a = this, s = a._last, o = lw;
                if (arguments.length) return a.timeScale((a._repeat < 0 ? a.duration() : a.totalDuration()) / (a.reversed() ? -t1 : t1));
                if (a._dirty) {
                    for(n = a.parent; s;)e = s._prev, s._dirty && s.totalDuration(), (i = s._start) > o && a._sort && s._ts && !a._lock ? (a._lock = 1, _b(a, s, i - s._delay, 1)._lock = 0) : o = i, i < 0 && s._ts && (r -= i, (!n && !a._dp || n && n.smoothChildTiming) && (a._start += i / a._ts, a._time -= i, a._tTime -= i), a.shiftChildren(-i, !1, -Infinity), o = 0), s._end > r && s._ts && (r = s._end), s = e;
                    Cb(a, a === Wx && a._time > r ? a._time : r, 1, 1), a._dirty = 0;
                }
                return a._tDur;
            }, e.updateRoot = function(t1) {
                if (Wx._ts && (sb(Wx, wb(t1, Wx)), Jx = hT.frame), hT.frame >= Xw) {
                    Xw += sw.autoSleep || 120;
                    var e = Wx._first;
                    if ((!e || !e._ts) && sw.autoSleep && hT._listeners.length < 2) {
                        for(; e && !e._ts;)e = e._next;
                        e || hT.sleep();
                    }
                }
            }, e;
        }(ET);
        cb(_T.prototype, {
            _lock: 0,
            _hasPause: 0,
            _forcing: 0
        });
        var IT, ST, NT = function(t1, e, i, n, r, a, s) {
            var o, l, c, u, h, d, p, A, f = new JT(this._pt, t1, e, 0, 1, GT, null, r), m = 0, g = 0;
            for(f.b = i, f.e = n, i += "", (p = ~(n += "").indexOf("random(")) && (n = Zb(n)), a && (a(A = [
                i,
                n
            ], t1, e), i = A[0], n = A[1]), l = i.match(Nw) || []; o = Nw.exec(n);)u = o[0], h = n.substring(m, o.index), c ? c = (c + 1) % 5 : "rgba(" === h.substr(-5) && (c = 1), u !== l[g++] && (d = parseFloat(l[g - 1]) || 0, f._pt = {
                _next: f._pt,
                p: h || 1 === g ? h : ",",
                s: d,
                c: "=" === u.charAt(1) ? nb(d, u) - d : parseFloat(u) - d,
                m: c && c < 4 ? Math.round : 0
            }, m = Nw.lastIndex);
            return f.c = m < n.length ? n.substring(m, n.length) : "", f.fp = s, (Dw.test(n) || p) && (f.e = 0), this._pt = f, f;
        }, DT = function(t1, e, i, n, r, a, s, o, l, c) {
            gw(n) && (n = n(r || 0, t1, a));
            var u, h = t1[e], d = "get" !== i ? i : gw(h) ? l ? t1[e.indexOf("set") || !gw(t1["get" + e.substr(3)]) ? e : "get" + e.substr(3)](l) : t1[e]() : h, p = gw(h) ? l ? BT : UT : kT;
            if (mw(n) && (~n.indexOf("random(") && (n = Zb(n)), "=" === n.charAt(1) && ((u = nb(d, n) + (kb(d) || 0)) || 0 === u) && (n = u)), !c || d !== n || ST) return isNaN(d * n) || "" === n ? (!h && !(e in t1) && jw(e, n), NT.call(this, t1, e, d, n, p, o || sw.stringFilter, l)) : (u = new JT(this._pt, t1, e, +d || 0, n - (d || 0), "boolean" == typeof h ? VT : HT, 0, p), l && (u.fp = l), s && u.modifier(s, this, t1), this._pt = u);
        }, CT = function(t1, e, i, n, r, a) {
            var s, o, l, c;
            if (Ww[t1] && !1 !== (s = new Ww[t1]).init(r, s.rawVars ? e[t1] : function(t1, e, i, n, r) {
                if (gw(t1) && (t1 = OT(t1, r, e, i, n)), !yw(t1) || t1.style && t1.nodeType || Ew(t1) || Tw(t1)) return mw(t1) ? OT(t1, r, e, i, n) : t1;
                var a, s = {};
                for(a in t1)s[a] = OT(t1[a], r, e, i, n);
                return s;
            }(e[t1], n, r, a, i), i, n, a) && (i._pt = o = new JT(i._pt, r, t1, 0, 1, s.render, s, 0, s.priority), i !== Kx)) for(l = i._ptLookup[i._targets.indexOf(r)], c = s._props.length; c--;)l[s._props[c]] = o;
            return s;
        }, zT = function t1(e, i, n) {
            var r, a, s, o, l, c, u, h, d, p, A, f, m, g = e.vars, M = g.ease, v = g.startAt, y = g.immediateRender, x = g.lazy, w = g.onUpdate, b = g.runBackwards, T = g.yoyoEase, E = g.keyframes, _ = g.autoRevert, I = e._dur, S = e._startAt, N = e._targets, D = e.parent, C = D && "nested" === D.data ? D.vars.targets : N, z = "auto" === e._overwrite && !Hx, L = e.timeline;
            if (L && (!E || !M) && (M = "none"), e._ease = vT(M, ow.ease), e._yEase = T ? gT(vT(!0 === T ? M : T, ow.ease)) : 0, T && e._yoyo && !e._repeat && (T = e._yEase, e._yEase = e._ease, e._ease = T), e._from = !L && !!g.runBackwards, !L || E && !g.stagger) {
                if (f = (h = N[0] ? Kw(N[0]).harness : 0) && g[h.prop], r = db(g, Hw), S && (S._zTime < 0 && S.progress(1), i < 0 && b && y && !_ ? S.render(-1, !0) : S.revert(b && I ? Fw : Bw), S._lazy = 0), v) {
                    if (mb(e._startAt = RT.set(N, cb({
                        data: "isStart",
                        overwrite: !1,
                        parent: D,
                        immediateRender: !0,
                        lazy: !S && xw(x),
                        startAt: null,
                        delay: 0,
                        onUpdate: w && function() {
                            return Kb(e, "onUpdate");
                        },
                        stagger: 0
                    }, v))), e._startAt._dp = 0, e._startAt._sat = e, i < 0 && (Vx || !y && !_) && e._startAt.revert(Fw), y && I && i <= 0 && n <= 0) return void (i && (e._zTime = i));
                } else if (b && I && !S) {
                    if (i && (y = !1), s = cb({
                        overwrite: !1,
                        data: "isFromStart",
                        lazy: y && !S && xw(x),
                        immediateRender: y,
                        stagger: 0,
                        parent: D
                    }, r), f && (s[h.prop] = f), mb(e._startAt = RT.set(N, s)), e._startAt._dp = 0, e._startAt._sat = e, i < 0 && (Vx ? e._startAt.revert(Fw) : e._startAt.render(-1, !0)), e._zTime = i, y) {
                        if (!i) return;
                    } else t1(e._startAt, cw, cw);
                }
                for(e._pt = e._ptCache = 0, x = I && xw(x) || x && !I, a = 0; a < N.length; a++){
                    if (u = (l = N[a])._gsap || Jw(N)[a]._gsap, e._ptLookup[a] = p = {}, Gw[u.id] && Vw.length && ab(), A = C === N ? a : C.indexOf(l), h && !1 !== (d = new h).init(l, f || r, e, A, C) && (e._pt = o = new JT(e._pt, l, d.name, 0, 1, d.render, d, 0, d.priority), d._props.forEach(function(t1) {
                        p[t1] = o;
                    }), d.priority && (c = 1)), !h || f) for(s in r)Ww[s] && (d = CT(s, r, e, A, l, C)) ? d.priority && (c = 1) : p[s] = o = DT.call(e, l, s, "get", r[s], A, C, 0, g.stringFilter);
                    e._op && e._op[a] && e.kill(l, e._op[a]), z && e._pt && (IT = e, Wx.killTweensOf(l, p, e.globalTime(i)), m = !e.parent, IT = 0), e._pt && x && (Gw[u.id] = 1);
                }
                c && qT(e), e._onInit && e._onInit(e);
            }
            e._onUpdate = w, e._initted = (!e._op || e._pt) && !m, E && i <= 0 && L.render(lw, !0, !0);
        }, LT = function(t1, e, i, n) {
            var r, a, s = e.ease || n || "power1.inOut";
            if (Ew(e)) a = i[t1] || (i[t1] = []), e.forEach(function(t1, i) {
                return a.push({
                    t: i / (e.length - 1) * 100,
                    v: t1,
                    e: s
                });
            });
            else for(r in e)a = i[r] || (i[r] = []), "ease" === r || a.push({
                t: parseFloat(t1),
                v: e[r],
                e: s
            });
        }, OT = function(t1, e, i, n, r) {
            return gw(t1) ? t1.call(e, i, n, r) : mw(t1) && ~t1.indexOf("random(") ? Zb(t1) : t1;
        }, PT = qw + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert", jT = {};
        tb(PT + ",id,stagger,delay,duration,paused,scrollTrigger", function(t1) {
            return jT[t1] = 1;
        });
        var RT = function(t1) {
            function e(e, i, n, r) {
                var a;
                "number" == typeof i && (n.duration = i, i = n, n = null);
                var s, o, l, c, u, h, d, p, A = (a = t1.call(this, r ? i : pb(i)) || this).vars, f = A.duration, m = A.delay, g = A.immediateRender, M = A.stagger, v = A.overwrite, y = A.keyframes, x = A.defaults, w = A.scrollTrigger, b = A.yoyoEase, T = i.parent || Wx, E = (Ew(e) || Tw(e) ? Mw(e[0]) : "length" in i) ? [
                    e
                ] : Fb(e);
                if (a._targets = E.length ? Jw(E) : Rw("GSAP target " + e + " not found. https://gsap.com", !sw.nullTargetWarn) || [], a._ptLookup = [], a._overwrite = v, y || M || bw(f) || bw(m)) {
                    if (i = a.vars, (s = a.timeline = new _T({
                        data: "nested",
                        defaults: x || {},
                        targets: T && "nested" === T.data ? T.vars.targets : E
                    })).kill(), s.parent = s._dp = Fx(a), s._start = 0, M || bw(f) || bw(m)) {
                        if (c = E.length, d = M && Vb(M), yw(M)) for(u in M)~PT.indexOf(u) && (p || (p = {}), p[u] = M[u]);
                        for(o = 0; o < c; o++)(l = db(i, jT)).stagger = 0, b && (l.yoyoEase = b), p && ub(l, p), h = E[o], l.duration = +OT(f, Fx(a), o, h, E), l.delay = (+OT(m, Fx(a), o, h, E) || 0) - a._delay, !M && 1 === c && l.delay && (a._delay = m = l.delay, a._start += m, l.delay = 0), s.to(h, l, d ? d(o, h, E) : 0), s._ease = pT.none;
                        s.duration() ? f = m = 0 : a.timeline = 0;
                    } else if (y) {
                        pb(cb(s.vars.defaults, {
                            ease: "none"
                        })), s._ease = vT(y.ease || i.ease || "none");
                        var _, I, S, N = 0;
                        if (Ew(y)) y.forEach(function(t1) {
                            return s.to(E, t1, ">");
                        }), s.duration();
                        else {
                            for(u in l = {}, y)"ease" === u || "easeEach" === u || LT(u, y[u], l, y.easeEach);
                            for(u in l)for(_ = l[u].sort(function(t1, e) {
                                return t1.t - e.t;
                            }), N = 0, o = 0; o < _.length; o++)(S = {
                                ease: (I = _[o]).e,
                                duration: (I.t - (o ? _[o - 1].t : 0)) / 100 * f
                            })[u] = I.v, s.to(E, S, N), N += S.duration;
                            s.duration() < f && s.to({}, {
                                duration: f - s.duration()
                            });
                        }
                    }
                    f || a.duration(f = s.duration());
                } else a.timeline = 0;
                return !0 !== v || Hx || (IT = Fx(a), Wx.killTweensOf(E), IT = 0), _b(T, Fx(a), n), i.reversed && a.reverse(), i.paused && a.paused(!0), (g || !f && !y && a._start === ib(T._time) && xw(g) && vb(Fx(a)) && "nested" !== T.data) && (a._tTime = -0.00000001, a.render(Math.max(0, -m) || 0)), w && Ib(Fx(a), w), a;
            }
            Qx(e, t1);
            var i = e.prototype;
            return i.render = function(t1, e, i) {
                var n, r, a, s, o, l, c, u, h, d = this._time, p = this._tDur, A = this._dur, f = t1 < 0, m = t1 > p - cw && !f ? p : t1 < cw ? 0 : t1;
                if (A) {
                    if (m !== this._tTime || !t1 || i || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== f) {
                        if (n = m, u = this.timeline, this._repeat) {
                            if (s = A + this._rDelay, this._repeat < -1 && f) return this.totalTime(100 * s + t1, e, i);
                            if (n = ib(m % s), m === p ? (a = this._repeat, n = A) : ((a = ~~(m / s)) && a === ib(m / s) && (n = A, a--), n > A && (n = A)), (l = this._yoyo && 1 & a) && (h = this._yEase, n = A - n), o = xb(this._tTime, s), n === d && !i && this._initted && a === o) return this._tTime = m, this;
                            a !== o && (u && this._yEase && MT(u, l), this.vars.repeatRefresh && !l && !this._lock && this._time !== s && this._initted && (this._lock = i = 1, this.render(ib(s * a), !0).invalidate()._lock = 0));
                        }
                        if (!this._initted) {
                            if (Sb(this, f ? t1 : n, i, e, m)) return this._tTime = 0, this;
                            if (!(d === this._time || i && this.vars.repeatRefresh && a !== o)) return this;
                            if (A !== this._dur) return this.render(t1, e, i);
                        }
                        if (this._tTime = m, this._time = n, !this._act && this._ts && (this._act = 1, this._lazy = 0), this.ratio = c = (h || this._ease)(n / A), this._from && (this.ratio = c = 1 - c), n && !d && !e && !a && (Kb(this, "onStart"), this._tTime !== m)) return this;
                        for(r = this._pt; r;)r.r(c, r.d), r = r._next;
                        u && u.render(t1 < 0 ? t1 : u._dur * u._ease(n / this._dur), e, i) || this._startAt && (this._zTime = t1), this._onUpdate && !e && (f && Mb(this, t1, 0, i), Kb(this, "onUpdate")), this._repeat && a !== o && this.vars.onRepeat && !e && this.parent && Kb(this, "onRepeat"), m !== this._tDur && m || this._tTime !== m || (f && !this._onUpdate && Mb(this, t1, 0, !0), (t1 || !A) && (m === this._tDur && this._ts > 0 || !m && this._ts < 0) && mb(this, 1), e || f && !d || !(m || d || l) || (Kb(this, m === p ? "onComplete" : "onReverseComplete", !0), this._prom && !(m < p && this.timeScale() > 0) && this._prom()));
                    }
                } else !function(t1, e, i, n) {
                    var r, a, s, o = t1.ratio, l = e < 0 || !e && (!t1._start && Nb(t1) && (t1._initted || !Db(t1)) || (t1._ts < 0 || t1._dp._ts < 0) && !Db(t1)) ? 0 : 1, c = t1._rDelay, u = 0;
                    if (c && t1._repeat && (u = Rb(0, t1._tDur, e), a = xb(u, c), t1._yoyo && 1 & a && (l = 1 - l), a !== xb(t1._tTime, c) && (o = 1 - l, t1.vars.repeatRefresh && t1._initted && t1.invalidate())), l !== o || Vx || n || t1._zTime === cw || !e && t1._zTime) {
                        if (!t1._initted && Sb(t1, e, n, i, u)) return;
                        for(s = t1._zTime, t1._zTime = e || (i ? cw : 0), i || (i = e && !s), t1.ratio = l, t1._from && (l = 1 - l), t1._time = 0, t1._tTime = u, r = t1._pt; r;)r.r(l, r.d), r = r._next;
                        e < 0 && Mb(t1, e, 0, !0), t1._onUpdate && !i && Kb(t1, "onUpdate"), u && t1._repeat && !i && t1.parent && Kb(t1, "onRepeat"), (e >= t1._tDur || e < 0) && t1.ratio === l && (l && mb(t1, 1), i || Vx || (Kb(t1, l ? "onComplete" : "onReverseComplete", !0), t1._prom && t1._prom()));
                    } else t1._zTime || (t1._zTime = e);
                }(this, t1, e, i);
                return this;
            }, i.targets = function() {
                return this._targets;
            }, i.invalidate = function(e) {
                return (!e || !this.vars.runBackwards) && (this._startAt = 0), this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0, this._ptLookup = [], this.timeline && this.timeline.invalidate(e), t1.prototype.invalidate.call(this, e);
            }, i.resetTo = function(t1, e, i, n, r) {
                $x || hT.wake(), this._ts || this.play();
                var a = Math.min(this._dur, (this._dp._time - this._start) * this._ts);
                return this._initted || zT(this, a), function(t1, e, i, n, r, a, s, o) {
                    var l, c, u, h, d = (t1._pt && t1._ptCache || (t1._ptCache = {}))[e];
                    if (!d) for(d = t1._ptCache[e] = [], u = t1._ptLookup, h = t1._targets.length; h--;){
                        if ((l = u[h][e]) && l.d && l.d._pt) for(l = l.d._pt; l && l.p !== e && l.fp !== e;)l = l._next;
                        if (!l) return ST = 1, t1.vars[e] = "+=0", zT(t1, s), ST = 0, o ? Rw(e + " not eligible for reset") : 1;
                        d.push(l);
                    }
                    for(h = d.length; h--;)(l = (c = d[h])._pt || c).s = !n && 0 !== n || r ? l.s + (n || 0) + a * l.c : n, l.c = i - l.s, c.e && (c.e = eb(i) + kb(c.e)), c.b && (c.b = l.s + kb(c.b));
                }(this, t1, e, i, n, this._ease(a / this._dur), a, r) ? this.resetTo(t1, e, i, n, 1) : (Tb(this, 0), this.parent || Ab(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0), this.render(0));
            }, i.kill = function(t1, e) {
                if (void 0 === e && (e = "all"), !(t1 || e && "all" !== e)) return this._lazy = this._pt = 0, this.parent ? $b(this) : this;
                if (this.timeline) {
                    var i = this.timeline.totalDuration();
                    return this.timeline.killTweensOf(t1, e, IT && !0 !== IT.vars.overwrite)._first || $b(this), this.parent && i !== this.timeline.totalDuration() && Cb(this, this._dur * this.timeline._tDur / i, 0, 1), this;
                }
                var n, r, a, s, o, l, c, u = this._targets, h = t1 ? Fb(t1) : u, d = this._ptLookup, p = this._pt;
                if ((!e || "all" === e) && function(t1, e) {
                    for(var i = t1.length, n = i === e.length; n && i-- && t1[i] === e[i];);
                    return i < 0;
                }(u, h)) return "all" === e && (this._pt = 0), $b(this);
                for(n = this._op = this._op || [], "all" !== e && (mw(e) && (o = {}, tb(e, function(t1) {
                    return o[t1] = 1;
                }), e = o), e = function(t1, e) {
                    var i, n, r, a, s = t1[0] ? Kw(t1[0]).harness : 0, o = s && s.aliases;
                    if (!o) return e;
                    for(n in i = ub({}, e), o)if ((n in i)) for(r = (a = o[n].split(",")).length; r--;)i[a[r]] = i[n];
                    return i;
                }(u, e)), c = u.length; c--;)if (~h.indexOf(u[c])) for(o in r = d[c], "all" === e ? (n[c] = e, s = r, a = {}) : (a = n[c] = n[c] || {}, s = e), s)(l = r && r[o]) && ("kill" in l.d && !0 !== l.d.kill(o) || fb(this, l, "_pt"), delete r[o]), "all" !== a && (a[o] = 1);
                return this._initted && !this._pt && p && $b(this), this;
            }, e.to = function(t1, i) {
                return new e(t1, i, arguments[2]);
            }, e.from = function(t1, e) {
                return Pb(1, arguments);
            }, e.delayedCall = function(t1, i, n, r) {
                return new e(i, 0, {
                    immediateRender: !1,
                    lazy: !1,
                    overwrite: !1,
                    delay: t1,
                    onComplete: i,
                    onReverseComplete: i,
                    onCompleteParams: n,
                    onReverseCompleteParams: n,
                    callbackScope: r
                });
            }, e.fromTo = function(t1, e, i) {
                return Pb(2, arguments);
            }, e.set = function(t1, i) {
                return i.duration = 0, i.repeatDelay || (i.repeat = 0), new e(t1, i);
            }, e.killTweensOf = function(t1, e, i) {
                return Wx.killTweensOf(t1, e, i);
            }, e;
        }(ET);
        cb(RT.prototype, {
            _targets: [],
            _lazy: 0,
            _startAt: 0,
            _op: 0,
            _onInit: 0
        }), tb("staggerTo,staggerFrom,staggerFromTo", function(t1) {
            RT[t1] = function() {
                var e = new _T, i = Ub.call(arguments, 0);
                return i.splice("staggerFromTo" === t1 ? 5 : 4, 0, 0), e[t1].apply(e, i);
            };
        });
        var kT = function(t1, e, i) {
            return t1[e] = i;
        }, UT = function(t1, e, i) {
            return t1[e](i);
        }, BT = function(t1, e, i, n) {
            return t1[e](n.fp, i);
        }, FT = function(t1, e, i) {
            return t1.setAttribute(e, i);
        }, QT = function(t1, e) {
            return gw(t1[e]) ? UT : vw(t1[e]) && t1.setAttribute ? FT : kT;
        }, HT = function(t1, e) {
            return e.set(e.t, e.p, Math.round(1e6 * (e.s + e.c * t1)) / 1e6, e);
        }, VT = function(t1, e) {
            return e.set(e.t, e.p, !!(e.s + e.c * t1), e);
        }, GT = function(t1, e) {
            var i = e._pt, n = "";
            if (!t1 && e.b) n = e.b;
            else if (1 === t1 && e.e) n = e.e;
            else {
                for(; i;)n = i.p + (i.m ? i.m(i.s + i.c * t1) : Math.round(1e4 * (i.s + i.c * t1)) / 1e4) + n, i = i._next;
                n += e.c;
            }
            e.set(e.t, e.p, n, e);
        }, WT = function(t1, e) {
            for(var i = e._pt; i;)i.r(t1, i.d), i = i._next;
        }, YT = function(t1, e, i, n) {
            for(var r, a = this._pt; a;)r = a._next, a.p === n && a.modifier(t1, e, i), a = r;
        }, XT = function(t1) {
            for(var e, i, n = this._pt; n;)i = n._next, n.p === t1 && !n.op || n.op === t1 ? fb(this, n, "_pt") : n.dep || (e = 1), n = i;
            return !e;
        }, ZT = function(t1, e, i, n) {
            n.mSet(t1, e, n.m.call(n.tween, i, n.mt), n);
        }, qT = function(t1) {
            for(var e, i, n, r, a = t1._pt; a;){
                for(e = a._next, i = n; i && i.pr > a.pr;)i = i._next;
                (a._prev = i ? i._prev : r) ? a._prev._next = a : n = a, (a._next = i) ? i._prev = a : r = a, a = e;
            }
            t1._pt = n;
        }, JT = function() {
            function t1(t1, e, i, n, r, a, s, o, l) {
                this.t = e, this.s = n, this.c = r, this.p = i, this.r = a || HT, this.d = s || this, this.set = o || kT, this.pr = l || 0, this._next = t1, t1 && (t1._prev = this);
            }
            return t1.prototype.modifier = function(t1, e, i) {
                this.mSet = this.mSet || this.set, this.set = ZT, this.m = t1, this.mt = i, this.tween = e;
            }, t1;
        }();
        tb(qw + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function(t1) {
            return Hw[t1] = 1;
        }), Lw.TweenMax = Lw.TweenLite = RT, Lw.TimelineLite = Lw.TimelineMax = _T, Wx = new _T({
            sortChildren: !1,
            defaults: ow,
            autoRemoveChildren: !0,
            id: "root",
            smoothChildTiming: !0
        }), sw.stringFilter = uT;
        var KT = [], $T = {}, tE = [], eE = 0, iE = 0, nE = function(t1) {
            return ($T[t1] || tE).map(function(t1) {
                return t1();
            });
        }, rE = function() {
            var t1 = Date.now(), e = [];
            t1 - eE > 2 && (nE("matchMediaInit"), KT.forEach(function(t1) {
                var i, n, r, a, s = t1.queries, o = t1.conditions;
                for(n in s)(i = Yx.matchMedia(s[n]).matches) && (r = 1), i !== o[n] && (o[n] = i, a = 1);
                a && (t1.revert(), r && e.push(t1));
            }), nE("matchMediaRevert"), e.forEach(function(t1) {
                return t1.onMatch(t1, function(e) {
                    return t1.add(null, e);
                });
            }), eE = t1, nE("matchMedia"));
        }, aE = function() {
            function t1(t1, e) {
                this.selector = e && Qb(e), this.data = [], this._r = [], this.isReverted = !1, this.id = iE++, t1 && this.add(t1);
            }
            var e = t1.prototype;
            return e.add = function(t1, e, i) {
                gw(t1) && (i = e, e = t1, t1 = gw);
                var n = this, r = function() {
                    var t1, r = Gx, a = n.selector;
                    return r && r !== n && r.data.push(n), i && (n.selector = Qb(i)), Gx = n, t1 = e.apply(n, arguments), gw(t1) && n._r.push(t1), Gx = r, n.selector = a, n.isReverted = !1, t1;
                };
                return n.last = r, t1 === gw ? r(n, function(t1) {
                    return n.add(null, t1);
                }) : t1 ? n[t1] = r : r;
            }, e.ignore = function(t1) {
                var e = Gx;
                Gx = null, t1(this), Gx = e;
            }, e.getTweens = function() {
                var e = [];
                return this.data.forEach(function(i) {
                    return i instanceof t1 ? e.push.apply(e, i.getTweens()) : i instanceof RT && !(i.parent && "nested" === i.parent.data) && e.push(i);
                }), e;
            }, e.clear = function() {
                this._r.length = this.data.length = 0;
            }, e.kill = function(t1, e) {
                var i = this;
                if (t1 ? function() {
                    for(var e, n = i.getTweens(), r = i.data.length; r--;)"isFlip" === (e = i.data[r]).data && (e.revert(), e.getChildren(!0, !0, !1).forEach(function(t1) {
                        return n.splice(n.indexOf(t1), 1);
                    }));
                    for(n.map(function(t1) {
                        return {
                            g: t1._dur || t1._delay || t1._sat && !t1._sat.vars.immediateRender ? t1.globalTime(0) : -1 / 0,
                            t: t1
                        };
                    }).sort(function(t1, e) {
                        return e.g - t1.g || -1 / 0;
                    }).forEach(function(e) {
                        return e.t.revert(t1);
                    }), r = i.data.length; r--;)(e = i.data[r]) instanceof _T ? "nested" !== e.data && (e.scrollTrigger && e.scrollTrigger.revert(), e.kill()) : !(e instanceof RT) && e.revert && e.revert(t1);
                    i._r.forEach(function(e) {
                        return e(t1, i);
                    }), i.isReverted = !0;
                }() : this.data.forEach(function(t1) {
                    return t1.kill && t1.kill();
                }), this.clear(), e) for(var n = KT.length; n--;)KT[n].id === this.id && KT.splice(n, 1);
            }, e.revert = function(t1) {
                this.kill(t1 || {});
            }, t1;
        }(), sE = function() {
            function t1(t1) {
                this.contexts = [], this.scope = t1, Gx && Gx.data.push(this);
            }
            var e = t1.prototype;
            return e.add = function(t1, e, i) {
                yw(t1) || (t1 = {
                    matches: t1
                });
                var n, r, a, s = new aE(0, i || this.scope), o = s.conditions = {};
                for(r in Gx && !s.selector && (s.selector = Gx.selector), this.contexts.push(s), e = s.add("onMatch", e), s.queries = t1, t1)"all" === r ? a = 1 : (n = Yx.matchMedia(t1[r])) && (KT.indexOf(s) < 0 && KT.push(s), (o[r] = n.matches) && (a = 1), n.addListener ? n.addListener(rE) : n.addEventListener("change", rE));
                return a && e(s, function(t1) {
                    return s.add(null, t1);
                }), this;
            }, e.revert = function(t1) {
                this.kill(t1 || {});
            }, e.kill = function(t1) {
                this.contexts.forEach(function(e) {
                    return e.kill(t1, !0);
                });
            }, t1;
        }(), oE = {
            registerPlugin: function() {
                for(var t1 = arguments.length, e = new Array(t1), i = 0; i < t1; i++)e[i] = arguments[i];
                e.forEach(function(t1) {
                    return eT(t1);
                });
            },
            timeline: function(t1) {
                return new _T(t1);
            },
            getTweensOf: function(t1, e) {
                return Wx.getTweensOf(t1, e);
            },
            getProperty: function(t1, e, i, n) {
                mw(t1) && (t1 = Fb(t1)[0]);
                var r = Kw(t1 || {}).get, a = i ? lb : ob;
                return "native" === i && (i = ""), t1 ? e ? a((Ww[e] && Ww[e].get || r)(t1, e, i, n)) : function(e, i, n) {
                    return a((Ww[e] && Ww[e].get || r)(t1, e, i, n));
                } : t1;
            },
            quickSetter: function(t1, e, i) {
                if ((t1 = Fb(t1)).length > 1) {
                    var n = t1.map(function(t1) {
                        return uE.quickSetter(t1, e, i);
                    }), r = n.length;
                    return function(t1) {
                        for(var e = r; e--;)n[e](t1);
                    };
                }
                t1 = t1[0] || {};
                var a = Ww[e], s = Kw(t1), o = s.harness && (s.harness.aliases || {})[e] || e, l = a ? function(e) {
                    var n = new a;
                    Kx._pt = 0, n.init(t1, i ? e + i : e, Kx, 0, [
                        t1
                    ]), n.render(1, n), Kx._pt && WT(1, Kx);
                } : s.set(t1, o);
                return a ? l : function(e) {
                    return l(t1, o, i ? e + i : e, s, 1);
                };
            },
            quickTo: function(t1, e, i) {
                var n, r = uE.to(t1, ub(((n = {})[e] = "+=0.1", n.paused = !0, n), i || {})), a = function(t1, i, n) {
                    return r.resetTo(e, t1, i, n);
                };
                return a.tween = r, a;
            },
            isTweening: function(t1) {
                return Wx.getTweensOf(t1, !0).length > 0;
            },
            defaults: function(t1) {
                return t1 && t1.ease && (t1.ease = vT(t1.ease, ow.ease)), hb(ow, t1 || {});
            },
            config: function(t1) {
                return hb(sw, t1 || {});
            },
            registerEffect: function(t1) {
                var e = t1.name, i = t1.effect, n = t1.plugins, r = t1.defaults, a = t1.extendTimeline;
                (n || "").split(",").forEach(function(t1) {
                    return t1 && !Ww[t1] && !Lw[t1] && Rw(e + " effect requires " + t1 + " plugin.");
                }), Yw[e] = function(t1, e, n) {
                    return i(Fb(t1), cb(e || {}, r), n);
                }, a && (_T.prototype[e] = function(t1, i, n) {
                    return this.add(Yw[e](t1, yw(i) ? i : (n = i) && {}, this), n);
                });
            },
            registerEase: function(t1, e) {
                pT[t1] = vT(e);
            },
            parseEase: function(t1, e) {
                return arguments.length ? vT(t1, e) : pT;
            },
            getById: function(t1) {
                return Wx.getById(t1);
            },
            exportRoot: function(t1, e) {
                void 0 === t1 && (t1 = {});
                var i, n, r = new _T(t1);
                for(r.smoothChildTiming = xw(t1.smoothChildTiming), Wx.remove(r), r._dp = 0, r._time = r._tTime = Wx._time, i = Wx._first; i;)n = i._next, !e && !i._dur && i instanceof RT && i.vars.onComplete === i._targets[0] || _b(r, i, i._start - i._delay), i = n;
                return _b(Wx, r, 0), r;
            },
            context: function(t1, e) {
                return t1 ? new aE(t1, e) : Gx;
            },
            matchMedia: function(t1) {
                return new sE(t1);
            },
            matchMediaRefresh: function() {
                return KT.forEach(function(t1) {
                    var e, i, n = t1.conditions;
                    for(i in n)n[i] && (n[i] = !1, e = 1);
                    e && t1.revert();
                }) || rE();
            },
            addEventListener: function(t1, e) {
                var i = $T[t1] || ($T[t1] = []);
                ~i.indexOf(e) || i.push(e);
            },
            removeEventListener: function(t1, e) {
                var i = $T[t1], n = i && i.indexOf(e);
                n >= 0 && i.splice(n, 1);
            },
            utils: {
                wrap: function t1(e, i, n) {
                    var r = i - e;
                    return Ew(e) ? Xb(e, t1(0, e.length), i) : jb(n, function(t1) {
                        return (r + (t1 - e) % r) % r + e;
                    });
                },
                wrapYoyo: function t1(e, i, n) {
                    var r = i - e, a = 2 * r;
                    return Ew(e) ? Xb(e, t1(0, e.length - 1), i) : jb(n, function(t1) {
                        return e + ((t1 = (a + (t1 - e) % a) % a || 0) > r ? a - t1 : t1);
                    });
                },
                distribute: Vb,
                random: Yb,
                snap: Wb,
                normalize: function(t1, e, i) {
                    return qb(t1, e, 0, 1, i);
                },
                getUnit: kb,
                clamp: function(t1, e, i) {
                    return jb(i, function(i) {
                        return Rb(t1, e, i);
                    });
                },
                splitColor: aT,
                toArray: Fb,
                selector: Qb,
                mapRange: qb,
                pipe: function() {
                    for(var t1 = arguments.length, e = new Array(t1), i = 0; i < t1; i++)e[i] = arguments[i];
                    return function(t1) {
                        return e.reduce(function(t1, e) {
                            return e(t1);
                        }, t1);
                    };
                },
                unitize: function(t1, e) {
                    return function(i) {
                        return t1(parseFloat(i)) + (e || kb(i));
                    };
                },
                interpolate: function t1(e, i, n, r) {
                    var a = isNaN(e + i) ? 0 : function(t1) {
                        return (1 - t1) * e + t1 * i;
                    };
                    if (!a) {
                        var s, o, l, c, u, h = mw(e), d = {};
                        if (!0 === n && (r = 1) && (n = null), h) e = {
                            p: e
                        }, i = {
                            p: i
                        };
                        else if (Ew(e) && !Ew(i)) {
                            for(l = [], c = e.length, u = c - 2, o = 1; o < c; o++)l.push(t1(e[o - 1], e[o]));
                            c--, a = function(t1) {
                                t1 *= c;
                                var e = Math.min(u, ~~t1);
                                return l[e](t1 - e);
                            }, n = i;
                        } else r || (e = ub(Ew(e) ? [] : {}, e));
                        if (!l) {
                            for(s in i)DT.call(d, e, s, "get", i[s]);
                            a = function(t1) {
                                return WT(t1, d) || (h ? e.p : e);
                            };
                        }
                    }
                    return jb(n, a);
                },
                shuffle: Hb
            },
            install: Pw,
            effects: Yw,
            ticker: hT,
            updateRoot: _T.updateRoot,
            plugins: Ww,
            globalTimeline: Wx,
            core: {
                PropTween: JT,
                globals: kw,
                Tween: RT,
                Timeline: _T,
                Animation: ET,
                getCache: Kw,
                _removeLinkedListItem: fb,
                reverting: function() {
                    return Vx;
                },
                context: function(t1) {
                    return t1 && Gx && (Gx.data.push(t1), t1._ctx = Gx), Gx;
                },
                suppressOverwrites: function(t1) {
                    return Hx = t1;
                }
            }
        };
        tb("to,from,fromTo,delayedCall,set,killTweensOf", function(t1) {
            return oE[t1] = RT[t1];
        }), hT.add(_T.updateRoot), Kx = oE.to({}, {
            duration: 0
        });
        var lE = function(t1, e) {
            for(var i = t1._pt; i && i.p !== e && i.op !== e && i.fp !== e;)i = i._next;
            return i;
        }, cE = function(t1, e) {
            return {
                name: t1,
                rawVars: 1,
                init: function(t1, i, n) {
                    n._onInit = function(t1) {
                        var n, r;
                        if (mw(i) && (n = {}, tb(i, function(t1) {
                            return n[t1] = 1;
                        }), i = n), e) {
                            for(r in n = {}, i)n[r] = e(i[r]);
                            i = n;
                        }
                        !function(t1, e) {
                            var i, n, r, a = t1._targets;
                            for(i in e)for(n = a.length; n--;)(r = t1._ptLookup[n][i]) && (r = r.d) && (r._pt && (r = lE(r, i)), r && r.modifier && r.modifier(e[i], t1, a[n], i));
                        }(t1, i);
                    };
                }
            };
        }, uE = oE.registerPlugin({
            name: "attr",
            init: function(t1, e, i, n, r) {
                var a, s, o;
                for(a in this.tween = i, e)o = t1.getAttribute(a) || "", (s = this.add(t1, "setAttribute", (o || 0) + "", e[a], n, r, 0, 0, a)).op = a, s.b = o, this._props.push(a);
            },
            render: function(t1, e) {
                for(var i = e._pt; i;)Vx ? i.set(i.t, i.p, i.b, i) : i.r(t1, i.d), i = i._next;
            }
        }, {
            name: "endArray",
            init: function(t1, e) {
                for(var i = e.length; i--;)this.add(t1, i, t1[i] || 0, e[i], 0, 0, 0, 0, 0, 1);
            }
        }, cE("roundProps", Gb), cE("modifiers"), cE("snap", Wb)) || oE;
        RT.version = _T.version = uE.version = "3.12.5", qx = 1, ww() && dT(), pT.Power0, pT.Power1, pT.Power2, pT.Power3, pT.Power4, pT.Linear, pT.Quad, pT.Cubic, pT.Quart, pT.Quint, pT.Strong, pT.Elastic, pT.Back, pT.SteppedEase, pT.Bounce, pT.Sine, pT.Expo, pT.Circ;
        var hE, dE, pE, AE, fE, mE, gE, ME, vE = {}, yE = 180 / Math.PI, xE = Math.PI / 180, wE = Math.atan2, bE = /([A-Z])/g, TE = /(left|right|width|margin|padding|x)/i, EE = /[\s,\(]\S/, _E = {
            autoAlpha: "opacity,visibility",
            scale: "scaleX,scaleY",
            alpha: "opacity"
        }, IE = function(t1, e) {
            return e.set(e.t, e.p, Math.round(1e4 * (e.s + e.c * t1)) / 1e4 + e.u, e);
        }, SE = function(t1, e) {
            return e.set(e.t, e.p, 1 === t1 ? e.e : Math.round(1e4 * (e.s + e.c * t1)) / 1e4 + e.u, e);
        }, NE = function(t1, e) {
            return e.set(e.t, e.p, t1 ? Math.round(1e4 * (e.s + e.c * t1)) / 1e4 + e.u : e.b, e);
        }, DE = function(t1, e) {
            var i = e.s + e.c * t1;
            e.set(e.t, e.p, ~~(i + (i < 0 ? -0.5 : .5)) + e.u, e);
        }, CE = function(t1, e) {
            return e.set(e.t, e.p, t1 ? e.e : e.b, e);
        }, zE = function(t1, e) {
            return e.set(e.t, e.p, 1 !== t1 ? e.b : e.e, e);
        }, LE = function(t1, e, i) {
            return t1.style[e] = i;
        }, OE = function(t1, e, i) {
            return t1.style.setProperty(e, i);
        }, PE = function(t1, e, i) {
            return t1._gsap[e] = i;
        }, jE = function(t1, e, i) {
            return t1._gsap.scaleX = t1._gsap.scaleY = i;
        }, RE = function(t1, e, i, n, r) {
            var a = t1._gsap;
            a.scaleX = a.scaleY = i, a.renderTransform(r, a);
        }, kE = function(t1, e, i, n, r) {
            var a = t1._gsap;
            a[e] = i, a.renderTransform(r, a);
        }, UE = "transform", BE = UE + "Origin", FE = function t1(e, i) {
            var n = this, r = this.target, a = r.style, s = r._gsap;
            if (e in vE && a) {
                if (this.tfm = this.tfm || {}, "transform" === e) return _E.transform.split(",").forEach(function(e) {
                    return t1.call(n, e, i);
                });
                if (~(e = _E[e] || e).indexOf(",") ? e.split(",").forEach(function(t1) {
                    return n.tfm[t1] = a_(r, t1);
                }) : this.tfm[e] = s.x ? s[e] : a_(r, e), e === BE && (this.tfm.zOrigin = s.zOrigin), this.props.indexOf(UE) >= 0) return;
                s.svg && (this.svgo = r.getAttribute("data-svg-origin"), this.props.push(BE, i, "")), e = UE;
            }
            (a || i) && this.props.push(e, i, a[e]);
        }, QE = function(t1) {
            t1.translate && (t1.removeProperty("translate"), t1.removeProperty("scale"), t1.removeProperty("rotate"));
        }, HE = function() {
            var t1, e, i = this.props, n = this.target, r = n.style, a = n._gsap;
            for(t1 = 0; t1 < i.length; t1 += 3)i[t1 + 1] ? n[i[t1]] = i[t1 + 2] : i[t1 + 2] ? r[i[t1]] = i[t1 + 2] : r.removeProperty("--" === i[t1].substr(0, 2) ? i[t1] : i[t1].replace(bE, "-$1").toLowerCase());
            if (this.tfm) {
                for(e in this.tfm)a[e] = this.tfm[e];
                a.svg && (a.renderTransform(), n.setAttribute("data-svg-origin", this.svgo || "")), (t1 = gE()) && t1.isStart || r[UE] || (QE(r), a.zOrigin && r[BE] && (r[BE] += " " + a.zOrigin + "px", a.zOrigin = 0, a.renderTransform()), a.uncache = 1);
            }
        }, VE = function(t1, e) {
            var i = {
                target: t1,
                props: [],
                revert: HE,
                save: FE
            };
            return t1._gsap || uE.core.getCache(t1), e && e.split(",").forEach(function(t1) {
                return i.save(t1);
            }), i;
        }, GE = function(t1, e) {
            var i = dE.createElementNS ? dE.createElementNS((e || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), t1) : dE.createElement(t1);
            return i && i.style ? i : dE.createElement(t1);
        }, WE = function t1(e, i, n) {
            var r = getComputedStyle(e);
            return r[i] || r.getPropertyValue(i.replace(bE, "-$1").toLowerCase()) || r.getPropertyValue(i) || !n && t1(e, XE(i) || i, 1) || "";
        }, YE = "O,Moz,ms,Ms,Webkit".split(","), XE = function(t1, e, i) {
            var n = (e || fE).style, r = 5;
            if (t1 in n && !i) return t1;
            for(t1 = t1.charAt(0).toUpperCase() + t1.substr(1); r-- && !(YE[r] + t1 in n););
            return r < 0 ? null : (3 === r ? "ms" : r >= 0 ? YE[r] : "") + t1;
        }, ZE = function() {
            "undefined" != typeof window && window.document && (hE = window, dE = hE.document, pE = dE.documentElement, fE = GE("div") || {
                style: {}
            }, GE("div"), UE = XE(UE), BE = UE + "Origin", fE.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0", ME = !!XE("perspective"), gE = uE.core.reverting, AE = 1);
        }, qE = function t1(e) {
            var i, n = GE("svg", this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), r = this.parentNode, a = this.nextSibling, s = this.style.cssText;
            if (pE.appendChild(n), n.appendChild(this), this.style.display = "block", e) try {
                i = this.getBBox(), this._gsapBBox = this.getBBox, this.getBBox = t1;
            } catch (t1) {}
            else this._gsapBBox && (i = this._gsapBBox());
            return r && (a ? r.insertBefore(this, a) : r.appendChild(this)), pE.removeChild(n), this.style.cssText = s, i;
        }, JE = function(t1, e) {
            for(var i = e.length; i--;)if (t1.hasAttribute(e[i])) return t1.getAttribute(e[i]);
        }, KE = function(t1) {
            var e;
            try {
                e = t1.getBBox();
            } catch (i) {
                e = qE.call(t1, !0);
            }
            return e && (e.width || e.height) || t1.getBBox === qE || (e = qE.call(t1, !0)), !e || e.width || e.x || e.y ? e : {
                x: +JE(t1, [
                    "x",
                    "cx",
                    "x1"
                ]) || 0,
                y: +JE(t1, [
                    "y",
                    "cy",
                    "y1"
                ]) || 0,
                width: 0,
                height: 0
            };
        }, $E = function(t1) {
            return !(!t1.getCTM || t1.parentNode && !t1.ownerSVGElement || !KE(t1));
        }, t_ = function(t1, e) {
            if (e) {
                var i, n = t1.style;
                e in vE && e !== BE && (e = UE), n.removeProperty ? ("ms" !== (i = e.substr(0, 2)) && "webkit" !== e.substr(0, 6) || (e = "-" + e), n.removeProperty("--" === i ? e : e.replace(bE, "-$1").toLowerCase())) : n.removeAttribute(e);
            }
        }, e_ = function(t1, e, i, n, r, a) {
            var s = new JT(t1._pt, e, i, 0, 1, a ? zE : CE);
            return t1._pt = s, s.b = n, s.e = r, t1._props.push(i), s;
        }, i_ = {
            deg: 1,
            rad: 1,
            turn: 1
        }, n_ = {
            grid: 1,
            flex: 1
        }, r_ = function t1(e, i, n, r) {
            var a, s, o, l, c = parseFloat(n) || 0, u = (n + "").trim().substr((c + "").length) || "px", h = fE.style, d = TE.test(i), p = "svg" === e.tagName.toLowerCase(), A = (p ? "client" : "offset") + (d ? "Width" : "Height"), f = 100, m = "px" === r, g = "%" === r;
            if (r === u || !c || i_[r] || i_[u]) return c;
            if ("px" !== u && !m && (c = t1(e, i, n, "px")), l = e.getCTM && $E(e), (g || "%" === u) && (vE[i] || ~i.indexOf("adius"))) return a = l ? e.getBBox()[d ? "width" : "height"] : e[A], eb(g ? c / a * f : c / 100 * a);
            if (h[d ? "width" : "height"] = f + (m ? u : r), s = ~i.indexOf("adius") || "em" === r && e.appendChild && !p ? e : e.parentNode, l && (s = (e.ownerSVGElement || {}).parentNode), s && s !== dE && s.appendChild || (s = dE.body), (o = s._gsap) && g && o.width && d && o.time === hT.time && !o.uncache) return eb(c / o.width * f);
            if (!g || "height" !== i && "width" !== i) (g || "%" === u) && !n_[WE(s, "display")] && (h.position = WE(e, "position")), s === e && (h.position = "static"), s.appendChild(fE), a = fE[A], s.removeChild(fE), h.position = "absolute";
            else {
                var M = e.style[i];
                e.style[i] = f + r, a = e[A], M ? e.style[i] = M : t_(e, i);
            }
            return d && g && ((o = Kw(s)).time = hT.time, o.width = s[A]), eb(m ? a * c / f : a && c ? f / a * c : 0);
        }, a_ = function(t1, e, i, n) {
            var r;
            return AE || ZE(), e in _E && "transform" !== e && ~(e = _E[e]).indexOf(",") && (e = e.split(",")[0]), vE[e] && "transform" !== e ? (r = g_(t1, n), r = "transformOrigin" !== e ? r[e] : r.svg ? r.origin : M_(WE(t1, BE)) + " " + r.zOrigin + "px") : (!(r = t1.style[e]) || "auto" === r || n || ~(r + "").indexOf("calc(")) && (r = u_[e] && u_[e](t1, e, i) || WE(t1, e) || $w(t1, e) || ("opacity" === e ? 1 : 0)), i && !~(r + "").trim().indexOf(" ") ? r_(t1, e, r, i) + i : r;
        }, s_ = function(t1, e, i, n) {
            if (!i || "none" === i) {
                var r = XE(e, t1, 1), a = r && WE(t1, r, 1);
                a && a !== i ? (e = r, i = a) : "borderColor" === e && (i = WE(t1, "borderTopColor"));
            }
            var s, o, l, c, u, h, d, p, A, f, m, g = new JT(this._pt, t1.style, e, 0, 1, GT), M = 0, v = 0;
            if (g.b = i, g.e = n, i += "", "auto" == (n += "") && (h = t1.style[e], t1.style[e] = n, n = WE(t1, e) || n, h ? t1.style[e] = h : t_(t1, e)), uT(s = [
                i,
                n
            ]), n = s[1], l = (i = s[0]).match(Sw) || [], (n.match(Sw) || []).length) {
                for(; o = Sw.exec(n);)d = o[0], A = n.substring(M, o.index), u ? u = (u + 1) % 5 : "rgba(" !== A.substr(-5) && "hsla(" !== A.substr(-5) || (u = 1), d !== (h = l[v++] || "") && (c = parseFloat(h) || 0, m = h.substr((c + "").length), "=" === d.charAt(1) && (d = nb(c, d) + m), p = parseFloat(d), f = d.substr((p + "").length), M = Sw.lastIndex - f.length, f || (f = f || sw.units[e] || m, M === n.length && (n += f, g.e += f)), m !== f && (c = r_(t1, e, h, f) || 0), g._pt = {
                    _next: g._pt,
                    p: A || 1 === v ? A : ",",
                    s: c,
                    c: p - c,
                    m: u && u < 4 || "zIndex" === e ? Math.round : 0
                });
                g.c = M < n.length ? n.substring(M, n.length) : "";
            } else g.r = "display" === e && "none" === n ? zE : CE;
            return Dw.test(n) && (g.e = 0), this._pt = g, g;
        }, o_ = {
            top: "0%",
            bottom: "100%",
            left: "0%",
            right: "100%",
            center: "50%"
        }, l_ = function(t1) {
            var e = t1.split(" "), i = e[0], n = e[1] || "50%";
            return "top" !== i && "bottom" !== i && "left" !== n && "right" !== n || (t1 = i, i = n, n = t1), e[0] = o_[i] || i, e[1] = o_[n] || n, e.join(" ");
        }, c_ = function(t1, e) {
            if (e.tween && e.tween._time === e.tween._dur) {
                var i, n, r, a = e.t, s = a.style, o = e.u, l = a._gsap;
                if ("all" === o || !0 === o) s.cssText = "", n = 1;
                else for(r = (o = o.split(",")).length; --r > -1;)i = o[r], vE[i] && (n = 1, i = "transformOrigin" === i ? BE : UE), t_(a, i);
                n && (t_(a, UE), l && (l.svg && a.removeAttribute("transform"), g_(a, 1), l.uncache = 1, QE(s)));
            }
        }, u_ = {
            clearProps: function(t1, e, i, n, r) {
                if ("isFromStart" !== r.data) {
                    var a = t1._pt = new JT(t1._pt, e, i, 0, 0, c_);
                    return a.u = n, a.pr = -10, a.tween = r, t1._props.push(i), 1;
                }
            }
        }, h_ = [
            1,
            0,
            0,
            1,
            0,
            0
        ], d_ = {}, p_ = function(t1) {
            return "matrix(1, 0, 0, 1, 0, 0)" === t1 || "none" === t1 || !t1;
        }, A_ = function(t1) {
            var e = WE(t1, UE);
            return p_(e) ? h_ : e.substr(7).match(Iw).map(eb);
        }, f_ = function(t1, e) {
            var i, n, r, a, s = t1._gsap || Kw(t1), o = t1.style, l = A_(t1);
            return s.svg && t1.getAttribute("transform") ? "1,0,0,1,0,0" === (l = [
                (r = t1.transform.baseVal.consolidate().matrix).a,
                r.b,
                r.c,
                r.d,
                r.e,
                r.f
            ]).join(",") ? h_ : l : (l !== h_ || t1.offsetParent || t1 === pE || s.svg || (r = o.display, o.display = "block", (i = t1.parentNode) && t1.offsetParent || (a = 1, n = t1.nextElementSibling, pE.appendChild(t1)), l = A_(t1), r ? o.display = r : t_(t1, "display"), a && (n ? i.insertBefore(t1, n) : i ? i.appendChild(t1) : pE.removeChild(t1))), e && l.length > 6 ? [
                l[0],
                l[1],
                l[4],
                l[5],
                l[12],
                l[13]
            ] : l);
        }, m_ = function(t1, e, i, n, r, a) {
            var s, o, l, c = t1._gsap, u = r || f_(t1, !0), h = c.xOrigin || 0, d = c.yOrigin || 0, p = c.xOffset || 0, A = c.yOffset || 0, f = u[0], m = u[1], g = u[2], M = u[3], v = u[4], y = u[5], x = e.split(" "), w = parseFloat(x[0]) || 0, b = parseFloat(x[1]) || 0;
            i ? u !== h_ && (o = f * M - m * g) && (l = w * (-m / o) + b * (f / o) - (f * y - m * v) / o, w = w * (M / o) + b * (-g / o) + (g * y - M * v) / o, b = l) : (w = (s = KE(t1)).x + (~x[0].indexOf("%") ? w / 100 * s.width : w), b = s.y + (~(x[1] || x[0]).indexOf("%") ? b / 100 * s.height : b)), n || !1 !== n && c.smooth ? (v = w - h, y = b - d, c.xOffset = p + (v * f + y * g) - v, c.yOffset = A + (v * m + y * M) - y) : c.xOffset = c.yOffset = 0, c.xOrigin = w, c.yOrigin = b, c.smooth = !!n, c.origin = e, c.originIsAbsolute = !!i, t1.style[BE] = "0px 0px", a && (e_(a, c, "xOrigin", h, w), e_(a, c, "yOrigin", d, b), e_(a, c, "xOffset", p, c.xOffset), e_(a, c, "yOffset", A, c.yOffset)), t1.setAttribute("data-svg-origin", w + " " + b);
        }, g_ = function(t1, e) {
            var i = t1._gsap || new TT(t1);
            if ("x" in i && !e && !i.uncache) return i;
            var n, r, a, s, o, l, c, u, h, d, p, A, f, m, g, M, v, y, x, w, b, T, E, _, I, S, N, D, C, z, L, O, P = t1.style, j = i.scaleX < 0, R = "px", k = "deg", U = getComputedStyle(t1), B = WE(t1, BE) || "0";
            return n = r = a = l = c = u = h = d = p = 0, s = o = 1, i.svg = !(!t1.getCTM || !$E(t1)), U.translate && ("none" === U.translate && "none" === U.scale && "none" === U.rotate || (P[UE] = ("none" !== U.translate ? "translate3d(" + (U.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + ("none" !== U.rotate ? "rotate(" + U.rotate + ") " : "") + ("none" !== U.scale ? "scale(" + U.scale.split(" ").join(",") + ") " : "") + ("none" !== U[UE] ? U[UE] : "")), P.scale = P.rotate = P.translate = "none"), m = f_(t1, i.svg), i.svg && (i.uncache ? (I = t1.getBBox(), B = i.xOrigin - I.x + "px " + (i.yOrigin - I.y) + "px", _ = "") : _ = !e && t1.getAttribute("data-svg-origin"), m_(t1, _ || B, !!_ || i.originIsAbsolute, !1 !== i.smooth, m)), A = i.xOrigin || 0, f = i.yOrigin || 0, m !== h_ && (y = m[0], x = m[1], w = m[2], b = m[3], n = T = m[4], r = E = m[5], 6 === m.length ? (s = Math.sqrt(y * y + x * x), o = Math.sqrt(b * b + w * w), l = y || x ? wE(x, y) * yE : 0, (h = w || b ? wE(w, b) * yE + l : 0) && (o *= Math.abs(Math.cos(h * xE))), i.svg && (n -= A - (A * y + f * w), r -= f - (A * x + f * b))) : (O = m[6], z = m[7], N = m[8], D = m[9], C = m[10], L = m[11], n = m[12], r = m[13], a = m[14], c = (g = wE(O, C)) * yE, g && (_ = T * (M = Math.cos(-g)) + N * (v = Math.sin(-g)), I = E * M + D * v, S = O * M + C * v, N = T * -v + N * M, D = E * -v + D * M, C = O * -v + C * M, L = z * -v + L * M, T = _, E = I, O = S), u = (g = wE(-w, C)) * yE, g && (M = Math.cos(-g), L = b * (v = Math.sin(-g)) + L * M, y = _ = y * M - N * v, x = I = x * M - D * v, w = S = w * M - C * v), l = (g = wE(x, y)) * yE, g && (_ = y * (M = Math.cos(g)) + x * (v = Math.sin(g)), I = T * M + E * v, x = x * M - y * v, E = E * M - T * v, y = _, T = I), c && Math.abs(c) + Math.abs(l) > 359.9 && (c = l = 0, u = 180 - u), s = eb(Math.sqrt(y * y + x * x + w * w)), o = eb(Math.sqrt(E * E + O * O)), g = wE(T, E), h = Math.abs(g) > 2e-4 ? g * yE : 0, p = L ? 1 / (L < 0 ? -L : L) : 0), i.svg && (_ = t1.getAttribute("transform"), i.forceCSS = t1.setAttribute("transform", "") || !p_(WE(t1, UE)), _ && t1.setAttribute("transform", _))), Math.abs(h) > 90 && Math.abs(h) < 270 && (j ? (s *= -1, h += l <= 0 ? 180 : -180, l += l <= 0 ? 180 : -180) : (o *= -1, h += h <= 0 ? 180 : -180)), e = e || i.uncache, i.x = n - ((i.xPercent = n && (!e && i.xPercent || (Math.round(t1.offsetWidth / 2) === Math.round(-n) ? -50 : 0))) ? t1.offsetWidth * i.xPercent / 100 : 0) + R, i.y = r - ((i.yPercent = r && (!e && i.yPercent || (Math.round(t1.offsetHeight / 2) === Math.round(-r) ? -50 : 0))) ? t1.offsetHeight * i.yPercent / 100 : 0) + R, i.z = a + R, i.scaleX = eb(s), i.scaleY = eb(o), i.rotation = eb(l) + k, i.rotationX = eb(c) + k, i.rotationY = eb(u) + k, i.skewX = h + k, i.skewY = d + k, i.transformPerspective = p + R, (i.zOrigin = parseFloat(B.split(" ")[2]) || !e && i.zOrigin || 0) && (P[BE] = M_(B)), i.xOffset = i.yOffset = 0, i.force3D = sw.force3D, i.renderTransform = i.svg ? E_ : ME ? T_ : y_, i.uncache = 0, i;
        }, M_ = function(t1) {
            return (t1 = t1.split(" "))[0] + " " + t1[1];
        }, v_ = function(t1, e, i) {
            var n = kb(e);
            return eb(parseFloat(e) + parseFloat(r_(t1, "x", i + "px", n))) + n;
        }, y_ = function(t1, e) {
            e.z = "0px", e.rotationY = e.rotationX = "0deg", e.force3D = 0, T_(t1, e);
        }, x_ = "0deg", w_ = "0px", b_ = ") ", T_ = function(t1, e) {
            var i = e || this, n = i.xPercent, r = i.yPercent, a = i.x, s = i.y, o = i.z, l = i.rotation, c = i.rotationY, u = i.rotationX, h = i.skewX, d = i.skewY, p = i.scaleX, A = i.scaleY, f = i.transformPerspective, m = i.force3D, g = i.target, M = i.zOrigin, v = "", y = "auto" === m && t1 && 1 !== t1 || !0 === m;
            if (M && (u !== x_ || c !== x_)) {
                var x, w = parseFloat(c) * xE, b = Math.sin(w), T = Math.cos(w);
                w = parseFloat(u) * xE, x = Math.cos(w), a = v_(g, a, b * x * -M), s = v_(g, s, -Math.sin(w) * -M), o = v_(g, o, T * x * -M + M);
            }
            f !== w_ && (v += "perspective(" + f + b_), (n || r) && (v += "translate(" + n + "%, " + r + "%) "), (y || a !== w_ || s !== w_ || o !== w_) && (v += o !== w_ || y ? "translate3d(" + a + ", " + s + ", " + o + ") " : "translate(" + a + ", " + s + b_), l !== x_ && (v += "rotate(" + l + b_), c !== x_ && (v += "rotateY(" + c + b_), u !== x_ && (v += "rotateX(" + u + b_), h === x_ && d === x_ || (v += "skew(" + h + ", " + d + b_), 1 === p && 1 === A || (v += "scale(" + p + ", " + A + b_), g.style[UE] = v || "translate(0, 0)";
        }, E_ = function(t1, e) {
            var i, n, r, a, s, o = e || this, l = o.xPercent, c = o.yPercent, u = o.x, h = o.y, d = o.rotation, p = o.skewX, A = o.skewY, f = o.scaleX, m = o.scaleY, g = o.target, M = o.xOrigin, v = o.yOrigin, y = o.xOffset, x = o.yOffset, w = o.forceCSS, b = parseFloat(u), T = parseFloat(h);
            d = parseFloat(d), p = parseFloat(p), (A = parseFloat(A)) && (p += A = parseFloat(A), d += A), d || p ? (d *= xE, p *= xE, i = Math.cos(d) * f, n = Math.sin(d) * f, r = Math.sin(d - p) * -m, a = Math.cos(d - p) * m, p && (A *= xE, s = Math.tan(p - A), r *= s = Math.sqrt(1 + s * s), a *= s, A && (s = Math.tan(A), i *= s = Math.sqrt(1 + s * s), n *= s)), i = eb(i), n = eb(n), r = eb(r), a = eb(a)) : (i = f, a = m, n = r = 0), (b && !~(u + "").indexOf("px") || T && !~(h + "").indexOf("px")) && (b = r_(g, "x", u, "px"), T = r_(g, "y", h, "px")), (M || v || y || x) && (b = eb(b + M - (M * i + v * r) + y), T = eb(T + v - (M * n + v * a) + x)), (l || c) && (s = g.getBBox(), b = eb(b + l / 100 * s.width), T = eb(T + c / 100 * s.height)), s = "matrix(" + i + "," + n + "," + r + "," + a + "," + b + "," + T + ")", g.setAttribute("transform", s), w && (g.style[UE] = s);
        }, __ = function(t1, e, i, n, r) {
            var a, s, o = 360, l = mw(r), c = parseFloat(r) * (l && ~r.indexOf("rad") ? yE : 1) - n, u = n + c + "deg";
            return l && ("short" === (a = r.split("_")[1]) && (c %= o) != c % 180 && (c += c < 0 ? o : -360), "cw" === a && c < 0 ? c = (c + 36e9) % o - ~~(c / o) * o : "ccw" === a && c > 0 && (c = (c - 36e9) % o - ~~(c / o) * o)), t1._pt = s = new JT(t1._pt, e, i, n, c, SE), s.e = u, s.u = "deg", t1._props.push(i), s;
        }, I_ = function(t1, e) {
            for(var i in e)t1[i] = e[i];
            return t1;
        }, S_ = function(t1, e, i) {
            var n, r, a, s, o, l, c, u = I_({}, i._gsap), h = i.style;
            for(r in u.svg ? (a = i.getAttribute("transform"), i.setAttribute("transform", ""), h[UE] = e, n = g_(i, 1), t_(i, UE), i.setAttribute("transform", a)) : (a = getComputedStyle(i)[UE], h[UE] = e, n = g_(i, 1), h[UE] = a), vE)(a = u[r]) !== (s = n[r]) && "perspective,force3D,transformOrigin,svgOrigin".indexOf(r) < 0 && (o = kb(a) !== (c = kb(s)) ? r_(i, r, a, c) : parseFloat(a), l = parseFloat(s), t1._pt = new JT(t1._pt, n, r, o, l - o, IE), t1._pt.u = c || 0, t1._props.push(r));
            I_(n, u);
        };
        tb("padding,margin,Width,Radius", function(t1, e) {
            var i = "Top", n = "Right", r = "Bottom", a = "Left", s = (e < 3 ? [
                i,
                n,
                r,
                a
            ] : [
                i + a,
                i + n,
                r + n,
                r + a
            ]).map(function(i) {
                return e < 2 ? t1 + i : "border" + i + t1;
            });
            u_[e > 1 ? "border" + t1 : t1] = function(t1, e, i, n, r) {
                var a, o;
                if (arguments.length < 4) return a = s.map(function(e) {
                    return a_(t1, e, i);
                }), 5 === (o = a.join(" ")).split(a[0]).length ? a[0] : o;
                a = (n + "").split(" "), o = {}, s.forEach(function(t1, e) {
                    return o[t1] = a[e] = a[e] || a[(e - 1) / 2 | 0];
                }), t1.init(e, o, r);
            };
        });
        var N_, D_, C_ = {
            name: "css",
            register: ZE,
            targetTest: function(t1) {
                return t1.style && t1.nodeType;
            },
            init: function(t1, e, i, n, r) {
                var a, s, o, l, c, u, h, d, p, A, f, m, g, M, v, y, x = this._props, w = t1.style, b = i.vars.startAt;
                for(h in AE || ZE(), this.styles = this.styles || VE(t1), y = this.styles.props, this.tween = i, e)if ("autoRound" !== h && (s = e[h], !Ww[h] || !CT(h, e, i, n, t1, r))) {
                    if (c = typeof s, u = u_[h], "function" === c && (c = typeof (s = s.call(i, n, t1, r))), "string" === c && ~s.indexOf("random(") && (s = Zb(s)), u) u(this, t1, h, s, i) && (v = 1);
                    else if ("--" === h.substr(0, 2)) a = (getComputedStyle(t1).getPropertyValue(h) + "").trim(), s += "", lT.lastIndex = 0, lT.test(a) || (d = kb(a), p = kb(s)), p ? d !== p && (a = r_(t1, h, a, p) + p) : d && (s += d), this.add(w, "setProperty", a, s, n, r, 0, 0, h), x.push(h), y.push(h, 0, w[h]);
                    else if ("undefined" !== c) {
                        if (b && h in b ? (a = "function" == typeof b[h] ? b[h].call(i, n, t1, r) : b[h], mw(a) && ~a.indexOf("random(") && (a = Zb(a)), kb(a + "") || "auto" === a || (a += sw.units[h] || kb(a_(t1, h)) || ""), "=" === (a + "").charAt(1) && (a = a_(t1, h))) : a = a_(t1, h), l = parseFloat(a), (A = "string" === c && "=" === s.charAt(1) && s.substr(0, 2)) && (s = s.substr(2)), o = parseFloat(s), h in _E && ("autoAlpha" === h && (1 === l && "hidden" === a_(t1, "visibility") && o && (l = 0), y.push("visibility", 0, w.visibility), e_(this, w, "visibility", l ? "inherit" : "hidden", o ? "inherit" : "hidden", !o)), "scale" !== h && "transform" !== h && ~(h = _E[h]).indexOf(",") && (h = h.split(",")[0])), f = h in vE) {
                            if (this.styles.save(h), m || ((g = t1._gsap).renderTransform && !e.parseTransform || g_(t1, e.parseTransform), M = !1 !== e.smoothOrigin && g.smooth, (m = this._pt = new JT(this._pt, w, UE, 0, 1, g.renderTransform, g, 0, -1)).dep = 1), "scale" === h) this._pt = new JT(this._pt, g, "scaleY", g.scaleY, (A ? nb(g.scaleY, A + o) : o) - g.scaleY || 0, IE), this._pt.u = 0, x.push("scaleY", h), h += "X";
                            else {
                                if ("transformOrigin" === h) {
                                    y.push(BE, 0, w[BE]), s = l_(s), g.svg ? m_(t1, s, 0, M, 0, this) : ((p = parseFloat(s.split(" ")[2]) || 0) !== g.zOrigin && e_(this, g, "zOrigin", g.zOrigin, p), e_(this, w, h, M_(a), M_(s)));
                                    continue;
                                }
                                if ("svgOrigin" === h) {
                                    m_(t1, s, 1, M, 0, this);
                                    continue;
                                }
                                if (h in d_) {
                                    __(this, g, h, l, A ? nb(l, A + s) : s);
                                    continue;
                                }
                                if ("smoothOrigin" === h) {
                                    e_(this, g, "smooth", g.smooth, s);
                                    continue;
                                }
                                if ("force3D" === h) {
                                    g[h] = s;
                                    continue;
                                }
                                if ("transform" === h) {
                                    S_(this, s, t1);
                                    continue;
                                }
                            }
                        } else h in w || (h = XE(h) || h);
                        if (f || (o || 0 === o) && (l || 0 === l) && !EE.test(s) && h in w) o || (o = 0), (d = (a + "").substr((l + "").length)) !== (p = kb(s) || (h in sw.units ? sw.units[h] : d)) && (l = r_(t1, h, a, p)), this._pt = new JT(this._pt, f ? g : w, h, l, (A ? nb(l, A + o) : o) - l, f || "px" !== p && "zIndex" !== h || !1 === e.autoRound ? IE : DE), this._pt.u = p || 0, d !== p && "%" !== p && (this._pt.b = a, this._pt.r = NE);
                        else if (h in w) s_.call(this, t1, h, a, A ? A + s : s);
                        else if (h in t1) this.add(t1, h, a || t1[h], A ? A + s : s, n, r);
                        else if ("parseTransform" !== h) {
                            jw(h, s);
                            continue;
                        }
                        f || (h in w ? y.push(h, 0, w[h]) : y.push(h, 1, a || t1[h])), x.push(h);
                    }
                }
                v && qT(this);
            },
            render: function(t1, e) {
                if (e.tween._time || !gE()) for(var i = e._pt; i;)i.r(t1, i.d), i = i._next;
                else e.styles.revert();
            },
            get: a_,
            aliases: _E,
            getSetter: function(t1, e, i) {
                var n = _E[e];
                return n && n.indexOf(",") < 0 && (e = n), e in vE && e !== BE && (t1._gsap.x || a_(t1, "x")) ? i && mE === i ? "scale" === e ? jE : PE : (mE = i || {}, "scale" === e ? RE : kE) : t1.style && !vw(t1.style[e]) ? LE : ~e.indexOf("-") ? OE : QT(t1, e);
            },
            core: {
                _removeProperty: t_,
                _getMatrix: f_
            }
        };
        uE.utils.checkPrefix = XE, uE.core.getStyleSaver = VE, D_ = tb("x,y,z,scale,scaleX,scaleY,xPercent,yPercent," + (N_ = "rotation,rotationX,rotationY,skewX,skewY") + ",transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", function(t1) {
            vE[t1] = 1;
        }), tb(N_, function(t1) {
            sw.units[t1] = "deg", d_[t1] = 1;
        }), _E[D_[13]] = "x,y,z,scale,scaleX,scaleY,xPercent,yPercent," + N_, tb("0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY", function(t1) {
            var e = t1.split(":");
            _E[e[1]] = D_[e[0]];
        }), tb("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(t1) {
            sw.units[t1] = "px";
        }), uE.registerPlugin(C_);
        var z_ = uE.registerPlugin(C_) || uE;
        z_.core.Tween;
        const L_ = class extends Pp {
            constructor(t1){
                var e, i, n;
                super(), e = this, n = !0, (i = function(t1) {
                    var e = function(t1) {
                        if ("object" != typeof t1 || !t1) return t1;
                        var e = t1[Symbol.toPrimitive];
                        if (void 0 !== e) {
                            var i = e.call(t1, "string");
                            if ("object" != typeof i) return i;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(t1);
                    }(t1);
                    return "symbol" == typeof e ? e : e + "";
                }(i = "_visible")) in e ? Object.defineProperty(e, i, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : e[i] = n, this.userData = t1, this.visible = !1, this.createHoverArea(), this.createPoint().then(()=>this.addEventListeners());
            }
            get visible() {
                return this._visible;
            }
            set visible(t1) {
                this._visible = t1, this.hoverArea && (this.hoverArea.visible = t1), this.point && (this.point.visible = t1);
            }
            async createPoint() {
                const t1 = new uh(30, 30, 10, 10), e = new yg, i = await e.loadAsync(this.userData.icon);
                i.center = new qo(.5, .5), i.colorSpace = Qs, i.minFilter = ya, i.magFilter = ma, i.anisotropy = 8;
                const n = new Om({
                    color: new Yc(16777215),
                    transparent: !0,
                    depthTest: !1,
                    side: cr,
                    map: i,
                    opacity: kx.isMobileDevice ? .5 : 0
                });
                this.point = new Fu(t1, n), this.point.position.copy(this.userData.position), this.point.rotation.x = Math.PI / 2, this.point.visible = this.visible, this.point.interactive = !0, this.point.renderOrder = 3, this.point.isLink = !0, this.point.updateOpacity = z_.quickTo(this.point.material, "opacity", {
                    ease: "back",
                    duration: .5
                }), this.add(this.point);
            }
            createHoverArea() {
                const t1 = new Of(125, 10, 10), e = new Om({
                    color: new Yc(16777215),
                    transparent: !0,
                    depthTest: !1,
                    side: cr,
                    opacity: 0
                });
                this.hoverArea = new Fu(t1, e), this.hoverArea.position.copy(this.userData.position), this.hoverArea.rotation.x = Math.PI / 2, this.hoverArea.visible = this.visible, this.hoverArea.isLinkSphere = !0, this.hoverArea.interactive = !0, this.hoverArea.renderOrder = 2, this.add(this.hoverArea);
            }
            addEventListeners() {
                return this.point.addEventListener("select", ()=>this.onClick()), this.point.addEventListener("click", ()=>this.onClick()), this.point.addEventListener("hoverstart", ()=>this.onHoverStart()), this.point.addEventListener("hoverend", ()=>this.onHoverEnd()), this.hoverArea.addEventListener("hoverstart", ()=>this.onHoverStart()), this.hoverArea.addEventListener("hoverend", ()=>this.onHoverEnd()), this;
            }
            dispose() {
                this.point && (this.point.material.dispose(), this.point.removeFromParent()), this.hoverArea && (this.hoverArea.material.dispose(), this.hoverArea.removeFromParent()), this.removeFromParent();
            }
            onHoverStart() {
                kx.isMobileDevice || this.point.updateOpacity(1);
            }
            onHoverEnd() {
                kx.isMobileDevice || this.point.updateOpacity(0);
            }
            onClick() {}
        };
        const O_ = class extends uA {
            constructor(t1){
                var e, i, n;
                super(), e = this, n = !0, (i = function(t1) {
                    var e = function(t1) {
                        if ("object" != typeof t1 || !t1) return t1;
                        var e = t1[Symbol.toPrimitive];
                        if (void 0 !== e) {
                            var i = e.call(t1, "string");
                            if ("object" != typeof i) return i;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(t1);
                    }(t1);
                    return "symbol" == typeof e ? e : e + "";
                }(i = "interactive")) in e ? Object.defineProperty(e, i, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : e[i] = n, this.userData = t1, this.position.copy(t1.position), this.renderOrder = 3, this.visible = !1, this.onHoverEnd(), this.createMaterial(), this.addEventListeners();
            }
            createGeometry() {
                return this.geometry = new uh(1, 1, 10, 10), this;
            }
            async createMaterial() {
                const t1 = new yg, e = await t1.loadAsync(this.userData.icon);
                e.center = new qo(.5, .5), e.colorSpace = Qs, e.minFilter = ya, e.magFilter = ma, e.anisotropy = 8;
                const i = new qp({
                    color: new Yc(16777215),
                    sizeAttenuation: !1,
                    transparent: !0,
                    depthTest: !1,
                    side: cr,
                    map: e,
                    opacity: 1
                });
                return this.material = i, this;
            }
            addEventListeners() {
                return this.addEventListener("select", ()=>this.onClick()), this.addEventListener("click", ()=>this.onClick()), this.addEventListener("hoverstart", ()=>this.onHoverStart()), this.addEventListener("hoverend", ()=>this.onHoverEnd()), this;
            }
            dispose() {
                this.material.dispose(), this.removeFromParent();
            }
            onHoverStart() {
                this.scale.setScalar(this.userData.scale + 20 * this.userData.scale / 100);
            }
            onHoverEnd() {
                this.scale.setScalar(this.userData.scale);
            }
            onClick() {}
        };
        function P_(t1, e, i) {
            return (e = function(t1) {
                var e = function(t1) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var e = t1[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e)) in t1 ? Object.defineProperty(t1, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = i, t1;
        }
        function j_(t1, e) {
            return t1.get(function(t1, e, i) {
                if ("function" == typeof t1 ? t1 === e : t1.has(e)) return arguments.length < 3 ? e : i;
                throw new TypeError("Private element is not present on this object");
            }(t1, e));
        }
        var R_ = new WeakMap;
        const k_ = class extends Fu {
            constructor(t1, e){
                var i, n, r;
                super(e), P_(this, "depthMap", null), P_(this, "loaded", !1), P_(this, "links", []), r = [], function(t1, e) {
                    if (e.has(t1)) throw new TypeError("Cannot initialize the same private elements twice on an object");
                }(i = this, n = R_), n.set(i, r), this.renderOrder = 0, this.userData = t1;
            }
            get panoramaId() {
                return this.userData.camera_id;
            }
            async loadDepth() {
                performance.mark("start downloadingDepth");
                try {
                    this.depthMap = await _x(this.userData.images.scene_depth);
                } catch (t1) {
                    this.depthMap = null, console.error("Error loading depthMap");
                }
                performance.mark("finish start downloadingDepth"), performance.measure("downloadingDepth", "start downloadingDepth", "finish start downloadingDepth");
            }
            async loadMask() {
                try {
                    this.mask = await _x(this.userData.images.object_ids);
                } catch (t1) {
                    this.mask = null, console.error("Error loading mask");
                }
            }
            async load() {
                return this.userData.images.scene_depth && await this.loadDepth().then(()=>this.removeBlockedLinks()), this.userData.images.object_ids && await this.loadMask(), await this.createMaterial().then(()=>this.loaded = !0);
            }
            removeBlockedLinks() {
                const t1 = [];
                this.links.forEach((e)=>{
                    const { delta: i, distance: n } = ((t1, e)=>{
                        const { direction: i } = (new rc).lookAt(t1), n = (1 + Math.atan2(i.z, i.x) / Math.PI) / 2, r = Math.acos(i.y) / Math.PI, { R: a } = Ix(n, r, e), s = a || 140, o = (new Nl).distanceTo(t1);
                        return {
                            depth: s,
                            distance: o,
                            delta: o - s
                        };
                    })(e.userData.position, this.depthMap);
                    if (i > 40 || n > 800) return e.dispose();
                    t1.push(e);
                });
            }
            createLinks(t1) {
                return this.createCameraPoints(), this.createDoors(t1), this;
            }
            createCameraPoints() {
                for (const t1 of this.userData.roomPanoramas){
                    if (t1 === this.panoramaId) continue;
                    const e = vx(Un.config.json, t1);
                    e && this.createLink(t1, e.Location, !1);
                }
                return this;
            }
            createDoors(t1) {
                var e, i;
                const n = Un.config.json.Floors[Un.currentFloorIndex], r = null !== (e = n.Apertures) && void 0 !== e ? e : [], a = null !== (i = n.Doors) && void 0 !== i ? i : [], s = Mx(Un.config.json, this.userData.room_id), { Rooms: o } = n.Units[0];
                for (const { Location: e, Walls: i, ...n } of [
                    ...a,
                    ...r
                ]){
                    if (!i.some((t1)=>s.Walls.some((e)=>e === t1))) continue;
                    const r = o.find((t1)=>{
                        const e = t1.Walls.some((t1)=>i.some((e)=>t1 === e)), n = t1.ID === s.ID;
                        return e && !n;
                    });
                    if (!r) continue;
                    const a = t1.filter((t1)=>{
                        let { userData: e } = t1;
                        return e.room_id === r.ID;
                    }), { panorama: l } = yx([
                        e.X,
                        e.Y
                    ], a);
                    l && this.createLink(l.panoramaId, e, !0, n);
                }
                return this;
            }
            createLink(t1, e) {
                var i;
                let n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], r = arguments.length > 3 ? arguments[3] : void 0;
                const a = (null === (i = this.userData.cameraData) || void 0 === i ? void 0 : i.Location.Z) || 140, s = [
                    this.userData.left,
                    this.userData.top
                ], o = e.X - s[0], l = e.Y - s[1], c = n ? r.Height / 2 - a : -a, u = new Nl(o, c, l);
                u.applyAxisAngle(new Nl(0, 1, 0), Math.PI / 2);
                const h = {
                    panoramaId: this.panoramaId,
                    position: u,
                    targetId: t1
                };
                if (n) {
                    const t1 = Un.config.panoramaIcons.door, e = Un.config.interactiveDoors ? new Bx({
                        ...h,
                        rotation: new fc(0, Tx(r.Rotation.Yaw + 90), 0),
                        height: r.Height,
                        width: r.Width,
                        scale: .1,
                        icon: t1,
                        loc: this.userData.cameraData.Location
                    }) : new O_({
                        ...h,
                        scale: .1,
                        icon: t1
                    });
                    return this.links.push(e), e;
                }
                const d = Un.config.interactiveCameraPoints ? Un.config.panoramaIcons.interactiveSpot : Un.config.panoramaIcons.spot, p = Un.config.interactiveCameraPoints ? new L_({
                    ...h,
                    icon: d,
                    scale: 1
                }) : new O_({
                    ...h,
                    scale: .1,
                    icon: d
                });
                return this.links.push(p), p;
            }
            addEventListener(t1, e) {
                "materialcreate" === t1 ? j_(R_, this).push({
                    type: t1,
                    listener: e
                }) : super.addEventListener(t1, e);
            }
            invoke(t1, e) {
                j_(R_, this).forEach((i)=>{
                    t1 === i.type && i.listener(e);
                });
            }
        }, U_ = class extends k_ {
            constructor(t1){
                performance.mark("start creating SphereGeometry");
                const e = new Tm(1e3, 512, 512).scale(-1, 1, 1);
                performance.mark("finish creating SphereGeometry"), performance.measure("creating SphereGeometry", "start creating SphereGeometry", "finish creating SphereGeometry"), super(t1, e), this.userData.image = t1.images.sphere || t1.images[0];
            }
            async createBareshellMaterial() {
                if (this.bareshellMaterial) return this.material = this.bareshellMaterial, this.bareshellMaterial;
                const t1 = await By.get(this.userData.image.replace(/\.jpe?g|\.webp/, (t1)=>{
                    switch(t1){
                        case ".jpg":
                        case ".jpeg":
                            return "_Unfurnished.jpg";
                        case ".webp":
                            return "_Unfurnished.webp";
                        default:
                            return t1;
                    }
                }));
                return this.material = new Om({
                    transparent: !0,
                    side: or,
                    map: t1,
                    opacity: 0
                }), this.bareshellMaterial = this.material, this;
            }
            async createDefaultMaterial() {
                if (this.defaultMaterial) return this.material = this.defaultMaterial, this.defaultMaterial;
                const t1 = await By.get(this.userData.image);
                return this.material = new Om({
                    transparent: !0,
                    side: or,
                    map: t1,
                    opacity: 0
                }), this.defaultMaterial = this.material, this;
            }
            async createMaterial() {
                const t1 = await (bS.bareshell ? this.createBareshellMaterial() : this.createDefaultMaterial());
                return this.invoke("materialcreate"), t1;
            }
            async fadeOut() {
                return await wx(this.material).then(()=>this.visible = !1);
            }
            async fadeIn() {
                return this.visible = !0, await bx(this.material);
            }
        }, B_ = class extends k_ {
            constructor(t1){
                performance.mark("start creating BoxGeometry");
                const e = new Hu(2e3, 2e3, 2e3).scale(-1, 1, 1);
                performance.mark("finish creating BoxGeometry"), performance.measure("creating BoxGeometry", "start creating BoxGeometry", "finish creating BoxGeometry"), super(t1, e), this.userData.cubemap = [
                    {
                        url: t1.images.front,
                        rotation: 0
                    },
                    {
                        url: t1.images.back,
                        rotation: 0
                    },
                    {
                        url: t1.images.top,
                        rotation: 90
                    },
                    {
                        url: t1.images.bottom,
                        rotation: 270
                    },
                    {
                        url: t1.images.left,
                        rotation: 0
                    },
                    {
                        url: t1.images.right,
                        rotation: 0
                    }
                ];
            }
            async loadSides() {
                let t1 = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                const { cubemap: e } = this.userData;
                let i = 0;
                const n = e.length, r = new Array(e.length);
                return new Promise((a)=>{
                    const s = ()=>{
                        i++, i === n && a(r);
                    };
                    e.forEach((e, i)=>{
                        let n = e.url;
                        if (t1) {
                            const t1 = /(Panorama_\d_\d_\d_([a-zA-Zа-яА-Я0-9-]+)\/.+)\.[a-zA-Z0-9]+/gm, i = e.url.match(t1)[0], r = i.replace("/", "_Unfurnished/");
                            n = e.url.replace(i, r);
                        }
                        By.get(n).then((t1)=>{
                            t1.rotation = Tx(e.rotation), r[i] = t1, s();
                        }).catch(s);
                    });
                });
            }
            async createBareshellMaterial() {
                if (this.bareshellMaterial) return this.material = this.bareshellMaterial, this.bareshellMaterial;
                const t1 = await this.loadSides(!0);
                this.material = t1.map((t1)=>new Om({
                        transparent: !0,
                        side: or,
                        opacity: 0,
                        map: t1
                    })), this.bareshellMaterial = this.material;
            }
            async createDefaultMaterial() {
                if (this.defaultMaterial) return this.material = this.defaultMaterial, this.defaultMaterial;
                const t1 = await this.loadSides();
                this.material = t1.map((t1)=>new Om({
                        transparent: !0,
                        side: or,
                        opacity: 0,
                        map: t1
                    })), this.defaultMaterial = this.material;
            }
            async createMaterial() {
                const t1 = await (bS.bareshell ? this.createBareshellMaterial() : this.createDefaultMaterial());
                return this.invoke("materialcreate"), t1;
            }
            async fadeOut() {
                const t1 = this.material.map(wx);
                return await Promise.all(t1).then(()=>this.visible = !1);
            }
            async fadeIn() {
                this.visible = !0;
                const t1 = this.material.map(bx);
                return await Promise.all(t1);
            }
        };
        function F_(t1, e, i) {
            return (e = function(t1) {
                var e = function(t1) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var e = t1[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e)) in t1 ? Object.defineProperty(t1, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = i, t1;
        }
        const Q_ = class extends Pp {
            constructor(t1){
                super(), F_(this, "type", "sphere"), F_(this, "items", []), F_(this, "floorIndex", void 0), this.floorIndex = t1;
            }
            getCreatedPanoramas() {
                const { json: t1 } = Un.config, e = t1.Floors[Un.currentFloorIndex];
                if (!e) return this.items.map((t1)=>{
                    const e = {
                        svgPathActions: [],
                        roomPanoramas: [],
                        rotation: 0,
                        points: [],
                        left: 0,
                        top: 0,
                        ...t1
                    };
                    return this.createPanorama(e);
                });
                const { primaryCameraPointId: i } = Un, n = vx(t1, i), { Walls: r } = e, { Vertices: a } = t1;
                return this.items.reduce((e, i)=>{
                    var s;
                    performance.mark("start getting rooms, cameras, svg paths ...");
                    const o = vx(t1, i.camera_id), l = Mx(t1, i.room_id), c = this.items.reduce((t1, e)=>e.room_id !== i.room_id ? t1 : [
                            ...t1,
                            e.camera_id
                        ], []), u = ((t1, e, i)=>{
                        const n = t1.Walls.reduce((t1, n)=>{
                            const r = e.find((t1)=>t1.ID === n);
                            return gx(e, r.ID, i).forEach((e)=>t1.push(e)), t1;
                        }, []);
                        return n;
                    })(l, r, a), h = l.Walls.reduce((t1, e, i)=>{
                        const n = r.find((t1)=>t1.ID === e), [s, o] = gx(r, e, a), l = [];
                        return 0 === i && t1.push({
                            type: "M",
                            x: s[0],
                            y: s[1]
                        }), t1.push({
                            type: "L",
                            x: s[0],
                            y: s[1]
                        }), n.ControlPoint && l.push({
                            type: "Q",
                            x: n.ControlPoint.Location.X,
                            y: n.ControlPoint.Location.Y,
                            dx: o[0],
                            dy: o[1]
                        }), l.push({
                            type: "L",
                            x: o[0],
                            y: o[1]
                        }), [
                            ...t1,
                            ...l
                        ];
                    }, []);
                    performance.mark("finish getting rooms, cameras, svg paths ..."), performance.measure("getting rooms, cameras, svg paths ...", "start getting rooms, cameras, svg paths ...", "finish getting rooms, cameras, svg paths ...");
                    const [d, p] = o ? [
                        o.Location.X,
                        o.Location.Y
                    ] : function(t1) {
                        let e = 0, i = 0, n = t1.length;
                        for(let r = 0; r < n; r++){
                            const n = t1[r];
                            e += n[0], i += n[1];
                        }
                        return [
                            e / n,
                            i / n
                        ];
                    }(u), A = -1 * Tx((null === (s = o.Rotation) || void 0 === s ? void 0 : s.Yaw) || 0), f = {
                        svgPathActions: [],
                        roomPanoramas: [],
                        rotation: 0,
                        points: [],
                        left: 0,
                        top: 0,
                        ...i,
                        cameraData: o || null,
                        roomPanoramas: c,
                        svgPathActions: h,
                        rotation: A,
                        points: u,
                        left: d,
                        top: p
                    }, m = this.createPanorama(f);
                    return n && n.ID === o.ID ? (e.unshift(m), e) : n || l.ID !== Un.initialPanoramaRoomId ? (e.push(m), e) : (e.unshift(m), e);
                }, []);
            }
            createPanoramas(t1, e) {
                this.items = t1, this.type = e, performance.mark("start create panorama's data");
                const i = this.getCreatedPanoramas();
                return performance.mark("finish create panorama's data"), performance.measure("creating panorama's data", "start create panorama's data", "finish create panorama's data"), i.forEach((t1, e)=>{
                    t1.userData.panorama_index = e, Un.config.json && t1.createLinks(i);
                }), i;
            }
            createPanorama(t1) {
                const e = "cube" === this.type ? new B_(t1) : new U_(t1);
                return e.addEventListener("materialcreate", ()=>{
                    ((t1, e)=>{
                        var i, n, r;
                        const { currentFloorIndex: a } = Un, s = null == t1 || null === (i = t1.Floors) || void 0 === i || null === (i = i[a]) || void 0 === i ? void 0 : i.CameraPoints;
                        if (!s) return void console.warn("Panorama cache: can't get floor cameras!");
                        const o = null === (n = Un.configParams.floors) || void 0 === n || null === (n = n[a]) || void 0 === n || null === (n = n.panorama) || void 0 === n ? void 0 : n.items;
                        if (!o) return void console.warn("Panorama cache: can't get panorama images data!");
                        let l = null;
                        const c = [];
                        if (s.forEach((t1)=>{
                            var i;
                            if (t1.ID === e) return void (l = t1);
                            const n = null === (i = o.find((e)=>e.camera_id === t1.ID)) || void 0 === i ? void 0 : i.images;
                            n && c.push({
                                id: t1.ID,
                                images: n.sphere ? [
                                    n.sphere
                                ] : [
                                    n.front,
                                    n.back,
                                    n.left,
                                    n.right,
                                    n.top,
                                    n.bottom
                                ],
                                location: t1.Location
                            });
                        }), !l) return;
                        const u = null !== (r = Un.config.preloadPerPanoramaCount) && void 0 !== r ? r : 3;
                        c.length > u && c.sort((t1, e)=>{
                            if (Un.config.forcePreloadNonCached) {
                                const i = Number(t1.images.every((t1)=>By.isCached(t1))), n = Number(e.images.every((t1)=>By.isCached(t1)));
                                if (i || n) return i - n;
                            }
                            return Nx(t1.location, l.Location) - Nx(e.location, l.Location);
                        });
                        const h = Math.min(u, c.length);
                        for(let t1 = 0; t1 < h; t1++)c[t1].images.forEach((t1)=>{
                            By.cache(t1);
                        });
                    })(Un.config.json, e.panoramaId);
                }), e.visible = !1, this.add(e), e;
            }
        };
        const H_ = class extends Qp {
            constructor(){
                var t1, e, i;
                super({
                    preserveDrawingBuffer: !0,
                    antialias: !0,
                    alpha: !0
                }), t1 = this, i = void 0, (e = function(t1) {
                    var e = function(t1) {
                        if ("object" != typeof t1 || !t1) return t1;
                        var e = t1[Symbol.toPrimitive];
                        if (void 0 !== e) {
                            var i = e.call(t1, "string");
                            if ("object" != typeof i) return i;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(t1);
                    }(t1);
                    return "symbol" == typeof e ? e : e + "";
                }(e = "currentVrSession")) in t1 ? Object.defineProperty(t1, e, {
                    value: i,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t1[e] = i, this.toneMapping = Zr, this.toneMappingExposure = 1, this.setPixelRatio(window.devicePixelRatio), this.setClearColor(new Yc(0), 0), this.setClearAlpha(1), this.xr.setReferenceSpaceType("local"), this.xr.enabled = !0;
            }
            async checkVrSessionSupport() {
                try {
                    return await navigator.xr.isSessionSupported("immersive-vr");
                } catch (t1) {
                    return !1;
                }
            }
            async onSessionStarted(t1) {
                t1.addEventListener("end", this.onSessionEnded.bind(this)), await this.xr.setSession(t1), this.xr.setFoveation(0), this.currentVrSession = t1;
            }
            onSessionEnded() {
                this.currentVrSession.removeEventListener("end", this.onSessionEnded.bind(this)), this.currentVrSession = null;
            }
            async enterVR() {
                return await navigator.xr.requestSession("immersive-vr", {
                    optionalFeatures: [
                        "local-floor",
                        "bounded-floor",
                        "hand-tracking",
                        "layers"
                    ]
                }).then(this.onSessionStarted.bind(this));
            }
            async exitVR() {
                if (this.currentVrSession) return await this.xr.getSession().end();
            }
        };
        function V_(t1, e, i) {
            return (e = function(t1) {
                var e = function(t1) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var e = t1[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e)) in t1 ? Object.defineProperty(t1, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = i, t1;
        }
        const G_ = class {
            constructor(t1, e){
                V_(this, "deviceOrientation", {}), V_(this, "screenOrientation", 0), V_(this, "alphaOffsetAngle", 0), V_(this, "connected", !1), V_(this, "enabled", !1), V_(this, "domElement", void 0), V_(this, "alpha", 0), V_(this, "tempX", 0), V_(this, "tempY", 0), V_(this, "rotY", 0), V_(this, "rotX", 0), V_(this, "camera", void 0), this.camera = t1, this.camera.rotation.reorder("YXZ"), this.domElement = e || document;
            }
            enable() {
                this.enabled = !0;
            }
            disable() {
                this.enabled = !1;
            }
            connect() {
                this.onScreenOrientationChange(), window.addEventListener("orientationchange", this.onScreenOrientationChange.bind(this)), window.addEventListener("deviceorientation", this.onDeviceOrientationChange.bind(this)), window.addEventListener("deviceorientation", this.update.bind(this)), this.domElement.addEventListener("touchstart", this.onTouchStart.bind(this)), this.domElement.addEventListener("touchmove", this.onTouchMove.bind(this)), this.connected = !0;
            }
            disconnect() {
                window.removeEventListener("orientationchange", this.onScreenOrientationChange.bind(this)), window.removeEventListener("deviceorientation", this.onDeviceOrientationChange.bind(this)), window.removeEventListener("deviceorientation", this.update.bind(this)), this.domElement.removeEventListener("touchstart", this.onTouchStart), this.domElement.removeEventListener("touchmove", this.onTouchMove), this.connected = !1;
            }
            onDeviceOrientationChange(t1) {
                this.deviceOrientation = t1;
            }
            onScreenOrientationChange() {
                this.screenOrientation = window.orientation || 0;
            }
            onTouchStart(t1) {
                t1.preventDefault(), t1.stopPropagation(), this.tempX = t1.touches[0].pageX, this.tempY = t1.touches[0].pageY;
            }
            onTouchMove(t1) {
                t1.preventDefault(), t1.stopPropagation(), this.rotY += Tx((t1.touches[0].pageX - this.tempX) / 4), this.rotX += Tx((this.tempY - t1.touches[0].pageY) / 4), this.updateAlphaOffsetAngle(this.rotY), this.tempX = t1.touches[0].pageX, this.tempY = t1.touches[0].pageY;
            }
            setCameraQuaternion(t1, e, i, n, r) {
                const a = new Nl(0, 0, 1), s = new fc, o = new Sl, l = new Sl(-Math.sqrt(.5), 0, 0, Math.sqrt(.5)), c = new Sl, u = new Sl;
                let h = null;
                0 === this.screenOrientation ? (h = new Nl(1, 0, 0), c.setFromAxisAngle(h, -this.rotX)) : 180 === this.screenOrientation ? (h = new Nl(1, 0, 0), c.setFromAxisAngle(h, this.rotX)) : 90 === this.screenOrientation ? (h = new Nl(0, 1, 0), c.setFromAxisAngle(h, this.rotX)) : -90 === this.screenOrientation && (h = new Nl(0, 1, 0), c.setFromAxisAngle(h, -this.rotX)), l.multiply(c), l.multiply(u), s.set(i, e, -n, "YXZ"), t1.setFromEuler(s), t1.multiply(l), t1.multiply(o.setFromAxisAngle(a, -r));
            }
            updateAlphaOffsetAngle(t1) {
                this.alphaOffsetAngle = t1, this.update();
            }
            update() {
                if (!1 === this.enabled) return;
                const t1 = this.deviceOrientation.alpha ? Tx(this.deviceOrientation.alpha + 90) + this.alphaOffsetAngle : 0, e = this.deviceOrientation.beta ? Tx(this.deviceOrientation.beta) : 0, i = this.deviceOrientation.gamma ? Tx(this.deviceOrientation.gamma) : 0, n = this.screenOrientation ? Tx(this.screenOrientation) : 0;
                this.setCameraQuaternion(this.camera.quaternion, t1, e, i, n), this.alpha = t1;
            }
            dispose() {
                this.disconnect();
            }
        }, W_ = Object.freeze({
            NONE: 0,
            ROTATE: 1,
            TRUCK: 2,
            OFFSET: 4,
            DOLLY: 8,
            ZOOM: 16,
            TOUCH_ROTATE: 32,
            TOUCH_TRUCK: 64,
            TOUCH_OFFSET: 128,
            TOUCH_DOLLY: 256,
            TOUCH_ZOOM: 512,
            TOUCH_DOLLY_TRUCK: 1024,
            TOUCH_DOLLY_OFFSET: 2048,
            TOUCH_DOLLY_ROTATE: 4096,
            TOUCH_ZOOM_TRUCK: 8192,
            TOUCH_ZOOM_OFFSET: 16384,
            TOUCH_ZOOM_ROTATE: 32768
        });
        function Y_(t1) {
            return t1.isPerspectiveCamera;
        }
        function X_(t1) {
            return t1.isOrthographicCamera;
        }
        const Z_ = 2 * Math.PI, q_ = Math.PI / 2, J_ = 1e-5, K_ = Math.PI / 180;
        function $_(t1, e, i) {
            return Math.max(e, Math.min(i, t1));
        }
        function tI(t1, e = J_) {
            return Math.abs(t1) < e;
        }
        function eI(t1, e, i = J_) {
            return tI(t1 - e, i);
        }
        function iI(t1, e) {
            return Math.round(t1 / e) * e;
        }
        function nI(t1) {
            return isFinite(t1) ? t1 : t1 < 0 ? -Number.MAX_VALUE : Number.MAX_VALUE;
        }
        function rI(t1) {
            return Math.abs(t1) < Number.MAX_VALUE ? t1 : t1 * (1 / 0);
        }
        function aI(t1, e, i, n, r = 1 / 0, a) {
            const s = 2 / (n = Math.max(1e-4, n)), o = s * a, l = 1 / (1 + o + .48 * o * o + .235 * o * o * o);
            let c = t1 - e;
            const u = e, h = r * n;
            c = $_(c, -h, h), e = t1 - c;
            const d = (i.value + s * c) * a;
            i.value = (i.value - s * d) * l;
            let p = e + (c + d) * l;
            return u - t1 > 0 == p > u && (p = u, i.value = (p - u) / a), p;
        }
        function sI(t1, e, i, n, r = 1 / 0, a, s) {
            const o = 2 / (n = Math.max(1e-4, n)), l = o * a, c = 1 / (1 + l + .48 * l * l + .235 * l * l * l);
            let u = e.x, h = e.y, d = e.z, p = t1.x - u, A = t1.y - h, f = t1.z - d;
            const m = u, g = h, M = d, v = r * n, y = p * p + A * A + f * f;
            if (y > v * v) {
                const t1 = Math.sqrt(y);
                p = p / t1 * v, A = A / t1 * v, f = f / t1 * v;
            }
            u = t1.x - p, h = t1.y - A, d = t1.z - f;
            const x = (i.x + o * p) * a, w = (i.y + o * A) * a, b = (i.z + o * f) * a;
            i.x = (i.x - o * x) * c, i.y = (i.y - o * w) * c, i.z = (i.z - o * b) * c, s.x = u + (p + x) * c, s.y = h + (A + w) * c, s.z = d + (f + b) * c;
            const T = m - t1.x, E = g - t1.y, _ = M - t1.z;
            return T * (s.x - m) + E * (s.y - g) + _ * (s.z - M) > 0 && (s.x = m, s.y = g, s.z = M, i.x = (s.x - m) / a, i.y = (s.y - g) / a, i.z = (s.z - M) / a), s;
        }
        function oI(t1, e) {
            e.set(0, 0), t1.forEach((t1)=>{
                e.x += t1.clientX, e.y += t1.clientY;
            }), e.x /= t1.length, e.y /= t1.length;
        }
        function lI(t1, e) {
            return !!X_(t1) && (console.warn(`${e} is not supported in OrthographicCamera`), !0);
        }
        class cI {
            constructor(){
                this._listeners = {};
            }
            addEventListener(t1, e) {
                const i = this._listeners;
                void 0 === i[t1] && (i[t1] = []), -1 === i[t1].indexOf(e) && i[t1].push(e);
            }
            hasEventListener(t1, e) {
                const i = this._listeners;
                return void 0 !== i[t1] && -1 !== i[t1].indexOf(e);
            }
            removeEventListener(t1, e) {
                const i = this._listeners[t1];
                if (void 0 !== i) {
                    const t1 = i.indexOf(e);
                    -1 !== t1 && i.splice(t1, 1);
                }
            }
            removeAllEventListeners(t1) {
                t1 ? Array.isArray(this._listeners[t1]) && (this._listeners[t1].length = 0) : this._listeners = {};
            }
            dispatchEvent(t1) {
                const e = this._listeners[t1.type];
                if (void 0 !== e) {
                    t1.target = this;
                    const i = e.slice(0);
                    for(let e = 0, n = i.length; e < n; e++)i[e].call(this, t1);
                }
            }
        }
        var uI;
        const hI = 1 / 8, dI = /Mac/.test(null === (uI = null === globalThis || void 0 === globalThis ? void 0 : globalThis.navigator) || void 0 === uI ? void 0 : uI.platform);
        let pI, AI, fI, mI, gI, MI, vI, yI, xI, wI, bI, TI, EI, _I, II, SI, NI, DI, CI, zI, LI, OI, PI;
        class jI extends cI {
            static install(t1) {
                pI = t1.THREE, AI = Object.freeze(new pI.Vector3(0, 0, 0)), fI = Object.freeze(new pI.Vector3(0, 1, 0)), mI = Object.freeze(new pI.Vector3(0, 0, 1)), gI = new pI.Vector2, MI = new pI.Vector3, vI = new pI.Vector3, yI = new pI.Vector3, xI = new pI.Vector3, wI = new pI.Vector3, bI = new pI.Vector3, TI = new pI.Vector3, EI = new pI.Vector3, _I = new pI.Vector3, II = new pI.Spherical, SI = new pI.Spherical, NI = new pI.Box3, DI = new pI.Box3, CI = new pI.Sphere, zI = new pI.Quaternion, LI = new pI.Quaternion, OI = new pI.Matrix4, PI = new pI.Raycaster;
            }
            static get ACTION() {
                return W_;
            }
            constructor(t1, e){
                super(), this.minPolarAngle = 0, this.maxPolarAngle = Math.PI, this.minAzimuthAngle = -1 / 0, this.maxAzimuthAngle = 1 / 0, this.minDistance = Number.EPSILON, this.maxDistance = 1 / 0, this.infinityDolly = !1, this.minZoom = .01, this.maxZoom = 1 / 0, this.smoothTime = .25, this.draggingSmoothTime = .125, this.maxSpeed = 1 / 0, this.azimuthRotateSpeed = 1, this.polarRotateSpeed = 1, this.dollySpeed = 1, this.dollyDragInverted = !1, this.truckSpeed = 2, this.dollyToCursor = !1, this.dragToOffset = !1, this.verticalDragToForward = !1, this.boundaryFriction = 0, this.restThreshold = .01, this.colliderMeshes = [], this.cancel = ()=>{}, this._enabled = !0, this._state = W_.NONE, this._viewport = null, this._changedDolly = 0, this._changedZoom = 0, this._hasRested = !0, this._boundaryEnclosesCamera = !1, this._needsUpdate = !0, this._updatedLastTime = !1, this._elementRect = new DOMRect, this._isDragging = !1, this._dragNeedsUpdate = !0, this._activePointers = [], this._lockedPointer = null, this._interactiveArea = new DOMRect(0, 0, 1, 1), this._isUserControllingRotate = !1, this._isUserControllingDolly = !1, this._isUserControllingTruck = !1, this._isUserControllingOffset = !1, this._isUserControllingZoom = !1, this._lastDollyDirection = 0, this._thetaVelocity = {
                    value: 0
                }, this._phiVelocity = {
                    value: 0
                }, this._radiusVelocity = {
                    value: 0
                }, this._targetVelocity = new pI.Vector3, this._focalOffsetVelocity = new pI.Vector3, this._zoomVelocity = {
                    value: 0
                }, this._truckInternal = (t1, e, i)=>{
                    let n, r;
                    if (Y_(this._camera)) {
                        const i = MI.copy(this._camera.position).sub(this._target), a = this._camera.getEffectiveFOV() * K_, s = i.length() * Math.tan(.5 * a);
                        n = this.truckSpeed * t1 * s / this._elementRect.height, r = this.truckSpeed * e * s / this._elementRect.height;
                    } else {
                        if (!X_(this._camera)) return;
                        {
                            const i = this._camera;
                            n = t1 * (i.right - i.left) / i.zoom / this._elementRect.width, r = e * (i.top - i.bottom) / i.zoom / this._elementRect.height;
                        }
                    }
                    this.verticalDragToForward ? (i ? this.setFocalOffset(this._focalOffsetEnd.x + n, this._focalOffsetEnd.y, this._focalOffsetEnd.z, !0) : this.truck(n, 0, !0), this.forward(-r, !0)) : i ? this.setFocalOffset(this._focalOffsetEnd.x + n, this._focalOffsetEnd.y + r, this._focalOffsetEnd.z, !0) : this.truck(n, r, !0);
                }, this._rotateInternal = (t1, e)=>{
                    const i = Z_ * this.azimuthRotateSpeed * t1 / this._elementRect.height, n = Z_ * this.polarRotateSpeed * e / this._elementRect.height;
                    this.rotate(i, n, !0);
                }, this._dollyInternal = (t1, e, i)=>{
                    const n = Math.pow(.95, -t1 * this.dollySpeed), r = this._sphericalEnd.radius, a = this._sphericalEnd.radius * n, s = $_(a, this.minDistance, this.maxDistance), o = s - a;
                    this.infinityDolly && this.dollyToCursor ? this._dollyToNoClamp(a, !0) : this.infinityDolly && !this.dollyToCursor ? (this.dollyInFixed(o, !0), this._dollyToNoClamp(s, !0)) : this._dollyToNoClamp(s, !0), this.dollyToCursor && (this._changedDolly += (this.infinityDolly ? a : s) - r, this._dollyControlCoord.set(e, i)), this._lastDollyDirection = Math.sign(-t1);
                }, this._zoomInternal = (t1, e, i)=>{
                    const n = Math.pow(.95, t1 * this.dollySpeed), r = this._zoom, a = this._zoom * n;
                    this.zoomTo(a, !0), this.dollyToCursor && (this._changedZoom += a - r, this._dollyControlCoord.set(e, i));
                }, void 0 === pI && console.error("camera-controls: `THREE` is undefined. You must first run `CameraControls.install( { THREE: THREE } )`. Check the docs for further information."), this._camera = t1, this._yAxisUpSpace = (new pI.Quaternion).setFromUnitVectors(this._camera.up, fI), this._yAxisUpSpaceInverse = this._yAxisUpSpace.clone().invert(), this._state = W_.NONE, this._target = new pI.Vector3, this._targetEnd = this._target.clone(), this._focalOffset = new pI.Vector3, this._focalOffsetEnd = this._focalOffset.clone(), this._spherical = (new pI.Spherical).setFromVector3(MI.copy(this._camera.position).applyQuaternion(this._yAxisUpSpace)), this._sphericalEnd = this._spherical.clone(), this._lastDistance = this._spherical.radius, this._zoom = this._camera.zoom, this._zoomEnd = this._zoom, this._lastZoom = this._zoom, this._nearPlaneCorners = [
                    new pI.Vector3,
                    new pI.Vector3,
                    new pI.Vector3,
                    new pI.Vector3
                ], this._updateNearPlaneCorners(), this._boundary = new pI.Box3(new pI.Vector3(-1 / 0, -1 / 0, -1 / 0), new pI.Vector3(1 / 0, 1 / 0, 1 / 0)), this._cameraUp0 = this._camera.up.clone(), this._target0 = this._target.clone(), this._position0 = this._camera.position.clone(), this._zoom0 = this._zoom, this._focalOffset0 = this._focalOffset.clone(), this._dollyControlCoord = new pI.Vector2, this.mouseButtons = {
                    left: W_.ROTATE,
                    middle: W_.DOLLY,
                    right: W_.TRUCK,
                    wheel: Y_(this._camera) ? W_.DOLLY : X_(this._camera) ? W_.ZOOM : W_.NONE
                }, this.touches = {
                    one: W_.TOUCH_ROTATE,
                    two: Y_(this._camera) ? W_.TOUCH_DOLLY_TRUCK : X_(this._camera) ? W_.TOUCH_ZOOM_TRUCK : W_.NONE,
                    three: W_.TOUCH_TRUCK
                };
                const i = new pI.Vector2, n = new pI.Vector2, r = new pI.Vector2, a = (t1)=>{
                    if (!this._enabled || !this._domElement) return;
                    if (0 !== this._interactiveArea.left || 0 !== this._interactiveArea.top || 1 !== this._interactiveArea.width || 1 !== this._interactiveArea.height) {
                        const e = this._domElement.getBoundingClientRect(), i = t1.clientX / e.width, n = t1.clientY / e.height;
                        if (i < this._interactiveArea.left || i > this._interactiveArea.right || n < this._interactiveArea.top || n > this._interactiveArea.bottom) return;
                    }
                    const e = "mouse" !== t1.pointerType ? null : 1 & ~t1.buttons ? 4 & ~t1.buttons ? 2 & ~t1.buttons ? null : 2 : 4 : 1;
                    if (null !== e) {
                        const t1 = this._findPointerByMouseButton(e);
                        t1 && this._disposePointer(t1);
                    }
                    if (!(1 & ~t1.buttons) && this._lockedPointer) return;
                    const i = {
                        pointerId: t1.pointerId,
                        clientX: t1.clientX,
                        clientY: t1.clientY,
                        deltaX: 0,
                        deltaY: 0,
                        mouseButton: e
                    };
                    this._activePointers.push(i), this._domElement.ownerDocument.removeEventListener("pointermove", s, {
                        passive: !1
                    }), this._domElement.ownerDocument.removeEventListener("pointerup", o), this._domElement.ownerDocument.addEventListener("pointermove", s, {
                        passive: !1
                    }), this._domElement.ownerDocument.addEventListener("pointerup", o), this._isDragging = !0, h(t1);
                }, s = (t1)=>{
                    t1.cancelable && t1.preventDefault();
                    const e = t1.pointerId, i = this._lockedPointer || this._findPointerById(e);
                    if (i) {
                        if (i.clientX = t1.clientX, i.clientY = t1.clientY, i.deltaX = t1.movementX, i.deltaY = t1.movementY, this._state = 0, "touch" === t1.pointerType) switch(this._activePointers.length){
                            case 1:
                                this._state = this.touches.one;
                                break;
                            case 2:
                                this._state = this.touches.two;
                                break;
                            case 3:
                                this._state = this.touches.three;
                        }
                        else (!this._isDragging && this._lockedPointer || this._isDragging && !(1 & ~t1.buttons)) && (this._state = this._state | this.mouseButtons.left), this._isDragging && !(4 & ~t1.buttons) && (this._state = this._state | this.mouseButtons.middle), this._isDragging && !(2 & ~t1.buttons) && (this._state = this._state | this.mouseButtons.right);
                        d();
                    }
                }, o = (t1)=>{
                    const e = this._findPointerById(t1.pointerId);
                    if (!e || e !== this._lockedPointer) {
                        if (e && this._disposePointer(e), "touch" === t1.pointerType) switch(this._activePointers.length){
                            case 0:
                                this._state = W_.NONE;
                                break;
                            case 1:
                                this._state = this.touches.one;
                                break;
                            case 2:
                                this._state = this.touches.two;
                                break;
                            case 3:
                                this._state = this.touches.three;
                        }
                        else this._state = W_.NONE;
                        p();
                    }
                };
                let l = -1;
                const c = (t1)=>{
                    if (!this._domElement) return;
                    if (!this._enabled || this.mouseButtons.wheel === W_.NONE) return;
                    if (0 !== this._interactiveArea.left || 0 !== this._interactiveArea.top || 1 !== this._interactiveArea.width || 1 !== this._interactiveArea.height) {
                        const e = this._domElement.getBoundingClientRect(), i = t1.clientX / e.width, n = t1.clientY / e.height;
                        if (i < this._interactiveArea.left || i > this._interactiveArea.right || n < this._interactiveArea.top || n > this._interactiveArea.bottom) return;
                    }
                    if (t1.preventDefault(), this.dollyToCursor || this.mouseButtons.wheel === W_.ROTATE || this.mouseButtons.wheel === W_.TRUCK) {
                        const t1 = performance.now();
                        l - t1 < 1e3 && this._getClientRect(this._elementRect), l = t1;
                    }
                    const e = dI ? -1 : -3, i = 1 === t1.deltaMode ? t1.deltaY / e : t1.deltaY / (10 * e), n = this.dollyToCursor ? (t1.clientX - this._elementRect.x) / this._elementRect.width * 2 - 1 : 0, r = this.dollyToCursor ? (t1.clientY - this._elementRect.y) / this._elementRect.height * -2 + 1 : 0;
                    switch(this.mouseButtons.wheel){
                        case W_.ROTATE:
                            this._rotateInternal(t1.deltaX, t1.deltaY), this._isUserControllingRotate = !0;
                            break;
                        case W_.TRUCK:
                            this._truckInternal(t1.deltaX, t1.deltaY, !1), this._isUserControllingTruck = !0;
                            break;
                        case W_.OFFSET:
                            this._truckInternal(t1.deltaX, t1.deltaY, !0), this._isUserControllingOffset = !0;
                            break;
                        case W_.DOLLY:
                            this._dollyInternal(-i, n, r), this._isUserControllingDolly = !0;
                            break;
                        case W_.ZOOM:
                            this._zoomInternal(-i, n, r), this._isUserControllingZoom = !0;
                    }
                    this.dispatchEvent({
                        type: "control"
                    });
                }, u = (t1)=>{
                    if (this._domElement && this._enabled) {
                        if (this.mouseButtons.right === jI.ACTION.NONE) {
                            const e = t1 instanceof PointerEvent ? t1.pointerId : 0, i = this._findPointerById(e);
                            return i && this._disposePointer(i), this._domElement.ownerDocument.removeEventListener("pointermove", s, {
                                passive: !1
                            }), void this._domElement.ownerDocument.removeEventListener("pointerup", o);
                        }
                        t1.preventDefault();
                    }
                }, h = (t1)=>{
                    if (this._enabled) {
                        if (oI(this._activePointers, gI), this._getClientRect(this._elementRect), i.copy(gI), n.copy(gI), this._activePointers.length >= 2) {
                            const t1 = gI.x - this._activePointers[1].clientX, e = gI.y - this._activePointers[1].clientY, i = Math.sqrt(t1 * t1 + e * e);
                            r.set(0, i);
                            const a = .5 * (this._activePointers[0].clientX + this._activePointers[1].clientX), s = .5 * (this._activePointers[0].clientY + this._activePointers[1].clientY);
                            n.set(a, s);
                        }
                        if (this._state = 0, t1) {
                            if ("pointerType" in t1 && "touch" === t1.pointerType) switch(this._activePointers.length){
                                case 1:
                                    this._state = this.touches.one;
                                    break;
                                case 2:
                                    this._state = this.touches.two;
                                    break;
                                case 3:
                                    this._state = this.touches.three;
                            }
                            else this._lockedPointer || !!(1 & ~t1.buttons) || (this._state = this._state | this.mouseButtons.left), !(4 & ~t1.buttons) && (this._state = this._state | this.mouseButtons.middle), !(2 & ~t1.buttons) && (this._state = this._state | this.mouseButtons.right);
                        } else this._lockedPointer && (this._state = this._state | this.mouseButtons.left);
                        (this._state & W_.ROTATE) !== W_.ROTATE && (this._state & W_.TOUCH_ROTATE) !== W_.TOUCH_ROTATE && (this._state & W_.TOUCH_DOLLY_ROTATE) !== W_.TOUCH_DOLLY_ROTATE && (this._state & W_.TOUCH_ZOOM_ROTATE) !== W_.TOUCH_ZOOM_ROTATE || (this._sphericalEnd.theta = this._spherical.theta, this._sphericalEnd.phi = this._spherical.phi, this._thetaVelocity.value = 0, this._phiVelocity.value = 0), (this._state & W_.TRUCK) !== W_.TRUCK && (this._state & W_.TOUCH_TRUCK) !== W_.TOUCH_TRUCK && (this._state & W_.TOUCH_DOLLY_TRUCK) !== W_.TOUCH_DOLLY_TRUCK && (this._state & W_.TOUCH_ZOOM_TRUCK) !== W_.TOUCH_ZOOM_TRUCK || (this._targetEnd.copy(this._target), this._targetVelocity.set(0, 0, 0)), (this._state & W_.DOLLY) !== W_.DOLLY && (this._state & W_.TOUCH_DOLLY) !== W_.TOUCH_DOLLY && (this._state & W_.TOUCH_DOLLY_TRUCK) !== W_.TOUCH_DOLLY_TRUCK && (this._state & W_.TOUCH_DOLLY_OFFSET) !== W_.TOUCH_DOLLY_OFFSET && (this._state & W_.TOUCH_DOLLY_ROTATE) !== W_.TOUCH_DOLLY_ROTATE || (this._sphericalEnd.radius = this._spherical.radius, this._radiusVelocity.value = 0), (this._state & W_.ZOOM) !== W_.ZOOM && (this._state & W_.TOUCH_ZOOM) !== W_.TOUCH_ZOOM && (this._state & W_.TOUCH_ZOOM_TRUCK) !== W_.TOUCH_ZOOM_TRUCK && (this._state & W_.TOUCH_ZOOM_OFFSET) !== W_.TOUCH_ZOOM_OFFSET && (this._state & W_.TOUCH_ZOOM_ROTATE) !== W_.TOUCH_ZOOM_ROTATE || (this._zoomEnd = this._zoom, this._zoomVelocity.value = 0), (this._state & W_.OFFSET) !== W_.OFFSET && (this._state & W_.TOUCH_OFFSET) !== W_.TOUCH_OFFSET && (this._state & W_.TOUCH_DOLLY_OFFSET) !== W_.TOUCH_DOLLY_OFFSET && (this._state & W_.TOUCH_ZOOM_OFFSET) !== W_.TOUCH_ZOOM_OFFSET || (this._focalOffsetEnd.copy(this._focalOffset), this._focalOffsetVelocity.set(0, 0, 0)), this.dispatchEvent({
                            type: "controlstart"
                        });
                    }
                }, d = ()=>{
                    if (!this._enabled || !this._dragNeedsUpdate) return;
                    this._dragNeedsUpdate = !1, oI(this._activePointers, gI);
                    const t1 = this._domElement && this._domElement.ownerDocument.pointerLockElement === this._domElement ? this._lockedPointer || this._activePointers[0] : null, e = t1 ? -t1.deltaX : n.x - gI.x, a = t1 ? -t1.deltaY : n.y - gI.y;
                    if (n.copy(gI), (this._state & W_.ROTATE) !== W_.ROTATE && (this._state & W_.TOUCH_ROTATE) !== W_.TOUCH_ROTATE && (this._state & W_.TOUCH_DOLLY_ROTATE) !== W_.TOUCH_DOLLY_ROTATE && (this._state & W_.TOUCH_ZOOM_ROTATE) !== W_.TOUCH_ZOOM_ROTATE || (this._rotateInternal(e, a), this._isUserControllingRotate = !0), (this._state & W_.DOLLY) === W_.DOLLY || (this._state & W_.ZOOM) === W_.ZOOM) {
                        const t1 = this.dollyToCursor ? (i.x - this._elementRect.x) / this._elementRect.width * 2 - 1 : 0, e = this.dollyToCursor ? (i.y - this._elementRect.y) / this._elementRect.height * -2 + 1 : 0, n = this.dollyDragInverted ? -1 : 1;
                        (this._state & W_.DOLLY) === W_.DOLLY ? (this._dollyInternal(n * a * hI, t1, e), this._isUserControllingDolly = !0) : (this._zoomInternal(n * a * hI, t1, e), this._isUserControllingZoom = !0);
                    }
                    if ((this._state & W_.TOUCH_DOLLY) === W_.TOUCH_DOLLY || (this._state & W_.TOUCH_ZOOM) === W_.TOUCH_ZOOM || (this._state & W_.TOUCH_DOLLY_TRUCK) === W_.TOUCH_DOLLY_TRUCK || (this._state & W_.TOUCH_ZOOM_TRUCK) === W_.TOUCH_ZOOM_TRUCK || (this._state & W_.TOUCH_DOLLY_OFFSET) === W_.TOUCH_DOLLY_OFFSET || (this._state & W_.TOUCH_ZOOM_OFFSET) === W_.TOUCH_ZOOM_OFFSET || (this._state & W_.TOUCH_DOLLY_ROTATE) === W_.TOUCH_DOLLY_ROTATE || (this._state & W_.TOUCH_ZOOM_ROTATE) === W_.TOUCH_ZOOM_ROTATE) {
                        const t1 = gI.x - this._activePointers[1].clientX, e = gI.y - this._activePointers[1].clientY, i = Math.sqrt(t1 * t1 + e * e), a = r.y - i;
                        r.set(0, i);
                        const s = this.dollyToCursor ? (n.x - this._elementRect.x) / this._elementRect.width * 2 - 1 : 0, o = this.dollyToCursor ? (n.y - this._elementRect.y) / this._elementRect.height * -2 + 1 : 0;
                        (this._state & W_.TOUCH_DOLLY) === W_.TOUCH_DOLLY || (this._state & W_.TOUCH_DOLLY_ROTATE) === W_.TOUCH_DOLLY_ROTATE || (this._state & W_.TOUCH_DOLLY_TRUCK) === W_.TOUCH_DOLLY_TRUCK || (this._state & W_.TOUCH_DOLLY_OFFSET) === W_.TOUCH_DOLLY_OFFSET ? (this._dollyInternal(a * hI, s, o), this._isUserControllingDolly = !0) : (this._zoomInternal(a * hI, s, o), this._isUserControllingZoom = !0);
                    }
                    (this._state & W_.TRUCK) !== W_.TRUCK && (this._state & W_.TOUCH_TRUCK) !== W_.TOUCH_TRUCK && (this._state & W_.TOUCH_DOLLY_TRUCK) !== W_.TOUCH_DOLLY_TRUCK && (this._state & W_.TOUCH_ZOOM_TRUCK) !== W_.TOUCH_ZOOM_TRUCK || (this._truckInternal(e, a, !1), this._isUserControllingTruck = !0), (this._state & W_.OFFSET) !== W_.OFFSET && (this._state & W_.TOUCH_OFFSET) !== W_.TOUCH_OFFSET && (this._state & W_.TOUCH_DOLLY_OFFSET) !== W_.TOUCH_DOLLY_OFFSET && (this._state & W_.TOUCH_ZOOM_OFFSET) !== W_.TOUCH_ZOOM_OFFSET || (this._truckInternal(e, a, !0), this._isUserControllingOffset = !0), this.dispatchEvent({
                        type: "control"
                    });
                }, p = ()=>{
                    oI(this._activePointers, gI), n.copy(gI), this._dragNeedsUpdate = !1, (0 === this._activePointers.length || 1 === this._activePointers.length && this._activePointers[0] === this._lockedPointer) && (this._isDragging = !1), 0 === this._activePointers.length && this._domElement && (this._domElement.ownerDocument.removeEventListener("pointermove", s, {
                        passive: !1
                    }), this._domElement.ownerDocument.removeEventListener("pointerup", o), this.dispatchEvent({
                        type: "controlend"
                    }));
                };
                this.lockPointer = ()=>{
                    this._enabled && this._domElement && (this.cancel(), this._lockedPointer = {
                        pointerId: -1,
                        clientX: 0,
                        clientY: 0,
                        deltaX: 0,
                        deltaY: 0,
                        mouseButton: null
                    }, this._activePointers.push(this._lockedPointer), this._domElement.ownerDocument.removeEventListener("pointermove", s, {
                        passive: !1
                    }), this._domElement.ownerDocument.removeEventListener("pointerup", o), this._domElement.requestPointerLock(), this._domElement.ownerDocument.addEventListener("pointerlockchange", A), this._domElement.ownerDocument.addEventListener("pointerlockerror", f), this._domElement.ownerDocument.addEventListener("pointermove", s, {
                        passive: !1
                    }), this._domElement.ownerDocument.addEventListener("pointerup", o), h());
                }, this.unlockPointer = ()=>{
                    var t1, e, i;
                    null !== this._lockedPointer && (this._disposePointer(this._lockedPointer), this._lockedPointer = null), null === (t1 = this._domElement) || void 0 === t1 || t1.ownerDocument.exitPointerLock(), null === (e = this._domElement) || void 0 === e || e.ownerDocument.removeEventListener("pointerlockchange", A), null === (i = this._domElement) || void 0 === i || i.ownerDocument.removeEventListener("pointerlockerror", f), this.cancel();
                };
                const A = ()=>{
                    this._domElement && this._domElement.ownerDocument.pointerLockElement === this._domElement || this.unlockPointer();
                }, f = ()=>{
                    this.unlockPointer();
                };
                this._addAllEventListeners = (t1)=>{
                    this._domElement = t1, this._domElement.style.touchAction = "none", this._domElement.style.userSelect = "none", this._domElement.style.webkitUserSelect = "none", this._domElement.addEventListener("pointerdown", a), this._domElement.addEventListener("pointercancel", o), this._domElement.addEventListener("wheel", c, {
                        passive: !1
                    }), this._domElement.addEventListener("contextmenu", u);
                }, this._removeAllEventListeners = ()=>{
                    this._domElement && (this._domElement.style.touchAction = "", this._domElement.style.userSelect = "", this._domElement.style.webkitUserSelect = "", this._domElement.removeEventListener("pointerdown", a), this._domElement.removeEventListener("pointercancel", o), this._domElement.removeEventListener("wheel", c, {
                        passive: !1
                    }), this._domElement.removeEventListener("contextmenu", u), this._domElement.ownerDocument.removeEventListener("pointermove", s, {
                        passive: !1
                    }), this._domElement.ownerDocument.removeEventListener("pointerup", o), this._domElement.ownerDocument.removeEventListener("pointerlockchange", A), this._domElement.ownerDocument.removeEventListener("pointerlockerror", f));
                }, this.cancel = ()=>{
                    this._state !== W_.NONE && (this._state = W_.NONE, this._activePointers.length = 0, p());
                }, e && this.connect(e), this.update(0);
            }
            get camera() {
                return this._camera;
            }
            set camera(t1) {
                this._camera = t1, this.updateCameraUp(), this._camera.updateProjectionMatrix(), this._updateNearPlaneCorners(), this._needsUpdate = !0;
            }
            get enabled() {
                return this._enabled;
            }
            set enabled(t1) {
                this._enabled = t1, this._domElement && (t1 ? (this._domElement.style.touchAction = "none", this._domElement.style.userSelect = "none", this._domElement.style.webkitUserSelect = "none") : (this.cancel(), this._domElement.style.touchAction = "", this._domElement.style.userSelect = "", this._domElement.style.webkitUserSelect = ""));
            }
            get active() {
                return !this._hasRested;
            }
            get currentAction() {
                return this._state;
            }
            get distance() {
                return this._spherical.radius;
            }
            set distance(t1) {
                this._spherical.radius === t1 && this._sphericalEnd.radius === t1 || (this._spherical.radius = t1, this._sphericalEnd.radius = t1, this._needsUpdate = !0);
            }
            get azimuthAngle() {
                return this._spherical.theta;
            }
            set azimuthAngle(t1) {
                this._spherical.theta === t1 && this._sphericalEnd.theta === t1 || (this._spherical.theta = t1, this._sphericalEnd.theta = t1, this._needsUpdate = !0);
            }
            get polarAngle() {
                return this._spherical.phi;
            }
            set polarAngle(t1) {
                this._spherical.phi === t1 && this._sphericalEnd.phi === t1 || (this._spherical.phi = t1, this._sphericalEnd.phi = t1, this._needsUpdate = !0);
            }
            get boundaryEnclosesCamera() {
                return this._boundaryEnclosesCamera;
            }
            set boundaryEnclosesCamera(t1) {
                this._boundaryEnclosesCamera = t1, this._needsUpdate = !0;
            }
            set interactiveArea(t1) {
                this._interactiveArea.width = $_(t1.width, 0, 1), this._interactiveArea.height = $_(t1.height, 0, 1), this._interactiveArea.x = $_(t1.x, 0, 1 - this._interactiveArea.width), this._interactiveArea.y = $_(t1.y, 0, 1 - this._interactiveArea.height);
            }
            addEventListener(t1, e) {
                super.addEventListener(t1, e);
            }
            removeEventListener(t1, e) {
                super.removeEventListener(t1, e);
            }
            rotate(t1, e, i = !1) {
                return this.rotateTo(this._sphericalEnd.theta + t1, this._sphericalEnd.phi + e, i);
            }
            rotateAzimuthTo(t1, e = !1) {
                return this.rotateTo(t1, this._sphericalEnd.phi, e);
            }
            rotatePolarTo(t1, e = !1) {
                return this.rotateTo(this._sphericalEnd.theta, t1, e);
            }
            rotateTo(t1, e, i = !1) {
                this._isUserControllingRotate = !1;
                const n = $_(t1, this.minAzimuthAngle, this.maxAzimuthAngle), r = $_(e, this.minPolarAngle, this.maxPolarAngle);
                this._sphericalEnd.theta = n, this._sphericalEnd.phi = r, this._sphericalEnd.makeSafe(), this._needsUpdate = !0, i || (this._spherical.theta = this._sphericalEnd.theta, this._spherical.phi = this._sphericalEnd.phi);
                const a = !i || eI(this._spherical.theta, this._sphericalEnd.theta, this.restThreshold) && eI(this._spherical.phi, this._sphericalEnd.phi, this.restThreshold);
                return this._createOnRestPromise(a);
            }
            dolly(t1, e = !1) {
                return this.dollyTo(this._sphericalEnd.radius - t1, e);
            }
            dollyTo(t1, e = !1) {
                return this._isUserControllingDolly = !1, this._lastDollyDirection = 0, this._changedDolly = 0, this._dollyToNoClamp($_(t1, this.minDistance, this.maxDistance), e);
            }
            _dollyToNoClamp(t1, e = !1) {
                const i = this._sphericalEnd.radius;
                if (this.colliderMeshes.length >= 1) {
                    const e = this._collisionTest(), n = eI(e, this._spherical.radius);
                    if (!(i > t1) && n) return Promise.resolve();
                    this._sphericalEnd.radius = Math.min(t1, e);
                } else this._sphericalEnd.radius = t1;
                this._needsUpdate = !0, e || (this._spherical.radius = this._sphericalEnd.radius);
                const n = !e || eI(this._spherical.radius, this._sphericalEnd.radius, this.restThreshold);
                return this._createOnRestPromise(n);
            }
            dollyInFixed(t1, e = !1) {
                this._targetEnd.add(this._getCameraDirection(xI).multiplyScalar(t1)), e || this._target.copy(this._targetEnd);
                const i = !e || eI(this._target.x, this._targetEnd.x, this.restThreshold) && eI(this._target.y, this._targetEnd.y, this.restThreshold) && eI(this._target.z, this._targetEnd.z, this.restThreshold);
                return this._createOnRestPromise(i);
            }
            zoom(t1, e = !1) {
                return this.zoomTo(this._zoomEnd + t1, e);
            }
            zoomTo(t1, e = !1) {
                this._isUserControllingZoom = !1, this._zoomEnd = $_(t1, this.minZoom, this.maxZoom), this._needsUpdate = !0, e || (this._zoom = this._zoomEnd);
                const i = !e || eI(this._zoom, this._zoomEnd, this.restThreshold);
                return this._changedZoom = 0, this._createOnRestPromise(i);
            }
            pan(t1, e, i = !1) {
                return console.warn("`pan` has been renamed to `truck`"), this.truck(t1, e, i);
            }
            truck(t1, e, i = !1) {
                this._camera.updateMatrix(), wI.setFromMatrixColumn(this._camera.matrix, 0), bI.setFromMatrixColumn(this._camera.matrix, 1), wI.multiplyScalar(t1), bI.multiplyScalar(-e);
                const n = MI.copy(wI).add(bI), r = vI.copy(this._targetEnd).add(n);
                return this.moveTo(r.x, r.y, r.z, i);
            }
            forward(t1, e = !1) {
                MI.setFromMatrixColumn(this._camera.matrix, 0), MI.crossVectors(this._camera.up, MI), MI.multiplyScalar(t1);
                const i = vI.copy(this._targetEnd).add(MI);
                return this.moveTo(i.x, i.y, i.z, e);
            }
            elevate(t1, e = !1) {
                return MI.copy(this._camera.up).multiplyScalar(t1), this.moveTo(this._targetEnd.x + MI.x, this._targetEnd.y + MI.y, this._targetEnd.z + MI.z, e);
            }
            moveTo(t1, e, i, n = !1) {
                this._isUserControllingTruck = !1;
                const r = MI.set(t1, e, i).sub(this._targetEnd);
                this._encloseToBoundary(this._targetEnd, r, this.boundaryFriction), this._needsUpdate = !0, n || this._target.copy(this._targetEnd);
                const a = !n || eI(this._target.x, this._targetEnd.x, this.restThreshold) && eI(this._target.y, this._targetEnd.y, this.restThreshold) && eI(this._target.z, this._targetEnd.z, this.restThreshold);
                return this._createOnRestPromise(a);
            }
            lookInDirectionOf(t1, e, i, n = !1) {
                const r = MI.set(t1, e, i).sub(this._targetEnd).normalize().multiplyScalar(-this._sphericalEnd.radius).add(this._targetEnd);
                return this.setPosition(r.x, r.y, r.z, n);
            }
            fitToBox(t1, e, { cover: i = !1, paddingLeft: n = 0, paddingRight: r = 0, paddingBottom: a = 0, paddingTop: s = 0 } = {}) {
                const o = [], l = t1.isBox3 ? NI.copy(t1) : NI.setFromObject(t1);
                l.isEmpty() && (console.warn("camera-controls: fitTo() cannot be used with an empty box. Aborting"), Promise.resolve());
                const c = iI(this._sphericalEnd.theta, q_), u = iI(this._sphericalEnd.phi, q_);
                o.push(this.rotateTo(c, u, e));
                const h = MI.setFromSpherical(this._sphericalEnd).normalize(), d = zI.setFromUnitVectors(h, mI), p = eI(Math.abs(h.y), 1);
                p && d.multiply(LI.setFromAxisAngle(fI, c)), d.multiply(this._yAxisUpSpaceInverse);
                const A = DI.makeEmpty();
                vI.copy(l.min).applyQuaternion(d), A.expandByPoint(vI), vI.copy(l.min).setX(l.max.x).applyQuaternion(d), A.expandByPoint(vI), vI.copy(l.min).setY(l.max.y).applyQuaternion(d), A.expandByPoint(vI), vI.copy(l.max).setZ(l.min.z).applyQuaternion(d), A.expandByPoint(vI), vI.copy(l.min).setZ(l.max.z).applyQuaternion(d), A.expandByPoint(vI), vI.copy(l.max).setY(l.min.y).applyQuaternion(d), A.expandByPoint(vI), vI.copy(l.max).setX(l.min.x).applyQuaternion(d), A.expandByPoint(vI), vI.copy(l.max).applyQuaternion(d), A.expandByPoint(vI), A.min.x -= n, A.min.y -= a, A.max.x += r, A.max.y += s, d.setFromUnitVectors(mI, h), p && d.premultiply(LI.invert()), d.premultiply(this._yAxisUpSpace);
                const f = A.getSize(MI), m = A.getCenter(vI).applyQuaternion(d);
                if (Y_(this._camera)) {
                    const t1 = this.getDistanceToFitBox(f.x, f.y, f.z, i);
                    o.push(this.moveTo(m.x, m.y, m.z, e)), o.push(this.dollyTo(t1, e)), o.push(this.setFocalOffset(0, 0, 0, e));
                } else if (X_(this._camera)) {
                    const t1 = this._camera, n = t1.right - t1.left, r = t1.top - t1.bottom, a = i ? Math.max(n / f.x, r / f.y) : Math.min(n / f.x, r / f.y);
                    o.push(this.moveTo(m.x, m.y, m.z, e)), o.push(this.zoomTo(a, e)), o.push(this.setFocalOffset(0, 0, 0, e));
                }
                return Promise.all(o);
            }
            fitToSphere(t1, e) {
                const i = [], n = "isObject3D" in t1 ? jI.createBoundingSphere(t1, CI) : CI.copy(t1);
                if (i.push(this.moveTo(n.center.x, n.center.y, n.center.z, e)), Y_(this._camera)) {
                    const t1 = this.getDistanceToFitSphere(n.radius);
                    i.push(this.dollyTo(t1, e));
                } else if (X_(this._camera)) {
                    const t1 = this._camera.right - this._camera.left, r = this._camera.top - this._camera.bottom, a = 2 * n.radius, s = Math.min(t1 / a, r / a);
                    i.push(this.zoomTo(s, e));
                }
                return i.push(this.setFocalOffset(0, 0, 0, e)), Promise.all(i);
            }
            setLookAt(t1, e, i, n, r, a, s = !1) {
                this._isUserControllingRotate = !1, this._isUserControllingDolly = !1, this._isUserControllingTruck = !1, this._lastDollyDirection = 0, this._changedDolly = 0;
                const o = vI.set(n, r, a), l = MI.set(t1, e, i);
                this._targetEnd.copy(o), this._sphericalEnd.setFromVector3(l.sub(o).applyQuaternion(this._yAxisUpSpace)), this.normalizeRotations(), this._needsUpdate = !0, s || (this._target.copy(this._targetEnd), this._spherical.copy(this._sphericalEnd));
                const c = !s || eI(this._target.x, this._targetEnd.x, this.restThreshold) && eI(this._target.y, this._targetEnd.y, this.restThreshold) && eI(this._target.z, this._targetEnd.z, this.restThreshold) && eI(this._spherical.theta, this._sphericalEnd.theta, this.restThreshold) && eI(this._spherical.phi, this._sphericalEnd.phi, this.restThreshold) && eI(this._spherical.radius, this._sphericalEnd.radius, this.restThreshold);
                return this._createOnRestPromise(c);
            }
            lerpLookAt(t1, e, i, n, r, a, s, o, l, c, u, h, d, p = !1) {
                this._isUserControllingRotate = !1, this._isUserControllingDolly = !1, this._isUserControllingTruck = !1, this._lastDollyDirection = 0, this._changedDolly = 0;
                const A = MI.set(n, r, a), f = vI.set(t1, e, i);
                II.setFromVector3(f.sub(A).applyQuaternion(this._yAxisUpSpace));
                const m = yI.set(c, u, h), g = vI.set(s, o, l);
                SI.setFromVector3(g.sub(m).applyQuaternion(this._yAxisUpSpace)), this._targetEnd.copy(A.lerp(m, d));
                const M = SI.theta - II.theta, v = SI.phi - II.phi, y = SI.radius - II.radius;
                this._sphericalEnd.set(II.radius + y * d, II.phi + v * d, II.theta + M * d), this.normalizeRotations(), this._needsUpdate = !0, p || (this._target.copy(this._targetEnd), this._spherical.copy(this._sphericalEnd));
                const x = !p || eI(this._target.x, this._targetEnd.x, this.restThreshold) && eI(this._target.y, this._targetEnd.y, this.restThreshold) && eI(this._target.z, this._targetEnd.z, this.restThreshold) && eI(this._spherical.theta, this._sphericalEnd.theta, this.restThreshold) && eI(this._spherical.phi, this._sphericalEnd.phi, this.restThreshold) && eI(this._spherical.radius, this._sphericalEnd.radius, this.restThreshold);
                return this._createOnRestPromise(x);
            }
            setPosition(t1, e, i, n = !1) {
                return this.setLookAt(t1, e, i, this._targetEnd.x, this._targetEnd.y, this._targetEnd.z, n);
            }
            setTarget(t1, e, i, n = !1) {
                const r = this.getPosition(MI), a = this.setLookAt(r.x, r.y, r.z, t1, e, i, n);
                return this._sphericalEnd.phi = $_(this._sphericalEnd.phi, this.minPolarAngle, this.maxPolarAngle), a;
            }
            setFocalOffset(t1, e, i, n = !1) {
                this._isUserControllingOffset = !1, this._focalOffsetEnd.set(t1, e, i), this._needsUpdate = !0, n || this._focalOffset.copy(this._focalOffsetEnd);
                const r = !n || eI(this._focalOffset.x, this._focalOffsetEnd.x, this.restThreshold) && eI(this._focalOffset.y, this._focalOffsetEnd.y, this.restThreshold) && eI(this._focalOffset.z, this._focalOffsetEnd.z, this.restThreshold);
                return this._createOnRestPromise(r);
            }
            setOrbitPoint(t1, e, i) {
                this._camera.updateMatrixWorld(), wI.setFromMatrixColumn(this._camera.matrixWorldInverse, 0), bI.setFromMatrixColumn(this._camera.matrixWorldInverse, 1), TI.setFromMatrixColumn(this._camera.matrixWorldInverse, 2);
                const n = MI.set(t1, e, i), r = n.distanceTo(this._camera.position), a = n.sub(this._camera.position);
                wI.multiplyScalar(a.x), bI.multiplyScalar(a.y), TI.multiplyScalar(a.z), MI.copy(wI).add(bI).add(TI), MI.z = MI.z + r, this.dollyTo(r, !1), this.setFocalOffset(-MI.x, MI.y, -MI.z, !1), this.moveTo(t1, e, i, !1);
            }
            setBoundary(t1) {
                if (!t1) return this._boundary.min.set(-1 / 0, -1 / 0, -1 / 0), this._boundary.max.set(1 / 0, 1 / 0, 1 / 0), void (this._needsUpdate = !0);
                this._boundary.copy(t1), this._boundary.clampPoint(this._targetEnd, this._targetEnd), this._needsUpdate = !0;
            }
            setViewport(t1, e, i, n) {
                null !== t1 ? (this._viewport = this._viewport || new pI.Vector4, "number" == typeof t1 ? this._viewport.set(t1, e, i, n) : this._viewport.copy(t1)) : this._viewport = null;
            }
            getDistanceToFitBox(t1, e, i, n = !1) {
                if (lI(this._camera, "getDistanceToFitBox")) return this._spherical.radius;
                const r = t1 / e, a = this._camera.getEffectiveFOV() * K_, s = this._camera.aspect;
                return .5 * ((n ? r > s : r < s) ? e : t1 / s) / Math.tan(.5 * a) + .5 * i;
            }
            getDistanceToFitSphere(t1) {
                if (lI(this._camera, "getDistanceToFitSphere")) return this._spherical.radius;
                const e = this._camera.getEffectiveFOV() * K_, i = 2 * Math.atan(Math.tan(.5 * e) * this._camera.aspect), n = 1 < this._camera.aspect ? e : i;
                return t1 / Math.sin(.5 * n);
            }
            getTarget(t1, e = !0) {
                return (t1 && t1.isVector3 ? t1 : new pI.Vector3).copy(e ? this._targetEnd : this._target);
            }
            getPosition(t1, e = !0) {
                return (t1 && t1.isVector3 ? t1 : new pI.Vector3).setFromSpherical(e ? this._sphericalEnd : this._spherical).applyQuaternion(this._yAxisUpSpaceInverse).add(e ? this._targetEnd : this._target);
            }
            getSpherical(t1, e = !0) {
                return (t1 || new pI.Spherical).copy(e ? this._sphericalEnd : this._spherical);
            }
            getFocalOffset(t1, e = !0) {
                return (t1 && t1.isVector3 ? t1 : new pI.Vector3).copy(e ? this._focalOffsetEnd : this._focalOffset);
            }
            normalizeRotations() {
                this._sphericalEnd.theta = this._sphericalEnd.theta % Z_, this._sphericalEnd.theta < 0 && (this._sphericalEnd.theta += Z_), this._spherical.theta += Z_ * Math.round((this._sphericalEnd.theta - this._spherical.theta) / Z_);
            }
            reset(t1 = !1) {
                if (!eI(this._camera.up.x, this._cameraUp0.x) || !eI(this._camera.up.y, this._cameraUp0.y) || !eI(this._camera.up.z, this._cameraUp0.z)) {
                    this._camera.up.copy(this._cameraUp0);
                    const t1 = this.getPosition(MI);
                    this.updateCameraUp(), this.setPosition(t1.x, t1.y, t1.z);
                }
                const e = [
                    this.setLookAt(this._position0.x, this._position0.y, this._position0.z, this._target0.x, this._target0.y, this._target0.z, t1),
                    this.setFocalOffset(this._focalOffset0.x, this._focalOffset0.y, this._focalOffset0.z, t1),
                    this.zoomTo(this._zoom0, t1)
                ];
                return Promise.all(e);
            }
            saveState() {
                this._cameraUp0.copy(this._camera.up), this.getTarget(this._target0), this.getPosition(this._position0), this._zoom0 = this._zoom, this._focalOffset0.copy(this._focalOffset);
            }
            updateCameraUp() {
                this._yAxisUpSpace.setFromUnitVectors(this._camera.up, fI), this._yAxisUpSpaceInverse.copy(this._yAxisUpSpace).invert();
            }
            applyCameraUp() {
                const t1 = MI.subVectors(this._target, this._camera.position).normalize(), e = vI.crossVectors(t1, this._camera.up);
                this._camera.up.crossVectors(e, t1).normalize(), this._camera.updateMatrixWorld();
                const i = this.getPosition(MI);
                this.updateCameraUp(), this.setPosition(i.x, i.y, i.z);
            }
            update(t1) {
                const e = this._sphericalEnd.theta - this._spherical.theta, i = this._sphericalEnd.phi - this._spherical.phi, n = this._sphericalEnd.radius - this._spherical.radius, r = EI.subVectors(this._targetEnd, this._target), a = _I.subVectors(this._focalOffsetEnd, this._focalOffset), s = this._zoomEnd - this._zoom;
                if (tI(e)) this._thetaVelocity.value = 0, this._spherical.theta = this._sphericalEnd.theta;
                else {
                    const e = this._isUserControllingRotate ? this.draggingSmoothTime : this.smoothTime;
                    this._spherical.theta = aI(this._spherical.theta, this._sphericalEnd.theta, this._thetaVelocity, e, 1 / 0, t1), this._needsUpdate = !0;
                }
                if (tI(i)) this._phiVelocity.value = 0, this._spherical.phi = this._sphericalEnd.phi;
                else {
                    const e = this._isUserControllingRotate ? this.draggingSmoothTime : this.smoothTime;
                    this._spherical.phi = aI(this._spherical.phi, this._sphericalEnd.phi, this._phiVelocity, e, 1 / 0, t1), this._needsUpdate = !0;
                }
                if (tI(n)) this._radiusVelocity.value = 0, this._spherical.radius = this._sphericalEnd.radius;
                else {
                    const e = this._isUserControllingDolly ? this.draggingSmoothTime : this.smoothTime;
                    this._spherical.radius = aI(this._spherical.radius, this._sphericalEnd.radius, this._radiusVelocity, e, this.maxSpeed, t1), this._needsUpdate = !0;
                }
                if (tI(r.x) && tI(r.y) && tI(r.z)) this._targetVelocity.set(0, 0, 0), this._target.copy(this._targetEnd);
                else {
                    const e = this._isUserControllingTruck ? this.draggingSmoothTime : this.smoothTime;
                    sI(this._target, this._targetEnd, this._targetVelocity, e, this.maxSpeed, t1, this._target), this._needsUpdate = !0;
                }
                if (tI(a.x) && tI(a.y) && tI(a.z)) this._focalOffsetVelocity.set(0, 0, 0), this._focalOffset.copy(this._focalOffsetEnd);
                else {
                    const e = this._isUserControllingOffset ? this.draggingSmoothTime : this.smoothTime;
                    sI(this._focalOffset, this._focalOffsetEnd, this._focalOffsetVelocity, e, this.maxSpeed, t1, this._focalOffset), this._needsUpdate = !0;
                }
                if (tI(s)) this._zoomVelocity.value = 0, this._zoom = this._zoomEnd;
                else {
                    const e = this._isUserControllingZoom ? this.draggingSmoothTime : this.smoothTime;
                    this._zoom = aI(this._zoom, this._zoomEnd, this._zoomVelocity, e, 1 / 0, t1);
                }
                if (this.dollyToCursor) {
                    if (Y_(this._camera) && 0 !== this._changedDolly) {
                        const t1 = this._spherical.radius - this._lastDistance, e = this._camera, i = this._getCameraDirection(xI), n = MI.copy(i).cross(e.up).normalize();
                        0 === n.lengthSq() && (n.x = 1);
                        const r = vI.crossVectors(n, i), a = this._sphericalEnd.radius * Math.tan(e.getEffectiveFOV() * K_ * .5), s = (this._sphericalEnd.radius - t1 - this._sphericalEnd.radius) / this._sphericalEnd.radius, o = yI.copy(this._targetEnd).add(n.multiplyScalar(this._dollyControlCoord.x * a * e.aspect)).add(r.multiplyScalar(this._dollyControlCoord.y * a)), l = MI.copy(this._targetEnd).lerp(o, s), c = 1 === this._lastDollyDirection && this._spherical.radius <= this.minDistance, u = -1 === this._lastDollyDirection && this.maxDistance <= this._spherical.radius;
                        if (this.infinityDolly && (c || u)) {
                            this._sphericalEnd.radius -= t1, this._spherical.radius -= t1;
                            const e = vI.copy(i).multiplyScalar(-t1);
                            l.add(e);
                        }
                        this._boundary.clampPoint(l, l);
                        const h = vI.subVectors(l, this._targetEnd);
                        this._targetEnd.copy(l), this._target.add(h), this._changedDolly -= t1, tI(this._changedDolly) && (this._changedDolly = 0);
                    } else if (X_(this._camera) && 0 !== this._changedZoom) {
                        const t1 = this._zoom - this._lastZoom, e = this._camera, i = MI.set(this._dollyControlCoord.x, this._dollyControlCoord.y, (e.near + e.far) / (e.near - e.far)).unproject(e), n = vI.set(0, 0, -1).applyQuaternion(e.quaternion), r = yI.copy(i).add(n.multiplyScalar(-i.dot(e.up))), a = -(this._zoom - t1 - this._zoom) / this._zoom, s = this._getCameraDirection(xI), o = this._targetEnd.dot(s), l = MI.copy(this._targetEnd).lerp(r, a), c = l.dot(s), u = s.multiplyScalar(c - o);
                        l.sub(u), this._boundary.clampPoint(l, l);
                        const h = vI.subVectors(l, this._targetEnd);
                        this._targetEnd.copy(l), this._target.add(h), this._changedZoom -= t1, tI(this._changedZoom) && (this._changedZoom = 0);
                    }
                }
                this._camera.zoom !== this._zoom && (this._camera.zoom = this._zoom, this._camera.updateProjectionMatrix(), this._updateNearPlaneCorners(), this._needsUpdate = !0), this._dragNeedsUpdate = !0;
                const o = this._collisionTest();
                this._spherical.radius = Math.min(this._spherical.radius, o), this._spherical.makeSafe(), this._camera.position.setFromSpherical(this._spherical).applyQuaternion(this._yAxisUpSpaceInverse).add(this._target), this._camera.lookAt(this._target), (!tI(this._focalOffset.x) || !tI(this._focalOffset.y) || !tI(this._focalOffset.z)) && (this._camera.updateMatrixWorld(), wI.setFromMatrixColumn(this._camera.matrix, 0), bI.setFromMatrixColumn(this._camera.matrix, 1), TI.setFromMatrixColumn(this._camera.matrix, 2), wI.multiplyScalar(this._focalOffset.x), bI.multiplyScalar(-this._focalOffset.y), TI.multiplyScalar(this._focalOffset.z), MI.copy(wI).add(bI).add(TI), this._camera.position.add(MI)), this._boundaryEnclosesCamera && this._encloseToBoundary(this._camera.position.copy(this._target), MI.setFromSpherical(this._spherical).applyQuaternion(this._yAxisUpSpaceInverse), 1);
                const l = this._needsUpdate;
                return l && !this._updatedLastTime ? (this._hasRested = !1, this.dispatchEvent({
                    type: "wake"
                }), this.dispatchEvent({
                    type: "update"
                })) : l ? (this.dispatchEvent({
                    type: "update"
                }), tI(e, this.restThreshold) && tI(i, this.restThreshold) && tI(n, this.restThreshold) && tI(r.x, this.restThreshold) && tI(r.y, this.restThreshold) && tI(r.z, this.restThreshold) && tI(a.x, this.restThreshold) && tI(a.y, this.restThreshold) && tI(a.z, this.restThreshold) && tI(s, this.restThreshold) && !this._hasRested && (this._hasRested = !0, this.dispatchEvent({
                    type: "rest"
                }))) : !l && this._updatedLastTime && this.dispatchEvent({
                    type: "sleep"
                }), this._lastDistance = this._spherical.radius, this._lastZoom = this._zoom, this._updatedLastTime = l, this._needsUpdate = !1, l;
            }
            toJSON() {
                return JSON.stringify({
                    enabled: this._enabled,
                    minDistance: this.minDistance,
                    maxDistance: nI(this.maxDistance),
                    minZoom: this.minZoom,
                    maxZoom: nI(this.maxZoom),
                    minPolarAngle: this.minPolarAngle,
                    maxPolarAngle: nI(this.maxPolarAngle),
                    minAzimuthAngle: nI(this.minAzimuthAngle),
                    maxAzimuthAngle: nI(this.maxAzimuthAngle),
                    smoothTime: this.smoothTime,
                    draggingSmoothTime: this.draggingSmoothTime,
                    dollySpeed: this.dollySpeed,
                    truckSpeed: this.truckSpeed,
                    dollyToCursor: this.dollyToCursor,
                    verticalDragToForward: this.verticalDragToForward,
                    target: this._targetEnd.toArray(),
                    position: MI.setFromSpherical(this._sphericalEnd).add(this._targetEnd).toArray(),
                    zoom: this._zoomEnd,
                    focalOffset: this._focalOffsetEnd.toArray(),
                    target0: this._target0.toArray(),
                    position0: this._position0.toArray(),
                    zoom0: this._zoom0,
                    focalOffset0: this._focalOffset0.toArray()
                });
            }
            fromJSON(t1, e = !1) {
                const i = JSON.parse(t1);
                this.enabled = i.enabled, this.minDistance = i.minDistance, this.maxDistance = rI(i.maxDistance), this.minZoom = i.minZoom, this.maxZoom = rI(i.maxZoom), this.minPolarAngle = i.minPolarAngle, this.maxPolarAngle = rI(i.maxPolarAngle), this.minAzimuthAngle = rI(i.minAzimuthAngle), this.maxAzimuthAngle = rI(i.maxAzimuthAngle), this.smoothTime = i.smoothTime, this.draggingSmoothTime = i.draggingSmoothTime, this.dollySpeed = i.dollySpeed, this.truckSpeed = i.truckSpeed, this.dollyToCursor = i.dollyToCursor, this.verticalDragToForward = i.verticalDragToForward, this._target0.fromArray(i.target0), this._position0.fromArray(i.position0), this._zoom0 = i.zoom0, this._focalOffset0.fromArray(i.focalOffset0), this.moveTo(i.target[0], i.target[1], i.target[2], e), II.setFromVector3(MI.fromArray(i.position).sub(this._targetEnd).applyQuaternion(this._yAxisUpSpace)), this.rotateTo(II.theta, II.phi, e), this.dollyTo(II.radius, e), this.zoomTo(i.zoom, e), this.setFocalOffset(i.focalOffset[0], i.focalOffset[1], i.focalOffset[2], e), this._needsUpdate = !0;
            }
            connect(t1) {
                this._domElement ? console.warn("camera-controls is already connected.") : (t1.setAttribute("data-camera-controls-version", "2.8.5"), this._addAllEventListeners(t1), this._getClientRect(this._elementRect));
            }
            disconnect() {
                this.cancel(), this._removeAllEventListeners(), this._domElement && (this._domElement.removeAttribute("data-camera-controls-version"), this._domElement = void 0);
            }
            dispose() {
                this.removeAllEventListeners(), this.disconnect();
            }
            _getTargetDirection(t1) {
                return t1.setFromSpherical(this._spherical).divideScalar(this._spherical.radius).applyQuaternion(this._yAxisUpSpaceInverse);
            }
            _getCameraDirection(t1) {
                return this._getTargetDirection(t1).negate();
            }
            _findPointerById(t1) {
                return this._activePointers.find((e)=>e.pointerId === t1);
            }
            _findPointerByMouseButton(t1) {
                return this._activePointers.find((e)=>e.mouseButton === t1);
            }
            _disposePointer(t1) {
                this._activePointers.splice(this._activePointers.indexOf(t1), 1);
            }
            _encloseToBoundary(t1, e, i) {
                const n = e.lengthSq();
                if (0 === n) return t1;
                const r = vI.copy(e).add(t1), a = this._boundary.clampPoint(r, yI).sub(r), s = a.lengthSq();
                if (0 === s) return t1.add(e);
                if (s === n) return t1;
                if (0 === i) return t1.add(e).add(a);
                {
                    const n = 1 + i * s / e.dot(a);
                    return t1.add(vI.copy(e).multiplyScalar(n)).add(a.multiplyScalar(1 - i));
                }
            }
            _updateNearPlaneCorners() {
                if (Y_(this._camera)) {
                    const t1 = this._camera, e = t1.near, i = t1.getEffectiveFOV() * K_, n = Math.tan(.5 * i) * e, r = n * t1.aspect;
                    this._nearPlaneCorners[0].set(-r, -n, 0), this._nearPlaneCorners[1].set(r, -n, 0), this._nearPlaneCorners[2].set(r, n, 0), this._nearPlaneCorners[3].set(-r, n, 0);
                } else if (X_(this._camera)) {
                    const t1 = this._camera, e = 1 / t1.zoom, i = t1.left * e, n = t1.right * e, r = t1.top * e, a = t1.bottom * e;
                    this._nearPlaneCorners[0].set(i, r, 0), this._nearPlaneCorners[1].set(n, r, 0), this._nearPlaneCorners[2].set(n, a, 0), this._nearPlaneCorners[3].set(i, a, 0);
                }
            }
            _collisionTest() {
                let t1 = 1 / 0;
                if (!(this.colliderMeshes.length >= 1)) return t1;
                if (lI(this._camera, "_collisionTest")) return t1;
                const e = this._getTargetDirection(xI);
                OI.lookAt(AI, e, this._camera.up);
                for(let i = 0; i < 4; i++){
                    const n = vI.copy(this._nearPlaneCorners[i]);
                    n.applyMatrix4(OI);
                    const r = yI.addVectors(this._target, n);
                    PI.set(r, e), PI.far = this._spherical.radius + 1;
                    const a = PI.intersectObjects(this.colliderMeshes);
                    0 !== a.length && a[0].distance < t1 && (t1 = a[0].distance);
                }
                return t1;
            }
            _getClientRect(t1) {
                if (!this._domElement) return;
                const e = this._domElement.getBoundingClientRect();
                return t1.x = e.left, t1.y = e.top, this._viewport ? (t1.x += this._viewport.x, t1.y += e.height - this._viewport.w - this._viewport.y, t1.width = this._viewport.z, t1.height = this._viewport.w) : (t1.width = e.width, t1.height = e.height), t1;
            }
            _createOnRestPromise(t1) {
                return t1 ? Promise.resolve() : (this._hasRested = !1, this.dispatchEvent({
                    type: "transitionstart"
                }), new Promise((t1)=>{
                    const e = ()=>{
                        this.removeEventListener("rest", e), t1();
                    };
                    this.addEventListener("rest", e);
                }));
            }
            _addAllEventListeners(t1) {}
            _removeAllEventListeners() {}
            get dampingFactor() {
                return console.warn(".dampingFactor has been deprecated. use smoothTime (in seconds) instead."), 0;
            }
            set dampingFactor(t1) {
                console.warn(".dampingFactor has been deprecated. use smoothTime (in seconds) instead.");
            }
            get draggingDampingFactor() {
                return console.warn(".draggingDampingFactor has been deprecated. use draggingSmoothTime (in seconds) instead."), 0;
            }
            set draggingDampingFactor(t1) {
                console.warn(".draggingDampingFactor has been deprecated. use draggingSmoothTime (in seconds) instead.");
            }
            static createBoundingSphere(t1, e = new pI.Sphere) {
                const i = e, n = i.center;
                NI.makeEmpty(), t1.traverseVisible((t1)=>{
                    t1.isMesh && NI.expandByObject(t1);
                }), NI.getCenter(n);
                let r = 0;
                return t1.traverseVisible((t1)=>{
                    if (!t1.isMesh) return;
                    const e = t1, i = e.geometry.clone();
                    i.applyMatrix4(e.matrixWorld);
                    const a = i.attributes.position;
                    for(let t1 = 0, e = a.count; t1 < e; t1++)MI.fromBufferAttribute(a, t1), r = Math.max(r, n.distanceToSquared(MI));
                }), i.radius = Math.sqrt(r), i;
            }
        }
        function RI(t1, e, i) {
            return (e = function(t1) {
                var e = function(t1) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var e = t1[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e)) in t1 ? Object.defineProperty(t1, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = i, t1;
        }
        jI.install({
            THREE: t1
        });
        const kI = class extends jI {
            constructor(t1, e){
                super(e, t1.domElement), RI(this, "disableAutoRotate", !1), RI(this, "userDragging", !1), RI(this, "_renderer", void 0), RI(this, "_camera", void 0), this._renderer = t1, this._camera = e, this.mouseButtons.middle = jI.ACTION.NONE, this.mouseButtons.left = jI.ACTION.ROTATE, this.mouseButtons.right = jI.ACTION.NONE, this.mouseButtons.wheel = jI.ACTION.NONE, this.touches.three = jI.ACTION.NONE, this.touches.two = jI.ACTION.NONE, this.touches.one = jI.ACTION.TOUCH_ROTATE, this.verticalDragToForward = !0, this.azimuthRotateSpeed = -0.25, this.polarRotateSpeed = -0.25, this.maxDistance = .001, this.truckSpeed = 1e4, this.minDistance = 0, this.dollySpeed = 0, this.minZoom = 1, this.maxZoom = 2, this.rotateTo(0, Math.PI / 2), this.setDefaultPosition(), this.addListeners();
            }
            setDefaultPosition() {
                this.moveTo(0, 0, 0), this.dollyTo(1e-9), this.zoomTo(1);
            }
            onRest() {
                this.removeEventListener("rest", this.onRest), this.disableAutoRotate = !1, this.holding = !1;
            }
            onControlStart() {
                this.currentAction !== jI.ACTION.NONE && (this.removeEventListener("rest", this.onRest), this.disableAutoRotate = !0, this.holding = !0);
            }
            onControlEnd() {
                this.active ? this.addEventListener("rest", this.onRest) : this.onRest();
            }
            onTransitionStart() {
                this.holding || (this.disableAutoRotate = !0, this.addEventListener("rest", this.onRest));
            }
            addListeners() {
                this.addEventListener("transitionstart", this.onTransitionStart), this.addEventListener("controlstart", this.onControlStart), this.addEventListener("controlend", this.onControlEnd);
            }
        };
        function UI(t1, e, i) {
            return (e = function(t1) {
                var e = function(t1) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var e = t1[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e)) in t1 ? Object.defineProperty(t1, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = i, t1;
        }
        const BI = class extends qu {
            constructor(t1){
                super(60, 1, .1, 1e4), UI(this, "deviceOrientationControls", void 0), UI(this, "controls", void 0), this.controls = new kI(t1, this), this.deviceOrientationControls = new G_(this, t1.domElement);
            }
        };
        const FI = class extends Wp {
            constructor(){
                var t1, e, i;
                super(), t1 = this, i = void 0, (e = function(t1) {
                    var e = function(t1) {
                        if ("object" != typeof t1 || !t1) return t1;
                        var e = t1[Symbol.toPrimitive];
                        if (void 0 !== e) {
                            var i = e.call(t1, "string");
                            if ("object" != typeof i) return i;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(t1);
                    }(t1);
                    return "symbol" == typeof e ? e : e + "";
                }(e = "controls")) in t1 ? Object.defineProperty(t1, e, {
                    value: i,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t1[e] = i, this.background = new Yc(16777215), this.add(new jg(new Yc(16777215), 3));
            }
        };
        function QI(t1, e, i) {
            return (e = function(t1) {
                var e = function(t1) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var e = t1[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e)) in t1 ? Object.defineProperty(t1, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = i, t1;
        }
        const HI = class extends Fu {
            constructor(){
                super(), QI(this, "canvas", document.createElement("canvas")), QI(this, "interactive", !0), QI(this, "height", 775), QI(this, "width", 775), this.canvas.height = this.height, this.canvas.width = this.width, this.createGeomtery(), this.createMaterial(), this.addEventListener("select", (t1)=>this.onClick(t1)), this.addEventListener("click", (t1)=>this.onClick(t1)), this.addEventListener("hoverstart", this.onHoverStart), this.addEventListener("hoverend", this.onHoverEnd), this.renderOrder = 5;
            }
            get context() {
                return this.canvas.getContext("2d");
            }
            onClick() {}
            onHoverStart() {
                this.scale.setScalar(1.15);
            }
            onHoverEnd() {
                this.scale.setScalar(1);
            }
            createGeomtery() {
                this.geometry = new uh(this.width, this.height, 100, 100);
            }
            createMaterial() {
                return this.material = new Om({
                    color: new Yc(16777215),
                    transparent: !0,
                    side: cr,
                    opacity: 1
                }), this;
            }
            async loadImage(t1) {
                const e = await fetch(t1, {
                    method: "GET",
                    cache: "no-cache"
                }), i = await e.blob();
                return await Dy(URL.createObjectURL(i));
            }
            setVisibility(t1) {
                this.visible = t1, this.scale.setScalar(t1 ? 1 : 0);
            }
            async updateMaterial(t1) {
                const e = "".concat(t1 + 1, " ").concat(zy("floor")), i = Un.config.colors.mainText, n = Un.getFloorConfig(t1);
                return this.loadImage(n.planImage).then((t1)=>{
                    this.context.clearRect(0, 0, this.canvas.width, this.canvas.height), this.context.beginPath(), this.context.fillStyle = "rgba(255, 255, 255, 1)", Cy(this.context, 0, 0, this.canvas.width, this.canvas.height, 50), this.context.fill(), this.context.drawImage(t1, 165, 75, 450, 450), this.context.textAlign = "center", this.context.font = "Bold 80px/1 Roboto Mono", this.context.fillStyle = i, this.context.fillColor = i, this.context.fillText(e, this.canvas.width / 2, this.canvas.height - 100), this.context.fillRect((this.canvas.width - 430) / 2, this.canvas.height - 55, 430, 5), this.material.map || (this.material.map = mx(this.canvas)), this.material.map.needsUpdate = !0, this.material.needsUpdate = !0;
                }), this;
            }
        };
        function VI(t1, e, i) {
            return (e = function(t1) {
                var e = function(t1) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var e = t1[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e)) in t1 ? Object.defineProperty(t1, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = i, t1;
        }
        const GI = class extends Fu {
            constructor(){
                super(), VI(this, "canvas", document.createElement("canvas")), VI(this, "height", 700), VI(this, "width", 700), this.canvas.height = this.height, this.canvas.width = this.width, this.createGeomtery(), this.createMaterial(), this.renderOrder = 5;
            }
            get context() {
                return this.canvas.getContext("2d");
            }
            createGeomtery() {
                this.geometry = new uh(this.width, this.height, 100, 100);
            }
            createMaterial() {
                return this.material = new Om({
                    color: new Yc(16777215),
                    transparent: !0,
                    side: cr,
                    opacity: 1
                }), this;
            }
            updateMaterial() {
                const t1 = "".concat(Un.currentFloorIndex + 1, " ").concat(zy("floor")), e = Un.config.colors.mainText;
                return this.context.clearRect(0, 0, this.canvas.width, this.canvas.height), this.context.textAlign = "center", this.context.font = "Bold 140px/1 Roboto Mono", this.context.fillStyle = e, this.context.fillColor = e, this.context.fillText(t1, this.canvas.width / 2, this.canvas.height / 2), this.context.fillRect(0, this.canvas.height / 2 + 50, this.canvas.width, 5), this.material.map || (this.material.map = mx(this.canvas)), this.material.map.needsUpdate = !0, this.material.needsUpdate = !0, this;
            }
        };
        function WI(t1, e, i) {
            return (e = function(t1) {
                var e = function(t1) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var e = t1[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e)) in t1 ? Object.defineProperty(t1, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = i, t1;
        }
        const YI = class extends Fu {
            constructor(){
                let t1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 400;
                super(), WI(this, "canvas", document.createElement("canvas")), WI(this, "isContainer", !0), this.canvas.width = t1, this.canvas.height = 120, this.createGeometry(), this.createMaterial(), this.renderOrder = 5;
            }
            get context() {
                return this.canvas.getContext("2d");
            }
            createGeometry() {
                return this.geometry = new uh(this.canvas.width, this.canvas.height, 10, 10), this;
            }
            createMaterial() {
                this.context.clearRect(0, 0, this.canvas.width, this.canvas.height), this.context.beginPath(), this.context.fillStyle = "rgba(20, 20, 20, 0.26)", Cy(this.context, 0, 0, this.canvas.width, this.canvas.height, 64), this.context.fill();
                const t1 = mx(this.canvas);
                return this.material = new Om({
                    color: new Yc(16777215),
                    transparent: !0,
                    side: cr,
                    map: t1,
                    opacity: 1
                }), this;
            }
            dispose() {
                this.material.map.dispose(), this.material.dispose(), this.removeFromParent();
            }
        };
        function XI(t1, e, i) {
            return (e = function(t1) {
                var e = function(t1) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var e = t1[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e)) in t1 ? Object.defineProperty(t1, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = i, t1;
        }
        const ZI = class extends Fu {
            constructor(t1){
                super(), XI(this, "canvas", document.createElement("canvas")), XI(this, "interactive", !0), XI(this, "isButton", !0), this.canvas.height = 92, this.canvas.width = 92, this.createGeometry(), this.createMaterial(), this.update(t1), this.addEventListener("select", (t1)=>this.onClick(t1)), this.addEventListener("click", (t1)=>this.onClick(t1)), this.position.set(0, 0, 1), this.renderOrder = 6;
            }
            get context() {
                return this.canvas.getContext("2d");
            }
            onClick() {}
            createGeometry() {
                return this.geometry = new uh(this.canvas.width, this.canvas.height, 10, 10), this;
            }
            createMaterial() {
                return this.material = new Om({
                    color: new Yc(16777215),
                    transparent: !0,
                    side: cr,
                    opacity: 1
                }), this;
            }
            update(t1) {
                return Dy(t1).then((t1)=>{
                    this.context.clearRect(0, 0, this.canvas.width, this.canvas.height), this.context.beginPath(), this.context.fillStyle = "rgba(255, 255, 255, 1)", Cy(this.context, 0, 0, this.canvas.width, this.canvas.height, 46), this.context.fill(), this.context.drawImage(t1, 20, 20, 52, 52), this.material.map || (this.material.map = mx(this.canvas)), this.material.map.needsUpdate = !0, this.material.needsUpdate = !0;
                }), this;
            }
            setVisibility(t1) {
                this.visible = t1, this.scale.setScalar(t1 ? 1 : 0);
            }
        };
        function qI(t1, e) {
            let i = t1[0], n = t1[1], r = !1;
            for(let t1 = 0, a = e.length - 1; t1 < e.length; a = t1++){
                const s = e[t1][0], o = e[t1][1], l = e[a][0], c = e[a][1];
                o > n != c > n && i < (l - s) * (n - o) / (c - o) + s && (r = !r);
            }
            return r;
        }
        function JI(t1, e, i) {
            return (e = function(t1) {
                var e = function(t1) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var e = t1[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e)) in t1 ? Object.defineProperty(t1, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = i, t1;
        }
        const KI = class extends Pp {
            constructor(){
                super(), JI(this, "planScale", new qo(1, 1)), JI(this, "currentPanoramasGroup", void 0), JI(this, "padding", 16), JI(this, "rooms", []), this.scale.set(1, -1, 1), this.renderOrder = 6;
            }
            updateScale(t1) {
                let { X: e, Y: i } = t1;
                return this.planScale.x = e, this.planScale.y = i, this.deleteRooms(), this.createRooms(this.currentPanoramasGroup), this;
            }
            showRoomById(t1) {
                return this.rooms.forEach((e)=>{
                    e.material.opacity = e.userData.id === t1 ? .3 : 0;
                }), this;
            }
            createRooms(t1) {
                return this.currentPanoramasGroup = t1, this.currentPanoramasGroup.children.forEach((t1)=>{
                    let { userData: e, panoramaId: i } = t1;
                    const n = e.points.map((t1)=>{
                        let [e, i] = t1;
                        return [
                            this.padding + 2 * e * this.planScale.x,
                            this.padding + 2 * i * this.planScale.y
                        ];
                    }).filter((t1)=>{
                        let [e, i] = t1;
                        return !isNaN(e) && !isNaN(i);
                    });
                    if (!n.length) return;
                    const r = this.padding + 2 * e.left * this.planScale.x, a = this.padding + 2 * e.top * this.planScale.y, s = new Vf;
                    s.moveTo(n[0][0], n[0][1]), n.forEach((t1)=>{
                        let [e, i] = t1;
                        return s.lineTo(e, i);
                    });
                    const o = new bm(s), l = new Om({
                        color: new Yc(Un.config.colors.main),
                        transparent: !0,
                        side: cr,
                        opacity: 0
                    }), c = new Fu(o, l);
                    c.userData = {
                        id: i,
                        points: n,
                        left: r,
                        top: a
                    }, this.rooms.push(c), this.add(c);
                }), this;
            }
            deleteRooms() {
                return this.rooms.forEach((t1)=>{
                    t1.material.dispose(), t1.removeFromParent();
                }), this.rooms = [], this;
            }
        };
        function $I(t1, e, i) {
            return (e = function(t1) {
                var e = function(t1) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var e = t1[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e)) in t1 ? Object.defineProperty(t1, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = i, t1;
        }
        const tS = class extends Fu {
            constructor(){
                super(), $I(this, "height", 140), $I(this, "width", 140), this.createGeometry(), this.createMaterial(), this.renderOrder = 7;
            }
            createGeometry() {
                return this.geometry = new uh(this.width, this.height, 10, 10), this;
            }
            createMaterial() {
                const t1 = this.width / 2, e = this.height / 2, i = Math.PI / 3 * 4, n = i + Math.PI / 3, r = document.createElement("canvas"), a = r.getContext("2d");
                return r.height = this.height, r.width = this.width, a.clearRect(0, 0, this.width, this.height), a.globalAlpha = .4, a.beginPath(), a.moveTo(t1, e), a.fillStyle = Un.config.colors.main, a.arc(t1, e, 70, i, n), a.lineTo(t1, e), a.fill(), a.closePath(), a.globalAlpha = 1, a.beginPath(), a.fillStyle = Un.config.colors.main, a.arc(t1, e, 16, 0, 2 * Math.PI), a.fill(), a.closePath(), a.beginPath(), a.fillStyle = "rgba(255, 255, 255, 1)", a.arc(t1, e, 12, 0, 2 * Math.PI), a.fill(), a.closePath(), a.beginPath(), a.fillStyle = Un.config.colors.main, a.arc(t1, e, 8, 0, 2 * Math.PI), a.fill(), a.closePath(), this.material = new Om({
                    map: mx(r),
                    color: new Yc(16777215),
                    transparent: !0,
                    depthTest: !1,
                    side: cr,
                    opacity: 1
                }), this;
            }
            update(t1, e, i) {
                this.position.set(t1, e, 10), this.rotation.set(0, 0, i);
            }
        };
        function eS(t1, e, i) {
            return (e = function(t1) {
                var e = function(t1) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var e = t1[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e)) in t1 ? Object.defineProperty(t1, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = i, t1;
        }
        const iS = class extends Fu {
            constructor(){
                super(), eS(this, "planScale", new qo(1, 1)), eS(this, "pointer", new qo(-1, -1)), eS(this, "interactive", !0), eS(this, "boundingScale", 4), eS(this, "padding", 16), eS(this, "hoverRoom", void 0), eS(this, "fovLayer", void 0), eS(this, "height", void 0), eS(this, "width", void 0), this.height = 200, this.width = 200, this.createGeometry(), this.createMaterial(), this.creteRoomsLayer(), this.createFovLayer(), this.addEventListener("hoverstart", this.onHoverStart), this.addEventListener("hoverend", this.onHoverEnd), this.addEventListener("click", this.handleClick), this.renderOrder = 5;
            }
            createGeometry() {
                return this.geometry = new uh(this.width, this.height, 100, 100), this;
            }
            createMaterial() {
                return this.material = new Om({
                    color: new Yc(16777215),
                    transparent: !0,
                    side: cr,
                    opacity: 1
                }), this;
            }
            async loadImage(t1) {
                const e = await fetch(t1, {
                    method: "GET",
                    cache: "no-cache"
                }), i = await e.blob();
                return this.image = new Image, this.image.onload = ()=>this.updateMaterial(), this.image.src = URL.createObjectURL(i), this;
            }
            createFovLayer() {
                return this.fovLayer = new tS, this.add(this.fovLayer), this;
            }
            creteRoomsLayer() {
                return this.roomsLayer = new KI, this.add(this.roomsLayer), this;
            }
            setDisabledState(t1) {
                this.disabled = t1;
            }
            setVisibility(t1) {
                this.visible = t1, this.scale.setScalar(t1 ? this.boundingScale : 0);
            }
            onHoverStart(t1) {
                const { x: e, y: i } = t1.data, n = this.height * i, r = this.width * e;
                this.pointer.x = r, this.pointer.y = n;
            }
            onHoverEnd() {
                this.pointer.x = -1, this.pointer.y = -1;
            }
            handleClick() {
                this.hoverRoom && (this.onClick(this.hoverRoom.userData.id), this.dispatchEvent({
                    type: "closemap"
                }));
            }
            onClick() {}
            updateMaterial() {
                const t1 = document.createElement("canvas"), e = t1.getContext("2d");
                return t1.height = this.height, t1.width = this.width, e.fillStyle = "rgba(255, 255, 255, 1)", Cy(e, 0, 0, this.width, this.height, 20), e.fill(), this.image && e.drawImage(this.image, this.padding, this.padding, this.width - 2 * this.padding, this.height - 2 * this.padding), this.material.map && this.material.map.dispose(), this.material.map = mx(t1), this.material.needsUpdate = !0, this;
            }
            updateSize(t1, e) {
                this.height = e + 2 * this.padding, this.width = t1 + 2 * this.padding, this.roomsLayer.position.set(-this.width / 2, this.height / 2, 5), this.createGeometry();
                const i = Math.min(this.width / this.height, 1);
                return this.boundingScale = 5 * i, this.setVisibility(this.visible), this;
            }
            updateScale(t1) {
                let { X: e, Y: i } = t1;
                return this.planScale.x = e, this.planScale.y = i, this.roomsLayer.updateScale({
                    X: e,
                    Y: i
                }), this;
            }
            updateRoomsLayer(t1) {
                return this.roomsLayer.deleteRooms(), this.roomsLayer.createRooms(t1), this;
            }
            update(t1, e, i) {
                var n;
                if (i) {
                    const t1 = this.roomsLayer.rooms.filter((t1)=>qI([
                            this.pointer.x,
                            this.pointer.y
                        ], t1.userData.points));
                    this.hoverRoom = yx([
                        this.pointer.x,
                        this.pointer.y
                    ], t1).panorama;
                }
                if (this.roomsLayer.showRoomById((null === (n = this.hoverRoom) || void 0 === n ? void 0 : n.userData.id) || null), !this.disabled && e) {
                    const i = this.padding + 2 * e.userData.left * this.planScale.x, n = this.padding + 2 * e.userData.top * this.planScale.y, r = this.height / 2, a = i - this.width / 2, s = -1 * (n - r);
                    this.fovLayer.update(a, s, t1);
                }
                return this;
            }
        }, nS = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzE4NDhfNjI0KSI+CjxwYXRoIGQ9Ik0xOC44MjI2IDEuODc0ODlMMS44NzUwNSAxOC44MjI0QzEuNDc2MDEgMTkuMjIxNCAxLjQ0MTUgMTkuODMzOSAxLjc5Nzk3IDIwLjE5MDRMNy44MDk0OCAyNi4yMDE5QzguMTY1OTUgMjYuNTU4MyA4Ljc3ODQyIDI2LjUyMzggOS4xNzc0NiAyNi4xMjQ4TDI2LjEyNSA5LjE3NzI5QzI2LjUyNCA4Ljc3ODI1IDI2LjU1ODUgOC4xNjU3OSAyNi4yMDIgNy44MDkzMkwyMC4xOTA1IDEuNzk3ODFDMTkuODM0MSAxLjQ0MTM0IDE5LjIyMTYgMS40NzU4NSAxOC44MjI2IDEuODc0ODlaIiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNS41MjUgNi4zMjg2MUwxOS42MTIyIDEwLjQxNTgiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEwLjkyNjkgMTAuOTI2OEwxNC4wMTQyIDE0LjAxNCIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNi4zMjg3NCAxNS41MjQ5TDEwLjQxNiAxOS42MTIxIiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMTg0OF82MjQiPgo8cmVjdCB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==";
        function rS(t1, e, i) {
            (function(t1, e) {
                if (e.has(t1)) throw new TypeError("Cannot initialize the same private elements twice on an object");
            })(t1, e), e.set(t1, i);
        }
        function aS(t1, e, i) {
            return (e = function(t1) {
                var e = function(t1) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var e = t1[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e)) in t1 ? Object.defineProperty(t1, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = i, t1;
        }
        function sS(t1, e) {
            return t1.get(lS(t1, e));
        }
        function oS(t1, e, i) {
            return t1.set(lS(t1, e), i), i;
        }
        function lS(t1, e, i) {
            if ("function" == typeof t1 ? t1 === e : t1.has(e)) return arguments.length < 3 ? e : i;
            throw new TypeError("Private element is not present on this object");
        }
        var cS = new WeakMap, uS = new WeakMap;
        const hS = class extends Pp {
            constructor(){
                super(), aS(this, "mapGroup", new Pp), rS(this, cS, void 0), rS(this, uS, void 0), aS(this, "prevFloorButton", void 0), aS(this, "nextFloorButton", void 0), aS(this, "rulerButton", void 0), aS(this, "floorTitle", void 0), aS(this, "exitButton", void 0), aS(this, "mapButton", void 0), aS(this, "container", void 0), aS(this, "map", void 0), this.createContainer(), this.createButtons(), this.createMap(), this.createFloorTitle(), this.createPrevFloorButton(), this.createNextFloorButton(), this.closeMap(), this.mapButton.setVisibility(!1), this.setVisibility(!1), this.mapGroup.position.set(0, 2e3, -2500), this.mapGroup.rotation.set(Tx(30), 0, 0), this.add(this.mapGroup);
            }
            set rulerButtonAvailable(t1) {
                oS(cS, this, t1), this.map.visible || this.setRulerButtonVisibility(t1);
            }
            set mapButtonAvailable(t1) {
                oS(uS, this, t1), this.map.visible || this.setMapButtonVisibility(t1);
            }
            onRulerButtonClick() {}
            onExitButtonClick() {}
            createContainer() {
                let t1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 400;
                if (this.container) {
                    const e = new YI(t1);
                    this.container.geometry = e.geometry.clone(), this.container.material = e.material.clone(), e.dispose();
                } else this.container = new YI(t1), this.add(this.container);
                return this;
            }
            createButtons() {
                return this.exitButton = new ZI("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIzLjE2NjEgNC44MzM5OEwxNCAxNC4wMDAxTTE0IDE0LjAwMDFMNC44MzM4IDIzLjE2NjNNMTQgMTQuMDAwMUwyMy4xNjYxIDIzLjE2NjNNMTQgMTQuMDAwMUw0LjgzMzggNC44MzM5OCIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L3N2Zz4K"), this.exitButton.onClick = (t1)=>{
                    if (this.map.visible) return this.closeMap();
                    this.onExitButtonClick(t1);
                }, this.rulerButton = new ZI(nS), this.rulerButton.onClick = (t1)=>this.onRulerButtonClick(t1), this.mapButton = new ZI("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI0LjIxMTQgMjQuNDIxMUgzLjc4ODY1QzMuNjI3NDggMjQuNDIxMSAzLjQ5NjgzIDI0LjI5MDQgMy40OTY4MyAyNC4xMjkzTDMuNDk2NzcgNC4wNjYyNEMzLjQ5Njc3IDMuOTA1MDcgMy42Mjc0MiAzLjc3NDQxIDMuNzg4NTkgMy43NzQ0MUgyNC4yMTE0QzI0LjM3MjUgMy43NzQ0MSAyNC41MDMyIDMuOTA1MDcgMjQuNTAzMiA0LjA2NjI0VjI0LjEyOTNDMjQuNTAzMiAyNC4yOTA0IDI0LjM3MjUgMjQuNDIxMSAyNC4yMTE0IDI0LjQyMTFaIiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMiIvPgo8cGF0aCBkPSJNNC4wMDE0NiAxMC4wNDU0SDEzLjM2ODRDMTMuNTI5NiAxMC4wNDU0IDEzLjY2MDIgMTAuMTc2MSAxMy42NjAyIDEwLjMzNzJWMjQuMjA1OSIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjEuNDU5MSIvPgo8cGF0aCBkPSJNMjQuNTAzMiAxMS4wNjU2SDE4LjM2NTFDMTguMjA0IDExLjA2NTYgMTguMDczMyAxMC45MzQ5IDE4LjA3MzMgMTAuNzczOFYzLjU3OTEiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIxLjQ1OTEiLz4KPC9zdmc+Cg=="), this.mapButton.onClick = (t1)=>this.openMap(t1), this.add(this.exitButton, this.rulerButton, this.mapButton), this;
            }
            createMap() {
                return this.map = new iS, this.map.addEventListener("closemap", this.closeMap.bind(this)), this.mapGroup.add(this.map), this;
            }
            createFloorTitle() {
                return this.floorTitle = new GI, this.mapGroup.add(this.floorTitle), this;
            }
            createNextFloorButton() {
                return this.nextFloorButton = new HI, this.mapGroup.add(this.nextFloorButton), this;
            }
            createPrevFloorButton() {
                return this.prevFloorButton = new HI, this.mapGroup.add(this.prevFloorButton), this;
            }
            openMap() {
                this.floorTitle.updateMaterial(), this.prevFloorButton.updateMaterial(Un.prevFloorIndex), this.nextFloorButton.updateMaterial(Un.nextFloorIndex), this.mapGroup.visible = !0, this.map.setVisibility(!0), this.rulerButton.setVisibility(!1), this.setMapButtonVisibility(!1);
                const t1 = Un.configParams.floors.length > 1;
                this.prevFloorButton.setVisibility(t1), this.nextFloorButton.setVisibility(t1);
            }
            closeMap() {
                this.mapGroup.visible = !1, this.map.setVisibility(!1), this.rulerButton.setVisibility(sS(cS, this)), this.setMapButtonVisibility(!0), this.prevFloorButton.setVisibility(!1), this.nextFloorButton.setVisibility(!1);
            }
            setRulerButtonVisibility(t1) {
                this.rulerButton.setVisibility(t1), this.updateButtonsPositions();
            }
            setMapButtonVisibility(t1) {
                this.mapButton.setVisibility(t1), this.updateButtonsPositions();
            }
            setVisibility(t1) {
                t1 ? (this.setRulerButtonVisibility(sS(cS, this)), this.setMapButtonVisibility(sS(uS, this))) : (this.setRulerButtonVisibility(!1), this.setMapButtonVisibility(!1)), this.exitButton.setVisibility(t1), this.container.visible = t1, this.visible = t1, this.scale.setScalar(t1 ? 6e-4 : 0);
            }
            setRulerIcon(t1) {
                return t1 ? this.rulerButton.update("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzE4NDhfNjU5KSI+CjxwYXRoIGQ9Ik0xOC44MjI2IDEuODc0ODlMMS44NzUwNSAxOC44MjI0QzEuNDc2MDEgMTkuMjIxNCAxLjQ0MTUgMTkuODMzOSAxLjc5Nzk3IDIwLjE5MDRMNy44MDk0OCAyNi4yMDE5QzguMTY1OTUgMjYuNTU4MyA4Ljc3ODQyIDI2LjUyMzggOS4xNzc0NiAyNi4xMjQ4TDI2LjEyNSA5LjE3NzI5QzI2LjUyNCA4Ljc3ODI1IDI2LjU1ODUgOC4xNjU3OSAyNi4yMDIgNy44MDkzMkwyMC4xOTA1IDEuNzk3ODFDMTkuODM0MSAxLjQ0MTM0IDE5LjIyMTYgMS40NzU4NSAxOC44MjI2IDEuODc0ODlaIiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNS41MjUgNi4zMjg2MUwxOS42MTIyIDEwLjQxNTgiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEwLjkyNjkgMTAuOTI2OEwxNC4wMTQyIDE0LjAxNCIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNi4zMjg3NCAxNS41MjQ5TDEwLjQxNiAxOS42MTIxIiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxyZWN0IHg9IjEwLjYyNDYiIHk9IjYuMjkzNDYiIHdpZHRoPSIxNS44MDAyIiBoZWlnaHQ9IjMuNjYxNiIgdHJhbnNmb3JtPSJyb3RhdGUoNDUgMTAuNjI0NiA2LjI5MzQ2KSIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTMuMDA2MjkgNC43MTE0M0wyMi45OTM4IDI1LjI4NzkiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF8xODQ4XzY1OSI+CjxyZWN0IHdpZHRoPSIyOCIgaGVpZ2h0PSIyOCIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K") : this.rulerButton.update(nS);
            }
            updateButtonsPositions() {
                return this.map.visible ? (this.exitButton.position.x = 0, void this.createContainer(120)) : this.mapButton.visible ? this.rulerButton.visible ? (this.rulerButton.position.x = 0, this.exitButton.position.x = 140, this.mapButton.position.x = -140, void this.createContainer(400)) : (this.exitButton.position.x = 70, this.mapButton.position.x = -70, void this.createContainer(260)) : this.rulerButton.visible ? (this.rulerButton.position.x = -70, this.exitButton.position.x = 70, void this.createContainer(260)) : (this.exitButton.position.x = 0, void this.createContainer(120));
            }
            updateFloorMaterials() {
                this.floorTitle.updateMaterial(), this.prevFloorButton.updateMaterial(Un.prevFloorIndex), this.nextFloorButton.updateMaterial(Un.nextFloorIndex);
            }
            updateFloorTitlePosition() {
                const t1 = 210 + this.map.height * this.map.scale.y / 2;
                this.floorTitle.position.set(0, t1, 0);
            }
            updateFloorButtonsPositions() {
                const { width: t1, height: e } = this.nextFloorButton, i = e / 2 - this.map.height * this.map.scale.y / 2, n = t1 / 2 + 200 + this.map.width * this.map.scale.x / 2;
                this.prevFloorButton.position.set(-n, i, 0), this.nextFloorButton.position.set(n, i, 0);
            }
            update(t1, e, i, n) {
                this.map.visible && this.map.update(e, i, n);
                const r = new Nl(.025, -0.5, -0.9);
                r.applyMatrix4(t1.matrixWorld);
                const a = new fc(0, 0, 0);
                a.setFromRotationMatrix(t1.matrixWorld), this.position.copy(r), this.rotation.copy(a), this.rotateX(Tx(-30)), this.updateMatrix(), this.updateFloorTitlePosition(), this.updateFloorButtonsPositions();
            }
        };
        const dS = class extends Fu {
            constructor(){
                var t1, e, i;
                super(), t1 = this, i = !0, (e = function(t1) {
                    var e = function(t1) {
                        if ("object" != typeof t1 || !t1) return t1;
                        var e = t1[Symbol.toPrimitive];
                        if (void 0 !== e) {
                            var i = e.call(t1, "string");
                            if ("object" != typeof i) return i;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(t1);
                    }(t1);
                    return "symbol" == typeof e ? e : e + "";
                }(e = "isDistanceLine")) in t1 ? Object.defineProperty(t1, e, {
                    value: i,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t1[e] = i, this.createGeometry(), this.createMaterial(), this.renderOrder = 3;
            }
            createGeometry(t1, e) {
                const i = new Tf(t1, e);
                return this.geometry = new Sm(i, 100, .1, 100, !1), this;
            }
            createMaterial() {
                return this.material = new Om({
                    color: new Yc(4275774),
                    transparent: !0,
                    depthTest: !1,
                    side: cr,
                    opacity: 1
                }), this;
            }
            update(t1, e) {
                return this.createGeometry(t1, e), this;
            }
            dispose() {
                this.material.dispose(), this.removeFromParent();
            }
        };
        function pS(t1, e, i) {
            return (e = function(t1) {
                var e = function(t1) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var e = t1[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e)) in t1 ? Object.defineProperty(t1, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = i, t1;
        }
        const AS = class extends uA {
            constructor(t1){
                super(), pS(this, "canvas", document.createElement("canvas")), pS(this, "isCenterPoint", !0), pS(this, "interactive", !0), pS(this, "materialValue", 0), pS(this, "ruler", void 0), this.ruler = t1;
                const e = .15;
                this.canvas.width = 256, this.canvas.height = 128, this.scale.set(e, e / (this.canvas.width / this.canvas.height), e), this.renderOrder = 5, this.createMaterial();
            }
            get context() {
                return this.canvas.getContext("2d");
            }
            onClick() {
                this.ruler.dispose();
            }
            onHoverStart() {
                this.updateMaterial(this.materialValue, "rgba(255, 99, 64, 0.8)", "rgba(255, 255, 255, 1)");
            }
            onHoverEnd() {
                this.updateMaterial(this.materialValue);
            }
            addEventListeners() {
                return this.addEventListener("select", this.onClick), this.addEventListener("click", this.onClick), this.addEventListener("hoverstart", this.onHoverStart), this.addEventListener("hoverend", this.onHoverEnd), this;
            }
            createMaterial() {
                return this.material = new qp({
                    color: new Yc(16777215),
                    sizeAttenuation: !1,
                    transparent: !0,
                    depthTest: !1,
                    side: cr,
                    opacity: 1
                }), this;
            }
            updateMaterial(t1) {
                let e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "rgba(255, 255, 255, 0.8)", i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : Un.config.colors.mainText;
                this.materialValue = t1;
                const n = "".concat(Number(t1 / 100).toFixed(2), " m "), r = "".concat(Number(.0328084 * t1).toFixed(2), " ft");
                return this.context.clearRect(0, 0, this.canvas.width, this.canvas.height), this.context.beginPath(), this.context.fillStyle = e, Cy(this.context, 0, 0, this.canvas.width, this.canvas.height, 55), this.context.fill(), this.context.textAlign = "center", this.context.font = "Bold 38px/1 Roboto Mono", this.context.fillStyle = i, this.context.fillText(r, this.canvas.width / 2, 100), this.context.fillText(n, this.canvas.width / 2, 50), this.material.map || (this.material.map = mx(this.canvas)), this.material.map.needsUpdate = !0, this.material.needsUpdate = !0, this;
            }
            updatePosition(t1, e) {
                const i = new Tf(t1, e).getPoint(.5, new Nl);
                return this.position.copy(i), this;
            }
            update(t1, e, i) {
                return this.updateMaterial(t1), this.updatePosition(e, i), this;
            }
            dispose() {
                this.material.map.dispose(), this.material.dispose(), this.removeFromParent();
            }
        };
        function fS(t1, e, i) {
            return (e = function(t1) {
                var e = function(t1) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var e = t1[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e)) in t1 ? Object.defineProperty(t1, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = i, t1;
        }
        const mS = class extends Fu {
            constructor(){
                super(), fS(this, "canvas", document.createElement("canvas")), fS(this, "isPoint", !0), this.canvas.width = 128, this.canvas.height = 128, this.createGeometry(), this.createMaterial(), this.renderOrder = 4;
            }
            get context() {
                return this.canvas.getContext("2d");
            }
            createGeometry() {
                return this.geometry = new uh(15, 15, 10, 10), this.geometry.rotateX(-Math.PI / 2), this;
            }
            createMaterial() {
                const t1 = this.canvas.width / 2, e = this.canvas.height / 2;
                this.context.beginPath(), this.context.arc(t1, e, this.canvas.width / 4, 0, 2 * Math.PI, !1), this.context.fillStyle = "rgba(255, 255, 255, 1)", this.context.fill(), this.context.lineWidth = 15, this.context.strokeStyle = Un.config.colors.main, this.context.stroke();
                const i = mx(this.canvas);
                return this.material = new Om({
                    color: new Yc(16777215),
                    transparent: !0,
                    depthWrite: !1,
                    depthTest: !1,
                    side: cr,
                    map: i,
                    opacity: 1
                }), this;
            }
            update(t1, e) {
                let i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
                return this.position.copy(t1), i ? (this.quaternion.slerp(e, .5), this) : (this.quaternion.copy(e), this);
            }
            dispose() {
                this.material.map.dispose(), this.material.dispose(), this.removeFromParent();
            }
        };
        function gS(t1, e, i) {
            return (e = function(t1) {
                var e = function(t1) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var e = t1[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e)) in t1 ? Object.defineProperty(t1, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = i, t1;
        }
        const MS = class extends Pp {
            constructor(t1){
                super(), gS(this, "distanceLine", null), gS(this, "centerPoint", null), gS(this, "secondPoint", null), gS(this, "firstPoint", null), gS(this, "isRuler", !0), this.userData = {
                    panoramaId: t1
                };
            }
            get distance() {
                return this.firstPoint && this.secondPoint ? this.firstPoint.position.distanceTo(this.secondPoint.position) : 0;
            }
            createRest(t1, e) {
                return this.createSecondPoint(t1, e), this.createDistanceLine(), this.createCenterPoint(), this;
            }
            createFirstPoint(t1, e) {
                return this.firstPoint = (new mS).update(t1, e, !1), this.add(this.firstPoint), this;
            }
            createSecondPoint(t1, e) {
                return this.secondPoint = (new mS).update(t1, e, !1), this.add(this.secondPoint), this;
            }
            createDistanceLine() {
                return this.distanceLine = new dS, this.add(this.distanceLine), this;
            }
            createCenterPoint() {
                return this.centerPoint = new AS(this), this.add(this.centerPoint), this;
            }
            update(t1, e) {
                var i, n, r;
                return null === (i = this.secondPoint) || void 0 === i || i.update(t1, e, !0), null === (n = this.centerPoint) || void 0 === n || n.update(this.distance, this.firstPoint.position, this.secondPoint.position), null === (r = this.distanceLine) || void 0 === r || r.update(this.firstPoint.position, this.secondPoint.position), this;
            }
            dispose() {
                var t1, e, i, n;
                return null === (t1 = this.firstPoint) || void 0 === t1 || t1.dispose(), null === (e = this.secondPoint) || void 0 === e || e.dispose(), null === (i = this.centerPoint) || void 0 === i || i.dispose(), null === (n = this.distanceLine) || void 0 === n || n.dispose(), this.removeFromParent(), this;
            }
        }, vS = "data:image/svg+xml;base64,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", yS = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIxLjgzNTQgMi4xNDA3OEwyLjM3NzE4IDIxLjU5OUMxLjkxOTAyIDIyLjA1NzIgMS44Nzk0IDIyLjc2MDQgMi4yODg2OCAyMy4xNjk3TDkuMTkwNzggMzAuMDcxOEM5LjYwMDA2IDMwLjQ4MSAxMC4zMDMzIDMwLjQ0MTQgMTAuNzYxNCAyOS45ODMzTDMwLjIxOTcgMTAuNTI1QzMwLjY3NzggMTAuMDY2OSAzMC43MTc0IDkuMzYzNjYgMzAuMzA4MiA4Ljk1NDM4TDIzLjQwNjEgMi4wNTIyOEMyMi45OTY4IDEuNjQyOTkgMjIuMjkzNiAxLjY4MjYyIDIxLjgzNTQgMi4xNDA3OFoiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIyLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTguMDQ5MyA3LjI1NDI3TDIyLjc0MjEgMTEuOTQ3IiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMi41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEyLjc3IDEyLjUzMzZMMTYuMzE0NiAxNi4wNzgyIiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMi41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTcuNDkwNzIgMTcuODEyOUwxMi4xODM1IDIyLjUwNTYiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIyLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K", xS = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkuMTYzMiAyNC45MDY3VjUuOTA2NjhIOC45NjI1N0wwLjQ4Mjg1NyA4Ljg5NVYxMi4wNTNMNS40MDQ4NCAxMC4zMzA0VjI0LjkwNjdIOS4xNjMyWiIgZmlsbD0iIzQxM0UzRSIvPgo8cGF0aCBkPSJNMjMuMTI2NiAxNS4xOTc5TDE5Ljk5NjkgMTAuNzg3MkgxNS45OTc4TDIwLjgzOTUgMTcuNzE2NEwxNS44MTA1IDI0LjkwNjdIMTkuODM2NEwyMy4xNCAyMC4yODcyTDI2LjQ3MDQgMjQuOTA2N0gzMC40ODI5TDI1LjQ1MzkgMTcuNzE2NEwzMC4zMDkgMTAuNzg3MkgyNi4zMDk5TDIzLjEyNjYgMTUuMTk3OVoiIGZpbGw9IiM0MTNFM0UiLz4KPC9zdmc+Cg==";
        function wS(t1, e, i) {
            return (e = function(t1) {
                var e = function(t1) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var e = t1[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e)) in t1 ? Object.defineProperty(t1, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = i, t1;
        }
        hi({
            useProxies: "never"
        });
        const bS = new class {
            constructor(){
                wS(this, "currentAutoRotateIcon", vS), wS(this, "currentRulerIcon", yS), wS(this, "currentFovIcon", xS), wS(this, "currentFovText", "1x"), wS(this, "rulerInstructionShown", !1), wS(this, "tempPointer", new qo), wS(this, "raycaster", new LM), wS(this, "tempMatrix", new ac), wS(this, "vrSessionSupported", !1), wS(this, "rulerButtonEnabled", !1), wS(this, "rulersGroup", new Pp), wS(this, "renderer", new H_), wS(this, "floorsGroup", new Pp), wS(this, "initialPanoramaId", null), wS(this, "rulerModeEnabled", !1), wS(this, "autoRotateState", !1), wS(this, "pointer", new qo), wS(this, "panoramasGroup", null), wS(this, "initialized", !1), wS(this, "clock", new iM), wS(this, "scene", new FI), wS(this, "animation", !1), wS(this, "currentPanoramaId", void 0), wS(this, "interactiveGroup", void 0), wS(this, "tempRuler", null), wS(this, "currentPanorama", void 0), wS(this, "loading", !1), wS(this, "vrControlPanel", void 0), wS(this, "maskCursor", void 0), wS(this, "camera", void 0), wS(this, "bareshell", !1), wS(this, "isFirstRender", !0), wS(this, "onMouseMove", (t1)=>{
                    let { clientX: e, clientY: i } = t1;
                    this.pointer.x = e / Un.config.width * 2 - 1, this.pointer.y = -i / Un.config.height * 2 + 1;
                }), wS(this, "onPointerDown", (t1)=>{
                    let { clientX: e, clientY: i } = t1;
                    this.tempPointer.x = Number(e.toFixed(0)), this.tempPointer.y = Number(i.toFixed(0)), this.onMouseMove({
                        clientX: e,
                        clientY: i
                    });
                }), wS(this, "onPointerUp", (t1)=>{
                    let { clientX: e, clientY: i } = t1;
                    if (this.interactiveGroup.hover) return;
                    const n = Math.abs(this.tempPointer.x - Number(e.toFixed(0))) < 10, r = Math.abs(this.tempPointer.y - Number(i.toFixed(0))) < 10;
                    n && r && (this.rulerModeEnabled ? this.addRulerPoint() : this.onMaskObjectClick());
                }), wS(this, "onControllerMove", (t1)=>{
                    const e = t1.target;
                    this.tempMatrix.identity().extractRotation(e.matrixWorld), this.raycaster.ray.origin.setFromMatrixPosition(e.matrixWorld), this.raycaster.ray.direction.set(0, 0, -1).applyMatrix4(this.tempMatrix);
                }), wS(this, "onControllerSelect", ()=>{
                    this.rulerModeEnabled ? this.addRulerPoint() : this.onMaskObjectClick();
                }), wS(this, "onMaskObjectClick", ()=>{}), zi(this), this.camera = new BI(this.renderer), this.interactiveGroup = new zx(this.renderer, this.camera), this.floorsGroup.rotation.y = Math.PI, this.scene.add(this.interactiveGroup, this.rulersGroup, this.floorsGroup), this.addEventListeners();
            }
            get currentViewAngle() {
                const t1 = this.currentCamera.getWorldDirection(new Nl), e = new Nl(-1, 0, 0), i = t1.x * e.x + t1.z * e.z, n = Math.sqrt(Math.pow(t1.x, 2) + Math.pow(t1.z, 2)), r = Math.sqrt(Math.pow(e.x, 2) + Math.pow(e.z, 2)), a = Math.acos(i / (n * r));
                return Math.sign(t1.z) * a;
            }
            get currentCamera() {
                return this.renderer.xr.getCamera().cameras[0] || this.camera;
            }
            get currentControls() {
                return this.camera.deviceOrientationControls.enabled ? this.camera.deviceOrientationControls : this.camera.controls;
            }
            getPanoramaById(t1) {
                return this.panoramasGroup.children.find((e)=>{
                    let { panoramaId: i } = e;
                    return i === t1;
                });
            }
            setLoadingState(t1) {
                this.loading = t1;
            }
            setInitializedState(t1) {
                this.initialized = t1;
            }
            setBareshell(t1) {
                this.bareshell = t1;
            }
            updateWindowSize(t1, e) {
                return this.renderer.setSize(t1, e), this.camera.aspect = t1 / e, this.camera.updateProjectionMatrix(), this.render();
            }
            enableRender() {
                this.renderer.setAnimationLoop(this.render.bind(this));
            }
            disableRender() {
                this.renderer.setAnimationLoop(null);
            }
            render() {
                const t1 = this.clock.getDelta();
                this.currentControls.update(t1), this.camera.updateProjectionMatrix(), this.autoRotateState && !this.camera.controls.disableAutoRotate && (this.camera.controls.azimuthAngle -= Tx(10 * t1)), this.renderer.currentVrSession || this.raycaster.setFromCamera(this.pointer, this.camera), kx.isMobileDevice || (this.tempRuler ? this.updateRuler() : this.updateMask()), this.maskCursor ? this.renderer.domElement.style.cursor = this.maskCursor : this.interactiveGroup.hover && this.interactiveGroup.cursor.length > 0 ? this.renderer.domElement.style.cursor = this.interactiveGroup.cursor : this.rulerModeEnabled ? this.renderer.domElement.style.cursor = "none" : this.camera.controls.holding ? this.renderer.domElement.style.cursor = "grabbing" : this.renderer.domElement.style.cursor = "grab";
                const e = document.querySelector(".widget-tab__panorama-map__fov");
                e && e.style.setProperty("--rotate", -this.currentViewAngle);
                const i = document.querySelector(".camera--current");
                return i && i.style.setProperty("--rotate", -this.currentViewAngle), this.renderer.currentVrSession && this.vrControlPanel.update(this.currentCamera, this.currentViewAngle, this.getPanoramaById(this.currentPanoramaId), this.panoramasGroup), this.renderer.render(this.scene, this.camera), this.isFirstRender && (this.isFirstRender = !1, performance.mark("first render")), this;
            }
            async init(t1, e, i) {
                return this.vrControlPanel = new hS, this.interactiveGroup.add(this.vrControlPanel), this.vrControlPanel.onRulerButtonClick = this.toggleRulerMode.bind(this), this.vrControlPanel.onExitButtonClick = this.exitVr.bind(this), this.vrControlPanel.map.onClick = this.setCurrentPanoramaById.bind(this), this.vrControlPanel.prevFloorButton.onClick = ()=>Un.setPrevFloorIndex(), this.vrControlPanel.nextFloorButton.onClick = ()=>Un.setNextFloorIndex(), this.setRulerButtonState(!1), this.cameraFovValues = {
                    x1: Un.config.panoramaFov,
                    x2: Un.config.panoramaFov / 2,
                    x05: 1.35 * Un.config.panoramaFov
                }, this.setCameraFov(this.cameraFovValues[Un.scales[0]]), this.checkVrSessionSupport(), await this.createPanoramasGroup(t1, e, i), this.setInitializedState(!0), this;
            }
            async createPanoramasGroup(t1, e, i) {
                performance.mark("start creatingPanoramas");
                const n = new Q_(i);
                return this.floorsGroup.add(n), this.setCurrentPanoramasGroup(i), this.createPanoramas(t1, e), await this.setInitialCurrentPanorama(), this.interactiveGroup.updateDeepChildren(), this;
            }
            addEventListeners() {
                const { domElement: t1 } = this.renderer;
                t1.addEventListener("contextmenu", (t1)=>t1.preventDefault()), t1.addEventListener("pointerdown", this.onPointerDown), t1.addEventListener("pointerup", this.onPointerUp), t1.addEventListener("mousemove", this.onMouseMove);
            }
            async enterVr() {
                return await this.renderer.enterVR().then(()=>{
                    this.vrControlPanel.setVisibility(!0);
                });
            }
            async exitVr() {
                return await this.renderer.exitVR().then(()=>{
                    this.camera.fov = this.cameraFov, this.vrControlPanel.setVisibility(!1);
                });
            }
            async checkVrSessionSupport() {
                const t1 = await this.renderer.checkVrSessionSupport();
                return this.setVrSessionSupport(t1), this.vrSessionSupported;
            }
            setVrSessionSupport(t1) {
                this.vrSessionSupported = t1;
            }
            resetMaskOptions() {
                this.onMaskObjectClick = ()=>{}, this.maskCursor = null;
            }
            setMaskObjectStairs(t1) {
                const e = t1.RoomID === this.currentPanorama.userData.room_id, i = "url(".concat(e ? "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIHZpZXdCb3g9IjAgMCA1MCA1MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzI1NjZfMikiPgo8cGF0aCBkPSJNMi43MDIyMSAxNS4yOTgxTDE0LjQ0NjggMy41NTM0NiIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTQuOTA0MzMgMy41NTM0N0wxNC40NDY4IDMuNTUzNDdMMTQuNDQ2OSAxMy4wOTYiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik00NS4xOTA0IDQ2LjMzMzNINC44MDk1N0M0LjE3ODM5IDQ2LjMzMzMgMy42NjY3MiA0NS44MjE2IDMuNjY2NzIgNDUuMTkwNFYzNy45OTQ3QzMuNjY2NzIgMzcuMzYzNSA0LjE3ODM5IDM2Ljg1MTggNC44MDk1NyAzNi44NTE4SDEzLjAyNzZDMTMuNjU4OCAzNi44NTE4IDE0LjE3MDUgMzYuMzQwMSAxNC4xNzA1IDM1LjcwOVYyNy4yNDM0QzE0LjE3MDUgMjYuNjEyMiAxNC42ODIyIDI2LjEwMDUgMTUuMzEzNCAyNi4xMDA1SDI0LjE4MjhDMjQuODE0IDI2LjEwMDUgMjUuMzI1NyAyNS41ODg5IDI1LjMyNTcgMjQuOTU3N1YxNS41NjA5QzI1LjMyNTcgMTQuOTI5NyAyNS44MzczIDE0LjQxOCAyNi40Njg1IDE0LjQxOEgzNC42ODY2QzM1LjMxNzggMTQuNDE4IDM1LjgyOTUgMTMuOTA2NCAzNS44Mjk1IDEzLjI3NTJWNC44MDk2QzM1LjgyOTUgNC4xNzg0MiAzNi4zNDExIDMuNjY2NzUgMzYuOTcyMyAzLjY2Njc1SDQ1LjE5MDRDNDUuODIxNiAzLjY2Njc1IDQ2LjMzMzIgNC4xNzg0MiA0Ni4zMzMyIDQuODA5NlY0NS4xOTA0QzQ2LjMzMzIgNDUuODIxNiA0NS44MjE2IDQ2LjMzMzMgNDUuMTkwNCA0Ni4zMzMzWiIgZmlsbD0id2hpdGUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzI1NjZfMiI+CjxyZWN0IHdpZHRoPSI0Ny45OTk4IiBoZWlnaHQ9IjQ3Ljk5OTgiIGZpbGw9IndoaXRlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxLjAwMDA2IDEuMDAwMjQpIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==" : "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIHZpZXdCb3g9IjAgMCA1MCA1MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzI1NTFfMTcyKSI+CjxwYXRoIGQ9Ik0xNC40NDY4IDMuNTUzNDZMMi43MDIyIDE1LjI5ODEiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xMi4yNDQ3IDE1LjI5ODFMMi43MDIyIDE1LjI5ODFMMi43MDIyIDUuNzU1NTciIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik00NS4xOTA0IDQ2LjMzMzNINC44MDk1N0M0LjE3ODM5IDQ2LjMzMzMgMy42NjY3MiA0NS44MjE2IDMuNjY2NzIgNDUuMTkwNFYzNy45OTQ3QzMuNjY2NzIgMzcuMzYzNSA0LjE3ODM5IDM2Ljg1MTggNC44MDk1NyAzNi44NTE4SDEzLjAyNzZDMTMuNjU4OCAzNi44NTE4IDE0LjE3MDUgMzYuMzQwMSAxNC4xNzA1IDM1LjcwOVYyNy4yNDM0QzE0LjE3MDUgMjYuNjEyMiAxNC42ODIyIDI2LjEwMDUgMTUuMzEzNCAyNi4xMDA1SDI0LjE4MjhDMjQuODE0IDI2LjEwMDUgMjUuMzI1NyAyNS41ODg5IDI1LjMyNTcgMjQuOTU3N1YxNS41NjA5QzI1LjMyNTcgMTQuOTI5NyAyNS44MzczIDE0LjQxOCAyNi40Njg1IDE0LjQxOEgzNC42ODY2QzM1LjMxNzggMTQuNDE4IDM1LjgyOTUgMTMuOTA2NCAzNS44Mjk1IDEzLjI3NTJWNC44MDk2QzM1LjgyOTUgNC4xNzg0MiAzNi4zNDExIDMuNjY2NzUgMzYuOTcyMyAzLjY2Njc1SDQ1LjE5MDRDNDUuODIxNiAzLjY2Njc1IDQ2LjMzMzIgNC4xNzg0MiA0Ni4zMzMyIDQuODA5NlY0NS4xOTA0QzQ2LjMzMzIgNDUuODIxNiA0NS44MjE2IDQ2LjMzMzMgNDUuMTkwNCA0Ni4zMzMzWiIgZmlsbD0id2hpdGUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzI1NTFfMTcyIj4KPHJlY3Qgd2lkdGg9IjQ3Ljk5OTgiIGhlaWdodD0iNDcuOTk5OCIgZmlsbD0id2hpdGUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEuMDAwMDYgMS4wMDAyNCkiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K", ") 25 25, pointer"), n = e ? Un.nextFloorIndex : Un.prevFloorIndex, r = e ? t1.UpperFloorCameraPointID : t1.LowerFloorCameraPointID, { CameraPoints: a } = Un.config.json.Floors[n], { id: s } = a.reduce((e, i)=>{
                    const n = [
                        i.Location.X,
                        i.Location.Y
                    ], r = Iy([
                        [
                            t1.Location.X,
                            t1.Location.Y
                        ],
                        n
                    ]);
                    return r < e.length ? {
                        id: i.ID,
                        length: r
                    } : e;
                }, {
                    length: 1 / 0,
                    id: null
                });
                this.initialPanoramaId = r || s, this.maskCursor = i, this.onMaskObjectClick = ()=>e ? Un.setNextFloorIndex() : Un.setPrevFloorIndex();
            }
            setMaskObjectDefault() {
                this.maskCursor = "pointer", this.onMaskObjectClick = ()=>{};
            }
            updateMask() {
                const t1 = this.getObjectFromMask(), e = Lx.some((e)=>(null == t1 ? void 0 : t1.Model) === e);
                return t1 ? e ? this.setMaskObjectStairs(t1) : this.setMaskObjectDefault() : this.resetMaskOptions();
            }
            getObjectFromMask() {
                if (!this.currentPanorama || !this.currentPanorama.mask) return;
                if (!Un.config.json || !Un.config.json.ObjectMaskColorPairs) return;
                if (this.interactiveGroup.hover) return;
                const { direction: t1 } = this.raycaster.ray, e = (1 + Math.atan2(t1.z, t1.x) / Math.PI) / 2, i = Math.acos(t1.y) / Math.PI, { R: n } = Ix(e, i, this.currentPanorama.mask), r = Math.round(n), a = Un.config.json.ObjectMaskColorPairs.find((t1)=>t1.MaskColorID.R === r);
                return a && "Furniture" === a.Type && Mx(Un.config.json, this.currentPanorama.userData.room_id) ? ((t1, e)=>{
                    for (const i of t1.Floors)for (const t1 of i.Units)for (const i of t1.Rooms)for (const t1 of i.Furniture)if (t1.ID === e) return t1;
                    return null;
                })(Un.config.json, a.ObjectID) : void 0;
            }
            setRulerInstructionShown(t1) {
                this.rulerInstructionShown = t1;
            }
            setRulerButtonState(t1) {
                this.rulerButtonEnabled = t1, this.vrControlPanel.rulerButtonAvailable = t1;
            }
            setRulerMode(t1) {
                this.rulerModeEnabled = t1, this.vrControlPanel.setRulerIcon(t1), this.rulersGroup.children.forEach((e)=>{
                    const i = !!t1 && e.userData.panoramaId === this.currentPanorama.panoramaId;
                    e.centerPoint && (e.centerPoint.visible = i), e.visible = i;
                }), t1 ? (this.currentRulerIcon = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIyLjkyMjggMTcuODIyTDI1LjM1NSAxNS4zODk3TDMwLjIxOTYgMTAuNTI1MUMzMC42Nzc4IDEwLjA2NyAzMC43MTc0IDkuMzYzNzggMzAuMzA4MSA4Ljk1NDVMMjMuNDA2IDIuMDUyNEMyMi45OTY3IDEuNjQzMTIgMjIuMjkzNSAxLjY4Mjc0IDIxLjgzNTQgMi4xNDA5TDE2Ljk3MDggNy4wMDU0NkwxNC41Mzg1IDkuNDM3NzRNMTkuMzE3OCAyMS40MjdMMTAuNzYxNCAyOS45ODM0QzEwLjMwMzIgMzAuNDQxNSA5LjYgMzAuNDgxMiA5LjE5MDcyIDMwLjA3MTlMMi4yODg2MiAyMy4xNjk4QzEuODc5MzMgMjIuNzYwNSAxLjkxODk2IDIyLjA1NzMgMi4zNzcxMiAyMS41OTkxTDEwLjc2MTQgMTMuMjE0OSIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjIuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xOC4wNDkzIDcuMjU0MzlMMjIuNzQyIDExLjk0NzEiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIyLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNy40OTA2IDE3LjgxM0wxMi4xODM0IDIyLjUwNTciIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIyLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMS41NDkyNiAzLjQ5NjA5TDI5LjEwMjMgMzAuODExMyIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjIuMjgzMjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K", kx.isMobileDevice || this.createTempRuler()) : (this.currentRulerIcon = yS, this.destroyTempRuler());
            }
            toggleRulerMode(t1) {
                this.setRulerMode(!this.rulerModeEnabled), t1 && t1.controller && (this.interactiveGroup.controller1.removeEventListener("select", this.onControllerSelect), this.interactiveGroup.controller1.removeEventListener("move", this.onControllerMove), this.interactiveGroup.controller2.removeEventListener("select", this.onControllerSelect), this.interactiveGroup.controller2.removeEventListener("move", this.onControllerMove), t1.controller.addEventListener("select", this.onControllerSelect), t1.controller.addEventListener("move", this.onControllerMove));
            }
            getRulerPoint() {
                const { direction: t1 } = this.raycaster.ray, e = (1 + Math.atan2(t1.z, t1.x) / Math.PI) / 2, i = Math.acos(t1.y) / Math.PI, { R: n } = Ix(e, i, this.currentPanorama.depthMap), r = n || 140;
                return {
                    depthValue: r,
                    position: t1.clone().multiplyScalar(r).add(this.currentCamera.position),
                    quaternion: this.getRulerPointQuaternion()
                };
            }
            getRulerPointQuaternion() {
                const { width: t1, height: e } = this.currentPanorama.depthMap, { direction: i } = this.raycaster.ray, n = [
                    {
                        x: -1,
                        y: -1
                    },
                    {
                        x: 0,
                        y: -1
                    },
                    {
                        x: 1,
                        y: -1
                    },
                    {
                        x: -1,
                        y: 0
                    },
                    {
                        x: 0,
                        y: 0
                    },
                    {
                        x: 1,
                        y: 0
                    },
                    {
                        x: -1,
                        y: 1
                    },
                    {
                        x: 0,
                        y: 1
                    },
                    {
                        x: 1,
                        y: 1
                    }
                ], r = (1 + Math.atan2(i.z, i.x) / Math.PI) / 2, a = Math.acos(i.y) / Math.PI, s = 1 / e, o = 1 / t1, l = Math.round(Math.sqrt(n.length)), c = n.map((t1)=>{
                    let { x: e, y: i } = t1;
                    const n = r + o * e, l = a + s * i, { R: c } = Ix(n, l, this.currentPanorama.depthMap), u = c || 140, h = ((t1, e)=>{
                        const i = new Nl;
                        return i.x = Math.cos((2 * t1 - 1) * Math.PI) * Math.sin(e * Math.PI), i.z = Math.sin((2 * t1 - 1) * Math.PI) * Math.sin(e * Math.PI), i.y = Math.cos(e * Math.PI), i;
                    })(n, l);
                    return h.clone().multiplyScalar(u).add(this.currentCamera.position);
                }), u = new Nl(0, 0, 0);
                for(let t1 = 0; t1 < l - 1; t1++)for(let e = 0; e < l - 1; e++){
                    const i = t1 * l + e, n = (t1 + 1) * l + e, r = c[i], a = c[i + 1], s = c[n], o = c[n + 1];
                    u.add(Dx(r, a, s)), u.add(Dx(a, o, s));
                }
                u.normalize();
                const h = new Nl(0, Math.sign(i.y), 0), d = (new Nl).crossVectors(h, u), p = u.angleTo(h);
                return (new Sl).setFromAxisAngle(d, p);
            }
            updateRuler() {
                if (this.interactiveGroup.hover) return;
                const { position: t1, quaternion: e } = this.getRulerPoint();
                return this.tempRuler.secondPoint ? this.tempRuler.update(t1, e) : this.tempRuler.firstPoint.update(t1, e);
            }
            finishRuler() {
                return this.interactiveGroup.add(this.tempRuler.centerPoint), this.tempRuler.centerPoint.addEventListeners(), this.tempRuler = null, this;
            }
            addRulerPoint() {
                if (this.interactiveGroup.hover) return;
                const { position: t1, quaternion: e } = this.getRulerPoint();
                return kx.isMobileDevice ? this.tempRuler ? void (this.tempRuler.firstPoint && (this.tempRuler.createRest(t1, e), this.updateRuler(), this.finishRuler())) : this.createTempRuler() : this.tempRuler.secondPoint ? (this.finishRuler(), this.createTempRuler()) : this.tempRuler.createRest(t1, e);
            }
            createTempRuler() {
                const { position: t1, quaternion: e } = this.getRulerPoint();
                return this.tempRuler = new MS(this.currentPanorama.panoramaId), this.tempRuler.createFirstPoint(t1, e), this.rulersGroup.add(this.tempRuler), this;
            }
            destroyTempRuler() {
                return this.tempRuler ? (this.tempRuler.dispose(), this.tempRuler = null, this) : this;
            }
            setCameraFov(t1) {
                this.camera.fov = t1, this.cameraFov = t1, t1 === this.cameraFovValues.x1 && (this.currentFovIcon = xS, this.currentFovText = "1x"), t1 === this.cameraFovValues.x2 && (this.currentFovIcon = "data:image/svg+xml;base64,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", this.currentFovText = "2x"), t1 === this.cameraFovValues.x05 && (this.currentFovIcon = "data:image/svg+xml;base64,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", this.currentFovText = "0.5x");
            }
            toggleFov() {
                const t1 = Object.entries(this.cameraFovValues).find((t1)=>{
                    let [e, i] = t1;
                    return i === this.camera.fov;
                })[0], e = Un.scales.findIndex((e)=>e === t1);
                Un.scales[e + 1] ? this.setCameraFov(this.cameraFovValues[Un.scales[e + 1]]) : this.setCameraFov(this.cameraFovValues[Un.scales[0]]);
            }
            setAutoRotateState(t1) {
                this.autoRotateState = t1, this.currentAutoRotateIcon = t1 ? "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzgiIGhlaWdodD0iMzgiIHZpZXdCb3g9IjAgMCAzOCAzOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIyLjc2IDI2LjQxNDNDMjUuNDIxIDI2LjA2NjYgMjcuOTA3NCAyNS4zMjI1IDI5Ljk2ODUgMjQuMjM4M0MzMi45MDcxIDIyLjY5MjYgMzQuNzc1MyAyMC41NjM5IDM1LjIxNjMgMTguMjU4OEMzNS42NTczIDE1Ljk1MzcgMzQuNjQwMSAxMy42MzM4IDMyLjM1OTEgMTEuNzQyMkMzMC4wNzgxIDkuODUwNTEgMjYuNjkzMSA4LjUxOTY4IDIyLjg1MDUgOC4wMDM4NUMxOS4wMDggNy40ODgwMiAxNC45NzczIDcuODIzMzQgMTEuNTI4MiA4Ljk0NTc3QzguMDc5MTEgMTAuMDY4MiA1LjQ1MzM5IDExLjg5OTEgNC4xNTI1MiAxNC4wODg3QzMuODE4MTEgMTQuNjUxNiAzLjU3NzI4IDE1LjIyOCAzLjQyOTY1IDE1LjgxMDMiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIzLjE1MjcxIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPHBhdGggZD0iTTI1LjI1MzYgMTkuNDMzM0wxOS45Njg3IDI2LjA4MzlMMjYuMDg3MyAzMC45NDYzIiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMy4xNTI3MSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNC40Nzg1IDIwLjk2OTdMNS40MTAyMyAzMC4wMzgiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIzLjE1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTE0LjQ3ODUgMzAuMDM4TDUuNDEwMjMgMjAuOTY5NyIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjMuMTUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K" : vS;
            }
            toggleAutoRotate() {
                this.setAutoRotateState(!this.autoRotateState), this.autoRotateState ? this.camera.deviceOrientationControls.disable() : kx.deviceOrientationGranted && this.camera.deviceOrientationControls.enable();
            }
            setCurrentPanoramasGroup(t1) {
                const e = this.floorsGroup.children.find((e)=>e.floorIndex === t1);
                if (e) return this.panoramasGroup = e, this.vrControlPanel.map.updateRoomsLayer(e), this.vrControlPanel.updateFloorMaterials(), this;
            }
            async setCurrentPanoramaById(t1) {
                var e;
                if ((null === (e = this.currentPanorama) || void 0 === e ? void 0 : e.panoramaId) === t1) return;
                const i = this.getPanoramaById(t1);
                if (this.animation || !i) return this;
                if (this.setCurrentPanoramaId(t1), this.animation = !0, Un.config.bareshell && i.loaded && (this.setLoadingState(!0), performance.mark("start downloadingPanoramas"), await i.load(), performance.mark("finish downloadingPanoramas"), performance.measure("downloadingPanorama", "start downloadingPanoramas", "finish downloadingPanoramas"), this.setLoadingState(!1)), !i.loaded && (this.setLoadingState(!0), performance.mark("start downloadingPanoramas"), await i.load(), performance.mark("finish downloadingPanoramas"), performance.measure("downloadingPanoramas", "start downloadingPanoramas", "finish downloadingPanoramas"), this.setLoadingState(!1), Un.config.enableCameraRotationBetweenPanoramas && 0 !== i.userData.rotation)) {
                    const t1 = !!Un.config.enableCameraTransitionBetweenPanoramas && this.currentPanorama;
                    setTimeout(()=>{
                        this.camera.controls.normalizeRotations();
                        const e = Ex(this.camera.controls.azimuthAngle), n = Ex(i.userData.rotation), r = Tx(((t1, e)=>{
                            const i = (e - t1) % 360;
                            return i > 180 ? i - 360 : i < -180 ? i + 360 : i;
                        })(e, n));
                        this.camera.controls.rotate(r, 0, t1);
                    }, t1 ? 200 : 0);
                }
                for (const t1 of (null === (n = this.currentPanorama) || void 0 === n ? void 0 : n.links) || []){
                    var n;
                    t1.visible = !1;
                }
                for (const t1 of i.links)t1.visible = !0;
                if (this.rulerModeEnabled) for (const e of this.rulersGroup.children){
                    const i = e.userData.panoramaId === t1;
                    e.centerPoint && (e.centerPoint.visible = i), e.visible = i;
                }
                this.currentPanorama && (this.currentPanorama.renderOrder = 0), i.renderOrder = 1, i.visible = !0, await i.fadeIn(), this.currentPanorama && (await this.currentPanorama.fadeOut(), this.currentPanorama.visible = !1);
                const r = null !== i.depthMap;
                return this.setCurrentPanorama(i), this.animation = !1, this.destroyTempRuler(), this.setRulerButtonState(r), this.rulerModeEnabled && this.setRulerMode(r), this;
            }
            setCurrentPanoramaId(t1) {
                this.currentPanoramaId = t1;
            }
            setCurrentPanorama(t1) {
                this.currentPanorama = t1;
            }
            async setInitialCurrentPanorama() {
                const t1 = this.panoramasGroup.children.find((t1)=>0 === t1.userData.panorama_index), e = this.initialPanoramaId || (null == t1 ? void 0 : t1.panoramaId) || null;
                return this.setCurrentPanoramaById(e).then(()=>{
                    this.initialPanoramaId = null;
                });
            }
            createPanoramas(t1, e) {
                const i = this.panoramasGroup.createPanoramas(t1, e);
                for (const t1 of i)for (const e of t1.links)e.onClick = ()=>this.setCurrentPanoramaById(e.userData.targetId), this.interactiveGroup.add(e);
                return this;
            }
        };
        if (!e.useState) throw new Error("mobx-react-lite requires React with Hooks support");
        var TS = i(961);
        function ES(t1) {
            t1();
        }
        function _S(t1) {
            var e;
            return pi(vn(t1, e));
        }
        var IS = function() {
            function t1(t1) {
                var e = this;
                Object.defineProperty(this, "finalize", {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: t1
                }), Object.defineProperty(this, "registrations", {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: new Map
                }), Object.defineProperty(this, "sweepTimeout", {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: void 0
                }), Object.defineProperty(this, "sweep", {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: function(t1) {
                        void 0 === t1 && (t1 = 1e4), clearTimeout(e.sweepTimeout), e.sweepTimeout = void 0;
                        var i = Date.now();
                        e.registrations.forEach(function(n, r) {
                            i - n.registeredAt >= t1 && (e.finalize(n.value), e.registrations.delete(r));
                        }), e.registrations.size > 0 && e.scheduleSweep();
                    }
                }), Object.defineProperty(this, "finalizeAllImmediately", {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: function() {
                        e.sweep(0);
                    }
                });
            }
            return Object.defineProperty(t1.prototype, "register", {
                enumerable: !1,
                configurable: !0,
                writable: !0,
                value: function(t1, e, i) {
                    this.registrations.set(i, {
                        value: e,
                        registeredAt: Date.now()
                    }), this.scheduleSweep();
                }
            }), Object.defineProperty(t1.prototype, "unregister", {
                enumerable: !1,
                configurable: !0,
                writable: !0,
                value: function(t1) {
                    this.registrations.delete(t1);
                }
            }), Object.defineProperty(t1.prototype, "scheduleSweep", {
                enumerable: !1,
                configurable: !0,
                writable: !0,
                value: function() {
                    void 0 === this.sweepTimeout && (this.sweepTimeout = setTimeout(this.sweep, 1e4));
                }
            }), t1;
        }(), SS = new ("undefined" != typeof FinalizationRegistry ? FinalizationRegistry : IS)(function(t1) {
            var e;
            null === (e = t1.reaction) || void 0 === e || e.dispose(), t1.reaction = null;
        }), NS = !1;
        function DS() {
            return NS;
        }
        var CS = function(t1, e) {
            var i = "function" == typeof Symbol && t1[Symbol.iterator];
            if (!i) return t1;
            var n, r, a = i.call(t1), s = [];
            try {
                for(; (void 0 === e || e-- > 0) && !(n = a.next()).done;)s.push(n.value);
            } catch (t1) {
                r = {
                    error: t1
                };
            } finally{
                try {
                    n && !n.done && (i = a.return) && i.call(a);
                } finally{
                    if (r) throw r.error;
                }
            }
            return s;
        };
        function zS(t1) {
            return "observer".concat(t1);
        }
        var LS = function() {};
        function OS() {
            return new LS;
        }
        var PS = "function" == typeof Symbol && Symbol.for, jS = PS ? Symbol.for("react.forward_ref") : "function" == typeof e.forwardRef && (0, e.forwardRef)(function(t1) {
            return null;
        }).$$typeof, RS = PS ? Symbol.for("react.memo") : "function" == typeof e.memo && (0, e.memo)(function(t1) {
            return null;
        }).$$typeof;
        function kS(t1, i) {
            var n;
            if (RS && t1.$$typeof === RS) throw new Error("[mobx-react-lite] You are trying to use `observer` on a function component wrapped in either another `observer` or `React.memo`. The observer already applies 'React.memo' for you.");
            if (DS()) return t1;
            var r = null !== (n = null == i ? void 0 : i.forwardRef) && void 0 !== n && n, a = t1, s = t1.displayName || t1.name;
            if (jS && t1.$$typeof === jS && (r = !0, "function" != typeof (a = t1.render))) throw new Error("[mobx-react-lite] `render` property of ForwardRef was not a function");
            var o, l, c = function(t1, i) {
                return function(t1, i) {
                    if (void 0 === i && (i = "observed"), DS()) return t1();
                    var n = CS(e.useState(OS), 1)[0], r = CS(e.useState(), 2)[1], a = function() {
                        return r([]);
                    }, s = e.useRef(null);
                    s.current || (s.current = {
                        reaction: null,
                        mounted: !1,
                        changedBeforeMount: !1
                    });
                    var o, l, c = s.current;
                    if (c.reaction || (c.reaction = new He(zS(i), function() {
                        c.mounted ? a() : c.changedBeforeMount = !0;
                    }), SS.register(n, c, c)), e.useDebugValue(c.reaction, _S), e.useEffect(function() {
                        return SS.unregister(c), c.mounted = !0, c.reaction ? c.changedBeforeMount && (c.changedBeforeMount = !1, a()) : (c.reaction = new He(zS(i), function() {
                            a();
                        }), a()), function() {
                            c.reaction.dispose(), c.reaction = null, c.mounted = !1, c.changedBeforeMount = !1;
                        };
                    }, []), c.reaction.track(function() {
                        try {
                            o = t1();
                        } catch (t1) {
                            l = t1;
                        }
                    }), l) throw l;
                    return o;
                }(function() {
                    return a(t1, i);
                }, s);
            };
            return "" !== s && (c.displayName = s), t1.contextTypes && (c.contextTypes = t1.contextTypes), r && (c = (0, e.forwardRef)(c)), c = (0, e.memo)(c), o = t1, l = c, Object.keys(o).forEach(function(t1) {
                US[t1] || Object.defineProperty(l, t1, Object.getOwnPropertyDescriptor(o, t1));
            }), c;
        }
        var US = {
            $$typeof: !0,
            render: !0,
            compare: !0,
            type: !0,
            displayName: !0
        };
        !function(t1) {
            t1 || (t1 = ES), hi({
                reactionScheduler: t1
            });
        }(TS.unstable_batchedUpdates), SS.finalizeAllImmediately;
        const BS = {
            smallMobile: 374,
            mobile: 670,
            tablet: 1100,
            laptop: 1440
        }, FS = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTEiIGhlaWdodD0iNTEiIHZpZXdCb3g9IjAgMCA1MSA1MSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTM5LjQwODkgMTAuMjc2OUwxMS4wMzQ1IDM4LjY1MTMiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIzLjE1MjcxIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTM5LjQwODkgMzguNjUxM0wxMS4wMzQ1IDEwLjI3NjkiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIzLjE1MjcxIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==", QS = kS(()=>Wn.enabled ? Wn.active ? e.createElement("button", {
                type: "button",
                className: "widget-exit-fullscreen",
                onClick: ()=>Wn.exit()
            }, e.createElement("img", {
                src: FS,
                alt: "exit-fullscreen"
            })) : e.createElement("button", {
                type: "button",
                className: "widget-enter-fullscreen",
                onClick: ()=>Wn.enter()
            }, e.createElement("img", {
                src: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTEiIHZpZXdCb3g9IjAgMCA1MCA1MSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMxLjI1IDkuODc1SDQwLjYyNVYxOS4yNSIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjMuMTUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMjkuNjg3NSAyMC44MTI1TDQwLjYyNSA5Ljg3NSIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjMuMTUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTguNzUgNDEuMTI1SDkuMzc1VjMxLjc1IiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMy4xNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yMC4zMTI1IDMwLjE4NzVMOS4zNzUgNDEuMTI1IiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMy4xNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=",
                alt: "enter-fullscreen"
            })) : null), HS = kS(()=>{
            const [t1, i] = (0, e.useState)(!1), n = (t1)=>zy("floor", t1), r = Un.config.floors.map((t1, e)=>({
                    label: n(e + 1),
                    value: e,
                    class: "floors-select--block-item",
                    classActive: "floors-select--block-item floors-select--block-item--active"
                }));
            return (0, e.useEffect)(()=>{
                document.addEventListener("click", (t1)=>{
                    t1.target.closest(".floors-select") || i(!1);
                });
            }, []), r.length > 1 && e.createElement("div", {
                id: "floors-select",
                onClick: ()=>i(!t1),
                className: "floors-select"
            }, e.createElement("div", {
                className: "floors-select--text"
            }, n(Un.currentFloorIndex + 1)), t1 && e.createElement("div", {
                className: "floors-select--block"
            }, r.map((t1)=>e.createElement("div", {
                    key: t1.value,
                    onClick: ()=>((t1)=>{
                            let { value: e } = t1;
                            Un.setCurrentFloorIndex(e), i(!1);
                        })(t1),
                    className: Un.currentFloorIndex === t1.value ? t1.classActive : t1.class
                }, t1.label))));
        }), VS = HS, GS = kS(()=>{
            const [t1, i] = (0, e.useState)(!1);
            return e.createElement("button", {
                type: "button",
                className: "widget-tab-button",
                disabled: t1,
                onClick: async ()=>{
                    i(!0), bS.enterVr().finally(()=>i(!1));
                }
            }, "VR");
        }), WS = (t1)=>{
            let { active: i, text: n, img: r, onClick: a } = t1;
            return e.createElement("button", {
                type: "button",
                className: "widget-tab-button ".concat(i ? "widget-tab-button--active" : ""),
                onClick: a
            }, n, Boolean(r) && e.createElement("img", {
                src: r,
                alt: "icon"
            }));
        }, YS = (t1)=>{
            let { href: i, text: n } = t1;
            return e.createElement("a", {
                href: i,
                target: "_blank",
                rel: "noreferrer"
            }, e.createElement("span", null, "made by"), " ", n);
        };
        var XS = i(611), ZS = i.n(XS);
        function qS(t1, e, i) {
            (function(t1, e) {
                if (e.has(t1)) throw new TypeError("Cannot initialize the same private elements twice on an object");
            })(t1, e), e.set(t1, i);
        }
        function JS(t1, e) {
            return t1.get($S(t1, e));
        }
        function KS(t1, e, i) {
            return t1.set($S(t1, e), i), i;
        }
        function $S(t1, e, i) {
            if ("function" == typeof t1 ? t1 === e : t1.has(e)) return arguments.length < 3 ? e : i;
            throw new TypeError("Private element is not present on this object");
        }
        var tN = new WeakMap, eN = new WeakMap, iN = new WeakMap;
        const nN = class {
            constructor(t1, e){
                qS(this, tN, null), qS(this, eN, null), qS(this, iN, null), KS(eN, this, e), KS(iN, this, {
                    container: {
                        mousedown: (t1)=>{
                            0 === t1.button && KS(tN, this, t1.pageX);
                        },
                        touchstart: (t1)=>KS(tN, this, t1.touches[0].clientX),
                        touchend: ()=>KS(tN, this, null)
                    },
                    prev: {
                        mousedown: (e)=>{
                            e.preventDefault(), t1.play(!0);
                        },
                        mouseup: (e)=>{
                            e.preventDefault(), t1.stop();
                        },
                        touchstart: (e)=>{
                            e.preventDefault(), t1.prev();
                        }
                    },
                    next: {
                        mousedown: (e)=>{
                            e.preventDefault(), t1.play();
                        },
                        mouseup: (e)=>{
                            e.preventDefault(), t1.stop();
                        },
                        touchstart: (e)=>{
                            e.preventDefault(), t1.next();
                        }
                    },
                    global: {
                        mouseup: ()=>KS(tN, this, null),
                        mousemove: (e)=>{
                            JS(tN, this) && Math.abs(JS(tN, this) - e.pageX) > JS(eN, this).dragTolerance && (t1.stop(), JS(tN, this) > e.pageX ? t1.prev() : t1.next(), KS(tN, this, e.pageX));
                        },
                        touchmove: (e)=>{
                            2 !== e.touches.length && (1 === e.touches.length && e.stopPropagation(), JS(tN, this) && Math.abs(JS(tN, this) - e.touches[0].clientX) > JS(eN, this).swipeTolerance && (t1.stop(), JS(tN, this) > e.touches[0].clientX ? t1.prev() : t1.next(), KS(tN, this, e.touches[0].clientX)));
                        },
                        keydown: (e)=>{
                            [
                                37,
                                39
                            ].includes(e.keyCode) && t1.play(37 === e.keyCode);
                        },
                        keyup: (e)=>{
                            [
                                37,
                                39
                            ].includes(e.keyCode) && t1.stop();
                        }
                    }
                }), this._initEvents();
            }
            destroy() {
                JS(eN, this).swipeTarget.removeEventListener("mousedown", JS(iN, this).container.mousedown), JS(eN, this).swipeTarget.removeEventListener("touchstart", JS(iN, this).container.touchstart), JS(eN, this).swipeTarget.removeEventListener("touchend", JS(iN, this).container.touchend), i.g.removeEventListener("mouseup", JS(iN, this).global.mouseup), i.g.removeEventListener("mousemove", JS(iN, this).global.mousemove), JS(eN, this).parentElement.removeEventListener("touchmove", JS(iN, this).global.touchmove), i.g.removeEventListener("keydown", JS(iN, this).global.keydown), i.g.removeEventListener("keyup", JS(iN, this).global.keyup), JS(eN, this).prev && (JS(eN, this).prev.removeEventListener("mousedown", JS(iN, this).prev.mousedown), JS(eN, this).prev.removeEventListener("mouseup", JS(iN, this).prev.mouseup), JS(eN, this).prev.removeEventListener("touchstart", JS(iN, this).prev.touchstart)), JS(eN, this).next && (JS(eN, this).next.removeEventListener("mousedown", JS(iN, this).next.mousedown), JS(eN, this).next.removeEventListener("mouseup", JS(iN, this).next.mouseup), JS(eN, this).next.removeEventListener("touchstart", JS(iN, this).next.touchstart));
            }
            _initEvents() {
                JS(eN, this).draggable && (JS(eN, this).swipeTarget.addEventListener("mousedown", JS(iN, this).container.mousedown), i.g.addEventListener("mouseup", JS(iN, this).global.mouseup), i.g.addEventListener("mousemove", JS(iN, this).global.mousemove)), JS(eN, this).swipeable && (JS(eN, this).swipeTarget.addEventListener("touchstart", JS(iN, this).container.touchstart), JS(eN, this).swipeTarget.addEventListener("touchend", JS(iN, this).container.touchend), JS(eN, this).parentElement.addEventListener("touchmove", JS(iN, this).global.touchmove)), JS(eN, this).keys && (i.g.addEventListener("keydown", JS(iN, this).global.keydown), i.g.addEventListener("keyup", JS(iN, this).global.keyup)), JS(eN, this).prev && (JS(eN, this).prev.addEventListener("mousedown", JS(iN, this).prev.mousedown), JS(eN, this).prev.addEventListener("mouseup", JS(iN, this).prev.mouseup), JS(eN, this).prev.addEventListener("touchstart", JS(iN, this).prev.touchstart)), JS(eN, this).next && (JS(eN, this).next.addEventListener("mousedown", JS(iN, this).next.mousedown), JS(eN, this).next.addEventListener("mouseup", JS(iN, this).next.mouseup), JS(eN, this).next.addEventListener("touchstart", JS(iN, this).next.touchstart));
            }
        };
        function rN(t1, e, i) {
            (function(t1, e) {
                if (e.has(t1)) throw new TypeError("Cannot initialize the same private elements twice on an object");
            })(t1, e), e.set(t1, i);
        }
        function aN(t1, e) {
            return t1.get(oN(t1, e));
        }
        function sN(t1, e, i) {
            return t1.set(oN(t1, e), i), i;
        }
        function oN(t1, e, i) {
            if ("function" == typeof t1 ? t1 === e : t1.has(e)) return arguments.length < 3 ? e : i;
            throw new TypeError("Private element is not present on this object");
        }
        var lN = new WeakMap, cN = new WeakMap, uN = new WeakMap, hN = new WeakMap, dN = new WeakMap, pN = new WeakMap;
        const AN = class {
            constructor(t1, e){
                rN(this, lN, null), rN(this, cN, 0), rN(this, uN, null), rN(this, hN, !1), rN(this, dN, null), rN(this, pN, !1), this.container = t1, sN(lN, this, Object.assign({
                    width: 300,
                    height: 300,
                    aspectRatio: 0,
                    count: 0,
                    perRow: 0,
                    speed: 100,
                    dragTolerance: 10,
                    swipeTolerance: 10,
                    draggable: !0,
                    swipeable: !0,
                    keys: !0,
                    inverted: !1
                }, e)), aN(lN, this).swipeTarget = aN(lN, this).swipeTarget || this.container, sN(pN, this, !Array.isArray(aN(lN, this).image)), this.sprite || (aN(lN, this).count = aN(lN, this).image.length), Object.freeze(aN(lN, this)), sN(dN, this, new nN(this, aN(lN, this))), this._windowResizeListener = this._windowResizeListener.bind(this), this._initContainer();
            }
            get isResponsive() {
                return aN(lN, this).aspectRatio > 0;
            }
            get containerWidth() {
                return this.isResponsive ? this.container.clientWidth : aN(lN, this).width;
            }
            get containerHeight() {
                return this.isResponsive ? this.container.clientWidth * aN(lN, this).aspectRatio : aN(lN, this).height;
            }
            get index() {
                return aN(cN, this);
            }
            get looping() {
                return aN(hN, this);
            }
            get sprite() {
                return aN(pN, this);
            }
            next() {
                this.goto(aN(lN, this).inverted ? aN(cN, this) - 1 : aN(cN, this) + 1);
            }
            prev() {
                this.goto(aN(lN, this).inverted ? aN(cN, this) + 1 : aN(cN, this) - 1);
            }
            goto(t1) {
                sN(cN, this, (aN(lN, this).count + t1) % aN(lN, this).count), this._update();
            }
            play(t1) {
                this.looping || (this._loop(t1), sN(hN, this, !0));
            }
            stop() {
                this.looping && (i.g.clearTimeout(aN(uN, this)), sN(hN, this, !1));
            }
            toggle(t1) {
                this.looping ? this.stop() : this.play(t1);
            }
            destroy() {
                this.stop(), aN(dN, this).destroy(), this.container.style.width = "", this.container.style.height = "", this.container.style.backgroundImage = "", this.container.style.backgroundPositionX = "", this.container.style.backgroundPositionY = "", this.container.style.backgroundSize = "", this.isResponsive && window.removeEventListener("resize", this._windowResizeListener);
            }
            _loop(t1) {
                t1 ? this.prev() : this.next(), sN(uN, this, i.g.setTimeout(()=>{
                    this._loop(t1);
                }, aN(lN, this).speed));
            }
            _update() {
                this.sprite ? (this.container.style.backgroundPositionX = -aN(cN, this) % aN(lN, this).perRow * this.containerWidth + "px", this.container.style.backgroundPositionY = -Math.floor(aN(cN, this) / aN(lN, this).perRow) * this.containerHeight + "px") : this.container.style.backgroundImage = 'url("'.concat(aN(lN, this).image[aN(cN, this)], '")');
            }
            _windowResizeListener() {
                this.container.style.height = this.containerHeight + "px", this._update();
            }
            _initContainer() {
                if (this.isResponsive || (this.container.style.width = this.containerWidth + "px"), this.container.style.height = this.containerHeight + "px", this.sprite) {
                    this.container.style.backgroundImage = 'url("'.concat(aN(lN, this).image, '")');
                    const t1 = aN(lN, this).perRow, e = Math.ceil(aN(lN, this).count / aN(lN, this).perRow);
                    this.container.style.backgroundSize = 100 * t1 + "% " + 100 * e + "%";
                }
                this.isResponsive && window.addEventListener("resize", this._windowResizeListener), this._update();
            }
        }, fN = (t1)=>{
            let { initialized: i, images: n, activeIndex: r } = t1;
            return e.createElement(e.Fragment, null, e.createElement("div", {
                className: "widget-tab__threesixty ".concat(i ? "widget-tab__threesixty--active" : "")
            }, e.createElement("div", {
                className: "widget-tab__threesixty-container",
                onTouchMove: (t1)=>{
                    t1.touches.length > 1 || i || t1.stopPropagation();
                }
            }, n.map((t1, i)=>e.createElement("img", {
                    className: r === i ? "active" : "",
                    alt: "rotation-view-".concat(i),
                    key: i,
                    src: t1
                })))));
        }, mN = (t1)=>{
            let { steps: i = [], disabled: n = !1, onClick: r = ()=>{} } = t1;
            const a = zy("instructions-hint-text");
            return e.createElement("div", {
                className: "widget-instructions",
                onClick: ()=>{
                    n || r();
                }
            }, e.createElement("div", {
                className: "widget-instructions__content",
                onClick: (t1)=>t1.stopPropagation()
            }, e.createElement("div", {
                className: "widget-instructions__steps"
            }, i.map((t1, i)=>{
                let { text: n, icon: r } = t1;
                return e.createElement("div", {
                    className: "widget-instructions__step",
                    key: i
                }, e.createElement("img", {
                    src: r,
                    alt: "step-icon"
                }), e.createElement("p", null, n));
            })), e.createElement("button", {
                disabled: n,
                onClick: r,
                type: "button"
            }, zy("ok")), Boolean(a) && e.createElement("div", {
                className: "widget-instructions__hint"
            }, e.createElement("p", null, a))));
        };
        class gN {
            constructor(t1 = 0, e = 0, i = 0, n = 1){
                gN.prototype.isVector4 = !0, this.x = t1, this.y = e, this.z = i, this.w = n;
            }
            get width() {
                return this.z;
            }
            set width(t1) {
                this.z = t1;
            }
            get height() {
                return this.w;
            }
            set height(t1) {
                this.w = t1;
            }
            set(t1, e, i, n) {
                return this.x = t1, this.y = e, this.z = i, this.w = n, this;
            }
            setScalar(t1) {
                return this.x = t1, this.y = t1, this.z = t1, this.w = t1, this;
            }
            setX(t1) {
                return this.x = t1, this;
            }
            setY(t1) {
                return this.y = t1, this;
            }
            setZ(t1) {
                return this.z = t1, this;
            }
            setW(t1) {
                return this.w = t1, this;
            }
            setComponent(t1, e) {
                switch(t1){
                    case 0:
                        this.x = e;
                        break;
                    case 1:
                        this.y = e;
                        break;
                    case 2:
                        this.z = e;
                        break;
                    case 3:
                        this.w = e;
                        break;
                    default:
                        throw new Error("index is out of range: " + t1);
                }
                return this;
            }
            getComponent(t1) {
                switch(t1){
                    case 0:
                        return this.x;
                    case 1:
                        return this.y;
                    case 2:
                        return this.z;
                    case 3:
                        return this.w;
                    default:
                        throw new Error("index is out of range: " + t1);
                }
            }
            clone() {
                return new this.constructor(this.x, this.y, this.z, this.w);
            }
            copy(t1) {
                return this.x = t1.x, this.y = t1.y, this.z = t1.z, this.w = void 0 !== t1.w ? t1.w : 1, this;
            }
            add(t1) {
                return this.x += t1.x, this.y += t1.y, this.z += t1.z, this.w += t1.w, this;
            }
            addScalar(t1) {
                return this.x += t1, this.y += t1, this.z += t1, this.w += t1, this;
            }
            addVectors(t1, e) {
                return this.x = t1.x + e.x, this.y = t1.y + e.y, this.z = t1.z + e.z, this.w = t1.w + e.w, this;
            }
            addScaledVector(t1, e) {
                return this.x += t1.x * e, this.y += t1.y * e, this.z += t1.z * e, this.w += t1.w * e, this;
            }
            sub(t1) {
                return this.x -= t1.x, this.y -= t1.y, this.z -= t1.z, this.w -= t1.w, this;
            }
            subScalar(t1) {
                return this.x -= t1, this.y -= t1, this.z -= t1, this.w -= t1, this;
            }
            subVectors(t1, e) {
                return this.x = t1.x - e.x, this.y = t1.y - e.y, this.z = t1.z - e.z, this.w = t1.w - e.w, this;
            }
            multiply(t1) {
                return this.x *= t1.x, this.y *= t1.y, this.z *= t1.z, this.w *= t1.w, this;
            }
            multiplyScalar(t1) {
                return this.x *= t1, this.y *= t1, this.z *= t1, this.w *= t1, this;
            }
            applyMatrix4(t1) {
                const e = this.x, i = this.y, n = this.z, r = this.w, a = t1.elements;
                return this.x = a[0] * e + a[4] * i + a[8] * n + a[12] * r, this.y = a[1] * e + a[5] * i + a[9] * n + a[13] * r, this.z = a[2] * e + a[6] * i + a[10] * n + a[14] * r, this.w = a[3] * e + a[7] * i + a[11] * n + a[15] * r, this;
            }
            divideScalar(t1) {
                return this.multiplyScalar(1 / t1);
            }
            setAxisAngleFromQuaternion(t1) {
                this.w = 2 * Math.acos(t1.w);
                const e = Math.sqrt(1 - t1.w * t1.w);
                return e < 1e-4 ? (this.x = 1, this.y = 0, this.z = 0) : (this.x = t1.x / e, this.y = t1.y / e, this.z = t1.z / e), this;
            }
            setAxisAngleFromRotationMatrix(t1) {
                let e, i, n, r;
                const a = .01, s = .1, o = t1.elements, l = o[0], c = o[4], u = o[8], h = o[1], d = o[5], p = o[9], A = o[2], f = o[6], m = o[10];
                if (Math.abs(c - h) < a && Math.abs(u - A) < a && Math.abs(p - f) < a) {
                    if (Math.abs(c + h) < s && Math.abs(u + A) < s && Math.abs(p + f) < s && Math.abs(l + d + m - 3) < s) return this.set(1, 0, 0, 0), this;
                    e = Math.PI;
                    const t1 = (l + 1) / 2, o = (d + 1) / 2, g = (m + 1) / 2, M = (c + h) / 4, v = (u + A) / 4, y = (p + f) / 4;
                    return t1 > o && t1 > g ? t1 < a ? (i = 0, n = .707106781, r = .707106781) : (i = Math.sqrt(t1), n = M / i, r = v / i) : o > g ? o < a ? (i = .707106781, n = 0, r = .707106781) : (n = Math.sqrt(o), i = M / n, r = y / n) : g < a ? (i = .707106781, n = .707106781, r = 0) : (r = Math.sqrt(g), i = v / r, n = y / r), this.set(i, n, r, e), this;
                }
                let g = Math.sqrt((f - p) * (f - p) + (u - A) * (u - A) + (h - c) * (h - c));
                return Math.abs(g) < .001 && (g = 1), this.x = (f - p) / g, this.y = (u - A) / g, this.z = (h - c) / g, this.w = Math.acos((l + d + m - 1) / 2), this;
            }
            min(t1) {
                return this.x = Math.min(this.x, t1.x), this.y = Math.min(this.y, t1.y), this.z = Math.min(this.z, t1.z), this.w = Math.min(this.w, t1.w), this;
            }
            max(t1) {
                return this.x = Math.max(this.x, t1.x), this.y = Math.max(this.y, t1.y), this.z = Math.max(this.z, t1.z), this.w = Math.max(this.w, t1.w), this;
            }
            clamp(t1, e) {
                return this.x = Math.max(t1.x, Math.min(e.x, this.x)), this.y = Math.max(t1.y, Math.min(e.y, this.y)), this.z = Math.max(t1.z, Math.min(e.z, this.z)), this.w = Math.max(t1.w, Math.min(e.w, this.w)), this;
            }
            clampScalar(t1, e) {
                return this.x = Math.max(t1, Math.min(e, this.x)), this.y = Math.max(t1, Math.min(e, this.y)), this.z = Math.max(t1, Math.min(e, this.z)), this.w = Math.max(t1, Math.min(e, this.w)), this;
            }
            clampLength(t1, e) {
                const i = this.length();
                return this.divideScalar(i || 1).multiplyScalar(Math.max(t1, Math.min(e, i)));
            }
            floor() {
                return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this.w = Math.floor(this.w), this;
            }
            ceil() {
                return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this.w = Math.ceil(this.w), this;
            }
            round() {
                return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this.w = Math.round(this.w), this;
            }
            roundToZero() {
                return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this.z = Math.trunc(this.z), this.w = Math.trunc(this.w), this;
            }
            negate() {
                return this.x = -this.x, this.y = -this.y, this.z = -this.z, this.w = -this.w, this;
            }
            dot(t1) {
                return this.x * t1.x + this.y * t1.y + this.z * t1.z + this.w * t1.w;
            }
            lengthSq() {
                return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
            }
            length() {
                return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
            }
            manhattanLength() {
                return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
            }
            normalize() {
                return this.divideScalar(this.length() || 1);
            }
            setLength(t1) {
                return this.normalize().multiplyScalar(t1);
            }
            lerp(t1, e) {
                return this.x += (t1.x - this.x) * e, this.y += (t1.y - this.y) * e, this.z += (t1.z - this.z) * e, this.w += (t1.w - this.w) * e, this;
            }
            lerpVectors(t1, e, i) {
                return this.x = t1.x + (e.x - t1.x) * i, this.y = t1.y + (e.y - t1.y) * i, this.z = t1.z + (e.z - t1.z) * i, this.w = t1.w + (e.w - t1.w) * i, this;
            }
            equals(t1) {
                return t1.x === this.x && t1.y === this.y && t1.z === this.z && t1.w === this.w;
            }
            fromArray(t1, e = 0) {
                return this.x = t1[e], this.y = t1[e + 1], this.z = t1[e + 2], this.w = t1[e + 3], this;
            }
            toArray(t1 = [], e = 0) {
                return t1[e] = this.x, t1[e + 1] = this.y, t1[e + 2] = this.z, t1[e + 3] = this.w, t1;
            }
            fromBufferAttribute(t1, e) {
                return this.x = t1.getX(e), this.y = t1.getY(e), this.z = t1.getZ(e), this.w = t1.getW(e), this;
            }
            random() {
                return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this.w = Math.random(), this;
            }
            *[Symbol.iterator]() {
                yield this.x, yield this.y, yield this.z, yield this.w;
            }
        }
        const MN = {
            enabled: !1,
            files: {},
            add: function(t1, e) {
                !1 !== this.enabled && (this.files[t1] = e);
            },
            get: function(t1) {
                if (!1 !== this.enabled) return this.files[t1];
            },
            remove: function(t1) {
                delete this.files[t1];
            },
            clear: function() {
                this.files = {};
            }
        };
        class vN {
            constructor(t1, e, i){
                const n = this;
                let r, a = !1, s = 0, o = 0;
                const l = [];
                this.onStart = void 0, this.onLoad = t1, this.onProgress = e, this.onError = i, this.itemStart = function(t1) {
                    o++, !1 === a && void 0 !== n.onStart && n.onStart(t1, s, o), a = !0;
                }, this.itemEnd = function(t1) {
                    s++, void 0 !== n.onProgress && n.onProgress(t1, s, o), s === o && (a = !1, void 0 !== n.onLoad && n.onLoad());
                }, this.itemError = function(t1) {
                    void 0 !== n.onError && n.onError(t1);
                }, this.resolveURL = function(t1) {
                    return r ? r(t1) : t1;
                }, this.setURLModifier = function(t1) {
                    return r = t1, this;
                }, this.addHandler = function(t1, e) {
                    return l.push(t1, e), this;
                }, this.removeHandler = function(t1) {
                    const e = l.indexOf(t1);
                    return -1 !== e && l.splice(e, 2), this;
                }, this.getHandler = function(t1) {
                    for(let e = 0, i = l.length; e < i; e += 2){
                        const i = l[e], n = l[e + 1];
                        if (i.global && (i.lastIndex = 0), i.test(t1)) return n;
                    }
                    return null;
                };
            }
        }
        const yN = new vN;
        class xN {
            constructor(t1){
                this.manager = void 0 !== t1 ? t1 : yN, this.crossOrigin = "anonymous", this.withCredentials = !1, this.path = "", this.resourcePath = "", this.requestHeader = {};
            }
            load() {}
            loadAsync(t1, e) {
                const i = this;
                return new Promise(function(n, r) {
                    i.load(t1, n, e, r);
                });
            }
            parse() {}
            setCrossOrigin(t1) {
                return this.crossOrigin = t1, this;
            }
            setWithCredentials(t1) {
                return this.withCredentials = t1, this;
            }
            setPath(t1) {
                return this.path = t1, this;
            }
            setResourcePath(t1) {
                return this.resourcePath = t1, this;
            }
            setRequestHeader(t1) {
                return this.requestHeader = t1, this;
            }
        }
        function wN(t1) {
            return document.createElementNS("http://www.w3.org/1999/xhtml", t1);
        }
        xN.DEFAULT_MATERIAL_NAME = "__DEFAULT", Int8Array, Uint8Array, Uint8ClampedArray, Int16Array, Uint16Array, Int32Array, Uint32Array, Float32Array, Float64Array;
        const bN = {};
        function TN(t1) {
            t1 in bN || (bN[t1] = !0, console.warn(t1));
        }
        class EN extends xN {
            constructor(t1){
                super(t1);
            }
            load(t1, e, i, n) {
                void 0 !== this.path && (t1 = this.path + t1), t1 = this.manager.resolveURL(t1);
                const r = this, a = MN.get(t1);
                if (void 0 !== a) return r.manager.itemStart(t1), setTimeout(function() {
                    e && e(a), r.manager.itemEnd(t1);
                }, 0), a;
                const s = wN("img");
                function o() {
                    c(), MN.add(t1, this), e && e(this), r.manager.itemEnd(t1);
                }
                function l(e) {
                    c(), n && n(e), r.manager.itemError(t1), r.manager.itemEnd(t1);
                }
                function c() {
                    s.removeEventListener("load", o, !1), s.removeEventListener("error", l, !1);
                }
                return s.addEventListener("load", o, !1), s.addEventListener("error", l, !1), "data:" !== t1.slice(0, 5) && void 0 !== this.crossOrigin && (s.crossOrigin = this.crossOrigin), r.manager.itemStart(t1), s.src = t1, s;
            }
        }
        class _N {
            addEventListener(t1, e) {
                void 0 === this._listeners && (this._listeners = {});
                const i = this._listeners;
                void 0 === i[t1] && (i[t1] = []), -1 === i[t1].indexOf(e) && i[t1].push(e);
            }
            hasEventListener(t1, e) {
                if (void 0 === this._listeners) return !1;
                const i = this._listeners;
                return void 0 !== i[t1] && -1 !== i[t1].indexOf(e);
            }
            removeEventListener(t1, e) {
                if (void 0 === this._listeners) return;
                const i = this._listeners[t1];
                if (void 0 !== i) {
                    const t1 = i.indexOf(e);
                    -1 !== t1 && i.splice(t1, 1);
                }
            }
            dispatchEvent(t1) {
                if (void 0 === this._listeners) return;
                const e = this._listeners[t1.type];
                if (void 0 !== e) {
                    t1.target = this;
                    const i = e.slice(0);
                    for(let e = 0, n = i.length; e < n; e++)i[e].call(this, t1);
                    t1.target = null;
                }
            }
        }
        const IN = 3001, SN = "srgb", NN = [
            "00",
            "01",
            "02",
            "03",
            "04",
            "05",
            "06",
            "07",
            "08",
            "09",
            "0a",
            "0b",
            "0c",
            "0d",
            "0e",
            "0f",
            "10",
            "11",
            "12",
            "13",
            "14",
            "15",
            "16",
            "17",
            "18",
            "19",
            "1a",
            "1b",
            "1c",
            "1d",
            "1e",
            "1f",
            "20",
            "21",
            "22",
            "23",
            "24",
            "25",
            "26",
            "27",
            "28",
            "29",
            "2a",
            "2b",
            "2c",
            "2d",
            "2e",
            "2f",
            "30",
            "31",
            "32",
            "33",
            "34",
            "35",
            "36",
            "37",
            "38",
            "39",
            "3a",
            "3b",
            "3c",
            "3d",
            "3e",
            "3f",
            "40",
            "41",
            "42",
            "43",
            "44",
            "45",
            "46",
            "47",
            "48",
            "49",
            "4a",
            "4b",
            "4c",
            "4d",
            "4e",
            "4f",
            "50",
            "51",
            "52",
            "53",
            "54",
            "55",
            "56",
            "57",
            "58",
            "59",
            "5a",
            "5b",
            "5c",
            "5d",
            "5e",
            "5f",
            "60",
            "61",
            "62",
            "63",
            "64",
            "65",
            "66",
            "67",
            "68",
            "69",
            "6a",
            "6b",
            "6c",
            "6d",
            "6e",
            "6f",
            "70",
            "71",
            "72",
            "73",
            "74",
            "75",
            "76",
            "77",
            "78",
            "79",
            "7a",
            "7b",
            "7c",
            "7d",
            "7e",
            "7f",
            "80",
            "81",
            "82",
            "83",
            "84",
            "85",
            "86",
            "87",
            "88",
            "89",
            "8a",
            "8b",
            "8c",
            "8d",
            "8e",
            "8f",
            "90",
            "91",
            "92",
            "93",
            "94",
            "95",
            "96",
            "97",
            "98",
            "99",
            "9a",
            "9b",
            "9c",
            "9d",
            "9e",
            "9f",
            "a0",
            "a1",
            "a2",
            "a3",
            "a4",
            "a5",
            "a6",
            "a7",
            "a8",
            "a9",
            "aa",
            "ab",
            "ac",
            "ad",
            "ae",
            "af",
            "b0",
            "b1",
            "b2",
            "b3",
            "b4",
            "b5",
            "b6",
            "b7",
            "b8",
            "b9",
            "ba",
            "bb",
            "bc",
            "bd",
            "be",
            "bf",
            "c0",
            "c1",
            "c2",
            "c3",
            "c4",
            "c5",
            "c6",
            "c7",
            "c8",
            "c9",
            "ca",
            "cb",
            "cc",
            "cd",
            "ce",
            "cf",
            "d0",
            "d1",
            "d2",
            "d3",
            "d4",
            "d5",
            "d6",
            "d7",
            "d8",
            "d9",
            "da",
            "db",
            "dc",
            "dd",
            "de",
            "df",
            "e0",
            "e1",
            "e2",
            "e3",
            "e4",
            "e5",
            "e6",
            "e7",
            "e8",
            "e9",
            "ea",
            "eb",
            "ec",
            "ed",
            "ee",
            "ef",
            "f0",
            "f1",
            "f2",
            "f3",
            "f4",
            "f5",
            "f6",
            "f7",
            "f8",
            "f9",
            "fa",
            "fb",
            "fc",
            "fd",
            "fe",
            "ff"
        ];
        function DN() {
            const t1 = 4294967295 * Math.random() | 0, e = 4294967295 * Math.random() | 0, i = 4294967295 * Math.random() | 0, n = 4294967295 * Math.random() | 0;
            return (NN[255 & t1] + NN[t1 >> 8 & 255] + NN[t1 >> 16 & 255] + NN[t1 >> 24 & 255] + "-" + NN[255 & e] + NN[e >> 8 & 255] + "-" + NN[e >> 16 & 15 | 64] + NN[e >> 24 & 255] + "-" + NN[63 & i | 128] + NN[i >> 8 & 255] + "-" + NN[i >> 16 & 255] + NN[i >> 24 & 255] + NN[255 & n] + NN[n >> 8 & 255] + NN[n >> 16 & 255] + NN[n >> 24 & 255]).toLowerCase();
        }
        function CN(t1, e, i) {
            return Math.max(e, Math.min(i, t1));
        }
        Math.PI, Math.PI;
        class zN {
            constructor(t1 = 0, e = 0){
                zN.prototype.isVector2 = !0, this.x = t1, this.y = e;
            }
            get width() {
                return this.x;
            }
            set width(t1) {
                this.x = t1;
            }
            get height() {
                return this.y;
            }
            set height(t1) {
                this.y = t1;
            }
            set(t1, e) {
                return this.x = t1, this.y = e, this;
            }
            setScalar(t1) {
                return this.x = t1, this.y = t1, this;
            }
            setX(t1) {
                return this.x = t1, this;
            }
            setY(t1) {
                return this.y = t1, this;
            }
            setComponent(t1, e) {
                switch(t1){
                    case 0:
                        this.x = e;
                        break;
                    case 1:
                        this.y = e;
                        break;
                    default:
                        throw new Error("index is out of range: " + t1);
                }
                return this;
            }
            getComponent(t1) {
                switch(t1){
                    case 0:
                        return this.x;
                    case 1:
                        return this.y;
                    default:
                        throw new Error("index is out of range: " + t1);
                }
            }
            clone() {
                return new this.constructor(this.x, this.y);
            }
            copy(t1) {
                return this.x = t1.x, this.y = t1.y, this;
            }
            add(t1) {
                return this.x += t1.x, this.y += t1.y, this;
            }
            addScalar(t1) {
                return this.x += t1, this.y += t1, this;
            }
            addVectors(t1, e) {
                return this.x = t1.x + e.x, this.y = t1.y + e.y, this;
            }
            addScaledVector(t1, e) {
                return this.x += t1.x * e, this.y += t1.y * e, this;
            }
            sub(t1) {
                return this.x -= t1.x, this.y -= t1.y, this;
            }
            subScalar(t1) {
                return this.x -= t1, this.y -= t1, this;
            }
            subVectors(t1, e) {
                return this.x = t1.x - e.x, this.y = t1.y - e.y, this;
            }
            multiply(t1) {
                return this.x *= t1.x, this.y *= t1.y, this;
            }
            multiplyScalar(t1) {
                return this.x *= t1, this.y *= t1, this;
            }
            divide(t1) {
                return this.x /= t1.x, this.y /= t1.y, this;
            }
            divideScalar(t1) {
                return this.multiplyScalar(1 / t1);
            }
            applyMatrix3(t1) {
                const e = this.x, i = this.y, n = t1.elements;
                return this.x = n[0] * e + n[3] * i + n[6], this.y = n[1] * e + n[4] * i + n[7], this;
            }
            min(t1) {
                return this.x = Math.min(this.x, t1.x), this.y = Math.min(this.y, t1.y), this;
            }
            max(t1) {
                return this.x = Math.max(this.x, t1.x), this.y = Math.max(this.y, t1.y), this;
            }
            clamp(t1, e) {
                return this.x = Math.max(t1.x, Math.min(e.x, this.x)), this.y = Math.max(t1.y, Math.min(e.y, this.y)), this;
            }
            clampScalar(t1, e) {
                return this.x = Math.max(t1, Math.min(e, this.x)), this.y = Math.max(t1, Math.min(e, this.y)), this;
            }
            clampLength(t1, e) {
                const i = this.length();
                return this.divideScalar(i || 1).multiplyScalar(Math.max(t1, Math.min(e, i)));
            }
            floor() {
                return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this;
            }
            ceil() {
                return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this;
            }
            round() {
                return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
            }
            roundToZero() {
                return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this;
            }
            negate() {
                return this.x = -this.x, this.y = -this.y, this;
            }
            dot(t1) {
                return this.x * t1.x + this.y * t1.y;
            }
            cross(t1) {
                return this.x * t1.y - this.y * t1.x;
            }
            lengthSq() {
                return this.x * this.x + this.y * this.y;
            }
            length() {
                return Math.sqrt(this.x * this.x + this.y * this.y);
            }
            manhattanLength() {
                return Math.abs(this.x) + Math.abs(this.y);
            }
            normalize() {
                return this.divideScalar(this.length() || 1);
            }
            angle() {
                return Math.atan2(-this.y, -this.x) + Math.PI;
            }
            angleTo(t1) {
                const e = Math.sqrt(this.lengthSq() * t1.lengthSq());
                if (0 === e) return Math.PI / 2;
                const i = this.dot(t1) / e;
                return Math.acos(CN(i, -1, 1));
            }
            distanceTo(t1) {
                return Math.sqrt(this.distanceToSquared(t1));
            }
            distanceToSquared(t1) {
                const e = this.x - t1.x, i = this.y - t1.y;
                return e * e + i * i;
            }
            manhattanDistanceTo(t1) {
                return Math.abs(this.x - t1.x) + Math.abs(this.y - t1.y);
            }
            setLength(t1) {
                return this.normalize().multiplyScalar(t1);
            }
            lerp(t1, e) {
                return this.x += (t1.x - this.x) * e, this.y += (t1.y - this.y) * e, this;
            }
            lerpVectors(t1, e, i) {
                return this.x = t1.x + (e.x - t1.x) * i, this.y = t1.y + (e.y - t1.y) * i, this;
            }
            equals(t1) {
                return t1.x === this.x && t1.y === this.y;
            }
            fromArray(t1, e = 0) {
                return this.x = t1[e], this.y = t1[e + 1], this;
            }
            toArray(t1 = [], e = 0) {
                return t1[e] = this.x, t1[e + 1] = this.y, t1;
            }
            fromBufferAttribute(t1, e) {
                return this.x = t1.getX(e), this.y = t1.getY(e), this;
            }
            rotateAround(t1, e) {
                const i = Math.cos(e), n = Math.sin(e), r = this.x - t1.x, a = this.y - t1.y;
                return this.x = r * i - a * n + t1.x, this.y = r * n + a * i + t1.y, this;
            }
            random() {
                return this.x = Math.random(), this.y = Math.random(), this;
            }
            *[Symbol.iterator]() {
                yield this.x, yield this.y;
            }
        }
        class LN {
            constructor(t1, e, i, n, r, a, s, o, l){
                LN.prototype.isMatrix3 = !0, this.elements = [
                    1,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    1
                ], void 0 !== t1 && this.set(t1, e, i, n, r, a, s, o, l);
            }
            set(t1, e, i, n, r, a, s, o, l) {
                const c = this.elements;
                return c[0] = t1, c[1] = n, c[2] = s, c[3] = e, c[4] = r, c[5] = o, c[6] = i, c[7] = a, c[8] = l, this;
            }
            identity() {
                return this.set(1, 0, 0, 0, 1, 0, 0, 0, 1), this;
            }
            copy(t1) {
                const e = this.elements, i = t1.elements;
                return e[0] = i[0], e[1] = i[1], e[2] = i[2], e[3] = i[3], e[4] = i[4], e[5] = i[5], e[6] = i[6], e[7] = i[7], e[8] = i[8], this;
            }
            extractBasis(t1, e, i) {
                return t1.setFromMatrix3Column(this, 0), e.setFromMatrix3Column(this, 1), i.setFromMatrix3Column(this, 2), this;
            }
            setFromMatrix4(t1) {
                const e = t1.elements;
                return this.set(e[0], e[4], e[8], e[1], e[5], e[9], e[2], e[6], e[10]), this;
            }
            multiply(t1) {
                return this.multiplyMatrices(this, t1);
            }
            premultiply(t1) {
                return this.multiplyMatrices(t1, this);
            }
            multiplyMatrices(t1, e) {
                const i = t1.elements, n = e.elements, r = this.elements, a = i[0], s = i[3], o = i[6], l = i[1], c = i[4], u = i[7], h = i[2], d = i[5], p = i[8], A = n[0], f = n[3], m = n[6], g = n[1], M = n[4], v = n[7], y = n[2], x = n[5], w = n[8];
                return r[0] = a * A + s * g + o * y, r[3] = a * f + s * M + o * x, r[6] = a * m + s * v + o * w, r[1] = l * A + c * g + u * y, r[4] = l * f + c * M + u * x, r[7] = l * m + c * v + u * w, r[2] = h * A + d * g + p * y, r[5] = h * f + d * M + p * x, r[8] = h * m + d * v + p * w, this;
            }
            multiplyScalar(t1) {
                const e = this.elements;
                return e[0] *= t1, e[3] *= t1, e[6] *= t1, e[1] *= t1, e[4] *= t1, e[7] *= t1, e[2] *= t1, e[5] *= t1, e[8] *= t1, this;
            }
            determinant() {
                const t1 = this.elements, e = t1[0], i = t1[1], n = t1[2], r = t1[3], a = t1[4], s = t1[5], o = t1[6], l = t1[7], c = t1[8];
                return e * a * c - e * s * l - i * r * c + i * s * o + n * r * l - n * a * o;
            }
            invert() {
                const t1 = this.elements, e = t1[0], i = t1[1], n = t1[2], r = t1[3], a = t1[4], s = t1[5], o = t1[6], l = t1[7], c = t1[8], u = c * a - s * l, h = s * o - c * r, d = l * r - a * o, p = e * u + i * h + n * d;
                if (0 === p) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
                const A = 1 / p;
                return t1[0] = u * A, t1[1] = (n * l - c * i) * A, t1[2] = (s * i - n * a) * A, t1[3] = h * A, t1[4] = (c * e - n * o) * A, t1[5] = (n * r - s * e) * A, t1[6] = d * A, t1[7] = (i * o - l * e) * A, t1[8] = (a * e - i * r) * A, this;
            }
            transpose() {
                let t1;
                const e = this.elements;
                return t1 = e[1], e[1] = e[3], e[3] = t1, t1 = e[2], e[2] = e[6], e[6] = t1, t1 = e[5], e[5] = e[7], e[7] = t1, this;
            }
            getNormalMatrix(t1) {
                return this.setFromMatrix4(t1).invert().transpose();
            }
            transposeIntoArray(t1) {
                const e = this.elements;
                return t1[0] = e[0], t1[1] = e[3], t1[2] = e[6], t1[3] = e[1], t1[4] = e[4], t1[5] = e[7], t1[6] = e[2], t1[7] = e[5], t1[8] = e[8], this;
            }
            setUvTransform(t1, e, i, n, r, a, s) {
                const o = Math.cos(r), l = Math.sin(r);
                return this.set(i * o, i * l, -i * (o * a + l * s) + a + t1, -n * l, n * o, -n * (-l * a + o * s) + s + e, 0, 0, 1), this;
            }
            scale(t1, e) {
                return this.premultiply(ON.makeScale(t1, e)), this;
            }
            rotate(t1) {
                return this.premultiply(ON.makeRotation(-t1)), this;
            }
            translate(t1, e) {
                return this.premultiply(ON.makeTranslation(t1, e)), this;
            }
            makeTranslation(t1, e) {
                return t1.isVector2 ? this.set(1, 0, t1.x, 0, 1, t1.y, 0, 0, 1) : this.set(1, 0, t1, 0, 1, e, 0, 0, 1), this;
            }
            makeRotation(t1) {
                const e = Math.cos(t1), i = Math.sin(t1);
                return this.set(e, -i, 0, i, e, 0, 0, 0, 1), this;
            }
            makeScale(t1, e) {
                return this.set(t1, 0, 0, 0, e, 0, 0, 0, 1), this;
            }
            equals(t1) {
                const e = this.elements, i = t1.elements;
                for(let t1 = 0; t1 < 9; t1++)if (e[t1] !== i[t1]) return !1;
                return !0;
            }
            fromArray(t1, e = 0) {
                for(let i = 0; i < 9; i++)this.elements[i] = t1[i + e];
                return this;
            }
            toArray(t1 = [], e = 0) {
                const i = this.elements;
                return t1[e] = i[0], t1[e + 1] = i[1], t1[e + 2] = i[2], t1[e + 3] = i[3], t1[e + 4] = i[4], t1[e + 5] = i[5], t1[e + 6] = i[6], t1[e + 7] = i[7], t1[e + 8] = i[8], t1;
            }
            clone() {
                return (new this.constructor).fromArray(this.elements);
            }
        }
        const ON = new LN;
        function PN(t1) {
            return t1 < .04045 ? .0773993808 * t1 : Math.pow(.9478672986 * t1 + .0521327014, 2.4);
        }
        let jN;
        new Set([
            "srgb-linear",
            "display-p3-linear"
        ]);
        class RN {
            static getDataURL(t1) {
                if (/^data:/i.test(t1.src)) return t1.src;
                if ("undefined" == typeof HTMLCanvasElement) return t1.src;
                let e;
                if (t1 instanceof HTMLCanvasElement) e = t1;
                else {
                    void 0 === jN && (jN = wN("canvas")), jN.width = t1.width, jN.height = t1.height;
                    const i = jN.getContext("2d");
                    t1 instanceof ImageData ? i.putImageData(t1, 0, 0) : i.drawImage(t1, 0, 0, t1.width, t1.height), e = jN;
                }
                return e.width > 2048 || e.height > 2048 ? (console.warn("THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons", t1), e.toDataURL("image/jpeg", .6)) : e.toDataURL("image/png");
            }
            static sRGBToLinear(t1) {
                if ("undefined" != typeof HTMLImageElement && t1 instanceof HTMLImageElement || "undefined" != typeof HTMLCanvasElement && t1 instanceof HTMLCanvasElement || "undefined" != typeof ImageBitmap && t1 instanceof ImageBitmap) {
                    const e = wN("canvas");
                    e.width = t1.width, e.height = t1.height;
                    const i = e.getContext("2d");
                    i.drawImage(t1, 0, 0, t1.width, t1.height);
                    const n = i.getImageData(0, 0, t1.width, t1.height), r = n.data;
                    for(let t1 = 0; t1 < r.length; t1++)r[t1] = 255 * PN(r[t1] / 255);
                    return i.putImageData(n, 0, 0), e;
                }
                if (t1.data) {
                    const e = t1.data.slice(0);
                    for(let t1 = 0; t1 < e.length; t1++)e instanceof Uint8Array || e instanceof Uint8ClampedArray ? e[t1] = Math.floor(255 * PN(e[t1] / 255)) : e[t1] = PN(e[t1]);
                    return {
                        data: e,
                        width: t1.width,
                        height: t1.height
                    };
                }
                return console.warn("THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied."), t1;
            }
        }
        let kN = 0;
        class UN {
            constructor(t1 = null){
                this.isSource = !0, Object.defineProperty(this, "id", {
                    value: kN++
                }), this.uuid = DN(), this.data = t1, this.version = 0;
            }
            set needsUpdate(t1) {
                !0 === t1 && this.version++;
            }
            toJSON(t1) {
                const e = void 0 === t1 || "string" == typeof t1;
                if (!e && void 0 !== t1.images[this.uuid]) return t1.images[this.uuid];
                const i = {
                    uuid: this.uuid,
                    url: ""
                }, n = this.data;
                if (null !== n) {
                    let t1;
                    if (Array.isArray(n)) {
                        t1 = [];
                        for(let e = 0, i = n.length; e < i; e++)n[e].isDataTexture ? t1.push(BN(n[e].image)) : t1.push(BN(n[e]));
                    } else t1 = BN(n);
                    i.url = t1;
                }
                return e || (t1.images[this.uuid] = i), i;
            }
        }
        function BN(t1) {
            return "undefined" != typeof HTMLImageElement && t1 instanceof HTMLImageElement || "undefined" != typeof HTMLCanvasElement && t1 instanceof HTMLCanvasElement || "undefined" != typeof ImageBitmap && t1 instanceof ImageBitmap ? RN.getDataURL(t1) : t1.data ? {
                data: Array.from(t1.data),
                width: t1.width,
                height: t1.height,
                type: t1.data.constructor.name
            } : (console.warn("THREE.Texture: Unable to serialize Texture."), {});
        }
        let FN = 0;
        class QN extends _N {
            constructor(t1 = QN.DEFAULT_IMAGE, e = QN.DEFAULT_MAPPING, i = 1001, n = 1001, r = 1006, a = 1008, s = 1023, o = 1009, l = QN.DEFAULT_ANISOTROPY, c = ""){
                super(), this.isTexture = !0, Object.defineProperty(this, "id", {
                    value: FN++
                }), this.uuid = DN(), this.name = "", this.source = new UN(t1), this.mipmaps = [], this.mapping = e, this.channel = 0, this.wrapS = i, this.wrapT = n, this.magFilter = r, this.minFilter = a, this.anisotropy = l, this.format = s, this.internalFormat = null, this.type = o, this.offset = new zN(0, 0), this.repeat = new zN(1, 1), this.center = new zN(0, 0), this.rotation = 0, this.matrixAutoUpdate = !0, this.matrix = new LN, this.generateMipmaps = !0, this.premultiplyAlpha = !1, this.flipY = !0, this.unpackAlignment = 4, "string" == typeof c ? this.colorSpace = c : (TN("THREE.Texture: Property .encoding has been replaced by .colorSpace."), this.colorSpace = c === IN ? SN : ""), this.userData = {}, this.version = 0, this.onUpdate = null, this.isRenderTargetTexture = !1, this.needsPMREMUpdate = !1;
            }
            get image() {
                return this.source.data;
            }
            set image(t1 = null) {
                this.source.data = t1;
            }
            updateMatrix() {
                this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
            }
            clone() {
                return (new this.constructor).copy(this);
            }
            copy(t1) {
                return this.name = t1.name, this.source = t1.source, this.mipmaps = t1.mipmaps.slice(0), this.mapping = t1.mapping, this.channel = t1.channel, this.wrapS = t1.wrapS, this.wrapT = t1.wrapT, this.magFilter = t1.magFilter, this.minFilter = t1.minFilter, this.anisotropy = t1.anisotropy, this.format = t1.format, this.internalFormat = t1.internalFormat, this.type = t1.type, this.offset.copy(t1.offset), this.repeat.copy(t1.repeat), this.center.copy(t1.center), this.rotation = t1.rotation, this.matrixAutoUpdate = t1.matrixAutoUpdate, this.matrix.copy(t1.matrix), this.generateMipmaps = t1.generateMipmaps, this.premultiplyAlpha = t1.premultiplyAlpha, this.flipY = t1.flipY, this.unpackAlignment = t1.unpackAlignment, this.colorSpace = t1.colorSpace, this.userData = JSON.parse(JSON.stringify(t1.userData)), this.needsUpdate = !0, this;
            }
            toJSON(t1) {
                const e = void 0 === t1 || "string" == typeof t1;
                if (!e && void 0 !== t1.textures[this.uuid]) return t1.textures[this.uuid];
                const i = {
                    metadata: {
                        version: 4.6,
                        type: "Texture",
                        generator: "Texture.toJSON"
                    },
                    uuid: this.uuid,
                    name: this.name,
                    image: this.source.toJSON(t1).uuid,
                    mapping: this.mapping,
                    channel: this.channel,
                    repeat: [
                        this.repeat.x,
                        this.repeat.y
                    ],
                    offset: [
                        this.offset.x,
                        this.offset.y
                    ],
                    center: [
                        this.center.x,
                        this.center.y
                    ],
                    rotation: this.rotation,
                    wrap: [
                        this.wrapS,
                        this.wrapT
                    ],
                    format: this.format,
                    internalFormat: this.internalFormat,
                    type: this.type,
                    colorSpace: this.colorSpace,
                    minFilter: this.minFilter,
                    magFilter: this.magFilter,
                    anisotropy: this.anisotropy,
                    flipY: this.flipY,
                    generateMipmaps: this.generateMipmaps,
                    premultiplyAlpha: this.premultiplyAlpha,
                    unpackAlignment: this.unpackAlignment
                };
                return Object.keys(this.userData).length > 0 && (i.userData = this.userData), e || (t1.textures[this.uuid] = i), i;
            }
            dispose() {
                this.dispatchEvent({
                    type: "dispose"
                });
            }
            transformUv(t1) {
                if (300 !== this.mapping) return t1;
                if (t1.applyMatrix3(this.matrix), t1.x < 0 || t1.x > 1) switch(this.wrapS){
                    case 1e3:
                        t1.x = t1.x - Math.floor(t1.x);
                        break;
                    case 1001:
                        t1.x = t1.x < 0 ? 0 : 1;
                        break;
                    case 1002:
                        1 === Math.abs(Math.floor(t1.x) % 2) ? t1.x = Math.ceil(t1.x) - t1.x : t1.x = t1.x - Math.floor(t1.x);
                }
                if (t1.y < 0 || t1.y > 1) switch(this.wrapT){
                    case 1e3:
                        t1.y = t1.y - Math.floor(t1.y);
                        break;
                    case 1001:
                        t1.y = t1.y < 0 ? 0 : 1;
                        break;
                    case 1002:
                        1 === Math.abs(Math.floor(t1.y) % 2) ? t1.y = Math.ceil(t1.y) - t1.y : t1.y = t1.y - Math.floor(t1.y);
                }
                return this.flipY && (t1.y = 1 - t1.y), t1;
            }
            set needsUpdate(t1) {
                !0 === t1 && (this.version++, this.source.needsUpdate = !0);
            }
            get encoding() {
                return TN("THREE.Texture: Property .encoding has been replaced by .colorSpace."), this.colorSpace === SN ? IN : 3e3;
            }
            set encoding(t1) {
                TN("THREE.Texture: Property .encoding has been replaced by .colorSpace."), this.colorSpace = t1 === IN ? SN : "";
            }
        }
        QN.DEFAULT_IMAGE = null, QN.DEFAULT_MAPPING = 300, QN.DEFAULT_ANISOTROPY = 1;
        class HN extends xN {
            constructor(t1){
                super(t1);
            }
            load(t1, e, i, n) {
                const r = new QN, a = new EN(this.manager);
                return a.setCrossOrigin(this.crossOrigin), a.setPath(this.path), a.load(t1, function(t1) {
                    r.image = t1, r.needsUpdate = !0, void 0 !== e && e(r);
                }, i, n), r;
            }
        }
        class VN extends QN {
            constructor(t1 = null, e = 1, i = 1, n, r, a, s, o, l = 1003, c = 1003, u, h){
                super(null, a, s, o, l, c, n, r, u, h), this.isDataTexture = !0, this.image = {
                    data: t1,
                    width: e,
                    height: i
                }, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
            }
        }
        function GN(t1, e, i) {
            return (e = function(t1) {
                var e = function(t1) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var e = t1[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e)) in t1 ? Object.defineProperty(t1, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = i, t1;
        }
        hi({
            useProxies: "never"
        });
        const WN = new class {
            constructor(){
                GN(this, "roomMask", null), GN(this, "currentColor", {
                    R: 0,
                    G: 0,
                    B: 0,
                    A: 0
                }), GN(this, "fixedColor", {
                    R: 0,
                    G: 0,
                    B: 0,
                    A: 0
                }), GN(this, "textureImg", null), GN(this, "textureMask", null), zi(this);
            }
            getCurrentColorVector() {
                return new gN(this.currentColor.R, this.currentColor.G, this.currentColor.B, this.currentColor.A);
            }
            getFixedColorVector() {
                return new gN(this.fixedColor.R, this.fixedColor.G, this.fixedColor.B, this.fixedColor.A);
            }
            setRoomMask(t1) {
                this.roomMask = t1;
            }
            setCurrentColor(t1) {
                this.currentColor = t1;
            }
            setFixedColor(t1) {
                this.fixedColor = t1;
            }
            setTextureImg(t1) {
                const e = new HN;
                this.textureImg = e.load(t1);
            }
            setTextureMask(t1) {
                const e = new VN(t1.data, t1.width, t1.height);
                e.needsUpdate = !0, e.type = Ia, this.textureMask = e;
            }
        }, YN = kS((t1)=>{
            let { imgs: i, masks: n, activeIndex: r, visible: a } = t1;
            const s = (0, e.useRef)(null), [o, l] = (0, e.useState)(null);
            (0, e.useEffect)(()=>{
                const t1 = new fx;
                t1.type = Ia, t1.load(n[r], (t1, e)=>{
                    WN.setRoomMask(e), WN.setTextureImg(i[r]), WN.setTextureMask(e), o || h();
                });
            }, [
                r
            ]);
            const c = (t1, e)=>{
                const i = document.getElementsByClassName("widget-tab__isometry-container")[0].style.transform.match(/\((.*?)\)/)[1].split(",")[0], n = t1.getBoundingClientRect(), r = e.clientX - n.left, a = e.clientY - n.top, s = r / (i * t1.offsetWidth), o = a / (i * t1.offsetHeight);
                return Sx(s.toFixed(2), o.toFixed(2), WN.roomMask);
            }, u = (t1, e)=>{
                const i = c(t1, e);
                WN.setCurrentColor(i);
            }, h = ()=>{
                const t1 = s.current, e = new xh(-1, 1, 1, -1, 0, 1), i = new Wp, n = new uh(2, 2), r = {
                    texture1: {
                        value: WN.textureImg
                    },
                    texture2: {
                        value: WN.textureMask
                    },
                    color: {
                        type: "vec4",
                        value: new yl
                    },
                    fixedColor: {
                        type: "vec4",
                        value: new yl
                    }
                }, a = new Xu({
                    uniforms: r,
                    fragmentShader: "\n      varying vec2 vUv;\n\n      uniform vec4 color;\n      uniform vec4 fixedColor;\n      uniform sampler2D texture1; \n      uniform sampler2D texture2; \n\n      void main()	{\n        vec4 color1 = texture2D(texture1, vUv);\n        vec4 color2 = texture2D(texture2, vUv);\n\n        if (color2 == vec4(0.0, 0.0, 0.0, 1.0)) {\n          gl_FragColor = color1;\n        } else if (color2.r == fixedColor.r) {\n          gl_FragColor = mix(color1, vec4(95.0/255.0, 68.0/255.0, 155.0/255.0, 1.0), 0.6);\n        } else if (color2.r == color.r) {\n          gl_FragColor = mix(color1, vec4(95.0/255.0, 68.0/255.0, 155.0/255.0, 1.0), 0.3);\n        } else {\n          gl_FragColor = color1;\n        }\n      }\n\n  ",
                    vertexShader: "\n      varying vec2 vUv;\n\n      void main()	{\n\n          vUv = uv;\n          gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);\n\n      }\n  "
                }), o = new Fu(n, a);
                i.add(o);
                const h = new Qp({
                    preserveDrawingBuffer: !0,
                    antialias: !0,
                    alpha: !0
                });
                h.toneMapping = Zr, h.toneMappingExposure = 1, h.setPixelRatio(window.devicePixelRatio), h.setSize(3 * t1.offsetWidth, 3 * t1.offsetHeight), h.render(i, e), h.setAnimationLoop(()=>{
                    r.texture1.value = WN.textureImg, r.texture2.value = WN.textureMask, r.color = {
                        type: "vec4",
                        value: WN.getCurrentColorVector()
                    }, r.fixedColor = {
                        type: "vec4",
                        value: WN.getFixedColorVector()
                    }, h.render(i, e);
                }), t1.appendChild(h.domElement), l(h), ((t1, e)=>{
                    e.addEventListener("mousemove", (t1)=>{
                        u(e, t1);
                    }), e.addEventListener("onTouchStart", (t1)=>{
                        u(e, t1);
                    }), e.addEventListener("onTouchMove", (t1)=>{
                        u(e, t1);
                    }), e.addEventListener("onTouchEnd", (t1)=>{
                        u(e, t1);
                    }), e.addEventListener("click", (t1)=>{
                        ((t1, e)=>{
                            const i = c(t1, e);
                            WN.setFixedColor(i);
                        })(e, t1);
                    }), window.addEventListener("resize", ()=>t1.setSize(3 * e.offsetWidth, 3 * e.offsetHeight));
                })(h, t1);
            };
            return e.createElement("div", {
                ref: s,
                className: "widget-tab__isometry-shader ".concat(a ? "" : "hidden")
            });
        }), XN = YN, ZN = (t1)=>{
            let { topViewImage: i, topViewMask: n, activeIndex: r, currentStep: a, planImage: s, images: o, masks: l = [], steps: c, setCurrentStep: u, setActiveIndex: h } = t1;
            const d = "renders" === a ? [
                i,
                ...o
            ] : o, p = [];
            p.push(null != n ? n : ""), l && p.push(...l);
            const A = ()=>{
                const t1 = c.findIndex((t1)=>t1 === a);
                return c[t1 + 1] || c[0];
            }, f = (t1)=>{
                t1.preventDefault();
                const e = r + 1;
                h(d[e] ? e : 0);
            }, m = (t1)=>{
                t1.preventDefault();
                const e = r - 1;
                h(d[e] ? e : d.length - 1);
            };
            let g = {
                x: 0,
                y: 0
            };
            const M = ()=>g = {
                    x: 0,
                    y: 0
                };
            return e.createElement(e.Fragment, null, e.createElement("div", {
                className: "widget-tab__isometry"
            }, e.createElement("div", {
                className: "widget-tab__isometry-container",
                onTouchStart: (t1)=>{
                    if (t1.touches.length > 1) return;
                    const e = t1.touches[0];
                    g = {
                        x: e.screenX
                    };
                },
                onTouchMove: (t1)=>{
                    if (t1.touches.length > 1) return;
                    t1.stopPropagation();
                    const e = t1.touches[0], i = g.x - e.screenX;
                    "carousel" === a && 0 !== g.x && (i >= 100 ? (f(), M()) : i <= -100 && (m(), M()));
                },
                onTouchEnd: M
            }, e.createElement("img", {
                className: "widget-tab__isometry--plan ".concat("plan" === a ? "active" : ""),
                src: s,
                alt: "plan-view"
            }), "renders" !== a && e.createElement(e.Fragment, null, e.createElement("img", {
                className: "widget-tab__isometry--top-view ".concat("topView" === a ? "active" : ""),
                src: i,
                alt: "top-view"
            }), null == o ? void 0 : o.map((t1, i)=>e.createElement("img", {
                    className: "carousel" === a && r === i ? "active" : "",
                    alt: "rotation-view-".concat(i),
                    key: i,
                    src: t1
                }))), "renders" === a && e.createElement(e.Fragment, null, e.createElement(XN, {
                imgs: d,
                masks: p,
                activeIndex: r,
                visible: n && l || !l && n && 0 === r || l && !n && 0 !== r
            }), !n && e.createElement("img", {
                className: "widget-tab__isometry--top-view ".concat(0 === r ? "active" : ""),
                src: i,
                alt: "top-view"
            }), !l && e.createElement(e.Fragment, null, null == o ? void 0 : o.map((t1, i)=>e.createElement("img", {
                    className: r === i + 1 ? "active" : "",
                    alt: "rotation-view-".concat(i),
                    key: i,
                    src: t1
                })))))), ("carousel" === a || "renders" === a) && e.createElement("div", {
                className: "widget-tab__isometry-arrows"
            }, e.createElement("button", {
                className: "widget-tab__isometry-arrow widget-tab__isometry-arrow--prev",
                onClick: (t1)=>m(t1)
            }, e.createElement("img", {
                src: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI3IDE2SDUiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTE0IDdMNSAxNkwxNCAyNSIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K",
                alt: "arrow-left"
            })), e.createElement("span", null, r + 1, "/", d.length), e.createElement("button", {
                className: "widget-tab__isometry-arrow widget-tab__isometry-arrow--next",
                onClick: (t1)=>f(t1)
            }, e.createElement("img", {
                src: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUgMTZIMjciIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTE4IDdMMjcgMTZMMTggMjUiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==",
                alt: "arrow-right"
            }))), e.createElement("div", {
                className: "widget-tab__isometry-buttons"
            }, c.length > 1 && e.createElement("button", {
                className: "widget-tab__isometry-button",
                onClick: ()=>u(A())
            }, e.createElement("img", {
                src: (()=>{
                    switch(A()){
                        case "carousel":
                            return "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIHZpZXdCb3g9IjAgMCA1MCA1MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuMTY5OTIgMzUuODU1N0wyNC44MzcgNDMuMTc3TDQxLjg0OTcgMzUuODU1NyIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjMuMTUyNzEiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMjYuMzMwMSA0My4xOTQ2TDguODMwMDggMzUuNjk0NkwyNS44MzAxIDI4LjE5NDZMNDIuODMwMSAzNS42OTQ2TDI2LjMzMDEgNDMuMTk0NloiIGZpbGw9IiNDNEM0QzQiLz4KPHBhdGggZD0iTTcuMTY5OTIgMzUuODE5NlYxMy44NTU3TDI0LjgzNyA2LjUzNDQyTDQxLjg0OTcgMTMuODU1N1YzNS44MTk2IiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMy4xNTI3MSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yNC44MzU5IDYuNjk0NThWMjguMTU4NSIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjMuMTUyNzEiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNy4xNjk5MiAzNi41MTU5TDI0LjgzNyAyOS4xOTQ2TDQxLjg0OTcgMzYuNTE1OUwyNC44MzcgNDMuODM3Mkw3LjE2OTkyIDM2LjUxNTlaIiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMy4xNTI3MSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";
                        case "plan":
                            return "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIHZpZXdCb3g9IjAgMCA1MCA1MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI1LjUxNDcgMzlMNy41IDMxLjVMMTYuMjUgMjcuNzVMMjAuNjI1IDI1Ljg3NUwyNSAyNy43NUwyOS4zNzUgMjUuODc1TDMzLjc1IDI3Ljc1TDQyLjUgMzEuNUwyNS41MTQ3IDM5WiIgZmlsbD0iI0M0QzRDNCIvPgo8cGF0aCBkPSJNMzAuMTUwOSAyNS4xMjVMMzQuOTM0IDI3LjI1TDQ0LjUgMzEuNUwyNS4zNjc5IDQwTDUuNSAzMS41TDE1LjQzNCAyNy4yNUwyMC40MDA5IDI1LjEyNSIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjMuMTUyNzEiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNS41IDE4LjVMMjUuMzY3OSAxMEw0NC41IDE4LjVMMjUuMzY3OSAyN0w1LjUgMTguNVoiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIzLjE1MjcxIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";
                        default:
                            return "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNDkiIHZpZXdCb3g9IjAgMCA1MCA0OSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTM4Ljk5NzIgMzguODk5NEgxMS4wMDM2QzEwLjc4MjcgMzguODk5NCAxMC42MDM2IDM4LjcyMDMgMTAuNjAzNiAzOC40OTk0TDEwLjYwMzUgMTAuOTk4OUMxMC42MDM1IDEwLjc3OCAxMC43ODI2IDEwLjU5ODkgMTEuMDAzNSAxMC41OTg5SDM4Ljk5NzJDMzkuMjE4MSAxMC41OTg5IDM5LjM5NzIgMTAuNzc4IDM5LjM5NzIgMTAuOTk4OVYzOC40OTk0QzM5LjM5NzIgMzguNzIwMyAzOS4yMTgxIDM4Ljg5OTQgMzguOTk3MiAzOC44OTk0WiIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjMuMTUyNzEiLz4KPHBhdGggZD0iTTEyLjE2OTkgMTkuMTk0NkgyNC4xMzQxQzI0LjM1NTEgMTkuMTk0NiAyNC41MzQxIDE5LjM3MzcgMjQuNTM0MSAxOS41OTQ2VjM3LjMyMTQiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxwYXRoIGQ9Ik0zNy44MjA2IDIwLjU5NDVIMzAuOTg0QzMwLjc2MzEgMjAuNTk0NSAzMC41ODQgMjAuNDE1NCAzMC41ODQgMjAuMTk0NVYxMi4xNjg3IiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMiIvPgo8L3N2Zz4K";
                    }
                })(),
                alt: "".concat(a, "-icon")
            }))));
        }, qN = "data:image/svg+xml;base64,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", JN = (t1)=>{
            let { planImage: i, topViewImage: n, topViewMask: r, images: a, masks: s, mode: o, disabled: l = !1 } = t1;
            const c = [
                {
                    icon: qN,
                    text: zy("rotate-plan")
                }
            ], [u, h] = (0, e.useState)(!1), [d, p] = (0, e.useState)(null), [A, f] = (0, e.useState)(0), [m, g] = (0, e.useState)(null), [M] = (0, e.useState)((()=>{
                const t1 = [], e = Un.config.hasTopViewMask || Un.config.hasMiddleCutMasks;
                return a && a.length > 0 && !e && t1.push("carousel"), i && t1.push("plan"), n && !e && t1.push("topView"), e && (a || n) && t1.push("renders"), t1;
            })()), [v, y] = (0, e.useState)(M[0]);
            function x() {
                f(this.index);
            }
            return (0, e.useEffect)(()=>{
                performance.mark("opening rotation mode");
                const t1 = document.querySelector(".widget-tab__threesixty-container"), e = document.querySelector(".widget-tab__isometry-container"), i = o === Yn.THREESIXTY ? t1 : e, n = ZS()(i, {
                    beforeMouseDown: ()=>!0,
                    onTouch: ()=>!1,
                    zoomDoubleClickSpeed: 1,
                    minZoom: .5,
                    maxZoom: 3
                });
                p(n);
            }, []), e.createElement("div", {
                className: "widget-tab__rotation",
                onContextMenu: Ny
            }, o === Yn.THREESIXTY && e.createElement(fN, {
                initialized: u,
                activeIndex: A,
                images: a
            }), o === Yn.DEFAULT && e.createElement(ZN, {
                setActiveIndex: f,
                setCurrentStep: (t1)=>{
                    const { scale: e } = d.getTransform();
                    d.pause(), d.zoomTo(0, 0, 1 / e), d.moveTo(0, 0), d.resume(), y(t1);
                },
                topViewImage: n,
                topViewMask: r,
                activeIndex: A,
                currentStep: v,
                planImage: i,
                images: a,
                masks: s,
                steps: M
            }), o === Yn.THREESIXTY && !u && e.createElement(mN, {
                onClick: ()=>{
                    h(!0);
                    const t1 = document.querySelector(".widget-tab__threesixty-container"), e = document.querySelector(".widget-tab__rotation"), i = new AN(t1, {
                        image: [
                            ...a
                        ],
                        parentElement: e,
                        inverted: !0,
                        speed: 300
                    });
                    i._update = x, d.on("panstart", ()=>{
                        i.stop(), i._update = ()=>{};
                    }), d.on("panend", ()=>{
                        i.goto(i.index), i._update = x;
                    }), g(i);
                },
                steps: c,
                disabled: l
            }));
        }, KN = kS(()=>((0, e.useEffect)(()=>{
                bS.setAutoRotateState(Un.autoRotatePanarama);
            }, []), e.createElement("button", {
                className: "widget-tab__panorama-controls-button widget-tab__panorama-controls-button--rotation",
                onClick: ()=>bS.toggleAutoRotate()
            }, e.createElement("img", {
                src: bS.currentAutoRotateIcon,
                alt: "rotation-icon"
            })))), $N = kS((t1)=>{
            let { onClick: i } = t1;
            return e.createElement("button", {
                className: "widget-tab__panorama-controls-button widget-tab__panorama-controls-button--ruler",
                disabled: !bS.rulerButtonEnabled,
                onClick: i
            }, e.createElement("img", {
                src: bS.currentRulerIcon,
                alt: "ruler-icon"
            }));
        }), tD = kS(()=>{
            const t1 = Un.config.scaleButtonType;
            return e.createElement("button", {
                className: "widget-tab__panorama-controls-button widget-tab__panorama-controls-button--scale",
                onClick: ()=>bS.toggleFov()
            }, "img" === t1 && e.createElement("img", {
                src: bS.currentFovIcon,
                alt: "scale-icon"
            }), "img" !== t1 && e.createElement("span", null, bS.currentFovText));
        }), eD = ()=>e.createElement("button", {
                className: "widget-tab__panorama-controls-button--bareshell"
            }, e.createElement("p", {
                className: "widget-tab__panorama-controls-button--bareshell-text"
            }, bS.bareshell ? "Bareshell" : "Furnished"), e.createElement("div", {
                className: "widget-tab__panorama-controls-button--bareshell-switch"
            }, e.createElement("div", {
                className: "widget-tab__panorama-controls-button--bareshell-switch-label",
                htmlFor: "bareshell-switch"
            }, e.createElement("span", {
                className: "widget-tab__panorama-controls-button--bareshell-switch-button ".concat(bS.bareshell ? "checked" : "")
            })))), iD = (t1)=>{
            let { absolute: i, size: n = "lg" } = t1;
            return e.createElement("div", {
                className: "widget-loader widget-loader--".concat(n, " ").concat(i ? "widget-loader--absolute" : "")
            }, e.createElement("div", null), e.createElement("div", null), e.createElement("div", null), e.createElement("div", null));
        }, nD = kS((t1)=>{
            let { disabled: i } = t1;
            const { planImage: n, json: r } = Un.config, [a, s] = (0, e.useState)({
                width: "200px",
                height: "auto"
            }), [o, l] = (0, e.useState)(!0), [c, u] = (0, e.useState)({
                X: 1,
                Y: 1
            }), [h, d] = (0, e.useState)(!1), p = ()=>{
                const t1 = document.querySelector(".widget-tab__panorama-map img"), e = t1.naturalWidth / t1.naturalHeight || 1, i = Un.config.height - 200;
                let n = 200, a = n / e;
                a >= i && (a = i, n = a * e);
                const o = ((t1, e)=>{
                    let { width: i, height: n } = t1;
                    if (!e) return {
                        X: 1,
                        Y: 1
                    };
                    const r = ((t1)=>{
                        var e, i, n, r, a;
                        const s = t1.Meta;
                        if (!s) return {
                            X: t1.Scale.X,
                            Y: t1.Scale.X
                        };
                        const o = Un.currentFloorIndex, l = null === (e = s.BackgroundsTransforms) || void 0 === e ? void 0 : e[o], c = null === (i = s.WidgetInfo) || void 0 === i || null === (i = i.PlanBounds) || void 0 === i ? void 0 : i[o];
                        if (null != l && l.Modified && c) return {
                            Width: c.Right,
                            Height: c.Bottom
                        };
                        const u = null === (n = s.FloorsScales) || void 0 === n ? void 0 : n[o];
                        return {
                            X: null !== (r = null == u ? void 0 : u.X) && void 0 !== r ? r : t1.Scale.X,
                            Y: null !== (a = null == u ? void 0 : u.Y) && void 0 !== a ? a : t1.Scale.X
                        };
                    })(e);
                    if (r.Width && r.Height) return {
                        X: i / r.Width,
                        Y: n / r.Height
                    };
                    const a = n * (1024 / i);
                    return {
                        X: i / 1024 / r.X,
                        Y: n / a / r.Y
                    };
                })({
                    width: n,
                    height: a
                }, r);
                s({
                    width: "".concat(n, "px"),
                    height: "".concat(a, "px")
                }), u(o), bS.updateWindowSize(Un.config.width, Un.config.height), bS.vrControlPanel.map.updateSize(2 * n, 2 * a), bS.vrControlPanel.map.updateScale(o);
            }, A = ()=>{
                Un.showControls(), d(!1);
            };
            return (0, e.useEffect)(p, [
                Un.config.width,
                Un.config.height,
                Un.currentFloorIndex
            ]), e.createElement(e.Fragment, null, h && e.createElement("div", {
                className: "widget-tab__panorama-close-map",
                onClick: A
            }, e.createElement("img", {
                src: FS,
                alt: "close-map"
            })), h && e.createElement("div", {
                className: "map-overlay map-overlay--visible",
                onClick: A
            }), e.createElement("div", {
                className: (()=>{
                    let t1 = "widget-tab__panorama-map";
                    return Un.config.bareshell && (t1 += " widget-tab__panorama-map--bottom"), o && (t1 += " widget-tab__panorama-map--hidden"), h && (t1 += " widget-tab__panorama-map--scaled"), t1;
                })()
            }, e.createElement("img", {
                src: n,
                style: a,
                alt: "plan",
                onLoad: ()=>{
                    p(), l(!r || i), bS.vrControlPanel.map.setDisabledState(!r || i), bS.vrControlPanel.map.loadImage(n).then(()=>{
                        bS.vrControlPanel.mapButtonAvailable = !0;
                    });
                }
            }), !o && e.createElement(e.Fragment, null, e.createElement("div", {
                className: "widget-tab__panorama-map__fov",
                style: (()=>{
                    const t1 = bS.getPanoramaById(bS.currentPanoramaId);
                    if (!t1) return {
                        display: "none"
                    };
                    const { left: e, top: i } = t1.userData;
                    return {
                        "--x": "".concat(e * c.X, "px"),
                        "--y": "".concat(i * c.Y, "px")
                    };
                })()
            }, e.createElement("div", {
                className: "widget-tab__panorama-map__fov-direction"
            }), e.createElement("div", {
                className: "widget-tab__panorama-map__fov-dot"
            })), e.createElement("svg", {
                style: {
                    width: a.width
                },
                key: "X-".concat(c.X, "-Y-").concat(c.Y),
                onClick: (t1)=>{
                    if (bS.loading) return;
                    if (Un.config.width <= BS.tablet && !h) return Un.hideControls(), void d(!0);
                    const e = document.querySelector(".widget-tab__panorama-map"), i = e.getBoundingClientRect().width / e.offsetWidth, n = document.querySelector(".widget-tab__panorama-map img").getBoundingClientRect(), { clientX: r, clientY: a } = t1, s = (r - n.left) / i / c.X, o = (a - n.top) / i / c.Y, l = bS.panoramasGroup.children.filter((t1)=>{
                        let { userData: e } = t1;
                        return qI([
                            s,
                            o
                        ], e.points);
                    }), { panorama: u } = yx([
                        s,
                        o
                    ], l);
                    A(), u && bS.setCurrentPanoramaById(u.panoramaId);
                }
            }, bS.panoramasGroup.children.map((t1, i)=>{
                let { userData: n } = t1;
                const r = n.svgPathActions.reduce((t1, e)=>{
                    const i = e.x * c.X, n = e.y * c.Y;
                    let r = "".concat(e.type, " ").concat(i, " ").concat(n);
                    if ("Q" === e.type) {
                        const t1 = e.dx * c.X, i = e.dy * c.Y;
                        r += " ".concat(t1, " ").concat(i);
                    }
                    return "".concat(t1, " ").concat(r);
                }, "");
                return e.createElement("path", {
                    key: i,
                    d: r
                });
            })))));
        }), rD = (t1, e, i, n)=>{
            const r = 1 - t1;
            return {
                x: r * r * e.Location.X + 2 * r * t1 * i.Location.X + t1 * t1 * n.Location.X,
                y: r * r * e.Location.Y + 2 * r * t1 * i.Location.Y + t1 * t1 * n.Location.Y
            };
        }, aD = (t1, e)=>{
            const i = t1.length;
            for(let n = 0; n < i; n++){
                const i = t1[n];
                if (i.ID === e) return i;
            }
            return null;
        }, sD = (t1, e, i, n, r)=>{
            const a = [
                {
                    x: -i,
                    y: -n
                },
                {
                    x: i,
                    y: -n
                },
                {
                    x: i,
                    y: n
                },
                {
                    x: -i,
                    y: n
                }
            ], s = Math.cos(r), o = Math.sin(r);
            for(let i = 0; i < 4; i++){
                const n = a[i], r = t1 + n.x * s - n.y * o;
                n.y = e + n.y * s + n.x * o, n.x = r;
            }
            return a;
        };
        class oD {
            constructor(t1 = 0, e = 0, i = 0, n = 1){
                this.isQuaternion = !0, this._x = t1, this._y = e, this._z = i, this._w = n;
            }
            static slerpFlat(t1, e, i, n, r, a, s) {
                let o = i[n + 0], l = i[n + 1], c = i[n + 2], u = i[n + 3];
                const h = r[a + 0], d = r[a + 1], p = r[a + 2], A = r[a + 3];
                if (0 === s) return t1[e + 0] = o, t1[e + 1] = l, t1[e + 2] = c, void (t1[e + 3] = u);
                if (1 === s) return t1[e + 0] = h, t1[e + 1] = d, t1[e + 2] = p, void (t1[e + 3] = A);
                if (u !== A || o !== h || l !== d || c !== p) {
                    let t1 = 1 - s;
                    const e = o * h + l * d + c * p + u * A, i = e >= 0 ? 1 : -1, n = 1 - e * e;
                    if (n > Number.EPSILON) {
                        const r = Math.sqrt(n), a = Math.atan2(r, e * i);
                        t1 = Math.sin(t1 * a) / r, s = Math.sin(s * a) / r;
                    }
                    const r = s * i;
                    if (o = o * t1 + h * r, l = l * t1 + d * r, c = c * t1 + p * r, u = u * t1 + A * r, t1 === 1 - s) {
                        const t1 = 1 / Math.sqrt(o * o + l * l + c * c + u * u);
                        o *= t1, l *= t1, c *= t1, u *= t1;
                    }
                }
                t1[e] = o, t1[e + 1] = l, t1[e + 2] = c, t1[e + 3] = u;
            }
            static multiplyQuaternionsFlat(t1, e, i, n, r, a) {
                const s = i[n], o = i[n + 1], l = i[n + 2], c = i[n + 3], u = r[a], h = r[a + 1], d = r[a + 2], p = r[a + 3];
                return t1[e] = s * p + c * u + o * d - l * h, t1[e + 1] = o * p + c * h + l * u - s * d, t1[e + 2] = l * p + c * d + s * h - o * u, t1[e + 3] = c * p - s * u - o * h - l * d, t1;
            }
            get x() {
                return this._x;
            }
            set x(t1) {
                this._x = t1, this._onChangeCallback();
            }
            get y() {
                return this._y;
            }
            set y(t1) {
                this._y = t1, this._onChangeCallback();
            }
            get z() {
                return this._z;
            }
            set z(t1) {
                this._z = t1, this._onChangeCallback();
            }
            get w() {
                return this._w;
            }
            set w(t1) {
                this._w = t1, this._onChangeCallback();
            }
            set(t1, e, i, n) {
                return this._x = t1, this._y = e, this._z = i, this._w = n, this._onChangeCallback(), this;
            }
            clone() {
                return new this.constructor(this._x, this._y, this._z, this._w);
            }
            copy(t1) {
                return this._x = t1.x, this._y = t1.y, this._z = t1.z, this._w = t1.w, this._onChangeCallback(), this;
            }
            setFromEuler(t1, e) {
                const i = t1._x, n = t1._y, r = t1._z, a = t1._order, s = Math.cos, o = Math.sin, l = s(i / 2), c = s(n / 2), u = s(r / 2), h = o(i / 2), d = o(n / 2), p = o(r / 2);
                switch(a){
                    case "XYZ":
                        this._x = h * c * u + l * d * p, this._y = l * d * u - h * c * p, this._z = l * c * p + h * d * u, this._w = l * c * u - h * d * p;
                        break;
                    case "YXZ":
                        this._x = h * c * u + l * d * p, this._y = l * d * u - h * c * p, this._z = l * c * p - h * d * u, this._w = l * c * u + h * d * p;
                        break;
                    case "ZXY":
                        this._x = h * c * u - l * d * p, this._y = l * d * u + h * c * p, this._z = l * c * p + h * d * u, this._w = l * c * u - h * d * p;
                        break;
                    case "ZYX":
                        this._x = h * c * u - l * d * p, this._y = l * d * u + h * c * p, this._z = l * c * p - h * d * u, this._w = l * c * u + h * d * p;
                        break;
                    case "YZX":
                        this._x = h * c * u + l * d * p, this._y = l * d * u + h * c * p, this._z = l * c * p - h * d * u, this._w = l * c * u - h * d * p;
                        break;
                    case "XZY":
                        this._x = h * c * u - l * d * p, this._y = l * d * u - h * c * p, this._z = l * c * p + h * d * u, this._w = l * c * u + h * d * p;
                        break;
                    default:
                        console.warn("THREE.Quaternion: .setFromEuler() encountered an unknown order: " + a);
                }
                return !1 !== e && this._onChangeCallback(), this;
            }
            setFromAxisAngle(t1, e) {
                const i = e / 2, n = Math.sin(i);
                return this._x = t1.x * n, this._y = t1.y * n, this._z = t1.z * n, this._w = Math.cos(i), this._onChangeCallback(), this;
            }
            setFromRotationMatrix(t1) {
                const e = t1.elements, i = e[0], n = e[4], r = e[8], a = e[1], s = e[5], o = e[9], l = e[2], c = e[6], u = e[10], h = i + s + u;
                if (h > 0) {
                    const t1 = .5 / Math.sqrt(h + 1);
                    this._w = .25 / t1, this._x = (c - o) * t1, this._y = (r - l) * t1, this._z = (a - n) * t1;
                } else if (i > s && i > u) {
                    const t1 = 2 * Math.sqrt(1 + i - s - u);
                    this._w = (c - o) / t1, this._x = .25 * t1, this._y = (n + a) / t1, this._z = (r + l) / t1;
                } else if (s > u) {
                    const t1 = 2 * Math.sqrt(1 + s - i - u);
                    this._w = (r - l) / t1, this._x = (n + a) / t1, this._y = .25 * t1, this._z = (o + c) / t1;
                } else {
                    const t1 = 2 * Math.sqrt(1 + u - i - s);
                    this._w = (a - n) / t1, this._x = (r + l) / t1, this._y = (o + c) / t1, this._z = .25 * t1;
                }
                return this._onChangeCallback(), this;
            }
            setFromUnitVectors(t1, e) {
                let i = t1.dot(e) + 1;
                return i < Number.EPSILON ? (i = 0, Math.abs(t1.x) > Math.abs(t1.z) ? (this._x = -t1.y, this._y = t1.x, this._z = 0, this._w = i) : (this._x = 0, this._y = -t1.z, this._z = t1.y, this._w = i)) : (this._x = t1.y * e.z - t1.z * e.y, this._y = t1.z * e.x - t1.x * e.z, this._z = t1.x * e.y - t1.y * e.x, this._w = i), this.normalize();
            }
            angleTo(t1) {
                return 2 * Math.acos(Math.abs(CN(this.dot(t1), -1, 1)));
            }
            rotateTowards(t1, e) {
                const i = this.angleTo(t1);
                if (0 === i) return this;
                const n = Math.min(1, e / i);
                return this.slerp(t1, n), this;
            }
            identity() {
                return this.set(0, 0, 0, 1);
            }
            invert() {
                return this.conjugate();
            }
            conjugate() {
                return this._x *= -1, this._y *= -1, this._z *= -1, this._onChangeCallback(), this;
            }
            dot(t1) {
                return this._x * t1._x + this._y * t1._y + this._z * t1._z + this._w * t1._w;
            }
            lengthSq() {
                return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
            }
            length() {
                return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
            }
            normalize() {
                let t1 = this.length();
                return 0 === t1 ? (this._x = 0, this._y = 0, this._z = 0, this._w = 1) : (t1 = 1 / t1, this._x = this._x * t1, this._y = this._y * t1, this._z = this._z * t1, this._w = this._w * t1), this._onChangeCallback(), this;
            }
            multiply(t1) {
                return this.multiplyQuaternions(this, t1);
            }
            premultiply(t1) {
                return this.multiplyQuaternions(t1, this);
            }
            multiplyQuaternions(t1, e) {
                const i = t1._x, n = t1._y, r = t1._z, a = t1._w, s = e._x, o = e._y, l = e._z, c = e._w;
                return this._x = i * c + a * s + n * l - r * o, this._y = n * c + a * o + r * s - i * l, this._z = r * c + a * l + i * o - n * s, this._w = a * c - i * s - n * o - r * l, this._onChangeCallback(), this;
            }
            slerp(t1, e) {
                if (0 === e) return this;
                if (1 === e) return this.copy(t1);
                const i = this._x, n = this._y, r = this._z, a = this._w;
                let s = a * t1._w + i * t1._x + n * t1._y + r * t1._z;
                if (s < 0 ? (this._w = -t1._w, this._x = -t1._x, this._y = -t1._y, this._z = -t1._z, s = -s) : this.copy(t1), s >= 1) return this._w = a, this._x = i, this._y = n, this._z = r, this;
                const o = 1 - s * s;
                if (o <= Number.EPSILON) {
                    const t1 = 1 - e;
                    return this._w = t1 * a + e * this._w, this._x = t1 * i + e * this._x, this._y = t1 * n + e * this._y, this._z = t1 * r + e * this._z, this.normalize(), this._onChangeCallback(), this;
                }
                const l = Math.sqrt(o), c = Math.atan2(l, s), u = Math.sin((1 - e) * c) / l, h = Math.sin(e * c) / l;
                return this._w = a * u + this._w * h, this._x = i * u + this._x * h, this._y = n * u + this._y * h, this._z = r * u + this._z * h, this._onChangeCallback(), this;
            }
            slerpQuaternions(t1, e, i) {
                return this.copy(t1).slerp(e, i);
            }
            random() {
                const t1 = Math.random(), e = Math.sqrt(1 - t1), i = Math.sqrt(t1), n = 2 * Math.PI * Math.random(), r = 2 * Math.PI * Math.random();
                return this.set(e * Math.cos(n), i * Math.sin(r), i * Math.cos(r), e * Math.sin(n));
            }
            equals(t1) {
                return t1._x === this._x && t1._y === this._y && t1._z === this._z && t1._w === this._w;
            }
            fromArray(t1, e = 0) {
                return this._x = t1[e], this._y = t1[e + 1], this._z = t1[e + 2], this._w = t1[e + 3], this._onChangeCallback(), this;
            }
            toArray(t1 = [], e = 0) {
                return t1[e] = this._x, t1[e + 1] = this._y, t1[e + 2] = this._z, t1[e + 3] = this._w, t1;
            }
            fromBufferAttribute(t1, e) {
                return this._x = t1.getX(e), this._y = t1.getY(e), this._z = t1.getZ(e), this._w = t1.getW(e), this;
            }
            toJSON() {
                return this.toArray();
            }
            _onChange(t1) {
                return this._onChangeCallback = t1, this;
            }
            _onChangeCallback() {}
            *[Symbol.iterator]() {
                yield this._x, yield this._y, yield this._z, yield this._w;
            }
        }
        class lD {
            constructor(t1 = 0, e = 0, i = 0){
                lD.prototype.isVector3 = !0, this.x = t1, this.y = e, this.z = i;
            }
            set(t1, e, i) {
                return void 0 === i && (i = this.z), this.x = t1, this.y = e, this.z = i, this;
            }
            setScalar(t1) {
                return this.x = t1, this.y = t1, this.z = t1, this;
            }
            setX(t1) {
                return this.x = t1, this;
            }
            setY(t1) {
                return this.y = t1, this;
            }
            setZ(t1) {
                return this.z = t1, this;
            }
            setComponent(t1, e) {
                switch(t1){
                    case 0:
                        this.x = e;
                        break;
                    case 1:
                        this.y = e;
                        break;
                    case 2:
                        this.z = e;
                        break;
                    default:
                        throw new Error("index is out of range: " + t1);
                }
                return this;
            }
            getComponent(t1) {
                switch(t1){
                    case 0:
                        return this.x;
                    case 1:
                        return this.y;
                    case 2:
                        return this.z;
                    default:
                        throw new Error("index is out of range: " + t1);
                }
            }
            clone() {
                return new this.constructor(this.x, this.y, this.z);
            }
            copy(t1) {
                return this.x = t1.x, this.y = t1.y, this.z = t1.z, this;
            }
            add(t1) {
                return this.x += t1.x, this.y += t1.y, this.z += t1.z, this;
            }
            addScalar(t1) {
                return this.x += t1, this.y += t1, this.z += t1, this;
            }
            addVectors(t1, e) {
                return this.x = t1.x + e.x, this.y = t1.y + e.y, this.z = t1.z + e.z, this;
            }
            addScaledVector(t1, e) {
                return this.x += t1.x * e, this.y += t1.y * e, this.z += t1.z * e, this;
            }
            sub(t1) {
                return this.x -= t1.x, this.y -= t1.y, this.z -= t1.z, this;
            }
            subScalar(t1) {
                return this.x -= t1, this.y -= t1, this.z -= t1, this;
            }
            subVectors(t1, e) {
                return this.x = t1.x - e.x, this.y = t1.y - e.y, this.z = t1.z - e.z, this;
            }
            multiply(t1) {
                return this.x *= t1.x, this.y *= t1.y, this.z *= t1.z, this;
            }
            multiplyScalar(t1) {
                return this.x *= t1, this.y *= t1, this.z *= t1, this;
            }
            multiplyVectors(t1, e) {
                return this.x = t1.x * e.x, this.y = t1.y * e.y, this.z = t1.z * e.z, this;
            }
            applyEuler(t1) {
                return this.applyQuaternion(uD.setFromEuler(t1));
            }
            applyAxisAngle(t1, e) {
                return this.applyQuaternion(uD.setFromAxisAngle(t1, e));
            }
            applyMatrix3(t1) {
                const e = this.x, i = this.y, n = this.z, r = t1.elements;
                return this.x = r[0] * e + r[3] * i + r[6] * n, this.y = r[1] * e + r[4] * i + r[7] * n, this.z = r[2] * e + r[5] * i + r[8] * n, this;
            }
            applyNormalMatrix(t1) {
                return this.applyMatrix3(t1).normalize();
            }
            applyMatrix4(t1) {
                const e = this.x, i = this.y, n = this.z, r = t1.elements, a = 1 / (r[3] * e + r[7] * i + r[11] * n + r[15]);
                return this.x = (r[0] * e + r[4] * i + r[8] * n + r[12]) * a, this.y = (r[1] * e + r[5] * i + r[9] * n + r[13]) * a, this.z = (r[2] * e + r[6] * i + r[10] * n + r[14]) * a, this;
            }
            applyQuaternion(t1) {
                const e = this.x, i = this.y, n = this.z, r = t1.x, a = t1.y, s = t1.z, o = t1.w, l = 2 * (a * n - s * i), c = 2 * (s * e - r * n), u = 2 * (r * i - a * e);
                return this.x = e + o * l + a * u - s * c, this.y = i + o * c + s * l - r * u, this.z = n + o * u + r * c - a * l, this;
            }
            project(t1) {
                return this.applyMatrix4(t1.matrixWorldInverse).applyMatrix4(t1.projectionMatrix);
            }
            unproject(t1) {
                return this.applyMatrix4(t1.projectionMatrixInverse).applyMatrix4(t1.matrixWorld);
            }
            transformDirection(t1) {
                const e = this.x, i = this.y, n = this.z, r = t1.elements;
                return this.x = r[0] * e + r[4] * i + r[8] * n, this.y = r[1] * e + r[5] * i + r[9] * n, this.z = r[2] * e + r[6] * i + r[10] * n, this.normalize();
            }
            divide(t1) {
                return this.x /= t1.x, this.y /= t1.y, this.z /= t1.z, this;
            }
            divideScalar(t1) {
                return this.multiplyScalar(1 / t1);
            }
            min(t1) {
                return this.x = Math.min(this.x, t1.x), this.y = Math.min(this.y, t1.y), this.z = Math.min(this.z, t1.z), this;
            }
            max(t1) {
                return this.x = Math.max(this.x, t1.x), this.y = Math.max(this.y, t1.y), this.z = Math.max(this.z, t1.z), this;
            }
            clamp(t1, e) {
                return this.x = Math.max(t1.x, Math.min(e.x, this.x)), this.y = Math.max(t1.y, Math.min(e.y, this.y)), this.z = Math.max(t1.z, Math.min(e.z, this.z)), this;
            }
            clampScalar(t1, e) {
                return this.x = Math.max(t1, Math.min(e, this.x)), this.y = Math.max(t1, Math.min(e, this.y)), this.z = Math.max(t1, Math.min(e, this.z)), this;
            }
            clampLength(t1, e) {
                const i = this.length();
                return this.divideScalar(i || 1).multiplyScalar(Math.max(t1, Math.min(e, i)));
            }
            floor() {
                return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this;
            }
            ceil() {
                return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this;
            }
            round() {
                return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this;
            }
            roundToZero() {
                return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this.z = Math.trunc(this.z), this;
            }
            negate() {
                return this.x = -this.x, this.y = -this.y, this.z = -this.z, this;
            }
            dot(t1) {
                return this.x * t1.x + this.y * t1.y + this.z * t1.z;
            }
            lengthSq() {
                return this.x * this.x + this.y * this.y + this.z * this.z;
            }
            length() {
                return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
            }
            manhattanLength() {
                return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
            }
            normalize() {
                return this.divideScalar(this.length() || 1);
            }
            setLength(t1) {
                return this.normalize().multiplyScalar(t1);
            }
            lerp(t1, e) {
                return this.x += (t1.x - this.x) * e, this.y += (t1.y - this.y) * e, this.z += (t1.z - this.z) * e, this;
            }
            lerpVectors(t1, e, i) {
                return this.x = t1.x + (e.x - t1.x) * i, this.y = t1.y + (e.y - t1.y) * i, this.z = t1.z + (e.z - t1.z) * i, this;
            }
            cross(t1) {
                return this.crossVectors(this, t1);
            }
            crossVectors(t1, e) {
                const i = t1.x, n = t1.y, r = t1.z, a = e.x, s = e.y, o = e.z;
                return this.x = n * o - r * s, this.y = r * a - i * o, this.z = i * s - n * a, this;
            }
            projectOnVector(t1) {
                const e = t1.lengthSq();
                if (0 === e) return this.set(0, 0, 0);
                const i = t1.dot(this) / e;
                return this.copy(t1).multiplyScalar(i);
            }
            projectOnPlane(t1) {
                return cD.copy(this).projectOnVector(t1), this.sub(cD);
            }
            reflect(t1) {
                return this.sub(cD.copy(t1).multiplyScalar(2 * this.dot(t1)));
            }
            angleTo(t1) {
                const e = Math.sqrt(this.lengthSq() * t1.lengthSq());
                if (0 === e) return Math.PI / 2;
                const i = this.dot(t1) / e;
                return Math.acos(CN(i, -1, 1));
            }
            distanceTo(t1) {
                return Math.sqrt(this.distanceToSquared(t1));
            }
            distanceToSquared(t1) {
                const e = this.x - t1.x, i = this.y - t1.y, n = this.z - t1.z;
                return e * e + i * i + n * n;
            }
            manhattanDistanceTo(t1) {
                return Math.abs(this.x - t1.x) + Math.abs(this.y - t1.y) + Math.abs(this.z - t1.z);
            }
            setFromSpherical(t1) {
                return this.setFromSphericalCoords(t1.radius, t1.phi, t1.theta);
            }
            setFromSphericalCoords(t1, e, i) {
                const n = Math.sin(e) * t1;
                return this.x = n * Math.sin(i), this.y = Math.cos(e) * t1, this.z = n * Math.cos(i), this;
            }
            setFromCylindrical(t1) {
                return this.setFromCylindricalCoords(t1.radius, t1.theta, t1.y);
            }
            setFromCylindricalCoords(t1, e, i) {
                return this.x = t1 * Math.sin(e), this.y = i, this.z = t1 * Math.cos(e), this;
            }
            setFromMatrixPosition(t1) {
                const e = t1.elements;
                return this.x = e[12], this.y = e[13], this.z = e[14], this;
            }
            setFromMatrixScale(t1) {
                const e = this.setFromMatrixColumn(t1, 0).length(), i = this.setFromMatrixColumn(t1, 1).length(), n = this.setFromMatrixColumn(t1, 2).length();
                return this.x = e, this.y = i, this.z = n, this;
            }
            setFromMatrixColumn(t1, e) {
                return this.fromArray(t1.elements, 4 * e);
            }
            setFromMatrix3Column(t1, e) {
                return this.fromArray(t1.elements, 3 * e);
            }
            setFromEuler(t1) {
                return this.x = t1._x, this.y = t1._y, this.z = t1._z, this;
            }
            setFromColor(t1) {
                return this.x = t1.r, this.y = t1.g, this.z = t1.b, this;
            }
            equals(t1) {
                return t1.x === this.x && t1.y === this.y && t1.z === this.z;
            }
            fromArray(t1, e = 0) {
                return this.x = t1[e], this.y = t1[e + 1], this.z = t1[e + 2], this;
            }
            toArray(t1 = [], e = 0) {
                return t1[e] = this.x, t1[e + 1] = this.y, t1[e + 2] = this.z, t1;
            }
            fromBufferAttribute(t1, e) {
                return this.x = t1.getX(e), this.y = t1.getY(e), this.z = t1.getZ(e), this;
            }
            random() {
                return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this;
            }
            randomDirection() {
                const t1 = 2 * (Math.random() - .5), e = Math.random() * Math.PI * 2, i = Math.sqrt(1 - t1 ** 2);
                return this.x = i * Math.cos(e), this.y = i * Math.sin(e), this.z = t1, this;
            }
            *[Symbol.iterator]() {
                yield this.x, yield this.y, yield this.z;
            }
        }
        const cD = new lD, uD = new oD;
        class hD {
            constructor(t1, e, i, n, r, a, s, o, l, c, u, h, d, p, A, f){
                hD.prototype.isMatrix4 = !0, this.elements = [
                    1,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    1
                ], void 0 !== t1 && this.set(t1, e, i, n, r, a, s, o, l, c, u, h, d, p, A, f);
            }
            set(t1, e, i, n, r, a, s, o, l, c, u, h, d, p, A, f) {
                const m = this.elements;
                return m[0] = t1, m[4] = e, m[8] = i, m[12] = n, m[1] = r, m[5] = a, m[9] = s, m[13] = o, m[2] = l, m[6] = c, m[10] = u, m[14] = h, m[3] = d, m[7] = p, m[11] = A, m[15] = f, this;
            }
            identity() {
                return this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
            }
            clone() {
                return (new hD).fromArray(this.elements);
            }
            copy(t1) {
                const e = this.elements, i = t1.elements;
                return e[0] = i[0], e[1] = i[1], e[2] = i[2], e[3] = i[3], e[4] = i[4], e[5] = i[5], e[6] = i[6], e[7] = i[7], e[8] = i[8], e[9] = i[9], e[10] = i[10], e[11] = i[11], e[12] = i[12], e[13] = i[13], e[14] = i[14], e[15] = i[15], this;
            }
            copyPosition(t1) {
                const e = this.elements, i = t1.elements;
                return e[12] = i[12], e[13] = i[13], e[14] = i[14], this;
            }
            setFromMatrix3(t1) {
                const e = t1.elements;
                return this.set(e[0], e[3], e[6], 0, e[1], e[4], e[7], 0, e[2], e[5], e[8], 0, 0, 0, 0, 1), this;
            }
            extractBasis(t1, e, i) {
                return t1.setFromMatrixColumn(this, 0), e.setFromMatrixColumn(this, 1), i.setFromMatrixColumn(this, 2), this;
            }
            makeBasis(t1, e, i) {
                return this.set(t1.x, e.x, i.x, 0, t1.y, e.y, i.y, 0, t1.z, e.z, i.z, 0, 0, 0, 0, 1), this;
            }
            extractRotation(t1) {
                const e = this.elements, i = t1.elements, n = 1 / dD.setFromMatrixColumn(t1, 0).length(), r = 1 / dD.setFromMatrixColumn(t1, 1).length(), a = 1 / dD.setFromMatrixColumn(t1, 2).length();
                return e[0] = i[0] * n, e[1] = i[1] * n, e[2] = i[2] * n, e[3] = 0, e[4] = i[4] * r, e[5] = i[5] * r, e[6] = i[6] * r, e[7] = 0, e[8] = i[8] * a, e[9] = i[9] * a, e[10] = i[10] * a, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, this;
            }
            makeRotationFromEuler(t1) {
                const e = this.elements, i = t1.x, n = t1.y, r = t1.z, a = Math.cos(i), s = Math.sin(i), o = Math.cos(n), l = Math.sin(n), c = Math.cos(r), u = Math.sin(r);
                if ("XYZ" === t1.order) {
                    const t1 = a * c, i = a * u, n = s * c, r = s * u;
                    e[0] = o * c, e[4] = -o * u, e[8] = l, e[1] = i + n * l, e[5] = t1 - r * l, e[9] = -s * o, e[2] = r - t1 * l, e[6] = n + i * l, e[10] = a * o;
                } else if ("YXZ" === t1.order) {
                    const t1 = o * c, i = o * u, n = l * c, r = l * u;
                    e[0] = t1 + r * s, e[4] = n * s - i, e[8] = a * l, e[1] = a * u, e[5] = a * c, e[9] = -s, e[2] = i * s - n, e[6] = r + t1 * s, e[10] = a * o;
                } else if ("ZXY" === t1.order) {
                    const t1 = o * c, i = o * u, n = l * c, r = l * u;
                    e[0] = t1 - r * s, e[4] = -a * u, e[8] = n + i * s, e[1] = i + n * s, e[5] = a * c, e[9] = r - t1 * s, e[2] = -a * l, e[6] = s, e[10] = a * o;
                } else if ("ZYX" === t1.order) {
                    const t1 = a * c, i = a * u, n = s * c, r = s * u;
                    e[0] = o * c, e[4] = n * l - i, e[8] = t1 * l + r, e[1] = o * u, e[5] = r * l + t1, e[9] = i * l - n, e[2] = -l, e[6] = s * o, e[10] = a * o;
                } else if ("YZX" === t1.order) {
                    const t1 = a * o, i = a * l, n = s * o, r = s * l;
                    e[0] = o * c, e[4] = r - t1 * u, e[8] = n * u + i, e[1] = u, e[5] = a * c, e[9] = -s * c, e[2] = -l * c, e[6] = i * u + n, e[10] = t1 - r * u;
                } else if ("XZY" === t1.order) {
                    const t1 = a * o, i = a * l, n = s * o, r = s * l;
                    e[0] = o * c, e[4] = -u, e[8] = l * c, e[1] = t1 * u + r, e[5] = a * c, e[9] = i * u - n, e[2] = n * u - i, e[6] = s * c, e[10] = r * u + t1;
                }
                return e[3] = 0, e[7] = 0, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, this;
            }
            makeRotationFromQuaternion(t1) {
                return this.compose(AD, t1, fD);
            }
            lookAt(t1, e, i) {
                const n = this.elements;
                return MD.subVectors(t1, e), 0 === MD.lengthSq() && (MD.z = 1), MD.normalize(), mD.crossVectors(i, MD), 0 === mD.lengthSq() && (1 === Math.abs(i.z) ? MD.x += 1e-4 : MD.z += 1e-4, MD.normalize(), mD.crossVectors(i, MD)), mD.normalize(), gD.crossVectors(MD, mD), n[0] = mD.x, n[4] = gD.x, n[8] = MD.x, n[1] = mD.y, n[5] = gD.y, n[9] = MD.y, n[2] = mD.z, n[6] = gD.z, n[10] = MD.z, this;
            }
            multiply(t1) {
                return this.multiplyMatrices(this, t1);
            }
            premultiply(t1) {
                return this.multiplyMatrices(t1, this);
            }
            multiplyMatrices(t1, e) {
                const i = t1.elements, n = e.elements, r = this.elements, a = i[0], s = i[4], o = i[8], l = i[12], c = i[1], u = i[5], h = i[9], d = i[13], p = i[2], A = i[6], f = i[10], m = i[14], g = i[3], M = i[7], v = i[11], y = i[15], x = n[0], w = n[4], b = n[8], T = n[12], E = n[1], _ = n[5], I = n[9], S = n[13], N = n[2], D = n[6], C = n[10], z = n[14], L = n[3], O = n[7], P = n[11], j = n[15];
                return r[0] = a * x + s * E + o * N + l * L, r[4] = a * w + s * _ + o * D + l * O, r[8] = a * b + s * I + o * C + l * P, r[12] = a * T + s * S + o * z + l * j, r[1] = c * x + u * E + h * N + d * L, r[5] = c * w + u * _ + h * D + d * O, r[9] = c * b + u * I + h * C + d * P, r[13] = c * T + u * S + h * z + d * j, r[2] = p * x + A * E + f * N + m * L, r[6] = p * w + A * _ + f * D + m * O, r[10] = p * b + A * I + f * C + m * P, r[14] = p * T + A * S + f * z + m * j, r[3] = g * x + M * E + v * N + y * L, r[7] = g * w + M * _ + v * D + y * O, r[11] = g * b + M * I + v * C + y * P, r[15] = g * T + M * S + v * z + y * j, this;
            }
            multiplyScalar(t1) {
                const e = this.elements;
                return e[0] *= t1, e[4] *= t1, e[8] *= t1, e[12] *= t1, e[1] *= t1, e[5] *= t1, e[9] *= t1, e[13] *= t1, e[2] *= t1, e[6] *= t1, e[10] *= t1, e[14] *= t1, e[3] *= t1, e[7] *= t1, e[11] *= t1, e[15] *= t1, this;
            }
            determinant() {
                const t1 = this.elements, e = t1[0], i = t1[4], n = t1[8], r = t1[12], a = t1[1], s = t1[5], o = t1[9], l = t1[13], c = t1[2], u = t1[6], h = t1[10], d = t1[14];
                return t1[3] * (+r * o * u - n * l * u - r * s * h + i * l * h + n * s * d - i * o * d) + t1[7] * (+e * o * d - e * l * h + r * a * h - n * a * d + n * l * c - r * o * c) + t1[11] * (+e * l * u - e * s * d - r * a * u + i * a * d + r * s * c - i * l * c) + t1[15] * (-n * s * c - e * o * u + e * s * h + n * a * u - i * a * h + i * o * c);
            }
            transpose() {
                const t1 = this.elements;
                let e;
                return e = t1[1], t1[1] = t1[4], t1[4] = e, e = t1[2], t1[2] = t1[8], t1[8] = e, e = t1[6], t1[6] = t1[9], t1[9] = e, e = t1[3], t1[3] = t1[12], t1[12] = e, e = t1[7], t1[7] = t1[13], t1[13] = e, e = t1[11], t1[11] = t1[14], t1[14] = e, this;
            }
            setPosition(t1, e, i) {
                const n = this.elements;
                return t1.isVector3 ? (n[12] = t1.x, n[13] = t1.y, n[14] = t1.z) : (n[12] = t1, n[13] = e, n[14] = i), this;
            }
            invert() {
                const t1 = this.elements, e = t1[0], i = t1[1], n = t1[2], r = t1[3], a = t1[4], s = t1[5], o = t1[6], l = t1[7], c = t1[8], u = t1[9], h = t1[10], d = t1[11], p = t1[12], A = t1[13], f = t1[14], m = t1[15], g = u * f * l - A * h * l + A * o * d - s * f * d - u * o * m + s * h * m, M = p * h * l - c * f * l - p * o * d + a * f * d + c * o * m - a * h * m, v = c * A * l - p * u * l + p * s * d - a * A * d - c * s * m + a * u * m, y = p * u * o - c * A * o - p * s * h + a * A * h + c * s * f - a * u * f, x = e * g + i * M + n * v + r * y;
                if (0 === x) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
                const w = 1 / x;
                return t1[0] = g * w, t1[1] = (A * h * r - u * f * r - A * n * d + i * f * d + u * n * m - i * h * m) * w, t1[2] = (s * f * r - A * o * r + A * n * l - i * f * l - s * n * m + i * o * m) * w, t1[3] = (u * o * r - s * h * r - u * n * l + i * h * l + s * n * d - i * o * d) * w, t1[4] = M * w, t1[5] = (c * f * r - p * h * r + p * n * d - e * f * d - c * n * m + e * h * m) * w, t1[6] = (p * o * r - a * f * r - p * n * l + e * f * l + a * n * m - e * o * m) * w, t1[7] = (a * h * r - c * o * r + c * n * l - e * h * l - a * n * d + e * o * d) * w, t1[8] = v * w, t1[9] = (p * u * r - c * A * r - p * i * d + e * A * d + c * i * m - e * u * m) * w, t1[10] = (a * A * r - p * s * r + p * i * l - e * A * l - a * i * m + e * s * m) * w, t1[11] = (c * s * r - a * u * r - c * i * l + e * u * l + a * i * d - e * s * d) * w, t1[12] = y * w, t1[13] = (c * A * n - p * u * n + p * i * h - e * A * h - c * i * f + e * u * f) * w, t1[14] = (p * s * n - a * A * n - p * i * o + e * A * o + a * i * f - e * s * f) * w, t1[15] = (a * u * n - c * s * n + c * i * o - e * u * o - a * i * h + e * s * h) * w, this;
            }
            scale(t1) {
                const e = this.elements, i = t1.x, n = t1.y, r = t1.z;
                return e[0] *= i, e[4] *= n, e[8] *= r, e[1] *= i, e[5] *= n, e[9] *= r, e[2] *= i, e[6] *= n, e[10] *= r, e[3] *= i, e[7] *= n, e[11] *= r, this;
            }
            getMaxScaleOnAxis() {
                const t1 = this.elements, e = t1[0] * t1[0] + t1[1] * t1[1] + t1[2] * t1[2], i = t1[4] * t1[4] + t1[5] * t1[5] + t1[6] * t1[6], n = t1[8] * t1[8] + t1[9] * t1[9] + t1[10] * t1[10];
                return Math.sqrt(Math.max(e, i, n));
            }
            makeTranslation(t1, e, i) {
                return t1.isVector3 ? this.set(1, 0, 0, t1.x, 0, 1, 0, t1.y, 0, 0, 1, t1.z, 0, 0, 0, 1) : this.set(1, 0, 0, t1, 0, 1, 0, e, 0, 0, 1, i, 0, 0, 0, 1), this;
            }
            makeRotationX(t1) {
                const e = Math.cos(t1), i = Math.sin(t1);
                return this.set(1, 0, 0, 0, 0, e, -i, 0, 0, i, e, 0, 0, 0, 0, 1), this;
            }
            makeRotationY(t1) {
                const e = Math.cos(t1), i = Math.sin(t1);
                return this.set(e, 0, i, 0, 0, 1, 0, 0, -i, 0, e, 0, 0, 0, 0, 1), this;
            }
            makeRotationZ(t1) {
                const e = Math.cos(t1), i = Math.sin(t1);
                return this.set(e, -i, 0, 0, i, e, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
            }
            makeRotationAxis(t1, e) {
                const i = Math.cos(e), n = Math.sin(e), r = 1 - i, a = t1.x, s = t1.y, o = t1.z, l = r * a, c = r * s;
                return this.set(l * a + i, l * s - n * o, l * o + n * s, 0, l * s + n * o, c * s + i, c * o - n * a, 0, l * o - n * s, c * o + n * a, r * o * o + i, 0, 0, 0, 0, 1), this;
            }
            makeScale(t1, e, i) {
                return this.set(t1, 0, 0, 0, 0, e, 0, 0, 0, 0, i, 0, 0, 0, 0, 1), this;
            }
            makeShear(t1, e, i, n, r, a) {
                return this.set(1, i, r, 0, t1, 1, a, 0, e, n, 1, 0, 0, 0, 0, 1), this;
            }
            compose(t1, e, i) {
                const n = this.elements, r = e._x, a = e._y, s = e._z, o = e._w, l = r + r, c = a + a, u = s + s, h = r * l, d = r * c, p = r * u, A = a * c, f = a * u, m = s * u, g = o * l, M = o * c, v = o * u, y = i.x, x = i.y, w = i.z;
                return n[0] = (1 - (A + m)) * y, n[1] = (d + v) * y, n[2] = (p - M) * y, n[3] = 0, n[4] = (d - v) * x, n[5] = (1 - (h + m)) * x, n[6] = (f + g) * x, n[7] = 0, n[8] = (p + M) * w, n[9] = (f - g) * w, n[10] = (1 - (h + A)) * w, n[11] = 0, n[12] = t1.x, n[13] = t1.y, n[14] = t1.z, n[15] = 1, this;
            }
            decompose(t1, e, i) {
                const n = this.elements;
                let r = dD.set(n[0], n[1], n[2]).length();
                const a = dD.set(n[4], n[5], n[6]).length(), s = dD.set(n[8], n[9], n[10]).length();
                this.determinant() < 0 && (r = -r), t1.x = n[12], t1.y = n[13], t1.z = n[14], pD.copy(this);
                const o = 1 / r, l = 1 / a, c = 1 / s;
                return pD.elements[0] *= o, pD.elements[1] *= o, pD.elements[2] *= o, pD.elements[4] *= l, pD.elements[5] *= l, pD.elements[6] *= l, pD.elements[8] *= c, pD.elements[9] *= c, pD.elements[10] *= c, e.setFromRotationMatrix(pD), i.x = r, i.y = a, i.z = s, this;
            }
            makePerspective(t1, e, i, n, r, a, s = 2e3) {
                const o = this.elements, l = 2 * r / (e - t1), c = 2 * r / (i - n), u = (e + t1) / (e - t1), h = (i + n) / (i - n);
                let d, p;
                if (2e3 === s) d = -(a + r) / (a - r), p = -2 * a * r / (a - r);
                else {
                    if (2001 !== s) throw new Error("THREE.Matrix4.makePerspective(): Invalid coordinate system: " + s);
                    d = -a / (a - r), p = -a * r / (a - r);
                }
                return o[0] = l, o[4] = 0, o[8] = u, o[12] = 0, o[1] = 0, o[5] = c, o[9] = h, o[13] = 0, o[2] = 0, o[6] = 0, o[10] = d, o[14] = p, o[3] = 0, o[7] = 0, o[11] = -1, o[15] = 0, this;
            }
            makeOrthographic(t1, e, i, n, r, a, s = 2e3) {
                const o = this.elements, l = 1 / (e - t1), c = 1 / (i - n), u = 1 / (a - r), h = (e + t1) * l, d = (i + n) * c;
                let p, A;
                if (2e3 === s) p = (a + r) * u, A = -2 * u;
                else {
                    if (2001 !== s) throw new Error("THREE.Matrix4.makeOrthographic(): Invalid coordinate system: " + s);
                    p = r * u, A = -1 * u;
                }
                return o[0] = 2 * l, o[4] = 0, o[8] = 0, o[12] = -h, o[1] = 0, o[5] = 2 * c, o[9] = 0, o[13] = -d, o[2] = 0, o[6] = 0, o[10] = A, o[14] = -p, o[3] = 0, o[7] = 0, o[11] = 0, o[15] = 1, this;
            }
            equals(t1) {
                const e = this.elements, i = t1.elements;
                for(let t1 = 0; t1 < 16; t1++)if (e[t1] !== i[t1]) return !1;
                return !0;
            }
            fromArray(t1, e = 0) {
                for(let i = 0; i < 16; i++)this.elements[i] = t1[i + e];
                return this;
            }
            toArray(t1 = [], e = 0) {
                const i = this.elements;
                return t1[e] = i[0], t1[e + 1] = i[1], t1[e + 2] = i[2], t1[e + 3] = i[3], t1[e + 4] = i[4], t1[e + 5] = i[5], t1[e + 6] = i[6], t1[e + 7] = i[7], t1[e + 8] = i[8], t1[e + 9] = i[9], t1[e + 10] = i[10], t1[e + 11] = i[11], t1[e + 12] = i[12], t1[e + 13] = i[13], t1[e + 14] = i[14], t1[e + 15] = i[15], t1;
            }
        }
        const dD = new lD, pD = new hD, AD = new lD(0, 0, 0), fD = new lD(1, 1, 1), mD = new lD, gD = new lD, MD = new lD, vD = (t1)=>Math.cos(t1 * Math.PI / 180), yD = (t1)=>Math.sin(t1 * Math.PI / 180), xD = (t1)=>Math.tan(t1 * Math.PI / 180), wD = function(t1, e) {
            let i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 21;
            const n = new hD(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, -e.X, -e.Y, -e.Z, 1), r = -90, a = -90, s = new hD(vD(a), -yD(a), 0, 0, yD(a), vD(a), 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), o = new hD(vD(r), 0, -yD(r), 0, 0, 1, 0, 0, yD(r), 0, vD(r), 0, 0, 0, 0, 1), l = new hD(1, 0, 0, 0, 0, vD(0), yD(0), 0, 0, -yD(0), vD(0), 0, 0, 0, 0, 1), c = s.multiply(o).multiply(l).multiply(new hD(0, 0, 1, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1)), u = i / 2, h = new hD(1 / xD(u), 0, 0, 0, 0, 1 / xD(u), 0, 0, 0, 0, 0, 1, 0, 0, 1, 0), d = n.multiply(c).multiply(h), { X: p, Y: A, Z: f } = t1, m = ((t1, e)=>{
                const i = e.elements;
                return new gN(t1.x * i[0] + t1.y * i[1] + t1.z * i[2] + t1.w * i[3], t1.x * i[4] + t1.y * i[5] + t1.z * i[6] + t1.w * i[7], t1.x * i[8] + t1.y * i[9] + t1.z * i[10] + t1.w * i[11], t1.x * i[12] + t1.y * i[13] + t1.z * i[14] + t1.w * i[15]);
            })(new gN(p, A, f, 1), d);
            if (m.w > 0) {
                const t1 = 1 / m.w;
                return {
                    x: m.x * t1 / 2 + .5,
                    y: 1 - m.y * t1 / 2 - .5
                };
            }
            return null;
        }, bD = "#version 300 es", TD = "".concat(bD, "\n  precision lowp float;\n\n  in vec2 iPos;\n  in vec2 iTexCoord;\n\n  out vec2 vTexCoord;\n  out vec2 vAltTexCoord;\n\n  void main()	{\n    vTexCoord = iTexCoord;\n    vAltTexCoord = vec2(iTexCoord.x, 1.0 - iTexCoord.y);\n    gl_Position = vec4(iPos, 0, 1);\n  }\n"), ED = "".concat(bD, "\n  precision lowp float;\n  precision lowp int;\n\n  in vec2 vTexCoord;\n  in vec2 vAltTexCoord;\n\n  out vec4 oColor;\n\n  uniform vec4 uColor;\n  uniform sampler2D uTexture0;\n  uniform sampler2D uTexture1;\n\n  void main()	{\n    vec4 color1 = texture(uTexture0, vTexCoord);\n    vec4 color2 = texture(uTexture1, vAltTexCoord);\n\n    int r = int(uColor.r);\n    int rColor = int(color2.r);\n\n    if (r != 0 && r == rColor) {\n      vec4 uSelectColor = vec4(1.0, 0.65, 0.0, 1.0);\n\n      float t = 0.7;\n      oColor = color1 * t + uSelectColor * (1.0 - t);\n    } else {\n      oColor = color1;\n    }\n  }\n");
        function _D(t1, e, i) {
            ID(t1, e), e.set(t1, i);
        }
        function ID(t1, e) {
            if (e.has(t1)) throw new TypeError("Cannot initialize the same private elements twice on an object");
        }
        function SD(t1, e, i) {
            return (e = function(t1) {
                var e = function(t1) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var e = t1[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e)) in t1 ? Object.defineProperty(t1, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = i, t1;
        }
        function ND(t1, e) {
            return t1.get(DD(t1, e));
        }
        function DD(t1, e, i) {
            if ("function" == typeof t1 ? t1 === e : t1.has(e)) return arguments.length < 3 ? e : i;
            throw new TypeError("Private element is not present on this object");
        }
        var CD = new WeakSet, zD = new WeakMap, LD = new WeakMap;
        function OD() {
            const t1 = this._gl, e = t1.createVertexArray();
            t1.bindVertexArray(e);
            const i = t1.createBuffer();
            t1.bindBuffer(t1.ARRAY_BUFFER, i), t1.bufferData(t1.ARRAY_BUFFER, new Float32Array([
                -1,
                1,
                1,
                1,
                1,
                -1,
                -1,
                -1
            ]), t1.STATIC_DRAW), t1.vertexAttribPointer(0, 2, t1.FLOAT, !1, 0, 0), t1.enableVertexAttribArray(0);
            const n = t1.createBuffer();
            t1.bindBuffer(t1.ARRAY_BUFFER, n), t1.bufferData(t1.ARRAY_BUFFER, new Float32Array([
                0,
                0,
                1,
                0,
                1,
                1,
                0,
                1
            ]), t1.STATIC_DRAW), t1.vertexAttribPointer(1, 2, t1.FLOAT, !1, 0, 0), t1.enableVertexAttribArray(1);
            const r = t1.createBuffer();
            t1.bindBuffer(t1.ELEMENT_ARRAY_BUFFER, r), t1.bufferData(t1.ELEMENT_ARRAY_BUFFER, new Uint16Array([
                0,
                1,
                2,
                0,
                2,
                3
            ]), t1.STATIC_DRAW), this._vao && t1.deleteVertexArray(this._vao), this._posBuf && t1.deleteBuffer(this._posBuf), this._texCoordBuf && t1.deleteBuffer(this._texCoordBuf), this._ebo && t1.deleteBuffer(this._ebo), this._vao = e, this._posBuf = i, this._texCoordBuf = n, this._ebo = r;
        }
        function PD() {
            const t1 = this._gl, e = this._program;
            this._uColorLocation = t1.getUniformLocation(e, "uColor"), t1.uniform1i(t1.getUniformLocation(e, "uTexture0"), 0), t1.uniform1i(t1.getUniformLocation(e, "uTexture1"), 1);
        }
        async function jD(t1) {
            const e = this._gl, i = ND(LD, this);
            return new Promise((n)=>{
                const r = new Image;
                r.crossOrigin = "anonymous", r.onload = ()=>{
                    const t1 = e.createTexture();
                    e.bindTexture(e.TEXTURE_2D, t1), e.texImage2D(e.TEXTURE_2D, 0, e.RGBA, e.RGBA, e.UNSIGNED_BYTE, r), i(r.width) && i(r.height) ? (e.generateMipmap(e.TEXTURE_2D), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_S, e.REPEAT), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_T, e.REPEAT), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MIN_FILTER, e.LINEAR_MIPMAP_LINEAR)) : (e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_S, e.CLAMP_TO_EDGE), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_T, e.CLAMP_TO_EDGE), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MIN_FILTER, e.LINEAR)), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MAG_FILTER, e.LINEAR), n(t1);
                }, r.onerror = (t1)=>{
                    console.error(t1), n(null);
                }, r.src = t1;
            });
        }
        async function RD(t1) {
            const e = this._gl, i = e.createTexture();
            return e.bindTexture(e.TEXTURE_2D, i), e.texImage2D(e.TEXTURE_2D, 0, e.RGBA32F, t1.width, t1.height, 0, e.RGBA, e.FLOAT, t1.data.slice()), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_S, e.CLAMP_TO_EDGE), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_T, e.CLAMP_TO_EDGE), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MIN_FILTER, e.NEAREST), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MAG_FILTER, e.NEAREST), i;
        }
        function kD(t1, e) {
            const i = this._gl, n = ND(zD, this), r = n(i, i.VERTEX_SHADER, t1), a = n(i, i.FRAGMENT_SHADER, e);
            if (!r || !a) return r && i.deleteShader(r), a && i.deleteShader(a), null;
            const s = i.createProgram();
            return i.attachShader(s, r), i.attachShader(s, a), i.linkProgram(s), i.deleteShader(r), i.deleteShader(a), i.getProgramParameter(s, i.LINK_STATUS) ? (i.useProgram(s), s) : (console.error("Failed to link program:", i.getProgramInfoLog(s)), i.deleteProgram(s), null);
        }
        const UD = new class {
            constructor(){
                var t1;
                ID(this, t1 = CD), t1.add(this), SD(this, "_textures", []), SD(this, "_canvas", void 0), SD(this, "_gl", void 0), SD(this, "_program", void 0), SD(this, "_vao", void 0), SD(this, "_ebo", void 0), SD(this, "_posBuf", void 0), SD(this, "_texCoordBuf", void 0), SD(this, "_uColorLocation", void 0), _D(this, zD, (t1, e, i)=>{
                    const n = t1.createShader(e);
                    return t1.shaderSource(n, i), t1.compileShader(n), t1.getShaderParameter(n, t1.COMPILE_STATUS) ? n : (console.error("Failed to load shader:", t1.getShaderInfoLog(n)), t1.deleteShader(n), null);
                }), _D(this, LD, (t1)=>!(t1 & t1 - 1));
            }
            async init(t1) {
                this._canvas = t1, this._gl = t1.getContext("webgl2"), this._program && this._gl.deleteProgram(this._program), this._program = DD(CD, this, kD).call(this, TD, ED), DD(CD, this, OD).call(this), DD(CD, this, PD).call(this);
            }
            async setTextures(t1, e) {
                const i = this._gl;
                this._textures.forEach((t1)=>{
                    t1 && i.deleteTexture(t1);
                }), this._textures = new Array(2), t1 && (this._textures[0] = await DD(CD, this, jD).call(this, t1)), e && (this._textures[1] = await DD(CD, this, RD).call(this, e));
            }
            draw(t1) {
                const e = this._gl;
                e.clearColor(1, 1, 1, 1), e.clear(e.COLOR_BUFFER_BIT), this._textures.forEach((t1, i)=>{
                    e.activeTexture(e.TEXTURE0 + i), e.bindTexture(e.TEXTURE_2D, t1);
                }), t1 ? e.uniform4f(this._uColorLocation, t1.R, t1.G, t1.B, t1.A) : e.uniform4f(this._uColorLocation, 0, 0, 0, 0), e.drawElements(e.TRIANGLES, 6, e.UNSIGNED_SHORT, 0);
            }
        }, BD = "top-view-mask", FD = kS((t1)=>{
            let { disabled: i } = t1;
            const { currentFloorIndex: n } = Un, { json: r, topViewImage: a, bareshell: s, topViewResolutionUpscale: o } = Un.config, l = bS.currentPanoramaId, c = 200, u = 200, [h, d] = (0, e.useState)(!0), [p, A] = (0, e.useState)(!1), [f, m] = (0, e.useState)(null), g = (0, e.useMemo)(()=>((t1, e)=>{
                    const i = t1.Floors[e];
                    if (!i) return null;
                    let n = 1 / 0, r = 1 / 0, a = i.Location.Z, s = -1 / 0, o = -1 / 0, l = i.Location.Z + i.Height;
                    const c = ((t1, e)=>{
                        const i = [];
                        return ((t1, e)=>{
                            const i = e.length;
                            for(let n = 0; n < i; n++){
                                const i = e[n], r = sD(i.Location.X, i.Location.Y, i.Extent.X, i.Extent.Y, i.Rotation.Yaw * Math.PI / 180);
                                for(let e = 0; e < 4; e++)t1.push(r[e]);
                            }
                        })(i, t1.Decors), ((t1, e, i)=>{
                            const n = e.length, r = new Set;
                            for(let a = 0; a < n; a++){
                                const n = e[a];
                                if (!n.IsExterior) continue;
                                const s = aD(i, n.Vertices[0]), o = n.ControlPoint, l = aD(i, n.Vertices[1]);
                                if (r.has(s) || (t1.push({
                                    x: s.Location.X,
                                    y: s.Location.Y
                                }), r.add(s.ID)), o) {
                                    const e = 1 / 21, i = 1 - e;
                                    for(let n = e; n <= i; n += e)t1.push(rD(n, s, o, l));
                                }
                                r.has(l) || (t1.push({
                                    x: l.Location.X,
                                    y: l.Location.Y
                                }), r.add(l.ID));
                            }
                        })(i, t1.Walls, e), i;
                    })(i, t1.Vertices), u = c.length;
                    for(let t1 = 0; t1 < u; t1++){
                        const { x: e, y: i } = c[t1];
                        e < n && (n = e), e > s && (s = e), i < r && (r = i), i > o && (o = i);
                    }
                    return {
                        Origin: {
                            X: (n + s) / 2,
                            Y: (r + o) / 2,
                            Z: (a + l) / 2
                        },
                        Extent: {
                            X: (s - n) / 2,
                            Y: (o - r) / 2,
                            Z: (l - a) / 2
                        }
                    };
                })(r, n), []), M = (0, e.useMemo)(()=>(function(t1) {
                    let e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 50;
                    const i = xD((arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 21) / 2), n = Math.max(t1.Extent.X, t1.Extent.Y) + e, r = t1.Extent.Z + n / i;
                    return {
                        X: t1.Origin.X,
                        Y: t1.Origin.Y,
                        Z: t1.Origin.Z + r
                    };
                })(g), [
                n
            ]), v = (0, e.useMemo)(()=>{
                if (!M) return [];
                const t1 = r.Floors[n];
                return t1.CameraPoints.map((e)=>{
                    const { X: i, Y: n } = e.Location, r = t1.Location.Z + e.Location.Z;
                    return {
                        id: e.ID,
                        roomId: e.RoomID,
                        position: wD({
                            X: i,
                            Y: n,
                            Z: r
                        }, M)
                    };
                });
            }, [
                n,
                M,
                c
            ]);
            (0, e.useEffect)(()=>{
                d(!0), r && !i && y().then(()=>{
                    d(!1);
                });
            }, [
                a
            ]);
            const y = async ()=>{
                const t1 = await _x(b);
                m(t1), t1 || console.warn("Failed to load top view color mask: ".concat(b));
                const e = document.getElementById(BD);
                e && (await UD.init(e), await UD.setTextures(a, t1), UD.draw());
            }, x = ()=>{
                WN.setCurrentColor({
                    r: 0,
                    g: 0,
                    b: 0,
                    a: 0
                }), UD.draw();
            }, w = ()=>{
                Un.showControls(), A(!1);
            }, b = a.replace(/\.(jpe?g|webp|png|svg)/, "_RoomIDs.exr"), T = {
                width: c,
                height: u
            }, E = {
                width: c * o,
                height: u * o
            };
            return e.createElement(e.Fragment, null, p && e.createElement(e.Fragment, null, e.createElement("div", {
                className: "widget-tab__panorama-close-map",
                onClick: w
            }, e.createElement("img", {
                src: FS,
                alt: "close-map"
            })), e.createElement("div", {
                className: "map-overlay map-overlay--visible",
                onClick: w
            })), e.createElement("div", {
                className: (()=>{
                    const t1 = [
                        "widget-tab__panorama-top-view-map"
                    ];
                    return s && t1.push("widget-tab__panorama-top-view-map--bottom"), h && t1.push("widget-tab__panorama-top-view-map--hidden"), p && t1.push("widget-tab__panorama-top-view-map--scaled"), t1.join(" ");
                })()
            }, e.createElement("div", {
                className: "display-wrapper"
            }, e.createElement("canvas", {
                id: BD,
                width: E.width,
                height: E.height,
                style: T,
                onClick: (t1)=>{
                    if (Un.config.width <= BS.tablet && !p) return x(), Un.hideControls(), void A(!0);
                    if (!document.getElementById(BD)) return;
                    w();
                    const e = t1.nativeEvent.layerX / c, i = t1.nativeEvent.layerY / u, n = WN.currentColor, a = r.RoomColorIDPairs.find((t1)=>t1.ColorID.R === n.R && t1.ColorID.G === n.G && t1.ColorID.B === n.B);
                    let s = v;
                    a && (s = s.filter((t1)=>t1.roomId === a.ObjectID));
                    const [o] = s.sort((t1, n)=>{
                        const r = t1.position.x - e, a = t1.position.y - i, s = n.position.x - e, o = n.position.y - i;
                        return r * r + a * a - (s * s + o * o);
                    });
                    o && bS.setCurrentPanoramaById(o.id);
                },
                onMouseMove: (t1)=>{
                    if (!f || h) return;
                    const e = t1.nativeEvent.layerX / c, i = t1.nativeEvent.layerY / u;
                    if (e < 0 || i < 0 || e > 1 || i > 1) return;
                    const { R: n, G: r, B: a, A: s } = Sx(e, i, f);
                    t1.target.style.cursor = 0 === n ? "default" : "pointer";
                    const o = {
                        R: n,
                        G: r,
                        B: a,
                        A: s
                    };
                    UD.draw(o), WN.setCurrentColor(o);
                },
                onMouseLeave: x
            }), v.map((t1)=>{
                const i = t1.id === l ? "camera camera--current" : "camera", n = {
                    left: t1.position.x * c,
                    top: t1.position.y * c
                };
                return e.createElement("span", {
                    className: i,
                    key: t1.id,
                    style: n
                });
            }))));
        }), QD = kS((t1)=>{
            let { disabled: i } = t1;
            const n = Un.isCapable("top_view_as_miniplan") || Boolean(Un.config.forceTopViewOnMap), r = Boolean(Un.config.topViewImage), a = n && r;
            n && !r && console.warn("Top view map requested, but image missed!");
            const s = a ? FD : nD;
            return e.createElement(s, {
                disabled: i
            });
        }), HD = "data:image/svg+xml;base64,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", VD = kS((t1)=>{
            let { items: i, type: n, disabled: r } = t1;
            const a = [
                {
                    icon: qN,
                    text: zy("rotate-plan")
                },
                {
                    icon: HD,
                    text: zy("research-plan")
                }
            ], s = [
                {
                    icon: qN,
                    text: zy("create-points")
                },
                {
                    icon: HD,
                    text: zy("delete-points")
                }
            ], [o, l] = (0, e.useState)(!1), [c, u] = (0, e.useState)(Un.instructionVisible), h = ()=>bS.updateWindowSize(Un.config.width, Un.config.height);
            return (0, e.useEffect)(()=>{
                performance.mark("opening panorama mode"), bS.enableRender();
                const t1 = document.querySelector(".widget-tab__panorama-overlay");
                return t1.appendChild(bS.renderer.domElement), ()=>{
                    bS.setInitialCurrentPanorama(), bS.camera.deviceOrientationControls.disable(), bS.setCameraFov(bS.cameraFovValues.x1), bS.camera.controls.setDefaultPosition(), bS.setAutoRotateState(!1), bS.setRulerMode(!1), bS.disableRender(), t1.innerHTML = "";
                };
            }, []), (0, e.useEffect)(()=>{
                const t1 = bS.floorsGroup.children.some((t1)=>t1.floorIndex === Un.currentFloorIndex);
                return bS.initialized ? t1 ? (bS.setCurrentPanoramasGroup(Un.currentFloorIndex), void bS.setInitialCurrentPanorama()) : (bS.setLoadingState(!0), void bS.createPanoramasGroup(i, n, Un.currentFloorIndex).finally(()=>bS.setLoadingState(!1))) : (bS.setLoadingState(!0), performance.mark("start PanaramaStore Init"), void bS.init(i, n, Un.currentFloorIndex).finally(()=>bS.setLoadingState(!1)));
            }, [
                Un.currentFloorIndex
            ]), (0, e.useEffect)(h, [
                Un.config.width,
                Un.config.height
            ]), e.createElement(e.Fragment, null, e.createElement("div", {
                className: "widget-tab__panorama"
            }, bS.loading && e.createElement(iD, {
                absolute: !0
            }), e.createElement("div", {
                className: "widget-tab__panorama-overlay",
                onContextMenu: Ny
            }), bS.currentPanorama && e.createElement(QD, {
                disabled: r
            }), bS.currentPanorama && e.createElement("div", {
                className: "".concat(Un.config.bareshell ? "widget-tab__panorama-controls-container" : "")
            }, e.createElement("div", {
                className: "widget-tab__panorama-controls"
            }, bS.currentPanorama.userData.images.scene_depth && e.createElement($N, {
                onClick: ()=>{
                    bS.toggleRulerMode(), bS.rulerInstructionShown || l(!0);
                }
            }), e.createElement(tD, null), e.createElement(KN, null)), Un.config.bareshell && e.createElement("div", {
                onClick: async ()=>{
                    bS.setBareshell(!bS.bareshell), bS.currentPanorama && (bS.setLoadingState(!0), await bS.currentPanorama.fadeOut(), await bS.currentPanorama.createMaterial(), await bS.currentPanorama.fadeIn(), bS.setLoadingState(!1));
                },
                className: "widget-tab__panorama-controls"
            }, e.createElement(eD, {
                isBareshell: bS.bareshell
            })))), c && e.createElement(mN, {
                disabled: r,
                steps: a,
                onClick: async ()=>{
                    if (u(!1), h(), !kx.isMobile && !kx.isTablet) return;
                    if (!Un.configParams.enableGyroscope) return;
                    if (bS.camera.deviceOrientationControls.connected) return bS.camera.deviceOrientationControls.enable();
                    if (await kx.requestDeviceOrientation() !== Rx) return;
                    const t1 = ()=>{
                        window.removeEventListener("deviceorientation", t1), bS.camera.deviceOrientationControls.connect(), setTimeout(()=>bS.camera.deviceOrientationControls.enable(), 250);
                    };
                    window.addEventListener("deviceorientation", t1);
                }
            }), o && e.createElement(mN, {
                steps: s,
                onClick: ()=>{
                    bS.setRulerInstructionShown(!0), l(!1);
                }
            }));
        }), GD = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDciIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCA0NyAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTM5LjUyNzcgOS44MjM0MUwzNC4xODI0IDUuNDI3MzZDMzMuOTc2OSA1LjI1ODM5IDMzLjcxOTIgNS4xNjYwMiAzMy40NTMyIDUuMTY2MDJIMTMuMzMwMkMxMy4wNTcgNS4xNjYwMiAxMi43OTI4IDUuMjYzNDUgMTIuNTg1IDUuNDQwOEw3LjQ0NTg4IDkuODI2NzdDNy4yNDI5NyA5Ljk5OTk0IDcuMzY1NDQgMTAuMzMyMSA3LjYzMjIgMTAuMzMyMUgzOS4zNDU0QzM5LjYxNDcgMTAuMzMyMSAzOS43MzU3IDkuOTk0NSAzOS41Mjc3IDkuODIzNDFaIiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMS41Ii8+CjxwYXRoIGQ9Ik0xMC4zNzk4IDIyLjM4NjdDMTAuMzc5OCAyMi44MDA5IDEwLjcxNTUgMjMuMTM2NyAxMS4xMjk4IDIzLjEzNjdDMTEuNTQ0IDIzLjEzNjcgMTEuODc5OCAyMi44MDA5IDExLjg3OTggMjIuMzg2N0wxMC4zNzk4IDIyLjM4NjdaTTExLjg3OTggMjIuMzg2N0wxMS44Nzk4IDEwLjMzMjZMMTAuMzc5OCAxMC4zMzI2TDEwLjM3OTggMjIuMzg2N0wxMS44Nzk4IDIyLjM4NjdaIiBmaWxsPSIjNDEzRTNFIi8+CjxwYXRoIGQ9Ik0zNC40MjQzIDIyLjM4NjdDMzQuNDI0MyAyMi44MDA5IDM0Ljc2MDEgMjMuMTM2NyAzNS4xNzQzIDIzLjEzNjdDMzUuNTg4NSAyMy4xMzY3IDM1LjkyNDMgMjIuODAwOSAzNS45MjQzIDIyLjM4NjdMMzQuNDI0MyAyMi4zODY3Wk0zNS45MjQzIDIyLjM4NjdMMzUuOTI0MyAxMC4zMzI2TDM0LjQyNDMgMTAuMzMyNkwzNC40MjQzIDIyLjM4NjdMMzUuOTI0MyAyMi4zODY3WiIgZmlsbD0iIzQxM0UzRSIvPgo8cGF0aCBkPSJNMTQuNjk1NCAxNi45MDYyQzE0LjY5NTQgMTcuMzIwNSAxNS4wMzEyIDE3LjY1NjIgMTUuNDQ1NCAxNy42NTYyQzE1Ljg1OTYgMTcuNjU2MyAxNi4xOTU0IDE3LjMyMDUgMTYuMTk1NCAxNi45MDYzTDE0LjY5NTQgMTYuOTA2MlpNMTYuMTk1NCAxNi45MDYzTDE2LjE5NTQgMTAuMzMxM0wxNC42OTU0IDEwLjMzMTNMMTQuNjk1NCAxNi45MDYyTDE2LjE5NTQgMTYuOTA2M1oiIGZpbGw9IiM0MTNFM0UiLz4KPHBhdGggZD0iTTMwLjEwODYgMTYuOTA2MkMzMC4xMDg2IDE3LjMyMDUgMzAuNDQ0NCAxNy42NTYyIDMwLjg1ODYgMTcuNjU2MkMzMS4yNzI4IDE3LjY1NjMgMzEuNjA4NiAxNy4zMjA1IDMxLjYwODYgMTYuOTA2M0wzMC4xMDg2IDE2LjkwNjJaTTMxLjYwODYgMTYuOTA2M0wzMS42MDg2IDEwLjMzMTNMMzAuMTA4NiAxMC4zMzEzTDMwLjEwODYgMTYuOTA2MkwzMS42MDg2IDE2LjkwNjNaIiBmaWxsPSIjNDEzRTNFIi8+Cjwvc3ZnPgo=", WD = "data:image/svg+xml;base64,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", YD = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDciIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCA0NyAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjY4MDUgMTkuNjAxNlYyMi4wMzkxIiBzdHJva2U9IiMxNDE0MTQiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTMzLjQ2ODkgMTkuNjAxNlYyMi4wMzkxIiBzdHJva2U9IiMxNDE0MTQiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEwLjcwODIgMTAuMDU0N1Y1Ljk5MjE5QzEwLjcwODIgNS40NTM0NyAxMC45Njc0IDQuOTM2ODEgMTEuNDI4OSA0LjU1NTg4QzExLjg5MDMgNC4xNzQ5NCAxMi41MTYyIDMuOTYwOTQgMTMuMTY4NyAzLjk2MDk0QzEzLjgyMTMgMy45NjA5NCAxNC40NDcxIDQuMTc0OTQgMTQuOTA4NiA0LjU1NTg4QzE1LjM3IDQuOTM2ODEgMTUuNjI5MyA1LjQ1MzQ3IDE1LjYyOTMgNS45OTIxOSIgc3Ryb2tlPSIjMTQxNDE0IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0zMy45NDIxIDkuMjQyMTlIMjUuNjU0NlYxNC4xMTcySDMzLjk0MjFWOS4yNDIxOVoiIHN0cm9rZT0iIzE0MTQxNCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMzQuNzk5MyAxMC4wNTQ3SDM4LjczNjJDMzguOTk3MiAxMC4wNTQ3IDM5LjI0NzUgMTAuMTQwMyAzOS40MzIxIDEwLjI5MjdDMzkuNjE2NyAxMC40NDUgMzkuNzIwNCAxMC42NTE3IDM5LjcyMDQgMTAuODY3MlYxNC43MjY2QzM5LjcyMDQgMTYuMDE5NSAzOS4wOTgyIDE3LjI1OTUgMzcuOTkwOCAxOC4xNzM3QzM2Ljg4MzMgMTkuMDg3OSAzNS4zODEzIDE5LjYwMTYgMzMuODE1MSAxOS42MDE2SDEyLjMzMDNDMTAuNzY0MSAxOS42MDE2IDkuMjYyMDcgMTkuMDg3OSA4LjE1NDYxIDE4LjE3MzdDNy4wNDcxNiAxNy4yNTk1IDYuNDI1IDE2LjAxOTUgNi40MjUgMTQuNzI2NlYxMC44NjcyQzYuNDI1IDEwLjY1MTcgNi41Mjg3IDEwLjQ0NSA2LjcxMzI3IDEwLjI5MjdDNi44OTc4NSAxMC4xNDAzIDcuMTQ4MTggMTAuMDU0NyA3LjQwOTIxIDEwLjA1NDdIMjUuNjUwNyIgc3Ryb2tlPSIjMTQxNDE0IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=", XD = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDciIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCA0NyAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2LjQ1OTYgMjMuNTMzNlYyLjQ2NzEzTDI0LjMxNTcgMi40NjY4TTE2LjQ1OTYgMjMuNTMzNkgzMC4zOTYzTTE2LjQ1OTYgMjMuNTMzNkwyNC4zMTU3IDIwLjA1OTFWMi40NjY4TTE2LjQ1OTYgMjMuNTMzNkg5Ljc2NjZNMzAuMzk2MyAyMy41MzM2VjIuNDY3MTNMMjQuMzE1NyAyLjQ2NjhNMzAuMzk2MyAyMy41MzM2SDM3Ljg0OTdNMjEuNTEwNiAxMS41MTM2TDE5LjgxNDYgMTIuMzgyMyIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=", ZD = "data:image/svg+xml;base64,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", qD = {
            Kitchen: {
                name: "Kitchen",
                img: GD
            },
            BrownTilesKitchen: {
                name: "Kitchen",
                img: GD
            },
            Living: {
                name: "Living",
                img: WD
            },
            KitchenLiving: {
                name: "KitchLiv",
                img: WD
            },
            Bedroom: {
                name: "Bedroom",
                img: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDciIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCA0NyAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTM4Ljk1ODUgMjIuMzg1NVYxNS40OTc0QzM4Ljk1ODUgMTQuNTQ2NCAzOC4xODc1IDEzLjc3NTQgMzcuMjM2NCAxMy43NzU0SDEwLjI1ODFDOS4zMDcwOCAxMy43NzU0IDguNTM2MSAxNC41NDY0IDguNTM2MSAxNS40OTc0VjIyLjM4NTUiIHN0cm9rZT0iIzE0MTQxNCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMjEuNzM4MiAxMi42Mjc2VjEwLjMzMTZDMjEuNzM4MiA5LjY5NzU4IDIxLjIyNDMgOS4xODM1OSAyMC41OTAyIDkuMTgzNTlIMTYuNDkwOEMxNS45ODIgOS4xODM1OSAxNS41MzQgOS41MTg0MyAxNS4zODk4IDEwLjAwNjNMMTQuNzExNCAxMi4zMDI0QzE0LjQ5NDEgMTMuMDM3OSAxNS4wNDU0IDEzLjc3NTYgMTUuODEyNCAxMy43NzU2SDIwLjU5MDJDMjEuMjI0MyAxMy43NzU2IDIxLjczODIgMTMuMjYxNyAyMS43MzgyIDEyLjYyNzZaIiBzdHJva2U9IiMxNDE0MTQiIHN0cm9rZS13aWR0aD0iMS41Ii8+CjxwYXRoIGQ9Ik0yNS43NTYzIDEyLjYyNzZWMTAuMzMxNkMyNS43NTYzIDkuNjk3NTggMjYuMjcwMyA5LjE4MzU5IDI2LjkwNDMgOS4xODM1OUgzMS4wMDM4QzMxLjUxMjUgOS4xODM1OSAzMS45NjA2IDkuNTE4NDMgMzIuMTA0NyAxMC4wMDYzTDMyLjc4MzEgMTIuMzAyNEMzMy4wMDA0IDEzLjAzNzkgMzIuNDQ5MSAxMy43NzU2IDMxLjY4MjEgMTMuNzc1NkgyNi45MDQzQzI2LjI3MDMgMTMuNzc1NiAyNS43NTYzIDEzLjI2MTcgMjUuNzU2MyAxMi42Mjc2WiIgc3Ryb2tlPSIjMTQxNDE0IiBzdHJva2Utd2lkdGg9IjEuNSIvPgo8cGF0aCBkPSJNOC41MzYxIDIwLjA4OThIMzguOTU4NSIgc3Ryb2tlPSIjMTQxNDE0IiBzdHJva2Utd2lkdGg9IjEuNSIvPgo8cGF0aCBkPSJNMzUuNTE0NCAxMy4yMDIzVjguMDM2MjZDMzUuNTE0NCA2Ljc2ODIgMzQuNDg2NSA1Ljc0MDIzIDMzLjIxODQgNS43NDAyM0gxNC4yNzYyQzEzLjAwODEgNS43NDAyMyAxMS45ODAxIDYuNzY4MiAxMS45ODAxIDguMDM2MjZWMTMuMjAyMyIgc3Ryb2tlPSIjMTQxNDE0IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo="
            },
            Kid_room: {
                name: "Kid room",
                img: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDciIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCA0NyAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIzLjI0ODIgMjIuNzVDMjguNjMyNSAyMi43NSAzMi45OTc0IDE4LjM4NDggMzIuOTk3NCAxM0MzMi45OTc0IDcuNjE1MjIgMjguNjMyNSAzLjI1IDIzLjI0ODIgMy4yNUMxNy44NjM4IDMuMjUgMTMuNDk5IDcuNjE1MjIgMTMuNDk5IDEzQzEzLjQ5OSAxOC4zODQ4IDE3Ljg2MzggMjIuNzUgMjMuMjQ4MiAyMi43NVoiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTkuNTkyMiAxNC4yMTg4QzIwLjI2NTIgMTQuMjE4OCAyMC44MTA4IDEzLjY3MzEgMjAuODEwOCAxM0MyMC44MTA4IDEyLjMyNjkgMjAuMjY1MiAxMS43ODEyIDE5LjU5MjIgMTEuNzgxMkMxOC45MTkxIDExLjc4MTIgMTguMzczNSAxMi4zMjY5IDE4LjM3MzUgMTNDMTguMzczNSAxMy42NzMxIDE4LjkxOTEgMTQuMjE4OCAxOS41OTIyIDE0LjIxODhaIiBmaWxsPSIjNDEzRTNFIi8+CjxwYXRoIGQ9Ik0yNi45MDQxIDE0LjIxODhDMjcuNTc3MSAxNC4yMTg4IDI4LjEyMjcgMTMuNjczMSAyOC4xMjI3IDEzQzI4LjEyMjcgMTIuMzI2OSAyNy41NzcxIDExLjc4MTIgMjYuOTA0MSAxMS43ODEyQzI2LjIzMSAxMS43ODEyIDI1LjY4NTQgMTIuMzI2OSAyNS42ODU0IDEzQzI1LjY4NTQgMTMuNjczMSAyNi4yMzEgMTQuMjE4OCAyNi45MDQxIDE0LjIxODhaIiBmaWxsPSIjNDEzRTNFIi8+CjxwYXRoIGQ9Ik0yNS45MzkzIDE3LjA2MjVDMjUuMTQxNyAxNy41OTIyIDI0LjIwNTYgMTcuODc0OCAyMy4yNDgxIDE3Ljg3NDhDMjIuMjkwNyAxNy44NzQ4IDIxLjM1NDUgMTcuNTkyMiAyMC41NTY5IDE3LjA2MjUiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMjMuMjQ4MiAzLjI1QzIxLjYyMzMgNS4yODEyNSAyMS42MjMzIDcuMzEyNSAyMS42MjMzIDcuMzEyNUMyMS42MjMzIDcuNzQzNDggMjEuNzk0NSA4LjE1NjggMjIuMDk5MiA4LjQ2MTU1QzIyLjQwMzkgOC43NjYyOSAyMi44MTcyIDguOTM3NSAyMy4yNDgyIDguOTM3NUMyMy42NzkxIDguOTM3NSAyNC4wOTI0IDguNzY2MjkgMjQuMzk3MSA4LjQ2MTU1QzI0LjcwMTggOC4xNTY4IDI0Ljg3MyA3Ljc0MzQ4IDI0Ljg3MyA3LjMxMjUiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K"
            },
            Hall: {
                name: "Hall",
                img: XD
            },
            Bathroom: {
                name: "Bathroom",
                img: YD
            },
            BathLaminate: {
                name: "Bathroom",
                img: YD
            },
            CombinedBathroom: {
                name: "CombBath",
                img: YD
            },
            LightWoodBath: {
                name: "Bathroom",
                img: YD
            },
            BrownTilesBath: {
                name: "Bathroom",
                img: YD
            },
            Toilet: {
                name: "Toilet",
                img: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDciIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCA0NyAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2Ljc1IDExLjM3NVY0LjA2MjVDMTYuNzUgMy44NDcwMSAxNi44MzU2IDMuNjQwMzUgMTYuOTg4IDMuNDg3OThDMTcuMTQwMyAzLjMzNTYgMTcuMzQ3IDMuMjUgMTcuNTYyNSAzLjI1SDI4LjkzNzVDMjkuMTUzIDMuMjUgMjkuMzU5NyAzLjMzNTYgMjkuNTEyIDMuNDg3OThDMjkuNjY0NCAzLjY0MDM1IDI5Ljc1IDMuODQ3MDEgMjkuNzUgNC4wNjI1VjExLjM3NSIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yMCA2LjVIMjEuNjI1IiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTMyLjE4NzUgMTEuMzc1QzMyLjE4NzUgMTMuNzQ1NCAzMS4yNDU5IDE2LjAxODcgMjkuNTY5OCAxNy42OTQ4QzI3Ljg5MzcgMTkuMzcwOSAyNS42MjA0IDIwLjMxMjUgMjMuMjUgMjAuMzEyNUMyMC44Nzk2IDIwLjMxMjUgMTguNjA2MyAxOS4zNzA5IDE2LjkzMDIgMTcuNjk0OEMxNS4yNTQxIDE2LjAxODcgMTQuMzEyNSAxMy43NDU0IDE0LjMxMjUgMTEuMzc1SDMyLjE4NzVaIiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTE5Ljc1NjMgMTkuNjAxNkwxOS4zMTk1IDIyLjYzODNDMTkuMzAzNiAyMi43NTMxIDE5LjMxMjQgMjIuODcgMTkuMzQ1NCAyMi45ODEyQzE5LjM3ODQgMjMuMDkyMyAxOS40MzQ4IDIzLjE5NTEgMTkuNTEwOCAyMy4yODI2QzE5LjU4NjggMjMuMzcwMiAxOS42ODA2IDIzLjQ0MDUgMTkuNzg2IDIzLjQ4ODdDMTkuODkxNCAyMy41MzcgMjAuMDA2IDIzLjU2MjIgMjAuMTIxOSAyMy41NjI1SDI2LjM3ODFDMjYuNDk0MSAyMy41NjIyIDI2LjYwODYgMjMuNTM3IDI2LjcxNCAyMy40ODg3QzI2LjgxOTQgMjMuNDQwNSAyNi45MTMzIDIzLjM3MDIgMjYuOTg5MyAyMy4yODI2QzI3LjA2NTMgMjMuMTk1MSAyNy4xMjE2IDIzLjA5MjMgMjcuMTU0NiAyMi45ODEyQzI3LjE4NzYgMjIuODcgMjcuMTk2NCAyMi43NTMxIDI3LjE4MDUgMjIuNjM4M0wyNi43NDM4IDE5LjYwMTYiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K"
            },
            Balcony: {
                name: "Balcony",
                img: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTciIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCA1NyAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjI0MzIgMTUuOTgwN1YxNS40ODc4QzE1LjI0MzIgMTQuMzgzMyAxNi4xMzg2IDEzLjQ4NzggMTcuMjQzMiAxMy40ODc4SDE5LjM3OTNNNDAuNDM5MyAxNS45ODA3VjE1LjQ4NzhDNDAuNDM5MyAxNC4zODMzIDM5LjU0MzkgMTMuNDg3OCAzOC40MzkzIDEzLjQ4NzhIMzYuMzAzMU0zNi4zMDMxIDEwLjg1NTdWMy4zMjIyN0gyNy44NDEyTTE5LjM3OTMgMTAuODU1N1YzLjMyMjI3SDI3Ljg0MTJNMjcuODQxMiAzLjMyMjI3VjEwLjg1NTdNMTYuMzQ2MSAyMi4xMTRIMTkuMzc5M00zOS4zMzYzIDIyLjExNEgzNi4zMDMxTTI3Ljg0MTIgMjIuMTE0VjEzLjQ4NzhNMjcuODQxMiAyMi4xMTRIMzIuMDI5MU0yNy44NDEyIDIyLjExNEgyMy42MTAyTTI3Ljg0MTIgMTMuNDg3OEgzMi4wMjkxTTI3Ljg0MTIgMTMuNDg3OEgxOS4zNzkzTTMyLjAyOTEgMTMuNDg3OFYyMi4xMTRNMzIuMDI5MSAxMy40ODc4SDM2LjMwMzFNMzIuMDI5MSAyMi4xMTRIMzYuMzAzMU0zNi4zMDMxIDIyLjExNFYxMy40ODc4TTE5LjM3OTMgMTMuNDg3OFYyMi4xMTRNMTkuMzc5MyAyMi4xMTRIMjMuNjEwMk0yMy42MTAyIDIyLjExNFYxMy42Mjg0IiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMS41Ii8+Cjwvc3ZnPgo="
            },
            Hallway: {
                name: "Hallway",
                img: XD
            },
            Cabinet: {
                name: "Cabinet",
                img: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTciIGhlaWdodD0iMzMiIHZpZXdCb3g9IjAgMCA1NyAzMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTM5IDkuNzI2NTZIMTdDMTYuNDQ3NyA5LjcyNjU2IDE2IDEwLjE3NDMgMTYgMTAuNzI2NlYyNi43MjY2QzE2IDI3LjI3ODggMTYuNDQ3NyAyNy43MjY2IDE3IDI3LjcyNjZIMzlDMzkuNTUyMyAyNy43MjY2IDQwIDI3LjI3ODggNDAgMjYuNzI2NlYxMC43MjY2QzQwIDEwLjE3NDMgMzkuNTUyMyA5LjcyNjU2IDM5IDkuNzI2NTZaIiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTMzIDkuNzI2NTZWNy43MjY1NkMzMyA3LjE5NjEzIDMyLjc4OTMgNi42ODc0MiAzMi40MTQyIDYuMzEyMzVDMzIuMDM5MSA1LjkzNzI4IDMxLjUzMDQgNS43MjY1NiAzMSA1LjcyNjU2SDI1QzI0LjQ2OTYgNS43MjY1NiAyMy45NjA5IDUuOTM3MjggMjMuNTg1OCA2LjMxMjM1QzIzLjIxMDcgNi42ODc0MiAyMyA3LjE5NjEzIDIzIDcuNzI2NTZWOS43MjY1NiIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik00MCAxNi41MTM3QzM2LjM1MjkgMTguNjIzIDMyLjIxMzIgMTkuNzMxMiAyOCAxOS43MjYyQzIzLjc4NjEgMTkuNzM3MSAxOS42NDQ4IDE4LjYyODUgMTYgMTYuNTEzNyIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yNi41IDE1LjcyNjZIMjkuNSIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo="
            },
            Wardrobe: {
                name: "Wardrobe",
                img: "data:image/svg+xml;base64,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"
            },
            Terrace: {
                name: "Terrace",
                img: ZD
            },
            Terrace_2: {
                name: "Terrace",
                img: ZD
            },
            Garage: {
                name: "Garage",
                img: "data:image/svg+xml;base64,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"
            },
            Gym: {
                name: "Gym",
                img: "data:image/svg+xml;base64,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"
            },
            Carpet: {
                name: "Pooja Room",
                img: GD
            }
        }, JD = kS(()=>{
            const t1 = (0, e.useRef)(null), i = t1.current, [n, r] = (0, e.useState)(!1), a = Un.config.json.Floors[Un.currentFloorIndex].Units[0].Rooms, s = [];
            Object.keys(qD).forEach((t1)=>{
                const e = a.filter((e)=>e.Type === t1 && "Flipped" !== e.WallsState && "Gap" !== e.CeilingState);
                e.length > 1 && e.forEach((t1, i)=>e[i].Numeric = i + 1), s.push(...e);
            });
            const o = function(t1) {
                var e;
                let i = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                const n = null !== (e = t1.getAttribute("data-test-id")) && void 0 !== e ? e : t1.closest("div").getAttribute("data-test-id");
                n && (i ? WN.setFixedColor({
                    R: Number(n),
                    G: 0,
                    B: 0,
                    A: 0
                }) : WN.setCurrentColor({
                    R: Number(n),
                    G: 0,
                    B: 0,
                    A: 0
                }));
            };
            return (0, e.useEffect)(()=>{
                i && i.addEventListener("mousedown", (t1)=>{
                    const e = t1.screenX, n = i.scrollLeft;
                    let r = !0;
                    const a = (t1)=>{
                        if (r) {
                            const r = e - t1.screenX;
                            i.scrollLeft = n + r;
                        }
                    }, s = ()=>{
                        r = !1, i.removeEventListener("mousemove", a), i.removeEventListener("mouseup", s), i.removeEventListener("mouseleave", o);
                    }, o = ()=>{
                        r = !1, i.removeEventListener("mousemove", a), i.removeEventListener("mouseup", s), i.removeEventListener("mouseleave", o);
                    };
                    i.addEventListener("mousemove", a), i.addEventListener("mouseup", s), i.addEventListener("mouseleave", o);
                });
            }, [
                i
            ]), (0, e.useEffect)(()=>{
                const t1 = s.findIndex((t1)=>t1.ColorID);
                t1 >= 0 && WN.setFixedColor(s[t1].ColorID);
            }, []), e.createElement(e.Fragment, null, e.createElement("div", {
                ref: t1,
                className: "widget-tab-rooms",
                onClick: (t1)=>o(t1.target, !0),
                onMouseMove: (t1)=>o(t1.target)
            }, e.createElement("div", {
                className: "widget-tab-rooms-switch"
            }, e.createElement("input", {
                onChange: ()=>{
                    r((t1)=>!t1);
                },
                className: "widget-tab-rooms-switch-checkbox",
                id: "area-type-switch",
                type: "checkbox"
            }), e.createElement("label", {
                className: "widget-tab-rooms-switch-label",
                htmlFor: "area-type-switch"
            }, e.createElement("span", {
                className: "widget-tab-rooms-switch-button"
            }), e.createElement("div", {
                className: "widget-tab-rooms-switch-text"
            }, e.createElement("p", {
                className: "widget-tab-rooms-switch-text-item ".concat(n ? "" : "active")
            }, "Feet"), e.createElement("p", {
                className: "widget-tab-rooms-switch-text-item ".concat(n ? "active" : "")
            }, "Meter")))), e.createElement("div", {
                className: "widget-tab-rooms-container"
            }, s.map((t1)=>{
                var i, r, a, s, o;
                return e.createElement("div", {
                    "data-test-id": null === (i = t1.ColorID) || void 0 === i ? void 0 : i.R,
                    className: "widget-tab-rooms-item ".concat((o = null === (r = t1.ColorID) || void 0 === r ? void 0 : r.R, o === WN.currentColor.R || o === WN.fixedColor.R ? "widget-tab-rooms-item-active" : "")),
                    key: t1.ID
                }, e.createElement("img", {
                    className: "widget-tab-rooms-item-img",
                    src: (a = t1.Type, null === (s = Object.entries(qD).find((t1)=>{
                        let [e, i] = t1;
                        return e === a;
                    })) || void 0 === s ? void 0 : s[1].img),
                    alt: "icon"
                }), e.createElement("p", {
                    className: "widget-tab-rooms-item-type"
                }, ((t1, e)=>{
                    var i;
                    const n = null === (i = Object.entries(qD).find((e)=>{
                        let [i, n] = e;
                        return i === t1;
                    })) || void 0 === i ? void 0 : i[1].name;
                    return e ? "".concat(n, " ").concat(e) : n;
                })(t1.Type, t1.Numeric)), e.createElement("p", {
                    className: "widget-tab-rooms-item-area"
                }, ((t1)=>{
                    var e, i;
                    const r = t1.Length * t1.Width;
                    return Math.abs(r / t1.Area - 1) >= .15 ? n ? "".concat(t1.Area.toFixed(1), "m\xb2") : "".concat(((t1)=>{
                        const e = Math.floor(t1 * Math.pow(Sy, 2)), i = 144 * (t1 * Math.pow(Sy, 2) - e);
                        return "".concat(e, "'").concat(Math.round(i), '"');
                    })(t1.Area)) : n ? "".concat(null === (e = t1.Width) || void 0 === e ? void 0 : e.toFixed(1), "m x ").concat(null === (i = t1.Length) || void 0 === i ? void 0 : i.toFixed(1), "m") : "".concat(Ly(t1.Width), " x ").concat(Ly(t1.Length));
                })(t1)));
            }))));
        }), KD = kS(()=>{
            var t1, i, n, r, a, s, o, l, c, u, h;
            const { config: d } = Un, p = {
                width: d.width,
                height: d.height,
                "--main-color": d.colors.main,
                "--main-text": d.colors.mainText
            }, A = Un.config.hasTopViewMask || Un.config.hasMiddleCutMasks, [f, m] = (0, e.useState)(d.tabs[0]), g = function(t1) {
                let e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                if (e && !Un.config.hasTopViewMask) return null;
                if (!e && !Un.config.hasMiddleCutMasks) return null;
                const i = [];
                return t1.forEach((t1, e)=>i[e] = t1.replace(/\.jpe?g|\.webp/, "_RoomIDs.exr")), e ? i[0] : i;
            }, M = {
                default: {
                    rotation: e.createElement(JN, {
                        disabled: !d.rotationData || !d.rotationData.items.length,
                        topViewImage: d.topViewImage,
                        images: (null === (t1 = d.rotationData) || void 0 === t1 ? void 0 : t1.items) || [],
                        type: (null === (i = d.rotationData) || void 0 === i ? void 0 : i.type) || "top_down",
                        planImage: d.planImage,
                        mode: d.rotationMode
                    }),
                    panorama: e.createElement(VD, {
                        disabled: !d.panoramaData || !d.panoramaData.items.length,
                        items: (null === (n = d.panoramaData) || void 0 === n ? void 0 : n.items) || [],
                        type: (null === (r = d.panoramaData) || void 0 === r ? void 0 : r.type) || "sphere",
                        planImage: d.planImage,
                        json: d.json
                    })
                },
                area: {
                    rotation: e.createElement(JN, {
                        disabled: !d.rotationData || !d.rotationData.items.length,
                        type: (null === (a = d.rotationData) || void 0 === a ? void 0 : a.type) || "top_down",
                        planImage: d.planImage,
                        mode: d.rotationMode,
                        key: "plan"
                    }),
                    panorama: e.createElement(VD, {
                        disabled: !d.panoramaData || !d.panoramaData.items.length,
                        items: (null === (s = d.panoramaData) || void 0 === s ? void 0 : s.items) || [],
                        type: (null === (o = d.panoramaData) || void 0 === o ? void 0 : o.type) || "sphere",
                        json: d.json
                    }),
                    area: e.createElement(JN, {
                        disabled: !d.rotationData || !d.rotationData.items.length,
                        topViewImage: d.topViewImage,
                        topViewMask: g([
                            d.topViewImage
                        ], !0),
                        images: (null === (l = d.rotationData) || void 0 === l ? void 0 : l.items) || [],
                        masks: g((null === (c = d.rotationData) || void 0 === c ? void 0 : c.items) || []),
                        type: (null === (u = d.rotationData) || void 0 === u ? void 0 : u.type) || "top_down",
                        mode: d.rotationMode,
                        key: "area"
                    })
                }
            };
            var v;
            return (0, e.useEffect)(()=>{
                Wn.init();
            }, []), (0, e.useEffect)(()=>{
                d.tabs.some((t1)=>t1 === f) || m(d.tabs[0]);
            }, [
                d,
                f
            ]), e.createElement("main", {
                className: (v = d.width, Object.keys(BS).filter((t1)=>v <= BS[t1])).reduce((t1, e)=>t1 + " widget-application--".concat(e), "widget-application"),
                id: "widget-application",
                style: p
            }, e.createElement("section", {
                className: "widget-tab widget-tab--".concat(f)
            }, M[A ? "area" : "default"][f]), d.logo && e.createElement("a", {
                href: (null === (h = d.branding) || void 0 === h ? void 0 : h.url) || d.logoUrl,
                className: "widget-logo",
                target: "_blank",
                rel: "noreferrer"
            }, e.createElement("img", {
                src: d.logo,
                alt: "logo"
            })), Un.controlsVisible && e.createElement(QS, null), e.createElement("div", {
                className: "widget-tab-buttons ".concat(A ? "widget-tab-buttons-vertical" : "")
            }, ({
                default: [
                    {
                        tab: "rotation",
                        text: "2D"
                    },
                    {
                        tab: "panorama",
                        text: "3D"
                    }
                ],
                area: [
                    {
                        tab: "rotation",
                        text: "2D"
                    },
                    {
                        tab: "area",
                        text: "3D"
                    },
                    {
                        tab: "panorama",
                        img: "data:image/svg+xml;base64,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"
                    }
                ]
            })[A ? "area" : "default"].map((t1, i)=>!Un.isTabIncluded(t1.tab) || d.tabs.length < 2 ? null : Un.controlsVisible ? e.createElement(WS, {
                    key: i,
                    text: t1.text,
                    img: t1.img,
                    active: f === t1.tab,
                    onClick: ()=>m(t1.tab)
                }) : null), "panorama" === f && bS.vrSessionSupported && bS.currentPanorama && !kx.isMobileDevice && e.createElement(GS, null)), "area" === f && e.createElement(JD, null), e.createElement("div", {
                className: "widget-watermark-button"
            }, e.createElement(YS, {
                href: d.branding ? d.branding.url : (()=>{
                    const t1 = zy("made-by-link");
                    return "en" === Rn.currentLocale ? t1 + "?utm_source=widget&utm_medium=widget" : t1;
                })(),
                text: d.branding ? d.branding.name : zy("made-by-text")
            })), e.createElement(VS, null));
        }), $D = class {
            constructor(t1){
                let i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                const n = {
                    ...Zn,
                    ...i
                }, r = document.querySelector(t1);
                if (!r) throw new Error("\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043D\u0430\u0439\u0442\u0438 \u044D\u043B\u0435\u043C\u0435\u043D\u0442: ".concat(t1));
                r.addEventListener("wheel", (t1)=>t1.preventDefault()), i.width || (n.width = r.offsetWidth), i.height || (n.height = r.offsetHeight), i.panoramaFov && "number" == typeof i.panoramaFov || (n.panoramaFov = Zn.panoramaFov), i.panoramaIcons && "object" == typeof i.panoramaIcons ? n.panoramaIcons = {
                    ...Zn.panoramaIcons,
                    ...i.panoramaIcons
                } : n.panoramaIcons = {
                    ...Zn.panoramaIcons
                }, n.containerElement = r, Un.setConfig(n), Wn.resize(n), n.resizable && new ResizeObserver(()=>this.onResize()).observe(r), TS.render(e.createElement(KD, null), r);
            }
            get options() {
                return Un.config;
            }
            get panoramaStore() {
                return bS;
            }
            updateSize(t1) {
                const e = {
                    ...this.options,
                    ...t1
                };
                Un.setConfig(e), Wn.resize(e);
            }
            onResize() {
                const { offsetWidth: t1, offsetHeight: e } = this.options.containerElement;
                this.updateSize({
                    width: t1,
                    height: e
                });
            }
            on(t1, e) {
                Un.addEventListener(t1, e);
            }
        };
    })(), $a5056a6656605403$exports = n;
})();



var $8ea846d9a1c2a59a$exports = {};
$8ea846d9a1c2a59a$exports = new URL("logo.5bd2e0e4.png", import.meta.url).toString();


const $8f6a480bb40b134f$var$WIDGET_API_URL = "https://backend.estate.hart-digital.com";
const $8f6a480bb40b134f$var$WIDGET_API_STAGE_URL = "https://backend-stage.estate.hart-digital.com";
const $8f6a480bb40b134f$var$createWidget = async ()=>{
    const searchParams = new URL(document.location).searchParams;
    const planId = searchParams.get("id");
    const env = searchParams.get("env");
    const widgetApiHandler = new (0, $a5056a6656605403$exports.ApiStore)(env === "stage" ? $8f6a480bb40b134f$var$WIDGET_API_STAGE_URL : $8f6a480bb40b134f$var$WIDGET_API_URL);
    const planData = await widgetApiHandler.loadWidgetData(planId);
    const options = {
        ...planData.parsed,
        API_URL: env === "stage" ? $8f6a480bb40b134f$var$WIDGET_API_STAGE_URL : $8f6a480bb40b134f$var$WIDGET_API_URL,
        rotationMode: (0, $a5056a6656605403$exports.rotationModes).DEFAULT,
        tabs: [
            "panorama",
            "rotation"
        ],
        locale: "en",
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($8ea846d9a1c2a59a$exports))),
        dictionaryOverrides: {
            "made-by-text": "dominusgradnja",
            "made-by-link": "https://www.dominusgradnja.hr"
        }
    };
    new (0, $a5056a6656605403$exports.Widget)("#widget", options);
};
$8f6a480bb40b134f$var$createWidget();


//# sourceMappingURL=index.4aa8b74d.js.map
